(self["webpackChunk"] = self["webpackChunk"] || []).push([[47215],{

/***/ 17275:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"my-item":"my-item___2qQtn","row":"row___1j1p5","requeired":"requeired___27Jrp","item-label":"item-label___2aiUP","item-value":"item-value___24xaO"};

/***/ }),

/***/ 49572:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"tableWrap___3s6IO"};

/***/ }),

/***/ 81369:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uploader":"uploader___1QNvZ","uploadText":"uploadText___20AYY"};

/***/ }),

/***/ 13439:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titleBar":"titleBar___3p-Ke","titles":"titles___3mblW","active":"active___bJpMh"};

/***/ }),

/***/ 88856:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uploader":"uploader___CUMaC","uploadText":"uploadText___3EAo8"};

/***/ }),

/***/ 11545:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sList":"sList___3mwJ8","sBlackListM":"sBlackListM___27MsV"};

/***/ }),

/***/ 17077:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uploader":"uploader___163aX","uploadText":"uploadText___3YJb7"};

/***/ }),

/***/ 19002:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"editableTableRow":"editableTableRow___2P0Xt","editableCellValueWrap":"editableCellValueWrap___1tAE_","newRow":"newRow___2MahK","ant-table-cell":"ant-table-cell___1WghL"};

/***/ }),

/***/ 23875:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"editableTableRow":"editableTableRow___2wN3h","editableCellValueWrap":"editableCellValueWrap___3P1gN","newRow":"newRow___2ol7b","ant-table-cell":"ant-table-cell___2ZB2o"};

/***/ }),

/***/ 70483:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pointerColor":"pointerColor___wRpGK","sList":"sList___zzrN0","sBlackListM":"sBlackListM___3SqCZ"};

/***/ }),

/***/ 3453:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pointerColor":"pointerColor___30zVJ","sList":"sList___38drT","sBlackListM":"sBlackListM___3mDx5"};

/***/ }),

/***/ 43721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AutoSaveForm_AutoSaveForm; }
});

// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(93224);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/FormBuilder/index.tsx + 4 modules
var FormBuilder = __webpack_require__(5670);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/components/AutoSaveForm/hooks/useDebounceFn.ts


function useDebounceFn(fn) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var fnRef = (0,react.useRef)(fn);
  var timer = (0,react.useRef)(null);
  fnRef.current = fn;
  var debounceFn = (0,react.useCallback)(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timer.current) {
      clearTimeout(timer.current);
    }

    timer.current = setTimeout(() => {
      fnRef.current(...args);
    }, ms);
  }, [ms]);
  return debounceFn;
}

/* harmony default export */ var hooks_useDebounceFn = (useDebounceFn);
;// CONCATENATED MODULE: ./src/components/AutoSaveForm/AutoSaveForm.tsx






var _excluded = ["elements", "initFormData", "formOptions"];

/**
 * 采购中心的自动保存
 *
 * 自动保存表单必填项
 * 当填完所有的必填项的表单后，触发回调函数。供父组件触发自动保存
 */






function isNull(params) {
  return params === undefined || params === null || params === '';
}

function AutoSaveForm(props, ref) {
  var form = (0,react.useRef)();

  var elements = props.elements,
      _props$initFormData = props.initFormData,
      initFormData = _props$initFormData === void 0 ? {} : _props$initFormData,
      formOptions = props.formOptions,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded); // 表单项是否保存


  var _useState = (0,react.useState)(undefined),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      hasSaved = _useState2[0],
      setHasSaved = _useState2[1]; // 提示的类型和提示内容
  // const [savedStatus, statusMessage] = useMemo<any>(() => FormStatusMap.get(hasSaved), [hasSaved])


  var usefulFields = elements.filter(Boolean); // 需要用到的form的值（使用者设置过的element）

  var usefulData = (0,react.useMemo)(() => usefulFields.reduce((pre, next) => {
    var name = next.name;
    var value = initFormData[name];

    if (value !== undefined && value !== null && value !== '') {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, pre), {}, {
        [name]: initFormData[name]
      });
    } else {
      return pre;
    }
  }, {}), [initFormData, usefulFields]); // 获取所有必填的表单项

  var requiredFields = (0,react.useMemo)(() => {
    return usefulFields.filter(v => v === null || v === void 0 ? void 0 : v.required).map(v => v.name);
  }, [usefulFields]); // 日期表单项的数据

  var dateFields = (0,react.useMemo)(() => {
    return usefulFields.reduce((pre, next) => {
      if (next.type === 'RANGE_PICKER' || next.type === 'DATE_PICKER') {
        var format = next.fieldOptions && next.fieldOptions.format ? next.fieldOptions.format : 'YYYY-MM-DD';
        pre[next.name] = format;
      }

      return pre;
    }, {});
  }, [usefulFields]);
  /**
   * 检查表单必填项是否填写
   * @param params 外部传入的，要补充的参数
   */

  var checkReuqiredFields = params => {
    var _form$current;

    // 所有必填项都被操作过后，判断是否存在没有填的必填项
    var values = (_form$current = form.current) === null || _form$current === void 0 ? void 0 : _form$current.getFieldsValue(requiredFields); // 获取传入参数里的表单必填项的数据

    var otherReqParams = lodash_default().pick(params, requiredFields);

    var requiredParams = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, values), otherReqParams); // 所有的必填项是否都有数据


    var isEmpty = Object.values(requiredParams).some(v => {
      if (Array.isArray(v)) return !v.length; // 类型是 Moment 时，表示存在值

      if (v instanceof (moment_default())) return false;
      return isNull(v);
    });
    return !isEmpty;
  };
  /**
   * 触发组件的保存的回调
   */


  var toggleSaveCallback = hooks_useDebounceFn( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
    var _form$current2;

    var allFields, dateKeys, boolean;
    return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            allFields = (_form$current2 = form.current) === null || _form$current2 === void 0 ? void 0 : _form$current2.getFieldsValue();

            if (!lodash_default().isEmpty(dateFields) && !lodash_default().isEmpty(allFields)) {
              // 获取 日期 类型的表单项的 字段名
              dateKeys = Object.keys(dateFields); // 类型转化

              dateKeys.forEach(val => {
                if (allFields[val] && typeof allFields[val] !== 'string') {
                  allFields[val] = moment_default()(allFields[val]).format(dateFields[val]);
                }
              });
            }

            if (!props.saveForm) {
              _context.next = 7;
              break;
            }

            _context.next = 5;
            return props.saveForm(allFields);

          case 5:
            boolean = _context.sent;
            // 是否保存成功
            setHasSaved(boolean);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), 1000);
  /**
   * 表单项的值改变时触发
   * @param field 当前修改的表单项
   * @param allFields 所有表单项的值
   */

  var changeForm = hooks_useDebounceFn((field, allFields) => {
    if (props.onChange) {
      props.onChange(field, allFields);
    }

    setHasSaved(undefined); // 表单的所有数据都集中到 initFormData

    Object.assign(initFormData, field);
    var hasSaved = checkReuqiredFields(allFields);

    if (hasSaved) {
      // 所有必填项都填完，有值的情况下。可发送请求
      toggleSaveCallback();
    }
  }, 800);
  /**
   * 编辑状态下，表单数据的回显
   */

  (0,react.useEffect)(() => {
    var _form$current3;

    // 判断表单项是否不一样
    if (lodash_default().isEqual((_form$current3 = form.current) === null || _form$current3 === void 0 ? void 0 : _form$current3.getFieldsValue(), usefulData)) {
      return;
    }

    form.current.setFieldsValue(initFormData); // 回显的数据的必填项是否都有数据

    var hasSaved = checkReuqiredFields(initFormData);

    if (hasSaved) {
      toggleSaveCallback();
    } else {
      setHasSaved(undefined);
    }
  }, [initFormData]);
  /**
   * 暴露出来的 ref 方法
   */

  (0,react.useImperativeHandle)(ref, () => (0,objectSpread2/* default */.Z)({}, form.current));
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    className: "mBottom16"
  }), /*#__PURE__*/react.createElement(FormBuilder/* default */.Z, (0,esm_extends/* default */.Z)({
    ref: form
  }, rest, {
    elements: elements,
    notSearchForm: true,
    responsed: true,
    onChange: changeForm,
    formOptions: (0,objectSpread2/* default */.Z)({
      layout: 'vertical'
    }, formOptions)
  })));
}

/* harmony default export */ var AutoSaveForm_AutoSaveForm = (/*#__PURE__*/(0,react.forwardRef)(AutoSaveForm));

/***/ }),

/***/ 41089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_AutoSaveForm; }
});

// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(93224);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/FormBuilder/index.tsx + 4 modules
var FormBuilder = __webpack_require__(5670);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/hooks/useDebounce.ts
var useDebounce = __webpack_require__(74900);
;// CONCATENATED MODULE: ./src/components/AutoSaveForm/constance.ts
/**
 * 表单保存状态
 */
var FormStatusMap = new Map([[true, ['success', '表单内容已保存成功']], [false, ['error', '表单内容保存失败']], [undefined, ['warning', '表单内容还没有保存']]]);
// EXTERNAL MODULE: ./src/hooks/useCompareEffect.ts
var useCompareEffect = __webpack_require__(19125);
;// CONCATENATED MODULE: ./src/components/AutoSaveForm/index.tsx






var _excluded = ["elements", "initFormData", "formOptions"];

/**
 * 自动保存表单必填项
 * 当填完所有的必填项的表单后，触发回调函数。供父组件触发自动保存
 */








function isNull(params) {
  return params === undefined || params === null || params === '';
}

function AutoSaveForm(props, ref) {
  var form = (0,react.useRef)();
  var autoSave = (0,react.useRef)(false);

  var elements = props.elements,
      initFormData = props.initFormData,
      formOptions = props.formOptions,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded); // 表单是否可以发送请求


  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      canRequest = _useState2[0],
      setCanRequest = _useState2[1]; // 表单项是否保存


  var _useState3 = (0,react.useState)(undefined),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      hasSaved = _useState4[0],
      setHasSaved = _useState4[1]; // 提示的类型和提示内容


  var _useMemo = (0,react.useMemo)(() => FormStatusMap.get(hasSaved), [hasSaved]),
      _useMemo2 = (0,slicedToArray/* default */.Z)(_useMemo, 2),
      savedStatus = _useMemo2[0],
      statusMessage = _useMemo2[1];

  var usefulFields = elements.filter(Boolean); // 获取所有必填的表单项

  var requiredFields = (0,react.useMemo)(() => {
    return usefulFields.filter(v => v === null || v === void 0 ? void 0 : v.required).map(v => v.name);
  }, [usefulFields]); // 日期表单项的数据

  var dateFields = (0,react.useMemo)(() => {
    return usefulFields.reduce((pre, next) => {
      if (next.type === 'RANGE_PICKER' || next.type === 'DATE_PICKER') {
        var format = next.fieldOptions && next.fieldOptions.format ? next.fieldOptions.format : 'YYYY-MM-DD';
        pre[next.name] = format;
      }

      return pre;
    }, {});
  }, [usefulFields]);
  /**
   * 检查表单必填项是否填写
   * @param params 外部传入的，要补充的参数
   */

  var checkReuqiredFields = params => {
    // 所有必填项都被操作过后，判断是否存在没有填的必填项
    var values = form.current.getFieldsValue(requiredFields); // 获取传入参数里的表单必填项的数据

    var otherReqParams = params ? Object.keys(params).reduce((pre, next) => {
      if (requiredFields.includes(next)) {
        pre[next] = params[next];
      }

      return pre;
    }, {}) : {};

    var requiredParams = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, values), otherReqParams); // 所有的必填项是否都有数据


    var isEmpty = Object.values(requiredParams).some(v => {
      if (Array.isArray(v)) return !v.length; // 类型是 Moment 时，表示存在值

      if (v instanceof (moment_default())) return false;
      return isNull(v);
    });
    return !isEmpty;
  };
  /**
   * 表单项的值改变时触发
   * @param field 当前修改的表单项
   * @param allFields 所有表单项的值
   */


  var changeForm = (field, allFields) => {
    if (props.onChange) {
      props.onChange(field, allFields);
    } // console.log(allFields)
    // autoSave.current = true


    setHasSaved(undefined); // 表单的所有数据都集中到 initFormData

    Object.assign(initFormData, field);
    var hasSaved = checkReuqiredFields(allFields);

    if (hasSaved) {
      // 所有必填项都填完，有值的情况下。可发送请求
      setCanRequest(true);
    }
  };
  /**
   * 触发组件的保存的回调
   */


  var toggleSaveCallback = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
      var allFields, dateKeys, boolean, saveResult;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              allFields = form.current.getFieldsValue();

              if (!lodash_default().isEmpty(dateFields)) {
                // 获取 日期 类型的表单项的 字段名
                dateKeys = Object.keys(dateFields); // 类型转化

                dateKeys.forEach(val => {
                  if (allFields[val] && typeof allFields[val] !== 'string') {
                    allFields[val] = moment_default()(allFields[val]).format(dateFields[val]);
                  }
                });
              }

              if (!props.saveForm) {
                _context.next = 9;
                break;
              }

              setCanRequest(false);
              _context.next = 6;
              return props.saveForm(allFields);

            case 6:
              boolean = _context.sent;
              saveResult = boolean !== null && boolean !== void 0 ? boolean : false; // 是否保存成功

              setHasSaved(saveResult);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function toggleSaveCallback() {
      return _ref.apply(this, arguments);
    };
  }(); // 截流


  (0,useDebounce/* default */.Z)(() => {
    if (canRequest) {
      toggleSaveCallback();
    }
  }, [canRequest], 900);
  /**
   * 编辑状态下，表单数据的回显
   */

  (0,useCompareEffect/* default */.Z)(() => {
    if (!lodash_default().isEmpty(initFormData)) {
      form.current.setFieldsValue(initFormData); // 回显的数据的必填项是否都有数据

      var shouldSavedForm = checkReuqiredFields(initFormData);
      setHasSaved(shouldSavedForm || undefined); // console.log(shouldSavedForm)
      // if (autoSave.current) {
      // setCanRequest(shouldSavedForm)
      // }
    }
  }, [initFormData, autoSave.current]);
  /**
   * 暴露出来的 ref 方法
   */

  (0,react.useImperativeHandle)(ref, () => (0,objectSpread2/* default */.Z)({
    setFormData: params => {
      form.current.setFieldsValue(params); // autoSave.current = true

      var hasSaved = checkReuqiredFields(params);

      if (hasSaved) {
        // 所有必填项都填完，有值的情况下。可发送请求
        setCanRequest(true);
      }
    }
  }, form.current));
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    className: "mBottom16"
  }), /*#__PURE__*/react.createElement(FormBuilder/* default */.Z, (0,esm_extends/* default */.Z)({
    ref: form
  }, rest, {
    elements: elements,
    notSearchForm: true,
    responsed: true,
    onChange: changeForm,
    formOptions: (0,objectSpread2/* default */.Z)({
      layout: 'vertical'
    }, formOptions)
  })));
}

/* harmony default export */ var components_AutoSaveForm = (/*#__PURE__*/(0,react.forwardRef)(AutoSaveForm));

/***/ }),

/***/ 99481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_BaseUploader; }
});

// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/upload/style/index.js
var style = __webpack_require__(43185);
// EXTERNAL MODULE: ./node_modules/antd/es/upload/index.js + 12 modules
var upload = __webpack_require__(3388);
// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var button_style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/index.js
var message_style = __webpack_require__(34792);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(48086);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/UploadOutlined.js + 1 modules
var UploadOutlined = __webpack_require__(84391);
;// CONCATENATED MODULE: ./src/components/BaseUploader/components/UploadFile.tsx













function UploadFiles(props) {
  var _props$btnText;

  var _props$uploadOptions = props.uploadOptions,
      uploadOptions = _props$uploadOptions === void 0 ? {} : _props$uploadOptions;

  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var disabled = uploadOptions.disabled; // 上传前的回调

  var beforeUpload = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(file) {
      var size;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              size = props.size;

              if (size && file.size / 1024 > size) {
                message.default.error("\u4E0D\u80FD\u4E0A\u4F20\u8D85\u8FC7".concat(size, "KB\u7684\u6587\u4EF6"));
              } // 获取上传需要的 token


              _context.next = 5;
              return props.beforeUpload(file);

            case 5:
              return _context.abrupt("return", _context.sent);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              // message.error(error.message)
              console.log(_context.t0);
              return _context.abrupt("return", Promise.reject(_context.t0));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function beforeUpload(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var onChange = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(info) {
      var file, fileList, status, name, uid, _file$response, code, msg, data, _message2, obj;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              file = info.file, fileList = info.fileList;
              status = file.status;

              if (!(!status || ['uploading', 'removed', 'error'].includes(status))) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              if (!(file.status === 'done')) {
                _context2.next = 13;
                break;
              }

              setLoading(false);
              name = file.name, uid = file.uid;
              _file$response = file.response, code = _file$response.code, msg = _file$response.msg, data = _file$response.data, _message2 = _file$response.message; // 上传失败

              if (!(code !== 200)) {
                _context2.next = 11;
                break;
              }

              _message2.error(msg);

              return _context2.abrupt("return");

            case 11:
              // 设置 fileList
              obj = [{
                uid,
                name,
                status: 'done',
                url: _message2,
                files: file,
                resId: file.resId
              }];
              props.handleChange(obj);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onChange(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/react.createElement(upload/* default */.Z, (0,esm_extends/* default */.Z)({
    name: "file",
    accept: props.accept,
    action: props.action,
    fileList: props.fileList,
    beforeUpload: beforeUpload,
    onChange: onChange,
    data: props.data,
    onRemove: props.handleRemove
  }, props.uploadOptions), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    loading: loading,
    disabled: loading || disabled,
    type: "primary"
  }, /*#__PURE__*/react.createElement(UploadOutlined/* default */.Z, null), " ", (_props$btnText = props.btnText) !== null && _props$btnText !== void 0 ? _props$btnText : '点击上传'));
}

/* harmony default export */ var UploadFile = (/*#__PURE__*/(0,react.memo)(UploadFiles));
// EXTERNAL MODULE: ./node_modules/antd/es/modal/style/index.js
var modal_style = __webpack_require__(71194);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(57016);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlusOutlined.js + 1 modules
var PlusOutlined = __webpack_require__(49101);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/components/BaseUploader/components/UploadImg.tsx















var type = 'DragableUploadList';


function getImgInfo(file) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      var img = new Image();
      img.src = reader.result;

      img.onload = () => {
        var info = {
          width: img.width,
          height: img.height
        };
        resolve(info);
      };
    };

    reader.onerror = error => reject(error);
  });
}

var ImgUpload = props => {
  var _props$maxCount = props.maxCount,
      maxCount = _props$maxCount === void 0 ? 1 : _props$maxCount,
      _props$preview = props.preview,
      preview = _props$preview === void 0 ? true : _props$preview,
      _props$fileList = props.fileList,
      fileList = _props$fileList === void 0 ? [] : _props$fileList,
      validateSize = props.validateSize,
      sizeMsg = props.sizeMsg,
      handleChange = props.handleChange,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? true : _props$multiple,
      fileSize = props.fileSize,
      disabled = props.disabled;

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      imgList = _useState2[0],
      setImgList = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      showImg = _useState4[0],
      setShowImg = _useState4[1];

  var _useState5 = (0,react.useState)(Boolean),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      visible = _useState6[0],
      setVisible = _useState6[1];

  var beforeUpload = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(file, fileList) {
      var info, isLt2M, size, msg;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getImgInfo(file);

            case 2:
              info = _context.sent;

              if (!((0,lodash.isEmpty)(info) || info.width === 0)) {
                _context.next = 6;
                break;
              }

              message.default.error("上传出错");

              return _context.abrupt("return", false);

            case 6:
              if (!fileSize) {
                _context.next = 12;
                break;
              }

              if (!(file.size / 1024 / 1024 > fileSize)) {
                _context.next = 10;
                break;
              }

              message.default.error("\u8BF7\u4E0A\u4F20\u5927\u5C0F\u4E0D\u8D85\u8FC7".concat(fileSize, "M\u7684\u56FE\u7247"));

              return _context.abrupt("return", false);

            case 10:
              _context.next = 16;
              break;

            case 12:
              isLt2M = file.size / 1024 < 200;

              if (isLt2M) {
                _context.next = 16;
                break;
              }

              message.default.error("请上传大小不超过200kb的图片");

              return _context.abrupt("return", false);

            case 16:
              size = validateSize ? validateSize(info.width, info.height) : true;

              if (size) {
                _context.next = 21;
                break;
              }

              msg = sizeMsg || '请上传图片';

              message.default.error(msg); // return Upload.LIST_IGNORE


              return _context.abrupt("return", false);

            case 21:
              _context.next = 23;
              return props.beforeUpload(file);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function beforeUpload(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var onChange = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(info) {
      var file, fileList, status, _file$response, _file$response$messag, _message2, uid, resId;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              file = info.file, fileList = info.fileList;
              status = file.status;
              _context2.prev = 2;

              if (!(!status || ['removed', 'error'].includes(status))) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return");

            case 5:
              // if (status === 'uploading') return
              // fileList = fileList.filter((i: IFile) => i.status)
              // if (!fileList.every((i: IFile) => i.status === 'done')) return
              // const list: IImg[] = imgList?.length ? [...imgList] : []
              // const files = fileList.map((i: IFile) => {
              //     const { response: { message = '' } = {}, uid, resId } = i
              //     if (message?.length) return { url: message, uid: uid, resId }
              //     return null
              // }).filter(Boolean)
              // setImgList([...list, ...files])
              // handleChange!([...list, ...files])
              _file$response = file.response;
              _file$response = _file$response === void 0 ? {} : _file$response;
              _file$response$messag = _file$response.message, _message2 = _file$response$messag === void 0 ? '' : _file$response$messag, uid = file.uid, resId = file.resId;
              setImgList([{
                url: _message2,
                uid: uid,
                resId
              }]);

              if (status === 'done') {
                handleChange([{
                  url: _message2,
                  uid: uid,
                  resId
                }]);
              }

              _context2.next = 15;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](2);
              console.log(_context2.t0);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 12]]);
    }));

    return function onChange(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onRemove = _ref3 => {
    var url = _ref3.url;
    if (preview) return false;
    var list = [...imgList].filter(i => i.url !== url);
    setImgList([...list]);
    handleChange([...list]);
  };

  var onPreview = _ref4 => {
    var url = _ref4.url;
    setShowImg(url || '');
    setVisible(true);
  }; // 通过覆盖默认的上传行为，可以自定义自己的上传实现


  var customRequest = arg => {
    var action = arg.action,
        data = arg.data,
        file = arg.file,
        _arg$filename = arg.filename,
        filename = _arg$filename === void 0 ? 'files' : _arg$filename,
        headers = arg.headers,
        onError = arg.onError,
        onProgress = arg.onProgress,
        onSuccess = arg.onSuccess,
        withCredentials = arg.withCredentials; // EXAMPLE: post form-data with 'axios'
    // eslint-disable-next-line no-undef

    var formData = new FormData();

    if (data) {
      Object.keys(data).forEach(key => {
        formData.append(key, data[key]);
      });
    }

    formData.append(filename, file);
    axios_default().post(action, formData, {
      withCredentials,
      headers: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, headers), {}, {
        'res-token': file['res-token']
      }),
      onUploadProgress: _ref5 => {
        var total = _ref5.total,
            loaded = _ref5.loaded;
        onProgress && onProgress({
          percent: Math.round(loaded / total * 100).toFixed(2)
        }, file);
      }
    }).then(_ref6 => {
      var response = _ref6.data;
      onSuccess && onSuccess(response, file);
    }).catch(error => console.log('upload error>>>', error));
    return {
      abort() {
        console.log('upload progress is aborted.');
      }

    };
  };

  (0,react.useEffect)(() => {
    if (fileList !== null && fileList !== void 0 && fileList.length) {
      setImgList([...fileList.map(i => {
        if (!i.url) {
          return {
            url: i,
            uid: i,
            status: 'done'
          };
        }

        return i;
      })]);
    }
  }, [fileList]);
  var uploadButton = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(PlusOutlined/* default */.Z, null), /*#__PURE__*/react.createElement("div", {
    style: {
      marginTop: 8
    }
  }, "\u4E0A\u4F20\u56FE\u7247"));
  var _upload = {
    className: "upload-btn ".concat(preview ? 'preview' : ''),
    multiple: false,
    listType: "picture-card",
    name: "file",
    accept: ".jpg,jpeg,.png",
    action: props.action,
    data: props.data,
    beforeUpload,
    onChange,
    customRequest,
    onPreview,
    onRemove,
    fileList: imgList,
    disabled
  };
  return /*#__PURE__*/react.createElement("div", {
    className: "img-upload"
  }, /*#__PURE__*/react.createElement(modal/* default */.Z, {
    footer: null,
    title: "\u67E5\u770B\u56FE\u7247",
    visible: visible,
    onOk: () => setVisible(true),
    onCancel: () => setVisible(false)
  }, /*#__PURE__*/react.createElement("img", {
    src: showImg,
    alt: "",
    className: "showImgModal",
    style: {
      width: '100%',
      height: '100%'
    }
  })), /*#__PURE__*/react.createElement(upload/* default */.Z, (0,esm_extends/* default */.Z)({}, _upload, {
    key: "img-upload"
  }), fileList.length >= maxCount || preview ? null : uploadButton));
};

/* harmony default export */ var UploadImg = (/*#__PURE__*/(0,react.memo)(ImgUpload));
// EXTERNAL MODULE: ./node_modules/antd/es/pagination/style/index.js
var pagination_style = __webpack_require__(14781);
// EXTERNAL MODULE: ./node_modules/antd/es/pagination/index.js + 7 modules
var pagination = __webpack_require__(19866);
// EXTERNAL MODULE: ./node_modules/antd/es/row/style/index.js
var row_style = __webpack_require__(13062);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/style/index.js
var col_style = __webpack_require__(89032);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/input/style/index.js
var input_style = __webpack_require__(47673);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 3 modules
var input = __webpack_require__(4107);
// EXTERNAL MODULE: ./node_modules/antd/es/image/style/index.js
var image_style = __webpack_require__(12968);
// EXTERNAL MODULE: ./node_modules/antd/es/image/index.js + 5 modules
var es_image = __webpack_require__(9415);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/BaseUploader/components/CommonItem/style.module.less?modules
var style_modulemodules = __webpack_require__(17275);
var style_modulemodules_default = /*#__PURE__*/__webpack_require__.n(style_modulemodules);
;// CONCATENATED MODULE: ./src/components/BaseUploader/components/CommonItem/index.tsx



function FormItem(props) {
  var labelChildren = props.label;
  return /*#__PURE__*/react.createElement("div", {
    className: "".concat((style_modulemodules_default())["my-item"], " ").concat((style_modulemodules_default()).row, " ").concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    style: props.style
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()('left', (style_modulemodules_default())["item-label"], {
      [(style_modulemodules_default()).requeired]: props.required
    })
  }, labelChildren), /*#__PURE__*/react.createElement("div", {
    className: classnames_default()('right', (style_modulemodules_default())["item-value"])
  }, props.children));
}
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
;// CONCATENATED MODULE: ./src/components/BaseUploader/components/ImgGallery.tsx
























var pageSizeOptions = ['10', '20', '30', '40', '50', '100'];
var defaultItem = {
  itemName: '',
  barcode: ''
};

var ImgGallery = props => {
  var _props$hide = props.hide,
      hide = _props$hide === void 0 ? true : _props$hide,
      itemPictureType = props.itemPictureType,
      handleCallback = props.handleCallback,
      _props$maxCount = props.maxCount,
      maxCount = _props$maxCount === void 0 ? 1 : _props$maxCount;

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      imgs = _useState2[0],
      setImgs = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      selected = _useState4[0],
      setSelectd = _useState4[1];

  var _useState5 = (0,react.useState)(Boolean),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      visible = _useState6[0],
      setVisible = _useState6[1];

  var _useState7 = (0,react.useState)({
    page: 1,
    size: 10
  }),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      pageInfo = _useState8[0],
      setPageInfo = _useState8[1];

  var _useState9 = (0,react.useState)(0),
      _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
      total = _useState10[0],
      setTotal = _useState10[1];

  var ImgSet = new Set();

  var _useState11 = (0,react.useState)(defaultItem),
      _useState12 = (0,slicedToArray/* default */.Z)(_useState11, 2),
      item = _useState12[0],
      setItem = _useState12[1];

  var onPageChange = (page, size) => {
    setPageInfo({
      page,
      size
    });
    setSelectd([]);
  };

  var onShowSizeChange = (_page, size) => {
    setPageInfo({
      page: 1,
      size
    });
    setSelectd([]);
  };

  var queryList = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
      var url, params, _yield$ypRider, result, success, list, _total;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = 'kernel.console.MerchantItemQueryService.pageQueryMerchantItemPicture';
              params = {
                pageInfo,
                param: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, item), {}, {
                  itemPictureType
                })
              };
              _context.prev = 2;
              _context.next = 5;
              return (0,ypRequest/* default */.Z)(url, params);

            case 5:
              _yield$ypRider = _context.sent;
              result = _yield$ypRider.result;
              success = _yield$ypRider.success;

              if (success) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return");

            case 10:
              list = result.list, _total = result.total;
              setImgs([...list]);
              setTotal(_total);
              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](2);
              console.log(_context.t0);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 15]]);
    }));

    return function queryList() {
      return _ref.apply(this, arguments);
    };
  }();

  var _onChange = (e, key) => {
    var _e$target$value = e.target.value,
        value = _e$target$value === void 0 ? '' : _e$target$value;
    setItem((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, item), {}, {
      [key]: value
    }));
  };

  var onClick = (0,react.useCallback)(() => {
    setVisible(true);
  }, []);
  var handleOk = (0,react.useCallback)(() => {
    if (!(selected !== null && selected !== void 0 && selected.length)) {
      message.default.info('请选择图片');

      return;
    }

    if ((selected === null || selected === void 0 ? void 0 : selected.length) > maxCount) {
      message.default.info("\u6700\u591A\u9009\u62E9".concat(maxCount, "\u5F20\u56FE\u7247"));

      return;
    }

    handleCallback && handleCallback(selected);
    init();
    setVisible(false);
  }, [selected]);
  var handleCancel = (0,react.useCallback)(() => {
    init();
    setVisible(false);
  }, [selected]);

  var init = () => {
    setPageInfo({
      page: 1,
      size: 10
    });
    setSelectd([]);
    setItem(defaultItem);
  };

  var handleSearch = () => {
    setPageInfo({
      page: 1,
      size: 10
    });
  };

  var handleSelect = (0,react.useCallback)(img => {
    if (selected.includes(img)) {
      var list = selected.filter(i => i !== img);
      setSelectd(list);
      return;
    }

    setSelectd([...selected, img]);
  }, [selected]);
  var renderImgs = (0,react.useMemo)(() => {
    if (!(imgs !== null && imgs !== void 0 && imgs.length)) return;
    return imgs.map((i, index) => {
      return /*#__PURE__*/react.createElement("div", {
        className: "gallery-item ".concat(selected.includes(i.pictureUrl) ? 'selected' : ''),
        key: "".concat(i.barcode, "_").concat(index),
        onClick: () => handleSelect(i.pictureUrl)
      }, /*#__PURE__*/react.createElement(es_image/* default */.Z, {
        width: 140,
        src: i.pictureUrl,
        preview: false
      }));
    });
  }, [imgs, selected]);
  (0,react.useEffect)(() => {
    if (!visible) return;
    queryList();
  }, [pageInfo, visible]);
  var _pagination = {
    showQuickJumper: true,
    current: pageInfo.page,
    total: total / 1,
    pageSize: pageInfo.size,
    onChange: onPageChange,
    showSizeChanger: true,
    pageSizeOptions,
    onShowSizeChange: onShowSizeChange,
    showTotal: total => "\u5171 ".concat(total, " \u6761"),
    hideOnSinglePage: true
  };
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(modal/* default */.Z, {
    title: "\u56FE\u7247\u5E93",
    visible: visible,
    onOk: handleOk,
    onCancel: handleCancel,
    width: 1000
  }, /*#__PURE__*/react.createElement("div", {
    className: "search-gallery"
  }, /*#__PURE__*/react.createElement(row/* default */.Z, {
    gutter: 24
  }, /*#__PURE__*/react.createElement(col/* default */.Z, {
    span: 8
  }, /*#__PURE__*/react.createElement(FormItem, {
    name: "goodsName",
    label: "\u5546\u54C1\u540D\u79F0",
    required: false
  }, /*#__PURE__*/react.createElement(input/* default */.Z, {
    value: item.itemName,
    onChange: e => _onChange(e, 'itemName')
  }))), /*#__PURE__*/react.createElement(col/* default */.Z, {
    span: 8
  }, /*#__PURE__*/react.createElement(FormItem, {
    name: "barcode",
    label: "\u5546\u54C1\u6761\u7801",
    required: false
  }, /*#__PURE__*/react.createElement(input/* default */.Z, {
    value: item.barcode,
    onChange: e => _onChange(e, 'barcode')
  }))), /*#__PURE__*/react.createElement(col/* default */.Z, {
    span: 8
  }, /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    onClick: handleSearch,
    type: "primary",
    style: {
      textAlign: 'right'
    }
  }, "\u67E5\u627E\u56FE\u7247")))), /*#__PURE__*/react.createElement("div", {
    className: "gallery-list"
  }, renderImgs), /*#__PURE__*/react.createElement(pagination/* default */.Z, _pagination)), hide ? null : /*#__PURE__*/react.createElement("div", {
    className: "galleryBtn",
    onClick: onClick
  }, "\u67E5\u627E\u56FE\u7247"));
};

/* harmony default export */ var components_ImgGallery = (/*#__PURE__*/(0,react.memo)(ImgGallery));
;// CONCATENATED MODULE: ./src/components/BaseUploader/components/UploadModal.tsx



















var UploadModal_type = 'DragableUploadList';

var DragableUploadListItem = _ref => {
  var originNode = _ref.originNode,
      file = _ref.file,
      fileList = _ref.fileList;
  var ref = (0,react.useRef)();
  var index = fileList !== null && fileList !== void 0 && fileList.length ? fileList.indexOf(file) : 0;
  return /*#__PURE__*/react.createElement("div", {
    ref: ref,
    style: {
      cursor: 'move'
    },
    className: "ant-upload-draggable-list-item"
  }, originNode);
};

function UploadModal_getImgInfo(file) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      var img = new Image();
      img.src = reader.result;

      img.onload = () => {
        var info = {
          width: img.width,
          height: img.height
        };
        resolve(info);
      };
    };

    reader.onerror = error => reject(error);
  });
}

var UploadModal_ImgUpload = props => {
  var _props$maxCount = props.maxCount,
      maxCount = _props$maxCount === void 0 ? 1 : _props$maxCount,
      preview = props.preview,
      _props$fileList = props.fileList,
      fileList = _props$fileList === void 0 ? [] : _props$fileList,
      validateSize = props.validateSize,
      sizeMsg = props.sizeMsg,
      handleChange = props.handleChange,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? true : _props$multiple,
      itemPictureType = props.itemPictureType,
      _props$showRemoveIcon = props.showRemoveIcon,
      showRemoveIcon = _props$showRemoveIcon === void 0 ? true : _props$showRemoveIcon;

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      imgList = _useState2[0],
      setImgList = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      showImg = _useState4[0],
      setShowImg = _useState4[1];

  var _useState5 = (0,react.useState)(Boolean),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      visible = _useState6[0],
      setVisible = _useState6[1];

  var beforeUpload = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(file, _fileList) {
      var info, isLt2M, size, msg;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return UploadModal_getImgInfo(file);

            case 2:
              info = _context.sent;

              if (!((0,lodash.isEmpty)(info) || info.width === 0)) {
                _context.next = 6;
                break;
              }

              message.default.error("上传出错");

              return _context.abrupt("return", false);

            case 6:
              isLt2M = file.size / 1024 < 200;

              if (isLt2M) {
                _context.next = 10;
                break;
              }

              message.default.error("请上传大小不超过200kb的图片");

              return _context.abrupt("return", false);

            case 10:
              size = validateSize ? validateSize(info.width, info.height) : true;

              if (size) {
                _context.next = 15;
                break;
              }

              msg = sizeMsg || '请上传图片';

              message.default.error(msg);

              return _context.abrupt("return", false);

            case 15:
              _context.next = 17;
              return props.beforeUpload(file);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function beforeUpload(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onChange = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(info) {
      var file, _fileList, _list, status, list, files;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              file = info.file, _fileList = info.fileList;
              _list = [..._fileList];
              status = file.status;
              _context2.prev = 3;
              setImgList([..._list].splice(0, maxCount));

              if (!(!status || ['uploading', 'removed', 'error'].includes(status))) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt("return");

            case 7:
              _list = _list.filter(i => i.status);

              if (_list.every(i => i.status === 'done')) {
                _context2.next = 10;
                break;
              }

              return _context2.abrupt("return");

            case 10:
              list = props !== null && props !== void 0 && props.fileList ? [...(props === null || props === void 0 ? void 0 : props.fileList)] : [];
              files = _list.map(i => {
                var _i$response$message = i.response.message,
                    message = _i$response$message === void 0 ? '' : _i$response$message,
                    uid = i.uid,
                    resId = i.resId;
                if (message !== null && message !== void 0 && message.length) return {
                  url: message,
                  uid: uid,
                  resId
                };
                return null;
              }).filter(Boolean);
              setImgList([...list, ...files]);
              _context2.next = 17;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](3);

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 15]]);
    }));

    return function onChange(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  var onRemove = _ref4 => {
    var url = _ref4.url;
    var list = [...fileList].filter(i => i.url !== url);
    handleChange([...list]);
  };

  var onPreview = _ref5 => {
    var url = _ref5.url;
    setShowImg(url || '');
    setVisible(true);
  }; // 通过覆盖默认的上传行为，可以自定义自己的上传实现


  var customRequest = arg => {
    var action = arg.action,
        data = arg.data,
        file = arg.file,
        _arg$filename = arg.filename,
        filename = _arg$filename === void 0 ? 'files' : _arg$filename,
        headers = arg.headers,
        onError = arg.onError,
        onProgress = arg.onProgress,
        onSuccess = arg.onSuccess,
        withCredentials = arg.withCredentials; // EXAMPLE: post form-data with 'axios'
    // eslint-disable-next-line no-undef

    var formData = new FormData();

    if (data) {
      Object.keys(data).forEach(key => {
        formData.append(key, data[key]);
      });
    }

    formData.append(filename, file);
    axios_default().post(action, formData, {
      withCredentials,
      headers: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, headers), {}, {
        'res-token': file['res-token']
      }),
      onUploadProgress: _ref6 => {
        var total = _ref6.total,
            loaded = _ref6.loaded;
        onProgress && onProgress({
          percent: Math.round(loaded / total * 100).toFixed(2)
        }, file);
      }
    }).then(_ref7 => {
      var response = _ref7.data;
      onSuccess && onSuccess(response, file);
    }).catch(error => {
      console.error('upload error>>>', error);
      var list = [...imgList].filter(i => i.uid !== file.uid);
      setImgList(list);
    });
    return {
      abort() {
        console.error('upload progress is aborted.');
      }

    };
  };

  var handleCallback = imgs => {
    var list = imgs.map(i => ({
      url: i,
      uid: i
    })) || [];
    setImgList([...list]);
  };

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      mVisible = _React$useState2[0],
      setMVisible = _React$useState2[1];

  var _upload = {
    className: 'upload-btn',
    multiple,
    maxCount,
    listType: "picture-card",
    name: "file",
    accept: ".jpg,.jpeg,.png",
    action: props.action,
    data: props.data,
    beforeUpload,
    onChange,
    customRequest,
    onPreview,
    onRemove,
    itemRender: (originNode, file, currFileList) => /*#__PURE__*/react.createElement(DragableUploadListItem, {
      originNode: originNode,
      file: file,
      fileList: currFileList,
      moveRow: () => {}
    })
  };
  return /*#__PURE__*/react.createElement("div", {
    className: "img-upload"
  }, preview ? /*#__PURE__*/react.createElement(upload/* default */.Z, (0,esm_extends/* default */.Z)({}, _upload, {
    fileList: fileList,
    showUploadList: {
      showPreviewIcon: true,
      showRemoveIcon,
      showDownloadIcon: false
    },
    key: "img-upload-display"
  })) : /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    type: "dashed",
    icon: /*#__PURE__*/react.createElement(PlusOutlined/* default */.Z, null),
    className: "upload-btn-modal",
    onClick: () => setMVisible(true)
  }, "\u4E0A\u4F20\u56FE\u7247"), /*#__PURE__*/react.createElement(modal/* default */.Z, {
    footer: null,
    title: "\u67E5\u770B\u56FE\u7247",
    visible: visible,
    onOk: () => setVisible(true),
    onCancel: () => setVisible(false)
  }, /*#__PURE__*/react.createElement("img", {
    src: showImg,
    alt: "",
    className: "showImgModal",
    style: {
      width: '100%',
      height: '100%'
    }
  })), /*#__PURE__*/react.createElement(modal/* default */.Z, {
    title: "\u4E0A\u4F20\u56FE\u7247",
    visible: mVisible,
    onOk: () => {
      setMVisible(false);
      handleChange(imgList);
    },
    onCancel: () => setMVisible(false),
    okButtonProps: {
      disabled: !imgList.length
    }
  }, /*#__PURE__*/react.createElement("div", null, "1\u3001\u56FE\u7247\u4EC5\u652F\u6301jpg\u3001jpeg\u3001png\u683C\u5F0F\uFF0C\u5C0F\u4E8E200kb"), /*#__PURE__*/react.createElement(upload/* default */.Z, (0,esm_extends/* default */.Z)({}, _upload, {
    fileList: imgList,
    showUploadList: {
      showPreviewIcon: true,
      showRemoveIcon: true,
      showDownloadIcon: false
    },
    onRemove: _ref8 => {
      var url = _ref8.url;
      var list = [...fileList].filter(i => i.url !== url);
      setImgList([...list]);
    },
    key: "img-upload"
  }), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(PlusOutlined/* default */.Z, null), "\u4E0A\u4F20\u56FE\u7247")), /*#__PURE__*/react.createElement(components_ImgGallery, {
    maxCount: maxCount,
    hide: false,
    handleCallback: handleCallback,
    itemPictureType: itemPictureType
  })));
};

/* harmony default export */ var UploadModal = (/*#__PURE__*/(0,react.memo)(UploadModal_ImgUpload));
;// CONCATENATED MODULE: ./src/components/BaseUploader/config.ts
// 上传前需要获取token的请求地址
var uploadTokenUrl = 'kernel.console.BatchToolsService.getUploadFileToken';
var imgSuffix = (/* unused pure expression or super */ null && (['image/jpeg', 'image/gif', 'image/png', 'image/jpg']));
;// CONCATENATED MODULE: ./src/components/BaseUploader/index.tsx












function BaseUploader(props) {
  var type = props.type,
      tokenParams = props.tokenParams,
      uploadType = props.uploadType,
      showRemoveIcon = props.showRemoveIcon,
      setInfo = props.setInfo;

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      fileList = _useState2[0],
      setFileList = _useState2[1];

  var _useState3 = (0,react.useState)({
    endpoint: '',
    // 上传地址
    resId: '',
    // 资源id
    params: {} // 上传附带的参数

  }),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      resToken = _useState4[0],
      setResToken = _useState4[1]; // 上传前  先获取 token


  var beforeUpload = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(file) {
      var params, _yield$ypRider, result, success;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, tokenParams), {}, {
                fileName: file.name,
                isPublic: type === 'img' ? true : false
              });
              setInfo && setInfo(file);
              _context.prev = 2;
              _context.next = 5;
              return (0,ypRequest/* default */.Z)(props.getTokenApi || uploadTokenUrl, params);

            case 5:
              _yield$ypRider = _context.sent;
              result = _yield$ypRider.result;
              success = _yield$ypRider.success;

              if (success) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return");

            case 10:
              if (uploadType && uploadType === 'diancang') {
                setResToken((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, result.uploadToken), {}, {
                  params: JSON.parse(result.uploadToken.params)
                })); // 资源id

                file.resId = result.uploadToken.resId;
              } else {
                setResToken(result); // 资源id

                file.resId = result.resId;
              }

              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](2);
              console.log(_context.t0);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 13]]);
    }));

    return function beforeUpload(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleChange = data => {
    setFileList(data);
    props.onChange(data);
  };

  var removeFile = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(data) {
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setFileList(data);
              props.onChange(data);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function removeFile(_x2) {
      return _ref2.apply(this, arguments);
    };
  }(); // 删除 fileList


  var handleRemove = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3(file) {
      var res;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              if (!props.onRemove) {
                _context3.next = 7;
                break;
              }

              _context3.next = 4;
              return props.onRemove(file);

            case 4:
              res = _context3.sent;
              // 如果返回为 true 可以删除
              if (res) removeFile(file);
              return _context3.abrupt("return", res);

            case 7:
              // 没有异步判断则直接删除
              removeFile(file);
              return _context3.abrupt("return", true);

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](0);
              return _context3.abrupt("return", false);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 11]]);
    }));

    return function handleRemove(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(() => {
    var _props$fileList;

    setFileList((_props$fileList = props.fileList) !== null && _props$fileList !== void 0 ? _props$fileList : []);
  }, [props === null || props === void 0 ? void 0 : props.fileList]);
  var uploadCommonProps = {
    action: resToken.endpoint,
    token: '',
    fileList,
    beforeUpload,
    handleChange,
    handleRemove,
    data: resToken.params
  };

  if (type === 'img') {
    return /*#__PURE__*/react.createElement(UploadImg, (0,esm_extends/* default */.Z)({}, props, uploadCommonProps));
  }

  if (type === 'modal') {
    return /*#__PURE__*/react.createElement(UploadModal, (0,esm_extends/* default */.Z)({}, props, uploadCommonProps, {
      showRemoveIcon: showRemoveIcon
    }));
  }

  return /*#__PURE__*/react.createElement(UploadFile, (0,esm_extends/* default */.Z)({}, props, uploadCommonProps));
}

/* harmony default export */ var components_BaseUploader = (/*#__PURE__*/(0,react.memo)(BaseUploader));

/***/ }),

/***/ 70400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/**
 * 详情页面的头部文案的布局展示
 */




var BigTitle = props => {
  var title = props.title,
      _props$noBorder = props.noBorder,
      noBorder = _props$noBorder === void 0 ? false : _props$noBorder,
      className = props.className;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('titleWrap', className, {
      noBorder
    })
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "fk"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "wz"
  }, title));
};

/* harmony default export */ __webpack_exports__["Z"] = (BigTitle);

/***/ }),

/***/ 32830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57016);
/* harmony import */ var antd_es_tag_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71153);
/* harmony import */ var antd_es_tag__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60331);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8870);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_FormBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5670);






/**
 * 作废功能，填写作废原因
 */


var layout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 5
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 18
    }
  }
};

function CancelModal(props) {
  var params = props.params,
      codeLength = props.codeLength,
      title = props.title,
      formfields = props.formfields;
  var form = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();

  var handleOk = () => {
    var values = form.current.getFieldsValue();
    props.saveModalCallback((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)({}, params), values));
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    title: title !== null && title !== void 0 ? title : '作废',
    destroyOnClose: true,
    maskClosable: false,
    width: 500,
    visible: true,
    onOk: handleOk,
    onCancel: props.closeModalCallback
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("p", {
    style: {
      paddingLeft: '30px'
    }
  }, "\u5171\u8BA1", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tag__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    color: "cyan",
    style: {
      margin: 2
    }
  }, codeLength), "\u6761\u5355\u636E\u9700\u8981\u53D6\u6D88"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_components_FormBuilder__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    defaultValues: params,
    ref: form,
    elements: formfields,
    notSearchForm: true,
    formOptions: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)({}, layout)
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (CancelModal);

/***/ }),

/***/ 76252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34041);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





/**
 * 二级品类、三级品类联动的自定义表单控件，业务： 要货编辑明细
 * 数据格式为CategoryCompactValue
 * 配合Form
 */

var Option = antd_es_select__WEBPACK_IMPORTED_MODULE_2__/* .default.Option */ .Z.Option;

function CategorySelectForTwo(props) {
  var _props$firstProps = props.firstProps,
      firstProps = _props$firstProps === void 0 ? {} : _props$firstProps,
      _props$secondProps = props.secondProps,
      secondProps = _props$secondProps === void 0 ? {} : _props$secondProps,
      _props$categoryList = props.categoryList,
      categoryList = _props$categoryList === void 0 ? [] : _props$categoryList,
      formValue = props.value,
      onSecondChange = props.onSecondChange,
      onThirdChange = props.onThirdChange;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState, 2),
      secondOptions = _useState2[0],
      setSecondOptions = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState3, 2),
      thirdOptions = _useState4[0],
      setThirdOptions = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState5, 2),
      thirdCategoryList = _useState6[0],
      setthirdCategoryList = _useState6[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    var firstValueTmp = formValue === null || formValue === void 0 ? void 0 : formValue.first;

    if (!firstValueTmp) {
      return;
    }

    try {
      // 二级的下拉数据
      var _ref = categoryList && categoryList.find(v => +v.value === +firstValueTmp) || {},
          others = _ref.others;

      if (!(others !== null && others !== void 0 && others.childCategoryList)) {
        setSecondOptions([]);
      }

      setthirdCategoryList(others === null || others === void 0 ? void 0 : others.childCategoryList);
      var list = Object.values(others === null || others === void 0 ? void 0 : others.childCategoryList).map(v => ({
        value: v.categoryId,
        label: v.categoryName
      }));
      setSecondOptions(list);
    } catch (error) {// console.log(error)
    }
  }, [categoryList, formValue]);

  var changeSecondSelect = secondValueArr => {
    onSecondChange && onSecondChange(secondValueArr);
    var arr = secondValueArr.map(e => thirdCategoryList[e]);

    if (!(arr !== null && arr !== void 0 && arr.length)) {
      setThirdOptions([]);
    }

    var list = arr.map(data => {
      return Object.values(data === null || data === void 0 ? void 0 : data.childCategoryList).map(v => ({
        value: v.categoryId,
        label: v.categoryName
      }));
    });
    setThirdOptions(list.flat());
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (thirdCategoryList && categoryList && formValue !== null && formValue !== void 0 && formValue.second) {
      changeSecondSelect([formValue === null || formValue === void 0 ? void 0 : formValue.second]);
    }
  }, [categoryList, thirdCategoryList, formValue === null || formValue === void 0 ? void 0 : formValue.second]);

  var changeThirdSelect = thirdValueArr => {
    onThirdChange && onThirdChange(thirdValueArr);
  };

  var renderOptions = dataSource => {
    if (dataSource && dataSource.length > 0) {
      return dataSource.map(v => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(Option, {
        value: v.value,
        key: v.value,
        rows: v
      }, v.label));
    }

    return null;
  };

  return (
    /*#__PURE__*/
    // <Input.Group compact>
    react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
      style: {
        width: '500px'
      },
      className: props === null || props === void 0 ? void 0 : props.className
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)({
      placeholder: "\u4E8C\u7EA7\u7C7B\u76EE",
      dropdownMatchSelectWidth: false,
      showSearch: true,
      mode: "multiple",
      mult: true,
      allowClear: true,
      disabled: formValue !== null && formValue !== void 0 && formValue.second ? true : false,
      value: +(formValue === null || formValue === void 0 ? void 0 : formValue.second) || undefined // filterOption={false}
      ,
      optionLabelProp: "children",
      style: {
        width: '250px'
      },
      maxTagCount: (props === null || props === void 0 ? void 0 : props.tag) || 2,
      onChange: changeSecondSelect
    }, secondProps), renderOptions(secondOptions)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)({
      placeholder: "\u4E09\u7EA7\u7C7B\u76EE",
      dropdownMatchSelectWidth: false,
      showSearch: true,
      mode: "multiple",
      allowClear: true,
      disabled: formValue !== null && formValue !== void 0 && formValue.third ? true : false,
      value: +(formValue === null || formValue === void 0 ? void 0 : formValue.third) || undefined,
      maxTagCount: (props === null || props === void 0 ? void 0 : props.tag) || 2 // filterOption={false}
      ,
      optionLabelProp: "children",
      style: {
        width: '250px'
      },
      onChange: changeThirdSelect
    }, secondProps), renderOptions(thirdOptions))) // </Input.Group>

  );
}

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(CategorySelectForTwo));

/***/ }),

/***/ 40934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CommonTable; }
});

// NAMESPACE OBJECT: ./src/components/CommonTable/utils/queryStructure.ts
var queryStructure_namespaceObject = {};
__webpack_require__.r(queryStructure_namespaceObject);
__webpack_require__.d(queryStructure_namespaceObject, {
  "useCustom": function() { return useCustom; },
  "useHefei": function() { return useHefei; },
  "useNormal": function() { return useNormal; },
  "usePage": function() { return usePage; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/table/style/index.js
var style = __webpack_require__(66456);
// EXTERNAL MODULE: ./node_modules/antd/es/table/index.js + 45 modules
var table = __webpack_require__(97423);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/antd/es/tag/style/index.js
var tag_style = __webpack_require__(71153);
// EXTERNAL MODULE: ./node_modules/antd/es/tag/index.js + 1 modules
var tag = __webpack_require__(60331);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(93224);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/.umi-production/core/umiExports.ts + 18 modules
var umiExports = __webpack_require__(71720);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
// EXTERNAL MODULE: ./src/utils/fetchQuery/index.tsx
var fetchQuery = __webpack_require__(48344);
;// CONCATENATED MODULE: ./src/components/CommonTable/utils/queryStructure.ts
var useNormal = (page, size) => {
  return {
    page,
    size
  };
};
var useHefei = (page, size) => {
  return {
    pageReq: {
      pageNum: page,
      pageSize: size
    }
  };
};
var useCustom = (page, size) => {
  return {
    pageInfo: {
      page,
      size
    }
  };
};
var usePage = (page, size) => {
  return {
    page: {
      page,
      size
    }
  };
};
;// CONCATENATED MODULE: ./src/components/CommonTable/utils/api2Response.ts
/**
 * API 2.0（apigw2 / fetchQuery）响应归一化
 * 兼容 { result: { list, total } } 与 { result: { result: { list, total } } } 两种结构
 * 兼容合肥网关 codeInfo 格式：code !== 0 表示业务失败（如参数校验不通过）
 */
function normalizeApi2FetchResponse(response) {
  var _gatewayResult$codeIn, _gatewayResult$result, _ref, _gatewayResult$result2;

  var gatewayResult = response === null || response === void 0 ? void 0 : response.result;
  var codeInfo = (_gatewayResult$codeIn = gatewayResult === null || gatewayResult === void 0 ? void 0 : gatewayResult.codeInfo) !== null && _gatewayResult$codeIn !== void 0 ? _gatewayResult$codeIn : gatewayResult === null || gatewayResult === void 0 ? void 0 : (_gatewayResult$result = gatewayResult.result) === null || _gatewayResult$result === void 0 ? void 0 : _gatewayResult$result.codeInfo;

  if (codeInfo && codeInfo.code !== 0) {
    return {
      success: false,
      message: codeInfo.msg,
      result: {}
    };
  }

  var bizPayload = (_ref = (_gatewayResult$result2 = gatewayResult === null || gatewayResult === void 0 ? void 0 : gatewayResult.result) !== null && _gatewayResult$result2 !== void 0 ? _gatewayResult$result2 : gatewayResult) !== null && _ref !== void 0 ? _ref : {};
  var success = (response === null || response === void 0 ? void 0 : response.success) !== false && (gatewayResult === null || gatewayResult === void 0 ? void 0 : gatewayResult.success) !== false;
  return {
    success,
    result: bizPayload
  };
}
;// CONCATENATED MODULE: ./src/components/CommonTable/useVirtualTable.tsx




var _excluded = ["children"],
    _excluded2 = ["children"],
    _excluded3 = ["style", "children"],
    _excluded4 = ["width"];

/* eslint-disable no-case-declarations */


var initialState = {
  // 行高度
  rowHeight: 0,
  // 当前的scrollTop
  curScrollTop: 0,
  // 可滚动区域的高度
  scrollHeight: 0,
  // scrollY值
  tableScrollY: 0
};

function reducer(state, action) {
  switch (action.type) {
    // 改变trs 即 改变渲染的列表trs
    case 'changeTrs':
      // 获取值
      var curScrollTop = action.curScrollTop;
      var scrollHeight = action.scrollHeight;
      var tableScrollY = action.tableScrollY;

      if (scrollHeight <= 0) {
        scrollHeight = 0;
      }

      if (state.scrollHeight !== 0) {
        if (tableScrollY === state.tableScrollY) {
          scrollHeight = state.scrollHeight;
        }
      }

      if (state.scrollHeight && curScrollTop > state.scrollHeight) {
        curScrollTop = state.scrollHeight;
      }

      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, state), {}, {
        curScrollTop,
        scrollHeight,
        tableScrollY
      });
    // 初始化每行的高度, 表格总高度, 渲染的条数

    case 'initHeight':
      // 获取值
      var rowHeight = action.rowHeight;
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, state), {}, {
        rowHeight
      });

    case 'reset':
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, state), {}, {
        curScrollTop: 0,
        scrollHeight: 0
      });

    default:
      throw new Error();
  }
}

var ScrollContext = /*#__PURE__*/(0,react.createContext)({
  dispatch: undefined,
  renderLen: 1,
  start: 0,
  offsetStart: 0,
  rowHeight: 0,
  totalLen: 0
});
var scrollY = 0;

function VRow(props) {
  var _useContext = (0,react.useContext)(ScrollContext),
      dispatch = _useContext.dispatch,
      rowHeight = _useContext.rowHeight,
      totalLen = _useContext.totalLen;

  var children = props.children,
      restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var trRef = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    var initHeight = trRef => {
      if (trRef !== null && trRef !== void 0 && trRef.offsetHeight && !rowHeight && totalLen) {
        var _trRef$offsetHeight;

        var tempRowHeight = (_trRef$offsetHeight = trRef === null || trRef === void 0 ? void 0 : trRef.offsetHeight) !== null && _trRef$offsetHeight !== void 0 ? _trRef$offsetHeight : 0;
        dispatch && dispatch({
          type: 'initHeight',
          rowHeight: tempRowHeight
        });
      }
    };

    initHeight(trRef === null || trRef === void 0 ? void 0 : trRef.current);
  }, [trRef, dispatch, rowHeight, totalLen]);
  return /*#__PURE__*/react.createElement("tr", (0,esm_extends/* default */.Z)({}, restProps, {
    ref: trRef,
    style: {
      height: rowHeight ? rowHeight : 'auto',
      boxSizing: 'border-box'
    }
  }), children);
}

function VWrapper(props) {
  var children = props.children,
      restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded2);

  var _useContext2 = (0,react.useContext)(ScrollContext),
      renderLen = _useContext2.renderLen,
      start = _useContext2.start,
      offsetStart = _useContext2.offsetStart;

  var contents = children[1];
  var tempNode = null;

  if (Array.isArray(contents) && contents.length) {
    tempNode = [children[0], contents.slice(start, start + renderLen).map(item => {
      if (Array.isArray(item)) {
        // 兼容antd v4.3.5 --- rc-table 7.8.1及以下
        return item[0];
      } else {
        // 处理antd ^v4.4.0  --- rc-table ^7.8.2
        return item;
      }
    })];
  } else {
    tempNode = children;
  }

  return /*#__PURE__*/react.createElement("tbody", (0,esm_extends/* default */.Z)({}, restProps, {
    style: {
      transform: "translateY(-".concat(offsetStart, "px)")
    }
  }), tempNode);
}

function VTable(props) {
  var _children$1$props$dat, _children$, _children$$props, _children$$props$data;

  var style = props.style,
      children = props.children,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded3);

  var width = style.width,
      restStyle = (0,objectWithoutProperties/* default */.Z)(style, _excluded4);

  var _useReducer = (0,react.useReducer)(reducer, initialState),
      _useReducer2 = (0,slicedToArray/* default */.Z)(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var wrapTableRef = (0,react.useRef)(null);
  var tableRef = (0,react.useRef)(null); // 数据的总条数

  var _useState = (0,react.useState)((_children$1$props$dat = (_children$ = children[1]) === null || _children$ === void 0 ? void 0 : (_children$$props = _children$.props) === null || _children$$props === void 0 ? void 0 : (_children$$props$data = _children$$props.data) === null || _children$$props$data === void 0 ? void 0 : _children$$props$data.length) !== null && _children$1$props$dat !== void 0 ? _children$1$props$dat : 0),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      totalLen = _useState2[0],
      setTotalLen = _useState2[1];

  (0,react.useEffect)(() => {
    var _children$2, _children$2$props, _children$2$props$dat;

    if ((0,lodash.isNumber)((_children$2 = children[1]) === null || _children$2 === void 0 ? void 0 : (_children$2$props = _children$2.props) === null || _children$2$props === void 0 ? void 0 : (_children$2$props$dat = _children$2$props.data) === null || _children$2$props$dat === void 0 ? void 0 : _children$2$props$dat.length)) {
      var _children$3, _children$3$props, _children$3$props$dat;

      setTotalLen((_children$3 = children[1]) === null || _children$3 === void 0 ? void 0 : (_children$3$props = _children$3.props) === null || _children$3$props === void 0 ? void 0 : (_children$3$props$dat = _children$3$props.data) === null || _children$3$props$dat === void 0 ? void 0 : _children$3$props$dat.length);
    }
  }, [children]); // table总高度

  var tableHeight = (0,react.useMemo)(() => {
    var temp = 'auto';

    if (state.rowHeight && totalLen) {
      temp = state.rowHeight * totalLen + 10;
    }

    return temp;
  }, [state.rowHeight, totalLen]); // table的scrollY值

  var tableScrollY = 0;

  if (typeof scrollY === 'string') {
    var _wrapTableRef$current, _wrapTableRef$current2;

    tableScrollY = (_wrapTableRef$current = wrapTableRef.current) === null || _wrapTableRef$current === void 0 ? void 0 : (_wrapTableRef$current2 = _wrapTableRef$current.parentNode) === null || _wrapTableRef$current2 === void 0 ? void 0 : _wrapTableRef$current2.offsetHeight;
  } else {
    tableScrollY = scrollY;
  }

  if ((0,lodash.isNumber)(tableHeight) && tableHeight < tableScrollY) {
    tableScrollY = tableHeight;
  } // 处理tableScrollY <= 0的情况


  if (tableScrollY <= 0) {
    tableScrollY = 0;
  } // 渲染的条数


  var renderLen = (0,react.useMemo)(() => {
    var temp = 1; // console.log(state.rowHeight, totalLen, tableScrollY)

    if (state.rowHeight && totalLen && tableScrollY) {
      if (tableScrollY <= 0) {
        temp = 0;
      } else {
        var tempRenderLen = (tableScrollY / state.rowHeight | 0) + 1 + 2; // console.log('tempRenderLen', tempRenderLen)

        temp = tempRenderLen > totalLen ? totalLen : tempRenderLen;
      }
    }

    return temp;
  }, [state.rowHeight, totalLen, tableScrollY]); // 渲染中的第一条

  var start = state.rowHeight ? state.curScrollTop / state.rowHeight | 0 : 0; // 偏移量

  var offsetStart = state.rowHeight ? state.curScrollTop % state.rowHeight : 0; // 用来优化向上滚动出现的空白

  if (state.curScrollTop && state.rowHeight && state.curScrollTop > state.rowHeight) {
    if (start > totalLen - renderLen) {
      // 可能以后会做点操作
      offsetStart = 0;
    } else if (start > 1) {
      start = start - 1;
      offsetStart += state.rowHeight;
    }
  } else {
    start = 0;
  }

  (0,react.useEffect)(() => {
    var _wrapTableRef$current3;

    // totalLen变化, 那么搜索条件一定变化, 数据也一定变化.
    var parentNode = (_wrapTableRef$current3 = wrapTableRef.current) === null || _wrapTableRef$current3 === void 0 ? void 0 : _wrapTableRef$current3.parentNode;

    if (parentNode) {
      parentNode.scrollTop = 0;
    }

    dispatch({
      type: 'reset'
    });
  }, [totalLen]);
  (0,react.useEffect)(() => {
    var _wrapTableRef$current4;

    var throttleScroll = (0,lodash.throttle)(e => {
      var _e$target$scrollTop, _e$target;

      var scrollTop = (_e$target$scrollTop = e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.scrollTop) !== null && _e$target$scrollTop !== void 0 ? _e$target$scrollTop : 0;

      if (scrollTop !== state.curScrollTop) {
        var scrollHeight = e.target.scrollHeight - tableScrollY;
        dispatch({
          type: 'changeTrs',
          curScrollTop: scrollTop,
          scrollHeight,
          tableScrollY
        });
      }
    }, 60);
    var ref = wrapTableRef === null || wrapTableRef === void 0 ? void 0 : (_wrapTableRef$current4 = wrapTableRef.current) === null || _wrapTableRef$current4 === void 0 ? void 0 : _wrapTableRef$current4.parentNode;

    if (ref) {
      ref.addEventListener('scroll', throttleScroll);
    }

    return () => {
      ref.removeEventListener('scroll', throttleScroll);
    };
  }, [wrapTableRef, state.curScrollTop, tableScrollY, state.scrollHeight]);
  return /*#__PURE__*/react.createElement("div", {
    className: "virtuallist",
    ref: wrapTableRef,
    style: {
      width: '100%',
      position: 'relative',
      height: tableHeight,
      boxSizing: 'border-box',
      paddingTop: state.curScrollTop
    }
  }, /*#__PURE__*/react.createElement(ScrollContext.Provider, {
    value: {
      dispatch,
      rowHeight: state.rowHeight,
      start,
      offsetStart,
      renderLen,
      totalLen
    }
  }, /*#__PURE__*/react.createElement("table", (0,esm_extends/* default */.Z)({}, rest, {
    ref: tableRef,
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, restStyle), {}, {
      width,
      position: 'relative'
    })
  }), children)));
}

function useVirtualTable(props) {
  var height = props.height,
      useVirtual = props.useVirtual;

  if (!useVirtual) {
    return null;
  }

  scrollY = height;
  return {
    table: VTable,
    body: {
      wrapper: VWrapper,
      row: VRow
    }
  };
}
// EXTERNAL MODULE: ./src/hooks/useCompareEffect.ts
var useCompareEffect = __webpack_require__(19125);
;// CONCATENATED MODULE: ./src/components/CommonTable/index.tsx










var CommonTable_excluded = ["current", "pageSize", "isPaging", "searchParams"],
    CommonTable_excluded2 = ["body"];

/* eslint-disable no-throw-literal */

/**
 * 通用列表
 */

/* eslint-disable @typescript-eslint/member-ordering */

/* eslint-disable @typescript-eslint/no-unused-vars */











// 列表跨页选择
// const tableSelectMap = ({
//   selectedLength: 0,
//   selectedObject: {}
// })
var CommonTable = (props, ref) => {
  var _props$pageSize;

  var formatResult = props.formatResult,
      _props$reqStructure = props.reqStructure,
      reqStructure = _props$reqStructure === void 0 ? 'useNormal' : _props$reqStructure,
      tableOptions = props.tableOptions,
      searchParams = props.searchParams,
      _props$cacheTable = props.cacheTable,
      cacheTable = _props$cacheTable === void 0 ? false : _props$cacheTable,
      propsPageSize = props.pageSize,
      queryDataUrl = props.queryDataUrl,
      returnData = props.returnData,
      _props$cancelRequest = props.cancelRequest,
      cancelRequest = _props$cancelRequest === void 0 ? false : _props$cancelRequest,
      rowSelectCallback = props.rowSelectCallback,
      sortCallback = props.sortCallback,
      setTableDataAfterRequest = props.setTableDataAfterRequest; // 多选内容

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      selectedRowKeys = _useState2[0],
      setSelectedRowKeys = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = (0,react.useState)({
    dataSource: [],
    total: 0,
    current: 1,
    pageSize: (_props$pageSize = props.pageSize) !== null && _props$pageSize !== void 0 ? _props$pageSize : 30
  }),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      tableParams = _useState6[0],
      setTableParams = _useState6[1]; // 列


  var _useState7 = (0,react.useState)(props.columns),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      columns = _useState8[0],
      setColumns = _useState8[1];

  var didMount = (0,react.useRef)(false); // 列表跨页选择

  var tableSelectMap = (0,react.useRef)({
    selectedLength: 0,
    selectedObject: {}
  });
  var dispatch = (0,umiExports/* useDispatch */.I0)();
  var tableCache = (0,umiExports/* useSelector */.v9)(state => {
    var _state$tableCache;

    return (_state$tableCache = state.tableCache) === null || _state$tableCache === void 0 ? void 0 : _state$tableCache[location.pathname];
  }) || {};
  /**
   * 获取页码与每页条数
   */

  var getPage = (0,react.useCallback)((current, pageSize, isPaging) => {
    if (cacheTable) {
      var pageNo = current ? current : tableCache.page || 1;
      var size = pageSize ? pageSize : tableCache.size || propsPageSize || 30; // 当页面加载完毕以及当前请求不是页码与条数变化时

      var useDefault = didMount.current && !isPaging;
      var usePage = useDefault ? 1 : pageNo;
      var useSize = useDefault ? 30 : size;
      return {
        pageNo: usePage,
        size: useSize
      };
    }

    return {
      pageNo: current || 1,
      size: pageSize || propsPageSize || 30
    };
  }, [cacheTable, propsPageSize, tableCache.page, tableCache.size]);
  /**
   * values 外部查询调用传参
   * pageParams 分页等查询参数
   */

  var sendRequest = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(reqProps) {
      var current, pageSize, _reqProps$isPaging, isPaging, searchParams, reset, _getPage, pageNo, size, params, _ref2, isApi2, result, _result$result, _result$result$total, total, l, d, data, totalCount, list;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              setTableParams(v => {
                return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
                  dataSource: []
                });
              });
              current = reqProps.current, pageSize = reqProps.pageSize, _reqProps$isPaging = reqProps.isPaging, isPaging = _reqProps$isPaging === void 0 ? true : _reqProps$isPaging, searchParams = reqProps.searchParams, reset = (0,objectWithoutProperties/* default */.Z)(reqProps, CommonTable_excluded);
              _getPage = getPage(current, pageSize, isPaging), pageNo = _getPage.pageNo, size = _getPage.size;
              params = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, queryStructure_namespaceObject[reqStructure](pageNo, size)), searchParams), reset);
              _context.prev = 5;

              if (queryDataUrl) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              //params.param.filterPendingApproval=0
              //message.info('表单查询参数:'+JSON.stringify(params)) //todo m delete
              // API 2.0：路径以 / 开头，走 apigw2 新网关（fetchQuery），分页一般为 page/size
              isApi2 = queryDataUrl.startsWith('/');

              if (!isApi2) {
                _context.next = 17;
                break;
              }

              _context.t1 = normalizeApi2FetchResponse;
              _context.next = 13;
              return (0,fetchQuery/* default */.Z)(queryDataUrl, 'POST', params);

            case 13:
              _context.t2 = _context.sent;
              _context.t0 = (0, _context.t1)(_context.t2);
              _context.next = 20;
              break;

            case 17:
              _context.next = 19;
              return (0,ypRequest/* default */.Z)(queryDataUrl, params);

            case 19:
              _context.t0 = _context.sent;

            case 20:
              result = _context.t0;

              if (!(isApi2 && result.success === false)) {
                _context.next = 23;
                break;
              }

              return _context.abrupt("return");

            case 23:
              if (formatResult instanceof Function) {
                // 交给调用处格式化数据
                result.result = formatResult(result.result);
              }

              _result$result = result.result, _result$result$total = _result$result.total, total = _result$result$total === void 0 ? 0 : _result$result$total, l = _result$result.list, d = _result$result.data;
              data = (_ref2 = d !== null && d !== void 0 ? d : l) !== null && _ref2 !== void 0 ? _ref2 : [];

              if (!(!data || !Array.isArray(data))) {
                _context.next = 28;
                break;
              }

              throw '接口返回的数据结构错误';

            case 28:
              // 对「total」进行数据转化
              totalCount = +total;

              if (!isNaN(totalCount)) {
                _context.next = 31;
                break;
              }

              throw '「total」字段类型错误';

            case 31:
              // 添加唯一key
              list = data.map(v => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
                commonTableKey: (0,lodash.uniqueId)('commonTable_')
              })); // 如果需要对数据进行操作

              if (!setTableDataAfterRequest) {
                _context.next = 36;
                break;
              }

              _context.next = 35;
              return setTableDataAfterRequest(list);

            case 35:
              list = _context.sent;

            case 36:
              setSelectedRowKeys([]); // Note: hooks中不能依赖tableParams又setTableParams

              setTableParams(v => {
                return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
                  dataSource: list,
                  total,
                  current: pageNo,
                  pageSize: size
                });
              });

              if (returnData) {
                returnData(list, {
                  dataSource: list,
                  total,
                  current: pageNo,
                  pageSize: size
                });
              } // 缓存则派发


              if (cacheTable) {
                dispatch({
                  type: 'tableCache/save',
                  payload: {
                    [location.pathname]: {
                      page: pageNo,
                      size: size
                    }
                  }
                });
              }

              _context.next = 44;
              break;

            case 42:
              _context.prev = 42;
              _context.t3 = _context["catch"](5);

            case 44:
              _context.prev = 44;
              setLoading(false);
              return _context.finish(44);

            case 47:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 42, 44, 47]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), // 依赖不要改
  [getPage, reqStructure, queryDataUrl, formatResult, setTableDataAfterRequest, returnData, cacheTable, dispatch]); // 表格事件操作

  var changeTable = (0,react.useCallback)((pagination, filters, sorters) => {
    var current = pagination.current,
        pageSize = pagination.pageSize;
    var column = sorters.column; // 防止没有排序的列发生请求

    if (sorters.column && !column.sorter) {
      return;
    }

    sendRequest({
      current,
      pageSize,
      isPaging: true,
      searchParams
    }); // 排序的回调

    if (sortCallback) {
      sortCallback(filters, sorters);
    }

    if (rowSelectCallback) {
      rowSelectCallback([], []);
    }
  }, [sortCallback, rowSelectCallback, sendRequest, searchParams]);
  /**
   * 默认的多选配置
   */

  var selection = (0,react.useMemo)(() => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.rowSelection), {}, {
    selectedRowKeys: selectedRowKeys,
    onChange: (keys, selectedRows) => {
      setSelectedRowKeys(keys);

      if (rowSelectCallback) {
        rowSelectCallback(keys, selectedRows);
      }
    }
  }), [rowSelectCallback, selectedRowKeys, tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.rowSelection]);
  /**
   * 获取CommonTable的selection配置
   * 缓存 rowselect 配置
   */

  var getRowSelection = (0,react.useMemo)(() => {
    // 如果没有自定义配置「rowSelection」以及没有「rowSelectCallback」表示不需要列表多选
    if (!(tableOptions !== null && tableOptions !== void 0 && tableOptions.rowSelection) && !props.rowSelectCallback) {
      return undefined;
    }

    return selection;
  }, [props.rowSelectCallback, selection, tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.rowSelection]);
  /**
   * 点击列表行
   * @param ev 点击的事件
   * @param record 当前行的数据
   */

  var onRowClick = (0,react.useCallback)((ev, record) => {
    if (!getRowSelection) return; // 行的键

    var rowKey = tableOptions !== null && tableOptions !== void 0 && tableOptions.rowKey ? tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.rowKey : record.id ? 'id' : 'commonTableKey'; // 获取键对应的值

    var tableRowVal = record[rowKey];
    var isSingle = selection.type ? selection.type === 'radio' : false;
    var exited = selectedRowKeys.includes(tableRowVal);
    var selectedKeys = exited ? selectedRowKeys.filter(v => v !== tableRowVal) : isSingle ? [tableRowVal] : selectedRowKeys.concat(tableRowVal);
    var selectedRows = tableParams.dataSource.filter((v, k) => {
      return selectedKeys.includes(v[rowKey]);
    });
    setSelectedRowKeys(selectedKeys);

    if (props.rowSelectCallback) {
      props.rowSelectCallback(selectedKeys, selectedRows);
    }
  }, [getRowSelection, selectedRowKeys, props, selection.type, tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.rowKey, tableParams.dataSource]);
  var tableRowOption = (0,react.useCallback)((record, index) => {
    var rowsData = {};

    if (tableOptions !== null && tableOptions !== void 0 && tableOptions.onRow && typeof (tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.onRow) === 'function') {
      rowsData = tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.onRow(record, index);
    }

    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, rowsData), {}, {
      onClick: ev => onRowClick(ev, record)
    });
  }, [onRowClick, tableOptions]);
  var calculateFunc = (0,react.useCallback)(() => {
    var _props$scrollYSize = props.scrollYSize,
        scrollYSize = _props$scrollYSize === void 0 ? 0 : _props$scrollYSize;

    if (scrollYSize) {
      return scrollYSize;
    }

    var clientHeight = document.body.clientHeight;
    var ele = document.getElementById('tablePart');

    if (ele) {
      var top = ele.getBoundingClientRect().top;
      var TOP_DIST = 60; // 上边距

      var BOTTOM_DIST = 55; // 下边距

      var scrollY = clientHeight - top - TOP_DIST - BOTTOM_DIST;
      return scrollY;
    }
  }, [props]);
  var scrollProps = (0,react.useMemo)(() => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.scroll), {}, {
    y: calculateFunc()
  }), [calculateFunc, tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.scroll]); // 使用虚拟列表

  var virtualComponents = useVirtualTable({
    height: calculateFunc(),
    useVirtual: props.useVirtual
  });
  var handleResize = (0,react.useCallback)(index => (e, _ref3) => {
    var size = _ref3.size;
    setColumns(columns => {
      var nextColumns = [...columns];
      nextColumns[index] = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, nextColumns[index]), {}, {
        width: size.width
      });
      return nextColumns;
    });
  }, []);
  var resizeColumns = (0,react.useMemo)(() => {
    return columns.map((col, index) => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, col), {}, {
      onHeaderCell: column => ({
        width: column.width,
        onResize: handleResize(index)
      })
    }));
  }, [handleResize, columns]);
  var components = (0,react.useMemo)(() => {
    var _ref4 = (tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.components) || {},
        body = _ref4.body,
        rest = (0,objectWithoutProperties/* default */.Z)(_ref4, CommonTable_excluded2);

    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, rest), {}, {
      header: {// cell: ResizableTitle
      },
      body: (0,objectSpread2/* default */.Z)({}, body) // table: props.cancelVirtual ? null : virtualComponents?.table

    });
  }, [tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.components]);

  var getPagination = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
    showSizeChanger: true,
    showQuickJumper: true,
    pageSizeOptions: ['30', '100', '300', '500'],
    pageSize: tableParams.pageSize
  }, tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.pagination), {}, {
    total: tableParams.total,
    current: tableParams.current,
    showTotal: total => /*#__PURE__*/react.createElement("div", null, rowSelectCallback && /*#__PURE__*/react.createElement("span", {
      className: "mRight16"
    }, "\u5DF2\u9009\u62E9\uFF1A", /*#__PURE__*/react.createElement(tag/* default */.Z, {
      color: "volcano"
    }, selectedRowKeys.length), "\u6761"), "\u5171 ", total, " \u6761")
  });
  /**
   * 通过该 hook 定义父组件 ref 拿到子组件的实例的内容
   * 父组件使用 reflashTable 来调用子组件 sendRequest 这个方法
   */


  (0,react.useImperativeHandle)(ref, () => ({
    reflashTable: params => sendRequest((0,objectSpread2/* default */.Z)({
      current: tableParams.current,
      pageSize: tableParams.pageSize
    }, params)),
    getTableData: () => tableParams
  }), [sendRequest, tableParams]);
  /**
   * 初始化加载时
   */

  (0,react.useEffect)(() => {
    function autoSendRequest() {
      return _autoSendRequest.apply(this, arguments);
    }

    function _autoSendRequest() {
      _autoSendRequest = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2() {
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (cancelRequest) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return sendRequest({
                  isPaging: false,
                  searchParams
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _autoSendRequest.apply(this, arguments);
    }

    autoSendRequest();
  }, [cancelRequest, searchParams]); // 不能添加函数依赖:sendRequest，否则请求错乱
  // 替换当前页的数据

  (0,react.useEffect)(() => {
    setTableParams(v => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
      dataSource: props.dataSource || []
    }));
  }, [props.dataSource]);
  /**
   * 覆盖组件表格的参数；
   * 用于表格的自定义操作
   */

  (0,useCompareEffect/* default */.Z)(() => {
    if (!props.tableParams) {
      return;
    }

    setTableParams(props.tableParams);
  }, [props.tableParams]);
  (0,react.useEffect)(() => {
    didMount.current = true;
  }, []);
  return /*#__PURE__*/react.createElement("div", {
    className: "commonTable",
    id: "tablePart"
  }, /*#__PURE__*/react.createElement(table/* default */.Z, (0,esm_extends/* default */.Z)({
    columns: props.columns,
    dataSource: tableParams.dataSource.filter(Boolean),
    rowKey: r => r.id ? r.id : r.commonTableKey || r.editableTableKey,
    onChange: changeTable,
    key: "table",
    size: "small",
    loading: loading
  }, tableOptions, {
    // bordered
    onRow: tableRowOption,
    components: components,
    scroll: scrollProps,
    rowSelection: getRowSelection,
    pagination: props.hidePagination ? false : getPagination
  })));
};

/* harmony default export */ var components_CommonTable = (/*#__PURE__*/(0,react.forwardRef)(CommonTable));

/***/ }),

/***/ 73520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var CommonWrap = props => {
  var cls = props.cls;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "commonWrap ".concat(cls),
    id: props.id
  }, props.children);
};

CommonWrap.defaultProps = {
  type: 1,
  id: 1
};
/* harmony default export */ __webpack_exports__["Z"] = (CommonWrap);

/***/ }),

/***/ 16494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_DetailInfo; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/style/index.js
var style = __webpack_require__(22385);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 1 modules
var tooltip = __webpack_require__(31097);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ./src/components/DetailInfo/components/Grid.tsx



/**
 * 固定布局
 */




var fillObj = {
  label: '',
  name: '',
  value: ''
}; // 一行

function rowEle(key, cols) {
  return /*#__PURE__*/react.createElement("div", {
    className: "yp-rowItem",
    key: key
  }, cols.map(v => v));
}

function renderInfo(list, num) {
  var isArray = Array.isArray(list);
  var data = isArray ? list : Array.from(list.values());
  var row = [];
  var col = []; // 数据整行展示的数据量不够时，给空位补充空数据。避免布局混乱

  var dataLen = data.length;
  var resetLen = dataLen % num === 0 ? 0 : num - dataLen % num;
  var arr = new Array(resetLen).fill(isArray ? fillObj : ['', '']);
  var newList = data.concat(arr);

  for (var index = 0; index < newList.length; index++) {
    var element = data[index] || ['', ''];

    var _randomData = lodash_default().uniqueId('detailInfo_');

    if (isArray) {
      var _element$label, _element$value, _element$lighthigh;

      element = [(_element$label = element.label) !== null && _element$label !== void 0 ? _element$label : '', (_element$value = element.value) !== null && _element$value !== void 0 ? _element$value : '', (_element$lighthigh = element.lighthigh) !== null && _element$lighthigh !== void 0 ? _element$lighthigh : ''];
    }

    var colItemKey = _randomData.toString() + element[0]; // 一行中的每一项

    var colEle = /*#__PURE__*/react.createElement("div", {
      className: "yp-colItem",
      key: colItemKey,
      style: {
        maxWidth: "".concat(100 / num, "%")
      }
    }, /*#__PURE__*/react.createElement("span", {
      className: "text"
    }, "".concat(element[0]).concat(element[0] && '：')), /*#__PURE__*/react.createElement(tooltip/* default */.Z, {
      placement: "topLeft",
      title: element[1]
    }, /*#__PURE__*/react.createElement("span", {
      className: classnames_default()('textVal', 'ellipsis', {
        strong: !!element[2]
      })
    }, element[1])));

    if (index % num === 0) {
      col.length > 0 && row.push(rowEle(colItemKey, col));
      col = [];
    }

    col.push(colEle);
  } // 获取随机值以防 key 的值重复


  var randomData = lodash_default().uniqueId('detailInfo_');

  row.push(rowEle(randomData, col));
  return row;
}

function DetailInfo(props) {
  var map = props.map,
      cols = props.cols;
  return /*#__PURE__*/react.createElement("div", {
    className: "yp-detailInfo"
  }, renderInfo(map, cols));
}

/* harmony default export */ var Grid = (DetailInfo);
;// CONCATENATED MODULE: ./src/components/DetailInfo/components/Response.tsx



/**
 * 响应式布局
 */




function Response(props) {
  var map = props.map;
  var isArray = Array.isArray(map);
  var data = isArray ? map : Array.from(map.values()).map(v => ({
    label: v[0],
    value: v[1],
    lighthigh: v[2]
  }));
  return /*#__PURE__*/react.createElement("div", {
    className: "yp-response"
  }, data.map(v => /*#__PURE__*/react.createElement("div", {
    className: "yp-response-item",
    key: v.label
  }, /*#__PURE__*/react.createElement("span", {
    className: "text"
  }, v.label, "\uFF1A"), /*#__PURE__*/react.createElement(tooltip/* default */.Z, {
    placement: "topLeft",
    title: v.value
  }, /*#__PURE__*/react.createElement("span", {
    className: classnames_default()('textVal', 'ellipsis', {
      strong: v.lighthigh
    })
  }, v.value)))));
}

/* harmony default export */ var components_Response = (Response);
;// CONCATENATED MODULE: ./src/components/DetailInfo/index.tsx
/**
 * 详情页面的头部文案的布局展示
 */





function DetailInfo_DetailInfo(props) {
  if (props.responsed) {
    return /*#__PURE__*/react.createElement(components_Response, props);
  }

  return /*#__PURE__*/react.createElement(Grid, props);
}

/* harmony default export */ var components_DetailInfo = (DetailInfo_DetailInfo);

/***/ }),

/***/ 77673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_dropdown_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59250);
/* harmony import */ var antd_es_dropdown__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13013);
/* harmony import */ var antd_es_divider_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48736);
/* harmony import */ var antd_es_divider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27049);
/* harmony import */ var antd_es_menu_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30887);
/* harmony import */ var antd_es_menu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87968);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92977);








var MenuItem = antd_es_menu__WEBPACK_IMPORTED_MODULE_4__/* .default.Item */ .Z.Item;
/**
 * 渲染不含下拉功能的操作按钮
 * @param {array} list
 */

function renderMenu(list, Element, hasDiver) {
  var div = hasDiver === null ? '' : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_divider__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    type: "vertical"
  });
  var length = list.length;
  return list && list.map((value, index) => {
    // 判断当前是否为最后一项
    var isLast = index + 1 === length;
    var dom = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
      key: "".concat(value.name, "-").concat(index)
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("a", {
      onClick: value.event
    }, value.name), !isLast && div);

    if (Element) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(Element, {
        key: "".concat(value.name, "-").concat(index)
      }, dom);
    }

    return dom;
  });
}
/**
 * 下拉 菜单
 * @param {array} list
 */


function renderDropMenu(list) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_menu__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, null, renderMenu(list, MenuItem, null));
}
/**
 * 渲染含下拉功能的操作按钮
 * @param {array} list
 * @param {number} num  展示在外面的数量
 */


function renderDrop(list, num) {
  var outsideArr = list.slice(0, num);
  var resetList = list.slice(num); // 取出前两项

  var commonMenu = renderMenu(outsideArr);
  var dropMenu = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_dropdown__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    overlay: renderDropMenu(resetList)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("a", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, null)));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, commonMenu, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_divider__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    type: "vertical"
  }), dropMenu);
}

function DropdownMenu(props) {
  var dataList = props.dataList,
      num = props.num;
  var list = dataList.filter(Boolean);
  var dataLen = list.length; // const count = num + 1

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, dataLen > num ? renderDrop(list, num) : renderMenu(list));
}

DropdownMenu.defaultProps = {
  num: 2
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_3__.memo)(DropdownMenu));

/***/ }),

/***/ 8149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ EditableTable_PageEditableTable; },
  "Ax": function() { return /* binding */ getEditableTableKey; }
});

// UNUSED EXPORTS: compareAndChangeData

// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/CommonTable/index.tsx + 3 modules
var CommonTable = __webpack_require__(40934);
// EXTERNAL MODULE: ./src/components/EditableTable/components/EditableCell.tsx
var EditableCell = __webpack_require__(64610);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js
var createForOfIteratorHelper = __webpack_require__(91220);
// EXTERNAL MODULE: ./node_modules/antd/es/popconfirm/style/index.js
var popconfirm_style = __webpack_require__(62350);
// EXTERNAL MODULE: ./node_modules/antd/es/popconfirm/index.js
var popconfirm = __webpack_require__(75443);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/index.js
var message_style = __webpack_require__(34792);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(48086);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(93224);
// EXTERNAL MODULE: ./src/components/EditableTable/components/Field.tsx
var Field = __webpack_require__(67898);
// EXTERNAL MODULE: ./src/components/EditableTable/utils/context.tsx
var context = __webpack_require__(88050);
// EXTERNAL MODULE: ./src/components/EditableTable/hooks/getContentValue.ts
var getContentValue = __webpack_require__(33461);
;// CONCATENATED MODULE: ./src/components/EditableTable/components/NewEditableCell.tsx










var _excluded = ["title", "children", "dataIndex", "type", "record", "rowIndex", "render", "editIndex", "dataList", "fieldOptions", "setCellRowValueByChange", "toggleEditCell"];

/* eslint-disable react-hooks/rules-of-hooks */







var NewEditableCell_Field = Field;

var NewEditableCell_EditableCell = props => {
  var title = props.title,
      children = props.children,
      dataIndex = props.dataIndex,
      type = props.type,
      record = props.record,
      rowIndex = props.rowIndex,
      render = props.render,
      colIndex = props.editIndex,
      dataList = props.dataList,
      fieldOptions = props.fieldOptions,
      setCellRowValueByChange = props.setCellRowValueByChange,
      toggleEditCell = props.toggleEditCell,
      restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var _useContext = (0,react.useContext)(context/* EditableContext */.P),
      handleDeleteRow = _useContext.handleDeleteRow,
      handleSaveRow = _useContext.handleSaveRow,
      hideDeleteBtn = _useContext.hideDeleteBtn,
      tableTag = _useContext.tableTag; // 拼接操作


  if (render && title === '操作') {
    var deleteBtn = () => {
      return /*#__PURE__*/react.createElement(popconfirm/* default */.Z, {
        title: "\u786E\u8BA4\u5220\u9664\u8FD9\u6761\u6570\u636E\u5417\uFF1F",
        onConfirm: () => {
          if (record !== null && record !== void 0 && record.notAllowDelete) {
            message.default.warn('无权删除该条数据');

            return;
          }

          if (handleDeleteRow) {
            handleDeleteRow(record.editableTableKey);
          }
        },
        okText: "\u786E\u8BA4",
        cancelText: "\u53D6\u6D88"
      }, /*#__PURE__*/react.createElement("a", {
        style: {
          marginRight: '8px'
        }
      }, "\u5220\u9664"));
    }; // 给新增的行添加背景颜色


    return /*#__PURE__*/react.createElement("td", restProps, !hideDeleteBtn && deleteBtn(), render(record[dataIndex], record, rowIndex, deleteBtn));
  }

  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      editing = _useState2[0],
      setEditing = _useState2[1]; // 自定义渲染的文本标签


  var renderRef = (0,react.useRef)(null); // 设置type的文本标签

  var textRef = (0,react.useRef)(null);
  /**
   * 下拉框组件的数据
   */

  var cellDataList = (0,react.useMemo)(() => {
    if (typeof dataList === 'function') {
      var _dataList;

      return (_dataList = dataList(record[dataIndex], record, rowIndex)) !== null && _dataList !== void 0 ? _dataList : [];
    }

    return dataList !== null && dataList !== void 0 ? dataList : [];
  }, [dataList, record, dataIndex, rowIndex]);
  /**
   * 组件的属性
   */

  var cellFieldOptions = (0,react.useMemo)(() => {
    if (typeof fieldOptions === 'function') {
      return fieldOptions(record[dataIndex], record, rowIndex);
    }

    return fieldOptions !== null && fieldOptions !== void 0 ? fieldOptions : {};
  }, [dataIndex, fieldOptions, record, rowIndex]);
  /**
   * 单元格类型
   */

  var cellType = (0,react.useMemo)(() => {
    if (typeof type === 'function') {
      return type(record[dataIndex], record, rowIndex);
    }

    return type;
  }, [dataIndex, type, record, rowIndex]); // 每条数据添加「editableTableKey」属性，相当于主键ID

  (0,react.useEffect)(() => {
    // 防止重复生成ID，预防后续操作的数据无法追溯
    if (record && !record.editableTableKey) {
      record.editableTableKey = getEditableTableKey();
    }
  }, [record]); // 更改单元格的编辑状态

  var toggleEdit = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(val) {
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(val === false && editing === false)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              if (!(toggleEditCell && typeof toggleEditCell === 'function')) {
                _context.next = 5;
                break;
              }

              _context.next = 5;
              return toggleEditCell(!editing, record[dataIndex], record, rowIndex);

            case 5:
              setEditing(!editing);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [toggleEditCell, record, editing, dataIndex, rowIndex]); // 控件发生变化时

  var fieldChange = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(val, o) {
      var params, res, currentCell, currentCellOldData, hasEdited;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              // 切换编辑状态
              toggleEdit(); // 更新后的本行数据

              params = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, record), {}, {
                [dataIndex]: val
              });

              if (!(setCellRowValueByChange && typeof setCellRowValueByChange === 'function')) {
                _context2.next = 8;
                break;
              }

              _context2.next = 6;
              return setCellRowValueByChange(val, params, o);

            case 6:
              res = _context2.sent;
              params = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, params), res);

            case 8:
              // 如果自定义了回调
              if (cellFieldOptions !== null && cellFieldOptions !== void 0 && cellFieldOptions.onChange) {
                cellFieldOptions.onChange(params);
              } // 单元格字段名对于的数据


              currentCell = {
                [dataIndex]: val
              };
              currentCellOldData = {
                [dataIndex]: record[dataIndex]
              }; // 是否修改过数据

              hasEdited = record[dataIndex] !== val;

              if (handleSaveRow) {
                handleSaveRow(params, {
                  hasEdited,
                  currentCell,
                  currentCellOldData,
                  currentRowOldData: record
                });
              }

              _context2.next = 18;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](0);
              console.log('Save failed:', _context2.t0);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 15]]);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }(), [setCellRowValueByChange, cellFieldOptions, handleSaveRow, toggleEdit, record, dataIndex]); // 单元格组件的样式类

  var fieldCls = (0,react.useMemo)(() => classnames_default()("editing-".concat(tableTag, "-").concat(cellType, "-").concat(colIndex, "-").concat(rowIndex), {
    'edittable-hide': !editing
  }), [tableTag, cellType, colIndex, rowIndex, editing]); // 单元格文本的样式类

  var textCls = (0,react.useMemo)(() => classnames_default()("text-".concat(tableTag, "-").concat(cellType, "-").concat(colIndex, "-").concat(rowIndex), 'editableCellValueWrap', {
    'edittable-hide': editing
  }), [tableTag, cellType, colIndex, rowIndex, editing]);
  /**
   * 监听文本标签的样式类的变化
   */

  (0,react.useEffect)(() => {
    var element = render ? renderRef.current : textRef.current;
    if (!element) return;
    var observer = new MutationObserver(mutationsList => {
      var _iterator = (0,createForOfIteratorHelper/* default */.Z)(mutationsList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutation = _step.value;

          if (mutation.type === 'attributes') {
            var classList = mutation.target.classList;
            var clsList = Array.from(classList);

            if (clsList.includes('edittable-change-to-edit')) {
              requestAnimationFrame(() => {
                setEditing(true);
              });
            } else {
              break;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    observer.observe(element, {
      attributes: true
    });
    return () => {
      observer.disconnect();
    };
  }, [renderRef, textRef, render]); // 设置组件回显的值

  var defaultVal = cellFieldOptions !== null && cellFieldOptions !== void 0 && cellFieldOptions.defaultValue ? cellFieldOptions === null || cellFieldOptions === void 0 ? void 0 : cellFieldOptions.defaultValue : record ? record[dataIndex] : undefined; // 格式化单元格文本内容和下拉数据

  var childContent = (0,getContentValue/* default */.Z)({
    children,
    dataList: cellDataList
  });
  var childNode = childContent;
  var FieldElement = cellType ? NewEditableCell_Field[cellType]({
    fieldOptions: cellFieldOptions,
    dataList: cellDataList,
    fieldChange: fieldChange,
    toggleEdit: toggleEdit,
    fieldValue: defaultVal,
    editing: editing
  }) : null;

  if (render) {
    var getFieldComponent = () => {
      return [/*#__PURE__*/react.createElement("div", {
        className: textCls,
        onClick: (0,react.useCallback)(() => toggleEdit(), [toggleEdit]),
        ref: renderRef,
        key: "text"
      }, childContent), /*#__PURE__*/react.createElement("div", {
        className: fieldCls,
        key: "field"
      }, FieldElement)];
    };

    return /*#__PURE__*/react.createElement("td", restProps, render(record[dataIndex], record, rowIndex, getFieldComponent));
  }

  if (cellType) {
    childNode = [/*#__PURE__*/react.createElement("div", {
      className: textCls,
      onClick: (0,react.useCallback)(() => toggleEdit(), [toggleEdit]),
      ref: textRef,
      key: "text"
    }, childContent), /*#__PURE__*/react.createElement("div", {
      className: fieldCls,
      key: "field"
    }, FieldElement)];
  }

  return /*#__PURE__*/react.createElement("td", restProps, childNode);
};

/* harmony default export */ var NewEditableCell = (NewEditableCell_EditableCell);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlusOutlined.js + 1 modules
var PlusOutlined = __webpack_require__(49101);
// EXTERNAL MODULE: ./src/hooks/useCompareEffect.ts
var useCompareEffect = __webpack_require__(19125);
// EXTERNAL MODULE: ./src/components/EditableTable/utils/constance.ts
var constance = __webpack_require__(29744);
;// CONCATENATED MODULE: ./src/components/EditableTable/PageEditableTable.tsx








/**
 * 通用 可编辑 表格
 */










 // 获取唯一的key

function getEditableTableKey(name) {
  return lodash_default().uniqueId("".concat(name || 'edittable', "_"));
}
/**
 * 对比和替换列表数据
 * @param list 列表数据
 * @param data 更新后的 列表行数据
 */

function compareAndChangeData(list, data) {
  return list.map(v => v.editableTableKey === data.editableTableKey ? data : v);
}

var PageEditableTable = (props, ref) => {
  var _props$pageSize;

  var tableOptions = props.tableOptions,
      onTableParamsChange = props.onTableParamsChange,
      _onChange = props.onChange,
      returnData = props.returnData,
      addRow = props.addRow,
      saveRow = props.saveRow,
      deleteRow = props.deleteRow;
  var table = (0,react.useRef)(null);
  var tableTag = (0,react.useRef)(getEditableTableKey('EditTableTag'));

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      selectedRowKeys = _useState2[0],
      setSelectedRowKeys = _useState2[1];

  var _useState3 = (0,react.useState)({
    dataSource: [],
    loading: false,
    total: 0,
    current: 1,
    pageSize: (_props$pageSize = props.pageSize) !== null && _props$pageSize !== void 0 ? _props$pageSize : 10,
    order: {},
    filters: {},
    sorters: {}
  }),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      tableParams = _useState4[0],
      setTableParams = _useState4[1]; // 过滤无效的columns项


  var usefulColumns = (0,react.useMemo)(() => props.columns.filter(Boolean), [props.columns]);

  var addRowData = () => {
    return usefulColumns.reduce((prev, next) => {
      prev[next.dataIndex] = next.initialValue || undefined; // 每个新增的数据都设置一个键为「editableTableKey」的随机值

      prev['editableTableKey'] = getEditableTableKey(); // 标记，表示当前行是未保存的新增状态

      prev['editableTableAdd'] = true;
      return prev;
    }, {});
  }; // 新增行


  var handleAddRow = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
      var newRows, list, dataParams;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              newRows = addRowData(); // 数据拼接

              list = [newRows, ...tableParams.dataSource];

              if (tableParams.dataSource.length >= tableParams.pageSize) {
                // 删除最后一项
                list.pop();
              }

              if (_onChange) {
                /**
                 * currentCell：当前编辑的单元格数据，{字段名：值}
                 * currentCellOldData：当前编辑的单元格老数据
                 * currentRow：当前编辑的行数据
                 * dataSource：表格所有数据
                 */
                dataParams = {
                  currentCell: {},
                  currentCellOldData: {},
                  currentRowOldData: {},
                  currentRow: newRows,
                  dataSource: list,
                  type: 'ADD'
                };

                _onChange(dataParams, selectedRowKeys);
              } // 如果存在异步函数


              if (!addRow) {
                _context.next = 10;
                break;
              }

              _context.next = 8;
              return addRow(addRowData, list);

            case 8:
              _context.next = 11;
              break;

            case 10:
              setTableParams(v => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
                dataSource: list
              }));

            case 11:
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              console.error('add row failed：', _context.t0);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 13]]);
    }));

    return function handleAddRow() {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * 保存表格行数据
   * @param data 当前修改保存的表格行所有数据
   * @param other 其他参数
   */


  var handleSaveRow = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(data, other) {
      var hasEdited, currentCell, currentCellOldData, currentRowOldData, list, selectedKeys, dataParams;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              // hasEdited，数据是否变化
              hasEdited = other.hasEdited, currentCell = other.currentCell, currentCellOldData = other.currentCellOldData, currentRowOldData = other.currentRowOldData; // return false

              if (hasEdited) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              // 赋值更新 列表数据
              list = compareAndChangeData(tableParams.dataSource, data); // 更新选中的数据

              selectedKeys = compareAndChangeData(selectedRowKeys, data);

              if (_onChange) {
                /**
                 * currentCell：当前编辑的单元格数据，{字段名：值}
                 * currentCellOldData：当前编辑的单元格老数据
                 * currentRow：当前编辑的行数据
                 * dataSource：表格所有数据
                 */
                dataParams = {
                  currentCell,
                  currentCellOldData,
                  currentRowOldData,
                  currentRow: data,
                  dataSource: list,
                  type: 'EDIT'
                };

                _onChange(dataParams, selectedKeys);
              } // 如果存在异步保存函数


              if (saveRow) {
                saveRow(data, list, currentRowOldData);
              }

              setTableParams(v => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
                dataSource: list
              }));
              setSelectedRowKeys(selectedKeys);
              _context2.next = 15;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](0);
              console.error('save row failed：', _context2.t0);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 12]]);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [_onChange, saveRow, selectedRowKeys, tableParams.dataSource]);
  /**
   * 删除行
   * @param i 删除行对应的 editableTableKey 值
   */

  var handleDeleteRow = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3(i) {
      var obj, list, deleteCallBack, result;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              obj = tableParams.dataSource.find(v => v.editableTableKey === i) || {};
              list = tableParams.dataSource.filter(v => v.editableTableKey !== i); // 删除回调

              deleteCallBack = () => {
                // 如果删除的是已经选中的行数据，过滤了
                var selectedRows = selectedRowKeys.length ? selectedRowKeys.filter(vi => vi.editableTableKey !== i) : [];
                setSelectedRowKeys(selectedRows);

                if (_onChange) {
                  /**
                   * currentCell：当前编辑的单元格数据，{字段名：值}
                   * currentCellOldData：当前编辑的单元格老数据
                   * currentRow：当前编辑的行数据
                   * dataSource：表格所有数据
                   */
                  var dataParams = {
                    currentCell: {},
                    currentCellOldData: {},
                    currentRowOldData: {},
                    currentRow: obj,
                    dataSource: list,
                    type: 'DELETE'
                  }; // 如果存在 onChange 则将删除后的结果数据返回

                  _onChange(dataParams, selectedRows);
                } // 将之前新增时模拟删除的一项数据加回来


                setTableParams(v => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
                  dataSource: list
                }));
              }; // 删除


              if (!deleteRow) {
                _context3.next = 11;
                break;
              }

              _context3.next = 7;
              return deleteRow(obj, list);

            case 7:
              result = _context3.sent;

              // 删除成功
              if (result) {
                deleteCallBack();
              }

              _context3.next = 12;
              break;

            case 11:
              deleteCallBack();

            case 12:
              _context3.next = 17;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](0);
              console.error('delete row failed：', _context3.t0);

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 14]]);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }(), [deleteRow, _onChange, selectedRowKeys, tableParams.dataSource]);
  /**
   * 表格的页面切换、展示页数量调整等回调操作
   * @param data tableParams的回调数据
   */

  var handleTableChange = (0,react.useCallback)((data, params) => {
    setTableParams(params);
    setSelectedRowKeys([]);

    if (returnData) {
      returnData(data, params);
    }
  }, [returnData]);
  /**
   * 暴露给父组件使用的方法
   */

  (0,react.useImperativeHandle)(ref, () => ({
    reflashTable: params => {
      var _table$current;

      return (_table$current = table.current) === null || _table$current === void 0 ? void 0 : _table$current.reflashTable(params);
    },
    getTableData: () => tableParams,
    deleteAndRefreshData: commonTableKeys => handlerDeleteAndRefreshData(commonTableKeys)
  }), [tableParams]);
  /**
   * 删除并刷新表格数据
   * @param deletecommonTableKeys 要删除的 commonTableKeys 数组
   */

  var handlerDeleteAndRefreshData = deletecommonTableKeys => {
    console.log('======批量删除commonTableKeys=====', deletecommonTableKeys);

    if (Array.isArray(deletecommonTableKeys) && deletecommonTableKeys.length > 0) {
      var _tableParams$dataSour;

      var newArr = tableParams === null || tableParams === void 0 ? void 0 : (_tableParams$dataSour = tableParams.dataSource) === null || _tableParams$dataSour === void 0 ? void 0 : _tableParams$dataSour.filter(m => deletecommonTableKeys.find(f => f == m.commonTableKey) == undefined);
      setSelectedRowKeys([]);

      if (props.rowSelectCallback) {
        props.rowSelectCallback([], []);
      }

      if (_onChange) {
        /**
         * currentCell：当前编辑的单元格数据，{字段名：值}
         * currentCellOldData：当前编辑的单元格老数据
         * currentRow：当前编辑的行数据
         * dataSource：表格所有数据
         */
        var dataParams = {
          currentCell: {},
          currentCellOldData: {},
          currentRow: {},
          currentRowOldData: {},
          dataSource: newArr,
          type: 'DELETE'
        }; // 如果存在 onChange 则将删除后的结果数据返回

        _onChange(dataParams, []);
      }

      setTableParams(v => {
        return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
          dataSource: newArr,
          total: v.total - deletecommonTableKeys.length
        });
      });
    }
  }; // 如果没有设置「hideDeleteBtn」，给「columns」拼接操作表头，并补上删除功能


  var renderCol = (0,react.useMemo)(() => {
    if (props.hideDeleteBtn) {
      return usefulColumns;
    }

    return usefulColumns.every(v => v.title !== '操作') ? [...usefulColumns, constance/* tableOptionsCol */.u] : usefulColumns;
  }, [usefulColumns, props.hideDeleteBtn]);

  var _useMemo = (0,react.useMemo)(() => renderCol.reduce((pre, next) => {
    // 如果当前column不存在 editable 字段、表头文案不是操作以及没有 type 值，表示当前单元格展示的是文案而不是表单组件
    if (!next.editable && !next.type && !next.render && next.title !== '操作') {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, pre), {}, {
        columns: [...pre.columns, next]
      });
    }

    var index = next.editable || next.type ? pre.editIndex + 1 : pre.editIndex;
    return {
      columns: [...pre.columns, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, next), {}, {
        onCell: (record, rowIndex) => {
          return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, next), {}, {
            rowIndex,
            record,
            editIndex: index === 0 ? undefined : index // 可编辑的单元格的序号

          });
        }
      })],
      editIndex: index
    };
  }, {
    columns: [],
    editIndex: 0
  }), [renderCol]),
      columns = _useMemo.columns;

  var selection = (0,react.useMemo)(() => ({
    selectedRowKeys: selectedRowKeys,
    onChange: keys => {
      setSelectedRowKeys(keys);

      if (_onChange) {
        var dataParams = {
          currentCell: {},
          currentCellOldData: {},
          currentRow: {},
          currentRowOldData: {},
          dataSource: tableParams.dataSource,
          type: 'SELECTED'
        };

        _onChange(dataParams, keys);
      }
    }
  }), [_onChange, selectedRowKeys, tableParams.dataSource]);
  /**
   * 获取CommonTable的selection配置
   * 缓存 rowselect 配置
   */

  var getRowSelection = (0,react.useMemo)(() => {
    // 如果没有自定义配置「rowSelection」以及没有「rowSelectCallback」表示不需要列表多选
    if (!(tableOptions !== null && tableOptions !== void 0 && tableOptions.rowSelection) && !props.rowSelectCallback) {
      return undefined;
    } // 自定义多选


    if (tableOptions && tableOptions.rowSelection) {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, tableOptions.rowSelection), selection);
    } // 默认的多选


    if (props.rowSelectCallback) {
      return selection;
    }
  }, [props.rowSelectCallback, selection, tableOptions]);
  (0,react.useEffect)(() => {
    if (onTableParamsChange) {
      onTableParamsChange(tableParams);
    }
  }, [tableParams, onTableParamsChange]);
  /**
   * 更新某一行的数据
   */

  (0,useCompareEffect/* default */.Z)(() => {
    var updateDataSource = props.updateDataSource;

    if (!updateDataSource || lodash_default().isEmpty(updateDataSource)) {
      return;
    }

    var dataSource = tableParams.dataSource,
        pageSize = tableParams.pageSize;
    var list = dataSource;

    if (Array.isArray(updateDataSource)) {
      // 生成对象：{editableTableKey: data}
      var rows = updateDataSource.reduce((pre, next) => {
        var key = next.editableTableKey; // 存在 editableTableKey，表示该项为修改；不存在表示该项为新增

        if (key) {
          pre[key] = next; // 记录「editRowLength」，表示要编辑的行数

          pre.editRowLength = ++pre.editRowLength;
        } else {
          // 新增
          var _obj = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, next), {}, {
            editableTableAdd: true
          });

          pre.add = pre.add.concat(_obj);
        }

        return pre;
      }, {
        add: [],
        editRowLength: 0
      }); // 存在要编辑的表格行

      if (rows.editRowLength > 0) {
        // 将编辑的数据更新到 dataSource
        list = dataSource.map(v => {
          var _rows$v$editableTable;

          return (_rows$v$editableTable = rows[v.editableTableKey]) !== null && _rows$v$editableTable !== void 0 ? _rows$v$editableTable : v;
        });
      } // 添加数据


      if (rows.add.length > 0) {
        list = rows.add.concat(list);

        if (list.length > +pageSize) {
          // 选取出列表单页的限额数据量，将其加入列表数据
          list = list.slice(0, +pageSize);
        }
      }
    } else {
      list = compareAndChangeData(dataSource, updateDataSource);
    }

    setTableParams(v => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
      dataSource: list
    }));
  }, [props.updateDataSource, selectedRowKeys]);
  return /*#__PURE__*/react.createElement(context/* EditableContext.Provider */.P.Provider, {
    value: {
      tableTag: tableTag === null || tableTag === void 0 ? void 0 : tableTag.current,
      handleDeleteRow,
      handleSaveRow,
      hideDeleteBtn: props.hideDeleteBtn
    }
  }, /*#__PURE__*/react.createElement(CommonTable/* default */.Z, (0,esm_extends/* default */.Z)({
    ref: table
  }, props, {
    columns: columns,
    queryDataUrl: props.queryDataUrl || '',
    tableParams: tableParams,
    returnData: handleTableChange,
    tableOptions: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props.tableOptions), {}, {
      rowSelection: getRowSelection,
      components: {
        body: {
          cell: (0,react.useMemo)(() => props.useNewCell ? NewEditableCell : EditableCell/* default */.Z, [props.useNewCell])
        }
      },
      onRow: (record, index) => ({
        record,
        index,
        className: classnames_default()({
          newRow: !!record.editableTableAdd
        })
      })
    })
  })), !props.hideBtn && /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    type: "dashed",
    onClick: handleAddRow,
    disabled: props.disableAddBtn,
    className: "mTop16",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/react.createElement(PlusOutlined/* default */.Z, null), " ", props.buttonTitle || '添加'));
};

/* harmony default export */ var EditableTable_PageEditableTable = (/*#__PURE__*/(0,react.memo)( /*#__PURE__*/(0,react.forwardRef)(PageEditableTable)));

/***/ }),

/***/ 61213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(71577);
/* harmony import */ var antd_es_table_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66456);
/* harmony import */ var antd_es_table__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97423);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(49101);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_EditableCell__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64610);
/* harmony import */ var _utils_constance__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29744);
/* harmony import */ var _utils_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88050);










/* eslint-disable react-hooks/exhaustive-deps */

/**
 * 数据全是外部传入的 可编辑表格
 */









var EditableTable = props => {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(props.dataSource),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState, 2),
      dataSource = _useState2[0],
      setDataSource = _useState2[1];

  var addRowData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    return props.columns.reduce((prev, next) => {
      prev[next.dataIndex] = (next === null || next === void 0 ? void 0 : next.initialValue) || undefined;
      return prev;
    }, {});
  }, [props.columns]); // 新增行

  var handleAddRow = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee() {
      var rowData, list;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              try {
                // 每个新增的数据都设置一个键为「editableTableKey」的随机值
                rowData = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({}, addRowData), {}, {
                  editableTableKey: lodash__WEBPACK_IMPORTED_MODULE_3___default().uniqueId('edittable_')
                });
                console.log('rowData', rowData);
                list = [rowData, ...dataSource];

                if (props.onChange) {
                  props.onChange(addRowData, list);
                }

                setDataSource(list);
              } catch (error) {
                console.log('add row failed：', error);
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleAddRow() {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * 保存表格行数据
   * @param data 当前修改保存的表格行所有数据
   * @param other 其他参数
   */


  var handleSaveRow = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee2(data, other) {
      var hasEdited, currentCell, currentCellOldData, list, dataParams;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              // hasEdited，数据是否变化
              hasEdited = other.hasEdited, currentCell = other.currentCell, currentCellOldData = other.currentCellOldData;

              if (hasEdited) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              // 赋值更新 列表数据
              list = dataSource.map(v => v.editableTableKey === data.editableTableKey ? data : v);

              if (props.onChange) {
                /**
                 * currentCell：当前编辑的单元格数据，{字段名：值}
                 * currentRow：当前编辑的行数据
                 * dataSource：表格所有数据
                 */
                dataParams = {
                  currentCell,
                  currentCellOldData,
                  currentRow: data,
                  dataSource: list,
                  type: 'EDIT'
                };
                props.outType && props.onChange(dataParams, []);
              }

              setDataSource(list);

              if (props.onChange) {
                props.onChange(data, list);
              }

              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              console.log('save row failed：', _context2.t0);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    }));

    return function handleSaveRow(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(); // 删除行


  var handleDeleteRow = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee3(i) {
      var list, dataParams;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              try {
                list = dataSource.filter(v => v.editableTableKey !== i);

                if (props.onChange) {
                  /**
                   * currentCell：当前编辑的单元格数据，{字段名：值}
                   * currentRow：当前编辑的行数据
                   * dataSource：表格所有数据
                   */
                  dataParams = {
                    currentCell: {},
                    currentRow: {},
                    currentCellOldData: {},
                    dataSource: list,
                    type: 'DELETE'
                  }; // 如果存在 onChange 则将删除后的结果数据返回

                  props.onChange(dataParams, list);
                }

                setDataSource(list);
              } catch (error) {
                console.log('delete row failed：', error);
              }

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleDeleteRow(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    setDataSource(props.dataSource);
  }, [props.dataSource]); // 如果没有设置「hideDeleteBtn」，给「columns」拼接操作表头，并补上删除功能

  var renderCol = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    if (props.hideDeleteBtn) {
      return props.columns;
    }

    return props.columns.every(v => v.title !== '操作') ? [...props.columns, _utils_constance__WEBPACK_IMPORTED_MODULE_6__/* .tableOptionsCol */ .u] : props.columns;
  }, [props.columns]);
  var columns = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    return renderCol.map(col => {
      // 如果当前column不存在 editable 字段、表头文案不是操作以及没有 type 值，表示当前单元格展示的是文案而不是表单组件
      if (!col.editable && col.title !== '操作' && !col.type && !col.render) {
        return col;
      }

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({}, col), {}, {
        onCell: (record, rowIndex) => {
          return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({}, col), {}, {
            rowIndex,
            record
          });
        }
      });
    });
  }, [renderCol]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_utils_context__WEBPACK_IMPORTED_MODULE_7__/* .EditableContext.Provider */ .P.Provider, {
    value: {
      handleDeleteRow,
      handleSaveRow,
      hideDeleteBtn: props.hideDeleteBtn
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_table__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({
    components: {
      body: {
        cell: _components_EditableCell__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z
      }
    },
    rowClassName: () => 'editableTable',
    dataSource: dataSource,
    columns: columns,
    rowKey: (re, k) => re.id ? re.id : k,
    pagination: false,
    size: "small"
  }, props.tableOptions, {
    onRow: (record, index) => ({
      record,
      index,
      className: classnames__WEBPACK_IMPORTED_MODULE_4___default()({
        newRow: !!record.editableTableAdd
      })
    })
  })), !props.hideBtn && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
    disabled: props.disableAddBtn,
    type: "dashed",
    onClick: handleAddRow,
    className: "mTop16",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z, null), " ", props.buttonTitle || '添加'));
};

/* harmony default export */ __webpack_exports__["Z"] = (EditableTable);

/***/ }),

/***/ 64610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_createForOfIteratorHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(91220);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2824);
/* harmony import */ var antd_es_popconfirm_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62350);
/* harmony import */ var antd_es_popconfirm__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75443);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93224);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Field__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67898);
/* harmony import */ var _PageEditableTable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8149);
/* harmony import */ var _utils_context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88050);
/* harmony import */ var _hooks_getContentValue__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(33461);








var _excluded = ["title", "editable", "children", "dataIndex", "type", "record", "rowIndex", "render", "editIndex", "dataList", "fieldOptions", "setCellRowValueByChange", "toggleEditCell"];

/* eslint-disable react-hooks/rules-of-hooks */







var Field = _Field__WEBPACK_IMPORTED_MODULE_4__;

var EditableCell = props => {
  var title = props.title,
      editable = props.editable,
      children = props.children,
      dataIndex = props.dataIndex,
      type = props.type,
      record = props.record,
      rowIndex = props.rowIndex,
      render = props.render,
      colIndex = props.editIndex,
      _props$dataList = props.dataList,
      componentDataList = _props$dataList === void 0 ? [] : _props$dataList,
      componentFieldOptions = props.fieldOptions,
      setCellRowValueByChange = props.setCellRowValueByChange,
      toggleEditCell = props.toggleEditCell,
      restProps = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(props, _excluded);

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_utils_context__WEBPACK_IMPORTED_MODULE_6__/* .EditableContext */ .P),
      handleDeleteRow = _useContext.handleDeleteRow,
      handleSaveRow = _useContext.handleSaveRow,
      hideDeleteBtn = _useContext.hideDeleteBtn,
      tableTag = _useContext.tableTag; // 拼接操作


  if (render && title === '操作') {
    var deleteBtn = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_popconfirm__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, {
      title: "\u786E\u8BA4\u5220\u9664\u8FD9\u6761\u6570\u636E\u5417\uFF1F",
      onConfirm: () => {
        console.log('record', record);

        if (record !== null && record !== void 0 && record.notAllowDelete) {
          antd_es_message__WEBPACK_IMPORTED_MODULE_9__.default.warn('无权删除该条数据');

          return;
        }

        if (handleDeleteRow) {
          handleDeleteRow(record.editableTableKey);
        }
      },
      okText: "\u786E\u8BA4",
      cancelText: "\u53D6\u6D88"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("a", {
      style: {
        marginRight: '8px'
      }
    }, "\u5220\u9664")); // 给新增的行添加背景颜色

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("td", restProps, !hideDeleteBtn && deleteBtn, render(record[dataIndex], record, rowIndex, deleteBtn));
  } // 自定义渲染的文本标签


  var renderRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null); // 设置type的文本标签

  var textRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null); // 单元格是否处于编辑状态

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_useState, 2),
      editing = _useState2[0],
      setEditing = _useState2[1];
  /**
   * 下拉框组件的数据
   */


  var dataList = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    var isFunc = typeof componentDataList === 'function';

    if (isFunc) {
      var _ref;

      return (_ref = componentDataList(record[dataIndex], record, rowIndex)) !== null && _ref !== void 0 ? _ref : [];
    }

    return componentDataList !== null && componentDataList !== void 0 ? componentDataList : [];
  }, [componentDataList, record, dataIndex, rowIndex]);
  /**
   * 组件的属性
   */

  var fieldOptions = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    var isFunc = typeof componentFieldOptions === 'function';

    if (isFunc) {
      return componentFieldOptions(record[dataIndex], record, rowIndex);
    }

    return componentFieldOptions !== null && componentFieldOptions !== void 0 ? componentFieldOptions : {};
  }, [dataIndex, componentFieldOptions, record, rowIndex]); // 每条数据添加「editableTableKey」属性，相当于主键ID

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    // 防止重复生成ID，预防后续操作的数据无法追溯
    if (record && !record.editableTableKey) {
      record.editableTableKey = (0,_PageEditableTable__WEBPACK_IMPORTED_MODULE_5__/* .getEditableTableKey */ .Ax)();
    }
  }, [record]); // 如果没有传「type」时设置默认是「INPUT」
  // 传了「type」 可以不传 「editable」

  var fieldType = !type && editable ? 'INPUT' : type; // 更改单元格的编辑状态

  var toggleEdit = bool => {
    var boolean = bool !== null && bool !== void 0 ? bool : !editing; // 触发回调

    if (toggleEditCell && typeof toggleEditCell === 'function') {
      toggleEditCell(boolean, record[dataIndex], record, rowIndex);
    }

    setEditing(boolean);
  }; // 控件发生变化时


  var fieldChange = (val, o) => {
    try {
      // 切换编辑状态
      toggleEdit(); // 是否修改过数据

      var hasEdited = record[dataIndex] !== val; // 防止Select组件，未选择时导致问题
      // 防止InputNumber组件返回空时，逻辑被过滤

      if (!val && val !== 0 && type === 'SELECT' || !hasEdited) {
        return;
      } // 更新后的本行数据


      var params = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({}, record), {}, {
        [dataIndex]: val
      });

      if (setCellRowValueByChange && typeof setCellRowValueByChange === 'function') {
        var res = setCellRowValueByChange(val, params, o);
        params = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({}, params), res);
      } // 如果自定义了回调


      if (fieldOptions !== null && fieldOptions !== void 0 && fieldOptions.onChange) {
        fieldOptions.onChange(params);
      } // 单元格字段名对于的数据


      var currentCell = {
        [dataIndex]: val
      }; // 单元格老数据

      var currentCellOldData = {
        [dataIndex]: record[dataIndex]
      };

      if (handleSaveRow) {
        handleSaveRow(params, {
          hasEdited,
          currentCell,
          currentCellOldData,
          currentRowOldData: record
        });
      }
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  }; // 设置组件回显的值


  var defaultVal = record ? record[dataIndex] : undefined; // 单元格组件的样式类

  var fieldCls = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => classnames__WEBPACK_IMPORTED_MODULE_3___default()("editing-".concat(tableTag, "-").concat(fieldType, "-").concat(colIndex, "-").concat(rowIndex), {
    'edittable-hide': !editing
  }), [colIndex, editing, fieldType, rowIndex, tableTag]); // 单元格文本的样式类

  var textCls = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => classnames__WEBPACK_IMPORTED_MODULE_3___default()("text-".concat(tableTag, "-").concat(fieldType, "-").concat(colIndex, "-").concat(rowIndex), 'editableCellValueWrap', {
    'edittable-hide': editing
  }), [colIndex, editing, fieldType, rowIndex, tableTag]);
  /**
   * 监听文本标签的样式类的变化
   */

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    var element = render ? renderRef.current : textRef.current;
    if (!element) return;
    var observer = new MutationObserver(mutationsList => {
      var _iterator = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_createForOfIteratorHelper_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(mutationsList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutation = _step.value;

          if (mutation.type === 'attributes') {
            var classList = mutation.target.classList;
            var clsList = Array.from(classList);

            if (clsList.includes('edittable-change-to-edit')) {
              requestAnimationFrame(() => {
                setEditing(true);
              });
            } else {
              break;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    observer.observe(element, {
      attributes: true
    });
    return () => {
      observer.disconnect();
    };
  }, [renderRef, textRef, render]);
  /**
   * 如果存在自定义渲染的情况，给「render」函数的第四项添加参数
   */

  if (render) {
    var getFieldComponent = renderParams => {
      var FieldElement = null;
      var childContent = (0,_hooks_getContentValue__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({
        children,
        dataList: renderParams.dataList || []
      });

      if (renderParams.fieldType) {
        var FieldComponent = Field[renderParams.fieldType];
        FieldElement = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(FieldComponent, {
          fieldOptions: renderParams.fieldOptions,
          dataList: renderParams.dataList,
          fieldChange: fieldChange,
          toggleEdit: toggleEdit,
          fieldValue: renderParams.value || defaultVal,
          editing: editing
        });
      }

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        className: textCls,
        onClick: () => toggleEdit(),
        ref: renderRef
      }, childContent), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        className: fieldCls
      }, FieldElement));
    };

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("td", restProps, render(record[dataIndex], record, rowIndex, getFieldComponent));
  } // 格式化单元格文本内容和下拉数据


  var childContent = (0,_hooks_getContentValue__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({
    children,
    dataList
  });
  var childNode = childContent;

  if (fieldType) {
    var FieldComponent = Field[fieldType];
    childNode = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
      className: textCls,
      onClick: () => toggleEdit(),
      ref: textRef
    }, childContent), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
      className: fieldCls
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(FieldComponent, {
      fieldOptions: fieldOptions,
      dataList: dataList,
      fieldChange: fieldChange,
      toggleEdit: toggleEdit,
      fieldValue: defaultVal,
      editing: editing
    })));
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("td", restProps, childNode);
};

/* harmony default export */ __webpack_exports__["Z"] = (EditableCell);

/***/ }),

/***/ 67898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SELECT": function() { return /* binding */ SELECT; },
/* harmony export */   "INPUT": function() { return /* binding */ INPUT; },
/* harmony export */   "RANGE_PICKER": function() { return /* binding */ RANGE_PICKER; },
/* harmony export */   "DATE_PICKER": function() { return /* binding */ DATE_PICKER; },
/* harmony export */   "INPUT_NUMBER": function() { return /* binding */ INPUT_NUMBER; },
/* harmony export */   "SELECT_TREE": function() { return /* binding */ SELECT_TREE; },
/* harmony export */   "RADIO_SINGLE": function() { return /* binding */ RADIO_SINGLE; }
/* harmony export */ });
/* harmony import */ var antd_es_radio_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88983);
/* harmony import */ var antd_es_radio__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(55742);
/* harmony import */ var antd_es_tree_select_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62999);
/* harmony import */ var antd_es_tree_select__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(57119);
/* harmony import */ var antd_es_input_number_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77883);
/* harmony import */ var antd_es_input_number__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(39635);
/* harmony import */ var antd_es_input_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47673);
/* harmony import */ var antd_es_input__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4107);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2824);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93224);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91896);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34041);
/* harmony import */ var antd_es_date_picker_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14965);
/* harmony import */ var antd_es_date_picker__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11448);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_7__);















var _excluded = ["formatter"];

/* eslint-disable no-unused-expressions */


var RangePicker = antd_es_date_picker__WEBPACK_IMPORTED_MODULE_8__/* .default.RangePicker */ .Z.RangePicker;
/**
 * 下拉框控件
 */

var SELECT = props => {
  var fieldOptions = props.fieldOptions,
      _props$dataList = props.dataList,
      dataList = _props$dataList === void 0 ? [] : _props$dataList,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue,
      toggleEdit = props.toggleEdit;
  var dataSource = dataList;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)({
    showSearch: true,
    onBlur: (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(() => toggleEdit(false), [toggleEdit]),
    dropdownMatchSelectWidth: false,
    value: fieldValue,
    filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
  }, fieldOptions, {
    onChange: undefined,
    onSelect: fieldChange,
    style: {
      width: '100%'
    }
  }), dataSource.map(item => {
    var value = item.value,
        label = item.label;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_9__/* .default.Option */ .Z.Option, {
      key: value,
      value: value,
      rows: item
    }, label);
  }));
};
/**
 * 输入框控件
 */

var INPUT = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      editing = props.editing,
      fieldValue = props.fieldValue;

  var _ref = fieldOptions || {},
      formatter = _ref.formatter,
      rest = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_ref, _excluded);

  var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState, 2),
      input = _useState2[0],
      setInput = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
    setInput(fieldValue);
  }, [fieldValue]);

  var save = () => {
    var val = input === null || input === void 0 ? void 0 : input.toString().replace(/(^\s*)|(\s*$)/g, '');
    fieldChange(val);
  };

  var changeField = e => {
    var value = e.target.value;

    if (formatter) {
      value = formatter(value);
    }

    setInput(value);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
    if (editing) {
      var _inputRef$current, _inputRef$current2;

      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
      (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.select();
    }
  }, [editing]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)({}, rest, {
    ref: inputRef,
    value: input,
    onChange: changeField,
    onPressEnter: save,
    onBlur: save
  }));
};
/**
 * 时间范围控件
 */

var RANGE_PICKER = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue;
  var format = (fieldOptions === null || fieldOptions === void 0 ? void 0 : fieldOptions.format) || 'YYYY-MM-DD';
  var value = Array.isArray(fieldValue) ? fieldValue : [];
  var defaultStart = fieldValue ? moment__WEBPACK_IMPORTED_MODULE_7___default()(value[0]) : undefined;
  var defaultEnd = fieldValue ? moment__WEBPACK_IMPORTED_MODULE_7___default()(value[1]) : undefined;

  var handleChange = e => {
    if (!e) {
      fieldChange(undefined);
      return;
    }

    var value = Array.isArray(e) ? e : [];
    var start = moment__WEBPACK_IMPORTED_MODULE_7___default()(value[0]).format(format);
    var end = moment__WEBPACK_IMPORTED_MODULE_7___default()(value[1]).format(format);
    fieldChange("".concat(start, " - ").concat(end));
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(RangePicker, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)({
    allowClear: true,
    autoFocus: true,
    style: {
      width: '100%'
    },
    format: [format, format],
    placeholder: ['开始', '结束']
  }, fieldOptions, {
    defaultValue: [defaultStart, defaultEnd],
    onChange: handleChange
  }));
};
/**
 * 时间选择控件
 */

var DATE_PICKER = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue;
  var format = (fieldOptions === null || fieldOptions === void 0 ? void 0 : fieldOptions.fieldOptions) || 'YYYY-MM-DD';
  var defaultValue = fieldValue ? moment__WEBPACK_IMPORTED_MODULE_7___default()(fieldValue) : undefined;

  var handleChange = e => {
    var data = moment__WEBPACK_IMPORTED_MODULE_7___default()(e).format(format);
    fieldChange(data);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_date_picker__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)({
    allowClear: true,
    autoFocus: true,
    style: {
      width: '100%'
    },
    format: format,
    placeholder: "\u8BF7\u9009\u62E9"
  }, fieldOptions, {
    defaultValue: defaultValue,
    onBlur: () => fieldChange(''),
    onChange: handleChange
  }));
};
/**
 * 数值控件
 */

var INPUT_NUMBER = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      editing = props.editing,
      fieldValue = props.fieldValue;
  var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)();

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(fieldValue),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState3, 2),
      val = _useState4[0],
      setVal = _useState4[1]; // 保留onChange事件的值，在onBlur事件后回传。因为如果内容为空的时候，blur事件接收到值有问题


  var save = e => {
    var val = e.target.value;
    var value = val === '' || val === 'undefined' ? undefined : val;
    fieldChange(value);
  };

  var changeValue = value => {
    setVal(value);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_input_number__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)({
    style: {
      width: '100%'
    }
  }, fieldOptions, {
    ref: inputRef,
    defaultValue: fieldValue,
    onChange: changeValue,
    onPressEnter: save,
    onBlur: save
  }));
};
/**
 * 树结构选择
 */

var SELECT_TREE = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue;
  var defaultValue = Array.isArray(fieldValue) ? fieldValue : [];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(defaultValue),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState5, 2),
      selected = _useState6[0],
      setSelected = _useState6[1];

  var changeTreeSelect = e => {
    setSelected(e);
  };

  var handleSave = () => {
    fieldChange(selected);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_tree_select__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)({
    style: {
      width: '100%'
    },
    multiple: true,
    placeholder: "\u8BF7\u9009\u62E9",
    showSearch: true,
    allowClear: true,
    treeDataSimpleMode: true,
    treeNodeFilterProp: "title" // 开启按title搜索

  }, fieldOptions, {
    defaultValue: fieldValue,
    onChange: changeTreeSelect,
    onBlur: handleSave
  }));
};
/**
 *
 */

var RADIO_SINGLE = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue,
      dataSource = props.dataList; // export const RADIO_SINGLE = (options: any, dataSource: any[]) => {
  // console.log('dataSource', dataSource);
  // console.log('props', props)

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_16__/* .default.Group */ .ZP.Group, null, (dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) && dataSource.map((val, key) => {
    var _ref2, _val$key;

    var optKey = (_ref2 = (_val$key = val.key) !== null && _val$key !== void 0 ? _val$key : val.value) !== null && _ref2 !== void 0 ? _ref2 : key;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_16__/* .default */ .ZP, {
      value: optKey,
      key: optKey
    }, val.label);
  }));
};

/***/ }),

/***/ 33461:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * 单元格的数据格式化
 */
function getContentValue(props) {
  var children = props.children,
      dataList = props.dataList; // 针对存在「list」的单元格进行设置；使单元格展示的是文案而不是值

  if (!Array.isArray(children)) {
    return children;
  }
  /**
   * 如果当前单元格的 可编辑 状态是 Select、Radio等具有「list」属性的表单控件
   * 1. 对该值进行判断校验
   * 2. 最后获取到该值对应的 中文 文案，并交给Table渲染该单元格
   */


  var val = children.slice(1)[0];
  var childType = typeof val;

  if (val === '' || val === undefined || val === null) {
    return children;
  }

  if (childType === 'object' || childType === 'function') {
    return children;
  } // 过滤可能出现的不必要的标签


  var newChildren = childType === 'string' ? val.replace('<tt>', '').replace('</tt>', '') : val;

  if (!dataList) {
    return [undefined, newChildren];
  }

  var _ref = dataList.find(v => v.value.toString() === val.toString()) || {},
      label = _ref.label;

  return [undefined, label !== null && label !== void 0 ? label : val];
}

/* harmony default export */ __webpack_exports__["Z"] = (getContentValue);

/***/ }),

/***/ 72927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _PageEditableTable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8149);



/**
 * 通用 可编辑 表格
 */



var EditableTable = (props, ref) => {
  var wrapper = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var changePointer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(e => {
    if (!['ArrowUp', 'ArrowDown', 'ArrowRight', 'ArrowLeft'].includes(e.code)) return; // if (!['ArrowUp', 'ArrowDown'].includes(e.code)) return

    var ele = e.target;
    var parent = ele === null || ele === void 0 ? void 0 : ele.parentNode;
    var cls = parent === null || parent === void 0 ? void 0 : parent.className; // 不存在父节点或者类名

    if (!parent || !cls) {
      return;
    }
    /**
     * editType: 1.editing；2.text
     * fieldType：组件类型
     * colIndex：可编辑的列序号
     * rowIndex：行序号
     */


    var _cls$split = cls.split('-'),
        _cls$split2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_cls$split, 5),
        editType = _cls$split2[0],
        tableTag = _cls$split2[1],
        fieldType = _cls$split2[2],
        colIndex = _cls$split2[3],
        rowIndex = _cls$split2[4]; // 只支持输入框光标移动，以 editing 开头


    if (!editType.startsWith('editing') || fieldType !== 'INPUT') {
      return;
    }

    var currentRowKey = Number(rowIndex);
    var currentColKey = Number(colIndex);
    var nextRowIndex = currentRowKey;
    var nextColIndex = currentColKey;

    if (e.code === 'ArrowUp') {
      if (currentRowKey === 0) {
        return;
      }

      nextRowIndex = currentRowKey - 1;
    } else if (e.code === 'ArrowDown') {
      var _ref$current;

      var _ref$current$getTable = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getTableData(),
          dataSource = _ref$current$getTable.dataSource;

      var maxKey = dataSource.length - 1;
      nextRowIndex = currentRowKey + 1;

      if (maxKey < nextRowIndex) {
        return;
      }
    } else if (e.code === 'ArrowRight') {
      nextColIndex = currentColKey + 1;
    } else {
      if (nextColIndex === 1) {
        return;
      }

      nextColIndex = currentColKey - 1;
    } // 未处于编辑状态的


    var newCls = "text-".concat(tableTag, "-").concat(fieldType, "-").concat(nextColIndex, "-").concat(nextRowIndex);
    var newElement = document.querySelector("div.".concat(newCls));

    if (newElement) {
      // 添加样式标识， 将单元格文本变成输入框
      newElement === null || newElement === void 0 ? void 0 : newElement.classList.add('edittable-change-to-edit');
    }
  }, [ref]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var _wrapper$current;

    if (!(wrapper.current instanceof HTMLElement)) return;
    (_wrapper$current = wrapper.current) === null || _wrapper$current === void 0 ? void 0 : _wrapper$current.addEventListener('keydown', changePointer);
    return () => {
      var _wrapper$current2;

      // eslint-disable-next-line react-hooks/exhaustive-deps
      (_wrapper$current2 = wrapper.current) === null || _wrapper$current2 === void 0 ? void 0 : _wrapper$current2.removeEventListener('keydown', changePointer);
    };
  }, [changePointer]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: wrapper
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_PageEditableTable__WEBPACK_IMPORTED_MODULE_1__/* .default */ .ZP, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)({
    ref: ref
  }, props)));
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(EditableTable));

/***/ }),

/***/ 29744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ tableOptionsCol; }
/* harmony export */ });
var tableOptionsCol = {
  title: '操作',
  dataIndex: 'operatess',
  key: 'operatess',
  fixed: 'right',
  width: 120,
  render: (t, r, i) => {
    return null;
  }
};

/***/ }),

/***/ 88050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ EditableContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var EditableContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

/***/ }),

/***/ 7336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iw": function() { return /* binding */ EnhanceContentContext; },
  "ZP": function() { return /* binding */ components_EnhanceTable; }
});

// UNUSED EXPORTS: getEditableTableKey

// EXTERNAL MODULE: ./node_modules/antd/es/table/style/index.js
var style = __webpack_require__(66456);
// EXTERNAL MODULE: ./node_modules/antd/es/table/index.js + 45 modules
var table = __webpack_require__(97423);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/antd/es/tag/style/index.js
var tag_style = __webpack_require__(71153);
// EXTERNAL MODULE: ./node_modules/antd/es/tag/index.js + 1 modules
var tag = __webpack_require__(60331);
// EXTERNAL MODULE: ./node_modules/antd/es/space/style/index.js
var space_style = __webpack_require__(49111);
// EXTERNAL MODULE: ./node_modules/antd/es/space/index.js + 1 modules
var space = __webpack_require__(19650);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(93224);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/antd/es/tree-select/style/index.js
var tree_select_style = __webpack_require__(62999);
// EXTERNAL MODULE: ./node_modules/antd/es/input/style/index.js
var input_style = __webpack_require__(47673);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 3 modules
var es_input = __webpack_require__(4107);
// EXTERNAL MODULE: ./node_modules/antd/es/select/style/index.js
var select_style = __webpack_require__(43358);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js
var es_select = __webpack_require__(34041);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/style/index.js
var date_picker_style = __webpack_require__(14965);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/index.js + 6 modules
var date_picker = __webpack_require__(11448);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/components/EnhanceCommonTable/components/Field.tsx











var _excluded = ["formatter"];

/* eslint-disable no-unused-expressions */


var RangePicker = date_picker/* default.RangePicker */.Z.RangePicker;
/**
 * 下拉框控件
 */

var EnSelect = props => {
  var fieldOptions = props.fieldOptions,
      _props$dataList = props.dataList,
      dataList = _props$dataList === void 0 ? [] : _props$dataList,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue;
  var dataSource = dataList;

  var handleChange = (value, o) => {
    return fieldChange(value, o);
  };

  return /*#__PURE__*/react.createElement(es_select/* default */.Z, (0,esm_extends/* default */.Z)({
    showSearch: true,
    dropdownMatchSelectWidth: false,
    value: fieldValue,
    filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
  }, fieldOptions, {
    onChange: undefined,
    onSelect: handleChange,
    style: {
      width: '100%'
    }
  }), dataSource.map(item => {
    var value = item.value,
        label = item.label;
    return /*#__PURE__*/react.createElement(es_select/* default.Option */.Z.Option, {
      key: value,
      value: value,
      rows: item
    }, label);
  }));
};
/**
 * 输入框控件
 */

var EnInput = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue,
      fieldCls = props.fieldCls,
      focusFunCallback = props.focusFunCallback;

  var _ref = fieldOptions || {},
      formatter = _ref.formatter,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var inputRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(fieldValue),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      input = _useState2[0],
      setInput = _useState2[1];

  (0,react.useEffect)(() => {
    setInput(fieldValue);
  }, [fieldValue]); // 失去焦点

  var save = () => {
    var val = input === null || input === void 0 ? void 0 : input.toString().trim();
    return fieldChange(val);
  }; // 保存输入内容


  var changeField = e => {
    var value = e.target.value;

    if (formatter) {
      value = formatter(value);
    }

    setInput(value);
    focusFunCallback && focusFunCallback();
  };

  var onFocus = () => {
    var _inputRef$current, _inputRef$current2;

    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.select();
    focusFunCallback && focusFunCallback();
  };

  return /*#__PURE__*/react.createElement(es_input/* default */.Z, (0,esm_extends/* default */.Z)({}, rest, {
    className: fieldCls,
    ref: inputRef,
    value: input,
    onFocus: onFocus,
    onChange: changeField,
    onPressEnter: save,
    onBlur: save
  }));
};
/**
 * 时间范围控件
 */

var EnRangePicker = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue;
  var format = (fieldOptions === null || fieldOptions === void 0 ? void 0 : fieldOptions.format) || 'YYYY-MM-DD';
  var value = Array.isArray(fieldValue) ? fieldValue : [];
  var defaultStart = fieldValue ? moment_default()(value[0]) : undefined;
  var defaultEnd = fieldValue ? moment_default()(value[1]) : undefined;

  var handleChange = e => {
    if (!e) {
      fieldChange(undefined);
      return;
    }

    var value = Array.isArray(e) ? e : [];
    var start = moment_default()(value[0]).format(format);
    var end = moment_default()(value[1]).format(format);
    fieldChange("".concat(start, " - ").concat(end));
  };

  return /*#__PURE__*/react.createElement(RangePicker, (0,esm_extends/* default */.Z)({
    allowClear: true,
    autoFocus: true,
    style: {
      width: '100%'
    },
    format: [format, format],
    placeholder: ['开始', '结束']
  }, fieldOptions, {
    defaultValue: [defaultStart, defaultEnd],
    onChange: handleChange
  }));
};
/**
 * 时间选择控件
 */

var EnDatePicker = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue;
  var format = (fieldOptions === null || fieldOptions === void 0 ? void 0 : fieldOptions.fieldOptions) || 'YYYY-MM-DD';
  var defaultValue = fieldValue ? moment_default()(fieldValue) : undefined;

  var handleChange = e => {
    var data = moment_default()(e).format(format);
    fieldChange(data);
  };

  return /*#__PURE__*/react.createElement(date_picker/* default */.Z, (0,esm_extends/* default */.Z)({
    allowClear: true,
    autoFocus: true,
    style: {
      width: '100%'
    },
    format: format,
    placeholder: "\u8BF7\u9009\u62E9"
  }, fieldOptions, {
    defaultValue: defaultValue,
    onChange: handleChange
  }));
};
/**
 * 树结构选择
 */

var EnSelectTree = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue;
  var defaultValue = Array.isArray(fieldValue) ? fieldValue : [];

  var _useState3 = useState(defaultValue),
      _useState4 = _slicedToArray(_useState3, 2),
      selected = _useState4[0],
      setSelected = _useState4[1];

  var changeTreeSelect = e => {
    setSelected(e);
  };

  var handleSave = () => {
    fieldChange(selected);
  };

  return /*#__PURE__*/React.createElement(_TreeSelect, _extends({
    style: {
      width: '100%'
    },
    multiple: true,
    placeholder: "\u8BF7\u9009\u62E9",
    showSearch: true,
    allowClear: true,
    treeDataSimpleMode: true,
    treeNodeFilterProp: "title" // 开启按title搜索

  }, fieldOptions, {
    defaultValue: fieldValue,
    onChange: changeTreeSelect,
    onBlur: handleSave
  }));
};
;// CONCATENATED MODULE: ./src/components/EnhanceCommonTable/components/EditableCell.tsx




var EditableCell_excluded = ["children", "dataIndex", "type", "record", "rowIndex", "dataList", "fieldOptions", "colIndex", "setCellRowValue", "render"];

/**
 * 单元格设置
 */




function BaseField(props) {
  var fieldType = props.fieldType,
      textData = props.textData;

  switch (fieldType) {
    case 'SELECT':
      return /*#__PURE__*/react.createElement(EnSelect, props);

    case 'INPUT':
      return /*#__PURE__*/react.createElement(EnInput, props);

    case 'DATE_PICKER':
      return /*#__PURE__*/react.createElement(EnDatePicker, props);

    case 'RANGE_PICKER':
      return /*#__PURE__*/react.createElement(EnRangePicker, props);

    default:
      return textData;
  }
}

function EditableCell(props) {
  var children = props.children,
      dataIndex = props.dataIndex,
      type = props.type,
      record = props.record,
      rowIndex = props.rowIndex,
      dataList = props.dataList,
      fieldOptions = props.fieldOptions,
      colIndex = props.colIndex,
      setCellRowValue = props.setCellRowValue,
      render = props.render,
      restProps = (0,objectWithoutProperties/* default */.Z)(props, EditableCell_excluded);

  var _useContext = (0,react.useContext)(EnhanceContentContext),
      tableTag = _useContext.tableTag,
      handleSaveRow = _useContext.handleSaveRow,
      focusFunCallback = _useContext.focusFunCallback;

  var cellData = (0,react.useMemo)(() => record ? record[dataIndex] : undefined, [record, dataIndex]);
  /**
   * 下拉框组件的数据
   */

  var cellDataList = (0,react.useMemo)(() => {
    if (typeof dataList === 'function') {
      var _dataList;

      return (_dataList = dataList(record, rowIndex)) !== null && _dataList !== void 0 ? _dataList : [];
    }

    return dataList !== null && dataList !== void 0 ? dataList : [];
  }, [dataList, record, rowIndex]);
  /**
   * 组件的属性
   */

  var cellFieldOptions = (0,react.useMemo)(() => {
    if (typeof fieldOptions === 'function') {
      return fieldOptions(record, rowIndex);
    }

    return fieldOptions !== null && fieldOptions !== void 0 ? fieldOptions : {};
  }, [fieldOptions, record, rowIndex]);
  /**
   * 单元格类型
   */

  var cellType = (0,react.useMemo)(() => {
    if (typeof type === 'function') {
      return type(record, rowIndex) || 'TEXT';
    }

    return type || 'TEXT';
  }, [type, record, rowIndex]); // 单元格组件的样式类

  var fieldCls = (0,react.useMemo)(() => "".concat(tableTag, "-").concat(cellType, "-").concat(rowIndex, "-").concat(colIndex), [tableTag, cellType, rowIndex, colIndex]);
  /**
   * 控件的值发生变化时
   */

  var fieldChange = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(val, o) {
      var params, res, currentCell, currentCellOldData, oldData, newData, hasEdited;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              // 更新后的本行数据
              params = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, record), {}, {
                [dataIndex]: val
              });

              if (!(setCellRowValue && typeof setCellRowValue === 'function')) {
                _context.next = 7;
                break;
              }

              _context.next = 5;
              return setCellRowValue(params, o);

            case 5:
              res = _context.sent;
              params = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, params), res);

            case 7:
              // 如果自定义了回调
              if (cellFieldOptions !== null && cellFieldOptions !== void 0 && cellFieldOptions.onChange) {
                cellFieldOptions.onChange(params);
              } // 单元格字段名对于的数据


              currentCell = {
                [dataIndex]: val
              };
              currentCellOldData = {
                [dataIndex]: cellData
              }; // 是否修改过数据

              oldData = cellData ? cellData.toString() : cellData;
              newData = val ? val.valueOf() : val;
              hasEdited = oldData !== newData;

              if (handleSaveRow) {
                requestAnimationFrame(() => {
                  handleSaveRow(params, {
                    hasEdited,
                    currentCell,
                    currentCellOldData,
                    currentRowOldData: record
                  });
                });
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](0);
              console.log('Save failed:', _context.t0);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 16]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [record, dataIndex, setCellRowValue, cellFieldOptions, cellData, handleSaveRow]);
  var childNode = /*#__PURE__*/react.createElement(BaseField, {
    fieldOptions: cellFieldOptions,
    dataList: cellDataList,
    fieldChange: fieldChange,
    fieldType: cellType,
    fieldValue: cellData,
    fieldCls: fieldCls,
    textData: children,
    focusFunCallback: focusFunCallback
  });

  if (render) {
    var data = cellType === 'TEXT' ? cellData : childNode;
    childNode = render(data, record, rowIndex);
  }

  return /*#__PURE__*/react.createElement("td", restProps, childNode);
}

/* harmony default export */ var components_EditableCell = (EditableCell);
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
// EXTERNAL MODULE: ./node_modules/react-resizable/index.js
var react_resizable = __webpack_require__(1706);
;// CONCATENATED MODULE: ./src/components/EnhanceCommonTable/components/ResizableTitle.tsx

var ResizableTitle_excluded = ["onResize", "width"];


/* harmony default export */ var ResizableTitle = (props => {
  var onResize = props.onResize,
      width = props.width,
      restProps = (0,objectWithoutProperties/* default */.Z)(props, ResizableTitle_excluded);

  if (!width) {
    return /*#__PURE__*/react.createElement("th", restProps);
  }

  return /*#__PURE__*/react.createElement(react_resizable.Resizable, {
    width: width,
    height: 0,
    handle: /*#__PURE__*/react.createElement("span", {
      className: "react-resizable-handle",
      onClick: e => {
        e.stopPropagation();
      }
    }),
    onResize: onResize,
    draggableOpts: {
      enableUserSelectHack: false
    }
  }, /*#__PURE__*/react.createElement("th", restProps));
});
// EXTERNAL MODULE: ./node_modules/antd/es/result/style/index.js
var result_style = __webpack_require__(32752);
// EXTERNAL MODULE: ./node_modules/antd/es/result/index.js + 3 modules
var result = __webpack_require__(6129);
;// CONCATENATED MODULE: ./src/components/EnhanceCommonTable/components/ErrorBoundary.tsx



/* eslint-disable @typescript-eslint/member-ordering */


class ErrorBoundary extends react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      hasError: false,
      errorInfo: ''
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      errorInfo: error.message
    };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/react.createElement(result/* default */.ZP, {
        status: "error",
        title: "\u51FA\u73B0\u4E86\u9519\u8BEF",
        extra: this.state.errorInfo
      });
    }

    return this.props.children;
  }

}

/* harmony default export */ var components_ErrorBoundary = (ErrorBoundary);
// EXTERNAL MODULE: ./node_modules/antd/es/popover/style/index.js
var popover_style = __webpack_require__(20136);
// EXTERNAL MODULE: ./node_modules/antd/es/popover/index.js
var popover = __webpack_require__(55241);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/style/index.js
var tooltip_style = __webpack_require__(22385);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 1 modules
var tooltip = __webpack_require__(31097);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/SettingOutlined.js + 1 modules
var SettingOutlined = __webpack_require__(24616);
// EXTERNAL MODULE: ./node_modules/antd/es/tree/style/index.js
var tree_style = __webpack_require__(32157);
// EXTERNAL MODULE: ./node_modules/antd/es/tree/index.js + 8 modules
var tree = __webpack_require__(15037);
;// CONCATENATED MODULE: ./src/components/EnhanceCommonTable/components/ColumnsSettings.tsx







function ColumnsSettings() {
  var _useContext = (0,react.useContext)(EnhanceContentContext),
      columns = _useContext.columns,
      checkStoreColumnsChange = _useContext.checkStoreColumnsChange;

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      checkedKeys = _useState2[0],
      setCheckedKeys = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      treeData = _useState4[0],
      setTreeData = _useState4[1];

  var onDrop = (0,react.useCallback)(_ref => {
    var node = _ref.node,
        dragNode = _ref.dragNode;

    if (!columns) {
      return;
    }

    var _columns$reduce = columns.reduce((pre, next, index) => {
      if (next.dataIndex === node.key) {
        return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, pre), {}, {
          first: index
        });
      } else if (next.dataIndex === dragNode.key) {
        return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, pre), {}, {
          second: index
        });
      } else {
        return pre;
      }
    }, {
      first: 0,
      second: 0
    }),
        first = _columns$reduce.first,
        second = _columns$reduce.second; // 交换位置


    var firstItem = columns[first];
    columns[first] = columns[second];
    columns[second] = firstItem;
    var newStoreList = columns.map(v => ({
      dataIndex: v.dataIndex,
      hide: v.hide
    }));
    window.localStorage.setItem(window.location.pathname, JSON.stringify(newStoreList)); // 回调，设置列

    if (checkStoreColumnsChange) {
      checkStoreColumnsChange();
    }
  }, [checkStoreColumnsChange, columns]);
  var handleStoreKeys = (0,react.useCallback)((keys, e) => {
    if (!columns) {
      return;
    }

    var _e$node = e.node,
        checked = _e$node.checked,
        key = _e$node.key;
    var newStoreList = columns === null || columns === void 0 ? void 0 : columns.map(v => ({
      dataIndex: v.dataIndex,
      hide: v.dataIndex === key ? checked : v.hide
    }));
    setCheckedKeys(v => checked ? v.filter(i => i !== key) : v.concat(key));
    window.localStorage.setItem(window.location.pathname, JSON.stringify(newStoreList)); // 回调，设置列

    if (checkStoreColumnsChange) {
      checkStoreColumnsChange();
    }
  }, [checkStoreColumnsChange, columns]); // 根据传入的columns生成列和选中项

  (0,react.useEffect)(() => {
    var _ref2 = (columns === null || columns === void 0 ? void 0 : columns.reduce((pre, next) => {
      return {
        data: pre.data.concat({
          key: next.dataIndex,
          title: next.title,
          hide: next.hide,
          children: []
        }),
        checkedList: !next.hide ? pre.checkedList.concat(next.dataIndex) : pre.checkedList
      };
    }, {
      data: [],
      checkedList: []
    })) || {
      data: [],
      checkedList: []
    },
        data = _ref2.data,
        checkedList = _ref2.checkedList;

    setTreeData(data);
    setCheckedKeys(checkedList);
  }, [columns]);
  return /*#__PURE__*/react.createElement(tree/* default */.Z, {
    className: "draggable-tree",
    checkable: true,
    draggable: true,
    blockNode: true,
    checkedKeys: checkedKeys,
    selectedKeys: [],
    onCheck: handleStoreKeys,
    onDrop: onDrop,
    treeData: treeData,
    onSelect: handleStoreKeys
  });
}

/* harmony default export */ var components_ColumnsSettings = (ColumnsSettings);
;// CONCATENATED MODULE: ./src/components/EnhanceCommonTable/components/ToolBar.tsx





/**
 * 表格操作区
 */




function ToolBar() {
  return /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(popover/* default */.Z, {
    content: /*#__PURE__*/react.createElement(components_ColumnsSettings, null),
    title: "\u8BBE\u7F6E\u5217",
    trigger: "click",
    placement: "bottom"
  }, /*#__PURE__*/react.createElement(tooltip/* default */.Z, {
    title: "\u8BBE\u7F6E\u5217"
  }, /*#__PURE__*/react.createElement(SettingOutlined/* default */.Z, {
    style: {
      fontSize: '18px'
    }
  }))));
}

/* harmony default export */ var components_ToolBar = (ToolBar);
;// CONCATENATED MODULE: ./src/components/EnhanceCommonTable/hooks/useVirtualTable.tsx




var useVirtualTable_excluded = ["children"],
    _excluded2 = ["children"],
    _excluded3 = ["style", "children"],
    _excluded4 = ["width"];

/* eslint-disable no-case-declarations */


var initialState = {
  // 行高度
  rowHeight: 0,
  // 当前的scrollTop
  curScrollTop: 0,
  // 可滚动区域的高度
  scrollHeight: 0,
  // scrollY值
  tableScrollY: 0
};

function reducer(state, action) {
  switch (action.type) {
    // 改变trs 即 改变渲染的列表trs
    case 'changeTrs':
      // 获取值
      var curScrollTop = action.curScrollTop;
      var scrollHeight = action.scrollHeight;
      var tableScrollY = action.tableScrollY;

      if (scrollHeight <= 0) {
        scrollHeight = 0;
      }

      if (state.scrollHeight !== 0) {
        if (tableScrollY === state.tableScrollY) {
          scrollHeight = state.scrollHeight;
        }
      }

      if (state.scrollHeight && curScrollTop > state.scrollHeight) {
        curScrollTop = state.scrollHeight;
      }

      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, state), {}, {
        curScrollTop,
        scrollHeight,
        tableScrollY
      });
    // 初始化每行的高度, 表格总高度, 渲染的条数

    case 'initHeight':
      // 获取值
      var rowHeight = action.rowHeight;
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, state), {}, {
        rowHeight
      });

    case 'reset':
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, state), {}, {
        curScrollTop: 0,
        scrollHeight: 0
      });

    default:
      throw new Error();
  }
}

var ScrollContext = /*#__PURE__*/(0,react.createContext)({
  dispatch: undefined,
  renderLen: 1,
  start: 0,
  offsetStart: 0,
  rowHeight: 0,
  totalLen: 0
});
var scrollY = 0;

function VRow(props) {
  var _useContext = (0,react.useContext)(ScrollContext),
      dispatch = _useContext.dispatch,
      rowHeight = _useContext.rowHeight,
      totalLen = _useContext.totalLen;

  var children = props.children,
      restProps = (0,objectWithoutProperties/* default */.Z)(props, useVirtualTable_excluded);

  var trRef = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    var initHeight = trRef => {
      if (trRef !== null && trRef !== void 0 && trRef.offsetHeight && !rowHeight && totalLen) {
        var _trRef$offsetHeight;

        var tempRowHeight = (_trRef$offsetHeight = trRef === null || trRef === void 0 ? void 0 : trRef.offsetHeight) !== null && _trRef$offsetHeight !== void 0 ? _trRef$offsetHeight : 0;
        dispatch && dispatch({
          type: 'initHeight',
          rowHeight: tempRowHeight
        });
      }
    };

    initHeight(trRef === null || trRef === void 0 ? void 0 : trRef.current);
  }, [trRef, dispatch, rowHeight, totalLen]);
  return /*#__PURE__*/react.createElement("tr", (0,esm_extends/* default */.Z)({}, restProps, {
    ref: trRef,
    style: {
      height: rowHeight ? rowHeight : 'auto',
      boxSizing: 'border-box'
    }
  }), children);
}

function VWrapper(props) {
  var children = props.children,
      restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded2);

  var _useContext2 = (0,react.useContext)(ScrollContext),
      renderLen = _useContext2.renderLen,
      start = _useContext2.start,
      offsetStart = _useContext2.offsetStart;

  var contents = children[1];
  var tempNode = null;

  if (Array.isArray(contents) && contents.length) {
    tempNode = [children[0], contents.slice(start, start + renderLen).map(item => {
      if (Array.isArray(item)) {
        // 兼容antd v4.3.5 --- rc-table 7.8.1及以下
        return item[0];
      } else {
        // 处理antd ^v4.4.0  --- rc-table ^7.8.2
        return item;
      }
    })];
  } else {
    tempNode = children;
  }

  return /*#__PURE__*/react.createElement("tbody", (0,esm_extends/* default */.Z)({}, restProps, {
    style: {
      transform: "translateY(-".concat(offsetStart, "px)")
    }
  }), tempNode);
}

function VTable(props) {
  var _children$1$props$dat, _children$, _children$$props, _children$$props$data;

  var style = props.style,
      children = props.children,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded3);

  var width = style.width,
      restStyle = (0,objectWithoutProperties/* default */.Z)(style, _excluded4);

  var _useReducer = (0,react.useReducer)(reducer, initialState),
      _useReducer2 = (0,slicedToArray/* default */.Z)(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var wrapTableRef = (0,react.useRef)(null);
  var tableRef = (0,react.useRef)(null); // 数据的总条数

  var _useState = (0,react.useState)((_children$1$props$dat = (_children$ = children[1]) === null || _children$ === void 0 ? void 0 : (_children$$props = _children$.props) === null || _children$$props === void 0 ? void 0 : (_children$$props$data = _children$$props.data) === null || _children$$props$data === void 0 ? void 0 : _children$$props$data.length) !== null && _children$1$props$dat !== void 0 ? _children$1$props$dat : 0),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      totalLen = _useState2[0],
      setTotalLen = _useState2[1];

  (0,react.useEffect)(() => {
    var _children$2, _children$2$props, _children$2$props$dat;

    if ((0,lodash.isNumber)((_children$2 = children[1]) === null || _children$2 === void 0 ? void 0 : (_children$2$props = _children$2.props) === null || _children$2$props === void 0 ? void 0 : (_children$2$props$dat = _children$2$props.data) === null || _children$2$props$dat === void 0 ? void 0 : _children$2$props$dat.length)) {
      var _children$3, _children$3$props, _children$3$props$dat;

      setTotalLen((_children$3 = children[1]) === null || _children$3 === void 0 ? void 0 : (_children$3$props = _children$3.props) === null || _children$3$props === void 0 ? void 0 : (_children$3$props$dat = _children$3$props.data) === null || _children$3$props$dat === void 0 ? void 0 : _children$3$props$dat.length);
    }
  }, [children]); // table总高度

  var tableHeight = (0,react.useMemo)(() => {
    var temp = 'auto';

    if (state.rowHeight && totalLen) {
      temp = state.rowHeight * totalLen + 10;
    }

    return temp;
  }, [state.rowHeight, totalLen]); // table的scrollY值

  var tableScrollY = 0;

  if (typeof scrollY === 'string') {
    var _wrapTableRef$current, _wrapTableRef$current2;

    tableScrollY = (_wrapTableRef$current = wrapTableRef.current) === null || _wrapTableRef$current === void 0 ? void 0 : (_wrapTableRef$current2 = _wrapTableRef$current.parentNode) === null || _wrapTableRef$current2 === void 0 ? void 0 : _wrapTableRef$current2.offsetHeight;
  } else {
    tableScrollY = scrollY;
  }

  if ((0,lodash.isNumber)(tableHeight) && tableHeight < tableScrollY) {
    tableScrollY = tableHeight;
  } // 处理tableScrollY <= 0的情况


  if (tableScrollY <= 0) {
    tableScrollY = 0;
  } // 渲染的条数


  var renderLen = (0,react.useMemo)(() => {
    var temp = 1; // console.log(state.rowHeight, totalLen, tableScrollY)

    if (state.rowHeight && totalLen && tableScrollY) {
      if (tableScrollY <= 0) {
        temp = 0;
      } else {
        var tempRenderLen = (tableScrollY / state.rowHeight | 0) + 1 + 2; // console.log('tempRenderLen', tempRenderLen)

        temp = tempRenderLen > totalLen ? totalLen : tempRenderLen;
      }
    }

    return temp;
  }, [state.rowHeight, totalLen, tableScrollY]); // 渲染中的第一条

  var start = state.rowHeight ? state.curScrollTop / state.rowHeight | 0 : 0; // 偏移量

  var offsetStart = state.rowHeight ? state.curScrollTop % state.rowHeight : 0; // 用来优化向上滚动出现的空白

  if (state.curScrollTop && state.rowHeight && state.curScrollTop > state.rowHeight) {
    if (start > totalLen - renderLen) {
      // 可能以后会做点操作
      offsetStart = 0;
    } else if (start > 1) {
      start = start - 1;
      offsetStart += state.rowHeight;
    }
  } else {
    start = 0;
  }

  (0,react.useEffect)(() => {
    var _wrapTableRef$current3;

    // totalLen变化, 那么搜索条件一定变化, 数据也一定变化.
    var parentNode = (_wrapTableRef$current3 = wrapTableRef.current) === null || _wrapTableRef$current3 === void 0 ? void 0 : _wrapTableRef$current3.parentNode;

    if (parentNode) {
      parentNode.scrollTop = 0;
    }

    dispatch({
      type: 'reset'
    });
  }, [totalLen]);
  (0,react.useEffect)(() => {
    var _wrapTableRef$current4;

    var throttleScroll = (0,lodash.throttle)(e => {
      var _e$target$scrollTop, _e$target;

      var scrollTop = (_e$target$scrollTop = e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.scrollTop) !== null && _e$target$scrollTop !== void 0 ? _e$target$scrollTop : 0;

      if (scrollTop !== state.curScrollTop) {
        var scrollHeight = e.target.scrollHeight - tableScrollY;
        dispatch({
          type: 'changeTrs',
          curScrollTop: scrollTop,
          scrollHeight,
          tableScrollY
        });
      }
    }, 100);
    var ref = wrapTableRef === null || wrapTableRef === void 0 ? void 0 : (_wrapTableRef$current4 = wrapTableRef.current) === null || _wrapTableRef$current4 === void 0 ? void 0 : _wrapTableRef$current4.parentNode;

    if (ref) {
      ref.addEventListener('scroll', throttleScroll);
    }

    return () => {
      ref.removeEventListener('scroll', throttleScroll);
    };
  }, [wrapTableRef, state.curScrollTop, tableScrollY, state.scrollHeight]);
  return /*#__PURE__*/react.createElement("div", {
    className: "virtuallist",
    ref: wrapTableRef,
    style: {
      width: '100%',
      position: 'relative',
      height: tableHeight,
      boxSizing: 'border-box',
      paddingTop: state.curScrollTop
    }
  }, /*#__PURE__*/react.createElement(ScrollContext.Provider, {
    value: {
      dispatch,
      rowHeight: state.rowHeight,
      start,
      offsetStart,
      renderLen,
      totalLen
    }
  }, /*#__PURE__*/react.createElement("table", (0,esm_extends/* default */.Z)({}, rest, {
    ref: tableRef,
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, restStyle), {}, {
      width,
      position: 'relative'
    })
  }), children)));
}

function useVirtualTable(props) {
  var height = props.height,
      useVirtual = props.useVirtual;

  if (!useVirtual) {
    return null;
  }

  scrollY = height;
  return {
    table: VTable,
    body: {
      wrapper: VWrapper,
      row: VRow
    }
  };
}
;// CONCATENATED MODULE: ./src/components/EnhanceCommonTable/hooks/useResizeColumns.ts




function useResizeColumns(propsColumns, useVirtual) {
  var _useState = (0,react.useState)(propsColumns),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      columns = _useState2[0],
      setColumns = _useState2[1];

  var handleResize = (0,react.useCallback)(index => (e, _ref) => {
    var size = _ref.size;
    setColumns(columns => {
      var nextColumns = [...columns];
      nextColumns[index] = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, nextColumns[index]), {}, {
        width: size.width
      });
      return nextColumns;
    });
  }, []);
  (0,react.useEffect)(() => {
    var _propsColumns$filter$ = propsColumns.filter(Boolean).reduce((pre, next, key) => {
      // 隐藏该列
      if (next.hide) {
        return pre;
      } // 如果当前column表头文案不是操作以及没有 type 值，表示当前单元格展示的是文案而不是表单组件


      if (!next.type && !next.render) {
        return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, pre), {}, {
          columns: [...pre.columns, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, next), {}, {
            ellipsis: !!useVirtual
          })]
        });
      }

      var index = next.type ? pre.editIndex + 1 : pre.editIndex;
      return {
        columns: [...pre.columns, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, next), {}, {
          ellipsis: (!!useVirtual).toString(),
          onCell: (record, rowIndex) => {
            return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, next), {}, {
              rowIndex,
              record,
              colIndex: index === 0 ? undefined : index // 可编辑的单元格的序号

            });
          },
          onHeaderCell: column => ({
            width: column.width,
            onResize: handleResize(key)
          })
        })],
        editIndex: index
      };
    }, {
      columns: [],
      editIndex: 0
    }),
        tableCols = _propsColumns$filter$.columns;

    setColumns(tableCols);
  }, [handleResize, propsColumns, useVirtual]);
  return columns;
}

/* harmony default export */ var hooks_useResizeColumns = (useResizeColumns);
;// CONCATENATED MODULE: ./src/components/EnhanceCommonTable/hooks/useFieldFocus.ts


/**
 * 输入框光标移动
 */

/* eslint-disable no-unused-expressions */


function useFieldFocus(props, deps) {
  var dataSource = props.dataSource,
      tableTag = props.tableTag,
      wrapper = props.wrapper;
  var changePointer = (0,react.useCallback)(e => {
    e.preventDefault();
    if (!['ArrowUp', 'ArrowDown', 'ArrowRight', 'ArrowLeft'].includes(e.code)) return;
    var ele = e.target;
    var cls = Array.from(ele.classList).find(v => v.includes('INPUT') && v.includes(tableTag)); // 当前节点不是input输入框

    if (ele.tagName !== 'INPUT' || !cls) {
      return;
    }
    /**
     * fieldType：组件类型
     * colIndex：可编辑的列序号
     * rowIndex：行序号
     */


    var _cls$split = cls.split('-'),
        _cls$split2 = (0,slicedToArray/* default */.Z)(_cls$split, 4),
        fieldType = _cls$split2[1],
        rowIndex = _cls$split2[2],
        colIndex = _cls$split2[3];

    var currentRowKey = Number(rowIndex);
    var currentColKey = Number(colIndex);
    var nextRowIndex = currentRowKey;
    var nextColIndex = currentColKey;

    if (e.code === 'ArrowUp') {
      if (currentRowKey === 0) {
        return;
      }

      nextRowIndex = currentRowKey - 1;
    } else if (e.code === 'ArrowDown') {
      var maxKey = dataSource.length - 1;
      nextRowIndex = currentRowKey + 1;

      if (maxKey < nextRowIndex) {
        return;
      }
    } else if (e.code === 'ArrowRight') {
      nextColIndex = currentColKey + 1;
    } else {
      if (nextColIndex === 1) {
        return;
      }

      nextColIndex = currentColKey - 1;
    } // 未处于编辑状态的


    var newCls = "".concat(tableTag, "-").concat(fieldType, "-").concat(nextRowIndex, "-").concat(nextColIndex);
    var newElement = document.querySelector("input.".concat(newCls));

    if (newElement) {
      ;
      newElement.focus();
    }
  }, [dataSource === null || dataSource === void 0 ? void 0 : dataSource.length, tableTag]);
  (0,react.useEffect)(() => {
    if (!wrapper || !(dataSource !== null && dataSource !== void 0 && dataSource.length) || deps.some(v => !v)) return;
    wrapper === null || wrapper === void 0 ? void 0 : wrapper.addEventListener('keyup', changePointer);
    return () => {
      wrapper === null || wrapper === void 0 ? void 0 : wrapper.removeEventListener('keyup', changePointer);
    };
  }, [changePointer, dataSource, deps, wrapper]);
}

/* harmony default export */ var hooks_useFieldFocus = (useFieldFocus);
;// CONCATENATED MODULE: ./src/components/EnhanceCommonTable/hooks/useScrollLoad.ts



/**
 * 滑动加载
 */
function useScrollLoad(props, deps) {
  var wrapper = props.wrapper,
      callback = props.callback;
  (0,react.useEffect)(() => {
    if (!deps.every(Boolean) || !wrapper) {
      return;
    }

    var tableBody = wrapper.getElementsByClassName('ant-table-body')[0];
    var tableBodyDivScroll = (0,lodash.throttle)(ev => {
      var bodyDivRect = ev.target.getBoundingClientRect();
      var tableRect = ev.target.querySelector('.virtuallist').getBoundingClientRect();
      var scrollBarHeight = 7; // global.less 中设置的滚动条厚度 7px

      var THRESHOLD = 20; // 触发阈值 (row高度)

      var bottom = tableRect.bottom + scrollBarHeight - bodyDivRect.bottom < THRESHOLD; // 记录本次滚动的高度

      var scrollHeight = tableBody.scrollHeight;

      if (bottom) {
        callback(() => {
          tableBody === null || tableBody === void 0 ? void 0 : tableBody.scrollTo(0, scrollHeight);
        });
      }
    }, 900);
    tableBody.addEventListener('scroll', tableBodyDivScroll);
    return () => {
      tableBody.removeEventListener('scroll', tableBodyDivScroll);
    };
  }, [callback, deps, wrapper]);
}
;// CONCATENATED MODULE: ./src/components/EnhanceCommonTable/hooks/useRefCallback.ts
/**
 * 当 useCallback 和 useEffect 组合使用时，由于 useCallback 的依赖项变化也会导致 useEffect 执行，这种隐式依赖会带来 BUG 或隐患。
 * 一旦某个函数使用了 useCallback ，当这个函数的依赖项变化时所有直接或间接调用这个 useCallback 的都需要回归。
 * 所以这是成本高、有风险的事情。
 */


function useRefCallback(callback, deps) {
  var callbackRef = (0,react.useRef)(callback);
  callbackRef.current = callback; // eslint-disable-next-line react-hooks/exhaustive-deps

  return (0,react.useCallback)(function () {
    return callbackRef.current(...arguments);
  }, deps);
}

/* harmony default export */ var hooks_useRefCallback = (useRefCallback);
;// CONCATENATED MODULE: ./src/components/EnhanceCommonTable/hooks/useTableYSize.ts



function useTableYSize(scrollYSize) {
  // table内容高度
  var _useState = (0,react.useState)(500),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      scrollY = _useState2[0],
      setScrollY = _useState2[1]; // 高度


  (0,react.useEffect)(() => {
    if (scrollYSize) {
      setScrollY(scrollYSize);
    } else {
      requestAnimationFrame(() => {
        var clientHeight = document.body.clientHeight;
        var ele = document.getElementById('tablePart');

        if (ele) {
          var top = ele.getBoundingClientRect().top;
          var TOP_DIST = 60; // 上边距

          var BOTTOM_DIST = 55; // 下边距

          var _scrollY = clientHeight - top - TOP_DIST - BOTTOM_DIST;

          setScrollY(_scrollY);
        }
      });
    }
  }, [scrollYSize]);
  return scrollY;
}

/* harmony default export */ var hooks_useTableYSize = (useTableYSize);
;// CONCATENATED MODULE: ./src/components/EnhanceCommonTable/components/EnhanceTable.tsx












var EnhanceTable_excluded = ["mode", "columns", "searchParams", "cacheTable", "pageSize", "requestUrl", "cancelRequest", "useVirtual", "useToolBar", "tableRef", "tableHeaderBar", "rowSelectCallback", "sortCallback", "afterRequest", "saveRowCallback", "clickRowCallback", "dataSourceChangeCallback", "focusFunCallback"];

/**
 * 终极奥义·通用列表
 */














var EnhanceContentContext = /*#__PURE__*/react.createContext({
  size: 'small',
  viewHeight: 500
});
function getEditableTableKey(name) {
  return (0,lodash.uniqueId)("".concat(name || 'commonT', "_"));
}

function EnhanceTable(props) {
  var _rest$scroll;

  var _props$mode = props.mode,
      mode = _props$mode === void 0 ? 'normal' : _props$mode,
      propsColumns = props.columns,
      searchParams = props.searchParams,
      _props$cacheTable = props.cacheTable,
      cacheTable = _props$cacheTable === void 0 ? false : _props$cacheTable,
      propsPageSize = props.pageSize,
      requestUrl = props.requestUrl,
      _props$cancelRequest = props.cancelRequest,
      cancelRequest = _props$cancelRequest === void 0 ? false : _props$cancelRequest,
      useVirtual = props.useVirtual,
      useToolBar = props.useToolBar,
      propsTableRef = props.tableRef,
      tableHeaderBar = props.tableHeaderBar,
      rowSelectCallback = props.rowSelectCallback,
      sortCallback = props.sortCallback,
      afterRequest = props.afterRequest,
      saveRowCallback = props.saveRowCallback,
      clickRowCallback = props.clickRowCallback,
      dataSourceChangeCallback = props.dataSourceChangeCallback,
      focusFunCallback = props.focusFunCallback,
      rest = (0,objectWithoutProperties/* default */.Z)(props, EnhanceTable_excluded);

  var isScrolled = mode === 'scroll'; // 多选内容

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      selectedRowKeys = _useState2[0],
      setSelectedRowKeys = _useState2[1]; // table loading


  var _useState3 = (0,react.useState)(false),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1]; // table的值


  var _useState5 = (0,react.useState)(props.dataSource || []),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      dataSource = _useState6[0],
      setDataSource = _useState6[1]; // 表格展示的列


  var _useState7 = (0,react.useState)(propsColumns),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      tableColumns = _useState8[0],
      setTableColumns = _useState8[1]; // table唯一标识


  var tableTag = (0,react.useRef)(getEditableTableKey('tableTag')); // 请求参数

  var searchParamsRef = (0,react.useRef)(); // 列表参数

  var tableParamsRef = (0,react.useRef)({
    total: 0,
    current: 1,
    pageSize: propsPageSize || 30
  }); // 是否加载渲染完

  var didMount = (0,react.useRef)(false); // table dom 对象

  var wrapper = (0,react.useRef)(null); // 表头信息

  var columns = hooks_useResizeColumns(tableColumns, useVirtual);
  /**
   * 鼠标上下左右移动焦距
   */

  hooks_useFieldFocus({
    dataSource,
    tableTag: tableTag.current,
    wrapper: wrapper.current
  }, [didMount.current]);
  /**
   * table内容高度
   */

  var scrollY = hooks_useTableYSize((rest === null || rest === void 0 ? void 0 : (_rest$scroll = rest.scroll) === null || _rest$scroll === void 0 ? void 0 : _rest$scroll.y) || 500);
  /**
   * 使用虚拟列表
   */

  var virtualComponents = useVirtualTable({
    height: scrollY,
    useVirtual: useVirtual || isScrolled
  });
  /**
   * table 滚动条
   */

  var scrollProps = (0,react.useMemo)(() => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, rest === null || rest === void 0 ? void 0 : rest.scroll), {}, {
    y: scrollY
  }), [scrollY, rest === null || rest === void 0 ? void 0 : rest.scroll]);
  /**
   * 获取CommonTable的selection配置
   * 缓存 rowselect 配置
   */

  var selection = (0,react.useMemo)(() => {
    // 如果没有自定义配置「rowSelection」以及没有「rowSelectCallback」表示不需要列表多选
    if (!(rest !== null && rest !== void 0 && rest.rowSelection) && !props.rowSelectCallback) {
      return undefined;
    }

    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, rest === null || rest === void 0 ? void 0 : rest.rowSelection), {}, {
      selectedRowKeys: selectedRowKeys,
      onChange: (keys, selectedRows) => {
        setSelectedRowKeys(keys);

        if (rowSelectCallback) {
          rowSelectCallback(keys, selectedRows);
        }
      }
    });
  }, [props.rowSelectCallback, rest === null || rest === void 0 ? void 0 : rest.rowSelection, rowSelectCallback, selectedRowKeys]);
  /**
   * 获取页码与每页条数
   */

  var getPage = (0,react.useCallback)((current, pageSize, isPaging) => {
    if (cacheTable) {
      var _data, _data2;

      var data = window.localStorage.getItem("".concat(location.pathname, "-").concat(tableTag));

      if (data) {
        try {
          data = JSON.parse(data);
        } catch (error) {
          console.log(error);
        }
      } // 表格不是第一次加载时取入参的页码等，否则拿缓存数据


      var pageNo = didMount.current ? current : (_data = data) === null || _data === void 0 ? void 0 : _data.page;
      var size = didMount.current ? pageSize : (_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.size; // 当前是页码等操作变化取入参

      var usePage = isPaging ? current : pageNo;
      var useSize = isPaging ? pageSize : size;
      return {
        pageNo: usePage || 1,
        size: useSize || propsPageSize || 30
      };
    }

    return {
      pageNo: current || 1,
      size: pageSize || propsPageSize || 30
    };
  }, [cacheTable, propsPageSize]);
  /**
   * values 外部查询调用传参
   * pageParams 分页等查询参数
   */

  var sendRequest = hooks_useRefCallback( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(reqProps) {
      var current, pageSize, _reqProps$isPaging, isPaging, searchParams, _getPage, pageNo, size, params, result, _result$result, list, _result$result$total, total, res, finalList;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              current = reqProps.current, pageSize = reqProps.pageSize, _reqProps$isPaging = reqProps.isPaging, isPaging = _reqProps$isPaging === void 0 ? false : _reqProps$isPaging, searchParams = reqProps.searchParams;
              _getPage = getPage(current, pageSize, isPaging), pageNo = _getPage.pageNo, size = _getPage.size;
              params = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, searchParams), {}, {
                page: pageNo,
                size
              });
              _context.prev = 4;
              _context.next = 7;
              return (0,ypRequest/* default */.Z)(requestUrl, params);

            case 7:
              result = _context.sent;
              _result$result = result.result, list = _result$result.list, _result$result$total = _result$result.total, total = _result$result$total === void 0 ? 0 : _result$result$total;

              if (!afterRequest) {
                _context.next = 14;
                break;
              }

              _context.next = 12;
              return afterRequest(list);

            case 12:
              res = _context.sent;
              list = res !== null && res !== void 0 ? res : list;

            case 14:
              tableParamsRef.current = {
                total,
                current: pageNo,
                pageSize: size
              };
              finalList = list.map(v => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
                commonTableKey: getEditableTableKey()
              }));

              if (isScrolled) {
                // 滚动加载的话  就将数据拼接
                setDataSource(v => pageNo === 1 ? finalList : v.concat(finalList));
              } else {
                setDataSource(finalList);
              } // 缓存则派发


              if (cacheTable) {
                window.localStorage.setItem("".concat(location.pathname, "-").concat(tableTag), JSON.stringify({
                  page: pageNo,
                  size: size
                }));
              }

              _context.next = 22;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](4);

            case 22:
              _context.prev = 22;
              setLoading(false);
              return _context.finish(22);

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 20, 22, 25]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [requestUrl, afterRequest, cacheTable, isScrolled]);
  /**
   * 表格事件操作
   */

  var changeTable = (0,react.useCallback)((pagination, filters, sorters) => {
    var current = pagination.current,
        pageSize = pagination.pageSize;
    var column = sorters.column; // 防止没有排序的列发生请求

    if (sorters.column && !column.sorter) {
      return;
    } // 排序的回调


    if (sortCallback) {
      var res = sortCallback(filters, sorters);
      searchParamsRef.current = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, searchParamsRef.current), res || {});
    }

    return sendRequest({
      current,
      pageSize,
      isPaging: true,
      searchParams: searchParamsRef.current || {}
    });
  }, [sortCallback, sendRequest]);
  useScrollLoad({
    wrapper: wrapper === null || wrapper === void 0 ? void 0 : wrapper.current,
    callback: function () {
      var _callback2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(_callback) {
        var _tableParamsRef$curre, current, pageSize, total, maxPageNo, pageNo;

        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _tableParamsRef$curre = tableParamsRef.current, current = _tableParamsRef$curre.current, pageSize = _tableParamsRef$curre.pageSize, total = _tableParamsRef$curre.total;
                maxPageNo = Math.ceil(Number(total) / Number(pageSize));
                pageNo = current + 1;

                if (!(pageNo > maxPageNo)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return");

              case 5:
                _context2.next = 7;
                return sendRequest({
                  current: pageNo,
                  pageSize,
                  searchParams: searchParamsRef.current || {}
                });

              case 7:
                _callback();

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function callback(_x2) {
        return _callback2.apply(this, arguments);
      }

      return callback;
    }()
  }, [isScrolled, didMount.current]);
  /**
   * 点击列表行
   * @param ev 点击的事件
   * @param record 当前行的数据
   */

  var onRowClick = (0,react.useCallback)((ev, record, index) => {
    // 点击行的回调
    if (clickRowCallback) {
      clickRowCallback(ev, record, index);
    }

    if (!selection) return; // 行的键

    var rowKey = rest !== null && rest !== void 0 && rest.rowKey ? rest === null || rest === void 0 ? void 0 : rest.rowKey : record.id ? 'id' : 'commonTableKey'; // 获取键对应的值

    var tableRowVal = record[rowKey];
    var isSingle = selection.type ? selection.type === 'radio' : false;
    var exited = selectedRowKeys.includes(tableRowVal);
    var selectedKeys = exited ? selectedRowKeys.filter(v => v !== tableRowVal) : isSingle ? [tableRowVal] : selectedRowKeys.concat(tableRowVal);
    var selectedRows = dataSource.filter(v => {
      return selectedKeys.includes(v[rowKey]);
    });
    setSelectedRowKeys(selectedKeys);

    if (rowSelectCallback) {
      rowSelectCallback(selectedKeys, selectedRows);
    }
  }, [selection, rest === null || rest === void 0 ? void 0 : rest.rowKey, selectedRowKeys, dataSource, rowSelectCallback, clickRowCallback]);
  /**
   * 设置表格行信息
   */

  var tableRowOption = (0,react.useCallback)((record, index) => {
    var rowsData = {};

    if (rest !== null && rest !== void 0 && rest.onRow && typeof (rest === null || rest === void 0 ? void 0 : rest.onRow) === 'function') {
      rowsData = rest === null || rest === void 0 ? void 0 : rest.onRow(record, index);
    }

    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, rowsData), {}, {
      onClick: ev => onRowClick(ev, record, index)
    });
  }, [onRowClick, rest]); // 更新表格数据

  var updateDataSource = (0,react.useCallback)(data => {
    var list = dataSource.map(v => {
      if (data && v.commonTableKey === data.commonTableKey) {
        return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), data);
      }

      return v;
    });
    setDataSource(list);
  }, [dataSource]); // 单元格修改后触发行保存

  var handleSaveRow = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3(data, other) {
      var hasEdited, currentCell, currentCellOldData, currentRowOldData, result, res;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              // hasEdited，数据是否变化
              hasEdited = other.hasEdited, currentCell = other.currentCell, currentCellOldData = other.currentCellOldData, currentRowOldData = other.currentRowOldData;

              if (hasEdited) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return");

            case 4:
              result = data; // 更新当前修改的数据

              updateDataSource(result); // 如果存在异步保存函数

              if (!saveRowCallback) {
                _context3.next = 12;
                break;
              }

              _context3.next = 9;
              return saveRowCallback({
                currentCell,
                currentRow: data,
                currentCellOldData,
                currentRowOldData
              });

            case 9:
              res = _context3.sent;
              result = res || result; // 更新用户返回的数据

              requestAnimationFrame(() => {
                updateDataSource(result);
              });

            case 12:
              _context3.next = 17;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](0);
              console.error('save row failed：', _context3.t0);

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 14]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }(), [updateDataSource, saveRowCallback]); // 检查并生成新的表格列

  var checkStoreColumnsChange = (0,react.useCallback)(() => {
    var pathname = window.location.pathname;
    var store = window.localStorage.getItem(pathname);

    if (store) {
      try {
        var data = JSON.parse(store); // 根据缓存的内容 遍历生成新的 columns 列

        var _columns = data.map(v => {
          var target = propsColumns.find(i => v.dataIndex === i.dataIndex);
          return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, target), v);
        });

        setTableColumns(_columns);
      } catch (error) {
        console.log(error);
      }
    } else {
      var _data3 = (propsColumns === null || propsColumns === void 0 ? void 0 : propsColumns.map(v => ({
        dataIndex: v.dataIndex,
        hide: !!v.hide
      }))) || []; // 不存在就赋值


      window.localStorage.setItem(pathname, JSON.stringify(_data3));
    }
  }, [propsColumns]); // 初始化访问缓存列

  (0,react.useEffect)(() => {
    if (useToolBar) {
      checkStoreColumnsChange();
    }
  }, [checkStoreColumnsChange, useToolBar]);
  (0,react.useEffect)(() => {
    setTableColumns(propsColumns);
  }, [propsColumns]);
  /**
   * 通过该 hook 定义父组件 ref 拿到子组件的实例的内容
   * 父组件使用 reflashTable 来调用子组件 sendRequest 这个方法
   */

  (0,react.useEffect)(() => {
    if (propsTableRef) {
      // @ts-ignore
      propsTableRef.current = {
        reload: params => sendRequest({
          current: tableParamsRef.current.current,
          pageSize: tableParamsRef.current.pageSize,
          searchParams: params || {}
        }),
        getTableData: () => tableParamsRef
      };
    }
  }, [propsTableRef, sendRequest]);
  /**
   * 替换当前表格的数据
   */

  (0,react.useEffect)(() => {
    // @ts-ignore
    setDataSource(props.dataSource);
  }, [props.dataSource]);
  /**
   * 列表数据变化时触发回调
   */

  (0,react.useEffect)(() => {
    if (dataSourceChangeCallback) {
      dataSourceChangeCallback(dataSource);
    }
  }, [dataSource, dataSourceChangeCallback]); // 初始化及查询参数变化后请求

  (0,react.useEffect)(() => {
    if (cancelRequest) {
      return;
    }

    searchParamsRef.current = searchParams;
    sendRequest({
      current: 1,
      pageSize: tableParamsRef.current.pageSize,
      searchParams
    });
  }, [cancelRequest, searchParams, sendRequest]); // 第一次加载结束后

  (0,react.useEffect)(() => {
    didMount.current = true;
  }, []);
  return /*#__PURE__*/react.createElement(EnhanceContentContext.Provider, {
    value: {
      size: rest.size || 'small',
      viewHeight: scrollY,
      tableTag: tableTag === null || tableTag === void 0 ? void 0 : tableTag.current,
      columns: tableColumns,
      handleSaveRow,
      checkStoreColumnsChange,
      focusFunCallback
    }
  }, /*#__PURE__*/react.createElement(components_ErrorBoundary, null, /*#__PURE__*/react.createElement("div", {
    className: "commonTable",
    id: "tablePart",
    ref: wrapper
  }, useToolBar ? /*#__PURE__*/react.createElement(space/* default */.Z, {
    className: "tableHeaderBar"
  }, /*#__PURE__*/react.createElement(components_ToolBar, null), tableHeaderBar) : null, /*#__PURE__*/react.createElement(table/* default */.Z, (0,esm_extends/* default */.Z)({
    size: "small",
    rowKey: r => r.id ? r.id : r.commonTableKey
  }, rest, {
    scroll: scrollProps,
    columns: columns,
    dataSource: dataSource,
    loading: loading,
    onChange: changeTable,
    onRow: tableRowOption,
    rowSelection: selection,
    components: {
      header: {
        cell: ResizableTitle
      },
      body: {
        cell: components_EditableCell,
        wrapper: virtualComponents === null || virtualComponents === void 0 ? void 0 : virtualComponents.body.wrapper,
        row: virtualComponents === null || virtualComponents === void 0 ? void 0 : virtualComponents.body.row
      },
      table: virtualComponents === null || virtualComponents === void 0 ? void 0 : virtualComponents.table
    },
    pagination: isScrolled ? false : {
      showSizeChanger: true,
      showQuickJumper: true,
      pageSizeOptions: ['30', '100', '300', '500'],
      pageSize: tableParamsRef.current.pageSize,
      total: tableParamsRef.current.total,
      current: tableParamsRef.current.current,
      showTotal: total => /*#__PURE__*/react.createElement("div", null, rowSelectCallback && /*#__PURE__*/react.createElement("span", {
        className: "mRight16"
      }, "\u5DF2\u9009\u62E9\uFF1A", /*#__PURE__*/react.createElement(tag/* default */.Z, {
        color: "volcano"
      }, selectedRowKeys.length), "\u6761"), "\u5171 ", total, " \u6761")
    }
  })))));
}

/* harmony default export */ var components_EnhanceTable = (EnhanceTable);

/***/ }),

/***/ 14845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_EnhanceTable; }
});

// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/antd/es/select/style/index.js
var style = __webpack_require__(43358);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js
var es_select = __webpack_require__(34041);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/antd/es/input/style/index.js
var input_style = __webpack_require__(47673);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 3 modules
var input = __webpack_require__(4107);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(93224);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/.umi-production/core/umiExports.ts + 18 modules
var umiExports = __webpack_require__(71720);
// EXTERNAL MODULE: ./node_modules/antd/es/table/index.js + 45 modules
var table = __webpack_require__(97423);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 12 modules
var es_form = __webpack_require__(35845);
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
;// CONCATENATED MODULE: ./src/components/EnhanceTable/hooks.ts


/**
 * EnhanceTable 支持快捷键移动光标
 */

/**
 * 上下键移动光标
 */

function useUpDownForInput() {
  var _useState = (0,react.useState)(),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      container = _useState2[0],
      setContainer = _useState2[1];

  var tableWrapKeydown = ev => {
    if (![38, 40].includes(ev.keyCode)) return;
    ev.preventDefault(); // 阻止光标跑到开头

    var className = Array.from(ev.target.classList).find(c => /input-\w+-row\d+$/.test(c));
    if (!className) return;
    var rowIdx = +className.replace(/input-\w+-row/, '');

    if (ev.keyCode === 38) {
      // up
      rowIdx = rowIdx - 1;
    } else if (ev.keyCode === 40) {
      // down
      rowIdx = rowIdx + 1;
    }

    className = className.replace(/(input-\w+-row)\d+/, "$1".concat(rowIdx));
    var oInput = ev.currentTarget.getElementsByClassName(className)[0];

    if (oInput instanceof HTMLInputElement) {
      setTimeout(() => {
        oInput.focus();
      }, 19);
    }
  };

  (0,react.useEffect)(() => {
    if (!(container instanceof HTMLElement)) return;
    container.addEventListener('keydown', tableWrapKeydown);
    return () => {
      container.removeEventListener('keydown', tableWrapKeydown);
    };
  }, [container]);
  return [setContainer];
}
/**
 * 滑动加载
 */

function useScrollLoad() {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bool => {};

  var _useState3 = (0,react.useState)(),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      container = _useState4[0],
      setContainer = _useState4[1];

  var ref_state = (0,react.useRef)(false);
  var ref_last = (0,react.useRef)(ref_state.current);

  var tableBodyDivScroll = ev => {
    var bodyDivRect = ev.target.getBoundingClientRect();
    var tableRect = ev.target.getElementsByTagName('table')[0].getBoundingClientRect();
    var scrollBarHeight = 7; // global.less 中设置的滚动条厚度 7px

    var THRESHOLD = 34; // 触发阈值 (row高度)

    ref_state.current = tableRect.bottom + scrollBarHeight - bodyDivRect.bottom < THRESHOLD;

    if (ref_state.current !== ref_last.current) {
      callback(ref_last.current = ref_state.current); // console.log(ref_last.current ? '触底' : '离开')
    }
  };

  (0,react.useEffect)(() => {
    var destroy = () => {};

    if (!(container instanceof HTMLElement)) return;
    var tableContainer = container.getElementsByClassName('ant-table-container')[0];
    if (!(tableContainer instanceof HTMLElement)) return;
    var handle = new MutationObserver(function () {
      var tableBody = container.getElementsByClassName('ant-table-body')[0];
      if (!(tableBody instanceof HTMLElement)) return;
      tableBody.addEventListener('scroll', tableBodyDivScroll);

      destroy = () => {
        handle.disconnect();
        tableBody.removeEventListener('scroll', tableBodyDivScroll);
      };
    });
    handle.observe(tableContainer, {
      childList: true,
      subtree: true
    });
    return destroy;
  }, [container]);
  return [setContainer];
}

/**
 * 计算 scroll: y 值
 */
function useCalcScrollY() {
  var arg0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useState5 = (0,react.useState)(350),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      scrollY = _useState6[0],
      setScrollY = _useState6[1];

  var _useState7 = (0,react.useState)(),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      container = _useState8[0],
      setContainer = _useState8[1];

  var setScrollYHandle = () => {
    var _arg0$top, _arg0$bottom;

    var clientHeight = document.body.clientHeight;
    var top = container.getBoundingClientRect().top;
    var TOP_DIST = (_arg0$top = arg0.top) !== null && _arg0$top !== void 0 ? _arg0$top : 50; // 上边距

    var BOTTOM_DIST = (_arg0$bottom = arg0.bottom) !== null && _arg0$bottom !== void 0 ? _arg0$bottom : 40; // 下边距

    var y = clientHeight - top - TOP_DIST - BOTTOM_DIST;
    if (y === scrollY) return;
    setScrollY(Math.max(y, 200)); // 最小 200
  };

  (0,react.useEffect)(() => {
    if (!(container instanceof HTMLElement)) return;
    setScrollYHandle();

    var destroy = () => {};

    var formBuilder = document.getElementsByClassName('formBuilder')[0];
    if (!(formBuilder instanceof HTMLElement)) return;
    var handle = new MutationObserver(setScrollYHandle);
    handle.observe(formBuilder, {
      childList: true,
      subtree: true,
      attributes: true
    });

    destroy = () => {
      handle.disconnect();
    };

    return destroy;
  }, [container]);
  return {
    scrollY,
    setContainer
  };
}
// EXTERNAL MODULE: ./src/components/EnhanceTable/index.less?modules
var EnhanceTablemodules = __webpack_require__(49572);
var EnhanceTablemodules_default = /*#__PURE__*/__webpack_require__.n(EnhanceTablemodules);
// EXTERNAL MODULE: ./src/utils/fetchQuery/index.tsx
var fetchQuery = __webpack_require__(48344);
;// CONCATENATED MODULE: ./src/components/EnhanceTable/index.tsx










var _excluded = ["index"],
    _excluded2 = ["column", "children", "record", "rowIndex"],
    _excluded3 = ["className", "style", "columns", "pagination", "dataSource", "query", "scrollable", "scrollOffset", "beforeLoad", "afterLoad", "onDataSourceChange", "onChange", "scroll", "rowSelection"];

/**
 * scroll.tsx 是 YPSHOP 定制版
 */








var EditableContext = /*#__PURE__*/react.createContext(null); // 覆写 tr

var EditableRow = _ref => {
  var index = _ref.index,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _Form$useForm = es_form/* default.useForm */.Z.useForm(),
      _Form$useForm2 = (0,slicedToArray/* default */.Z)(_Form$useForm, 1),
      form = _Form$useForm2[0];

  return /*#__PURE__*/react.createElement(es_form/* default */.Z, {
    form: form,
    component: false
  }, /*#__PURE__*/react.createElement(EditableContext.Provider, {
    value: form
  }, /*#__PURE__*/react.createElement("tr", props)));
}; // 覆写 td


var EditableCell = props => {
  var _props$column = props.column,
      column = _props$column === void 0 ? {} : _props$column,
      children = props.children,
      record = props.record,
      rowIndex = props.rowIndex,
      ommited = (0,objectWithoutProperties/* default */.Z)(props, _excluded2); // 只有 editable 才会有 column，把所有东西放 column 里面维护清晰


  var editable = column.editable,
      dataIndex = column.dataIndex,
      options = column.options,
      type = column.type,
      onCellChange = column.onCellChange,
      disabled = column.disabled,
      FormItem = column.FormItem,
      render = column.render,
      dropdownVisibleChange = column.dropdownVisibleChange;
  var form = (0,react.useContext)(EditableContext);

  if (editable) {
    try {
      form.setFieldsValue({
        [dataIndex]: record[dataIndex]
      }); // 初始化数据同步到 Form 中
    } catch (error) {
      console.warn(error);
    }
  }

  var save = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(e) {
      var value;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              value = form.getFieldsValue()[dataIndex]; // 保留一份原始数据，做判断用

              if (record["".concat(dataIndex, "_old")] === undefined) {
                record["".concat(dataIndex, "_old")] = record[dataIndex];
              } // 数据同步到编辑行


              record[dataIndex] = value;

              if (onCellChange instanceof Function) {
                try {
                  onCellChange({
                    value,
                    form,
                    dataIndex,
                    record,
                    rowIndex,
                    keyCode: e === null || e === void 0 ? void 0 : e.keyCode,
                    type: type !== null && type !== void 0 ? type : 'INPUT' // 默认 Input

                  });
                } catch (error) {
                  console.warn(error);
                }
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function save(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var childNode = children;
  var _editable = editable;

  if (editable instanceof Function) {
    try {
      _editable = editable(record[dataIndex], record, rowIndex);
    } catch (error) {
      _editable = false;
      console.warn('editable 调用报错:\n', error);
    }
  }

  if (_editable) {
    var _options = options;

    var _type = type !== null && type !== void 0 ? type : 'INPUT'; // 默认 Input


    if (options instanceof Function) {
      try {
        _options = options(record[dataIndex], record, rowIndex);
      } catch (error) {
        _options = [];
        console.warn('options 调用报错:\n', error);
      }
    }

    var _disabled = disabled;

    if (disabled instanceof Function) {
      try {
        _disabled = disabled(record[dataIndex], record, rowIndex);
      } catch (error) {
        _disabled = false;
        console.warn('disabled 调用报错:\n', error);
      }
    }

    if (!type) {
      if (Array.isArray(_options)) _type = 'SELECT'; // 有 options，没 type 认为是 Select
    }

    if (_type === 'INPUT') {
      childNode = /*#__PURE__*/react.createElement(es_form/* default.Item */.Z.Item, (0,esm_extends/* default */.Z)({
        name: dataIndex,
        initialValue: record[dataIndex]
        /* getValueFromEvent={arg0 => {
        if (FormItem && (FormItem as FormItemProps).getValueFromEvent instanceof Function) {
          // 扩展属性
          arg0.external = { form, value: arg0.target.value, record, dataIndex, rowIndex }
          return FormItem.getValueFromEvent(arg0)
        }
        return arg0.target.value
        }} */

      }, FormItem), /*#__PURE__*/react.createElement(input/* default */.Z, {
        disabled: _disabled,
        id: dataIndex + rowIndex,
        onPressEnter: ev => ev.target.blur(),
        onBlur: save,
        autoComplete: "off",
        className: "input-".concat(dataIndex, "-row").concat(rowIndex)
      }));
    } else if (_type === 'SELECT') {
      childNode = /*#__PURE__*/react.createElement(es_form/* default.Item */.Z.Item, (0,esm_extends/* default */.Z)({
        name: dataIndex,
        initialValue: record[dataIndex]
      }, FormItem), /*#__PURE__*/react.createElement(es_select/* default */.Z, {
        allowClear: true,
        disabled: _disabled,
        onChange: save,
        className: "select-".concat(dataIndex, "-row").concat(rowIndex),
        dropdownMatchSelectWidth: false,
        onDropdownVisibleChange: v => dropdownVisibleChange && dropdownVisibleChange(v, record)
      }, _options.map(_ref3 => {
        var label = _ref3.label,
            value = _ref3.value;
        return /*#__PURE__*/react.createElement(es_select/* default.Option */.Z.Option, {
          key: value,
          value: value
        }, label);
      })));
    }
  } // return <td {...ommited}>{render instanceof Function ? render(childNode, record, rowIndex) : childNode}</td>


  return /*#__PURE__*/react.createElement("td", ommited, _editable && render instanceof Function ? render(childNode, record, rowIndex) : childNode);
};
/**
 * 自定义表格
 * @param props 基于表格属性扩展了一增强
 */


function EnhanceTable(props, // ref: React.MutableRefObject<RefType<RecordType>>
ref) {
  var _query$auto, _columns$filter;

  var className = props.className,
      style = props.style,
      columns = props.columns,
      pagination = props.pagination,
      data = props.dataSource,
      query = props.query,
      _props$scrollable = props.scrollable,
      scrollable = _props$scrollable === void 0 ? false : _props$scrollable,
      _props$scrollOffset = props.scrollOffset,
      scrollOffset = _props$scrollOffset === void 0 ? {} : _props$scrollOffset,
      beforeLoad = props.beforeLoad,
      afterLoad = props.afterLoad,
      onDataSourceChange = props.onDataSourceChange,
      onChange = props.onChange,
      scroll = props.scroll,
      _props$rowSelection = props.rowSelection,
      rowSelection = _props$rowSelection === void 0 ? {} : _props$rowSelection,
      ommited = (0,objectWithoutProperties/* default */.Z)(props, _excluded3);

  var ref_tableWrap = (0,react.useRef)();
  var ref_auto = (0,react.useRef)((_query$auto = query === null || query === void 0 ? void 0 : query.auto) !== null && _query$auto !== void 0 ? _query$auto : true);
  var ref_isDidMount = (0,react.useRef)(false); // 是否是 componentDidMount

  var ref_page = (0,react.useRef)((0,objectSpread2/* default */.Z)({
    current: 1,
    pageSize: 30,
    total: 0
  }, pagination ? pagination : undefined));
  var ref_timer = (0,react.useRef)();
  var ref_result = (0,react.useRef)({});

  var _useState = (0,react.useState)(data),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      dataSource = _useState2[0],
      setDataSource = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      total = _useState4[0],
      setTotal = _useState4[1];

  var _useState5 = (0,react.useState)(),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      _params = _useState6[0],
      set_params = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var _useState9 = (0,react.useState)([]),
      _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
      changArgs = _useState10[0],
      setChangArgs = _useState10[1];

  var _useUpDownForInput = useUpDownForInput(),
      _useUpDownForInput2 = (0,slicedToArray/* default */.Z)(_useUpDownForInput, 1),
      setInputEventContainer = _useUpDownForInput2[0];

  var _useScrollLoad = useScrollLoad(bool => {
    if (bool) {
      if (ref_result.current.isEnd) return;
      ref_page.current = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, ref_page.current), {}, {
        current: ref_page.current.current + 1
      });
      set_params((0,objectSpread2/* default */.Z)({}, _params));
    }
  }),
      _useScrollLoad2 = (0,slicedToArray/* default */.Z)(_useScrollLoad, 1),
      setScrollEventContainer = _useScrollLoad2[0];

  var _useCalcScrollY = useCalcScrollY(scrollOffset),
      scrollY = _useCalcScrollY.scrollY,
      setCalcScrollYContainer = _useCalcScrollY.setContainer;

  var formCacheKey = "".concat(location.pathname, "-pagination");
  var formCache = (0,umiExports/* useSelector */.v9)(state => state.formCache);
  var dispatch = (0,umiExports/* useDispatch */.I0)();

  var tableProps = (0,objectSpread2/* default */.Z)({
    size: 'small',
    columns: columns === null || columns === void 0 ? void 0 : (_columns$filter = columns.filter(col => col.show === undefined ? true : col.show)) === null || _columns$filter === void 0 ? void 0 : _columns$filter.map(column => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, column), {}, {
      onCell: (record, rowIndex) => ({
        // EditableCell: props
        record,
        rowIndex,
        column
      })
    })),
    // dataSource 扩展 className
    onRow: (record, index) => ({
      record,
      index,
      className: record.className
    }),
    components: {
      body: {
        row: EditableRow,
        cell: EditableCell
      }
    },
    pagination: function () {
      if (scrollable) return false;
      if (pagination === false) return false;

      var page = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
        size: 'small',
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['30', '100', '300', '500'],
        // ['10', '30', '50', '100'],
        showTotal: total => {
          var _ref4 = rowSelection || {},
              _ref4$selectedRowKeys = _ref4.selectedRowKeys,
              selectedRowKeys = _ref4$selectedRowKeys === void 0 ? [] : _ref4$selectedRowKeys;

          return /*#__PURE__*/react.createElement("div", null, selectedRowKeys.length ? /*#__PURE__*/react.createElement("span", {
            style: {
              color: 'red',
              marginRight: 10
            }
          }, "\u5DF2\u52FE\u9009", selectedRowKeys.length, "\u6761") : null, /*#__PURE__*/react.createElement("span", null, "\u5171\u8BA1", total, "\u6761\u6570\u636E"));
        }
      }, ref_page.current), {}, {
        // ...(formCache[formCacheKey] || {}), 20-12-14 去掉页码缓存，有 BUG
        total
      });

      return page;
    }(),

    onChange(pagination, filters, sorter, extra) {
      // pagination 为 false 时这里得到 {}
      if (onChange instanceof Function) onChange(pagination, filters, sorter, extra); // 外部传入的 onChange

      setChangArgs([pagination, filters, sorter, extra]);
      ref_page.current = pagination; // 20-12-14 去掉页码缓存，有 BUG
      // dispatch({
      //   type: 'formCache/save',
      //   payload: {
      //     [formCacheKey]: pagination
      //   }
      // })

      set_params((0,objectSpread2/* default */.Z)({}, _params)); // 重新发起请求
    },

    loading,
    dataSource,
    rowKey: (_, i) => String(i),
    locale: {
      emptyText: '暂无数据'
    },
    scroll: (0,objectSpread2/* default */.Z)({
      y: scrollY
    }, scroll),
    rowSelection
  }, ommited); // 加载前干点啥


  var _beforeLoad = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(url, params) {
      var params2;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params2 = params;

              if (!(beforeLoad instanceof Function)) {
                _context2.next = 5;
                break;
              }

              _context2.next = 4;
              return beforeLoad({
                url,
                params,
                changArgs
              });

            case 4:
              params2 = _context2.sent;

            case 5:
              if (params2) {
                setLoading(true);
              }

              return _context2.abrupt("return", [params2]);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function _beforeLoad(_x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }(); // 加载后干点啥


  var _afterLoad = res => {
    var _res = res;
    setLoading(false);

    if (afterLoad instanceof Function) {
      try {
        var _afterLoad2;

        // 交给调用处格式化数据
        _res = (_afterLoad2 = afterLoad(res)) !== null && _afterLoad2 !== void 0 ? _afterLoad2 : res;
      } catch (error) {
        console.warn('调用处格式化数据 formatResult\n', error);
      }
    }

    return [_res]; // 考虑到后面可能多返回值
  };

  var queryHandle = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3() {
      var pagination,
          current,
          pageSize,
          total,
          _ref7,
          url,
          params,
          _yield$_beforeLoad,
          _yield$_beforeLoad2,
          params2,
          res,
          r,
          _afterLoad3,
          _afterLoad4,
          res2,
          success,
          result,
          _ref8,
          isEnd,
          _result$total,
          _total,
          l,
          d,
          list,
          _args3 = arguments;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              pagination = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : formCache[formCacheKey] || ref_page.current;
              current = pagination.current, pageSize = pagination.pageSize, total = pagination.total;
              _ref7 = query !== null && query !== void 0 ? query : {}, url = _ref7.url, params = _ref7.params;

              if (!url) {
                _context3.next = 25;
                break;
              }

              _context3.next = 6;
              return _beforeLoad(url, params);

            case 6:
              _yield$_beforeLoad = _context3.sent;
              _yield$_beforeLoad2 = (0,slicedToArray/* default */.Z)(_yield$_beforeLoad, 1);
              params2 = _yield$_beforeLoad2[0];

              if (!(params2 === false)) {
                _context3.next = 11;
                break;
              }

              return _context3.abrupt("return");

            case 11:
              res = null;

              if (!url.startsWith('/')) {
                _context3.next = 19;
                break;
              }

              _context3.next = 15;
              return (0,fetchQuery/* default */.Z)(url, 'POST', (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, pagination ? {
                page: current,
                size: pageSize
              } : undefined), params2));

            case 15:
              r = _context3.sent;
              res = r.result;
              _context3.next = 22;
              break;

            case 19:
              _context3.next = 21;
              return (0,ypRequest/* default */.Z)(url, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, pagination ? {
                page: current,
                size: pageSize
              } : undefined), params2));

            case 21:
              res = _context3.sent;

            case 22:
              _afterLoad3 = _afterLoad(res), _afterLoad4 = (0,slicedToArray/* default */.Z)(_afterLoad3, 1), res2 = _afterLoad4[0];
              success = res2.success, result = res2.result;

              if (success) {
                isEnd = result.isEnd, _result$total = result.total, _total = _result$total === void 0 ? 0 : _result$total, l = result.list, d = result.data;
                list = (_ref8 = d !== null && d !== void 0 ? d : l) !== null && _ref8 !== void 0 ? _ref8 : [];
                ref_result.current = (0,objectSpread2/* default */.Z)({
                  isEnd: list.length < ref_page.current.pageSize
                }, result);

                if (Array.isArray(list)) {
                  setDataSource(scrollable && ref_page.current.current > 1 ? [...(dataSource !== null && dataSource !== void 0 ? dataSource : []), ...list] : list);
                  setTotal(ref_page.current.total = +_total);
                }
              }

            case 25:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function queryHandle() {
      return _ref6.apply(this, arguments);
    };
  }();

  (0,react.useImperativeHandle)(ref, () => ({
    dataSource,
    pagination: ref_page.current,
    reload: queryHandle
  }), [dataSource, ref_page.current]);
  (0,react.useEffect)(() => {
    if (!ref_auto.current) return; // 打断自动请求

    set_params((0,objectSpread2/* default */.Z)({}, query === null || query === void 0 ? void 0 : query.params));
    ref_page.current.current = 1; // 回到第一页
  }, [query === null || query === void 0 ? void 0 : query.params]);
  (0,react.useEffect)(() => {
    if (!ref_isDidMount.current) return; // 避开第一次自动执行

    if (ref_timer.current) clearTimeout(ref_timer.current);
    ref_timer.current = setTimeout(() => {
      queryHandle();
    }, 200);
  }, [_params]); // 外部回填 dataSource

  (0,react.useEffect)(() => {
    if (ref_isDidMount.current) setDataSource(data);
  }, [data]); // dataSource 刷新事件

  (0,react.useEffect)(() => {
    if (onDataSourceChange instanceof Function) onDataSourceChange(dataSource);
  }, [dataSource]); // 这个当 componentDidMount 用，放在最后面

  (0,react.useEffect)(() => {
    ref_isDidMount.current = true;
    ref_auto.current = true; // 第一次运行后，将请求开放

    setInputEventContainer(ref_tableWrap.current);
    if (scrollable) setScrollEventContainer(ref_tableWrap.current);
    if (!(scroll !== null && scroll !== void 0 && scroll.y)) setCalcScrollYContainer(ref_tableWrap.current);
  }, []);
  return /*#__PURE__*/react.createElement("div", {
    className: [className, (EnhanceTablemodules_default()).tableWrap].join(' '),
    style: style,
    ref: ref_tableWrap
  }, /*#__PURE__*/react.createElement(table/* default */.Z, tableProps));
}

/* harmony default export */ var components_EnhanceTable = (/*#__PURE__*/react.forwardRef(EnhanceTable));

/***/ }),

/***/ 42891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31097);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





function Exception(props) {
  var _props$labelName = props.labelName,
      labelName = _props$labelName === void 0 ? '价格异常' : _props$labelName,
      exceptionPriceCount = props.exceptionPriceCount,
      sortCallback = props.sortCallback; // 是否升序

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState, 2),
      isAsc = _useState2[0],
      setIsAsc = _useState2[1];
  /**
   * 根据价格异常排序
   */


  var handleSort = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(() => {
    setIsAsc(v => !v);
    sortCallback(!isAsc, 'exceptionPrice');
  }, [isAsc, sortCallback]);

  if (!exceptionPriceCount) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null);
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, "\u2003", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    title: isAsc ? '降序' : '升序'
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("a", {
    style: {
      color: 'red'
    },
    onClick: handleSort
  }, labelName, "\uFF1A", exceptionPriceCount ? "".concat(exceptionPriceCount) : '-')));
}

/* harmony default export */ __webpack_exports__["Z"] = (Exception);

/***/ }),

/***/ 83769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ ExportType; }
/* harmony export */ });
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57016);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71577);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48086);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _CommonTable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40934);







/**
 * 查看导出结果浮层
 */


var ExportType;

(function (ExportType) {
  ExportType[ExportType["\u91C7\u8D2D\u5355\u5546\u54C1\u5BFC\u51FA"] = 1] = "\u91C7\u8D2D\u5355\u5546\u54C1\u5BFC\u51FA";
  ExportType[ExportType["\u91C7\u8D2D\u5355\u5355\u4E2A\u5BFC\u51FA"] = 2] = "\u91C7\u8D2D\u5355\u5355\u4E2A\u5BFC\u51FA";
  ExportType[ExportType["\u8C03\u62E8\u5355\u5BFC\u51FA"] = 3] = "\u8C03\u62E8\u5355\u5BFC\u51FA";
  ExportType[ExportType["\u96C6\u5355\u5546\u54C1\u5BFC\u51FA"] = 4] = "\u96C6\u5355\u5546\u54C1\u5BFC\u51FA";
  ExportType[ExportType["\u96C6\u5355\u672A\u4E0B\u5355\u95E8\u5E97\u5BFC\u51FA"] = 5] = "\u96C6\u5355\u672A\u4E0B\u5355\u95E8\u5E97\u5BFC\u51FA";
  ExportType[ExportType["\u96C6\u5355\u5931\u8D25\u660E\u7EC6\u5BFC\u51FA"] = 6] = "\u96C6\u5355\u5931\u8D25\u660E\u7EC6\u5BFC\u51FA";
  ExportType[ExportType["\u91C7\u8D2D\u5355\u4EF7\u683C\u6A21\u677F\u5BFC\u51FA"] = 7] = "\u91C7\u8D2D\u5355\u4EF7\u683C\u6A21\u677F\u5BFC\u51FA";
  ExportType[ExportType["\u91C7\u8D2D\u5355\u5408\u5E76\u5BFC\u51FA"] = 8] = "\u91C7\u8D2D\u5355\u5408\u5E76\u5BFC\u51FA";
  ExportType[ExportType["\u96C6\u5355\u5206\u62E8\u6253\u5370\u5BFC\u51FA"] = 9] = "\u96C6\u5355\u5206\u62E8\u6253\u5370\u5BFC\u51FA";
  ExportType[ExportType["\u5FEB\u6D88\u96C6\u5355\u5BFC\u51FA"] = 12] = "\u5FEB\u6D88\u96C6\u5355\u5BFC\u51FA";
  ExportType[ExportType["\u8865\u8D27\u5355\u5BFC\u51FA"] = 13] = "\u8865\u8D27\u5355\u5BFC\u51FA";
  ExportType[ExportType["\u751F\u9C9C\u81EA\u52A8\u8865\u8D27\u65E5\u8BA1\u5212\u7F16\u8F91\u9875\u5BFC\u51FA"] = 17] = "\u751F\u9C9C\u81EA\u52A8\u8865\u8D27\u65E5\u8BA1\u5212\u7F16\u8F91\u9875\u5BFC\u51FA";
  ExportType[ExportType["\u8C03\u62E8\u51FA\u5165\u5E93\u660E\u7EC6\u5BFC\u51FA\u4E1A\u52A1"] = 11] = "\u8C03\u62E8\u51FA\u5165\u5E93\u660E\u7EC6\u5BFC\u51FA\u4E1A\u52A1";
  ExportType[ExportType["\u91C7\u8D2D\u660E\u7EC6\u4FE1\u606F\u5BFC\u51FA"] = 20] = "\u91C7\u8D2D\u660E\u7EC6\u4FE1\u606F\u5BFC\u51FA";
  ExportType[ExportType["\u8425\u9500\u6D3B\u52A8\u5BFC\u51FA"] = 26] = "\u8425\u9500\u6D3B\u52A8\u5BFC\u51FA";
  ExportType[ExportType["\u8425\u9500\u6D3B\u52A8\u5546\u54C1\u5BFC\u51FA"] = 27] = "\u8425\u9500\u6D3B\u52A8\u5546\u54C1\u5BFC\u51FA";
})(ExportType || (ExportType = {}));

function ExportModal(props) {
  var _props$businessType;

  var queryDataUrl = props.queryDataUrl,
      businessType = props.businessType,
      closeModalCallback = props.closeModalCallback,
      _props$visible = props.visible,
      visible = _props$visible === void 0 ? true : _props$visible;
  var table = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
  var searchParams = {
    businessType: (_props$businessType = props.businessType) !== null && _props$businessType !== void 0 ? _props$businessType : ExportType.采购单单个导出
  };

  var downloadFile = url => {
    if (!url) {
      antd_es_message__WEBPACK_IMPORTED_MODULE_5__.default.error('不存在文件');

      return;
    }

    window.location.href = url;
  };

  var reloadTable = () => {
    table.current.reflashTable({
      businessType
    });
  };

  var columns = [{
    title: '文件名称',
    dataIndex: 'fileName',
    key: 'fileName',
    width: 160
  }, {
    title: '导出时间',
    dataIndex: 'exportTime',
    key: 'exportTime',
    width: 140
  }, {
    title: '状态',
    dataIndex: 'statusName',
    key: 'statusName',
    width: 100
  }, {
    title: '操作人',
    dataIndex: 'creator',
    key: 'creator',
    width: 120
  }, {
    title: '操作',
    dataIndex: 'operateeee',
    key: 'operateeee',
    width: 100,
    render: (_, r) => {
      return r.status === 8 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("a", {
        onClick: () => downloadFile(r.downloadUrl)
      }, "\u4E0B\u8F7D") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("a", {
        onClick: reloadTable
      }, "\u5237\u65B0");
    }
  }];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    title: "\u67E5\u770B\u5BFC\u51FA\u7ED3\u679C",
    destroyOnClose: true,
    maskClosable: false,
    width: 800,
    visible: visible,
    onOk: closeModalCallback,
    onCancel: closeModalCallback,
    footer: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
      onClick: closeModalCallback
    }, "\u5173\u95ED")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_CommonTable__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    ref: table,
    searchParams: searchParams,
    columns: columns,
    queryDataUrl: queryDataUrl || 'purchase.export.getExportTaskList'
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (ExportModal);

/***/ }),

/***/ 34070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71577);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20924);
/* harmony import */ var _components_CommonTable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40934);






/**
 * 详情页面的头部文案的布局展示
 */






var ExportOffline = props => {
  // const {} = props
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var openFunc = () => {
    console.log(1234);
  };

  var onOkFunc = () => {
    console.log('onOkFunc');
  };

  var onCancelFunc = () => {
    setVisible(false);
  };

  var openModal = () => {
    setVisible(true);
  };

  var columns = [{
    title: '文件名称',
    dataIndex: 'sCode',
    key: 'sCode',
    width: 100
  }, {
    title: '导出时间',
    dataIndex: 'CreateTime',
    key: 'CreateTime',
    width: 130
  }, {
    title: '操作人',
    dataIndex: 'status',
    key: 'status',
    width: 130
  }, {
    title: '状态',
    dataIndex: 'status2',
    key: 'status2',
    width: 130,
    render: record => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, "\u72B6\u6001")
  }, {
    title: '操作',
    key: 'operation',
    width: 60,
    render: record => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('curblue'),
      onClick: () => {
        console.log(12);
      }
    }, "\u4E0B\u8F7D"))
  }];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('exportOfferLineWrap')
  }, visible ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    visible: visible,
    footer: null,
    title: props.title || '导出列表',
    onOk: () => {
      onOkFunc();
    },
    onCancel: () => {
      onCancelFunc();
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_components_CommonTable__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z // canSelect={false}
  , {
    showAlert: false,
    columns: columns,
    queryDataUrl: "settlement.sheet.querySettlementSheets"
  })) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
    type: "primary",
    onClick: () => {
      openFunc();
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, null), "\u5BFC\u51FA"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
    style: {
      marginLeft: 20
    },
    onClick: () => {
      openModal();
    }
  }, "\u67E5\u770B\u5BFC\u51FA\u7ED3\u679C"));
};

/* harmony default export */ __webpack_exports__["Z"] = (ExportOffline);

/***/ }),

/***/ 92145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_upload_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43185);
/* harmony import */ var antd_es_upload__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3388);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91896);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71577);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2824);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(84391);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24731);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);














function FileUploader(props) {
  var _props$tokenUrl = props.tokenUrl,
      tokenUrl = _props$tokenUrl === void 0 ? 'mms.fileService.getUploadToken' : _props$tokenUrl,
      onChange = props.onChange,
      btnText = props.btnText,
      uploadOptions = props.uploadOptions;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState, 2),
      uploadParams = _useState2[0],
      setUploadParams = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState3, 2),
      endPoint = _useState4[0],
      setEndPoint = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState5, 2),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState7, 2),
      fileList = _useState8[0],
      setFileList = _useState8[1]; // 上传前  先获取 token


  var beforeUpload = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().mark(function _callee(file, fileList) {
      var args, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              args = {
                fileName: file === null || file === void 0 ? void 0 : file.name,
                bizType: 1 // 文件类型(0-图片小文件,1-大文件下载,2-视音频点播)

              };
              _context.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(tokenUrl, args);

            case 3:
              res = _context.sent;
              return _context.abrupt("return", new Promise((resolve, reject) => {
                var _res$result, _res$result2;

                setUploadParams(res.result.params);
                setEndPoint((_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.endPoint);
                file.resId = (_res$result2 = res.result) === null || _res$result2 === void 0 ? void 0 : _res$result2.resId;
                resolve(file);
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function beforeUpload(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleChange = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().mark(function _callee2(_ref2) {
      var file, fileList, _file$response, code, _message2;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref2.file, fileList = _ref2.fileList;

              if (!(file.status === 'uploading')) {
                _context2.next = 5;
                break;
              }

              setLoading(true);
              setFileList(fileList);
              return _context2.abrupt("return");

            case 5:
              if (!(file.status === 'error')) {
                _context2.next = 9;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_8__.default.error("\u3010".concat(file.name, "\u3011\u4E0A\u4F20\u5931\u8D25"));

              setLoading(false);
              return _context2.abrupt("return");

            case 9:
              if (!(file.status === 'done')) {
                _context2.next = 17;
                break;
              }

              setLoading(false);
              _file$response = file.response, code = _file$response.code, _message2 = _file$response.message; // 上传失败

              if (!(code !== 200)) {
                _context2.next = 15;
                break;
              }

              _message2.error(_message2);

              return _context2.abrupt("return");

            case 15:
              setFileList(fileList);

              if (onChange) {
                onChange(file.resId, _message2);
              }

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleChange(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_upload__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)({
    name: "files",
    accept: '.xlsx, .xls',
    action: endPoint,
    data: uploadParams,
    fileList: fileList,
    beforeUpload: beforeUpload,
    onChange: handleChange
  }, uploadOptions), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z, {
    loading: loading,
    disabled: loading || (uploadOptions === null || uploadOptions === void 0 ? void 0 : uploadOptions.disabled),
    type: "primary"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, null), " ", btnText ? btnText : '点击上传'));
}

/* harmony default export */ __webpack_exports__["Z"] = (FileUploader);

/***/ }),

/***/ 32065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5977);




/**
 * FixedBottomCps 底部固定DIV
 */



var val = 200; // + 16 + 16

function FixedBottomCps(props) {
  var outerRE = props.outerRE;
  var history = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .useHistory */ .k6)();
  var clientWidth = document.body.offsetWidth - val; // 除去left menu  width

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(clientWidth),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState, 2),
      curWidth = _useState2[0],
      setcurWidth = _useState2[1];

  var resizeFunc = () => {
    var w = document.body.offsetWidth - val;
    setcurWidth(w);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    window.addEventListener('resize', resizeFunc);
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    style: {
      padding: '20px'
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "bottom-fixed",
    style: {
      width: (props === null || props === void 0 ? void 0 : props.width) || curWidth,
      left: (props === null || props === void 0 ? void 0 : props.left) || '200px'
    }
  }, outerRE ? outerRE : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    onClick: () => {
      history.goBack();
    }
  }, "\u8FD4\u56DE")));
}

/* harmony default export */ __webpack_exports__["Z"] = (FixedBottomCps);

/***/ }),

/***/ 90280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var antd_es_table_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66456);
/* harmony import */ var antd_es_table__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97423);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);






var purchaseColumns = [{
  title: '商品编码',
  dataIndex: 'goodsId',
  width: 180
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  width: 180
}, {
  title: '批发单价(元)',
  dataIndex: 'unitPrice',
  width: 180
}, {
  title: '成本价(元)',
  dataIndex: 'costPrice'
}];
var transferColumns = [{
  title: '地点编码',
  dataIndex: 'placeCode',
  width: 180
}, {
  title: '商品编码',
  dataIndex: 'goodsId',
  width: 180
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  width: 180
}, {
  title: '批发单价(元)',
  dataIndex: 'unitPrice',
  width: 180
}, {
  title: '参考价(元)',
  dataIndex: 'costPrice'
}];
var allClms = {
  order: purchaseColumns,
  distribution: transferColumns
};

var SingleError = props => {
  var title = props.title,
      columns = props.columns,
      dataSource = props.dataSource;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    style: {
      marginBottom: '30px'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    style: {
      marginBottom: '8px'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
    style: {
      fontSize: '16px',
      color: '#333',
      fontWeight: 'bold'
    }
  }, title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
    style: {
      marginLeft: '30px'
    }
  }, "\u5171\u53D1\u73B0", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
    style: {
      color: 'red'
    }
  }, dataSource.length), "\u4E2A\u5546\u54C1\uFF0C", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
    style: {
      color: 'red'
    }
  }, "\u8BF7\u6838\u5BF9\u4EF7\u683C"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_table__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    scroll: {
      y: 400,
      x: 800
    },
    rowKey: e => e.goodsCode + e.shopCode,
    columns: columns,
    dataSource: dataSource,
    pagination: false
  }));
};

var FoolproofModal = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((props, ref) => {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState3, 2),
      errList = _useState4[0],
      setErrList = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState5, 2),
      confirmFunc = _useState6[0],
      setCF = _useState6[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useImperativeHandle)(ref, () => {
    return {
      check: check
    };
  });
  var renderTitle = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(() => {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", null, "\u76D1\u6D4B\u5F02\u5E38"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
      style: {
        marginLeft: '50px',
        color: 'red',
        fontSize: '14px'
      }
    }, "\u5171\u53D1\u73B0".concat(errList.length, "\u9879\u5F02\u5E38")));
  }, [errList]);

  var closeFunc = () => {
    setVisible(false);
    setErrList([]);
    setCF([]);
  };

  var confirm = () => {
    confirmFunc.length && confirmFunc[0]();
    closeFunc();
  };

  function check(res, callback) {
    // const checkErrorList = [{goodsName: 'dede', goodsCode: '1939232', price: '200', referencePrice: '3232',}]
    // const result = [{shopCode: '12323', shopName: '罗成超时', goodsName: 'dede', goodsCode: '1939232', price: '200', referencePrice: '3232',}]
    var _res$result = res.result,
        result = _res$result === void 0 ? [] : _res$result,
        _res$checkErrorList = res.checkErrorList,
        checkErrorList = _res$checkErrorList === void 0 ? [] : _res$checkErrorList,
        tableKey = res.tableKey;

    if (checkErrorList.length || result.length) {
      var foolList = [{
        key: tableKey,
        keyChinese: '批发价',
        datas: checkErrorList
      }, {
        key: 'distribution',
        keyChinese: '批发分配单',
        datas: result
      }];

      var _errList = foolList.map(u => ({
        title: "\u5B58\u5728".concat(u.keyChinese, ">1.5\u500D\u7684\u53C2\u8003\u5355\u4EF7"),
        columns: allClms[u.key] || [],
        dataSource: u.datas
      })).filter(e => e.dataSource && e.dataSource.length);

      setVisible(true);
      setErrList(_errList);
      setCF([callback]);
    }
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    title: renderTitle(),
    width: 1200,
    visible: visible,
    cancelText: "\u786E\u8BA4\u63D0\u4EA4",
    okText: "\u53BB\u6838\u5BF9",
    maskClosable: false,
    onCancel: confirm,
    onOk: closeFunc,
    closable: false
  }, errList.map(e => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(SingleError, {
    key: e.title,
    title: e.title,
    columns: e.columns,
    dataSource: e.dataSource
  })));
});
/* harmony default export */ __webpack_exports__["Z"] = (FoolproofModal);

/***/ }),

/***/ 5670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_FormBuilder; }
});

// NAMESPACE OBJECT: ./src/components/FormBuilder/components/Field.tsx
var Field_namespaceObject = {};
__webpack_require__.r(Field_namespaceObject);
__webpack_require__.d(Field_namespaceObject, {
  "BRAND": function() { return BRAND; },
  "CASCADER": function() { return CASCADER; },
  "CHECKBOX_GROUP": function() { return CHECKBOX_GROUP; },
  "CHECKBOX_GROUP_EXTRA": function() { return CHECKBOX_GROUP_EXTRA; },
  "DATE_PICKER": function() { return DATE_PICKER; },
  "INPUT": function() { return INPUT; },
  "INPUT_NUMBER": function() { return INPUT_NUMBER; },
  "RADIO": function() { return RADIO; },
  "RANGE_PICKER": function() { return RANGE_PICKER; },
  "RANGE_PICKER_SHORT": function() { return RANGE_PICKER_SHORT; },
  "SEARCH_BUTTON": function() { return SEARCH_BUTTON; },
  "SELECT": function() { return SELECT; },
  "SELECT_BIG_DATA": function() { return SELECT_BIG_DATA; },
  "TEXTAREA": function() { return TEXTAREA; },
  "TREESELECT": function() { return TREESELECT; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/row/style/index.js
var style = __webpack_require__(13062);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/style/index.js
var tooltip_style = __webpack_require__(22385);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 1 modules
var tooltip = __webpack_require__(31097);
// EXTERNAL MODULE: ./node_modules/antd/es/col/style/index.js
var col_style = __webpack_require__(89032);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/antd/es/form/style/index.js
var form_style = __webpack_require__(9715);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 12 modules
var es_form = __webpack_require__(35845);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/QuestionCircleOutlined.js + 1 modules
var QuestionCircleOutlined = __webpack_require__(1870);
// EXTERNAL MODULE: ./src/.umi-production/core/umiExports.ts + 18 modules
var umiExports = __webpack_require__(71720);
// EXTERNAL MODULE: ./node_modules/antd/es/tree-select/style/index.js
var tree_select_style = __webpack_require__(62999);
// EXTERNAL MODULE: ./node_modules/antd/es/tree-select/index.js + 40 modules
var tree_select = __webpack_require__(57119);
// EXTERNAL MODULE: ./node_modules/antd/es/cascader/style/index.js
var cascader_style = __webpack_require__(36877);
// EXTERNAL MODULE: ./node_modules/antd/es/cascader/index.js + 5 modules
var cascader = __webpack_require__(34366);
// EXTERNAL MODULE: ./node_modules/antd/es/checkbox/style/index.js
var checkbox_style = __webpack_require__(63185);
// EXTERNAL MODULE: ./node_modules/antd/es/checkbox/index.js + 2 modules
var es_checkbox = __webpack_require__(9676);
// EXTERNAL MODULE: ./node_modules/antd/es/input-number/style/index.js
var input_number_style = __webpack_require__(77883);
// EXTERNAL MODULE: ./node_modules/antd/es/input-number/index.js + 2 modules
var input_number = __webpack_require__(39635);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/style/index.js
var radio_style = __webpack_require__(88983);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js
var es_radio = __webpack_require__(55742);
// EXTERNAL MODULE: ./node_modules/antd/es/select/style/index.js
var select_style = __webpack_require__(43358);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js
var es_select = __webpack_require__(34041);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(93224);
// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var button_style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/input/style/index.js
var input_style = __webpack_require__(47673);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 3 modules
var input = __webpack_require__(4107);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/style/index.js
var date_picker_style = __webpack_require__(14965);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/index.js + 6 modules
var date_picker = __webpack_require__(11448);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/FormBuilder/components/Field.tsx

























var _excluded = ["label"],
    _excluded2 = ["value", "label"],
    _excluded3 = ["label"],
    _excluded4 = ["label"],
    _excluded5 = ["label"],
    _excluded6 = ["label"],
    _excluded7 = ["label"];



var RangePicker = date_picker/* default.RangePicker */.Z.RangePicker;
var TextArea = input/* default.TextArea */.Z.TextArea;
var SEARCH_BUTTON = (resetField, leftElement, btnElement) => {
  return /*#__PURE__*/react.createElement("div", {
    className: "optionBtns"
  }, /*#__PURE__*/react.createElement("div", {
    className: "ellipsis"
  }, leftElement), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    type: "primary",
    htmlType: "submit",
    className: classnames_default()('mRight10', {
      mLeft16: !!leftElement
    })
  }, "\u67E5\u8BE2"), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    onClick: resetField,
    className: "mRight10"
  }, "\u91CD\u7F6E"), btnElement ? btnElement : null);
};
var SELECT = (options, dataSource) => {
  var label = options.label,
      rest = (0,objectWithoutProperties/* default */.Z)(options, _excluded);

  var fieldOpts = (0,objectSpread2/* default */.Z)({
    virtual: true,
    allowClear: true,
    showSearch: true,
    filterOption: (input, option) => {
      var _option$children;

      return ((_option$children = option.children) === null || _option$children === void 0 ? void 0 : _option$children.toLowerCase().indexOf(input.toLowerCase())) >= 0;
    },
    placeholder: "\u8BF7\u9009\u62E9".concat(label),
    dropdownMatchSelectWidth: false
  }, rest);

  return /*#__PURE__*/react.createElement(es_select/* default */.Z, fieldOpts, dataSource && dataSource.map(val => {
    var value = val.value,
        label = val.label,
        ommit = (0,objectWithoutProperties/* default */.Z)(val, _excluded2);

    return /*#__PURE__*/react.createElement(es_select/* default.Option */.Z.Option, (0,esm_extends/* default */.Z)({
      key: value,
      value: value,
      rows: val
    }, ommit), label);
  }));
}; // 大数据下拉框

var SELECT_BIG_DATA = (options, dataSource) => {
  var label = options.label,
      rest = (0,objectWithoutProperties/* default */.Z)(options, _excluded3);

  var fieldOpts = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
    allowClear: true,
    showSearch: true,
    filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
    placeholder: "\u8BF7\u9009\u62E9".concat(label),
    dropdownMatchSelectWidth: false
  }, rest), {}, {
    options: dataSource
  });

  return /*#__PURE__*/react.createElement(es_select/* default */.Z, fieldOpts);
};
var INPUT = options => {
  var label = options.label,
      rest = (0,objectWithoutProperties/* default */.Z)(options, _excluded4);

  return /*#__PURE__*/react.createElement(input/* default */.Z, (0,esm_extends/* default */.Z)({
    placeholder: "\u8BF7\u8F93\u5165".concat(label),
    allowClear: true
  }, rest));
};
var TEXTAREA = options => {
  var label = options.label,
      rest = (0,objectWithoutProperties/* default */.Z)(options, _excluded5);

  return /*#__PURE__*/react.createElement(TextArea, (0,esm_extends/* default */.Z)({
    placeholder: "\u8BF7\u8F93\u5165".concat(label),
    allowClear: true,
    autoSize: true
  }, rest));
};
var RANGE_PICKER = options => {
  return /*#__PURE__*/react.createElement(RangePicker, (0,esm_extends/* default */.Z)({
    allowClear: true,
    style: {
      width: '100%'
    }
  }, options));
};
var DATE_PICKER = options => {
  return /*#__PURE__*/react.createElement(date_picker/* default */.Z, (0,esm_extends/* default */.Z)({
    style: {
      width: '100%'
    }
  }, options));
};
var RADIO = (options, dataSource) => {
  return /*#__PURE__*/react.createElement(es_radio/* default.Group */.ZP.Group, options, dataSource && dataSource.map((val, key) => {
    var _ref, _val$key;

    var optKey = (_ref = (_val$key = val.key) !== null && _val$key !== void 0 ? _val$key : val.value) !== null && _ref !== void 0 ? _ref : key;
    return /*#__PURE__*/react.createElement(es_radio/* default */.ZP, {
      value: optKey,
      key: optKey
    }, val.label);
  }));
};
var INPUT_NUMBER = options => {
  var label = options.label,
      rest = (0,objectWithoutProperties/* default */.Z)(options, _excluded6);

  return /*#__PURE__*/react.createElement(input_number/* default */.Z, (0,esm_extends/* default */.Z)({
    style: {
      width: '100%'
    }
  }, rest));
};
var CHECKBOX_GROUP = (options, dataSource) => {
  return /*#__PURE__*/react.createElement(es_checkbox/* default.Group */.Z.Group, null, /*#__PURE__*/react.createElement(row/* default */.Z, null, dataSource && dataSource.map((val, key) => {
    var _ref2, _val$key2;

    var optKey = (_ref2 = (_val$key2 = val.key) !== null && _val$key2 !== void 0 ? _val$key2 : val.value) !== null && _ref2 !== void 0 ? _ref2 : key;
    return /*#__PURE__*/react.createElement(col/* default */.Z, {
      key: optKey
    }, /*#__PURE__*/react.createElement(es_checkbox/* default */.Z, {
      value: optKey
    }, val.label));
  })));
};
var BRAND = (options, dataSource) => {
  return /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(es_checkbox/* default.Group */.Z.Group, null, /*#__PURE__*/react.createElement(row/* default */.Z, null, dataSource && dataSource.map((val, key) => {
    var _ref3, _val$key3;

    var optKey = (_ref3 = (_val$key3 = val.key) !== null && _val$key3 !== void 0 ? _val$key3 : val.value) !== null && _ref3 !== void 0 ? _ref3 : key;
    return /*#__PURE__*/react.createElement(col/* default */.Z, {
      key: optKey
    }, /*#__PURE__*/react.createElement(es_checkbox/* default */.Z, {
      value: optKey
    }, val.label));
  }))));
};
/**
 * 简短的日期范围选择组件
 */

var RANGE_PICKER_SHORT = options => {
  return /*#__PURE__*/react.createElement(RangePicker, (0,esm_extends/* default */.Z)({
    allowClear: true,
    style: {
      width: '100%'
    }
  }, options, {
    showTime: false,
    className: "shortPangePicker",
    suffixIcon: null
  }));
};
var CHECKBOX_GROUP_EXTRA = (options, dataSource) => {
  return /*#__PURE__*/react.createElement(es_checkbox/* default.Group */.Z.Group, options, /*#__PURE__*/react.createElement(row/* default */.Z, null, dataSource && dataSource.map(val => {
    return /*#__PURE__*/react.createElement(col/* default */.Z, {
      key: val.value
    }, /*#__PURE__*/react.createElement(es_checkbox/* default */.Z, {
      value: val.value
    }, val.label));
  })));
};
/**
 * 简短的日期范围选择组件
 */

var CASCADER = options => {
  return /*#__PURE__*/react.createElement(cascader/* default */.Z, (0,esm_extends/* default */.Z)({
    defaultValue: options === null || options === void 0 ? void 0 : options.defaultValue
  }, options));
};
/**
 * 树选择器
 * */

var TREESELECT = (options, dataSource) => {
  // console.log(dataSource,'树的渲染数据为什么没有渲染 treeDataSimpleMode',options)
  var label = options.label,
      rest = (0,objectWithoutProperties/* default */.Z)(options, _excluded7);

  var fieldOpts = (0,objectSpread2/* default */.Z)({
    placeholder: "\u8BF7\u9009\u62E9".concat(label),
    treeData: dataSource,
    filterTreeNode: (input, treeNode) => treeNode.title.toLowerCase().includes(input.toLowerCase())
  }, rest);

  return /*#__PURE__*/react.createElement(tree_select/* default */.Z, (0,esm_extends/* default */.Z)({}, fieldOpts, {
    showSearch: true
  }));
};
;// CONCATENATED MODULE: ./src/components/FormBuilder/useSliderBtn.tsx



/**
 * 搜索功能的Form表单 「收起展开」 功能
 */

var formfieldsLen = 3;

function useSliderBtn(formfields, notSearchForm) {
  var defaultExpand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isHiddenSliderBtn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var onExpand = arguments.length > 4 ? arguments[4] : undefined;

  // 整理出将可视的不可视的表单项
  var _useMemo = (0,react.useMemo)(() => {
    return formfields.reduce((pre, next) => {
      if (!next) {
        return pre;
      }

      if (next.hide) {
        pre.hiddenFields = pre.hiddenFields.concat(next);
      } else {
        pre.visibleFields = pre.visibleFields.concat(next);
      }

      return pre;
    }, {
      visibleFields: [],
      hiddenFields: []
    });
  }, [formfields]),
      visibleFields = _useMemo.visibleFields,
      hiddenFields = _useMemo.hiddenFields; // 将可视的不可视的表单项拼接


  var usefulFields = (0,react.useMemo)(() => visibleFields.concat(hiddenFields), [visibleFields, hiddenFields]); // 默认收起

  var _useState = (0,react.useState)(!defaultExpand),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      slideForm = _useState2[0],
      setSlideForm = _useState2[1];

  var _useState3 = (0,react.useState)(usefulFields),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      fields = _useState4[0],
      setFields = _useState4[1];

  var toggleForm = () => {
    setSlideForm(v => !v);
    onExpand && onExpand(slideForm);
  };

  (0,react.useEffect)(() => {
    if (slideForm && !notSearchForm) {
      var _usefulFields$reduce = usefulFields.reduce((pre, next, index) => {
        var hide = next.hide,
            _next$columns = next.columns,
            columns = _next$columns === void 0 ? 1 : _next$columns;

        if (hide) {
          pre.list = pre.list.concat(next);
        } else if (index < formfieldsLen) {
          pre.cols += columns;
          pre.list = pre.list.concat((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, next), {}, {
            hide: pre.cols > formfieldsLen
          }));
        } else {
          pre.list = pre.list.concat((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, next), {}, {
            hide: true
          }));
        }

        return pre;
      }, {
        cols: 0,
        list: []
      }),
          list = _usefulFields$reduce.list;

      setFields(list);
    } else {
      setFields(usefulFields);
    }
  }, [slideForm, usefulFields, notSearchForm]); // 如果表单项比较小设置默认值

  var btnElement = usefulFields.length <= formfieldsLen || isHiddenSliderBtn ? null : /*#__PURE__*/react.createElement("a", {
    key: "btn",
    style: {
      minWidth: '30px'
    },
    onClick: toggleForm
  }, slideForm ? '展开' : '收起');
  return [fields, btnElement];
}

/* harmony default export */ var FormBuilder_useSliderBtn = (useSliderBtn);
// EXTERNAL MODULE: ./node_modules/use-media-antd-query/es/index.js + 1 modules
var es = __webpack_require__(38069);
// EXTERNAL MODULE: ./src/hooks/useCompareEffect.ts
var useCompareEffect = __webpack_require__(19125);
;// CONCATENATED MODULE: ./src/components/FormBuilder/utils/layouts.ts
var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 8
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 16
    }
  }
}; // 垂直排布的form布局

var defaultVerticalLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 24
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 24
    }
  }
};
var defaultLayout = {
  horizontal: defaultFormItemLayout,
  vertical: defaultVerticalLayout,
  inline: defaultFormItemLayout
};
var normalColLayout = {
  xxl: 6,
  xl: 6,
  lg: 8,
  md: 12,
  sm: 24,
  xs: 24
}; // 占据一整行

var fullColLayout = {
  xxl: 24,
  xl: 24,
  lg: 24,
  md: 24,
  sm: 24,
  xs: 24
};
var oneColLayout = (/* unused pure expression or super */ null && (fullColLayout));
var twoColLayout = {
  xxl: 12,
  xl: 12,
  lg: 12,
  md: 12,
  sm: 24,
  xs: 24
};
var threeColLayout = {
  xxl: 8,
  xl: 8,
  lg: 8,
  md: 12,
  sm: 24,
  xs: 24
};
;// CONCATENATED MODULE: ./src/components/FormBuilder/utils/constance.ts
 // 要去除前后空格的组件

var trimWhitespaceFields = ['INPUT', 'INPUT_NUMBER', 'TEXT_AREA']; // 失去焦点才获取值的控件

var getValueInBlur = ['INPUT', 'INPUT_NUMBER', 'TEXT_AREA'];
var currentLayoutType = {
  // 1: oneColLayout,
  // 2: twoColLayout,
  // 3: threeColLayout,
  // 4: normalColLayout,
  default: normalColLayout
}; // 不同大小的表单项对应的文本表单控件占据的空间大小

var formItemLayoutType = {
  1: {
    labelCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 8
      }
    },
    wrapperCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 16
      }
    }
  },
  2: {
    labelCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 4
      }
    },
    wrapperCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 20
      }
    }
  },
  3: {
    labelCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 2
      }
    },
    wrapperCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 22
      }
    }
  },
  4: {
    labelCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 2
      }
    },
    wrapperCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 22
      }
    }
  }
};
;// CONCATENATED MODULE: ./src/components/FormBuilder/index.tsx














/**
 * 通用表单组件
 */











var FormItem = es_form/* default.Item */.Z.Item;
var Fields = Field_namespaceObject;
/**
 * 去除用户输入造成的前后空格
 * @param value 当前控件输入的值
 * @param element 用户传入的当前表单项的配置的属性
 */

function handleNormalize(value, type) {
  if (!type || !trimWhitespaceFields.includes(type)) {
    return value;
  }

  if (typeof value === 'number') {
    return value;
  }

  if (value) {
    return value.replace(/(^\s*)|(\s*$)/g, '');
  }
}

var FormBuilder = (props, ref) => {
  var _props$formOptions2;

  var _Form$useForm = es_form/* default.useForm */.Z.useForm(),
      _Form$useForm2 = (0,slicedToArray/* default */.Z)(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var propsElements = props.elements;
  var mediaSize = (0,es.default)(); // 根据传入的值，获取不同的布局栅格参数

  var layoutType = currentLayoutType.default; // 获取表单项list，以及搜索、重置按钮

  var _useSliderBtn = FormBuilder_useSliderBtn(propsElements, props.notSearchForm, props.defaultExpand, props.isHiddenSliderBtn, props.onExpand),
      _useSliderBtn2 = (0,slicedToArray/* default */.Z)(_useSliderBtn, 2),
      formfields = _useSliderBtn2[0],
      btnElement = _useSliderBtn2[1];

  var formCache = (0,umiExports/* useSelector */.v9)(state => {
    var _state$formCache;

    return (_state$formCache = state.formCache) === null || _state$formCache === void 0 ? void 0 : _state$formCache[location.pathname];
  });
  var dispatch = (0,umiExports/* useDispatch */.I0)(); // 表单验证完成

  var onFinish = values => {
    if (props.isCache) {
      dispatch({
        type: 'formCache/save',
        payload: {
          [location.pathname]: (0,objectSpread2/* default */.Z)({}, values)
        }
      });
    }

    if (props.callbackHandler) {
      props.callbackHandler('success', (0,objectSpread2/* default */.Z)({}, values));
    }
  }; // 表单验证失败


  var onFinishFailed = errorInfo => {
    if (props.callbackHandler) {
      props.callbackHandler('error', errorInfo);
    }
  }; // 重置表单


  var resetField = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
      var arr, objData, values;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              arr = propsElements.filter(ele => ele.reset === undefined ? true : ele.reset);
              form.resetFields(arr.map(e => e.name));
              objData = {};
              propsElements.map(ele => {
                objData[ele.name] = null;
              });
              form.setFieldsValue(props.resetByInitValue ? initialValues : objData);

              if (props.isCache) {
                dispatch({
                  type: 'formCache/save',
                  payload: {
                    [location.pathname]: {}
                  }
                });
              }

              if (!props.onReset) {
                _context.next = 11;
                break;
              }

              _context.next = 9;
              return form.validateFields();

            case 9:
              values = _context.sent;

              if (values) {
                props.onReset('success', (0,objectSpread2/* default */.Z)({}, values));
              }

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function resetField() {
      return _ref.apply(this, arguments);
    };
  }();

  var btnOffset = (0,react.useMemo)(() => {
    if (props.doNotCalculate) return 0;
    var span = layoutType[mediaSize]; // 计算一行展示多少个表单项

    var rowLength = 24 / span; // 当按钮存在左侧内容时

    if (props.leftElement) {
      var _offset = (rowLength - 1) * span;

      return _offset;
    } // 获取所有展示出来的表单项占据的栅格数


    var length = formfields.reduce((pre, next) => {
      var hide = next.hide,
          _next$columns = next.columns,
          columns = _next$columns === void 0 ? 1 : _next$columns;
      if (hide) return pre; // 当用户定义占据的栅格大于每行应该展示的表单项时，使用每行展示的表单项的值；避免造成栅格过多引起布局错乱

      var len = columns > rowLength ? rowLength : columns;
      return pre + len;
    }, 0); // 求余数，传入的表单项数量与每行展示的数量的余数；最后一行展示的数量

    var remainder = length % rowLength;
    var restLength = rowLength - remainder;
    var offset = remainder === 0 ? (rowLength - 1) * span : (restLength - 1) * span;
    return offset;
  }, [props.doNotCalculate, props.leftElement, layoutType, mediaSize, formfields]); // 表单排布，栅格布局渲染

  var renderLayout = (0,react.useCallback)(elements => {
    return elements.map((ele, key) => {
      var _ele$props = ele.props,
          name = _ele$props.name,
          style = _ele$props.style,
          hide = _ele$props.hide,
          _ele$props$columns = _ele$props.columns,
          columns = _ele$props$columns === void 0 ? 1 : _ele$props$columns;
      /**
       * 是否将本表单项设置为独占一行(row:24)的布局
       * 如果不是搜索表单且不是响应式表单，设置为每一项form占据一行
       */

      var shouldFull = props.notSearchForm && !props.responsed;
      var colLayout = {
        xxl: 6 * columns,
        xl: 6 * columns,
        lg: 6 * (columns * 8 / 6),
        md: columns > 1 ? 24 : 12,
        sm: 24,
        xs: 24
      }; // 是否占据一行展示

      if (shouldFull) {
        colLayout = fullColLayout;
      }

      var fieldStyle = {}; // 如果设置了 display:none，或设置了hide属性

      if (style && style.display === 'none' || hide === 'true') {
        fieldStyle = {
          display: 'none'
        };
      }

      return /*#__PURE__*/react.createElement(col/* default */.Z, (0,esm_extends/* default */.Z)({
        key: name + key
      }, colLayout, {
        style: fieldStyle,
        className: "col-item"
      }), ele);
    });
  }, [props.notSearchForm, props.responsed]); //  渲染表单项

  var renderElement = (0,react.useCallback)(element => {
    // Handle form item props
    var label = element.tooltip ? /*#__PURE__*/react.createElement("span", null, element.label, /*#__PURE__*/react.createElement(tooltip/* default */.Z, {
      title: element.tooltip
    }, /*#__PURE__*/react.createElement(QuestionCircleOutlined/* default */.Z, null))) : element.label; // 设置校验的属性

    var rules = element.rules || [];

    if (element.required) {
      rules = [...rules, {
        required: true,
        message: "".concat(element.label, "\u4E0D\u80FD\u4E3A\u7A7A")
      }];
    } // 自定义必填项表单项的样式


    var requiredCls = classnames_default()({
      'required-item': element.required
    }); // 校验时机

    var triggerInBlur = element.type ? getValueInBlur.includes(element.type) : false;

    var formItemProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
      name: element.name,
      colon: props.colon || false,
      label,
      rules,
      key: element.name,
      hide: element.hide ? element.hide.toString() : 'false',
      validateTrigger: triggerInBlur ? 'onBlur' : 'onChange',
      columns: element.columns
    }, element.formItemProps), {}, {
      normalize: val => handleNormalize(val, element.type),
      extra: element.extra
    });

    var columns = element.columns || 1;
    var formItemLayout = props.notSearchForm ? {} : formItemLayoutType[columns];
    var formLayout = element.formItemLayout || {};

    if (element.type) {
      var options = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, element.fieldOptions), {}, {
        label
      });

      return /*#__PURE__*/react.createElement(FormItem, (0,esm_extends/* default */.Z)({}, formItemProps, formItemLayout, formLayout, {
        fieldtype: element.type,
        className: requiredCls
      }), Fields[element.type](options, element.dataList));
    }

    return /*#__PURE__*/react.createElement(FormItem, (0,esm_extends/* default */.Z)({}, formItemProps, formItemLayout, formLayout, {
      className: requiredCls
    }), element.widget);
  }, [props.colon, props.notSearchForm]); // 获取所有表单项的初始值

  var initialValues = (0,react.useMemo)(() => {
    var values = formfields.reduce((prev, next) => {
      if (!next) return prev;
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, prev), {}, {
        [next.name]: next.initialValue
      });
    }, {});
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, values), props.defaultValues);
  }, [formfields, props.defaultValues]);
  /**
   * 支持动态的initialValue
   */

  (0,react.useEffect)(() => {
    var itemInitial = {};
    propsElements && propsElements.filter(Boolean).forEach(item => {
      if (item && (item.initialValue || item.initialValue === 0)) {
        Object.assign(itemInitial, {
          [item.name]: item.initialValue
        });
      }
    });
    form.setFieldsValue((0,objectSpread2/* default */.Z)({}, itemInitial));
  }, [propsElements, form]);
  (0,useCompareEffect/* default */.Z)(() => {
    var _location, _location$search;

    // 对象比较用这个hook
    var isEditPage = location.pathname.toLowerCase().indexOf('edit') > 0 || ((_location = location) === null || _location === void 0 ? void 0 : (_location$search = _location.search) === null || _location$search === void 0 ? void 0 : _location$search.length) > 0;

    if (formCache && props.isCache && !isEditPage) {
      var cacheValues = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, initialValues || {}), formCache); // setInitialValues(cacheValues)


      form.setFieldsValue(cacheValues); // if (props.callbackHandler) {
      //   props.callbackHandler('success', cacheValues)
      // }
    }
  }, [form, formCache, initialValues, props.isCache]); // 设置不同模式的form布局

  var defaultFormLayout = (0,react.useMemo)(() => {
    var _props$formOptions;

    var layout = ((_props$formOptions = props.formOptions) === null || _props$formOptions === void 0 ? void 0 : _props$formOptions.layout) || 'horizontal';
    return defaultLayout[layout];
  }, [(_props$formOptions2 = props.formOptions) === null || _props$formOptions2 === void 0 ? void 0 : _props$formOptions2.layout]);
  return /*#__PURE__*/react.createElement("div", {
    className: "formBuilder"
  }, /*#__PURE__*/react.createElement(es_form/* default */.Z, (0,esm_extends/* default */.Z)({
    ref: ref,
    form: form,
    initialValues: initialValues,
    onFinish: onFinish,
    onFinishFailed: onFinishFailed,
    onValuesChange: props.onChange
  }, defaultFormLayout, props.formOptions), /*#__PURE__*/react.createElement(row/* default */.Z, {
    gutter: 24
  }, (0,react.useMemo)(() => renderLayout(formfields.map(renderElement)), [formfields, renderElement, renderLayout]), props.notSearchForm ? null : /*#__PURE__*/react.createElement(col/* default */.Z, (0,esm_extends/* default */.Z)({
    span: 8,
    key: "button",
    offset: btnOffset
  }, normalColLayout, {
    className: "col-item"
  }), /*#__PURE__*/react.createElement(FormItem, {
    labelCol: {
      span: 0
    },
    wrapperCol: {
      span: 24
    }
  }, Fields['SEARCH_BUTTON'](resetField, props.leftElement, btnElement))))));
};

/* harmony default export */ var components_FormBuilder = (/*#__PURE__*/react.forwardRef(FormBuilder));

/***/ }),

/***/ 45199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_input_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47673);
/* harmony import */ var antd_es_input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4107);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34041);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);








/**
 * 一级品类、二级品类联动的自定义表单控件
 * 数据格式为CategoryCompactValue
 * 配合Form
 */

var Option = antd_es_select__WEBPACK_IMPORTED_MODULE_3__/* .default.Option */ .Z.Option;

function CategorySelect(props) {
  var _props$firstProps = props.firstProps,
      firstProps = _props$firstProps === void 0 ? {} : _props$firstProps,
      _props$secondProps = props.secondProps,
      secondProps = _props$secondProps === void 0 ? {} : _props$secondProps,
      _props$categoryList = props.categoryList,
      categoryList = _props$categoryList === void 0 ? [] : _props$categoryList,
      formValue = props.formValue,
      onChange = props.onChange;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      secondOptions = _useState2[0],
      setSecondOptions = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(formValue),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState3, 2),
      fieldValue = _useState4[0],
      setFieldValue = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    var firstValueTmp = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.first;

    if (!firstValueTmp || !categoryList.length) {
      return;
    }

    try {
      // 二级的下拉数据
      var _ref = categoryList && categoryList.find(v => +v.value === firstValueTmp) || {},
          others = _ref.others; // console.log(categoryList, firstValueTmp)
      // console.log(others)


      if (!(others !== null && others !== void 0 && others.childCategoryList)) {
        setSecondOptions([]);
      }

      var list = Object.values(others === null || others === void 0 ? void 0 : others.childCategoryList).map(v => ({
        value: v.categoryId,
        label: v.categoryName
      }));
      setSecondOptions(list);
    } catch (error) {
      console.log(error);
    }
  }, [categoryList, fieldValue]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (formValue) {
      setFieldValue(formValue);
    }
  }, [formValue]);

  var changeFirstSelect = value => {
    setFieldValue(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)({}, v), {}, {
      first: value,
      second: undefined
    }));

    if (onChange) {
      onChange({
        first: value,
        second: undefined
      });
    }
  };

  var changeSecondSelect = secondValue => {
    setFieldValue(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)({}, v), {}, {
      second: secondValue
    }));

    if (onChange) {
      var _value = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)({}, fieldValue), {}, {
        second: secondValue
      });

      onChange(_value);
    }
  };

  var renderOptions = dataSource => {
    if (dataSource && dataSource.length > 0) {
      return dataSource.map(v => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(Option, {
        value: v.value,
        key: v.value,
        rows: v
      }, v.label));
    }

    return null;
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_6__/* .default.Group */ .Z.Group, {
    compact: true
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({
    placeholder: "\u4E00\u7EA7",
    dropdownMatchSelectWidth: false,
    showSearch: true,
    allowClear: true,
    optionLabelProp: "children",
    style: {
      width: '50%'
    },
    onChange: changeFirstSelect,
    value: fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.first
  }, firstProps), renderOptions(categoryList)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({
    placeholder: "\u4E8C\u7EA7",
    dropdownMatchSelectWidth: false,
    showSearch: true,
    allowClear: true,
    value: fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.second // filterOption={false}
    ,
    optionLabelProp: "children",
    style: {
      width: '50%'
    },
    onChange: changeSecondSelect
  }, secondProps), renderOptions(secondOptions)));
}

/* harmony default export */ __webpack_exports__["Z"] = (CategorySelect);

/***/ }),

/***/ 51115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var antd_es_tree_select_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62999);
/* harmony import */ var antd_es_tree_select__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57119);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71720);




/**
 * 商品类目树
 */



var TreeNode = antd_es_tree_select__WEBPACK_IMPORTED_MODULE_2__/* .default.TreeNode */ .Z.TreeNode;

var GoodsCategorySelect = props => {
  var _useSelector = (0,umi__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(state => state.goodsStore),
      goodsCategoryList = _useSelector.goodsCategoryList;

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    setTreeData(goodsCategoryList);
  }, [goodsCategoryList]);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(goodsCategoryList),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      treeData = _useState2[0],
      setTreeData = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState3, 2),
      curCategoryValue = _useState4[0],
      setCurCategoryValue = _useState4[1];
  /** 渲染树 */


  var renderTreeNode = treeData => {
    if (!treeData) return;
    return treeData.map((item, key) => {
      if (item.childBackCategory) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(TreeNode, {
          value: item.backCategoryId,
          title: item.backCategoryName,
          key: item.backCategoryId
        }, renderTreeNode(item.childBackCategory));
      } else {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(TreeNode, {
          value: item.backCategoryId,
          title: item.backCategoryName,
          key: item.backCategoryId
        });
      }
    });
  };
  /** 数据选择 */


  var onTreeChange = e => {
    setCurCategoryValue(e);

    if (props.setCategoryId) {
      props.setCategoryId(e);
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    id: "my-tree-select"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tree_select__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    allowClear: true,
    treeDataSimpleMode: true,
    style: {
      width: '100%'
    },
    value: curCategoryValue || props.categoryId || undefined,
    dropdownStyle: {
      maxHeight: 400,
      overflow: 'auto'
    },
    placeholder: "\u8BF7\u9009\u62E9\u5546\u54C1\u7C7B\u76EE",
    onChange: onTreeChange
  }, renderTreeNode(treeData)));
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(GoodsCategorySelect));

/***/ }),

/***/ 2271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_GoodsModal; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/modal/style/index.js
var style = __webpack_require__(71194);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(57016);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/FormBuilder/index.tsx + 4 modules
var FormBuilder = __webpack_require__(5670);
// EXTERNAL MODULE: ./src/components/CommonTable/index.tsx + 3 modules
var CommonTable = __webpack_require__(40934);
// EXTERNAL MODULE: ./src/hooks/useMapping.ts
var useMapping = __webpack_require__(7704);
;// CONCATENATED MODULE: ./src/components/GoodsModal/useFormfields.ts

function useFormfields(secondCategoryId) {
  var _useMapping = (0,useMapping/* default */.Z)(5),
      mappingList = _useMapping.mappingList;

  return [{
    label: '商品查询',
    name: 'queryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '商品品类',
    name: 'secondCategoryId',
    type: 'SELECT',
    dataList: mappingList.get(5),
    initialValue: secondCategoryId === 0 || !secondCategoryId ? undefined : secondCategoryId,
    reset: false,
    fieldOptions: {
      disabled: !!secondCategoryId
    }
  }, {
    label: '品牌名称',
    name: 'brandName',
    type: 'INPUT'
  }];
}
;// CONCATENATED MODULE: ./src/components/GoodsModal/columns.ts
/* harmony default export */ var columns = ([// {
//   title: '商家名称',
//   dataIndex: 'merchantName',
//   key: 'merchantName'
// },
{
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId'
}, // {
//   title: '商品条码',
//   dataIndex: 'goodsBarCode',
//   key: 'goodsBarCode',
//   width: 140
// },
{
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName'
}, {
  title: '二类',
  dataIndex: 'secondCategoryName',
  key: 'secondCategoryName'
}, {
  title: '品牌名称',
  dataIndex: 'brandName',
  key: 'brandName'
}, {
  title: '单位',
  dataIndex: 'orderSpecificationUnit',
  key: 'orderSpecificationUnit',
  width: 120
}, {
  title: '规格',
  dataIndex: 'orderSpecification',
  key: 'orderSpecification',
  width: 130
}]);
;// CONCATENATED MODULE: ./src/components/GoodsModal/index.tsx





/**
 * 商家商品
 */





// billType:
// 采购订货(1),
// 采购退货(2),
// 仓间调拨(3),
// 店间调拨(4),
// 仓店配送(5),
// 要货集单(6),
// 退货集单(7);
var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 10
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 14
    }
  }
};

function GoodsModal(props) {
  var _props$columns;

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      selectedRows = _useState2[0],
      setSelectedRows = _useState2[1];

  var _useState3 = (0,react.useState)(props.searchParams),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      searchParams = _useState4[0],
      setSearchParams = _useState4[1];

  var secondCategoryId = isNaN(+props.searchParams.condition.secondCategoryId) ? undefined : +props.searchParams.condition.secondCategoryId;
  var formfields = useFormfields(secondCategoryId);
  var searchHandler = (0,react.useCallback)((state, values) => {
    setSearchParams(v => {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
        condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v.condition), values)
      });
    });
  }, []);

  var propsSearchHandler = (state, values) => {
    var curSelectCategoryId = props.searchParams.curSelectCategoryId;
    values['backCategoryId'] = curSelectCategoryId;

    for (var k in values) {
      if (values[k] === '' || values[k] === undefined || values[k] === null) {
        // 过滤
        delete values[k];
      }
    }

    setSearchParams(() => (0,objectSpread2/* default */.Z)({}, values));
  };

  var resetFields = (0,react.useCallback)(() => {
    setSearchParams(props.searchParams);
  }, [props.searchParams]);
  var rowSelectCallback = (0,react.useCallback)((keys, rows) => {
    setSelectedRows(rows);
  }, []);

  var handleOk = () => {
    props.saveModalCallback(selectedRows);
  };

  (0,react.useEffect)(() => {
    console.log('searchParams', props.searchParams);
  }, [props.searchParams]);
  return /*#__PURE__*/react.createElement(modal/* default */.Z, {
    title: props.title || '商品选择',
    destroyOnClose: true,
    maskClosable: false,
    width: 1200,
    visible: true,
    onOk: handleOk,
    onCancel: props.closeModalCallback
  }, /*#__PURE__*/react.createElement(FormBuilder/* default */.Z, {
    elements: props.GoodsModalFormElements || props.formfields || formfields,
    callbackHandler: props.GoodsModalFormElements ? propsSearchHandler : searchHandler,
    onReset: resetFields,
    formOptions: (0,objectSpread2/* default */.Z)({}, defaultFormItemLayout)
  }), /*#__PURE__*/react.createElement(CommonTable/* default */.Z, {
    scrollYSize: 400,
    columns: (_props$columns = props.columns) !== null && _props$columns !== void 0 ? _props$columns : columns,
    searchParams: searchParams,
    queryDataUrl: props.queryGoodsModalDataUrl || 'purchase.product.querySelectPlaceProductByCondition' // 采购模块: 商家维度接口，不需要物流模式；
    ,
    tableOptions: (0,objectSpread2/* default */.Z)({
      scroll: {
        y: 380
      }
    }, props.tableOptions),
    rowSelectCallback: rowSelectCallback,
    returnData: props.returnData // {...props.tableOptions}

  }));
}

/* harmony default export */ var components_GoodsModal = (GoodsModal);

/***/ }),

/***/ 73311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71577);
/* harmony import */ var antd_es_input_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47673);
/* harmony import */ var antd_es_input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4107);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_GoodsModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2271);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43061);






/**
 * 选择商家/商品的表单项按钮
 */


 // Todo 商家选择保存

function GoodRoutesMerchantFormfield(props) {
  var initFormData = props.initFormData,
      isEdit = props.isEdit,
      handleSetFormData = props.handleSetFormData,
      searchParams = props.searchParams,
      name = props.name,
      btnText = props.btnText,
      columns = props.columns,
      formfields = props.formfields,
      title = props.title,
      onClickBefore = props.onClickBefore,
      deleteBtn = props.deleteBtn;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1]; // 保存 选择商家 浮层


  var saveModalCallback = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(rows => {
    setVisible(false);
    handleSetFormData(rows);
  }, []); // 关闭 浮层

  var closeModal = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(() => {
    setVisible(false);
  }, []);

  var onClickBtn = () => {
    if (onClickBefore) {
      onClickBefore() && setVisible(true);
    } else {
      setVisible(true);
    }
  };

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState3, 2),
      curInputVal = _useState4[0],
      setcurInputVal = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (Array.isArray(initFormData) && initFormData !== null && initFormData !== void 0 && initFormData.length) {
      var str = '';
      initFormData.map(e => {
        str += (e === null || e === void 0 ? void 0 : e.goodsName) + ' ' + (e === null || e === void 0 ? void 0 : e.goodsId) + ' ';
      });
      setcurInputVal(str);
    }
  }, [initFormData]);

  var deleteSelected = () => {
    handleSetFormData === null || handleSetFormData === void 0 ? void 0 : handleSetFormData([]);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_5__/* .default.Group */ .Z.Group, {
    className: "complexInput"
  }, Array.isArray(initFormData) && initFormData !== null && initFormData !== void 0 && initFormData.length ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    style: {
      borderRight: '0px'
    },
    value: curInputVal || '',
    readOnly: true,
    name: name
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    style: {
      borderRight: '0px'
    },
    value: "".concat((initFormData === null || initFormData === void 0 ? void 0 : initFormData.name) || '', " ").concat((initFormData === null || initFormData === void 0 ? void 0 : initFormData.id) || ''),
    readOnly: true,
    name: name
  }), deleteBtn && ((initFormData === null || initFormData === void 0 ? void 0 : initFormData.id) || curInputVal) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      paddingRight: 5,
      borderTop: '1px solid #d9d9d9',
      borderBottom: '1px solid #d9d9d9'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    style: {
      color: '#c6c6c6',
      fontSize: 12
    },
    onClick: deleteSelected
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
    type: "primary",
    disabled: !isEdit,
    className: "complexBtn",
    onClick: onClickBtn
  }, btnText !== null && btnText !== void 0 ? btnText : '商家选择')), visible && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_components_GoodsModal__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    queryGoodsModalDataUrl: props.queryDataUrl,
    tableOptions: props.tableOptions,
    searchParams: searchParams,
    title: title,
    formfields: formfields,
    columns: columns,
    closeModalCallback: closeModal,
    saveModalCallback: saveModalCallback
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (GoodRoutesMerchantFormfield);

/***/ }),

/***/ 33773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OldUploader; }
});

// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/index.js
var style = __webpack_require__(34792);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(48086);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/upload/style/index.js
var upload_style = __webpack_require__(43185);
// EXTERNAL MODULE: ./node_modules/antd/es/upload/index.js + 12 modules
var upload = __webpack_require__(3388);
// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var button_style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/UploadOutlined.js + 1 modules
var UploadOutlined = __webpack_require__(84391);
;// CONCATENATED MODULE: ./src/components/OldUploader/components/CommonUploader.tsx








function CommonUploader(props) {
  var _props$btnText;

  var disabled = props.uploadOptions.disabled;
  return /*#__PURE__*/react.createElement(upload/* default */.Z, (0,esm_extends/* default */.Z)({
    name: "files",
    accept: props.accept,
    action: props.action,
    data: props.data // showUploadList={props.isFileNameShow}
    ,
    headers: {
      'res-token': props.token
    },
    fileList: props.fileList,
    beforeUpload: props.beforeUpload,
    onChange: props.handleChange,
    onRemove: props.handleRemove
  }, props.uploadOptions), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    loading: props.loading,
    disabled: props.loading || disabled,
    type: "primary"
  }, /*#__PURE__*/react.createElement(UploadOutlined/* default */.Z, null), " ", (_props$btnText = props.btnText) !== null && _props$btnText !== void 0 ? _props$btnText : '点击上传'));
}

/* harmony default export */ var components_CommonUploader = (CommonUploader);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/style/index.js
var modal_style = __webpack_require__(71194);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(57016);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlusOutlined.js + 1 modules
var PlusOutlined = __webpack_require__(49101);
;// CONCATENATED MODULE: ./src/components/OldUploader/utils/constance.ts
// 上传前需要获取token的请求地址
var uploadTokenUrl = 'purchase.basis.getToken';
var imgSuffix = ['image/jpeg', 'image/gif', 'image/png', 'image/jpg'];
// EXTERNAL MODULE: ./src/components/OldUploader/index.less?modules
var OldUploadermodules = __webpack_require__(81369);
var OldUploadermodules_default = /*#__PURE__*/__webpack_require__.n(OldUploadermodules);
;// CONCATENATED MODULE: ./src/components/OldUploader/components/UploadImg.tsx















var suffixs = imgSuffix.join(',').replace(/\image/g, ''); // 获取图片信息

function readFiles(file, type) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onerror = error => reject(error);

    if (type === 'url') {
      reader.onload = () => resolve(reader.result);
    } else {
      reader.onload = img => {
        var image = new Image();
        image.src = img.target.result;

        image.onload = function () {
          resolve(this);
        };
      };
    }
  });
}

function UploadImg(props) {
  var _props$accept, _props$btnText;

  var _useState = (0,react.useState)({
    visible: false,
    img: ''
  }),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      previewModal = _useState2[0],
      setPreviewModal = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      fileName = _useState4[0],
      setFileName = _useState4[1]; // 展示预览图


  var handlePreview = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(file) {
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('handlePreview', file);

              if (!(!file.url && !file.preview)) {
                _context.next = 5;
                break;
              }

              _context.next = 4;
              return readFiles(file.originFileObj, 'url');

            case 4:
              file.preview = _context.sent;

            case 5:
              setFileName(file === null || file === void 0 ? void 0 : file.name);
              setPreviewModal({
                visible: true,
                img: file.url || file.preview
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handlePreview(_x) {
      return _ref.apply(this, arguments);
    };
  }(); // 上传前的回调


  function beforeUpload(_x2) {
    return _beforeUpload.apply(this, arguments);
  }

  function _beforeUpload() {
    _beforeUpload = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(file) {
      var isJpgOrPng, size, width, height, _size;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log('file', file);
              _context2.prev = 1;
              isJpgOrPng = imgSuffix.includes(file.type);

              if (isJpgOrPng) {
                _context2.next = 5;
                break;
              }

              throw "\u53EA\u80FD\u4E0A\u4F20\u540E\u7F00\u540D\u4E3A\u3010".concat(suffixs, "\u3011\u7684\u6587\u4EF6");

            case 5:
              size = props.size, width = props.width, height = props.height; // 如果有传入参数限制图片大小

              if (!size) {
                _context2.next = 9;
                break;
              }

              if (!(file.size / 1024 / 1024 > size / 1024)) {
                _context2.next = 9;
                break;
              }

              throw "\u4E0D\u80FD\u4E0A\u4F20\u8D85\u8FC7".concat(size, "K\u7684\u56FE\u7247");

            case 9:
              if (!(width || height)) {
                _context2.next = 17;
                break;
              }

              _context2.next = 12;
              return readFiles(file, 'size');

            case 12:
              _size = _context2.sent;

              if (!(width && width > _size.width)) {
                _context2.next = 15;
                break;
              }

              throw "\u4E0A\u4F20\u56FE\u7247\u7684\u6700\u5927\u5BBD\u5EA6\u4E3A".concat(width, "px");

            case 15:
              if (!(height && height > _size.height)) {
                _context2.next = 17;
                break;
              }

              throw "\u4E0A\u4F20\u56FE\u7247\u7684\u6700\u5927\u9AD8\u5EA6\u4E3A".concat(height, "px");

            case 17:
              _context2.next = 19;
              return props.beforeUpload(file);

            case 19:
              _context2.next = 25;
              break;

            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2["catch"](1);

              message.default.error(_context2.t0);

              return _context2.abrupt("return", Promise.reject(_context2.t0));

            case 25:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 21]]);
    }));
    return _beforeUpload.apply(this, arguments);
  }

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(upload/* default */.Z, (0,esm_extends/* default */.Z)({
    name: "files",
    accept: (_props$accept = props.accept) !== null && _props$accept !== void 0 ? _props$accept : 'image/*',
    listType: "picture-card",
    className: (OldUploadermodules_default()).uploader,
    headers: {
      'res-token': props.token
    },
    fileList: props.fileList,
    action: props.action,
    beforeUpload: beforeUpload,
    onPreview: handlePreview,
    onChange: props.handleChange,
    onRemove: props.handleRemove
  }, props.uploadOptions), props.loading ?
  /*#__PURE__*/
  // <LoadingOutlined />
  react.createElement(react.Fragment, null) : [/*#__PURE__*/react.createElement("div", {
    key: "text",
    className: (OldUploadermodules_default()).uploadText
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(PlusOutlined/* default */.Z, {
    key: "icon",
    style: {
      fontSize: 18
    }
  })), (_props$btnText = props.btnText) !== null && _props$btnText !== void 0 ? _props$btnText : '上传图片')]), /*#__PURE__*/react.createElement(modal/* default */.Z, {
    visible: previewModal.visible,
    title: fileName,
    footer: null,
    onCancel: () => setPreviewModal(v => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
      visible: false
    }))
  }, /*#__PURE__*/react.createElement("img", {
    alt: "example",
    style: {
      width: '100%'
    },
    src: previewModal.img
  })));
}

/* harmony default export */ var components_UploadImg = (UploadImg);
;// CONCATENATED MODULE: ./src/components/OldUploader/index.tsx












function Uploader(props) {
  var _props$defaultFileLis;

  var type = props.type,
      tokenParams = props.tokenParams,
      tokenUrl = props.tokenUrl; //   const [token, setToken] = useState('')

  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react.useState)((_props$defaultFileLis = props.defaultFileList) !== null && _props$defaultFileLis !== void 0 ? _props$defaultFileLis : []),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      fileList = _useState4[0],
      setFileList = _useState4[1];

  var _useState5 = (0,react.useState)({
    endpoint: '',
    // 上传地址
    resId: '',
    // 资源id
    params: {} // 上传附带的参数

  }),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      resToken = _useState6[0],
      setResToken = _useState6[1];

  (0,react.useEffect)(() => {
    if (props.defaultFileList) {
      setFileList(props.defaultFileList);
    }
  }, [props.defaultFileList]); // 上传前  先获取 token

  var beforeUpload = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(file) {
      var imgTokenAPI, uploadTokenUrl, url, params, _yield$ypRider, result, success, msg;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              imgTokenAPI = 'item.resource.getResourceToken';
              uploadTokenUrl = 'kernel.console.BatchToolsService.getUploadFileToken';
              url = type === 'img' ? imgTokenAPI : tokenUrl || uploadTokenUrl;
              params = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, tokenParams), {}, {
                fileName: file.name,
                isPublic: type === 'img' ? true : false
              });
              _context.next = 6;
              return (0,ypRequest/* default */.Z)(url, params);

            case 6:
              _yield$ypRider = _context.sent;
              result = _yield$ypRider.result;
              success = _yield$ypRider.success;
              msg = _yield$ypRider.message;
              return _context.abrupt("return", new Promise((resolve, reject) => {
                try {
                  // 获取上传的 token 失败
                  if (!success) {
                    throw msg !== null && msg !== void 0 ? msg : '获取token失败';
                  } // if (!result || !result.token) {
                  //   throw '请求成功，但无有效 token 信息'
                  // }
                  // setToken(res.result.token)


                  file.resId = result.resId;
                  setResToken(result);
                  resolve(file);
                } catch (error) {
                  // message.error(error)
                  reject(file);
                }
              }));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function beforeUpload(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleChange = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(_ref2) {
      var file, fileList, name, uid, resId, _file$response, url, code, obj;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref2.file, fileList = _ref2.fileList;

              if (!(file.status === 'uploading')) {
                _context2.next = 5;
                break;
              }

              setLoading(true);
              setFileList(fileList);
              return _context2.abrupt("return");

            case 5:
              if (!(file.status === 'error')) {
                _context2.next = 9;
                break;
              }

              message.default.error("\u3010".concat(file.name, "\u3011\u4E0A\u4F20\u5931\u8D25"));

              setLoading(false);
              return _context2.abrupt("return");

            case 9:
              if (!(file.status === 'done')) {
                _context2.next = 19;
                break;
              }

              setLoading(false);
              name = file.name, uid = file.uid, resId = file.resId, _file$response = file.response, url = _file$response.message, code = _file$response.code; // 上传失败

              if (!(code !== 200)) {
                _context2.next = 15;
                break;
              }

              message.default.error('上传失败');

              return _context2.abrupt("return");

            case 15:
              // 设置 fileList
              //   const fileOriginPath = data.url + '/' + data.files[0]
              obj = [{
                uid,
                name,
                status: 'done',
                resId: resId,
                files: url
              }]; // const newFileList = fileList.filter((v: any) => !!v.url).concat(obj)

              console.log(obj);
              setFileList(obj);
              props.onChange && props.onChange(obj);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleChange(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var removeFile = file => {
    var list = fileList.filter(v => v.uid !== file.uid);
    setFileList(list); // 将结果返回

    if (props.onChange) {
      props.onChange(list);
    }
  }; // 删除 fileList


  var handleRemove = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3(file) {
      var res;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              if (!props.onRemove) {
                _context3.next = 7;
                break;
              }

              _context3.next = 4;
              return props.onRemove(file);

            case 4:
              res = _context3.sent;

              // 如果返回为 true 可以删除
              if (res) {
                removeFile(file);
              }

              return _context3.abrupt("return", res);

            case 7:
              // 没有异步判断则直接删除
              removeFile(file);
              return _context3.abrupt("return", true);

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](0);
              return _context3.abrupt("return", false);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 11]]);
    }));

    return function handleRemove(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  var uploadCommonProps = {
    // action: api.uploadUrlNew,
    // token,
    action: resToken.endpoint,
    data: resToken.params,
    token: '',
    loading: props.loading || loading,
    fileList,
    beforeUpload,
    handleChange,
    handleRemove
  };

  if (type === 'img') {
    return /*#__PURE__*/react.createElement(components_UploadImg, (0,esm_extends/* default */.Z)({}, props, uploadCommonProps));
  }

  return /*#__PURE__*/react.createElement(components_CommonUploader, (0,esm_extends/* default */.Z)({}, props, uploadCommonProps));
}

/* harmony default export */ var OldUploader = (Uploader);

/***/ }),

/***/ 87043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OperationGroupMultiSelect; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34041);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pages_Promotion_hooks_useOperationGroupList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87237);





var Option = antd_es_select__WEBPACK_IMPORTED_MODULE_3__/* .default.Option */ .Z.Option;
function OperationGroupMultiSelect(_ref) {
  var disabled = _ref.disabled,
      style = _ref.style,
      value = _ref.value,
      onChange = _ref.onChange;

  var _useOperationGroupLis = (0,_pages_Promotion_hooks_useOperationGroupList__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(),
      _useOperationGroupLis2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useOperationGroupLis, 2),
      list = _useOperationGroupLis2[1];

  var _React$useMemo = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => {
    var options = [...list];
    var optionsIdList = options.map(option => option.value);

    if (options.length > 1) {
      options.unshift({
        value: '-1',
        label: '全部'
      });
    }

    return [options, optionsIdList];
  }, [list]),
      _React$useMemo2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_React$useMemo, 2),
      options = _React$useMemo2[0],
      optionsIdList = _React$useMemo2[1];

  var _value = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => {
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
  }, [value, optionsIdList]);

  var handleChange = next => {
    if (!onChange) return;
    onChange(next.includes('-1') ? optionsIdList : next);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    showSearch: true,
    allowClear: true,
    mode: "multiple",
    maxTagCount: disabled ? undefined : 1,
    placeholder: "\u8BF7\u9009\u62E9\u8FD0\u8425\u7EC4",
    disabled: disabled,
    filterOption: (input, option) => {
      var _option$children;

      return ((_option$children = option === null || option === void 0 ? void 0 : option.children) !== null && _option$children !== void 0 ? _option$children : '').includes(input);
    },
    style: style,
    value: _value,
    onChange: handleChange
  }, options.map(d => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(Option, {
    key: d.value,
    value: d.value
  }, d.label)));
}

/***/ }),

/***/ 13875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31097);
/* harmony import */ var antd_es_spin_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20228);
/* harmony import */ var antd_es_spin__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11382);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1870);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24731);











function OrderExceptionMsg(props) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState3, 2),
      message = _useState4[0],
      setMessage = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState5, 2),
      visible = _useState6[0],
      setVisible = _useState6[1];

  var queryBlockOrderInfo = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().mark(function _callee(v) {
      var _result$result, result;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(v && props.orderNO)) {
                _context.next = 8;
                break;
              }

              setLoading(true);
              _context.next = 4;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(props.queryUrl, {
                orderNo: props.orderNO
              });

            case 4:
              result = _context.sent;
              console.log(v, result);
              setMessage((_result$result = result.result) === null || _result$result === void 0 ? void 0 : _result$result.showBlockMsg);
              setLoading(false);

            case 8:
              setVisible(v);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [props.orderNO, props.queryUrl]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
    title: () => loading ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_spin__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, null) : message,
    onVisibleChange: queryBlockOrderInfo,
    visible: visible
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, {
    style: {
      color: '#f50'
    }
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (OrderExceptionMsg);

/***/ }),

/***/ 55054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ PurchaseCategorySelect; }
/* harmony export */ });
/* harmony import */ var antd_es_cascader_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36877);
/* harmony import */ var antd_es_cascader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34366);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26715);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7704);




/**
 * 采购 - 权限下的类目
 */



var PurchaseCategorySelect = props => {
  var curCategoryArr = props.curCategoryArr,
      handleCategory = props.handleCategory,
      deepLength = props.deepLength,
      disabled = props.disabled;

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)([_config_enums__WEBPACK_IMPORTED_MODULE_2__/* .purchaseEnumConfig.categoryCodeAll */ .Nt.categoryCodeAll]),
      mappingList = _useMapping.mappingList;

  var fieldDataList = type => {
    return mappingList && mappingList['get'] && mappingList.get(_config_enums__WEBPACK_IMPORTED_MODULE_2__/* .purchaseEnumConfig */ .Nt[type]);
  };

  var list = fieldDataList('categoryCodeAll');
  var allCatArr = [];

  if (list && list.length) {
    list.forEach(e => {
      allCatArr.push({
        value: e.others.categoryId.toString(),
        label: e.others.categoryName,
        // children: exchangeObjToArr(e.others.childCategoryList),
        children: deepLength === 2 ? exchangeObjToArrFor2(e.others.childCategoryList) : exchangeObjToArrFor4(e.others.childCategoryList)
      });
    });
  } //   console.log('allCatArr', allCatArr)


  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      state = _useState2[0],
      setstate = _useState2[1];

  var onChange = (value, selectedOptions) => {
    setstate(value);
    var _val = {
      firstCategoryId: selectedOptions[0] ? selectedOptions[0].value : undefined,
      firstCategoryName: selectedOptions[0] ? selectedOptions[0].label : undefined,
      secondCategoryId: selectedOptions[1] ? selectedOptions[1].value : undefined,
      secondCategoryName: selectedOptions[1] ? selectedOptions[1].label : undefined,
      threeCategoryId: selectedOptions[2] ? selectedOptions[2].value : undefined,
      threeCategoryName: selectedOptions[2] ? selectedOptions[2].label : undefined,
      fourCategoryId: selectedOptions[3] ? selectedOptions[3].value : undefined,
      fourCategoryName: selectedOptions[3] ? selectedOptions[3].label : undefined
    };

    for (var i in _val) {
      if (!_val[i]) {
        delete _val[i];
      }
    }

    handleCategory(_val);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_cascader__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    options: allCatArr,
    onChange: onChange,
    changeOnSelect: true,
    key: curCategoryArr,
    defaultValue: state.length ? state : curCategoryArr,
    disabled: disabled
  });
}; // /** 1001: {categoryId: 11001, categoryName: "干货类",} => [{value: 1001, label: '干货类'}] */
// const exchangeObjToArr = (object: any) => {
//   const arr: any = []
//   if (Object.keys(object).length) {
//     for (const key in object) {
//       if (object.hasOwnProperty(key)) {
//         const _arr: any = {
//           value: key.toString(),
//           label: object[key]['categoryName'],
//         }
//         if (exchangeObjToArr(object[key]['childCategoryList']) && exchangeObjToArr(object[key]['childCategoryList']).length) {
//           _arr['children'] = exchangeObjToArr(object[key]['childCategoryList'])
//         }
//         arr.push(_arr)
//       }
//     }
//   }
//   return arr
// }

/** 1001: {categoryId: 11001, categoryName: "干货类",} => [{value: 1001, label: '干货类'}] */

/**
 *
 * @param object 处理对象
 * @param deepLength 获取2层对象
 */

var exchangeObjToArrFor2 = object => {
  var arr = [];

  if (object && Object.keys(object).length) {
    for (var key in object) {
      if (object.hasOwnProperty(key)) {
        var _arr = {
          value: key.toString(),
          label: object[key]['categoryName']
        };

        if (object[key]['categorylevel'] < 3) {
          if (exchangeObjToArrFor2(object[key]['childCategoryList']) && exchangeObjToArrFor2(object[key]['childCategoryList']).length) {
            _arr['children'] = exchangeObjToArrFor2(object[key]['childCategoryList']);
          }

          arr.push(_arr);
        }
      }
    }
  }

  return arr;
};

var exchangeObjToArrFor4 = object => {
  var arr = [];

  if (object && Object.keys(object).length) {
    for (var key in object) {
      if (object.hasOwnProperty(key)) {
        var _arr = {
          value: key.toString(),
          label: object[key]['categoryName']
        };

        if (exchangeObjToArrFor4(object[key]['childCategoryList']) && exchangeObjToArrFor4(object[key]['childCategoryList']).length) {
          _arr['children'] = exchangeObjToArrFor4(object[key]['childCategoryList']);
        }

        arr.push(_arr);
      }
    }
  }

  return arr;
};

/***/ }),

/***/ 65440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export download */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93162);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(file_saver__WEBPACK_IMPORTED_MODULE_1__);


var download = (url, name) => {
  if (!(url !== null && url !== void 0 && url.length)) return;
  if (!(name !== null && name !== void 0 && name.length)) return;
  saveAs(url, "".concat(name, ".xlsx"));
};

var SaveFile = props => {
  var children = props.children,
      url = props.url,
      name = props.name;

  var onClick = () => {
    var xhr = new XMLHttpRequest();
    xhr.open("get", url, true);
    xhr.responseType = "blob";

    xhr.onload = function (_ref) {
      var target = _ref.target;

      if (target.status === 200) {
        (0,file_saver__WEBPACK_IMPORTED_MODULE_1__.saveAs)(target.response, "".concat(name, ".xlsx"));
      }
    };

    xhr.send();
  };

  return url !== null && url !== void 0 && url.length ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    onClick: onClick
  }, children) : null;
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(SaveFile));

/***/ }),

/***/ 12031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_spin_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20228);
/* harmony import */ var antd_es_spin__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11382);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8870);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2824);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34041);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24731);











/**
 * SELECT - 下拉搜索组件
 * createDate: 2020年04月27日
 * <SearchSelect
    type={type}
    disabled={searchShow}
    callBack={e => _callBack(e, type)}
    searchUrl={SUPPLIER_FARMER_LIST_API}
    paramsKey='SupplierName'
    fields={{text: 'SupplierName', value: 'SupplierCode'}}
    />
 */



var Option = antd_es_select__WEBPACK_IMPORTED_MODULE_6__/* .default.Option */ .Z.Option;

var SearchSelect = props => {
  var callBack = props.callBack,
      searchUrl = props.searchUrl,
      type = props.type,
      fields = props.fields,
      paramsKey = props.paramsKey,
      isShowSelectId = props.isShowSelectId,
      initData = props.initData;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    data: [],
    value: [],
    fetching: false
  }),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var lastFetchId = 0;

  var _res;

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (initData) {
      setState({
        data: [],
        value: initData,
        fetching: false
      });
    }
  }, [initData]);

  var msgNotFound = () => {
    setTimeout(() => {
      antd_es_message__WEBPACK_IMPORTED_MODULE_8__.default.info('未查询到指定信息');

      setState((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, state), {}, {
        data: [],
        fetching: false
      }));
      return;
    }, 1500);
  };

  var fetchFoo = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)().mark(function _callee(value) {
      var fetchId, _params, _res2, _res3, res, _data, _data2;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              lastFetchId += 1;
              fetchId = lastFetchId;
              setState((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, state), {}, {
                data: [],
                fetching: true
              }));
              _params = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({
                page: 1,
                size: 30
              }, props.params);

              if (paramsKey) {
                _params[paramsKey] = value;
              }

              if (props.moduleType && props.moduleType === 'goodsStatistics') {
                _params = {
                  pageInfo: {
                    page: 1,
                    size: 30
                  },
                  query: {
                    [paramsKey]: value
                  }
                };
              }

              _context.prev = 6;
              _context.next = 9;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(searchUrl, _params);

            case 9:
              res = _context.sent;

              if (!(fetchId !== lastFetchId)) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return");

            case 12:
              if (!(type === 'settlementCompany')) {
                _context.next = 17;
                break;
              }

              // 兼容查询公司接口返回
              _res = res.result.companyList;

              if (_res && !_res.length) {
                msgNotFound();
              }

              if (_res && _res.length) {
                _data = _res.map(e => ({
                  text: e[fields.text],
                  value: e[fields.value]
                }));
                setState((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, state), {}, {
                  data: _data,
                  fetching: false
                }));
              }

              return _context.abrupt("return");

            case 17:
              _res = res.result.list; // 其他通用返回格式

              if (!((_res2 = _res) !== null && _res2 !== void 0 && _res2.length)) {
                msgNotFound();
              }

              console.log('_res', _res);

              if ((_res3 = _res) !== null && _res3 !== void 0 && _res3.length) {
                _data2 = _res.map(e => ({
                  text: e[fields.text],
                  value: e[fields.value]
                }));
                setState((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, state), {}, {
                  data: _data2,
                  fetching: false
                }));
              }

              _context.next = 26;
              break;

            case 23:
              _context.prev = 23;
              _context.t0 = _context["catch"](6);
              console.error('fetchFooERROR', _context.t0);

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 23]]);
    }));

    return function fetchFoo(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var fetchMsg = lodash_debounce__WEBPACK_IMPORTED_MODULE_4___default()(fetchFoo, 800);

  var handleChange = value => {
    callBack(value);
    setState({
      value,
      data: [],
      fetching: false
    });
  };

  var fetching = state.fetching,
      data = state.data,
      value = state.value;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    disabled: props.disabled // mode="multiple"
    ,
    showSearch: true,
    labelInValue: true,
    value: value,
    placeholder: props.placeholder || '请输入关键字查询',
    notFoundContent: fetching ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_spin__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
      size: "small"
    }) : null,
    filterOption: false,
    onSearch: fetchMsg,
    onChange: handleChange,
    style: {
      width: '100%'
    },
    allowClear: true
  }, data.map(d => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(Option, {
    key: d.value,
    value: d.value
  }, isShowSelectId ? " (".concat(d.value, ") ") + d.text : d.text)));
};

/* harmony default export */ __webpack_exports__["Z"] = (SearchSelect);

/***/ }),

/***/ 22077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SelectPrinter; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/modal/style/index.js
var style = __webpack_require__(71194);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(57016);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var button_style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/style/index.js
var radio_style = __webpack_require__(88983);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js
var es_radio = __webpack_require__(55742);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(93224);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/index.js
var message_style = __webpack_require__(34792);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(48086);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/utils/c-lodop.ts



/**
 * 获取Lodop对象
 */
function getLodop() {
  var LODOP;

  if (window.getCLodop instanceof Function) {
    LODOP = window.getCLodop(); // 控件安装完会默认自动开启, 直接访问，不用修改不用调tslint
  }

  if (!LODOP && document.readyState !== 'complete') {
    message.default.info('C-Lodop打印控件还没准备好，请稍后再试或者重装控件！');

    return;
  }

  if (LODOP) {
    LODOP.SET_LICENSES("重庆谊品到家科技有限公司", "5D9B0FA6D7DEAA27349BB3B4177E3152454", "重慶誼品到家科技有限公司", "D2E9AA6901BB9815BD6B266D4BE551917E1");
    LODOP.SET_LICENSES("THIRD LICENSE", "", "Chongqing yipinjia Technology Co., Ltd", "708ACF3FA5B2CC480BDDDCF1F90C16232A0");
    return LODOP;
  }
}
// EXTERNAL MODULE: ./src/hooks/useTimer.ts
var useTimer = __webpack_require__(2441);
;// CONCATENATED MODULE: ./src/components/SelectPrinter/index.tsx













var _excluded = ["getPrintData", "closeModalCallback", "render"];



/** 打印验证 */

var valPrint = LODOP => {
  if (!LODOP) {
    message.default.warn('未找到LODOP控件，请安装LOSOP插件');

    return false;
  }

  return true;
};
/**
 * 打印的内容
 * @param LODOP 打印机对象实例
 * @param printer 打印机的名称
 * @param printContent 打印的内容
 * @param current 当前页
 * @param total 所有页数
 */


var printSetting = (LODOP, printer, printContent, current, total) => {
  LODOP.PRINT_INIT(''); // 打印初始化

  LODOP.SET_PRINTER_INDEX(printer); // 设置打印机

  LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4'); // 必须: 设置打印纸尺寸

  LODOP.ADD_PRINT_HTM(50, 0, '100%', '90%', printContent.replace(/,/g, ''));
  LODOP.ADD_PRINT_HTM('95%', '45%', '40%', 20, "<span>\u7B2C".concat(current, "\u9875</span>/<span>\u5171").concat(total, "\u9875</span>"));
  LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1); // 每页都输出
  // LODOP.PREVIEW() // 预览

  LODOP.PRINT(); // 直接打印
};

var handlePrint = (printer, printData) => {
  var LODOP = getLodop();

  if (!valPrint(LODOP)) {
    console.error('error');
    return;
  }

  if (!printData) {
    message.default.error('未获取到打印数据');

    return;
  }

  var printFn = _ref => {
    var data = _ref.data,
        before = _ref.before,
        current = _ref.current,
        total = _ref.total;
    var tmp = before === null || before === void 0 ? void 0 : before({
      data,
      page: {
        current,
        total
      }
    }); // 打印前修改参数

    if (tmp) {
      data = tmp.data;
      current = tmp.page.current;
      total = tmp.page.total;
    }

    printSetting(LODOP, printer, data, current, total);
  };

  message.default.success('正在打印中，请稍等....'); // 兼容 data 为 string 数组


  printData.forEach((ele1, i1, arr1) => {
    var data = ele1.data,
        before = ele1.before;

    if (Array.isArray(data)) {
      data.forEach((ele2, i2, arr2) => {
        printFn({
          data: ele2,
          before,
          current: i2 + 1,
          total: arr2.length
        });
      });
    } else {
      printFn({
        data,
        before,
        current: 1,
        total: 1
      });
    }
  });
  /* for (let i = 0; i < printData.length; i++) {
    let data = printData[i].data
    let current = i + 1
    let total = printData.length
    if (printData[i].before instanceof Function) {
      // 打印前修改参数
      const tmp = (printData[i].before as any)({ data, page: { current, total: total } })
      data = tmp.data
      current = tmp.page.current
      total = tmp.page.total
    }
    printSetting(LODOP, printer, data, current, total)
  } */
};

function getPrinters() {
  var LODOP = getLodop();
  if (!valPrint(LODOP)) return []; // 获取打印机个数

  var count = LODOP.GET_PRINTER_COUNT();
  var localPrinters = []; // 获取本地的打印机名称

  for (var i = 0; i < count; i++) {
    localPrinters.push(LODOP.GET_PRINTER_NAME(i));
  }

  return localPrinters;
}

var radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
  marginBottom: '5px'
};
function SelectPrinter(props) {
  var getPrintData = props.getPrintData,
      closeModalCallback = props.closeModalCallback,
      render = props.render,
      ommit = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var _useState = (0,react.useState)(),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      radioSelect = _useState2[0],
      setRadioSelect = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1]; // 倒计时


  var _useTimer = (0,useTimer/* default */.Z)(),
      _useTimer2 = (0,slicedToArray/* default */.Z)(_useTimer, 2),
      count = _useTimer2[0],
      setCount = _useTimer2[1];

  console.log(count, radioSelect);
  var disabledBtn = !radioSelect || count > 0;

  var handlePrintData = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
      var res;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 开始倒计时
              setCount(10);
              setLoading(true);
              _context.next = 4;
              return getPrintData();

            case 4:
              res = _context.sent;
              setLoading(false); // closeModalCallback() // 关掉选择打印机面板

              if (!(!res || !res.length)) {
                _context.next = 9;
                break;
              }

              message.default.error('没有需要打印的内容');

              return _context.abrupt("return");

            case 9:
              if (radioSelect) handlePrint(radioSelect, res);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handlePrintData() {
      return _ref2.apply(this, arguments);
    };
  }();

  var printListNode = /*#__PURE__*/react.createElement(es_radio/* default.Group */.ZP.Group, {
    onChange: e => setRadioSelect(e.target.value),
    value: radioSelect,
    buttonStyle: "solid"
  }, getPrinters().map(v => /*#__PURE__*/react.createElement(es_radio/* default.Button */.ZP.Button, {
    key: v,
    style: radioStyle,
    value: v
  }, v)));
  return /*#__PURE__*/react.createElement(modal/* default */.Z, (0,esm_extends/* default */.Z)({
    title: "\u53EF\u9009\u62E9\u7684\u6253\u5370\u673A",
    destroyOnClose: true,
    maskClosable: false,
    width: 400,
    onCancel: closeModalCallback,
    visible: true,
    footer: [/*#__PURE__*/react.createElement(es_button/* default */.Z, {
      type: "primary",
      key: "true",
      onClick: handlePrintData,
      disabled: disabledBtn,
      loading: loading
    }, radioSelect ? count ? "".concat(count, " \u6253\u5370") : '打印' : /*#__PURE__*/react.createElement("span", {
      style: {
        color: 'red'
      }
    }, "\u8BF7\u9009\u62E9\u6253\u5370\u673A")), null]
  }, ommit), render instanceof Function ? render(printListNode) : printListNode);
}

/***/ }),

/***/ 16266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57016);
/* harmony import */ var antd_es_table_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66456);
/* harmony import */ var antd_es_table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97423);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





/* harmony default export */ __webpack_exports__["Z"] = (props => {
  var isModalOpen = props.isModalOpen,
      setIsModalOpen = props.setIsModalOpen,
      stockList = props.stockList,
      exportData = props.exportData;
  var columns = [{
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId'
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName'
  }, {
    title: '单位',
    dataIndex: 'basicUnit',
    key: 'basicUnit'
  }, {
    title: '下单合计量',
    key: 'goodsQty',
    dataIndex: 'goodsQty'
  }, {
    title: '仓库库存量',
    key: 'inventoryQty',
    dataIndex: 'inventoryQty'
  }, {
    title: '缺量',
    key: 'diffQty',
    dataIndex: 'diffQty',
    render: (_, data) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
        style: {
          color: 'red'
        }
      }, _);
    }
  }];

  var showModal = () => {
    setIsModalOpen(true);
  };

  var handleOk = () => {
    var link = document.createElement('a');
    link.style.display = 'none';
    link.href = exportData;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setIsModalOpen(false);
  };

  var handleCancel = () => {
    setIsModalOpen(false);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    visible: isModalOpen,
    onOk: handleOk,
    onCancel: handleCancel,
    okText: "\u5BFC\u51FA",
    cancelText: "\u8FD4\u56DE\u4FEE\u6539",
    width: 800,
    type: "primary",
    cancelButtonProps: {
      type: "primary"
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("p", null, "\u5B58\u5728 ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
    style: {
      color: 'red'
    }
  }, " ", stockList ? stockList === null || stockList === void 0 ? void 0 : stockList.length : 0), " \u652F\u5546\u54C1\uFF0C\u4ED3\u5E93\u5E93\u5B58\u4E0D\u8DB3"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_table__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    columns: columns,
    dataSource: stockList
  })));
});

/***/ }),

/***/ 80441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/**
 * 详情页面的头部文案的布局展示
 */




var TextLine = props => {
  var text = props.text,
      label = props.label,
      _props$noBorder = props.noBorder,
      noBorder = _props$noBorder === void 0 ? false : _props$noBorder;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('titleLineWrap', {
      noBorder
    })
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "fk"
  }, label), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "wz"
  }, text));
};

/* harmony default export */ __webpack_exports__["Z"] = (TextLine);

/***/ }),

/***/ 84698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Style_module_less_modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13439);
/* harmony import */ var _Style_module_less_modules__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Style_module_less_modules__WEBPACK_IMPORTED_MODULE_2__);
/**
 * 标题tab切换功能组件
 */




function TitleTab(props) {
  var activeKey = props.activeKey,
      data = props.data,
      style = props.style,
      clickTitleCallback = props.clickTitleCallback;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Style_module_less_modules__WEBPACK_IMPORTED_MODULE_2___default().titleBar)),
    style: style
  }, data.map(val => {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      key: val.name,
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Style_module_less_modules__WEBPACK_IMPORTED_MODULE_2___default().titles), {
        [(_Style_module_less_modules__WEBPACK_IMPORTED_MODULE_2___default().active)]: activeKey === val.name
      }),
      onClick: () => clickTitleCallback(val)
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, val.title));
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (TitleTab);

/***/ }),

/***/ 84843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Uploader; }
});

// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/index.js
var style = __webpack_require__(34792);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(48086);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/upload/style/index.js
var upload_style = __webpack_require__(43185);
// EXTERNAL MODULE: ./node_modules/antd/es/upload/index.js + 12 modules
var upload = __webpack_require__(3388);
// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var button_style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/UploadOutlined.js + 1 modules
var UploadOutlined = __webpack_require__(84391);
;// CONCATENATED MODULE: ./src/components/Uploader/components/CommonUploader.tsx








function CommonUploader(props) {
  var _props$btnText, _props$btnText2;

  var disabled = props.uploadOptions.disabled;
  return /*#__PURE__*/react.createElement(upload/* default */.Z, (0,esm_extends/* default */.Z)({
    name: "file",
    accept: props.accept,
    action: props.action,
    data: props.data,
    beforeUpload: props.beforeUpload,
    onChange: props.handleChange
  }, props.uploadOptions), props.showType ? /*#__PURE__*/react.createElement("span", null, (_props$btnText = props.btnText) !== null && _props$btnText !== void 0 ? _props$btnText : "点击上传") : /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    loading: props.loading,
    disabled: props.loading || disabled,
    type: "primary"
  }, /*#__PURE__*/react.createElement(UploadOutlined/* default */.Z, null), " ", (_props$btnText2 = props.btnText) !== null && _props$btnText2 !== void 0 ? _props$btnText2 : "点击上传"));
}

/* harmony default export */ var components_CommonUploader = (CommonUploader);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/style/index.js
var modal_style = __webpack_require__(71194);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(57016);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlusOutlined.js + 1 modules
var PlusOutlined = __webpack_require__(49101);
;// CONCATENATED MODULE: ./src/components/Uploader/utils/constance.ts
// 上传前需要获取token的请求地址
var uploadTokenUrl = "purchase.basis.getToken";
var imgSuffix = ["image/jpeg", "image/gif", "image/png", "image/jpg"];
// EXTERNAL MODULE: ./src/components/Uploader/index.less?modules
var Uploadermodules = __webpack_require__(88856);
var Uploadermodules_default = /*#__PURE__*/__webpack_require__.n(Uploadermodules);
;// CONCATENATED MODULE: ./src/components/Uploader/components/UploadImg.tsx












/* eslint-disable no-throw-literal */




var suffixs = imgSuffix.join(",").replace(/\image/g, ""); // 获取图片信息

function readFiles(file, type) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onerror = error => reject(error);

    if (type === "url") {
      reader.onload = () => resolve(reader.result);
    } else {
      reader.onload = img => {
        var image = new Image();
        image.src = img.target.result;

        image.onload = function () {
          resolve(this);
        };
      };
    }
  });
}

function UploadImg(props) {
  var _props$accept, _props$btnText;

  var _useState = (0,react.useState)({
    visible: false,
    img: ""
  }),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      previewModal = _useState2[0],
      setPreviewModal = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      fileName = _useState4[0],
      setFileName = _useState4[1]; // 展示预览图


  var handlePreview = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(file) {
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log("handlePreview", file);

              if (!(!file.url && !file.preview)) {
                _context.next = 5;
                break;
              }

              _context.next = 4;
              return readFiles(file.originFileObj, "url");

            case 4:
              file.preview = _context.sent;

            case 5:
              setFileName(file === null || file === void 0 ? void 0 : file.name);
              setPreviewModal({
                visible: true,
                img: file.url || file.preview
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handlePreview(_x) {
      return _ref.apply(this, arguments);
    };
  }(); // 上传前的回调


  function beforeUpload(_x2) {
    return _beforeUpload.apply(this, arguments);
  }

  function _beforeUpload() {
    _beforeUpload = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3(file) {
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(resolve, reject) {
                  var isJpgOrPng, size, width, height, _size;

                  return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.prev = 0;
                          isJpgOrPng = imgSuffix.includes(file.type);

                          if (isJpgOrPng) {
                            _context2.next = 4;
                            break;
                          }

                          throw "\u53EA\u80FD\u4E0A\u4F20\u540E\u7F00\u540D\u4E3A\u3010".concat(suffixs, "\u3011\u7684\u6587\u4EF6");

                        case 4:
                          size = props.size, width = props.width, height = props.height; // 如果有传入参数限制图片大小

                          if (!size) {
                            _context2.next = 8;
                            break;
                          }

                          if (!(file.size / 1024 / 1024 > size / 1024)) {
                            _context2.next = 8;
                            break;
                          }

                          throw "\u4E0D\u80FD\u4E0A\u4F20\u8D85\u8FC7".concat(size, "K\u7684\u56FE\u7247");

                        case 8:
                          if (!(width || height)) {
                            _context2.next = 16;
                            break;
                          }

                          _context2.next = 11;
                          return readFiles(file, "size");

                        case 11:
                          _size = _context2.sent;

                          if (!(width && width > _size.width)) {
                            _context2.next = 14;
                            break;
                          }

                          throw "\u4E0A\u4F20\u56FE\u7247\u7684\u6700\u5927\u5BBD\u5EA6\u4E3A".concat(width, "px");

                        case 14:
                          if (!(height && height > _size.height)) {
                            _context2.next = 16;
                            break;
                          }

                          throw "\u4E0A\u4F20\u56FE\u7247\u7684\u6700\u5927\u9AD8\u5EA6\u4E3A".concat(height, "px");

                        case 16:
                          _context2.next = 18;
                          return props.beforeUpload(file);

                        case 18:
                          return _context2.abrupt("return", resolve(true));

                        case 21:
                          _context2.prev = 21;
                          _context2.t0 = _context2["catch"](0);

                          message.default.error(_context2.t0); // eslint-disable-next-line no-promise-executor-return


                          return _context2.abrupt("return", Promise.reject(_context2.t0));

                        case 25:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, null, [[0, 21]]);
                }));

                return function (_x3, _x4) {
                  return _ref2.apply(this, arguments);
                };
              }()));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _beforeUpload.apply(this, arguments);
  }

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(upload/* default */.Z, (0,esm_extends/* default */.Z)({
    name: "files",
    accept: (_props$accept = props.accept) !== null && _props$accept !== void 0 ? _props$accept : "image/*",
    listType: "picture-card",
    className: (Uploadermodules_default()).uploader,
    headers: {
      'res-token': props.data
    },
    data: props.data,
    action: props.action,
    beforeUpload: beforeUpload,
    onPreview: handlePreview,
    onChange: props.handleChange
  }, props.uploadOptions), props.loading ? // <LoadingOutlined />
  null : [/*#__PURE__*/react.createElement("div", {
    key: "text",
    className: (Uploadermodules_default()).uploadText
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(PlusOutlined/* default */.Z, {
    key: "icon",
    style: {
      fontSize: 18
    }
  })), (_props$btnText = props.btnText) !== null && _props$btnText !== void 0 ? _props$btnText : "上传图片")]), /*#__PURE__*/react.createElement(modal/* default */.Z, {
    visible: previewModal.visible,
    title: fileName,
    footer: null,
    onCancel: () => setPreviewModal(v => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
      visible: false
    }))
  }, /*#__PURE__*/react.createElement("img", {
    alt: "example",
    style: {
      width: "100%"
    },
    src: previewModal.img
  })));
}

/* harmony default export */ var components_UploadImg = (UploadImg);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
;// CONCATENATED MODULE: ./src/components/Uploader/utils/api.ts

var env = null;
var baseURL = '';
var uploadUrlNew = '';
var API_ENV = "prod" || 0;
var apiHead = 'https://apigw';

if (API_ENV === 'prod' || API_ENV === 'production') {
  env = 'prod';
  baseURL = 'https://apigw.ypshengxian.com';
  uploadUrlNew = 'https://api-resource.ypshengxian.com/resource/upload';
} else {
  if (API_ENV === 'dev') {
    env = 'dev';
    baseURL = 'https://apigw-dev.ypshengxian.com';
    uploadUrlNew = 'https://test-api-resource.ypshengxian.com/resource/upload';
  } else if (API_ENV === 'test') {
    env = 'test';
    baseURL = 'https://apigw-test.ypshengxian.com';
    uploadUrlNew = 'https://test-api-resource.ypshengxian.com/resource/upload';
  } else if (API_ENV === 'pre') {
    env = 'pre';
    baseURL = 'https://apigw-pre.ypshengxian.com';
    uploadUrlNew = 'https://pre-api-resource.ypshengxian.com/resource/upload';
  } else if (API_ENV === 'sit') {
    env = 'sit';
    baseURL = 'https://apigw-sit.ypshengxian.com';
    uploadUrlNew = 'https://sit-api-resource.ypshengxian.com/resource/upload';
  } else if (API_ENV === 'testdev') {
    env = 'test';
    baseURL = 'https://apigw-dev.ypshengxian.com';
    uploadUrlNew = 'https://test-api-resource.ypshengxian.com/resource/upload';
  }
}

/* harmony default export */ var api = ({
  env,
  uploadUrlNew,
  imgUrl: 'https://h5.ypshengxian.com/treaty/static/images/defaultimg.png',
  appVersionName: '1.0.0',
  appVersion: '1.0.0',
  baseURL,
  baseUrl: apiHead + '.ypshengxian.com/',
  urlFetch: apiHead + '.ypshengxian.com/request',
  baseUrlCheck: 'https://release.ypshengxian.com',
  appId: 'ypsypush',
  appPlatform: 'web'
}); // export default config
;// CONCATENATED MODULE: ./src/components/Uploader/index.tsx







/* eslint-disable no-throw-literal */







function Uploader(props) {
  var type = props.type,
      tokenUrl = props.tokenUrl;

  var _useState = (0,react.useState)(""),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      token = _useState2[0],
      setToken = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      actionUrl = _useState4[0],
      setActionUrl = _useState4[1];

  var _useState5 = (0,react.useState)(""),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      resId = _useState6[0],
      setResId = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var _useState9 = (0,react.useState)(),
      _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
      currentFile = _useState10[0],
      setCurrentFile = _useState10[1]; // 上传前  先获取 token


  var beforeUpload = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(file) {
      var _res, imgTokenAPI, url, res;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!props.beforeUpload) {
                _context.next = 6;
                break;
              }

              _context.next = 3;
              return props.beforeUpload(file);

            case 3:
              _res = _context.sent;

              if (_res) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", false);

            case 6:
              imgTokenAPI = "item.resource.getResourceToken";
              url = type === "img" ? imgTokenAPI : tokenUrl || uploadTokenUrl;
              _context.next = 10;
              return (0,ypRequest/* default */.Z)(url, {
                fileName: file.name,
                isPublic: true
              });

            case 10:
              res = _context.sent;
              return _context.abrupt("return", new Promise((resolve, reject) => {
                try {
                  // 获取上传的 token 失败
                  if (!res.success) {
                    var _res$message;

                    throw (_res$message = res.message) !== null && _res$message !== void 0 ? _res$message : "获取token失败";
                  } // debugger


                  var _ref2 = res.result,
                      tokenValue = _ref2.params,
                      endpoint = _ref2.endpoint,
                      _resId = _ref2.resId;

                  if (type === 'img') {
                    setActionUrl(api.uploadUrlNew);
                    setToken(res.result.token);
                    resolve(file);
                  } else {
                    setActionUrl(endpoint);
                    setToken(tokenValue);
                    setResId(_resId);
                    setCurrentFile(file);
                    resolve(file);
                  }
                } catch (error) {
                  message.default.error(error);

                  reject(file);
                }
              }));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function beforeUpload(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleChange = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(_ref3) {
      var file, name, uid, _file$response, code, msg, data, _message2, _props$onChange, fileOriginPath, obj, _props$onChange2;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref3.file;
              console.log(file);

              if (!(file.status === "uploading")) {
                _context2.next = 5;
                break;
              }

              setLoading(true);
              return _context2.abrupt("return");

            case 5:
              if (!(file.status === "error")) {
                _context2.next = 9;
                break;
              }

              message.default.error("\u3010".concat(file.name, "\u3011\u4E0A\u4F20\u5931\u8D25"));

              setLoading(false);
              return _context2.abrupt("return");

            case 9:
              if (!(file.status === "done")) {
                _context2.next = 17;
                break;
              }

              setLoading(false);
              name = file.name, uid = file.uid;
              _file$response = file.response, code = _file$response.code, msg = _file$response.msg, data = _file$response.data, _message2 = _file$response.message; // 上传失败

              if (!(code !== 200)) {
                _context2.next = 16;
                break;
              }

              _message2.error(msg);

              return _context2.abrupt("return");

            case 16:
              if (type === 'img') {
                // 设置 fileList
                fileOriginPath = data.url + '/' + data.files[0];
                obj = [{
                  uid,
                  name,
                  status: 'done',
                  url: fileOriginPath,
                  files: data.files[0]
                }]; // const newFileList = fileList.filter((v: any) => !!v.url).concat(obj)
                // setFileList(obj)

                (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, obj, _message2, currentFile);
              } else {
                (_props$onChange2 = props.onChange) === null || _props$onChange2 === void 0 ? void 0 : _props$onChange2.call(props, resId, _message2, currentFile);
              }

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleChange(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  var uploadCommonProps = {
    action: actionUrl,
    data: token,
    loading: props.loading || loading,
    beforeUpload,
    handleChange
  };

  if (type === "img") {
    return /*#__PURE__*/react.createElement(components_UploadImg, (0,esm_extends/* default */.Z)({}, props, uploadCommonProps));
  }

  return /*#__PURE__*/react.createElement(components_CommonUploader, (0,esm_extends/* default */.Z)({}, props, uploadCommonProps));
}

/* harmony default export */ var components_Uploader = (Uploader);

/***/ }),

/***/ 27088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useRouter; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8870);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5977);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36855);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


/**
 * hooks获取history参数等
 */


 // Hook

var useRouter = () => {
  var params = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .useParams */ .UO)();
  var location = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .useLocation */ .TH)();
  var history = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .useHistory */ .k6)();
  var match = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .useRouteMatch */ .$B)();
  return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => {
    return {
      push: history.push,
      replace: history.replace,
      pathname: location.pathname,
      query: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)({}, query_string__WEBPACK_IMPORTED_MODULE_0__.parse(location.search)), params),
      match,
      location,
      history
    };
  }, [params, match, location, history]);
}; // 使用
// function MyComponent(){
//   const router = useRouter();
//   // 获取参数 (?postId=123) or (/:postId)
//   console.log(router.query.postId);
//   // 获取路由
//   console.log(router.pathname)
// }

/***/ }),

/***/ 71651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2824);
/* harmony import */ var antd_es_upload_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43185);
/* harmony import */ var antd_es_upload__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3388);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24731);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43347);







var Dragger = antd_es_upload__WEBPACK_IMPORTED_MODULE_4__/* .default.Dragger */ .Z.Dragger;


var YPDragger = props => {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState, 2),
      resId = _useState2[0],
      setResId = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState3, 2),
      token = _useState4[0],
      setToken = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState5, 2),
      endpoint = _useState6[0],
      setEndpoint = _useState6[1];

  var _props$showUploadList = props.showUploadList,
      showUploadList = _props$showUploadList === void 0 ? true : _props$showUploadList,
      fileList = props.fileList;

  var beforeUpload = file => {
    var name = file.name;
    var isExcel = !!name.includes('xls');
    var limit = props.limit,
        tokenApi = props.tokenApi;

    if (limit) {
      var isLt1M = file.size / 1024 / 1024 < limit;

      if (!isLt1M) {
        antd_es_message__WEBPACK_IMPORTED_MODULE_6__.default.error("\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7".concat(limit, "M"));

        return;
      }
    }

    return new Promise((resolve, reject) => {
      var fileType = 2; // 非图片资源类型

      if (props.mode === 'img' || props.mode === 'image') {
        fileType = 1; // 图片资源类型
      }

      if (!isExcel) {
        antd_es_message__WEBPACK_IMPORTED_MODULE_6__.default.error('只能上传excel文件');

        reject(file);
        return;
      }

      var args = {
        fileName: name // type: fileType,

      };
      var url;
      url = tokenApi || 'kernel.console.BatchToolsService.getUploadFileToken';

      if (props.tokenUrl) {
        url = props.tokenUrl;
      }

      if (props.tokenUrl2) {
        url = props.tokenUrl2;
      }

      (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(url, args).then(res => {
        var success = res.success,
            result = res.result,
            errorCode = res.errorCode,
            errorMessage = res.errorMessage;

        if (success) {
          if (props.tokenUrl) {
            // 返参不一致
            var uploadToken = result.uploadToken;
            setEndpoint(uploadToken.endpoint);
            setToken(uploadToken.params);
            setResId(uploadToken.resId);
            resolve(file);
          } else if (props.tokenUrl2) {
            setEndpoint(result.endpoint);
            setToken(result.params);
            setResId(result.resId);
            resolve(file);
          } else {
            setEndpoint(result.endpoint);
            setToken(result.params);
            setResId(result.resId);
            resolve(file);
          }
        } else {
          antd_es_message__WEBPACK_IMPORTED_MODULE_6__.default.error(errorCode, errorMessage);
        }
      });
    });
  };

  var _onChange = (e, resId) => {
    props.onChange(e, resId);
  };

  var _onRemove = e => {
    props.onRemove(e);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(Dragger, {
    name: "file",
    multiple: true,
    className: "avatar-uploader",
    action: endpoint,
    beforeUpload: beforeUpload,
    data: token,
    fileList: fileList,
    onChange: e => {
      _onChange(e, resId);
    },
    onRemove: e => {
      _onRemove(e);
    },
    accept: ".xlsx,.xls",
    showUploadList: showUploadList
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
    style: {
      color: '#1890ff',
      fontSize: '55px'
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("p", {
    className: "ant-upload-text"
  }, "\u70B9\u51FB\u6216\u62D6\u62FD\u4E0A\u4F20\u6587\u4EF6"));
};

/* harmony default export */ __webpack_exports__["Z"] = (YPDragger);

/***/ }),

/***/ 52882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var CommonWrap = props => {
  var cls = props.cls; // const [flag, setFlag] = useState(true)

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var logFlag = sessionStorage.getItem('logFlag');

    if (!logFlag) {
      var env = 'prod'; // const shopInfo = ypStore.get(SHOP_CURRENT)
      // const employee = ypStore.get('employee')

      var clientWidth = document.body.clientWidth;
      var clientHeight = document.body.clientHeight;
      var screenHeight = window.screen.height;
      var screenWidth = window.screen.width;
      sessionStorage.setItem('logFlag', '1'); // if (token && shopInfo && employee && employee.phone) {
      //   const OSVAL = `${browser.getOS().name}-${browser.getOS().versionName}-${
      //     browser.getOS().version
      //   }`
      //   const msg2 = `${shopInfo.name}门店员工-${employee.relName}-${
      //     employee.phone
      //   }在${moment().format(
      //     'YYYY-MM-DD HH:mm:ss'
      //   )}用${OSVAL}打开系统，,网页可见区域${clientWidth}*${clientHeight},屏幕分辨率${screenWidth}*${screenHeight}`
      //   if (env === 'prod') {
      //     ;(window as any)._czc.push(['_trackEvent', '每日记录', '信息', msg2])
      //   }
      // }
    } // ypEvent.on('open_hide', values => {
    //   setFlag(values)
    // })
    // return () => {
    //   cleanup
    // }

  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "commonWrap ".concat(cls),
    id: props.id // style={{ overflow: flag ? 'hidden' : 'hidden scroll' }}

  }, props.children);
};

CommonWrap.defaultProps = {
  type: 1,
  id: 1
};
/* harmony default export */ __webpack_exports__["Z"] = (CommonWrap);

/***/ }),

/***/ 37734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ YpshopCps_EditableTable; }
});

// NAMESPACE OBJECT: ./src/components/YpshopCps/EditableTable/components/Field.tsx
var Field_namespaceObject = {};
__webpack_require__.r(Field_namespaceObject);
__webpack_require__.d(Field_namespaceObject, {
  "DATE_PICKER": function() { return DATE_PICKER; },
  "INPUT": function() { return INPUT; },
  "INPUT_NUMBER": function() { return INPUT_NUMBER; },
  "RANGE_PICKER": function() { return RANGE_PICKER; },
  "SELECT": function() { return SELECT; }
});

// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/CommonTable/index.tsx + 3 modules
var CommonTable = __webpack_require__(40934);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js
var createForOfIteratorHelper = __webpack_require__(91220);
// EXTERNAL MODULE: ./node_modules/antd/es/popconfirm/style/index.js
var popconfirm_style = __webpack_require__(62350);
// EXTERNAL MODULE: ./node_modules/antd/es/popconfirm/index.js
var popconfirm = __webpack_require__(75443);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(93224);
// EXTERNAL MODULE: ./node_modules/antd/es/input-number/style/index.js
var input_number_style = __webpack_require__(77883);
// EXTERNAL MODULE: ./node_modules/antd/es/input-number/index.js + 2 modules
var input_number = __webpack_require__(39635);
// EXTERNAL MODULE: ./node_modules/antd/es/input/style/index.js
var input_style = __webpack_require__(47673);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 3 modules
var es_input = __webpack_require__(4107);
// EXTERNAL MODULE: ./node_modules/antd/es/select/style/index.js
var select_style = __webpack_require__(43358);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js
var es_select = __webpack_require__(34041);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/style/index.js
var date_picker_style = __webpack_require__(14965);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/index.js + 6 modules
var date_picker = __webpack_require__(11448);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/components/YpshopCps/EditableTable/components/Field.tsx











var _excluded = ["formatter"];

/* eslint-disable no-unused-expressions */


var RangePicker = date_picker/* default.RangePicker */.Z.RangePicker;
/**
 * 下拉框控件
 */

var SELECT = props => {
  var fieldOptions = props.fieldOptions,
      dataList = props.dataList,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue;
  return /*#__PURE__*/react.createElement(es_select/* default */.Z, (0,esm_extends/* default */.Z)({
    showSearch: true,
    onBlur: () => fieldChange(''),
    dropdownMatchSelectWidth: false,
    value: fieldValue,
    filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
  }, fieldOptions, {
    onChange: fieldChange,
    style: {
      width: '100%'
    }
  }), dataList.map(item => {
    var value = item.value,
        label = item.label;
    return /*#__PURE__*/react.createElement(es_select/* default.Option */.Z.Option, {
      key: value,
      value: value,
      rows: item
    }, label);
  }));
};
/**
 * 输入框控件
 */

var INPUT = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      editing = props.editing,
      fieldValue = props.fieldValue;

  var _ref = fieldOptions || {},
      formatter = _ref.formatter,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var inputRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      input = _useState2[0],
      setInput = _useState2[1];

  (0,react.useEffect)(() => {
    setInput(fieldValue);
  }, [fieldValue]);

  var save = () => {
    var val = input === null || input === void 0 ? void 0 : input.toString().replace(/(^\s*)|(\s*$)/g, '');
    fieldChange(val);
  };

  var changeField = e => {
    var value = e.target.value;

    if (formatter) {
      value = formatter(value);
    }

    setInput(value);
  };

  (0,react.useEffect)(() => {
    if (editing) {
      var _inputRef$current, _inputRef$current2;

      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
      (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.select();
    }
  }, [editing]);
  return /*#__PURE__*/react.createElement(es_input/* default */.Z, (0,esm_extends/* default */.Z)({}, rest, {
    ref: inputRef,
    value: input,
    onChange: changeField,
    onPressEnter: save,
    onBlur: save
  }));
};
/**
 * 时间范围控件
 */

var RANGE_PICKER = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue;
  var format = (fieldOptions === null || fieldOptions === void 0 ? void 0 : fieldOptions.fieldOptions) || 'YYYY-MM-DD';
  var value = Array.isArray(fieldValue) ? fieldValue : [];
  var defaultStart = fieldValue ? moment_default()(value[0]) : undefined;
  var defaultEnd = fieldValue ? moment_default()(value[1]) : undefined;

  var handleChange = e => {
    if (!e) {
      fieldChange(undefined);
      return;
    }

    var value = Array.isArray(e) ? e : [];
    var start = moment_default()(value[0]).format(format);
    var end = moment_default()(value[1]).format(format);
    fieldChange("".concat(start, " ~ ").concat(end));
  };

  return /*#__PURE__*/react.createElement(RangePicker, (0,esm_extends/* default */.Z)({
    allowClear: true,
    autoFocus: true,
    style: {
      width: '100%'
    },
    format: [format, format],
    placeholder: ['开始', '结束']
  }, fieldOptions, {
    defaultValue: [defaultStart, defaultEnd],
    onChange: handleChange
  }));
};
/**
 * 时间选择控件
 */

var DATE_PICKER = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue;
  var format = (fieldOptions === null || fieldOptions === void 0 ? void 0 : fieldOptions.fieldOptions) || 'YYYY-MM-DD';
  var defaultValue = fieldValue ? moment_default()(fieldValue) : undefined;

  var handleChange = e => {
    var data = moment_default()(e).format(format);
    fieldChange(data);
  };

  return /*#__PURE__*/react.createElement(date_picker/* default */.Z, (0,esm_extends/* default */.Z)({
    allowClear: true,
    autoFocus: true,
    style: {
      width: '100%'
    },
    format: format,
    placeholder: "\u8BF7\u9009\u62E9"
  }, fieldOptions, {
    defaultValue: defaultValue,
    onBlur: () => fieldChange(''),
    onChange: handleChange
  }));
};
/**
 * 数值控件
 */

var INPUT_NUMBER = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      editing = props.editing,
      fieldValue = props.fieldValue;
  var inputRef = (0,react.useRef)(); // const [val, setVal] = useState<number | undefined | string>(fieldValue)

  var save = e => {
    var val = e.target.value;
    var value = val === '' || val === 'undefined' || val === null ? undefined : val;
    fieldChange(value);
  }; // const changeValue = (v: number | undefined) => {
  //   setVal(v)
  // }


  (0,react.useEffect)(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);
  return /*#__PURE__*/react.createElement(input_number/* default */.Z, (0,esm_extends/* default */.Z)({
    style: {
      width: '100%'
    }
  }, fieldOptions, {
    ref: inputRef,
    defaultValue: fieldValue // onChange={changeValue}
    ,
    onPressEnter: save,
    onBlur: save
  }));
}; // export const SELECT_INPUT_NUMBER = (props: FieldsProps) => {
//   const { fieldOptions, dataList, fieldChange, fieldValue } = props
//   return (
//     <AutoComplete
//       options={dataList}
//       allowClear
//       showSearch
//        value={fieldValue}
//       filterOption={(input, option: any) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
//       {...fieldOptions}
//       onChange={fieldChange}
//     >
//       <InputNumber
//         placeholder='input here'
//         className='custom'
//         style={{ height: 50 }}
//         // onKeyPress={handleKeyPress}
//       />
//     </AutoComplete>
//   )
// }
;// CONCATENATED MODULE: ./src/components/YpshopCps/EditableTable/utils/context.tsx

var EditableContext = /*#__PURE__*/react.createContext({});
;// CONCATENATED MODULE: ./src/components/YpshopCps/EditableTable/hooks/getContentValue.ts
/**
 * 单元格的数据格式化
 */
function getContentValue(props) {
  var children = props.children,
      dataList = props.dataList; // 针对存在「list」的单元格进行设置；使单元格展示的是文案而不是值

  if (!Array.isArray(children)) {
    return children;
  }
  /**
   * 如果当前单元格的 可编辑 状态是 Select、Radio等具有「list」属性的表单控件
   * 1. 对该值进行判断校验
   * 2. 最后获取到该值对应的 中文 文案，并交给Table渲染该单元格
   */


  var val = children.slice(1)[0];
  var childType = typeof val;

  if (val === '' || val === undefined || val === null) {
    return children;
  }

  if (childType === 'object' || childType === 'function') {
    return children;
  } // 过滤可能出现的不必要的标签


  var newChildren = childType === 'string' ? val.replace('<tt>', '').replace('</tt>', '') : val;

  if (!dataList) {
    return [undefined, newChildren];
  }

  var _ref = dataList.find(v => v.value.toString() === val.toString()) || {},
      label = _ref.label;

  return [undefined, label !== null && label !== void 0 ? label : val];
}

/* harmony default export */ var hooks_getContentValue = (getContentValue);
;// CONCATENATED MODULE: ./src/components/YpshopCps/EditableTable/components/EditableCell.tsx






var EditableCell_excluded = ["title", "editable", "children", "dataIndex", "type", "record", "rowIndex", "render", "editIndex", "dataList", "fieldOptions", "setCellRowValueByChange", "toggleEditCell"];







var Field = Field_namespaceObject;

var EditableCell = props => {
  var title = props.title,
      editable = props.editable,
      children = props.children,
      dataIndex = props.dataIndex,
      type = props.type,
      record = props.record,
      rowIndex = props.rowIndex,
      render = props.render,
      colIndex = props.editIndex,
      _props$dataList = props.dataList,
      componentDataList = _props$dataList === void 0 ? [] : _props$dataList,
      componentFieldOptions = props.fieldOptions,
      setCellRowValueByChange = props.setCellRowValueByChange,
      toggleEditCell = props.toggleEditCell,
      restProps = (0,objectWithoutProperties/* default */.Z)(props, EditableCell_excluded);

  var _useContext = (0,react.useContext)(EditableContext),
      handleDeleteRow = _useContext.handleDeleteRow,
      handleSaveRow = _useContext.handleSaveRow,
      hideDeleteBtn = _useContext.hideDeleteBtn; // 拼接操作


  if (render && title === '操作') {
    var deleteBtn = /*#__PURE__*/react.createElement(popconfirm/* default */.Z, {
      title: "\u786E\u8BA4\u5220\u9664\u8FD9\u6761\u6570\u636E\u5417\uFF1F",
      onConfirm: () => {
        if (handleDeleteRow) {
          handleDeleteRow(record.editableTableKey);
        }
      },
      okText: "\u786E\u8BA4",
      cancelText: "\u53D6\u6D88"
    }, /*#__PURE__*/react.createElement("a", {
      style: {
        marginRight: '8px'
      }
    }, "\u5220\u9664")); // 给新增的行添加背景颜色

    return /*#__PURE__*/react.createElement("td", restProps, !hideDeleteBtn && deleteBtn, render(record[dataIndex], record, rowIndex, deleteBtn));
  } // 自定义渲染的文本标签


  var renderRef = (0,react.useRef)(null); // 设置type的文本标签

  var textRef = (0,react.useRef)(null); // 单元格是否处于编辑状态

  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      editing = _useState2[0],
      setEditing = _useState2[1];
  /**
   * 下拉框组件的数据
   */


  var dataList = (0,react.useMemo)(() => {
    var isFunc = typeof componentDataList === 'function';

    if (isFunc) {
      var _ref;

      return (_ref = componentDataList(record[dataIndex], record, rowIndex)) !== null && _ref !== void 0 ? _ref : [];
    }

    return componentDataList !== null && componentDataList !== void 0 ? componentDataList : [];
  }, [componentDataList, record, dataIndex, rowIndex]);
  /**
   * 组件的属性
   */

  var fieldOptions = (0,react.useMemo)(() => {
    var isFunc = typeof componentFieldOptions === 'function';

    if (isFunc) {
      return componentFieldOptions(record[dataIndex], record, rowIndex);
    }

    return componentFieldOptions !== null && componentFieldOptions !== void 0 ? componentFieldOptions : {};
  }, [dataIndex, componentFieldOptions, record, rowIndex]); // 每条数据添加「editableTableKey」属性，相当于主键ID

  (0,react.useEffect)(() => {
    // 防止重复生成ID，预防后续操作的数据无法追溯
    if (record && !record.editableTableKey) {
      record.editableTableKey = getEditableTableKey();
    }
  }, [record]); // 如果没有传「type」时设置默认是「INPUT」
  // 传了「type」 可以不传 「editable」

  var fieldType = !type && editable ? 'INPUT' : type; // 更改单元格的编辑状态

  var toggleEdit = bool => {
    var boolean = bool !== null && bool !== void 0 ? bool : !editing; // 触发回调

    if (toggleEditCell && typeof toggleEditCell === 'function') {
      toggleEditCell(boolean, record[dataIndex], record, rowIndex);
    }

    setEditing(boolean);
  }; // 控件发生变化时


  var fieldChange = (val, o) => {
    try {
      // 切换编辑状态
      toggleEdit(); // 是否修改过数据

      var hasEdited = record[dataIndex] !== val; // 防止Select组件，未选择时导致问题
      // 防止InputNumber组件返回空时，逻辑被过滤

      if (!val && val !== 0 && type === 'SELECT' || !hasEdited) {
        return;
      } // 更新后的本行数据


      var params = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, record), {}, {
        [dataIndex]: val
      });

      if (setCellRowValueByChange && typeof setCellRowValueByChange === 'function') {
        var res = setCellRowValueByChange(val, params, o);
        params = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, params), res);
      } // 如果自定义了回调


      if (fieldOptions !== null && fieldOptions !== void 0 && fieldOptions.onChange) {
        fieldOptions.onChange(params);
      } // 单元格字段名对于的数据


      var currentCell = {
        [dataIndex]: val
      }; // 单元格老数据

      var currentCellOldData = {
        [dataIndex]: record[dataIndex]
      };

      if (handleSaveRow) {
        handleSaveRow(params, {
          hasEdited,
          currentCell,
          currentCellOldData
        });
      }
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  }; // 设置组件回显的值


  var defaultVal = record ? record[dataIndex] : undefined; // 单元格组件的样式类

  var fieldCls = (0,react.useMemo)(() => classnames_default()("editing-".concat(fieldType, "-").concat(colIndex, "-").concat(rowIndex), {
    'edittable-hide': !editing
  }), [colIndex, editing, fieldType, rowIndex]); // 单元格文本的样式类

  var textCls = (0,react.useMemo)(() => classnames_default()("text-".concat(fieldType, "-").concat(colIndex, "-").concat(rowIndex), 'editableCellValueWrap', {
    'edittable-hide': editing
  }), [colIndex, editing, fieldType, rowIndex]);
  /**
   * 监听文本标签的样式类的变化
   */

  (0,react.useEffect)(() => {
    var element = render ? renderRef.current : textRef.current;
    if (!element) return;
    var observer = new MutationObserver(mutationsList => {
      var _iterator = (0,createForOfIteratorHelper/* default */.Z)(mutationsList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutation = _step.value;

          if (mutation.type === 'attributes') {
            var classList = mutation.target.classList;
            var clsList = Array.from(classList);

            if (clsList.includes('edittable-change-to-edit')) {
              setEditing(true);
            } else {
              break;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    observer.observe(element, {
      attributes: true
    });
    return () => {
      observer.disconnect();
    };
  }, [renderRef, textRef, render]);
  /**
   * 如果存在自定义渲染的情况，给「render」函数的第四项添加参数
   */

  if (render) {
    var getFieldComponent = renderParams => {
      var FieldElement = null;
      var childContent = hooks_getContentValue({
        children,
        dataList: renderParams.dataList
      });

      if (renderParams.fieldType) {
        var FieldComponent = Field[renderParams.fieldType];
        FieldElement = /*#__PURE__*/react.createElement("div", {
          className: fieldCls
        }, /*#__PURE__*/react.createElement(FieldComponent, {
          fieldOptions: renderParams.fieldOptions,
          dataList: renderParams.dataList,
          fieldChange: fieldChange,
          toggleEdit: toggleEdit,
          fieldValue: renderParams.value || defaultVal,
          editing: editing
        }));
      }

      return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
        className: textCls,
        onClick: () => toggleEdit(),
        ref: renderRef
      }, childContent), FieldElement);
    };

    return /*#__PURE__*/react.createElement("td", restProps, render(record[dataIndex], record, rowIndex, getFieldComponent));
  } // 格式化单元格文本内容和下拉数据


  var childContent = hooks_getContentValue({
    children,
    dataList
  });
  var childNode = childContent;

  if (fieldType) {
    var FieldComponent = Field[fieldType];
    childNode = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
      className: textCls,
      onClick: () => toggleEdit(),
      ref: textRef
    }, childContent), /*#__PURE__*/react.createElement("div", {
      className: fieldCls
    }, /*#__PURE__*/react.createElement(FieldComponent, {
      fieldOptions: fieldOptions,
      dataList: dataList,
      fieldChange: fieldChange,
      toggleEdit: toggleEdit,
      fieldValue: defaultVal,
      editing: editing
    })));
  }

  return /*#__PURE__*/react.createElement("td", restProps, childNode);
};

/* harmony default export */ var components_EditableCell = (EditableCell);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlusOutlined.js + 1 modules
var PlusOutlined = __webpack_require__(49101);
// EXTERNAL MODULE: ./src/hooks/useCompareEffect.ts
var useCompareEffect = __webpack_require__(19125);
;// CONCATENATED MODULE: ./src/components/YpshopCps/EditableTable/utils/constance.ts
var tableOptionsCol = {
  title: '操作',
  dataIndex: 'operatess',
  key: 'operatess',
  fixed: 'right',
  width: 120,
  render: () => null
};
;// CONCATENATED MODULE: ./src/components/YpshopCps/EditableTable/PageEditableTable.tsx








/**
 * 通用 可编辑 表格
 */









 // 获取唯一的key

function getEditableTableKey() {
  return lodash_default().uniqueId('edittable_');
}
/**
 * 对比和替换列表数据
 * @param list 列表数据
 * @param data 更新后的 列表行数据
 */

function compareAndChangeData(list, data) {
  return list.map(v => v.editableTableKey === data.editableTableKey ? data : v);
}

var PageEditableTable = (props, ref) => {
  var _props$pageSize;

  var tableOptions = props.tableOptions,
      onTableParamsChange = props.onTableParamsChange,
      _onChange = props.onChange,
      returnData = props.returnData,
      addRow = props.addRow,
      saveRow = props.saveRow,
      deleteRow = props.deleteRow;
  var table = (0,react.useRef)(null);

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      selectedRowKeys = _useState2[0],
      setSelectedRowKeys = _useState2[1];

  var _useState3 = (0,react.useState)({
    dataSource: [],
    loading: false,
    total: 0,
    current: 1,
    pageSize: (_props$pageSize = props.pageSize) !== null && _props$pageSize !== void 0 ? _props$pageSize : 10,
    order: {},
    filters: {},
    sorters: {}
  }),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      tableParams = _useState4[0],
      setTableParams = _useState4[1]; // 过滤无效的columns项


  var usefulColumns = (0,react.useMemo)(() => props.columns.filter(Boolean), [props.columns]);

  var addRowData = () => {
    return usefulColumns.reduce((prev, next) => {
      prev[next.dataIndex] = undefined; // 每个新增的数据都设置一个键为「editableTableKey」的随机值

      prev['editableTableKey'] = getEditableTableKey(); // 标记，表示当前行是未保存的新增状态

      prev['editableTableAdd'] = true;
      return prev;
    }, {});
  }; // 新增行


  var handleAddRow = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
      var newRows, list, dataParams;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              newRows = addRowData(); // 数据拼接

              list = [newRows, ...tableParams.dataSource];

              if (tableParams.dataSource.length >= tableParams.pageSize) {
                // 删除最后一项
                list.pop();
              }

              if (_onChange) {
                /**
                 * currentCell：当前编辑的单元格数据，{字段名：值}
                 * currentCellOldData：当前编辑的单元格老数据
                 * currentRow：当前编辑的行数据
                 * dataSource：表格所有数据
                 */
                dataParams = {
                  currentCell: {},
                  currentCellOldData: {},
                  currentRow: newRows,
                  dataSource: list,
                  type: 'ADD'
                };

                _onChange(dataParams, selectedRowKeys);
              } // 如果存在异步函数


              if (!addRow) {
                _context.next = 10;
                break;
              }

              _context.next = 8;
              return addRow(addRowData, list);

            case 8:
              _context.next = 11;
              break;

            case 10:
              setTableParams(v => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
                dataSource: list
              }));

            case 11:
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              console.error('add row failed：', _context.t0);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 13]]);
    }));

    return function handleAddRow() {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * 保存表格行数据
   * @param data 当前修改保存的表格行所有数据
   * @param other 其他参数
   */


  var handleSaveRow = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(data, other) {
      var hasEdited, currentCell, currentCellOldData, list, selectedKeys, dataParams;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              // hasEdited，数据是否变化
              hasEdited = other.hasEdited, currentCell = other.currentCell, currentCellOldData = other.currentCellOldData;

              if (hasEdited) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              // 赋值更新 列表数据
              list = compareAndChangeData(tableParams.dataSource, data); // 更新选中的数据

              selectedKeys = compareAndChangeData(selectedRowKeys, data);

              if (_onChange) {
                /**
                 * currentCell：当前编辑的单元格数据，{字段名：值}
                 * currentCellOldData：当前编辑的单元格老数据
                 * currentRow：当前编辑的行数据
                 * dataSource：表格所有数据
                 */
                dataParams = {
                  currentCell,
                  currentCellOldData,
                  currentRow: data,
                  dataSource: list,
                  type: 'EDIT'
                };

                _onChange(dataParams, selectedKeys);
              } // 如果存在异步保存函数


              if (saveRow) {
                saveRow(data, list);
              } else {
                setTableParams(v => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
                  dataSource: list
                }));
                setSelectedRowKeys(selectedKeys);
              }

              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              console.error('save row failed：', _context2.t0);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [_onChange, saveRow, selectedRowKeys, tableParams.dataSource]);
  /**
   * 删除行
   * @param i 删除行对应的 editableTableKey 值
   */

  var handleDeleteRow = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3(i) {
      var obj, list, deleteCallBack, result;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              obj = tableParams.dataSource.find(v => v.editableTableKey === i) || {};
              list = tableParams.dataSource.filter(v => v.editableTableKey !== i); // 删除回调

              deleteCallBack = () => {
                // 如果删除的是已经选中的行数据，过滤了
                var selectedRows = selectedRowKeys.length ? selectedRowKeys.filter(vi => vi.editableTableKey !== i) : [];
                setSelectedRowKeys(selectedRows);

                if (_onChange) {
                  /**
                   * currentCell：当前编辑的单元格数据，{字段名：值}
                   * currentCellOldData：当前编辑的单元格老数据
                   * currentRow：当前编辑的行数据
                   * dataSource：表格所有数据
                   */
                  var dataParams = {
                    currentCell: {},
                    currentCellOldData: {},
                    currentRow: obj,
                    dataSource: list,
                    type: 'DELETE'
                  }; // 如果存在 onChange 则将删除后的结果数据返回

                  _onChange(dataParams, selectedRows);
                } // 将之前新增时模拟删除的一项数据加回来


                setTableParams(v => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
                  dataSource: list
                }));
              }; // 删除


              if (!deleteRow) {
                _context3.next = 11;
                break;
              }

              _context3.next = 7;
              return deleteRow(obj, list);

            case 7:
              result = _context3.sent;

              // 删除成功
              if (result) {
                deleteCallBack();
              }

              _context3.next = 12;
              break;

            case 11:
              deleteCallBack();

            case 12:
              _context3.next = 17;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](0);
              console.error('delete row failed：', _context3.t0);

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 14]]);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }(), [deleteRow, _onChange, selectedRowKeys, tableParams.dataSource]);
  /**
   * 表格的页面切换、展示页数量调整等回调操作
   * @param data tableParams的回调数据
   */

  var handleTableChange = (0,react.useCallback)((data, params) => {
    setTableParams(params);
    setSelectedRowKeys([]);

    if (returnData) {
      returnData(data, params);
    }
  }, [returnData]);
  /**
   * 暴露给父组件使用的方法
   */

  (0,react.useImperativeHandle)(ref, () => ({
    reflashTable: params => table.current.reflashTable(params),
    getTableData: () => tableParams
  }), [tableParams]); // 如果没有设置「hideDeleteBtn」，给「columns」拼接操作表头，并补上删除功能

  var renderCol = (0,react.useMemo)(() => {
    if (props.hideDeleteBtn) {
      return usefulColumns;
    }

    return usefulColumns.every(v => v.title !== '操作') ? [...usefulColumns, tableOptionsCol] : usefulColumns;
  }, [usefulColumns, props.hideDeleteBtn]);

  var _useMemo = (0,react.useMemo)(() => renderCol.reduce((pre, next) => {
    // 如果当前column不存在 editable 字段、表头文案不是操作以及没有 type 值，表示当前单元格展示的是文案而不是表单组件
    if (!next.editable && !next.type && !next.render && next.title !== '操作') {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, pre), {}, {
        columns: [...pre.columns, next]
      });
    }

    var index = next.editable || next.type ? pre.editIndex + 1 : pre.editIndex;
    return {
      columns: [...pre.columns, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, next), {}, {
        onCell: (record, rowIndex) => {
          return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, next), {}, {
            rowIndex,
            record,
            editIndex: index === 0 ? undefined : index // 可编辑的单元格的序号

          });
        }
      })],
      editIndex: index
    };
  }, {
    columns: [],
    editIndex: 0
  }), [renderCol]),
      columns = _useMemo.columns;

  var selection = (0,react.useMemo)(() => ({
    selectedRowKeys: selectedRowKeys,
    onChange: keys => {
      setSelectedRowKeys(keys);

      if (_onChange) {
        var dataParams = {
          currentCell: {},
          currentCellOldData: {},
          currentRow: {},
          dataSource: tableParams.dataSource,
          type: 'SELECTED'
        };

        _onChange(dataParams, keys);
      }
    }
  }), [_onChange, selectedRowKeys, tableParams.dataSource]);
  /**
   * 获取CommonTable的selection配置
   * 缓存 rowselect 配置
   */

  var getRowSelection = (0,react.useMemo)(() => {
    // 如果没有自定义配置「rowSelection」以及没有「rowSelectCallback」表示不需要列表多选
    if (!(tableOptions !== null && tableOptions !== void 0 && tableOptions.rowSelection) && !props.rowSelectCallback) {
      return undefined;
    } // 自定义多选


    if (tableOptions && tableOptions.rowSelection) {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, tableOptions.rowSelection), selection);
    } // 默认的多选


    if (props.rowSelectCallback) {
      return selection;
    }
  }, [props.rowSelectCallback, selection, tableOptions]);
  (0,react.useEffect)(() => {
    if (onTableParamsChange) {
      onTableParamsChange(tableParams);
    }
  }, [tableParams, onTableParamsChange]);
  /**
   * 更新某一行的数据
   */

  (0,useCompareEffect/* default */.Z)(() => {
    var updateDataSource = props.updateDataSource;

    if (!updateDataSource || lodash_default().isEmpty(updateDataSource)) {
      return;
    }

    var dataSource = tableParams.dataSource,
        pageSize = tableParams.pageSize;
    var list = dataSource;

    if (Array.isArray(updateDataSource)) {
      // 生成对象：{editableTableKey: data}
      var rows = updateDataSource.reduce((pre, next) => {
        var key = next.editableTableKey; // 存在 editableTableKey，表示该项为修改；不存在表示该项为新增

        if (key) {
          pre[key] = next; // 记录「editRowLength」，表示要编辑的行数

          pre.editRowLength = ++pre.editRowLength;
        } else {
          // 新增
          var _obj = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, next), {}, {
            editableTableAdd: true
          });

          pre.add = pre.add.concat(_obj);
        }

        return pre;
      }, {
        add: [],
        editRowLength: 0
      }); // 存在要编辑的表格行

      if (rows.editRowLength > 0) {
        // 将编辑的数据更新到 dataSource
        list = dataSource.map(v => {
          var _rows$v$editableTable;

          return (_rows$v$editableTable = rows[v.editableTableKey]) !== null && _rows$v$editableTable !== void 0 ? _rows$v$editableTable : v;
        });
      } // 添加数据


      if (rows.add.length > 0) {
        list = rows.add.concat(list);

        if (list.length > +pageSize) {
          // 选取出列表单页的限额数据量，将其加入列表数据
          list = list.slice(0, +pageSize);
        }
      }
    } else {
      list = compareAndChangeData(dataSource, updateDataSource);
    }

    setTableParams(v => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
      dataSource: list
    }));
  }, [props.updateDataSource, selectedRowKeys]);
  return /*#__PURE__*/react.createElement(EditableContext.Provider, {
    value: {
      handleDeleteRow,
      handleSaveRow,
      hideDeleteBtn: props.hideDeleteBtn
    }
  }, /*#__PURE__*/react.createElement(CommonTable/* default */.Z, (0,esm_extends/* default */.Z)({
    ref: table
  }, props, {
    columns: columns,
    queryDataUrl: props.queryDataUrl || '',
    tableParams: tableParams,
    returnData: handleTableChange,
    tableOptions: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props.tableOptions), {}, {
      rowSelection: getRowSelection,
      components: {
        body: {
          cell: components_EditableCell
        }
      },
      onRow: (record, index) => ({
        record,
        index,
        className: classnames_default()({
          newRow: !!record.editableTableAdd
        })
      })
    })
  })), !props.hideBtn && /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    type: "dashed",
    onClick: handleAddRow,
    disabled: props.disableAddBtn,
    className: "mTop16",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/react.createElement(PlusOutlined/* default */.Z, null), " ", props.buttonTitle || '添加'));
};

/* harmony default export */ var EditableTable_PageEditableTable = (/*#__PURE__*/(0,react.memo)( /*#__PURE__*/(0,react.forwardRef)(PageEditableTable)));
;// CONCATENATED MODULE: ./src/components/YpshopCps/EditableTable/index.tsx



/* eslint-disable no-unused-expressions */

/**
 * 通用 可编辑 表格
 */



var EditableTable = (props, ref) => {
  var wrapper = (0,react.useRef)(null);
  var changePointer = (0,react.useCallback)(e => {
    if (!['ArrowUp', 'ArrowDown', 'ArrowRight', 'ArrowLeft'].includes(e.code)) return; // if (!['ArrowUp', 'ArrowDown'].includes(e.code)) return

    var ele = e.target;
    var parent = ele === null || ele === void 0 ? void 0 : ele.parentNode;
    var cls = parent === null || parent === void 0 ? void 0 : parent.className; // 不存在父节点或者类名

    if (!parent || !cls) {
      return;
    }
    /**
     * editType: 1.editing；2.text
     * fieldType：组件类型
     * colIndex：可编辑的列序号
     * rowIndex：行序号
     */


    var _cls$split = cls.split('-'),
        _cls$split2 = (0,slicedToArray/* default */.Z)(_cls$split, 4),
        editType = _cls$split2[0],
        fieldType = _cls$split2[1],
        colIndex = _cls$split2[2],
        rowIndex = _cls$split2[3]; // 只支持输入框光标移动，以 editing 开头


    if (!editType.startsWith('editing') || fieldType !== 'INPUT') {
      return;
    }

    var currentRowKey = Number(rowIndex);
    var currentColKey = Number(colIndex);
    var nextRowIndex = currentRowKey;
    var nextColIndex = currentColKey;

    if (e.code === 'ArrowUp') {
      if (currentRowKey === 0) {
        return;
      }

      nextRowIndex = currentRowKey - 1;
    } else if (e.code === 'ArrowDown') {
      var _ref$current;

      var _ref$current$getTable = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getTableData(),
          dataSource = _ref$current$getTable.dataSource;

      var maxKey = dataSource.length - 1;
      nextRowIndex = currentRowKey + 1;

      if (maxKey < nextRowIndex) {
        return;
      }
    } else if (e.code === 'ArrowRight') {
      nextColIndex = currentColKey + 1;
    } else {
      if (nextColIndex === 1) {
        return;
      }

      nextColIndex = currentColKey - 1;
    } // 未处于编辑状态的


    var newCls = "text-".concat(fieldType, "-").concat(nextColIndex, "-").concat(nextRowIndex);
    var newElement = document.querySelector("div.".concat(newCls));

    if (newElement) {
      // 添加样式标识， 将单元格文本变成输入框
      newElement === null || newElement === void 0 ? void 0 : newElement.classList.add('edittable-change-to-edit');
    }
  }, []);
  (0,react.useEffect)(() => {
    var _wrapper$current;

    if (!(wrapper.current instanceof HTMLElement)) return;
    (_wrapper$current = wrapper.current) === null || _wrapper$current === void 0 ? void 0 : _wrapper$current.addEventListener('keydown', changePointer);
    return () => {
      var _wrapper$current2;

      (_wrapper$current2 = wrapper.current) === null || _wrapper$current2 === void 0 ? void 0 : _wrapper$current2.removeEventListener('keydown', changePointer);
    };
  }, [changePointer]);
  return /*#__PURE__*/react.createElement("div", {
    ref: wrapper
  }, /*#__PURE__*/react.createElement(EditableTable_PageEditableTable, (0,esm_extends/* default */.Z)({
    ref: ref
  }, props)));
};

/* harmony default export */ var YpshopCps_EditableTable = (/*#__PURE__*/(0,react.forwardRef)(EditableTable));

/***/ }),

/***/ 82347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "xb": function() { return /* binding */ isEmpty; }
/* harmony export */ });
/* unused harmony exports getEditableTableKey, compareAndChangeData */
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

 // 获取唯一的key

function getEditableTableKey() {
  return _.uniqueId('edittable_');
}
/**
 * 对比和替换列表数据
 * @param list 列表数据
 * @param data 更新后的 列表行数据
 */

function compareAndChangeData(list, data) {
  return list.map(v => v.editableTableKey === data.editableTableKey ? _objectSpread(_objectSpread({}, v), data) : v);
}
/**
 * 是否为空
 * @param params
 */

function isEmpty(params) {
  return lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(params);
}

/***/ }),

/***/ 29891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ YpshopCps_FormBuilder; }
});

// NAMESPACE OBJECT: ./src/components/YpshopCps/FormBuilder/components/Field.tsx
var Field_namespaceObject = {};
__webpack_require__.r(Field_namespaceObject);
__webpack_require__.d(Field_namespaceObject, {
  "BRAND": function() { return BRAND; },
  "CASCADER": function() { return CASCADER; },
  "CHECKBOX_GROUP": function() { return CHECKBOX_GROUP; },
  "CHECKBOX_GROUP_EXTRA": function() { return CHECKBOX_GROUP_EXTRA; },
  "DATE_PICKER": function() { return DATE_PICKER; },
  "INPUT": function() { return INPUT; },
  "INPUT_NUMBER": function() { return INPUT_NUMBER; },
  "RADIO": function() { return RADIO; },
  "RANGE_PICKER": function() { return RANGE_PICKER; },
  "RANGE_PICKER_SHORT": function() { return RANGE_PICKER_SHORT; },
  "SEARCH_BUTTON": function() { return SEARCH_BUTTON; },
  "SELECT": function() { return SELECT; },
  "TEXTAREA": function() { return TEXTAREA; },
  "VIRTUAL_SELECT": function() { return VIRTUAL_SELECT; },
  "VirtualSelect": function() { return VirtualSelect; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/row/style/index.js
var style = __webpack_require__(13062);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/style/index.js
var tooltip_style = __webpack_require__(22385);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 1 modules
var tooltip = __webpack_require__(31097);
// EXTERNAL MODULE: ./node_modules/antd/es/col/style/index.js
var col_style = __webpack_require__(89032);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/antd/es/form/style/index.js
var form_style = __webpack_require__(9715);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 12 modules
var es_form = __webpack_require__(35845);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/QuestionCircleOutlined.js + 1 modules
var QuestionCircleOutlined = __webpack_require__(1870);
// EXTERNAL MODULE: ./node_modules/antd/es/cascader/style/index.js
var cascader_style = __webpack_require__(36877);
// EXTERNAL MODULE: ./node_modules/antd/es/cascader/index.js + 5 modules
var cascader = __webpack_require__(34366);
// EXTERNAL MODULE: ./node_modules/antd/es/checkbox/style/index.js
var checkbox_style = __webpack_require__(63185);
// EXTERNAL MODULE: ./node_modules/antd/es/checkbox/index.js + 2 modules
var es_checkbox = __webpack_require__(9676);
// EXTERNAL MODULE: ./node_modules/antd/es/input-number/style/index.js
var input_number_style = __webpack_require__(77883);
// EXTERNAL MODULE: ./node_modules/antd/es/input-number/index.js + 2 modules
var input_number = __webpack_require__(39635);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/style/index.js
var radio_style = __webpack_require__(88983);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js
var es_radio = __webpack_require__(55742);
// EXTERNAL MODULE: ./node_modules/antd/es/select/style/index.js
var select_style = __webpack_require__(43358);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js
var es_select = __webpack_require__(34041);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(93224);
// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var button_style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/input/style/index.js
var input_style = __webpack_require__(47673);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 3 modules
var input = __webpack_require__(4107);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/style/index.js
var date_picker_style = __webpack_require__(14965);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/index.js + 6 modules
var date_picker = __webpack_require__(11448);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/YpshopCps/FormBuilder/components/Field.tsx























var _excluded = ["label"],
    _excluded2 = ["label"],
    _excluded3 = ["label"],
    _excluded4 = ["label"],
    _excluded5 = ["label"],
    _excluded6 = ["label"];



var RangePicker = date_picker/* default.RangePicker */.Z.RangePicker;
var TextArea = input/* default.TextArea */.Z.TextArea;
var SEARCH_BUTTON = (resetField, leftElement, btnElement) => {
  return /*#__PURE__*/react.createElement("div", {
    className: "optionBtns"
  }, /*#__PURE__*/react.createElement("div", {
    className: "ellipsis"
  }, leftElement), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    type: "primary",
    htmlType: "submit",
    className: classnames_default()('mRight10', {
      mLeft16: !!leftElement
    })
  }, "\u67E5\u8BE2"), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    onClick: resetField,
    className: "mRight10"
  }, "\u91CD\u7F6E"), btnElement ? btnElement : null);
};
var SELECT = (options, dataSource) => {
  var label = options.label,
      rest = (0,objectWithoutProperties/* default */.Z)(options, _excluded);

  var fieldOpts = (0,objectSpread2/* default */.Z)({
    allowClear: true,
    showSearch: true,
    filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
    placeholder: "\u8BF7\u9009\u62E9".concat(label),
    dropdownMatchSelectWidth: false
  }, rest);

  return /*#__PURE__*/react.createElement(es_select/* default */.Z, fieldOpts, dataSource && dataSource.map(val => {
    return /*#__PURE__*/react.createElement(es_select/* default.Option */.Z.Option, {
      key: val.value,
      value: val.value,
      rows: val
    }, val.label);
  }));
};
var VirtualSelect = function VirtualSelect(options) {
  var dataSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var label = options.label,
      rest = (0,objectWithoutProperties/* default */.Z)(options, _excluded2);

  var fieldOpts = (0,objectSpread2/* default */.Z)({
    allowClear: true,
    showSearch: true,
    filterOption: (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0,
    placeholder: "\u8BF7\u9009\u62E9".concat(label),
    dropdownMatchSelectWidth: false
  }, rest);

  return /*#__PURE__*/react.createElement(es_select/* default */.Z, (0,esm_extends/* default */.Z)({}, fieldOpts, {
    options: dataSource
  }));
};
var INPUT = options => {
  var label = options.label,
      rest = (0,objectWithoutProperties/* default */.Z)(options, _excluded3);

  return /*#__PURE__*/react.createElement(input/* default */.Z, (0,esm_extends/* default */.Z)({
    placeholder: "\u8BF7\u8F93\u5165".concat(label),
    allowClear: true
  }, rest));
};
var TEXTAREA = options => {
  var label = options.label,
      rest = (0,objectWithoutProperties/* default */.Z)(options, _excluded4);

  return /*#__PURE__*/react.createElement(TextArea, (0,esm_extends/* default */.Z)({
    placeholder: "\u8BF7\u8F93\u5165".concat(label),
    allowClear: true,
    autoSize: true
  }, rest));
};
var RANGE_PICKER = options => {
  return /*#__PURE__*/react.createElement(RangePicker, (0,esm_extends/* default */.Z)({
    allowClear: true,
    style: {
      width: '100%'
    }
  }, options));
};
var DATE_PICKER = options => {
  return /*#__PURE__*/react.createElement(date_picker/* default */.Z, (0,esm_extends/* default */.Z)({
    style: {
      width: '100%'
    }
  }, options));
};
var RADIO = (options, dataSource) => {
  return /*#__PURE__*/react.createElement(es_radio/* default.Group */.ZP.Group, options, dataSource && dataSource.map((val, key) => {
    var _ref, _val$key;

    var optKey = (_ref = (_val$key = val.key) !== null && _val$key !== void 0 ? _val$key : val.value) !== null && _ref !== void 0 ? _ref : key;
    return /*#__PURE__*/react.createElement(es_radio/* default */.ZP, {
      value: optKey,
      key: optKey
    }, val.label);
  }));
};
var INPUT_NUMBER = options => {
  var label = options.label,
      rest = (0,objectWithoutProperties/* default */.Z)(options, _excluded5);

  return /*#__PURE__*/react.createElement(input_number/* default */.Z, (0,esm_extends/* default */.Z)({
    style: {
      width: '100%'
    }
  }, rest));
};
var CHECKBOX_GROUP = (options, dataSource) => {
  return /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(es_checkbox/* default.Group */.Z.Group, null, /*#__PURE__*/react.createElement(row/* default */.Z, null, dataSource && dataSource.map((val, key) => {
    var _ref2, _val$key2;

    var optKey = (_ref2 = (_val$key2 = val.key) !== null && _val$key2 !== void 0 ? _val$key2 : val.value) !== null && _ref2 !== void 0 ? _ref2 : key;
    return /*#__PURE__*/react.createElement(col/* default */.Z, {
      key: optKey
    }, /*#__PURE__*/react.createElement(es_checkbox/* default */.Z, {
      value: optKey
    }, val.label));
  }))));
};
var BRAND = (options, dataSource) => {
  return /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(es_checkbox/* default.Group */.Z.Group, null, /*#__PURE__*/react.createElement(row/* default */.Z, null, dataSource && dataSource.map((val, key) => {
    var _ref3, _val$key3;

    var optKey = (_ref3 = (_val$key3 = val.key) !== null && _val$key3 !== void 0 ? _val$key3 : val.value) !== null && _ref3 !== void 0 ? _ref3 : key;
    return /*#__PURE__*/react.createElement(col/* default */.Z, {
      key: optKey
    }, /*#__PURE__*/react.createElement(es_checkbox/* default */.Z, {
      value: optKey
    }, val.label));
  }))));
};
var RANGE_PICKER_SHORT = options => {
  return /*#__PURE__*/react.createElement(RangePicker, (0,esm_extends/* default */.Z)({
    allowClear: true,
    style: {
      width: '100%'
    }
  }, options, {
    showTime: false,
    className: "shortPangePicker",
    suffixIcon: null
  }));
};
var CHECKBOX_GROUP_EXTRA = (options, dataSource) => {
  return /*#__PURE__*/react.createElement(es_checkbox/* default.Group */.Z.Group, null, /*#__PURE__*/react.createElement(row/* default */.Z, null, dataSource && dataSource.map(val => {
    return /*#__PURE__*/react.createElement(col/* default */.Z, {
      key: val.value
    }, /*#__PURE__*/react.createElement(es_checkbox/* default */.Z, {
      value: val.value
    }, val.label));
  })));
};
/** 大数据Select渲染 */

var VIRTUAL_SELECT = function VIRTUAL_SELECT(options) {
  var dataSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var label = options.label,
      rest = (0,objectWithoutProperties/* default */.Z)(options, _excluded6);

  var fieldOpts = (0,objectSpread2/* default */.Z)({
    allowClear: true,
    showSearch: true,
    filterOption: (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0,
    placeholder: "\u8BF7\u9009\u62E9".concat(label),
    dropdownMatchSelectWidth: false
  }, rest);

  return /*#__PURE__*/react.createElement(es_select/* default */.Z, (0,esm_extends/* default */.Z)({}, fieldOpts, {
    options: dataSource
  }));
};
/**
 * 简短的日期范围选择组件
 */

var CASCADER = options => {
  return /*#__PURE__*/react.createElement(cascader/* default */.Z, (0,esm_extends/* default */.Z)({
    defaultValue: options === null || options === void 0 ? void 0 : options.defaultValue
  }, options));
};
;// CONCATENATED MODULE: ./src/components/YpshopCps/FormBuilder/useSliderBtn.tsx



/**
 * 搜索功能的Form表单 「收起展开」 功能
 */

var formfieldsLen = 8;

function useSliderBtn(formfields, notSearchForm) {
  var defaultExpand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  /**
   * usefulFields: 有效的表单项（包括隐藏的表单项）
   * showKey: 可以展示的表单项的下标值（index）
   */
  var _useMemo = (0,react.useMemo)(() => {
    return formfields.reduce((pre, next) => {
      var _ref = next || {},
          hide = _ref.hide,
          _ref$columns = _ref.columns,
          columns = _ref$columns === void 0 ? 1 : _ref$columns;

      if (!next) return pre;

      if (!hide) {
        // 当设置了占据多格的表单项，减去其占据的位置
        pre.showKey = columns > 1 ? pre.showKey - columns : pre.showKey;
      } // 获取有效表单项和可以展示的表单项的下标值（index）


      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, pre), {}, {
        usefulFields: pre.usefulFields.concat(next)
      });
    }, {
      usefulFields: [],
      showKey: formfieldsLen
    });
  }, [formfields]),
      usefulFields = _useMemo.usefulFields,
      showKey = _useMemo.showKey; // 默认收起


  var _useState = (0,react.useState)(!defaultExpand),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      slideForm = _useState2[0],
      setSlideForm = _useState2[1];

  var _useState3 = (0,react.useState)(usefulFields),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      fields = _useState4[0],
      setFields = _useState4[1];

  var toggleForm = () => {
    setSlideForm(v => !v);
  };

  (0,react.useEffect)(() => {
    if (slideForm && !notSearchForm) {
      var list = usefulFields.map((v, k) => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
        hide: k >= showKey
      }));
      setFields(list);
    } else {
      setFields(usefulFields);
    }
  }, [slideForm, usefulFields, notSearchForm, showKey]); // 如果表单项比较小设置默认值

  var btnElement = usefulFields.length <= showKey ? null : /*#__PURE__*/react.createElement("a", {
    key: "btn",
    style: {
      minWidth: '30px'
    },
    onClick: toggleForm
  }, slideForm ? '展开' : '收起');
  return [fields, btnElement];
}

/* harmony default export */ var FormBuilder_useSliderBtn = (useSliderBtn);
// EXTERNAL MODULE: ./node_modules/use-media-antd-query/es/index.js + 1 modules
var es = __webpack_require__(38069);
;// CONCATENATED MODULE: ./src/components/YpshopCps/FormBuilder/utils/layouts.ts

var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 8
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 16
    }
  }
}; // 垂直排布的form布局

var defaultVerticalLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 24
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 24
    }
  }
}; // 时间范围选择器的布局

var rangeFormLayout = {
  labelCol: {
    md: 4,
    sm: 8
  },
  wrapperCol: {
    md: 20,
    sm: 16
  }
};
var defaultLayout = {
  horizontal: defaultFormItemLayout,
  vertical: defaultVerticalLayout,
  inline: defaultFormItemLayout
};
var normalColLayout = {
  xxl: 6,
  xl: 6,
  lg: 8,
  md: 12,
  sm: 24,
  xs: 24
};
var rangeColLayout = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, normalColLayout), {}, {
  xxl: 12,
  xl: 12,
  lg: 16,
  md: 24
});
var threeRangeColLayout = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, normalColLayout), {}, {
  xxl: 18,
  xl: 18,
  lg: 24,
  md: 24
}); // 占据一整行

var fullColLayout = {
  xxl: 24,
  xl: 24,
  lg: 24,
  md: 24,
  sm: 24,
  xs: 24
};
var oneColLayout = fullColLayout;
var twoColLayout = {
  xxl: 12,
  xl: 12,
  lg: 12,
  md: 12,
  sm: 24,
  xs: 24
};
var threeColLayout = {
  xxl: 8,
  xl: 8,
  lg: 8,
  md: 12,
  sm: 24,
  xs: 24
};
;// CONCATENATED MODULE: ./src/components/YpshopCps/FormBuilder/utils/constance.ts
 // 占据两个栅格的表单项类型

var twoColsMap = {// RANGE_PICKER: 'RANGE_PICKER'
  // TEXTAREA: 'RANGE_PICKER'
}; // 占据三个栅格的表单项类型

var treeColsMap = {
  DATE_RANGE_PICKER: 'DATE_RANGE_PICKER'
}; // 要去除前后空格的组件

var trimWhitespaceFields = ['INPUT', 'INPUT_NUMBER', 'TEXT_AREA']; // 失去焦点才获取值的控件

var getValueInBlur = ['INPUT', 'INPUT_NUMBER', 'TEXT_AREA'];
var currentLayoutType = {
  1: oneColLayout,
  2: twoColLayout,
  3: threeColLayout,
  4: normalColLayout,
  default: normalColLayout
}; // 不同大小的表单项对应的文本表单控件占据的空间大小

var formItemLayoutType = {
  1: {
    labelCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 8
      }
    },
    wrapperCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 16
      }
    }
  },
  2: {
    labelCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 4
      }
    },
    wrapperCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 20
      }
    }
  },
  3: {
    labelCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 2
      }
    },
    wrapperCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 22
      }
    }
  },
  4: {
    labelCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 2
      }
    },
    wrapperCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 22
      }
    }
  }
};
// EXTERNAL MODULE: ./src/.umi-production/core/umiExports.ts + 18 modules
var umiExports = __webpack_require__(71720);
;// CONCATENATED MODULE: ./src/components/YpshopCps/FormBuilder/index.tsx












/**
 * 通用表单组件
 */









var FormItem = es_form/* default.Item */.Z.Item;
var Fields = Field_namespaceObject;
/**
 * 去除用户输入造成的前后空格
 * @param value 当前控件输入的值
 * @param element 用户传入的当前表单项的配置的属性
 */

function handleNormalize(value, type) {
  if (!trimWhitespaceFields.includes(type)) {
    return value;
  }

  if (typeof value === 'number') {
    return value;
  }

  if (value) {
    return value.replace(/(^\s*)|(\s*$)/g, '');
  }
}

var FormBuilder = (props, ref) => {
  var _props$columns, _props$formOptions2;

  var _Form$useForm = es_form/* default.useForm */.Z.useForm(),
      _Form$useForm2 = (0,slicedToArray/* default */.Z)(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var mediaSize = (0,es.default)();
  var formCache = (0,umiExports/* useSelector */.v9)(state => state.formCache);
  var dispatch = (0,umiExports/* useDispatch */.I0)(); // 根据传入的值，获取不同的布局栅格参数

  var layoutType = currentLayoutType[(_props$columns = props.columns) !== null && _props$columns !== void 0 ? _props$columns : 'default']; // 获取表单项list，以及搜索、重置按钮

  var _useSliderBtn = FormBuilder_useSliderBtn(props.elements, props.notSearchForm, props.defaultExpand),
      _useSliderBtn2 = (0,slicedToArray/* default */.Z)(_useSliderBtn, 2),
      formfields = _useSliderBtn2[0],
      btnElement = _useSliderBtn2[1]; // 表单验证完成


  var onFinish = values => {
    if (props.callbackHandler) {
      props.callbackHandler('success', (0,objectSpread2/* default */.Z)({}, values));
    }

    if (!props.disableCache) {
      dispatch({
        type: 'formCache/save',
        payload: {
          [location.hash]: values
        }
      });
    } // setTimeout(()=>{
    //   console.log(formCache,location,form.getFieldsValue())
    // },1000)

  }; // 表单验证失败


  var onFinishFailed = errorInfo => {
    if (props.callbackHandler) {
      props.callbackHandler('error', (0,objectSpread2/* default */.Z)({}, errorInfo));
    }
  }; // 重置表单


  var resetField = () => {
    var arr = props.elements.filter(ele => ele.reset === undefined ? true : ele.reset);
    form.resetFields(arr.map(e => e.name));
    var values = form.getFieldsValue();

    if (props.onReset) {
      props.onReset((0,objectSpread2/* default */.Z)({}, values));
    }

    if (props.resetCallback) {
      props.resetCallback('success', (0,objectSpread2/* default */.Z)({}, values));
    }

    if (!props.disableCache) {
      dispatch({
        type: 'formCache/save',
        payload: {
          [location.hash]: values
        }
      });
    }
  };
  /**
   * 计算按钮的布局
   */


  var btnOffset = (0,react.useMemo)(() => {
    if (props.doNotCalculate) return 0;
    var span = layoutType[mediaSize]; // 计算一行展示多少个表单项

    var rowLength = 24 / span; // 当按钮存在左侧内容时

    if (props.leftElement) {
      var _offset = (rowLength - 1) * span;

      return _offset;
    } // 获取所有展示出来的表单项占据的栅格数


    var length = formfields.reduce((pre, next) => {
      var hide = next.hide,
          _next$columns = next.columns,
          columns = _next$columns === void 0 ? 1 : _next$columns;
      if (hide) return pre; // 当用户定义占据的栅格大于每行应该展示的表单项时，使用每行展示的表单项的值；避免造成栅格过多引起布局错乱

      var len = columns > rowLength ? rowLength : columns;
      return pre + len;
    }, 0); // 求余数，传入的表单项数量与每行展示的数量的余数；最后一行展示的数量

    var remainder = length % rowLength;
    var restLength = rowLength - remainder;
    var offset = remainder === 0 ? (rowLength - 1) * span : (restLength - 1) * span;
    return offset;
  }, [mediaSize, props.leftElement, formfields, layoutType, props.doNotCalculate]); // 表单排布，栅格布局渲染

  var renderLayout = elements => {
    return elements.map((ele, key) => {
      var _ele$props = ele.props,
          name = _ele$props.name,
          fieldtype = _ele$props.fieldtype,
          style = _ele$props.style,
          hide = _ele$props.hide,
          _ele$props$columns = _ele$props.columns,
          columns = _ele$props$columns === void 0 ? 1 : _ele$props$columns;
      /**
       * 是否将本表单项设置为独占一行(row:24)的布局
       * 如果不是搜索表单且不是响应式表单，设置为每一项form占据一行
       */

      var shouldFull = props.notSearchForm && !props.responsed;
      var colLayout = {
        xxl: 6 * columns,
        xl: 6 * columns,
        lg: 6 * (columns * 8 / 6),
        md: columns > 1 ? 24 : 12,
        sm: 24,
        xs: 24
      }; // 是否为特殊表单项，如：日期区间、多行文本输入

      if (twoColsMap[fieldtype]) {
        colLayout = rangeColLayout;
      } // 暂时适配掉colLayout 个别页面用。


      if (props.defaultColLayout) {
        colLayout = props.defaultColLayout;
      } // 是否占据一行展示


      if (shouldFull) {
        colLayout = fullColLayout;
      }

      var fieldStyle = {}; // 如果设置了 display:none，或设置了hide属性

      if (style && style.display === 'none' || hide === 'true') {
        fieldStyle = {
          display: 'none'
        };
      }

      return /*#__PURE__*/react.createElement(col/* default */.Z, (0,esm_extends/* default */.Z)({
        key: name + key
      }, colLayout, {
        style: fieldStyle,
        className: "col-item"
      }), ele);
    });
  }; //  渲染表单项


  var renderElement = element => {
    // Handle form item props
    var label = element.tooltip ? /*#__PURE__*/react.createElement("span", null, element.label, /*#__PURE__*/react.createElement(tooltip/* default */.Z, {
      title: element.tooltip
    }, /*#__PURE__*/react.createElement(QuestionCircleOutlined/* default */.Z, null))) : element.label; // 设置校验的属性

    var rules = element.rules || [];

    if (element.required) {
      rules = [...rules, {
        required: true,
        message: "".concat(element.label || element.key || element.id, "\u4E0D\u80FD\u4E3A\u7A7A.")
      }];
    } // 校验时机


    var triggerInBlur = getValueInBlur.includes(element.type);

    var formItemProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
      name: element.name || element.id,
      colon: props.colon || false,
      label,
      rules,
      key: element.name || element.key,
      hide: element.hide ? element.hide.toString() : 'false',
      validateTrigger: triggerInBlur ? 'onBlur' : 'onChange',
      columns: element.columns
    }, element.formItemProps), {}, {
      normalize: val => handleNormalize(val, element.type)
    });

    var columns = element.columns || 1;
    var formItemLayout = props.notSearchForm ? {} : formItemLayoutType[columns];

    if (element.type) {
      var options = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, element.fieldOptions), {}, {
        label
      }); // 如果是特定的表单项(通过type判断)，设置特定的布局；如果是自定义的表单项则设置


      var formLayout = element.formItemLayout; // 非查询功能表单，不设置特定的样式

      if (!props.notSearchForm) {
        formLayout = twoColsMap[element.type] ? rangeFormLayout : {};
      }

      return /*#__PURE__*/react.createElement(FormItem, (0,esm_extends/* default */.Z)({}, formItemLayout, formItemProps, formLayout, {
        fieldtype: element.type
      }), Fields[element.type](options, element.dataList));
    }

    return /*#__PURE__*/react.createElement(FormItem, (0,esm_extends/* default */.Z)({}, formItemLayout, formItemProps), element.widget);
  }; // 获取所有表单项的初始值


  var initialValues = (0,react.useMemo)(() => {
    return formfields.reduce((prev, next) => {
      if (!next) return prev;
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, prev), {}, {
        [next.name]: next.initialValue
      });
    }, {});
  }, [formfields]);
  (0,react.useEffect)(() => {
    // 没有则忽略
    if (formCache[location.hash] && !props.disableCache) {
      form.setFieldsValue(formCache[location.hash] || initialValues);

      if (props.callbackHandler) {
        props.callbackHandler('success', (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, initialValues), formCache[location.hash]));
      }
    }
  }, [props.disableCache]); // 设置不同模式的form布局

  var defaultFormLayout = (0,react.useMemo)(() => {
    var _props$formOptions;

    var layout = ((_props$formOptions = props.formOptions) === null || _props$formOptions === void 0 ? void 0 : _props$formOptions.layout) || 'horizontal';
    return defaultLayout[layout];
  }, [(_props$formOptions2 = props.formOptions) === null || _props$formOptions2 === void 0 ? void 0 : _props$formOptions2.layout]);
  return /*#__PURE__*/react.createElement("div", {
    className: "formBuilder"
  }, /*#__PURE__*/react.createElement(es_form/* default */.Z, (0,esm_extends/* default */.Z)({
    ref: ref,
    form: form,
    initialValues: props.defaultValues || initialValues,
    onFinish: onFinish,
    onFinishFailed: onFinishFailed,
    onValuesChange: props.onChange
  }, defaultFormLayout, props.formOptions), /*#__PURE__*/react.createElement(row/* default */.Z, {
    className: "m-0",
    gutter: 24
  }, renderLayout(formfields.map(renderElement)), props.notSearchForm ? null : /*#__PURE__*/react.createElement(col/* default */.Z, (0,esm_extends/* default */.Z)({
    span: 8,
    key: "button",
    offset: btnOffset
  }, normalColLayout, {
    style: props.doNotCalculate ? {
      flexGrow: 1,
      maxWidth: '100%'
    } : {},
    className: "col-item"
  }), /*#__PURE__*/react.createElement(FormItem, {
    labelCol: {
      span: 0
    },
    wrapperCol: {
      span: 24
    }
  }, Fields['SEARCH_BUTTON'](resetField, props.leftElement, btnElement))))));
};

/* harmony default export */ var YpshopCps_FormBuilder = (/*#__PURE__*/react.forwardRef(FormBuilder));

/***/ }),

/***/ 64679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ GoodsCategoryCascader; }
/* harmony export */ });
/* harmony import */ var antd_es_cascader_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36877);
/* harmony import */ var antd_es_cascader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34366);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26715);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7704);




/**
 * 采购 - 权限下的类目 - Cascader
 * 默认获取三层类目
 */



var GoodsCategoryCascader = props => {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      innerMappingList = _useState2[0],
      setinnerMappingList = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState3, 2),
      allCatArr = _useState4[0],
      setallCatArr = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (!(props !== null && props !== void 0 && props.mappingList)) {
      var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)([_config_enums__WEBPACK_IMPORTED_MODULE_2__/* .purchaseEnumConfig.categoryCodeAll */ .Nt.categoryCodeAll]),
          mappingList = _useMapping.mappingList;

      setinnerMappingList(mappingList === null || mappingList === void 0 ? void 0 : mappingList.get(_config_enums__WEBPACK_IMPORTED_MODULE_2__/* .purchaseEnumConfig.categoryCodeAll */ .Nt.categoryCodeAll));
    } else {
      var _props$mappingList;

      var _innerMappingList = props === null || props === void 0 ? void 0 : (_props$mappingList = props.mappingList) === null || _props$mappingList === void 0 ? void 0 : _props$mappingList.get(_config_enums__WEBPACK_IMPORTED_MODULE_2__/* .purchaseEnumConfig.categoryCodeAll */ .Nt.categoryCodeAll);

      setinnerMappingList(_innerMappingList);

      if (_innerMappingList && _innerMappingList.length) {
        var _allCatArr = [];

        _innerMappingList.forEach(e => {
          _allCatArr.push({
            value: e.others.categoryId.toString(),
            label: e.others.categoryName,
            children: exchangeObj(deepLength, e.others.childCategoryList)
          });
        });

        setallCatArr(_allCatArr);
      }
    }
  }, [props === null || props === void 0 ? void 0 : props.mappingList]);

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState5, 2),
      state = _useState6[0],
      setstate = _useState6[1];

  var onChange = props.onChange,
      _props$deepLength = props.deepLength,
      deepLength = _props$deepLength === void 0 ? 3 : _props$deepLength,
      dataDisable = props.dataDisable;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (dataDisable && allCatArr !== null && allCatArr !== void 0 && allCatArr.length) {
      allCatArr.forEach(e => {
        if (e.value != (props === null || props === void 0 ? void 0 : props.data[0])) {
          e['disabled'] = true;
        }
      });
    }
  }, [allCatArr]);

  var _onChange = (value, selectedOptions) => {
    setstate(value);
    var _val = {
      firstCategoryId: selectedOptions[0] ? selectedOptions[0].value : undefined,
      firstCategoryName: selectedOptions[0] ? selectedOptions[0].label : undefined,
      secondCategoryId: selectedOptions[1] ? selectedOptions[1].value : undefined,
      secondCategoryName: selectedOptions[1] ? selectedOptions[1].label : undefined,
      thirdCategoryId: selectedOptions[2] ? selectedOptions[2].value : undefined,
      thirdCategoryName: selectedOptions[2] ? selectedOptions[2].label : undefined,
      fourCategoryId: selectedOptions[3] ? selectedOptions[3].value : undefined,
      fourCategoryName: selectedOptions[3] ? selectedOptions[3].label : undefined
    };

    for (var i in _val) {
      if (!_val[i]) {
        delete _val[i];
      }
    }

    onChange(_val);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_cascader__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    disabled: props.disabled,
    options: allCatArr,
    onChange: _onChange,
    changeOnSelect: true,
    value: state.length ? state : props.data
  });
};
/**
 * 对象转Cascader指定数组
 * @param deeps 深度
 * @param obj 对象
 */

var exchangeObj = function exchangeObj() {
  var deeps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
  var obj = arguments.length > 1 ? arguments[1] : undefined;

  // if(!obj){
  //   console.log('obj',obj)
  //   return []
  // }
  if (deeps === 4) {
    return exchangeObjToArrFor4(obj);
  } else if (deeps === 3) {
    return exchangeObjToArrFor3(obj);
  } else {
    // 默认返回全部: 二层
    return exchangeObjToArrFor2(obj);
  }
};
/** 1001: {categoryId: 11001, categoryName: "干货类",} => [{value: 1001, label: '干货类'}] */

/**
 * 获取2层对象
 * @param object 处理对象
 */


var exchangeObjToArrFor2 = object => {
  var arr = [];

  if (object && Object.keys(object).length) {
    for (var key in object) {
      if (object.hasOwnProperty(key)) {
        var _arr = {
          value: key.toString(),
          label: object[key]['categoryName']
        };

        if (object[key]['categorylevel'] < 3) {
          if (exchangeObjToArrFor2(object[key]['childCategoryList']) && exchangeObjToArrFor2(object[key]['childCategoryList']).length) {
            _arr['children'] = exchangeObjToArrFor2(object[key]['childCategoryList']);
          }

          arr.push(_arr);
        }
      }
    }
  }

  return arr;
};
/**
 * 获取3层对象
 * @param object 处理对象
 */


var exchangeObjToArrFor3 = object => {
  var arr = [];

  if (object && Object.keys(object).length) {
    for (var key in object) {
      if (object.hasOwnProperty(key)) {
        var _arr = {
          value: key.toString(),
          label: object[key]['categoryName']
        };

        if (object[key]['categorylevel'] < 4) {
          if (exchangeObjToArrFor3(object[key]['childCategoryList']) && exchangeObjToArrFor3(object[key]['childCategoryList']).length) {
            _arr['children'] = exchangeObjToArrFor3(object[key]['childCategoryList']);
          }

          arr.push(_arr);
        }
      }
    }
  }

  return arr;
};
/**
 * 获取4层对象
 * @param object 处理对象
 */


var exchangeObjToArrFor4 = object => {
  var arr = [];

  if (Object.keys(object).length) {
    for (var key in object) {
      if (object.hasOwnProperty(key)) {
        var _arr = {
          value: key.toString(),
          label: object[key]['categoryName']
        };

        if (exchangeObjToArrFor4(object[key]['childCategoryList']) && exchangeObjToArrFor4(object[key]['childCategoryList']).length) {
          _arr['children'] = exchangeObjToArrFor4(object[key]['childCategoryList']);
        }

        arr.push(_arr);
      }
    }
  }

  return arr;
};

/***/ }),

/***/ 77769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ usage; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(5977);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
;// CONCATENATED MODULE: ./src/components/iframe/index.tsx



var Iframe = props => {
  var url = props.url;
  url = decodeURIComponent(url);
  var param = {
    token: js_cookie_default().get('token') || '',
    mobile: js_cookie_default().get('mobile') || '',
    subjectId: js_cookie_default().get('subjectId') || ''
  };

  if (url.includes('?')) {
    var params = new URLSearchParams(url.split('?')[1]);
    Object.keys(param).forEach(key => params.get(key) !== null && delete param[key]);
  }

  var querystring = new URLSearchParams(param).toString();
  console.log(js_cookie_default().get());
  var src = url + (url.includes('?') ? '&' : '?') + querystring;
  console.log(src);
  var iframeRef = (0,react.useRef)(null); // useEffect(() => {
  //   iframeRef.current!.addEventListener('load', function () {
  //   })
  // }, [])

  return /*#__PURE__*/react.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      background: '#fff'
    }
  }, /*#__PURE__*/react.createElement("iframe", {
    ref: iframeRef,
    src: src,
    style: {
      width: '100%',
      height: '100%',
      background: '#fff'
    }
  }));
};

/* harmony default export */ var iframe = (/*#__PURE__*/(0,react.memo)(Iframe));
;// CONCATENATED MODULE: ./src/components/iframe/usage.tsx




var IframeUsage = function IframeUsage() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onOpen = props.onOpen,
      handleHook = props.handleHook;

  var _useLocation = (0,react_router/* useLocation */.TH)(),
      query = _useLocation.query;

  var history = (0,react_router/* useHistory */.k6)();
  var iframeProps = {
    url: query.url
  };
  return /*#__PURE__*/react.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      background: '#fff'
    }
  }, /*#__PURE__*/react.createElement(iframe, iframeProps));
};

/* harmony default export */ var usage = (IframeUsage);

/***/ }),

/***/ 15910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gg": function() { return /* binding */ queryStoreByCondition; },
/* harmony export */   "P5": function() { return /* binding */ queryGroupByOperationGroupIdsAndType; },
/* harmony export */   "NO": function() { return /* binding */ asyncImportShop; },
/* harmony export */   "$H": function() { return /* binding */ getLastImportShopResult; },
/* harmony export */   "V$": function() { return /* binding */ upload_token; },
/* harmony export */   "a": function() { return /* binding */ posListShopByCondition; },
/* harmony export */   "DL": function() { return /* binding */ posAsyncImportShop; },
/* harmony export */   "s8": function() { return /* binding */ posGetLastImportShopResult; },
/* harmony export */   "mV": function() { return /* binding */ pos_upload_token; }
/* harmony export */ });
/* unused harmony export promotion_dateSegment_list */
var promotion_dateSegment_list = 'mms.content.list';
var queryStoreByCondition = '/marketing/merchantService/queryStoreByCondition'; // 根据运营组、门店类型、门店组/调价标签查询门店

var queryGroupByOperationGroupIdsAndType = '/phoenix/groupService/queryGroupByOperationGroupIdsAndType'; // 根据运营组Ids和类型查询店群、队形接口

var asyncImportShop = '/marketing/importTaskService/asyncImportShop'; // 异步导入门店接口

var getLastImportShopResult = '/marketing/importTaskService/getLastImportShopResult'; // 查询导入门店结果

var upload_token = 'mms.fileService.getUploadToken'; // 文件上传的token

var posListShopByCondition = '/pos/shopService/listShopByCondition'; // 根据运营组、门店类型、门店组查询门店

var posAsyncImportShop = '/pos/importExportTaskService/asyncImportShop'; // 异步导入门店接口

var posGetLastImportShopResult = '/pos/importExportTaskService/getLastImportShopResult'; // 查询导入门店结果

var pos_upload_token = 'ypsx.pos.device.v1.FileService.GetUploadToken'; // 文件上传的token

/***/ }),

/***/ 26715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$7": function() { return /* binding */ priceModifyType; },
/* harmony export */   "Zz": function() { return /* binding */ enumPurchaseDownloadType; },
/* harmony export */   "Nk": function() { return /* binding */ enumPoolingType; },
/* harmony export */   "oV": function() { return /* binding */ enumDeliveryDays; },
/* harmony export */   "Nt": function() { return /* binding */ purchaseEnumConfig; },
/* harmony export */   "H4": function() { return /* binding */ enumRuleLogistics; },
/* harmony export */   "oB": function() { return /* binding */ LogisticModeMap; },
/* harmony export */   "Z$": function() { return /* binding */ TransferType; },
/* harmony export */   "wB": function() { return /* binding */ enumPurchaseImportStatus; },
/* harmony export */   "Pb": function() { return /* binding */ enumPurchaseImportStatusType; },
/* harmony export */   "bK": function() { return /* binding */ enumPriceImportStatus; },
/* harmony export */   "qW": function() { return /* binding */ replenishStatus; },
/* harmony export */   "Ov": function() { return /* binding */ enumGlobalPurchase; },
/* harmony export */   "V$": function() { return /* binding */ replenishType; },
/* harmony export */   "aW": function() { return /* binding */ enumBillTYPE; },
/* harmony export */   "uO": function() { return /* binding */ enumPurchaseSCMImportStatusType; },
/* harmony export */   "Zv": function() { return /* binding */ SCMImportType; },
/* harmony export */   "kc": function() { return /* binding */ SCMDownloadType; },
/* harmony export */   "$M": function() { return /* binding */ BILL_TYPE; }
/* harmony export */ });
/* unused harmony exports purchaseBizType, EnumDictionaryCatalog, LogisticMode, LogisticModeSign */
/**
 * 全局枚举映射
 *
 * 使用：window.mapping
 */
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (new Map([[1, '需求申请单类型'], [2, '需求申请单状态'], [3, '当前用户权限的地点'], [4, '仅一级品类'], [5, '仅二级品类'], [6, '需求汇总单状态'], [7, '物流模式'], [8, '需求申请单集单标记'], [9, '采购单状态'], [10, '采购单类型'], [11, '采购单退货好坏货标记'], [12, '退货原因'], [13, '经营方式'], [14, '采购分配单需求类型'], [15, '采购分配单状态'], [16, '采购分配单订单类型'], [17, '集单方式'], // [18, '当前用户权限的商家'],
[19, '当前用户权限的供货DC-发货仓'], [20, '集单失败类型'], [21, '调拨单类型'], [22, '加价规则的加价类型'], [23, '加价规则的基数类型'], [24, '补救单状态'], [25, '补救单类型'], [26, '批发销售单状态'], [27, '批发销售的客户分类'], [28, '批发销售的结算账期'], [29, '批发客户联系人类型'], [30, '批发销售单订单来源'], [31, '批发销售单送货方式'], [32, '批发销售单订单类型'], [33, '批发销售单支付方式'], [34, '退货集单的退货方式'], [35, '调拨单状态'], [36, '调拨分配单需求类型'], [37, '租户'], [38, '预约单的预约类型'], [39, '预约单状态'], [40, '当前用户权限的且在指定商家下的地点'], [41, '品类一级二级合集'], [42, '批量销售客户状态'], [43, '采购单是否直通'], [46, '新的品类一级二级合集，41已弃用'], // [54, '当前用户权限的供货DC - 收货地'],
[47, '当前用户权限的供货DC - 收货地'], [54, '单据类型'], [55, '品类'], [56, '调拨分配单红冲状态类型'], [57, '大仓库存标记'], [58, '批发分配单状态'] // [45, '当前用户权限商家下的地点']
]));
var purchaseBizType = new Map([[1, '采购预处理'], [2, '调拨预处理'], [3, '采购订单'], [4, '调拨订单'], [5, '采购预约单'], [6, '补救单']]);
/**
 * 调价单类型
 */

var priceModifyType; // 采购 - 下载模板类型

(function (priceModifyType) {
  priceModifyType[priceModifyType["PURCHASE_PRICE"] = 1] = "PURCHASE_PRICE";
  priceModifyType[priceModifyType["SELL_PRICE"] = 2] = "SELL_PRICE";
  priceModifyType[priceModifyType["PLU_PRICE"] = 3] = "PLU_PRICE";
})(priceModifyType || (priceModifyType = {}));

var enumPurchaseDownloadType;
/**
 * 集单方式
 */

(function (enumPurchaseDownloadType) {
  enumPurchaseDownloadType[enumPurchaseDownloadType["PURCAHSE_PRE_TEMPLATE"] = 1] = "PURCAHSE_PRE_TEMPLATE";
  enumPurchaseDownloadType[enumPurchaseDownloadType["TRANSFER_PRE_CD"] = 2] = "TRANSFER_PRE_CD";
  enumPurchaseDownloadType[enumPurchaseDownloadType["TRANSFER_PRE_CCDD"] = 3] = "TRANSFER_PRE_CCDD";
  enumPurchaseDownloadType[enumPurchaseDownloadType["WHOLESALE_GOOD_TEMPLATE"] = 4] = "WHOLESALE_GOOD_TEMPLATE";
  enumPurchaseDownloadType[enumPurchaseDownloadType["PURCHASE_GOODS_IMPORT_TEMPLATE"] = 5] = "PURCHASE_GOODS_IMPORT_TEMPLATE";
  enumPurchaseDownloadType[enumPurchaseDownloadType["PURCHASE_PREPROCESS_TEMPLATE"] = 6] = "PURCHASE_PREPROCESS_TEMPLATE";
  enumPurchaseDownloadType[enumPurchaseDownloadType["TRANSFER_PREPROCESS_TEMPLATE"] = 7] = "TRANSFER_PREPROCESS_TEMPLATE";
  enumPurchaseDownloadType[enumPurchaseDownloadType["APPLY_REQUIRE_ORDER"] = 8] = "APPLY_REQUIRE_ORDER";
  enumPurchaseDownloadType[enumPurchaseDownloadType["APPLY_RETURN_ORDER"] = 9] = "APPLY_RETURN_ORDER";
  enumPurchaseDownloadType[enumPurchaseDownloadType["GOODS_WASTAGE_RATE_TEMPLATE"] = 10] = "GOODS_WASTAGE_RATE_TEMPLATE";
  enumPurchaseDownloadType[enumPurchaseDownloadType["GOODS_ROUTES_RATE_TEMPLATE"] = 3] = "GOODS_ROUTES_RATE_TEMPLATE";
  enumPurchaseDownloadType[enumPurchaseDownloadType["TAIZHOUCANG_PRICE_TEMPLATE"] = 7] = "TAIZHOUCANG_PRICE_TEMPLATE";
  enumPurchaseDownloadType[enumPurchaseDownloadType["GOODS_ADD_PRICE_TEMPLATE"] = 11] = "GOODS_ADD_PRICE_TEMPLATE";
  enumPurchaseDownloadType[enumPurchaseDownloadType["DELIVERY_PERIOD_TEMPLATE"] = 6] = "DELIVERY_PERIOD_TEMPLATE";
  enumPurchaseDownloadType[enumPurchaseDownloadType["PURCHASE_GOODS_RETURN_IMPORT_TEMPLATE"] = 12] = "PURCHASE_GOODS_RETURN_IMPORT_TEMPLATE";
  enumPurchaseDownloadType[enumPurchaseDownloadType["TRANSFER_GOODS_IMPORT_TEMPLATE"] = 13] = "TRANSFER_GOODS_IMPORT_TEMPLATE";
  enumPurchaseDownloadType[enumPurchaseDownloadType["WHOLESALE_MANAGE_PREPROCESS_TEMPLATE"] = 14] = "WHOLESALE_MANAGE_PREPROCESS_TEMPLATE";
  enumPurchaseDownloadType[enumPurchaseDownloadType["DURABLE_GOODS_TEMPLATE"] = 20] = "DURABLE_GOODS_TEMPLATE";
  enumPurchaseDownloadType[enumPurchaseDownloadType["QUICK_TEMPLATE"] = 21] = "QUICK_TEMPLATE";
  enumPurchaseDownloadType[enumPurchaseDownloadType["FRESH_TEMPLATE"] = 22] = "FRESH_TEMPLATE";
  enumPurchaseDownloadType[enumPurchaseDownloadType["AUTO_REPLENISHMANAGER_TEMPLATE"] = 28] = "AUTO_REPLENISHMANAGER_TEMPLATE";
})(enumPurchaseDownloadType || (enumPurchaseDownloadType = {}));

var enumPoolingType;
/**
 * 集单方式
 */

(function (enumPoolingType) {
  enumPoolingType[enumPoolingType["AUTO"] = 1] = "AUTO";
  enumPoolingType[enumPoolingType["SELF"] = 2] = "SELF";
})(enumPoolingType || (enumPoolingType = {}));

var enumDeliveryDays; // 采购 枚举 字段名对应的映射
// https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=31411559

(function (enumDeliveryDays) {
  enumDeliveryDays[enumDeliveryDays["\u5468\u4E00"] = 1] = "\u5468\u4E00";
  enumDeliveryDays[enumDeliveryDays["\u5468\u4E8C"] = 2] = "\u5468\u4E8C";
  enumDeliveryDays[enumDeliveryDays["\u5468\u4E09"] = 3] = "\u5468\u4E09";
  enumDeliveryDays[enumDeliveryDays["\u5468\u56DB"] = 4] = "\u5468\u56DB";
  enumDeliveryDays[enumDeliveryDays["\u5468\u4E94"] = 5] = "\u5468\u4E94";
  enumDeliveryDays[enumDeliveryDays["\u5468\u516D"] = 6] = "\u5468\u516D";
  enumDeliveryDays[enumDeliveryDays["\u5468\u65E5"] = 7] = "\u5468\u65E5";
})(enumDeliveryDays || (enumDeliveryDays = {}));

var purchaseEnumConfig = {
  billState: 9,
  categoryCode: 4,
  categoryAll: 41,
  // 无权限的全量类目树
  placeCode: 3,
  queryPlaces: 84,
  orderType: 10,
  isStraight: 43,
  categoryCodeAll: 46,
  firstCategoryId: 4,
  // 一级类目
  secondCategoryId: 5,
  // 一级类目
  placeId: 3,
  // 地点
  merchantId: 40,
  // 商家/机构
  logisticMode: 7,
  // 物流模式
  transferType: 21,
  // 调拨单类型
  baseType: 23,
  // 基数类型
  addPriceType: 22,
  // 加价类型
  deliveryDcId: 19,
  // 当前用户权限的供货DC - 发货仓
  deliveryReceiveDc: 47,
  // 当前用户权限的供货DC - 收货地
  poolingType: 17,
  // 集单方式
  receiptsType: 54,
  // 单据类型
  goodsType: 55,
  // 品类
  warehouseType: 40,
  // 权限内，仓库类型地点
  shopType: 40,
  // 权限内，门店类型地点
  authPlaceId: 53,
  // 当前用户权限下的生鲜门店
  requireSource: 44,
  status: 2,
  flag: 8,
  placeGroupId: 59,
  // 店群，群组
  replenishmentType: 82 // 门店补货明细 类型

};
/**
 * 集单策略 物流模式
 */

var enumRuleLogistics;
/**
 * 枚举字典
 */

(function (enumRuleLogistics) {
  enumRuleLogistics[enumRuleLogistics["\u76F4\u9001"] = 1] = "\u76F4\u9001";
  enumRuleLogistics[enumRuleLogistics["\u914D\u9001"] = 2] = "\u914D\u9001";
  enumRuleLogistics[enumRuleLogistics["\u76F4\u901A"] = 3] = "\u76F4\u901A";
})(enumRuleLogistics || (enumRuleLogistics = {}));

var EnumDictionaryCatalog = {
  // -----COMMON------ 系统内通用枚举 //
  // 当前用户权限的地点
  AuthPlace: 3,
  // 所有一级品类
  FirstCategory: 4,
  // 所有二级品类
  SecondCategory: 5,
  logistics: 7,
  // ------------------ //
  // 需求申请单类型
  RequireApplyOrderType: 1,
  // 需求申请单状态
  RequireApplyOrderStatus: 2,
  // 需求汇总单状态
  demandPoolingStatus: 6 // 物流模式(7, "logistics"),
  // 需求申请单集单标记(8, "poolingFlag"),
  // 采购单状态(9, "purchaseOrderStatus"),
  // 采购单类型(10, "purchaseOrderType"),
  // 采购单退货好坏货标记(11, "goodOrBadFlag"),
  // 退货原因(12, "returnReason"),
  // 经营方式(13, "businessMode"),
  // 采购分配单需求类型(14, "purchasePreOrderRequireType"),
  // 采购分配单状态(15, "purchasePreOrderStatus"),
  // 采购分配单订单类型(16, "purchasePreOrderOrderType"),
  // 集单方式(17, "poolingWay"),
  // 当前用户权限的供货DC(19, "authDC"),
  // 集单失败类型(20, "poolingErrorType"),
  // 调拨单类型(21, "transferOrderType"),
  // 加价规则的加价类型(22, "priceMarkUpType"),
  // 加价规则的基数类型(23, "priceMarkUpBaseType"),
  // 补救单状态(24, "remedyOrderStatus"),
  // 补救单类型(25, "remedyOrderType"),
  // 批发销售单状态(26, "wholesaleOrderStatus"),
  // 批发销售的客户分类(27, "wholesaleOrderCustomerType"),
  // 批发销售的结算账期(28, "wholesaleOrderSettlement"),
  // 批发客户联系人类型(29, "wholesaleOrderContactsType"),
  // 批发销售单订单来源(30, "wholesaleOrderRequireSource"),
  // 批发销售单送货方式(31, "wholesaleOrderDeliveryType"),
  // 批发销售单订单类型(32, "wholesaleOrderOrderType"),
  // 批发销售单支付方式(33, "wholesaleOrderPayType"),
  // 退货集单的退货方式(34, "poolingReturnWay"),
  // 调拨单状态(35, "transferOrderStatus"),
  // 调拨分配单需求类型(36, "transferPreOrderRequireType"),
  // 租户(37, "tenant"),
  // 预约单的预约类型(38, "appointmentType"),
  // 预约单状态(39, "appointmentOrderStatus"),
  // 当前用户权限的商家以及商家下的地点(40, "authPlaceWithMerchant"),
  // 所有品类的类目树(41, "categoryTree"),
  // 批发销售的客户状态(42, "wholesaleOrderCustomerStatus"),
  // 是否直通(43, "whetherThrough"),
  // 需求申请单来源(44, "requireApplyOrderSource"),
  // 当前用户权限商家下的地点(45, "authMerchantPlace"),
  // 当前用户权限下的类目数(46, "authMerchantCategory"),
  // 当前用户权限下的门店和营业部(47, "authShop"),
  // 当前门店和营业部对应的供货DC(48, "shopOfWareHouse"),
  // 所有门店和营业部(49, "allShop"),
  // 所有仓库和配送中心(50, "allWareHouse"),
  // 所有商家(51, "allMerchant"),
  // 当前商家下的所有地点(52, "merchantOfPlaces");

};
/**
 * 物流模式/配送模式
 */

var LogisticMode;
/**
 * 物流模式的前端标记,分为1/2
 */

(function (LogisticMode) {
  LogisticMode[LogisticMode["DTS"] = 1] = "DTS";
  LogisticMode[LogisticMode["DC"] = 2] = "DC";
  LogisticMode[LogisticMode["XD"] = 3] = "XD";
})(LogisticMode || (LogisticMode = {}));

var LogisticModeSign; // export const LogisticModeMap = {
//   [LogisticMode.DTS]: LogisticModeSign.NOMORL,
//   // 仓店之间调拨
//   [LogisticMode.DC]: LogisticModeSign.TRANSFER,
//   [LogisticMode.XD]: LogisticModeSign.TRANSFER
// }

/**
 * 判断物流模式
 * 分为 1/NOMORL. 直送; 2/TRANSFER. 配送+直通
 */

(function (LogisticModeSign) {
  LogisticModeSign[LogisticModeSign["NOMORL"] = 1] = "NOMORL";
  LogisticModeSign[LogisticModeSign["TRANSFER"] = 2] = "TRANSFER";
})(LogisticModeSign || (LogisticModeSign = {}));

var LogisticModeMap = {
  [LogisticModeSign.NOMORL]: [LogisticMode.DTS],
  [LogisticModeSign.TRANSFER]: [LogisticMode.DC, LogisticMode.XD],
  NOMORL: [LogisticMode.DTS],
  TRANSFER: [LogisticMode.DC, LogisticMode.XD],
  DC: [LogisticMode.DC],
  XD: [LogisticMode.XD]
};
/**
 * 调拨类型枚举
 */

var TransferType;
/**
 * 异常明细的业务类型枚举
 */

(function (TransferType) {
  TransferType[TransferType["WAREHOUSE_TO_SHOP"] = 1] = "WAREHOUSE_TO_SHOP";
  TransferType[TransferType["SHOP_TO_SHOP"] = 2] = "SHOP_TO_SHOP";
  TransferType[TransferType["WAREHOUSE_TO_WAREHOUSE"] = 3] = "WAREHOUSE_TO_WAREHOUSE";
  TransferType[TransferType["SHOP_TO_WAREHOUSE"] = 4] = "SHOP_TO_WAREHOUSE";
})(TransferType || (TransferType = {}));

var enumPurchaseImportStatus;
/**
 * 异常明细异步导入状态
 */

(function (enumPurchaseImportStatus) {
  enumPurchaseImportStatus[enumPurchaseImportStatus["\u5F85\u6267\u884C"] = 1] = "\u5F85\u6267\u884C";
  enumPurchaseImportStatus[enumPurchaseImportStatus["\u6267\u884C\u4E2D"] = 2] = "\u6267\u884C\u4E2D";
  enumPurchaseImportStatus[enumPurchaseImportStatus["\u6267\u884C\u5931\u8D25"] = 3] = "\u6267\u884C\u5931\u8D25";
  enumPurchaseImportStatus[enumPurchaseImportStatus["\u6267\u884C\u6210\u529F"] = 8] = "\u6267\u884C\u6210\u529F";
})(enumPurchaseImportStatus || (enumPurchaseImportStatus = {}));

var enumPurchaseImportStatusType;
/**
 * 调价导入状态枚举
 */

(function (enumPurchaseImportStatusType) {
  enumPurchaseImportStatusType[enumPurchaseImportStatusType["\u91C7\u8D2D\u5355\u5546\u54C1\u5BFC\u5165"] = 1] = "\u91C7\u8D2D\u5355\u5546\u54C1\u5BFC\u5165";
  enumPurchaseImportStatusType[enumPurchaseImportStatusType["\u9700\u6C42\u7533\u8BF7\u5355\u5546\u54C1\u5BFC\u5165"] = 2] = "\u9700\u6C42\u7533\u8BF7\u5355\u5546\u54C1\u5BFC\u5165";
  enumPurchaseImportStatusType[enumPurchaseImportStatusType["\u6279\u53D1\u9500\u552E\u5BFC\u5165"] = 3] = "\u6279\u53D1\u9500\u552E\u5BFC\u5165";
  enumPurchaseImportStatusType[enumPurchaseImportStatusType["\u91C7\u8D2D\u5206\u914D\u5355\u5BFC\u5165"] = 4] = "\u91C7\u8D2D\u5206\u914D\u5355\u5BFC\u5165";
  enumPurchaseImportStatusType[enumPurchaseImportStatusType["\u8C03\u62E8\u5206\u914D\u5355\u5BFC\u5165"] = 5] = "\u8C03\u62E8\u5206\u914D\u5355\u5BFC\u5165";
  enumPurchaseImportStatusType[enumPurchaseImportStatusType["\u8C03\u62E8\u5355\u5BFC\u5165"] = 6] = "\u8C03\u62E8\u5355\u5BFC\u5165";
  enumPurchaseImportStatusType[enumPurchaseImportStatusType["\u91C7\u8D2D\u5355\u4EF7\u683C\u66F4\u65B0\u5BFC\u5165"] = 7] = "\u91C7\u8D2D\u5355\u4EF7\u683C\u66F4\u65B0\u5BFC\u5165";
  enumPurchaseImportStatusType[enumPurchaseImportStatusType["\u6279\u53D1\u5206\u914D\u5355\u5BFC\u5165"] = 8] = "\u6279\u53D1\u5206\u914D\u5355\u5BFC\u5165";
  enumPurchaseImportStatusType[enumPurchaseImportStatusType["\u8FD0\u8D39\u89C4\u5219\u5BFC\u5165"] = 9] = "\u8FD0\u8D39\u89C4\u5219\u5BFC\u5165";
  enumPurchaseImportStatusType[enumPurchaseImportStatusType["\u6279\u53D1\u5355\u5408\u5E76\u5BFC\u51FA"] = 10] = "\u6279\u53D1\u5355\u5408\u5E76\u5BFC\u51FA";
  enumPurchaseImportStatusType[enumPurchaseImportStatusType["\u96C6\u5355\u8010\u7528\u54C1\u660E\u7EC6"] = 11] = "\u96C6\u5355\u8010\u7528\u54C1\u660E\u7EC6";
  enumPurchaseImportStatusType[enumPurchaseImportStatusType["\u96C6\u5355\u660E\u7EC6\u5BFC\u5165"] = 12] = "\u96C6\u5355\u660E\u7EC6\u5BFC\u5165";
  enumPurchaseImportStatusType[enumPurchaseImportStatusType["\u751F\u9C9C\u96C6\u5355\u5BFC\u5165"] = 13] = "\u751F\u9C9C\u96C6\u5355\u5BFC\u5165";
  enumPurchaseImportStatusType[enumPurchaseImportStatusType["\u91C7\u8D2D\u5355\u9000\u8D27"] = 14] = "\u91C7\u8D2D\u5355\u9000\u8D27";
  enumPurchaseImportStatusType[enumPurchaseImportStatusType["\u5546\u54C1\u53BB\u635F\u7387"] = 21] = "\u5546\u54C1\u53BB\u635F\u7387";
})(enumPurchaseImportStatusType || (enumPurchaseImportStatusType = {}));

var enumPriceImportStatus; // 采购 -

(function (enumPriceImportStatus) {
  enumPriceImportStatus[enumPriceImportStatus["\u5F85\u5F00\u59CB"] = 1] = "\u5F85\u5F00\u59CB";
  enumPriceImportStatus[enumPriceImportStatus["\u8FDB\u884C\u4E2D"] = 2] = "\u8FDB\u884C\u4E2D";
  enumPriceImportStatus[enumPriceImportStatus["\u6210\u529F"] = 3] = "\u6210\u529F";
  enumPriceImportStatus[enumPriceImportStatus["\u5931\u8D25"] = 4] = "\u5931\u8D25";
})(enumPriceImportStatus || (enumPriceImportStatus = {}));

var replenishStatus;
/**
 * 采购本地枚举
 */

(function (replenishStatus) {
  replenishStatus[replenishStatus["NULL"] = 0] = "NULL";
  replenishStatus[replenishStatus["\u8349\u7A3F"] = 1] = "\u8349\u7A3F";
  replenishStatus[replenishStatus["\u5F85\u5BA1\u6838"] = 2] = "\u5F85\u5BA1\u6838";
  replenishStatus[replenishStatus["\u751F\u6548"] = 3] = "\u751F\u6548";
  replenishStatus[replenishStatus["\u4F5C\u5E9F"] = 4] = "\u4F5C\u5E9F";
})(replenishStatus || (replenishStatus = {}));

var enumGlobalPurchase = {
  /** 好坏货标记 */
  isDamage: [{
    value: 1,
    label: '好货'
  }, {
    value: 2,
    label: '坏货'
  }],

  /** 退货原因 */
  returnReason: [{
    value: 1,
    label: '高库存'
  }, {
    value: 2,
    label: '供应商撤场'
  }, {
    value: 3,
    label: '销售差'
  }, {
    value: 4,
    label: '其他'
  }]
}; // 采购 - 补退货类型

var replenishType;
/** 单据类型 */

(function (replenishType) {
  replenishType[replenishType["NULL"] = 0] = "NULL";
  replenishType[replenishType["\u8865\u8D27\u7533\u8BF7"] = 1] = "\u8865\u8D27\u7533\u8BF7";
  replenishType[replenishType["\u9000\u8D27\u7533\u8BF7"] = 2] = "\u9000\u8D27\u7533\u8BF7";
})(replenishType || (replenishType = {}));

var enumBillTYPE;
/**
 * 采购SCM系统 导入枚举
 * 1, "运费基础配置导入"。2, "去损率基础配置导入"。3,"供应链路由配置导入"。
 * 4,"补货商品配置-库存水位线",5:耐用品仓商品路由配置导入
 */

(function (enumBillTYPE) {
  enumBillTYPE[enumBillTYPE["\u91C7\u8D2D\u8BA2\u8D27"] = 1] = "\u91C7\u8D2D\u8BA2\u8D27";
  enumBillTYPE[enumBillTYPE["\u91C7\u8D2D\u9000\u8D27"] = 2] = "\u91C7\u8D2D\u9000\u8D27";
  enumBillTYPE[enumBillTYPE["\u4ED3\u95F4\u8C03\u62E8"] = 3] = "\u4ED3\u95F4\u8C03\u62E8";
  enumBillTYPE[enumBillTYPE["\u5E97\u95F4\u8C03\u62E8"] = 4] = "\u5E97\u95F4\u8C03\u62E8";
  enumBillTYPE[enumBillTYPE["\u4ED3\u5E97\u914D\u9001"] = 5] = "\u4ED3\u5E97\u914D\u9001";
  enumBillTYPE[enumBillTYPE["\u8865\u8D27\u96C6\u5355"] = 6] = "\u8865\u8D27\u96C6\u5355";
  enumBillTYPE[enumBillTYPE["\u9000\u8D27\u96C6\u5355"] = 7] = "\u9000\u8D27\u96C6\u5355";
})(enumBillTYPE || (enumBillTYPE = {}));

var enumPurchaseSCMImportStatusType;
/** SCM刷新导入结果查询所需type */

(function (enumPurchaseSCMImportStatusType) {
  enumPurchaseSCMImportStatusType[enumPurchaseSCMImportStatusType["\u5546\u54C1\u8DEF\u7531"] = 5] = "\u5546\u54C1\u8DEF\u7531";
  enumPurchaseSCMImportStatusType[enumPurchaseSCMImportStatusType["\u4F9B\u5E94\u94FE\u8DEF\u7531\u914D\u7F6E\u5BFC\u5165"] = 3] = "\u4F9B\u5E94\u94FE\u8DEF\u7531\u914D\u7F6E\u5BFC\u5165";
  enumPurchaseSCMImportStatusType[enumPurchaseSCMImportStatusType["\u53F0\u5DDE\u4ED3\u6279\u53D1\u4EF7\u683C\u5BFC\u5165"] = 8] = "\u53F0\u5DDE\u4ED3\u6279\u53D1\u4EF7\u683C\u5BFC\u5165";
  enumPurchaseSCMImportStatusType[enumPurchaseSCMImportStatusType["\u95E8\u5E97\u8DEF\u7531\u590D\u5236"] = 19] = "\u95E8\u5E97\u8DEF\u7531\u590D\u5236";
})(enumPurchaseSCMImportStatusType || (enumPurchaseSCMImportStatusType = {}));

var SCMImportType;
/** SCM刷新导入结果查询所需type */

(function (SCMImportType) {
  SCMImportType[SCMImportType["\u8FD0\u8D39\u57FA\u7840\u914D\u7F6E\u5BFC\u5165"] = 1] = "\u8FD0\u8D39\u57FA\u7840\u914D\u7F6E\u5BFC\u5165";
  SCMImportType[SCMImportType["\u53BB\u635F\u7387\u57FA\u7840\u914D\u7F6E\u5BFC\u5165"] = 2] = "\u53BB\u635F\u7387\u57FA\u7840\u914D\u7F6E\u5BFC\u5165";
  SCMImportType[SCMImportType["\u4F9B\u5E94\u94FE\u8DEF\u7531\u914D\u7F6E\u5BFC\u5165"] = 3] = "\u4F9B\u5E94\u94FE\u8DEF\u7531\u914D\u7F6E\u5BFC\u5165";
  SCMImportType[SCMImportType["\u5E93\u5B58\u6C34\u4F4D\u7EBF"] = 4] = "\u5E93\u5B58\u6C34\u4F4D\u7EBF";
  SCMImportType[SCMImportType["\u8010\u7528\u54C1\u4ED3\u5546\u54C1\u8DEF\u7531\u914D\u7F6E\u5BFC\u5165"] = 5] = "\u8010\u7528\u54C1\u4ED3\u5546\u54C1\u8DEF\u7531\u914D\u7F6E\u5BFC\u5165";
  SCMImportType[SCMImportType["\u4F9B\u5E94\u5546\u51FA\u5355\u65E5\u914D\u7F6E"] = 6] = "\u4F9B\u5E94\u5546\u51FA\u5355\u65E5\u914D\u7F6E";
  SCMImportType[SCMImportType["\u4ED3\u5E93\u914D\u9001\u5468\u671F\u5BFC\u5165"] = 7] = "\u4ED3\u5E93\u914D\u9001\u5468\u671F\u5BFC\u5165";
})(SCMImportType || (SCMImportType = {}));

var SCMDownloadType;
/** 单据类型 */

(function (SCMDownloadType) {
  SCMDownloadType[SCMDownloadType["\u4F9B\u5E94\u94FE\u8DEF\u7531\u5BFC\u5165\u6A21\u677F"] = 1] = "\u4F9B\u5E94\u94FE\u8DEF\u7531\u5BFC\u5165\u6A21\u677F";
  SCMDownloadType[SCMDownloadType["\u8865\u8D27\u5546\u54C1\u5E93\u5B58\u6C34\u4F4D\u7EBF\u914D\u7F6E"] = 2] = "\u8865\u8D27\u5546\u54C1\u5E93\u5B58\u6C34\u4F4D\u7EBF\u914D\u7F6E";
  SCMDownloadType[SCMDownloadType["\u5546\u54C1\u53BB\u635F\u7387\u5BFC\u5165\u6A21\u677F"] = 10] = "\u5546\u54C1\u53BB\u635F\u7387\u5BFC\u5165\u6A21\u677F";
  SCMDownloadType[SCMDownloadType["\u52A0\u4EF7\u89C4\u5219\u5BFC\u5165\u6A21\u677F"] = 11] = "\u52A0\u4EF7\u89C4\u5219\u5BFC\u5165\u6A21\u677F";
  SCMDownloadType[SCMDownloadType["\u8010\u7528\u54C1\u4ED3\u5546\u54C1\u8DEF\u7531\u914D\u7F6E\u5BFC\u5165\u6A21\u677F"] = 3] = "\u8010\u7528\u54C1\u4ED3\u5546\u54C1\u8DEF\u7531\u914D\u7F6E\u5BFC\u5165\u6A21\u677F";
  SCMDownloadType[SCMDownloadType["\u4F9B\u5E94\u5546\u51FA\u5355\u65E5\u914D\u7F6E\u5BFC\u5165\u6A21\u677F"] = 5] = "\u4F9B\u5E94\u5546\u51FA\u5355\u65E5\u914D\u7F6E\u5BFC\u5165\u6A21\u677F";
})(SCMDownloadType || (SCMDownloadType = {}));

var BILL_TYPE;

(function (BILL_TYPE) {
  BILL_TYPE[BILL_TYPE["\u672A\u77E5"] = 0] = "\u672A\u77E5";
  BILL_TYPE[BILL_TYPE["\u91C7\u8D2D\u8BA2\u8D27"] = 1] = "\u91C7\u8D2D\u8BA2\u8D27";
  BILL_TYPE[BILL_TYPE["\u91C7\u8D2D\u9000\u8D27"] = 2] = "\u91C7\u8D2D\u9000\u8D27";
  BILL_TYPE[BILL_TYPE["\u4ED3\u95F4\u8C03\u62E8"] = 3] = "\u4ED3\u95F4\u8C03\u62E8";
  BILL_TYPE[BILL_TYPE["\u5E97\u95F4\u8C03\u62E8"] = 4] = "\u5E97\u95F4\u8C03\u62E8";
  BILL_TYPE[BILL_TYPE["\u4ED3\u5E97\u914D\u9001"] = 5] = "\u4ED3\u5E97\u914D\u9001";
  BILL_TYPE[BILL_TYPE["\u8981\u8D27\u96C6\u5355"] = 6] = "\u8981\u8D27\u96C6\u5355";
  BILL_TYPE[BILL_TYPE["\u9000\u8D27\u96C6\u5355"] = 7] = "\u9000\u8D27\u96C6\u5355";
  BILL_TYPE[BILL_TYPE["\u6279\u53D1\u9500\u552E"] = 8] = "\u6279\u53D1\u9500\u552E";
  BILL_TYPE[BILL_TYPE["\u5E97\u4ED3\u9000\u914D"] = 9] = "\u5E97\u4ED3\u9000\u914D";
  BILL_TYPE[BILL_TYPE["\u91C7\u8D2D\u5206\u914D\u5355\u8BA2\u8D27"] = 10] = "\u91C7\u8D2D\u5206\u914D\u5355\u8BA2\u8D27";
  BILL_TYPE[BILL_TYPE["\u91C7\u8D2D\u5206\u914D\u5355\u9000\u8D27"] = 11] = "\u91C7\u8D2D\u5206\u914D\u5355\u9000\u8D27";
  BILL_TYPE[BILL_TYPE["\u5206\u62E8\u8BA2\u5355\u4ED3\u95F4\u8C03\u62E8"] = 12] = "\u5206\u62E8\u8BA2\u5355\u4ED3\u95F4\u8C03\u62E8";
  BILL_TYPE[BILL_TYPE["\u5206\u62E8\u8BA2\u5355\u5E97\u95F4\u8C03\u62E8"] = 13] = "\u5206\u62E8\u8BA2\u5355\u5E97\u95F4\u8C03\u62E8";
  BILL_TYPE[BILL_TYPE["\u5206\u62E8\u8BA2\u5355\u4ED3\u5E97\u914D\u9001"] = 14] = "\u5206\u62E8\u8BA2\u5355\u4ED3\u5E97\u914D\u9001";
  BILL_TYPE[BILL_TYPE["\u5206\u62E8\u8BA2\u5355\u5E97\u4ED3\u9000\u914D"] = 15] = "\u5206\u62E8\u8BA2\u5355\u5E97\u4ED3\u9000\u914D";
})(BILL_TYPE || (BILL_TYPE = {}));

/***/ }),

/***/ 3602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dU": function() { return /* binding */ changePriceType; },
/* harmony export */   "pH": function() { return /* binding */ changePriceEffectStatus; },
/* harmony export */   "Uh": function() { return /* binding */ changePriceApproveStatus; },
/* harmony export */   "mU": function() { return /* binding */ enumBomType; },
/* harmony export */   "dE": function() { return /* binding */ enumBomMode; },
/* harmony export */   "Yv": function() { return /* binding */ enumBomSupplyType; },
/* harmony export */   "Kl": function() { return /* binding */ enumBomStatus; },
/* harmony export */   "rZ": function() { return /* binding */ sellPriceSource; }
/* harmony export */ });
/* unused harmony export sellPriceStatus */
/** 调价类型 */
var changePriceType;
/** 调价单生效类型 */

(function (changePriceType) {
  changePriceType[changePriceType["\u552E\u4EF7"] = 2] = "\u552E\u4EF7";
  changePriceType[changePriceType["\u751F\u9C9C\u8C03\u4EF7\u552E\u4EF7"] = 3] = "\u751F\u9C9C\u8C03\u4EF7\u552E\u4EF7";
  changePriceType[changePriceType["\u8FDB\u4EF7"] = 1] = "\u8FDB\u4EF7";
})(changePriceType || (changePriceType = {}));

var changePriceEffectStatus;
/** 调价单审核类型 */

(function (changePriceEffectStatus) {
  changePriceEffectStatus[changePriceEffectStatus["\u7ACB\u5373\u751F\u6548"] = 1] = "\u7ACB\u5373\u751F\u6548";
  changePriceEffectStatus[changePriceEffectStatus["\u5B9A\u65F6\u751F\u6548"] = 2] = "\u5B9A\u65F6\u751F\u6548";
})(changePriceEffectStatus || (changePriceEffectStatus = {}));

var changePriceApproveStatus;
/** 加工类型 */

(function (changePriceApproveStatus) {
  changePriceApproveStatus[changePriceApproveStatus["\u5DF2\u5BA1\u6838"] = 1] = "\u5DF2\u5BA1\u6838";
  changePriceApproveStatus[changePriceApproveStatus["\u672A\u5BA1\u6838"] = 2] = "\u672A\u5BA1\u6838";
})(changePriceApproveStatus || (changePriceApproveStatus = {}));

var enumBomType;
/** 加工模式 */

(function (enumBomType) {
  enumBomType[enumBomType["\u7B49\u4EF7\u6DF7\u9500"] = 1] = "\u7B49\u4EF7\u6DF7\u9500";
  enumBomType[enumBomType["\u5206\u5272"] = 2] = "\u5206\u5272";
  enumBomType[enumBomType["\u4E00\u822C\u52A0\u5DE5"] = 3] = "\u4E00\u822C\u52A0\u5DE5";
  enumBomType[enumBomType["\u5206\u5272\u53EF\u9006"] = 5] = "\u5206\u5272\u53EF\u9006";
  enumBomType[enumBomType["\u732A\u8089\u5206\u5272"] = 6] = "\u732A\u8089\u5206\u5272";
  enumBomType[enumBomType["\u8089\u5206\u5272\uFF08\u8F6C\u79FB\u6210\u672C\uFF09"] = 7] = "\u8089\u5206\u5272\uFF08\u8F6C\u79FB\u6210\u672C\uFF09";
})(enumBomType || (enumBomType = {}));

var enumBomMode;
/** 物料类型 */

(function (enumBomMode) {
  enumBomMode[enumBomMode["\u5165\u5E93\u81EA\u52A8\u52A0\u5DE5"] = 1] = "\u5165\u5E93\u81EA\u52A8\u52A0\u5DE5";
  enumBomMode[enumBomMode["\u51FA\u5E93\u81EA\u52A8\u52A0\u5DE5"] = 2] = "\u51FA\u5E93\u81EA\u52A8\u52A0\u5DE5";
  enumBomMode[enumBomMode["\u5730\u70B9\u624B\u52A8\u52A0\u5DE5"] = 3] = "\u5730\u70B9\u624B\u52A8\u52A0\u5DE5";
})(enumBomMode || (enumBomMode = {}));

var enumBomSupplyType;
/** 状态类型 */

(function (enumBomSupplyType) {
  enumBomSupplyType[enumBomSupplyType["\u539F\u6599"] = 10] = "\u539F\u6599";
  enumBomSupplyType[enumBomSupplyType["\u6210\u54C1"] = 20] = "\u6210\u54C1";
})(enumBomSupplyType || (enumBomSupplyType = {}));

var enumBomStatus;
/** 状态类型 */

(function (enumBomStatus) {
  enumBomStatus[enumBomStatus["\u542F\u7528"] = 1] = "\u542F\u7528";
  enumBomStatus[enumBomStatus["\u672A\u542F\u7528"] = 2] = "\u672A\u542F\u7528";
})(enumBomStatus || (enumBomStatus = {}));

var sellPriceStatus = {
  '1': '草稿',
  '2': '已审核',
  '3': '调价中',
  '4': '调价完成'
};
/** 售价调价单来源类型 */

var sellPriceSource;

(function (sellPriceSource) {
  sellPriceSource[sellPriceSource["\u603B\u90E8"] = 1] = "\u603B\u90E8";
  sellPriceSource[sellPriceSource["\u95E8\u5E97"] = 2] = "\u95E8\u5E97";
  sellPriceSource[sellPriceSource["\u9E35\u5B9D"] = 3] = "\u9E35\u5B9D";
})(sellPriceSource || (sellPriceSource = {}));

/***/ }),

/***/ 82001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




/**
 * 倒计时
 */

/**
 * 使用requestAnimationFrame执行倒计时
 * @param time 执行回调的时间间隔
 * @param func 回调函数
 * @returns void
 */

function useAnimationFrameTimer(time, func) {
  var frameId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var timeTag = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(performance.now());
  var funcRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(func);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)(_useState, 2),
      result = _useState2[0],
      setResult = _useState2[1];

  funcRef.current = func;

  var countdown = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)().mark(function _callee() {
      var currentTime, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currentTime = performance.now();

              if (!(currentTime - timeTag.current >= time)) {
                _context.next = 8;
                break;
              }

              timeTag.current = currentTime;
              _context.next = 5;
              return funcRef.current();

            case 5:
              res = _context.sent;
              console.log(res);
              setResult(res);

            case 8:
              frameId.current = window.requestAnimationFrame(countdown);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function countdown() {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * 开启倒计时
   */


  var start = () => {
    frameId.current = window.requestAnimationFrame(countdown);
  };

  var stop = () => {
    if (frameId.current) {
      cancelAnimationFrame(frameId.current);
    }
  };

  return {
    start,
    stop,
    result,
    setResult
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (useAnimationFrameTimer);

/***/ }),

/***/ 16569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24731);
/* harmony import */ var _useCompareEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19125);





// props: 表示 placeCode 是否必传
function useAutoBill(props) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState, 2),
      showAutoBill = _useState2[0],
      setShowAutoBill = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    merchantId: '',
    firstCategoryId: '',
    secondCategoryId: '',
    orderType: '',
    orderDirect: '',
    placeCode: undefined
  }),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState3, 2),
      params = _useState4[0],
      setParams = _useState4[1]; // 是否展示强采过账


  (0,_useCompareEffect__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(() => {
    var merchantId = params.merchantId,
        firstCategoryId = params.firstCategoryId,
        secondCategoryId = params.secondCategoryId,
        orderType = params.orderType,
        orderDirect = params.orderDirect,
        placeCode = params.placeCode;

    if (merchantId && firstCategoryId && orderType && orderDirect && (props ? !!placeCode : true)) {
      (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)('purchase.basicdata.queryOrderIsAutoBill', {
        merchantId,
        firstCategoryId,
        secondCategoryId,
        orderType,
        orderDirect,
        placeCode
      }).then(v => {
        var allowAutoBill = v.result.allowAutoBill;

        if (v.success) {
          setShowAutoBill(allowAutoBill);
        }
      });
    }
  }, [params, props]);
  return [showAutoBill, setParams];
}

/* harmony default export */ __webpack_exports__["Z"] = (useAutoBill);

/***/ }),

/***/ 13764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71720);






/**
 * 获取采购单，调拨单等单号
 */



// 采购预处理(1),
// 调拨预处理(2),
// 采购订单单号(3)
// 调拨订单单号(4)
// 采购验收单单号(5)
// 补救单号(6)
// 转移入库单单号(11)
// 转移出库单单号(12)
// 采购流水单号(13)
// 补货需求单号(14)
// 集单号(15)
// 批发销售单号(16)
// 客户编号(17)
function useBizType(props) {
  var bizType = props.bizType;
  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState3, 2),
      code = _useState4[0],
      setCode = _useState4[1]; // 获取单号


  var getCode = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee() {
    var res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setLoading(true);
            _context.next = 4;
            return dispatch({
              type: 'common/getOrderIdByBizType',
              payload: {
                bizType
              }
            });

          case 4:
            res = _context.sent;
            setCode(res);
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);

            antd_es_message__WEBPACK_IMPORTED_MODULE_6__.default.error(_context.t0);

          case 11:
            _context.prev = 11;
            setLoading(false);
            return _context.finish(11);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8, 11, 14]]);
  })), [bizType, dispatch]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (bizType) {
      getCode();
    }
  }, [bizType, getCode]);
  return [code, loading];
}

/* harmony default export */ __webpack_exports__["Z"] = (useBizType);

/***/ }),

/***/ 53453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ UseButtonPermission; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24731);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_2__);







/**
 * 使用按钮权限分为几步
 * 一、中台权限中心在生鲜下 找到对应的页面权限下编辑，添加按钮权限
 * 二、给按钮取个中文名字， 英文编码，例如： SALE_PRICE_AUDIT
 * 三、调用UseButtonPermission 传入应用编码，代码实例如下：
 *  // 是否有权限
    const [canAudit] = UseButtonPermission({
      appCode: 'YPSX_MANAGEDATA',
      path: 'GoodsManage/Price/SellPrice',
      btnCode: 'SALE_PRICE_AUDIT'
    })
 * @param params appCode: 应用编码，例如区域管理：YPSX_MANAGEDATA； path：页面相对路径，例如：GoodsManage/Price/SellPrice；btnCode：按钮权限编码
 * @returns
 */
function UseButtonPermission(params) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState, 2),
      havePermission = _useState2[0],
      setHavePermission = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    queryPermission();
  }, []);

  var queryPermission = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee() {
      var identity, res, result, success, v, value, ruleArray;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              identity = params.appCode + '/' + params.path;
              _context.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__/* .default */ .Z)('purchase.basis.mapping', {
                type: [62],
                ext: {
                  appCode: params.appCode,
                  identity: identity,
                  tenant: js_cookie__WEBPACK_IMPORTED_MODULE_2___default().get('tenantId') || 1
                }
              });

            case 3:
              res = _context.sent;
              result = res.result, success = res.success;

              if (success) {
                v = result.maps;
                value = JSON.parse(v[62])["".concat(identity)];
                ruleArray = value ? JSON.parse(value) : [];
                setHavePermission(ruleArray.includes(params.btnCode));
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function queryPermission() {
      return _ref.apply(this, arguments);
    };
  }();

  return [havePermission];
}



/***/ }),

/***/ 74328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useCategory2; }
/* harmony export */ });
/* unused harmony export FRESH_CATE_CODE */
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var antd_lib_select__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64749);
/* harmony import */ var _useEnums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16965);






/** 生鲜类目 ID */
var FRESH_CATE_CODE = '10';
var Option = antd_lib_select__WEBPACK_IMPORTED_MODULE_2__/* .default.Option */ .Z.Option;
/**
 * @deprecated 推荐使用 src/pages/CentralManage/components/useCategory3.tsx
 * 二级商品类目联动
 */

var useCategory2 = filterCates => {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState, 2),
      firstCategoryId = _useState2[0],
      setFirstCategoryId = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState3, 2),
      secondCategoryId = _useState4[0],
      setSecondCategoryId = _useState4[1];

  var _useEnums = (0,_useEnums__WEBPACK_IMPORTED_MODULE_1__/* .useEnums */ .ws)(_useEnums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_DICT.categoryTreeBusinessMapping */ .J3.categoryTreeBusinessMapping),
      _useEnums2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useEnums, 2),
      categoryRaw = _useEnums2[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState5, 2),
      category2Opt = _useState6[0],
      setCategory2Opt = _useState6[1];

  var _useMemo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (categoryRaw) {
      var arr = [];
      var item; // 用 const 也可以在 eval 下跑 🙃

      Object.values(categoryRaw).forEach(val => {
        // eslint-disable-next-line no-eval
        eval("(item=".concat(val, ")"));
        arr.push(item);
      }); // {categoryId: 10, categoryName: "生鲜部", categorylevel: 1, childCategoryList: {…}, parentCategoryId: 0}

      if (filterCates instanceof Function) {
        try {
          arr = filterCates(arr);
        } catch (error) {
          console.warn('格式化类目报错\n', error);
        }
      }

      return [arr.map(item => ({
        value: item.categoryId,
        label: item.categoryName
      })), arr];
    } else {
      return [[], []];
    }
  }, [categoryRaw]),
      _useMemo2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useMemo, 2),
      categoryOpts1 = _useMemo2[0],
      categoryArr = _useMemo2[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState7, 2),
      categoryOpts2 = _useState8[0],
      setCategoryOpts2 = _useState8[1];

  var category2Ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  if (categoryRaw && !Object.values(categoryRaw).length) {
    console.warn('木有获取到类目', categoryRaw);
  }

  var changeCategory = (value, key) => {
    // const item = categoryArr.find(_ => value === _.categoryId)
    // const opts = Object.values(item?.childCategoryList || {}).map(({ categoryId: value, categoryName: label }) => ({ value, label }))
    if (key === 'firstCategoryId') {
      setFirstCategoryId(value);
      category2Ref.current = undefined; // setCategoryOpts2(opts)
    } else {
      setSecondCategoryId(value);
    }
  };

  var reset = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    setFirstCategoryId(undefined); // setSecondCategoryId(undefined)
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setSecondCategoryId(undefined);
    var item = categoryArr.find(_ => firstCategoryId === _.categoryId);
    var opts = Object.values((item === null || item === void 0 ? void 0 : item.childCategoryList) || {}).map(_ref => {
      var value = _ref.categoryId,
          label = _ref.categoryName;
      return {
        value,
        label
      };
    });
    setCategoryOpts2(opts !== null && opts !== void 0 ? opts : []);
  }, [firstCategoryId, categoryArr]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (category2Ref.current && categoryOpts2.find(opt => opt.value === +category2Ref.current)) {
      setSecondCategoryId(+category2Ref.current); // category2Ref.current = undefined
    }
  }, [categoryOpts2]);
  var setCategory2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(_ref2 => {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_ref2, 2),
        first = _ref3[0],
        second = _ref3[1];

    setFirstCategoryId(isNaN(+first) ? undefined : +first);

    if (second) {
      category2Ref.current = second;
    } // if (second !== undefined) {
    //   setTimeout(() => {
    //     setSecondCategoryId(isNaN(+second) ? undefined : +second) // 避开 firstCategoryId 引起的 setSecondCategoryId(undefined)
    //   }, 4000)
    // }

  }, []);
  var element = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd_lib_select__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)({
    allowClear: true,
    placeholder: "\u8BF7\u9009\u62E9",
    value: firstCategoryId,
    onChange: val => changeCategory(val, 'firstCategoryId')
  }, category2Opt[0]), categoryOpts1.map(_ref4 => {
    var value = _ref4.value,
        label = _ref4.label;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, {
      key: value,
      value: value
    }, label);
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd_lib_select__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)({
    allowClear: true,
    placeholder: "\u8BF7\u9009\u62E9",
    value: secondCategoryId,
    style: {
      minWidth: 104
    },
    onChange: val => changeCategory(val, 'secondCategoryId')
  }, category2Opt[1]), categoryOpts2.map(_ref5 => {
    var value = _ref5.value,
        label = _ref5.label;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, {
      key: value,
      value: value
    }, label);
  })));
  return [element, {
    category2: {
      firstCategoryId,
      secondCategoryId
    },
    setCategory2,
    reset,
    category2Opt,
    setCategory2Opt
  }];
};

/***/ }),

/***/ 71117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useCategory3Level; }
/* harmony export */ });
/* unused harmony export CategoryDict */
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var antd_lib_select__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64749);



/**
 * 三级类目选择
 * 一级下拉选择
 * 二三级 支持多级，可多选，可删除
 * 改造自useCategory3
 */


var ENUM_DICT = {
  /** 所有品类的类目树 */
  categoryTreeBusinessMapping: 46
};
var CategoryDict;

(function (CategoryDict) {
  CategoryDict["\u4E00\u7EA7\u7C7B\u76EE"] = "firstCategoryId";
  CategoryDict["\u4E8C\u7EA7\u7C7B\u76EE"] = "secondCategoryIds";
  CategoryDict["\u4E09\u7EA7\u7C7B\u76EE"] = "thirdCategoryIds";
})(CategoryDict || (CategoryDict = {}));

var Option = antd_lib_select__WEBPACK_IMPORTED_MODULE_1__/* .default.Option */ .Z.Option;

/**
 * 二级商品类目联动
 */
var useCategory3Level = (props, depth) => {
  var _props$outCategory6, _props$outCategory7;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState, 2),
      firstCategoryId = _useState2[0],
      setFirstCategoryId = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState3, 2),
      secondCategoryIds = _useState4[0],
      setSecondCategoryIds = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState5, 2),
      thirdCategoryIds = _useState6[0],
      setThirdCategoryIds = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState7, 2),
      categoryRaw = _useState8[0],
      setcategoryRaw = _useState8[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!props.goodModalCategoryData && props !== null && props !== void 0 && props.mappingList) {
      var res = (props === null || props === void 0 ? void 0 : props.mappingList) && (props === null || props === void 0 ? void 0 : props.mappingList['get']) && (props === null || props === void 0 ? void 0 : props.mappingList.get(ENUM_DICT.categoryTreeBusinessMapping));
      console.log('res233', res);
      setcategoryRaw(res);
    } else {
      setcategoryRaw(props.goodModalCategoryData);
    }
  }, [props.goodModalCategoryData, props === null || props === void 0 ? void 0 : props.mappingList]);

  var _useMemo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (!categoryRaw) return [[], []];
    var arr = categoryRaw;
    return [categoryRaw, arr];
  }, [categoryRaw]),
      _useMemo2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useMemo, 2),
      categoryOpts1 = _useMemo2[0],
      categoryArr = _useMemo2[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState9, 2),
      categoryOpts2 = _useState10[0],
      setCategoryOpts2 = _useState10[1];

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState12 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState11, 2),
      categoryOpts3 = _useState12[0],
      setCategoryOpts3 = _useState12[1];

  if (categoryRaw && !Object.values(categoryRaw).length) {
    console.warn('木有获取到类目', categoryRaw);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var _props$outCategory, _props$outCategory2, _props$outCategory4;

    setFirstCategoryId((_props$outCategory = props.outCategory) === null || _props$outCategory === void 0 ? void 0 : _props$outCategory.firstCategoryId);

    if ((_props$outCategory2 = props.outCategory) !== null && _props$outCategory2 !== void 0 && _props$outCategory2.secondCategoryId) {
      var _props$outCategory3;

      var _secondCategoryIds = [(_props$outCategory3 = props.outCategory) === null || _props$outCategory3 === void 0 ? void 0 : _props$outCategory3.secondCategoryId];
      setSecondCategoryIds(_secondCategoryIds);
      var firstItem = categoryArr.find(_ => firstCategoryId + '' === _.value + ''); //   // 根据二级类目id拼接三级类目

      var secondIem = _secondCategoryIds.reduce((acc, id) => {
        var _firstItem$others;

        console.log('firstItem', firstItem);
        console.log('id', id);

        if (firstItem !== null && firstItem !== void 0 && (_firstItem$others = firstItem.others) !== null && _firstItem$others !== void 0 && _firstItem$others.childCategoryList[id]) {
          var _firstItem$others2, _firstItem$others2$ch;

          return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)({}, acc), firstItem === null || firstItem === void 0 ? void 0 : (_firstItem$others2 = firstItem.others) === null || _firstItem$others2 === void 0 ? void 0 : (_firstItem$others2$ch = _firstItem$others2.childCategoryList[id]) === null || _firstItem$others2$ch === void 0 ? void 0 : _firstItem$others2$ch.childCategoryList);
        }

        return acc;
      }, {});

      var opts = Object.values(secondIem || {}).map(_ref => {
        var value = _ref.categoryId,
            label = _ref.categoryName;
        return {
          value,
          label
        };
      });
      console.log('opts', opts);
      setCategoryOpts3(opts !== null && opts !== void 0 ? opts : []);
    }

    if ((_props$outCategory4 = props.outCategory) !== null && _props$outCategory4 !== void 0 && _props$outCategory4.thirdCategoryId) {
      var _props$outCategory5;

      setThirdCategoryIds([(_props$outCategory5 = props.outCategory) === null || _props$outCategory5 === void 0 ? void 0 : _props$outCategory5.thirdCategoryId]);
    }
  }, [props.outCategory, categoryArr]);

  var changeCategory = (value, key) => {
    if (key === CategoryDict.一级类目) {
      setFirstCategoryId(value); // 设置一级类目，会自动重置二级类目
    } else if (key === CategoryDict.二级类目) {
      setSecondCategoryIds(value);
      var firstItem = categoryArr.find(_ => firstCategoryId + '' === _.value + ''); // const firstItem: any = categoryArr.find(_ => firstCategoryId === _.categoryId)
      // 根据二级类目id拼接三级类目

      if (value) {
        var _secondCategoryIds = [value];
        setThirdCategoryIds([]);
        console.log('value', value);

        var secondIem = _secondCategoryIds.reduce((acc, id) => {
          var _firstItem$others3;

          console.log('firstItem', firstItem);

          if (firstItem !== null && firstItem !== void 0 && (_firstItem$others3 = firstItem.others) !== null && _firstItem$others3 !== void 0 && _firstItem$others3.childCategoryList[id]) {
            var _firstItem$others4, _firstItem$others4$ch;

            return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)({}, acc), firstItem === null || firstItem === void 0 ? void 0 : (_firstItem$others4 = firstItem.others) === null || _firstItem$others4 === void 0 ? void 0 : (_firstItem$others4$ch = _firstItem$others4.childCategoryList[id]) === null || _firstItem$others4$ch === void 0 ? void 0 : _firstItem$others4$ch.childCategoryList);
          }

          return acc;
        }, {});

        console.log('secondIem', secondIem);
        var opts = Object.values(secondIem || {}).map(_ref2 => {
          var value = _ref2.categoryId,
              label = _ref2.categoryName;
          return {
            value,
            label
          };
        });
        setCategoryOpts3(opts !== null && opts !== void 0 ? opts : []);
      } else {
        setThirdCategoryIds([]);
      }
    } else if (key === CategoryDict.三级类目) {
      setThirdCategoryIds(value);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var _item$others;

    var item = categoryArr.find(_ => firstCategoryId + '' === _.value + '');

    if (item !== null && item !== void 0 && (_item$others = item.others) !== null && _item$others !== void 0 && _item$others.childCategoryList) {
      var _item$others2;

      var opts = Object.values((item === null || item === void 0 ? void 0 : (_item$others2 = item.others) === null || _item$others2 === void 0 ? void 0 : _item$others2.childCategoryList) || {}).map(_ref3 => {
        var value = _ref3.categoryId,
            label = _ref3.categoryName;
        return {
          value,
          label
        };
      });
      setCategoryOpts2(opts !== null && opts !== void 0 ? opts : []);
    }
  }, [firstCategoryId, categoryArr]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    console.log('secondCategoryIds', secondCategoryIds); // setThirdCategoryIds([])
  }, [secondCategoryIds]);
  var element = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "d-flex user-category-3"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd_lib_select__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z, {
    style: {
      width: 130
    },
    allowClear: true,
    placeholder: "\u8BF7\u9009\u62E9",
    value: firstCategoryId,
    disabled: true,
    onChange: val => changeCategory(val, CategoryDict.一级类目)
  }, categoryOpts1.map(_ref4 => {
    var value = _ref4.value,
        label = _ref4.label;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, {
      key: value,
      value: value
    }, label);
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd_lib_select__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z, {
    allowClear: true,
    style: {
      width: 130
    },
    placeholder: "\u8BF7\u9009\u62E9",
    disabled: props !== null && props !== void 0 && (_props$outCategory6 = props.outCategory) !== null && _props$outCategory6 !== void 0 && _props$outCategory6.secondCategoryId ? true : false // mode='tags'
    ,
    value: secondCategoryIds,
    onChange: val => changeCategory(val, CategoryDict.二级类目)
  }, categoryOpts2.map(_ref5 => {
    var value = _ref5.value,
        label = _ref5.label;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, {
      key: value,
      value: value
    }, label);
  })), depth ? null : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd_lib_select__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z, {
    allowClear: true,
    style: {
      width: 350
    },
    placeholder: "\u8BF7\u9009\u62E9",
    mode: "multiple",
    maxTagCount: 3,
    value: thirdCategoryIds,
    disabled: props !== null && props !== void 0 && (_props$outCategory7 = props.outCategory) !== null && _props$outCategory7 !== void 0 && _props$outCategory7.thirdCategoryId ? true : false,
    onChange: val => changeCategory(val, CategoryDict.三级类目)
  }, categoryOpts3.map(_ref6 => {
    var value = _ref6.value,
        label = _ref6.label;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, {
      key: value,
      value: value
    }, label);
  })));
  return [element, {
    category3: {
      firstCategoryId,
      secondCategoryIds,
      thirdCategoryIds
    },

    reset() {
      setFirstCategoryId(undefined);
    }

  }];
};

/***/ }),

/***/ 16292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_input_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47673);
/* harmony import */ var antd_es_input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4107);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34041);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);








/**
 * 一级品类、二级品类的联动表单项
 */


function useCategoryFields(props) {
  var label = props.label,
      _props$firstName = props.firstName,
      firstName = _props$firstName === void 0 ? 'firstCategoryId' : _props$firstName,
      _props$secondName = props.secondName,
      secondName = _props$secondName === void 0 ? 'secondCategoryIds' : _props$secondName,
      disabledFirst = props.disabledFirst,
      disabledSecond = props.disabledSecond,
      firstDefaultValue = props.firstDefaultValue,
      secondDefaultValue = props.secondDefaultValue,
      changeFieldCallback = props.changeFieldCallback,
      tip = props.tip,
      required = props.required; // 品类的数据集合

  var categoryAllList = props.categoryList || [];

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      firstValue = _useState2[0],
      setFirstValue = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState3, 2),
      secondValue = _useState4[0],
      setSecondValue = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState5, 2),
      secondList = _useState6[0],
      setSecondList = _useState6[1];

  var disableSecond = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => secondList.length === 1, [secondList]); // 设置二级品类下拉框数据

  var setSecondOptionsList = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((value, isSetSecondValue) => {
    try {
      // 二级的下拉数据
      var _ref = categoryAllList && categoryAllList.find(v => +v.value === value) || {},
          others = _ref.others;

      if (!(others !== null && others !== void 0 && others.childCategoryList)) {
        return;
      }

      var list = Object.values(others === null || others === void 0 ? void 0 : others.childCategoryList).map(v => ({
        value: v.categoryId,
        label: v.categoryName
      }));
      setSecondList(list); // 只有一条二级品类数据时

      var justOneData = list.length === 1; // 只有一个二级品类时赋值，生鲜类时赋值

      if (isSetSecondValue !== undefined || justOneData) {
        var secondVal;

        if (justOneData || isSetSecondValue) {
          var _list$;

          secondVal = (_list$ = list[0]) === null || _list$ === void 0 ? void 0 : _list$.value;
        }

        setSecondValue(secondVal);

        if (changeFieldCallback && isSetSecondValue !== undefined) {
          changeFieldCallback(secondName, secondVal, list[0]);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, [categoryAllList, secondName, changeFieldCallback]); // 初始化展示品类数据

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    // 一级品类
    if (firstDefaultValue) {
      var intValue = +firstDefaultValue;

      if (isNaN(intValue)) {
        antd_es_message__WEBPACK_IMPORTED_MODULE_5__.default.warning("\u300C".concat(firstName, "\u300D\u521D\u59CB\u503C\u4E0D\u662F\u6709\u6548\u6570\u503C"));

        return;
      } // 二级的下拉数据


      setSecondOptionsList(intValue, undefined);
      setFirstValue(intValue);
    } // 二级


    if (secondDefaultValue) {
      var _intValue = +secondDefaultValue;

      if (isNaN(_intValue)) {
        antd_es_message__WEBPACK_IMPORTED_MODULE_5__.default.warning("\u300C".concat(secondName, "\u300D\u521D\u59CB\u503C\u4E0D\u662F\u6709\u6548\u6570\u503C"));

        return;
      }

      if (_intValue === 0) {
        return;
      }

      setSecondValue(_intValue);
    }
  }, [firstDefaultValue, secondDefaultValue, categoryAllList.length, firstName, secondName]); // 一级品类、二级品类下拉框变化时

  var changeField = (name, value, opt) => {
    if (changeFieldCallback) {
      changeFieldCallback(name, value, opt);
    } // 选择一级品类时


    if (name === firstName) {
      // 如果一级品类的不是生鲜时，将二级品类置空，否则设置默认值
      var isFresh = +value === 10;
      setSecondOptionsList(value, isFresh);
      setFirstValue(value);
    }

    if (name === secondName) {
      setSecondValue(value);
    }
  };

  return [{
    label: label !== null && label !== void 0 ? label : '品类',
    // 名称
    name: firstName,
    // 字段名
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_6__/* .default.Group */ .Z.Group, {
      compact: true
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
      placeholder: "\u4E00\u7EA7",
      dropdownMatchSelectWidth: false,
      showSearch: true,
      allowClear: true,
      value: firstValue,
      optionLabelProp: "children",
      style: {
        width: '50%'
      },
      onChange: (v, o) => changeField(firstName, v, o),
      disabled: disabledFirst
    }, categoryAllList.map(v => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_7__/* .default.Option */ .Z.Option, {
      value: v.value,
      key: v.value,
      rows: v
    }, v.label))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
      placeholder: "\u4E8C\u7EA7",
      dropdownMatchSelectWidth: false,
      showSearch: true,
      allowClear: true,
      filterOption: false,
      value: secondValue,
      optionLabelProp: "children",
      style: {
        width: '50%'
      },
      onChange: (v, o) => changeField(secondName, v, o),
      disabled: disabledSecond || disableSecond
    }, secondList.map(v => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_7__/* .default.Option */ .Z.Option, {
      value: v.value,
      key: v.value,
      rows: v
    }, v.label))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
      style: {
        color: 'red',
        marginLeft: 1,
        fontSize: 12
      }
    }, tip)),
    required: required ? false : true
  }, {
    label: '二级品类',
    name: secondName,
    type: 'INPUT',
    hide: true
  }];
}

/* harmony default export */ __webpack_exports__["Z"] = (useCategoryFields);

/***/ }),

/***/ 61982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93224);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46565);


var _excluded = ["categoryId", "categoryName", "childCategoryList", "categorylevel"];

/**
 * 全量品类数据
 */



function useCategoryWholeData(num) {
  var disableIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var level = num || 1; // 默认一级

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState, 2),
      categoryList = _useState2[0],
      setCategoryList = _useState2[1]; // 将对象转为对象数组的形式


  var formatData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(obj => {
    return Object.entries(obj).map(item => {
      var _item = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(item, 2),
          key = _item[0],
          value = _item[1]; // eslint-disable-next-line no-eval


      var obj = value ? typeof value === 'string' ? eval("(".concat(value, ")")) : value : {};

      var categoryId = obj.categoryId,
          categoryName = obj.categoryName,
          childCategoryList = obj.childCategoryList,
          categorylevel = obj.categorylevel,
          rest = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(obj, _excluded);

      var existChild = childCategoryList ? Object.keys(childCategoryList).length : 0; // 取小于当前等级的数据

      var children = existChild && categorylevel < level && !disableIds.includes(categoryId) ? formatData(childCategoryList) : [];
      return {
        value: categoryId,
        label: categoryName,
        children,
        others: rest,
        disabled: disableIds.includes(categoryId)
      };
    });
  }, [level]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_1__/* .YpRequest */ .XQ)('purchase.basis.mapping', {
      type: [41]
    }).then(res => {
      if (!res.success) {
        return;
      }

      try {
        var _res$result, _res$result$maps, _res$result2, _res$result2$maps;

        var data = (_res$result = res.result) !== null && _res$result !== void 0 && (_res$result$maps = _res$result.maps) !== null && _res$result$maps !== void 0 && _res$result$maps[41] ? JSON.parse((_res$result2 = res.result) === null || _res$result2 === void 0 ? void 0 : (_res$result2$maps = _res$result2.maps) === null || _res$result2$maps === void 0 ? void 0 : _res$result2$maps[41]) : {};
        var list = formatData(data) || [];
        setCategoryList(list);
      } catch (error) {
        console.log(error);
      }
    });
  }, [formatData]);
  return categoryList;
}

/* harmony default export */ __webpack_exports__["Z"] = (useCategoryWholeData);

/***/ }),

/***/ 49952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46565);




function useCityList() {
  var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var layerNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState, 2),
      cityList = _useState2[0],
      setCityList = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_1__/* .YpRequest */ .XQ)('phoenix.AreaService.queryAreasByLevel', {
      level,
      layerNum
    }).then(v => {
      if (v.success) {
        var list = v.result.areaTree || [];
        setCityList(list);
      }
    });
  }, [layerNum, level]);
  return cityList;
}

/* harmony default export */ __webpack_exports__["Z"] = (useCityList);

/***/ }),

/***/ 19125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCompareEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/**
 * useEffect的依赖是否相同，相同不触发
 */


function useCompareEffect(effect, dependencies) {
  function deepCompareDependencies(value) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

    if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEqual)(value, ref.current)) {
      ref.current = value;
    }

    return ref.current;
  }

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(effect, deepCompareDependencies(dependencies));
}

/***/ }),

/***/ 53421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24731);




/**
 * 根据客户名称查询客户
 */



function useCustomer(name) {
  var oldName = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState, 2),
      customerList = _useState2[0],
      setCustomerList = _useState2[1];

  var searchCustomer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().mark(function _callee(value) {
      var res, _res$result, success, list, data;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)('purchase.wholesale.queryCustomerInformationCodeList', {
                customerName: value,
                page: 1,
                size: 10
              });

            case 2:
              res = _context.sent;
              _res$result = res.result, success = _res$result.success, list = _res$result.list;

              if (success) {
                data = list.map(v => ({
                  value: v.customerNo,
                  label: "".concat(v.customerNo, "-").concat(v.customerName),
                  others: v
                }));
                setCustomerList(data);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (oldName.current === name || name === undefined) {
      return;
    }

    oldName.current = name;
    searchCustomer(name);
  }, [name, searchCustomer]);
  return [customerList];
}

/* harmony default export */ __webpack_exports__["Z"] = (useCustomer);

/***/ }),

/***/ 76511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93224);


var _excluded = ["label", "name", "type", "initialValue"];

function useDateRange(props) {
  var label = props.label,
      name = props.name,
      type = props.type,
      initialValue = props.initialValue,
      rest = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_0__/* .default */ .Z)(props, _excluded);

  return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)({}, rest), {}, {
    label,
    name,
    type,
    rules: [{
      validator: (_, value) => {
        if (value && value.length) {
          var diffDate = value[1].diff(value[0], 'day');

          if (diffDate > 31) {
            return Promise.reject('时间范围不能超过31天');
          }
        }

        return Promise.resolve();
      }
    }],
    initialValue
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (useDateRange);

/***/ }),

/***/ 74900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useDebounce = function useDebounce(fn, deps) {
  var ms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
  var timeout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (timeout.current) clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      fn();
    }, ms);
  }, [deps]);

  var cancel = () => {
    clearTimeout(timeout.current);
    timeout = null;
  };

  return [cancel];
};

/* harmony default export */ __webpack_exports__["Z"] = (useDebounce);

/***/ }),

/***/ 88840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDependencyEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable no-extra-boolean-cast */

/**
 * 组件 componentDidMount 的时候不执行 useEffect 的方法
 * 只有依赖变化的时候会执行
 */

function useDependencyEffect(effect, dependencies) {
  var componentDidMount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!!componentDidMount.current) {
      effect();
    }
  }, dependencies);
  /**
   * 必须放在最底下
   */

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    componentDidMount.current = true;
  }, []);
}

/***/ }),

/***/ 78004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useDynamicColumns; }
/* harmony export */ });
/* unused harmony export DYNAMIC_COLUMNS */
/* harmony import */ var antd_es_popover_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20136);
/* harmony import */ var antd_es_popover__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55241);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71577);
/* harmony import */ var antd_es_divider_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48736);
/* harmony import */ var antd_es_divider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27049);
/* harmony import */ var antd_es_checkbox_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63185);
/* harmony import */ var antd_es_checkbox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9676);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5977);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(24616);













var _couter = 0;
var DYNAMIC_COLUMNS = 'table-dynamic-columns';

/**
 * 动态显示列
 */
function useDynamicColumns(columns, arg2) {
  var _arg2$deps;

  var location = (0,umi__WEBPACK_IMPORTED_MODULE_5__/* .useLocation */ .TH)();
  var ref_origin = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)([]);
  ref_origin.current = Array.isArray(columns) ? columns : ref_origin.current;

  var uniqueVal = col => col.key || col.dataIndex || col.title;

  var checked2columns = function checked2columns() {
    var checked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return ref_origin.current.filter(col => checked.includes(uniqueVal(col)));
  };

  var storageItem = localStorage.getItem(DYNAMIC_COLUMNS);
  var cache = {};

  if (storageItem) {
    var _JSON$parse;

    cache = (_JSON$parse = JSON.parse(storageItem)) !== null && _JSON$parse !== void 0 ? _JSON$parse : {};
  }

  var cache_key = "".concat(location.pathname, "[").concat(_couter, "]");

  if (arg2 instanceof Object) {
    if (arg2.key) cache_key = arg2.key;
  }

  (0,react__WEBPACK_IMPORTED_MODULE_4__.useLayoutEffect)(() => {
    _couter++;
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    _couter = 0;
  }, [location.pathname]);
  var cache_checked;

  if (cache.hasOwnProperty(cache_key)) {
    cache_checked = cache[cache_key];
  } // const cache_checked = cache[cache_key]


  var columns2checked = function columns2checked() {
    var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ref_origin.current;
    return columns.map(col => uniqueVal(col));
  };

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(cache_checked ? cache_checked : columns2checked()),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(checked2columns(checked)),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_useState3, 2),
      _columns = _useState4[0],
      set_columns = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_useState5, 2),
      visible = _useState6[0],
      setVisible = _useState6[1];

  var ref_checked = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(checked);

  var changeCheckbox = values => {
    setChecked(ref_checked.current = values);
  };

  var clickConfirm = () => {
    setVisible(false);
    set_columns(checked2columns(ref_checked.current));
    cache[cache_key] = ref_checked.current;
    localStorage.setItem(DYNAMIC_COLUMNS, JSON.stringify(cache));
  };

  var options = ref_origin.current.map(item => ({
    value: uniqueVal(item),
    label: item.title
  }));
  var indeterminate = checked.length < ref_origin.current.length && checked.length > 0;
  var checkedAll = checked.length === ref_origin.current.length;

  var clickCheckAll = () => {
    ref_checked.current = indeterminate || checked.length === 0 ? columns2checked() : [];
    setChecked(ref_checked.current);
  };

  var onVisibleChange = () => {
    setVisible(!visible);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    if (!Array.isArray(arg2 === null || arg2 === void 0 ? void 0 : arg2.deps)) return;
    set_columns(checked2columns(ref_checked.current));
  }, (_arg2$deps = arg2 === null || arg2 === void 0 ? void 0 : arg2.deps) !== null && _arg2$deps !== void 0 ? _arg2$deps : []);
  var content = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
    className: "dynamic-column-checkbox-group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_checkbox__WEBPACK_IMPORTED_MODULE_7__/* .default.Group */ .Z.Group, {
    onChange: changeCheckbox,
    value: checked,
    options: options
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_divider__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, {
    className: "mt-2 mb-2"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
    className: "text-right"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, {
    size: "small",
    type: "primary",
    onClick: clickConfirm
  }, "\u786E\u5B9A")));
  var CtrlButton = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
    className: ['table-dynamic-column d-inline-block'].join(' ')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_popover__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z, {
    placement: "bottomRight",
    title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_checkbox__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
      indeterminate: indeterminate,
      onChange: clickCheckAll,
      checked: checkedAll
    }, "\u5168\u9009"),
    visible: visible,
    content: content,
    onVisibleChange: onVisibleChange,
    trigger: "click"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z, null)));
  /** 不传递数据，返回百分比；传递数据，返回根据百分比计算后值 */

  var percent = arg0 => {
    var n = _columns.length / ref_origin.current.length;

    if (arg0 instanceof Object) {
      var num = arg0.num,
          _arg0$min = arg0.min,
          min = _arg0$min === void 0 ? 900 : _arg0$min;
      n = ~~Math.max(n * num, min);
    }

    return n;
  };

  return {
    columns: _columns,
    setColumns: set_columns,
    CtrlButton,
    percent
  };
}

/***/ }),

/***/ 16965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J3": function() { return /* binding */ ENUM_DICT; },
/* harmony export */   "ws": function() { return /* binding */ useEnums; },
/* harmony export */   "rJ": function() { return /* binding */ enum40processor; },
/* harmony export */   "A": function() { return /* binding */ enum3processor; }
/* harmony export */ });
/* unused harmony exports _useEnums, enum45processor */
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24731);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



/**
 * 所有枚举
 * https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=31411559
 */

var ENUM_DICT = {
  /** 需求汇总单状态 */
  demandPoolingStatusBusinessMapping: 6,

  /** 物流模式 */
  logisticsBusinessMapping: 7,

  /** 配送中心 */
  authDCBusinessMapping: 19,
  // 当前用户权限的供货(DC-大仓)

  /** 当前用户权限的地点 */
  authPlaceBusinessMapping: 3,
  // 数据混杂

  /** 当前用户权限的商家以及商家下的地点 */
  authPlaceWithMerchantBusinessMapping: 40,

  /** 当前用户权限商家下的地点 */
  authMerchantPlaceBusinessMapping: 45,

  /** 权限下的店群及门店信息 */
  authPlaceGroupMapper: 59,

  /** 所有品类的类目树 */
  categoryTreeBusinessMapping: 46,

  /** 退货集单的退货方式 */
  poolingReturnWayBusinessMapping: 34,

  /** 退货原因 */
  returnReasonBusinessMapping: 12,
  集单方式: 17,
  需求申请单来源: 44,
  // 补货提取数据
  当前用户权限的商家以及商家下的地点: 40,

  /**
   * 3 包含了 40 所有的数据 21-01-12
    枚举type=3(权限下的地点) 的接口
    新增参数placeScopes
     1、只要门店
    placeScopes=1
    2、只要大仓
    placeScopes=2
    3、只要营业部
    placeScopes=3
    4、都要
    placeScopes="" 或者参数不传
    5、需要多种组合
    placeScopes="1,2,3"
    1,2,3可以任意组合
   */
  当前用户权限的地点: 3
};

/**
 * 能用全局的 map，优先用全局的
 * 全局木有的，或者要原生数据的再用这个
 * @param type 兼容多个枚举
 */
var useEnums = function useEnums(type) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(() => {
    var arr = [[]]; // 单数

    if (Array.isArray(type)) {
      arr = []; // 复数

      type.forEach(_ => {
        arr.push([[]]);
      });
    }

    return arr;
  }),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState, 2),
      options = _useState2[0],
      setOptions = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__/* .default */ .Z)('purchase.basis.mapping', {
      type: Array.isArray(type) ? type : [type],
      ext: Object.values(params).filter(_ => _).length ? params : undefined
    }).then(_ref => {
      var success = _ref.success,
          result = _ref.result;

      if (success) {
        try {
          if (Array.isArray(type)) {
            var jsonArr = type.map(t => {
              var json = JSON.parse(result.maps[t]);
              return [// eslint-disable-next-line max-nested-callbacks
              Object.entries(json).map(_ref2 => {
                var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_ref2, 2),
                    value = _ref3[0],
                    label = _ref3[1];

                return {
                  value: +value,
                  label
                };
              }), json];
            });
            setOptions(jsonArr);
          } else {
            var json = JSON.parse(result.maps[type]);
            var opts = Object.entries(json).map(_ref4 => {
              var _ref5 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_ref4, 2),
                  value = _ref5[0],
                  label = _ref5[1];

              return {
                value: +value,
                label
              };
            });
            setOptions([opts, json]);
          }
        } catch (error) {
          console.warn('返回值', result);
          console.warn(error);
        }
      }
    });
  }, [JSON.stringify(params)]);
  return options;
}; // @useless - 单个枚举

var _useEnums = type => {
  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      options = _useState4[0],
      setOptions = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      raw = _useState6[0],
      setRaw = _useState6[1];

  useEffect(() => {
    ypRequest('purchase.basis.mapping', {
      type: [type]
    }).then(_ref6 => {
      var success = _ref6.success,
          result = _ref6.result;

      if (success) {
        var json = JSON.parse(result.maps[type]);
        var opts = Object.entries(json).map(_ref7 => {
          var _ref8 = _slicedToArray(_ref7, 2),
              value = _ref8[0],
              label = _ref8[1];

          return {
            value: +value,
            label
          };
        });
        setOptions(opts);
        setRaw(json);
      }
    });
  }, []);
  return [options, raw];
};

/**
 * placeRaw -> [{"merchantBusinessType":2,"merchantId":"2132334614","merchantName":"重庆第三方商家","placeVos":[{"placeId":"11111","placeName":"伪造的地点1"},{"placeId":"22222","placeName":"伪造的地点2"}]}]
 */
function enum40processor(placeRaw) {
  var res = [];
  if (!placeRaw) return res;

  try {
    var json = JSON.parse(placeRaw[Object.keys(placeRaw)[0]]);
    var arr = json.reduce((acc, cur) => acc.concat(cur.placeVos), []);
    res = arr.map(item => ({
      value: item.placeId,
      label: item.placeName,
      $raw: item
    }));
  } catch (error) {
    console.error('enum40processor\n', error);
  }

  return res;
}

/**
 * 解析枚举为 3 数据；useEnums.md 中有数据结构
 */
function enum3processor(raw) {
  var res = [];
  if (!raw) return res;

  try {
    res = Object.entries(raw).map(_ref9 => {
      var _ref10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_ref9, 2),
          jsonStr = _ref10[1];

      return JSON.parse(jsonStr);
    });
  } catch (error) {
    console.error('enum3processor\n', error);
  }

  return res;
}
/** 解析配送中心 - placeId(地点) */

enum3processor.map2delivery = function (raw) {
  return this(raw).map(record => ({
    label: record.
    /* delivery */
    placeName,
    value: record.
    /* delivery */
    placeId,
    $raw: record
  }));
};
/** 解析供应商 */


enum3processor.map2merchant = function (raw) {
  return this(raw).map(record => ({
    label: record.merchantName,
    value: record.merchantId,
    $raw: record
  }));
};

var enum45processor = (/* unused pure expression or super */ null && (enum3processor));

/***/ }),

/***/ 15880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useMapping__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7704);
/**
 * 根据枚举渲染 DetailInfo 组件数据
 */
 // import { useSelector } from 'umi'



function useGetDetailInfo(props) {
  var mapObj = props.mapObj,
      detailInfoMap = props.detailInfoMap,
      mapDataSource = props.mapDataSource; // const { mapping } = useSelector((state: any) => state.map)

  var mappingKeys = Object.values(mapObj);

  var _useMapping = (0,_useMapping__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)(mappingKeys),
      mapping = _useMapping.mapping;

  var result = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    var dataSource = mapDataSource;

    if (Array.isArray(detailInfoMap)) {
      detailInfoMap.forEach(val => {
        var name = val.name;
        var key = mapObj[name];
        var dataKey = dataSource[name];
        var mapVal = mapping.get(key) ? mapping.get(key)[dataKey] : dataKey;
        val.value = mapVal !== null && mapVal !== void 0 ? mapVal : '-';
      });
    } else {
      detailInfoMap.forEach((v, k) => {
        var key = mapObj[k]; // 当前的字段名对应的枚举的key

        var dataKey = dataSource[k]; // 当前的字段名对应的接口返回枚举

        var mapVal = mapping.get(key) ? mapping.get(key)[dataKey] : dataKey;
        v[1] = mapVal !== null && mapVal !== void 0 ? mapVal : '-';
      });
    }

    return detailInfoMap;
  }, [mapDataSource, detailInfoMap, mapping]);
  return result;
}

/* harmony default export */ __webpack_exports__["Z"] = (useGetDetailInfo);

/***/ }),

/***/ 88242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(57016);
/* harmony import */ var antd_es_progress_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34669);
/* harmony import */ var antd_es_progress__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(44808);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24731);
/* harmony import */ var _useAnimationFrameTimer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82001);
/* harmony import */ var _useRefCallback__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82981);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26715);










/**
 * 新奥义 · 轮训导入
 */






function useLoopImport(props) {
  var refreshCallback = props.refreshCallback,
      request = props.request;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState, 2),
      btnLoading = _useState2[0],
      setBtnLoading = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState3, 2),
      visible = _useState4[0],
      setVisible = _useState4[1]; // 轮训导入请求


  var importRequest = (0,_useRefCallback__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee() {
    var res, success, result, status, downloadUrl, tipsMsg;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(request.url, request.params);

          case 2:
            res = _context.sent;
            success = res.success, result = res.result;

            if (success) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", false);

          case 6:
            status = result.status, downloadUrl = result.downloadUrl, tipsMsg = result.tipsMsg;

            if (!(status === _config_enums__WEBPACK_IMPORTED_MODULE_7__/* .enumPurchaseImportStatus["待执行"] */ .wB["待执行"] || status === _config_enums__WEBPACK_IMPORTED_MODULE_7__/* .enumPurchaseImportStatus["执行中"] */ .wB["执行中"])) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", true);

          case 11:
            if (!(status === _config_enums__WEBPACK_IMPORTED_MODULE_7__/* .enumPurchaseImportStatus["执行成功"] */ .wB["执行成功"])) {
              _context.next = 17;
              break;
            }

            antd_es_message__WEBPACK_IMPORTED_MODULE_11__.default.success('导入数据成功');

            refreshCallback();
            return _context.abrupt("return", false);

          case 17:
            if (!(status === _config_enums__WEBPACK_IMPORTED_MODULE_7__/* .enumPurchaseImportStatus["执行失败"] */ .wB["执行失败"])) {
              _context.next = 20;
              break;
            }

            if (downloadUrl) {
              antd_es_message__WEBPACK_IMPORTED_MODULE_11__.default.warn(tipsMsg ? tipsMsg : '导入失败,请在excel中查看明细..');

              window.location.href = downloadUrl;
            } else {
              antd_es_message__WEBPACK_IMPORTED_MODULE_11__.default.warn(tipsMsg ? tipsMsg : '导入失败');
            }

            return _context.abrupt("return", false);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [request.url, request.params, refreshCallback]);
  var timer = (0,_useAnimationFrameTimer__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(1000, importRequest); // 开始轮训

  var startLoop = (0,_useRefCallback__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(() => {
    setBtnLoading(true);
    setVisible(true); // 导入失败后的重新导入状态重置

    timer.setResult(true);
    timer.start();
  }, [timer.start]); // console.log(timer.result)
  // 结束轮训

  var stopLoop = (0,_useRefCallback__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(() => {
    setBtnLoading(false);
    setVisible(false);
    timer.setResult(false);
    timer.stop();
  }, [timer.stop]); // 是否继续轮训

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (timer.result === false) {
      stopLoop();
    } else if (timer.result === true) {
      startLoop();
    } else {
      stopLoop();
    }

    return stopLoop;
  }, [startLoop, stopLoop, timer.result]);
  var loadingModal = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
    width: 540,
    visible: true,
    centered: true,
    destroyOnClose: true,
    maskClosable: false,
    closable: false,
    footer: null
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("h3", {
    className: "mTop16 mBottom16 alignCenter"
  }, "\u6B63\u5728\u5BFC\u5165\u6570\u636E"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
    style: {
      paddingBottom: '20px'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_progress__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
    strokeColor: {
      from: '#108ee9',
      to: '#87d068'
    },
    percent: 100,
    showInfo: false,
    status: "active"
  })));
  var dom = visible ? loadingModal : null;
  return {
    loading: btnLoading,
    startLoop,
    stopLoop,
    loadingModal: dom
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (useLoopImport);

/***/ }),

/***/ 68406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57016);
/* harmony import */ var antd_es_progress_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34669);
/* harmony import */ var antd_es_progress__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44808);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24731);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26715);
/* harmony import */ var _useDependencyEffect__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88840);








/* eslint-disable no-throw-literal */





function useLoopImportResult(props, deps) {
  var businessType = props.businessType,
      orderNo = props.orderNo,
      refreshCallback = props.refreshCallback,
      importUrl = props.importUrl,
      loadingTip = props.loadingTip,
      successTip = props.successTip;
  var interval = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState, 2),
      btnLoading = _useState2[0],
      setBtnLoading = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState3, 2),
      visible = _useState4[0],
      setVisible = _useState4[1];
  /**  导入改为异步，则2s轮询请求状态，直到成功或失败停止，给提示  默认5分钟内或者离开页面clear */


  var handleAfterImport = () => {
    /** clear loop */
    var clearLoop = () => {
      setBtnLoading(false);

      if (interval.current) {
        clearInterval(interval.current);
        interval.current = null;
      }
    };

    if (interval.current) {
      return;
    }

    setBtnLoading(true);
    interval.current = setInterval(() => {
      (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(importUrl || 'purchase.import.getLastImportResult', {
        businessType,
        // 业务类型
        orderNo // 主单编号

      }).then(res => {
        var success = res.success,
            result = res.result;

        if (!success) {
          // 任务问题直接清掉
          throw '请求失败';
        }

        var status = result.status,
            downloadUrl = result.downloadUrl,
            tipsMsg = result.tipsMsg;

        if (status === _config_enums__WEBPACK_IMPORTED_MODULE_5__/* .enumPurchaseImportStatus["待执行"] */ .wB["待执行"] || status === _config_enums__WEBPACK_IMPORTED_MODULE_5__/* .enumPurchaseImportStatus["执行中"] */ .wB["执行中"]) {// keep loop
        } else if (status === _config_enums__WEBPACK_IMPORTED_MODULE_5__/* .enumPurchaseImportStatus["执行成功"] */ .wB["执行成功"]) {
          antd_es_message__WEBPACK_IMPORTED_MODULE_8__.default.success(successTip || '导入数据成功');

          setBtnLoading(false);
          refreshCallback(true);
          setVisible(false);
          clearLoop();
        } else if (status === _config_enums__WEBPACK_IMPORTED_MODULE_5__/* .enumPurchaseImportStatus["执行失败"] */ .wB["执行失败"]) {
          if (downloadUrl) {
            antd_es_message__WEBPACK_IMPORTED_MODULE_8__.default.warn(tipsMsg ? tipsMsg : '导入失败,请在excel中查看明细..');

            window.location.href = downloadUrl;
          } else {
            antd_es_message__WEBPACK_IMPORTED_MODULE_8__.default.warn(tipsMsg ? tipsMsg : '导入失败');
          }

          clearLoop();
          refreshCallback(false);
          setVisible(false);
        } else {
          refreshCallback(false);
          setVisible(false);
          clearLoop();
        }
      }).catch(() => {
        refreshCallback(false);
        setVisible(false);
        clearLoop();
      });
    }, 2000); // setTimeout(() => {
    //   clearLoop()
    //   refreshCallback(false)
    // }, 3 * 60000) // 3分钟后自动如果继续失败，则强制移除
  };

  (0,_useDependencyEffect__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(() => {
    if (deps[0] === true && props.orderNo) {
      setVisible(true);
      handleAfterImport();
    }

    return () => {};
  }, [...deps, props.orderNo]);
  var loadingModal = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, {
    width: 540,
    visible: true,
    centered: true,
    destroyOnClose: true,
    maskClosable: false,
    closable: false,
    footer: null
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("h3", {
    className: "mTop16 mBottom16 alignCenter"
  }, loadingTip || '正在导入数据'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
    style: {
      paddingBottom: '20px'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_progress__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z, {
    strokeColor: {
      from: '#108ee9',
      to: '#87d068'
    },
    percent: 100,
    showInfo: false,
    status: "active"
  })));
  var dom = visible ? loadingModal : null;
  return [btnLoading, dom];
}

/* harmony default export */ __webpack_exports__["Z"] = (useLoopImportResult);

/***/ }),

/***/ 7704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ MappingKey; },
/* harmony export */   "Z": function() { return /* binding */ useMapping; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24731);
/* harmony import */ var _useCompareEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19125);




/**
 * 全局枚举
 */



/**
 * 全局枚举映射
 *
 * 使用：window.mapping
 */
//  需求申请单类型(1, "requireApplyOrderTypeBusinessMapping"),
//  需求申请单状态(2, "requireApplyOrderStatusBusinessMapping"),
//  当前用户权限的地点(3, "authPlaceBusinessMapping"),
//  仅所有一级品类(4, "firstCategoryBusinessMapping"),
//  仅所有二级品类(5, "secondCategoryBusinessMapping"),
//  需求汇总单状态(6, "demandPoolingStatusBusinessMapping"),
//  物流模式(7, "logisticsBusinessMapping"),
//  需求申请单集单标记(8, "poolingFlagBusinessMapping"),
//  采购单状态(9, "purchaseOrderStatusBusinessMapping"),
//  采购单类型(10, "purchaseOrderTypeBusinessMapping"),
//  采购单退货好坏货标记(11, "goodOrBadFlagBusinessMapping"),
//  退货原因(12, "returnReasonBusinessMapping"),
//  经营方式(13, "businessModeBusinessMapping"),
//  采购分配单需求类型(14, "purchasePreOrderRequireTypeBusinessMapping"),
//  采购分配单状态(15, "purchasePreOrderStatusBusinessMapping"),
//  采购分配单订单类型(16, "purchasePreOrderOrderTypeBusinessMapping"),
//  集单方式(17, "poolingWayBusinessMapping"),
//  //当前用户权限的商家(18, "authMerchantBusinessMapping"),
//  当前用户权限的供货DC(19, "authDCBusinessMapping"),
//  集单失败类型(20, "poolingErrorTypeBusinessMapping"),
//  调拨单类型(21, "transferOrderTypeBusinessMapping"),
//  加价规则的加价类型(22, "priceMarkUpTypeBusinessMapping"),
//  加价规则的基数类型(23, "priceMarkUpBaseTypeBusinessMapping"),
//  补救单状态(24, "remedyOrderStatusBusinessMapping"),
//  补救单类型(25, "remedyOrderTypeBusinessMapping"),
//  批发销售单状态(26, "wholesaleOrderStatusBusinessMapping"),
//  批发销售的客户分类(27, "wholesaleOrderCustomerTypeBusinessMapping"),
//  批发销售的结算账期(28, "wholesaleOrderSettlementBusinessMapping"),
//  批发客户联系人类型(29, "wholesaleOrderContactsTypeBusinessMapping"),
//  批发销售单订单来源(30, "wholesaleOrderRequireSourceBusinessMapping"),
//  批发销售单送货方式(31, "wholesaleOrderDeliveryTypeBusinessMapping"),
//  批发销售单订单类型(32, "wholesaleOrderOrderTypeBusinessMapping"),
//  批发销售单支付方式(33, "wholesaleOrderPayTypeBusinessMapping"),
//  退货集单的退货方式(34, "poolingReturnWayBusinessMapping"),
//  调拨单状态(35, "transferOrderStatusBusinessMapping"),
//  调拨分配单需求类型(36, "transferPreOrderRequireTypeBusinessMapping"),
//  租户(37, "tenantBusinessMapping"),
//  预约单的预约类型(38, "appointmentTypeBusinessMapping"),
//  预约单状态(39, "appointmentOrderStatusBusinessMapping"),
//  当前用户权限的商家以及商家下的地点(40, "authPlaceWithMerchantBusinessMapping"),
//  所有品类的类目树(41, "categoryTreeBusinessMapping"),
//  批发销售的客户状态(42, "wholesaleOrderCustomerStatusBusinessMapping"),
//  是否直通(43, "whetherThroughBusinessMapping"),
//  需求申请单来源(44, "requireApplyOrderSourceMapping"),
//  当前用户权限商家下的地点(45, "authMerchantPlaceBusinessMapping"),
//  当前用户权限下的类目数(46, "authMerchantCategoryBusinessMapping"),
//  当前用户权限下的门店和营业部(47, "authShopBusinessMapping"),
//  当前门店和营业部对应的供货DC(48, "shopOfWareHouseBusinessMapping"),
//  所有门店和营业部(49, "allShopBusinessMapping"),
//  所有仓库和配送中心(50, "allWareHouseBusinessMapping"),
//  所有商家(51, "allMerchantBusinessMapping"),
//  当前商家下的所有地点(52, "merchantOfPlacesBusinessMapping")
//  当前用户权限下的生鲜门店(53, "authYpshopBusinessMapping"),
//  单据类型(54, "orderTypeMapping"),
//  品类(55, "categoryMapping"),
//  调拨分配单红冲状态类型(56,"transferPreOrderReverseState"),
//  大仓库存标记(57, "inventoryStateBusinessMapping")，
//  批发分配单订单状态(58,"wholesalePreOrderStatusMapping"),
//  权限下的店群信息(59,"authPlaceGroupMapper"),
//  权限下店群的门店信息(60,"authGroupPlaceInfoMapper"),
//  权限下允许无单收货的类目信息(61,"authMerchantSingleReleaseGoodsCategoryMapper"),
//  查询按钮权限(62,"buttonPermissionsBusinessMapping")
// 枚举键

var MappingKey;

(function (MappingKey) {
  MappingKey[MappingKey["\u7269\u6D41\u6A21\u5F0F"] = 7] = "\u7269\u6D41\u6A21\u5F0F";
  MappingKey[MappingKey["\u6240\u6709\u54C1\u7C7B"] = 41] = "\u6240\u6709\u54C1\u7C7B";
  MappingKey[MappingKey["\u6743\u9650\u4E0B\u7684\u54C1\u7C7B"] = 46] = "\u6743\u9650\u4E0B\u7684\u54C1\u7C7B";
  MappingKey[MappingKey["\u6743\u9650\u4E0B\u7684\u5546\u5BB6"] = 40] = "\u6743\u9650\u4E0B\u7684\u5546\u5BB6";
  MappingKey[MappingKey["\u6743\u9650\u4E0B\u7684\u5730\u70B9"] = 3] = "\u6743\u9650\u4E0B\u7684\u5730\u70B9";
  MappingKey[MappingKey["\u6743\u9650\u4E0B\u7684\u6240\u6709\u5730\u70B9\u65E0\u8FC7\u6EE4\u6761\u4EF6"] = 84] = "\u6743\u9650\u4E0B\u7684\u6240\u6709\u5730\u70B9\u65E0\u8FC7\u6EE4\u6761\u4EF6";
  MappingKey[MappingKey["\u5F53\u524D\u7528\u6237\u6743\u9650\u7684\u4F9B\u8D27DC"] = 19] = "\u5F53\u524D\u7528\u6237\u6743\u9650\u7684\u4F9B\u8D27DC";
  MappingKey[MappingKey["\u7D27\u6025\u7A0B\u5EA6"] = 63] = "\u7D27\u6025\u7A0B\u5EA6";
  MappingKey[MappingKey["\u6743\u9650\u4E0B\u5E97\u7FA4\u7684\u95E8\u5E97\u4FE1\u606F"] = 60] = "\u6743\u9650\u4E0B\u5E97\u7FA4\u7684\u95E8\u5E97\u4FE1\u606F";
  MappingKey[MappingKey["\u8C03\u62E8\u5355\u7C7B\u578B"] = 21] = "\u8C03\u62E8\u5355\u7C7B\u578B";
  MappingKey[MappingKey["\u62A5\u4EF7\u8981\u6C42"] = 67] = "\u62A5\u4EF7\u8981\u6C42";
  MappingKey[MappingKey["\u8BE2\u4EF7\u7C7B\u578B"] = 68] = "\u8BE2\u4EF7\u7C7B\u578B";
  MappingKey[MappingKey["\u8BE2\u4EF7\u5355\u72B6\u6001"] = 69] = "\u8BE2\u4EF7\u5355\u72B6\u6001";
  MappingKey[MappingKey["\u91C7\u8D2D\u5206\u914D\u5355\u8BA2\u5355\u7C7B\u578B"] = 16] = "\u91C7\u8D2D\u5206\u914D\u5355\u8BA2\u5355\u7C7B\u578B";
  MappingKey[MappingKey["\u91C7\u8D2D\u5206\u914D\u5355\u72B6\u6001"] = 15] = "\u91C7\u8D2D\u5206\u914D\u5355\u72B6\u6001";
  MappingKey[MappingKey["\u91C7\u8D2D\u5206\u914D\u5355\u9700\u6C42\u7C7B\u578B"] = 14] = "\u91C7\u8D2D\u5206\u914D\u5355\u9700\u6C42\u7C7B\u578B";
  MappingKey[MappingKey["\u5546\u54C1\u6C60\u5BA1\u6838\u72B6\u6001"] = 70] = "\u5546\u54C1\u6C60\u5BA1\u6838\u72B6\u6001";
  MappingKey[MappingKey["\u5546\u54C1\u6C60\u5BA1\u6838\u610F\u89C1"] = 71] = "\u5546\u54C1\u6C60\u5BA1\u6838\u610F\u89C1";
  MappingKey[MappingKey["\u5546\u54C1\u6C60\u72B6\u6001"] = 72] = "\u5546\u54C1\u6C60\u72B6\u6001";
  MappingKey[MappingKey["\u6743\u9650\u4E0B\u7684\u5E97\u7FA4\u4FE1\u606F"] = 59] = "\u6743\u9650\u4E0B\u7684\u5E97\u7FA4\u4FE1\u606F";
  MappingKey[MappingKey["\u9700\u6C42\u7533\u8BF7\u5355\u72B6\u6001"] = 2] = "\u9700\u6C42\u7533\u8BF7\u5355\u72B6\u6001";
  MappingKey[MappingKey["\u62A5\u4EF7\u72B6\u6001"] = 73] = "\u62A5\u4EF7\u72B6\u6001";
  MappingKey[MappingKey["\u9000\u8D27\u539F\u56E0"] = 12] = "\u9000\u8D27\u539F\u56E0";
})(MappingKey || (MappingKey = {}));

// 恶一些心的枚举数据结构，害
var arrEnums = new Map([[3, ['placeId', 'placeName']], [41, ['categoryId', 'categoryName']], [46, ['categoryId', 'categoryName']], [47, ['placeId', 'placeName']], [59, ['placeGroupId', 'placeGroupName']], [84, ['placeId', 'placeName']]]);
var enumsKeys = [...arrEnums.keys()]; // 将对象转为对象数组的形式

var renderOptionsByObj = (obj, num) => {
  if (!obj || typeof obj !== 'object') {
    return [];
  }

  return Object.keys(obj).map(v => {
    var value = isNaN(parseFloat(v)) ? v : parseFloat(v);

    if (enumsKeys.includes(num)) {
      try {
        var enums = arrEnums.get(num); // eslint-disable-next-line no-eval

        var labelData = eval("(".concat(obj[v], ")"));
        return {
          value: labelData[enums[0]],
          label: labelData[enums[1]],
          others: labelData
        };
      } catch (error) {
        console.log("\u89E3\u6790\u679A\u4E3E\u300C".concat(num, "\u300D\u5931\u8D25\uFF1A"), error);
      }
    }

    return {
      value,
      label: obj[v],
      others: v
    };
  });
}; // 枚举type=3(权限下的地点) 的接口
// 新增参数placeScopes
// 1、只要门店
// placeScopes=1
// 2、只要大仓
// placeScopes=2
// 3、只要营业部
// placeScopes=3
// 4、都要
// placeScopes="" 或者参数不传
// 5、需要多种组合
// placeScopes="1,2,3"
// 1,2,3可以任意组合

/**
 * 获取全局枚举
 * @param type 获取的枚举类型
 */


function useMapping(type, p) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(new Map()),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState, 2),
      mapping = _useState2[0],
      setMapping = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(new Map()),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState3, 2),
      mappingList = _useState4[0],
      setMappingList = _useState4[1];

  (0,_useCompareEffect__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(() => {
    var queryMappingData = /*#__PURE__*/function () {
      var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee() {
        var params, res, maps, mappings, mappingsList;
        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  type: Array.isArray(type) ? type : [type]
                };

                if (p) {
                  params['ext'] = p;
                }

                _context.next = 4;
                return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)('purchase.basis.mapping', params);

              case 4:
                res = _context.sent;
                maps = res.result.maps;

                if (maps) {
                  _context.next = 9;
                  break;
                }

                console.error('请求枚举失败：', res);
                return _context.abrupt("return");

              case 9:
                mappings = [];
                mappingsList = [];
                Object.entries(maps).forEach(val => {
                  var key = val[0]; // 枚举的键值，如：1，2，3，4

                  var value = val[1]; // 枚举的值，如：{1:xxx, 2: hhhh}
                  // 将键转为数字类型

                  var num = typeof key === 'string' ? parseInt(key) : key; // 判断是否存在，以及是否为字符串

                  var obj = value ? typeof value === 'string' ? JSON.parse(value) : {} : {};
                  var list = [];

                  if (num === 40 || num === 85) {
                    var str = obj.merchants;

                    try {
                      var arr = JSON.parse(str);
                      list = arr.map(v => ({
                        value: +v.merchantId,
                        label: v.merchantName,
                        others: v
                      }));
                    } catch (error) {
                      console.log('解析商户枚举失败：', error);
                    }
                  } else {
                    list = renderOptionsByObj(obj, num);
                  }

                  mappings.push([num, obj]); // 塞到枚举数组里

                  mappingsList.push([num, list]);
                });
                setMapping(new Map(mappings));
                setMappingList(new Map(mappingsList));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function queryMappingData() {
        return _ref.apply(this, arguments);
      };
    }();

    queryMappingData();
  }, [type, p]);
  return {
    mapping,
    mappingList
  };
}

/***/ }),

/***/ 66108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_input_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47673);
/* harmony import */ var antd_es_input__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4107);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31097);
/* harmony import */ var antd_es_spin_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20228);
/* harmony import */ var antd_es_spin__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11382);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34041);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71720);
/* harmony import */ var _useMapping__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7704);












/* eslint-disable react-hooks/exhaustive-deps */

/**
 * 商家、地点表单项及其联动
 */




function usePlaceAndMerchant(props) {
  var label = props.label,
      merchantName = props.merchantName,
      placeName = props.placeName,
      disableMerchant = props.disableMerchant,
      disablePlace = props.disablePlace,
      placeDefaultValue = props.placeDefaultValue,
      merchantDefaultValue = props.merchantDefaultValue,
      changeFieldCallback = props.changeFieldCallback;
  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();

  var _useMapping = (0,_useMapping__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)([3, 40]),
      mappingList = _useMapping.mappingList;

  var outMerchantList = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => {
    var _props$merchantList;

    return (_props$merchantList = props.merchantList) !== null && _props$merchantList !== void 0 && _props$merchantList.length ? props.merchantList : undefined;
  }, [props.merchantList]); // 存在外部传入的数据时

  var merchantList = outMerchantList || mappingList.get(40) || [];
  var placeInitList = mappingList.get(3) || [];

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState, 2),
      placeList = _useState2[0],
      setPlaceList = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState3, 2),
      merchantValue = _useState4[0],
      setMerchantValue = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState5, 2),
      placeValue = _useState6[0],
      setPlaceValue = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState7, 2),
      loadingPlaceList = _useState8[0],
      setLoadingPlaceList = _useState8[1]; // 回显地点的值


  var place = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => {
    if (!placeValue) return;
    if (typeof placeValue === 'string' && placeValue.includes('-')) return placeValue;
    if (!placeList.length) return;

    var _ref = placeList.find(v => +v.value === +placeValue) || {
      label: undefined,
      others: {}
    },
        label = _ref.label,
        placeCode = _ref.others.placeCode;

    return "".concat(placeCode, "-").concat(label);
  }, [placeValue, placeList]); // 根据id或者商家详情

  var getMerchantDetail = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(merchantId => {
    var defaultData = {
      label: undefined,
      others: {}
    };
    if (!merchantId) return defaultData;
    var res = merchantList.find(v => +v.value === +merchantId) || defaultData;
    return res;
  }, [merchantList]); // 商家、地点下拉框变化时

  var changeField = (name, value, opt) => {
    var rows = opt || {
      rows: {}
    };
    var data = value;

    if (name === placeName) {
      var placeCode = value ? value.split('-')[0] : undefined;

      var _getMerchantDetail = getMerchantDetail(merchantDefaultValue),
          placeVos = _getMerchantDetail.others.placeVos; // 获取id 用于表单保存


      var _ref2 = (placeVos === null || placeVos === void 0 ? void 0 : placeVos.find(v => v.placeCode === placeCode)) || {},
          placeId = _ref2.placeId;

      data = placeId;
      setPlaceValue(value);
    } else {
      // 选择商家时
      setMerchantValue(data);
    }

    if (changeFieldCallback) {
      changeFieldCallback(name, data, rows);
    }
  }; // 解析地点的下拉数据


  var handlePlaceData = (str, val) => {
    try {
      var _ref3 = JSON.parse(str) || {},
          merchants = _ref3.merchants;

      if (!merchants) {
        return;
      }

      var _ref4 = JSON.parse(merchants).find(v => +v.merchantId === +val) || {},
          placeVos = _ref4.placeVos;

      if (!placeVos) {
        return;
      }

      var list = placeVos.map(v => ({
        value: +v.placeId,
        label: v.placeName,
        others: v
      }));
      setPlaceList(list);
    } catch (error) {
      console.log('解析地点数据失败：', error);
    }
  }; // 选中商家时，请求地点数据


  var selectMerchant = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)( /*#__PURE__*/function () {
    var _ref5 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().mark(function _callee(val) {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setPlaceList([]); // 置空地点下拉数据，以展示loading效果

              setPlaceValue(undefined);
              setLoadingPlaceList(true);
              _context.next = 5;
              return dispatch({
                type: 'map/queryComplex',
                payload: {
                  type: [40],
                  ext: {
                    merchantId: val
                  }
                }
              });

            case 5:
              res = _context.sent;

              if (res[40]) {
                handlePlaceData(res[40], val);
              }

              setLoadingPlaceList(false);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref5.apply(this, arguments);
    };
  }(), [dispatch]); // 选择地点，设置对应的商家

  var selectPlace = (v, opt) => {
    var others = opt.rows.others;
    var merchantId = others.merchantId;

    if (merchantId) {
      setMerchantValue(+merchantId);
    }
  }; // 初始化展示商家数据


  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    if (!merchantDefaultValue) {
      return;
    }

    var intValue = +merchantDefaultValue;

    if (isNaN(intValue)) {
      return;
    }

    setMerchantValue(intValue); // 获取地点下拉框数据

    selectMerchant(intValue);
  }, [merchantDefaultValue, selectMerchant]); // 初始化展示地点数据

  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    if (!placeDefaultValue || placeDefaultValue === placeValue) {
      return;
    }

    setPlaceValue(placeDefaultValue);
    var strVal = placeDefaultValue.toString();
    var placeId = strVal.includes('-') ? strVal.split('-')[0] : strVal;
    var rows = placeList.find(v => +v.value === +placeId) || {};
    if (!Object.keys(rows).length) return;

    if (changeFieldCallback) {
      changeFieldCallback(placeName, placeId, {
        rows
      }, true);
    }
  }, [changeFieldCallback, placeDefaultValue, placeList, placeName, placeValue]); // 初始化赋值下拉框数据

  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    if (placeInitList.length) {
      setPlaceList(placeInitList);
    }
  }, [placeInitList]);
  return [{
    label: label !== null && label !== void 0 ? label : '商家/地点',
    // 名称
    name: merchantName,
    // 商家字段名
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_10__/* .default.Group */ .Z.Group, {
      compact: true
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z, {
      placeholder: "\u5546\u5BB6",
      dropdownMatchSelectWidth: false,
      showSearch: true,
      allowClear: true,
      value: merchantValue,
      optionLabelProp: "children",
      style: {
        width: '50%'
      },
      onChange: (v, o) => changeField(merchantName, v, o),
      onSelect: selectMerchant,
      filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
      disabled: disableMerchant
    }, merchantList.map(v => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_11__/* .default.Option */ .Z.Option, {
      value: v.value,
      key: v.value,
      rows: v
    }, v.label))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
      title: place
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z, {
      placeholder: "\u5730\u70B9",
      dropdownMatchSelectWidth: false,
      showSearch: true,
      allowClear: true,
      value: place,
      optionLabelProp: "children",
      style: {
        width: '50%'
      },
      notFoundContent: loadingPlaceList ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_spin__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
        size: "small"
      }) : null,
      onChange: (v, o) => changeField(placeName, v, o),
      filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
      onSelect: selectPlace,
      disabled: disablePlace
    }, placeList.map(v => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_11__/* .default.Option */ .Z.Option, {
      value: "".concat(v.others.placeCode, "-").concat(v.label),
      key: "".concat(v.others.placeCode, "-").concat(v.label),
      rows: v
    }, "".concat(v.others.placeCode, "-").concat(v.label)))))),
    required: true
  }, {
    label: '地点',
    name: placeName,
    type: 'INPUT',
    hide: true,
    required: true
  }];
}

/* harmony default export */ __webpack_exports__["Z"] = (usePlaceAndMerchant);

/***/ }),

/***/ 41987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24731);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26715);
/* harmony import */ var _useDependencyEffect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88840);




/* eslint-disable no-throw-literal */

/**
 * 异步导入 适配区域调价
 */





function usePriceLoopImport(props, deps) {
  var type = props.type,
      taskId = props.taskId,
      refreshCallback = props.refreshCallback;
  var interval = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState, 2),
      btnLoading = _useState2[0],
      setBtnLoading = _useState2[1];
  /**  导入改为异步，则2s轮询请求状态，直到成功或失败停止，给提示  默认5分钟内或者离开页面clear */


  var handleAfterImport = () => {
    /** clear loop */
    var clearLoop = () => {
      setBtnLoading(false);

      if (interval.current) {
        clearInterval(interval.current);
        interval.current = null;
      }
    };

    setBtnLoading(true);
    interval.current = setInterval(() => {
      (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)('pms.sgPriceModifyManageService.getImportSgPriceModifyResult', {
        type,
        // 业务类型
        taskId // 任务编号

      }).then(res => {
        var success = res.success,
            result = res.result;

        if (!success) {
          // 任务问题直接清掉
          throw '请求失败';
        }

        console.log(result);
        var status = result.status,
            errorUrl = result.errorUrl,
            tipsMsg = result.tipsMsg,
            sgPriceModifyItemInfoDTO = result.sgPriceModifyItemInfoDTO,
            successCount = result.successCount,
            errorCount = result.errorCount,
            successUrl = result.successUrl; // 1-待开始 2-进行中 3-成功 4-失败

        if (status === _config_enums__WEBPACK_IMPORTED_MODULE_3__/* .enumPriceImportStatus["待开始"] */ .bK["待开始"] || status === _config_enums__WEBPACK_IMPORTED_MODULE_3__/* .enumPriceImportStatus["进行中"] */ .bK["进行中"]) {// keep loop
        } else if (status === _config_enums__WEBPACK_IMPORTED_MODULE_3__/* .enumPriceImportStatus["成功"] */ .bK["成功"]) {
          if (!(sgPriceModifyItemInfoDTO !== null && sgPriceModifyItemInfoDTO !== void 0 && sgPriceModifyItemInfoDTO.length)) {
            antd_es_message__WEBPACK_IMPORTED_MODULE_6__.default.warn('商品数据全部导入失败');

            window.location.href = errorUrl;
            refreshCallback(false);
          }

          if (!errorUrl && sgPriceModifyItemInfoDTO !== null && sgPriceModifyItemInfoDTO !== void 0 && sgPriceModifyItemInfoDTO.length) {
            antd_es_message__WEBPACK_IMPORTED_MODULE_6__.default.success('商品数据导入成功');

            refreshCallback(true, sgPriceModifyItemInfoDTO, {
              successCount,
              errorCount,
              successUrl
            });
          }

          if (errorUrl && sgPriceModifyItemInfoDTO !== null && sgPriceModifyItemInfoDTO !== void 0 && sgPriceModifyItemInfoDTO.length) {
            antd_es_message__WEBPACK_IMPORTED_MODULE_6__.default.warn('部分商品数据失败');

            window.location.href = errorUrl;
            refreshCallback(true, sgPriceModifyItemInfoDTO, {
              successCount,
              errorCount,
              successUrl,
              errorUrl
            });
          }

          setBtnLoading(false);
          clearLoop();
        } else if (status === _config_enums__WEBPACK_IMPORTED_MODULE_3__/* .enumPriceImportStatus["失败"] */ .bK["失败"]) {
          antd_es_message__WEBPACK_IMPORTED_MODULE_6__.default.error('导入任务失败');

          refreshCallback(false, sgPriceModifyItemInfoDTO);
          clearLoop();
        } else {
          refreshCallback(false, sgPriceModifyItemInfoDTO);
          clearLoop();
        }
      }).catch(() => {
        refreshCallback(false);
        clearLoop();
      });
    }, 2500);
    setTimeout(() => {
      clearLoop();
      refreshCallback(false);
    }, 10 * 60000); // 10分钟后自动如果继续失败，则强制移除
  };

  (0,_useDependencyEffect__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(() => {
    if (deps[0] === true) {
      handleAfterImport();
    }
  }, deps);
  return [btnLoading];
}

/* harmony default export */ __webpack_exports__["Z"] = (usePriceLoopImport);

/***/ }),

/***/ 12051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34041);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7704);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



 // 枚举type=3(权限下的地点) 的接口
// 新增参数placeScopes
// 1、只要门店
// placeScopes=1
// 2、只要大仓
// placeScopes=2
// 3、只要营业部
// placeScopes=3
// 4、都要
// placeScopes="" 或者参数不传
// 5、需要多种组合
// placeScopes="1,2,3"
// 1,2,3可以任意组合

/**
 * 根据placeid获取大仓，门店和营业部等来进行联动展示
 *   purchaseEnum: any // enum配置
 *   placeScopes: number // 当前地点类型选择
 *   title?: string // 如： 供货DC
 */
var usePurchaseConfigPlaced = props => {
  var purchaseEnum = props.purchaseEnum,
      placeScopes = props.placeScopes,
      title = props.title,
      _onSelect = props.onSelect,
      disabled = props.disabled;

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)(purchaseEnum, {
    // 1: 门店  2: 大仓  3： 营业部
    'placeScopes': placeScopes,
    // merchantType: 商家类型，默认  1:自营   2: POP
    merchantType: 1
  }),
      mappingList = _useMapping.mappingList; // 自定义渲染下拉列表 - 地点


  var SelectComponent = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    var _mappingList$get;

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
      placeholder: title || '供货DC',
      dropdownMatchSelectWidth: false,
      showSearch: true,
      disabled: disabled,
      allowClear: true,
      onSelect: val => {
        _onSelect && _onSelect(val, mappingList);
      },
      filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }, (_mappingList$get = mappingList.get(purchaseEnum)) === null || _mappingList$get === void 0 ? void 0 : _mappingList$get.map(v => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_3__/* .default.Option */ .Z.Option, {
      value: v.others.placeId,
      key: v.others.placeId
    }, "".concat(v.others.placeCode, "-").concat(v.label))));
  }, [mappingList]);
  return SelectComponent;
};

/* harmony default export */ __webpack_exports__["Z"] = (usePurchaseConfigPlaced);

/***/ }),

/***/ 1167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46565);






function usePurchaseExtData(formData) {
  var _ref = formData || {},
      merchantId = _ref.merchantId,
      placeId = _ref.placeId,
      firstCategoryId = _ref.firstCategoryId,
      orderDirect = _ref.orderDirect,
      merchantFlag = _ref.merchantFlag,
      placeCode = _ref.placeCode,
      suppCode = _ref.suppCode,
      billState = _ref.billState; // 获取参考价


  var queryPurchaseExtData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)().mark(function _callee(dataList) {
      var _res$0$result$list, _res$, _res$$result, _res$1$result$list, _res$2, _res$2$result, _res$2$result$infoMap, _res$3, _res$3$result, _res$2$result$turnOve, _res$4, _res$4$result;

      var extParams, referParams, queryParams, res, stockList, referenceList, turnoverDayList, turnDayMap, maps, stockMaps;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              extParams = {
                needPlaceStock: true,
                needWarehouseStock: true,
                needMinPurchasePrice: billState === 1,
                param: dataList.map(v => ({
                  merchantId,
                  placeId,
                  goodsId: +v.goodsId
                }))
              };
              referParams = {
                orderDirect,
                merchantId,
                placeId,
                firstCategoryId,
                goodsIds: dataList.map(v => +v.goodsId)
              };
              queryParams = {
                param: {
                  placeCode: placeCode,
                  goodsIdList: dataList.map(v => {
                    return {
                      goodsId: +v.goodsId,
                      price: v.amount
                    };
                  }),
                  placeId,
                  merchantId,
                  supplierCode: suppCode
                }
              };
              _context.next = 5;
              return Promise.all([(0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_1__/* .YpRequest */ .XQ)('purchase.product.queryProductExtInfo', extParams), (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_1__/* .YpRequest */ .XQ)('purchase.purchase.queryPurchaseReferencePrice', referParams), (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_1__/* .YpRequest */ .XQ)('purchase.order.purchaseOrderDetailEstimateTurnoverDayList', queryParams)]);

            case 5:
              res = _context.sent;
              // 库存list
              stockList = (_res$0$result$list = (_res$ = res[0]) === null || _res$ === void 0 ? void 0 : (_res$$result = _res$.result) === null || _res$$result === void 0 ? void 0 : _res$$result.list) !== null && _res$0$result$list !== void 0 ? _res$0$result$list : []; // 参考价list

              referenceList = (_res$1$result$list = (_res$2 = res[1]) === null || _res$2 === void 0 ? void 0 : (_res$2$result = _res$2.result) === null || _res$2$result === void 0 ? void 0 : _res$2$result.list) !== null && _res$1$result$list !== void 0 ? _res$1$result$list : []; // 预计周转天数

              turnoverDayList = (_res$2$result$infoMap = (_res$3 = res[2]) === null || _res$3 === void 0 ? void 0 : (_res$3$result = _res$3.result) === null || _res$3$result === void 0 ? void 0 : _res$3$result.infoMap) !== null && _res$2$result$infoMap !== void 0 ? _res$2$result$infoMap : null;
              turnDayMap = (_res$2$result$turnOve = (_res$4 = res[2]) === null || _res$4 === void 0 ? void 0 : (_res$4$result = _res$4.result) === null || _res$4$result === void 0 ? void 0 : _res$4$result.turnOverDayMap) !== null && _res$2$result$turnOve !== void 0 ? _res$2$result$turnOve : null; // 获取参考价的映射

              maps = referenceList.reduce((pre, next) => {
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)({}, pre), {}, {
                  [next.goodsId]: {
                    referencePrice: next.referencePrice || ''
                  }
                });
              }, {}); // 库存等

              stockMaps = stockList.reduce((pre, next) => {
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)({}, pre), {}, {
                  [next.goodsId]: {
                    stock: next.stock,
                    minPurchasePrice: next.minPurchasePrice
                  }
                });
              }, {});
              return _context.abrupt("return", dataList.map(v => {
                var _stockMaps$v$goodsId;

                console.log("===>>> apply info before", v);
                delete v['turnoverDay'];
                console.log("===>>> apply info after", v); // 供应商类型为-POP，则金额、单价默认为0，当 merchantFlag 为1时，表示为自营商家，否则pop商家
                // 新增时采购单的单价、金额默认为空

                var unitPrice = !!v.id && !!v.unitPrice ? v.unitPrice : merchantFlag === 2 ? 0 : undefined;
                var amount = !!v.id && !!v.amount ? v.amount : merchantFlag === 2 ? 0 : undefined;
                var minPrice = billState === 1 ? stockMaps === null || stockMaps === void 0 ? void 0 : (_stockMaps$v$goodsId = stockMaps[v === null || v === void 0 ? void 0 : v.goodsId]) === null || _stockMaps$v$goodsId === void 0 ? void 0 : _stockMaps$v$goodsId.minPurchasePrice : v.minPrice;
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)({}, v), maps[v.goodsId]), {}, {
                  unitPrice,
                  amount
                }, stockMaps[v.goodsId]), {}, {
                  blgdeclmal: turnoverDayList && turnoverDayList[v.goodsId] ? turnoverDayList[v.goodsId] : null,
                  turnoverDay: turnDayMap && turnDayMap[v.goodsId] ? turnDayMap[v.goodsId] : null,
                  minPrice
                });
              }));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [firstCategoryId, merchantFlag, merchantId, orderDirect, placeId]);
  return queryPurchaseExtData;
}

/* harmony default export */ __webpack_exports__["Z"] = (usePurchaseExtData);

/***/ }),

/***/ 58298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91896);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34041);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2824);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93224);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71720);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _useCompareEffect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19125);








var _excluded = ["label", "name", "fieldOptions", "defaultValue", "hide", "required", "searchParams", "onListChange"];

/* eslint-disable react-hooks/rules-of-hooks */

/**
 * 使用供应商表单项
 */





function useSupplier(props) {
  var label = props.label,
      name = props.name,
      fieldOptions = props.fieldOptions,
      defaultValue = props.defaultValue,
      hide = props.hide,
      required = props.required,
      searchParams = props.searchParams,
      onListChange = props.onListChange,
      restProps = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(props, _excluded);

  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_useState, 2),
      suppCodeList = _useState2[0],
      setSuppCodeList = _useState2[1]; // 获取供应商数据


  var changeSupplier = (0,lodash__WEBPACK_IMPORTED_MODULE_2__.debounce)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)().mark(function _callee(value) {
      var list, formatList;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch({
                type: 'purchase/querySupplierBaseInfoPage',
                payload: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, searchParams), {}, {
                  page: 1,
                  size: 10,
                  supplierName: value
                })
              });

            case 2:
              list = _context.sent;
              formatList = list.map(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, v), {}, {
                value: v.supplierCode,
                label: "".concat(v.supplierCode, "-").concat(v.supplierName)
              }));
              setSuppCodeList(formatList);
              onListChange === null || onListChange === void 0 ? void 0 : onListChange(list);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), 500);
  (0,_useCompareEffect__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(() => {
    if (hide) {
      return;
    }

    changeSupplier(defaultValue || ''); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue, hide, searchParams]);
  return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({
    label: label !== null && label !== void 0 ? label : '供应商',
    name: name !== null && name !== void 0 ? name : 'suppName',
    required,
    hide
  }, restProps), {}, {
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({}, fieldOptions, {
      filterOption: false,
      showSearch: true,
      allowClear: true,
      onSearch: changeSupplier,
      placeholder: "\u8BF7\u9009\u62E9\u4F9B\u5E94\u5546",
      dropdownMatchSelectWidth: false
    }), suppCodeList === null || suppCodeList === void 0 ? void 0 : suppCodeList.map(v => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_10__/* .default.Option */ .Z.Option, {
      value: v.supplierCode,
      key: v.supplierCode,
      rows: v
    }, "".concat(v.supplierCode, "-").concat(v.supplierName))))
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (useSupplier);

/***/ }),

/***/ 82981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/**
 * 当 useCallback 和 useEffect 组合使用时，由于 useCallback 的依赖项变化也会导致 useEffect 执行，这种隐式依赖会带来 BUG 或隐患。
 * 一旦某个函数使用了 useCallback ，当这个函数的依赖项变化时所有直接或间接调用这个 useCallback 的都需要回归。
 * 所以这是成本高、有风险的事情。
 */


function useRefCallback(callback, deps) {
  var callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
  callbackRef.current = callback;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    return callbackRef.current(...arguments);
  }, deps);
}

/* harmony default export */ __webpack_exports__["Z"] = (useRefCallback);

/***/ }),

/***/ 2633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5977);



function useRouterPush() {
  var shouldHideHeadAndSideMenu = top.location !== location;
  var history = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_1__/* .useHistory */ .k6)();
  var pushHistory = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(props => {
    var isString = typeof props === 'string';
    var paramsData = isString ? {
      pathname: props,
      query: {}
    } : props;

    if (shouldHideHeadAndSideMenu) {
      top.postMessage({
        type: 'push',
        params: paramsData,
        portal: true // 加了这个WMS那边才处理message

      }, '*');
    } else {
      history.push(props);
    }
  }, [history, shouldHideHeadAndSideMenu]);
  return pushHistory;
}

/* harmony default export */ __webpack_exports__["Z"] = (useRouterPush);

/***/ }),

/***/ 53658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91896);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34041);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2824);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93224);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71720);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _useCompareEffect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19125);








var _excluded = ["label", "name", "fieldOptions", "defaultValue", "hide", "required", "searchParams", "onListChange"];

/* eslint-disable react-hooks/rules-of-hooks */

/**
 * 使用供应商表单项
 */





function useSupplier(props) {
  var label = props.label,
      name = props.name,
      fieldOptions = props.fieldOptions,
      defaultValue = props.defaultValue,
      hide = props.hide,
      required = props.required,
      searchParams = props.searchParams,
      onListChange = props.onListChange,
      restProps = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(props, _excluded);

  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_useState, 2),
      suppCodeList = _useState2[0],
      setSuppCodeList = _useState2[1]; // 获取供应商数据


  var changeSupplier = (0,lodash__WEBPACK_IMPORTED_MODULE_2__.debounce)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)().mark(function _callee(value) {
      var list, formatList;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch({
                type: 'purchase/querySupplierBaseInfoPage',
                payload: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, searchParams), {}, {
                  page: 1,
                  size: 10,
                  supplierName: value,
                  supplierCategory: 1,
                  supplierStatus: 1
                })
              });

            case 2:
              list = _context.sent;
              formatList = list.map(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, v), {}, {
                value: v.supplierCode,
                label: "".concat(v.supplierCode, "-").concat(v.supplierName)
              }));
              setSuppCodeList(formatList);
              onListChange === null || onListChange === void 0 ? void 0 : onListChange(list);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), 500);
  (0,_useCompareEffect__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(() => {
    if (hide) {
      return;
    }

    changeSupplier(defaultValue || ''); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue, hide, searchParams]);
  return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({
    label: label !== null && label !== void 0 ? label : '供应商',
    name: name !== null && name !== void 0 ? name : 'suppName',
    required,
    hide
  }, restProps), {}, {
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({}, fieldOptions, {
      filterOption: false,
      showSearch: true,
      allowClear: true,
      onSearch: changeSupplier,
      placeholder: "\u8BF7\u9009\u62E9\u4F9B\u5E94\u5546",
      dropdownMatchSelectWidth: false
    }), suppCodeList === null || suppCodeList === void 0 ? void 0 : suppCodeList.map(v => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_10__/* .default.Option */ .Z.Option, {
      value: v.supplierCode,
      key: v.supplierCode,
      rows: v
    }, "".concat(v.supplierCode, "-").concat(v.supplierName))))
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (useSupplier);

/***/ }),

/***/ 2441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * 倒计时
 */


function useTimer() {
  var seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(seconds),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  var timer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!count) {
      clearTimeout(timer.current);
      return;
    }

    timer.current = setTimeout(() => {
      if (count > 0) {
        setCount(c => c - 1);
      }
    }, 1000);
  }, [count]);
  return [count, setCount];
}

/* harmony default export */ __webpack_exports__["Z"] = (useTimer);

/***/ }),

/***/ 20802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(57016);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(71577);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_FormBuilder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5670);
/* harmony import */ var _components_EditableTable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72927);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24731);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7704);
/* harmony import */ var _useTransferExtData__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77969);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96534);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26715);
/* harmony import */ var _constance__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35715);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7058);











/**
 * 商家商品
 */











// 库存等数据参数
var extInfoParams = {
  needPlaceStock: true,
  needWarehouseStock: true,
  needSupplier: true
};

var getLogisticMode = (transferType, inventoryState) => {
  // 仓店配送，直通标记勾选，模式必须为直通物流模式
  // 直通标记不勾选，物流模式必须为配送物流模式
  if (transferType === _config_enums__WEBPACK_IMPORTED_MODULE_11__/* .TransferType.WAREHOUSE_TO_SHOP */ .Z$.WAREHOUSE_TO_SHOP) {
    // 如果大仓库存字段有值，表示已经勾选直通
    var isStraight = !!inventoryState;
    return isStraight ? _config_enums__WEBPACK_IMPORTED_MODULE_11__/* .LogisticModeMap.XD */ .oB.XD : _config_enums__WEBPACK_IMPORTED_MODULE_11__/* .LogisticModeMap.DC */ .oB.DC;
  } // 店仓返配，配送+直通


  if (transferType === _config_enums__WEBPACK_IMPORTED_MODULE_11__/* .TransferType.SHOP_TO_WAREHOUSE */ .Z$.SHOP_TO_WAREHOUSE) {
    return _config_enums__WEBPACK_IMPORTED_MODULE_11__/* .LogisticModeMap.TRANSFER */ .oB.TRANSFER;
  } // 仓间调拨、店间调拨，物流模式不限制


  return undefined;
};

var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 10
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 14
    }
  }
};

function GoodsEditableModal(props) {
  var allowChangePrice = props.allowChangePrice,
      formData = props.formData;
  var transferOrderNo = formData.transferOrderNo,
      deliveryDcId = formData.deliveryDcId,
      receiveDcId = formData.receiveDcId,
      transferType = formData.transferType,
      deliveryMerchantId = formData.deliveryMerchantId,
      receiveMerchantId = formData.receiveMerchantId,
      secondCategoryId = formData.secondCategoryId,
      firstCategoryId = formData.firstCategoryId,
      inventoryState = formData.inventoryState;
  var transferExtData = (0,_useTransferExtData__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(formData); // 商家id

  var merchantId = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    return transferType === 1 ? receiveMerchantId : deliveryMerchantId;
  }, [deliveryMerchantId, receiveMerchantId, transferType]); // 地点id

  var placeId = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    return transferType === 1 ? receiveDcId : deliveryDcId;
  }, [deliveryDcId, receiveDcId, transferType]); // 默认查询参数

  var defaultSearchParams = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => ({
    billType: _constance__WEBPACK_IMPORTED_MODULE_12__/* .BillType */ .mP[+transferType],
    condition: {
      merchantId,
      placeId,
      firstCategoryId,
      secondCategoryId,
      logisticMode: getLogisticMode(transferType, inventoryState)
    }
  }), [firstCategoryId, inventoryState, merchantId, placeId, secondCategoryId, transferType]);

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(5),
      mappingList = _useMapping.mappingList;

  var table = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null); // 能否关闭浮层

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)(_useState, 2),
      canClose = _useState2[0],
      setCanClose = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)(_useState3, 2),
      queryState = _useState4[0],
      setQuery = _useState4[1]; // 判断多个请求之后状态


  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(defaultSearchParams),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)(_useState5, 2),
      searchParams = _useState6[0],
      setSearchParams = _useState6[1]; // 更新表格数据


  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)(_useState7, 2),
      updateDataSource = _useState8[0],
      setUpdateDataSource = _useState8[1];

  var secondId = isNaN(+secondCategoryId) ? undefined : +secondCategoryId; // 是否存在二级code

  var notSecondCode = secondId === 0 || !secondId;
  var formfields = [{
    label: '商品模糊',
    name: 'queryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '商品精准',
    name: 'accurateQueryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '商品品类',
    name: 'secondCategoryId',
    type: 'SELECT',
    dataList: mappingList.get(5),
    initialValue: notSecondCode ? undefined : secondId,
    reset: notSecondCode,
    fieldOptions: {
      disabled: !!secondId
    }
  }, {
    label: '品牌名称',
    name: 'brandName',
    type: 'INPUT'
  }];
  var columns = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => [{
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 170,
    fixed: true
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 90
  }, {
    title: '商品条码',
    dataIndex: 'goodsBarCode',
    key: 'goodsBarCode',
    width: 140
  }, {
    title: '二类类目',
    dataIndex: 'secondCategoryName',
    key: 'secondCategoryName',
    width: 100
  }, {
    title: '品牌名称',
    dataIndex: 'brandName',
    key: 'brandName',
    width: 110
  }, {
    title: '单位',
    dataIndex: 'specUnit',
    key: 'specUnit',
    align: 'right',
    width: 90
  }, {
    title: '数量',
    dataIndex: 'goodsCopies',
    key: 'goodsCopies',
    width: 150,
    editable: true,
    render: (t, r, i, fn) => {
      // 非称重商品为正整数，称重商品保留三位小数
      var isPositiveInteger = r.isWeigh === 2;

      if (fn) {
        var params = {
          fieldType: 'INPUT',
          fieldOptions: {
            formatter: value => isPositiveInteger ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_10__/* .exchageToNum1 */ .Ly)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_10__/* .exchageToNum3 */ .hY)(value)
          }
        };
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center'
          }
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
          style: {
            flex: 1
          }
        }, fn(params)), r.barCodeUnit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "/", r.barCodeUnit));
      }

      if (isNaN(+t)) {
        return undefined;
      }

      return isPositiveInteger ? Math.floor(+t) : (Math.floor(+t * 1000) / 1000).toFixed(3);
    }
  }, allowChangePrice && {
    title: '参考价',
    dataIndex: 'referencePrice',
    key: 'referencePrice',
    width: 110,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " \u5143").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '单价(含税)',
    dataIndex: 'unitPrice',
    key: 'unitPrice',
    width: 140,
    editable: allowChangePrice,
    render: (t, r, i, fn) => {
      if (fn && allowChangePrice) {
        var params = {
          fieldType: 'INPUT',
          fieldOptions: {
            formatter: _utils_common__WEBPACK_IMPORTED_MODULE_10__/* .exchageToNum3 */ .hY
          }
        };
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center'
          }
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
          style: {
            flex: 1
          }
        }, fn(params)), r.basicUnit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "\u5143/", r.basicUnit));
      }

      return !allowChangePrice && r.basicUnit && t ? "".concat(t, "\u5143/").concat(r.basicUnit) : t;
    }
  }, {
    title: '金额(含税)',
    dataIndex: 'amount',
    key: 'amount',
    width: 110,
    render: t => t || '-'
  }, {
    title: '调出地库存',
    dataIndex: 'dcStock',
    key: 'dcStock',
    width: 120,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " ").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '调入地库存',
    dataIndex: 'stock',
    key: 'stock',
    width: 120,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " ").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '规格描述',
    dataIndex: 'specDesc',
    key: 'specDesc',
    width: 90,
    align: 'right',
    render: t => t || '-'
  }].filter(Boolean), [allowChangePrice]);
  var searchHandler = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((state, values) => {
    setSearchParams(v => {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, v), {}, {
        condition: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, v.condition), values)
      });
    });
  }, []);
  var resetFields = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    setSearchParams(defaultSearchParams);
  }, [defaultSearchParams]); // 获取参考价和库存，并更新列表数据

  var setTableDataAfterRequest = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee(dataList) {
      var list, dataSource;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return transferExtData.queryInfo({
                dataList,
                extParams: extInfoParams
              });

            case 2:
              list = _context.sent;
              // 给「goodsId」对应的数据设置参考价
              dataSource = list.map(v => {
                var supplier = v.supplier.find(k => k.isDefaultSupplier) || {}; // 当且仅当 该条数据是从商品浮层添加的时候（不存在id）

                if (!v.id) {
                  return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, v), {}, {
                    unitPrice: undefined,
                    supplierCode: supplier.supplierCode,
                    supplierName: supplier.supplierName
                  });
                }

                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, v), {}, {
                  supplierCode: supplier.supplierCode,
                  supplierName: supplier.supplierName
                });
              });
              return _context.abrupt("return", dataSource);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function setTableDataAfterRequest(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var changeTable = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee2(data) {
      var _defaultSupplier$;

      var currentCell, currentRowOldData, currentRow, defaultSupplier, supplier, reqParams, res, _res$result, _res$result2, _ref3, unitPrice, amount, isSpecifiedPrice, isSpec, newRow;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currentCell = data.currentCell, currentRowOldData = data.currentRowOldData, currentRow = data.currentRow;

              if (!lodash__WEBPACK_IMPORTED_MODULE_4___default().isEmpty(currentCell)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              if (currentRow['goodsCopies']) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return");

            case 5:
              // console.log('111111')
              setQuery(prev => {
                return prev + 1;
              }); // if (Number(currentRow.unitPrice) === 0) {
              //   message.warning('单价/金额不可为0')
              //   return
              // }

              _context2.next = 8;
              return transferExtData.queryExtInfo([currentRow], extInfoParams);

            case 8:
              defaultSupplier = _context2.sent;
              supplier = (defaultSupplier === null || defaultSupplier === void 0 ? void 0 : (_defaultSupplier$ = defaultSupplier[0]) === null || _defaultSupplier$ === void 0 ? void 0 : _defaultSupplier$.supplier.find(k => k.isDefaultSupplier)) || {};
              reqParams = {
                id: currentRow.id,
                transferOrderNo,
                deliveryDcId,
                receiveDcId,
                goodsId: currentRow.goodsId,
                goodsBarCode: currentRow.goodsBarCode,
                goodsCopies: currentRow.goodsCopies,
                unitPrice: currentRow.unitPrice,
                referencePrice: currentRow.referencePrice,
                supplierCode: supplier.supplierCode,
                supplierName: supplier.supplierName
              };
              _context2.next = 13;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_17__/* .ALLOCATION_DETAIL_SAVE */ .F0, reqParams);

            case 13:
              res = _context2.sent;
              // console.log('22222')
              setQuery(prev => {
                return prev - 1;
              });

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_18__.default.success("".concat(currentRow.id ? '修改' : '添加', "\u5546\u54C1\u3010").concat(currentRow.goodsName, "\u3011\u6210\u529F"));

                _ref3 = (res === null || res === void 0 ? void 0 : (_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.detail) || {}, unitPrice = _ref3.unitPrice, amount = _ref3.amount, isSpecifiedPrice = _ref3.isSpecifiedPrice;
                isSpec = isSpecifiedPrice === 1; // isSpecifiedPrice为1时，表示指定价格

                newRow = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, currentRow), res === null || res === void 0 ? void 0 : (_res$result2 = res.result) === null || _res$result2 === void 0 ? void 0 : _res$result2.detail), {}, {
                  unitPrice: isSpec ? unitPrice : undefined,
                  amount: isSpec ? amount : undefined
                });
                setUpdateDataSource(arr => [...arr, newRow]);
              } else {
                setUpdateDataSource([(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, currentRow), currentRowOldData), {}, {
                  amount: undefined,
                  goodsCopies: undefined
                })]);
              }

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function changeTable(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    console.log(queryState, 'queryState');

    if (queryState === 0) {
      setCanClose(true);
    } else {
      setCanClose(false);
    }
  }, [queryState]); // 关闭的函数

  var closeProgramFun = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    // console.log('33333', canClose)
    if (canClose) {
      props.closeModalCallback();
    }
  }, [canClose]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z, {
    title: "\u5546\u54C1\u9009\u62E9",
    destroyOnClose: true,
    maskClosable: false,
    width: 1200,
    closable: false,
    visible: true,
    onCancel: props.closeModalCallback,
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
      key: "back",
      disabled: !canClose,
      onClick: () => {
        closeProgramFun();
      }
    }, "\u5173\u95ED")]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_FormBuilder__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    elements: formfields,
    callbackHandler: searchHandler,
    onReset: resetFields,
    formOptions: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, defaultFormItemLayout)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_EditableTable__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    ref: table,
    scrollYSize: 400,
    columns: columns,
    searchParams: searchParams,
    hideBtn: true,
    hideDeleteBtn: true,
    cancelRequest: !placeId,
    onChange: changeTable,
    queryDataUrl: "purchase.product.querySelectPlaceProductByCondition",
    tableOptions: {
      scroll: {
        y: 380
      }
    },
    updateDataSource: updateDataSource,
    setTableDataAfterRequest: setTableDataAfterRequest
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (GoodsEditableModal);

/***/ }),

/***/ 35715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mP": function() { return /* binding */ BillType; },
/* harmony export */   "Cd": function() { return /* binding */ OrderDirectType; },
/* harmony export */   "Dk": function() { return /* binding */ scopeMap; }
/* harmony export */ });
/* unused harmony exports PlaceScopeType, TransferType, colFieldEnums */
/**
 * 商户类型-枚举
 */
var PlaceScopeType;
/**
 * 调拨类型枚举
 */

(function (PlaceScopeType) {
  PlaceScopeType[PlaceScopeType["STORE"] = 1] = "STORE";
  PlaceScopeType[PlaceScopeType["WAREHOUSE"] = 2] = "WAREHOUSE";
  PlaceScopeType[PlaceScopeType["YYB"] = 3] = "YYB";
  PlaceScopeType[PlaceScopeType["DELIVERY"] = 4] = "DELIVERY";
})(PlaceScopeType || (PlaceScopeType = {}));

var TransferType;
/**
 * 订单类型
 * 符合多种订单如采购/调拨/等类型,因此需要做转换
 */

(function (TransferType) {
  TransferType[TransferType["WAREHOUSE_TO_SHOP"] = 1] = "WAREHOUSE_TO_SHOP";
  TransferType[TransferType["SHOP_TO_SHOP"] = 2] = "SHOP_TO_SHOP";
  TransferType[TransferType["WAREHOUSE_TO_WAREHOUSE"] = 3] = "WAREHOUSE_TO_WAREHOUSE";
  TransferType[TransferType["SHOP_TO_WAREHOUSE"] = 4] = "SHOP_TO_WAREHOUSE";
})(TransferType || (TransferType = {}));

var BillType = {
  [TransferType.WAREHOUSE_TO_SHOP]: 5,
  [TransferType.SHOP_TO_SHOP]: 4,
  [TransferType.WAREHOUSE_TO_WAREHOUSE]: 3,
  [TransferType.SHOP_TO_WAREHOUSE]: 9
};
/**
 * 强采强配过账枚举
 */

var OrderDirectType = {
  [TransferType.WAREHOUSE_TO_SHOP]: 3,
  [TransferType.SHOP_TO_SHOP]: 4,
  [TransferType.WAREHOUSE_TO_WAREHOUSE]: 5,
  [TransferType.SHOP_TO_WAREHOUSE]: 6
};
/**
 * 商品列表金额计算的字段映射
 */

var colFieldEnums; // 调拨类型对应的 仓店类型

(function (colFieldEnums) {
  colFieldEnums["specification"] = "deliverySpecification";
  colFieldEnums["goodsQty"] = "goodsCopies";
  colFieldEnums["goodsPrice"] = "unitPrice";
  colFieldEnums["referencePrice"] = "referencePrice";
})(colFieldEnums || (colFieldEnums = {}));

var scopeMap = {
  1: [2, 4],
  //
  2: [1, 3],
  // 店间调拨
  3: [2, 4],
  // 仓间调拨
  4: [2, 4]
};

/***/ }),

/***/ 77969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71720);




/**
 * 调拨单商品明细获取额外的参数
 */



function useTransferExtData(formData) {
  var receiveDcId = formData.receiveDcId,
      deliveryDcId = formData.deliveryDcId,
      transferType = formData.transferType,
      deliveryMerchantId = formData.deliveryMerchantId,
      receiveMerchantId = formData.receiveMerchantId;
  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)(); // 商家id

  var merchantId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    var transferType = formData.transferType,
        deliveryMerchantId = formData.deliveryMerchantId,
        receiveMerchantId = formData.receiveMerchantId;
    return transferType === 1 ? receiveMerchantId : deliveryMerchantId;
  }, [formData]);

  var queryExtInfo = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)().mark(function _callee(dataList, extParams) {
      var extInfoParams, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 库存等数据参数
              extInfoParams = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)({
                needPlaceStock: true,
                needWarehouseStock: true,
                param: dataList.map(v => ({
                  merchantId: +merchantId,
                  placeId: +receiveDcId,
                  goodsId: +v.goodsId,
                  deliveryDcId: +deliveryDcId
                }))
              }, extParams);
              _context.next = 3;
              return dispatch({
                type: 'purchase/queryProductExtInfo',
                payload: extInfoParams
              });

            case 3:
              res = _context.sent;
              return _context.abrupt("return", res.list);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function queryExtInfo(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(); // 获取参考价


  var queryReferencePrice = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)().mark(function _callee2(dataList, referenceParams) {
      var params, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 参考价的请求参数
              params = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)({
                transferType,
                deliveryMerchantId,
                receiveMerchantId,
                goods: dataList.map(v => ({
                  receivePlaceId: receiveDcId,
                  deliveryPlaceId: deliveryDcId,
                  goodsId: +v.goodsId
                }))
              }, referenceParams);
              _context2.next = 3;
              return dispatch({
                type: 'purchase/queryTransferReferencePrice',
                payload: params
              });

            case 3:
              res = _context2.sent;
              return _context2.abrupt("return", res.result.list);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function queryReferencePrice(_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();

  var queryInfo = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)().mark(function _callee3(props) {
      var dataList, referenceParams, extParams, requestArr, res, referenceList, stockList, maps, stockMaps;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dataList = props.dataList, referenceParams = props.referenceParams, extParams = props.extParams; // 需要额外发送接口请求特定的数据

              requestArr = [queryReferencePrice(dataList, referenceParams), queryExtInfo(dataList, extParams)];
              _context3.next = 4;
              return Promise.allSettled(requestArr);

            case 4:
              res = _context3.sent;
              // 参考价list
              referenceList = res[0].status === 'fulfilled' ? res[0].value : []; // 库存list

              stockList = res[1].status === 'fulfilled' ? res[1].value : []; // 获取商品编码与参考价的映射

              maps = referenceList.reduce((pre, next) => {
                pre[next.goodsId] = {
                  referencePrice: next.referencePrice
                };
                return pre;
              }, {}); // 库存等

              stockMaps = stockList.reduce((pre, next) => {
                pre[next.goodsId] = next;
                return pre;
              }, {}); // 给「goodsId」对应的数据设置参考价

              return _context3.abrupt("return", dataList.map(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)({}, v), maps[v.goodsId]), stockMaps[v.goodsId]), {}, {
                unitPrice: v.isSpecifiedPrice === 1 ? v.unitPrice : undefined
              })));

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function queryInfo(_x5) {
      return _ref3.apply(this, arguments);
    };
  }();

  return {
    queryReferencePrice,
    queryExtInfo,
    queryInfo
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (useTransferExtData);

/***/ }),

/***/ 7058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t7": function() { return /* binding */ ALLOCATION_LIST; },
/* harmony export */   "o_": function() { return /* binding */ ALLOCATION_INFO; },
/* harmony export */   "q3": function() { return /* binding */ ALLOCATION_SAVE; },
/* harmony export */   "F0": function() { return /* binding */ ALLOCATION_DETAIL_SAVE; },
/* harmony export */   "W": function() { return /* binding */ ALLOCATION_DETAIL_IMPORT; },
/* harmony export */   "Sb": function() { return /* binding */ ALLOCATION_DETAIL_DELETE; },
/* harmony export */   "Ee": function() { return /* binding */ ALLOCATION_SUBMIT; },
/* harmony export */   "Wm": function() { return /* binding */ ALLOCATION_CANCEL; },
/* harmony export */   "Kq": function() { return /* binding */ ALLOCATION_DETAIL_CLEAN; },
/* harmony export */   "JS": function() { return /* binding */ ALLOCATION_EXPORT; },
/* harmony export */   "Zn": function() { return /* binding */ ALLOCATION_AUDIT; },
/* harmony export */   "tj": function() { return /* binding */ ALLOCATION_DETAIL_LIST; },
/* harmony export */   "bB": function() { return /* binding */ ALLOCATION_ORDER_OUT_INFO; },
/* harmony export */   "eU": function() { return /* binding */ PURCHASE_LIST; },
/* harmony export */   "Hg": function() { return /* binding */ CREATE_REVERSE_ORDER; },
/* harmony export */   "Z2": function() { return /* binding */ ALLOCATION_BATCH_CANCEL; },
/* harmony export */   "Ev": function() { return /* binding */ PRE_ALLOCATION_LIST; },
/* harmony export */   "nq": function() { return /* binding */ PRE_ALLOCATION_SAVE; },
/* harmony export */   "NE": function() { return /* binding */ PRE_ALLOCATION_SUBMIT; },
/* harmony export */   "tz": function() { return /* binding */ PRE_ALLOCATION_CANCEL; },
/* harmony export */   "HE": function() { return /* binding */ PRE_ALLOCATION_DETAIL; },
/* harmony export */   "QB": function() { return /* binding */ PRE_ALLOCATION_OL_LIST; },
/* harmony export */   "gv": function() { return /* binding */ PRE_ALLOCATION_OL_SAVE; },
/* harmony export */   "ly": function() { return /* binding */ PRE_ALLOCATION_OL_IMPORT; },
/* harmony export */   "lo": function() { return /* binding */ PRE_ALLOCATION_OL_DELETE; },
/* harmony export */   "tM": function() { return /* binding */ PRE_ALLOCATION_CANCEL_CHECK; },
/* harmony export */   "NO": function() { return /* binding */ ALLOW_CHANGE_PRICE; },
/* harmony export */   "nM": function() { return /* binding */ PRODUCT_DETAIL; },
/* harmony export */   "DE": function() { return /* binding */ REFERENCE_PRICE; },
/* harmony export */   "l8": function() { return /* binding */ STATISTICS; },
/* harmony export */   "VQ": function() { return /* binding */ CHECK_REVERSE; },
/* harmony export */   "kz": function() { return /* binding */ BLOCK_ORDER; },
/* harmony export */   "qr": function() { return /* binding */ PRE_AUTO_IN_FLOW; },
/* harmony export */   "eR": function() { return /* binding */ TRANSFER_REVERSE; },
/* harmony export */   "JQ": function() { return /* binding */ PURCHASE_ORDER_LIST; },
/* harmony export */   "yY": function() { return /* binding */ PRODUCT_EXT_INFO; },
/* harmony export */   "He": function() { return /* binding */ ALLOCATION_DETAIL_INOUT; },
/* harmony export */   "ZO": function() { return /* binding */ ALLOCATION_DETAIL_EXPORT; }
/* harmony export */ });
/* unused harmony exports PRE_ALLOCATION_OL_CLEAR, PRE_ALLOCATION_ORDERS, BAR_CODE_LIST, PRODUCT_ID_NAMELIKE, PRODUCT_CODE_NAMELIKE, SUPPLIER_LIST */
/**
 * 调拨单主信息查询接口
 */
var ALLOCATION_LIST = 'scm.transfer.queryTransferOrderList';
/**
 * 调拨单信息主信息详情
 */

var ALLOCATION_INFO = 'purchase.transfer.transferOrderInfo';
/**
 * 调拨单主信息创建、更新接口
 */

var ALLOCATION_SAVE = 'purchase.transfer.saveTransferOrder';
/**
 * 调拨单明细保存、更新接口
 */

var ALLOCATION_DETAIL_SAVE = 'purchase.transfer.saveTransferOrderLine';
/**
 * 调拨单明细导入接口
 */

var ALLOCATION_DETAIL_IMPORT = 'purchase.transfer.importTransferOrderLine';
/**
 * 调拨单明细删除接口
 */

var ALLOCATION_DETAIL_DELETE = 'purchase.transfer.deleteTransferOrderLine';
/**
 * 调拨单提交接口
 */

var ALLOCATION_SUBMIT = 'purchase.transfer.submitTransferOrder';
/**
 * 调拨单作废接口
 */

var ALLOCATION_CANCEL = 'scm.transfer.cancelTransferOrder';
/**
 * 调拨单清空明细接口
 */

var ALLOCATION_DETAIL_CLEAN = 'purchase.transfer.cleanTransferOrderDetail';
/**
 * 调拨单导出接口
 */

var ALLOCATION_EXPORT = 'purchase.transfer.exportTransferOrder';
/**
 * 调拨单审核接口
 */

var ALLOCATION_AUDIT = 'purchase.transfer.auditTransferOrder';
/**
 * 调拨单明细分页查询接口
 */

var ALLOCATION_DETAIL_LIST = 'purchase.transfer.transferOrderDetailPageInfo';
/**
 * 详情-出入库查询接口
 */

var ALLOCATION_ORDER_OUT_INFO = 'purchase.transfer.queryTransferOrderOutInInfo';
/**
 * 采购单列表查询接口
 */

var PURCHASE_LIST = 'purchase.order.purchaseOrderList';
/**
 * 创建红冲单
 */

var CREATE_REVERSE_ORDER = 'purchase.transfer.createTransferReverseOrder';
/**
 * 批量导出
 */

var ALLOCATION_BATCH_CANCEL = 'scm.transfer.mergeExportTransferOrder'; // //////////////////////////////////////////////////////
// /////////// 调拨分配单 ///////////////////////////////

/**
 * 调拨分配单(预处理)列表查询接口
 */

var PRE_ALLOCATION_LIST = 'purchase.require.queryTransferPreprocessOrderList';
/**
 * 调拨分配单(预处理)主单保存接口
 */

var PRE_ALLOCATION_SAVE = 'purchase.require.saveTransferPreProcessOrder';
/**
 * 调拨分配单(预处理)提交接口
 */

var PRE_ALLOCATION_SUBMIT = 'purchase.require.submitTransferPreProcessOrder';
/**
 * 调拨分配单(预处理)作废接口
 */

var PRE_ALLOCATION_CANCEL = 'purchase.require.cancelTransferPreProcessOrder';
/**
 * 调拨分配单(预处理)详情查询接口
 */

var PRE_ALLOCATION_DETAIL = 'purchase.require.queryTransferPreprocessOrderDetail';
/**
 * 调拨分配单(预处理)商品明细列表接口
 */

var PRE_ALLOCATION_OL_LIST = 'purchase.require.queryTransferPreprocessOrderLines';
/**
 * 调拨分配单(预处理)商品明细保存接口
 */

var PRE_ALLOCATION_OL_SAVE = 'purchase.require.saveTransferPreProcessOrderLine';
/**
 * 调拨分配单(预处理)商品明细导入接口
 */

var PRE_ALLOCATION_OL_IMPORT = 'purchase.require.importTransferPreProcessOrderLine';
/**
 * 调拨分配单(预处理)商品明细删除接口
 */

var PRE_ALLOCATION_OL_DELETE = 'purchase.require.deleteTransferPreProcessOrderLine';
/**
 * 调拨分配单(预处理)商品明细清空接口
 */

var PRE_ALLOCATION_OL_CLEAR = 'purchase.require.clearTransferPreProcessOrderLine';
/**
 * 调拨分配单(预处理)订单列表
 */

var PRE_ALLOCATION_ORDERS = 'purchase.transfer.queryTransferOrderListByPreProcessNO';
/**
 * 调拨单分配单取消check校验
 */

var PRE_ALLOCATION_CANCEL_CHECK = 'purchase.require.statCancelTransfer';
/**
 * 查询是否能够改价-根据一级品类
 */

var ALLOW_CHANGE_PRICE = 'purchase.product.allowChangePrice';
/**
 * 根据编码查询条码列表
 */

var BAR_CODE_LIST = 'purchase.product.queryBarcodeByProductId';
/**
 * 模糊搜索 商品编码
 */

var PRODUCT_ID_NAMELIKE = 'purchase.product.queryProductIdByKey';
/**
 * 模糊搜索 商品条码
 */

var PRODUCT_CODE_NAMELIKE = 'purchase.product.queryBarcodeByKey';
/**
 * 商品详情
 */

var PRODUCT_DETAIL = 'purchase.product.queryInsertPlaceProduct';
/**
 * 供销商列表
 */

var SUPPLIER_LIST = 'purchase.product.queryProductSupplier';
/**
 * 参考价
 */

var REFERENCE_PRICE = 'purchase.transfer.queryTransferReferencePrice';
/**
 * 统计
 */

var STATISTICS = 'purchase.require.statTransferPreprocessOrderInfo';
/**
 * 调拨单是否可以红冲
 */

var CHECK_REVERSE = 'purchase.transfer.checkReverse';
/**
 * 调拨单堵单原因查询
 */

var BLOCK_ORDER = 'scm.transfer.queryBlockOrderInfo';
/**
 * 调拨单一键收获
 */

var PRE_AUTO_IN_FLOW = 'purchase.transfer.isAutoInFlow';
/**
 * 调拨红冲
 */

var TRANSFER_REVERSE = 'purchase.transfer.createTransferReverseOrder';
/**
 * 查询采购单列表
 */

var PURCHASE_ORDER_LIST = 'purchase.order.purchaseOrderList';
/**
 * 商品扩展信息，包括供应商
 */

var PRODUCT_EXT_INFO = 'purchase.product.queryProductExtInfo';
/**
 * 调拨出入库明细分页查询接口
 */

var ALLOCATION_DETAIL_INOUT = 'transfer.query.transferOrderInOutDetailPageInfo';
/**
* 调拨出入库明细导出
*/

var ALLOCATION_DETAIL_EXPORT = 'transfer.export.exportTransferOrderInOutDetail';

/***/ }),

/***/ 69027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(57016);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(71577);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(93224);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(8870);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(34041);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71720);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_FormBuilder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5670);
/* harmony import */ var _components_EditableTable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72927);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24731);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7704);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96534);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26715);
/* harmony import */ var _constance__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69758);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(7058);













var _excluded = ["placeList"],
    _excluded2 = ["placeList"];

/**
 * 商家商品
 */











var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 10
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 14
    }
  }
};

function GoodsEditableModal(props) {
  var formData = props.formData,
      deliveryPlaceList = props.deliveryPlaceList,
      receivePlaceList = props.receivePlaceList,
      allowChangePrice = props.allowChangePrice,
      receiveMerchantId = props.receiveMerchantId,
      deliveryMerchantId = props.deliveryMerchantId,
      getCascadeDeliveryPlace = props.getCascadeDeliveryPlace,
      getCascadeReceivePlace = props.getCascadeReceivePlace;
  var preProcessOrderNo = formData.preProcessOrderNo,
      transferType = formData.transferType,
      isThrough = formData.isThrough,
      orderDirect = formData.orderDirect,
      firstCategoryId = formData.firstCategoryId,
      secondCategoryId = formData.secondCategoryId; // 判断调拨类型是否为仓店配送

  var isWarehourseToShop = transferType === _constance__WEBPACK_IMPORTED_MODULE_12__/* .TransferType.WAREHOUSE_TO_SHOP */ .Z$.WAREHOUSE_TO_SHOP; // 是否为店仓返配

  var isShopToWarehourse = transferType === _constance__WEBPACK_IMPORTED_MODULE_12__/* .TransferType.SHOP_TO_WAREHOUSE */ .Z$.SHOP_TO_WAREHOUSE; // 仓间调拨或店间调拨

  var isBewttenTransfer = !isWarehourseToShop && !isShopToWarehourse; // 当前地点ID的字段名

  var currentPlaceIdName = isWarehourseToShop ? 'receivePlaceId' : 'deliveryPlaceId'; // 默认查询参数

  var defaultSearchParams = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => {
    // 仓店之间需要DC
    var isTransfer = isWarehourseToShop || isShopToWarehourse;
    return {
      condition: {
        firstCategoryId,
        // 仓店配送存在物流模式，含直通商品标记不为空：物流模式为”直通“，含直通商品标记为空：物流模式为”直通+配送“
        logisticMode: isTransfer ? isThrough ? _config_enums__WEBPACK_IMPORTED_MODULE_11__/* .LogisticModeMap.XD */ .oB.XD : _config_enums__WEBPACK_IMPORTED_MODULE_11__/* .LogisticModeMap.TRANSFER */ .oB.TRANSFER : undefined,
        //
        merchantId: isWarehourseToShop ? receiveMerchantId : deliveryMerchantId
      },
      billType: _constance__WEBPACK_IMPORTED_MODULE_12__/* .BillType */ .mP[transferType]
    };
  }, [transferType, firstCategoryId, isThrough, isWarehourseToShop, receiveMerchantId, deliveryMerchantId, isShopToWarehourse]);
  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_13__/* .useDispatch */ .I0)();

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(46),
      mappingList = _useMapping.mappingList;

  var table = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
  var form = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null); // 能否关闭浮层

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState, 2),
      canClose = _useState2[0],
      setCanClose = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState3, 2),
      queryState = _useState4[0],
      setQuery = _useState4[1]; // 判断多个请求之后状态
  // 当前正在编辑保存中的行
  // const [editingRow, setEditingRow] = useState<string | undefined>()


  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(defaultSearchParams),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState5, 2),
      searchParams = _useState6[0],
      setSearchParams = _useState6[1]; // 更新表格数据


  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState7, 2),
      updateDataSource = _useState8[0],
      setUpdateDataSource = _useState8[1]; // 调出地下拉框数据


  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(() => isBewttenTransfer ? deliveryPlaceList : []),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState9, 2),
      deliveryList = _useState10[0],
      setDeliveryList = _useState10[1]; // 调入地下拉框数据


  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(() => isBewttenTransfer ? receivePlaceList : []),
      _useState12 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState11, 2),
      receiveList = _useState12[0],
      setReceiveList = _useState12[1]; // const canCloseModal = useMemo(() => function, input)
  // 地点


  var placeId = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => searchParams.condition.placeId, [searchParams.condition.placeId]);
  var secondId = isNaN(+secondCategoryId) ? undefined : +secondCategoryId; // 地点下拉框数据

  var placeOptionList = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => {
    if (transferType === _constance__WEBPACK_IMPORTED_MODULE_12__/* .TransferType.WAREHOUSE_TO_WAREHOUSE */ .Z$.WAREHOUSE_TO_WAREHOUSE) {
      // 所选商家下的自营仓
      return deliveryPlaceList.filter(v => {
        var _v$others;

        return (v === null || v === void 0 ? void 0 : (_v$others = v.others) === null || _v$others === void 0 ? void 0 : _v$others.merchantFlag) === 1;
      });
    }

    if (transferType !== _constance__WEBPACK_IMPORTED_MODULE_12__/* .TransferType.WAREHOUSE_TO_SHOP */ .Z$.WAREHOUSE_TO_SHOP) {
      return deliveryPlaceList;
    }

    return receivePlaceList;
  }, [deliveryPlaceList, transferType, receivePlaceList]); // 二级品类下拉框

  var secondList = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => {
    var _category$others;

    var list = mappingList.get(46);

    if (!list || !list.length) {
      return [];
    }

    var category = list.find(v => Number(v.value) === Number(firstCategoryId));

    if (category !== null && category !== void 0 && (_category$others = category.others) !== null && _category$others !== void 0 && _category$others.childCategoryList) {
      return Object.values(category.others.childCategoryList).map(v => ({
        value: v.categoryId,
        label: v.categoryName
      }));
    }

    return [];
  }, [firstCategoryId, mappingList]);
  var formfields = [{
    label: '地点',
    name: 'placeId',
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z, {
      showSearch: true,
      placeholder: "\u8BF7\u9009\u62E9\u5730\u70B9",
      dropdownMatchSelectWidth: false,
      filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
      onChange: (v, o) => {// console.log(o, '选择模式')
        // if (o?.others?.shopType === 3 && formData?.transferType === 2) {
        //   message.warning(`${o?.children}为加盟门店，不允许做店间调拨`)
        //   form.current?.setFieldsValue({ placeId: null })
        //   return false
        // }
      }
    }, placeOptionList === null || placeOptionList === void 0 ? void 0 : placeOptionList.map(v => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_15__/* .default.Option */ .Z.Option, {
      value: v.value,
      key: v.value,
      others: v === null || v === void 0 ? void 0 : v.others
    }, "".concat(v.others.placeCode, "-").concat(v.label)))),
    required: true
  }, {
    label: '商品模糊',
    name: 'queryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '商品精准',
    name: 'accurateQueryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '商品品类',
    name: 'secondCategoryId',
    type: 'SELECT',
    dataList: secondList || [],
    initialValue: secondId === 0 || !secondId ? undefined : secondId,
    fieldOptions: {
      disabled: !!secondId
    }
  }, {
    label: '品牌名称',
    name: 'brandName',
    type: 'INPUT'
  }];
  var searchHandler = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)((state, values) => {
    if (state === 'error') return;
    setSearchParams(v => {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)({}, v), {}, {
        condition: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)({}, v.condition), values), {}, {
          [currentPlaceIdName]: values.placeId
        })
      });
    });
  }, [currentPlaceIdName]);
  /**
   * 重置
   */

  var resetFields = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(() => {
    var _form$current;

    (_form$current = form.current) === null || _form$current === void 0 ? void 0 : _form$current.validateFields();
  }, []);
  /**
   * 获取调入地、调出地数据
   */

  var getCascadePlace = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().mark(function _callee() {
    var _receivePlaceList$fin, obj, placeList, rest, _deliveryPlaceList$fi, _obj, _placeList, _rest;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!isWarehourseToShop) {
              _context.next = 12;
              break;
            }

            _context.next = 3;
            return getCascadeDeliveryPlace(placeId, formData === null || formData === void 0 ? void 0 : formData.receiveMerchantId);

          case 3:
            _context.t0 = _context.sent;

            if (_context.t0) {
              _context.next = 6;
              break;
            }

            _context.t0 = {};

          case 6:
            obj = _context.t0;
            placeList = obj.placeList, rest = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)(obj, _excluded); // 设置调出地下拉框

            setDeliveryList(placeList);
            return _context.abrupt("return", (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)({}, rest), {}, {
              receivePlaceId: placeId,
              receivePlaceName: (_receivePlaceList$fin = receivePlaceList.find(v => v.value === placeId)) === null || _receivePlaceList$fin === void 0 ? void 0 : _receivePlaceList$fin.label
            }));

          case 12:
            if (!isShopToWarehourse) {
              _context.next = 24;
              break;
            }

            _context.next = 15;
            return getCascadeReceivePlace(placeId, formData === null || formData === void 0 ? void 0 : formData.deliveryMerchantId);

          case 15:
            _context.t1 = _context.sent;

            if (_context.t1) {
              _context.next = 18;
              break;
            }

            _context.t1 = {};

          case 18:
            _obj = _context.t1;
            _placeList = _obj.placeList, _rest = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)(_obj, _excluded2); // 设置调入地下拉框

            setReceiveList(_placeList);
            return _context.abrupt("return", (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)({}, _rest), {}, {
              deliveryPlaceId: placeId,
              deliveryPlaceName: (_deliveryPlaceList$fi = deliveryPlaceList.find(v => v.value === placeId)) === null || _deliveryPlaceList$fi === void 0 ? void 0 : _deliveryPlaceList$fi.label
            }));

          case 24:
            return _context.abrupt("return", {
              deliveryPlaceId: placeId
            });

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [deliveryPlaceList, getCascadeDeliveryPlace, getCascadeReceivePlace, isShopToWarehourse, isWarehourseToShop, placeId, receivePlaceList, formData]);
  var queryOtherData = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().mark(function _callee2(dataList, params) {
      var _res$0$result$list, _res$, _res$1$list, _res$2;

      var cascadePlace, _dataList$reduce, referList, extList, referenceParams, extInfoParams, requestArr, res, referenceList, stockList, referencePriceMaps, stockMaps;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getCascadePlace();

            case 2:
              cascadePlace = _context2.sent;

              /**
               * 参考价、库存等请求的参数
               */
              _dataList$reduce = dataList.reduce((pre, next) => {
                return {
                  referList: pre.referList.concat({
                    goodsId: next.goodsId,
                    deliveryPlaceId: params ? params.deliveryPlaceId : cascadePlace.deliveryPlaceId,
                    receivePlaceId: params ? params.receivePlaceId : cascadePlace.receivePlaceId
                  }),
                  extList: pre.extList.concat({
                    merchantId: deliveryMerchantId,
                    placeId: params ? params.deliveryPlaceId : cascadePlace.deliveryPlaceId,
                    goodsId: next.goodsId
                  })
                };
              }, {
                referList: [],
                extList: []
              }), referList = _dataList$reduce.referList, extList = _dataList$reduce.extList; // 参考价的请求参数

              referenceParams = {
                orderDirect,
                merchantId: deliveryMerchantId,
                firstCategoryId,
                goods: referList
              }; // 库存等数据参数

              extInfoParams = {
                needPlaceStock: true,
                param: extList
              }; // 如果当前页面类型是批发销售时，需要额外发送接口请求特定的数据

              requestArr = [(0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_20__/* .REFERENCE_PRICE */ .DE, referenceParams), dispatch({
                type: 'purchase/queryProductExtInfo',
                payload: extInfoParams
              })];
              _context2.next = 9;
              return Promise.all(requestArr);

            case 9:
              res = _context2.sent;
              // 参考价list
              referenceList = (_res$0$result$list = (_res$ = res[0]) === null || _res$ === void 0 ? void 0 : _res$.result.list) !== null && _res$0$result$list !== void 0 ? _res$0$result$list : []; // 库存list

              stockList = (_res$1$list = (_res$2 = res[1]) === null || _res$2 === void 0 ? void 0 : _res$2.list) !== null && _res$1$list !== void 0 ? _res$1$list : []; // 获取商品编码与参考价的映射

              referencePriceMaps = referenceList.reduce((pre, next) => {
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)({}, pre), {}, {
                  [next.goodsId]: {
                    referencePrice: next.referencePrice
                  }
                });
              }, {}); // 库存等

              stockMaps = stockList.reduce((pre, next) => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)({}, pre), {}, {
                [next.goodsId]: {
                  stock: next.stock,
                  dcStock: next.dcStock
                }
              }), {});
              return _context2.abrupt("return", {
                cascadePlace,
                referencePriceMaps,
                stockMaps
              });

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [deliveryMerchantId, dispatch, firstCategoryId, getCascadePlace, orderDirect]); // 获取参考价和库存，并更新列表数据

  var setTableDataAfterRequest = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().mark(function _callee3(dataList) {
      var _yield$queryOtherData, cascadePlace, referencePriceMaps, stockMaps;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (dataList.length) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", dataList);

            case 2:
              _context3.next = 4;
              return queryOtherData(dataList);

            case 4:
              _yield$queryOtherData = _context3.sent;
              cascadePlace = _yield$queryOtherData.cascadePlace;
              referencePriceMaps = _yield$queryOtherData.referencePriceMaps;
              stockMaps = _yield$queryOtherData.stockMaps;
              return _context3.abrupt("return", dataList.map(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)({}, v), referencePriceMaps[v.goodsId]), stockMaps[v.goodsId]), cascadePlace), {}, {
                unitPrice: undefined
              })));

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function setTableDataAfterRequest(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * 改变表格内容时，触发保存
   */


  var changeTable = /*#__PURE__*/function () {
    var _ref4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().mark(function _callee4(data) {
      var currentCell, currentRowOldData, currentRow, _ref5, others, _ref6, _others, id, goodsId, goodsBarCode, rowUnitPrice, referencePrice, supplierCode, goodsCopies, deliveryPlaceId, receivePlaceId, secondCategoryName, secondCategoryId, params, res, _ref7, unitPrice, amount, isSpecifiedPrice, isSpec, newRow;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              currentCell = data.currentCell, currentRowOldData = data.currentRowOldData, currentRow = data.currentRow; // 进行判断	调入地是不是加盟商门店
              // if (props.formData && props.formData.transferType == 2) {
              //   const { others } = receiveList.find((v: DataListType) => v.value === currentRow.receivePlaceId) || {}
              //   console.log(others, 'others666加盟商', receiveList);
              //   if (others?.shopType == 3 && formData?.transferType === 2) {
              //     message.error(`${others?.placeCode}-${others?.placeName}为加盟门店，不允许做店间调拨`);
              //     setUpdateDataSource([{ ...currentRow, ...currentRowOldData, unitPrice: undefined, goodsCopies: undefined, receivePlaceId: [] }])
              //     return false
              //   } else {
              //   }
              // }

              setQuery(prev => {
                return prev + 1;
              });

              if (!(props.formData && props.formData.transferType == 1)) {
                _context4.next = 10;
                break;
              }

              _ref5 = deliveryList.find(v => v.value === currentRow.deliveryPlaceId) || {}, others = _ref5.others;

              if (!(others && others.merchantId == props.formData.deliveryMerchantId)) {
                _context4.next = 7;
                break;
              }

              _context4.next = 10;
              break;

            case 7:
              antd_es_message__WEBPACK_IMPORTED_MODULE_21__.default.error('仓库商家与主单调出地商家不一致');

              setQuery(prev => {
                return prev - 1;
              });
              return _context4.abrupt("return");

            case 10:
              if (!(props.formData && props.formData.transferType == 4)) {
                _context4.next = 18;
                break;
              }

              _ref6 = receiveList.find(v => v.value === currentRow.receivePlaceId) || {}, _others = _ref6.others;

              if (!(_others && _others.merchantId == props.formData.receiveMerchantId)) {
                _context4.next = 15;
                break;
              }

              _context4.next = 18;
              break;

            case 15:
              antd_es_message__WEBPACK_IMPORTED_MODULE_21__.default.error('仓库商家与主单调入地商家不一致');

              setQuery(prev => {
                return prev - 1;
              });
              return _context4.abrupt("return");

            case 18:
              if (!(0,lodash__WEBPACK_IMPORTED_MODULE_5__.isEmpty)(currentCell)) {
                _context4.next = 20;
                break;
              }

              return _context4.abrupt("return");

            case 20:
              id = currentRow.id, goodsId = currentRow.goodsId, goodsBarCode = currentRow.goodsBarCode, rowUnitPrice = currentRow.unitPrice, referencePrice = currentRow.referencePrice, supplierCode = currentRow.supplierCode, goodsCopies = currentRow.goodsCopies, deliveryPlaceId = currentRow.deliveryPlaceId, receivePlaceId = currentRow.receivePlaceId, secondCategoryName = currentRow.secondCategoryName, secondCategoryId = currentRow.secondCategoryId;

              if (goodsCopies) {
                _context4.next = 24;
                break;
              }

              setQuery(prev => {
                return prev - 1;
              });
              return _context4.abrupt("return");

            case 24:
              // if (Number(rowUnitPrice) === 0) {
              //   message.warning('单价/金额不可为0')
              //   return
              // }
              params = {
                id,
                preProcessOrderNo,
                deliveryMerchantId,
                receiveMerchantId,
                goodsId,
                goodsBarCode,
                goodsCopies,
                unitPrice: rowUnitPrice,
                referencePrice,
                deliveryPlaceId,
                receivePlaceId,
                supplierCode
              };
              _context4.next = 27;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_20__/* .PRE_ALLOCATION_OL_SAVE */ .gv, params);

            case 27:
              res = _context4.sent;
              setQuery(prev => {
                return prev - 1;
              });

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_21__.default.success("".concat(currentRow.id ? '修改' : '添加', "\u5546\u54C1\u3010").concat(currentRow.goodsName, "\u3011\u6210\u529F"));

                _ref7 = (res === null || res === void 0 ? void 0 : res.result) || {}, unitPrice = _ref7.unitPrice, amount = _ref7.amount, isSpecifiedPrice = _ref7.isSpecifiedPrice;
                isSpec = isSpecifiedPrice === 1; // isSpecifiedPrice为1时，表示指定价格

                newRow = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)({}, currentRow), res === null || res === void 0 ? void 0 : res.result), {}, {
                  secondCategoryName,
                  secondCategoryId,
                  referencePrice,
                  unitPrice: isSpec ? unitPrice : undefined,
                  amount: isSpec ? amount : undefined
                });
                setUpdateDataSource(arr => [...arr, newRow]);
              } else {
                setUpdateDataSource([(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)({}, currentRow), currentRowOldData), {}, {
                  unitPrice: undefined,
                  goodsCopies: undefined
                })]);
              }

            case 30:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function changeTable(_x4) {
      return _ref4.apply(this, arguments);
    };
  }();

  var columns = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => [{
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 170,
    fixed: true
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 90
  }, {
    title: '商品条码',
    dataIndex: 'goodsBarCode',
    key: 'goodsBarCode',
    width: 140
  }, {
    title: '调出地',
    dataIndex: 'deliveryPlaceId',
    key: 'deliveryPlaceId',
    width: 190,
    type: isShopToWarehourse ? undefined : 'SELECT',
    dataList: deliveryList,
    render: isShopToWarehourse ? (t, r) => r.deliveryPlaceName : undefined,
    setCellRowValueByChange: function () {
      var _setCellRowValueByChange = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().mark(function _callee5(value, record) {
        var receivePlaceId, goodsId, _yield$queryOtherData2, referencePriceMaps, stockMaps, _ref8, label;

        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                receivePlaceId = record.receivePlaceId, goodsId = record.goodsId;
                _context5.next = 3;
                return queryOtherData([record], {
                  deliveryPlaceId: value,
                  receivePlaceId
                });

              case 3:
                _yield$queryOtherData2 = _context5.sent;
                referencePriceMaps = _yield$queryOtherData2.referencePriceMaps;
                stockMaps = _yield$queryOtherData2.stockMaps;
                _ref8 = deliveryList.find(v => v.value === value) || {}, label = _ref8.label;
                return _context5.abrupt("return", (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)({}, record), referencePriceMaps[goodsId]), stockMaps[goodsId]), {}, {
                  deliveryPlaceName: label
                }));

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function setCellRowValueByChange(_x5, _x6) {
        return _setCellRowValueByChange.apply(this, arguments);
      }

      return setCellRowValueByChange;
    }()
  }, {
    title: '调入地',
    dataIndex: 'receivePlaceId',
    key: 'receivePlaceId',
    width: 190,
    type: isWarehourseToShop ? undefined : 'SELECT',
    dataList: receiveList,
    render: isWarehourseToShop ? (t, r) => {
      return r.receivePlaceName;
    } : undefined,
    setCellRowValueByChange: function () {
      var _setCellRowValueByChange2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().mark(function _callee6(value, record) {
        var deliveryPlaceId, goodsId, _yield$queryOtherData3, referencePriceMaps, stockMaps, _ref9, label;

        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                deliveryPlaceId = record.deliveryPlaceId, goodsId = record.goodsId;
                _context6.next = 3;
                return queryOtherData([record], {
                  receivePlaceId: value,
                  deliveryPlaceId
                });

              case 3:
                _yield$queryOtherData3 = _context6.sent;
                referencePriceMaps = _yield$queryOtherData3.referencePriceMaps;
                stockMaps = _yield$queryOtherData3.stockMaps;
                _ref9 = receiveList.find(v => v.value === value) || {}, label = _ref9.label;
                return _context6.abrupt("return", (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)({}, record), referencePriceMaps[goodsId]), stockMaps[goodsId]), {}, {
                  receivePlaceName: label
                }));

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function setCellRowValueByChange(_x7, _x8) {
        return _setCellRowValueByChange2.apply(this, arguments);
      }

      return setCellRowValueByChange;
    }()
  }, {
    title: '二类类目',
    dataIndex: 'secondCategoryName',
    key: 'secondCategoryName',
    width: 100
  }, {
    title: '品牌名称',
    dataIndex: 'brandName',
    key: 'brandName',
    width: 110
  }, {
    title: '单位',
    dataIndex: 'specUnit',
    key: 'specUnit',
    align: 'right',
    width: 90
  }, {
    title: '数量',
    dataIndex: 'goodsCopies',
    key: 'goodsCopies',
    width: 150,
    editable: true,
    type: 'INPUT',
    fieldOptions: (t, r) => {
      // 非称重商品为正整数，称重商品保留三位小数
      var isWeight = r.isWeigh === 1;
      return {
        formatter: value => isWeight ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_10__/* .exchageToNum3 */ .hY)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_10__/* .exchageToNum1 */ .Ly)(value)
      };
    },
    render: (t, r, i, fn) => {
      // 非称重商品为正整数，称重商品保留三位小数
      var isWeight = r.isWeigh === 1;

      if (fn) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center'
          }
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
          style: {
            flex: 1
          }
        }, fn()), r.barCodeUnit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", null, "/", r.barCodeUnit));
      }

      return t && isWeight ? (Math.floor(+t * 1000) / 1000).toFixed(3) : t || '';
    }
  }, {
    title: '参考价',
    dataIndex: 'referencePrice',
    key: 'referencePrice',
    width: 110,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " \u5143").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '单价(含税)',
    dataIndex: 'unitPrice',
    width: 160,
    editable: true,
    type: 'INPUT',
    fieldOptions: {
      formatter: _utils_common__WEBPACK_IMPORTED_MODULE_10__/* .exchageToNum3 */ .hY
    },
    render: (t, r, i, fn) => {
      if (fn && allowChangePrice) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center'
          }
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
          style: {
            flex: 1
          }
        }, fn()), r.basicUnit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", null, "\u5143/", r.basicUnit));
      }

      var val = t ? (Math.floor(+t * 1000) / 1000).toFixed(3) : '';
      return !allowChangePrice && r.basicUnit && val ? "".concat(val, "\u5143/").concat(r.basicUnit) : val;
    }
  }, {
    title: '金额(含税)',
    dataIndex: 'amount',
    key: 'amount',
    width: 120,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " \u5143").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '规格描述',
    dataIndex: 'specDesc',
    key: 'specDesc',
    width: 90,
    align: 'right',
    render: t => t || '-'
  }], [allowChangePrice, deliveryList, receiveList, isShopToWarehourse, isWarehourseToShop, queryOtherData]);
  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    if (queryState === 0) {
      setCanClose(true);
    } else {
      setCanClose(false);
    }
  }, [queryState]); // 关闭的函数

  var closeProgramFun = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(() => {
    if (canClose) {
      props.closeModalCallback();
    }
  }, [canClose]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_22__/* .default */ .Z, {
    title: "\u5546\u54C1\u9009\u62E9",
    destroyOnClose: true,
    maskClosable: false,
    width: 1200,
    closable: false,
    visible: true,
    onCancel: props.closeModalCallback,
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z, {
      key: "back",
      disabled: !canClose,
      onClick: () => {
        closeProgramFun();
      }
    }, "\u5173\u95ED")]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_components_FormBuilder__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    ref: form,
    elements: formfields,
    callbackHandler: searchHandler,
    onReset: resetFields,
    formOptions: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)({}, defaultFormItemLayout)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_components_EditableTable__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
    useNewCell: true,
    ref: table,
    scrollYSize: 400,
    columns: columns,
    searchParams: searchParams,
    hideBtn: true,
    hideDeleteBtn: true,
    cancelRequest: !placeId,
    onChange: changeTable,
    updateDataSource: updateDataSource,
    queryDataUrl: "purchase.product.querySelectPlaceProductByCondition",
    tableOptions: {
      scroll: {
        y: 380,
        x: 1200
      }
    },
    setTableDataAfterRequest: setTableDataAfterRequest
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (GoodsEditableModal);

/***/ }),

/***/ 69758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z$": function() { return /* binding */ TransferType; },
/* harmony export */   "mP": function() { return /* binding */ BillType; },
/* harmony export */   "fY": function() { return /* binding */ PlaceScopeType; },
/* harmony export */   "zV": function() { return /* binding */ PlaceTypeNumber; },
/* harmony export */   "AS": function() { return /* binding */ PlaceType; },
/* harmony export */   "eM": function() { return /* binding */ AutoBillType; }
/* harmony export */ });
/* unused harmony exports fieldEnums, ColumnDataIndex */
/**
 * 表单项的映射
 * 表单项的 code/id 与 中文 表单项的映射
 * 主要用于表单提交，与回显
 */
var fieldEnums;
/**
 * 调拨类型枚举
 */

(function (fieldEnums) {
  fieldEnums["deliveryDcName"] = "deliveryDcId";
  fieldEnums["deliveryMerchantName"] = "deliveryMerchantId";
  fieldEnums["receiveMerchantName"] = "receiveMerchantId";
  fieldEnums["receiveDcName"] = "receiveDcId";
  fieldEnums["transferTypeName"] = "transferType";
  fieldEnums["categoryName"] = "categoryCode";
  fieldEnums["secondCategoryName"] = "secondCategoryId";
  fieldEnums["firstCategoryName"] = "firstCategoryId";
})(fieldEnums || (fieldEnums = {}));

var TransferType; // 分拨订单仓间调拨(12),
// 分拨订单店间调拨(13),
// 分拨订单仓店配送(14),
// 分拨订单店仓退配(15);

/**
 * 订单类型
 * 符合多种订单如采购/调拨/等类型,因此需要做转换
 */

(function (TransferType) {
  TransferType[TransferType["WAREHOUSE_TO_SHOP"] = 1] = "WAREHOUSE_TO_SHOP";
  TransferType[TransferType["SHOP_TO_SHOP"] = 2] = "SHOP_TO_SHOP";
  TransferType[TransferType["WAREHOUSE_TO_WAREHOUSE"] = 3] = "WAREHOUSE_TO_WAREHOUSE";
  TransferType[TransferType["SHOP_TO_WAREHOUSE"] = 4] = "SHOP_TO_WAREHOUSE";
})(TransferType || (TransferType = {}));

var BillType = {
  [TransferType.WAREHOUSE_TO_SHOP]: 14,
  [TransferType.SHOP_TO_SHOP]: 13,
  [TransferType.WAREHOUSE_TO_WAREHOUSE]: 12,
  [TransferType.SHOP_TO_WAREHOUSE]: 15
};
/**
 * 商户类型-后端枚举
 */

var PlaceScopeType;
/**
 * 前端标记
 */

(function (PlaceScopeType) {
  PlaceScopeType[PlaceScopeType["STORE"] = 1] = "STORE";
  PlaceScopeType[PlaceScopeType["WAREHOUSE"] = 2] = "WAREHOUSE";
  PlaceScopeType[PlaceScopeType["YYB"] = 3] = "YYB";
  PlaceScopeType[PlaceScopeType["DELIVERY"] = 4] = "DELIVERY";
})(PlaceScopeType || (PlaceScopeType = {}));

var PlaceTypeNumber;
/**
 * 判断店仓类型
 */

(function (PlaceTypeNumber) {
  PlaceTypeNumber[PlaceTypeNumber["SHOP"] = 1] = "SHOP";
  PlaceTypeNumber[PlaceTypeNumber["WAREHOUSE"] = 2] = "WAREHOUSE";
})(PlaceTypeNumber || (PlaceTypeNumber = {}));

var PlaceType = {
  // 1/3 店
  [PlaceScopeType.STORE]: PlaceTypeNumber.SHOP,
  [PlaceScopeType.YYB]: PlaceTypeNumber.SHOP,
  // 2/4 仓
  [PlaceScopeType.WAREHOUSE]: PlaceTypeNumber.WAREHOUSE,
  [PlaceScopeType.DELIVERY]: PlaceTypeNumber.WAREHOUSE
};
/**
 * right to left
 */

var ColumnDataIndex;
/**
 * 强配过账枚举
 */

(function (ColumnDataIndex) {
  ColumnDataIndex["isGift"] = "gift";
  ColumnDataIndex["merchantFlagName"] = "businessStatusName";
  ColumnDataIndex["orderSpecificationUnit"] = "specUnit";
  ColumnDataIndex["orderSpecification"] = "specification";
})(ColumnDataIndex || (ColumnDataIndex = {}));

var AutoBillType = {
  [TransferType.WAREHOUSE_TO_SHOP]: 3,
  [TransferType.SHOP_TO_SHOP]: 4,
  [TransferType.WAREHOUSE_TO_WAREHOUSE]: 5,
  [TransferType.SHOP_TO_WAREHOUSE]: 6
};

/***/ }),

/***/ 23377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jM": function() { return /* binding */ parsePlaceCommon; },
/* harmony export */   "Hs": function() { return /* binding */ getPlaceByMerchant; }
/* harmony export */ });
/* unused harmony export parsePlace_40 */
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2824);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24731);





var parsePlace_40 = (str, merchantId) => {
  try {
    var _ref = JSON.parse(str) || {},
        merchants = _ref.merchants;

    if (!merchants) {
      return [];
    } // debugger


    var _ref2 = JSON.parse(merchants).find(v => +v.merchantId === +merchantId) || {},
        placeVos = _ref2.placeVos;

    if (!placeVos) {
      return [];
    }

    var placeList = placeVos.map(v => ({
      value: v.placeId,
      code: v.placeCode,
      label: v.placeName,
      placeScope: v.placeScope,
      others: v
    }));
    return placeList;
  } catch (error) {
    console.log('解析地点数据失败：', error);
    return [];
  }
};
var parsePlaceCommon = str => {
  try {
    var list = JSON.parse(str) || {};
    var result = Object.entries(list).map(_ref3 => {
      var _ref4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)(_ref3, 2),
          value = _ref4[1];

      return JSON.parse(value);
    });
    return result === null || result === void 0 ? void 0 : result.map(v => ({
      value: v.placeId,
      code: v.placeCode,
      label: v.placeName,
      placeScope: v.placeScope,
      others: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)({}, v)
    }));
  } catch (error) {
    console.log('解析地点数据失败：', error);
    return [];
  }
};
var getPlaceByMerchant = /*#__PURE__*/function () {
  var _ref5 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().mark(function _callee(merchantId) {
    var _res$result;

    var enumValue,
        res,
        strJson,
        _args = arguments;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enumValue = _args.length > 1 && _args[1] !== undefined ? _args[1] : 40;

            if (!(!merchantId || merchantId === '')) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", []);

          case 3:
            _context.next = 5;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__/* .default */ .Z)('purchase.basis.mapping', {
              type: [enumValue],
              ext: {
                merchantId
              }
            });

          case 5:
            res = _context.sent;
            strJson = res === null || res === void 0 ? void 0 : (_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.maps;

            if (!(enumValue === 52)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", parsePlaceCommon(strJson[enumValue]));

          case 9:
            return _context.abrupt("return", parsePlace_40(strJson[enumValue], merchantId));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getPlaceByMerchant(_x) {
    return _ref5.apply(this, arguments);
  };
}();

/***/ }),

/***/ 34920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(57016);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8870);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24731);
/* harmony import */ var _components_FormBuilder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5670);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7058);














var confirmUrlMap = new Map([[1, _Api__WEBPACK_IMPORTED_MODULE_6__/* .TRANSFER_REVERSE */ .eR], [2, _Api__WEBPACK_IMPORTED_MODULE_6__/* .PRE_AUTO_IN_FLOW */ .qr], [0, '']]);

function ReverseModal(props) {
  var closeModalCallback = props.closeModalCallback,
      saveModalCallback = props.saveModalCallback,
      params = props.params;
  var title = params.title,
      okText = params.okText,
      tag = params.tag,
      preProcessOrderNo = params.preProcessOrderNo;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var formRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();

  var saveModal = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().mark(function _callee() {
      var url, values, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = confirmUrlMap.get(tag || 0);

              if (url) {
                _context.next = 4;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_10__.default.error('红冲类型不对');

              return _context.abrupt("return");

            case 4:
              _context.next = 6;
              return formRef.current.validateFields();

            case 6:
              values = _context.sent;
              setLoading(true);
              _context.next = 10;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(url, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({}, values), {}, {
                preprocessOrder: preProcessOrderNo
              }));

            case 10:
              res = _context.sent;
              setLoading(false);

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_10__.default.success(tag === 1 ? '红冲成功!' : '收货成功!');
              }

              saveModalCallback(res.success);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function saveModal() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
    title: title,
    destroyOnClose: true,
    maskClosable: false,
    width: 500,
    visible: true,
    onOk: saveModal,
    onCancel: closeModalCallback,
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
      key: "back",
      onClick: closeModalCallback
    }, "\u53D6\u6D88"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
      key: "submit",
      type: "primary",
      loading: loading,
      onClick: saveModal
    }, okText)]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_FormBuilder__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    ref: formRef,
    formOptions: {
      wrapperCol: {
        span: 20
      },
      labelCol: {
        span: 4
      }
    },
    elements: [{
      label: '备注',
      name: 'reverseRemark',
      type: 'TEXTAREA',
      required: true,
      fieldOptions: {
        autoSize: {
          minRows: 3
        }
      }
    }],
    notSearchForm: true
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (ReverseModal);

/***/ }),

/***/ 77352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ListDictionary; }
/* harmony export */ });
/**
 * 列表
 */
var ListDictionary = {
  transferType: 21,
  requireSource: 14,
  preTransferBillState: 15,
  categoryAll: 41,
  // 无权限的全量类目树
  transferPreOrderReverseState: 56,
  merchant: 40
};

/***/ }),

/***/ 71254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useGoodsColumns": function() { return /* binding */ useGoodsColumns; },
/* harmony export */   "deliveryColumns": function() { return /* binding */ deliveryColumns; },
/* harmony export */   "purchaseColumns": function() { return /* binding */ purchaseColumns; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31097);
/* harmony import */ var antd_es_tag_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71153);
/* harmony import */ var antd_es_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60331);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73727);






var useGoodsColumns = (transferType, generalWarehouseFlag) => {
  return [{
    title: '序号',
    dataIndex: 'goodslistIndex',
    key: 'goodslistIndex',
    width: 90,
    render: (t, r, i) => i + 1
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 120,
    ellipsis: true
  }, {
    title: '销售商品编码',
    dataIndex: 'skuId',
    key: 'skuId',
    width: 120
  }, {
    title: '商品条码',
    dataIndex: 'goodsBarCode',
    key: 'goodsBarCode',
    width: 140
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 170
  }, {
    title: '品类',
    dataIndex: 'firstCategoryName',
    key: 'firstCategoryName',
    width: 100
  }, ...(transferType === 4 ? [{
    title: '好坏货标记',
    dataIndex: 'isDamageName',
    key: 'isDamage',
    width: 100
  }, {
    title: '退货原因',
    dataIndex: 'returnReasonName',
    key: 'returnReason',
    width: 100
  }] : []), {
    title: '是否赠品',
    dataIndex: 'isGift',
    key: 'isGift',
    width: 90,
    render: t => t === 1 ? '是' : '否'
  }, {
    title: '规格描述',
    dataIndex: 'specDesc',
    key: 'specDesc',
    align: 'right',
    width: 100
  }, ...(generalWarehouseFlag === 1 ? [{
    title: '去损率%',
    dataIndex: 'lossRate',
    key: 'lossRate',
    width: 100
  }] : []), {
    title: '单位',
    dataIndex: 'specUnit',
    key: 'specUnit',
    width: 100,
    align: 'right'
  }, {
    title: '数量',
    dataIndex: 'goodsCopies',
    key: 'goodsCopies',
    width: 110,
    align: 'right',
    render: (t, r) => r.deliverySpecificationUnit ? "".concat(t, "/").concat(r.deliverySpecificationUnit || '') : t
  }, {
    title: '审核数量',
    dataIndex: 'goodsAuditQuantity',
    key: 'goodsAuditQuantity',
    width: 110,
    align: 'right',
    render: (t, r) => {
      return r.basicSpecificationUnit ? "".concat(t, "/").concat(r.basicSpecificationUnit || '') : t;
    }
  }, {
    title: '单价(含税)',
    dataIndex: 'unitPrice',
    key: 'unitPrice',
    width: 120,
    align: 'right',
    render: (t, r) => {
      var value = r.basicSpecificationUnit ? "".concat(t, "/").concat(r.basicSpecificationUnit || '') : t; // isSpecifiedPrice 为1时，表示指定价格

      if (r.isSpecifiedPrice === 1) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, value, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tag__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
          color: "#2db7f5"
        }, "\u6307"));
      }

      return value;
    }
  }, ...(generalWarehouseFlag === 1 ? [{
    title: '到店价（不含运费）',
    dataIndex: 'shopPrice',
    key: 'shopPrice',
    width: 150
  }] : []), {
    title: '参考总额',
    dataIndex: 'referenceAmount',
    key: 'referenceAmount',
    width: 100
  }, {
    title: '利润余留',
    dataIndex: 'profit',
    key: 'profit',
    width: 100
  }, ...(generalWarehouseFlag === 1 ? [{
    title: '调出数量（去损前）',
    dataIndex: 'deliveryDetractFrontQty',
    key: 'deliveryDetractFrontQty',
    width: 150
  }] : []), {
    title: '调出数量',
    dataIndex: 'deliveryGoodsQty',
    key: 'deliveryGoodsQty',
    width: 120,
    align: 'right',
    render: (t, r) => r.basicSpecificationUnit ? "".concat(t, "/").concat(r.basicSpecificationUnit || '') : t
  }, {
    title: '调入数量',
    dataIndex: 'receiveGoodsQty',
    key: 'receiveGoodsQty',
    width: 110,
    align: 'right',
    render: (t, r) => r.basicSpecificationUnit ? "".concat(t, "/").concat(r.basicSpecificationUnit || '') : t
  }, {
    title: '备注',
    dataIndex: 'auditRemark',
    key: 'auditRemark',
    width: 130
  }, {
    title: '规格描述',
    dataIndex: 'productSpecDesc',
    key: 'productSpecDesc',
    width: 130
  }];
};
var deliveryColumns = [{
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 120
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 160,
  ellipsis: true
}, {
  title: '出库单号',
  dataIndex: 'deliveryOrderNo',
  key: 'deliveryOrderNo',
  width: 180
}, {
  title: '调出量',
  dataIndex: 'transferOutQty',
  key: 'transferOutQty',
  width: 140,
  align: 'right',
  render: (t, r) => r.basicSpecificationUnit ? "".concat(t, "/").concat(r.basicSpecificationUnit || '') : t
}, {
  title: '调出时间',
  dataIndex: 'gmtCreateOut',
  key: 'gmtCreateOut',
  width: 170
}, {
  title: '收货单号',
  dataIndex: 'receiveOrderNo',
  key: 'receiveOrderNo',
  width: 180
}, {
  title: '调入数量',
  dataIndex: 'transferInQty',
  key: 'transferInQty',
  width: 140,
  align: 'right',
  render: (t, r) => r.basicSpecificationUnit ? "".concat(t, "/").concat(r.basicSpecificationUnit || '') : t
}, {
  title: '调入时间',
  dataIndex: 'gmtCreateIn',
  key: 'gmtCreateIn',
  width: 170
}, {
  title: '实际单价(含运费)',
  dataIndex: 'actualUnitPrice',
  key: 'actualUnitPrice',
  width: 140
}, {
  title: '实际总金额(含运费)',
  dataIndex: 'actualAmount',
  key: 'actualAmount',
  width: 140
}];
var purchaseColumns = (inventoryState, isStraight) => [{
  title: '采购单单号',
  dataIndex: 'purchaseOrderNo',
  key: 'purchaseOrderNo',
  width: 130,
  render: (t, r) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    title: "\u67E5\u770B\u8BE6\u60C5"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(umi__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU, {
    to: "/Purchase/Purchase/Detail?purchaseOrderNo=".concat(t, "&id=").concat(r.id)
  }, t))
}, {
  title: '订单类别',
  dataIndex: 'orderDirectName',
  key: 'orderDirectName',
  width: 100
}, {
  title: '供应商编码',
  dataIndex: 'suppCode',
  key: 'suppCode',
  width: 100
}, {
  title: '供应商名称',
  dataIndex: 'suppName',
  key: 'suppName',
  width: 120
}, {
  title: '地点编码',
  dataIndex: 'placeCode',
  key: 'placeCode',
  width: 100
}, {
  title: '地点名称',
  dataIndex: 'placeName',
  key: 'placeName',
  width: 120
}, {
  title: '创建人',
  dataIndex: 'createUserName',
  key: 'createUserName',
  width: 120
}, {
  title: '创建时间',
  dataIndex: 'gmtCreate',
  key: 'gmtCreate',
  width: 160
}, {
  title: '单据状态',
  dataIndex: 'billStateName',
  key: 'billStateName',
  width: 90
}, {
  title: '操作',
  dataIndex: 'operatesss',
  key: 'operatesss',
  fixed: 'right',
  width: 90,
  render: (t, r) => {
    var url = new Map([[1, "/Purchase/Purchase/WarehouseEdit?purchaseOrderNo=".concat(r.purchaseOrderNo, "&id=").concat(r.id, "&inventoryState=").concat(inventoryState, "&orderType=").concat(r.orderType)], [2, "/Purchase/Purchase/Edit?purchaseOrderNo=".concat(r.purchaseOrderNo, "&id=").concat(r.id)], [undefined, '']]);
    return r.billState === 1 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(umi__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU, {
      to: url.get(isStraight)
    }, "\u7F16\u8F91") : null;
  }
}];

/***/ }),

/***/ 69283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ TRANSFER_PRIVILEGE_LIST; },
/* harmony export */   "BZ": function() { return /* binding */ CANCEL_TRANSFER_PRIVILEGE; },
/* harmony export */   "_n": function() { return /* binding */ TRANSFER_PRIVILEGE_SAVE; },
/* harmony export */   "d7": function() { return /* binding */ TRANSFER_PRIVILEGE_SAVE_DETAIL; },
/* harmony export */   "kh": function() { return /* binding */ TRANSFER_PRIVILEGE_IMPORT; },
/* harmony export */   "fe": function() { return /* binding */ TRANSFER_PRIVILEGE_DELETE_DETAIL; },
/* harmony export */   "mo": function() { return /* binding */ TRANSFER_PRIVILEGE_CLEAR; },
/* harmony export */   "Sf": function() { return /* binding */ TRANSFER_PRIVILEGE_SUBMIT; },
/* harmony export */   "W3": function() { return /* binding */ TRANSFER_PRIVILEGE_ORDER_DETAIL; },
/* harmony export */   "uA": function() { return /* binding */ TRANSFER_PRIVILEGE_DETAIL_LIST; },
/* harmony export */   "k3": function() { return /* binding */ TRANSFER_PRIVILEGE_STAT; },
/* harmony export */   "di": function() { return /* binding */ TRANSFER_PRIVILEGE_CODE; },
/* harmony export */   "Ro": function() { return /* binding */ TRANSFER_PRIVILEGE_GOODS_LIST; }
/* harmony export */ });
 // 特权分配列表

var TRANSFER_PRIVILEGE_LIST = 'scm.transfer.queryTransferPrivilegeOrderList'; // 取消特权分拨单

var CANCEL_TRANSFER_PRIVILEGE = 'scm.transfer.cancelTransferPrivilegeOrder'; // 保存特权主单

var TRANSFER_PRIVILEGE_SAVE = 'scm.transfer.saveTransferPrivilegeOrder'; // 保存明细

var TRANSFER_PRIVILEGE_SAVE_DETAIL = 'scm.transfer.saveTransferPrivilegeOrderLine'; // 导入

var TRANSFER_PRIVILEGE_IMPORT = 'scm.transfer.importTransferPrivilegeOrderLine'; // 删除明细

var TRANSFER_PRIVILEGE_DELETE_DETAIL = 'scm.transfer.deleteTransferPrivilegeOrderLine'; // 清空明细

var TRANSFER_PRIVILEGE_CLEAR = 'scm.transfer.clearTransferPrivilegeOrderLines'; // 提交

var TRANSFER_PRIVILEGE_SUBMIT = 'scm.transfer.submitTransferPrivilegeOrder'; // 主单明细查询

var TRANSFER_PRIVILEGE_ORDER_DETAIL = 'scm.transfer.queryTransferPrivilegeOrderDetail'; // 明细列表

var TRANSFER_PRIVILEGE_DETAIL_LIST = 'scm.transfer.queryTransferPrivilegeOrderLines'; // 统计信息

var TRANSFER_PRIVILEGE_STAT = 'scm.transfer.statTransferPrivilegeOrderInfo'; // 获取单号

var TRANSFER_PRIVILEGE_CODE = 'scm.transfer.getOrderIdByBizType'; // 浮层选品接口

var TRANSFER_PRIVILEGE_GOODS_LIST = 'scm.transfer.querySelectPlaceProductByCondition';

/***/ }),

/***/ 63190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ allocationObj; },
/* harmony export */   "X": function() { return /* binding */ Dictionary; }
/* harmony export */ });
var allocationObj = {
  placeCode: 3,
  transferType: 21,
  billState: 35,
  categoryCode: 4,
  merchantId: 40,
  categoryCodeAll: 46,
  requireSource: 14,
  preBillState: 15,
  // 调拨分配单状态
  categoryAll: 41,
  queryPlaces: 84
};
var Dictionary;

(function (Dictionary) {
  Dictionary[Dictionary["AUTH_PLACE"] = 3] = "AUTH_PLACE";
  Dictionary[Dictionary["TRANSFER_TYPE"] = 21] = "TRANSFER_TYPE";
  Dictionary[Dictionary["TRANSFER_PRE_BILL_STATE"] = 15] = "TRANSFER_PRE_BILL_STATE";
  Dictionary[Dictionary["TRANSFER_PRE_REQUIRE_SOURCE"] = 36] = "TRANSFER_PRE_REQUIRE_SOURCE";
  Dictionary[Dictionary["AUTH_MERCHANT"] = 40] = "AUTH_MERCHANT";
  Dictionary[Dictionary["AUTH_CATEGORY_ALL"] = 46] = "AUTH_CATEGORY_ALL";
  Dictionary[Dictionary["SHOP_OF_WAREHOUSE"] = 81] = "SHOP_OF_WAREHOUSE";
  Dictionary[Dictionary["MERTCHANGT_ALL"] = 51] = "MERTCHANGT_ALL";
  Dictionary[Dictionary["MERTCHANGT_OF_PLACE"] = 52] = "MERTCHANGT_OF_PLACE";
  Dictionary[Dictionary["THROUGH_GOODS"] = 57] = "THROUGH_GOODS";
})(Dictionary || (Dictionary = {}));

/***/ }),

/***/ 48383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ GoodsApi; }
/* harmony export */ });
/**
 * API集合
 */
var GoodsApi = {
  pageProduct: 'kernel.console.ProductQueryService.pageProduct',
  queryOperationSelect: 'ylp.ibd.ReceiptProcessService.queryOperationSelect',
  getUploadToken: 'ylp.md.resource.service.getUploadToken',
  pageQueryAquaticProduct: 'ds.link.linkAquaticProductService.pageQueryAquaticProduct',
  saveAquaticProduct: 'ds.link.linkAquaticProductService.saveAquaticProduct',
  getTemplate: 'ds.task.DataImportTemplateService.getTemplate',
  generateUrl: 'ylp.md.resource.service.generateUrl',
  dataImport: 'ds.task.ImportExportTaskService.dataImport',
  exportFile: 'ds.task.ImportExportTaskService.export',
  queryListByPage: 'ds.task.ImportExportTaskService.queryListByPage'
};

/***/ }),

/***/ 71866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "weightList": function() { return /* binding */ weightList; },
/* harmony export */   "statisticalUnitList": function() { return /* binding */ statisticalUnitList; },
/* harmony export */   "isStatisticsList": function() { return /* binding */ isStatisticsList; },
/* harmony export */   "formJson": function() { return /* binding */ formJson; },
/* harmony export */   "GOODS_COLUMN_FIELD": function() { return /* binding */ GOODS_COLUMN_FIELD; },
/* harmony export */   "statusMap": function() { return /* binding */ statusMap; },
/* harmony export */   "downformJson": function() { return /* binding */ downformJson; },
/* harmony export */   "DOWN_COLUMN_FIELD": function() { return /* binding */ DOWN_COLUMN_FIELD; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

// 是否称重
var weightList = [{
  label: '称重',
  value: 2
}, {
  label: '非称重',
  value: 1
}];
var weightMapper = {
  2: '称重',
  1: '非称重'
}; // 统计单位

var statisticalUnitList = [{
  label: 'KG',
  value: 1
}, {
  label: '条',
  value: 2
}, {
  label: '只',
  value: 3
}, {
  label: '袋',
  value: 4
}, {
  label: '个',
  value: 5
}, {
  label: '件',
  value: 6
}, {
  label: '份',
  value: 7
}, {
  label: '盒',
  value: 8
}, {
  label: '包',
  value: 9
}];
var unitMapper = {
  1: 'KG',
  2: '条',
  3: '只',
  4: '袋',
  5: '个',
  6: '件',
  7: '份',
  8: '盒',
  9: '包'
}; // 是否统计

var isStatisticsList = [{
  label: '是',
  value: 2
}, {
  label: '否',
  value: 1
}];
var defaultMapper = {
  1: '否',
  2: '是'
};
var statusMapper = {
  1: '新品',
  2: '正常',
  3: '停购',
  4: '停售',
  5: '清退'
};
var formJson = [{
  type: 'COMMON_INPUT',
  label: '运营组',
  placeholder: '请输入运营组名称',
  field: 'operationGroupName',
  width: '',
  initialValue: ''
}, {
  type: 'COMMON_INPUT',
  label: '商品名称',
  placeholder: '请输入商品名称/编码',
  field: 'productName',
  width: '',
  initialValue: ''
}, {
  type: 'GOODS_CATEGORY',
  label: '商品类别',
  placeholder: '请选择商品类别',
  field: 'categoryId',
  width: '',
  initialValue: ''
}];
var GOODS_COLUMN_FIELD = [{
  title: '运营组ID',
  dataIndex: 'operationGroupId',
  width: 90
}, {
  title: '运营组名称',
  dataIndex: 'operationGroupName',
  width: 120
}, {
  title: '商品编码',
  dataIndex: 'productCode',
  width: 90
}, {
  title: '商品名称',
  dataIndex: 'productName',
  width: 80
}, {
  title: '品类',
  dataIndex: 'categoryName',
  width: 100
}, {
  title: '是否统计',
  dataIndex: 'isStatistics',
  width: 80,
  render: isStatistics => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, defaultMapper[isStatistics])
}, {
  title: '是否称重',
  dataIndex: 'isWeigh',
  width: 80,
  render: isWeigh => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, weightMapper[isWeigh])
}, {
  title: '统计单位',
  dataIndex: 'statisticalUnit',
  width: 80,
  render: statisticalUnit => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, unitMapper[statisticalUnit] || '-')
}, {
  title: '统计换算',
  dataIndex: 'statisticalConversion',
  width: 80,
  render: statisticalConversion => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, statisticalConversion || '-')
}, {
  title: '创建人',
  dataIndex: 'creator',
  width: 80
}, {
  title: '创建时间',
  dataIndex: 'createTime',
  width: 120
}, {
  title: '更新人',
  dataIndex: 'modifier',
  width: 80
}, {
  title: '更新时间',
  dataIndex: 'modifyTime',
  width: 120
}];
var statusMap = {
  1: '待处理',
  2: '处理中',
  3: '处理成功',
  4: '处理失败',
  5: '部分成功'
};
var downformJson = [{
  label: '状态',
  name: 'taskStatus',
  type: 'SELECT',
  dataList: [{
    label: '待处理',
    value: 1
  }, {
    label: '处理中',
    value: 2
  }, {
    label: '处理成功',
    value: 3
  }, {
    label: '处理失败',
    value: 4
  }, {
    label: '部分成功',
    value: 5
  }]
} // {
//   label: '开始时间',
//   name: 'taskCreateTimeStart',
//   initialValue: undefined,
//   type: 'DATE_PICKER',
//   fieldOptions: {},
// },
// {
//   label: '结束时间',
//   name: 'taskCreateTimeEnd',
//   initialValue: undefined,
//   type: 'DATE_PICKER',
//   fieldOptions: {},
// },
];
var DOWN_COLUMN_FIELD = [{
  title: '名称',
  dataIndex: 'exportFileName',
  width: 120
}, {
  title: '类型',
  dataIndex: 'bizTypeName',
  width: 90,
  render: (bizTypeName, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, bizTypeName)
}, {
  title: '状态',
  dataIndex: 'status',
  width: 90,
  render: status => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, statusMap[status])
}, {
  title: '操作人',
  dataIndex: 'creator',
  width: 80
}, {
  title: '任务创建时间',
  dataIndex: 'createTime',
  width: 120
}, {
  title: '任务完成时间',
  dataIndex: 'finishTime',
  width: 120
}];

/***/ }),

/***/ 66243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ asyncImport; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/spin/style/index.js
var style = __webpack_require__(20228);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js
var spin = __webpack_require__(11382);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/index.js
var message_style = __webpack_require__(34792);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(48086);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/antd/es/upload/style/index.js
var upload_style = __webpack_require__(43185);
// EXTERNAL MODULE: ./node_modules/antd/es/upload/index.js + 12 modules
var upload = __webpack_require__(3388);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/pages/Category/Manage/Import/MyImport/dataInfo.ts
var REACT_APP_ENV = ({"NODE_ENV":"production"}).REACT_APP_ENV || 'test'; // console.log(REACT_APP_ENV)

var env = null;
var baseURL = null;
var downLoadUrl = null;
var uploadUrlNew = null; // 区分内外网
// let urlValue = window.location.href

console.log('REACT_APP_ENV', REACT_APP_ENV);

if (REACT_APP_ENV === 'prod') {
  env = 'prod';
  baseURL = 'https://apigw.ypshengxian.com';
  uploadUrlNew = 'https://api-resource.ypshengxian.com/resource/upload';
} else {
  if (REACT_APP_ENV === 'dev') {
    env = 'dev';
    baseURL = 'https://apigw-dev.ypshengxian.com'; // uploadUrlNew = 'http://172.16.4.184:8070/resource/upload'

    uploadUrlNew = 'https://test-api-resource.ypshengxian.com/resource/upload';
  } else if (REACT_APP_ENV === 'test') {
    env = 'test';
    baseURL = 'https://apigw-test.ypshengxian.com';
    uploadUrlNew = 'https://test-api-resource.ypshengxian.com/resource/upload';
  } else if (REACT_APP_ENV === 'pre') {
    env = 'pre';
    baseURL = 'https://apigw-pre.ypshengxian.com';
    uploadUrlNew = 'https://pre-api-resource.ypshengxian.com/resource/upload';
  } else if (REACT_APP_ENV === 'testdev') {
    env = 'test';
    baseURL = 'https://apigw-test.ypshengxian.com'; // baseURL = 'https://apigw-dev.ypshengxian.com'

    uploadUrlNew = 'https://test-api-resource.ypshengxian.com/resource/upload';
  } else if (REACT_APP_ENV === 'sit') {
    env = 'sit';
    baseURL = 'https://apigw-sit.ypshengxian.com'; // baseURL = 'https://apigw-dev.ypshengxian.com'
    // uploadUrlNew = 'http://172.16.4.184:8070/resource/upload'

    uploadUrlNew = 'https://sit-api-resource.ypshengxian.com/resource/upload';
  } // baseURL = 'http://172.16.4.178:28080'

}

downLoadUrl = baseURL;
var data = {
  env,
  token: 'deb347999c1f4d8b8b627ad956c2e292',
  login: 'lct2019',
  downLoadUrl,
  uploadUrlNew,
  baseURL
};
/* harmony default export */ var dataInfo = (data);
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
;// CONCATENATED MODULE: ./src/pages/Category/Manage/Import/MyImport/asyncImport.tsx











 // import apis from '@api/apigw'
// import $fetch from '@utils/fetch'


var Dragger = upload/* default.Dragger */.Z.Dragger;

var AsyncImport = props => {
  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react.useState)(true),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      showUploadList = _useState4[0],
      setShowUploadList = _useState4[1];

  var _useState5 = (0,react.useState)({
    'res-token': ''
  }),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      headers = _useState6[0],
      setHeaders = _useState6[1];

  var actionUrl = dataInfo.uploadUrlNew;

  var beforeUpload = file => {
    var name = file.name;
    var isExcel = !!name.includes('xls');
    var limit = props.limit;

    if (limit) {
      var isLt1M = file.size / 1024 / 1024 < limit;

      if (!isLt1M) {
        message.default.error("\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7".concat(limit, "M"));

        return;
      }
    }

    return new Promise((resolve, reject) => {
      if (!isExcel) {
        message.default.error('只能上传excel文件');

        reject(file);
      } else {
        var dataVal = {
          bizDescription: '商品中心文件上传',
          type: 1
        }; // 0-图片 1-excel

        (0,ypRequest/* default */.Z)('item.resource.getResourceToken', dataVal).then(res => {
          console.log('res', res);
          var headers = {
            'res-token': res.result.token
          };
          setHeaders(headers);
          resolve(file);
        });
      }
    });
  };

  var handleChange = info => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }

    setLoading(false);

    if (info.file.status === 'done') {
      if (info.file.response.code !== 200) {
        message.default.error(info.file.response.msg);
      } else {
        var data = info.file.response.data;
        var val = data.files[0];
        props.doSuccess && props.doSuccess(val, data); // getData(val)
      }
    }
  };

  var getData = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(resourceAddr) {
      var uploadUrl, paramsKey, params, url, dataVal, result, res, success;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              uploadUrl = props.uploadUrl, paramsKey = props.paramsKey, params = props.params;
              url = uploadUrl ? uploadUrl : 'item.erpGoodsManage.cityMatchGoodsUpload';
              dataVal = {};

              if (paramsKey) {
                dataVal = (0,objectSpread2/* default */.Z)({}, params);
                dataVal[paramsKey] = resourceAddr;
              } else {
                dataVal = {
                  resourceAddr
                };
              }

              _context.prev = 4;
              _context.next = 7;
              return (0,ypRequest/* default */.Z)(url, dataVal);

            case 7:
              result = _context.sent;
              res = result.res, success = result.success;

              if (success) {
                message.default.success('创建导入任务成功,您可以查看离线任务关注导入动态');

                props.doSuccess && props.doSuccess();
              }

              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](4);
              console.log(_context.t0);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 12]]);
    }));

    return function getData(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var onRemove = data => {
    (props === null || props === void 0 ? void 0 : props.onRemove) && props.onRemove(data);
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, loading ? /*#__PURE__*/react.createElement("div", {
    className: "maskPart"
  }, /*#__PURE__*/react.createElement("div", {
    className: "poce"
  }, /*#__PURE__*/react.createElement(spin/* default */.Z, {
    tip: "\u6B63\u5728\u5BFC\u5165\u4E2D...",
    size: "large"
  }))) : null, /*#__PURE__*/react.createElement(Dragger, {
    headers: headers,
    name: "files",
    className: "avatar-uploader",
    showUploadList: showUploadList,
    action: actionUrl,
    beforeUpload: beforeUpload,
    onChange: handleChange,
    onRemove: onRemove,
    accept: ".xlsx,.xls"
  }, /*#__PURE__*/react.createElement("p", {
    className: "ant-upload-drag-icon"
  }, /*#__PURE__*/react.createElement("svg", {
    viewBox: "0 0 1024 1024",
    focusable: "false",
    className: "",
    "data-icon": "inbox",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    style: {
      color: '#1890ff',
      fontSize: 55
    }
  }, /*#__PURE__*/react.createElement("path", {
    d: "M885.2 446.3l-.2-.8-112.2-285.1c-5-16.1-19.9-27.2-36.8-27.2H281.2c-17 0-32.1 11.3-36.9 27.6L139.4 443l-.3.7-.2.8c-1.3 4.9-1.7 9.9-1 14.8-.1 1.6-.2 3.2-.2 4.8V830a60.9 60.9 0 0 0 60.8 60.8h627.2c33.5 0 60.8-27.3 60.9-60.8V464.1c0-1.3 0-2.6-.1-3.7.4-4.9 0-9.6-1.3-14.1zm-295.8-43l-.3 15.7c-.8 44.9-31.8 75.1-77.1 75.1-22.1 0-41.1-7.1-54.8-20.6S436 441.2 435.6 419l-.3-15.7H229.5L309 210h399.2l81.7 193.3H589.4zm-375 76.8h157.3c24.3 57.1 76 90.8 140.4 90.8 33.7 0 65-9.4 90.3-27.2 22.2-15.6 39.5-37.4 50.7-63.6h156.5V814H214.4V480.1z"
  }))), /*#__PURE__*/react.createElement("p", {
    className: "ant-upload-text"
  }, "\u70B9\u51FB\u6216\u62D6\u62FD\u4E0A\u4F20\u6587\u4EF6")));
};

/* harmony default export */ var asyncImport = (AsyncImport);

/***/ }),

/***/ 32672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var antd_es_tree_select_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62999);
/* harmony import */ var antd_es_tree_select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57119);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24731);







var TreeNode = antd_es_tree_select__WEBPACK_IMPORTED_MODULE_3__/* .default.TreeNode */ .Z.TreeNode;

var CategorySelect = props => {
  var form = props.form,
      categoryId = props.categoryId;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      treeData = _useState2[0],
      setTreeData = _useState2[1];

  var getDataSource = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().mark(function _callee() {
      var res, result, success, _result$childBackCate, childBackCategory;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)("pms.backCategoryManage.getBackCategoryTree", {});

            case 2:
              res = _context.sent;
              result = res.result, success = res.success;

              if (success) {
                _result$childBackCate = result.childBackCategory, childBackCategory = _result$childBackCate === void 0 ? [] : _result$childBackCate;
                setTreeData(childBackCategory);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getDataSource() {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    getDataSource();
  }, []);

  var renderTreeNode = treeData => {
    if (!treeData) return;
    return treeData.map((item, key) => {
      if (item.childBackCategory) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(TreeNode, {
          value: item.backCategoryId,
          title: item.backCategoryName,
          key: item.backCategoryId
        }, renderTreeNode(item.childBackCategory));
      } else {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(TreeNode, {
          value: item.backCategoryId,
          title: item.backCategoryName,
          key: item.backCategoryId
        });
      }
    });
  };

  var onTreeChange = value => {
    var _form$current;

    (_form$current = form.current) === null || _form$current === void 0 ? void 0 : _form$current.setFieldsValue({
      categoryId: value
    });
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tree_select__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    treeDataSimpleMode: true,
    allowClear: true,
    style: {
      width: '100%'
    },
    defaultValue: categoryId,
    dropdownStyle: {
      maxHeight: 400,
      overflow: 'auto'
    },
    placeholder: "\u8BF7\u9009\u62E9\u5546\u54C1\u7C7B\u76EE",
    onChange: onTreeChange
  }, renderTreeNode(treeData));
};

/* harmony default export */ __webpack_exports__["default"] = (CategorySelect);

/***/ }),

/***/ 60683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FormFields": function() { return /* binding */ FormFields; },
/* harmony export */   "TableColumns": function() { return /* binding */ TableColumns; }
/* harmony export */ });
/* harmony import */ var antd_es_checkbox_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63185);
/* harmony import */ var antd_es_checkbox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9676);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46565);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _categorySelect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32672);








var FormFields = (rowData, form) => {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      shopList = _useState2[0],
      setshopList = _useState2[1];

  var getShopList = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().mark(function _callee() {
      var params, v, list, l;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = {
                merchantId: rowData === null || rowData === void 0 ? void 0 : rowData.merchantId,
                siteCode: "",
                siteName: "",
                page: 1
              };
              _context.next = 3;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_1__/* .YpRequest */ .XQ)('pms.pmsMerchantService.querySiteInfoByCodeOrName', params);

            case 3:
              v = _context.sent;

              if (v.success) {
                list = v.result.list;
                l = list.map(item => {
                  return {
                    label: item.siteName,
                    value: item.siteId
                  };
                });
                setshopList(l);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getShopList() {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    getShopList();
  }, []);

  var checkChange = val => {
    var _form$current;

    (_form$current = form.current) === null || _form$current === void 0 ? void 0 : _form$current.setFieldsValue({
      status: val.target.checked
    });
  };

  return [{
    label: '选择门店',
    name: 'shopId',
    type: 'SELECT',
    initialValue: [rowData === null || rowData === void 0 ? void 0 : rowData.shopId],
    dataList: shopList,
    fieldOptions: {
      mode: "multiple"
    }
  }, {
    label: '商品类目',
    name: 'categoryId',
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_categorySelect__WEBPACK_IMPORTED_MODULE_3__.default, {
      form: form,
      categoryId: rowData === null || rowData === void 0 ? void 0 : rowData.categoryId
    })
  }, {
    label: '只展示爆箱类目',
    name: 'status',
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_checkbox__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
      defaultChecked: true,
      onChange: checkChange
    })
  }, {
    label: '商品',
    name: 'good',
    type: 'INPUT',
    fieldOptions: {
      placeholder: "商品名称/条码/编码"
    }
  }];
};
var TableColumns = () => {
  return [{
    title: '门店编码',
    dataIndex: 'shopCode',
    key: 'shopCode',
    width: 100
  }, {
    title: '门店名称',
    dataIndex: 'shopName',
    key: 'shopName',
    width: 100
  }, {
    title: '品类名称',
    dataIndex: 'categoryName',
    key: 'categoryName',
    width: 100
  }, {
    title: '箱子数类型',
    dataIndex: 'boxType',
    key: 'boxType',
    width: 100
  }, {
    title: '标准箱子商品数',
    dataIndex: 'confBoxNum',
    key: 'confBoxNum',
    width: 100
  }, {
    title: '实际箱子商品数',
    dataIndex: 'realBoxNum',
    key: 'realBoxNum',
    width: 100
  }, {
    title: '可用箱子商品数',
    dataIndex: 'useBoxNum',
    key: 'useBoxNum',
    width: 100,
    render: (text, record) => {
      if (record.confBoxNum - record.realBoxNum < 0) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("a", {
          onClick: () => {},
          style: {
            color: 'red'
          }
        }, record.confBoxNum - record.realBoxNum);
      }

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("a", {
        onClick: () => {}
      }, record.confBoxNum - record.realBoxNum);
    }
  }, {
    title: '箱子满足率',
    dataIndex: 'boxRate',
    key: 'boxRate',
    width: 100,
    render: (text, record) => {
      if (!record.realBoxNum) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", null, "0");
      } else if (!record.confBoxNum) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", null, record.realBoxNum * 100, "%");
      } else if (Number.isInteger(record.realBoxNum / record.confBoxNum) || Number.isInteger(record.realBoxNum / record.confBoxNum * 100)) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", null, record.realBoxNum / record.confBoxNum * 100, "%");
      } else {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", null, (record.realBoxNum / record.confBoxNum * 100).toFixed(2), "%");
      }
    }
  }];
};

/***/ }),

/***/ 44343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ExpandTableColumns": function() { return /* binding */ ExpandTableColumns; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var ExpandTableColumns = () => {
  return [{
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 100
  }, {
    title: '商品名称',
    dataIndex: 'itemName',
    key: 'itemName',
    width: 100,
    sorter: (a, b) => a.itemName.localeCompare(b.itemName)
  }, {
    title: '商品条码',
    dataIndex: 'barcode',
    key: 'barcode',
    width: 100,
    sorter: (a, b) => a.barcode - b.barcode
  }, {
    title: '二级类目',
    dataIndex: 'categoryName2th',
    key: 'categoryName2th',
    width: 100
  }, {
    title: '三级类目',
    dataIndex: 'categoryName3th',
    key: 'categoryName3th',
    width: 100
  }, {
    title: '商品生命周期',
    dataIndex: 'status',
    key: 'status',
    width: 100,
    sorter: (a, b) => a.status - b.status,
    render: (text, record) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, ['新品', '正常', '停购', '停售', '清退'][text - 1]);
    }
  }, {
    title: '供应商编码',
    dataIndex: 'supplierCode',
    key: 'supplierCode',
    width: 100
  }, {
    title: '供应商名称',
    dataIndex: 'supplierName',
    key: 'supplierName',
    width: 100,
    sorter: (a, b) => a.supplierName.localeCompare(b.supplierName)
  }, {
    title: '库存',
    dataIndex: 'stock',
    key: 'stock',
    width: 100,
    sorter: (a, b) => a.stock - b.stock
  }, {
    title: '昨日销量',
    dataIndex: 'saleNumYesterday',
    key: 'saleNumYesterday',
    width: 100,
    sorter: (a, b) => a.saleNumYesterday - b.saleNumYesterday
  }, {
    title: '近一周销量',
    dataIndex: 'saleNumLastWeek',
    key: 'saleNumLastWeek',
    width: 100,
    sorter: (a, b) => a.saleNumLastWeek - b.saleNumLastWeek
  }, {
    title: '近一月销量',
    dataIndex: 'saleNumLastMonth',
    key: 'saleNumLastMonth',
    width: 100,
    sorter: (a, b) => a.saleNumLastMonth - b.saleNumLastMonth
  }];
};

/***/ }),

/***/ 94224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var antd_es_tree_select_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62999);
/* harmony import */ var antd_es_tree_select__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57119);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);







/* eslint-disable array-callback-return */

/* eslint-disable no-unreachable */

/* eslint-disable no-unused-expressions */

/* eslint-disable prefer-promise-reject-errors */

/* eslint-disable no-async-promise-executor */

/**
 * 店群门店树形选择（新版-根据全部数据展开）
 * 杭州-杭州一区-杭州xx门店
 * 适配分档数据，其他店群不太复用
 */

// import { GET_STORES_API } from '@views/Master/Import';
var SHOW_PARENT = antd_es_tree_select__WEBPACK_IMPORTED_MODULE_2__/* .default.SHOW_PARENT */ .Z.SHOW_PARENT; // SHOW_ALL SHOW_PARENT
// const { SHOW_ALL } = TreeSelect; // SHOW_ALL SHOW_PARENT

var TreeNode = antd_es_tree_select__WEBPACK_IMPORTED_MODULE_2__/* .default.TreeNode */ .Z.TreeNode;

var StoresSelect3 = props => {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState, 2),
      curValue = _useState2[0],
      setcurValue = _useState2[1]; // 当前值


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState3, 2),
      shopNum = _useState4[0],
      setshopNum = _useState4[1]; // 当前值


  var shopList = props.shopList,
      _props$treeCheckable = props.treeCheckable,
      treeCheckable = _props$treeCheckable === void 0 ? true : _props$treeCheckable,
      _props$showCheckedStr = props.showCheckedStrategy,
      showCheckedStrategy = _props$showCheckedStr === void 0 ? SHOW_PARENT : _props$showCheckedStr,
      placeholder = props.placeholder;

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState5, 2),
      curTreeData = _useState6[0],
      setcurTreeData = _useState6[1]; // 内部树数据结构


  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState7, 2),
      merchantData = _useState8[0],
      setmerchantData = _useState8[1]; // 商户数据


  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState9, 2),
      submitData = _useState10[0],
      setSubmitData = _useState10[1]; // 提交数据


  var curYTSelect = props.curYTSelect,
      merchantList = props.merchantList;

  var _getOrganizationId = id => {
    var list = [...curTreeData];
    var organizationId = null;
    list.forEach(i => {
      if (i.children.some(j => j.id === id)) {
        organizationId = i.id;
      }
    });
    return organizationId;
  };

  var _getSite = children => {
    if (!(children !== null && children !== void 0 && children.length)) return [];
    var arr = [];
    children.forEach(i => {
      var _props$children;

      var _i$props = i.props,
          props = _i$props === void 0 ? {} : _i$props;

      if (props.lv === 4) {
        arr.push({
          siteId: props === null || props === void 0 ? void 0 : props.value,
          siteType: props === null || props === void 0 ? void 0 : props.type,
          siteName: props === null || props === void 0 ? void 0 : props.title
        });
      } else if (props.lv === 3 && (_props$children = props.children) !== null && _props$children !== void 0 && _props$children.length) {
        var child = props.children.map(j => {
          var _j$props, _j$props2, _j$props3;

          return {
            siteId: j === null || j === void 0 ? void 0 : (_j$props = j.props) === null || _j$props === void 0 ? void 0 : _j$props.value,
            siteType: j === null || j === void 0 ? void 0 : (_j$props2 = j.props) === null || _j$props2 === void 0 ? void 0 : _j$props2.type,
            siteName: j === null || j === void 0 ? void 0 : (_j$props3 = j.props) === null || _j$props3 === void 0 ? void 0 : _j$props3.title
          };
        });
        arr = arr.concat(child);
      }
    });
    return arr.filter(Boolean);
  };
  /**
  * 数据改变
  * @param value 当前值
  * @param label 标签
  * @param extra
  */


  var _onChange = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee(value, label, extra) {
      var triggerNode, checked, data, list, treeData, lv, id, pId, children, type, title, _treeData$, _mId, name, _mType, arr, _pId, _arr, _arr2, _pId2;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setcurValue(value); // extra?.triggerNode?.key : 当前节点选择值

              triggerNode = extra.triggerNode, checked = extra.checked;
              data = triggerNode.props;
              list = [...submitData];
              treeData = [...merchantData];
              lv = data.lv, id = data.value, pId = data.pId, children = data.children, type = data.type, title = data.title;
              _treeData$ = treeData[0], _mId = _treeData$.id, name = _treeData$.name, _mType = _treeData$.type;

              if (checked) {
                if (lv === 2) {
                  arr = {
                    merchantId: _mId,
                    organizationId: id,
                    merchantType: _mType,
                    title: name,
                    siteDTO: _getSite(children)
                  };
                  list = list.concat(arr);
                } else if (lv === 4) {
                  _pId = type === 3 ? _getOrganizationId(pId) : pId;

                  if (list.some(i => (i === null || i === void 0 ? void 0 : i.merchantId) === _mId && (i === null || i === void 0 ? void 0 : i.organizationId) === _pId)) {
                    list.forEach(i => {
                      if ((i === null || i === void 0 ? void 0 : i.merchantId) === _mId && (i === null || i === void 0 ? void 0 : i.organizationId) === _pId) {
                        i.siteDTO = i.siteDTO.concat([{
                          siteId: id,
                          siteType: type,
                          siteName: title
                        }]);
                      }
                    });
                  } else {
                    _arr = {
                      merchantId: _mId,
                      organizationId: _pId,
                      merchantType: _mType,
                      title: name,
                      siteDTO: [{
                        siteId: id,
                        siteType: type,
                        siteName: title
                      }]
                    };
                    list = list.concat(_arr);
                  }
                } else {
                  if (list.some(i => i.organizationId === pId)) {
                    list.forEach(i => {
                      i.siteDTO = i.siteDTO.concat(_getSite(children));
                    });
                  } else {
                    list.push({
                      merchantId: _mId,
                      // 商家 id
                      organizationId: pId,
                      // 运营组织Id
                      title: name,
                      // 商家名称
                      merchantType: _mType,
                      // 商家类型
                      siteDTO: _getSite(children)
                    });
                  }
                }
              } else {
                _arr2 = [];

                if (lv === 2) {
                  _arr2 = list.filter(i => i.organizationId !== id).filter(Boolean);
                } else if (lv === 4) {
                  _pId2 = type === 3 ? _getOrganizationId(pId) : pId;
                  _arr2 = list.map(i => {
                    if (i.merchantId === _mId && i.organizationId === _pId2) {
                      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)({}, i), {}, {
                        siteDTO: i.siteDTO.filter(j => j.siteId !== id)
                      });
                    }
                  }).filter(Boolean);
                }

                list = [..._arr2];
              }

              setSubmitData(list);
              props.onChange && props.onChange(list);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function _onChange(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * 提示
   */


  var tips = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => {
    var _tip = shopNum ? "\u5DF2\u9009\u62E9".concat(shopNum, "\u4E2A\u95E8\u5E97") : '';

    return "\u9009\u62E9\u95E8\u5E97 ".concat(_tip);
  }, [shopNum]);

  var renderTreeNode = treeData => {
    if (!(treeData !== null && treeData !== void 0 && treeData.length)) return null;
    return treeData.map((item, key) => {
      var _item$children;

      if ((_item$children = item.children) !== null && _item$children !== void 0 && _item$children.length) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(TreeNode, {
          value: item.id,
          title: item.name,
          key: item.id,
          isLeaf: false,
          lv: item.level,
          pId: item.pid
        }, renderTreeNode(item.children));
      } else {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(TreeNode, {
          value: item.id,
          title: item.name,
          key: item.id,
          isLeaf: true,
          lv: item.level,
          pId: item.pid,
          type: item.type
        });
      }
    });
  };

  var handleData = merchantList => {
    var _ref2 = merchantList !== null && merchantList !== void 0 && merchantList.length ? merchantList[0] : {},
        _ref2$children = _ref2.children,
        children = _ref2$children === void 0 ? [] : _ref2$children;

    setcurTreeData(children);
    setmerchantData(merchantList);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    handleData(merchantList);
  }, [merchantList]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    setSubmitData([]);
    setcurValue([]);
    props.onChange && props.onChange([]);
  }, [curYTSelect, props.merchantId]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    style: {
      fontSize: 14,
      marginBottom: 6,
      color: 'rgba(0, 0, 0, 0.85)'
    }
  }, props.tip ? props.tip : tips), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tree_select__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    value: curValue,
    dropdownStyle: {
      maxHeight: 400,
      overflow: 'auto'
    },
    onChange: _onChange // treeData={curTreeData}
    ,
    multiple: true,
    treeCheckable: treeCheckable,
    maxTagCount: props.maxTagCount || 1 // loadData={onLoadData}
    ,
    placeholder: placeholder || '请输入商家/门店名称',
    allowClear: props.allowClear,
    showSearch: true,
    treeDefaultExpandAll: props.treeDefaultExpandAll || false,
    style: props.style || {
      width: 320
    },
    treeDataSimpleMode: true,
    treeNodeFilterProp: "title" // 开启按title搜索

  }, renderTreeNode(curTreeData)));
};

/* harmony default export */ __webpack_exports__["default"] = (StoresSelect3);

/***/ }),

/***/ 47863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var antd_es_tree_select_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62999);
/* harmony import */ var antd_es_tree_select__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57119);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71720);




/**
 * 商品类目树
 */


var TreeNode = antd_es_tree_select__WEBPACK_IMPORTED_MODULE_2__/* .default.TreeNode */ .Z.TreeNode;

var GoodsCategorySelect = props => {
  var _useSelector = (0,umi__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(state => state.goodsStore),
      goodsCategoryList = _useSelector.goodsCategoryList;

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    setTreeData(goodsCategoryList);
  }, [goodsCategoryList]);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(goodsCategoryList),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      treeData = _useState2[0],
      setTreeData = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState3, 2),
      curCategoryValue = _useState4[0],
      setCurCategoryValue = _useState4[1];
  /** 渲染树 */


  var renderTreeNode = treeData => {
    if (!treeData) return;
    return treeData.map((item, key) => {
      if (item.childBackCategory && item.level <= 3) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(TreeNode, {
          disabled: item.level < 3,
          value: item.backCategoryId,
          title: item.backCategoryName,
          key: item.backCategoryId
        }, renderTreeNode(item.childBackCategory));
      }
    });
  };
  /** 数据选择 */


  var onTreeChange = e => {
    setCurCategoryValue(e);

    if (props.setCategoryId) {
      props.setCategoryId(e);
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    id: "my-tree-select"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tree_select__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    allowClear: true,
    treeDataSimpleMode: true,
    style: {
      width: '100%'
    },
    value: curCategoryValue || props.categoryId || undefined,
    dropdownStyle: {
      maxHeight: 400,
      overflow: 'auto'
    },
    placeholder: props.placeholder || '请选择商品类目',
    onChange: onTreeChange
  }, renderTreeNode(treeData)));
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(GoodsCategorySelect));

/***/ }),

/***/ 73451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(91896);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46565);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49408);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7704);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27731);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(37982);










/**
 * 批量更新
 */





var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 4
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 18
    }
  }
};

function BatchUpdateModal(props) {
  var poolingId = props.poolingId,
      batchType = props.batchType,
      closeModalCallback = props.closeModalCallback;
  var formbuilder = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)([_hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__/* .MappingKey["当前用户权限的供货DC"] */ .M["当前用户权限的供货DC"], _hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__/* .MappingKey["紧急程度"] */ .M["紧急程度"]]),
      mappingList = _useMapping.mappingList;

  var dcList = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    if (batchType === _config__WEBPACK_IMPORTED_MODULE_5__/* .BatchUpdateType["供货路径"] */ .U4["供货路径"]) {
      return [{
        value: 1,
        label: '台州仓-城市仓-城市店'
      }, {
        value: 2,
        label: '台州仓-城市仓'
      }, {
        value: 3,
        label: '台州仓-城市店'
      }];
    } else if (batchType === _config__WEBPACK_IMPORTED_MODULE_5__/* .BatchUpdateType["紧急程度"] */ .U4["紧急程度"]) {
      return mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__/* .MappingKey["紧急程度"] */ .M["紧急程度"]);
    } else {
      return mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__/* .MappingKey["当前用户权限的供货DC"] */ .M["当前用户权限的供货DC"]);
    }
  }, [mappingList, batchType]); // 保存

  var handleOk = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)().mark(function _callee() {
    var _formbuilder$current;

    var values, params, url, res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (_formbuilder$current = formbuilder.current) === null || _formbuilder$current === void 0 ? void 0 : _formbuilder$current.getFieldsValue();

          case 2:
            values = _context.sent;

            if (values.modifyDeliveryDcId) {
              _context.next = 6;
              break;
            }

            antd_es_message__WEBPACK_IMPORTED_MODULE_9__.default.error('请选择批量更新的内容');

            return _context.abrupt("return");

          case 6:
            params = {};
            url = _api__WEBPACK_IMPORTED_MODULE_10__/* .DURABLE_BATCH_UPDATE */ .$D;

            if (batchType === _config__WEBPACK_IMPORTED_MODULE_5__/* .BatchUpdateType["供货路径"] */ .U4["供货路径"]) {
              params = {
                query: {
                  poolingId
                },
                modifyInfo: {
                  supplyRoute: values === null || values === void 0 ? void 0 : values.modifyDeliveryDcId
                }
              };
            } else if (batchType === _config__WEBPACK_IMPORTED_MODULE_5__/* .BatchUpdateType["紧急程度"] */ .U4["紧急程度"]) {
              params = {
                query: {
                  poolingId
                },
                modifyInfo: {
                  emergLevel: values === null || values === void 0 ? void 0 : values.modifyDeliveryDcId
                }
              };
            } else {
              // 不确定格式
              params = {
                modifyDeliveryDcId: values === null || values === void 0 ? void 0 : values.modifyDeliveryDcId,
                poolingId
              };
              url = _api__WEBPACK_IMPORTED_MODULE_11__/* .BATCH_MODIFY_DC */ .sH;
            }

            _context.next = 11;
            return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .YpRequest */ .XQ)(url, params);

          case 11:
            res = _context.sent;

            if (!res.success) {
              _context.next = 15;
              break;
            }

            antd_es_message__WEBPACK_IMPORTED_MODULE_9__.default.success('批量更新成功');

            return _context.abrupt("return", closeModalCallback());

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [batchType, poolingId, closeModalCallback]);
  var elements = [batchType === _config__WEBPACK_IMPORTED_MODULE_5__/* .BatchUpdateType["供货路径"] */ .U4["供货路径"] && {
    label: ' ',
    name: 'deliveryDcId',
    type: 'RADIO',
    dataList: [{
      value: 1,
      label: '供货路径'
    }]
  }, batchType === _config__WEBPACK_IMPORTED_MODULE_5__/* .BatchUpdateType["紧急程度"] */ .U4["紧急程度"] && {
    label: ' ',
    name: 'deliveryDcId',
    type: 'RADIO',
    dataList: [{
      value: 1,
      label: '紧急程度'
    }]
  }, batchType === _config__WEBPACK_IMPORTED_MODULE_5__/* .BatchUpdateType["配送仓"] */ .U4["配送仓"] && {
    label: ' ',
    name: 'deliveryDcId',
    type: 'RADIO',
    dataList: [{
      value: 1,
      label: '配送仓'
    }]
  }, {
    label: ' ',
    name: 'modifyDeliveryDcId',
    type: 'SELECT',
    dataList: dcList || []
  }].filter(Boolean);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
    title: "\u6279\u91CF\u66F4\u65B0",
    destroyOnClose: true,
    maskClosable: false,
    width: 400,
    visible: true,
    onCancel: closeModalCallback,
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
      key: "cancel",
      onClick: closeModalCallback
    }, "\u53D6\u6D88"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
      type: "primary",
      key: "ok",
      onClick: handleOk
    }, "\u786E\u8BA4")]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .FormBuilder */ .qu, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, defaultFormItemLayout, {
    colon: false,
    formRef: formbuilder,
    elements: elements,
    initialValues: {
      deliveryDcId: 1
    },
    notSearchForm: true
  })));
}

/* harmony default export */ __webpack_exports__["default"] = (BatchUpdateModal);

/***/ }),

/***/ 63525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(91896);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(90636);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(57016);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93224);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46565);
/* harmony import */ var _components_FormCategorySelect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45199);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7704);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(37982);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26715);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67541);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24731);












var _excluded = ["category"];

/**
 * 商品清退
 */








var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 4
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 18
    }
  }
};

function GoodsModal(props) {
  var formData = props.formData,
      childPlaceList = props.childPlaceList,
      bussinessType = props.bussinessType;
  var formbuilder = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
  var isFresh = ___WEBPACK_IMPORTED_MODULE_8__.BussinessType["生鲜"] === bussinessType; // 表格查询参数

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_useState, 2),
      searchParams = _useState2[0],
      setSearchParams = _useState2[1]; // 正在保存商品行


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_useState3, 2),
      isSaving = _useState4[0],
      setIsSaving = _useState4[1]; // 判断多个请求之后状态


  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_useState5, 2),
      queryState = _useState6[0],
      setQuery = _useState6[1];

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)([_hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__/* .MappingKey["所有品类"] */ .M["所有品类"]]),
      mappingList = _useMapping.mappingList;

  var categoryList = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__/* .MappingKey["所有品类"] */ .M["所有品类"]), [mappingList]); // 取消请求数据

  var cancelRequest = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    return !(searchParams !== null && searchParams !== void 0 && searchParams.condition.placeId);
  }, [searchParams === null || searchParams === void 0 ? void 0 : searchParams.condition.placeId]); // 查询

  var handleSearch = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(values => {
    var category = values.category,
        rest = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(values, _excluded);

    var params = {
      billType: _config_enums__WEBPACK_IMPORTED_MODULE_7__/* .BILL_TYPE["要货集单"] */ .$M["要货集单"],
      condition: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)({}, rest), {}, {
        firstCategoryId: formData === null || formData === void 0 ? void 0 : formData.firstCategoryId,
        secondCategoryId: formData === null || formData === void 0 ? void 0 : formData.secondCategoryId,
        merchantId: formData === null || formData === void 0 ? void 0 : formData.merchantId,
        logisticMode: formData !== null && formData !== void 0 && formData.logistics ? [formData === null || formData === void 0 ? void 0 : formData.logistics] : undefined
      })
    };
    setSearchParams(params);
  }, [formData === null || formData === void 0 ? void 0 : formData.firstCategoryId, formData === null || formData === void 0 ? void 0 : formData.logistics, formData === null || formData === void 0 ? void 0 : formData.merchantId, formData === null || formData === void 0 ? void 0 : formData.secondCategoryId]); // 保存行

  var saveRowCallback = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().mark(function _callee(data) {
      var currentCellOldData, currentRow, params, res, _res$result, _res$result2;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currentCellOldData = data.currentCellOldData, currentRow = data.currentRow;
              setQuery(prev => {
                return prev + 1;
              });
              params = {
                poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId,
                detail: {
                  id: currentRow.id,
                  placeId: currentRow.placeId,
                  goodsId: currentRow.goodsId,
                  barCode: currentRow.goodsBarCode,
                  demandNum: 1,
                  // 需求数量 固定
                  approveNum: currentRow.approveNum || 0,
                  // 审核数量
                  supplierCode: currentRow.supplierCode,
                  // 供应商编码
                  logistics: currentRow.logistic,
                  // 物流模式：1直送；2配送；3直通
                  merchantId: currentRow === null || currentRow === void 0 ? void 0 : currentRow.merchantId,
                  deliveryDcId: currentRow.logistic === 1 ? '0' : currentRow.deliveryDcId,
                  emergLevel: 1,
                  // 默认 正常
                  supplyRoute: 1 // 默认 台州仓-城市仓-城市店

                }
              };
              _context.next = 5;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_15__/* .SAVE_PLACE_GOODS */ .xq, params);

            case 5:
              res = _context.sent;
              setQuery(prev => {
                return prev - 1;
              });

              if (!res.success) {
                _context.next = 13;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.success('保存商品成功');

              if (currentRow.approveNum !== ((_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.approveNum)) {
                antd_es_modal__WEBPACK_IMPORTED_MODULE_17__/* .default.info */ .Z.info({
                  title: '温馨提示',
                  content: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "\u5546\u54C1\u3010", currentRow.goodsId, "\u3011", currentRow === null || currentRow === void 0 ? void 0 : currentRow.goodsName), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "\u5BA1\u6838\u6570\u91CF: ", currentRow.approveNum), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "\u6309\u6B65\u957F\u6298\u7B97\u6210: ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("strong", null, (_res$result2 = res.result) === null || _res$result2 === void 0 ? void 0 : _res$result2.approveNum)))
                });
              }

              return _context.abrupt("return", (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)({}, currentRow), res.result));

            case 13:
              return _context.abrupt("return", currentCellOldData);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [formData === null || formData === void 0 ? void 0 : formData.poolingId]);
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (queryState === 0) {
      setIsSaving(false);
    } else {
      setIsSaving(true);
    }
  }, [queryState]); // 关闭的函数

  var closeProgramFun = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    console.log('33333');

    if (!isSaving) {
      props.closeModalCallback();
    }
  }, [isSaving]);
  var elements = [{
    label: '地点',
    name: 'placeId',
    type: 'SELECT',
    required: true,
    dataList: childPlaceList || []
  }, {
    label: '商品信息',
    name: 'queryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/编码/名称/PLU'
    }
  }, {
    label: '品牌名称',
    name: 'brandName',
    type: 'INPUT'
  }, {
    label: '品类',
    name: 'category',
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_FormCategorySelect__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
      categoryList: categoryList,
      formValue: {
        first: formData === null || formData === void 0 ? void 0 : formData.firstCategoryId,
        second: formData === null || formData === void 0 ? void 0 : formData.secondCategoryId
      },
      firstProps: {
        disabled: true
      },
      secondProps: {
        disabled: isFresh
      }
    })
  }];
  var columns = [{
    title: '商品编码',
    dataIndex: 'goodsId',
    width: 100
  }, {
    title: '商品条码',
    dataIndex: 'goodsBarCode',
    width: 130
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    width: 170
  }, {
    title: '二类名称',
    dataIndex: 'secondCategoryName',
    width: 130
  }, {
    title: '审核数量',
    dataIndex: 'approveNum',
    width: 140,
    type: 'INPUT'
  }, {
    title: '品牌名称',
    dataIndex: 'brandName',
    width: 130
  }, {
    title: '规格',
    dataIndex: 'orderSpecification',
    width: 80
  }, {
    title: '单位',
    dataIndex: 'orderSpecificationUnit',
    width: 80
  }];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z, {
    title: "\u5546\u54C1\u9009\u62E9",
    destroyOnClose: true,
    maskClosable: false,
    closable: false,
    width: 1200,
    visible: true,
    onCancel: () => {
      closeProgramFun();
    },
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
      key: "cancel",
      disabled: isSaving,
      onClick: () => {
        closeProgramFun();
      }
    }, "\u5173\u95ED")]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .FormBuilder */ .qu, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)({}, defaultFormItemLayout, {
    formRef: formbuilder,
    elements: elements,
    onSearch: handleSearch
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .EnhanceTable */ .UO, {
    cancelRequest: cancelRequest,
    searchParams: searchParams,
    columns: columns,
    requestUrl: _api__WEBPACK_IMPORTED_MODULE_15__/* .ADD_GOODS_LIST */ .gA,
    saveRowCallback: saveRowCallback
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (GoodsModal);

/***/ }),

/***/ 25021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(8870);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71720);
/* harmony import */ var _components_Uploader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84843);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46565);
/* harmony import */ var _BatchUpdateModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73451);
/* harmony import */ var _hooks_useLoopImport__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88242);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(83987);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(90631);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(37982);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(27731);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49408);
/* harmony import */ var _GoodsModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63525);











/* eslint-disable no-async-promise-executor */











function HandleBtn(props) {
  var formData = props.formData,
      exitSavedGoods = props.exitSavedGoods,
      exitGoods = props.exitGoods,
      bussinessType = props.bussinessType,
      importUrl = props.importUrl,
      templateType = props.templateType,
      afterHandleCallback = props.afterHandleCallback;
  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_10__/* .useDispatch */ .I0)();

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_config__WEBPACK_IMPORTED_MODULE_8__/* .CollectionContext */ .WH),
      childPlaceList = _useContext.childPlaceList; // 无法操作


  var disabledBtn = !(formData !== null && formData !== void 0 && formData.id);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState, 2),
      goodsModalVisible = _useState2[0],
      setGoodsModalVisible = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    batchType: undefined,
    visible: false
  }),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState3, 2),
      batchModal = _useState4[0],
      setBatchModal = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    stock: false,
    errorReason: false
  }),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState5, 2),
      btnLoading = _useState6[0],
      setBtnLoading = _useState6[1];

  var _useLoopImport = (0,_hooks_useLoopImport__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({
    request: {
      url: 'purchase.import.getLastImportResult',
      params: {
        businessType: props.importLoopRequestType,
        orderNo: (formData === null || formData === void 0 ? void 0 : formData.poolingId) || ''
      }
    },
    refreshCallback: afterHandleCallback
  }),
      loading = _useLoopImport.loading,
      loadingModal = _useLoopImport.loadingModal,
      startLoop = _useLoopImport.startLoop;

  var changeUpload = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee(val) {
      var params, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = {
                poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId,
                resId: val
              };
              _context.next = 3;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_5__/* .YpRequest */ .XQ)(importUrl, params);

            case 3:
              res = _context.sent;

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.success('导入任务添加成功'); // 开始轮训


                startLoop();
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [formData === null || formData === void 0 ? void 0 : formData.poolingId, importUrl, startLoop]); // 下载

  var downloadTemplate = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee2() {
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return dispatch({
              type: 'purchase/downloadGoodsTemplate',
              payload: {
                downloadType: templateType
              }
            });

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [dispatch, templateType]); // 清空商品

  var clearGoods = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    antd_es_modal__WEBPACK_IMPORTED_MODULE_15__/* .default.confirm */ .Z.confirm({
      title: '清空商品',
      icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, null),
      content: '确认清空全部商品吗？',
      okText: '确认',
      cancelText: '取消',

      onOk() {
        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee3() {
          var res;
          return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_5__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_17__/* .CLEAR_GOODS */ .NN, {
                    poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId
                  });

                case 2:
                  res = _context3.sent;

                  if (res.success) {
                    afterHandleCallback();

                    antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.success('清空商品成功');
                  }

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      }

    });
  }, [afterHandleCallback, formData === null || formData === void 0 ? void 0 : formData.poolingId]); // 刷新大仓库存

  var reloadStock = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee4() {
    var res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            setBtnLoading(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)({}, v), {}, {
              stock: true
            }));
            _context4.next = 3;
            return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_5__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_17__/* .REFRESH_STOCK */ .H, {
              poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId
            });

          case 3:
            res = _context4.sent;
            setBtnLoading(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)({}, v), {}, {
              stock: false
            }));

            if (!res.success) {
              _context4.next = 8;
              break;
            }

            antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.success('刷新大仓库存成功');

            return _context4.abrupt("return", afterHandleCallback());

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  })), [formData === null || formData === void 0 ? void 0 : formData.poolingId, afterHandleCallback]); // 刷新异常原因

  var reloadErrorReason = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee6() {
    var result, loopResult;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            setBtnLoading(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)({}, v), {}, {
              errorReason: true
            }));
            _context6.next = 3;
            return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_5__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_19__/* .DURABLE_REFRESH_ERROR */ .p1, {
              poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId
            });

          case 3:
            result = _context6.sent;

            if (result.success) {
              _context6.next = 7;
              break;
            }

            setBtnLoading(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)({}, v), {}, {
              errorReason: false
            }));
            return _context6.abrupt("return");

          case 7:
            loopResult = /*#__PURE__*/function () {
              var _ref5 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee5() {
                var res;
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_5__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_19__/* .DURABLE_REFRESH_LOOP */ .Np, {
                          poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId
                        });

                      case 2:
                        res = _context5.sent;

                        if (res.success) {
                          _context5.next = 5;
                          break;
                        }

                        return _context5.abrupt("return");

                      case 5:
                        if (!res.result.succ) {
                          _context5.next = 11;
                          break;
                        }

                        setBtnLoading(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)({}, v), {}, {
                          errorReason: false
                        }));

                        antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.success('异常原因检测完毕');

                        return _context5.abrupt("return", afterHandleCallback());

                      case 11:
                        loopResult();

                      case 12:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));

              return function loopResult() {
                return _ref5.apply(this, arguments);
              };
            }();

            loopResult();

          case 9:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  })), [formData === null || formData === void 0 ? void 0 : formData.poolingId, afterHandleCallback]); // 关闭浮层回调

  var closeModalCallback = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    setGoodsModalVisible(false);
    afterHandleCallback();
  }, [afterHandleCallback]); // 批量更新供货路径

  var batchUpdateRoute = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    setBatchModal({
      batchType: _config__WEBPACK_IMPORTED_MODULE_8__/* .BatchUpdateType["供货路径"] */ .U4["供货路径"],
      visible: true
    });
  }, []); // 批量更新配送仓

  var batchUpdateWarehouse = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    setBatchModal({
      batchType: _config__WEBPACK_IMPORTED_MODULE_8__/* .BatchUpdateType["配送仓"] */ .U4["配送仓"],
      visible: true
    });
  }, []); // 批量更新紧急程度

  var batchUpdateEmergLevel = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    setBatchModal({
      batchType: _config__WEBPACK_IMPORTED_MODULE_8__/* .BatchUpdateType["紧急程度"] */ .U4["紧急程度"],
      visible: true
    });
  }, []);
  var closeBatchModalCallback = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    setBatchModal(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)({}, v), {}, {
      visible: false
    }));
    afterHandleCallback();
  }, [afterHandleCallback]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
    type: "primary",
    disabled: disabledBtn,
    className: "mRight16",
    onClick: () => setGoodsModalVisible(true)
  }, "\u6DFB\u52A0\u5546\u54C1"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
    className: "mRight16"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_Uploader__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    tokenUrl: "purchase.resource.getResourceToken",
    accept: ".xlsx,.xls",
    onChange: changeUpload,
    loading: loading,
    btnText: "\u6279\u91CF\u5BFC\u5165",
    uploadOptions: {
      showUploadList: false,
      disabled: exitGoods || disabledBtn
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
    className: "mRight16",
    onClick: downloadTemplate,
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_21__/* .default */ .Z, null)
  }, "\u6A21\u677F\u4E0B\u8F7D"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
    className: "mRight16",
    danger: true,
    disabled: !exitGoods,
    onClick: clearGoods
  }, "\u6E05\u7A7A\u5546\u54C1"), bussinessType !== _config__WEBPACK_IMPORTED_MODULE_8__/* .BussinessType["耐用品"] */ .fQ["耐用品"] ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
    type: "primary",
    loading: btnLoading.stock,
    disabled: !exitSavedGoods || disabledBtn,
    className: "mRight16",
    onClick: reloadStock
  }, "\u5237\u65B0\u5927\u4ED3\u5E93\u5B58"), bussinessType === _config__WEBPACK_IMPORTED_MODULE_8__/* .BussinessType["生鲜"] */ .fQ["生鲜"] ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
    onClick: batchUpdateWarehouse,
    disabled: !exitSavedGoods || disabledBtn
  }, "\u6279\u91CF\u66F4\u65B0\u914D\u9001\u4ED3") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
    onClick: batchUpdateEmergLevel,
    disabled: !exitSavedGoods || disabledBtn
  }, "\u6279\u91CF\u66F4\u65B0\u7D27\u6025\u7A0B\u5EA6")) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
    type: "primary",
    className: "mRight16",
    disabled: !exitSavedGoods || disabledBtn,
    onClick: reloadErrorReason
  }, "\u5237\u65B0\u5F02\u5E38\u539F\u56E0"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
    onClick: batchUpdateRoute,
    disabled: !exitSavedGoods || disabledBtn
  }, "\u6279\u91CF\u66F4\u65B0\u4F9B\u8D27\u8DEF\u5F84")), batchModal.visible && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_BatchUpdateModal__WEBPACK_IMPORTED_MODULE_6__.default, {
    poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId,
    batchType: batchModal.batchType,
    closeModalCallback: closeBatchModalCallback
  }), goodsModalVisible && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_GoodsModal__WEBPACK_IMPORTED_MODULE_9__.default, {
    formData: formData,
    childPlaceList: childPlaceList,
    bussinessType: bussinessType,
    closeModalCallback: closeModalCallback
  }), loadingModal);
}

/* harmony default export */ __webpack_exports__["default"] = (HandleBtn);

/***/ }),

/***/ 1210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8870);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57016);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93224);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46565);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37982);
/* harmony import */ var _useExtData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30703);









var _excluded = ["formData", "placeTableRef", "getApproveSummary", "handleReload"];

/**
 * 地点维度表格
 */





function PlaceDemandTable(props) {
  var formData = props.formData,
      placeTableRef = props.placeTableRef,
      getApproveSummary = props.getApproveSummary,
      handleReload = props.handleReload,
      restProps = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(props, _excluded); // 获取额外参数


  var concatExtData = (0,_useExtData__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(formData === null || formData === void 0 ? void 0 : formData.firstCategoryId, formData === null || formData === void 0 ? void 0 : formData.merchantId); // 地点维度

  var afterPlaceRequest = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().mark(function _callee(data) {
      var list, _restProps$afterReque;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return concatExtData(data);

            case 2:
              list = _context.sent;

              if (!restProps.afterRequest) {
                _context.next = 10;
                break;
              }

              _context.next = 6;
              return (_restProps$afterReque = restProps.afterRequest) === null || _restProps$afterReque === void 0 ? void 0 : _restProps$afterReque.call(restProps, list);

            case 6:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 9;
                break;
              }

              _context.t0 = list;

            case 9:
              list = _context.t0;

            case 10:
              return _context.abrupt("return", list);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [concatExtData, restProps]); // 保存地点维度商品

  var savePlaceRowCallback = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().mark(function _callee2(data) {
      var currentCell, currentRow, currentRowOldData, deliveryDcId, _currentRow$dc, defaultDC, params, res, _res$result, _res$result3, _res$result5, _res$result2, _res$result4;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currentCell = data.currentCell, currentRow = data.currentRow, currentRowOldData = data.currentRowOldData; // 不是直送时  大仓必选

              if (!(currentCell['deliveryDcId'] && currentRow.logistics !== 1 && !currentRow.deliveryDcId)) {
                _context2.next = 4;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_8__.default.warn('请选择大仓');

              return _context2.abrupt("return", currentRowOldData);

            case 4:
              deliveryDcId = currentRow.deliveryDcId;

              if (currentCell['logistics'] && Number(currentRow.deliveryDcId) === 0) {
                defaultDC = (_currentRow$dc = currentRow.dc) === null || _currentRow$dc === void 0 ? void 0 : _currentRow$dc.find(d => d.isDefault);

                if (defaultDC) {
                  deliveryDcId = defaultDC.deliveryDcId;
                }
              }

              if (currentRow.supplierCode) {
                _context2.next = 9;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_8__.default.warning('请选择供应商');

              return _context2.abrupt("return", currentRowOldData);

            case 9:
              if (currentRow.logistics) {
                _context2.next = 12;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_8__.default.warning('请选择物流模式');

              return _context2.abrupt("return", currentRowOldData);

            case 12:
              params = {
                poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId,
                detail: {
                  id: currentRow.id,
                  placeId: currentRow.placeId,
                  goodsId: currentRow.goodsId,
                  barCode: currentRow.barCode,
                  demandNum: currentRow.demandNum,
                  // 需求数量
                  approveNum: currentRow.approveNum || 0,
                  // 审核数量
                  supplierCode: currentRow.supplierCode,
                  // 供应商编码
                  logistics: currentRow.logistics,
                  // 物流模式：1直送；2配送；3直通
                  deliveryDcId,
                  unitPrice: currentRow.unitPrice,
                  merchantId: formData === null || formData === void 0 ? void 0 : formData.merchantId,
                  supplyRoute: currentRow.supplyRoute,
                  // 供货路径
                  emergLevel: currentRow.emergLevel,
                  fatness: Array.isArray(currentRow.fatness) ? undefined : currentRow.fatness,
                  referneceWeight: Array.isArray(currentRow.referneceWeight) ? undefined : currentRow.referneceWeight
                }
              };
              _context2.next = 15;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_3__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_9__/* .SAVE_PLACE_GOODS */ .xq, params);

            case 15:
              res = _context2.sent;

              if (!res.success) {
                _context2.next = 24;
                break;
              }

              if (currentRow.approveNum !== ((_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.approveNum)) {
                antd_es_modal__WEBPACK_IMPORTED_MODULE_10__/* .default.info */ .Z.info({
                  title: '温馨提示',
                  content: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, "\u5546\u54C1\u3010", currentRow.goodsId, "\u3011", currentRow === null || currentRow === void 0 ? void 0 : currentRow.goodsName), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, "\u5BA1\u6838\u6570\u91CF: ", currentRow.approveNum), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, "\u6309\u6B65\u957F\u6298\u7B97\u6210: ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("strong", null, (_res$result2 = res.result) === null || _res$result2 === void 0 ? void 0 : _res$result2.approveNum)))
                });
              }

              if ((_res$result3 = res.result) !== null && _res$result3 !== void 0 && _res$result3.totalPlaceReferencePrice) {
                currentCell.totalPlaceReferencePrice = (_res$result4 = res.result) === null || _res$result4 === void 0 ? void 0 : _res$result4.totalPlaceReferencePrice;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_8__.default.success('修改成功');

              requestAnimationFrame(() => {
                getApproveSummary();

                if (handleReload) {
                  handleReload(currentCell);
                }
              });
              return _context2.abrupt("return", (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({}, currentRow), res.result), {}, {
                totalReferencePrice: (_res$result5 = res.result) === null || _res$result5 === void 0 ? void 0 : _res$result5.totalReferencePrice
              }));

            case 24:
              return _context2.abrupt("return", currentRowOldData);

            case 25:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [formData === null || formData === void 0 ? void 0 : formData.poolingId, formData === null || formData === void 0 ? void 0 : formData.merchantId, getApproveSummary, handleReload]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_3__/* .EnhanceTable */ .UO, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)({
    requestUrl: _api__WEBPACK_IMPORTED_MODULE_9__/* .PLACE_DEMAND_LIST */ .Wc
  }, restProps, {
    tableRef: placeTableRef,
    afterRequest: afterPlaceRequest,
    saveRowCallback: savePlaceRowCallback,
    scroll: {
      y: 500
    }
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (PlaceDemandTable);

/***/ }),

/***/ 37982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vC": function() { return /* binding */ CREATE_COLLECTION; },
/* harmony export */   "VT": function() { return /* binding */ IMPORT_FRESH_DETAIL; },
/* harmony export */   "gA": function() { return /* binding */ ADD_GOODS_LIST; },
/* harmony export */   "Wc": function() { return /* binding */ PLACE_DEMAND_LIST; },
/* harmony export */   "m": function() { return /* binding */ GOODS_DEMAND_LIST; },
/* harmony export */   "NN": function() { return /* binding */ CLEAR_GOODS; },
/* harmony export */   "xq": function() { return /* binding */ SAVE_PLACE_GOODS; },
/* harmony export */   "H": function() { return /* binding */ REFRESH_STOCK; },
/* harmony export */   "wL": function() { return /* binding */ GOODS_STAT; },
/* harmony export */   "ig": function() { return /* binding */ BATCH_MODIFY; },
/* harmony export */   "sH": function() { return /* binding */ BATCH_MODIFY_DC; },
/* harmony export */   "g$": function() { return /* binding */ UPDATE_STATUS; }
/* harmony export */ });
/* unused harmony export DEMAND_REFERENCE_PRICE */

/**
 * 创建集单主单
 */

var CREATE_COLLECTION = 'purchase.demandPooling.saveDemandPooling';
/**
 * 生鲜集单导入
 */

var IMPORT_FRESH_DETAIL = 'purchase.demandPooling.importFreshDemandPoolingDetail';
/**
 * 复杂商品查询
 */

var ADD_GOODS_LIST = 'purchase.product.querySelectPlaceProductByCondition';
/**
 * 地点维度请求
 */

var PLACE_DEMAND_LIST = 'purchase.demandPooling.queryPlaceDemandPoolingDetailList';
/**
 * 商品维度请求
 */

var GOODS_DEMAND_LIST = 'purchase.demandPooling.queryGoodsDemandPoolingDetailList';
/**
 * 清空明细
 */

var CLEAR_GOODS = 'purchase.demandPooling.clearDemandPoolingDetail';
/**
 * 保存地点维度商品
 */

var SAVE_PLACE_GOODS = 'purchase.demandPooling.saveDemandPoolingDetail';
/**
 * 刷新大仓库存
 */

var REFRESH_STOCK = 'purchase.demandPooling.refreshStock';
/**
 * 审核汇总信息
 */

var GOODS_STAT = 'purchase.demandPooling.statPoolingGoodsInfo';
/**
 * 批量更新
 */

var BATCH_MODIFY = 'purchase.demandPooling.batchModifyDetail';
/**
 * 更新
 */

var BATCH_MODIFY_DC = 'purchase.demandPooling.batchModifyDeliveryDc';
/**
 * 获取参考价等
 */

var DEMAND_REFERENCE_PRICE = 'purchase.demandPooling.queryDemandPoolingReferencePrice';
/**
 * 审核
 */

var UPDATE_STATUS = 'purchase.demandPooling.updateDemandPoolingStatus';

/***/ }),

/***/ 49408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fQ": function() { return /* binding */ BussinessType; },
/* harmony export */   "U4": function() { return /* binding */ BatchUpdateType; },
/* harmony export */   "V7": function() { return /* binding */ RouteUrl; },
/* harmony export */   "qp": function() { return /* binding */ CreateCollectionContext; },
/* harmony export */   "WH": function() { return /* binding */ CollectionContext; }
/* harmony export */ });
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26715);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37982);



var BussinessType;

(function (BussinessType) {
  BussinessType[BussinessType["\u751F\u9C9C"] = 0] = "\u751F\u9C9C";
  BussinessType[BussinessType["\u5FEB\u6D88"] = 1] = "\u5FEB\u6D88";
  BussinessType[BussinessType["\u8010\u7528\u54C1"] = 2] = "\u8010\u7528\u54C1";
})(BussinessType || (BussinessType = {}));

var BatchUpdateType;

(function (BatchUpdateType) {
  BatchUpdateType[BatchUpdateType["\u4F9B\u8D27\u8DEF\u5F84"] = 0] = "\u4F9B\u8D27\u8DEF\u5F84";
  BatchUpdateType[BatchUpdateType["\u7D27\u6025\u7A0B\u5EA6"] = 1] = "\u7D27\u6025\u7A0B\u5EA6";
  BatchUpdateType[BatchUpdateType["\u914D\u9001\u4ED3"] = 2] = "\u914D\u9001\u4ED3";
})(BatchUpdateType || (BatchUpdateType = {}));

var RouteUrl;
/**
 * 新增集单上下文
 */

(function (RouteUrl) {
  RouteUrl["\u751F\u9C9C"] = "/CentralManage/FreshSupplement";
  RouteUrl["\u5FEB\u6D88"] = "/CentralManage/QuickSaleSupplement";
  RouteUrl["\u8010\u7528\u54C1"] = "/CentralManage/DurableGoods";
})(RouteUrl || (RouteUrl = {}));

var CreateCollectionContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  bussinessType: BussinessType.快消,
  importUrl: _api__WEBPACK_IMPORTED_MODULE_2__/* .IMPORT_FRESH_DETAIL */ .VT,
  logisticsList: [],
  placeColumns: [],
  goodsColumns: [],
  importLoopRequestType: _config_enums__WEBPACK_IMPORTED_MODULE_0__/* .enumPurchaseImportStatusType["集单耐用品明细"] */ .Pb["集单耐用品明细"],
  templateType: _config_enums__WEBPACK_IMPORTED_MODULE_0__/* .enumPurchaseDownloadType.QUICK_TEMPLATE */ .Zz.QUICK_TEMPLATE,
  getFormDataCallback: undefined
});
var CollectionContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  formData: undefined,
  childPlaceList: []
});

/***/ }),

/***/ 67541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BussinessType": function() { return /* reexport safe */ _config__WEBPACK_IMPORTED_MODULE_9__.fQ; },
/* harmony export */   "CreateCollectionContext": function() { return /* reexport safe */ _config__WEBPACK_IMPORTED_MODULE_9__.qp; }
/* harmony export */ });
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(71577);
/* harmony import */ var antd_es_divider_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48736);
/* harmony import */ var antd_es_divider__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(27049);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(91896);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2824);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(93224);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5977);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46565);
/* harmony import */ var _components_BigTitle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70400);
/* harmony import */ var _components_ComplexTable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51966);
/* harmony import */ var _HandleBtn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25021);
/* harmony import */ var _useFormfields__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59013);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49408);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(37982);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71151);
/* harmony import */ var _components_FixedBottomCps__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(32065);












var _excluded = ["bussinessType", "getFormDataCallback", "goodsColumns", "placeColumns"],
    _excluded2 = ["category"];

/**
 * 新增集单
 */












function CreateCollection() {
  var _history$location$que;

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_config__WEBPACK_IMPORTED_MODULE_9__/* .CreateCollectionContext */ .qp),
      bussinessType = _useContext.bussinessType,
      getFormDataCallback = _useContext.getFormDataCallback,
      goodsColumns = _useContext.goodsColumns,
      placeColumns = _useContext.placeColumns,
      restContext = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useContext, _excluded);

  var history = (0,umi__WEBPACK_IMPORTED_MODULE_13__/* .useHistory */ .k6)();
  var autoFormRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null); // 地点维度的ref

  var placeTableRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null); // 商品维度的ref

  var goodsTableRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null); // 主单信息

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    poolingId: (_history$location$que = history.location.query) === null || _history$location$que === void 0 ? void 0 : _history$location$que.poolingId
  }),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState, 2),
      formData = _useState2[0],
      setFormData = _useState2[1]; // 商家下的地点


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState3, 2),
      childPlaceList = _useState4[0],
      setChildPlaceList = _useState4[1]; // 汇总信息


  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState5, 2),
      statistics = _useState6[0],
      setStatistics = _useState6[1]; // 是否存在已保存的商品\存在商品


  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    exitSavedGoods: false,
    exitGoods: false,
    exitNotSaved: false
  }),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState7, 2),
      goodsStatus = _useState8[0],
      setGoodsStatus = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState9, 2),
      btnLoading = _useState10[0],
      setBtnLoading = _useState10[1]; // 取消请求


  var cancelRequest = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => !(formData !== null && formData !== void 0 && formData.id), [formData === null || formData === void 0 ? void 0 : formData.id]); // 允许提交

  var canCommit = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    return !goodsStatus.exitNotSaved && (formData === null || formData === void 0 ? void 0 : formData.id) && goodsStatus.exitGoods;
  }, [formData === null || formData === void 0 ? void 0 : formData.id, goodsStatus.exitGoods, goodsStatus.exitNotSaved]); // 返回主页的url

  var mainRouteUrl = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    if (bussinessType === _config__WEBPACK_IMPORTED_MODULE_9__/* .BussinessType["快消"] */ .fQ["快消"]) {
      return _config__WEBPACK_IMPORTED_MODULE_9__/* .RouteUrl["快消"] */ .V7["快消"];
    } else if (bussinessType === _config__WEBPACK_IMPORTED_MODULE_9__/* .BussinessType["生鲜"] */ .fQ["生鲜"]) {
      return _config__WEBPACK_IMPORTED_MODULE_9__/* .RouteUrl["生鲜"] */ .V7["生鲜"];
    } else {
      return _config__WEBPACK_IMPORTED_MODULE_9__/* .RouteUrl["耐用品"] */ .V7["耐用品"];
    }
  }, [bussinessType]); // 请求参数

  var searchParams = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    return {
      condition: {
        poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId,
        logistics: formData === null || formData === void 0 ? void 0 : formData.logistics,
        firstCategoryId: formData === null || formData === void 0 ? void 0 : formData.firstCategoryId,
        secondCategoryId: formData === null || formData === void 0 ? void 0 : formData.secondCategoryId,
        merchantId: formData === null || formData === void 0 ? void 0 : formData.merchantId
      }
    };
  }, [formData === null || formData === void 0 ? void 0 : formData.firstCategoryId, formData === null || formData === void 0 ? void 0 : formData.logistics, formData === null || formData === void 0 ? void 0 : formData.merchantId, formData === null || formData === void 0 ? void 0 : formData.poolingId, formData === null || formData === void 0 ? void 0 : formData.secondCategoryId]); // 一级品类默认值

  var initCategory = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    if (bussinessType === _config__WEBPACK_IMPORTED_MODULE_9__/* .BussinessType["生鲜"] */ .fQ["生鲜"]) {
      return {
        first: 10
      };
    } else {
      return {
        first: 20
      };
    }
  }, [bussinessType]); // 表单项内容

  var formfields = (0,_useFormfields__WEBPACK_IMPORTED_MODULE_8__.default)(initCategory, setChildPlaceList, goodsStatus.exitGoods); // 保存主单

  var saveForm = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee(values) {
      var category, rest, categoryData, params, res, _autoFormRef$current, id;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              category = values.category, rest = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(values, _excluded2);
              categoryData = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)({}, initCategory), category ? category : {});
              params = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)({}, rest), {}, {
                firstCategoryId: categoryData === null || categoryData === void 0 ? void 0 : categoryData.first,
                secondCategoryId: categoryData === null || categoryData === void 0 ? void 0 : categoryData.second,
                demandType: 1,
                // 1补货；2退货  现阶段只有正向补货
                poolingDurableType: [_config__WEBPACK_IMPORTED_MODULE_9__/* .BussinessType["快消"] */ .fQ["快消"], _config__WEBPACK_IMPORTED_MODULE_9__/* .BussinessType["生鲜"] */ .fQ["生鲜"]].includes(bussinessType) ? 1 : 3
              });
              _context.next = 5;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_18__/* .CREATE_COLLECTION */ .vC, params);

            case 5:
              res = _context.sent;

              if (res.success) {
                id = res.result.id;
                (_autoFormRef$current = autoFormRef.current) === null || _autoFormRef$current === void 0 ? void 0 : _autoFormRef$current.setFieldsValue({
                  id
                });
                setFormData((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)({}, params), {}, {
                  id
                }));
              }

              return _context.abrupt("return", res.success);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [bussinessType, initCategory]); // 获取汇总信息

  var getApproveSummary = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee2() {
    var condition, res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            condition = {
              poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId,
              logistics: formData === null || formData === void 0 ? void 0 : formData.logistics,
              firstCategoryId: formData === null || formData === void 0 ? void 0 : formData.firstCategoryId,
              secondCategoryId: formData === null || formData === void 0 ? void 0 : formData.secondCategoryId,
              merchantId: formData === null || formData === void 0 ? void 0 : formData.merchantId
            };
            _context2.next = 3;
            return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_18__/* .GOODS_STAT */ .wL, {
              condition
            });

          case 3:
            res = _context2.sent;

            if (res.success) {
              setStatistics(res.result);
            }

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [formData === null || formData === void 0 ? void 0 : formData.firstCategoryId, formData === null || formData === void 0 ? void 0 : formData.logistics, formData === null || formData === void 0 ? void 0 : formData.merchantId, formData === null || formData === void 0 ? void 0 : formData.poolingId, formData === null || formData === void 0 ? void 0 : formData.secondCategoryId]); // 地点维度列表数据变化后会触发

  var placeDataChangeCallback = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(data => {
    setGoodsStatus(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)({}, v), {}, {
      exitSavedGoods: data === null || data === void 0 ? void 0 : data.some(v => !!v.id),
      exitNotSaved: !(data !== null && data !== void 0 && data.every(v => !!v.id))
    }));
  }, []); // 商品数据变化

  var goodsDataChangeCallback = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(data => {
    setGoodsStatus(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)({}, v), {}, {
      exitGoods: !!(data !== null && data !== void 0 && data.length)
    }));
  }, []); // 刷新列表项

  var afterHandleCallback = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    var _goodsTableRef$curren, _placeTableRef$curren;

    getApproveSummary();
    (_goodsTableRef$curren = goodsTableRef.current) === null || _goodsTableRef$curren === void 0 ? void 0 : _goodsTableRef$curren.reload();
    (_placeTableRef$curren = placeTableRef.current) === null || _placeTableRef$curren === void 0 ? void 0 : _placeTableRef$curren.reload();
  }, [getApproveSummary]);
  var submitOrder = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee3() {
    var _yield$YpRequest, success;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            setBtnLoading(true);
            _context3.next = 3;
            return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_18__/* .UPDATE_STATUS */ .g$, {
              poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId,
              operateType: _utils__WEBPACK_IMPORTED_MODULE_10__/* .APPROVE_STATUS_OPT["审核通过"] */ .l["审核通过"]
            });

          case 3:
            _yield$YpRequest = _context3.sent;
            success = _yield$YpRequest.success;
            setBtnLoading(false);

            if (success) {
              antd_es_message__WEBPACK_IMPORTED_MODULE_19__.default.success('审核成功');

              history.push(mainRouteUrl);
            }

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [formData === null || formData === void 0 ? void 0 : formData.poolingId, history, mainRouteUrl]); // 获取单号

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    var _history$location$que2;

    if ((_history$location$que2 = history.location.query) !== null && _history$location$que2 !== void 0 && _history$location$que2.poolingId) {
      return;
    }

    (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .YpRequest */ .XQ)('purchase.order.getOrderIdByBizType', {
      bizType: 15
    }).then(res => {
      if (res.success && res.result.orderId) {
        var _autoFormRef$current2, _history$location$que3;

        history.push({
          pathname: history.location.pathname,
          query: {
            poolingId: res.result.orderId
          }
        }); // 设置单号默认值

        (_autoFormRef$current2 = autoFormRef.current) === null || _autoFormRef$current2 === void 0 ? void 0 : _autoFormRef$current2.setFieldsValue({
          poolingId: (_history$location$que3 = history.location.query) === null || _history$location$que3 === void 0 ? void 0 : _history$location$que3.poolingId
        });
      }
    });
  }, [history]); // 汇总

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (!(formData !== null && formData !== void 0 && formData.id)) {
      return;
    }

    getApproveSummary();
  }, [formData === null || formData === void 0 ? void 0 : formData.id, getApproveSummary]);
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (formData !== null && formData !== void 0 && formData.id && getFormDataCallback) {
      getFormDataCallback(formData);
    }
  }, [formData, formData === null || formData === void 0 ? void 0 : formData.id, getFormDataCallback]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .WrapperLayout.WrapperLayout */ .p8.WrapperLayout, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .WrapperLayout.WrapperContent */ .p8.WrapperContent, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_config__WEBPACK_IMPORTED_MODULE_9__/* .CollectionContext.Provider */ .WH.Provider, {
    value: {
      childPlaceList,
      formData
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_BigTitle__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    title: "\u57FA\u672C\u4FE1\u606F"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .AutoSaveForm */ .uC, {
    autoFormRef: autoFormRef,
    saveFormCallback: saveForm,
    elements: formfields
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_BigTitle__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    title: "\u5546\u54C1\u4FE1\u606F"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_HandleBtn__WEBPACK_IMPORTED_MODULE_7__.default, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)({}, restContext, {
    formData: formData,
    bussinessType: bussinessType,
    exitSavedGoods: goodsStatus.exitSavedGoods,
    exitGoods: goodsStatus.exitGoods,
    afterHandleCallback: afterHandleCallback
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
    className: "flex-fill text-right pt-1"
  }, bussinessType === _config__WEBPACK_IMPORTED_MODULE_9__/* .BussinessType["耐用品"] */ .fQ["耐用品"] && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
    style: {
      color: 'red'
    }
  }, "\u5546\u54C1\u5F02\u5E38 ", statistics === null || statistics === void 0 ? void 0 : statistics.abnormalGoodsCount), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_divider__WEBPACK_IMPORTED_MODULE_21__/* .default */ .Z, {
    type: "vertical"
  })), "\u4F9B\u5E94\u5546\u4E2A\u6570 ", statistics === null || statistics === void 0 ? void 0 : statistics.supplierCount, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_divider__WEBPACK_IMPORTED_MODULE_21__/* .default */ .Z, {
    type: "vertical"
  }), "\u79CD\u7C7B ", statistics === null || statistics === void 0 ? void 0 : statistics.skuNum, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_divider__WEBPACK_IMPORTED_MODULE_21__/* .default */ .Z, {
    type: "vertical"
  }), "\u7533\u8BF7\u603B\u6570 ", statistics === null || statistics === void 0 ? void 0 : statistics.totalApplyNum, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_divider__WEBPACK_IMPORTED_MODULE_21__/* .default */ .Z, {
    type: "vertical"
  }), "\u5BA1\u6838\u603B\u6570 ", statistics === null || statistics === void 0 ? void 0 : statistics.totalApproveNum), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_ComplexTable__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    goodsTableRef: goodsTableRef,
    formSearchData: searchParams.condition,
    placeTableRef: placeTableRef,
    bussinessType: _config__WEBPACK_IMPORTED_MODULE_9__/* .BussinessType["耐用品"] */ .fQ["耐用品"],
    queryApporeSummaryCallback: getApproveSummary,
    hideAddStoreBtn: true,
    goods: {
      columns: goodsColumns,
      cancelRequest,
      dataSourceChangeCallback: goodsDataChangeCallback
    },
    place: {
      columns: placeColumns,
      dataSourceChangeCallback: placeDataChangeCallback
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_FixedBottomCps__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z, {
    outerRE: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_22__/* .default */ .Z, {
      type: "primary",
      className: "mRight16",
      loading: btnLoading,
      disabled: !canCommit,
      onClick: submitOrder
    }, "\u63D0\u4EA4\u5E76\u5BA1\u6838"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_22__/* .default */ .Z, {
      onClick: () => history.push(mainRouteUrl)
    }, "\u4FDD\u5B58\u5E76\u8FD4\u56DE"))
  }))));
}


/* harmony default export */ __webpack_exports__["default"] = (CreateCollection);

/***/ }),

/***/ 30703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2824);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46565);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71151);









function useExtData(firstCategoryId, merchantId, goodsId) {
  // 额外参数
  var queryDemandPoolingExt = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee(data) {
      var params, res, extList;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = {
                needSupplier: true,
                needPlaceStock: true,
                needSale: true,
                needDc: true,
                param: data.map(item => ({
                  placeId: item.placeId,
                  goodsId: goodsId ? goodsId : item.goodsId,
                  merchantId: merchantId ? merchantId : item.merchantId,
                  firstCategoryId: firstCategoryId ? firstCategoryId : item.firstCategoryId,
                  secondCategoryId: item.secondCategoryId
                }))
              };
              _context.next = 3;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .YpRequest */ .XQ)('purchase.product.queryProductExtInfo', params);

            case 3:
              res = _context.sent;
              extList = res.result.list || [];
              return _context.abrupt("return", (0,lodash__WEBPACK_IMPORTED_MODULE_1__.keyBy)(extList, o => "".concat(o.goodsId, "-").concat(o.placeId)));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []); // 获取参考价

  var queryDemandReferencePrice = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee2(data) {
      var params, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = {
                orderDirect: _utils__WEBPACK_IMPORTED_MODULE_3__/* .DEMAND_TYPE.SUUPLEMENT */ .fb.SUUPLEMENT,
                // 订单方向
                firstCategoryId,
                // 一级类目ID
                merchantId,
                // 商家ID
                goodsList: data.map(item => ({
                  goodsId: item.goodsId,
                  // 商品 id
                  logistics: item.logistics,
                  // 物流模式
                  placeId: item.placeId,
                  // 地点ID
                  deliveryDcId: item.deliveryDcId // 大仓ID

                }))
              };
              _context2.next = 3;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .YpRequest */ .XQ)('purchase.demandPooling.queryDemandPoolingReferencePrice', params);

            case 3:
              res = _context2.sent;
              return _context2.abrupt("return", (0,lodash__WEBPACK_IMPORTED_MODULE_1__.keyBy)(res.result.list, o => "".concat(o.goodsId, "-").concat(o.placeId)));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [firstCategoryId, merchantId]); // 拼接额外的参数

  var concatExtData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)( /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee3(data) {
      var _yield$Promise$allSet, _yield$Promise$allSet2, extObj, referObj, fir, sec;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (data.length) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", data);

            case 2:
              _context3.next = 4;
              return Promise.allSettled([queryDemandPoolingExt(data), queryDemandReferencePrice(data)]);

            case 4:
              _yield$Promise$allSet = _context3.sent;
              _yield$Promise$allSet2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_yield$Promise$allSet, 2);
              extObj = _yield$Promise$allSet2[0];
              referObj = _yield$Promise$allSet2[1];
              fir = extObj.status === 'fulfilled';
              sec = referObj.status === 'fulfilled';
              return _context3.abrupt("return", data.map(v => {
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({}, v), fir ? extObj.value["".concat(v.goodsId, "-").concat(v.placeId)] : {}), sec ? referObj.value["".concat(v.goodsId, "-").concat(v.placeId)] : {}), {}, {
                  deliveryDcId: v.deliveryDcId,
                  dcStock: v.dcStock,
                  emergLevel: Number(v.emergLevel) === 0 ? 1 : v.emergLevel // 紧急程度如果是0 默认赋值 正常

                });
              }));

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }(), [queryDemandPoolingExt, queryDemandReferencePrice]);
  return concatExtData;
}

/* harmony default export */ __webpack_exports__["Z"] = (useExtData);

/***/ }),

/***/ 59013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_FormCategorySelect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45199);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7704);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49408);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5977);






function useFormfields(initCategory, setChildPlaceList, disabled) {
  var location = (0,umi__WEBPACK_IMPORTED_MODULE_4__/* .useLocation */ .TH)();

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_config__WEBPACK_IMPORTED_MODULE_3__/* .CreateCollectionContext */ .qp),
      bussinessType = _useContext.bussinessType,
      logisticsList = _useContext.logisticsList;

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)([_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["所有品类"] */ .M["所有品类"], _hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["权限下的商家"] */ .M["权限下的商家"]]),
      mappingList = _useMapping.mappingList; // 当前是否为生鲜新增项


  var isFresh = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => bussinessType === _config__WEBPACK_IMPORTED_MODULE_3__/* .BussinessType["生鲜"] */ .fQ["生鲜"], [bussinessType]); // 耐用品

  var isDurable = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => bussinessType === _config__WEBPACK_IMPORTED_MODULE_3__/* .BussinessType["耐用品"] */ .fQ["耐用品"], [bussinessType]);
  var categoryList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (!mappingList.has(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["所有品类"] */ .M["所有品类"])) {
      return [];
    }

    if (isFresh) {
      return mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["所有品类"] */ .M["所有品类"]);
    } else {
      return mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["所有品类"] */ .M["所有品类"]).filter(v => v.value !== 10);
    }
  }, [isFresh, mappingList]); // 获取商户下的地点数据

  var changeMerchant = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((v, o) => {
    var _o$others;

    var placeList = ((_o$others = o.others) === null || _o$others === void 0 ? void 0 : _o$others.placeVos) || [];
    var list = placeList.map(i => {
      return {
        label: "".concat(i.placeCode, "-").concat(i.placeName),
        value: i.placeId,
        others: i
      };
    });
    setChildPlaceList(list || []); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return [{
    label: 'id',
    name: 'id',
    type: 'INPUT',
    hide: true
  }, {
    label: isDurable ? '耐用品集单号' : '补货集单号',
    name: 'poolingId',
    type: 'INPUT',
    initialValue: location === null || location === void 0 ? void 0 : location.query.poolingId,
    fieldOptions: {
      disabled: true
    }
  }, !isDurable && {
    label: '物流模式',
    name: 'logistics',
    type: 'SELECT',
    dataList: logisticsList,
    required: true,
    fieldOptions: {
      disabled
    }
  }, {
    label: '商家',
    name: 'merchantId',
    type: 'SELECT',
    required: true,
    dataList: mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["权限下的商家"] */ .M["权限下的商家"]) || [],
    fieldOptions: {
      disabled,
      onChange: changeMerchant
    }
  }, {
    label: '品类',
    name: 'category',
    required: isFresh,
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_FormCategorySelect__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z, {
      categoryList: categoryList,
      formValue: initCategory,
      firstProps: {
        disabled: isFresh || disabled
      },
      secondProps: {
        disabled
      }
    })
  }].filter(Boolean);
}

/* harmony default export */ __webpack_exports__["default"] = (useFormfields);

/***/ }),

/***/ 27731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vl": function() { return /* binding */ DURABLE_LIST; },
/* harmony export */   "B6": function() { return /* binding */ SUBMIT_DURABLE; },
/* harmony export */   "QN": function() { return /* binding */ DURABLE_PLACE; },
/* harmony export */   "rJ": function() { return /* binding */ DURABLE_MERCHANT; },
/* harmony export */   "Fb": function() { return /* binding */ DURABLE_EXPORT; },
/* harmony export */   "r3": function() { return /* binding */ DURABLE_PICK_STAT; },
/* harmony export */   "p1": function() { return /* binding */ DURABLE_REFRESH_ERROR; },
/* harmony export */   "Np": function() { return /* binding */ DURABLE_REFRESH_LOOP; },
/* harmony export */   "Bw": function() { return /* binding */ DURABLE_IMPORT_DETAIL; },
/* harmony export */   "$D": function() { return /* binding */ DURABLE_BATCH_UPDATE; },
/* harmony export */   "fR": function() { return /* binding */ DURABLE_CANCEL; }
/* harmony export */ });
/* unused harmony export GET_UPLOAD_TOKEN */
/**
 * 耐用品集单列表
 */
var DURABLE_LIST = 'purchase.demandPooling.listDurableDemandPooling';
/**
 * 耐用品提取数据
 */

var SUBMIT_DURABLE = 'purchase.demandPooling.extractDurableDemandPooling';
/**
 * 耐用品集单提取数据-地点商品维度查询
 */

var DURABLE_PLACE = 'purchase.demandPooling.pagePlaceDurableDemandPoolingDetail';
/**
 * 耐用品集单提取数据-商品维度查询
 */

var DURABLE_MERCHANT = 'purchase.demandPooling.pageGoodsDurableDemandPoolingDetail';
/**
 * 导出耐用品集单
 */

var DURABLE_EXPORT = 'purchase.demandPooling.exportDurablePoolingGoods';
/**
 * 耐用品集单提取数据统计
 */

var DURABLE_PICK_STAT = 'purchase.demandPooling.statDurableDemandPoolingDetail';
/**
 * 刷新耐用品异常明细
 */

var DURABLE_REFRESH_ERROR = 'purchase.demandPooling.refreshDurableAbnormalGoods';
/**
 * 查询异常刷新结果
 */

var DURABLE_REFRESH_LOOP = 'purchase.demandPooling.refreshDurableAbnormalGoodsResult';
/**
 * 集单明细导入
 */

var DURABLE_IMPORT_DETAIL = 'purchase.demandPooling.importPoolingDetail';
/**
 * 批量更新
 */

var DURABLE_BATCH_UPDATE = 'purchase.demandPooling.batchModifyPoolingDetail';
/**
 * 集单取消
 */

var DURABLE_CANCEL = 'purchase.demandPooling.cancelDemandPooling';
/**
 * 获取token
 */

var GET_UPLOAD_TOKEN = 'purchase.resource.getResourceToken';

/***/ }),

/***/ 44973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1870);





function useGoodsColumns() {
  return [{
    title: '商品名称',
    dataIndex: 'goodsName',
    fixed: 'left',
    width: 200,
    sorter: true
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    sorter: true,
    width: 110
  }, {
    title: '商品条码',
    dataIndex: 'barCode',
    sorter: true,
    width: 140
  }, {
    title: '类目',
    dataIndex: 'secondCategoryId',
    width: 140,
    render: (_, record) => record.secondCategoryName ? "".concat(record.firstCategoryName, "/").concat(record.secondCategoryName) : record.firstCategoryName,
    sorter: true
  }, {
    title: '规格',
    dataIndex: 'specification',
    width: 90
  }, {
    title: '单位',
    dataIndex: 'specificationUnit',
    width: 90
  }, {
    title: '物流模式',
    dataIndex: 'logisticsName',
    width: 80
  }, {
    title: '总申请数量',
    dataIndex: 'totalDemandNum',
    width: 110,
    sorter: true
  }, {
    title: '审批数量',
    width: 110,
    dataIndex: 'totalApproveNum',
    sorter: true
  }, {
    title: '满足率%',
    dataIndex: 'satisfactionRate',
    width: 100,
    render: (txt, record) => {
      if (+record.totalDemandNum === 0) {
        return '100%';
      }

      var rate = +record.totalApproveNum / +record.totalDemandNum * 100;
      return isNaN(rate) ? '' : "".concat(rate.toFixed(1), "%");
    }
  }, {
    title: '门店数',
    dataIndex: 'placeNum',
    sorter: true,
    width: 90
  }, {
    title: '大仓库存',
    width: 120,
    dataIndex: 'dcStock',
    sorter: true
  }, {
    title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
      placement: "top",
      title: "\u8D1F\u6570\u4EE3\u8868\u5927\u4ED3\u7F3A\u8D27\uFF0C\u6B63\u6570\u4EE3\u8868\u5927\u4ED3\u6EE1\u8DB3\u9700\u6C42\u540E\u5269\u4F59\u5E93\u5B58"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "cursor-pointer"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
      className: "mr-1"
    }, "\u5DEE\u5F02\u91CF"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, null))),
    dataIndex: 'diffQty',
    sorter: true,
    width: 100
  }];
}

/* harmony default export */ __webpack_exports__["default"] = (useGoodsColumns);

/***/ }),

/***/ 60597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1870);





function useGoodsColumns() {
  var columns = [{
    title: '商品名称',
    dataIndex: 'goodsName',
    fixed: 'left',
    width: 120,
    sorter: true
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    sorter: true,
    width: 100
  }, {
    title: '单位',
    dataIndex: 'specificationUnit',
    width: 70
  }, {
    title: '总申请数量',
    dataIndex: 'totalDemandNum',
    width: 100,
    sorter: true
  }, {
    title: '总审批数量',
    width: 100,
    dataIndex: 'totalApproveNum',
    sorter: true
  }, {
    title: '总金额',
    width: 100,
    dataIndex: 'totalReferencePrice',
    sorter: true
  }, {
    title: '门店预购量',
    dataIndex: 'storeRegularOrderQty',
    width: 100
  }, {
    title: '门店加单量',
    dataIndex: 'storeAdditionalQty',
    width: 100
  }, {
    title: '满足率%',
    dataIndex: 'satisfactionRate',
    width: 100,
    render: (txt, record) => {
      if (+record.totalDemandNum === 0) {
        return '100%';
      }

      var rate = +record.totalApproveNum / +record.totalDemandNum * 100;
      return isNaN(rate) ? '' : "".concat(rate.toFixed(1), "%");
    }
  }, {
    title: '门店数',
    dataIndex: 'placeNum',
    sorter: true,
    width: 90
  }, {
    title: '商品条码',
    dataIndex: 'barCode',
    sorter: true,
    width: 120
  }, {
    title: '物流模式',
    dataIndex: 'logisticsName',
    width: 80
  }, {
    title: '大仓库存',
    width: 100,
    dataIndex: 'dcStock',
    sorter: true
  }, {
    title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
      placement: "top",
      title: "\u8D1F\u6570\u4EE3\u8868\u5927\u4ED3\u7F3A\u8D27\uFF0C\u6B63\u6570\u4EE3\u8868\u5927\u4ED3\u6EE1\u8DB3\u9700\u6C42\u540E\u5269\u4F59\u5E93\u5B58"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "cursor-pointer"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
      className: "mr-1"
    }, "\u5DEE\u5F02\u91CF"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, null))),
    dataIndex: 'diffQty',
    sorter: true,
    width: 100
  }];
  return columns;
}

/* harmony default export */ __webpack_exports__["default"] = (useGoodsColumns);

/***/ }),

/***/ 36231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Create_usePlaceColumns; }
});

// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(5977);
// EXTERNAL MODULE: ./src/pages/CentralManage/utils.ts
var utils = __webpack_require__(71151);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(93224);
// EXTERNAL MODULE: ./node_modules/yp-frontend-library/esm/index.js + 77 modules
var esm = __webpack_require__(46565);
;// CONCATENATED MODULE: ./src/pages/CentralManage/CreateCollection/useSlicedMeat.ts




var _excluded = ["bomWithProduct"];

/* eslint-disable max-nested-callbacks */

/**
 * 获取膘厚、重量参数
 */



function useSlicedMeat() {
  var querySlicedMeat = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(condition) {
      var res, data, list;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,esm/* YpRequest */.XQ)('purchase.product.queryMerchantProductSlicedMeat', {
                condition
              });

            case 2:
              res = _context.sent;

              if (res.success) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              data = res.result || [];
              list = data.map(v => {
                var bomWithProduct = v.bomWithProduct,
                    rest = (0,objectWithoutProperties/* default */.Z)(v, _excluded);

                var obj = bomWithProduct.reduce((pre, next) => {
                  var fat = {
                    value: next.fatness,
                    label: next.fatness
                  };
                  var weight = {
                    value: next.referneceWeight,
                    label: next.referneceWeight
                  };
                  var fatnessList = pre.fatnessList.some(v => v.value === next.fatness) ? pre.fatnessList : pre.fatnessList.concat(fat);
                  var referneceWeightList = pre.referneceWeightList.some(v => v.value === next.referneceWeight) ? pre.referneceWeightList : pre.referneceWeightList.concat(weight); // 存在膘厚,则判断该膘厚下是否已存在重量参数，做出对应的操作

                  var curFatnessMap = pre.fatnessMap[next.fatness] ? pre.fatnessMap[next.fatness].some(v => v.value === next.referneceWeight) ? pre.fatnessMap[next.fatness] : pre.fatnessMap[next.fatness].concat(weight) : [weight]; // 同上

                  var curWeightMap = pre.referneceWeightMap[next.referneceWeight] ? pre.referneceWeightMap[next.referneceWeight].some(v => v.value === next.fatness) ? pre.referneceWeightMap[next.referneceWeight] : pre.referneceWeightMap[next.referneceWeight].concat(fat) : [fat];
                  return {
                    fatnessList,
                    referneceWeightList,
                    fatnessMap: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, pre.fatnessMap), {}, {
                      [next.fatness]: curFatnessMap
                    }),
                    referneceWeightMap: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, pre.referneceWeightMap), {}, {
                      [next.referneceWeight]: curWeightMap
                    })
                  };
                }, {
                  fatnessList: [],
                  referneceWeightList: [],
                  fatnessMap: {},
                  referneceWeightMap: {}
                });
                return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, rest), obj);
              });
              return _context.abrupt("return", list);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  return querySlicedMeat;
}

/* harmony default export */ var CreateCollection_useSlicedMeat = (useSlicedMeat);
;// CONCATENATED MODULE: ./src/pages/CentralManage/FreshSupplement/Create/usePlaceColumns.tsx









function usePlaceColumns(_ref) {
  var logisticsList = _ref.logisticsList;

  var _useLocation = (0,react_router/* useLocation */.TH)(),
      query = _useLocation.query;

  var editable = query.fn !== utils/* FUNC.VIEW */.O6.VIEW; // 膘厚、白条重量参数数据

  var _useState = (0,react.useState)(),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      meatData = _useState2[0],
      setMeatData = _useState2[1];

  var querySlicedMeat = CreateCollection_useSlicedMeat(); // 膘厚

  var visibleChange = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(v, r) {
      var data;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (v) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              setMeatData(undefined);
              _context.next = 5;
              return querySlicedMeat([{
                merchantId: r.merchantId,
                goodsId: r.goodsId
              }]);

            case 5:
              data = _context.sent;

              if (data && data.length) {
                setMeatData(data[0]);
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [querySlicedMeat]);
  var columns = [// {
  //   title: '商品名称',
  //   dataIndex: 'goodsName',
  //   fixed: 'left',
  //   width: 160,
  //   sorter: true
  // },
  // {
  //   title: '商品条码',
  //   dataIndex: 'barCode',
  //   sorter: true,
  //   width: 140
  // },
  // {
  //   title: '商品编码',
  //   dataIndex: 'goodsId',
  //   sorter: true,
  //   width: 100
  // },
  {
    title: '门店编码',
    dataIndex: 'placeCode',
    width: 100,
    fixed: 'left',
    sorter: true
  }, {
    title: '门店名称',
    dataIndex: 'placeName',
    fixed: 'left',
    width: 120
  }, {
    title: '单位',
    dataIndex: 'specificationUnit',
    width: 70
  }, {
    title: '规格',
    dataIndex: 'orderStepSize',
    width: 70
  }, {
    title: '申请数量',
    dataIndex: 'demandNum',
    width: 100,
    sorter: true,
    type: r => !r.id ? 'INPUT' : undefined,
    render: (node, r) => /*#__PURE__*/react.createElement("div", {
      className: "d-flex"
    }, node, "\xA0", r.barCodeUnit)
  }, {
    title: '审核数量',
    dataIndex: 'approveNum',
    width: 100,
    sorter: true,
    type: editable ? 'INPUT' : undefined,
    render: (node, r) => /*#__PURE__*/react.createElement("div", {
      className: "d-flex"
    }, node, "\xA0", r.barCodeUnit)
  }, {
    title: '总金额',
    width: 100,
    dataIndex: 'totalReferencePrice',
    sorter: true
  }, {
    title: '门店预购量',
    dataIndex: 'storeRegularOrderQty',
    width: 100
  }, {
    title: '门店加单量',
    dataIndex: 'storeAdditionalQty',
    width: 100
  }, {
    title: '昨销',
    dataIndex: 'yestDaySaleCount',
    width: 70
  }, {
    title: '近7日销量',
    dataIndex: 'last7DaySaleCount',
    width: 100
  }, {
    title: '当前库存',
    dataIndex: 'stock',
    width: 100
  }, {
    title: '供应商名称',
    dataIndex: 'supplierName',
    type: r => r.logistics === utils/* LOGISTICE_MODE.配送 */.xT["配送"] || !editable ? undefined : 'SELECT',
    width: 140,
    dataList: r => {
      if (r.supplier && Array.isArray(r.supplier)) {
        return r.supplier.map(v => ({
          value: v.supplierCode,
          label: v.supplierName
        }));
      } else {
        return [{
          value: r.supplierCode,
          label: r.supplierName
        }];
      }
    },
    sorter: true,
    setCellRowValue: (r, o) => {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, r), {}, {
        supplierCode: o.value
      });
    }
  }, {
    title: '供应商编码',
    dataIndex: 'supplierCode',
    sorter: true,
    width: 110
  }, {
    title: '参考采购价(元)',
    dataIndex: 'purchaseReferencePrice',
    width: 110
  }, {
    title: '采购价(元)',
    dataIndex: 'unitPrice',
    width: 100,
    type: r => ![utils/* LOGISTICE_MODE.直送 */.xT["直送"], utils/* LOGISTICE_MODE.直通 */.xT["直通"]].includes(r.logistics) || !editable ? undefined : 'INPUT'
  }, {
    title: '配送价(元)',
    // 成本价
    dataIndex: 'transferReferencePrice',
    width: 100
  }, {
    title: '指定到店价(含运费)',
    dataIndex: 'unitCostPrice',
    width: 150
  }, {
    title: '大仓',
    dataIndex: editable ? 'deliveryDcId' : 'deliveryDcName',
    type: editable ? 'SELECT' : undefined,
    dataList: r => Array.isArray(r.dc) && r.dc.length ? r.dc.map(e => ({
      label: e.deliveryDcName,
      value: e.deliveryDcId
    })) : [{
      label: r.deliveryDcName,
      value: r.deliveryDcId,
      others: {
        deliveryDcCode: r.deliveryDcCode,
        deliveryDcId: r.deliveryDcId,
        deliveryDcName: r.deliveryDcName
      }
    }],
    render: (node, record) => record.logistics === utils/* LOGISTICE_MODE.直送 */.xT["直送"] ? '-' : node,
    // 直送不展示
    width: 140
  }, {
    title: '物流模式',
    dataIndex: editable ? 'logistics' : 'logisticsName',
    // 注意：商品给的是 logistic，采购给的是 logistics。在添加门店层逻辑中磨平
    width: 100,
    dataList: logisticsList,
    type: editable ? 'SELECT' : undefined,
    sorter: true
  }, {
    title: '大仓库存',
    dataIndex: 'dcStock',
    width: 100
  }, {
    title: '满足率%',
    dataIndex: 'satisfactionRate',
    width: 100,
    // （审核数量/申请数量）*100=结果（保留1为小数）
    render: (txt, record) => {
      if (+record.demandNum === 0) {
        return '100%';
      }

      var rate = +record.approveNum / +record.demandNum * 100;
      return isNaN(rate) ? '' : "".concat(rate.toFixed(1), "%");
    }
  }, {
    title: '当前在途',
    dataIndex: 'onOrderStock',
    width: 100
  }, {
    title: '失败原因',
    dataIndex: 'errorMsg',
    width: 130,
    render: txt => /*#__PURE__*/react.createElement("span", {
      style: {
        color: 'red'
      }
    }, txt),
    sorter: true
  }];
  return columns;
}

/* harmony default export */ var Create_usePlaceColumns = (usePlaceColumns);

/***/ }),

/***/ 46344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1870);





function useGoodsColumns() {
  return [{
    title: '商品名称',
    dataIndex: 'goodsName',
    fixed: 'left',
    width: 200,
    sorter: true
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    sorter: true,
    width: 110
  }, {
    title: '商品条码',
    dataIndex: 'barCode',
    sorter: true,
    width: 140
  }, {
    title: '类目',
    dataIndex: 'secondCategoryId',
    width: 140,
    render: (_, record) => record.secondCategoryName ? "".concat(record.firstCategoryName, "/").concat(record.secondCategoryName) : record.firstCategoryName,
    sorter: true
  }, {
    title: '规格',
    dataIndex: 'specification',
    width: 90
  }, {
    title: '单位',
    dataIndex: 'specificationUnit',
    width: 90
  }, {
    title: '物流模式',
    dataIndex: 'logisticsName',
    width: 80
  }, {
    title: '申请数量',
    dataIndex: 'totalDemandNum',
    width: 110,
    sorter: true
  }, {
    title: '审批数量',
    width: 110,
    dataIndex: 'totalApproveNum',
    sorter: true
  }, {
    title: '满足率%',
    dataIndex: 'satisfactionRate',
    width: 100,
    render: (txt, record) => {
      if (+record.totalDemandNum === 0) {
        return '100%';
      }

      var rate = +record.totalApproveNum / +record.totalDemandNum * 100;
      return isNaN(rate) ? '' : "".concat(rate.toFixed(1), "%");
    }
  }, {
    title: '门店数',
    dataIndex: 'placeNum',
    sorter: true,
    width: 90
  }, {
    title: '大仓库存',
    width: 120,
    dataIndex: 'dcStock',
    sorter: true
  }, {
    title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
      placement: "top",
      title: "\u8D1F\u6570\u4EE3\u8868\u5927\u4ED3\u7F3A\u8D27\uFF0C\u6B63\u6570\u4EE3\u8868\u5927\u4ED3\u6EE1\u8DB3\u9700\u6C42\u540E\u5269\u4F59\u5E93\u5B58"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "cursor-pointer"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
      className: "mr-1"
    }, "\u5DEE\u5F02\u91CF"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, null))),
    dataIndex: 'diffQty',
    sorter: true,
    width: 100
  }];
}

/* harmony default export */ __webpack_exports__["default"] = (useGoodsColumns);

/***/ }),

/***/ 82990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8870);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5977);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71151);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7704);






function usePlaceColumns(logistics) {
  var _useLocation = (0,umi__WEBPACK_IMPORTED_MODULE_3__/* .useLocation */ .TH)(),
      query = _useLocation.query;

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)([_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["紧急程度"] */ .M["紧急程度"]]),
      mappingList = _useMapping.mappingList;

  var editable = query.fn !== _utils__WEBPACK_IMPORTED_MODULE_1__/* .FUNC.VIEW */ .O6.VIEW;
  return [// {
  //   title: '商品名称',
  //   dataIndex: 'goodsName',
  //   fixed: 'left',
  //   width: 160,
  //   sorter: true
  // },
  // {
  //   title: '商品条码',
  //   dataIndex: 'barCode',
  //   sorter: true,
  //   width: 140
  // },
  // {
  //   title: '商品编码',
  //   dataIndex: 'goodsId',
  //   sorter: true,
  //   width: 100
  // },
  {
    title: '地点编码',
    dataIndex: 'placeCode',
    width: 100,
    fixed: 'left',
    sorter: true
  }, {
    title: '地点名称',
    dataIndex: 'placeName',
    fixed: 'left',
    width: 160
  }, {
    title: '类目',
    dataIndex: 'secondCategoryId',
    width: 130,
    render: (_, record) => record.secondCategoryName ? "".concat(record.firstCategoryName, "/").concat(record.secondCategoryName) : record.firstCategoryName,
    sorter: true
  }, {
    title: '单位',
    dataIndex: 'specificationUnit',
    width: 80
  }, {
    title: '参考采购价(元)',
    dataIndex: 'purchaseReferencePrice',
    hide: ![_utils__WEBPACK_IMPORTED_MODULE_1__/* .LOGISTICE_MODE["直送"] */ .xT["直送"], _utils__WEBPACK_IMPORTED_MODULE_1__/* .LOGISTICE_MODE["直通"] */ .xT["直通"]].includes(Number(logistics)),
    width: 120
  }, {
    title: '采购价(元)',
    dataIndex: 'unitPrice',
    width: 100,
    hide: ![_utils__WEBPACK_IMPORTED_MODULE_1__/* .LOGISTICE_MODE["直送"] */ .xT["直送"]
    /* LOGISTICE_MODE.直通 */
    ].includes(Number(logistics)),
    type: r => ![_utils__WEBPACK_IMPORTED_MODULE_1__/* .LOGISTICE_MODE["直送"] */ .xT["直送"]].includes(r.logistics) || !editable ? undefined : 'INPUT'
  }, {
    title: '配送价(元)',
    // 成本价
    dataIndex: 'transferReferencePrice',
    hide: ![_utils__WEBPACK_IMPORTED_MODULE_1__/* .LOGISTICE_MODE["配送"] */ .xT["配送"]].includes(Number(logistics)),
    width: 100
  }, {
    title: '大仓',
    dataIndex: editable ? 'deliveryDcId' : 'deliveryDcName',
    type: editable ? 'SELECT' : undefined,
    dataList: r => Array.isArray(r.dc) && r.dc.length ? r.dc.map(e => ({
      label: e.deliveryDcName,
      value: e.deliveryDcId
    })) : [{
      label: r.deliveryDcName,
      value: r.deliveryDcId,
      raw: {
        deliveryDcCode: r.deliveryDcCode,
        deliveryDcId: r.deliveryDcId,
        deliveryDcName: r.deliveryDcName
      }
    }],
    render: (node, record) => record.logistics === _utils__WEBPACK_IMPORTED_MODULE_1__/* .LOGISTICE_MODE["直送"] */ .xT["直送"] ? '-' : node,
    // 直送不展示
    width: 180
  }, {
    title: '大仓库存',
    dataIndex: 'dcStock',
    width: 110
  }, {
    title: '物流模式',
    dataIndex: 'logisticsName',
    // 注意：商品给的是 logistic，采购给的是 logistics。在添加门店层逻辑中磨平
    width: 120,
    sorter: true
  }, {
    title: '步长',
    dataIndex: 'orderStepSize',
    width: 80
  }, {
    title: '建议补货量',
    dataIndex: 'goodsReqQty',
    width: 80
  }, {
    title: 'DMS',
    dataIndex: 'dmsQty',
    width: 80
  }, {
    title: '申请数量',
    dataIndex: 'demandNum',
    width: 100,
    sorter: true,
    type: r => !r.id && editable ? 'INPUT' : undefined,
    render: (node, r) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "d-flex"
    }, node, "\xA0", r.barCodeUnit)
  }, {
    title: '审核数量',
    dataIndex: 'approveNum',
    width: 100,
    sorter: true,
    type: editable ? 'INPUT' : undefined,
    render: (node, r) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "d-flex"
    }, node, "\xA0", r.barCodeUnit)
  }, {
    title: '供应商名称',
    dataIndex: 'supplierName',
    type: r => r.logistics === _utils__WEBPACK_IMPORTED_MODULE_1__/* .LOGISTICE_MODE["配送"] */ .xT["配送"] || !editable ? undefined : 'SELECT',
    width: 180,
    dataList: r => {
      if (r.supplier && Array.isArray(r.supplier)) {
        return r.supplier.map(v => ({
          value: v.supplierCode,
          label: v.supplierName
        }));
      } else {
        return [{
          value: r.supplierCode,
          label: r.supplierName
        }];
      }
    },
    setCellRowValue: (r, o) => {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)({}, r), {}, {
        supplierCode: o.value
      });
    },
    sorter: true
  }, {
    title: '供应商编码',
    dataIndex: 'supplierCode',
    sorter: true,
    width: 120
  }, {
    title: '紧急程度',
    dataIndex: editable ? 'emergLevel' : 'emergLevelName',
    type: editable ? 'SELECT' : undefined,
    width: 110,
    dataList: (mappingList === null || mappingList === void 0 ? void 0 : mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["紧急程度"] */ .M["紧急程度"])) || []
  }, {
    title: '昨日销量',
    dataIndex: 'yestDaySaleCount',
    width: 110
  }, {
    title: '近7日销量',
    dataIndex: 'last7DaySaleCount',
    width: 110
  }, {
    title: '当前库存',
    dataIndex: 'stock',
    width: 110
  }, {
    title: '当前在途',
    dataIndex: 'onOrderStock',
    width: 110
  }, {
    title: '失败原因',
    dataIndex: 'errorMsg',
    width: 130,
    render: txt => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      style: {
        color: 'red'
      }
    }, txt),
    sorter: true
  }];
}

/* harmony default export */ __webpack_exports__["default"] = (usePlaceColumns);

/***/ }),

/***/ 51966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ComplexTable; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/tabs/style/index.js
var style = __webpack_require__(18106);
// EXTERNAL MODULE: ./node_modules/antd/es/tabs/index.js + 32 modules
var tabs = __webpack_require__(69584);
// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var button_style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./src/hooks/useMapping.ts
var useMapping = __webpack_require__(7704);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/UpOutlined.js + 1 modules
var UpOutlined = __webpack_require__(58491);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/DownOutlined.js + 1 modules
var DownOutlined = __webpack_require__(57254);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(5977);
// EXTERNAL MODULE: ./node_modules/yp-frontend-library/esm/index.js + 77 modules
var esm = __webpack_require__(46565);
// EXTERNAL MODULE: ./src/pages/CentralManage/CreateCollection/index.tsx
var CreateCollection = __webpack_require__(67541);
// EXTERNAL MODULE: ./src/pages/CentralManage/CreateCollection/PlaceDemandTable.tsx
var PlaceDemandTable = __webpack_require__(1210);
// EXTERNAL MODULE: ./src/pages/CentralManage/utils.ts
var utils = __webpack_require__(71151);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/style/index.js
var modal_style = __webpack_require__(71194);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(57016);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/index.js
var message_style = __webpack_require__(34792);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(48086);
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
// EXTERNAL MODULE: ./src/pages/CentralManage/CreateCollection/useExtData.ts
var useExtData = __webpack_require__(30703);
// EXTERNAL MODULE: ./src/utils/common.ts
var common = __webpack_require__(96534);
;// CONCATENATED MODULE: ./src/pages/CentralManage/components/NoOrderModal.tsx












/**
 * 商品清退
 */








var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 4
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 18
    }
  }
};

function NoOrderModal(props) {
  var formData = props.formData,
      bussinessType = props.bussinessType,
      childPlaceList = props.childPlaceList,
      storeGroupList = props.storeGroupList;
  var formbuilder = (0,react.useRef)();
  var isFresh = CreateCollection.BussinessType["生鲜"] === bussinessType;

  var _useMapping = (0,useMapping/* default */.Z)([useMapping/* MappingKey.物流模式 */.M["物流模式"]]),
      mappingList = _useMapping.mappingList;

  var logisticsList = mappingList.get(useMapping/* MappingKey.物流模式 */.M["物流模式"]) || []; // 表格查询参数

  var _useState = (0,react.useState)({
    poolingNo: formData === null || formData === void 0 ? void 0 : formData.poolingId,
    goodsId: formData === null || formData === void 0 ? void 0 : formData.goodsId
  }),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      searchParams = _useState2[0],
      setSearchParams = _useState2[1]; // 正在保存商品行


  var _useState3 = (0,react.useState)(false),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      isSaving = _useState4[0],
      setIsSaving = _useState4[1]; // 判断多个请求之后状态


  var _useState5 = (0,react.useState)(0),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      queryState = _useState6[0],
      setQuery = _useState6[1]; // // 取消请求数据
  // const cancelRequest = useMemo(() => {
  //   return !searchParams?.placeIds.length
  // }, [searchParams?.placeIds])
  // 获取额外参数


  var concatExtData = (0,useExtData/* default */.Z)(formData === null || formData === void 0 ? void 0 : formData.firstCategoryId, formData === null || formData === void 0 ? void 0 : formData.merchantId, formData === null || formData === void 0 ? void 0 : formData.goodsId); // 查询

  var handleSearch = (0,react.useCallback)(values => {
    setSearchParams((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, values), {}, {
      poolingNo: formData === null || formData === void 0 ? void 0 : formData.poolingId,
      goodsId: formData === null || formData === void 0 ? void 0 : formData.goodsId
    }));
  }, [formData === null || formData === void 0 ? void 0 : formData.poolingId, formData === null || formData === void 0 ? void 0 : formData.goodsId]); // 请求后

  var afterRequest = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
    var data,
        list,
        _args = arguments;
    return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = _args.length > 0 && _args[0] !== undefined ? _args[0] : [];
            _context.next = 3;
            return concatExtData(data);

          case 3:
            list = _context.sent;
            return _context.abrupt("return", list);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [concatExtData]); // 保存行

  var saveRowCallback = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(data) {
      var currentCellOldData, currentRow, params, res, _res$result, _res$result2, _res$result3, tip;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currentCellOldData = data.currentCellOldData, currentRow = data.currentRow;
              setQuery(prev => {
                return prev + 1;
              });
              params = {
                poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId,
                detail: {
                  id: currentRow.id,
                  placeId: currentRow.placeId,
                  goodsId: formData === null || formData === void 0 ? void 0 : formData.goodsId,
                  barCode: formData === null || formData === void 0 ? void 0 : formData.barCode,
                  demandNum: 0,
                  // 需求数量 固定
                  approveNum: currentRow.approveNum || 0,
                  // 审核数量
                  supplierCode: currentRow.supplierCode,
                  // 供应商编码
                  logistics: currentRow.logistics,
                  // 物流模式：1直送；2配送；3直通
                  unitPrice: currentRow.unitPrice,
                  merchantId: formData === null || formData === void 0 ? void 0 : formData.merchantId,
                  deliveryDcId: currentRow.logistics === 1 ? '0' : currentRow.deliveryDcId,
                  emergLevel: 1,
                  // 默认 正常
                  supplyRoute: 1 // 默认 台州仓-城市仓-城市店

                }
              };
              _context2.next = 5;
              return (0,ypRequest/* default */.Z)('purchase.demandPooling.saveDemandPoolingDetail', params);

            case 5:
              res = _context2.sent;
              setQuery(prev => {
                return prev - 1;
              });

              if (!res.success) {
                _context2.next = 12;
                break;
              }

              if (currentRow.approveNum !== ((_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.approveNum)) {
                tip = '保存商品成功,按步长折算成:' + ((_res$result2 = res.result) === null || _res$result2 === void 0 ? void 0 : _res$result2.approveNum);

                message.default.success(tip);

                currentRow.approveNum = (_res$result3 = res.result) === null || _res$result3 === void 0 ? void 0 : _res$result3.approveNum;
              } else {
                message.default.success('保存商品成功');
              }

              return _context2.abrupt("return", (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, currentRow), {}, {
                id: res.result.id
              }));

            case 12:
              return _context2.abrupt("return", currentCellOldData);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [formData === null || formData === void 0 ? void 0 : formData.barCode, formData === null || formData === void 0 ? void 0 : formData.goodsId, formData === null || formData === void 0 ? void 0 : formData.merchantId, formData === null || formData === void 0 ? void 0 : formData.poolingId]);
  var elements = [{
    label: '店群',
    name: 'placeGroupIds',
    dataList: storeGroupList,
    type: 'SELECT',
    fieldOptions: {
      mode: 'multiple'
    }
  }, {
    label: '地点',
    name: 'placeIds',
    type: 'SELECT',
    dataList: childPlaceList || [],
    fieldOptions: {
      mode: 'multiple'
    }
  }];
  var columns = [{
    title: '商品编码',
    dataIndex: 'goodsId',
    width: 100,
    fixed: 'left'
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    width: 120,
    fixed: 'left'
  }, {
    title: '地点编码',
    dataIndex: 'placeCode',
    width: 100,
    fixed: 'left'
  }, {
    title: '地点名称',
    dataIndex: 'placeName',
    width: 170,
    fixed: 'left'
  }, {
    title: '物流模式',
    dataIndex: 'logisticsName',
    width: 100 // type: isFresh ? 'SELECT' : undefined,
    // dataList: logisticsList

  }, {
    title: '规格',
    dataIndex: 'specification',
    width: 80
  }, {
    title: '申请数量',
    dataIndex: 'demandNum',
    width: 100,
    render: () => 0
  }, {
    title: '审核数量',
    dataIndex: 'approveNum',
    width: 140,
    type: 'INPUT',
    fieldOptions: r => {
      // 非称重商品为正整数，称重商品保留三位小数
      var isPositiveInteger = r.isWeigh === 2;
      return {
        formatter: value => isPositiveInteger ? (0,common/* exchageToNum1 */.Ly)(value) : (0,common/* exchageToNum3 */.hY)(value)
      };
    }
  }, {
    title: '昨销',
    dataIndex: 'yestDaySaleCount',
    width: 110
  }, {
    title: '近7日销量',
    dataIndex: 'last7DaySaleCount',
    width: 120
  }, {
    title: '当前库存',
    dataIndex: 'stock',
    width: 110
  }, {
    title: '供应商名称',
    dataIndex: 'supplierName',
    width: 150,
    type: r => r.logistics === utils/* LOGISTICE_MODE.配送 */.xT["配送"] ? undefined : 'SELECT',
    dataList: r => {
      if (r.supplier && Array.isArray(r.supplier)) {
        return r.supplier.map(v => ({
          value: v.supplierCode,
          label: v.supplierName
        }));
      } else {
        return [{
          value: r.supplierCode,
          label: r.supplierName
        }];
      }
    },
    setCellRowValue: (r, o) => {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, r), {}, {
        supplierCode: o.value
      });
    }
  }, {
    title: '供应商编码',
    dataIndex: 'supplierCode',
    width: 100
  }, {
    title: '参考采购价',
    dataIndex: 'purchaseReferencePrice',
    width: 110
  }, {
    title: '采购价',
    dataIndex: 'unitPrice',
    width: 110,
    type: r => ![utils/* LOGISTICE_MODE.直送 */.xT["直送"], utils/* LOGISTICE_MODE.直通 */.xT["直通"]].includes(r.logistics) ? undefined : 'INPUT'
  }, {
    title: '参考配送价',
    dataIndex: 'transferReferencePrice',
    width: 110
  }, {
    title: '大仓',
    dataIndex: 'deliveryDcId',
    width: 150,
    type: 'SELECT',
    dataList: r => Array.isArray(r.dc) && r.dc.length ? r.dc.map(e => ({
      label: e.deliveryDcName,
      value: e.deliveryDcId
    })) : [{
      label: r.deliveryDcName,
      value: r.deliveryDcId,
      others: {
        deliveryDcCode: r.deliveryDcCode,
        deliveryDcId: r.deliveryDcId,
        deliveryDcName: r.deliveryDcName
      }
    }],
    render: (node, record) => record.logistics === utils/* LOGISTICE_MODE.直送 */.xT["直送"] ? '-' : node // 直送不展示

  }, {
    title: '大仓库存',
    dataIndex: 'dcStock',
    width: 110
  }, {
    title: '满足率',
    dataIndex: 'satisfactionRate',
    width: 110,
    // （审核数量/申请数量）*100=结果（保留1为小数）
    render: (txt, record) => {
      var rate = +record.approveNum / +record.demandNum * 100;
      return isNaN(rate) ? '' : "".concat(rate.toFixed(1), "%");
    }
  }, {
    title: '当前在途',
    dataIndex: 'onOrderStock',
    width: 110
  }, {
    title: '失败原因',
    dataIndex: 'errorMsg',
    width: 140,
    render: txt => /*#__PURE__*/react.createElement("span", {
      style: {
        color: 'red'
      }
    }, txt)
  }];
  (0,react.useEffect)(() => {
    if (queryState === 0) {
      setIsSaving(false);
    } else {
      setIsSaving(true);
    }
  }, [queryState]); // 关闭的函数

  var closeProgramFun = (0,react.useCallback)(() => {
    // console.log('点击关闭触发函数')
    if (!isSaving) {
      props.closeModalCallback();
    }
  }, [isSaving]);
  return /*#__PURE__*/react.createElement(modal/* default */.Z, {
    title: "\u8FFD\u52A0\u95E8\u5E97",
    focusTriggerAfterClose: false,
    destroyOnClose: true,
    maskClosable: false,
    closable: false,
    width: 1200,
    visible: true,
    onCancel: props.closeModalCallback,
    footer: [/*#__PURE__*/react.createElement(es_button/* default */.Z, {
      key: "cancel",
      disabled: isSaving,
      onClick: () => {
        closeProgramFun();
      }
    }, "\u5173\u95ED")]
  }, /*#__PURE__*/react.createElement(esm/* FormBuilder */.qu, (0,esm_extends/* default */.Z)({}, defaultFormItemLayout, {
    formRef: formbuilder,
    elements: elements,
    onSearch: handleSearch
  })), /*#__PURE__*/react.createElement(esm/* EnhanceTable */.UO, {
    // cancelRequest={cancelRequest}
    searchParams: searchParams,
    columns: columns,
    requestUrl: "purchase.demandPooling.placeNoOrderSelect",
    saveRowCallback: saveRowCallback,
    afterRequest: afterRequest,
    scroll: {
      x: 1300,
      y: 500
    }
  }));
}

/* harmony default export */ var components_NoOrderModal = (NoOrderModal);
;// CONCATENATED MODULE: ./src/pages/CentralManage/components/ComplexTable.tsx










/**
 * 商品和地点维度表格结合
 */










function ComplexTable(props) {
  var goods = props.goods,
      place = props.place,
      placeGoods = props.placeGoods,
      goodsTableRef = props.goodsTableRef,
      formSearchData = props.formSearchData,
      hideAddStoreBtn = props.hideAddStoreBtn,
      bussinessType = props.bussinessType,
      placeTableRef = props.placeTableRef,
      queryApporeSummaryCallback = props.queryApporeSummaryCallback;

  var _useLocation = (0,react_router/* useLocation */.TH)(),
      query = _useLocation.query;

  var editable = query.fn !== utils/* FUNC.VIEW */.O6.VIEW;
  var goodsRef = (0,react.useRef)(null);
  var placeRef = (0,react.useRef)(null);
  var tabPlaceRef = (0,react.useRef)(null);
  var isFresh = CreateCollection.BussinessType["生鲜"] === bussinessType; // 追加门店

  var _useState = (0,react.useState)({
    visible: false,
    record: {}
  }),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      goodsModal = _useState2[0],
      setGoodsModal = _useState2[1];

  var _useMapping = (0,useMapping/* default */.Z)([useMapping/* MappingKey.权限下的商家 */.M["权限下的商家"], useMapping/* MappingKey.权限下的店群信息 */.M["权限下的店群信息"]], {
    'merchantId': formSearchData === null || formSearchData === void 0 ? void 0 : formSearchData.merchantId
  }),
      mappingList = _useMapping.mappingList; // 商家下的地点


  var _useState3 = (0,react.useState)([]),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      childPlaceList = _useState4[0],
      setChildPlaceList = _useState4[1]; // 店群


  var _useState5 = (0,react.useState)([]),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      storeGroupList = _useState6[0],
      setStoreGroupList = _useState6[1]; // 表格展示的key


  var _useState7 = (0,react.useState)([]),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      expandKeys = _useState8[0],
      setExpandKeys = _useState8[1]; // 子表格展示参数


  var _useState9 = (0,react.useState)(),
      _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
      expandPrams = _useState10[0],
      setExpandPrams = _useState10[1];

  var _useState11 = (0,react.useState)(),
      _useState12 = (0,slicedToArray/* default */.Z)(_useState11, 2),
      goodsDataSource = _useState12[0],
      setGoodsDataSource = _useState12[1]; // tab的key


  var _useState13 = (0,react.useState)('goods'),
      _useState14 = (0,slicedToArray/* default */.Z)(_useState13, 2),
      activeKey = _useState14[0],
      setActiveKey = _useState14[1]; // 未展开不请求地点数据


  var cancelRequestPlace = (0,react.useMemo)(() => !(expandPrams !== null && expandPrams !== void 0 && expandPrams.expanded), [expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.expanded]); // 商品维度请求参数

  var goodsSearchParams = (0,react.useMemo)(() => ({
    condition: formSearchData
  }), [formSearchData]); // 地点维度请求参数

  var placeSearchParams = (0,react.useMemo)(() => ({
    condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formSearchData), {}, {
      goodsId: expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.record.goodsId,
      deliveryDcId: expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.record.deliveryDcId,
      barCode: expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.record.barCode,
      searchType: 1
    })
  }), [formSearchData, expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.record.goodsId, expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.record.deliveryDcId, expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.record.barCode]); // 地点商品维度查询数据

  var goodsPlaceSearchParams = (0,react.useMemo)(() => {
    return {
      condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formSearchData), {}, {
        searchType: 2
      })
    };
  }, [formSearchData]); // 商品维度筛选，排序的回调

  var sortCallback = (0,react.useCallback)((filter, sorter) => {
    var isAsc;

    if (sorter.order === 'ascend') {
      isAsc = true;
    } else if (sorter.order === 'descend') {
      isAsc = false;
    }

    return {
      condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formSearchData), {}, {
        isAsc,
        orderColumn: sorter.field
      })
    };
  }, [formSearchData]); // 地点维度筛选，排序的回调

  var sortPlaceCallback = (0,react.useCallback)((filter, sorter) => {
    var isAsc;

    if (sorter.order === 'ascend') {
      isAsc = true;
    } else if (sorter.order === 'descend') {
      isAsc = false;
    }

    return {
      condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, placeSearchParams.condition), {}, {
        isAsc,
        orderColumn: sorter.field
      })
    };
  }, [placeSearchParams]); // console.log(goodsDataSource,'这个数据是什么')
  // 商品地点维度排序

  var sortGoodsPlaceCallback = (0,react.useCallback)((filter, sorter) => {
    var isAsc;

    if (sorter.order === 'ascend') {
      isAsc = true;
    } else if (sorter.order === 'descend') {
      isAsc = false;
    }

    return {
      condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, goodsPlaceSearchParams.condition), {}, {
        isAsc,
        orderColumn: sorter.field
      })
    };
  }, [goodsPlaceSearchParams]); // 展示子表格

  var handleExpand = (0,react.useCallback)((expanded, record) => {
    setExpandPrams({
      expanded,
      record
    });
  }, []); // 关闭浮层回调

  var closeModalCallback = (0,react.useCallback)(() => {
    var _goodsRef$current;

    setGoodsModal({
      visible: false,
      record: {}
    });
    (_goodsRef$current = goodsRef.current) === null || _goodsRef$current === void 0 ? void 0 : _goodsRef$current.reload(goodsSearchParams);
    queryApporeSummaryCallback();
  }, [goodsSearchParams, queryApporeSummaryCallback]); // 追加门店

  var handleAddShop = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(r) {
      var _target$others;

      var list, target, placeList, placeGroupList;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              list = mappingList.get(useMapping/* MappingKey.权限下的商家 */.M["权限下的商家"]) || [];
              target = list.find(v => v.value === Number(r.merchantId)) || {};
              placeList = ((target === null || target === void 0 ? void 0 : (_target$others = target.others) === null || _target$others === void 0 ? void 0 : _target$others.placeVos) || []).map(v => ({
                value: +v.placeId,
                label: "".concat(v.placeCode, "-").concat(v.placeName),
                others: v
              })); //todo 获取店群

              placeGroupList = mappingList.get(useMapping/* MappingKey.权限下的店群信息 */.M["权限下的店群信息"]) || [];
              setGoodsModal({
                visible: true,
                record: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formSearchData), r)
              });
              setChildPlaceList(placeList);
              setStoreGroupList(placeGroupList);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [mappingList, formSearchData]); // 商品维度请求后

  var afterRequest = (0,react.useCallback)(data => {
    if (data && data.length && !expandKeys.length) {
      // 默认展开
      setExpandKeys(["".concat(data[0].barCode, "-").concat(data[0].goodsId, "-").concat(data[0].deliveryDcId)]);
      setExpandPrams({
        expanded: true,
        record: data[0]
      });
    }

    setGoodsDataSource(data);
    return data;
  }, [expandKeys.length]); // 商品维度地点保存行回调

  var handleReload = (0,react.useCallback)(data => {
    // 如果修改的是 审核数量 更新商品维度的总量
    if (data.approveNum) {
      var _placeRef$current;

      var placeData = (_placeRef$current = placeRef.current) === null || _placeRef$current === void 0 ? void 0 : _placeRef$current.getTableData();
      console.log(data, '获取到的数据');
      var dataSource = (placeData === null || placeData === void 0 ? void 0 : placeData.dataSource) || [];
      var totalApproveNum = dataSource.reduce((pre, next) => {
        var num = Number(next.approveNum);

        if (Number.isNaN(num)) {
          return pre;
        }

        return pre + num;
      }, 0);
      setGoodsDataSource(v => {
        return v === null || v === void 0 ? void 0 : v.map(item => {
          if ("".concat(expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.record.barCode, "-").concat(expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.record.goodsId, "-").concat(expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.record.deliveryDcId) === "".concat(item.barCode, "-").concat(item.goodsId, "-").concat(item.deliveryDcId)) {
            return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, item), {}, {
              totalApproveNum,
              totalReferencePrice: data !== null && data !== void 0 && data.totalPlaceReferencePrice ? data === null || data === void 0 ? void 0 : data.totalPlaceReferencePrice : null
            });
          }

          return item;
        });
      });
    }
  }, [expandPrams]);

  var changeTabs = key => {
    setActiveKey(key);

    if (key === 'goods') {
      var _goodsRef$current2;

      goodsRef === null || goodsRef === void 0 ? void 0 : (_goodsRef$current2 = goodsRef.current) === null || _goodsRef$current2 === void 0 ? void 0 : _goodsRef$current2.reload(goodsSearchParams);
    } else {
      var _tabPlaceRef$current;

      (_tabPlaceRef$current = tabPlaceRef.current) === null || _tabPlaceRef$current === void 0 ? void 0 : _tabPlaceRef$current.reload(goodsPlaceSearchParams);
    } // 通知父组件当前选中的维度


    props.onTabChange && props.onTabChange(key);
  };

  (0,react.useEffect)(() => {
    if (!goodsTableRef) {
      return;
    } // @ts-ignore


    goodsTableRef.current = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, goodsRef.current), {}, {
      reload: data => {
        var _goodsRef$current3;

        return (_goodsRef$current3 = goodsRef.current) === null || _goodsRef$current3 === void 0 ? void 0 : _goodsRef$current3.reload({
          condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, data === null || data === void 0 ? void 0 : data.condition), formSearchData)
        });
      }
    });
  }, [formSearchData, goodsRef, goodsTableRef]);
  (0,react.useEffect)(() => {
    if (!placeTableRef) {
      return;
    } // @ts-ignore


    placeTableRef.current = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, placeRef.current), {}, {
      reload: data => {
        var _placeRef$current2;

        return (_placeRef$current2 = placeRef.current) === null || _placeRef$current2 === void 0 ? void 0 : _placeRef$current2.reload({
          condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, data === null || data === void 0 ? void 0 : data.condition), placeSearchParams.condition)
        });
      }
    });
  }, [placeSearchParams.condition, placeTableRef, placeSearchParams]);
  var placeColumns = [{
    title: '商品名称',
    dataIndex: 'goodsName',
    fixed: 'left',
    width: 120,
    sorter: true
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    sorter: true,
    width: 100
  }, {
    title: '门店编码',
    dataIndex: 'placeCode',
    width: 100,
    sorter: true
  }, {
    title: '门店名称',
    dataIndex: 'placeName',
    width: 140
  }, {
    title: '规格',
    dataIndex: 'orderStepSize',
    width: 80,
    sorter: true
  }, {
    title: '申请数量',
    dataIndex: 'demandNum',
    width: 100,
    sorter: true,
    render: (node, r) => /*#__PURE__*/react.createElement("div", {
      className: "d-flex"
    }, node, "\xA0", r.barCodeUnit)
  }, {
    title: '审核数量',
    dataIndex: 'approveNum',
    width: 100,
    sorter: true,
    type: editable ? 'INPUT' : undefined,
    render: (node, r) => /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
      className: "d-flex"
    }, node, "\xA0", r.barCodeUnit), Number(r === null || r === void 0 ? void 0 : r.exceptionQtyFlag) === 1 ? /*#__PURE__*/react.createElement("div", {
      style: {
        color: 'red',
        fontSize: 12
      }
    }, "\u7591\u4F3C\u8BA2\u91CF\u5F02\u5E38") : null)
  }, {
    title: '总金额',
    width: 100,
    dataIndex: 'totalReferencePrice',
    sorter: true
  }, {
    title: '门店预购量',
    dataIndex: 'storeRegularOrderQty',
    width: 100
  }, {
    title: '门店加单量',
    dataIndex: 'storeAdditionalQty',
    width: 100
  }, {
    title: '当前库存',
    dataIndex: 'stock',
    width: 100
  }, {
    title: '昨销',
    dataIndex: 'yestDaySaleCount',
    width: 80
  }, {
    title: '近7日销量',
    dataIndex: 'last7DaySaleCount',
    width: 100
  }, {
    title: '供应商名称',
    dataIndex: 'supplierName',
    type: r => r.logistics === utils/* LOGISTICE_MODE.配送 */.xT["配送"] || !editable ? undefined : 'SELECT',
    width: 160,
    dataList: r => {
      if (r.supplier && Array.isArray(r.supplier)) {
        return r.supplier.map(v => ({
          value: v.supplierCode,
          label: v.supplierName
        }));
      } else {
        return [{
          value: r.supplierCode,
          label: r.supplierName
        }];
      }
    },
    sorter: true,
    setCellRowValue: r => {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, r), {}, {
        supplierCode: r.supplierName
      });
    }
  }, {
    title: '供应商编码',
    dataIndex: 'supplierCode',
    sorter: true,
    width: 120
  }, {
    title: '参考采购价(元)',
    dataIndex: 'purchaseReferencePrice',
    width: 120
  }, {
    title: '采购价(元)',
    dataIndex: 'unitPrice',
    width: 100,
    type: r => {
      if (isFresh) {
        return ![utils/* LOGISTICE_MODE.直送 */.xT["直送"], utils/* LOGISTICE_MODE.直通 */.xT["直通"]].includes(r.logistics) || !editable ? undefined : 'INPUT';
      }

      return ![utils/* LOGISTICE_MODE.直送 */.xT["直送"]].includes(r.logistics) || !editable ? undefined : 'INPUT';
    }
  }, {
    title: '参考配送价(元)',
    // 成本价
    dataIndex: 'transferReferencePrice',
    width: 120
  }, {
    title: '指定到店价(含运费)',
    dataIndex: 'unitCostPrice',
    width: 150
  }, {
    title: '大仓',
    dataIndex: editable ? 'deliveryDcId' : 'deliveryDcName',
    type: r => [utils/* LOGISTICE_MODE.直通 */.xT["直通"], utils/* LOGISTICE_MODE.配送 */.xT["配送"]].includes(r.logistics) || editable ? 'SELECT' : undefined,
    dataList: r => Array.isArray(r.dc) && r.dc.length ? r.dc.map(e => ({
      label: e.deliveryDcName,
      value: e.deliveryDcId
    })) : [{
      label: r.deliveryDcName,
      value: r.deliveryDcId,
      raw: {
        deliveryDcCode: r.deliveryDcCode,
        deliveryDcId: r.deliveryDcId,
        deliveryDcName: r.deliveryDcName
      }
    }],
    render: (node, record) => record.logistics === utils/* LOGISTICE_MODE.直送 */.xT["直送"] ? '-' : node,
    // 直送不展示
    width: 140
  }, {
    title: '商品条码',
    dataIndex: 'barCode',
    sorter: true,
    width: 120
  }, {
    title: '物流模式',
    dataIndex: 'logisticsName',
    // 注意：商品给的是 logistic，采购给的是 logistics。在添加门店层逻辑中磨平
    width: 100,
    sorter: true
  }, {
    title: '大仓库存',
    dataIndex: 'dcStock',
    width: 100
  }, {
    title: '当前在途',
    dataIndex: 'onOrderStock',
    width: 100
  }, {
    title: '失败原因',
    dataIndex: 'errorMsg',
    width: 130,
    render: txt => /*#__PURE__*/react.createElement("span", {
      style: {
        color: 'red'
      }
    }, txt),
    sorter: true
  }];
  return /*#__PURE__*/react.createElement(tabs/* default */.Z, {
    onChange: changeTabs,
    activeKey: activeKey,
    destroyInactiveTabPane: true
  }, /*#__PURE__*/react.createElement(tabs/* default.TabPane */.Z.TabPane, {
    tab: "\u5546\u54C1\u7EF4\u5EA6",
    key: "goods"
  }, /*#__PURE__*/react.createElement(esm/* EnhanceTable */.UO, (0,esm_extends/* default */.Z)({
    requestUrl: "purchase.demandPooling.queryGoodsDemandPoolingDetailList"
  }, goods, {
    tableRef: goodsRef,
    useTool: false,
    searchParams: goodsSearchParams,
    sortCallback: sortCallback,
    scroll: {
      x: 1200,
      y: 2000
    },
    rowKey: r => "".concat(r.barCode, "-").concat(r.goodsId, "-").concat(r.deliveryDcId),
    afterRequest: afterRequest,
    dataSource: goodsDataSource,
    onRow: r => {
      if (expandKeys.includes("".concat(r.barCode, "-").concat(r.goodsId, "-").concat(r.deliveryDcId))) {
        return {
          className: 'bgBlue'
        };
      }

      return {};
    },
    expandable: {
      expandRowByClick: true,
      expandedRowKeys: expandKeys,
      onExpand: handleExpand,
      expandIcon: _ref2 => {
        var expanded = _ref2.expanded,
            onExpand = _ref2.onExpand,
            record = _ref2.record;
        return expanded ? /*#__PURE__*/react.createElement(UpOutlined/* default */.Z, {
          onClick: e => onExpand(record, e)
        }) : /*#__PURE__*/react.createElement(DownOutlined/* default */.Z, {
          onClick: e => onExpand(record, e)
        });
      },
      expandedRowRender: record => {
        return expandKeys.includes("".concat(record.barCode, "-").concat(record.goodsId, "-").concat(record.deliveryDcId)) && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(PlaceDemandTable.default, (0,esm_extends/* default */.Z)({}, place, {
          mode: "scroll",
          useTool: false,
          cancelRequest: cancelRequestPlace,
          formData: formSearchData,
          searchParams: placeSearchParams,
          placeTableRef: placeRef,
          sortCallback: sortPlaceCallback,
          getApproveSummary: queryApporeSummaryCallback,
          handleReload: handleReload,
          scroll: {
            x: 600
          },
          onRow: r => {
            if (r.errorMsg) {
              return {
                className: 'bgRed'
              };
            }

            return {};
          }
        })), !hideAddStoreBtn && /*#__PURE__*/react.createElement(es_button/* default */.Z, {
          type: "dashed",
          style: {
            width: '100%',
            marginTop: '23px',
            color: '#1890ff',
            borderColor: '#1890ff'
          },
          onClick: () => handleAddShop(record)
        }, "\u8FFD\u52A0\u95E8\u5E97"));
      },
      onExpandedRowsChange: r => {
        var data = r.filter(v => !expandKeys.includes(v));
        setExpandKeys(data);
      }
    }
  }))), /*#__PURE__*/react.createElement(tabs/* default.TabPane */.Z.TabPane, {
    tab: "\u95E8\u5E97\u5546\u54C1\u7EF4\u5EA6",
    key: "place"
  }, /*#__PURE__*/react.createElement(PlaceDemandTable.default, (0,esm_extends/* default */.Z)({}, placeGoods, {
    mode: "scroll",
    columns: placeGoods !== null && placeGoods !== void 0 && placeGoods.columns ? placeGoods === null || placeGoods === void 0 ? void 0 : placeGoods.columns : placeColumns,
    cancelRequest: cancelRequestPlace,
    formData: formSearchData,
    searchParams: goodsPlaceSearchParams,
    placeTableRef: tabPlaceRef,
    sortCallback: sortGoodsPlaceCallback,
    getApproveSummary: queryApporeSummaryCallback,
    scroll: {
      x: 700
    },
    onRow: r => {
      if (r.errorMsg) {
        return {
          className: 'bgRed'
        };
      }

      return {};
    }
  }))), goodsModal.visible && /*#__PURE__*/react.createElement(components_NoOrderModal, {
    formData: goodsModal.record,
    bussinessType: bussinessType,
    childPlaceList: childPlaceList,
    storeGroupList: storeGroupList,
    closeModalCallback: closeModalCallback
  }));
}

/* harmony default export */ var components_ComplexTable = (ComplexTable);

/***/ }),

/***/ 67177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tM": function() { return /* binding */ ExportType; },
/* harmony export */   "ug": function() { return /* binding */ ExportTabType; }
/* harmony export */ });
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57016);
/* harmony import */ var antd_es_tabs_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18106);
/* harmony import */ var antd_es_tabs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69584);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91896);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71577);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _components_EnhanceTable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14845);











/**
 * 查看导出结果浮层
 */


var ExportType;

(function (ExportType) {
  ExportType[ExportType["\u91C7\u8D2D\u5355\u5546\u54C1\u5BFC\u51FA"] = 1] = "\u91C7\u8D2D\u5355\u5546\u54C1\u5BFC\u51FA";
  ExportType[ExportType["\u91C7\u8D2D\u5355\u5355\u4E2A\u5BFC\u51FA"] = 2] = "\u91C7\u8D2D\u5355\u5355\u4E2A\u5BFC\u51FA";
  ExportType[ExportType["\u8C03\u62E8\u5355\u5BFC\u51FA"] = 3] = "\u8C03\u62E8\u5355\u5BFC\u51FA";
  ExportType[ExportType["\u96C6\u5355\u5546\u54C1\u5BFC\u51FA"] = 4] = "\u96C6\u5355\u5546\u54C1\u5BFC\u51FA";
  ExportType[ExportType["\u96C6\u5355\u672A\u4E0B\u5355\u95E8\u5E97\u5BFC\u51FA"] = 5] = "\u96C6\u5355\u672A\u4E0B\u5355\u95E8\u5E97\u5BFC\u51FA";
  ExportType[ExportType["\u96C6\u5355\u5931\u8D25\u660E\u7EC6\u5BFC\u51FA"] = 6] = "\u96C6\u5355\u5931\u8D25\u660E\u7EC6\u5BFC\u51FA";
  ExportType[ExportType["\u91C7\u8D2D\u5355\u4EF7\u683C\u6A21\u677F\u5BFC\u51FA"] = 7] = "\u91C7\u8D2D\u5355\u4EF7\u683C\u6A21\u677F\u5BFC\u51FA";
  ExportType[ExportType["\u91C7\u8D2D\u5355\u5408\u5E76\u5BFC\u51FA"] = 8] = "\u91C7\u8D2D\u5355\u5408\u5E76\u5BFC\u51FA";
  ExportType[ExportType["\u96C6\u5355\u5206\u62E8\u6253\u5370\u5BFC\u51FA"] = 9] = "\u96C6\u5355\u5206\u62E8\u6253\u5370\u5BFC\u51FA";
  ExportType[ExportType["\u96C6\u5355\u8010\u7528\u54C1\u660E\u7EC6"] = 11] = "\u96C6\u5355\u8010\u7528\u54C1\u660E\u7EC6";
})(ExportType || (ExportType = {}));

var ExportTabType;

(function (ExportTabType) {
  ExportTabType["\u5BFC\u51FA\u660E\u7EC6"] = "\u5BFC\u51FA\u660E\u7EC6";
  ExportTabType["\u5546\u54C1\u660E\u7EC6"] = "\u5546\u54C1\u660E\u7EC6";
})(ExportTabType || (ExportTabType = {}));

function ExportList(props) {
  var businessType = props.businessType;
  var table = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(props.exportTabType || ExportTabType.导出明细),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_useState, 2),
      exportTabType = _useState2[0],
      setExportTabType = _useState2[1];

  var downloadFile = url => {
    if (!url) {
      antd_es_message__WEBPACK_IMPORTED_MODULE_7__.default.error('不存在文件');

      return;
    }

    window.location.href = url;
  };

  var columns = [{
    title: '文件名称',
    dataIndex: 'fileName',
    width: 160
  }, {
    title: '导出时间',
    dataIndex: 'exportTime',
    width: 140
  }, {
    title: '状态',
    dataIndex: 'statusName',
    width: 100
  }, {
    title: '操作人',
    dataIndex: 'creator',
    width: 120
  }, {
    title: '操作',
    dataIndex: 'operateeee',
    width: 100,
    render: (_, r) => {
      return r.status === 8 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("a", {
        onClick: () => downloadFile(r.downloadUrl)
      }, "\u4E0B\u8F7D") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("a", {
        onClick: () => {
          var _table$current;

          return (_table$current = table.current) === null || _table$current === void 0 ? void 0 : _table$current.reload();
        }
      }, "\u5237\u65B0");
    }
  }];
  var tablePropsJD = {
    columns,
    query: {
      url: 'purchase.export.getExportTaskList',
      params: {
        businessType: businessType || ExportType.集单商品导出
      } // 不用 useMemoe 包裹可以在 Tabs 切换时触发刷新

    }
  };
  var tablePropsDY = {
    columns,
    query: {
      url: 'purchase.export.getExportTaskList',
      params: {
        businessType: businessType || ExportType.集单分拨打印导出
      } // 不用 useMemoe 包裹可以在 Tabs 切换时触发刷新

    }
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, {
    title: "\u67E5\u770B\u5BFC\u51FA\u7ED3\u679C",
    destroyOnClose: true,
    maskClosable: false,
    width: 800,
    visible: true,
    onOk: props.closeModalCallback,
    onCancel: props.closeModalCallback,
    footer: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, {
      onClick: props.closeModalCallback
    }, "\u5173\u95ED")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_tabs__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z, {
    activeKey: exportTabType,
    onChange: key => setExportTabType(key)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_tabs__WEBPACK_IMPORTED_MODULE_10__/* .default.TabPane */ .Z.TabPane, {
    key: ExportTabType.导出明细,
    tab: "\u5BFC\u51FA\u660E\u7EC6"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_components_EnhanceTable__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({
    ref: table
  }, tablePropsJD))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_tabs__WEBPACK_IMPORTED_MODULE_10__/* .default.TabPane */ .Z.TabPane, {
    key: ExportTabType.商品明细,
    tab: "\u5546\u54C1\u660E\u7EC6"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_components_EnhanceTable__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({
    ref: table
  }, tablePropsDY)))));
}

/* harmony default export */ __webpack_exports__["ZP"] = (ExportList);

/***/ }),

/***/ 80248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EY": function() { return /* binding */ FRESH_CATE_CODE; },
/* harmony export */   "hk": function() { return /* binding */ FRESH_SECOND_CATE_CODE; },
/* harmony export */   "Aj": function() { return /* binding */ QUICK_SALE_CATE_CODE; },
/* harmony export */   "Q3": function() { return /* binding */ QUICK_SALE_SECOND_CATE_CODE; },
/* harmony export */   "eT": function() { return /* binding */ useCategory3; },
/* harmony export */   "s6": function() { return /* binding */ categoryFilter; }
/* harmony export */ });
/* unused harmony export CategoryDict */
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var antd_lib_select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64749);
/* harmony import */ var _hooks_useEnums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16965);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71151);






var CategoryDict;

(function (CategoryDict) {
  CategoryDict["\u4E00\u7EA7\u7C7B\u76EE"] = "firstCategoryId";
  CategoryDict["\u4E8C\u7EA7\u7C7B\u76EE"] = "secondCategoryIds";
  CategoryDict["\u4E09\u7EA7\u7C7B\u76EE"] = "thirdCategoryIds";
  CategoryDict["\u56DB\u7EA7\u7C7B\u76EE"] = "fourthCategoryIds";
})(CategoryDict || (CategoryDict = {}));

/** 生鲜类目 ID */
var FRESH_CATE_CODE = 10;
/** 生鲜类目 ID */

var FRESH_SECOND_CATE_CODE = 1001;
/** 快消类目 ID */

var QUICK_SALE_CATE_CODE = 20;
/** 快消类目 ID */

var QUICK_SALE_SECOND_CATE_CODE = 2001;
var Option = antd_lib_select__WEBPACK_IMPORTED_MODULE_3__/* .default.Option */ .Z.Option;
/**
 * 二级商品类目联动
 */

var useCategory3 = function useCategory3() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var filterCates = props.filterCates,
      depth = props.depth,
      _props$defaultValues = props.defaultValues,
      defaultValues = _props$defaultValues === void 0 ? {} : _props$defaultValues,
      changeSecondCategoryIds = props.changeSecondCategoryIds,
      multiple = props.multiple;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultValues.firstCategoryId),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      firstCategoryId = _useState2[0],
      setFirstCategoryId = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultValues.secondCategoryIds),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState3, 2),
      secondCategoryIds = _useState4[0],
      setSecondCategoryIds = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState5, 2),
      thirdCategoryIds = _useState6[0],
      setThirdCategoryIds = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState7, 2),
      fourthCategoryIds = _useState8[0],
      setFourthCategoryIds = _useState8[1];

  var _useEnums = (0,_hooks_useEnums__WEBPACK_IMPORTED_MODULE_1__/* .useEnums */ .ws)(_hooks_useEnums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_DICT.categoryTreeBusinessMapping */ .J3.categoryTreeBusinessMapping),
      _useEnums2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useEnums, 2),
      categoryRaw = _useEnums2[1];

  var _useMemo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (!categoryRaw) return [[], []];
    var arr = [];
    var item; // 用 const 也可以在 eval 下跑 🙃

    Object.values(categoryRaw).forEach(val => {
      // eslint-disable-next-line no-eval
      eval("(item=".concat(val, ")"));
      arr.push(item);
    }); // {categoryId: 10, categoryName: "生鲜部", categorylevel: 1, childCategoryList: {…}, parentCategoryId: 0}

    if (filterCates instanceof Function) {
      try {
        arr = filterCates(arr);
      } catch (error) {
        console.warn('格式化类目报错\n', error);
      }
    }

    return [arr.map(item => ({
      value: item.categoryId,
      label: item.categoryName
    })), arr];
  }, [categoryRaw]),
      _useMemo2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useMemo, 2),
      categoryOpts1 = _useMemo2[0],
      categoryArr = _useMemo2[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState9, 2),
      categoryOpts2 = _useState10[0],
      setCategoryOpts2 = _useState10[1];

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState12 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState11, 2),
      categoryOpts3 = _useState12[0],
      setCategoryOpts3 = _useState12[1];

  var _useState13 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState14 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState13, 2),
      categoryOpts4 = _useState14[0],
      setCategoryOpts4 = _useState14[1];

  if (categoryRaw && !Object.values(categoryRaw).length) {
    console.warn('木有获取到类目[enum46]\n', categoryRaw);
  }

  var changeCategory = (value, key) => {
    // const item = categoryArr.find(_ => value === _.categoryId)
    // const opts = Object.values(item?.childCategoryList || {}).map(({ categoryId: value, categoryName: label }) => ({ value, label }))
    if (key === CategoryDict.一级类目) {
      setFirstCategoryId(value); // 设置一级类目，会自动重置二级类目

      setSecondCategoryIds([]);
      setThirdCategoryIds([]);
      setFourthCategoryIds([]);
    } else if (key === CategoryDict.二级类目) {
      if (multiple) {
        setSecondCategoryIds(value);
      } else {
        setSecondCategoryIds(value ? [value] : []);
      }

      changeSecondCategoryIds({
        firstCategoryId,
        secondCategoryIds: value ? [value] : []
      });
    } else if (key === CategoryDict.三级类目) {
      setThirdCategoryIds(value);
    } else if (key === CategoryDict.四级类目) {
      setFourthCategoryIds(value);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    // console.log('categoryArr', categoryArr, firstCategoryId)
    var item = categoryArr.find(_ => firstCategoryId === _.categoryId);
    var opts = Object.values((item === null || item === void 0 ? void 0 : item.childCategoryList) || {}).map(_ref => {
      var value = _ref.categoryId,
          label = _ref.categoryName;
      return {
        value,
        label
      };
    }); // setSecondCategoryIds([])

    setThirdCategoryIds([]);
    setFourthCategoryIds([]);
    setCategoryOpts2(opts !== null && opts !== void 0 ? opts : []);
  }, [firstCategoryId, categoryArr]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var firstItem = categoryArr.find(_ => firstCategoryId === _.categoryId); // 根据二级类目id拼接三级类目

    var secondIem = secondCategoryIds === null || secondCategoryIds === void 0 ? void 0 : secondCategoryIds.reduce((acc, id) => {
      if (firstItem !== null && firstItem !== void 0 && firstItem.childCategoryList[id]) {
        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)({}, acc), firstItem.childCategoryList[id].childCategoryList);
      }

      return acc;
    }, {});
    var opts = Object.values(secondIem || {}).map(_ref2 => {
      var value = _ref2.categoryId,
          label = _ref2.categoryName;
      return {
        value,
        label
      };
    });
    setThirdCategoryIds([]);
    setFourthCategoryIds([]);
    setCategoryOpts3(opts !== null && opts !== void 0 ? opts : []);
  }, [secondCategoryIds, categoryArr]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var firstItem = categoryArr.find(_ => firstCategoryId === _.categoryId);
    var secondItem = secondCategoryIds === null || secondCategoryIds === void 0 ? void 0 : secondCategoryIds.reduce((acc, id) => {
      if (firstItem !== null && firstItem !== void 0 && firstItem.childCategoryList[id]) {
        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)({}, acc), firstItem.childCategoryList[id].childCategoryList);
      }

      return acc;
    }, {});
    var thirdItem = thirdCategoryIds === null || thirdCategoryIds === void 0 ? void 0 : thirdCategoryIds.reduce((acc, id) => {
      var _secondItem$id;

      if (secondItem !== null && secondItem !== void 0 && (_secondItem$id = secondItem[id]) !== null && _secondItem$id !== void 0 && _secondItem$id.childCategoryList) {
        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)({}, acc), secondItem[id].childCategoryList);
      }

      return acc;
    }, {});
    var opts = Object.values(thirdItem || {}).map(_ref3 => {
      var value = _ref3.categoryId,
          label = _ref3.categoryName;
      return {
        value,
        label
      };
    });
    setFourthCategoryIds([]);
    setCategoryOpts4(opts !== null && opts !== void 0 ? opts : []);
  }, [thirdCategoryIds, categoryArr, firstCategoryId, secondCategoryIds]);
  var element = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "d-flex user-category-3"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd_lib_select__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    style: {
      width: 90
    },
    allowClear: false,
    placeholder: "\u8BF7\u9009\u62E9",
    value: firstCategoryId,
    dropdownMatchSelectWidth: false,
    onChange: val => changeCategory(val, CategoryDict.一级类目)
  }, categoryOpts1.map(_ref4 => {
    var value = _ref4.value,
        label = _ref4.label;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, {
      key: value,
      value: value
    }, label);
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd_lib_select__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    style: {
      width: '100%'
    },
    allowClear: false,
    placeholder: "\u8BF7\u9009\u62E9",
    mode: !multiple ? null : 'multiple',
    value: secondCategoryIds,
    onChange: val => changeCategory(val, CategoryDict.二级类目)
  }, categoryOpts2.map(_ref5 => {
    var value = _ref5.value,
        label = _ref5.label;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, {
      key: value,
      value: value
    }, label);
  })), depth ? null : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd_lib_select__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    style: {
      width: '100%'
    },
    allowClear: true,
    placeholder: "\u8BF7\u9009\u62E9",
    mode: "multiple",
    value: thirdCategoryIds,
    onChange: val => changeCategory(val, CategoryDict.三级类目)
  }, categoryOpts3.map(_ref6 => {
    var value = _ref6.value,
        label = _ref6.label;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, {
      key: value,
      value: value
    }, label);
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd_lib_select__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    style: {
      width: '100%'
    },
    allowClear: true,
    placeholder: "\u8BF7\u9009\u62E9",
    mode: "multiple",
    value: fourthCategoryIds,
    onChange: val => changeCategory(val, CategoryDict.四级类目)
  }, categoryOpts4.map(_ref7 => {
    var value = _ref7.value,
        label = _ref7.label;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, {
      key: value,
      value: value
    }, label);
  }))));
  return [element, {
    category3: {
      firstCategoryId,
      secondCategoryIds,
      thirdCategoryIds,
      fourthCategoryIds
    },

    reset() {
      setFirstCategoryId(defaultValues.firstCategoryId);
      setSecondCategoryIds(defaultValues.secondCategoryIds);
      setThirdCategoryIds([]);
      setFourthCategoryIds([]);
    }

  }];
};
/**
 * 类目过滤
 * 20-09-22
 */

function categoryFilter(type) {
  return categoryies => categoryies.filter(cate => {
    if (type === _utils__WEBPACK_IMPORTED_MODULE_2__/* .POOL_TYPE.FRESH */ .FP.FRESH) {
      return +cate.categoryId === FRESH_CATE_CODE; // 生鲜只留生鲜
    } else {
      return +cate.categoryId !== FRESH_CATE_CODE; // 快消排除生鲜
    }
  });
}

/***/ }),

/***/ 71151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O6": function() { return /* binding */ FUNC; },
/* harmony export */   "FP": function() { return /* binding */ POOL_TYPE; },
/* harmony export */   "fb": function() { return /* binding */ DEMAND_TYPE; },
/* harmony export */   "gn": function() { return /* binding */ TAB_TYPE; },
/* harmony export */   "l": function() { return /* binding */ APPROVE_STATUS_OPT; },
/* harmony export */   "Oq": function() { return /* binding */ APPROVE_STATUS; },
/* harmony export */   "jY": function() { return /* binding */ supplyRouteList; },
/* harmony export */   "al": function() { return /* binding */ changeApproveStatus; },
/* harmony export */   "G$": function() { return /* binding */ validateForm; },
/* harmony export */   "xT": function() { return /* binding */ LOGISTICE_MODE; },
/* harmony export */   "g2": function() { return /* binding */ RETURN_MODE; },
/* harmony export */   "B5": function() { return /* binding */ mergeArr; },
/* harmony export */   "ME": function() { return /* binding */ seconds2minute; },
/* harmony export */   "yQ": function() { return /* binding */ getApproveSummary; },
/* harmony export */   "zN": function() { return /* binding */ formatPlaceGroup; },
/* harmony export */   "dy": function() { return /* binding */ treeSelectList; },
/* harmony export */   "kp": function() { return /* binding */ uniqueOptions; },
/* harmony export */   "v0": function() { return /* binding */ ONE_PAGE_COL; },
/* harmony export */   "Y1": function() { return /* binding */ ONE_PAGE_ROW; },
/* harmony export */   "FN": function() { return /* binding */ assembleGoodsPrintTpl; },
/* harmony export */   "y8": function() { return /* binding */ cancelPooling; },
/* harmony export */   "hQ": function() { return /* binding */ onekeyBalanceStock; },
/* harmony export */   "XK": function() { return /* binding */ useBatchUpdateDelivery; },
/* harmony export */   "H8": function() { return /* binding */ backfill; },
/* harmony export */   "MO": function() { return /* binding */ editChange; },
/* harmony export */   "FU": function() { return /* binding */ convertBusiness_with_Place; },
/* harmony export */   "MU": function() { return /* binding */ limitDay_for_RangePicker; },
/* harmony export */   "gz": function() { return /* binding */ STOCK_SUPPLIER; },
/* harmony export */   "KZ": function() { return /* binding */ convertValue_arr2let; }
/* harmony export */ });
/* unused harmony exports map2options, options2map, LINE_FLAG, APPROVE_STATUS_MAP, RETURNE_OPTS, getSupplier, getDemandPoolingReferencePrice, BILL_TYPE, getPlaceProductSales, usePlaceList, useJionList, ONE_PAGE_ITEMS, refreshDCStock, queryProductExtInfo, sorterHelper, querystring */
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(34041);
/* harmony import */ var antd_es_radio_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88983);
/* harmony import */ var antd_es_radio__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(55742);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(48086);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24731);
/* harmony import */ var _hooks_useEnums__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16965);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7704);


















/** 详情页功能标识 */
var FUNC;

(function (FUNC) {
  FUNC["APPROVE"] = "_approve";
  FUNC["VIEW"] = "_view";
})(FUNC || (FUNC = {}));

var map2options = map => {
  return Array.from(map).map(_ref => {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return {
      value: k,
      label: v
    };
  });
};
var options2map = options => {
  return new Map(options.map(_ref3 => {
    var value = _ref3.value,
        label = _ref3.label;
    return [+value, label];
  }));
};
/**
 * int32 categoryType = 6; // 1.生鲜 2.快消  必传
 */

var POOL_TYPE;
/**
 * int32 demandType = 8; // 需求类型：1补货；2退货  必传
 */

(function (POOL_TYPE) {
  POOL_TYPE[POOL_TYPE["FRESH"] = 1] = "FRESH";
  POOL_TYPE[POOL_TYPE["QUICK"] = 2] = "QUICK";
})(POOL_TYPE || (POOL_TYPE = {}));

var DEMAND_TYPE;

(function (DEMAND_TYPE) {
  DEMAND_TYPE[DEMAND_TYPE["SUUPLEMENT"] = 1] = "SUUPLEMENT";
  DEMAND_TYPE[DEMAND_TYPE["RETURN"] = 2] = "RETURN";
})(DEMAND_TYPE || (DEMAND_TYPE = {}));

var TAB_TYPE;
/** 回落数据标记 */

(function (TAB_TYPE) {
  TAB_TYPE["GOODS"] = "GOODS";
  TAB_TYPE["PLACE"] = "PLACE";
})(TAB_TYPE || (TAB_TYPE = {}));

var LINE_FLAG;
/**
 * 操作类型：1开始审核；2取消审核；3审核通过；4审核不通过
 */

(function (LINE_FLAG) {
  LINE_FLAG["\u65B0\u6DFB"] = "\u65B0\u6DFB";
  LINE_FLAG["\u56DE\u586B"] = "\u56DE\u586B";
})(LINE_FLAG || (LINE_FLAG = {}));

var APPROVE_STATUS_OPT;

(function (APPROVE_STATUS_OPT) {
  APPROVE_STATUS_OPT[APPROVE_STATUS_OPT["\u5F00\u59CB\u5BA1\u6838"] = 1] = "\u5F00\u59CB\u5BA1\u6838";
  APPROVE_STATUS_OPT[APPROVE_STATUS_OPT["\u53D6\u6D88\u5BA1\u6838"] = 2] = "\u53D6\u6D88\u5BA1\u6838";
  APPROVE_STATUS_OPT[APPROVE_STATUS_OPT["\u5BA1\u6838\u901A\u8FC7"] = 3] = "\u5BA1\u6838\u901A\u8FC7";
  APPROVE_STATUS_OPT[APPROVE_STATUS_OPT["\u5BA1\u6838\u4E0D\u901A\u8FC7"] = 4] = "\u5BA1\u6838\u4E0D\u901A\u8FC7";
})(APPROVE_STATUS_OPT || (APPROVE_STATUS_OPT = {}));

var APPROVE_STATUS;

(function (APPROVE_STATUS) {
  APPROVE_STATUS[APPROVE_STATUS["\u5F85\u5BA1\u6838"] = 1] = "\u5F85\u5BA1\u6838";
  APPROVE_STATUS[APPROVE_STATUS["\u5BA1\u6838\u4E2D"] = 2] = "\u5BA1\u6838\u4E2D";
  APPROVE_STATUS[APPROVE_STATUS["\u5BA1\u6838\u901A\u8FC7"] = 3] = "\u5BA1\u6838\u901A\u8FC7";
  APPROVE_STATUS[APPROVE_STATUS["\u5BA1\u6838\u4E0D\u901A\u8FC7"] = 4] = "\u5BA1\u6838\u4E0D\u901A\u8FC7";
  APPROVE_STATUS[APPROVE_STATUS["\u96C6\u5355\u4E2D"] = 5] = "\u96C6\u5355\u4E2D";
  APPROVE_STATUS[APPROVE_STATUS["\u96C6\u5355\u5931\u8D25"] = 6] = "\u96C6\u5355\u5931\u8D25";
})(APPROVE_STATUS || (APPROVE_STATUS = {}));

var APPROVE_STATUS_MAP = new Map([[1, '待审核'], [2, '审核中'], [3, '审核通过'], [4, '审核不通过'], [5, '集单中'], [6, '集单失败']]);
/**
 * 供货路径
 */

var supplyRouteList = [{
  value: 1,
  label: '台州仓-城市仓-城市店'
}, {
  value: 2,
  label: '台州仓-城市仓'
}, {
  value: 3,
  label: '台州仓-城市店'
}];
/**
 * 修改审核状态
 * @param poolingId 集单号
 */

var changeApproveStatus = /*#__PURE__*/function () {
  var _ref4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee(poolingId, operateType) {
    var url;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = 'purchase.demandPooling.updateDemandPoolingStatus';
            return _context.abrupt("return", (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(url, {
              poolingId,
              operateType
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function changeApproveStatus(_x, _x2) {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * 验证表单
 */

var validateForm = /*#__PURE__*/function () {
  var _ref5 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee2(form) {
    var _ref6,
        _ref6$begin,
        begin,
        _ref6$end,
        end,
        _ref6$arrivalBegin,
        arrivalBegin,
        _ref6$arrivalEnd,
        arrivalEnd,
        values,
        _args2 = arguments;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref6 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, _ref6$begin = _ref6.begin, begin = _ref6$begin === void 0 ? 'beginCreateTime' : _ref6$begin, _ref6$end = _ref6.end, end = _ref6$end === void 0 ? 'endCreateTime' : _ref6$end, _ref6$arrivalBegin = _ref6.arrivalBegin, arrivalBegin = _ref6$arrivalBegin === void 0 ? 'arrivalDateFrom' : _ref6$arrivalBegin, _ref6$arrivalEnd = _ref6.arrivalEnd, arrivalEnd = _ref6$arrivalEnd === void 0 ? 'arrivalDateTo' : _ref6$arrivalEnd;

            if (form) {
              _context2.next = 3;
              break;
            }

            throw new Error('form 实例不能为空');

          case 3:
            _context2.prev = 3;
            _context2.next = 6;
            return form.current.validateFields();

          case 6:
            values = _context2.sent;

            if (Array.isArray(values.time) && values.time.length) {
              values[begin] = values.time[0].format('YYYY-MM-DD 00:00:00');
              values[end] = values.time[1].format('YYYY-MM-DD 23:59:59');
            }

            if (Array.isArray(values.arrivalDay) && values.arrivalDay.length) {
              values[arrivalBegin] = values.arrivalDay[0].format('YYYY-MM-DD 00:00:00');
              values[arrivalEnd] = values.arrivalDay[1].format('YYYY-MM-DD 23:59:59');
            }

            Object.entries(values).forEach(_ref7 => {
              var _ref8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_ref7, 2),
                  k = _ref8[0],
                  v = _ref8[1];

              return v || delete values[k];
            });
            delete values.time;
            delete values.arrivalDay;
            return _context2.abrupt("return", values);

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](3);
            return _context2.abrupt("return", null);

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 15]]);
  }));

  return function validateForm(_x3) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * 物流模式 1直送；2配送；3直通
 */

var LOGISTICE_MODE; // 直通是统一退大仓后退供应商
// 退货方式：退供应商（直送）
// 退货方式：退仓（配送）
// 退DC后退供应商：直通（DC-大仓）

/**
 * 退货方式,对应三种物流模式
 * [{"value":1,"label":"退仓后退供应商","others":"1"},{"value":2,"label":"退仓后退供应商","others":"2"},{"value":3,"label":"退仓后退供应商","others":"3"}]
 */

(function (LOGISTICE_MODE) {
  LOGISTICE_MODE[LOGISTICE_MODE["\u76F4\u9001"] = 1] = "\u76F4\u9001";
  LOGISTICE_MODE[LOGISTICE_MODE["\u914D\u9001"] = 2] = "\u914D\u9001";
  LOGISTICE_MODE[LOGISTICE_MODE["\u76F4\u901A"] = 3] = "\u76F4\u901A";
})(LOGISTICE_MODE || (LOGISTICE_MODE = {}));

var RETURN_MODE;

(function (RETURN_MODE) {
  RETURN_MODE[RETURN_MODE["\u9000\u4F9B\u5E94\u5546"] = 1] = "\u9000\u4F9B\u5E94\u5546";
  RETURN_MODE[RETURN_MODE["\u9000\u4ED3"] = 2] = "\u9000\u4ED3";
  RETURN_MODE[RETURN_MODE["\u9000\u4ED3\u540E\u9000\u4F9B\u5E94\u5546"] = 3] = "\u9000\u4ED3\u540E\u9000\u4F9B\u5E94\u5546";
})(RETURN_MODE || (RETURN_MODE = {}));

var RETURNE_OPTS = [{
  label: '退供应商',
  value: 1
}, {
  label: '退仓',
  value: 2
}, {
  label: '退仓后退供应商',
  value: 3
}];

/**
 * @deprecated
 * 获取供应商
 * 文档：https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=31960057#id-%E9%80%9A%E7%94%A8%E5%95%86%E5%93%81%E6%A8%A1%E5%9D%97%E6%8E%A5%E5%8F%A3-2.4%E6%9F%A5%E8%AF%A2%E5%95%86%E5%93%81%E4%BE%9B%E5%BA%94%E5%95%86%E4%BF%A1%E6%81%AF
 */
function getSupplier(_x4) {
  return _getSupplier.apply(this, arguments);
}

function _getSupplier() {
  _getSupplier = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(tableList) {
    var url, paramList, res, _yield$ypRequest4, success, result;

    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (Array.isArray(tableList) && tableList.length) {
              _context6.next = 3;
              break;
            }

            console.warn('getSupplier-获取供应商参数无效', tableList);
            return _context6.abrupt("return", Promise.resolve([]));

          case 3:
            url = 'purchase.product.queryProductSupplier';
            paramList = tableList.map(item => {
              var json = {
                merchantId: item.merchantId,
                // 商家Id
                goodsId: item.goodsId,
                // 商品Id列表
                placeId: item.placeId // 地点Id

              };

              if (json.merchantId && json.goodsId && json.placeId) {
                return json;
              }

              return null;
            }).filter(_ => _);
            res = [];
            _context6.next = 8;
            return ypRequest(url, {
              paramList
            });

          case 8:
            _yield$ypRequest4 = _context6.sent;
            success = _yield$ypRequest4.success;
            result = _yield$ypRequest4.result;

            if (success) {
              res = result.list.map(item => _objectSpread(_objectSpread({}, item), {}, {
                options: item.supplier.map(item2 => ({
                  label: item2.supplierName,
                  value: item2.supplierCode
                }))
              }));
            }

            return _context6.abrupt("return", res);

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getSupplier.apply(this, arguments);
}

/**
 * @deprecated
 * 获取集单里商品的参考采购价、配送价
 * 文档：https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=31960057#id-通用商品模块接口-2.2获取集单里商品的参考采购价、配送价
 */
function getReferencePrice2(_x5, _x6) {
  return _getReferencePrice.apply(this, arguments);
}

function _getReferencePrice() {
  _getReferencePrice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(orderDirect, tableList) {
    var url, paramList, res, _yield$ypRequest5, success, result;

    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (Array.isArray(tableList) && tableList.length) {
              _context7.next = 3;
              break;
            }

            console.warn('getReferencePrice-参考采购价、配送价参数无效', tableList);
            return _context7.abrupt("return", Promise.resolve([]));

          case 3:
            url = 'purchase.demandPooling.queryDemandPoolingReferencePrice';
            paramList = tableList.map(item => ({
              merchantId: item.merchantId,
              // 商家Id
              goodsId: item.goodsId,
              // 商品Id列表
              placeId: item.placeId,
              // 地点Id
              firstCategoryId: item.firstCategoryId,
              // 商品一级类目
              secondCategoryId: item.secondCategoryId // 商品二级类目

            }));
            res = [];
            _context7.next = 8;
            return ypRequest(url, {
              orderDirect,
              paramList
            });

          case 8:
            _yield$ypRequest5 = _context7.sent;
            success = _yield$ypRequest5.success;
            result = _yield$ypRequest5.result;

            if (success) {
              res = result.list;
            }

            return _context7.abrupt("return", res);

          case 13:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getReferencePrice.apply(this, arguments);
}

/**
 * 获取集单里商品的参考采购价、成本价
 * https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=31960057#id-通用商品模块接口-2.2获取集单里商品的参考采购价、成本价
 */
function getDemandPoolingReferencePrice(_x7) {
  return _getDemandPoolingReferencePrice.apply(this, arguments);
}
/** 单据类型 */

function _getDemandPoolingReferencePrice() {
  _getDemandPoolingReferencePrice = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee8(arg0) {
    var url, params, res, _yield$ypRequest6, success, result;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (Array.isArray(arg0.tableList) && arg0.tableList.length) {
              _context8.next = 3;
              break;
            }

            console.warn('getReferencePrice-参考采购价、配送价参数无效', arg0.tableList);
            return _context8.abrupt("return", Promise.resolve([]));

          case 3:
            url = 'purchase.demandPooling.queryDemandPoolingReferencePrice';
            params = {
              orderDirect: arg0.orderDirect,
              // 订单方向
              firstCategoryId: arg0.firstCategoryId,
              // 一级类目ID
              merchantId: arg0.merchantId,
              // 商家ID
              goodsList: arg0.tableList.map(item => ({
                goodsId: item.goodsId,
                // 商品 id
                logistics: item.logistics,
                // 物流模式
                placeId: item.placeId,
                // 地点ID
                deliveryDcId: item.deliveryDcId // 大仓ID

              }))
            };
            res = [];
            _context8.next = 8;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(url, params);

          case 8:
            _yield$ypRequest6 = _context8.sent;
            success = _yield$ypRequest6.success;
            result = _yield$ypRequest6.result;

            if (success) {
              res = result.list;
            }

            return _context8.abrupt("return", res);

          case 13:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _getDemandPoolingReferencePrice.apply(this, arguments);
}

var BILL_TYPE;

(function (BILL_TYPE) {
  BILL_TYPE[BILL_TYPE["\u672A\u77E5"] = 0] = "\u672A\u77E5";
  BILL_TYPE[BILL_TYPE["\u91C7\u8D2D\u8BA2\u8D27"] = 1] = "\u91C7\u8D2D\u8BA2\u8D27";
  BILL_TYPE[BILL_TYPE["\u91C7\u8D2D\u9000\u8D27"] = 2] = "\u91C7\u8D2D\u9000\u8D27";
  BILL_TYPE[BILL_TYPE["\u4ED3\u95F4\u8C03\u62E8"] = 3] = "\u4ED3\u95F4\u8C03\u62E8";
  BILL_TYPE[BILL_TYPE["\u5E97\u95F4\u8C03\u62E8"] = 4] = "\u5E97\u95F4\u8C03\u62E8";
  BILL_TYPE[BILL_TYPE["\u4ED3\u5E97\u914D\u9001"] = 5] = "\u4ED3\u5E97\u914D\u9001";
  BILL_TYPE[BILL_TYPE["\u8981\u8D27\u96C6\u5355"] = 6] = "\u8981\u8D27\u96C6\u5355";
  BILL_TYPE[BILL_TYPE["\u9000\u8D27\u96C6\u5355"] = 7] = "\u9000\u8D27\u96C6\u5355";
  BILL_TYPE[BILL_TYPE["\u6279\u53D1\u9500\u552E"] = 8] = "\u6279\u53D1\u9500\u552E";
  BILL_TYPE[BILL_TYPE["\u5E97\u4ED3\u9000\u914D"] = 9] = "\u5E97\u4ED3\u9000\u914D";
  BILL_TYPE[BILL_TYPE["\u91C7\u8D2D\u5206\u914D\u5355\u8BA2\u8D27"] = 10] = "\u91C7\u8D2D\u5206\u914D\u5355\u8BA2\u8D27";
  BILL_TYPE[BILL_TYPE["\u91C7\u8D2D\u5206\u914D\u5355\u9000\u8D27"] = 11] = "\u91C7\u8D2D\u5206\u914D\u5355\u9000\u8D27";
  BILL_TYPE[BILL_TYPE["\u5206\u62E8\u8BA2\u5355\u4ED3\u95F4\u8C03\u62E8"] = 12] = "\u5206\u62E8\u8BA2\u5355\u4ED3\u95F4\u8C03\u62E8";
  BILL_TYPE[BILL_TYPE["\u5206\u62E8\u8BA2\u5355\u5E97\u95F4\u8C03\u62E8"] = 13] = "\u5206\u62E8\u8BA2\u5355\u5E97\u95F4\u8C03\u62E8";
  BILL_TYPE[BILL_TYPE["\u5206\u62E8\u8BA2\u5355\u4ED3\u5E97\u914D\u9001"] = 14] = "\u5206\u62E8\u8BA2\u5355\u4ED3\u5E97\u914D\u9001";
  BILL_TYPE[BILL_TYPE["\u5206\u62E8\u8BA2\u5355\u5E97\u4ED3\u9000\u914D"] = 15] = "\u5206\u62E8\u8BA2\u5355\u5E97\u4ED3\u9000\u914D";
})(BILL_TYPE || (BILL_TYPE = {}));

/**
 * @deprecated
 * 根据商家+地点+编码查询商品销量(地点维度)
 * 文档：https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=31960057#id-通用商品模块接口-1.8根据商家+地点+编码查询商品销量(地点维度)
 */
function getPlaceProductSales(_x8) {
  return _getPlaceProductSales.apply(this, arguments);
}
/**
 * 合并两个数组
 */

function _getPlaceProductSales() {
  _getPlaceProductSales = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(tableList) {
    var url, paramList, res, _yield$ypRequest7, success, result;

    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (Array.isArray(tableList) && tableList.length) {
              _context9.next = 3;
              break;
            }

            console.warn('getPlaceProductSales-根据商家+地点+编码查询商品销量，参数无效', tableList);
            return _context9.abrupt("return", Promise.resolve([]));

          case 3:
            url = 'purchase.product.queryPlaceProductSales';
            paramList = tableList.map(item => ({
              merchantId: item.merchantId,
              // 商家Id
              goodsId: item.goodsId,
              // 商品Id列表
              placeId: item.placeId // 地点Id

            }));
            res = [];
            _context9.next = 8;
            return ypRequest(url, {
              paramList
            });

          case 8:
            _yield$ypRequest7 = _context9.sent;
            success = _yield$ypRequest7.success;
            result = _yield$ypRequest7.result;

            if (success) {
              res = result.list;
            }

            return _context9.abrupt("return", res);

          case 13:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _getPlaceProductSales.apply(this, arguments);
}

function mergeArr() {
  var arr1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var arr2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var field = arguments.length > 2 ? arguments[2] : undefined;
  return arr1.map(item1 => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)({}, item1), arr2.find(item2 => {
    if (Array.isArray(field)) {
      // 方式1
      var rest = field.map(str => item2[str] === item1[str]).filter(b => !b);
      return rest.length === 0; // 方式2
      // const bool = field.reduce((acc, cur, idx) => acc && item2[cur] === item1[cur], true)
      // return bool
    } else {
      return item2[field] === item1[field];
    }
  })));
} // /**
//  * 返回：数组交集、并集
//  * 并集有问题: 20-07-09
//  */
// export function intersectionArr(arr1: Array<any> = [], arr2: Array<any> = [], field: string | string[]) {
//   const _arr1: Array<any> = []
//   const _arr2: Array<any> = []
//   arr1.forEach(item1 => {
//     _arr2.push(JSON.parse(JSON.stringify(item1)))
//     let first_index = -1
//     arr2.forEach((item2, idx2) => {
//       let bool: boolean
//       if (Array.isArray(field)) {
//         bool = field.reduce((acc, key, i) => acc && item2[key] === item1[key], true) as any
//       } else {
//         bool = item2[field] === item1[field]
//       }
//       if (!bool) {
//         _arr2.push(JSON.parse(JSON.stringify(item2)))
//       }
//       if (bool && first_index === -1) first_index = idx2
//     })
//     if (first_index !== -1) {
//       _arr1.push(JSON.parse(JSON.stringify(arr2[first_index])))
//     }
//   })
//   return [
//     /** 交集 */
//     _arr1,
//     /** 并集 */
//     _arr2
//   ]
// }

/** 秒 -> 分 */

function seconds2minute(str) {
  var splitor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '~';

  try {
    var tmp = str.split(splitor);

    if (tmp.length === 2) {
      return [tmp[0].substr(0, 10), tmp[1].substr(0, 10)].join(splitor);
    }

    return tmp[0].substr(0, 10);
  } catch (error) {
    return str;
  }
}

/**
 * 审核汇总
 * https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=29184742#id-%E9%9C%80%E6%B1%82%E5%B9%B3%E8%A1%A1-2.17%E6%9F%A5%E8%AF%A2%E9%9B%86%E5%8D%95%E6%B1%87%E6%80%BB%E4%BF%A1%E6%81%AF
 */
function getApproveSummary(_x9) {
  return _getApproveSummary.apply(this, arguments);
}

function _getApproveSummary() {
  _getApproveSummary = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee10(params) {
    var _yield$ypRequest8, success, result;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)('purchase.demandPooling.statPoolingGoodsInfo', {
              condition: params
            });

          case 2:
            _yield$ypRequest8 = _context10.sent;
            success = _yield$ypRequest8.success;
            result = _yield$ypRequest8.result;
            return _context10.abrupt("return", success ? result : getApproveSummary.defaultApproveSummary);

          case 6:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _getApproveSummary.apply(this, arguments);
}

getApproveSummary.defaultApproveSummary = {
  supplierCount: '-',
  skuNum: '-',
  totalApplyNum: '-',
  totalApproveNum: '-',
  totalAmount: '-',
  abnormalGoodsCount: '-',
  totalCostPrice: '-',
  _failed: true
};
/** 店群下门店 */

/** 格式化店群数据 */
function formatPlaceGroup(rawMap) {
  if (Array.isArray(rawMap) || !rawMap) {
    return [];
  }

  return Object.entries(rawMap).map(_ref9 => {
    var _ref10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_ref9, 2),
        val = _ref10[1];

    var _ref11 = JSON.parse(val),
        placeGroupName = _ref11.placeGroupName,
        placeGroupId = _ref11.placeGroupId,
        placeList = _ref11.placeList;

    return {
      label: placeGroupName,
      value: placeGroupId,
      placeList
    };
  });
}
function treeSelectList(_x10, _x11) {
  return _treeSelectList.apply(this, arguments);
}
/** 获取店群下的门店 */

function _treeSelectList() {
  _treeSelectList = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee11(merchantId, setTreeData) {
    var _yield$ypRequest9, success, result, listData;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)("pms.pmsMerchantService.queryGroupsAndWarehouseByMerchantId", {
              merchantId: Number(merchantId)
            });

          case 2:
            _yield$ypRequest9 = _context11.sent;
            success = _yield$ypRequest9.success;
            result = _yield$ypRequest9.result;

            if (success) {
              listData = result === null || result === void 0 ? void 0 : result.list.filter(item => {
                if (item.flag === 1) {
                  item === null || item === void 0 ? void 0 : item.children.map(itemData => {
                    itemData.title = "".concat(itemData === null || itemData === void 0 ? void 0 : itemData.code, "-").concat(itemData.title);
                  });
                  return item;
                }
              });
              setTreeData(listData);
            }

          case 6:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _treeSelectList.apply(this, arguments);
}

function usePlaceList() {
  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      placeGroupId = _useState2[0],
      setPlaceGroupId = _useState2[1];

  var _useEnums = useEnums(60, {
    placeGroupId
  }),
      _useEnums2 = _slicedToArray(_useEnums, 2),
      _useEnums2$ = _useEnums2[1],
      raw = _useEnums2$ === void 0 ? {} : _useEnums2$;

  var place = {};

  try {
    place = JSON.parse(raw[placeGroupId || '']);
  } catch (error) {}

  var placeList = (place.placeList || []).map(_ => ({
    label: _.shotName,
    value: _.placeId,
    $raw: _
  }));
  return {
    placeList: placeGroupId ? placeList :
    /** 无店群用原来的全部地点 */
    [],
    setPlaceGroupId
  };
}
function useJionList() {
  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      placeGroupId = _useState4[0],
      setPlaceGroupId = _useState4[1];

  var _useEnums3 = useEnums(60, {
    placeGroupId
  }),
      _useEnums4 = _slicedToArray(_useEnums3, 2),
      _useEnums4$ = _useEnums4[1],
      raw = _useEnums4$ === void 0 ? {} : _useEnums4$;

  var place = {};

  try {
    place = JSON.parse(raw[placeGroupId || '']);
  } catch (error) {}

  var placeList = (place.placeList || []).map(_ => ({
    title: _.shotName,
    value: _.placeId,
    key: _.placeId,
    isLeaf: true
  }));
  return {
    placeList: placeGroupId ? placeList :
    /** 无店群用原来的全部地点 */
    [],
    placeGroupId,
    setPlaceGroupId
  };
}
/** 数组去重 */

function uniqueOptions(arr) {
  return [...new Set(arr.map(_ => _.value))].map(_ => arr.find(ele => ele.value === _)).filter(_ => _);
}
var ONE_PAGE_COL = 3; // 分三列打印

var ONE_PAGE_ROW = 31; // 行数

var ONE_PAGE_ITEMS = ONE_PAGE_COL * ONE_PAGE_ROW; // 单页总数据量

/**
 * 装配打印模板
 * record 即代表一页 A4 纸，item.detail 为 A4 纸一页数据
 */

function assembleGoodsPrintTpl(record) {
  var title = [[{
    n: '采购日期',
    f: 'purchaseDate'
  }, {
    n: '采购商品',
    f: 'goodsName',

    /* value style */
    vs: 'font-weight:bold; font-size:14px;'
  }, {
    n: '商品总重',
    f: 'totalQty',
    vs: 'font-weight:bold; font-size:14px;'
  }, {
    n: '商品单位',
    f: 'unit'
  }], [{
    n: '供应商名称',
    f: ''
  }, {
    n: '商品编码',
    f: 'goodsId'
  }, {
    n: '联系方式',
    f: ''
  }, {
    n: '商品规格',
    f: 'spec'
  }], [{
    n: '采购员签字',
    f: ''
  }, {
    n: '送货员签字',
    f: ''
  }, {
    n: '质检签字',
    f: ''
  }, {
    n: '仓位号',
    f: ''
  }]].map(strs => {
    var labelStyle = "style=\"display:inline-block;width:9%;line-height:24px;font-size:12px;margin-left:1.4%;\"";

    var valueStyle = function valueStyle() {
      var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return "style=\"display:inline-block;width:13%;line-height:24px;font-size:12px;border-bottom:1px solid black;".concat(style, "\"");
    };

    var spans = "\n      <span ".concat(labelStyle, ">").concat(strs[0].n, "</span> <span ").concat(valueStyle(strs[0].vs), ">").concat(record[strs[0].f] || '&nbsp;', "</span>\n      <span ").concat(labelStyle, ">").concat(strs[1].n, "</span> <span ").concat(valueStyle(strs[1].vs), ">").concat(record[strs[1].f] || '&nbsp;', "</span>\n      <span ").concat(labelStyle, ">").concat(strs[2].n, "</span> <span ").concat(valueStyle(strs[2].vs), ">").concat(record[strs[2].f] || '&nbsp;', "</span>\n      <span ").concat(labelStyle, ">").concat(strs[3].n, "</span> <span ").concat(valueStyle(strs[3].vs), ">").concat(record[strs[3].f] || '&nbsp;', "</span>");
    return "<div>".concat(spans.trim(), "</div>");
  });
  var fillPrintRecord = {
    detail: {}
  };
  var length = ONE_PAGE_ITEMS - record.detail.length % ONE_PAGE_ITEMS + record.detail.length; // 补充每页空白

  var tableDataArr = new Array(length).fill(fillPrintRecord).map((_, i) => record.detail[i] || _);
  var tableArr_chunked = (0,lodash__WEBPACK_IMPORTED_MODULE_7__.chunk)(tableDataArr, ONE_PAGE_ROW); // 按每列排列行数切割

  var trStyle = "style=\"height:26px;\"";

  var table = dataSource => {
    var tdCenter = "style=\"text-align:center;\"";
    var trs = dataSource.map((_ref12, idx) => {
      var placeCode = _ref12.placeCode,
          sortName = _ref12.sortName,
          qty = _ref12.qty;
      var sortName_style = (sortName || '').length >=
      /* 两列取 11，三列取 7 */
      7 ? "style=\"font-size:10px;\"" : '';
      return "<tr ".concat(trStyle.trim(), ">\n        <td ").concat(tdCenter, ">").concat(placeCode || '', "</td>\n        <td ").concat(sortName_style, ">").concat(sortName || '', "</td>\n        <td ").concat(tdCenter, ">").concat(qty || '', "</td>\n        <td></td>\n      </tr>");
    });
    var tableStyle = "\n    border=\"1\" style=\"border-spacing:0;border-collapse:collapse;font-size:13px;float:left;width:".concat((1 / ONE_PAGE_COL * 100 - 1).toFixed(2), "%;margin:0 .5%;\"\n    ");
    return "<table ".concat(tableStyle.trim(), ">\n      <thead>\n        <tr>\n          <th style=\"width:20%;text-align:center;\">\u5E97\u7F16\u53F7</th>\n          <th style=\"width:40%;font-weight:bold;\">\u5E97\u7B80\u79F0</th>\n          <th style=\"width:20%;text-align:center;font-size:10px;\">\u8981\u8D27\u6570\u91CF</th>\n          <th style=\"width:20%;font-size:10px;\">\u5B9E\u5206\u6570\u91CF</th>\n        </tr>\n      </thead>\n      <tbody>\n        ").concat(trs, "\n      </tbody>\n    </table>");
  };

  var tables = tableArr_chunked.map(d => table(d));
  var bottomLabelStyle = "style=\"display:inline-block;font-size:12px;line-height:24px;width:9%;margin-left:1%;\"";
  var bottomValueStyle = "style=\"display:inline-block;font-size:12px;line-height:24px;width:15%;border-bottom:1px solid black;\"";
  var bottom = "\n  <div style=\"text-align:center;margin-top:15px;clear:both;\">\n  <span ".concat(bottomLabelStyle, ">\u53D1\u8D27\u603B\u91CD\u91CF</span> <span ").concat(bottomValueStyle, ">&nbsp;</span>\n  <span ").concat(bottomLabelStyle, ">\u5355\u4EF7</span> <span ").concat(bottomValueStyle, ">&nbsp;</span>\n  <span ").concat(bottomLabelStyle, ">\u603B\u91D1\u989D</span> <span ").concat(bottomValueStyle, ">&nbsp;</span>\n  </div>\n  ");
  var pages = (0,lodash__WEBPACK_IMPORTED_MODULE_7__.chunk)(tables, ONE_PAGE_COL);
  return {
    title,
    tables,
    pages,
    A4_pages: pages.map(tablesOfA4 => "\n      <div style=\"text-align:center;margin-bottom:5px;font-size:16px;font-weight:bold;\">\u8C0A\u54C1\u751F\u9C9C\u91C7\u8D2D\u5355</div>\n      ".concat(title, "\n      <div style=\"margin-top:15px;padding:0 7px;\">\n        <div>").concat(tablesOfA4.join(''), "</div>\n        ").concat(record.isLastPage ? bottom.trim() : '', "\n      </div>").trim())
  };
}
/**
 * 取消集单
 */

function cancelPooling(poolingId) {
  return new Promise((resolve, reject) => {
    antd_es_modal__WEBPACK_IMPORTED_MODULE_13__/* .default.confirm */ .Z.confirm({
      content: '是否确定取消',

      onOk() {
        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee3() {
          var _yield$ypRequest, success, result;

          return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)('purchase.demandPooling.cancelDemandPooling', {
                    poolingId
                  });

                case 2:
                  _yield$ypRequest = _context3.sent;
                  success = _yield$ypRequest.success;
                  result = _yield$ypRequest.result;

                  if (success && result) {
                    antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.success('取消成功');
                  }

                  resolve(success && result);

                case 7:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      }

    });
  });
}

function get_refreshDCStock_res(_x12) {
  return _get_refreshDCStock_res.apply(this, arguments);
}
/**
 * 刷新大仓库存
 */


function _get_refreshDCStock_res() {
  _get_refreshDCStock_res = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(poolingId) {
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt("return", new Promise((resolve, reject) => {
              var refresh = /*#__PURE__*/function () {
                var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(poolingId) {
                  var _yield$ypRequest10, success, result;

                  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                    while (1) {
                      switch (_context12.prev = _context12.next) {
                        case 0:
                          _context12.next = 2;
                          return ypRequest('require.poolingorder.refreshStockUpdateResult', {
                            poolingId
                          });

                        case 2:
                          _yield$ypRequest10 = _context12.sent;
                          success = _yield$ypRequest10.success;
                          result = _yield$ypRequest10.result;

                          if (!success) {
                            resolve([false, false]); // 网关报错
                          } else if (result) {
                            resolve([true, true]); // 成功
                          } else {
                            setTimeout(() => {
                              refresh(poolingId);
                            }, 999); // 轮询刷新
                          }

                        case 6:
                        case "end":
                          return _context12.stop();
                      }
                    }
                  }, _callee12);
                }));

                return function refresh(_x19) {
                  return _ref21.apply(this, arguments);
                };
              }();

              setTimeout(() => {
                refresh(poolingId);
              }, 999);
            }));

          case 1:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _get_refreshDCStock_res.apply(this, arguments);
}

function refreshDCStock(_x13) {
  return _refreshDCStock.apply(this, arguments);
}

function _refreshDCStock() {
  _refreshDCStock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(poolingId) {
    var listen,
        _args15 = arguments;
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            listen = _args15.length > 1 && _args15[1] !== undefined ? _args15[1] : bool => {};
            return _context15.abrupt("return", new Promise( /*#__PURE__*/function () {
              var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(resolve, reject) {
                var _yield$ypRequest11, success, result;

                return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                  while (1) {
                    switch (_context14.prev = _context14.next) {
                      case 0:
                        listen(true);
                        _context14.next = 3;
                        return ypRequest('purchase.demandPooling.refreshStock', {
                          poolingId
                        });

                      case 3:
                        _yield$ypRequest11 = _context14.sent;
                        success = _yield$ypRequest11.success;
                        result = _yield$ypRequest11.result;

                        if (success) {
                          _context14.next = 11;
                          break;
                        }

                        resolve([false, false]); // 网关报错

                        listen(false);
                        _context14.next = 17;
                        break;

                      case 11:
                        _context14.t0 = resolve;
                        _context14.next = 14;
                        return get_refreshDCStock_res(poolingId);

                      case 14:
                        _context14.t1 = _context14.sent;
                        (0, _context14.t0)(_context14.t1);
                        // 获取结果
                        listen(false);

                      case 17:
                      case "end":
                        return _context14.stop();
                    }
                  }
                }, _callee14);
              }));

              return function (_x20, _x21) {
                return _ref22.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _refreshDCStock.apply(this, arguments);
}

function get_onekeyBalanceStock_res(poolingId) {
  return new Promise((resolve, reject) => {
    var refresh = /*#__PURE__*/function () {
      var _ref13 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee4(poolingId) {
        var _yield$ypRequest2, success, result;

        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)('purchase.demandPooling.refreshBalanceStockResult', {
                  poolingId
                });

              case 2:
                _yield$ypRequest2 = _context4.sent;
                success = _yield$ypRequest2.success;
                result = _yield$ypRequest2.result;

                if (!success) {
                  resolve([false, false]); // 网关报错
                } else if (result) {
                  resolve([true, true]); // 成功
                } else {
                  setTimeout(() => {
                    refresh(poolingId);
                  }, 999); // 轮询刷新
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function refresh(_x14) {
        return _ref13.apply(this, arguments);
      };
    }();

    setTimeout(() => {
      refresh(poolingId);
    }, 999);
  });
}
/**
 * 库存平衡
 */


function onekeyBalanceStock(_x15) {
  return _onekeyBalanceStock.apply(this, arguments);
}

function _onekeyBalanceStock() {
  _onekeyBalanceStock = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee18(poolingId) {
    var listen,
        _args18 = arguments;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            listen = _args18.length > 1 && _args18[1] !== undefined ? _args18[1] : bool => {};
            return _context18.abrupt("return", new Promise( /*#__PURE__*/function () {
              var _ref23 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee17(resolve, reject) {
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee17$(_context17) {
                  while (1) {
                    switch (_context17.prev = _context17.next) {
                      case 0:
                        _context17.t0 = antd_es_modal__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z;
                        _context17.t1 = {
                          content: '是否同比例分配大仓库存',

                          onCancel() {
                            resolve([false, false]);
                          },

                          onOk() {
                            return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee16() {
                              var _yield$ypRequest12, success, result;

                              return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee16$(_context16) {
                                while (1) {
                                  switch (_context16.prev = _context16.next) {
                                    case 0:
                                      listen(true);
                                      _context16.next = 3;
                                      return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)('purchase.demandPooling.balanceStock', {
                                        poolingId
                                      });

                                    case 3:
                                      _yield$ypRequest12 = _context16.sent;
                                      success = _yield$ypRequest12.success;
                                      result = _yield$ypRequest12.result;

                                      if (success) {
                                        _context16.next = 11;
                                        break;
                                      }

                                      resolve([false, false]); // 网关报错

                                      listen(false);
                                      _context16.next = 17;
                                      break;

                                    case 11:
                                      _context16.t0 = resolve;
                                      _context16.next = 14;
                                      return get_onekeyBalanceStock_res(poolingId);

                                    case 14:
                                      _context16.t1 = _context16.sent;
                                      (0, _context16.t0)(_context16.t1);
                                      // 获取结果
                                      listen(false);

                                    case 17:
                                    case "end":
                                      return _context16.stop();
                                  }
                                }
                              }, _callee16);
                            }))();
                          }

                        };

                        _context17.t0.confirm.call(_context17.t0, _context17.t1);

                      case 3:
                      case "end":
                        return _context17.stop();
                    }
                  }
                }, _callee17);
              }));

              return function (_x22, _x23) {
                return _ref23.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _onekeyBalanceStock.apply(this, arguments);
}

/**
 * 20-11-24 通用回填数据接口
 * https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=31960057#id-%E9%80%9A%E7%94%A8%E5%95%86%E5%93%81%E6%A8%A1%E5%9D%97%E6%8E%A5%E5%8F%A3-2.7%E6%9F%A5%E8%AF%A2%E5%95%86%E5%93%81%E6%89%A9%E5%B1%95%E4%BF%A1%E6%81%AF
 */
function queryProductExtInfo(_x16) {
  return _queryProductExtInfo.apply(this, arguments);
}

function _queryProductExtInfo() {
  _queryProductExtInfo = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee19(params) {
    var _yield$ypRequest13, success, result;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.next = 2;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)('purchase.product.queryProductExtInfo', params);

          case 2:
            _yield$ypRequest13 = _context19.sent;
            success = _yield$ypRequest13.success;
            result = _yield$ypRequest13.result;
            return _context19.abrupt("return", success ? result.list : []);

          case 6:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _queryProductExtInfo.apply(this, arguments);
}

// TODO weiwanc

/**
 * 批量更新配送仓
 * https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=46368304#id-4.3.1%E5%95%86%E8%A1%8C%E9%9B%86%E5%8D%95-2.25%E6%89%B9%E9%87%8F%E6%9B%B4%E6%96%B0%E9%85%8D%E9%80%81%E4%BB%93
 */
function useBatchUpdateDelivery(_ref14) {
  var beforeReq = _ref14.beforeReq,
      _ref14$afterReq = _ref14.afterReq,
      afterReq = _ref14$afterReq === void 0 ? () => {} : _ref14$afterReq,
      merchantId = _ref14.merchantId,
      _ref14$batchType = _ref14.batchType,
      batchType = _ref14$batchType === void 0 ? '紧急程度' : _ref14$batchType,
      _ref14$requestUrl = _ref14.requestUrl,
      requestUrl = _ref14$requestUrl === void 0 ? 'purchase.demandPooling.batchModifyDeliveryDc' : _ref14$requestUrl;

  var _useEnums5 = (0,_hooks_useEnums__WEBPACK_IMPORTED_MODULE_6__/* .useEnums */ .ws)(_hooks_useEnums__WEBPACK_IMPORTED_MODULE_6__/* .ENUM_DICT.authDCBusinessMapping */ .J3.authDCBusinessMapping, {
    merchantId
  }),
      _useEnums6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useEnums5, 1),
      delivery = _useEnums6[0];

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(63),
      mappingList = _useMapping.mappingList;

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(batchType),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState5, 2),
      dcId = _useState6[0],
      setDcId = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState7, 2),
      visible = _useState8[0],
      setVisible = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState9, 2),
      selected = _useState10[0],
      setSelected = _useState10[1];

  var emergLevelsList = (mappingList === null || mappingList === void 0 ? void 0 : mappingList.get(63)) || [];
  var listMap = {
    配送仓: delivery,
    紧急程度: emergLevelsList,
    供货路径: supplyRouteList
  };
  var optionDataList = listMap[dcId];
  var ModalNode = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
    title: '批量更新',

    onOk() {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee5() {
        var _ref15, params, _yield$ypRequest3, success, result;

        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _ref15 = beforeReq(dcId, selected), params = _ref15.params;

                if (!(!params.modifyDeliveryDcId && Object.keys(params.modifyInfo).length === 0)) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return", antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.warn('请选择'));

              case 3:
                _context5.next = 5;
                return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(requestUrl, params);

              case 5:
                _yield$ypRequest3 = _context5.sent;
                success = _yield$ypRequest3.success;
                result = _yield$ypRequest3.result;
                afterReq(success);

                if (success) {
                  console.log('更新 result', result);
                }

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },

    onCancel() {
      setVisible(false);
    },

    visible,
    width: 340
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_15__/* .default.Group */ .ZP.Group, {
    style: {
      marginBottom: '12px'
    },

    onChange(e) {
      setSelected(undefined);
      setDcId(e.target.value);
    },

    value: dcId
  }, // React.createElement(Radio, { value: '配送仓', children: '配送仓', key: '配送仓' }),
  batchType === '紧急程度' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_15__/* .default */ .ZP, {
    value: '紧急程度',
    children: '紧急程度',
    key: '紧急程度'
  }), batchType === '供货路径' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_15__/* .default */ .ZP, {
    value: '供货路径',
    children: '供货路径',
    key: '供货路径'
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, {
    style: {
      width: 220
    },
    placeholder: '请选择',
    allowClear: true,
    showSearch: true,
    filterOption: (input, option) => (option === null || option === void 0 ? void 0 : option.children.toLowerCase().indexOf(input.toLowerCase())) >= 0,
    value: selected,

    onChange(value) {
      setSelected(value);
    }

  }, optionDataList.map((item, idx) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_16__/* .default.Option */ .Z.Option, {
    value: item.value,
    children: item.label,
    key: idx
  }, item.label))));
  return {
    showUpdateDeliveryModal: function showUpdateDeliveryModal() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return setVisible(bool);
    },
    UpdateDeliveryModal: ModalNode
  };
}
/** 集单详情列表回填数据 */

function backfill(_x17) {
  return _backfill.apply(this, arguments);
}
/**
 * 排序自动封装
 */

function _backfill() {
  _backfill = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee20(_ref16) {
    var firstCategoryId, merchantId, tableRef, dataSource, list, query, queryPrice, res, _res$, _res$2, _res$3, tmp;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            firstCategoryId = _ref16.firstCategoryId, merchantId = _ref16.merchantId, tableRef = _ref16.tableRef, dataSource = _ref16.dataSource;
            list = dataSource;

            if (list.length) {
              _context20.next = 4;
              break;
            }

            return _context20.abrupt("return", list);

          case 4:
            query = querystring.parse();
            queryPrice = APPROVE_STATUS.待审核 === +query.status; // 20-01-21 add 除了待审核状态，不查询任何价格

            _context20.next = 8;
            return Promise.allSettled([queryProductExtInfo({
              needSupplier: true,
              needPlaceStock: true,
              needSale: true,
              needDc: true,
              param: list.map(item => ({
                placeId: item.placeId,
                goodsId: item.goodsId,
                merchantId: item.merchantId,
                firstCategoryId: item.firstCategoryId,
                secondCategoryId: item.secondCategoryId
              }))
            }), ...(queryPrice ? [getDemandPoolingReferencePrice({
              // 回填参考采购价、配送价
              tableList: list,
              orderDirect: DEMAND_TYPE.SUUPLEMENT,
              firstCategoryId,
              merchantId
            })] : [])]);

          case 8:
            res = _context20.sent;

            if (queryPrice) {
              console.groupCollapsed('---- 回填 ----');
              console.log('地点维度库存、销量、供应商', (_res$ = res[0]) === null || _res$ === void 0 ? void 0 : _res$.value);
              console.log('参考采购价、配送价', (_res$2 = res[1]) === null || _res$2 === void 0 ? void 0 : _res$2.value);
              console.groupEnd();
            } else {
              console.log('地点维度库存、销量、供应商', (_res$3 = res[0]) === null || _res$3 === void 0 ? void 0 : _res$3.value);
            }

            tmp = [];
            res.forEach((r, i) => {
              if (r.status === 'fulfilled' && r.value.length) {
                if (i === 0) r.value = r.value.map(item => {
                  delete item.deliveryDcId; // 屏蔽大仓显示 0 BUG

                  delete item.dcStock; // 屏蔽大仓库存显示空 BUG

                  return item;
                });
                tmp = tmp.length ? mergeArr(tmp, r.value, ['goodsId', 'placeId'
                /* 回填采购价中没有该字段 'merchantId' */
                ]) : r.value;
              }
            });
            return _context20.abrupt("return", tmp);

          case 13:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _backfill.apply(this, arguments);
}

function sorterHelper(_ref17) {
  var _changArgs$;

  var url = _ref17.url,
      params = _ref17.params,
      changArgs = _ref17.changArgs;
  var sorter = (_changArgs$ = changArgs[2]) !== null && _changArgs$ !== void 0 ? _changArgs$ : {};

  if (sorter.order === 'ascend') {
    params.condition = _objectSpread(_objectSpread({}, params.condition), {}, {
      orderColumn: sorter.field,
      isAsc: true
    });
  } else if (sorter.order === 'descend') {
    params.condition = _objectSpread(_objectSpread({}, params.condition), {}, {
      orderColumn: sorter.field,
      isAsc: false
    });
  } else {
    params.condition = _objectSpread(_objectSpread({}, params.condition), {}, {
      orderColumn: undefined,
      isAsc: undefined
    });
  }

  return params;
}
/**
 * @脏逻辑
 * 集单审核-行内编辑
 * Select、Input 改动实时保存
 */

function editChange(_x18) {
  return _editChange.apply(this, arguments);
}
/**
 * 转换商家(商家以及商家下的地点) -> OptionItem
 */

function _editChange() {
  _editChange = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee21(_ref18) {
    var _refTable$current;

    var cmd, cellChangeArgs, query, refTable, setDataSource, successCallback, dataSource, value, type, dataIndex, record, rowIndex, _record$dc, defaultDC, updateOld, url, params, result;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            cmd = _ref18.cmd, cellChangeArgs = _ref18.cellChangeArgs, query = _ref18.query, refTable = _ref18.refTable, setDataSource = _ref18.setDataSource, successCallback = _ref18.successCallback;
            dataSource = ((_refTable$current = refTable.current) === null || _refTable$current === void 0 ? void 0 : _refTable$current.dataSource) || [];
            value = cellChangeArgs.value, type = cellChangeArgs.type, dataIndex = cellChangeArgs.dataIndex, record = cellChangeArgs.record, rowIndex = cellChangeArgs.rowIndex;
            console.log("".concat(cmd, "[").concat(dataIndex, "]"), "".concat(record[dataIndex + '_old'], "_old"), value);
            if (cmd === '审核数量' && value === '') record[dataIndex] = 0; // 审核数量为空时，自动补 0

            if (!(type === 'INPUT' && record["".concat(dataIndex, "_old")] === value)) {
              _context21.next = 7;
              break;
            }

            return _context21.abrupt("return");

          case 7:
            if (!(cmd === '大仓' && record.logistics !== LOGISTICE_MODE.直送 && !+record.deliveryDcId)) {
              _context21.next = 9;
              break;
            }

            return _context21.abrupt("return", antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.warn('请选择大仓'));

          case 9:
            if (cmd === '物流模式' && +record.deliveryDcId ===
            /* grpc int 类型默认值 */
            0) {
              defaultDC = (_record$dc = record.dc) === null || _record$dc === void 0 ? void 0 : _record$dc.find(d => d.isDefault);
              defaultDC && (record.deliveryDcId = defaultDC.deliveryDcId); // 12-20-17 直送->配送、直通 默认大仓
              // @todo
              // record === refTable.current?.dataSource[rowIndex] -> true
              // 这里背后赋值，理论上 tabel 刷新会跟着变；还需要再折腾下 20-12-17 18:12:00
            }

            updateOld = () => {
              record["".concat(dataIndex, "_old")] = value;
            }; // 更新改动


            if (+record.demandNum > 0 && record.supplierCode && record.logistics) {
              _context21.next = 13;
              break;
            }

            return _context21.abrupt("return");

          case 13:
            // 必传三个参数
            url = 'purchase.demandPooling.saveDemandPoolingDetail';
            params = {
              poolingId: query.poolingId,
              detail: {
                id: record.id,
                placeId: record.placeId,
                goodsId: record.goodsId,
                barCode: record.barCode,
                demandNum: record.demandNum,
                // 需求数量
                approveNum: record.approveNum,
                // 审核数量
                supplierCode: record.supplierCode,
                // 供应商编码
                logistics: record.logistics,
                // 物流模式：1直送；2配送；3直通
                deliveryDcId: record.deliveryDcId,
                // 20-11-27 add 选择大仓
                unitPrice: record.unitPrice,
                merchantId: query.merchantId,
                supplyRoute: record.supplyRoute,
                // 供货路径
                emergLevel: record.emergLevel,
                fatness: record.fatness,
                referneceWeight: record.referneceWeight
              }
            };
            _context21.next = 17;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(url, params);

          case 17:
            result = _context21.sent;

            if (result.success) {
              updateOld();

              antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.success('保存成功'); // @complete
              // refTable.current?.dataSource[rowIndex] === dataSource[rowIndex] -> false
              // 这里竟然不相等；通过引用上面的 dataSource 避开 20-12-17 20:36:00
              // 地点维度改动


              setDataSource(dataSource.map(item => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)({}, item), {}, {
                // ERP-1904(goodsId + placeId 才是唯一的)
                id: item.goodsId === record.goodsId && item.placeId === record.placeId ? result.result.id : item.id,
                // 补充 id
                LINE_FLAG: undefined // 回填数据状态改变

              })));

              if (successCallback) {
                successCallback();
              }
            }

            return _context21.abrupt("return", result);

          case 20:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
  return _editChange.apply(this, arguments);
}

function convertBusiness_with_Place() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  try {
    var arr = data.merchants ? JSON.parse(data.merchants) : [];
    return arr.map(item => ({
      label: item.merchantName,
      value: item.merchantId
    }));
  } catch (error) {
    return [];
  }
}
/** RangePicker 选择时间控制 */

function limitDay_for_RangePicker() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 31;
  return {
    validator: (_, value) => {
      if (value && value.length) {
        var diffDate = value[1].diff(value[0], 'day');

        if (diffDate > limit) {
          return Promise.reject("\u65F6\u95F4\u8303\u56F4\u4E0D\u80FD\u8D85\u8FC7".concat(limit, "\u5929"));
        }
      }

      return Promise.resolve();
    }
  };
}
/** 原生解析 querystring */

var querystring = {
  parse() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.search;
    var dict = {};
    Array.from(new URLSearchParams(str).entries()).forEach(_ref19 => {
      var _ref20 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_ref19, 2),
          k = _ref20[0],
          v = _ref20[1];

      return dict[k] = v;
    });
    return dict;
  }

};
/** 供货方。其他：1；台州仓供货：2 */

var STOCK_SUPPLIER;
/** FormBuilder 中 CHECKBOX_GROUP_EXTRA 数据类型是数组；转换成单个值 */

(function (STOCK_SUPPLIER) {
  STOCK_SUPPLIER[STOCK_SUPPLIER["\u5176\u4ED6"] = 1] = "\u5176\u4ED6";
  STOCK_SUPPLIER[STOCK_SUPPLIER["\u53F0\u5DDE\u4ED3\u4F9B\u8D27"] = 2] = "\u53F0\u5DDE\u4ED3\u4F9B\u8D27";
})(STOCK_SUPPLIER || (STOCK_SUPPLIER = {}));

function convertValue_arr2let(values, key) {
  var _values = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)({}, values);

  _values[key] = (values[key] || []).length ? +values[key][0] : undefined;
  _values[key] === undefined && delete _values[key];
  return _values;
}

/***/ }),

/***/ 15172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ scmResourceTokenApi; }
/* harmony export */ });
var scmResourceTokenApi = 'scmconfig.resouce.getResourceToken';

/***/ }),

/***/ 23831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lG": function() { return /* binding */ DELIVERY_DETAIL_API; },
/* harmony export */   "e1": function() { return /* binding */ DELIVERY_LIST_API; },
/* harmony export */   "OB": function() { return /* binding */ DELIVERY_MODIFY_API; },
/* harmony export */   "yG": function() { return /* binding */ IMPORT_ORDER; },
/* harmony export */   "Kq": function() { return /* binding */ BATCH_DELETE; },
/* harmony export */   "Q9": function() { return /* binding */ MERCHANT_GOODS_LIST; }
/* harmony export */ });
/**
 * API集合
 */
// 详情
var DELIVERY_DETAIL_API = 'scm.warehouseDeliveryPeriod.getWarehouseDeliveryPeriodDetail'; // 列表

var DELIVERY_LIST_API = 'scm.warehouseDeliveryPeriod.getWarehouseDeliveryPeriodPage'; // 保存

var DELIVERY_MODIFY_API = 'scm.warehouseDeliveryPeriod.save'; // 导入接口

var IMPORT_ORDER = 'scmconfig.warehouseDeliveryPeriod.importWarehouseDeliveryPeriod'; // 批量删除

var BATCH_DELETE = 'scmconfig.warehouseDeliveryPeriod.deleteWarehouseDeliveryPeriod'; // 商家维度查询商品

var MERCHANT_GOODS_LIST = 'purchase.product.querySelectMerchantProductByCondition';

/***/ }),

/***/ 55549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "rV": function() { return /* binding */ ADD_API; },
/* harmony export */   "S9": function() { return /* binding */ EDIT_API; },
/* harmony export */   "N1": function() { return /* binding */ LOSS_RATE_LIST_API; },
/* harmony export */   "oZ": function() { return /* binding */ LOSS_RATE_DETAIL_API; },
/* harmony export */   "yG": function() { return /* binding */ IMPORT_ORDER; },
/* harmony export */   "sd": function() { return /* binding */ MULTY_DELETE; },
/* harmony export */   "Q9": function() { return /* binding */ MERCHANT_GOODS_LIST; },
/* harmony export */   "kt": function() { return /* binding */ PLACE_GOODS_LIST; }
/* harmony export */ });
/* unused harmony export DOWNLOAD_TEMPLATE */
/**
 * API集合
 */
// 商品路由新增
var ADD_API = 'scm.goodsRouting.batchAddGoodsRouting'; // 商品路由编辑

var EDIT_API = 'scm.goodsRouting.modifyGoodsRouting'; // 商品路由配置列表

var LOSS_RATE_LIST_API = 'scm.goodsRouting.queryGoodsRoutingPage'; // 商品路由配置详情

var LOSS_RATE_DETAIL_API = 'scm.goodsRouting.queryGoodsRouting'; // 下载模板

var DOWNLOAD_TEMPLATE = 'scm.config.getDownloadTemplate'; // 商品商品路由配置导入接口

var IMPORT_ORDER = 'scm.goodsRouting.importGoodsRouting'; // 批量删除

var MULTY_DELETE = 'scm.goodsRouting.deleteGoodsRouting'; // 商家维度查询商品

var MERCHANT_GOODS_LIST = 'purchase.product.querySelectMerchantProductByCondition'; // 地点维度查询商品

var PLACE_GOODS_LIST = 'purchase.product.querySelectPlaceProductByCondition';

/***/ }),

/***/ 42801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DICTIONARY": function() { return /* binding */ DICTIONARY; },
/* harmony export */   "BASE_MAP": function() { return /* binding */ BASE_MAP; },
/* harmony export */   "TABLE_COLUMNS": function() { return /* binding */ TABLE_COLUMNS; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


 // 字典

var DICTIONARY = [{
  key: 'SupplierCategory',
  configMap: {
    '1': '采购供应商',
    '2': '农户供应商'
  }
}]; // 字段名对应的映射
// https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=31411559
// export const purchaseObj: any = {
//   billState: 9,
//   categoryCode: 4,
//   placeCode: 3,
//   orderType: 10,
//   isStraight: 43,
//   categoryCodeAll: 46,
//   firstCategoryId: 4, // 一级类目
//   secondCategoryId: 5, // 一级类目
//   placeId: 3, // 地点
//   merchantId: 40, // 商家/机构
//   logisticMode: 7 // 物流模式
// }

var BASE_MAP = [// firstCategoryId: "10"
// firstCategoryName: "生鲜部"
// gmtModified: "2021-02-03 17:53:04"
// goodsId: "1001305"
// goodsName: "活龙胆鱼"
// id: "2"
// receiveMerchantCode: "M100140108"
// receiveMerchantId: "2000000506"
// receiveMerchantName: "去ERP测试自营商家"
// receivePlaceCode: "A01999"
// receivePlaceId: "2000000504"
// receivePlaceName: "去ERP测试门店1"
// secondCategoryId: "1005"
// secondCategoryName: "水产类"
// status: 2
// updateUserName: "陶秋明"
// success: true
// 基础信息
['deliveryDcCode', ['调出地编码', '']], ['deliveryDcName', ['调出地名称', '']], ['receiveMerchantCode', ['机构编码', '']], ['receiveMerchantName', ['机构', '']], ['receivePlaceCode', ['地点编码', '']], ['receivePlaceName', ['地点', '']], ['firstCategoryName', ['一级品类', '']], ['secondCategoryName', ['二级品类', '']], ['goodsName', ['商品名称', '']], ['goodsId', ['商品编码', '']], ['statusName', ['状态', '']], ['updateUserName', ['操作人', '']]];
var TABLE_COLUMNS = [{
  title: '调出地编码',
  dataIndex: 'deliveryDcCode',
  key: 'deliveryDcCode',
  width: 130
}, {
  title: '调出地名称',
  dataIndex: 'deliveryDcName',
  key: 'deliveryDcName',
  width: 130
}, {
  title: '调入地商家编码',
  dataIndex: 'receiveMerchantCode',
  key: 'receiveMerchantCode',
  width: 130
}, {
  title: '调入地商家名称',
  dataIndex: 'receiveMerchantName',
  key: 'receiveMerchantName',
  width: 130
}, {
  title: '调入地编码',
  dataIndex: 'receivePlaceCode',
  key: 'receivePlaceCode',
  width: 120,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '调入地名称',
  dataIndex: 'receivePlaceName',
  key: 'receivePlaceName',
  width: 65
}, {
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 90
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 130,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '最后修改时间',
  dataIndex: 'gmtModified',
  key: 'gmtModified',
  width: 100
}, {
  title: '最后修改人',
  dataIndex: 'updateUserName',
  key: 'updateUserName',
  width: 70,
  ellipsis: true
}, {
  title: '状态',
  dataIndex: 'status',
  key: 'status',
  width: 70,
  ellipsis: true,
  render: status => {
    var _statusDesc = '';

    if (status === 1) {
      _statusDesc = '失效';
    } else if (status === 2) {
      _statusDesc = '生效';
    } else {
      _statusDesc = '未知';
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, _statusDesc);
  }
}];

/***/ }),

/***/ 35682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AG": function() { return /* binding */ CHANGE_PRICE_LIST; },
/* harmony export */   "cy": function() { return /* binding */ CHANGE_PRICE_INFO; },
/* harmony export */   "rr": function() { return /* binding */ CHANGE_PRICE_ADD; }
/* harmony export */ });
/* unused harmony exports SAVE_LOSS_RATE_API, IMPORT_LOSS_API, LOSS_RATE_LIST_API, LOSS_RATE_DETAIL_API, DOWNLOAD_TEMPLATE, LOSS_IMPORT_ORDER, MERCHANT_GOODS_LIST */
/**
 * API集合
 */
// 去损率保存
var SAVE_LOSS_RATE_API = 'purchase.basic.goodsWastageRateSave'; // 去损率导入

var IMPORT_LOSS_API = 'purchase.basic.importGoodsWastageRate'; // 去损率列表

var LOSS_RATE_LIST_API = 'purchase.basic.getGoodsWastageRatePage'; // 去损率详情

var LOSS_RATE_DETAIL_API = 'purchase.basic.getGoodsWastageRateDetail'; // 下载模板

var DOWNLOAD_TEMPLATE = 'purchase.downlaod.getTemplate'; // 商品去损率导入接口

var LOSS_IMPORT_ORDER = 'purchase.basic.importGoodsWastageRate'; // 商家维度查询商品

var MERCHANT_GOODS_LIST = 'purchase.product.querySelectMerchantProductByCondition'; // 查询改价列表

var CHANGE_PRICE_LIST = 'scmconfig.changeprice.queryChangePriceConfigPage'; // 改价详情

var CHANGE_PRICE_INFO = 'scmconfig.changeprice.queryChangePriceConfigDetail'; // 新增修改改价服务

var CHANGE_PRICE_ADD = 'scmconfig.changeprice.insertOrUpdateChangePriceConfig';

/***/ }),

/***/ 9398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sh": function() { return /* binding */ DICTIONARY; },
/* harmony export */   "lw": function() { return /* binding */ BASE_MAP; },
/* harmony export */   "FU": function() { return /* binding */ SUBORDER_TYPE_ENMUS; },
/* harmony export */   "l1": function() { return /* binding */ SUBORDER_TYPE_ENMUS1; },
/* harmony export */   "YE": function() { return /* binding */ SUBORDER_TYPE_ENMUS2; }
/* harmony export */ });
/**
 * 业务常量
 */
var DICTIONARY = [{
  key: 'OrderType',
  configMap: {
    '1': '采购订单',
    '2': '采购分配单',
    '3': '调拨订单',
    '4': '分拨订单'
  }
}, {
  key: 'GoodsType',
  configMap: {
    '20': '快消',
    '10': '生鲜'
  }
}, {
  key: 'SupplierCategory',
  configMap: {
    '1': '采购供应商',
    '2': '农户供应商'
  }
}, {
  key: 'subOrderType',
  configMap: {
    '1': orderType => ['1', '2'].includes(orderType) ? '进货' : '仓间调拨',
    '2': orderType => ['1', '2'].includes(orderType) ? '退货' : '店间调拨',
    '3': '仓店配送',
    '4': '店仓返配'
  }
}];
var BASE_MAP = [// int64 organizationId = 2; //机构id, 商家id
// string placeId = 3; //调出地id，all-全部
// string firstCategoryId = 4; //一级分类id，all-全部
// string secondCategoryId = 5; //二级分类id，all-全部
// int64 goodsId = 6; //商品编码
// int32 wastageRate = 7; // 基数类型，1-按单价、2-按金额
// string operator = 8; // 操作人
// 基础信息
['merchantName', ['商家', '']], ['orderType', ['单据类型', '']], ['subOrderType', ['单据细分类', '']], ['goodsType', ['品类', '']], ['isChangePrice', ['是否允许改价', '']], ['isChangeLow', ['是否仅允许改低', '']]];
var SUBORDER_TYPE_ENMUS = [{
  label: '订货',
  value: 1
}, {
  label: '退货',
  value: 2
}, {
  label: '仓店配送',
  value: 3
}, {
  label: '店仓返配',
  value: 4
}, {
  label: '仓间调拨',
  value: 5
}, {
  label: '店间调拨',
  value: 6
}];
var SUBORDER_TYPE_ENMUS1 = [{
  label: '订货',
  value: 1
}, {
  label: '退货',
  value: 2
}];
var SUBORDER_TYPE_ENMUS2 = [{
  label: '仓店配送',
  value: 3
}, {
  label: '店仓返配',
  value: 4
}, {
  label: '仓间调拨',
  value: 5
}, {
  label: '店间调拨',
  value: 6
}];

/***/ }),

/***/ 61515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N9": function() { return /* binding */ SAVE_LOSS_RATE_API; },
/* harmony export */   "N1": function() { return /* binding */ LOSS_RATE_LIST_API; },
/* harmony export */   "oZ": function() { return /* binding */ LOSS_RATE_DETAIL_API; },
/* harmony export */   "n0": function() { return /* binding */ LOSS_IMPORT_ORDER; },
/* harmony export */   "Q9": function() { return /* binding */ MERCHANT_GOODS_LIST; },
/* harmony export */   "MH": function() { return /* binding */ BATCH_DELETD; }
/* harmony export */ });
/* unused harmony exports IMPORT_LOSS_API, DOWNLOAD_TEMPLATE */
/**
 * API集合
 */
// 去损率保存
var SAVE_LOSS_RATE_API = 'purchase.basic.goodsWastageRateSave'; // 去损率导入

var IMPORT_LOSS_API = 'purchase.basic.importGoodsWastageRate'; // 去损率列表

var LOSS_RATE_LIST_API = 'purchase.basic.getGoodsWastageRatePage'; // 去损率详情

var LOSS_RATE_DETAIL_API = 'purchase.basic.getGoodsWastageRateDetail'; // 下载模板

var DOWNLOAD_TEMPLATE = 'purchase.downlaod.getTemplate'; // 商品去损率导入接口

var LOSS_IMPORT_ORDER = 'purchase.basic.importGoodsWastageRate'; // 商家维度查询商品

var MERCHANT_GOODS_LIST = 'purchase.product.querySelectMerchantProductByCondition'; // 批量删除

var BATCH_DELETD = 'purchase.basic.batchDeleteGoodsWastageRate';

/***/ }),

/***/ 44863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DICTIONARY": function() { return /* binding */ DICTIONARY; },
/* harmony export */   "BASE_MAP": function() { return /* binding */ BASE_MAP; },
/* harmony export */   "TABLE_COLUMNS": function() { return /* binding */ TABLE_COLUMNS; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


 // 字典

var DICTIONARY = [{
  "key": "SupplierCategory",
  "configMap": {
    "1": "采购供应商",
    "2": "农户供应商"
  }
}]; // 字段名对应的映射
// https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=31411559
// export const purchaseObj: any = {
//   billState: 9,
//   categoryCode: 4,
//   placeCode: 3,
//   orderType: 10,
//   isStraight: 43,
//   categoryCodeAll: 46,
//   firstCategoryId: 4, // 一级类目
//   secondCategoryId: 5, // 一级类目
//   placeId: 3, // 地点
//   merchantId: 40, // 商家/机构
//   logisticMode: 7 // 物流模式
// }

var BASE_MAP = [// int64 organizationId = 2; //机构id, 商家id
// string placeId = 3; //调出地id，all-全部
// string firstCategoryId = 4; //一级分类id，all-全部
// string secondCategoryId = 5; //二级分类id，all-全部
// int64 goodsId = 6; //商品编码
// int32 wastageRate = 7; // 基数类型，1-按单价、2-按金额
// string operator = 8; // 操作人
// 基础信息
['organizationCode', ['机构编码', '']], ['organizationName', ['机构', '']], ['placeName', ['地点', '']], ['firstCategoryName', ['一级品类', '']], ['secondCategoryName', ['二级品类', '']], ['wastageRate', ['商品损耗率(%)', '']], ['goodsName', ['商品名', '']], ['goodsId', ['商品编码', '']], ['operator', ['操作人', '']]];
var TABLE_COLUMNS = [{
  title: '机构',
  dataIndex: 'organizationName',
  key: 'organizationName',
  width: 135
}, {
  title: '地点编码',
  dataIndex: 'placeCode',
  key: 'placeCode',
  width: 65
}, {
  title: '地点名称',
  dataIndex: 'placeName',
  key: 'placeName',
  width: 120,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '商品大类',
  dataIndex: 'firstCategoryName',
  key: 'firstCategoryName',
  width: 65
}, {
  title: '商品二级分类',
  dataIndex: 'secondCategoryName',
  key: 'secondCategoryName',
  width: 90
}, {
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 70
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 188,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t) // render: (t:any) => dictionaryMatch(t, 'isPrePay', DICTIONARY, 'list')

}, {
  title: '商品损耗率(%)',
  dataIndex: 'wastageRate',
  key: 'wastageRate',
  width: 100
}, {
  title: '操作人',
  dataIndex: 'operator',
  key: 'operator',
  width: 70,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '创建时间',
  dataIndex: 'gmtCreate',
  key: 'gmtCreate',
  width: 180
}];

/***/ }),

/***/ 18354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KT": function() { return /* binding */ PICKUPSEND_CONFIG_LIST_API; },
/* harmony export */   "$b": function() { return /* binding */ PICKUPSEND_CONFIG_DETAIL_API; },
/* harmony export */   "oj": function() { return /* binding */ PICKUPSEND_CONFIG_MODIFY_API; },
/* harmony export */   "yG": function() { return /* binding */ IMPORT_ORDER; },
/* harmony export */   "NO": function() { return /* binding */ PICKUPSEND_CONFIG_BATCH_DELETE; },
/* harmony export */   "Q9": function() { return /* binding */ MERCHANT_GOODS_LIST; }
/* harmony export */ });
/**
 * API集合
 */
// 列表
var PICKUPSEND_CONFIG_LIST_API = 'scmconfig.startsend.queryStartingSendConfigPage'; // 详情

var PICKUPSEND_CONFIG_DETAIL_API = 'scmconfig.startsend.queryStartingSendConfigDetail'; // 保存

var PICKUPSEND_CONFIG_MODIFY_API = 'scmconfig.startsend.addOrUpdateStartingSendConfig'; // 导入接口

var IMPORT_ORDER = ''; // 批量删除

var PICKUPSEND_CONFIG_BATCH_DELETE = 'scmconfig.startsend.deleteStartingSendConfig';
var MERCHANT_GOODS_LIST = 'purchase.product.querySelectMerchantProductByCondition';

/***/ }),

/***/ 44376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ logisticsTypes; },
/* harmony export */   "t": function() { return /* binding */ startingSendTypes; }
/* harmony export */ });
var logisticsTypes = [{
  label: '直送',
  value: 1
}, {
  label: '配送',
  value: 2
}, {
  label: '直通',
  value: 3
}];
var startingSendTypes = [{
  label: '按总金额',
  value: 1
}];

/***/ }),

/***/ 93854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N9": function() { return /* binding */ SAVE_LOSS_RATE_API; },
/* harmony export */   "N1": function() { return /* binding */ LOSS_RATE_LIST_API; },
/* harmony export */   "oZ": function() { return /* binding */ LOSS_RATE_DETAIL_API; },
/* harmony export */   "yG": function() { return /* binding */ IMPORT_ORDER; },
/* harmony export */   "Qm": function() { return /* binding */ CANCEL_ORDER; },
/* harmony export */   "Q9": function() { return /* binding */ MERCHANT_GOODS_LIST; },
/* harmony export */   "Jg": function() { return /* binding */ CUSTOMER_CODE_LIST; },
/* harmony export */   "fl": function() { return /* binding */ EXPORT_ORDER; },
/* harmony export */   "bA": function() { return /* binding */ EXPORT_LIST; }
/* harmony export */ });
/* unused harmony exports DOWNLOAD_TEMPLATE, CUSTOMER_SELECT_LIST, DELETE_ORDER */
/**
 * API集合
 */
// 加价保存
var SAVE_LOSS_RATE_API = 'scmconfig.freight.save'; // 列表

var LOSS_RATE_LIST_API = 'scmconfig.freight.getAddPriceRulePage'; // 详情

var LOSS_RATE_DETAIL_API = 'scmconfig.freight.getAddPriceRuleDetail'; // 下载模板

var DOWNLOAD_TEMPLATE = 'purchase.downlaod.getTemplate'; // 导入接口

var IMPORT_ORDER = 'scmconfig.freight.importAddPriceRule'; // 删除接口

var CANCEL_ORDER = 'scmconfig.freight.cancelPriceRule'; // 商家维度查询商品

var MERCHANT_GOODS_LIST = 'purchase.product.querySelectMerchantProductByCondition'; // 客户信息下拉列表 - 弹框查询

var CUSTOMER_CODE_LIST = 'purchase.wholesale.queryCustomerInformationCodeList'; // 客户信息下拉列表 - SELECT

var CUSTOMER_SELECT_LIST = 'purchase.customer.queryCustomerInformationByProvinceCode'; // 删除接口

var DELETE_ORDER = 'scmconfig.freight.cancelPriceRule'; // 导出接口

var EXPORT_ORDER = 'scmconfig.freight.exportFreight'; // 查询导出明细列表

var EXPORT_LIST = 'scm.config.getExportTaskList';

/***/ }),

/***/ 20989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PRICE_DICTIONARY": function() { return /* binding */ PRICE_DICTIONARY; },
/* harmony export */   "BASE_MAP": function() { return /* binding */ BASE_MAP; },
/* harmony export */   "BASE_PF_MAP": function() { return /* binding */ BASE_PF_MAP; },
/* harmony export */   "TABLE_COLUMNS": function() { return /* binding */ TABLE_COLUMNS; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31097);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Edit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23013);



/**
 * 业务常量
 */


 // 字典

var PRICE_DICTIONARY = [{
  key: 'OrderType',
  configMap: {
    '1': '仓店配送',
    '2': '店间调拨',
    '3': '仓间调拨',
    '4': '店仓返配',
    '5': '批发销售'
  }
}, {
  key: 'BaseType',
  configMap: {
    '1': '按单价',
    '2': '按数量'
  }
}, {
  key: 'AddPriceType',
  configMap: {
    '1': '加价率',
    '2': '加价额'
  }
}];
var BASE_MAP = [// 基础信息
['orderType', ['业务类型', '']], ['deliveryMerchantName', ['调出地商家', '']], ['deliveryPlaceName', ['调出地', '']], ['receiveMerchantName', ['调入地商家', '']], ['receivePlaceName', ['调入地', '']], ['firstCategoryName', ['一级品类', '']], ['secondCategoryName', ['二级品类', '']], ['threeCategoryName', ['三级品类', '']], ['fourCategoryName', ['四级品类', '']], ['goodsId', ['商品编码', '']], ['goodsName', ['商品名称', '']], ['baseType', ['基数类型', '']], ['addPriceType', ['加价类型', '']], ['amount', ['加价额/率', '']]];
var BASE_PF_MAP = [// 基础信息 - 批发销售
['orderType', ['业务类型', '']], ['provinceName', ['省份', '']], ['cityName', ['省份', '']], ['deliveryMerchantName', ['调出地商家', '']], ['deliveryPlaceName', ['调出地', '']], ['receiveMerchantName', ['调入地商家', '']], ['receivePlaceName', ['调入地', '']], ['firstCategoryName', ['一级品类', '']], ['secondCategoryName', ['二级品类', '']], ['threeCategoryName', ['三级品类', '']], ['fourCategoryName', ['四级品类', '']], ['goodsId', ['商品编码', '']], ['goodsName', ['商品名称', '']], ['baseType', ['基数类型', '']], ['addPriceType', ['加价类型', '']], ['amount', ['加价额/率', '']]]; // int32 orderType = 2; //业务类型，1-仓店配送、2-店间调拨、3-仓间调拨、4-店仓返配
// string deliveryMerchantId = 3; //调出地id，all-全部
// string deliveryMerchantCode = 4; //调出地编码
// string deliveryMerchantName = 5; //调出地名称
// int64 deliveryPlaceId = 6; //调出地id，all-全部
// string deliveryPlaceCode = 7; //调出地编码
// string deliveryPlaceName = 8; //调出地名称
// string receiveMerchantId = 9; //调入地id，all-全部
// string receiveMerchantCode = 10; //调入地编码
// string receiveMerchantName = 11; //调入地名称
// int64 receivePlaceId = 12; //调出地id，all-全部
// string receivePlaceCode = 13; //调出地编码
// string receivePlaceName = 14; //调出地名称
// string firstCategoryId = 15; //一级分类id，all-全部
// string firstCategoryName = 16; //大类名称
// string secondCategoryId = 17; //二级分类id，all-全部
// string secondCategoryName = 18; //二级品类名称
// string threeCategoryId = 19; //三级分类id，all-全部
// string threeCategoryName = 20; //三级分类名称
// string fourCategoryId = 21; //四级分类id，all-全部
// string fourCategoryName = 22; //四级品类名称
// int64 merchantItemId = 23; //商家货品id
// int64 goodsId = 24; //商品编码
// string goodsName = 25; //商品名称
// int32 baseType = 26; // 基数类型，1-按单价、2-按金额
// int32 addPriceType = 27; // 加价类型，1-加价率、2-加价额
// string amount = 28; //加价额/率
// string operator = 29; //创建人
// string gmtCreate = 30; //创建时间，时间戳
// }

var TABLE_COLUMNS = [{
  title: '业务类型',
  dataIndex: 'orderType',
  key: 'orderType',
  width: 75,
  // render: (t: any) => dictionaryMatch(t, 'orderType', PRICE_DICTIONARY, 'list')
  render: t => {
    for (var key in _Edit__WEBPACK_IMPORTED_MODULE_3__.orderTypeEnums) {
      if (t === +key) {
        return _Edit__WEBPACK_IMPORTED_MODULE_3__.orderTypeEnums[key];
      }
    }

    return '';
  }
}, {
  title: '调出地商家名称',
  dataIndex: 'deliveryMerchantName',
  key: 'deliveryMerchantName',
  width: 168,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '调出地商家编码',
  dataIndex: 'deliveryMerchantCode',
  key: 'deliveryMerchantCode',
  width: 120
}, {
  title: '调出地名称',
  dataIndex: 'deliveryPlaceName',
  key: 'deliveryPlaceName',
  width: 188,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '调出地编码',
  dataIndex: 'deliveryPlaceCode',
  key: 'deliveryPlaceCode',
  width: 100
}, {
  title: '省份',
  dataIndex: 'address',
  key: 'address',
  width: 130,
  render: (t, r) => {
    if ((r === null || r === void 0 ? void 0 : r.provinceName) === (r === null || r === void 0 ? void 0 : r.cityName)) {
      return r === null || r === void 0 ? void 0 : r.provinceName;
    }

    return (r === null || r === void 0 ? void 0 : r.provinceName) + (r === null || r === void 0 ? void 0 : r.cityName);
  }
}, {
  title: '批发客户',
  dataIndex: 'customerName',
  key: 'customerName',
  width: 130
}, {
  title: '批发客户编码',
  dataIndex: 'customerNo',
  key: 'customerNo',
  width: 130
}, {
  title: '一级分类',
  dataIndex: 'firstCategoryName',
  key: 'firstCategoryName',
  width: 90
}, {
  title: '二级分类',
  dataIndex: 'secondCategoryName',
  key: 'secondCategoryName',
  width: 90
}, {
  title: '三级分类',
  dataIndex: 'threeCategoryName',
  key: 'threeCategoryName',
  width: 90
}, {
  title: '四级分类',
  dataIndex: 'fourCategoryName',
  key: 'fourCategoryName',
  width: 90
}, {
  title: '商家货品编码',
  dataIndex: 'status',
  key: 'status',
  width: 70,
  render: t => {
    if (t == 1) {
      return '生效';
    } else if (t == 2) {
      return '失效';
    } else {
      return '-';
    }
  }
}, {
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 100,
  render: t => {
    if (t == 0 || t == '0') {
      return '';
    }

    return t;
  }
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 188
}, {
  title: '基数类型',
  dataIndex: 'baseType',
  key: 'baseType',
  render: t => (0,_utils_common__WEBPACK_IMPORTED_MODULE_1__/* .dictionaryMatch */ .XB)(t, 'baseType', PRICE_DICTIONARY, 'list'),
  width: 80
}, {
  title: '加价类型',
  dataIndex: 'addPriceType',
  key: 'addPriceType',
  render: t => (0,_utils_common__WEBPACK_IMPORTED_MODULE_1__/* .dictionaryMatch */ .XB)(t, 'addPriceType', PRICE_DICTIONARY, 'list'),
  width: 80
}, {
  title: '加价额/率',
  dataIndex: 'amount',
  key: 'amount',
  width: 90,
  render: (t, r) => {
    if (r['addPriceType'] === 2) {
      return t ? (+t).toFixed(3) : '';
    }

    return t ? (+t * 100).toFixed(2) + '%' : '';
  }
}, {
  title: '调入地商家名称',
  dataIndex: 'receiveMerchantName',
  key: 'receiveMerchantName',
  width: 188,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '调入地商家编码',
  dataIndex: 'receiveMerchantCode',
  key: 'receiveMerchantCode',
  width: 120
}, {
  title: '调入地名称',
  dataIndex: 'receivePlaceName',
  key: 'receivePlaceName',
  width: 188,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '调入地编码',
  dataIndex: 'receivePlaceCode',
  key: 'receivePlaceCode',
  width: 100
}, {
  title: '创建人',
  dataIndex: 'operator',
  key: 'operator',
  width: 80
}, {
  title: '创建时间',
  dataIndex: 'gmtCreate',
  key: 'gmtCreate',
  width: 180
}];

/***/ }),

/***/ 23013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Edit; },
  "orderTypeEnums": function() { return /* binding */ orderTypeEnums; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/spin/style/index.js
var style = __webpack_require__(20228);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js
var spin = __webpack_require__(11382);
// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var button_style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/cascader/style/index.js
var cascader_style = __webpack_require__(36877);
// EXTERNAL MODULE: ./node_modules/antd/es/cascader/index.js + 5 modules
var cascader = __webpack_require__(34366);
// EXTERNAL MODULE: ./node_modules/antd/es/input/style/index.js
var input_style = __webpack_require__(47673);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 3 modules
var input = __webpack_require__(4107);
// EXTERNAL MODULE: ./node_modules/antd/es/select/style/index.js
var select_style = __webpack_require__(43358);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js
var es_select = __webpack_require__(34041);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/index.js
var message_style = __webpack_require__(34792);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(48086);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/CommonWrap/index.tsx
var CommonWrap = __webpack_require__(73520);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(5977);
// EXTERNAL MODULE: ./src/components/FormBuilder/index.tsx + 4 modules
var FormBuilder = __webpack_require__(5670);
// EXTERNAL MODULE: ./src/components/UseRouter/index.tsx
var UseRouter = __webpack_require__(27088);
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
// EXTERNAL MODULE: ./src/.umi-production/core/umiExports.ts + 18 modules
var umiExports = __webpack_require__(71720);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/components/GoodsModal/index.tsx + 2 modules
var GoodsModal = __webpack_require__(2271);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CloseCircleFilled.js + 1 modules
var CloseCircleFilled = __webpack_require__(43061);
;// CONCATENATED MODULE: ./src/pages/ConfigManage/SupplyChain/PriceIncreaseRule/components/MerchantFormfield/index.tsx






/**
 * 选择商家/商品的表单项按钮
 */



 // Todo 商家选择保存

function MerchantFormfield(props) {
  var initFormData = props.initFormData,
      isEdit = props.isEdit,
      handleSetFormData = props.handleSetFormData,
      searchParams = props.searchParams,
      name = props.name,
      btnText = props.btnText,
      formfields = props.formfields,
      title = props.title;

  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1]; // 保存 选择商家 浮层


  var saveModalCallback = (0,react.useCallback)(rows => {
    setVisible(false);
    handleSetFormData(rows);
  }, []); // 关闭 浮层

  var closeModal = (0,react.useCallback)(() => {
    setVisible(false);
  }, []);

  var clearGoods = () => {
    handleSetFormData([]);
  };

  (0,react.useEffect)(() => {
    console.log('initFormData', initFormData);
  }, [initFormData]);
  var columns = [{
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId'
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName'
  }, {
    title: '商品类目',
    dataIndex: 'cateName',
    key: 'cateName'
  }, {
    title: '品牌名称',
    dataIndex: 'brandName',
    key: 'brandName'
  }, {
    title: '单位',
    dataIndex: 'basicSpecificationUnit',
    key: 'basicSpecificationUnit',
    width: 120
  }, {
    title: '规格',
    dataIndex: 'basicSpecification',
    key: 'basicSpecification',
    width: 130
  }];
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(input/* default.Group */.Z.Group, {
    className: "complexInput"
  }, /*#__PURE__*/react.createElement(input/* default */.Z, {
    value: "".concat((initFormData === null || initFormData === void 0 ? void 0 : initFormData.name) || '', " ").concat((initFormData === null || initFormData === void 0 ? void 0 : initFormData.id) || ''),
    readOnly: true,
    name: name
  }), initFormData !== null && initFormData !== void 0 && initFormData.id ? /*#__PURE__*/react.createElement(CloseCircleFilled/* default */.Z, {
    className: "close-btn",
    onClick: clearGoods
  }) : null, /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    type: "primary",
    disabled: !isEdit,
    className: "complexBtn",
    onClick: () => setVisible(true)
  }, btnText !== null && btnText !== void 0 ? btnText : '商家选择')), visible && /*#__PURE__*/react.createElement(GoodsModal/* default */.Z, {
    queryGoodsModalDataUrl: props.queryDataUrl,
    tableOptions: props.tableOptions,
    searchParams: searchParams,
    title: title,
    formfields: formfields,
    columns: columns,
    closeModalCallback: closeModal,
    saveModalCallback: saveModalCallback
  }));
}

/* harmony default export */ var components_MerchantFormfield = (MerchantFormfield);
// EXTERNAL MODULE: ./src/pages/ConfigManage/SupplyChain/PriceIncreaseRule/Api/index.ts
var Api = __webpack_require__(93854);
// EXTERNAL MODULE: ./src/config/enums.ts
var enums = __webpack_require__(26715);
// EXTERNAL MODULE: ./src/components/PurchaseCategorySelect/index.tsx
var PurchaseCategorySelect = __webpack_require__(55054);
// EXTERNAL MODULE: ./src/hooks/useMapping.ts
var useMapping = __webpack_require__(7704);
// EXTERNAL MODULE: ./src/pages/GoodsManage/GoodStock/components/math.tsx
var math = __webpack_require__(50307);
// EXTERNAL MODULE: ./src/components/BigTitle/index.tsx
var BigTitle = __webpack_require__(70400);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/style/index.js
var modal_style = __webpack_require__(71194);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(57016);
// EXTERNAL MODULE: ./src/components/CommonTable/index.tsx + 3 modules
var CommonTable = __webpack_require__(40934);
;// CONCATENATED MODULE: ./src/pages/ConfigManage/SupplyChain/PriceIncreaseRule/components/CustomerFormfield/CustomerModal.tsx











var columns = [{
  title: '编号',
  dataIndex: 'customerNo',
  key: 'customerNo',
  width: 120
}, {
  title: '姓名',
  dataIndex: 'customerName',
  key: 'customerName',
  width: 130
}, {
  title: '手机号',
  dataIndex: 'customerTel',
  key: 'customerTel',
  width: 130
}, {
  title: '地址',
  dataIndex: 'detailedAddress',
  key: 'detailedAddress',
  width: 170
}];

function CustomerModal(props) {
  var provinceInfo = props.provinceInfo;

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      selectedRows = _useState2[0],
      setSelectedRows = _useState2[1];

  var _useState3 = (0,react.useState)(provinceInfo),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      searchParams = _useState4[0],
      setSearchParams = _useState4[1];

  var selectedOne = selectedRows.length === 1;
  var router = (0,UseRouter/* useRouter */.t)();
  var handleType = router.query.type; // 操作类型或者编码, 如： 'add'或者编码'GYS126827'

  var isAddHandle = handleType === 'add' ? true : false;
  var searchHandler = (0,react.useCallback)((state, values) => {
    setSearchParams(values);
  }, []);
  var rowSelectCallback = (0,react.useCallback)((keys, rows) => {
    setSelectedRows(rows);
  }, []);

  var handleOk = () => {
    props.saveModalCallback(selectedRows);
  };

  (0,react.useEffect)(() => {
    var _searchParams$provinc;

    if (provinceInfo !== null && provinceInfo !== void 0 && provinceInfo.length && !(searchParams !== null && searchParams !== void 0 && (_searchParams$provinc = searchParams.provinceCode) !== null && _searchParams$provinc !== void 0 && _searchParams$provinc.length)) {
      setSearchParams((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, searchParams), {}, {
        provinceCode: provinceInfo[0]
      }));
    }
  }, [provinceInfo]);
  var formfields = [{
    label: '客户编码',
    name: 'customerNo',
    type: 'INPUT'
  }, {
    label: '客户名称',
    name: 'customerName',
    type: 'INPUT'
  }];
  return /*#__PURE__*/react.createElement(modal/* default */.Z, {
    title: "\u6DFB\u52A0\u5BA2\u6237",
    destroyOnClose: true,
    maskClosable: false,
    width: 1000,
    visible: true,
    onOk: handleOk,
    onCancel: props.closeModalCallback,
    footer: [/*#__PURE__*/react.createElement(es_button/* default */.Z, {
      key: "close",
      onClick: props.closeModalCallback
    }, "\u5173\u95ED"), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      key: "confirm",
      type: "primary",
      onClick: handleOk
    }, "\u786E\u8BA4")]
  }, /*#__PURE__*/react.createElement(FormBuilder/* default */.Z, {
    elements: formfields,
    callbackHandler: searchHandler
  }), /*#__PURE__*/react.createElement(CommonTable/* default */.Z, {
    scrollYSize: 400,
    columns: columns,
    searchParams: searchParams,
    queryDataUrl: Api/* CUSTOMER_CODE_LIST */.Jg,
    rowSelectCallback: rowSelectCallback,
    tableOptions: {
      scroll: {
        y: 380
      },
      rowSelection: {
        type: isAddHandle ? 'checkbox' : 'radio'
      }
    }
  }));
}

/* harmony default export */ var CustomerFormfield_CustomerModal = (/*#__PURE__*/react.memo(CustomerModal));
;// CONCATENATED MODULE: ./src/pages/ConfigManage/SupplyChain/PriceIncreaseRule/components/CustomerFormfield/index.tsx






/**
 * 选择商家/商品的表单项按钮
 */





// Todo 商家选择保存
function CustomerFormfield(props) {
  var customerInfo = props.customerInfo,
      handleSetCustomer = props.handleSetCustomer,
      btnText = props.btnText,
      provinceInfo = props.provinceInfo;

  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0,react.useState)(),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      customerName = _useState4[0],
      setcustomerName = _useState4[1]; // 保存 选择商家 浮层


  var saveModalCallback = (0,react.useCallback)(rows => {
    setVisible(false);
    console.log('rows', rows); //         commonTableKey: "commonTable_122"
    // customerName: "ce测试"
    // customerNo: "C000009"
    // customerTel: "13023053896"
    // detailedAddress: "测试地址1"

    handleSetCustomer(rows);
  }, []); // 关闭 浮层

  var clearGoods = () => {
    handleSetCustomer([]);
    setcustomerName('');
  };

  (0,react.useEffect)(() => {
    if (customerInfo !== null && customerInfo !== void 0 && customerInfo.length) {
      if ((customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.length) === 1) {
        setcustomerName("".concat(customerInfo[0].customerNo, "-").concat(customerInfo[0].customerName));
      } else {
        setcustomerName(customerInfo.map(e => e.customerName).join(' '));
      }
    } else {
      setcustomerName('');
    }
  }, [customerInfo]);

  var _useState5 = (0,react.useState)({}),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      curProvinceInfo = _useState6[0],
      setcurProvinceInfo = _useState6[1];

  (0,react.useEffect)(() => {
    if (provinceInfo !== null && provinceInfo !== void 0 && provinceInfo.length) {
      setcurProvinceInfo({
        provinceCode: provinceInfo !== null && provinceInfo !== void 0 && provinceInfo.length ? provinceInfo[0] : ''
      });
    } else {
      setcurProvinceInfo({});
    }
  }, [provinceInfo]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(input/* default.Group */.Z.Group, {
    className: "complexInput"
  }, /*#__PURE__*/react.createElement(input/* default */.Z, {
    value: "".concat(customerName ? customerName : ''),
    readOnly: true,
    name: customerName
  }), customerName ? /*#__PURE__*/react.createElement(CloseCircleFilled/* default */.Z, {
    className: "close-btn",
    onClick: clearGoods
  }) : null, /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    type: "primary",
    className: "complexBtn",
    onClick: () => setVisible(true)
  }, btnText !== null && btnText !== void 0 ? btnText : '客户选择')), visible && /*#__PURE__*/react.createElement(CustomerFormfield_CustomerModal, {
    provinceInfo: curProvinceInfo,
    closeModalCallback: () => setVisible(false),
    saveModalCallback: saveModalCallback
  }));
}

/* harmony default export */ var components_CustomerFormfield = (/*#__PURE__*/react.memo(CustomerFormfield));
// EXTERNAL MODULE: ./src/hooks/useCityList.ts
var useCityList = __webpack_require__(49952);
// EXTERNAL MODULE: ./src/components/FixedBottomCps/index.tsx
var FixedBottomCps = __webpack_require__(32065);
;// CONCATENATED MODULE: ./src/pages/ConfigManage/SupplyChain/PriceIncreaseRule/Edit/index.tsx

















/* eslint-disable radix */

/**
 * 配置管理 - 供应链基础配置 - 加价规则 - 新增/编辑
 * https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=35782520
 */


















var orderTypeEnums;

(function (orderTypeEnums) {
  orderTypeEnums[orderTypeEnums["\u4ED3\u5E97\u914D\u9001"] = 1] = "\u4ED3\u5E97\u914D\u9001";
  orderTypeEnums[orderTypeEnums["\u5E97\u95F4\u8C03\u62E8"] = 2] = "\u5E97\u95F4\u8C03\u62E8";
  orderTypeEnums[orderTypeEnums["\u4ED3\u95F4\u8C03\u62E8"] = 3] = "\u4ED3\u95F4\u8C03\u62E8";
  orderTypeEnums[orderTypeEnums["\u5E97\u4ED3\u9000\u914D"] = 4] = "\u5E97\u4ED3\u9000\u914D";
  orderTypeEnums[orderTypeEnums["\u6279\u53D1\u9500\u552E"] = 5] = "\u6279\u53D1\u9500\u552E";
})(orderTypeEnums || (orderTypeEnums = {}));

var addressTypeEnums;

(function (addressTypeEnums) {
  addressTypeEnums[addressTypeEnums["\u95E8\u5E97"] = 1] = "\u95E8\u5E97";
  addressTypeEnums[addressTypeEnums["\u5927\u4ED3"] = 2] = "\u5927\u4ED3";
})(addressTypeEnums || (addressTypeEnums = {}));

var HandleEdit = props => {
  var dispatch = (0,umiExports/* useDispatch */.I0)(); // props

  var baseInfoForm = (0,react.useRef)();
  var history = (0,react_router/* useHistory */.k6)();
  var router = (0,UseRouter/* useRouter */.t)();
  var handleType = router.query.type; // 操作类型或者编码, 如： 'add'或者编码'GYS126827'

  var isAddHandle = handleType === 'add' ? true : false;

  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      spinLoading = _useState2[0],
      setSpinLoading = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      submitLoading = _useState4[0],
      setSubmitLoading = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      isModalEdit = _useState6[0],
      setIsModalEdit = _useState6[1]; // 是否能操作modal


  var _useState7 = (0,react.useState)({}),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      curGoodParams = _useState8[0],
      setCurGoodParams = _useState8[1]; // 商品modal请求数据需要(地点)


  var formOptions = {
    layout: 'vertical'
  }; // 上下排列

  var _props$location$query = props.location.query,
      id = _props$location$query.id,
      orderType = _props$location$query.orderType;

  var _useState9 = (0,react.useState)(''),
      _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
      curGoodId = _useState10[0],
      setCurGoodId = _useState10[1];

  var _useState11 = (0,react.useState)({
    name: curGoodId,
    id: ''
  }),
      _useState12 = (0,slicedToArray/* default */.Z)(_useState11, 2),
      initFormData = _useState12[0],
      setInitFormData = _useState12[1];

  var _useState13 = (0,react.useState)(),
      _useState14 = (0,slicedToArray/* default */.Z)(_useState13, 2),
      curDeliveryMerchantId = _useState14[0],
      setcurDeliveryMerchantId = _useState14[1];

  var _useState15 = (0,react.useState)(),
      _useState16 = (0,slicedToArray/* default */.Z)(_useState15, 2),
      curDeliveryPlaceId = _useState16[0],
      setcurDeliveryPlaceId = _useState16[1];

  var _useState17 = (0,react.useState)(),
      _useState18 = (0,slicedToArray/* default */.Z)(_useState17, 2),
      curReceiveMerchantId = _useState18[0],
      setcurReceiveMerchantId = _useState18[1];

  var _useState19 = (0,react.useState)(),
      _useState20 = (0,slicedToArray/* default */.Z)(_useState19, 2),
      curReceivePlaceId = _useState20[0],
      setcurReceivePlaceId = _useState20[1];

  var provinceList = (0,useCityList/* default */.Z)(1, 1);
  (0,react.useEffect)(() => {
    dispatch({
      type: 'supplierStore/provinceInfo',
      payload: {}
    });
  }, []);

  var _useMapping = (0,useMapping/* default */.Z)([enums/* purchaseEnumConfig.orderType */.Nt.orderType, enums/* purchaseEnumConfig.merchantId */.Nt.merchantId, enums/* purchaseEnumConfig.baseType */.Nt.baseType, enums/* purchaseEnumConfig.addPriceType */.Nt.addPriceType]),
      mappingList = _useMapping.mappingList;

  var fieldDataList = type => {
    return mappingList && mappingList['get'] && mappingList.get(enums/* purchaseEnumConfig */.Nt[type]);
  };

  (0,react.useEffect)(() => {
    try {
      if (mappingList) {
        setSpinLoading(false);
      }
    } catch (error) {} finally {
      setTimeout(() => {
        setSpinLoading(false);
      }, 3000);
    }
  }, [mappingList]);

  var _useState21 = (0,react.useState)({}),
      _useState22 = (0,slicedToArray/* default */.Z)(_useState21, 2),
      curCategory = _useState22[0],
      setcurCategory = _useState22[1];

  var _useState23 = (0,react.useState)([]),
      _useState24 = (0,slicedToArray/* default */.Z)(_useState23, 2),
      curCategoryArr = _useState24[0],
      setcurCategoryArr = _useState24[1];

  var _useState25 = (0,react.useState)([]),
      _useState26 = (0,slicedToArray/* default */.Z)(_useState25, 2),
      deliveryPlaceList = _useState26[0],
      setDeliveryPlaceList = _useState26[1];

  var _useState27 = (0,react.useState)([]),
      _useState28 = (0,slicedToArray/* default */.Z)(_useState27, 2),
      receivePlaceList = _useState28[0],
      setReceivePlaceList = _useState28[1];

  var _useState29 = (0,react.useState)(100),
      _useState30 = (0,slicedToArray/* default */.Z)(_useState29, 2),
      priceMax = _useState30[0],
      setMax = _useState30[1];

  var _useState31 = (0,react.useState)([]),
      _useState32 = (0,slicedToArray/* default */.Z)(_useState31, 2),
      curMPShopList = _useState32[0],
      setcurMPShopList = _useState32[1]; // 当前商家下的门店地点


  var _useState33 = (0,react.useState)([]),
      _useState34 = (0,slicedToArray/* default */.Z)(_useState33, 2),
      curMPWarehouseList = _useState34[0],
      setcurMPWarehouseList = _useState34[1]; // 当前商家下的仓库地点


  var _useState35 = (0,react.useState)([]),
      _useState36 = (0,slicedToArray/* default */.Z)(_useState35, 2),
      curMPALLhouseList = _useState36[0],
      setcurMPALLhouseList = _useState36[1]; // 当前商家下的地点+仓库地点


  var handleArr = arr => {
    return arr.map(e => {
      return {
        value: e.placeId,
        label: e.placeName,
        code: e.placeCode
      };
    });
  };
  /** 编辑: 获取当前用户权限下所有的商家和对应地点 */


  var queryMerchantPlacesInfo = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(data) {
      var orderType, deliveryMerchantId, shop_res, shop_list, arr, _arr$find, shopPlaceArr, _arr$find2, _shopPlaceArr, ware_res, ware_list, _arr, _arr$find3, warehosePlaceArr, _arr$find4, _warehosePlaceArr, ALL_res, ALL_LIST, _arr2$find, _arr2, ARR;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              orderType = data.orderType, deliveryMerchantId = data.deliveryMerchantId;
              _context.next = 3;
              return dispatch({
                type: 'map/queryComplex',
                payload: {
                  type: [40],
                  ext: {
                    placeScopes: addressTypeEnums['门店']
                  }
                }
              });

            case 3:
              shop_res = _context.sent;
              console.log('shop_res', shop_res);

              if (shop_res) {
                shop_list = JSON.parse(JSON.parse(shop_res[40])['merchants']);
                console.log('shop_list', shop_list);

                if (shop_list !== null && shop_list !== void 0 && shop_list.length) {
                  arr = shop_list.map(value => {
                    return {
                      merchantId: +value.merchantId,
                      placeVos: value.placeVos
                    };
                  });

                  if (orderType === orderTypeEnums['店仓退配'] || orderType === orderTypeEnums['店间调拨']) {
                    shopPlaceArr = (_arr$find = arr.find(e => e.merchantId == data.deliveryMerchantId)) === null || _arr$find === void 0 ? void 0 : _arr$find.placeVos; // 调出地点，当前业务类型为店仓返配|店间调拨，获取门店类型地点

                    (shopPlaceArr === null || shopPlaceArr === void 0 ? void 0 : shopPlaceArr.length) && setDeliveryPlaceList(handleArr(shopPlaceArr));
                  }

                  if (orderType === orderTypeEnums['仓店配送'] || orderType === orderTypeEnums['店间调拨']) {
                    _shopPlaceArr = (_arr$find2 = arr.find(e => e.merchantId == data.receiveMerchantId)) === null || _arr$find2 === void 0 ? void 0 : _arr$find2.placeVos; // 调入地点，当前业务类型为仓店配送|店间调拨，获取门店类型地点

                    (_shopPlaceArr === null || _shopPlaceArr === void 0 ? void 0 : _shopPlaceArr.length) && setReceivePlaceList(handleArr(_shopPlaceArr));
                  }

                  setcurMPShopList(arr);
                }
              }

              _context.next = 8;
              return dispatch({
                type: 'map/queryComplex',
                payload: {
                  type: [40],
                  ext: {
                    placeScopes: addressTypeEnums['大仓']
                  }
                }
              });

            case 8:
              ware_res = _context.sent;

              if (ware_res) {
                ware_list = JSON.parse(JSON.parse(ware_res[40])['merchants']);

                if (ware_list !== null && ware_list !== void 0 && ware_list.length) {
                  _arr = ware_list.map(value => {
                    return {
                      merchantId: +value.merchantId,
                      placeVos: value.placeVos
                    };
                  });

                  if (orderType === orderTypeEnums['仓店配送'] || orderType === orderTypeEnums['仓间调拨']) {
                    warehosePlaceArr = (_arr$find3 = _arr.find(e => e.merchantId == data.deliveryMerchantId)) === null || _arr$find3 === void 0 ? void 0 : _arr$find3.placeVos; // 调出地点，当前业务类型为仓店配送|仓间调拨，获取仓库类型地点

                    (warehosePlaceArr === null || warehosePlaceArr === void 0 ? void 0 : warehosePlaceArr.length) && setDeliveryPlaceList(handleArr(warehosePlaceArr));
                  }

                  if (orderType === orderTypeEnums['仓间调拨'] || orderType === orderTypeEnums['店仓退配']) {
                    _warehosePlaceArr = (_arr$find4 = _arr.find(e => e.merchantId == data.receiveMerchantId)) === null || _arr$find4 === void 0 ? void 0 : _arr$find4.placeVos; // 调入地点，当前业务类型为仓间调拨|店仓返配，获取仓库类型地点

                    (_warehosePlaceArr === null || _warehosePlaceArr === void 0 ? void 0 : _warehosePlaceArr.length) && setReceivePlaceList(handleArr(_warehosePlaceArr));
                  }

                  setcurMPWarehouseList(_arr);
                }
              }

              if (!(orderType === orderTypeEnums['批发销售'])) {
                _context.next = 16;
                break;
              }

              _context.next = 13;
              return dispatch({
                type: 'map/queryComplex',
                payload: {
                  type: [52],
                  ext: {
                    merchantId: deliveryMerchantId
                  }
                }
              });

            case 13:
              ALL_res = _context.sent;

              if (ALL_res) {
                ALL_LIST = JSON.parse(JSON.parse(ALL_res[52])['merchants']);

                if (ALL_LIST !== null && ALL_LIST !== void 0 && ALL_LIST.length) {
                  _arr2 = ALL_LIST.map(value => {
                    return {
                      merchantId: +value.merchantId,
                      placeVos: value.placeVos
                    };
                  });
                  ARR = (_arr2$find = _arr2.find(e => e.merchantId == data.deliveryMerchantId)) === null || _arr2$find === void 0 ? void 0 : _arr2$find.placeVos;
                  (ARR === null || ARR === void 0 ? void 0 : ARR.length) && setDeliveryPlaceList(handleArr(ARR));
                  setcurMPALLhouseList(_arr2);
                }
              }

              return _context.abrupt("return");

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function queryMerchantPlacesInfo(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  /** 新增: 获取当前用户权限下所有的商家和对应地点 */


  var initQueryMerchantPlacesInfo = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2() {
      var shop_res, shop_list, arr, ware_res, ware_list, _arr3;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch({
                type: 'map/queryComplex',
                payload: {
                  type: [40],
                  ext: {
                    placeScopes: addressTypeEnums['门店']
                  }
                }
              });

            case 2:
              shop_res = _context2.sent;

              if (shop_res) {
                shop_list = JSON.parse(JSON.parse(shop_res[40])['merchants']);

                if (shop_list !== null && shop_list !== void 0 && shop_list.length) {
                  arr = shop_list.map(value => {
                    return {
                      merchantId: +value.merchantId,
                      placeVos: value.placeVos
                    };
                  });
                  setcurMPShopList(arr);
                }
              }

              _context2.next = 6;
              return dispatch({
                type: 'map/queryComplex',
                payload: {
                  type: [40],
                  ext: {
                    placeScopes: addressTypeEnums['大仓']
                  }
                }
              });

            case 6:
              ware_res = _context2.sent;

              if (ware_res) {
                ware_list = JSON.parse(JSON.parse(ware_res[40])['merchants']);

                if (ware_list !== null && ware_list !== void 0 && ware_list.length) {
                  _arr3 = ware_list.map(value => {
                    return {
                      merchantId: +value.merchantId,
                      placeVos: value.placeVos
                    };
                  });
                  setcurMPWarehouseList(_arr3);
                }
              }

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function initQueryMerchantPlacesInfo() {
      return _ref2.apply(this, arguments);
    };
  }();
  /** 批发销售: 根据当前商家选择获取地点 */


  var getAddressIdForPF = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3(merchantId) {
      var ALL_res, ALL_LIST, ARR, key, obj;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setDeliveryPlaceList([]); // 每次切换商家时先清空

              _context3.next = 3;
              return dispatch({
                type: 'map/queryComplex',
                payload: {
                  type: [52],
                  ext: {
                    merchantId
                  }
                }
              });

            case 3:
              ALL_res = _context3.sent;
              ALL_LIST = JSON.parse(ALL_res[52]);

              if (ALL_LIST) {
                ARR = [];

                for (key in ALL_LIST) {
                  obj = JSON.parse(ALL_LIST[key]);
                  ARR.push({
                    placeId: obj['placeId'],
                    placeName: obj['placeName'],
                    placeCode: obj['placeCode'] // 注意: 页面显示改动需要注意这个数据格式

                  });
                }

                (ARR === null || ARR === void 0 ? void 0 : ARR.length) && setDeliveryPlaceList(handleArr(ARR));
              }

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function getAddressIdForPF(_x2) {
      return _ref3.apply(this, arguments);
    };
  }(); // 请求详情


  var queryDetailInfo = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee4() {
      var res, data, obj, category, _p;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              setSpinLoading(true);
              _context4.next = 4;
              return (0,ypRequest/* default */.Z)(Api/* LOSS_RATE_DETAIL_API */.oZ, {
                id,
                orderType
              });

            case 4:
              res = _context4.sent;

              if (!(res && res.success)) {
                _context4.next = 31;
                break;
              }

              data = res.result;
              obj = {
                orderType: data.orderType,
                operator: data.operator,
                amount: data.amount,
                baseType: data.baseType,
                addPriceType: data.addPriceType,
                goodsId: data === null || data === void 0 ? void 0 : data.goodsId,
                category: data.secondCategoryId,
                address: [data.provinceCode]
              };

              if (data !== null && data !== void 0 && data.customerName) {
                setCustomerInfo([{
                  customerName: data === null || data === void 0 ? void 0 : data.customerName,
                  customerNo: data === null || data === void 0 ? void 0 : data.customerNo
                }]);
              }

              setorderType(data.orderType);

              if (!(obj !== null && obj !== void 0 && obj.goodsId) || (obj === null || obj === void 0 ? void 0 : obj.goodsId) === 0 || (obj === null || obj === void 0 ? void 0 : obj.goodsId) === '0') {
                delete obj['goodsId'];
              }

              data.firstCategoryId && setcurCategoryArr([data.firstCategoryId]);
              data.secondCategoryId && setcurCategoryArr([data.firstCategoryId].concat([data.secondCategoryId]));
              data.threeCategoryId && setcurCategoryArr([data.firstCategoryId, data.secondCategoryId].concat([data.threeCategoryId]));
              data.threeCategoryId && setcurCategoryArr([data.firstCategoryId, data.secondCategoryId, data.threeCategoryId].concat([data.fourCategoryId]));
              baseInfoForm.current.setFieldsValue(obj);
              setMax(data.addPriceType !== 1 ? Infinity : 100);
              setInitFormData((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, initFormData), {}, {
                id: data.goodsId === '0' ? '' : data.goodsId,
                name: data.goodsName
              }));

              if (data !== null && data !== void 0 && data.goodsId && (data === null || data === void 0 ? void 0 : data.goodsId) !== '0') {
                setCurGoodId(data.goodsId);
              }

              category = {
                firstCategoryId: data.firstCategoryId,
                firstCategoryName: data.firstCategoryName,
                secondCategoryId: data.secondCategoryId,
                secondCategoryName: data.secondCategoryName,
                threeCategoryId: data.threeCategoryId,
                threeCategoryName: data.threeCategoryName,
                fourCategoryId: data.fourCategoryId,
                fourCategoryName: data.fourCategoryName
              };
              setcurCategory(category);
              _p = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, curGoodParams), {}, {
                merchantId: parseInt(data.deliveryMerchantId),
                firstCategoryId: data.firstCategoryId
              });

              if (data !== null && data !== void 0 && data.secondCategoryId) {
                _p.secondCategoryId = data.secondCategoryId;
              }

              setCurGoodParams(_p);
              data.deliveryMerchantId && setcurDeliveryMerchantId(+data.deliveryMerchantId);

              if (data.orderType === orderTypeEnums['批发销售']) {
                getAddressIdForPF(data.deliveryMerchantId);
              }

              data.deliveryPlaceId && setcurDeliveryPlaceId(data.deliveryPlaceId);
              data.receiveMerchantId && setcurReceiveMerchantId(+data.receiveMerchantId);

              if (data.receivePlaceId == '0') {
                setcurReceivePlaceId(undefined);
              } else {
                data.receivePlaceId && setcurReceivePlaceId(data.receivePlaceId);
              } // data.receivePlaceId && setcurReceivePlaceId(data.receivePlaceId)
              // getPlaceList('deliver', data.deliveryMerchantId)


              _context4.next = 31;
              return queryMerchantPlacesInfo(data);

            case 31:
              _context4.next = 36;
              break;

            case 33:
              _context4.prev = 33;
              _context4.t0 = _context4["catch"](0);
              setSpinLoading(false); // console.error('queryDetailInfoERROR', error)

            case 36:
              _context4.prev = 36;
              setTimeout(() => {
                setSpinLoading(false);
              }, 5000);
              return _context4.finish(36);

            case 39:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 33, 36, 39]]);
    }));

    return function queryDetailInfo() {
      return _ref4.apply(this, arguments);
    };
  }(); // 初始化数据


  (0,react.useEffect)(() => {
    if (!isAddHandle) {
      queryDetailInfo();
      setIsModalEdit(true);
    } else {
      // 默认设置基数类型和加价类型
      baseInfoForm.current.setFieldsValue({
        baseType: 1,
        addPriceType: 1
      });
      initQueryMerchantPlacesInfo();
    }
  }, [handleType]); // 提交

  var submit = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee5(params) {
      var result;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              setSubmitLoading(true);
              _context5.prev = 1;
              _context5.next = 4;
              return (0,ypRequest/* default */.Z)(Api/* SAVE_LOSS_RATE_API */.N9, params);

            case 4:
              result = _context5.sent;

              if (result && result.success) {
                setSubmitLoading(false);

                message.default.success('操作成功');

                setTimeout(() => {
                  history.push('/ConfigManage/SupplyChain/PriceIncreaseRule');
                }, 800);
              }

              _context5.next = 10;
              break;

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](1);

            case 10:
              _context5.prev = 10;
              setTimeout(() => {
                setSubmitLoading(false);
              }, 1500);
              return _context5.finish(10);

            case 13:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 8, 10, 13]]);
    }));

    return function submit(_x3) {
      return _ref5.apply(this, arguments);
    };
  }();

  var baseHandler = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee6() {
      var _p$address, p, k;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return baseInfoForm.current.validateFields();

            case 3:
              p = baseInfoForm.current.getFieldsValue();

              if (id) {
                p.id = id;
              }

              if (curDeliveryMerchantId) {
                _context6.next = 8;
                break;
              }

              message.default.warn('请选择调出商家!');

              return _context6.abrupt("return");

            case 8:
              if ((p === null || p === void 0 ? void 0 : p.orderType) === orderTypeEnums['批发销售'] && p !== null && p !== void 0 && (_p$address = p.address) !== null && _p$address !== void 0 && _p$address.length) {
                p['provinceCode'] = p === null || p === void 0 ? void 0 : p.address[0]; // p['cityCode'] = p?.address[1] || ''
              }

              p['deliveryMerchantId'] = curDeliveryMerchantId;
              p['receiveMerchantId'] = curReceiveMerchantId;
              p['deliveryPlaceId'] = curDeliveryPlaceId;
              p['receivePlaceId'] = curReceivePlaceId;
              p['firstCategoryId'] = curCategory['firstCategoryId'];
              p['firstCategoryName'] = curCategory['firstCategoryName'];
              p['secondCategoryId'] = curCategory['secondCategoryId'];
              p['secondCategoryName'] = curCategory['secondCategoryName'];
              p['threeCategoryId'] = curCategory['threeCategoryId'];
              p['threeCategoryName'] = curCategory['threeCategoryName'];
              p['fourCategoryId'] = curCategory['fourCategoryId'];
              p['fourCategoryName'] = curCategory['fourCategoryName'];

              for (k in p) {
                if (p[k] === undefined || p[k] === null || p[k] === '') {
                  delete p[k];
                }
              }

              delete p['address'];

              if (!(!p['firstCategoryName'] && !curGoodId)) {
                _context6.next = 27;
                break;
              }

              message.default.error('商品类目或者商品必须选择一种');

              setSubmitLoading(false);
              return _context6.abrupt("return", false);

            case 27:
              if (!curGoodId && curGoodId === '0') {
                delete p['goodsId'];
              }

              if (!(curDeliveryMerchantId && !curDeliveryPlaceId)) {
                _context6.next = 32;
                break;
              }

              message.default.error('请选择调出地地点');

              setSubmitLoading(false);
              return _context6.abrupt("return", false);

            case 32:
              if (!(curReceiveMerchantId && !curReceivePlaceId)) {
                _context6.next = 36;
                break;
              }

              message.default.error('请选择调入地地点');

              setSubmitLoading(false);
              return _context6.abrupt("return", false);

            case 36:
              if (customerInfo !== null && customerInfo !== void 0 && customerInfo.length && (p === null || p === void 0 ? void 0 : p.orderType) === orderTypeEnums['批发销售']) {
                p['list'] = customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.map(e => {
                  return {
                    customerNo: e === null || e === void 0 ? void 0 : e.customerNo,
                    customerName: e === null || e === void 0 ? void 0 : e.customerName
                  };
                });
              }

              submit(p);
              _context6.next = 43;
              break;

            case 40:
              _context6.prev = 40;
              _context6.t0 = _context6["catch"](0);
              setSubmitLoading(false); // console.error(error)

            case 43:
              _context6.prev = 43;
              setTimeout(() => {
                setSubmitLoading(false);
              }, 3000);
              return _context6.finish(43);

            case 46:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 40, 43, 46]]);
    }));

    return function baseHandler() {
      return _ref6.apply(this, arguments);
    };
  }();

  var debounceSubmit = debounce_default()(baseHandler, 600);
  /** 调出商家/地  onchange func */

  var changeField = (type, val, data) => {
    switch (type) {
      case 'deliveryMerchant':
        setDeliveryPlaceList([]); // 每次选择商家都清空一次地点选择

        setcurDeliveryMerchantId(val);
        setcurDeliveryPlaceId(undefined);
        setCurGoodParams((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, curGoodParams), {}, {
          merchantId: parseInt(val)
        }));
        getPlaceList('deliver', val);
        break;

      case 'deliveryPlace':
        setcurDeliveryPlaceId(val);
        break;

      default:
        break;
    }
  };
  /** 调入商家/地 onchange func */


  var changeReceiveField = (type, val, data) => {
    switch (type) {
      case 'receiveMerchant':
        setReceivePlaceList([]); // 每次选择商家都清空一次地点选择

        setcurReceiveMerchantId(val);
        setcurReceivePlaceId(undefined);
        setCurGoodParams((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, curGoodParams), {}, {
          merchantId: parseInt(val)
        }));
        getPlaceList('receive', val);
        break;

      case 'receivePlace':
        setcurReceivePlaceId(val);
        break;

      default:
        break;
    }
  };

  var changeorderType = e => {
    setorderType(e);
  };

  var _useState37 = (0,react.useState)(),
      _useState38 = (0,slicedToArray/* default */.Z)(_useState37, 2),
      curorderType = _useState38[0],
      setorderType = _useState38[1];

  var _useState39 = (0,react.useState)(),
      _useState40 = (0,slicedToArray/* default */.Z)(_useState39, 2),
      customerInfo = _useState40[0],
      setCustomerInfo = _useState40[1];

  var formfields = (0,react.useMemo)(() => {
    var _fieldDataList, _fieldDataList2, _baseInfoForm$current;

    var handleSetFormData = val => {
      if (val && val.length) {
        var obj = {
          name: val[0].goodsName,
          id: val[0].goodsId === '0' ? '' : val[0].goodsId
        };
        setInitFormData(obj);
        setCurGoodId(val[0].goodsId);
        baseInfoForm.current.setFieldsValue({
          goodsId: val[0].goodsId
        });
      } else {
        setInitFormData({
          name: '',
          id: ''
        });
        setCurGoodId(null);
        baseInfoForm.current.setFieldsValue({
          goodsId: null
        });
      }
    };

    var handleSetCustomer = val => {
      setCustomerInfo(val !== null && val !== void 0 && val.length ? val : []);
    };

    var handleCategory = val => {
      //   baseInfoForm.current.setFieldsValue({ category: val })
      setcurCategory(val);

      var p = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, curGoodParams), {}, {
        firstCategoryId: val === null || val === void 0 ? void 0 : val.firstCategoryId
      });

      if (val !== null && val !== void 0 && val.secondCategoryId) {
        p.secondCategoryId = val.secondCategoryId;
      }

      if (!(val !== null && val !== void 0 && val.secondCategoryId)) {
        p === null || p === void 0 ? true : delete p.secondCategoryId;
      }

      setCurGoodParams(p);
    };

    return [{
      label: '业务类型',
      name: 'orderType',
      type: 'SELECT',
      required: true,
      fieldOptions: {
        onChange: changeorderType
      },
      dataList: [{
        value: 1,
        label: '仓店配送'
      }, {
        value: 2,
        label: '店间调拨'
      }, {
        value: 3,
        label: '仓间调拨'
      }, // {
      //   value: 4,
      //   label: '店仓退配'
      // },
      {
        value: 5,
        label: '批发销售'
      }]
    }, {
      label: '调出商家/地',
      name: '_deliveryMerchantId',
      // required: true,
      widget: /*#__PURE__*/react.createElement(input/* default.Group */.Z.Group, {
        compact: true
      }, /*#__PURE__*/react.createElement(es_select/* default */.Z, {
        placeholder: "\u8C03\u51FA\u5546\u5BB6",
        dropdownMatchSelectWidth: false,
        showSearch: true,
        allowClear: true,
        value: curDeliveryMerchantId,
        optionLabelProp: "children",
        style: {
          width: '50%'
        },
        onChange: (v, o) => changeField('deliveryMerchant', v, o) // onSelect={selectMerchant}
        ,
        filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 // disabled={disableMerchant}

      }, ((_fieldDataList = fieldDataList('merchantId')) === null || _fieldDataList === void 0 ? void 0 : _fieldDataList.length) && fieldDataList('merchantId').map(v => /*#__PURE__*/react.createElement(es_select/* default.Option */.Z.Option, {
        value: v.value,
        key: v.value,
        rows: v
      }, v.label))), /*#__PURE__*/react.createElement(es_select/* default */.Z, {
        placeholder: "\u8C03\u51FA\u5730",
        dropdownMatchSelectWidth: false,
        showSearch: true,
        allowClear: true,
        value: curDeliveryPlaceId,
        optionLabelProp: "children",
        style: {
          width: '50%'
        },
        onChange: (v, o) => changeField('deliveryPlace', v, o),
        filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 // onSelect={selectPlace}
        // disabled={disablePlace}

      }, (deliveryPlaceList === null || deliveryPlaceList === void 0 ? void 0 : deliveryPlaceList.length) && deliveryPlaceList.map(v => /*#__PURE__*/react.createElement(es_select/* default.Option */.Z.Option, {
        value: v.value,
        key: v.value,
        rows: v
      }, v.code + ' - ' + v.label))))
    }, {
      label: '省份',
      name: 'address',
      // hide: curorderType === orderTypeEnums['批发销售'] ? false : true,
      widget: /*#__PURE__*/react.createElement(cascader/* default */.Z, {
        fieldNames: {
          label: 'name',
          value: 'code'
        },
        options: provinceList,
        placeholder: "\u8BF7\u9009\u62E9\u7701\u5E02",
        changeOnSelect: true
      })
    }, {
      label: '调入商家/地',
      name: '_receiveMerchantId',
      hide: curorderType === orderTypeEnums['批发销售'] ? true : false,
      widget: /*#__PURE__*/react.createElement(input/* default.Group */.Z.Group, {
        compact: true
      }, /*#__PURE__*/react.createElement(es_select/* default */.Z, {
        placeholder: "\u8C03\u5165\u5546\u5BB6",
        dropdownMatchSelectWidth: false,
        showSearch: true,
        allowClear: true,
        value: curReceiveMerchantId,
        optionLabelProp: "children",
        style: {
          width: '50%'
        },
        filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
        onChange: (v, o) => {
          changeReceiveField('receiveMerchant', v, o);
        }
      }, ((_fieldDataList2 = fieldDataList('merchantId')) === null || _fieldDataList2 === void 0 ? void 0 : _fieldDataList2.length) && fieldDataList('merchantId').map(v => /*#__PURE__*/react.createElement(es_select/* default.Option */.Z.Option, {
        value: v.value,
        key: v.value,
        rows: v
      }, v.label))), /*#__PURE__*/react.createElement(es_select/* default */.Z, {
        placeholder: "\u8C03\u5165\u5730",
        dropdownMatchSelectWidth: false,
        showSearch: true,
        allowClear: true,
        value: curReceivePlaceId,
        optionLabelProp: "children",
        style: {
          width: '50%'
        },
        filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
        onChange: (v, o) => changeReceiveField('receivePlace', v, o)
      }, (receivePlaceList === null || receivePlaceList === void 0 ? void 0 : receivePlaceList.length) && receivePlaceList.map(v => /*#__PURE__*/react.createElement(es_select/* default.Option */.Z.Option, {
        value: v.value,
        key: v.value,
        rows: v
      }, v.label))))
    }, {
      label: '基数类型',
      name: 'baseType',
      type: 'SELECT',
      dataList: fieldDataList('baseType'),
      required: true,
      fieldOptions: {
        defaultValue: 1
      }
    }, {
      label: '加价类型',
      name: 'addPriceType',
      type: 'SELECT',
      dataList: fieldDataList('addPriceType'),
      required: true,
      fieldOptions: {
        defaultValue: 1,
        disabled: true
      }
    }, {
      label: '加价额/率',
      name: 'amount',
      type: 'INPUT_NUMBER',
      required: true,
      rules: [{
        validator: (_, value) => {
          var n = Number(value);

          if (n < 0) {
            return Promise.reject('输入的数值需要大于等于0');
          }

          return Promise.resolve();
        }
      }],
      fieldOptions: {
        formatter: math/* limitDecimalsThree */.ed,
        max: 999999.999
      }
    }, {
      label: '商品类目',
      name: 'category',
      // required: true,
      widget: /*#__PURE__*/react.createElement(PurchaseCategorySelect/* PurchaseCategorySelect */.o, {
        handleCategory: handleCategory,
        curCategoryArr: curCategoryArr
      })
    }, {
      label: '选择商品',
      name: 'goodsId',
      // required: true,
      widget: /*#__PURE__*/react.createElement(components_MerchantFormfield, {
        name: "goodsId",
        title: "\u9009\u62E9\u5546\u54C1",
        btnText: "\u9009\u62E9\u5546\u54C1",
        initFormData: initFormData,
        isEdit: true,
        searchParams: {
          condition: curGoodParams
        },
        queryDataUrl: Api/* MERCHANT_GOODS_LIST */.Q9,
        tableOptions: {
          rowSelection: {
            type: 'radio'
          }
        },
        handleSetFormData: handleSetFormData
      })
    }, {
      label: '批发客户',
      name: 'list',
      hide: curorderType === orderTypeEnums['批发销售'] ? false : true,
      widget: /*#__PURE__*/react.createElement(components_CustomerFormfield, {
        provinceInfo: baseInfoForm === null || baseInfoForm === void 0 ? void 0 : (_baseInfoForm$current = baseInfoForm.current) === null || _baseInfoForm$current === void 0 ? void 0 : _baseInfoForm$current.getFieldValue('address'),
        handleSetCustomer: handleSetCustomer,
        customerInfo: customerInfo
      })
    }];
  }, [mappingList, initFormData, curGoodParams, deliveryPlaceList, changeorderType, priceMax, curDeliveryMerchantId, curDeliveryPlaceId, curMPWarehouseList, curMPShopList, curReceivePlaceId, curReceiveMerchantId, curMPALLhouseList]);
  /** 表单改变 */

  var changeBaseForm = e => {
    var current = baseInfoForm.current;

    if (e && Object.keys(e)[0] === 'baseType') {
      var baseType = current.getFieldValue('baseType');
      current.setFieldsValue({
        addPriceType: baseType
      });
      setMax(baseType !== 1 ? Infinity : 100);
    }

    if (e && Object.keys(e)[0] === 'addPriceType') {
      var addPriceType = current.getFieldValue('addPriceType');
      setMax(addPriceType !== 1 ? Infinity : 100);
    }

    if (e && Object.keys(e)[0] === 'orderType') {
      setcurDeliveryMerchantId(undefined);
      setcurDeliveryPlaceId(undefined);
      setDeliveryPlaceList([]);
      setReceivePlaceList([]);
      setcurReceiveMerchantId(undefined);
      setcurReceivePlaceId(undefined);
    }

    if (e && Object.keys(e)[0] === 'address') {
      setCustomerInfo([]); // 切换地址清空批发客户
    }
  };
  /** 调出/入 根据商家获取地点list */


  var getPlaceList = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee7(type, id) {
      var _baseInfoForm$current3, _curMPWarehouseList$f, _curMPShopList$find;

      var _baseInfoForm$current2, orderType, warehosePlaceArr, shopPlaceArr;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _baseInfoForm$current2 = baseInfoForm === null || baseInfoForm === void 0 ? void 0 : (_baseInfoForm$current3 = baseInfoForm.current) === null || _baseInfoForm$current3 === void 0 ? void 0 : _baseInfoForm$current3.getFieldValue(), orderType = _baseInfoForm$current2.orderType;
              warehosePlaceArr = (_curMPWarehouseList$f = curMPWarehouseList.find(e => e.merchantId == id)) === null || _curMPWarehouseList$f === void 0 ? void 0 : _curMPWarehouseList$f.placeVos;
              console.log('curMPShopList', curMPShopList);
              shopPlaceArr = (_curMPShopList$find = curMPShopList.find(e => e.merchantId == id)) === null || _curMPShopList$find === void 0 ? void 0 : _curMPShopList$find.placeVos;
              console.log('shopPlaceArr', shopPlaceArr); // const ALLPlaceArr = curMPALLhouseList.find((e: any) => e.merchantId == id)?.placeVos

              if (!(type === 'deliver')) {
                _context7.next = 13;
                break;
              }

              console.log('orderType', orderType, id);

              if (!(orderType === orderTypeEnums['批发销售'] && id)) {
                _context7.next = 10;
                break;
              }

              getAddressIdForPF(id);
              return _context7.abrupt("return");

            case 10:
              if (orderType === orderTypeEnums['仓店配送'] || orderType === orderTypeEnums['仓间调拨']) {
                // 调出商家，当前业务类型为仓店配送|仓间调拨，获取仓库类型地点
                (warehosePlaceArr === null || warehosePlaceArr === void 0 ? void 0 : warehosePlaceArr.length) && setDeliveryPlaceList(handleArr(warehosePlaceArr));
              } else {
                (shopPlaceArr === null || shopPlaceArr === void 0 ? void 0 : shopPlaceArr.length) && setDeliveryPlaceList(handleArr(shopPlaceArr));
              }

              _context7.next = 14;
              break;

            case 13:
              if (orderType === orderTypeEnums['仓店配送'] || orderType === orderTypeEnums['店间调拨']) {
                // 调出商家，当前业务类型为仓店配送|仓间调拨，获取仓库类型地点
                (shopPlaceArr === null || shopPlaceArr === void 0 ? void 0 : shopPlaceArr.length) && setReceivePlaceList(handleArr(shopPlaceArr));
              } else {
                (warehosePlaceArr === null || warehosePlaceArr === void 0 ? void 0 : warehosePlaceArr.length) && setReceivePlaceList(handleArr(warehosePlaceArr));
              }

            case 14:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function getPlaceList(_x4, _x5) {
      return _ref7.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(() => {
    // setCurGoodParams(curGoodParams)
    if (curGoodParams && curGoodParams['merchantId'] && curGoodParams['placeId']) {
      setIsModalEdit(true);
    }
  }, [curGoodParams]);
  return /*#__PURE__*/react.createElement(CommonWrap/* default */.Z, {
    id: "supplierEdit"
  }, /*#__PURE__*/react.createElement("div", {
    className: "wrapStyle"
  }, /*#__PURE__*/react.createElement(BigTitle/* default */.Z, {
    title: "\u52A0\u4EF7\u89C4\u5219-".concat(isAddHandle ? '新增' : '编辑')
  }), /*#__PURE__*/react.createElement(spin/* default */.Z, {
    spinning: spinLoading
  }, /*#__PURE__*/react.createElement("div", {
    className: "wrapStyle"
  }, /*#__PURE__*/react.createElement(FormBuilder/* default */.Z, {
    ref: baseInfoForm,
    elements: formfields,
    notSearchForm: true,
    formOptions: formOptions,
    colon: true,
    onChange: changeBaseForm,
    responsed: true
  })), /*#__PURE__*/react.createElement(FixedBottomCps/* default */.Z, {
    outerRE: /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      onClick: () => history.goBack()
    }, "\u8FD4\u56DE"), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      type: "primary",
      onClick: () => {
        setSubmitLoading(true);
        debounceSubmit();
      },
      loading: submitLoading
    }, "\u786E\u8BA4"))
  }))));
};

/* harmony default export */ var Edit = (HandleEdit);

/***/ }),

/***/ 67943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R0": function() { return /* binding */ SUPPLIER_ORDER_LIST; },
/* harmony export */   "pu": function() { return /* binding */ SUPPLIER_ORDER_DELETE; },
/* harmony export */   "yc": function() { return /* binding */ SUPPLIER_ORDER_INFO; },
/* harmony export */   "kb": function() { return /* binding */ SUPPLIER_ORDER_SAVE; },
/* harmony export */   "$H": function() { return /* binding */ SUPPLIER_ORDER_IMPORT; },
/* harmony export */   "Q9": function() { return /* binding */ MERCHANT_GOODS_LIST; },
/* harmony export */   "Kq": function() { return /* binding */ BATCH_DELETE; }
/* harmony export */ });
/**
 * API集合
 */
// 供应商出单日配置列表
var SUPPLIER_ORDER_LIST = 'scm.supplierIssueDate.querySupplierIssueDatePage'; // 删除供应商出单日配置

var SUPPLIER_ORDER_DELETE = 'scm.supplierIssueDate.deleteSupplierIssueDate'; // 根据id查询供应商出单日配置

var SUPPLIER_ORDER_INFO = 'scm.supplierIssueDate.querySupplierIssueDateById'; // 供应商出单日配置保存

var SUPPLIER_ORDER_SAVE = 'scm.supplierIssueDate.modifySupplierIssueDate'; // 导入

var SUPPLIER_ORDER_IMPORT = 'scm.supplierIssueDate.importSupplierIssueDate';
var MERCHANT_GOODS_LIST = 'purchase.product.querySelectMerchantProductByCondition'; // 批量删除

var BATCH_DELETE = '/scmConfig/supplierIssueDateService/batchDeleteSupplierIssueDate';

/***/ }),

/***/ 60798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DICTIONARY": function() { return /* binding */ DICTIONARY; },
/* harmony export */   "BASE_MAP": function() { return /* binding */ BASE_MAP; },
/* harmony export */   "weekNameArr": function() { return /* binding */ weekNameArr; },
/* harmony export */   "TABLE_COLUMNS": function() { return /* binding */ TABLE_COLUMNS; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96534);



/**
 * 业务常量
 */

 // 字典

var DICTIONARY = [{
  key: 'SupplierCategory',
  configMap: {
    '1': '采购供应商',
    '2': '农户供应商'
  }
}]; // 字段名对应的映射
// https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=31411559
// export const purchaseObj: any = {
//   billState: 9,
//   categoryCode: 4,
//   placeCode: 3,
//   orderType: 10,
//   isStraight: 43,
//   categoryCodeAll: 46,
//   firstCategoryId: 4, // 一级类目
//   secondCategoryId: 5, // 一级类目
//   placeId: 3, // 地点
//   merchantId: 40, // 商家/机构
//   logisticMode: 7 // 物流模式
// }

var BASE_MAP = [// int64 organizationId = 2; //机构id, 商家id
// string placeId = 3; //调出地id，all-全部
// string firstCategoryId = 4; //一级分类id，all-全部
// string secondCategoryId = 5; //二级分类id，all-全部
// int64 goodsId = 6; //商品编码
// int32 wastageRate = 7; // 基数类型，1-按单价、2-按金额
// string operator = 8; // 操作人
// 基础信息
['organizationCode', ['机构编码', '']], ['organizationName', ['机构', '']], ['placeName', ['地点', '']], ['firstCategoryName', ['一级品类', '']], ['secondCategoryName', ['二级品类', '']], ['wastageRate', ['商品损耗率(%)', '']], ['goodsName', ['商品名', '']], ['goodsId', ['商品编码', '']], ['operator', ['操作人', '']]]; // int64 merchantId = 2; //地点所属商家id
// string merchantName = 26; //地点所属商家名称
// string merchantCode = 27; //地点所属商家编码
// int64 placeId = 3; //地点Id
// string placeCode=4;//地点编码
// string placeName=5;//地点名称
// int64 type = 6; //订货周期类型 1按 周 2 按天
// string typeName = 10; //订货周期类型名称
// string weekOrderDate=7;//订货日期（周）
// string monthOrderDate=8;//订货日期（月）
// string updateTime=9;//最后更新时间

var weekNameArr = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'];
var TABLE_COLUMNS = [{
  title: '商家编码',
  dataIndex: 'merchantCode',
  key: 'merchantCode',
  width: 120
}, {
  title: '商家名称',
  dataIndex: 'merchantName',
  key: 'merchantName',
  width: 150,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '地点编码',
  dataIndex: 'placeCode',
  key: 'placeCode',
  width: 80
}, {
  title: '地点名称',
  dataIndex: 'placeName',
  key: 'placeName',
  width: 180,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '周期类型',
  dataIndex: 'typeName',
  key: 'typeName',
  width: 80
}, {
  title: '订货日期(周)',
  dataIndex: 'weekOrderDate',
  key: 'weekOrderDate',
  width: 140,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, (0,_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exChangeWeekDate */ .GK)(t))
}, {
  title: '订货日期(月)',
  dataIndex: 'monthOrderDate',
  key: 'monthOrderDate',
  width: 140,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    placement: "topLeft",
    title: (0,_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exChangeMongthDate */ .cX)(t, true)
  }, (0,_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exChangeMongthDate */ .cX)(t, true))
}, {
  title: '供应商编码',
  dataIndex: 'supplierCode',
  key: 'supplierCode',
  width: 100
}, {
  title: '供应商名称',
  dataIndex: 'supplierName',
  key: 'supplierName',
  width: 150
}, {
  title: '品牌',
  dataIndex: 'brandId',
  key: 'brandId',
  width: 170,
  render: (t, r) => {
    return Number(t) !== 0 && "".concat(t, "-").concat(r.brandName);
  }
}, {
  title: '商品',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 170,
  render: (t, r) => {
    return Number(t) !== 0 && "".concat(t, "-").concat(r.goodsName);
  }
}, {
  title: '送货天数',
  dataIndex: 'deliveryDays',
  key: 'deliveryDays',
  width: 100
}, {
  title: '起送金额',
  dataIndex: 'thresholdAmount',
  key: 'thresholdAmount',
  width: 130
}, {
  title: '起订量',
  dataIndex: 'thresholdQty',
  key: 'thresholdQty',
  width: 130
}, {
  title: '更新时间',
  dataIndex: 'updateTime',
  key: 'updateTime',
  width: 180
}, {
  title: '最后更新人',
  dataIndex: 'updateUserName',
  key: 'updateUserName',
  width: 110
}];

/***/ }),

/***/ 63000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lG": function() { return /* binding */ DELIVERY_DETAIL_API; },
/* harmony export */   "e1": function() { return /* binding */ DELIVERY_LIST_API; },
/* harmony export */   "OB": function() { return /* binding */ DELIVERY_MODIFY_API; },
/* harmony export */   "yG": function() { return /* binding */ IMPORT_ORDER; },
/* harmony export */   "EZ": function() { return /* binding */ COPY_ROUTE_API; }
/* harmony export */ });
/**
 * API集合
 */
// 详情
var DELIVERY_DETAIL_API = 'scm.routing.queryScmRoutingWarehouseById'; // 列表

var DELIVERY_LIST_API = 'scm.routing.queryScmRoutingPage'; // 保存

var DELIVERY_MODIFY_API = 'scm.routing.modifyScmRouting'; // 导入

var IMPORT_ORDER = 'scm.routing.importScmRouting'; // 门店路由复制（apigw2 新网关）

var COPY_ROUTE_API = '/scm/routing/copyScmRouting';

/***/ }),

/***/ 68098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_input_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47673);
/* harmony import */ var antd_es_input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4107);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34041);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);








/**
 * 一级品类、二级品类联动的自定义表单控件
 * 数据格式为CategoryCompactValue
 * 配合Form
 */

var Option = antd_es_select__WEBPACK_IMPORTED_MODULE_3__/* .default.Option */ .Z.Option;

function CategorySelect(props) {
  var _props$firstProps = props.firstProps,
      firstProps = _props$firstProps === void 0 ? {} : _props$firstProps,
      _props$secondProps = props.secondProps,
      secondProps = _props$secondProps === void 0 ? {} : _props$secondProps,
      _props$categoryList = props.categoryList,
      categoryList = _props$categoryList === void 0 ? [] : _props$categoryList,
      value = props.value,
      onChange = props.onChange,
      formValue = props.formValue; // const [firstValue, setFirstValue]: any = useState()
  // const [secondValue, setSecondValue] = useState()

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      secondOptions = _useState2[0],
      setSecondOptions = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    // debugger
    var firstValueTmp = formValue === null || formValue === void 0 ? void 0 : formValue.first;

    if (!firstValueTmp) {
      return;
    }

    try {
      var _Object$values;

      // 二级的下拉数据
      var _ref = (categoryList === null || categoryList === void 0 ? void 0 : categoryList.length) && categoryList.find(v => +v.value === firstValueTmp) || {},
          others = _ref.others;

      if (!(others !== null && others !== void 0 && others.childCategoryList)) {
        setSecondOptions([]);
      }

      if (others !== null && others !== void 0 && others.childCategoryList && (_Object$values = Object.values(others === null || others === void 0 ? void 0 : others.childCategoryList)) !== null && _Object$values !== void 0 && _Object$values.length) {
        var list = Object.values(others === null || others === void 0 ? void 0 : others.childCategoryList).map(v => ({
          value: v.categoryId,
          label: v.categoryName
        }));
        setSecondOptions(list);
      }
    } catch (error) {
      console.log(error);
    }
  }, [categoryList, formValue]);

  var changeFirstSelect = (value, data) => {
    if (onChange) {
      onChange({
        first: value,
        second: undefined
      });
    }
  };

  var changeSecondSelect = secondValue => {
    if (onChange) {
      var _value = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)({}, formValue), {}, {
        second: secondValue
      });

      onChange(_value);
    }
  };

  var renderOptions = dataSource => {
    if (dataSource && dataSource.length > 0) {
      return dataSource.map(v => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(Option, {
        value: v.value,
        key: v.value,
        rows: v
      }, v.label));
    }

    return null;
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_6__/* .default.Group */ .Z.Group, {
    compact: true
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({
    placeholder: "\u4E00\u7EA7",
    dropdownMatchSelectWidth: false,
    showSearch: true,
    allowClear: true,
    optionLabelProp: "children",
    style: {
      width: '50%'
    },
    onChange: changeFirstSelect,
    value: formValue === null || formValue === void 0 ? void 0 : formValue.first
  }, firstProps), renderOptions(categoryList)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({
    placeholder: "\u4E8C\u7EA7",
    dropdownMatchSelectWidth: false,
    showSearch: true,
    allowClear: true,
    value: formValue === null || formValue === void 0 ? void 0 : formValue.second // filterOption={false}
    ,
    optionLabelProp: "children",
    style: {
      width: '50%'
    },
    onChange: changeSecondSelect
  }, secondProps), renderOptions(secondOptions)));
}

/* harmony default export */ __webpack_exports__["Z"] = (CategorySelect);

/***/ }),

/***/ 33629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p2": function() { return /* binding */ handleFilterPlace; },
/* harmony export */   "PB": function() { return /* binding */ handleFilterDc; }
/* harmony export */ });
/* harmony import */ var antd_es_input_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47673);
/* harmony import */ var antd_es_input__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4107);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(31097);
/* harmony import */ var antd_es_spin_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20228);
/* harmony import */ var antd_es_spin__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11382);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34041);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2824);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8870);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71720);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7704);
/* harmony import */ var _pages_Allocation_Distribution_Edit_constance__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69758);













/* eslint-disable react-hooks/exhaustive-deps */

/**
 * 商家、地点表单项及其联动 : 编辑页商家地点
 */





/**
 * 过滤门店和营业部
 * @param list
 */
var handleFilterPlace = list => {
  var _list$filter, _list$filter$call;

  var placeScopeSHOP = _pages_Allocation_Distribution_Edit_constance__WEBPACK_IMPORTED_MODULE_6__/* .PlaceScopeType.STORE */ .fY.STORE;
  var placeScopeYYB = _pages_Allocation_Distribution_Edit_constance__WEBPACK_IMPORTED_MODULE_6__/* .PlaceScopeType.YYB */ .fY.YYB;

  var _list = list === null || list === void 0 ? void 0 : (_list$filter = list.filter) === null || _list$filter === void 0 ? void 0 : (_list$filter$call = _list$filter.call(list, v => {
    var _v$others;

    var scope = v === null || v === void 0 ? void 0 : (_v$others = v.others) === null || _v$others === void 0 ? void 0 : _v$others.placeScope;
    return scope !== placeScopeSHOP && scope !== placeScopeYYB;
  })) === null || _list$filter$call === void 0 ? void 0 : _list$filter$call.map(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({}, v), {}, {
    label: v.label
  }));

  return _list || [];
};
/**
 * 过滤大仓
 * @param list
 */

var handleFilterDc = list => {
  var _list$filter2;

  var placeScopeSHOP = _pages_Allocation_Distribution_Edit_constance__WEBPACK_IMPORTED_MODULE_6__/* .PlaceTypeNumber.SHOP */ .zV.SHOP; // 默认过滤掉大仓

  var _list = list === null || list === void 0 ? void 0 : (_list$filter2 = list.filter) === null || _list$filter2 === void 0 ? void 0 : _list$filter2.call(list, v => {
    var _v$others2;

    var scope = v === null || v === void 0 ? void 0 : (_v$others2 = v.others) === null || _v$others2 === void 0 ? void 0 : _v$others2.placeScope;
    return scope === placeScopeSHOP; // return PlaceType[scope as PlaceScopeType] === placeScopeSHOP
  }).map(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({}, v), {}, {
    label: v.label // code: v.label

  }));

  return _list || [];
};

function useChainEditPlaceAndMerchant(props) {
  var label = props.label,
      merchantName = props.merchantName,
      placeName = props.placeName,
      disableMerchant = props.disableMerchant,
      disablePlace = props.disablePlace,
      placeDefaultValue = props.placeDefaultValue,
      merchantDefaultValue = props.merchantDefaultValue,
      changeFieldCallback = props.changeFieldCallback,
      changeMerchantback = props.changeMerchantback;
  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_8__/* .useDispatch */ .I0)();

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)([3, 40]),
      mappingList = _useMapping.mappingList;

  var outMerchantList = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => {
    var _props$merchantList;

    return (_props$merchantList = props.merchantList) !== null && _props$merchantList !== void 0 && _props$merchantList.length ? props.merchantList : undefined;
  }, [props.merchantList]); // 存在外部传入的数据时

  var merchantList = outMerchantList || mappingList.get(40) || [];
  var placeInitList = mappingList.get(3) || [];

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState, 2),
      placeList = _useState2[0],
      setPlaceList = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState3, 2),
      merchantValue = _useState4[0],
      setMerchantValue = _useState4[1]; // 每次主动或被动切换商家，返回对应地点列表


  var handleMerchant = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)().mark(function _callee(val) {
      var res, _ref2, merchants, _ref3, placeVos, list;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch({
                type: 'map/queryComplex',
                payload: {
                  type: [40],
                  ext: {
                    merchantId: val
                  }
                }
              });

            case 2:
              res = _context.sent;

              if (!(res && res[40])) {
                _context.next = 17;
                break;
              }

              _context.prev = 4;
              _ref2 = JSON.parse(res[40]) || {}, merchants = _ref2.merchants;

              if (merchants) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              _ref3 = JSON.parse(merchants).find(v => +v.merchantId === +val) || {}, placeVos = _ref3.placeVos;

              if (placeVos) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return");

            case 11:
              if (placeVos !== null && placeVos !== void 0 && placeVos.length) {
                list = placeVos.map(v => ({
                  value: +v.placeId,
                  label: v.placeName,
                  others: v
                }));
                changeMerchantback && changeMerchantback(list);
              }

              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](4);
              console.log('解析地点数据失败：', _context.t0);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 14]]);
    }));

    return function handleMerchant(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    console.log('merchantValue', merchantValue);

    if (merchantValue) {
      handleMerchant(merchantValue); // const placeList =
      // changeMerchantback()
    }
  }, [merchantValue]);

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState5, 2),
      placeValue = _useState6[0],
      setPlaceValue = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState7, 2),
      loadingPlaceList = _useState8[0],
      setLoadingPlaceList = _useState8[1]; // 回显地点的值


  var place = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => {
    if (!placeValue) return;
    if (typeof placeValue === 'string' && placeValue.includes('-')) return placeValue;
    if (!placeList.length) return;

    var _ref4 = placeList.find(v => +v.value === +placeValue) || {
      label: undefined,
      others: {}
    },
        label = _ref4.label,
        placeCode = _ref4.others.placeCode;

    return placeCode ? "".concat(placeCode, "-").concat(label) : "";
  }, [placeValue, placeList]); // 根据id或者商家详情

  var getMerchantDetail = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(merchantId => {
    var defaultData = {
      label: undefined,
      others: {}
    };
    if (!merchantId) return defaultData;
    var res = merchantList.find(v => +v.value === +merchantId) || defaultData;
    return res;
  }, [merchantList]); // 商家、地点下拉框变化时

  var changeField = (name, value, opt) => {
    console.log(name, value, opt);
    var rows = opt || {
      rows: {}
    };
    var data = value;

    if (name === placeName) {
      var _opt$rows, _opt$rows$others;

      var placeCode = value ? opt === null || opt === void 0 ? void 0 : (_opt$rows = opt.rows) === null || _opt$rows === void 0 ? void 0 : (_opt$rows$others = _opt$rows.others) === null || _opt$rows$others === void 0 ? void 0 : _opt$rows$others.placeCode : undefined; // const placeCode = value ? value.split('-')[0] : undefined

      var _getMerchantDetail = getMerchantDetail(merchantDefaultValue),
          placeVos = _getMerchantDetail.others.placeVos; // 获取id 用于表单保存


      var _ref5 = (placeVos === null || placeVos === void 0 ? void 0 : placeVos.find(v => v.placeCode === placeCode)) || {},
          placeId = _ref5.placeId;

      data = placeId;
      setPlaceValue(value);
    } else {
      // 选择商家时
      setMerchantValue(data);
    }

    if (changeFieldCallback) {
      changeFieldCallback(name, data, rows);
    }
  }; // 解析地点的下拉数据


  var handlePlaceData = (str, val) => {
    try {
      var _ref6 = JSON.parse(str) || {},
          merchants = _ref6.merchants;

      if (!merchants) {
        return;
      }

      var _ref7 = JSON.parse(merchants).find(v => +v.merchantId === +val) || {},
          placeVos = _ref7.placeVos;

      if (!placeVos) {
        return;
      }

      var list = placeVos.map(v => ({
        value: +v.placeId,
        label: v.placeName,
        others: v
      }));
      setPlaceList(handleFilterDc(list));
    } catch (error) {
      console.log('解析地点数据失败：', error);
    }
  }; // 选中商家时，请求地点数据


  var selectMerchant = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)( /*#__PURE__*/function () {
    var _ref8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)().mark(function _callee2(val) {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setPlaceList([]); // 置空地点下拉数据，以展示loading效果

              setPlaceValue(undefined);
              setLoadingPlaceList(true);
              _context2.next = 5;
              return dispatch({
                type: 'map/queryComplex',
                payload: {
                  type: [40],
                  ext: {
                    merchantId: val
                  }
                }
              });

            case 5:
              res = _context2.sent;

              if (res[40]) {
                handlePlaceData(res[40], val);
              }

              setLoadingPlaceList(false);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref8.apply(this, arguments);
    };
  }(), [dispatch]); // 选择地点，设置对应的商家

  var selectPlace = (v, opt) => {
    var others = opt.rows.others;
    var merchantId = others.merchantId;

    if (merchantId) {
      setMerchantValue(+merchantId);
    }
  }; // 初始化展示商家数据


  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    setMerchantValue(merchantDefaultValue);
  }, [merchantDefaultValue]); // 初始化展示商家数据

  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    console.log('placeDefaultValue', placeDefaultValue);
  }, [placeDefaultValue]); // 初始化展示地点数据

  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    if (typeof placeDefaultValue === 'undefined') {
      setPlaceValue(undefined);
    }

    if (!placeDefaultValue || placeDefaultValue === placeValue) {
      return;
    }

    setPlaceValue(placeDefaultValue);
    var strVal = placeDefaultValue.toString();
    var placeId = strVal.includes('-') ? strVal.split('-')[0] : strVal;
    var rows = placeList.find(v => +v.value === +placeId) || {};
    if (!Object.keys(rows).length) return;

    if (changeFieldCallback) {
      changeFieldCallback(placeName, placeId, {
        rows
      });
    }
  }, [changeFieldCallback, placeDefaultValue, placeList, placeName, placeValue]); // 初始化赋值下拉框数据

  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    if (placeInitList.length) {
      var list = handleFilterDc(placeInitList);
      setPlaceList(list);
    }
  }, [placeInitList]);
  return [{
    label: label !== null && label !== void 0 ? label : '商家/地点',
    // 名称
    name: merchantName,
    // 商家字段名
    // columns: 2,
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_12__/* .default.Group */ .Z.Group, {
      compact: true
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
      placeholder: "\u5546\u5BB6",
      dropdownMatchSelectWidth: false,
      showSearch: true,
      allowClear: true,
      value: merchantValue || undefined,
      optionLabelProp: "children",
      style: {
        width: '50%'
      },
      onChange: (v, o) => changeField(merchantName, v, o),
      onSelect: selectMerchant,
      filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
      disabled: disableMerchant
    }, merchantList.map(v => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_13__/* .default.Option */ .Z.Option, {
      value: v.value,
      key: v.value,
      rows: v
    }, v.label))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
      title: place
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
      placeholder: "\u5730\u70B9",
      dropdownMatchSelectWidth: false,
      showSearch: true,
      allowClear: true,
      value: placeValue,
      optionLabelProp: "children",
      style: {
        width: '50%'
      },
      notFoundContent: loadingPlaceList ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_spin__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z, {
        size: "small"
      }) : null,
      onChange: (v, o) => changeField(placeName, v, o),
      filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
      onSelect: selectPlace,
      disabled: disablePlace
    }, placeList.map(v => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_13__/* .default.Option */ .Z.Option, {
      value: +v.others.placeId,
      key: "".concat(v.others.placeCode, "-").concat(v.label),
      rows: v
    }, "".concat(v.others.placeCode, "-").concat(v.label))))))
  }];
}

/* harmony default export */ __webpack_exports__["ZP"] = (useChainEditPlaceAndMerchant);

/***/ }),

/***/ 41611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SupplyChain_SupplyChainRoute; },
  "enumChainRouteSource": function() { return /* binding */ enumChainRouteSource; },
  "enumChainRouteStatus": function() { return /* binding */ enumChainRouteStatus; },
  "enumIsDefaultDC": function() { return /* binding */ enumIsDefaultDC; },
  "handleDataList": function() { return /* binding */ handleDataList; }
});

// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/CommonWrap/index.tsx
var CommonWrap = __webpack_require__(73520);
// EXTERNAL MODULE: ./src/components/FormBuilder/index.tsx + 4 modules
var FormBuilder = __webpack_require__(5670);
// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/index.js
var message_style = __webpack_require__(34792);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(48086);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/style/index.js
var tooltip_style = __webpack_require__(22385);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 1 modules
var tooltip = __webpack_require__(31097);
// EXTERNAL MODULE: ./src/components/CommonTable/index.tsx + 3 modules
var CommonTable = __webpack_require__(40934);
// EXTERNAL MODULE: ./src/pages/ConfigManage/SupplyChain/SupplyChainRoute/components/View.module.less?modules
var View_modulemodules = __webpack_require__(11545);
var View_modulemodules_default = /*#__PURE__*/__webpack_require__.n(View_modulemodules);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(5977);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/FileAddOutlined.js + 1 modules
var FileAddOutlined = __webpack_require__(84189);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/DownloadOutlined.js + 1 modules
var DownloadOutlined = __webpack_require__(90631);
// EXTERNAL MODULE: ./src/pages/ConfigManage/SupplyChain/SupplyChainRoute/Api/index.ts
var Api = __webpack_require__(63000);
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
// EXTERNAL MODULE: ./src/config/enums.ts
var enums = __webpack_require__(26715);
// EXTERNAL MODULE: ./src/hooks/useDynamicColumns/index.tsx
var useDynamicColumns = __webpack_require__(78004);
// EXTERNAL MODULE: ./src/components/Uploader/index.tsx + 4 modules
var Uploader = __webpack_require__(84843);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/.umi-production/core/umiExports.ts + 18 modules
var umiExports = __webpack_require__(71720);
// EXTERNAL MODULE: ./src/hooks/useLoopImportResult.tsx
var useLoopImportResult = __webpack_require__(68406);
// EXTERNAL MODULE: ./src/pages/ConfigManage/SupplyChain/Api.ts
var SupplyChain_Api = __webpack_require__(15172);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/style/index.js
var modal_style = __webpack_require__(71194);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(57016);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/antd/es/select/style/index.js
var select_style = __webpack_require__(43358);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js
var es_select = __webpack_require__(34041);
// EXTERNAL MODULE: ./node_modules/antd/es/form/style/index.js
var form_style = __webpack_require__(9715);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 12 modules
var es_form = __webpack_require__(35845);
// EXTERNAL MODULE: ./src/hooks/useMapping.ts
var useMapping = __webpack_require__(7704);
// EXTERNAL MODULE: ./src/utils/fetchQuery/index.tsx
var fetchQuery = __webpack_require__(48344);
;// CONCATENATED MODULE: ./src/pages/ConfigManage/SupplyChain/SupplyChainRoute/components/routeCopyUtils.ts
/** EntityStatusEnum.NORMAL，正常营业 */
var NORMAL_OPERATING_STORE_STATUS = 1;
/** shopType：6-虚拟门店 */

var VIRTUAL_STORE_SHOP_TYPE = 6;
var PLACE_SCOPE_STORE = 1;
/** 门店名称中含以下关键字视为非正常营业 */

var INACTIVE_STORE_NAME_KEYWORDS = ['待转', '停业', '闭店', '待用', '废弃', '虚拟门店', '中台店', '已转'];
function filterNormalOperatingStores(list) {
  return list.filter(item => {
    var _item$others$storeSta, _item$others, _item$others2;

    var _ref = (item === null || item === void 0 ? void 0 : item.others) || {},
        placeScope = _ref.placeScope,
        shopType = _ref.shopType,
        placeName = _ref.placeName;

    if (Number(placeScope) !== PLACE_SCOPE_STORE) {
      return false;
    }

    if (Number(shopType) === VIRTUAL_STORE_SHOP_TYPE) {
      return false;
    }

    if (placeName && INACTIVE_STORE_NAME_KEYWORDS.some(keyword => placeName.includes(keyword))) {
      return false;
    }

    var status = (_item$others$storeSta = item === null || item === void 0 ? void 0 : (_item$others = item.others) === null || _item$others === void 0 ? void 0 : _item$others.storeStatus) !== null && _item$others$storeSta !== void 0 ? _item$others$storeSta : item === null || item === void 0 ? void 0 : (_item$others2 = item.others) === null || _item$others2 === void 0 ? void 0 : _item$others2.status;

    if (status !== undefined && status !== null && status !== '') {
      return Number(status) === NORMAL_OPERATING_STORE_STATUS;
    }

    return true;
  });
}
function parseMerchantPlaces(merchantPlacesRaw, merchantId) {
  var _merchant$placeVos;

  var parsed = JSON.parse(merchantPlacesRaw) || {};
  var merchantsRaw = parsed.merchants;

  if (!merchantsRaw) {
    return [];
  }

  var merchants = typeof merchantsRaw === 'string' ? JSON.parse(merchantsRaw) : merchantsRaw;
  var merchant = merchants.find(v => +v.merchantId === +merchantId);

  if (!(merchant !== null && merchant !== void 0 && (_merchant$placeVos = merchant.placeVos) !== null && _merchant$placeVos !== void 0 && _merchant$placeVos.length)) {
    return [];
  }

  var list = merchant.placeVos.map(v => ({
    value: +v.placeId,
    label: "".concat(v.placeCode, "-").concat(v.placeName),
    others: v
  }));
  return filterNormalOperatingStores(list);
}
;// CONCATENATED MODULE: ./src/pages/ConfigManage/SupplyChain/SupplyChainRoute/components/RouteCopyModal.tsx




















var layout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};

function RouteCopyModal(props) {
  var visible = props.visible,
      onClose = props.onClose,
      onSuccess = props.onSuccess;

  var _Form$useForm = es_form/* default.useForm */.Z.useForm(),
      _Form$useForm2 = (0,slicedToArray/* default */.Z)(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var dispatch = (0,umiExports/* useDispatch */.I0)();

  var _useMapping = (0,useMapping/* default */.Z)([40]),
      mappingList = _useMapping.mappingList;

  var merchantList = (0,react.useMemo)(() => mappingList.get(40) || [], [mappingList]);

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      placeList = _useState2[0],
      setPlaceList = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      loadingPlaces = _useState4[0],
      setLoadingPlaces = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      submitting = _useState6[0],
      setSubmitting = _useState6[1];

  var _useState7 = (0,react.useState)(),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      copyOrderNo = _useState8[0],
      setCopyOrderNo = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
      loopResult = _useState10[0],
      setLoopResult = _useState10[1];

  var _useLoopImportResult = (0,useLoopImportResult/* default */.Z)({
    importUrl: 'scm.config.getLastImportResult',
    businessType: enums/* enumPurchaseSCMImportStatusType.门店路由复制 */.uO["门店路由复制"],
    orderNo: copyOrderNo,
    loadingTip: '正在复制门店路由',
    successTip: '门店路由复制成功',
    refreshCallback: successed => {
      if (successed) {
        onSuccess();
        handleClose();
      }

      setLoopResult(false);
    }
  }, [loopResult]),
      _useLoopImportResult2 = (0,slicedToArray/* default */.Z)(_useLoopImportResult, 1),
      copyLoading = _useLoopImportResult2[0];

  var handleClose = (0,react.useCallback)(() => {
    form.resetFields();
    setPlaceList([]);
    onClose();
  }, [form, onClose]);
  var loadPlaces = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(merchantId) {
      var res;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              form.setFieldsValue({
                newPlaceId: undefined,
                sourcePlaceId: undefined
              });

              if (merchantId) {
                _context.next = 4;
                break;
              }

              setPlaceList([]);
              return _context.abrupt("return");

            case 4:
              if (merchantList.some(item => +item.value === +merchantId)) {
                _context.next = 8;
                break;
              }

              message.default.warning('暂无该商家权限，无法复制');

              setPlaceList([]);
              return _context.abrupt("return");

            case 8:
              setLoadingPlaces(true);
              _context.prev = 9;
              _context.next = 12;
              return dispatch({
                type: 'map/queryComplex',
                payload: {
                  type: [40],
                  ext: {
                    merchantId,
                    placeScopes: '1'
                  }
                }
              });

            case 12:
              res = _context.sent;

              if (res !== null && res !== void 0 && res[40]) {
                setPlaceList(parseMerchantPlaces(res[40], merchantId));
              } else {
                setPlaceList([]);
              }

              _context.next = 20;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](9);
              setPlaceList([]);

              message.default.error('加载门店失败');

            case 20:
              _context.prev = 20;
              setLoadingPlaces(false);
              return _context.finish(20);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 16, 20, 23]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [dispatch, form, merchantList]);
  (0,react.useEffect)(() => {
    if (!visible) {
      form.resetFields();
      setPlaceList([]);
    }
  }, [visible, form]);

  var handleOk = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2() {
      var _res$result, _res$result2, values, merchantId, newPlaceId, sourcePlaceId, res, _res$result3, _res$result3$error, _res$error;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return form.validateFields();

            case 3:
              values = _context2.sent;
              merchantId = values.merchantId, newPlaceId = values.newPlaceId, sourcePlaceId = values.sourcePlaceId;

              if (merchantList.some(item => +item.value === +merchantId)) {
                _context2.next = 8;
                break;
              }

              message.default.warning('暂无该商家权限，无法复制');

              return _context2.abrupt("return");

            case 8:
              if (!(!placeList.some(item => +item.value === +newPlaceId) || !placeList.some(item => +item.value === +sourcePlaceId))) {
                _context2.next = 11;
                break;
              }

              message.default.warning('请选择该商家下有权限的正常营业门店');

              return _context2.abrupt("return");

            case 11:
              if (!(+newPlaceId === +sourcePlaceId)) {
                _context2.next = 14;
                break;
              }

              message.default.warning('新开门店与被复制门店不能相同');

              return _context2.abrupt("return");

            case 14:
              setSubmitting(true);
              _context2.next = 17;
              return (0,fetchQuery/* default */.Z)(Api/* COPY_ROUTE_API */.EZ, 'POST', {
                merchantId: Number(merchantId),
                newPlaceId: Number(newPlaceId),
                sourcePlaceId: Number(sourcePlaceId)
              });

            case 17:
              res = _context2.sent;

              if (res !== null && res !== void 0 && res.success && res !== null && res !== void 0 && (_res$result = res.result) !== null && _res$result !== void 0 && _res$result.success && res !== null && res !== void 0 && (_res$result2 = res.result) !== null && _res$result2 !== void 0 && _res$result2.orderNo) {
                setCopyOrderNo(String(res.result.orderNo));
                setLoopResult(true);
              } else {
                message.default.error((res === null || res === void 0 ? void 0 : (_res$result3 = res.result) === null || _res$result3 === void 0 ? void 0 : (_res$result3$error = _res$result3.error) === null || _res$result3$error === void 0 ? void 0 : _res$result3$error.message) || (res === null || res === void 0 ? void 0 : (_res$error = res.error) === null || _res$error === void 0 ? void 0 : _res$error.message) || '门店路由复制失败');
              }

              _context2.next = 23;
              break;

            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2["catch"](0);

            case 23:
              _context2.prev = 23;
              setSubmitting(false);
              return _context2.finish(23);

            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 21, 23, 26]]);
    }));

    return function handleOk() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/react.createElement(modal/* default */.Z, {
    title: "\u95E8\u5E97\u8DEF\u7531\u590D\u5236",
    visible: visible,
    width: 600,
    destroyOnClose: true,
    maskClosable: false,
    okText: "\u4E00\u952E\u590D\u5236",
    confirmLoading: submitting || copyLoading,
    onOk: handleOk,
    onCancel: handleClose
  }, /*#__PURE__*/react.createElement(es_form/* default */.Z, (0,esm_extends/* default */.Z)({}, layout, {
    form: form
  }), /*#__PURE__*/react.createElement(es_form/* default.Item */.Z.Item, {
    label: "\u5546\u5BB6",
    name: "merchantId",
    rules: [{
      required: true,
      message: '请选择商家'
    }]
  }, /*#__PURE__*/react.createElement(es_select/* default */.Z, {
    allowClear: true,
    showSearch: true,
    placeholder: "\u8BF7\u9009\u62E9\u5546\u5BB6",
    optionFilterProp: "children",
    onChange: loadPlaces
  }, merchantList.map(item => /*#__PURE__*/react.createElement(es_select/* default.Option */.Z.Option, {
    key: item.value,
    value: item.value
  }, item.label)))), /*#__PURE__*/react.createElement(es_form/* default.Item */.Z.Item, {
    label: "\u65B0\u5F00\u95E8\u5E97",
    name: "newPlaceId",
    rules: [{
      required: true,
      message: '请选择新开门店'
    }]
  }, /*#__PURE__*/react.createElement(es_select/* default */.Z, {
    allowClear: true,
    showSearch: true,
    loading: loadingPlaces,
    placeholder: "\u8BF7\u9009\u62E9\u65B0\u5F00\u95E8\u5E97",
    optionFilterProp: "children",
    disabled: !placeList.length
  }, placeList.map(item => /*#__PURE__*/react.createElement(es_select/* default.Option */.Z.Option, {
    key: item.value,
    value: item.value
  }, item.label)))), /*#__PURE__*/react.createElement(es_form/* default.Item */.Z.Item, {
    label: "\u590D\u5236\u95E8\u5E97",
    name: "sourcePlaceId",
    rules: [{
      required: true,
      message: '请选择被复制门店'
    }]
  }, /*#__PURE__*/react.createElement(es_select/* default */.Z, {
    allowClear: true,
    showSearch: true,
    loading: loadingPlaces,
    placeholder: "\u8BF7\u9009\u62E9\u88AB\u590D\u5236\u95E8\u5E97",
    optionFilterProp: "children",
    disabled: !placeList.length
  }, placeList.map(item => /*#__PURE__*/react.createElement(es_select/* default.Option */.Z.Option, {
    key: item.value,
    value: item.value
  }, item.label))))));
}

/* harmony default export */ var components_RouteCopyModal = (RouteCopyModal);
;// CONCATENATED MODULE: ./src/pages/ConfigManage/SupplyChain/SupplyChainRoute/components/ViewList.tsx


























var ViewList = props => {
  // props
  var history = (0,react_router/* useHistory */.k6)();

  var handleRender = record => {
    return /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("a", {
      onClick: () => goHandle('edit', record.id)
    }, "\u7F16\u8F91"), /*#__PURE__*/react.createElement("a", {
      onClick: () => goHandle('detail', record.id)
    }, "\u8BE6\u60C5"));
  };

  var _COLUMNS = [//     dcMerchantCode: ""
  // dcMerchantId: "0"
  // dcMerchantName: ""
  // deliveryDcCode: ""
  // deliveryDcId: "0"
  // deliveryDcName: ""
  // firstCategoryId: "10"
  // firstCategoryName: "生鲜部"
  // id: "911"
  // isDelete: 1
  // merchantCode: "M100140108"
  // merchantId: "2000000506"
  // merchantName: "去ERP测试子公司"
  // placeCode: "A01999"
  // placeId: "2000000504"
  // placeName: "去ERP测试门店1"
  // secondCategoryId: "1005"
  // secondCategoryName: "水产类"
  // string updateTime=20;//最后修改时间
  // int32 source=21;  //来源1：商户 2：手工
  // string updateName=22;//最后修改人
  {
    title: '地点所属商家',
    dataIndex: 'merchantName',
    key: 'merchantName',
    width: 140
  }, {
    title: '地点编码',
    dataIndex: 'placeCode',
    key: 'placeCode',
    width: 108
  }, {
    title: '地点名称',
    dataIndex: 'placeName',
    key: 'placeName',
    width: 140
  }, {
    title: '商品类别',
    dataIndex: 'firstCategoryName',
    key: 'firstCategoryName',
    width: 130,
    render: (t, r) => {
      if (r !== null && r !== void 0 && r.secondCategoryName) {
        return (r === null || r === void 0 ? void 0 : r.firstCategoryName) + '/' + (r === null || r === void 0 ? void 0 : r.secondCategoryName);
      }

      return r === null || r === void 0 ? void 0 : r.firstCategoryName;
    }
  }, {
    title: '供货DC所属商家',
    dataIndex: 'dcMerchantName',
    key: 'dcMerchantName',
    width: 130
  }, {
    title: '供货DC编码',
    dataIndex: 'deliveryDcCode',
    key: 'deliveryDcCode',
    width: 128
  }, {
    title: '供货DC名称',
    dataIndex: 'deliveryDcName',
    key: 'deliveryDcName',
    width: 120,
    ellipsis: true,
    render: text => /*#__PURE__*/react.createElement(tooltip/* default */.Z, {
      placement: "leftTop",
      title: text
    }, text)
  }, {
    title: '最后修改时间',
    dataIndex: 'updateTime',
    key: 'updateTime',
    width: 120,
    ellipsis: true,
    render: text => /*#__PURE__*/react.createElement(tooltip/* default */.Z, {
      placement: "leftTop",
      title: text
    }, text)
  }, {
    title: '最后修改人',
    dataIndex: 'updateName',
    key: 'updateName',
    width: 120
  }, {
    title: '来源',
    dataIndex: 'source',
    key: 'source',
    width: 90,
    render: (t, r) => {
      if (t === enumChainRouteSource["商户"]) {
        return '商户';
      }

      if (t === enumChainRouteSource["手工"]) {
        return '手工';
      }
    }
  }, {
    title: '状态',
    dataIndex: 'isDelete',
    key: 'isDelete',
    width: 100,
    render: (t, r) => {
      if (t === enumChainRouteStatus["生效"]) {
        return '生效';
      }

      if (t === enumChainRouteStatus["失效"]) {
        return '失效';
      }
    }
  }];

  var _useDynamicColumns = (0,useDynamicColumns/* useDynamicColumns */.m)(_COLUMNS),
      dynamicColumns = _useDynamicColumns.columns,
      CtrlButton = _useDynamicColumns.CtrlButton;

  var newColumns = [...dynamicColumns, {
    title: '操作',
    key: 'operation',
    fixed: 'right',
    width: 120,
    render: (text, record) => handleRender(record)
  }];
  var searchParams = props.searchParams; // methods

  var goHandle = (v, id) => {
    console.log(id);

    if (v === 'detail') {
      history.push("/ConfigManage/SupplyChain/SupplyChainRoute/Detail/".concat(id));
    }

    if (v === 'edit' || v === 'add') {
      history.push("/ConfigManage/SupplyChain/SupplyChainRoute/Edit?type=".concat(v).concat(v === 'edit' ? '&id=' + id : ''));
    }
  };
  /** 导入初始化 */


  var _useState = (0,react.useState)(''),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      curResId = _useState2[0],
      setcurResId = _useState2[1];
  /** 导入初始化 轮询 */


  var _useState3 = (0,react.useState)(false),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      loopResult = _useState4[0],
      setLoopResult = _useState4[1];

  var _useLoopImportResult = (0,useLoopImportResult/* default */.Z)({
    importUrl: 'scm.config.getLastImportResult',
    businessType: enums/* enumPurchaseSCMImportStatusType.供应链路由配置导入 */.uO["供应链路由配置导入"],
    orderNo: curResId,
    refreshCallback: successed => {
      if (successed) {
        message.default.success('导入成功');

        props.refreshTable();
      }

      setLoopResult(false); // 重置状态
    }
  }, [loopResult]),
      _useLoopImportResult2 = (0,slicedToArray/* default */.Z)(_useLoopImportResult, 1),
      btnLoading = _useLoopImportResult2[0]; // 导入


  var changeUpload = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(val) {
      var _res$result, params, res, _res$result2;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              params = {
                resId: val
              };
              _context.next = 4;
              return (0,ypRequest/* default */.Z)(Api/* IMPORT_ORDER */.yG, params);

            case 4:
              res = _context.sent;

              if (res.success && res !== null && res !== void 0 && (_res$result = res.result) !== null && _res$result !== void 0 && _res$result.orderNo) {
                setcurResId(res === null || res === void 0 ? void 0 : (_res$result2 = res.result) === null || _res$result2 === void 0 ? void 0 : _res$result2.orderNo);
                setLoopResult(true);
              } else {
                message.default.warn('未找到orderNo');
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

              message.default.error(_context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function changeUpload(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var dispatch = (0,umiExports/* useDispatch */.I0)();

  var _useState5 = (0,react.useState)(false),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      copyModalVisible = _useState6[0],
      setCopyModalVisible = _useState6[1]; // 下载模板


  var downloadTemplate = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2() {
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return dispatch({
                type: 'purchase/downloadSCMTemplate',
                payload: {
                  type: 1
                }
              });

            case 3:
              _context2.next = 8;
              break;

            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);

              message.default.error(_context2.t0);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 5]]);
    }));

    return function downloadTemplate() {
      return _ref2.apply(this, arguments);
    };
  }();

  var debounceDownloadTpl = debounce_default()(downloadTemplate, 400);
  return /*#__PURE__*/react.createElement("div", {
    className: (View_modulemodules_default()).sList
  }, /*#__PURE__*/react.createElement("ul", {
    className: "optionBtnList"
  }, CtrlButton, /*#__PURE__*/react.createElement("li", null, /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    type: "primary",
    onClick: () => goHandle('add'),
    icon: /*#__PURE__*/react.createElement(FileAddOutlined/* default */.Z, null)
  }, "\u65B0\u589E\u4F9B\u5E94\u94FE\u8DEF\u7531"), /*#__PURE__*/react.createElement("span", {
    style: {
      marginLeft: 16,
      marginRight: 16
    },
    key: "upload"
  }, /*#__PURE__*/react.createElement(Uploader/* default */.Z, {
    tokenUrl: SupplyChain_Api/* scmResourceTokenApi */.e,
    accept: ".xlsx,.xls",
    onChange: changeUpload,
    loading: btnLoading,
    btnText: "\u5BFC\u5165excel",
    uploadOptions: {
      showUploadList: false
    }
  })), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    type: "default",
    icon: /*#__PURE__*/react.createElement(DownloadOutlined/* default */.Z, null),
    key: "download",
    className: "c-btn",
    onClick: () => {
      message.default.info('正在处理...');

      debounceDownloadTpl();
    }
  }, "\u6A21\u677F\u4E0B\u8F7D"), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    type: "default",
    className: "ml-2",
    onClick: () => setCopyModalVisible(true)
  }, "\u95E8\u5E97\u8DEF\u7531\u590D\u5236"))), /*#__PURE__*/react.createElement(components_RouteCopyModal, {
    visible: copyModalVisible,
    onClose: () => setCopyModalVisible(false),
    onSuccess: () => {
      var _props$refresh;

      return (_props$refresh = props.refresh) === null || _props$refresh === void 0 ? void 0 : _props$refresh.call(props);
    }
  }), /*#__PURE__*/react.createElement(CommonTable/* default */.Z, {
    columns: newColumns,
    queryDataUrl: Api/* DELIVERY_LIST_API */.e1,
    searchParams: searchParams,
    tableOptions: {
      scroll: {
        x: 1400
      }
    }
  }));
};

/* harmony default export */ var components_ViewList = (ViewList);
// EXTERNAL MODULE: ./node_modules/antd/es/input/style/index.js
var input_style = __webpack_require__(47673);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 3 modules
var input = __webpack_require__(4107);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/style/index.js
var spin_style = __webpack_require__(20228);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js
var spin = __webpack_require__(11382);
// EXTERNAL MODULE: ./src/pages/ConfigManage/SupplyChain/SupplyChainRoute/components/useChainEditPlaceAndMerchant.tsx
var useChainEditPlaceAndMerchant = __webpack_require__(33629);
;// CONCATENATED MODULE: ./src/pages/ConfigManage/SupplyChain/SupplyChainRoute/components/useChainDCPlaceAndMerchant.tsx












/* eslint-disable react-hooks/exhaustive-deps */

/**
 * 商家、地点表单项及其联动 - 供货DC
 */



 // DC：过滤剩余DC

function useChainDCPlaceAndMerchant(props) {
  var _merchantList$find;

  var label = props.label,
      merchantName = props.merchantName,
      placeName = props.placeName,
      disableMerchant = props.disableMerchant,
      disablePlace = props.disablePlace,
      placeDefaultValue = props.placeDefaultValue,
      merchantDefaultValue = props.merchantDefaultValue,
      changeFieldCallback = props.changeFieldCallback,
      changeMerchantback = props.changeMerchantback;
  var dispatch = (0,umiExports/* useDispatch */.I0)();

  var _useMapping = (0,useMapping/* default */.Z)([3, 40]),
      mappingList = _useMapping.mappingList;

  var outMerchantList = (0,react.useMemo)(() => {
    var _props$merchantList;

    return (_props$merchantList = props.merchantList) !== null && _props$merchantList !== void 0 && _props$merchantList.length ? props.merchantList : undefined;
  }, [props.merchantList]); // 存在外部传入的数据时

  var merchantList = outMerchantList || mappingList.get(40) || [];
  var placeInitList = mappingList.get(3) || [];

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      placeList = _useState2[0],
      setPlaceList = _useState2[1];

  var _useState3 = (0,react.useState)(),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      merchantValue = _useState4[0],
      setMerchantValue = _useState4[1]; // 每次主动或被动切换商家，返回对应地点列表


  var handleMerchant = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(val) {
      var res, _ref2, merchants, _ref3, placeVos, list;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch({
                type: 'map/queryComplex',
                payload: {
                  type: [40],
                  ext: {
                    merchantId: val
                  }
                }
              });

            case 2:
              res = _context.sent;

              if (!(res && res[40])) {
                _context.next = 17;
                break;
              }

              _context.prev = 4;
              _ref2 = JSON.parse(res[40]) || {}, merchants = _ref2.merchants;

              if (merchants) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              _ref3 = JSON.parse(merchants).find(v => +v.merchantId === +val) || {}, placeVos = _ref3.placeVos;

              if (placeVos) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return");

            case 11:
              if (placeVos !== null && placeVos !== void 0 && placeVos.length) {
                list = placeVos.map(v => ({
                  value: +v.placeId,
                  label: v.placeName,
                  others: v
                }));
                changeMerchantback && changeMerchantback(list);
              }

              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](4);
              console.log('解析地点数据失败：', _context.t0);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 14]]);
    }));

    return function handleMerchant(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(() => {
    console.log('merchantValue', merchantValue);

    if (merchantValue) {
      handleMerchant(merchantValue); // const placeList =
      // changeMerchantback()
    }
  }, [merchantValue]);

  var _useState5 = (0,react.useState)(),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      placeValue = _useState6[0],
      setPlaceValue = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      loadingPlaceList = _useState8[0],
      setLoadingPlaceList = _useState8[1]; // 回显地点的值


  var place = (0,react.useMemo)(() => {
    if (!placeValue) return;
    if (typeof placeValue === 'string' && placeValue.includes('-')) return placeValue;
    if (!placeList.length) return;

    var _ref4 = placeList.find(v => +v.value === +placeValue) || {
      label: undefined,
      others: {}
    },
        label = _ref4.label,
        placeCode = _ref4.others.placeCode;

    return placeCode ? "".concat(placeCode, "-").concat(label) : "";
  }, [placeValue, placeList]); // 根据id或者商家详情

  var getMerchantDetail = (0,react.useCallback)(merchantId => {
    var defaultData = {
      label: undefined,
      others: {}
    };
    if (!merchantId) return defaultData;
    var res = merchantList.find(v => +v.value === +merchantId) || defaultData;
    return res;
  }, [merchantList]); // 商家、地点下拉框变化时

  var changeField = (name, value, opt) => {
    console.log(name, value, opt);
    var rows = opt || {
      rows: {}
    };
    var data = value;

    if (name === placeName) {
      var _opt$rows, _opt$rows$others;

      var placeCode = value ? opt === null || opt === void 0 ? void 0 : (_opt$rows = opt.rows) === null || _opt$rows === void 0 ? void 0 : (_opt$rows$others = _opt$rows.others) === null || _opt$rows$others === void 0 ? void 0 : _opt$rows$others.placeCode : undefined; // const placeCode = value ? value.split('-')[0] : undefined

      var _getMerchantDetail = getMerchantDetail(merchantDefaultValue),
          placeVos = _getMerchantDetail.others.placeVos; // 获取id 用于表单保存


      var _ref5 = (placeVos === null || placeVos === void 0 ? void 0 : placeVos.find(v => v.placeCode === placeCode)) || {},
          placeId = _ref5.placeId;

      data = placeId;
      setPlaceValue(value);
    } else {
      // 选择商家时
      setMerchantValue(data);
    }

    if (changeFieldCallback) {
      changeFieldCallback(name, data, rows);
    }
  }; // 解析地点的下拉数据


  var handlePlaceData = (str, val) => {
    try {
      var _ref6 = JSON.parse(str) || {},
          merchants = _ref6.merchants;

      if (!merchants) {
        return;
      }

      var _ref7 = JSON.parse(merchants).find(v => +v.merchantId === +val) || {},
          placeVos = _ref7.placeVos;

      if (!placeVos) {
        return;
      }

      var list = placeVos.map(v => ({
        value: +v.placeId,
        label: v.placeName,
        others: v
      }));

      var _list = (0,useChainEditPlaceAndMerchant/* handleFilterPlace */.p2)(list);

      setPlaceList(_list);
    } catch (error) {
      console.log('解析地点数据失败：', error);
    }
  }; // 选中商家时，请求地点数据


  var selectMerchant = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(val) {
      var res;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setPlaceList([]); // 置空地点下拉数据，以展示loading效果

              setPlaceValue(undefined);
              setLoadingPlaceList(true);
              _context2.next = 5;
              return dispatch({
                type: 'map/queryComplex',
                payload: {
                  type: [40],
                  ext: {
                    merchantId: val
                  }
                }
              });

            case 5:
              res = _context2.sent;

              if (res[40]) {
                handlePlaceData(res[40], val);
              }

              setLoadingPlaceList(false);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref8.apply(this, arguments);
    };
  }(), [dispatch]); // 选择地点，设置对应的商家

  var selectPlace = (v, opt) => {
    var others = opt.rows.others;
    var merchantId = others.merchantId;

    if (merchantId) {
      setMerchantValue(+merchantId);
    }
  }; // 初始化展示商家数据


  (0,react.useEffect)(() => {
    setMerchantValue(merchantDefaultValue);
  }, [merchantDefaultValue]); // 初始化展示商家数据

  (0,react.useEffect)(() => {
    console.log('placeDefaultValue', placeDefaultValue);
  }, [placeDefaultValue]); // 初始化展示地点数据

  (0,react.useEffect)(() => {
    if (typeof placeDefaultValue === 'undefined') {
      setPlaceValue(undefined);
    }

    if (!placeDefaultValue || placeDefaultValue === placeValue) {
      return;
    }

    setPlaceValue(placeDefaultValue);
    var strVal = placeDefaultValue.toString();
    var placeId = strVal.includes('-') ? strVal.split('-')[0] : strVal;
    var rows = placeList.find(v => +v.value === +placeId) || {};
    if (!Object.keys(rows).length) return;

    if (changeFieldCallback) {
      changeFieldCallback(placeName, placeId, {
        rows
      });
    }
  }, [changeFieldCallback, placeDefaultValue, placeList, placeName, placeValue]); // 初始化赋值下拉框数据

  (0,react.useEffect)(() => {
    if (placeInitList.length) {
      var list = (0,useChainEditPlaceAndMerchant/* handleFilterPlace */.p2)(placeInitList);
      setPlaceList(list);
    }
  }, [placeInitList]);
  return [{
    label: label !== null && label !== void 0 ? label : '商家/地点',
    // 名称
    name: merchantName,
    // 商家字段名
    // columns: 2,
    widget: /*#__PURE__*/react.createElement(input/* default.Group */.Z.Group, {
      compact: true
    }, /*#__PURE__*/react.createElement(tooltip/* default */.Z, {
      title: ((_merchantList$find = merchantList.find(e => e.value === merchantValue)) === null || _merchantList$find === void 0 ? void 0 : _merchantList$find.label) || ''
    }, /*#__PURE__*/react.createElement(es_select/* default */.Z, {
      placeholder: "\u5546\u5BB6",
      dropdownMatchSelectWidth: false,
      showSearch: true,
      allowClear: true,
      value: merchantValue || undefined,
      optionLabelProp: "children",
      style: {
        width: '50%'
      },
      onChange: (v, o) => changeField(merchantName, v, o),
      onSelect: selectMerchant,
      filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
      disabled: disableMerchant
    }, merchantList.map(v => /*#__PURE__*/react.createElement(es_select/* default.Option */.Z.Option, {
      value: v.value,
      key: v.value,
      rows: v
    }, v.label)))), /*#__PURE__*/react.createElement(tooltip/* default */.Z, {
      title: place
    }, /*#__PURE__*/react.createElement(es_select/* default */.Z, {
      placeholder: "\u5730\u70B9",
      dropdownMatchSelectWidth: false,
      showSearch: true,
      allowClear: true,
      value: placeValue,
      optionLabelProp: "children",
      style: {
        width: '50%'
      },
      notFoundContent: loadingPlaceList ? /*#__PURE__*/react.createElement(spin/* default */.Z, {
        size: "small"
      }) : null,
      onChange: (v, o) => changeField(placeName, v, o),
      filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
      onSelect: selectPlace,
      disabled: disablePlace
    }, placeList.map(v => /*#__PURE__*/react.createElement(es_select/* default.Option */.Z.Option, {
      value: +v.others.placeId,
      key: "".concat(v.others.placeCode, "-").concat(v.label),
      rows: v
    }, "".concat(v.others.placeCode, "-").concat(v.label))))))
  }];
}

/* harmony default export */ var components_useChainDCPlaceAndMerchant = (useChainDCPlaceAndMerchant);
;// CONCATENATED MODULE: ./src/pages/ConfigManage/SupplyChain/SupplyChainRoute/components/useChainMerchantPlaceAndMerchant.tsx












/* eslint-disable react-hooks/exhaustive-deps */

/**
 * 商家、地点表单项及其联动 | 入口页：地点
 */



 // 供货DC：过滤剩余营业部和门店

function useChainMerchantPlaceAndMerchant(props) {
  var _merchantList$find;

  var label = props.label,
      merchantName = props.merchantName,
      placeName = props.placeName,
      disableMerchant = props.disableMerchant,
      disablePlace = props.disablePlace,
      placeDefaultValue = props.placeDefaultValue,
      merchantDefaultValue = props.merchantDefaultValue,
      changeFieldCallback = props.changeFieldCallback,
      changeMerchantback = props.changeMerchantback;
  var dispatch = (0,umiExports/* useDispatch */.I0)();

  var _useMapping = (0,useMapping/* default */.Z)([3, 40]),
      mappingList = _useMapping.mappingList;

  var outMerchantList = (0,react.useMemo)(() => {
    var _props$merchantList;

    return (_props$merchantList = props.merchantList) !== null && _props$merchantList !== void 0 && _props$merchantList.length ? props.merchantList : undefined;
  }, [props.merchantList]); // 存在外部传入的数据时

  var merchantList = outMerchantList || mappingList.get(40) || [];
  var placeInitList = mappingList.get(3) || [];

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      placeList = _useState2[0],
      setPlaceList = _useState2[1];

  var _useState3 = (0,react.useState)(),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      merchantValue = _useState4[0],
      setMerchantValue = _useState4[1]; // 每次主动或被动切换商家，返回对应地点列表


  var handleMerchant = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(val) {
      var res, _ref2, merchants, _ref3, placeVos, list;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch({
                type: 'map/queryComplex',
                payload: {
                  type: [40],
                  ext: {
                    merchantId: val
                  }
                }
              });

            case 2:
              res = _context.sent;

              if (!(res && res[40])) {
                _context.next = 17;
                break;
              }

              _context.prev = 4;
              _ref2 = JSON.parse(res[40]) || {}, merchants = _ref2.merchants;

              if (merchants) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              _ref3 = JSON.parse(merchants).find(v => +v.merchantId === +val) || {}, placeVos = _ref3.placeVos;

              if (placeVos) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return");

            case 11:
              if (placeVos !== null && placeVos !== void 0 && placeVos.length) {
                list = placeVos.map(v => ({
                  value: +v.placeId,
                  label: v.placeName,
                  others: v
                }));
                changeMerchantback && changeMerchantback(list);
              }

              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](4);
              console.log('解析地点数据失败：', _context.t0);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 14]]);
    }));

    return function handleMerchant(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(() => {
    console.log('merchantValue', merchantValue);

    if (merchantValue) {
      handleMerchant(merchantValue); // const placeList =
      // changeMerchantback()
    }
  }, [merchantValue]);

  var _useState5 = (0,react.useState)(),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      placeValue = _useState6[0],
      setPlaceValue = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      loadingPlaceList = _useState8[0],
      setLoadingPlaceList = _useState8[1]; // 回显地点的值


  var place = (0,react.useMemo)(() => {
    if (!placeValue) return;
    if (typeof placeValue === 'string' && placeValue.includes('-')) return placeValue;
    if (!placeList.length) return;

    var _ref4 = placeList.find(v => +v.value === +placeValue) || {
      label: undefined,
      others: {}
    },
        label = _ref4.label,
        placeCode = _ref4.others.placeCode;

    return placeCode ? "".concat(placeCode, "-").concat(label) : "";
  }, [placeValue, placeList]); // 根据id或者商家详情

  var getMerchantDetail = (0,react.useCallback)(merchantId => {
    var defaultData = {
      label: undefined,
      others: {}
    };
    if (!merchantId) return defaultData;
    var res = merchantList.find(v => +v.value === +merchantId) || defaultData;
    return res;
  }, [merchantList]); // 商家、地点下拉框变化时

  var changeField = (name, value, opt) => {
    console.log(name, value, opt);
    var rows = opt || {
      rows: {}
    };
    var data = value;

    if (name === placeName) {
      var _opt$rows, _opt$rows$others;

      var placeCode = value ? opt === null || opt === void 0 ? void 0 : (_opt$rows = opt.rows) === null || _opt$rows === void 0 ? void 0 : (_opt$rows$others = _opt$rows.others) === null || _opt$rows$others === void 0 ? void 0 : _opt$rows$others.placeCode : undefined; // const placeCode = value ? value.split('-')[0] : undefined

      var _getMerchantDetail = getMerchantDetail(merchantDefaultValue),
          placeVos = _getMerchantDetail.others.placeVos; // 获取id 用于表单保存


      var _ref5 = (placeVos === null || placeVos === void 0 ? void 0 : placeVos.find(v => v.placeCode === placeCode)) || {},
          placeId = _ref5.placeId;

      data = placeId;
      setPlaceValue(value);
    } else {
      // 选择商家时
      setMerchantValue(data);
    }

    if (changeFieldCallback) {
      changeFieldCallback(name, data, rows);
    }
  }; // 解析地点的下拉数据


  var handlePlaceData = (str, val) => {
    try {
      var _ref6 = JSON.parse(str) || {},
          merchants = _ref6.merchants;

      if (!merchants) {
        return;
      }

      var _ref7 = JSON.parse(merchants).find(v => +v.merchantId === +val) || {},
          placeVos = _ref7.placeVos;

      if (!placeVos) {
        return;
      }

      var list = placeVos.map(v => ({
        value: +v.placeId,
        label: v.placeName,
        others: v
      }));

      var _list = (0,useChainEditPlaceAndMerchant/* handleFilterDc */.PB)(list);

      setPlaceList(_list);
    } catch (error) {
      console.log('解析地点数据失败：', error);
    }
  }; // 选中商家时，请求地点数据


  var selectMerchant = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(val) {
      var res;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setPlaceList([]); // 置空地点下拉数据，以展示loading效果

              setPlaceValue(undefined);
              setLoadingPlaceList(true);
              _context2.next = 5;
              return dispatch({
                type: 'map/queryComplex',
                payload: {
                  type: [40],
                  ext: {
                    merchantId: val
                  }
                }
              });

            case 5:
              res = _context2.sent;

              if (res[40]) {
                handlePlaceData(res[40], val);
              }

              setLoadingPlaceList(false);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref8.apply(this, arguments);
    };
  }(), [dispatch]); // 选择地点，设置对应的商家

  var selectPlace = (v, opt) => {
    var others = opt.rows.others;
    var merchantId = others.merchantId;

    if (merchantId) {
      setMerchantValue(+merchantId);
    }
  }; // 初始化展示商家数据


  (0,react.useEffect)(() => {
    setMerchantValue(merchantDefaultValue);
  }, [merchantDefaultValue]); // 初始化展示商家数据

  (0,react.useEffect)(() => {
    console.log('placeDefaultValue', placeDefaultValue);
  }, [placeDefaultValue]); // 初始化展示地点数据

  (0,react.useEffect)(() => {
    if (typeof placeDefaultValue === 'undefined') {
      setPlaceValue(undefined);
    }

    if (!placeDefaultValue || placeDefaultValue === placeValue) {
      return;
    }

    setPlaceValue(placeDefaultValue);
    var strVal = placeDefaultValue.toString();
    var placeId = strVal.includes('-') ? strVal.split('-')[0] : strVal;
    var rows = placeList.find(v => +v.value === +placeId) || {};
    if (!Object.keys(rows).length) return;

    if (changeFieldCallback) {
      changeFieldCallback(placeName, placeId, {
        rows
      });
    }
  }, [changeFieldCallback, placeDefaultValue, placeList, placeName, placeValue]); // 初始化赋值下拉框数据

  (0,react.useEffect)(() => {
    if (placeInitList.length) {
      var list = (0,useChainEditPlaceAndMerchant/* handleFilterDc */.PB)(placeInitList);
      setPlaceList(list);
    }
  }, [placeInitList]);
  return [{
    label: label !== null && label !== void 0 ? label : '商家/地点',
    // 名称
    name: merchantName,
    // 商家字段名
    // columns: 2,
    widget: /*#__PURE__*/react.createElement(input/* default.Group */.Z.Group, {
      compact: true
    }, /*#__PURE__*/react.createElement(tooltip/* default */.Z, {
      title: ((_merchantList$find = merchantList.find(e => e.value === merchantValue)) === null || _merchantList$find === void 0 ? void 0 : _merchantList$find.label) || ''
    }, /*#__PURE__*/react.createElement(es_select/* default */.Z, {
      placeholder: "\u5546\u5BB6",
      dropdownMatchSelectWidth: false,
      showSearch: true,
      allowClear: true,
      value: merchantValue || undefined,
      optionLabelProp: "children",
      style: {
        width: '50%'
      },
      onChange: (v, o) => changeField(merchantName, v, o),
      onSelect: selectMerchant,
      filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
      disabled: disableMerchant
    }, merchantList.map(v => /*#__PURE__*/react.createElement(es_select/* default.Option */.Z.Option, {
      value: v.value,
      key: v.value,
      rows: v
    }, v.label)))), /*#__PURE__*/react.createElement(tooltip/* default */.Z, {
      title: place
    }, /*#__PURE__*/react.createElement(es_select/* default */.Z, {
      placeholder: "\u5730\u70B9",
      dropdownMatchSelectWidth: false,
      showSearch: true,
      allowClear: true,
      value: placeValue,
      optionLabelProp: "children",
      style: {
        width: '50%'
      },
      notFoundContent: loadingPlaceList ? /*#__PURE__*/react.createElement(spin/* default */.Z, {
        size: "small"
      }) : null,
      onChange: (v, o) => changeField(placeName, v, o),
      filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
      onSelect: selectPlace,
      disabled: disablePlace
    }, placeList.map(v => /*#__PURE__*/react.createElement(es_select/* default.Option */.Z.Option, {
      value: +v.others.placeId,
      key: "".concat(v.others.placeCode, "-").concat(v.label),
      rows: v
    }, "".concat(v.others.placeCode, "-").concat(v.label))))))
  }];
}

/* harmony default export */ var components_useChainMerchantPlaceAndMerchant = (useChainMerchantPlaceAndMerchant);
// EXTERNAL MODULE: ./src/pages/ConfigManage/SupplyChain/SupplyChainRoute/components/ChainFormCategorySelect/index.tsx
var ChainFormCategorySelect = __webpack_require__(68098);
;// CONCATENATED MODULE: ./src/pages/ConfigManage/SupplyChain/SupplyChainRoute/index.tsx



/**
 * SupplyChainRoute 供应链路由
 */










var enumIsDefaultDC;

(function (enumIsDefaultDC) {
  enumIsDefaultDC[enumIsDefaultDC["\u662F"] = 1] = "\u662F";
  enumIsDefaultDC[enumIsDefaultDC["\u5426"] = 2] = "\u5426";
})(enumIsDefaultDC || (enumIsDefaultDC = {}));

var enumChainRouteStatus;

(function (enumChainRouteStatus) {
  enumChainRouteStatus[enumChainRouteStatus["\u5931\u6548"] = 1] = "\u5931\u6548";
  enumChainRouteStatus[enumChainRouteStatus["\u751F\u6548"] = 2] = "\u751F\u6548";
})(enumChainRouteStatus || (enumChainRouteStatus = {}));

var enumChainRouteSource;

(function (enumChainRouteSource) {
  enumChainRouteSource[enumChainRouteSource["\u5546\u6237"] = 1] = "\u5546\u6237";
  enumChainRouteSource[enumChainRouteSource["\u624B\u5DE5"] = 2] = "\u624B\u5DE5";
  enumChainRouteSource[enumChainRouteSource["\u5168\u90E8"] = 0] = "\u5168\u90E8";
})(enumChainRouteSource || (enumChainRouteSource = {}));

var handleDataList = arr => {
  return arr.map(e => {
    return {
      value: e.placeId,
      label: e.placeName
    };
  });
};

var SupplyChainRoute = () => {
  var _useMapping = (0,useMapping/* default */.Z)([enums/* purchaseEnumConfig.merchantId */.Nt.merchantId, enums/* purchaseEnumConfig.deliveryDcId */.Nt.deliveryDcId, enums/* purchaseEnumConfig.firstCategoryId */.Nt.firstCategoryId, enums/* purchaseEnumConfig.secondCategoryId */.Nt.secondCategoryId, enums/* purchaseEnumConfig.placeId */.Nt.placeId, enums/* purchaseEnumConfig.categoryAll */.Nt.categoryAll]),
      mappingList = _useMapping.mappingList;

  var fieldDataList = type => {
    return mappingList && mappingList['get'] && mappingList.get(enums/* purchaseEnumConfig */.Nt[type]);
  };

  var formCache = (0,umiExports/* useSelector */.v9)(state => {
    var _state$formCache;

    return ((_state$formCache = state.formCache) === null || _state$formCache === void 0 ? void 0 : _state$formCache[location.pathname]) || {};
  });

  var _useState = (0,react.useState)({
    condition: (0,objectSpread2/* default */.Z)({
      isDelete: 2
    }, formCache)
  }),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var formRef = (0,react.useRef)(null);
  /** 当前商户 */

  var _useState3 = (0,react.useState)(undefined),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      curMerchantId = _useState4[0],
      setcurMerchantId = _useState4[1];

  var _useState5 = (0,react.useState)(undefined),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      curPlaceId = _useState6[0],
      setcurPlaceId = _useState6[1]; // 展示用-地点


  var _useState7 = (0,react.useState)(undefined),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      realcurPlaceId = _useState8[0],
      setRealcurPlaceId = _useState8[1]; // 查询用-地点


  var _useState9 = (0,react.useState)(undefined),
      _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
      dcMerchantId = _useState10[0],
      setdcMerchantId = _useState10[1];

  var _useState11 = (0,react.useState)(undefined),
      _useState12 = (0,slicedToArray/* default */.Z)(_useState11, 2),
      deliveryDcId = _useState12[0],
      setdeliveryDcId = _useState12[1];

  var _useState13 = (0,react.useState)(undefined),
      _useState14 = (0,slicedToArray/* default */.Z)(_useState13, 2),
      realDeliveryDcId = _useState14[0],
      setrealDeliveryDcId = _useState14[1];

  var _useState15 = (0,react.useState)([]),
      _useState16 = (0,slicedToArray/* default */.Z)(_useState15, 2),
      receivePlaceList = _useState16[0],
      setReceivePlaceList = _useState16[1];

  var dispatch = (0,umiExports/* useDispatch */.I0)(); // 商家地点-DC

  var placeMerchantDC = components_useChainDCPlaceAndMerchant({
    label: '供货DC',
    merchantDefaultValue: dcMerchantId,
    merchantName: 'dcMerchantId',
    placeDefaultValue: deliveryDcId,
    placeName: 'deliveryDcId',
    changeFieldCallback: (e, i, rows) => {
      console.log(e, i, rows);
      e === 'dcMerchantId' && setdcMerchantId(i);

      if (e === 'deliveryDcId') {
        var _rows$rows, _rows$rows2, _rows$rows2$others;

        setrealDeliveryDcId(+(rows === null || rows === void 0 ? void 0 : (_rows$rows = rows.rows) === null || _rows$rows === void 0 ? void 0 : _rows$rows.value));
        setdeliveryDcId(rows === null || rows === void 0 ? void 0 : rows.value);
        setdcMerchantId(+(rows === null || rows === void 0 ? void 0 : (_rows$rows2 = rows.rows) === null || _rows$rows2 === void 0 ? void 0 : (_rows$rows2$others = _rows$rows2.others) === null || _rows$rows2$others === void 0 ? void 0 : _rows$rows2$others.merchantId));
      }
    }
  }); // 商家地点

  var placeMerchant = components_useChainMerchantPlaceAndMerchant({
    label: '地点',
    merchantDefaultValue: curMerchantId,
    merchantName: 'curMerchantId',
    placeDefaultValue: curPlaceId,
    placeName: 'curPlaceId',
    changeFieldCallback: (e, i, rows) => {
      console.log(e, i, rows);
      e === 'curMerchantId' && setcurMerchantId(i);

      if (e === 'curPlaceId') {
        var _rows$rows3, _rows$rows4, _rows$rows4$others;

        setcurPlaceId(rows === null || rows === void 0 ? void 0 : rows.value);
        setRealcurPlaceId(+(rows === null || rows === void 0 ? void 0 : (_rows$rows3 = rows.rows) === null || _rows$rows3 === void 0 ? void 0 : _rows$rows3.value));
        setcurMerchantId(+(rows === null || rows === void 0 ? void 0 : (_rows$rows4 = rows.rows) === null || _rows$rows4 === void 0 ? void 0 : (_rows$rows4$others = _rows$rows4.others) === null || _rows$rows4$others === void 0 ? void 0 : _rows$rows4$others.merchantId));
      }
    }
  });
  (0,react.useEffect)(() => {
    console.log('curMerchantId', curMerchantId);
  }, [curMerchantId]);
  (0,react.useEffect)(() => {
    formRef.current.setFieldsValue({
      '_placeId': [curMerchantId, curPlaceId]
    });
  }, [curPlaceId, curMerchantId]);
  (0,react.useEffect)(() => {
    var _fieldDataList;

    // 默认获取全部地点作为地点取值
    ((_fieldDataList = fieldDataList('placeId')) === null || _fieldDataList === void 0 ? void 0 : _fieldDataList.length) && setReceivePlaceList(fieldDataList('placeId')); // 每次选择商家都清空一次地点选择
  }, [fieldDataList('placeId')]);
  (0,react.useEffect)(() => {
    var _formRef$current, _formRef$current$getF, _formRef$current$getF2;

    console.log('formRef?.current?.getFieldsValue()?.categoryId?.first', formRef === null || formRef === void 0 ? void 0 : (_formRef$current = formRef.current) === null || _formRef$current === void 0 ? void 0 : (_formRef$current$getF = _formRef$current.getFieldsValue()) === null || _formRef$current$getF === void 0 ? void 0 : (_formRef$current$getF2 = _formRef$current$getF.categoryId) === null || _formRef$current$getF2 === void 0 ? void 0 : _formRef$current$getF2.first);
  }, [formRef]);

  var _useState17 = (0,react.useState)({
    first: undefined,
    second: undefined
  }),
      _useState18 = (0,slicedToArray/* default */.Z)(_useState17, 2),
      curCategory = _useState18[0],
      setcurCategory = _useState18[1];

  var categoryChange = e => {
    setcurCategory({
      first: e === null || e === void 0 ? void 0 : e.first,
      second: e === null || e === void 0 ? void 0 : e.second
    });
  };

  var formList = [...placeMerchant, ...placeMerchantDC, {
    label: '品类',
    name: 'categoryId',
    widget: /*#__PURE__*/react.createElement(ChainFormCategorySelect/* default */.Z, {
      categoryList: fieldDataList('categoryAll'),
      formValue: curCategory,
      onChange: categoryChange
    })
  }, // 默认全部，可下拉筛选手工/商户系统；
  {
    label: '来源',
    name: 'source',
    dataList: [{
      value: 0,
      label: '全部'
    }, {
      value: 1,
      label: '商户'
    }, {
      value: 2,
      label: '手工'
    }],
    type: 'SELECT'
  }, {
    label: '状态',
    name: 'isDelete',
    dataList: [{
      value: 0,
      label: '全部'
    }, {
      value: 1,
      label: '失效'
    }, {
      value: 2,
      label: '生效'
    }],
    type: 'SELECT'
  }]; // 表单回调

  var searchHandler = (e, result) => {
    if (e === 'success') {
      var p = {
        condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, result), {}, {
          merchantId: curMerchantId,
          placeId: realcurPlaceId,
          dcMerchantId,
          deliveryDcId: realDeliveryDcId
        })
      };

      if (curCategory !== null && curCategory !== void 0 && curCategory.first) {
        p['condition']['firstCategoryId'] = curCategory === null || curCategory === void 0 ? void 0 : curCategory.first;
      }

      if (curCategory !== null && curCategory !== void 0 && curCategory.second) {
        p['condition']['secondCategoryId'] = curCategory === null || curCategory === void 0 ? void 0 : curCategory.second;
      }

      p['condition']['categoryId'] && delete p['condition']['categoryId'];
      setState((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, state), p));
    }
  }; // 刷新列表


  var refresh = () => {
    setState((0,objectSpread2/* default */.Z)({}, state));
  };

  var handleResetForm = (_state, values) => {
    setState((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, values), {}, {
      condition: {
        isDelete: enumChainRouteStatus['生效']
      }
    })); // formRef.current.setFieldsValue({ '_placeId': [undefined, undefined] })

    setcurMerchantId(undefined);
    setcurPlaceId(undefined);
    setRealcurPlaceId(undefined);
    setdcMerchantId(undefined);
    setdeliveryDcId(undefined);
    setrealDeliveryDcId(undefined);
  };

  return /*#__PURE__*/react.createElement(CommonWrap/* default */.Z, null, /*#__PURE__*/react.createElement("div", {
    className: "column-flex"
  }, /*#__PURE__*/react.createElement("div", {
    className: "wrapFormStyle"
  }, /*#__PURE__*/react.createElement(FormBuilder/* default */.Z, {
    defaultExpand: true,
    ref: formRef,
    elements: formList,
    callbackHandler: searchHandler,
    onReset: handleResetForm,
    isCache: true
  })), /*#__PURE__*/react.createElement("div", {
    className: "wrapStyle mTop10 flex-fill"
  }, /*#__PURE__*/react.createElement(components_ViewList, {
    searchParams: state,
    refresh: refresh
  }))));
};

/* harmony default export */ var SupplyChain_SupplyChainRoute = (SupplyChainRoute);

/***/ }),

/***/ 17014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IY": function() { return /* binding */ LIST; },
/* harmony export */   "$Y": function() { return /* binding */ DETAIL; },
/* harmony export */   "wb": function() { return /* binding */ UPDATE; },
/* harmony export */   "OL": function() { return /* binding */ BATCHDELETE; },
/* harmony export */   "xM": function() { return /* binding */ EXPORT; },
/* harmony export */   "uv": function() { return /* binding */ FETCH_TAIZHOUCANG_MERCHANTID; },
/* harmony export */   "kt": function() { return /* binding */ PLACE_GOODS_LIST; }
/* harmony export */ });
/* unused harmony exports DOWNLOAD_TEMPLATE, MERCHANT_GOODS_LIST */
/**
 * API集合
 */
// 列表
var LIST = 'scm.wholesaleAppointPrice.queryAppointPricePage'; // 明细

var DETAIL = 'scm.wholesaleAppointPrice.queryAppointPriceDetail'; // 新增修改

var UPDATE = 'scm.wholesaleAppointPrice.addOrUpdateAppointPrice'; // 批量删除

var BATCHDELETE = 'scm.wholesaleAppointPrice.deleteAppointPrice'; // 导入

var EXPORT = 'scm.wholesaleAppointPrice.importAppointPrice'; // 下载模板

var DOWNLOAD_TEMPLATE = 'scm.config.getDownloadTemplate'; // 获取台州仓商户id

var FETCH_TAIZHOUCANG_MERCHANTID = 'scmconfig.appointprice.queryAppointPriceMerchantId'; // 商家维度查询商品

var MERCHANT_GOODS_LIST = 'purchase.product.querySelectMerchantProductByCondition'; // 地点维度查询商品

var PLACE_GOODS_LIST = 'purchase.product.querySelectPlaceProductByCondition';

/***/ }),

/***/ 89998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DICTIONARY": function() { return /* binding */ DICTIONARY; },
/* harmony export */   "BASE_MAP": function() { return /* binding */ BASE_MAP; },
/* harmony export */   "TABLE_COLUMNS": function() { return /* binding */ TABLE_COLUMNS; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


 // 字典

var DICTIONARY = [{
  "key": "SupplierCategory",
  "configMap": {
    "1": "采购供应商",
    "2": "农户供应商"
  }
}];
var BASE_MAP = [['goodsId', ['商品编码', '']], ['goodsBarCode', ['商品条码', '']], // ['referencePrice', ['系统参考价', '']],
['appointPrice', ['指定批发价', '']], ['provinceName', ['省份', '']], ['customerName', ['客户名称', '']]];
var TABLE_COLUMNS = [{
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 90
}, {
  title: '商品条码',
  dataIndex: 'goodsBarCode',
  key: 'goodsBarCode',
  width: 140
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 130,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '单位',
  dataIndex: 'specificationUnit',
  key: 'specificationUnit',
  width: 80
}, {
  title: '客户编码',
  dataIndex: 'customerNo',
  key: 'customerNo',
  width: 110
}, {
  title: '客户名称',
  dataIndex: 'customerName',
  key: 'customerName',
  width: 120
}, {
  title: '省份',
  dataIndex: 'provinceName',
  key: 'provinceName',
  width: 100
}, // {
//   title: '系统参考价(元)',
//   dataIndex: 'referencePrice',
//   key: 'referencePrice',
//   width: 80
// },
{
  title: '指定批发价(元)',
  dataIndex: 'appointPrice',
  key: 'appointPrice',
  width: 130
}, {
  title: '最后修改时间',
  dataIndex: 'gmtModified',
  key: 'gmtModified',
  width: 170
}, {
  title: '最后修改人',
  dataIndex: 'updateUserName',
  key: 'updateUserName',
  width: 110,
  ellipsis: true
}];

/***/ }),

/***/ 51816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_d": function() { return /* binding */ QUERY_GROUP_LIST; },
/* harmony export */   "IR": function() { return /* binding */ QUERY_STORE_LIST; },
/* harmony export */   "PD": function() { return /* binding */ QUERY_SHOP_LIST; },
/* harmony export */   "v6": function() { return /* binding */ QUERY_AUTO_CLOSE_LIST; },
/* harmony export */   "xt": function() { return /* binding */ QUERY_LIST_BY_PAGE; },
/* harmony export */   "SA": function() { return /* binding */ QUERY_PLACE_LIST; },
/* harmony export */   "ft": function() { return /* binding */ QUERY_LEVEL_LIST; },
/* harmony export */   "_k": function() { return /* binding */ QUERY_KEY_LIST; },
/* harmony export */   "$6": function() { return /* binding */ SUBMIT_AUTO_CLOSE_CONFIG; },
/* harmony export */   "Tx": function() { return /* binding */ QUERY_AUTO_CLOSE_RESULT; },
/* harmony export */   "Ji": function() { return /* binding */ VERIFY_AUTO_CLOSE_CONFIG; }
/* harmony export */ });
/**
 * 门店-自动关单配置
 */
// 查询运营组列表
var QUERY_GROUP_LIST = 'ylp.ibd.ReceiptProcessService.queryOperationSelect'; // 查询店群列表

var QUERY_STORE_LIST = "ylp.ibd.ReceiptProcessService.queryGroupSelect"; // 获取门店列表

var QUERY_SHOP_LIST = "ylp.ibd.ReceiptProcessService.queryShopSelect"; // 收货自动关单配置查询

var QUERY_AUTO_CLOSE_LIST = "ylp.ibd.ReceiptProcessService.queryAutoCloseConfig"; // 收货自动关单配置查询 详情页列表

var QUERY_LIST_BY_PAGE = "ylp.ibd.ReceiptProcessService.queryListByPage"; // 查询店群/运营组下的门店地点信息

var QUERY_PLACE_LIST = "ylp.ibd.ReceiptProcessService.queryShops"; // 自动关单品类列表

var QUERY_LEVEL_LIST = "ylp.mst.SkuTypeService.queryByLevel"; // 自动关单  receiptAutoCron时间列表  shopIbdReceiptType收获类型列表

var QUERY_KEY_LIST = "ylp.mst.SysEnumService.queryByKey"; // 自动关单 提交

var SUBMIT_AUTO_CLOSE_CONFIG = "ylp.ibd.ReceiptProcessService.submitAutoCloseConfig"; // 自动关单 提交结果查询

var QUERY_AUTO_CLOSE_RESULT = "ylp.ibd.ReceiptProcessService.queryAutoCloseResult"; // 校验关单配置

var VERIFY_AUTO_CLOSE_CONFIG = "ylp.ibd.ReceiptProcessService.verifyAutoCloseConfig";

/***/ }),

/***/ 93624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hI": function() { return /* binding */ getGroupList; },
/* harmony export */   "dX": function() { return /* binding */ getStoreList; },
/* harmony export */   "IU": function() { return /* binding */ getShopList; },
/* harmony export */   "ZP": function() { return /* binding */ useFormfield; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3182);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24731);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51816);




// 获取运营组列表
function getGroupList() {
  return _getGroupList.apply(this, arguments);
} // 获取店群列表

function _getGroupList() {
  _getGroupList = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)().mark(function _callee() {
    var _res$result, _res$result$data;

    var res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_3__/* .QUERY_GROUP_LIST */ ._d);

          case 2:
            res = _context.sent;
            return _context.abrupt("return", (res === null || res === void 0 ? void 0 : res.code) === 200 ? res === null || res === void 0 ? void 0 : (_res$result = res.result) === null || _res$result === void 0 ? void 0 : (_res$result$data = _res$result.data) === null || _res$result$data === void 0 ? void 0 : _res$result$data.map(e => ({
              label: e.name,
              value: e.id
            })) : []);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getGroupList.apply(this, arguments);
}

function getStoreList() {
  return _getStoreList.apply(this, arguments);
} // 获取门店列表

function _getStoreList() {
  _getStoreList = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)().mark(function _callee2() {
    var _res$result2, _res$result2$data;

    var res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_3__/* .QUERY_STORE_LIST */ .IR);

          case 2:
            res = _context2.sent;
            return _context2.abrupt("return", (res === null || res === void 0 ? void 0 : res.code) === 200 ? res === null || res === void 0 ? void 0 : (_res$result2 = res.result) === null || _res$result2 === void 0 ? void 0 : (_res$result2$data = _res$result2.data) === null || _res$result2$data === void 0 ? void 0 : _res$result2$data.map(e => ({
              label: e.name,
              value: e.id
            })) : []);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getStoreList.apply(this, arguments);
}

function getShopList() {
  return _getShopList.apply(this, arguments);
}

function _getShopList() {
  _getShopList = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)().mark(function _callee3() {
    var _res$result3, _res$result3$data;

    var res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_3__/* .QUERY_SHOP_LIST */ .PD);

          case 2:
            res = _context3.sent;
            return _context3.abrupt("return", (res === null || res === void 0 ? void 0 : res.code) === 200 ? res === null || res === void 0 ? void 0 : (_res$result3 = res.result) === null || _res$result3 === void 0 ? void 0 : (_res$result3$data = _res$result3.data) === null || _res$result3$data === void 0 ? void 0 : _res$result3$data.map(e => ({
              label: e.placeName,
              value: e.placeCode
            })) : []);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getShopList.apply(this, arguments);
}

function useFormfield() {
  return [{
    title: '门店编码',
    dataIndex: 'placeCodeCodes',
    hideInTable: true,
    fieldProps: {
      allowClear: false
    }
  }, {
    title: '门店名称',
    dataIndex: 'placeNameCodes',
    valueType: 'select',
    hideInTable: true,
    request: getShopList,
    fieldProps: {
      mode: 'multiple',
      maxTagCount: 3,
      optionFilterProp: 'label'
    }
  }, {
    title: '店群',
    dataIndex: 'groupIds',
    valueType: 'select',
    hideInTable: true,
    request: getStoreList,
    fieldProps: {
      mode: 'multiple',
      maxTagCount: 6,
      optionFilterProp: 'label'
    }
  }, {
    title: '运营组',
    dataIndex: 'operationGroupIds',
    valueType: 'select',
    hideInTable: true,
    request: getGroupList,
    fieldProps: {
      mode: 'multiple',
      maxTagCount: 2,
      optionFilterProp: 'label'
    }
  }, {
    title: '更新时间',
    dataIndex: 'operateTime',
    valueType: 'dateTimeRange',
    hideInTable: true,
    fieldProps: {
      allowClear: true
    }
  }, {
    title: '更新人',
    dataIndex: 'modifier',
    hideInTable: true,
    fieldProps: {
      allowClear: false
    }
  }];
}

/***/ }),

/***/ 86816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CustomUploader; }
});

// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/index.js
var style = __webpack_require__(34792);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(48086);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/upload/style/index.js
var upload_style = __webpack_require__(43185);
// EXTERNAL MODULE: ./node_modules/antd/es/upload/index.js + 12 modules
var upload = __webpack_require__(3388);
// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var button_style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/UploadOutlined.js + 1 modules
var UploadOutlined = __webpack_require__(84391);
;// CONCATENATED MODULE: ./src/pages/DigitalStore/IncreaseDecreaseFill/CustomUploader/components/CommonUploader.tsx








function CommonUploader(props) {
  var _props$btnText, _props$btnText2;

  var disabled = props.uploadOptions.disabled;
  return /*#__PURE__*/react.createElement(upload/* default */.Z, (0,esm_extends/* default */.Z)({
    name: "file",
    accept: props.accept,
    action: props.action,
    data: props.data,
    beforeUpload: props.beforeUpload,
    onChange: props.handleChange
  }, props.uploadOptions), props.showType ? /*#__PURE__*/react.createElement("span", null, (_props$btnText = props.btnText) !== null && _props$btnText !== void 0 ? _props$btnText : "点击上传") : /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    loading: props.loading,
    disabled: props.loading || disabled,
    type: "primary"
  }, /*#__PURE__*/react.createElement(UploadOutlined/* default */.Z, null), " ", (_props$btnText2 = props.btnText) !== null && _props$btnText2 !== void 0 ? _props$btnText2 : "点击上传"));
}

/* harmony default export */ var components_CommonUploader = (CommonUploader);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/style/index.js
var modal_style = __webpack_require__(71194);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(57016);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlusOutlined.js + 1 modules
var PlusOutlined = __webpack_require__(49101);
;// CONCATENATED MODULE: ./src/pages/DigitalStore/IncreaseDecreaseFill/CustomUploader/utils/constance.ts
// 上传前需要获取token的请求地址
var uploadTokenUrl = "purchase.basis.getToken";
var imgSuffix = ["image/jpeg", "image/gif", "image/png", "image/jpg"];
// EXTERNAL MODULE: ./src/pages/DigitalStore/IncreaseDecreaseFill/CustomUploader/index.less?modules
var CustomUploadermodules = __webpack_require__(17077);
var CustomUploadermodules_default = /*#__PURE__*/__webpack_require__.n(CustomUploadermodules);
;// CONCATENATED MODULE: ./src/pages/DigitalStore/IncreaseDecreaseFill/CustomUploader/components/UploadImg.tsx












/* eslint-disable no-throw-literal */




var suffixs = imgSuffix.join(",").replace(/\image/g, ""); // 获取图片信息

function readFiles(file, type) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onerror = error => reject(error);

    if (type === "url") {
      reader.onload = () => resolve(reader.result);
    } else {
      reader.onload = img => {
        var image = new Image();
        image.src = img.target.result;

        image.onload = function () {
          resolve(this);
        };
      };
    }
  });
}

function UploadImg(props) {
  var _props$accept, _props$btnText;

  var _useState = (0,react.useState)({
    visible: false,
    img: ""
  }),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      previewModal = _useState2[0],
      setPreviewModal = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      fileName = _useState4[0],
      setFileName = _useState4[1]; // 展示预览图


  var handlePreview = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(file) {
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log("handlePreview", file);

              if (!(!file.url && !file.preview)) {
                _context.next = 5;
                break;
              }

              _context.next = 4;
              return readFiles(file.originFileObj, "url");

            case 4:
              file.preview = _context.sent;

            case 5:
              setFileName(file === null || file === void 0 ? void 0 : file.name);
              setPreviewModal({
                visible: true,
                img: file.url || file.preview
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handlePreview(_x) {
      return _ref.apply(this, arguments);
    };
  }(); // 上传前的回调


  function beforeUpload(_x2) {
    return _beforeUpload.apply(this, arguments);
  }

  function _beforeUpload() {
    _beforeUpload = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3(file) {
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(resolve, reject) {
                  var isJpgOrPng, size, width, height, _size;

                  return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.prev = 0;
                          isJpgOrPng = imgSuffix.includes(file.type);

                          if (isJpgOrPng) {
                            _context2.next = 4;
                            break;
                          }

                          throw "\u53EA\u80FD\u4E0A\u4F20\u540E\u7F00\u540D\u4E3A\u3010".concat(suffixs, "\u3011\u7684\u6587\u4EF6");

                        case 4:
                          size = props.size, width = props.width, height = props.height; // 如果有传入参数限制图片大小

                          if (!size) {
                            _context2.next = 8;
                            break;
                          }

                          if (!(file.size / 1024 / 1024 > size / 1024)) {
                            _context2.next = 8;
                            break;
                          }

                          throw "\u4E0D\u80FD\u4E0A\u4F20\u8D85\u8FC7".concat(size, "K\u7684\u56FE\u7247");

                        case 8:
                          if (!(width || height)) {
                            _context2.next = 16;
                            break;
                          }

                          _context2.next = 11;
                          return readFiles(file, "size");

                        case 11:
                          _size = _context2.sent;

                          if (!(width && width > _size.width)) {
                            _context2.next = 14;
                            break;
                          }

                          throw "\u4E0A\u4F20\u56FE\u7247\u7684\u6700\u5927\u5BBD\u5EA6\u4E3A".concat(width, "px");

                        case 14:
                          if (!(height && height > _size.height)) {
                            _context2.next = 16;
                            break;
                          }

                          throw "\u4E0A\u4F20\u56FE\u7247\u7684\u6700\u5927\u9AD8\u5EA6\u4E3A".concat(height, "px");

                        case 16:
                          _context2.next = 18;
                          return props.beforeUpload(file);

                        case 18:
                          return _context2.abrupt("return", resolve(true));

                        case 21:
                          _context2.prev = 21;
                          _context2.t0 = _context2["catch"](0);

                          message.default.error(_context2.t0); // eslint-disable-next-line no-promise-executor-return


                          return _context2.abrupt("return", Promise.reject(_context2.t0));

                        case 25:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, null, [[0, 21]]);
                }));

                return function (_x3, _x4) {
                  return _ref2.apply(this, arguments);
                };
              }()));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _beforeUpload.apply(this, arguments);
  }

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(upload/* default */.Z, (0,esm_extends/* default */.Z)({
    name: "files",
    accept: (_props$accept = props.accept) !== null && _props$accept !== void 0 ? _props$accept : "image/*",
    listType: "picture-card",
    className: (CustomUploadermodules_default()).uploader,
    headers: {
      'res-token': props.data
    },
    data: props.data,
    action: props.action,
    beforeUpload: beforeUpload,
    onPreview: handlePreview,
    onChange: props.handleChange
  }, props.uploadOptions), props.loading ? // <LoadingOutlined />
  null : [/*#__PURE__*/react.createElement("div", {
    key: "text",
    className: (CustomUploadermodules_default()).uploadText
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(PlusOutlined/* default */.Z, {
    key: "icon",
    style: {
      fontSize: 18
    }
  })), (_props$btnText = props.btnText) !== null && _props$btnText !== void 0 ? _props$btnText : "上传图片")]), /*#__PURE__*/react.createElement(modal/* default */.Z, {
    visible: previewModal.visible,
    title: fileName,
    footer: null,
    onCancel: () => setPreviewModal(v => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
      visible: false
    }))
  }, /*#__PURE__*/react.createElement("img", {
    alt: "example",
    style: {
      width: "100%"
    },
    src: previewModal.img
  })));
}

/* harmony default export */ var components_UploadImg = (UploadImg);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
;// CONCATENATED MODULE: ./src/pages/DigitalStore/IncreaseDecreaseFill/CustomUploader/utils/api.ts

var env = null;
var baseURL = '';
var uploadUrlNew = '';
var API_ENV = "prod" || 0;
var apiHead = 'https://apigw';

if (API_ENV === 'prod' || API_ENV === 'production') {
  env = 'prod';
  baseURL = 'https://apigw.ypshengxian.com';
  uploadUrlNew = 'https://api-resource.ypshengxian.com/resource/upload';
} else {
  if (API_ENV === 'dev') {
    env = 'dev';
    baseURL = 'https://apigw-dev.ypshengxian.com';
    uploadUrlNew = 'https://test-api-resource.ypshengxian.com/resource/upload';
  } else if (API_ENV === 'test') {
    env = 'test';
    baseURL = 'https://apigw-test.ypshengxian.com';
    uploadUrlNew = 'https://test-api-resource.ypshengxian.com/resource/upload';
  } else if (API_ENV === 'pre') {
    env = 'pre';
    baseURL = 'https://apigw-pre.ypshengxian.com';
    uploadUrlNew = 'https://pre-api-resource.ypshengxian.com/resource/upload';
  } else if (API_ENV === 'sit') {
    env = 'sit';
    baseURL = 'https://apigw-sit.ypshengxian.com';
    uploadUrlNew = 'https://sit-api-resource.ypshengxian.com/resource/upload';
  } else if (API_ENV === 'testdev') {
    env = 'test';
    baseURL = 'https://apigw-dev.ypshengxian.com';
    uploadUrlNew = 'https://test-api-resource.ypshengxian.com/resource/upload';
  }
}

/* harmony default export */ var api = ({
  env,
  uploadUrlNew,
  imgUrl: 'https://h5.ypshengxian.com/treaty/static/images/defaultimg.png',
  appVersionName: '1.0.0',
  appVersion: '1.0.0',
  baseURL,
  baseUrl: apiHead + '.ypshengxian.com/',
  urlFetch: apiHead + '.ypshengxian.com/request',
  baseUrlCheck: 'https://release.ypshengxian.com',
  appId: 'ypsypush',
  appPlatform: 'web'
}); // export default config
;// CONCATENATED MODULE: ./src/pages/DigitalStore/IncreaseDecreaseFill/CustomUploader/index.tsx







/* eslint-disable no-throw-literal */







function Uploader(props) {
  var type = props.type,
      tokenUrl = props.tokenUrl;

  var _useState = (0,react.useState)(""),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      token = _useState2[0],
      setToken = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      actionUrl = _useState4[0],
      setActionUrl = _useState4[1];

  var _useState5 = (0,react.useState)(""),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      resId = _useState6[0],
      setResId = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var _useState9 = (0,react.useState)(),
      _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
      currentFile = _useState10[0],
      setCurrentFile = _useState10[1]; // 上传前  先获取 token


  var beforeUpload = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(file) {
      var _res, imgTokenAPI, url, res;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!props.beforeUpload) {
                _context.next = 6;
                break;
              }

              _context.next = 3;
              return props.beforeUpload(file);

            case 3:
              _res = _context.sent;

              if (_res) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", false);

            case 6:
              imgTokenAPI = "item.resource.getResourceToken";
              url = type === "img" ? imgTokenAPI : tokenUrl || uploadTokenUrl;
              _context.next = 10;
              return (0,ypRequest/* default */.Z)(url, {
                fileName: file.name,
                isPublic: true
              });

            case 10:
              res = _context.sent;
              return _context.abrupt("return", new Promise((resolve, reject) => {
                try {
                  // 获取上传的 token 失败
                  if (!res.success) {
                    var _res$message;

                    throw (_res$message = res.message) !== null && _res$message !== void 0 ? _res$message : "获取token失败";
                  }

                  var uploadToken = res.result.uploadToken;
                  console.log('uploadToken', uploadToken);
                  var params = uploadToken.params,
                      endpoint = uploadToken.endpoint,
                      _resId = uploadToken.resId;
                  var tokenValue = JSON.parse(params);

                  if (type === 'img') {
                    setActionUrl(api.uploadUrlNew);
                    setToken(res.result.token);
                    resolve(file);
                  } else {
                    endpoint && setActionUrl(endpoint);
                    setToken(tokenValue);
                    setResId(_resId);
                    setCurrentFile(file);
                    resolve(file);
                  }
                } catch (error) {
                  message.default.error(error);

                  reject(file);
                }
              }));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function beforeUpload(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleChange = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(_ref2) {
      var file, name, uid, _file$response, code, msg, data, _message2, _props$onChange, fileOriginPath, obj, _props$onChange2;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref2.file;
              console.log(file);

              if (!(file.status === "uploading")) {
                _context2.next = 5;
                break;
              }

              setLoading(true);
              return _context2.abrupt("return");

            case 5:
              if (!(file.status === "error")) {
                _context2.next = 9;
                break;
              }

              message.default.error("\u3010".concat(file.name, "\u3011\u4E0A\u4F20\u5931\u8D25"));

              setLoading(false);
              return _context2.abrupt("return");

            case 9:
              if (!(file.status === "done")) {
                _context2.next = 17;
                break;
              }

              setLoading(false);
              name = file.name, uid = file.uid;
              _file$response = file.response, code = _file$response.code, msg = _file$response.msg, data = _file$response.data, _message2 = _file$response.message; // 上传失败

              if (!(code !== 200)) {
                _context2.next = 16;
                break;
              }

              _message2.error(msg);

              return _context2.abrupt("return");

            case 16:
              if (type === 'img') {
                // 设置 fileList
                fileOriginPath = data.url + '/' + data.files[0];
                obj = [{
                  uid,
                  name,
                  status: 'done',
                  url: fileOriginPath,
                  files: data.files[0]
                }]; // const newFileList = fileList.filter((v: any) => !!v.url).concat(obj)
                // setFileList(obj)

                (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, obj, _message2, currentFile);
              } else {
                (_props$onChange2 = props.onChange) === null || _props$onChange2 === void 0 ? void 0 : _props$onChange2.call(props, resId, _message2, currentFile);
              }

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleChange(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var uploadCommonProps = {
    action: actionUrl,
    data: token,
    loading: props.loading || loading,
    beforeUpload,
    handleChange
  };

  if (type === "img") {
    return /*#__PURE__*/react.createElement(components_UploadImg, (0,esm_extends/* default */.Z)({}, props, uploadCommonProps));
  }

  return /*#__PURE__*/react.createElement(components_CommonUploader, (0,esm_extends/* default */.Z)({}, props, uploadCommonProps));
}

/* harmony default export */ var CustomUploader = (Uploader);

/***/ }),

/***/ 19960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57016);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46565);






function TableComponent(props) {
  var typeName = props.typeName; // 运营组

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      operateList = _useState2[0],
      setOperateList = _useState2[1]; // 类型


  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      placeList = _useState4[0],
      setPlaceList = _useState4[1];

  var elements = [{
    label: '选择运营组',
    name: 'yun',
    type: 'SELECT',
    dataList: operateList
  }, {
    label: "\u9009\u62E9".concat(typeName),
    name: 'shop',
    type: 'SELECT',
    dataList: placeList
  }];
  var columns = [{
    title: '运营组',
    dataIndex: 'yun',
    key: 'yun',
    width: 90
  }, {
    title: typeName,
    dataIndex: 'ss',
    key: 'ss' // type: ''

  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormBuilder, {
    elements: elements
  }), /*#__PURE__*/React.createElement(EnhanceTable, {
    columns: columns
  }));
}

function PushTargetModal(props) {
  var closeModalCallback = props.closeModalCallback;

  var saveModal = () => {};

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    title: "\u63A8\u9001\u5BF9\u8C61\uFF08}\uFF09",
    destroyOnClose: true,
    maskClosable: false,
    width: 500,
    visible: true,
    onOk: saveModal,
    onCancel: closeModalCallback
  });
}

/* harmony default export */ __webpack_exports__["default"] = (PushTargetModal);

/***/ }),

/***/ 47399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kQ": function() { return /* binding */ SEARCH_OPERATION_GROUP; },
/* harmony export */   "K9": function() { return /* binding */ QUERY_INCOME_PLAN_LIST; },
/* harmony export */   "OE": function() { return /* binding */ QUERY_INCOME_RELATION_LIST; },
/* harmony export */   "L": function() { return /* binding */ SAVE_INCOME_RELATION; },
/* harmony export */   "BL": function() { return /* binding */ QUERY_STATION_LIST; },
/* harmony export */   "Yu": function() { return /* binding */ BATCH_UPDATE_STATUS; }
/* harmony export */ });
/* unused harmony exports ENUMERATION_MONTH, QUERY_INCOME_RULE_LIST */
/**
 * 运营组查询
 */
var SEARCH_OPERATION_GROUP = 'ds.task.PlaceService.searchOperationGroups';
/**
 * 填报月份枚举
 */

var ENUMERATION_MONTH = 'ds.perf.IncomeRuleService.queryWriteMonthList';
/**
 * 规则填报记录分页查询
 */

var QUERY_INCOME_RULE_LIST = 'ds.perf.IncomeRuleService.queryIncomeRuleList';
/**
 * 查询方案列表
 */
// export const QUERY_INCOME_PLAN_LIST = 'ds.perf.IncomePlanService.queryIncomePlanList'

var QUERY_INCOME_PLAN_LIST = 'ds.perf.IncomePlanNewService.queryIncomePlanNewList';
/**
 * 查询关联关系列表
 */

var QUERY_INCOME_RELATION_LIST = 'ds.perf.IncomeRelationService.queryIncomeRelationList';
/**
 * 新增关联关系
 */

var SAVE_INCOME_RELATION = 'ds.perf.IncomeRelationService.saveIncomeRelation';
/**
 * 查询岗位列表
 */

var QUERY_STATION_LIST = 'ds.perf.StationCategoryConfigService.queryStationList';
/**
 *批量更新状态
 */

var BATCH_UPDATE_STATUS = 'ds.perf.IncomeRelationService.updateRelationStatus';

/***/ }),

/***/ 54035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ getOperationGroupList; },
/* harmony export */   "Z": function() { return /* binding */ myFormField; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2824);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3182);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24731);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47399);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);








// 获取运营组列表
function getOperationGroupList() {
  return _getOperationGroupList.apply(this, arguments);
} // 获取方案列表
// export async function queryIncomePlanList(name:string ){
//   const res: ResponstResult = await ypRider(api.QUERY_INCOME_PLAN_LIST, { status: 2 ,planName:name})
//    res?.code === 200 ? res?.result?.data?.map((e: IncomePlanItem) => ({ ...e, label: e.planName, value: e.planId })) : []
// }
// export async function handleSearch (newValue: string)  {
//    queryIncomePlanList(newValue)
// };

function _getOperationGroupList() {
  _getOperationGroupList = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().mark(function _callee3() {
    var _res$result2, _res$result2$data;

    var res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_5__/* .SEARCH_OPERATION_GROUP */ .kQ);

          case 2:
            res = _context3.sent;
            return _context3.abrupt("return", (res === null || res === void 0 ? void 0 : res.code) === 200 ? res === null || res === void 0 ? void 0 : (_res$result2 = res.result) === null || _res$result2 === void 0 ? void 0 : (_res$result2$data = _res$result2.data) === null || _res$result2$data === void 0 ? void 0 : _res$result2$data.map(e => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)({}, e), {}, {
              label: e.placeName,
              value: e.placeId
            })) : []);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getOperationGroupList.apply(this, arguments);
}

function myFormField(ref) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState, 2),
      operationGroupList = _useState2[0],
      setOperationGroupList = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState3, 2),
      planList = _useState4[0],
      setPlanList = _useState4[1];

  var statusList = [{
    label: '停用',
    value: '1'
  }, {
    label: '启用',
    value: '2'
  }];

  function queryIncomePlanList(_x) {
    return _queryIncomePlanList.apply(this, arguments);
  }

  function _queryIncomePlanList() {
    _queryIncomePlanList = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().mark(function _callee2(name) {
      var _res$result, _res$result$data;

      var res, planData;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_5__/* .QUERY_INCOME_PLAN_LIST */ .K9, {
                status: 2
              });

            case 2:
              res = _context2.sent;
              planData = (res === null || res === void 0 ? void 0 : res.code) === 200 ? res === null || res === void 0 ? void 0 : (_res$result = res.result) === null || _res$result === void 0 ? void 0 : (_res$result$data = _res$result.data) === null || _res$result$data === void 0 ? void 0 : _res$result$data.map(e => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)({}, e), {}, {
                label: e.planName,
                value: e.planId
              })) : [];
              setPlanList(planData);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _queryIncomePlanList.apply(this, arguments);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    (function () {
      var _init = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().mark(function _callee() {
        var data;
        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getOperationGroupList();

              case 2:
                data = _context.sent;
                setOperationGroupList(data);
                _context.next = 6;
                return queryIncomePlanList('');

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    })()();
  }, []);
  return [{
    title: '方案名称',
    dataIndex: 'planId',
    valueType: 'select',
    hideInTable: true,
    fieldProps: {
      showSearch: true,
      allowClear: false,
      options: planList,
      filterOption: (input, option) => {
        var _option$label;

        return ((_option$label = option === null || option === void 0 ? void 0 : option.label) !== null && _option$label !== void 0 ? _option$label : '').includes(input);
      }
    }
  }, {
    title: '运营组',
    dataIndex: 'operationGroupId',
    valueType: 'select',
    hideInTable: true,
    fieldProps: {
      allowClear: false,
      options: operationGroupList
    }
  }, {
    title: '填报月份',
    dataIndex: 'month',
    valueType: 'dateMonth',
    hideInTable: true,
    //initialValue: moment(),
    fieldProps: {
      allowClear: true,
      disabledDate: current => current < moment__WEBPACK_IMPORTED_MODULE_2___default()('2021') || current > moment__WEBPACK_IMPORTED_MODULE_2___default()(moment__WEBPACK_IMPORTED_MODULE_2___default()().year() + '-' + (moment__WEBPACK_IMPORTED_MODULE_2___default()().month() + 3))
    }
  }, {
    title: '状态',
    dataIndex: 'status',
    valueType: 'select',
    hideInTable: true,
    initialValue: ['2'],
    fieldProps: {
      allowClear: false,
      options: statusList
    }
  }];
}

/***/ }),

/***/ 67710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kQ": function() { return /* binding */ SEARCH_OPERATION_GROUP; },
/* harmony export */   "MI": function() { return /* binding */ QUERY_INCOME_RULE_LIST; },
/* harmony export */   "zQ": function() { return /* binding */ QUERY_INCOME_RULE_DETAIL; },
/* harmony export */   "$$": function() { return /* binding */ SAVE_INCOME_RULE; },
/* harmony export */   "Am": function() { return /* binding */ QUERY_PLACE_BY_OPERATION_GROUP_ID; },
/* harmony export */   "Ep": function() { return /* binding */ QUERY_GROUP_BY_OPERATION_GROUP_ID; }
/* harmony export */ });
/* unused harmony exports ENUMERATION_MONTH, ENUMS_MONTH_LIST */
/**
 * 运营组查询
 */
var SEARCH_OPERATION_GROUP = 'ds.task.PlaceService.searchOperationGroups';
/**
 * 填报月份枚举
 */

var ENUMERATION_MONTH = 'ds.perf.IncomeRuleService.queryWriteMonthList';
/**
 * 规则填报记录分页查询
 */

var QUERY_INCOME_RULE_LIST = 'ds.perf.IncomeRuleService.queryIncomeRuleList';
/**
 * 门店规则详情查询
 */

var QUERY_INCOME_RULE_DETAIL = 'ds.perf.IncomeRuleService.queryIncomeRuleByShopId';
/**
 * 规则保存
 */

var SAVE_INCOME_RULE = 'ds.perf.IncomeRuleService.saveIncomeRuleList';
/**
 * 月份枚举
 */

var ENUMS_MONTH_LIST = 'ds.perf.IncomeRuleService.queryWriteMonthList';
/**
 * 运营组下地点查询
 */

var QUERY_PLACE_BY_OPERATION_GROUP_ID = 'ds.task.place.PlaceService.queryPlaceByOperationGroupId';
/**
 * 运营组下队形查询
 */

var QUERY_GROUP_BY_OPERATION_GROUP_ID = 'ds.task.place.PlaceService.querGroupByOperationGroupId';

/***/ }),

/***/ 32643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kQ": function() { return /* binding */ SEARCH_OPERATION_GROUP; },
/* harmony export */   "jo": function() { return /* binding */ QUERY_BASIC_RULE_DETAIL; },
/* harmony export */   "jL": function() { return /* binding */ QUERY_GEAR_RULE_DETAIL; },
/* harmony export */   "Ep": function() { return /* binding */ QUERY_GROUP_BY_OPERATION_GROUP_ID; },
/* harmony export */   "rH": function() { return /* binding */ QUERY_BASIC_TARGET_RULE_LIST; },
/* harmony export */   "YM": function() { return /* binding */ QUERY_GEAR_TARGET_RULE_LIST; },
/* harmony export */   "qy": function() { return /* binding */ SAVE_OR_UPDATE_BASIC_TARGET_RULE; },
/* harmony export */   "dI": function() { return /* binding */ SAVE_OR_UPDATE_GEAR_TARGET_RULE; }
/* harmony export */ });
/* unused harmony exports QUERY_INCOME_RULE_LIST, SAVE_INCOME_RULE, ENUMS_MONTH_LIST, QUERY_PLACE_BY_OPERATION_GROUP_ID */
/**
 * 运营组查询
 */
var SEARCH_OPERATION_GROUP = 'ds.task.PlaceService.searchOperationGroups';
/**
 * 规则填报记录分页查询
 */

var QUERY_INCOME_RULE_LIST = 'ds.perf.IncomeRuleService.queryIncomeRuleList';
/**
 * 门店基础规则详情查询
 */

var QUERY_BASIC_RULE_DETAIL = 'ds.perf.TargetRuleService.queryBasicTargetRuleByShopCode';
/**
 * 门店档位规则详情查询
 */

var QUERY_GEAR_RULE_DETAIL = 'ds.perf.TargetRuleService.queryGearTargetRuleByShopCode';
/**
 * 规则保存
 */

var SAVE_INCOME_RULE = 'ds.perf.IncomeRuleService.saveIncomeRuleList';
/**
 * 月份枚举
 */

var ENUMS_MONTH_LIST = 'ds.perf.IncomeRuleService.queryWriteMonthList';
/**
 * 运营组下地点查询
 */

var QUERY_PLACE_BY_OPERATION_GROUP_ID = 'ds.task.place.PlaceService.queryPlaceByOperationGroupId';
/**
 * 运营组下队形查询
 */

var QUERY_GROUP_BY_OPERATION_GROUP_ID = 'ds.task.place.PlaceService.querGroupByOperationGroupId';
/**
 * 查询基础规则列表
 */

var QUERY_BASIC_TARGET_RULE_LIST = 'ds.perf.TargetRuleService.queryBasicTargetRuleList';
/**
 * 查询分档规则列表
 */

var QUERY_GEAR_TARGET_RULE_LIST = 'ds.perf.TargetRuleService.queryGearTargetRuleList';
/**
 * 保存or更新基础规则
 */

var SAVE_OR_UPDATE_BASIC_TARGET_RULE = 'ds.perf.TargetRuleService.saveOrUpdateBasicTargetRuleList';
/**
 * 保存or更新档位规则
 */

var SAVE_OR_UPDATE_GEAR_TARGET_RULE = 'ds.perf.TargetRuleService.saveOrUpdateGearTargetRuleList';

/***/ }),

/***/ 24056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57016);
/* harmony import */ var antd_es_progress_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34669);
/* harmony import */ var antd_es_progress__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44808);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);






/* harmony default export */ __webpack_exports__["Z"] = (props => {
  var visible = props.visible,
      percent = props.percent;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState, 2),
      title = _useState2[0],
      setTitle = _useState2[1];

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    title: "\u63D0\u4EA4\u8FDB\u5EA6",
    visible: visible,
    footer: null,
    closable: false,
    maskClosable: false,
    centered: true
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_progress__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    status: "active",
    percent: percent
  }));
});

/***/ }),

/***/ 82426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ Queue; }
/* harmony export */ });
function Queue() {
  // 初始化队列
  var items = []; // 向队列插入元素

  this.push = function (elem) {
    items.push(elem);
  }; // 从队头删除元素


  this.shift = function () {
    return items.shift();
  }; // 查看对头元素


  this.firstItem = function () {
    return items[0];
  }; // 判断队列是否为空


  this.isEmpty = function () {
    return items.length === 0;
  }; // 查看队列的长度


  this.length = function () {
    return items.length;
  }; // 查看队列


  this.toString = function () {
    return items.map(el => el.toString());
  }; // 返回数组


  this.dataSource = function () {
    return items;
  };
}

/***/ }),

/***/ 60654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ InputWithLength; }
/* harmony export */ });
/* harmony import */ var antd_es_input_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47673);
/* harmony import */ var antd_es_input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4107);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function InputWithLength(props) {
  var _value$length;

  var value = props.value,
      onChange = props.onChange,
      placeholder = props.placeholder,
      disabled = props.disabled;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "horizontal"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    disabled: disabled,
    allowClear: true
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, (_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0, "/20"));
}

/***/ }),

/***/ 48211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SelectMerchantOrg": function() { return /* binding */ SelectMerchantOrg; }
/* harmony export */ });
/* harmony import */ var antd_es_auto_complete_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65011);
/* harmony import */ var antd_es_auto_complete__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49288);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24731);










function MerchantOrg(props, ref) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      list = _useState2[0],
      setList = _useState2[1];

  var handleSearch = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().mark(function _callee(val) {
      var result;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)('phoenix.GeneralQueryService.multipleSearch', {
                type: 2,
                criteria: {
                  name: {
                    value: val,
                    fuzzy: true
                  }
                }
              });

            case 3:
              result = _context.sent;

              if (result.result.list) {
                _context.next = 6;
                break;
              }

              throw '数据结构错误';

            case 6:
              setList(result.result.list);
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_7__.default.error(_context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function handleSearch(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_auto_complete__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, {
    ref: ref,
    onSearch: handleSearch,
    onSelect: props.handleSelect,
    disabled: props.disabled,
    placeholder: "\u8BF7\u9009\u62E9\u9002\u7528\u7EC4\u7EC7\u540D\u79F0",
    allowClear: props.allowClear
  }, list.map(v => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_auto_complete__WEBPACK_IMPORTED_MODULE_8__/* .default.Option */ .Z.Option, {
    key: v.id,
    value: v.name
  }, v.name))));
}

var SelectMerchantOrg = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(MerchantOrg);

/***/ }),

/***/ 78998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kG": function() { return /* binding */ franchiseItemListQuery; },
/* harmony export */   "WX": function() { return /* binding */ franchiseItemDelete; },
/* harmony export */   "ph": function() { return /* binding */ franchiseItemUpdate; },
/* harmony export */   "EO": function() { return /* binding */ franchiseOrderQuery; },
/* harmony export */   "F3": function() { return /* binding */ franchiseApprove; },
/* harmony export */   "kL": function() { return /* binding */ franchiseSingleOrderQuery; },
/* harmony export */   "rG": function() { return /* binding */ franchiseItemOperateLog; },
/* harmony export */   "ft": function() { return /* binding */ franchiseOrderUpdate; },
/* harmony export */   "fd": function() { return /* binding */ franchiseOrderDelete; },
/* harmony export */   "ut": function() { return /* binding */ allPlacesByLogin; }
/* harmony export */ });
/* unused harmony export getDownloadFileUrl */
var franchiseItemListQuery = 'ds.income.franchiseService.franchiseItemListQuery';
var franchiseItemDelete = 'ds.income.franchiseService.franchiseItemDelete';
var getDownloadFileUrl = 'kernel.console.BatchToolsService.getDownloadFileUrl';
var franchiseItemUpdate = 'ds.income.franchiseService.franchiseItemUpdate';
var franchiseOrderQuery = 'ds.income.franchiseService.franchiseOrderQuery';
var franchiseApprove = 'ds.income.franchiseService.franchiseApprove';
var franchiseSingleOrderQuery = 'ds.income.franchiseService.franchiseSingleOrderQuery';
var franchiseItemOperateLog = 'ds.income.franchiseService.itemOperateLog';
var franchiseOrderUpdate = 'ds.income.franchiseService.franchiseOrderUpdate';
var franchiseOrderDelete = '/ds/income/franchiseService/franchiseOrderDelete';
var allPlacesByLogin = 'ds.income.franchiseService.allPlacesByLogin';

/***/ }),

/***/ 60240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XC": function() { return /* binding */ BOM_DETAIL_API; },
/* harmony export */   "iJ": function() { return /* binding */ BOM_LIST_API; },
/* harmony export */   "Pp": function() { return /* binding */ DELIVERY_ADD_API; },
/* harmony export */   "OB": function() { return /* binding */ DELIVERY_MODIFY_API; },
/* harmony export */   "zU": function() { return /* binding */ MODIFY_BOM_STATUS_API; },
/* harmony export */   "hw": function() { return /* binding */ DELETE_BOM_API; },
/* harmony export */   "Me": function() { return /* binding */ QUERY_MERCHANTID; },
/* harmony export */   "pX": function() { return /* binding */ FatnessRange; },
/* harmony export */   "O$": function() { return /* binding */ WidgetRange; }
/* harmony export */ });
/**
 * API集合
 */
// 详情
var BOM_DETAIL_API = 'pms.sgBomManageService.queryBomDetail'; // 列表

var BOM_LIST_API = 'pms.sgBomManageService.queryBomList'; // 新增

var DELIVERY_ADD_API = 'pms.sgBomManageService.createBom'; // 编辑

var DELIVERY_MODIFY_API = 'pms.sgBomManageService.updateBom'; // 修改bom状态

var MODIFY_BOM_STATUS_API = 'pms.sgBomManageService.updateBomStatus'; // 删除bom

var DELETE_BOM_API = 'pms.sgBomManageService.deleteBom'; // 获取当前账号下的商家/商户

var QUERY_MERCHANTID = 'kernel.console.AuthorizedDataQueryService.queryAuthorizedMerchant'; // 获取膘厚列表

var FatnessRange = 'pms.sgBomManageService.queryFatnessRangeList'; // 获取重量列表

var WidgetRange = 'pms.sgBomManageService.queryWeightRangeList';

/***/ }),

/***/ 88473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W8": function() { return /* binding */ LIST_API; },
/* harmony export */   "Rl": function() { return /* binding */ GOODS_SEARCH_LIST; },
/* harmony export */   "D2": function() { return /* binding */ SEARCH_GOOD_LIST; },
/* harmony export */   "gG": function() { return /* binding */ SEARCH_GOOD_BASIC_INFO_API; },
/* harmony export */   "O8": function() { return /* binding */ SAVE_BUSINESS_API; },
/* harmony export */   "vy": function() { return /* binding */ GET_SHOPS_API; },
/* harmony export */   "lE": function() { return /* binding */ HANDLE_SHOP_RANGE_API; },
/* harmony export */   "nk": function() { return /* binding */ SEARCH_SHOP_RANGE_API; },
/* harmony export */   "Ez": function() { return /* binding */ GOODS_IMPORT_API; },
/* harmony export */   "jB": function() { return /* binding */ MULTIPLE_UPLOAD_API; },
/* harmony export */   "YA": function() { return /* binding */ MULTIPLE_LIST; },
/* harmony export */   "Fy": function() { return /* binding */ DELIVERYGOODS_EXPORT; },
/* harmony export */   "uU": function() { return /* binding */ SEARCH_STORE_PRICE_API; },
/* harmony export */   "Vq": function() { return /* binding */ CHANGE_STORE_PRICE_API; },
/* harmony export */   "Kd": function() { return /* binding */ QUERY_AUTHORIZED_MERCHANT; },
/* harmony export */   "oF": function() { return /* binding */ SEARCH_SHOP_ITEM_SKU_STATUS_API; },
/* harmony export */   "PD": function() { return /* binding */ QUERY_SHOP_LIST; },
/* harmony export */   "q0": function() { return /* binding */ UPDATE_SHOP_SKU_SALE_STATUS; }
/* harmony export */ });
/* unused harmony exports M_SEARCH_API, BILL_SETTING_MODIFY_API, BILL_SETTING_DELETE_API, BILL_SETTING_DETAIL_API, MULTIPLE_IMPORT_PUBLISH_API, MULTIPLE_IMPORT_MULTIPLE_API, MULTIPLE_IMPORT_IMG_API, SEARCH_HANDLE_API */
/**
 * API集合
 */

/** 外卖商品列表 */
var LIST_API = 'pms.takeawayItemManage.queryTakeAwayItemSummary';
/** 商品模糊搜索 */

var M_SEARCH_API = 'supplier.basicdata.querySupplierBaseInfoPage';
/** 新增|修改 */

var BILL_SETTING_MODIFY_API = 'purchase.basicdata.addOrEditDistributionData';
/** 删除 */

var BILL_SETTING_DELETE_API = 'purchase.basicdata.deleteDistributionData';
/** 详情 */

var BILL_SETTING_DETAIL_API = 'purchase.basicdata.queryDetail';
var MULTIPLE_IMPORT_PUBLISH_API = 'pms.productManageService.importBatchCreateProduct';
var MULTIPLE_IMPORT_MULTIPLE_API = 'pms.productManageService.importBatchCreateProduct';
var MULTIPLE_IMPORT_IMG_API = 'pms.productManageService.importBatchCreateProduct';
/** 编辑页，商品模糊搜索 */

var GOODS_SEARCH_LIST = 'pms.productManageService.queryProductList';
/** 编辑页，根据商户id和商品id查询商品经营信息 */

var SEARCH_GOOD_LIST = 'pms.takeawayItemManage.queryTakeawayMerchantItem';
/** 编辑页，查询商品主档详情 */

var SEARCH_GOOD_BASIC_INFO_API = 'pms.productManageService.queryProductDetail';
/** 编辑外卖商品经营信息 */

var SAVE_BUSINESS_API = 'pms.takeawayItemManage.editTakeawayMerchantItem';
/** 获取门店/大仓 */

var GET_SHOPS_API = 'pms.takeawayItemManage.querySiteInfoByCodeOrNameForTakeaway';
/** 新增销售范围 */

var HANDLE_SHOP_RANGE_API = 'pms.takeawayItemManage.createProductSaleScope';
/** 查询销售范围 */

var SEARCH_SHOP_RANGE_API = 'pms.takeawayItemManage.batchQuerySaleScope';
/** 模糊搜索门店下拉列表 */

var SEARCH_HANDLE_API = 'pms.pmsMerchantService.querySiteInfoByCodeOrName';
/** 发布商品导入 templateType 固定为3 | 批量改价导入 templateType	固定为5 */

var GOODS_IMPORT_API = 'isc.ComponentManageService.BatchImport';
/** 批量发布 - 上传文件 */

var MULTIPLE_UPLOAD_API = 'isc.ComponentManageService.generateToken';
/** 批量操作 - 列表查询 */

var MULTIPLE_LIST = 'isc.ComponentManageService.historyList';
/** 导出外卖商品 */

var DELIVERYGOODS_EXPORT = 'isc.ComponentManageService.batchExport'; // 查询门店价格

var SEARCH_STORE_PRICE_API = 'pms.SgShopItemManageService.pageQuerySisByShopNameAndMisIds'; // 更新价格

var CHANGE_STORE_PRICE_API = 'pms.SgShopItemManageService.updateShopItemSkuByIds'; // 查询用户有权限下的商家列表

var QUERY_AUTHORIZED_MERCHANT = 'kernel.console.AuthorizedDataQueryService.queryAuthorizedMerchant'; // 查询门店商品状态

var SEARCH_SHOP_ITEM_SKU_STATUS_API = 'pms.takeawayItemManage.pageQueryTakeawayShopItemSku'; // 查询用户有权限下的商家列表

var QUERY_SHOP_LIST = 'pms.pmsMerchantService.querySiteInfoByCodeOrName'; // 修改销售状态

var UPDATE_SHOP_SKU_SALE_STATUS = 'pms.takeawayItemManage.updateShopItemSkuSaleStatusByIds';

/***/ }),

/***/ 43744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "weightUnitList": function() { return /* binding */ weightUnitList; },
/* harmony export */   "goodsUnitList": function() { return /* binding */ goodsUnitList; },
/* harmony export */   "ORDER_TYPE": function() { return /* binding */ ORDER_TYPE; },
/* harmony export */   "ORDER_CHILDREN_TYPE": function() { return /* binding */ ORDER_CHILDREN_TYPE; },
/* harmony export */   "TABLE_COLUMNS": function() { return /* binding */ TABLE_COLUMNS; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/**
 * 业务常量
 */

var weightUnitList = [{
  label: '份',
  value: '份'
}];
var goodsUnitList = [// { label: 'kg', value: 'kg' },
{
  label: '包',
  value: '包'
}, {
  label: '瓶',
  value: '瓶'
}, {
  label: '袋',
  value: '袋'
}, {
  label: '盒',
  value: '盒'
}, {
  label: '箱',
  value: '箱'
}, {
  label: '件',
  value: '件'
}, {
  label: '支',
  value: '支'
}, {
  label: '罐',
  value: '罐'
}, {
  label: '条',
  value: '条'
}, {
  label: '份',
  value: '份'
}, {
  label: '桶',
  value: '桶'
}, {
  label: '杯',
  value: '杯'
}, {
  label: '只',
  value: '只'
}, {
  label: '盆',
  value: '盆'
}, {
  label: '把',
  value: '把'
}, {
  label: '双',
  value: '双'
}, {
  label: '提',
  value: '提'
}, {
  label: '套',
  value: '套'
}, {
  label: '根',
  value: '根'
}, {
  label: '块',
  value: '块'
}, {
  label: '排',
  value: '排'
}, {
  label: '捆',
  value: '捆'
}, {
  label: '张',
  value: '张'
}, {
  label: '板',
  value: '板'
}, {
  label: '卷',
  value: '卷'
}, {
  label: '片',
  value: '片'
}, {
  label: '听',
  value: '听'
}, {
  label: '打',
  value: '打'
}, {
  label: '组',
  value: '组'
}, {
  label: '碗',
  value: '碗'
}, {
  label: '台',
  value: '台'
}, {
  label: '串',
  value: '串'
}, {
  label: '个',
  value: '个'
}, {
  label: '卡',
  value: '卡'
}, {
  label: '筒',
  value: '筒'
}, {
  label: '本',
  value: '本'
}, {
  label: '副',
  value: '副'
}, {
  label: '米',
  value: '米'
}, {
  label: '壶',
  value: '壶'
}, {
  label: '筐',
  value: '筐'
}];
var ORDER_TYPE = [{
  value: 1,
  label: '要货单'
}, {
  value: 2,
  label: '采购订单'
}, {
  value: 3,
  label: '调拨订单'
}, {
  value: 4,
  label: '采购分配单'
}, {
  value: 5,
  label: '调拨分配单'
}, {
  value: 6,
  label: '批发销售单'
}, {
  value: 7,
  label: '批发分配单'
}];
var ORDER_CHILDREN_TYPE = [{
  value: 1,
  label: '进货'
}, {
  value: 2,
  label: '退货'
}, {
  value: 3,
  label: '仓店配送'
}, {
  value: 4,
  label: '店间调拨'
}, {
  value: 5,
  label: '仓间调拨'
}, {
  value: 6,
  label: '店仓退配'
}];
var TABLE_COLUMNS = [{
  title: '销售单位',
  dataIndex: 'saleUnit',
  key: 'saleUnit',
  width: 70
}, {
  title: '换算比例',
  dataIndex: 'conversionRatio',
  key: 'conversionRatio',
  width: 90,

  render(field, record, index) {
    return parseFloat(field) + (record === null || record === void 0 ? void 0 : record.specUnit);
  }

}, {
  title: '门店上下架数',
  key: 'shopStatusInfo',
  name: 'shopStatusInfo',
  width: 160,

  render(t, r, i, reactNode) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, r.shopStatusInfo && Object.keys(r.shopStatusInfo).map(item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      key: item
    }, "".concat(item, "\u95E8\u5E97\uFF1A").concat(r.shopStatusInfo[item], "\u4E2A"))));
  }

}, {
  title: '商品类目',
  dataIndex: 'backCategoryName',
  key: 'backCategoryName',
  width: 150
}, {
  title: '上下架状态',
  dataIndex: 'saleStatusDesc',
  key: 'saleStatusDesc',
  width: 100
}, {
  title: '操作人',
  dataIndex: 'operator',
  key: 'operator',
  width: 80
}, {
  title: '更新时间',
  dataIndex: 'gmtModified',
  key: 'gmtModified',
  width: 150
}];

/***/ }),

/***/ 59378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SI": function() { return /* binding */ enumGoodsBusinessType; },
/* harmony export */   "aP": function() { return /* binding */ enumEditStep; },
/* harmony export */   "tF": function() { return /* binding */ DELIVERY_GOOD_BAR_DATA; },
/* harmony export */   "ws": function() { return /* binding */ enumDeliveryBusinessType; },
/* harmony export */   "SU": function() { return /* binding */ enumHandleTemplateType; },
/* harmony export */   "oO": function() { return /* binding */ enumHandleType; }
/* harmony export */ });
var enumGoodsBusinessType;
/** 当前步骤 */

(function (enumGoodsBusinessType) {
  enumGoodsBusinessType[enumGoodsBusinessType["\u5916\u5356\u5546\u54C1"] = 5] = "\u5916\u5356\u5546\u54C1";
})(enumGoodsBusinessType || (enumGoodsBusinessType = {}));

var enumEditStep;

(function (enumEditStep) {
  enumEditStep["\u57FA\u7840\u4FE1\u606F"] = "BASE_INFO";
  enumEditStep["\u7ECF\u8425\u4FE1\u606F"] = "BUSINESS_INFO";
  enumEditStep["\u9500\u552E\u8303\u56F4"] = "SALE_RANGE";
})(enumEditStep || (enumEditStep = {}));

/** Tab数据 */
var DELIVERY_GOOD_BAR_DATA = [{
  name: 'BASE_INFO',
  title: '基础信息'
}, {
  name: 'BUSINESS_INFO',
  title: '经营信息'
}, {
  name: 'SALE_RANGE',
  title: '销售范围'
}];
var enumDeliveryBusinessType;

(function (enumDeliveryBusinessType) {
  enumDeliveryBusinessType[enumDeliveryBusinessType["\u5230\u5BB6"] = 1] = "\u5230\u5BB6";
  enumDeliveryBusinessType[enumDeliveryBusinessType["\u5168\u56FD\u5305\u90AE"] = 2] = "\u5168\u56FD\u5305\u90AE";
  enumDeliveryBusinessType[enumDeliveryBusinessType["\u751F\u9C9C"] = 3] = "\u751F\u9C9C";
  enumDeliveryBusinessType[enumDeliveryBusinessType["\u8C0A\u6279\u5B9D"] = 4] = "\u8C0A\u6279\u5B9D";
  enumDeliveryBusinessType[enumDeliveryBusinessType["\u5916\u5356"] = 5] = "\u5916\u5356";
})(enumDeliveryBusinessType || (enumDeliveryBusinessType = {}));

var enumHandleTemplateType;

(function (enumHandleTemplateType) {
  enumHandleTemplateType[enumHandleTemplateType["\u5546\u54C1\u5BFC\u51FA/\u67E5\u770B\u5546\u54C1\u5BFC\u51FA\u5217\u8868"] = 7] = "\u5546\u54C1\u5BFC\u51FA/\u67E5\u770B\u5546\u54C1\u5BFC\u51FA\u5217\u8868";
  enumHandleTemplateType[enumHandleTemplateType["BOM\u5BFC\u51FA"] = 12] = "BOM\u5BFC\u51FA";
})(enumHandleTemplateType || (enumHandleTemplateType = {}));

var enumHandleType; // 3, "海博外卖商品导入模版"
// 4, "外卖门店商品导出模版"
// 5, "批量改价导入模版"
// 6, "商家主图导入模版"
// 7, "外卖商家商品导出模版"

(function (enumHandleType) {
  enumHandleType[enumHandleType["\u5BFC\u5165"] = 2] = "\u5BFC\u5165";
  enumHandleType[enumHandleType["\u5BFC\u51FA"] = 4] = "\u5BFC\u51FA";
})(enumHandleType || (enumHandleType = {}));

/***/ }),

/***/ 17514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZH": function() { return /* binding */ masterApi; },
/* harmony export */   "cE": function() { return /* binding */ gradingApi; },
/* harmony export */   "Ct": function() { return /* binding */ salesApi; },
/* harmony export */   "X9": function() { return /* binding */ apiList; },
/* harmony export */   "FF": function() { return /* binding */ copyApi; }
/* harmony export */ });
/**
 * API集合
 */
var masterApi = {
  querySgMerchantItemList: 'pms.sgMerchantItemManageService.querySgMerchantItemList',
  // 获取商家商品列表
  getBackCategoryTree: 'pms.backCategoryManage.getBackCategoryTree',
  // 获取后台类目树
  queryProductDetail: 'pms.productManageService.queryProductDetail',
  // 基础资料详情
  createProduct: 'pms.productManageService.createProduct',
  // 创建基础资料
  updateProduct: 'pms.productManageService.updateProduct',
  // 更新基础资料
  queryYpShengXianMerchant: 'pms.pmsMerchantService.queryYpShengXianMerchant',
  // 查询生鲜商户列表
  queryMerchantList: 'pms.merchantItemManage.queryMerchantList',
  // 查询商户权限
  downloadSgMerchantItem: 'pms.sgMerchantItemManageService.downloadSgMerchantItem',
  // 导出
  queryTaskList: 'pms.taskManageService.queryTaskList' // 异步导出查询列表

};
var gradingApi = {
  queryProductManageInfo: 'pms.sgMerchantItemManageService.queryProductManageInfo',
  // 获取经营信息详情
  getPluCodeList: 'pms.productManageService.getPluCodeList',
  // 新建分档，查询Plu列表
  createProductManageInfo: 'pms.productManageService.createProductManageInfo',
  // 新增经营信息
  updateProductManageInfo: 'pms.sgMerchantItemManageService.updateProductManageInfo',
  // 编辑经营信息
  querySupplierByCodeOrName: 'pms.pmsPurchaseService.querySupplierByCodeOrName' // 根据编码或者名称查询供应商列表

};
var salesApi = {
  queryProductSaleInfo: 'pms.sgMerchantItemManageService.queryProductSaleInfo',
  // 获取销售信息详情
  updateProductSaleInfo: 'pms.sgMerchantItemManageService.updateProductSaleInfo',
  // 编辑销售信息
  createProductSaleInfo: 'pms.productManageService.createProductSaleInfo',
  // 新建销售信息
  querySiteInfoByCodeOrName: 'pms.pmsMerchantService.querySiteInfoByCodeOrName',
  // 根据编码或者名称查询地点列表
  queryProductSaleInfoBySiteIds: 'pms.sgMerchantItemManageService.queryProductSaleInfoBySiteIds',
  // 根据门店id查询销售信息
  queryGroupsAndWarehouseByMerchantId: 'pms.pmsMerchantService.queryGroupsAndWarehouseByMerchantId' // 查询店群和配送中心

};
var apiList = {
  category: 'item.erpCategory.queryCategoryListByHeadId',
  fuzzyQueryBrandByName: 'pms.brandManageService.fuzzyQueryBrandByName',
  queryUserMerchantList: 'kernel.console.AuthorizedDataQueryService.queryAuthorizedMerchant',
  // 查询生鲜商户权限列表
  queryUserSiteList: 'pms.pmsMerchantService.queryUserSiteList' // 查询生鲜门店权限列表

};
var copyApi = {
  queryCopyShopList: 'pms.taskManageService.queryCopyShopItem',
  // 查询门店商品复制结果
  queryCopyShopItem: 'pms.openSalesDepartmentService.copyShopItem' //  复制门店商品

};

/***/ }),

/***/ 99776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iC": function() { return /* binding */ modeMapper; },
/* harmony export */   "dc": function() { return /* binding */ supplyJson; },
/* harmony export */   "d9": function() { return /* binding */ unitList; }
/* harmony export */ });
/* unused harmony exports defaultList, typeList, taxList, goodsList, logistics, salesJson */
var defaultList = [{
  value: 1,
  name: '是'
}, {
  value: 2,
  name: '否'
}];
var typeList = [{
  value: 1,
  name: '谊品生鲜'
}];
var taxList = [{
  value: '0',
  name: '0%'
}, {
  value: '3',
  name: '3%'
}, {
  value: '5',
  name: '5%'
}, {
  value: '6',
  name: '6%'
}, {
  value: '9',
  name: '9%'
}, {
  value: '10',
  name: '10%'
}, {
  value: '13',
  name: '13%'
}, {
  value: '16',
  name: '16%'
}];
var goodsList = [{
  value: 1,
  name: '散称'
}, {
  value: 2,
  name: 'PCS'
}];
var logistics = [{
  value: 1,
  name: '直送'
}, {
  value: 2,
  name: '配送'
}, {
  value: 3,
  name: '直通'
}];
var modeMapper = {
  1: '经销',
  2: '代销',
  3: '联营',
  8: 'POP'
};
var supplyJson = [{
  type: 'COMMON_INPUT',
  label: '供应商查询',
  placeholder: '请输入供应商编码/名称',
  field: 'codeOrName',
  width: '',
  initialValue: ''
}, {
  type: 'COMMON_TYPE_SELECT',
  label: '经营方式',
  placeholder: '请选择经营方式',
  field: 'runMode',
  width: '',
  initialValue: null,
  list: [{
    name: '全部',
    value: null
  }, {
    name: '经销',
    value: 1
  }, {
    name: '代销',
    value: 2
  }, {
    name: '联营',
    value: 3
  }, {
    name: 'POP',
    value: 8
  }]
}];
var salesJson = [{
  type: 'COMMON_INPUT',
  label: '销售地点编码',
  placeholder: '请输入销售地点编码',
  field: 'siteCode',
  width: '',
  initialValue: ''
}, {
  type: 'COMMON_INPUT',
  label: '销售地点名称',
  placeholder: '请选择销售地点名称',
  field: 'siteName',
  width: '',
  initialValue: 0
}];
var unitList = [{
  name: 'kg',
  value: 'kg'
}, {
  name: '包',
  value: '包'
}, {
  name: '瓶',
  value: '瓶'
}, {
  name: '袋',
  value: '袋'
}, {
  name: '盒',
  value: '盒'
}, {
  name: '箱',
  value: '箱'
}, {
  name: '件',
  value: '件'
}, {
  name: '支',
  value: '支'
}, {
  name: '罐',
  value: '罐'
}, {
  name: '条',
  value: '条'
}, {
  name: '份',
  value: '份'
}, {
  name: '桶',
  value: '桶'
}, {
  name: '杯',
  value: '杯'
}, {
  name: '只',
  value: '只'
}, {
  name: '盆',
  value: '盆'
}, {
  name: '把',
  value: '把'
}, {
  name: '双',
  value: '双'
}, {
  name: '提',
  value: '提'
}, {
  name: '套',
  value: '套'
}, {
  name: '根',
  value: '根'
}, {
  name: '块',
  value: '块'
}, {
  name: '排',
  value: '排'
}, {
  name: '捆',
  value: '捆'
}, {
  name: '张',
  value: '张'
}, {
  name: '板',
  value: '板'
}, {
  name: '卷',
  value: '卷'
}, {
  name: '片',
  value: '片'
}, {
  name: '听',
  value: '听'
}, {
  name: '打',
  value: '打'
}, {
  name: '组',
  value: '组'
}, {
  name: '碗',
  value: '碗'
}, {
  name: '台',
  value: '台'
}, {
  name: '串',
  value: '串'
}, {
  name: '个',
  value: '个'
}, {
  name: '卡',
  value: '卡'
}, {
  name: '筒',
  value: '筒'
}, {
  name: '本',
  value: '本'
}, {
  name: '副',
  value: '副'
}, {
  name: '米',
  value: '米'
}, {
  name: '壶',
  value: '壶'
}, {
  name: '筐',
  value: '筐'
}];

/***/ }),

/***/ 67437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dR": function() { return /* binding */ modeList; },
/* harmony export */   "kG": function() { return /* binding */ defaultList; },
/* harmony export */   "VY": function() { return /* binding */ storageTypeList; },
/* harmony export */   "aj": function() { return /* binding */ siteMapper; },
/* harmony export */   "iC": function() { return /* binding */ modeMapper; }
/* harmony export */ });
var modeList = [{
  value: 1,
  name: '直送'
}, {
  value: 2,
  name: '配送'
}, {
  value: 3,
  name: '直通'
}];
var defaultList = [{
  value: 1,
  name: '是'
}, {
  value: 2,
  name: '否'
}];
var storageTypeList = [{
  value: 0,
  name: '常温'
}, {
  value: 1,
  name: '冷藏'
}, {
  value: 2,
  name: '冷冻'
}];
var siteMapper = {
  3: '门店',
  16: '配送中心'
};
var modeMapper = {
  1: '经销',
  2: '代销',
  3: '联营',
  8: 'POP'
};

/***/ }),

/***/ 86163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Context": function() { return /* binding */ Context; },
/* harmony export */   "Context2": function() { return /* binding */ Context2; },
/* harmony export */   "ContextWrapper": function() { return /* binding */ ContextWrapper; },
/* harmony export */   "OperateContext": function() { return /* binding */ OperateContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var Context = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var Context2 = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var ContextWrapper = props => {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Context.Provider, {
    value: props.value
  }, props.children);
};
var OperateContext = props => {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Context2.Provider, {
    value: props.value
  }, props.children);
};

/***/ }),

/***/ 23263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "renderOptions": function() { return /* binding */ renderOptions; },
/* harmony export */   "renderSupplyOptions": function() { return /* binding */ renderSupplyOptions; },
/* harmony export */   "renderMerchantOptions": function() { return /* binding */ renderMerchantOptions; },
/* harmony export */   "renderRadioGroup": function() { return /* binding */ renderRadioGroup; },
/* harmony export */   "validateObjFn": function() { return /* binding */ validateObjFn; },
/* harmony export */   "validateArrFn": function() { return /* binding */ validateArrFn; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2824);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8870);
/* harmony import */ var antd_es_radio_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88983);
/* harmony import */ var antd_es_radio__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55742);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34041);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);







var Option = antd_es_select__WEBPACK_IMPORTED_MODULE_3__/* .default.Option */ .Z.Option;
var renderOptions = list => {
  if (!(list !== null && list !== void 0 && list.length)) return false;
  return list.map(item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(Option, {
    value: item.value,
    key: item.value
  }, item.name));
};
var renderSupplyOptions = list => {
  if (!(list !== null && list !== void 0 && list.length)) return false;
  return list.map(item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(Option, {
    value: item.supplierCode,
    key: item.supplierCode
  }, item.supplierName));
};
var renderMerchantOptions = list => {
  if (!(list !== null && list !== void 0 && list.length)) return false;
  return list.map(item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(Option, {
    value: item.merchantId,
    key: item.merchantId
  }, item.merchantName));
};
var renderRadioGroup = list => {
  if (!list.length) return false;
  return list.map(item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_4__/* .default */ .ZP, {
    value: item.value,
    key: item.value
  }, item.name));
};
function validateObjFn(data, filter) {
  var msgs = [];

  var newData = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)({}, data);

  for (var _i = 0, _Object$entries = Object.entries(newData); _i < _Object$entries.length; _i++) {
    var _ref3 = _Object$entries[_i];

    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_ref3, 2);

    var key = _ref2[0];
    var value = _ref2[1];

    if (filter && filter !== null && filter !== void 0 && filter.length) {
      if (!filter.includes(key) && (!value || value === '')) {
        msgs.push(key);
      }
    } else {
      if (!value || value === '') {
        msgs.push(key);
      }
    }
  }

  if (msgs) {
    return msgs[0];
  }

  return false;
}
function validateArrFn(arr, filter, filterKey) {
  var _msgs;

  console.log(arr, filter, filterKey);
  if (!(arr !== null && arr !== void 0 && arr.length)) return;
  var msgs = [];
  var newArr = [...arr];
  newArr.forEach((item, index) => {
    for (var _i2 = 0, _Object$entries2 = Object.entries(item); _i2 < _Object$entries2.length; _i2++) {
      var _ref6 = _Object$entries2[_i2];

      var _ref5 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_ref6, 2);

      var key = _ref5[0];
      var value = _ref5[1];

      if (filter !== null && filter !== void 0 && filter.length && filterKey && !filter.includes(filterKey)) {
        if (!value || value === '') {
          msgs.push(key);
        }
      } else {
        if (!value || value === '') {
          msgs.push(key);
        }
      }
    }
  });
  msgs = Array.from(new Set(msgs));

  if ((_msgs = msgs) !== null && _msgs !== void 0 && _msgs.length) {
    return msgs[0];
  }

  return false;
}

/***/ }),

/***/ 9744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vo": function() { return /* reexport */ myInputNumber; },
  "qS": function() { return /* reexport */ FormItem; },
  "I$": function() { return /* reexport */ MyTitle; },
  "UI": function() { return /* reexport */ searchForm; },
  "xS": function() { return /* reexport */ components_simpleTable; }
});

// UNUSED EXPORTS: MyPopover, MyStatistic

// NAMESPACE OBJECT: ./src/pages/GoodsManage/GoodCopy/components/searchForm/Fields.tsx
var Fields_namespaceObject = {};
__webpack_require__.r(Fields_namespaceObject);
__webpack_require__.d(Fields_namespaceObject, {
  "COMMON_INPUT": function() { return COMMON_INPUT; },
  "COMMON_INPUT_NUMBER": function() { return COMMON_INPUT_NUMBER; },
  "COMMON_TYPE_SELECT": function() { return COMMON_TYPE_SELECT; },
  "DATE_RANGE": function() { return DATE_RANGE; },
  "GOODS_BRAND": function() { return GOODS_BRAND; },
  "GOODS_CATEGORY": function() { return GOODS_CATEGORY; },
  "GOODS_MERCHANT": function() { return GOODS_MERCHANT; },
  "GOODS_SHOP": function() { return GOODS_SHOP; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodCopy/components/myTitle.tsx

function MyTitle(props) {
  return /*#__PURE__*/react.createElement("div", {
    id: "content-title"
  }, /*#__PURE__*/react.createElement("span", null), props.title);
}
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodCopy/components/myItem.tsx


function FormItem(props) {
  var labelChildren = props.label;
  return /*#__PURE__*/react.createElement("div", {
    className: "my-item ".concat(props.class || '', " ").concat(props.row ? 'row' : '')
  }, /*#__PURE__*/react.createElement("div", {
    className: "".concat(props.required ? 'requeired' : '', " item-label"),
    style: {
      width: "".concat(props.span, "0%")
    }
  }, labelChildren), /*#__PURE__*/react.createElement("div", {
    className: "item-value"
  }, props.children));
}
// EXTERNAL MODULE: ./node_modules/antd/es/table/style/index.js
var style = __webpack_require__(66456);
// EXTERNAL MODULE: ./node_modules/antd/es/table/index.js + 45 modules
var table = __webpack_require__(97423);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/index.js
var message_style = __webpack_require__(34792);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(48086);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodCopy/components/simpleTable.tsx











message.default.config({
  top: 100
});

var simpleTable = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _useState = (0,react.useState)({}),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      tableData = _useState2[0],
      setTableData = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      selectedRowKeys = _useState4[0],
      setSelectedRowKeys = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      selectedRows = _useState6[0],
      setSelectedRows = _useState6[1];

  var _useState7 = (0,react.useState)({}),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      pagination = _useState8[0],
      setPagination = _useState8[1];

  var onSelectChange = (selectedKeys, selectedRows) => {
    setSelectedRowKeys(selectedKeys);
    setSelectedRows(selectedRows);
    (props === null || props === void 0 ? void 0 : props.setRowKeys) && props.setRowKeys(selectedKeys, selectedRows);
  };

  var onPageChange = (page, size) => {
    props.handlePage && props.handlePage({
      page,
      size
    });
  };

  var onShowSizeChange = (_page, size) => {
    props.handlePage && props.handlePage({
      page: 1,
      size
    });
  };

  if (ref) {
    ref.current = {
      selectedRowKeys,
      selectedRows
    };
  }

  (0,react.useEffect)(() => {
    if (props.page) {
      var obj = {
        showQuickJumper: true,
        current: props.page.page,
        total: props.page.total,
        pageSize: props.page.size,
        pageSizeOptions: ['10', '30', '50', '100'],
        onChange: onPageChange,
        showSizeChanger: true,
        onShowSizeChange: onShowSizeChange,
        showTotal: total => "\u5171".concat(total, "\u6761")
      };
      setPagination(obj);
    } else {
      setPagination(false);
    }
  }, [props.page]);
  (0,react.useEffect)(() => {
    var multiSelect = props.multiSelect,
        dataSource = props.dataSource;
    var params = {
      dataSource: props.rowKey ? dataSource : dataSource.map(i => {
        return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, i), {}, {
          edittable_: (0,lodash.uniqueId)('edittable_')
        });
      })
    };

    if (multiSelect) {
      var rowSelection = (0,objectSpread2/* default */.Z)({
        selectedRowKeys,
        onChange: onSelectChange
      }, multiSelect);

      params['rowSelection'] = rowSelection;
    }

    setTableData(params);
  }, [selectedRowKeys, props.dataSource]);

  var calculateFunc = () => {
    var _props$scrollYSize = props.scrollYSize,
        scrollYSize = _props$scrollYSize === void 0 ? 0 : _props$scrollYSize;

    if (scrollYSize) {
      return scrollYSize;
    }

    var clientHeight = document.body.clientHeight;
    var ele = document.getElementById('simple-tablePart');

    if (ele) {
      var top = ele.getBoundingClientRect().top;
      var TOP_DIST = 70; // 上边距

      var BOTTOM_DIST = 65; // 下边距

      var scrollY = clientHeight - top - TOP_DIST - BOTTOM_DIST;
      return scrollY;
    }
  };

  var scrollProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props.scroll), {}, {
    y: calculateFunc()
  }); //   console.log(props.dataSource)


  return /*#__PURE__*/react.createElement("div", {
    className: "simple-table",
    id: "simple-tablePart"
  }, /*#__PURE__*/react.createElement(table/* default */.Z, (0,esm_extends/* default */.Z)({}, tableData, {
    size: "small" // dataSource={props.dataSource}
    ,
    columns: props.columns,
    rowKey: props.rowKey ? props.rowKey : 'edittable_',
    bordered: false,
    scroll: scrollProps,
    pagination: pagination
  })));
});
/* harmony default export */ var components_simpleTable = (/*#__PURE__*/(0,react.memo)(simpleTable));
// EXTERNAL MODULE: ./node_modules/antd/es/input-number/style/index.js
var input_number_style = __webpack_require__(77883);
// EXTERNAL MODULE: ./node_modules/antd/es/input-number/index.js + 2 modules
var input_number = __webpack_require__(39635);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodCopy/components/myInputNumber.tsx






var MyInputNumber = props => {
  var placeholder = props.placeholder,
      index = props.index,
      dataKey = props.dataKey,
      value = props.value,
      max = props.max,
      min = props.min,
      addonBefore = props.addonBefore,
      addonAfter = props.addonAfter,
      disabled = props.disabled;
  return /*#__PURE__*/react.createElement("div", {
    id: "my-input-number"
  }, addonBefore ? /*#__PURE__*/react.createElement("span", {
    className: "addon"
  }, addonBefore) : null, /*#__PURE__*/react.createElement(input_number/* default */.Z, (0,esm_extends/* default */.Z)({
    value: value,
    disabled: disabled,
    onChange: e => props.onChange(e, index, dataKey),
    placeholder: placeholder,
    min: min,
    max: max,
    precision: 2,
    className: "".concat(addonBefore ? 'addon-before' : '', " ").concat(addonAfter ? 'addon-after' : '')
  }, props)), addonAfter ? /*#__PURE__*/react.createElement("span", {
    className: "addon2"
  }, addonAfter) : null);
};

/* harmony default export */ var myInputNumber = (MyInputNumber);
// EXTERNAL MODULE: ./node_modules/antd/es/col/style/index.js
var col_style = __webpack_require__(89032);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/row/style/index.js
var row_style = __webpack_require__(13062);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var button_style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./src/pages/GoodsManage/GoodCopy/Api/index.ts
var Api = __webpack_require__(17514);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodCopy/components/searchForm/hooks.tsx


function useEventListener(eventName, handler) {
  var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;
  var saveHandler = useRef();
  useEffect(() => {
    saveHandler.current = handler;
  }, [handler]);
  useEffect(() => {
    var isSupported = element && element.addEventListener;
    if (!isSupported) return;

    var eventListener = event => saveHandler.current(event);

    element.addEventListener(eventName, e => {
      var event = null;

      if (window.event) {
        event = window.event;
      }

      var code = e.charCode || event.keyCode;

      if (code === 13) {
        eventListener(e);
      }
    });
    return () => {
      element.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element]);
} // 展开收起按钮hooks

var formfieldsLen = 8;
function useSliderBtn() {
  var formfields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : formfieldsLen;
  var usefulFields = (0,react.useMemo)(() => formfields.filter(Boolean), [formfields]);

  var _useState = (0,react.useState)(true),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      slideForm = _useState2[0],
      setSlideForm = _useState2[1];

  var _useState3 = (0,react.useState)(usefulFields),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      fields = _useState4[0],
      setFields = _useState4[1];

  var num = number || formfieldsLen; // 如果不传参，则默认收起时展示4个表单项

  var toggleForm = () => setSlideForm(v => !v);

  (0,react.useEffect)(() => {
    if (slideForm) {
      var list = usefulFields.slice(0, num - 1);
      setFields(list);
    } else {
      setFields(usefulFields);
    }
  }, [slideForm, usefulFields, num]); // 如果表单项比较小

  if (usefulFields.length < formfieldsLen) {
    return [fields, null];
  }

  return [fields, /*#__PURE__*/react.createElement("a", {
    key: "btn",
    style: {
      minWidth: '30px'
    },
    onClick: toggleForm
  }, slideForm ? '展开' : '收起')];
}
// EXTERNAL MODULE: ./node_modules/antd/es/input/style/index.js
var input_style = __webpack_require__(47673);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 3 modules
var input = __webpack_require__(4107);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/style/index.js
var date_picker_style = __webpack_require__(14965);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/index.js + 6 modules
var date_picker = __webpack_require__(11448);
// EXTERNAL MODULE: ./node_modules/antd/es/select/style/index.js
var select_style = __webpack_require__(43358);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js
var es_select = __webpack_require__(34041);
// EXTERNAL MODULE: ./src/pages/GoodsManage/GoodCopy/components/searchForm/searchSelect/index.ts + 4 modules
var searchSelect = __webpack_require__(52933);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodCopy/components/searchForm/Fields.tsx











var Option = es_select/* default.Option */.Z.Option;
var RangePicker = date_picker/* default.RangePicker */.Z.RangePicker;
var COMMON_INPUT = _ref => {
  var field = _ref.field,
      value = _ref.value,
      placeholder = _ref.placeholder,
      _onChange = _ref.onChange,
      initialValue = _ref.initialValue;
  return /*#__PURE__*/react.createElement(input/* default */.Z, {
    type: "text",
    placeholder: placeholder,
    value: value ? value : initialValue || null,
    onChange: e => _onChange(e, field)
  });
};
var COMMON_INPUT_NUMBER = _ref2 => {
  var field = _ref2.field,
      value = _ref2.value,
      placeholder = _ref2.placeholder,
      _onChange2 = _ref2.onChange;
  return /*#__PURE__*/react.createElement(input_number/* default */.Z, {
    placeholder: placeholder,
    value: value ? value : null,
    onChange: e => _onChange2(e, field)
  });
};
var COMMON_TYPE_SELECT = _ref3 => {
  var field = _ref3.field,
      value = _ref3.value,
      placeholder = _ref3.placeholder,
      _onChange3 = _ref3.onChange,
      initialValue = _ref3.initialValue,
      fieldOptions = _ref3.fieldOptions,
      list = _ref3.list;
  return /*#__PURE__*/react.createElement(es_select/* default */.Z, (0,esm_extends/* default */.Z)({
    showSearch: true,
    placeholder: placeholder,
    value: value ? value : initialValue || initialValue === null ? initialValue : undefined,
    filterOption: (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
    onChange: e => _onChange3(e, field)
  }, fieldOptions), list.length && list.map(i => {
    return /*#__PURE__*/react.createElement(Option, {
      value: i.value,
      key: i.value
    }, i.name);
  }));
};
var GOODS_MERCHANT = _ref4 => {
  var field = _ref4.field,
      value = _ref4.value,
      setMerchantList = _ref4.setMerchantList,
      defaultMerchant = _ref4.defaultMerchant,
      placeholder = _ref4.placeholder,
      _onChange4 = _ref4.onChange;
  return /*#__PURE__*/react.createElement(searchSelect/* MerchantSearch */.cO, {
    placeholder: placeholder,
    setMerchantList: setMerchantList,
    onChange: e => _onChange4(e, field),
    defaultMerchant: defaultMerchant,
    value: value
  });
};
var GOODS_CATEGORY = _ref5 => {
  var field = _ref5.field,
      apis = _ref5.apis,
      value = _ref5.value,
      onChange = _ref5.onChange;
  return /*#__PURE__*/react.createElement(searchSelect/* MyTreeSelect */.lO, {
    api: apis,
    setCategoryId: e => onChange(e, field),
    categoryId: value ? value : undefined
  });
};
var GOODS_SHOP = _ref6 => {
  var field = _ref6.field,
      value = _ref6.value,
      merchantId = _ref6.merchantId,
      placeholder = _ref6.placeholder,
      _onChange5 = _ref6.onChange,
      setShopList = _ref6.setShopList;
  return /*#__PURE__*/react.createElement(searchSelect/* ShopSearch */.zD, {
    placeholder: placeholder,
    value: value ? value : undefined,
    setShopList: setShopList,
    onChange: e => _onChange5(e, field),
    merchantId: merchantId
  });
};
var GOODS_BRAND = _ref7 => {
  var field = _ref7.field,
      value = _ref7.value,
      placeholder = _ref7.placeholder,
      _onChange6 = _ref7.onChange,
      initialValue = _ref7.initialValue;
  return /*#__PURE__*/react.createElement(searchSelect/* BrandSearch */.hP, {
    placeholder: placeholder,
    value: value ? value : initialValue.length ? initialValue : undefined,
    onChange: e => _onChange6(e, field)
  });
};
var DATE_RANGE = _ref8 => {
  var field = _ref8.field,
      value = _ref8.value,
      placeholder = _ref8.placeholder,
      _onChange7 = _ref8.onChange,
      initialValue = _ref8.initialValue,
      disabledDate = _ref8.disabledDate,
      format = _ref8.format,
      showTime = _ref8.showTime;
  return /*#__PURE__*/react.createElement(RangePicker, {
    placeholder: placeholder,
    value: value || initialValue,
    showTime: showTime || false,
    onChange: e => _onChange7(e, field),
    style: {
      width: '100%'
    }
  });
};
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodCopy/components/searchForm/index.tsx
















var Fields = Fields_namespaceObject;
var SearchForm = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var searchStorage = props.storageKey || 'searchStorage';

  var _useSliderBtn = useSliderBtn(props.formJson),
      _useSliderBtn2 = (0,slicedToArray/* default */.Z)(_useSliderBtn, 2),
      formfields = _useSliderBtn2[0],
      btnElement = _useSliderBtn2[1];

  var _useState = (0,react.useState)({}),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      formParams = _useState2[0],
      setFormParams = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      merchantList = _useState4[0],
      setMerchantList = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      shopList = _useState6[0],
      setShopList = _useState6[1];

  var renderBtn = () => {
    if (!(formfields !== null && formfields !== void 0 && formfields.length)) return null;
    var len = formfields === null || formfields === void 0 ? void 0 : formfields.length;
    var remainder = len % 4;
    var span = remainder === 0 ? 24 : (4 - remainder) * 6;
    return /*#__PURE__*/react.createElement(col/* default */.Z, {
      span: span,
      key: "btns",
      className: "search-btns"
    }, /*#__PURE__*/react.createElement(row/* default */.Z, {
      className: "rowItem"
    }, /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      type: "primary",
      id: "search-btn",
      onClick: handleSubmit,
      htmlType: "submit"
    }, "\u67E5\u8BE2"), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      onClick: reset
    }, "\u91CD\u7F6E"), btnElement));
  };

  var renderItem = (item, child) => {
    var label = item.label,
        field = item.field;
    return /*#__PURE__*/react.createElement(col/* default */.Z, {
      span: 6,
      key: field
    }, /*#__PURE__*/react.createElement(row/* default */.Z, {
      className: "rowItem"
    }, /*#__PURE__*/react.createElement(col/* default */.Z, {
      span: 6,
      className: "itemLabel"
    }, label), /*#__PURE__*/react.createElement(col/* default */.Z, {
      span: 18,
      className: "itemValue"
    }, child)));
  };

  var onChange = (e, key, validateMsg, args) => {
    var value = e && e.target ? e.target.value : e;

    if (validateMsg && !value) {
      message.default.info(validateMsg);

      return false;
    }

    var obj = (0,objectSpread2/* default */.Z)({}, formParams);

    if (key === 'merchantId') {
      obj[key] = value;
      obj['shopId'] = '';
    } else if (key === 'goodsId') {
      var data = '';

      if (Array.isArray(value)) {
        data = value.join(' ');
      } else data = value !== null && value !== void 0 && value.length ? value : [];

      obj[key] = data;
    } else {
      obj[key] = value;
    }

    setFormParams(obj);
  };

  var handleSubmit = () => {
    // e && e.preventDefault();
    var params = (0,objectSpread2/* default */.Z)({}, formParams);

    if (props.needStorage) sessionStorage.setItem(searchStorage, JSON.stringify(params));
    setFormParams(params);
    props.handleSearch(params);
  };

  var reset = () => {
    var fieldsValue = (0,objectSpread2/* default */.Z)({}, formParams);

    for (var i in fieldsValue) {
      if (['createTime'].includes(i)) {
        fieldsValue[i].length = 0;
      }

      fieldsValue[i] = null;
    }

    if (props.needStorage) {
      sessionStorage.setItem(searchStorage, '{}');
    }

    setFormParams(fieldsValue);
    props.resetSearch(fieldsValue);
  };

  var handleMerchant = list => {
    setMerchantList(list);
  };

  var handleShop = list => {
    setShopList(list);
  };
  /**
   * 渲染searchForm
   */


  var renderElement = (0,react.useCallback)(item => {
    if (!Fields[item.type]) return null;

    var options = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, item), {}, {
      value: formParams[item.field],
      onChange: onChange
    });

    if (item.type === 'GOODS_MERCHANT') {
      options = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, options), {}, {
        setMerchantList: handleMerchant
      });
    } else if (item.type === 'GOODS_SHOP') {
      options = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, options), {}, {
        merchantId: formParams['merchantId'],
        setShopList: handleShop,
        multiple: props.multiShop ? true : false
      });
    } else if (['GOODS_CATEGORY', 'CATEGORY_TREE'].includes(item.type)) {
      options = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, options), {}, {
        apis: Api/* masterApi.getBackCategoryTree */.ZH.getBackCategoryTree
      });
    } else if (item.type === 'DATE_RANGE') {
      options = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, options), {}, {
        value: undefined
      });
    }

    var child = Fields[item.type](options);
    return renderItem(item, child);
  }, [formParams, merchantList]);
  /**
   * 设置默认商家
   */

  var defaultMerchant = (0,react.useCallback)(() => {
    if (!(merchantList !== null && merchantList !== void 0 && merchantList.length)) return;
    if (!props.needDefaultMerchant) return;
    var ids = merchantList.map(i => i.merchantId);
    var _formParams$merchantI = formParams.merchantId,
        merchantId = _formParams$merchantI === void 0 ? null : _formParams$merchantI;

    if (!merchantId) {
      setFormParams((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formParams), {}, {
        merchantId: ids[0] // 没有merchantId默认选第一个

      }));
    }
  }, [formParams, merchantList]);
  var defaultShop = (0,react.useCallback)(() => {
    if (!(merchantList !== null && merchantList !== void 0 && merchantList.length)) return;
    if (!props.needDefaultShop) return;
    var _formParams$merchantI2 = formParams.merchantId,
        merchantId = _formParams$merchantI2 === void 0 ? null : _formParams$merchantI2;

    if (merchantId && shopList !== null && shopList !== void 0 && shopList.length) {
      // 是否需要默认选营业部
      var list = shopList.length ? shopList.map(i => i.siteId) : [];
      setFormParams((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formParams), {}, {
        shopId: list[0]
      }));
    }
  }, [formParams, shopList]);

  if (ref) {
    ref.current = {
      resetFields: reset
    };
  }

  (0,react.useEffect)(() => {
    var sessionSearch = sessionStorage.getItem(searchStorage);
    var params = JSON.parse(sessionSearch) || {};

    if (!(0,lodash.isEmpty)(params)) {
      setFormParams(params);
    }
  }, [props.needStorage]); // useEffect(() => {
  //   if (merchantList?.length) {
  //     defaultMerchant();
  //     props.setMerchantList && props.setMerchantList(merchantList);
  //   }
  // }, [merchantList]);
  // useEffect(() => {
  //   if (shopList?.length) {
  //     props.needDefaultShop && defaultShop();
  //     props.setShopList && props.setShopList(shopList);
  //   }
  // }, [shopList, props.needDefaultShop]);

  (0,react.useEffect)(() => {
    if (!(0,lodash.isEmpty)(formParams)) {
      var _formParams$shopIds = formParams.shopIds,
          shopIds = _formParams$shopIds === void 0 ? [] : _formParams$shopIds,
          merchantId = formParams.merchantId,
          shopId = formParams.shopId;

      if (formParams.hasOwnProperty('merchantId')) {
        var item = merchantList.filter(i => i.merchantId === merchantId)[0] || {};
        props.setMerchant && props.setMerchant(item, formParams);
        props.setShop && props.setShop(item, props.multiShop ? shopIds : shopId, formParams);
      }
    }
  }, [formParams, merchantList]);
  return /*#__PURE__*/react.createElement("div", {
    id: "serachFrom",
    key: searchStorage
  }, /*#__PURE__*/react.createElement(row/* default */.Z, {
    className: "search-row"
  }, formfields.map(renderElement), renderBtn()));
});
/* harmony default export */ var searchForm = (/*#__PURE__*/(0,react.memo)(SearchForm));
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodCopy/components/myStatistic.tsx


function MyStatistic(props) {
  return /*#__PURE__*/React.createElement("div", {
    id: "my-statistic"
  }, /*#__PURE__*/React.createElement("div", {
    className: "unusual"
  }, /*#__PURE__*/React.createElement(ExclamationCircleFilled, {
    style: {
      color: '#F7BB24',
      marginRight: '10px'
    }
  }), props.text ? props.text : null, props.child ? props.child() : null));
}
// EXTERNAL MODULE: ./node_modules/antd/es/popover/style/index.js
var popover_style = __webpack_require__(20136);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodCopy/components/myPopover.tsx





var Tips = props => {
  var _props$list, _props$list2, _props$list3;

  var _content = () => {
    var list = Array.from(new Set(props.list));
    if (!(list !== null && list !== void 0 && list.length)) return false;
    return /*#__PURE__*/React.createElement("div", {
      className: "tips-wrap"
    }, /*#__PURE__*/React.createElement("ul", null, list.map((i, k) => /*#__PURE__*/React.createElement("li", {
      key: k + 1
    }, i))));
  };

  var ele = props !== null && props !== void 0 && (_props$list = props.list) !== null && _props$list !== void 0 && _props$list.length ? props.list[0] : '';
  return /*#__PURE__*/React.createElement("div", {
    className: "tips"
  }, /*#__PURE__*/React.createElement("span", null, ele), props !== null && props !== void 0 && (_props$list2 = props.list) !== null && _props$list2 !== void 0 && _props$list2.length ? /*#__PURE__*/React.createElement(_Popover, {
    content: () => _content(),
    title: "\u5546\u54C1\u6761\u7801"
  }, (props === null || props === void 0 ? void 0 : (_props$list3 = props.list) === null || _props$list3 === void 0 ? void 0 : _props$list3.length) > 1 ? /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#1890ff',
      cursor: 'pointer'
    }
  }, "\u66F4\u591A") : undefined) : null);
};

/* harmony default export */ var myPopover = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(Tips))));
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodCopy/components/index.ts









/***/ }),

/***/ 350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wY": function() { return /* binding */ Multiply; },
/* harmony export */   "p3": function() { return /* binding */ Divide; },
/* harmony export */   "ZR": function() { return /* binding */ limitDecimalsNum; },
/* harmony export */   "ed": function() { return /* binding */ limitDecimalsThree; },
/* harmony export */   "Xe": function() { return /* binding */ limitLength; }
/* harmony export */ });
/* unused harmony exports Add, Subtract, decimalFixed, limitDecimals, limitDecimalsLength, limitNum, limitOneDecimals */
// 加法函数
var Add = (arg1, arg2) => {
  var r1;
  var r2;
  var m;
  var c;

  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }

  ;

  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }

  ;
  c = Math.abs(r1 - r2);
  m = Math.pow(10, Math.max(r1, r2));

  if (c > 0) {
    var cm = Math.pow(10, c);

    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace(".", ""));
      arg2 = Number(arg2.toString().replace(".", "")) * cm;
    } else {
      arg1 = Number(arg1.toString().replace(".", "")) * cm;
      arg2 = Number(arg2.toString().replace(".", ""));
    }
  } else {
    arg1 = Number(arg1.toString().replace(".", ""));
    arg2 = Number(arg2.toString().replace(".", ""));
  }

  return (arg1 + arg2) / m;
}; // 减法函数

var Subtract = (arg1, arg2) => {
  var r1 = 0;
  var r2 = 0;
  var m;

  try {
    r1 = String(arg1).split('.')[1].length;
  } catch (e) {}

  try {
    r2 = String(arg2).split('.')[1].length;
  } catch (e) {}

  m = Math.pow(10, Math.max(r1, r2));
  arg1 = Number(arg1) * m;
  arg2 = Number(arg2) * m;
  return (arg1 - arg2) / m;
}; // 乘法函数

var Multiply = (arg1, arg2) => {
  var m = 0;
  var s1 = String(arg1);
  var s2 = String(arg2);

  try {
    m += s1.split('.')[1].length;
  } catch (e) {}

  try {
    m += s2.split('.')[1].length;
  } catch (e) {}

  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
}; // 除法函数

var Divide = (num1, num2) => {
  var baseNum1 = 0;
  var baseNum2 = 0;
  var baseNum3;
  var baseNum4;

  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }

  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }

  baseNum3 = Number(String(num1).replace(".", ""));
  baseNum4 = Number(String(num2).replace(".", ""));
  return baseNum3 / baseNum4 * Math.pow(10, baseNum2 - baseNum1);
};
/**
 * 判断小数点后几位
 * @param {判断的数值} number 
 */

var decimalFixed = number => {
  if (!number) return;
  var num = Number(number);
  var str = String(number);
  if (num === 0) return 0;
  if (str.indexOf('.') === -1) return 0;
  return str.split('.')[1].length;
};
/**
 * 限制小数点后两位输入
 * @param {*} value 
 */

var limitDecimals = (value, len) => {
  var reg = /^(\-)*(\d+)\.(\d\d).*$/;

  if (typeof value === 'string') {
    if (String(value).length > len) {
      return value.replace(reg, '$1$2.$3').slice(0, len);
    } else {
      return !isNaN(Number(value)) ? value.slice(0, len).replace(reg, '$1$2.$3') : '';
    }
  } else if (typeof value === 'number') {
    if (String(value).length > len) {
      return Number(String(value).replace(reg, '$1$2.$3').slice(0, len));
    } else {
      return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : '';
    }
  } else {
    return '';
  }
};
/**
 * 限制小数2位 大小
 * @param value 
 * @param len 
 */

var limitDecimalsNum = (value, num) => {
  var reg = /^(\-)*(\d+)\.(\d\d).*$/;

  if (typeof value === 'string') {
    if (!isNaN(Number(value))) {
      return Number(value) > num ? num : value.replace(reg, '$1$2.$3');
    } else {
      return !isNaN(parseFloat(value)) ? String(parseFloat(value)).replace(reg, '$1$2.$3') : '';
    }
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : '';
  } else {
    return '';
  }
};
/**
 * 限制小数点后三位输入
 * @param {*} value 
 */

var limitDecimalsThree = (value, num) => {
  var reg = /^(\-)*(\d+)\.(\d\d\d).*$/;

  if (typeof value === 'string') {
    return Number(value) > num ? String(num) : value.replace(reg, '$1$2.$3');
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : '';
  } else {
    return '';
  }
};
/**
 * 限制正数 长度
 * @param value 
 * @param len 
 */

var limitDecimalsLength = (value, len) => {
  var reg = /^(\-)*(\d+)\.(\d\d).*$/;

  if (typeof value === 'string') {
    if (!isNaN(Number(value))) {
      return String(value).length > len ? String(parseFloat(value)).slice(0, len).replace(reg, '$1$2.$3') : value.replace(reg, '$1$2.$3');
    } else {
      return !isNaN(parseFloat(value)) ? String(parseFloat(value)).replace(reg, '$1$2.$3') : '';
    }
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : '';
  } else {
    return '';
  }
};
/**
 * 限制正整数 长度:
 * @param {*} value 
 */

var limitLength = (value, len) => {
  var reg = /[^\-?\d]/g;

  if (typeof value === 'string') {
    if (!isNaN(Number(value))) {
      return String(value).length > len ? String(parseFloat(value)).slice(0, len).replace(reg, '') : value.replace(reg, '');
    } else {
      return !isNaN(parseFloat(value)) ? String(parseFloat(value)).replace(reg, '') : '';
    }
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '') : '';
  } else {
    return '';
  }
};
/**
 * 限制整数
 * @param {*} value 
 */

var limitNum = (value, num) => {
  var reg = /[^\-?\d]/g;

  if (typeof value === 'string') {
    if (!isNaN(Number(value))) {
      return num ? Number(value) > num ? num : value.replace(reg, '') : value;
    } else {
      return !isNaN(parseFloat(value)) ? String(parseFloat(value)).replace(reg, '') : '';
    }
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '') : '';
  } else {
    return '';
  }
};
/**
 * 限制小数点后一位輸入
 * @param {*} value 
 */

var limitOneDecimals = (value, num) => {
  // if (value === '') return ''
  var reg = /^(\-)*(\d+)\.(\d).*$/;

  if (typeof value === 'string') {
    if (!isNaN(Number(value))) {
      return Number(value) > num ? num : value.replace(reg, '$1$2.$3');
    } else {
      return !isNaN(parseFloat(value)) ? String(parseFloat(value)).replace(reg, '$1$2.$3') : '';
    }
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : '';
  } else {
    return '';
  }
};

/***/ }),

/***/ 52933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hP": function() { return /* reexport */ brandSearch; },
  "cO": function() { return /* reexport */ merchantSearch; },
  "lO": function() { return /* reexport */ myTreeSelect; },
  "zD": function() { return /* reexport */ shopSearch; }
});

// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/antd/es/select/style/index.js
var style = __webpack_require__(43358);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js
var es_select = __webpack_require__(34041);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/pages/GoodsManage/GoodCopy/Api/index.ts
var Api = __webpack_require__(17514);
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodCopy/components/searchForm/searchSelect/brandSearch.tsx










var Option = es_select/* default.Option */.Z.Option;

function useSearch(search) {
  var debounceRef = (0,react.useRef)();

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      brandList = _useState2[0],
      setBrand = _useState2[1];

  (0,react.useEffect)(() => {
    if (debounceRef.current) {
      if (search) {
        debounceRef.current(search);
      }
    } else {
      debounceRef.current = (0,lodash.debounce)( /*#__PURE__*/function () {
        var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(search) {
          var url, params, res, result, success;
          return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  url = Api/* apiList.fuzzyQueryBrandByName */.X9.fuzzyQueryBrandByName;
                  params = {
                    brandName: search
                  };
                  _context.prev = 2;
                  _context.next = 5;
                  return (0,ypRequest/* default */.Z)(url, params);

                case 5:
                  res = _context.sent;
                  result = res.result, success = res.success;

                  if (success) {
                    setBrand(result);
                  }

                  _context.next = 13;
                  break;

                case 10:
                  _context.prev = 10;
                  _context.t0 = _context["catch"](2);
                  console.log(_context.t0);

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 10]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }(), 300);
    }
  }, [search]);
  return [brandList, setBrand];
}

var BrandSearch = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _useState3 = (0,react.useState)(''),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      search = _useState4[0],
      setSearch = _useState4[1];

  var _useSearch = useSearch(search),
      _useSearch2 = (0,slicedToArray/* default */.Z)(_useSearch, 1),
      brandList = _useSearch2[0];

  return /*#__PURE__*/react.createElement(es_select/* default */.Z, (0,esm_extends/* default */.Z)({
    allowClear: true,
    defaultActiveFirstOption: false,
    filterOption: false,
    showSearch: true,
    onSearch: val => setSearch(val)
  }, props), brandList.map(item => /*#__PURE__*/react.createElement(Option, {
    key: item.brandId,
    value: item.brandId || undefined
  }, item.brandName)));
});
/* harmony default export */ var brandSearch = (BrandSearch);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodCopy/components/searchForm/searchSelect/merchantSearch.tsx










var merchantSearch_Option = es_select/* default.Option */.Z.Option;
var MerchantSearch = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      merchantList = _useState2[0],
      setMerchantList = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      merchantId = _useState4[0],
      setMerchantId = _useState4[1];

  var queryMerchant = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
      var url, params, _yield$ypRider, result, success, data, list;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // const url = masterApi.queryYpShengXianMerchant
              url = Api/* apiList.queryUserMerchantList */.X9.queryUserMerchantList;
              params = {
                tenantId: 1,
                phone: js_cookie_default().get('mobile')
              };
              _context.prev = 2;
              _context.next = 5;
              return (0,ypRequest/* default */.Z)(url, params);

            case 5:
              _yield$ypRider = _context.sent;
              result = _yield$ypRider.result;
              success = _yield$ypRider.success;

              if (success) {
                data = result === null || result === void 0 ? void 0 : result.list.filter(ele => !ele.switchSx);
                list = data.map(item => {
                  return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, item), item.merchantInfo);
                });
                setMerchantList(list);
                props.setMerchantList && props.setMerchantList(list);
              }

              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              console.log(_context.t0);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 11]]);
    }));

    return function queryMerchant() {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(() => {
    if (!merchantList.length) queryMerchant();
  }, []);
  return /*#__PURE__*/react.createElement(es_select/* default */.Z, {
    allowClear: true,
    defaultActiveFirstOption: false,
    showSearch: true,
    filterOption: (input, option) => {
      var _option$children, _option$children$toLo;

      return (option === null || option === void 0 ? void 0 : (_option$children = option.children) === null || _option$children === void 0 ? void 0 : (_option$children$toLo = _option$children.toLowerCase()) === null || _option$children$toLo === void 0 ? void 0 : _option$children$toLo.indexOf(input === null || input === void 0 ? void 0 : input.toLowerCase())) >= 0;
    },
    value: props.value,
    onChange: props.onChange,
    placeholder: props.placeholder // {...props}

  }, merchantList.map(item => /*#__PURE__*/react.createElement(merchantSearch_Option, {
    key: item.merchantId,
    value: item.merchantId || undefined
  }, item.merchantName)));
});
/* harmony default export */ var merchantSearch = (MerchantSearch);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodCopy/components/searchForm/searchSelect/shopSearch.tsx








var shopSearch_Option = es_select/* default.Option */.Z.Option;
var ShopSearch = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      shopList = _useState2[0],
      setShopList = _useState2[1];

  var queryShop = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(merchantId) {
      var url, params, _yield$ypRider, result, success, list;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = Api/* salesApi.querySiteInfoByCodeOrName */.Ct.querySiteInfoByCodeOrName;
              params = {
                merchantId,
                siteCode: '',
                siteName: '',
                page: 1
              };
              _context.prev = 2;
              _context.next = 5;
              return (0,ypRequest/* default */.Z)(url, params);

            case 5:
              _yield$ypRider = _context.sent;
              result = _yield$ypRider.result;
              success = _yield$ypRider.success;

              if (success) {
                list = result.list; // if (props?.clearDefault) {
                //   shops.shift();
                // }

                setShopList(list);
                props.setShopList && props.setShopList(list);
              }

              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              console.log(_context.t0);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 11]]);
    }));

    return function queryShop(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(() => {
    var _props$merchantId;

    if (props !== null && props !== void 0 && (_props$merchantId = props.merchantId) !== null && _props$merchantId !== void 0 && _props$merchantId.length) {
      queryShop(props.merchantId);
    } else {
      setShopList([]);
    }
  }, [props.merchantId]);
  return /*#__PURE__*/react.createElement(es_select/* default */.Z, {
    allowClear: true,
    defaultActiveFirstOption: false,
    showSearch: true,
    filterOption: (input, option) => {
      var _option$children, _option$children$toLo;

      return (option === null || option === void 0 ? void 0 : (_option$children = option.children) === null || _option$children === void 0 ? void 0 : (_option$children$toLo = _option$children.toLowerCase()) === null || _option$children$toLo === void 0 ? void 0 : _option$children$toLo.indexOf(input === null || input === void 0 ? void 0 : input.toLowerCase())) >= 0;
    },
    value: props.value || null,
    onChange: props.onChange,
    placeholder: props.placeholder
  }, (shopList === null || shopList === void 0 ? void 0 : shopList.length) && shopList.map(item => /*#__PURE__*/react.createElement(shopSearch_Option, {
    key: item.siteId,
    value: item.siteId
  }, item.siteName)));
});
/* harmony default export */ var shopSearch = (ShopSearch);
// EXTERNAL MODULE: ./node_modules/antd/es/tree-select/style/index.js
var tree_select_style = __webpack_require__(62999);
// EXTERNAL MODULE: ./node_modules/antd/es/tree-select/index.js + 40 modules
var tree_select = __webpack_require__(57119);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodCopy/components/searchForm/searchSelect/myTreeSelect.tsx







var TreeNode = tree_select/* default.TreeNode */.Z.TreeNode;
var MyTreeSelect = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      treeData = _useState2[0],
      setTreeData = _useState2[1];

  (0,react.useEffect)(() => {
    getTreeData();
  }, []);

  var getTreeData = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
      var url, params, res, result, success, _result$childBackCate, childBackCategory;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = props.api;
              params = {};
              _context.prev = 2;
              _context.next = 5;
              return (0,ypRequest/* default */.Z)(url, params);

            case 5:
              res = _context.sent;
              result = res.result, success = res.success;

              if (success) {
                _result$childBackCate = result.childBackCategory, childBackCategory = _result$childBackCate === void 0 ? [] : _result$childBackCate;
                setTreeData(childBackCategory);
              }

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              console.log(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 10]]);
    }));

    return function getTreeData() {
      return _ref.apply(this, arguments);
    };
  }();

  var renderTreeNode = treeData => {
    if (!treeData) return;
    return treeData.map((item, key) => {
      if (item.childBackCategory) {
        return /*#__PURE__*/react.createElement(TreeNode, {
          value: item.backCategoryId,
          title: item.backCategoryName,
          key: item.backCategoryId
        }, renderTreeNode(item.childBackCategory));
      } else {
        return /*#__PURE__*/react.createElement(TreeNode, {
          value: item.backCategoryId,
          title: item.backCategoryName,
          key: item.backCategoryId
        });
      }
    });
  };

  var onTreeChange = e => {
    props.setCategoryId(e);
  };

  return /*#__PURE__*/react.createElement("div", {
    id: "my-tree-select"
  }, /*#__PURE__*/react.createElement(tree_select/* default */.Z, {
    treeDataSimpleMode: true,
    style: {
      width: '100%'
    },
    value: props.categoryId || undefined,
    dropdownStyle: {
      maxHeight: 400,
      overflow: 'auto'
    },
    placeholder: "\u8BF7\u9009\u62E9\u5546\u54C1\u7C7B\u76EE",
    onChange: onTreeChange
  }, renderTreeNode(treeData)));
});
/* harmony default export */ var myTreeSelect = (MyTreeSelect);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodCopy/components/searchForm/searchSelect/index.ts






/***/ }),

/***/ 82682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZH": function() { return /* binding */ masterApi; },
/* harmony export */   "cE": function() { return /* binding */ gradingApi; },
/* harmony export */   "Ct": function() { return /* binding */ salesApi; },
/* harmony export */   "X9": function() { return /* binding */ apiList; },
/* harmony export */   "A0": function() { return /* binding */ sgApi; }
/* harmony export */ });
/**
 * API集合
 */
var masterApi = {
  querySgMerchantItemList: 'pms.sgMerchantItemManageService.querySgMerchantItemList',
  // 获取商家商品列表
  getBackCategoryTree: 'pms.backCategoryManage.getBackCategoryTree',
  // 获取后台类目树
  queryProductDetail: 'pms.productManageService.queryProductDetail',
  // 基础资料详情
  createProduct: 'pms.productManageService.createProduct',
  // 创建基础资料
  updateProduct: 'pms.productManageService.updateProduct',
  // 更新基础资料
  queryYpShengXianMerchant: 'pms.pmsMerchantService.queryYpShengXianMerchant',
  // 查询生鲜商户列表
  queryMerchantList: 'pms.merchantItemManage.queryMerchantList',
  // 查询商户权限
  downloadSgMerchantItem: 'pms.sgMerchantItemManageService.downloadSgMerchantItem',
  // 导出商家商品
  downloadSgShopItem: 'pms.ShopItemManageService.exportSgShopItemList',
  // 导出门店商品
  queryTaskList: 'pms.taskManageService.queryTaskList',
  // 异步导出查询列表
  exportSiteGoodsPurchaseInfo: 'pms.sgMerchantItemManageService.exportSiteGoodsPurchaseInfo' // 导出门店采购信息

};
var gradingApi = {
  queryProductManageInfo: 'pms.sgMerchantItemManageService.queryProductManageInfo',
  // 获取经营信息详情
  getPluCodeList: 'pms.productManageService.getPluCodeList',
  // 新建分档，查询Plu列表
  createProductManageInfo: 'pms.productManageService.createProductManageInfo',
  // 新增经营信息
  updateProductManageInfo: 'pms.sgMerchantItemManageService.updateProductManageInfo',
  // 编辑经营信息
  querySupplierByCodeOrName: 'pms.pmsPurchaseService.querySupplierByCodeOrName' // 根据编码或者名称查询供应商列表

};
var salesApi = {
  queryProductSaleInfo: 'pms.sgMerchantItemManageService.queryProductSaleInfo',
  // 获取销售信息详情
  updateProductSaleInfo: 'pms.sgMerchantItemManageService.updateProductSaleInfo',
  // 编辑销售信息
  createProductSaleInfo: 'pms.productManageService.createProductSaleInfo',
  // 新建销售信息
  querySiteInfoByCodeOrName: 'pms.pmsMerchantService.querySiteInfoByCodeOrName',
  // 根据编码或者名称查询地点列表
  queryProductSaleInfoBySiteIds: 'pms.sgMerchantItemManageService.queryProductSaleInfoBySiteIds',
  // 根据门店id查询销售信息
  queryGroupsAndWarehouseByMerchantId: 'pms.pmsMerchantService.queryGroupsAndWarehouseByMerchantId' // 查询店群和配送中心

};
var apiList = {
  category: 'item.erpCategory.queryCategoryListByHeadId',
  fuzzyQueryBrandByName: 'pms.brandManageService.fuzzyQueryBrandByName',
  queryUserMerchantList: 'kernel.console.AuthorizedDataQueryService.queryAuthorizedMerchant',
  // 查询生鲜商户权限列表
  queryUserSiteList: 'pms.pmsMerchantService.queryUserSiteList',
  // 查询生鲜门店权限列表
  queryTagList: '/pms/pms/queryItemTags' // 查询标签列表

};
var sgApi = {
  querySgMerchantItemList: 'pms.sgMerchantItemManageService.querySgMerchantItemList',
  querySgShopItemList: 'pms.ShopItemManageService.querySgShopItemSkuList',
  updateTaxRate: 'pms.sgMerchantItemManageService.batchUpdateMerchantItemSaleCostRate',
  removeSupplyRation: 'pms.sgMerchantItemManageService.removeSupplyRation',
  querySgShopItemChangeLogList: '/pms/SgShopItemManageService/querySgShopItemChangeLogList' // 查询地点商品变更日志（新网关）

};

/***/ }),

/***/ 89091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iC": function() { return /* binding */ modeMapper; },
/* harmony export */   "dc": function() { return /* binding */ supplyJson; },
/* harmony export */   "d9": function() { return /* binding */ unitList; }
/* harmony export */ });
/* unused harmony exports defaultList, typeList, taxList, goodsList, logistics, salesJson */
var defaultList = [{
  value: 1,
  name: '是'
}, {
  value: 2,
  name: '否'
}];
var typeList = [{
  value: 1,
  name: '谊品生鲜'
}];
var taxList = [{
  value: '0',
  name: '0%'
}, {
  value: '3',
  name: '3%'
}, {
  value: '5',
  name: '5%'
}, {
  value: '6',
  name: '6%'
}, {
  value: '9',
  name: '9%'
}, {
  value: '10',
  name: '10%'
}, {
  value: '13',
  name: '13%'
}, {
  value: '16',
  name: '16%'
}];
var goodsList = [{
  value: 1,
  name: '散称'
}, {
  value: 2,
  name: 'PCS'
}];
var logistics = [{
  value: 1,
  name: '直送'
}, {
  value: 2,
  name: '配送'
}, {
  value: 3,
  name: '直通'
}];
var modeMapper = {
  1: '经销',
  2: '代销',
  3: '联营',
  8: 'POP'
};
var supplyJson = [{
  type: 'COMMON_INPUT',
  label: '供应商查询',
  placeholder: '请输入供应商编码/名称',
  field: 'codeOrName',
  width: '',
  initialValue: ''
}, {
  type: 'COMMON_TYPE_SELECT',
  label: '经营方式',
  placeholder: '请选择经营方式',
  field: 'runMode',
  width: '',
  initialValue: null,
  list: [{
    name: '全部',
    value: null
  }, {
    name: '经销',
    value: 1
  }, {
    name: '代销',
    value: 2
  }, {
    name: '联营',
    value: 3
  }, {
    name: 'POP',
    value: 8
  }]
}];
var salesJson = [{
  type: 'COMMON_INPUT',
  label: '销售地点编码',
  placeholder: '请输入销售地点编码',
  field: 'siteCode',
  width: '',
  initialValue: ''
}, {
  type: 'COMMON_INPUT',
  label: '销售地点名称',
  placeholder: '请选择销售地点名称',
  field: 'siteName',
  width: '',
  initialValue: 0
}];
var unitList = [{
  name: 'kg',
  value: 'kg'
}, {
  name: '包',
  value: '包'
}, {
  name: '瓶',
  value: '瓶'
}, {
  name: '袋',
  value: '袋'
}, {
  name: '盒',
  value: '盒'
}, {
  name: '箱',
  value: '箱'
}, {
  name: '件',
  value: '件'
}, {
  name: '支',
  value: '支'
}, {
  name: '罐',
  value: '罐'
}, {
  name: '条',
  value: '条'
}, {
  name: '份',
  value: '份'
}, {
  name: '桶',
  value: '桶'
}, {
  name: '杯',
  value: '杯'
}, {
  name: '只',
  value: '只'
}, {
  name: '盆',
  value: '盆'
}, {
  name: '把',
  value: '把'
}, {
  name: '双',
  value: '双'
}, {
  name: '提',
  value: '提'
}, {
  name: '套',
  value: '套'
}, {
  name: '根',
  value: '根'
}, {
  name: '块',
  value: '块'
}, {
  name: '排',
  value: '排'
}, {
  name: '捆',
  value: '捆'
}, {
  name: '张',
  value: '张'
}, {
  name: '板',
  value: '板'
}, {
  name: '卷',
  value: '卷'
}, {
  name: '片',
  value: '片'
}, {
  name: '听',
  value: '听'
}, {
  name: '打',
  value: '打'
}, {
  name: '组',
  value: '组'
}, {
  name: '碗',
  value: '碗'
}, {
  name: '台',
  value: '台'
}, {
  name: '串',
  value: '串'
}, {
  name: '个',
  value: '个'
}, {
  name: '卡',
  value: '卡'
}, {
  name: '筒',
  value: '筒'
}, {
  name: '本',
  value: '本'
}, {
  name: '副',
  value: '副'
}, {
  name: '米',
  value: '米'
}, {
  name: '壶',
  value: '壶'
}, {
  name: '筐',
  value: '筐'
}];

/***/ }),

/***/ 54435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Context": function() { return /* binding */ Context; },
/* harmony export */   "Context2": function() { return /* binding */ Context2; },
/* harmony export */   "ContextWrapper": function() { return /* binding */ ContextWrapper; },
/* harmony export */   "OperateContext": function() { return /* binding */ OperateContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var Context = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var Context2 = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var ContextWrapper = props => {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Context.Provider, {
    value: props.value
  }, props.children);
};
var OperateContext = props => {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Context2.Provider, {
    value: props.value
  }, props.children);
};

/***/ }),

/***/ 57174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "renderOptions": function() { return /* binding */ renderOptions; },
/* harmony export */   "renderSupplyOptions": function() { return /* binding */ renderSupplyOptions; },
/* harmony export */   "renderMerchantOptions": function() { return /* binding */ renderMerchantOptions; },
/* harmony export */   "renderRadioGroup": function() { return /* binding */ renderRadioGroup; },
/* harmony export */   "validateObjFn": function() { return /* binding */ validateObjFn; },
/* harmony export */   "validateArrFn": function() { return /* binding */ validateArrFn; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2824);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8870);
/* harmony import */ var antd_es_radio_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88983);
/* harmony import */ var antd_es_radio__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55742);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34041);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);







var Option = antd_es_select__WEBPACK_IMPORTED_MODULE_3__/* .default.Option */ .Z.Option;
var renderOptions = list => {
  if (!(list !== null && list !== void 0 && list.length)) return false;
  return list.map(item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(Option, {
    value: item.value,
    key: item.value
  }, item.name));
};
var renderSupplyOptions = list => {
  if (!(list !== null && list !== void 0 && list.length)) return false;
  return list.map(item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(Option, {
    value: item.supplierCode,
    key: item.supplierCode
  }, item.supplierName));
};
var renderMerchantOptions = list => {
  if (!(list !== null && list !== void 0 && list.length)) return false;
  return list.map(item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(Option, {
    value: item.merchantId,
    key: item.merchantId
  }, item.merchantName));
};
var renderRadioGroup = list => {
  if (!list.length) return false;
  return list.map(item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_4__/* .default */ .ZP, {
    value: item.value,
    key: item.value
  }, item.name));
};
function validateObjFn(data, filter) {
  var msgs = [];

  var newData = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)({}, data);

  for (var _i = 0, _Object$entries = Object.entries(newData); _i < _Object$entries.length; _i++) {
    var _ref3 = _Object$entries[_i];

    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_ref3, 2);

    var key = _ref2[0];
    var value = _ref2[1];

    if (filter && filter !== null && filter !== void 0 && filter.length) {
      if (!filter.includes(key) && (!value || value === '')) {
        msgs.push(key);
      }
    } else {
      if (!value || value === '') {
        msgs.push(key);
      }
    }
  }

  if (msgs) {
    return msgs[0];
  }

  return false;
}
function validateArrFn(arr, filter, filterKey) {
  var _msgs;

  console.log(arr, filter, filterKey);
  if (!(arr !== null && arr !== void 0 && arr.length)) return;
  var msgs = [];
  var newArr = [...arr];
  newArr.forEach((item, index) => {
    for (var _i2 = 0, _Object$entries2 = Object.entries(item); _i2 < _Object$entries2.length; _i2++) {
      var _ref6 = _Object$entries2[_i2];

      var _ref5 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_ref6, 2);

      var key = _ref5[0];
      var value = _ref5[1];

      if (filter !== null && filter !== void 0 && filter.length && filterKey && !filter.includes(filterKey)) {
        if (!value || value === '') {
          msgs.push(key);
        }
      } else {
        if (!value || value === '') {
          msgs.push(key);
        }
      }
    }
  });
  msgs = Array.from(new Set(msgs));

  if ((_msgs = msgs) !== null && _msgs !== void 0 && _msgs.length) {
    return msgs[0];
  }

  return false;
}

/***/ }),

/***/ 82022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57016);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34041);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _components_BaseUploader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99481);
/* harmony import */ var _utils_fetchQuery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48344);
/* harmony import */ var _pages_GoodsManage_GoodCopy_components_searchForm_searchSelect__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52933);














/* harmony default export */ __webpack_exports__["default"] = (props => {
  var visible = props.visible,
      setImg = props.setImg;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    brandId: '',
    name: '',
    status: 1,
    description: ''
  }),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState, 2),
      itemDetail = _useState2[0],
      setItemDetail = _useState2[1]; // 获取到目前上传图片的信息


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState3, 2),
      imgInfoData = _useState4[0],
      setInfo = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState5, 2),
      importMerchant = _useState6[0],
      setImportMerchant = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    imgNameType: 1
  }),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState7, 2),
      businessData = _useState8[0],
      setBusiness = _useState8[1];
  /**
   *
   * 获取logo
   */


  var handleGetImageUrl = imgUrl => {
    console.log(imgUrl, '获取商品信息');
    setItemDetail((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)({}, itemDetail), {}, {
      logo: imgUrl
    }));
  };

  var onMerchantChange = val => {
    setImportMerchant(val);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, {
    title: "\u6279\u91CF\u4E0A\u4F20\u5546\u5BB6\u5546\u54C1\u56FE\u7247",
    visible: visible,
    onOk: /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)().mark(function _callee() {
      var _itemDetail$logo$, _itemDetail$logo$2;

      var params, _yield$fetchQuery, result, success;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!importMerchant || importMerchant === 0)) {
                _context.next = 3;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_12__.default.error('请选择导入商家');

              return _context.abrupt("return");

            case 3:
              if (!(!(itemDetail !== null && itemDetail !== void 0 && itemDetail.logo) || !(itemDetail !== null && itemDetail !== void 0 && (_itemDetail$logo$ = itemDetail.logo[0]) !== null && _itemDetail$logo$ !== void 0 && _itemDetail$logo$.resId))) {
                _context.next = 6;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_12__.default.error('请上传商品图片');

              return _context.abrupt("return");

            case 6:
              params = {
                // 图片资源ID
                resId: itemDetail === null || itemDetail === void 0 ? void 0 : (_itemDetail$logo$2 = itemDetail.logo[0]) === null || _itemDetail$logo$2 === void 0 ? void 0 : _itemDetail$logo$2.resId,
                // 图片名称类型, 1:商品编码 2:商品条码
                imgNameType: businessData === null || businessData === void 0 ? void 0 : businessData.imgNameType,
                // 文件名称，图片是商品编码/商品条码: 83476274.png 压缩文件无要求: 压缩文件.zip
                fileName: imgInfoData === null || imgInfoData === void 0 ? void 0 : imgInfoData.name,
                // 所属商家ID
                merchantId: importMerchant
              };
              _context.next = 9;
              return (0,_utils_fetchQuery__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)('/pms/importMerchantItemImg', 'POST', params);

            case 9:
              _yield$fetchQuery = _context.sent;
              result = _yield$fetchQuery.result;
              success = _yield$fetchQuery.success;

              if (success) {
                setImg(false);
              }

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })),
    onCancel: () => {
      setImg(false);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("p", null, "\u652F\u6301\u4E3A\u591A\u4E2A\u5546\u54C1\u6279\u91CF\u6DFB\u52A0\u56FE\u7247\uFF0C\u4E0A\u4F20\u89C4\u5219\u5982\u4E0B:"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("p", null, "1\u3001\u56FE\u7247\u547D\u540D\u4E3A\u5546\u54C1\u7F16\u7801\u6216\u8005\u5546\u54C1\u6761\u7801"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("p", null, "2\u3001\u5355\u4E2A\u5546\u54C1\u603B\u56FE\u7247\u6570\u91CF\u6700\u591A1\u5F20"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("p", null, "3\u3001\u591A\u4E2A\u5546\u54C1\u56FE\u7247\u6587\u4EF6\u5939\u5185\u5168\u9009\u538B\u7F29\u4E3Azip\u5305\u4E0A\u4F20"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("p", null, "4\u3001\u4EC5\u652F\u6301jpg\u3001jpeg\u3001png\u683C\u5F0F\uFF0C\u5355\u5F20\u4E0D\u8D85\u8FC71M"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("p", null, "\u9009\u62E9\u5BFC\u5165\u5546\u5BB6\uFF1A", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_pages_GoodsManage_GoodCopy_components_searchForm_searchSelect__WEBPACK_IMPORTED_MODULE_6__/* .MerchantSearch */ .cO, {
    placeholder: '请选择导入的商家',
    onChange: onMerchantChange
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("p", null, "\u56FE\u7247\u540D\u79F0\u7C7B\u578B\uFF1A", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
    defaultValue: businessData === null || businessData === void 0 ? void 0 : businessData.imgNameType,
    onChange: value => {
      setBusiness((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)({}, businessData), {}, {
        imgNameType: value
      }));
    },
    options: [{
      value: 1,
      label: '按照商品编码命名'
    }, {
      value: 2,
      label: '按照商品条码命名'
    }]
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_BaseUploader__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    maxCount: 1,
    fileList: itemDetail.logo,
    onChange: handleGetImageUrl,
    preview: false,
    btnText: "\u4E0A\u4F20\u56FE\u7247",
    accept: "file",
    setInfo: setInfo,
    size: 1024
  }));
});

/***/ }),

/***/ 53069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "formJson": function() { return /* binding */ formJson; },
/* harmony export */   "GOOD_STOCK_TABLE_COLUMN_FIELD": function() { return /* binding */ GOOD_STOCK_TABLE_COLUMN_FIELD; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_BaseUploader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99481);





var defaultList = [{
  name: '全部',
  value: null
}, {
  name: '是',
  value: 1
}, {
  name: '否',
  value: 2
}];
var productType = [{
  name: '实物商品',
  value: 1
}, {
  name: '物料耗材',
  value: 2
}, {
  name: '虚拟商品',
  value: 3
}, {
  name: '礼品卡',
  value: 4
}];
var statusList = [{
  name: '新品',
  value: 1
}, {
  name: '正常',
  value: 2
}, {
  name: '停购',
  value: 3
}, {
  name: '停售',
  value: 4
}, {
  name: '清退',
  value: 5
}, {
  name: '永久淘汰',
  value: 6
}];
var productMapper = {
  1: '实物商品',
  2: '物料耗材',
  3: '虚拟商品',
  4: '礼品卡'
};
var defaultMapper = {
  1: '是',
  2: '否'
};
var statusMapper = {
  1: '新品',
  2: '正常',
  3: '停购',
  4: '停售',
  5: '清退',
  6: '永久淘汰'
};
var weightMapper = {
  1: '散称',
  2: '非称重',
  3: 'PCS'
};
var formJson = [{
  type: 'GOODS_MERCHANT',
  label: '商户查询',
  placeholder: '商户查询',
  field: 'merchantIds',
  mode: 'multiple',
  width: '',
  initialValue: '',
  hasInitialValue: true // needDefaultMerchant: true

}, {
  type: 'GOODS_SHOP_TREE',
  label: '地点查询',
  placeholder: '请选择门店',
  field: 'siteIdList',
  width: ''
}, {
  type: 'COMMON_INPUT',
  label: '商品查询',
  placeholder: '商品名称/条码/编码/plu码',
  field: 'queryCriteria',
  width: '',
  initialValue: ''
}, {
  type: 'GOODS_CATEGORY',
  label: '商品类目',
  placeholder: '商品类目',
  field: 'backCategoryId',
  width: '',
  initialValue: '',
  params: {
    businessType: 1
  }
}, {
  type: 'SCENE_CATEGORY',
  label: '场景类目',
  placeholder: '请选择场景类目',
  field: 'sceneCategoryId',
  result: 'childList',
  width: '',
  initialValue: ''
}, {
  type: 'GOODS_BRAND',
  label: '商品品牌',
  placeholder: '请输入商品品牌',
  field: 'brandId',
  width: '',
  initialValue: '全部'
}, {
  type: 'COMMON_INPUT',
  label: '供应商查询',
  placeholder: '供应商名称/供应商编码',
  field: 'supplierCriteria',
  width: '',
  initialValue: ''
}, {
  type: 'COMMON_TYPE_SELECT',
  label: '商品类型',
  placeholder: '商品类型',
  field: 'productType',
  width: '',
  initialValue: '全部',
  list: productType
}, {
  type: 'COMMON_TYPE_SELECT',
  label: '是否称重',
  placeholder: '是否称重',
  field: 'weightType',
  width: '',
  initialValue: '全部',
  list: defaultList
}, {
  type: 'COMMON_TYPE_SELECT',
  label: '是否生鲜',
  placeholder: '是否生鲜',
  field: 'freshType',
  width: '',
  initialValue: '全部',
  list: defaultList
}, {
  type: 'COMMON_TYPE_SELECT',
  label: '商品生命周期',
  placeholder: '请选择商品生命周期',
  field: 'status',
  initialValue: [1, 2, 3, 4, 5],
  list: statusList,
  fieldOptions: {
    maxTagCount: 1,
    mode: "multiple"
  }
}, {
  type: 'RADIO',
  label: '隐藏仓库商品',
  field: 'hiddenWareHouseGoodsFlag',
  dataList: [{
    label: '是',
    value: 1
  }]
}];
var GOOD_STOCK_TABLE_COLUMN_FIELD = [{
  title: '商品',
  dataIndex: 'productName',
  width: 300,
  fixed: 'left',
  ellipsis: {
    showTitle: false
  },
  render: (productName, record) => {
    var barcode = Array.from(new Set(record.barcode));
    var pluCode = Array.from(new Set(record.pluCode));
    var fileList = record !== null && record !== void 0 && record.imgUrl ? [{
      uid: record.imgUrl,
      url: record.imgUrl
    }] : [];
    var showTag = (record === null || record === void 0 ? void 0 : record.status) == 1 || (record === null || record === void 0 ? void 0 : record.status) == 2;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row'
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      style: {
        position: 'relative'
      }
    }, fileList !== null && fileList !== void 0 && fileList.length ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_components_BaseUploader__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
      maxCount: 1,
      fileList: fileList,
      type: "img",
      preview: true
    }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("img", {
      style: {
        width: 104,
        height: 104,
        border: '1px solid #d9d9d9',
        marginRight: 8,
        marginBottom: 8
      },
      src: "data:image/png;base64,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"
    }), !showTag ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "goods-no-no"
    }, statusMapper[record === null || record === void 0 ? void 0 : record.status]) : null), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "goods-box".concat(showTag ? '' : ' hidden')
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
      placement: "topLeft",
      title: productName
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "ellipsis"
    }, record.productName))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, "\u7F16\u7801\uFF1A", record.productId), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, "\u6761\u7801\uFF1A", record.barcode), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, "PLU\uFF1A", record.pluCode), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, "\u89C4\u683C/\u5355\u4F4D\uFF1A", record.specDesc, "/", record.unit), showTag ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "goods-status-tag"
    }, statusMapper[record === null || record === void 0 ? void 0 : record.status]) : null));
  }
}, {
  title: '门店',
  dataIndex: 'merchantName',
  key: 'merchantName',
  fixed: 'left',
  width: 200,
  ellipsis: {
    showTitle: false
  },
  render: (merchantName, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, "\u5546\u5BB6\uFF1A", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    placement: "topLeft",
    title: merchantName
  }, record.merchantName)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, "\u5E97\u7F16\uFF1A", record.shopCode), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, "\u5E97\u540D\u79F0\uFF1A", record.shopName))
}, {
  title: '价格',
  dataIndex: 'averageCost',
  width: 180,
  render: (text, record) => {
    var renderPrice = (label, value) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, label, "\uFF1A", value ? "".concat(value, "/\u5143") : '-');

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, renderPrice('移动平均成本', record.averageCost), renderPrice('最新进价', record.lastPurchaseCost), renderPrice('经销商指导价', (record.dealerPrice / 100).toFixed(2)), renderPrice('售价', record.salePrice), renderPrice('会员价', record.memberPrice), renderPrice('促销价', record.activityPrice));
  }
}, {
  title: '毛利',
  dataIndex: 'margins',
  align: 'center',
  width: 160,
  render: margins => {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, "\u5B9A\u4EF7\u6BDB\u5229\uFF1A", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
      style: {
        color: margins > 0 ? 'black' : 'red'
      }
    }, margins ? "".concat(margins, "%") : '')));
  }
}, {
  title: '商品品牌',
  dataIndex: 'brandName',
  width: 80
}, {
  title: '商品类目',
  dataIndex: 'categoryName',
  width: 120,
  ellipsis: {
    showTitle: false
  },
  render: (categoryName, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    placement: "topLeft",
    title: categoryName
  }, record.categoryName)
}, {
  title: '场景类目',
  dataIndex: 'sceneCategoryName',
  width: 120,
  ellipsis: {
    showTitle: false
  },
  render: (sceneCategoryName, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    placement: "topLeft",
    title: sceneCategoryName
  }, record.sceneCategoryName)
}, {
  title: '供应商',
  dataIndex: 'supplierName',
  width: 120
}, {
  title: '商品类型',
  dataIndex: 'productType',
  width: 80,
  render: (text, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, productMapper[record === null || record === void 0 ? void 0 : record.productType])
}, {
  title: '是否称重',
  dataIndex: 'weightType',
  width: 80,
  render: (text, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, weightMapper[record === null || record === void 0 ? void 0 : record.weightType])
}, {
  title: '是否应季',
  dataIndex: 'seasonType',
  width: 80,
  render: (text, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, defaultMapper[record === null || record === void 0 ? void 0 : record.seasonType])
}, {
  title: '操作人',
  dataIndex: 'operator',
  width: 80,
  render: (text, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, record === null || record === void 0 ? void 0 : record.operator)
}, {
  title: '更新时间',
  dataIndex: 'modifiedTime',
  width: 140,
  render: (text, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, moment__WEBPACK_IMPORTED_MODULE_2___default()(record === null || record === void 0 ? void 0 : record.modifiedTime).format('YYYY/MM/DD HH:mm:ss'))
}];

/***/ }),

/***/ 58521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(57016);
/* harmony import */ var antd_es_table_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66456);
/* harmony import */ var antd_es_table__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(97423);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(34041);
/* harmony import */ var antd_es_descriptions_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98858);
/* harmony import */ var antd_es_descriptions__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4914);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2824);
/* harmony import */ var antd_es_tabs_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18106);
/* harmony import */ var antd_es_tabs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69584);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _components_BigTitle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70400);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24731);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82682);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_9__);















/**
 * 地点商品变更日志（调价 / 生命周期 / 要货步长）
 */






var TabPane = antd_es_tabs__WEBPACK_IMPORTED_MODULE_10__/* .default.TabPane */ .Z.TabPane;
var SOURCE_MAP = {
  1: '手工更改',
  2: '便捷工具',
  3: '系统同步'
};
var STATUS_MAP = {
  1: '新品',
  2: '正常',
  3: '停购',
  4: '停售',
  5: '清退',
  6: '永久淘汰'
};
var TAB_PRICE = 'price';
var TAB_LIFECYCLE = 'lifecycle';
var TAB_STEP_SIZE = 'stepSize';
/** 兼容 protobuf Timestamp（seconds）、毫秒/秒时间戳、ISO 字符串 */

var formatChangeTime = changeTime => {
  if (changeTime === null || changeTime === undefined || changeTime === '') return '-';
  var ms = null;

  if (typeof changeTime === 'object') {
    if (changeTime.seconds !== null && changeTime.seconds !== undefined) {
      ms = Number(changeTime.seconds) * 1000 + Math.floor(Number(changeTime.nanos || 0) / 1e6);
    } else if (changeTime.value !== null && changeTime.value !== undefined) {
      return formatChangeTime(changeTime.value);
    }
  } else if (typeof changeTime === 'string' && Number.isNaN(Number(changeTime))) {
    var m = moment__WEBPACK_IMPORTED_MODULE_9___default()(changeTime);
    return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : '-';
  } else {
    var n = Number(changeTime);
    if (!Number.isFinite(n) || n <= 0) return '-';
    ms = n < 1e12 ? n * 1000 : n;
  }

  if (ms === null || !Number.isFinite(ms)) return '-';
  return moment__WEBPACK_IMPORTED_MODULE_9___default()(ms).format('YYYY-MM-DD HH:mm:ss');
};

var priceTypeOptions = [{
  label: '全部',
  value: '0'
}, {
  label: '售价',
  value: '1'
}, {
  label: '会员价',
  value: '2'
}, {
  label: '促销价',
  value: '3'
}, {
  label: '经销商指导价',
  value: '4'
}];

function PriceAdjustModal(props) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)({}),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState, 2),
      basicInfo = _useState2[0],
      setBasicInfo = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState3, 2),
      adjustList = _useState4[0],
      setAdjustList = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState5, 2),
      priceType = _useState6[0],
      setPriceType = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(TAB_PRICE),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState7, 2),
      activeTab = _useState8[0],
      setActiveTab = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState9, 2),
      lifecycleList = _useState10[0],
      setLifecycleList = _useState10[1];

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]),
      _useState12 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState11, 2),
      stepSizeList = _useState12[0],
      setStepSizeList = _useState12[1];

  var priceColumns = [{
    title: '序号',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 90,
    render: (_, __, i) => i + 1
  }, {
    title: '调价单号/活动ID',
    dataIndex: 'orderNum',
    key: 'orderNum'
  }, {
    title: '调价类型',
    dataIndex: 'priceType',
    key: 'priceType',
    render: text => {
      var _priceTypeOptions$fin;

      return (_priceTypeOptions$fin = priceTypeOptions.find(f => String(f.value) === String(text))) === null || _priceTypeOptions$fin === void 0 ? void 0 : _priceTypeOptions$fin.label;
    }
  }, {
    title: '调价价格',
    dataIndex: 'amount',
    key: 'amount'
  }, {
    title: '当前状态',
    dataIndex: 'status',
    key: 'status'
  }, {
    title: '制单人',
    dataIndex: 'creator',
    key: 'creator'
  }, {
    title: '制单日期',
    dataIndex: 'gmtCreated',
    key: 'gmtCreated'
  }];
  var lifecycleColumns = [{
    title: '序号',
    dataIndex: 'index',
    width: 70,
    render: (_, __, index) => index + 1
  }, {
    title: '变更来源',
    dataIndex: 'source',
    render: source => SOURCE_MAP[source] || source || '-'
  }, {
    title: '调整后状态',
    dataIndex: 'afterStatus',
    render: afterStatus => STATUS_MAP[afterStatus] || afterStatus || '-'
  }, {
    title: '变更人',
    dataIndex: 'operator'
  }, {
    title: '变更时间',
    dataIndex: 'changeTime',
    width: 170,
    render: changeTime => formatChangeTime(changeTime)
  }];
  var stepSizeColumns = [{
    title: '序号',
    dataIndex: 'index',
    width: 70,
    render: (_, __, index) => index + 1
  }, {
    title: '变更来源',
    dataIndex: 'source',
    render: source => SOURCE_MAP[source] || source || '-'
  }, {
    title: '调整后单位',
    dataIndex: 'afterPurchaseUnit',
    render: v => v || '-'
  }, {
    title: '调整后步长',
    dataIndex: 'afterOrderStepSize',
    render: v => v || '-'
  }, {
    title: '变更人',
    dataIndex: 'operator'
  }, {
    title: '变更时间',
    dataIndex: 'changeTime',
    width: 170,
    render: changeTime => formatChangeTime(changeTime)
  }];

  var queryPriceDetail = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee(val) {
      var p, _yield$ypRider, _yield$ypRider$result, itemInfo, list;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              p = {
                priceType,
                flag: val
              };
              _context.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)('pms.ShopItemManageService.querySgShopItemSkuAdjustPriceRecord', (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, p), props.params));

            case 3:
              _yield$ypRider = _context.sent;
              _yield$ypRider$result = _yield$ypRider.result;
              itemInfo = _yield$ypRider$result.itemInfo;
              list = _yield$ypRider$result.adjustList;
              setBasicInfo(itemInfo);
              setAdjustList(list);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function queryPriceDetail(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var queryChangeLog = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee2(changeType) {
      var _props$params, _props$params2, params, _yield$ypRider2, result, success;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              params = {
                changeType,
                shopItemSkuId: (_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.shopItemSkuId
              };

              if ((_props$params2 = props.params) !== null && _props$params2 !== void 0 && _props$params2.shopItemId) {
                params.shopItemId = props.params.shopItemId;
              }

              _context2.next = 5;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_8__/* .sgApi.querySgShopItemChangeLogList */ .A0.querySgShopItemChangeLogList, params);

            case 5:
              _yield$ypRider2 = _context2.sent;
              result = _yield$ypRider2.result;
              success = _yield$ypRider2.success;

              if (success) {
                _context2.next = 10;
                break;
              }

              return _context2.abrupt("return", []);

            case 10:
              if (!Array.isArray(result)) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return", result);

            case 12:
              if (!Array.isArray(result === null || result === void 0 ? void 0 : result.list)) {
                _context2.next = 14;
                break;
              }

              return _context2.abrupt("return", result.list);

            case 14:
              return _context2.abrupt("return", []);

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0);
              return _context2.abrupt("return", []);

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 17]]);
    }));

    return function queryChangeLog(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var loadTabData = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee3(tabKey) {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(tabKey === TAB_PRICE)) {
                _context3.next = 4;
                break;
              }

              _context3.next = 3;
              return queryPriceDetail(priceType ? 1 : undefined);

            case 3:
              return _context3.abrupt("return");

            case 4:
              if (!(tabKey === TAB_LIFECYCLE)) {
                _context3.next = 11;
                break;
              }

              _context3.t0 = setLifecycleList;
              _context3.next = 8;
              return queryChangeLog(1);

            case 8:
              _context3.t1 = _context3.sent;
              (0, _context3.t0)(_context3.t1);
              return _context3.abrupt("return");

            case 11:
              if (!(tabKey === TAB_STEP_SIZE)) {
                _context3.next = 17;
                break;
              }

              _context3.t2 = setStepSizeList;
              _context3.next = 15;
              return queryChangeLog(2);

            case 15:
              _context3.t3 = _context3.sent;
              (0, _context3.t2)(_context3.t3);

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function loadTabData(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  var onTabChange = key => {
    setActiveTab(key);
    loadTabData(key);
  };

  var priceChange = val => {
    setPriceType(val);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
    if (activeTab !== TAB_PRICE) return;

    if (priceType) {
      queryPriceDetail(1);
      return;
    }

    queryPriceDetail();
  }, [priceType]);
  (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(() => {
    setActiveTab(TAB_PRICE);
    setLifecycleList([]);
    setStepSizeList([]);
  }, []);
  var modalTitle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("div", {
    style: {
      fontSize: 18,
      lineHeight: '28px',
      display: 'flex',
      alignItems: 'baseline'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("span", null, "\u53D8\u66F4\u65E5\u5FD7"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("span", {
    style: {
      fontSize: 13,
      marginLeft: 12,
      color: 'rgba(0,0,0,0.45)',
      fontWeight: 'normal'
    }
  }, "\u53EA\u5C55\u793A\u8FD130\u5929\u8BB0\u5F55"));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z, {
    title: modalTitle,
    destroyOnClose: true,
    maskClosable: false,
    width: 980,
    visible: true,
    wrapClassName: "change-log-modal",
    onOk: props.closeModalCallback,
    onCancel: props.closeModalCallback
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("div", {
    className: "change-log-section"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(_components_BigTitle__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    title: "\u57FA\u672C\u4FE1\u606F"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("div", {
    className: "change-log-desc"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_descriptions__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, {
    column: 3
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_descriptions__WEBPACK_IMPORTED_MODULE_16__/* .default.Item */ .Z.Item, {
    label: "\u5546\u54C1\u7F16\u7801"
  }, (basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.goodsCode) || '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_descriptions__WEBPACK_IMPORTED_MODULE_16__/* .default.Item */ .Z.Item, {
    label: "\u5546\u54C1\u540D\u79F0"
  }, (basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.name) || '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_descriptions__WEBPACK_IMPORTED_MODULE_16__/* .default.Item */ .Z.Item, {
    label: "\u5546\u54C1\u5355\u4F4D"
  }, (basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.unit) || '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_descriptions__WEBPACK_IMPORTED_MODULE_16__/* .default.Item */ .Z.Item, {
    label: "\u5546\u54C1\u6761\u7801"
  }, (basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.barcode) || '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_descriptions__WEBPACK_IMPORTED_MODULE_16__/* .default.Item */ .Z.Item, {
    label: "\u5546\u54C1PLU"
  }, (basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.pluCode) || '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_descriptions__WEBPACK_IMPORTED_MODULE_16__/* .default.Item */ .Z.Item, {
    label: "PLU\u7EA7\u522B"
  }, (basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.pluLevel) || '-')))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_tabs__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z, {
    className: "change-log-tabs",
    activeKey: activeTab,
    onChange: onTabChange
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(TabPane, {
    tab: "\u8C03\u4EF7\u4FE1\u606F",
    key: TAB_PRICE
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("div", {
    className: "change-log-price-filter"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("span", {
    style: {
      marginRight: 8
    }
  }, "\u4EF7\u683C\u7C7B\u578B"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z, {
    options: priceTypeOptions,
    placeholder: "\u4EF7\u683C\u7C7B\u578B",
    onChange: priceChange,
    style: {
      width: 130
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_table__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
    columns: priceColumns,
    dataSource: adjustList,
    rowKey: (r, i) => r.orderNum || i
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(TabPane, {
    tab: "\u751F\u547D\u5468\u671F",
    key: TAB_LIFECYCLE
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_table__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
    columns: lifecycleColumns,
    dataSource: lifecycleList,
    rowKey: r => r.id || "".concat(r.changeTime, "-").concat(r.operator),
    pagination: false,
    scroll: {
      y: 340
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(TabPane, {
    tab: "\u8981\u8D27\u6B65\u957F",
    key: TAB_STEP_SIZE
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_table__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
    columns: stepSizeColumns,
    dataSource: stepSizeList,
    rowKey: r => r.id || "".concat(r.changeTime, "-").concat(r.operator),
    pagination: false,
    scroll: {
      y: 340
    }
  }))));
}

/* harmony default export */ __webpack_exports__["default"] = (PriceAdjustModal);

/***/ }),

/***/ 60808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "formJson": function() { return /* binding */ formJson; },
/* harmony export */   "GOOD_STOCK_TABLE_COLUMN_FIELD": function() { return /* binding */ GOOD_STOCK_TABLE_COLUMN_FIELD; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_myPopover__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49978);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_BaseUploader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99481);






var defaultList = [{
  name: '全部',
  value: null
}, {
  name: '是',
  value: 1
}, {
  name: '否',
  value: 2
}];
var productType = [{
  name: '实物商品',
  value: 1
}, {
  name: '物料耗材',
  value: 2
}, {
  name: '虚拟商品',
  value: 3
}, {
  name: '礼品卡',
  value: 4
}];
var statusList = [{
  name: '新品',
  value: 1
}, {
  name: '正常',
  value: 2
}, {
  name: '停购',
  value: 3
}, {
  name: '停售',
  value: 4
}, {
  name: '清退',
  value: 5
}, {
  name: '永久淘汰',
  value: 6
}];
var productMapper = {
  1: '实物商品',
  2: '物料耗材',
  3: '虚拟商品',
  4: '礼品卡'
};
var defaultMapper = {
  1: '是',
  2: '否'
};
var statusMapper = {
  1: '新品',
  2: '正常',
  3: '停购',
  4: '停售',
  5: '清退',
  6: '永久淘汰'
};
var weightMapper = {
  1: '散称',
  2: '非称重',
  3: 'PCS'
};
var formJson = [{
  type: 'GOODS_MERCHANT',
  label: '商户查询',
  placeholder: '商户查询',
  field: 'merchantIds',
  width: '',
  initialValue: '',
  mode: 'multiple' // needDefaultMerchant: true

}, {
  type: 'COMMON_INPUT',
  label: '商品查询',
  placeholder: '商品名称/条码/编码/plu码',
  field: 'queryCriteria',
  width: '',
  initialValue: ''
}, {
  type: 'GOODS_CATEGORY',
  label: '商品类目',
  placeholder: '商品类目',
  field: 'backCategoryId',
  width: '',
  initialValue: '',
  params: {
    businessType: 1
  }
}, {
  type: 'SCENE_CATEGORY',
  label: '场景类目',
  placeholder: '场景类目',
  field: 'sceneCategoryId',
  result: 'childList',
  width: '',
  initialValue: ''
}, {
  type: 'GOODS_BRAND',
  label: '商品品牌',
  placeholder: '请输入商品品牌',
  field: 'brandId',
  width: '',
  initialValue: '全部'
}, {
  type: 'COMMON_INPUT',
  label: '供应商查询',
  placeholder: '供应商名称/供应商编码',
  field: 'supplierCriteria',
  width: '',
  initialValue: ''
}, {
  type: 'COMMON_TYPE_SELECT',
  label: '商品类型',
  placeholder: '商品类型',
  field: 'productType',
  width: '',
  initialValue: '全部',
  list: productType
}, {
  type: 'COMMON_TYPE_SELECT',
  label: '是否称重',
  placeholder: '是否称重',
  field: 'weightType',
  width: '',
  initialValue: '全部',
  list: defaultList
}, {
  type: 'COMMON_TYPE_SELECT',
  label: '是否生鲜',
  placeholder: '是否生鲜',
  field: 'freshType',
  width: '',
  initialValue: '全部',
  list: defaultList
}, {
  type: 'COMMON_TYPE_SELECT',
  label: '商品生命周期',
  placeholder: '请选择商品生命周期',
  field: 'status',
  initialValue: [1, 2, 3, 4, 5],
  list: statusList,
  fieldOptions: {
    maxTagCount: 1,
    mode: "multiple"
  }
}, {
  label: '创建时间',
  field: 'gmtCreated',
  type: 'DATE_RANGE',
  width: '',
  initialValue: ''
}, {
  type: 'ITEM_TAGS',
  label: '商品标签',
  placeholder: '请选择商品标签',
  field: 'itemTags',
  width: '',
  initialValue: '',
  mode: 'multiple' // needDefaultMerchant: true

}, {
  type: 'CHECKBOX',
  label: '无图商品',
  field: 'includePic',
  hiddenLabel: true
}];
var GOOD_STOCK_TABLE_COLUMN_FIELD = [{
  title: '商品',
  dataIndex: 'alias',
  width: 280,
  fixed: 'left',
  ellipsis: {
    showTitle: false
  },
  render: (alias, record) => {
    var barcode = Array.from(new Set(record.barcode));
    var pluCode = Array.from(new Set(record.pluCode));
    var fileList = record !== null && record !== void 0 && record.imgUrl ? [{
      uid: record.imgUrl,
      url: record.imgUrl
    }] : [];
    var showTag = (record === null || record === void 0 ? void 0 : record.status) == 1 || (record === null || record === void 0 ? void 0 : record.status) == 2;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row'
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      style: {
        position: 'relative'
      }
    }, fileList !== null && fileList !== void 0 && fileList.length ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_components_BaseUploader__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
      maxCount: 1,
      fileList: fileList,
      type: "img",
      preview: true
    }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("img", {
      style: {
        width: 104,
        height: 104,
        border: '1px solid #d9d9d9',
        marginRight: 8,
        marginBottom: 8
      },
      src: "data:image/png;base64,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"
    }), !showTag ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "goods-no-no"
    }, statusMapper[record === null || record === void 0 ? void 0 : record.status]) : null), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "goods-box".concat(showTag ? '' : ' hidden')
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
      placement: "topLeft",
      title: alias
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "ellipsis"
    }, record.alias))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, "\u7F16\u7801\uFF1A", record.productId), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, "\u6761\u7801\uFF1A", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_components_myPopover__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
      list: barcode || [],
      title: "\u6761\u7801"
    })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, "PLU\uFF1A", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_components_myPopover__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
      list: pluCode || [],
      title: "PLU"
    })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, "\u89C4\u683C/\u5355\u4F4D\uFF1A", record.conversionRatio, record.unit, "/", record.saleUnit), showTag ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "goods-status-tag"
    }, statusMapper[record === null || record === void 0 ? void 0 : record.status]) : null));
  }
}, {
  title: '商家',
  dataIndex: 'merchantName',
  key: 'merchantName',
  align: 'center',
  fixed: 'left',
  width: 140,
  ellipsis: {
    showTitle: false
  },
  render: (merchantName, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    placement: "topLeft",
    title: merchantName
  }, record.merchantName)
}, {
  title: '经销商指导价（元）',
  dataIndex: 'dealerPrice',
  width: 100,
  render: (dealerPrice, _) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, (dealerPrice / 100).toFixed(2))
}, {
  title: '进项税率',
  dataIndex: 'costTaxRate',
  width: 80,
  render: (costTaxRate, record) => {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, costTaxRate, "%");
  }
}, {
  title: '销项税率',
  dataIndex: 'saleTaxRate',
  width: 80,
  render: (saleTaxRate, record) => {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, saleTaxRate, "%");
  }
}, {
  title: '商品品牌',
  dataIndex: 'brandName',
  width: 80
}, {
  title: '商品类目',
  dataIndex: 'categoryName',
  width: 120,
  ellipsis: {
    showTitle: false
  },
  render: (categoryName, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    placement: "topLeft",
    title: categoryName
  }, record.categoryName)
}, {
  title: '场景类目',
  dataIndex: 'sceneCategoryName',
  width: 120,
  ellipsis: {
    showTitle: false
  },
  render: (sceneCategoryName, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    placement: "topLeft",
    title: sceneCategoryName
  }, record.sceneCategoryName)
}, {
  title: '商品类型',
  dataIndex: 'productType',
  width: 80,
  render: (text, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, productMapper[record === null || record === void 0 ? void 0 : record.productType])
}, {
  title: '商品档期',
  dataIndex: 'theme',
  width: 120,
  ellipsis: {
    showTitle: false
  },
  render: (theme, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    placement: "topLeft",
    title: theme
  }, record.theme)
}, {
  title: '是否称重',
  dataIndex: 'weightType',
  width: 80,
  render: (text, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, weightMapper[record === null || record === void 0 ? void 0 : record.weightType])
}, {
  title: '是否应季',
  dataIndex: 'seasonType',
  width: 80,
  render: (text, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, defaultMapper[record === null || record === void 0 ? void 0 : record.seasonType])
}, {
  title: '商品标签',
  dataIndex: 'tagNames',
  width: 120,
  render: (text, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, ((record === null || record === void 0 ? void 0 : record.tagNames) || []).join(', ') || '')
}, // {
//   title: '创建人',
//   dataIndex: 'creator',
//   width: 80,
//   render: (text: any, record: any) => (
//       <span>{record?.creator}</span>
//   ),
// },
{
  title: '创建时间',
  dataIndex: 'gmtCreated',
  width: 140,
  render: (text, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, moment__WEBPACK_IMPORTED_MODULE_3___default()(record === null || record === void 0 ? void 0 : record.gmtCreated).format('YYYY/MM/DD HH:mm:ss'))
}, {
  title: '操作人',
  dataIndex: 'operator',
  width: 80,
  render: (text, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, record === null || record === void 0 ? void 0 : record.operator)
}, {
  title: '更新时间',
  dataIndex: 'modifiedTime',
  width: 140,
  render: (text, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, moment__WEBPACK_IMPORTED_MODULE_3___default()(record === null || record === void 0 ? void 0 : record.modifiedTime).format('YYYY/MM/DD HH:mm:ss'))
}];

/***/ }),

/***/ 2714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(71577);
/* harmony import */ var antd_es_table_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66456);
/* harmony import */ var antd_es_table__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(97423);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(91896);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(57016);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82682);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24731);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(68855);



















var statusMap = new Map([[1, '待开始'], [2, '进行中'], [3, '成功'], [4, '失败']]);
var columns = [// { title: '任务ID', dataIndex: 'taskId' },
{
  title: '任务',
  dataIndex: 'taskName',
  render: taskName => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("span", null, taskName)
}, {
  title: '申请时间 ',
  dataIndex: 'taskCreateTime',
  render: taskCreateTime => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("span", null, moment__WEBPACK_IMPORTED_MODULE_6___default()(taskCreateTime).format('YYYY-MM-DD HH:mm:ss'))
}, {
  title: '生成时间',
  dataIndex: 'taskEffectiveTime',
  render: (taskEffectiveTime, record) => Number(record.taskStatus) !== 2 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("span", null, " ", moment__WEBPACK_IMPORTED_MODULE_6___default()(taskEffectiveTime).format('YYYY-MM-DD HH:mm:ss')) : '-'
}, {
  title: '申请人',
  dataIndex: 'creator'
}, {
  title: '状态',
  dataIndex: 'taskStatus',
  render: taskStatus => statusMap.get(Number(taskStatus))
}, {
  title: '操作',
  dataIndex: 'taskUrl',
  render: taskUrl => {
    var props = {
      download: taskUrl,
      disabled: !(taskUrl !== null && taskUrl !== void 0 && taskUrl.length),
      href: taskUrl,
      target: '_blank'
    };
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("a", props, "\u4E0B\u8F7D");
  }
}];

var AsyncExport = props => {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState5, 2),
      exportTaskId = _useState6[0],
      setExportTaskId = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState7, 2),
      dataSource = _useState8[0],
      setDataSource = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState9, 2),
      total = _useState10[0],
      setTotal = _useState10[1];

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
    page: 1,
    size: 10
  }),
      _useState12 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState11, 2),
      page = _useState12[0],
      setPage = _useState12[1];

  var getList = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)().mark(function _callee() {
      var type, params, url, _yield$ypRider, _yield$ypRider$result, result, success, list, _total;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!visible || loading)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              type = props.params.type;

              if (type) {
                type = [43, 45];
              } else {
                type = [1];
              }

              _context.prev = 4;
              params = {
                // tenantId: cookie.get('tenantId'), // 租户id,
                tenantId: 1,
                phone: js_cookie__WEBPACK_IMPORTED_MODULE_5___default().get('mobile'),
                // 登录用户手机号码,
                page: page.page,
                // 任务列表页码,
                size: page.size,
                // 任务列表每页的条数
                taskType: type
              }; //  message.info('type'+type+"   str:"+JSON.stringify(params))

              console.log('type' + type + "   str:" + JSON.stringify(params));
              url = _Api__WEBPACK_IMPORTED_MODULE_7__/* .masterApi.queryTaskList */ .ZH.queryTaskList;
              setLoading(true);
              _context.next = 11;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(url, params);

            case 11:
              _yield$ypRider = _context.sent;
              _yield$ypRider$result = _yield$ypRider.result;
              result = _yield$ypRider$result === void 0 ? {} : _yield$ypRider$result;
              success = _yield$ypRider.success;
              list = result.list, _total = result.total;
              setLoading(false);

              if (success) {
                setDataSource(list);
                setTotal(_total);
              }

              _context.next = 24;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](4);
              setLoading(false);
              console.log(_context.t0);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 20]]);
    }));

    return function getList() {
      return _ref.apply(this, arguments);
    };
  }();

  var onPageChange = (page, size) => {
    setPage({
      page,
      size
    });
  };

  var onShowSizeChange = (_page, size) => {
    setPage({
      page: 1,
      size
    });
  };

  var exportFn = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)().mark(function _callee2() {
      var params, url, _yield$ypRider2, result, success;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = props.params, url = props.url;
              setLoading(true); // const url = masterApi.downloadSgMerchantItem

              _context2.prev = 2;
              _context2.next = 5;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(url, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)({}, params), {}, {
                phone: js_cookie__WEBPACK_IMPORTED_MODULE_5___default().get('mobile')
              }));

            case 5:
              _yield$ypRider2 = _context2.sent;
              result = _yield$ypRider2.result;
              success = _yield$ypRider2.success;
              setLoading(false);
              setExportTaskId(result);
              if (success) antd_es_message__WEBPACK_IMPORTED_MODULE_13__.default.success('创建导出任务成功,您可以查看导出列表关注导出动态');
              _context2.next = 17;
              break;

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](2);
              setLoading(false);
              console.log(_context2.t0);

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 13]]);
    }));

    return function exportFn() {
      return _ref2.apply(this, arguments);
    };
  }();

  var exportPurchaseGoodsFn = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)().mark(function _callee3() {
      var params, url, _yield$ypRider3, result, success;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              params = props.params, url = props.url;
              console.log('params', params);
              setLoading(true); // const url = masterApi.downloadSgMerchantItem

              _context3.prev = 3;
              _context3.next = 6;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_7__/* .masterApi.exportSiteGoodsPurchaseInfo */ .ZH.exportSiteGoodsPurchaseInfo, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)({}, params), {}, {
                phone: js_cookie__WEBPACK_IMPORTED_MODULE_5___default().get('mobile')
              }));

            case 6:
              _yield$ypRider3 = _context3.sent;
              result = _yield$ypRider3.result;
              success = _yield$ypRider3.success;
              setLoading(false);
              setExportTaskId(result);
              if (success) antd_es_message__WEBPACK_IMPORTED_MODULE_13__.default.success('创建导出任务成功,您可以查看导出列表关注导出动态');
              _context3.next = 18;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](3);
              setLoading(false);
              console.log(_context3.t0);

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 14]]);
    }));

    return function exportPurchaseGoodsFn() {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * 地点商品导出商品
   */


  var shopGoodsExport = () => {
    antd_es_modal__WEBPACK_IMPORTED_MODULE_14__/* .default.confirm */ .Z.confirm({
      title: '导出提示',
      icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z, null),
      content: '商品明细导出限制50万条上限，超过请分批导出',
      okText: '导出',
      cancelText: '取消',

      onOk() {
        exportFn();
      }

    });
  };

  var useTable = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => {
    var _tableProps = {
      columns,
      rowKey: 'taskId',
      scroll: {
        y: 340
      },
      pagination: {
        showQuickJumper: true,
        current: page.page,
        total: total,
        pageSize: page.size,
        onChange: onPageChange,
        showSizeChanger: true,
        onShowSizeChange: onShowSizeChange
      }
    };
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_table__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)({
      key: "taskId"
    }, _tableProps, {
      dataSource: dataSource
    }));
  }, [dataSource, page, total]);
  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    if (visible) getList();
  }, [visible, page]);
  var _modalProps = {
    key: 'exportListModal',
    title: '导出历史',
    width: 800,
    maskClosable: true
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row-reverse'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
    key: "exportListBtn",
    onClick: () => setVisible(true),
    style: {
      marginLeft: 12
    }
  }, "\u5BFC\u51FA\u5386\u53F2"), props.type === 'SHOP_GOODS' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
    type: "primary",
    onClick: exportPurchaseGoodsFn,
    disabled: props.disabled,
    style: {
      marginLeft: 12
    }
  }, "\u5BFC\u51FA\u91C7\u8D2D\u4FE1\u606F"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
    type: "primary",
    onClick: props.type === 'SHOP_GOODS' ? shopGoodsExport : exportFn,
    disabled: props.disabled
  }, "\u5BFC\u51FA\u5546\u54C1"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)({
    visible: visible,
    onOk: () => setVisible(false),
    onCancel: () => setVisible(false)
  }, _modalProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", null, "\u5DF2\u751F\u6210\u7684\u62A5\u8868\u7CFB\u7EDF\u6700\u591A\u4FDD\u75597\u5929"), useTable));
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(AsyncExport));

/***/ }),

/***/ 25428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vo": function() { return /* reexport */ myInputNumber; },
  "qS": function() { return /* reexport */ FormItem; },
  "E7": function() { return /* reexport */ myPopover/* default */.Z; },
  "I$": function() { return /* reexport */ MyTitle; },
  "UI": function() { return /* reexport */ searchForm; },
  "xS": function() { return /* reexport */ components_simpleTable; }
});

// UNUSED EXPORTS: MyStatistic

// NAMESPACE OBJECT: ./src/pages/GoodsManage/GoodStock/components/searchForm/Fields.tsx
var Fields_namespaceObject = {};
__webpack_require__.r(Fields_namespaceObject);
__webpack_require__.d(Fields_namespaceObject, {
  "CHECKBOX": function() { return CHECKBOX; },
  "COMMON_INPUT": function() { return COMMON_INPUT; },
  "COMMON_INPUT_NUMBER": function() { return COMMON_INPUT_NUMBER; },
  "COMMON_TYPE_SELECT": function() { return COMMON_TYPE_SELECT; },
  "DATE_RANGE": function() { return DATE_RANGE; },
  "FOREGROUND_CATEGORY": function() { return FOREGROUND_CATEGORY; },
  "GOODS_BRAND": function() { return GOODS_BRAND; },
  "GOODS_CATEGORY": function() { return GOODS_CATEGORY; },
  "GOODS_CATEGORY_CATGE": function() { return GOODS_CATEGORY_CATGE; },
  "GOODS_CATEGORY_T": function() { return GOODS_CATEGORY_T; },
  "GOODS_MERCHANT": function() { return GOODS_MERCHANT; },
  "GOODS_SHOP": function() { return GOODS_SHOP; },
  "GOODS_SHOP_T": function() { return GOODS_SHOP_T; },
  "GOODS_SHOP_TREE": function() { return GOODS_SHOP_TREE; },
  "ITEM_TAGS": function() { return ITEM_TAGS; },
  "RADIO": function() { return RADIO; },
  "SCENE_CATEGORY": function() { return SCENE_CATEGORY; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/myTitle.tsx

function MyTitle(props) {
  return /*#__PURE__*/react.createElement("div", {
    id: "content-title"
  }, /*#__PURE__*/react.createElement("span", null), props.title);
}
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/myItem.tsx


function FormItem(props) {
  var labelChildren = props.label;
  return /*#__PURE__*/react.createElement("div", {
    className: "my-item ".concat(props.class || '', " ").concat(props.row ? 'row' : '')
  }, /*#__PURE__*/react.createElement("div", {
    className: "".concat(props.required ? 'requeired' : '', " item-label"),
    style: {
      width: "".concat(props.span, "0%")
    }
  }, labelChildren), /*#__PURE__*/react.createElement("div", {
    className: "item-value"
  }, props.children));
}
// EXTERNAL MODULE: ./node_modules/antd/es/table/style/index.js
var style = __webpack_require__(66456);
// EXTERNAL MODULE: ./node_modules/antd/es/table/index.js + 45 modules
var table = __webpack_require__(97423);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/index.js
var message_style = __webpack_require__(34792);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(48086);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/simpleTable.tsx











message.default.config({
  top: 100
});

var simpleTable = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _useState = (0,react.useState)({}),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      tableData = _useState2[0],
      setTableData = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      selectedRowKeys = _useState4[0],
      setSelectedRowKeys = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      selectedRows = _useState6[0],
      setSelectedRows = _useState6[1];

  var _useState7 = (0,react.useState)({}),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      pagination = _useState8[0],
      setPagination = _useState8[1];

  var onSelectChange = (selectedKeys, selectedRows) => {
    setSelectedRowKeys(selectedKeys);
    setSelectedRows(selectedRows);
    (props === null || props === void 0 ? void 0 : props.setRowKeys) && props.setRowKeys(selectedKeys, selectedRows);
  };

  var onPageChange = (page, size) => {
    props.handlePage && props.handlePage({
      page,
      size
    });
  };

  var onShowSizeChange = (_page, size) => {
    props.handlePage && props.handlePage({
      page: 1,
      size
    });
  };

  if (ref) {
    ref.current = {
      selectedRowKeys,
      selectedRows
    };
  }

  (0,react.useEffect)(() => {
    if (props.page) {
      var obj = {
        showQuickJumper: true,
        current: props.page.page,
        total: props.page.total,
        pageSize: props.page.size,
        pageSizeOptions: ['10', '30', '50', '100'],
        onChange: onPageChange,
        showSizeChanger: true,
        onShowSizeChange: onShowSizeChange,
        showTotal: total => "\u5171".concat(total, "\u6761")
      };
      setPagination(obj);
    } else {
      setPagination(false);
    }
  }, [props.page]);
  (0,react.useEffect)(() => {
    var multiSelect = props.multiSelect,
        dataSource = props.dataSource;
    var params = {
      dataSource: props.rowKey ? dataSource : dataSource.map(i => {
        return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, i), {}, {
          edittable_: (0,lodash.uniqueId)('edittable_')
        });
      })
    };

    if (multiSelect) {
      var rowSelection = (0,objectSpread2/* default */.Z)({
        selectedRowKeys,
        onChange: onSelectChange
      }, multiSelect);

      params['rowSelection'] = rowSelection;
    }

    setTableData(params);
  }, [selectedRowKeys, props.dataSource]);

  var calculateFunc = () => {
    var _props$scrollYSize = props.scrollYSize,
        scrollYSize = _props$scrollYSize === void 0 ? 0 : _props$scrollYSize;

    if (scrollYSize) {
      return scrollYSize;
    }

    var clientHeight = document.body.clientHeight;
    var ele = document.getElementById('simple-tablePart');

    if (ele) {
      var top = ele.getBoundingClientRect().top;
      var TOP_DIST = 70; // 上边距

      var BOTTOM_DIST = 65; // 下边距

      var scrollY = clientHeight - top - TOP_DIST - BOTTOM_DIST;
      return scrollY;
    }
  };

  var scrollProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props.scroll), {}, {
    y: calculateFunc()
  }); //   console.log(props.dataSource)


  return /*#__PURE__*/react.createElement("div", {
    className: "simple-table",
    id: "simple-tablePart"
  }, /*#__PURE__*/react.createElement(table/* default */.Z, (0,esm_extends/* default */.Z)({}, tableData, {
    size: "small" // dataSource={props.dataSource}
    ,
    columns: props.columns,
    rowKey: props.rowKey ? props.rowKey : 'edittable_',
    bordered: false,
    scroll: scrollProps,
    pagination: pagination
  })));
});
/* harmony default export */ var components_simpleTable = (/*#__PURE__*/(0,react.memo)(simpleTable));
// EXTERNAL MODULE: ./node_modules/antd/es/input-number/style/index.js
var input_number_style = __webpack_require__(77883);
// EXTERNAL MODULE: ./node_modules/antd/es/input-number/index.js + 2 modules
var input_number = __webpack_require__(39635);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/myInputNumber.tsx






var MyInputNumber = props => {
  var placeholder = props.placeholder,
      index = props.index,
      dataKey = props.dataKey,
      value = props.value,
      max = props.max,
      min = props.min,
      addonBefore = props.addonBefore,
      addonAfter = props.addonAfter,
      disabled = props.disabled;
  return /*#__PURE__*/react.createElement("div", {
    id: "my-input-number"
  }, addonBefore ? /*#__PURE__*/react.createElement("span", {
    className: "addon"
  }, addonBefore) : null, /*#__PURE__*/react.createElement(input_number/* default */.Z, (0,esm_extends/* default */.Z)({
    value: value,
    disabled: disabled,
    onChange: e => props.onChange(e, index, dataKey),
    placeholder: placeholder,
    min: min,
    max: max,
    precision: 2,
    className: "".concat(addonBefore ? 'addon-before' : '', " ").concat(addonAfter ? 'addon-after' : '')
  }, props)), addonAfter ? /*#__PURE__*/react.createElement("span", {
    className: "addon2"
  }, addonAfter) : null);
};

/* harmony default export */ var myInputNumber = (MyInputNumber);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js
var createForOfIteratorHelper = __webpack_require__(91220);
// EXTERNAL MODULE: ./node_modules/antd/es/col/style/index.js
var col_style = __webpack_require__(89032);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/row/style/index.js
var row_style = __webpack_require__(13062);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var button_style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./src/pages/GoodsManage/GoodStock/Api/index.ts
var Api = __webpack_require__(82682);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/searchForm/hooks.tsx


function useEventListener(eventName, handler) {
  var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;
  var saveHandler = useRef();
  useEffect(() => {
    saveHandler.current = handler;
  }, [handler]);
  useEffect(() => {
    var isSupported = element && element.addEventListener;
    if (!isSupported) return;

    var eventListener = event => saveHandler.current(event);

    element.addEventListener(eventName, e => {
      var event = null;

      if (window.event) {
        event = window.event;
      }

      var code = e.charCode || event.keyCode;

      if (code === 13) {
        eventListener(e);
      }
    });
    return () => {
      element.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element]);
} // 展开收起按钮hooks

var formfieldsLen = 8;
function useSliderBtn() {
  var formfields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : formfieldsLen;
  var usefulFields = (0,react.useMemo)(() => formfields.filter(Boolean), [formfields]);

  var _useState = (0,react.useState)(true),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      slideForm = _useState2[0],
      setSlideForm = _useState2[1];

  var _useState3 = (0,react.useState)(usefulFields),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      fields = _useState4[0],
      setFields = _useState4[1];

  var num = number || formfieldsLen; // 如果不传参，则默认收起时展示4个表单项

  var toggleForm = () => setSlideForm(v => !v);

  (0,react.useEffect)(() => {
    if (slideForm) {
      var list = usefulFields.slice(0, num - 1);
      setFields(list);
    } else {
      setFields(usefulFields);
    }
  }, [slideForm, usefulFields, num]); // 如果表单项比较小

  if (usefulFields.length < formfieldsLen) {
    return [fields, null];
  }

  return [fields, /*#__PURE__*/react.createElement("a", {
    key: "btn",
    style: {
      minWidth: '30px'
    },
    onClick: toggleForm
  }, slideForm ? '展开' : '收起')];
}
// EXTERNAL MODULE: ./node_modules/antd/es/checkbox/style/index.js
var checkbox_style = __webpack_require__(63185);
// EXTERNAL MODULE: ./node_modules/antd/es/checkbox/index.js + 2 modules
var es_checkbox = __webpack_require__(9676);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(93224);
// EXTERNAL MODULE: ./node_modules/antd/es/input/style/index.js
var input_style = __webpack_require__(47673);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 3 modules
var input = __webpack_require__(4107);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/style/index.js
var date_picker_style = __webpack_require__(14965);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/index.js + 6 modules
var date_picker = __webpack_require__(11448);
// EXTERNAL MODULE: ./node_modules/antd/es/select/style/index.js
var select_style = __webpack_require__(43358);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js
var es_select = __webpack_require__(34041);
// EXTERNAL MODULE: ./src/pages/GoodsManage/GoodStock/components/searchForm/searchSelect/index.ts + 9 modules
var searchSelect = __webpack_require__(16152);
// EXTERNAL MODULE: ./node_modules/moment/locale/zh-cn.js
var zh_cn = __webpack_require__(83839);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/locale/zh_CN.js + 1 modules
var zh_CN = __webpack_require__(87121);
// EXTERNAL MODULE: ./node_modules/antd/es/tree-select/style/index.js
var tree_select_style = __webpack_require__(62999);
// EXTERNAL MODULE: ./node_modules/antd/es/tree-select/index.js + 40 modules
var tree_select = __webpack_require__(57119);
// EXTERNAL MODULE: ./src/.umi-production/core/umiExports.ts + 18 modules
var umiExports = __webpack_require__(71720);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/StoresSelect/index.tsx




/**
 * 店群门店树形选择（新版-根据全部数据展开）
 * 杭州-杭州一区-杭州xx门店
 * 适配调价管理
 */


var SHOW_PARENT = tree_select/* default.SHOW_PARENT */.Z.SHOW_PARENT; // SHOW_ALL SHOW_PARENT
// const { SHOW_ALL } = TreeSelect; // SHOW_ALL SHOW_PARENT

/** 渠道选择枚举 */
var enumYT;

(function (enumYT) {
  enumYT[enumYT["\u8C0A\u54C1\u5230\u5BB6"] = 1] = "\u8C0A\u54C1\u5230\u5BB6";
  enumYT[enumYT["\u5305\u90AE"] = 2] = "\u5305\u90AE";
  enumYT[enumYT["\u8C0A\u54C1\u751F\u9C9C"] = 3] = "\u8C0A\u54C1\u751F\u9C9C";
  enumYT[enumYT["\u8C0A\u6279\u5B9D"] = 4] = "\u8C0A\u6279\u5B9D";
  enumYT[enumYT["\u5916\u5356"] = 5] = "\u5916\u5356";
})(enumYT || (enumYT = {}));

var getSubMerchantType = (arr, value) => {
  var _arr = arr.filter(e => e.value === value);

  return _arr !== null && _arr !== void 0 && _arr.length ? _arr[0].subMerchantType : '';
};
var _getPID = (arr, value) => {
  var _arr = arr.filter(e => e.value === value);

  return _arr !== null && _arr !== void 0 && _arr.length ? _arr[0].pId : '';
};
/** 获取父id */

var getPID = (arr, value) => {
  var _arr$, _merchantIdList$filte;

  var _arr = arr.filter(e => e.id === value);

  if (((_arr$ = _arr[0]) === null || _arr$ === void 0 ? void 0 : _arr$.subMerchantType) === 16) {
    return _arr[0].pId || '';
  } // 处理店群数据, 根据当前商家数据，与arr匹配，如果找到该数据是店群数据


  var _merchantIdList = arr.filter(e => e.pId === '0').map(e => e.value);

  if (_arr !== null && _arr !== void 0 && _arr.length && (_merchantIdList$filte = _merchantIdList.filter(e => {
    var _arr$2;

    return (e === null || e === void 0 ? void 0 : e.id) === ((_arr$2 = _arr[0]) === null || _arr$2 === void 0 ? void 0 : _arr$2.pId);
  })) !== null && _merchantIdList$filte !== void 0 && _merchantIdList$filte.length) {
    return _arr[0].pId;
  }

  if (_arr !== null && _arr !== void 0 && _arr.length && _arr[0].pId !== '0') {
    //  根据门店找到店群，则往上继续追溯到商户id，
    return _getPID(arr, _arr[0].pId);
  }

  return _arr !== null && _arr !== void 0 && _arr.length ? _arr[0].pId : '';
};

var StoresSelect = props => {
  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      curValue = _useState2[0],
      setcurValue = _useState2[1]; // 当前值


  var shopList = props.shopList,
      _props$treeCheckable = props.treeCheckable,
      treeCheckable = _props$treeCheckable === void 0 ? true : _props$treeCheckable,
      _props$showCheckedStr = props.showCheckedStrategy,
      showCheckedStrategy = _props$showCheckedStr === void 0 ? SHOW_PARENT : _props$showCheckedStr,
      placeholder = props.placeholder;

  var _useState3 = (0,react.useState)([]),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      curTreeData = _useState4[0],
      setcurTreeData = _useState4[1]; // 内部树数据结构


  var _useState5 = (0,react.useState)(enumYT['谊品生鲜']),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      curYTSelect = _useState6[0],
      setcurYTSelect = _useState6[1]; // 当前业态选择


  var _useSelector = (0,umiExports/* useSelector */.v9)(state => state.goodsStore),
      merchantList = _useSelector.merchantList;

  var dispatch = (0,umiExports/* useDispatch */.I0)();
  (0,react.useEffect)(() => {
    dispatch({
      type: 'goodsStore/handleQueryLocationData',
      payload: props === null || props === void 0 ? void 0 : props.params
    });
  }, [props === null || props === void 0 ? void 0 : props.params]);
  (0,react.useEffect)(() => {
    setcurTreeData(merchantList);
  }, [merchantList]);
  /**
   * 数据改变
   * @param value 当前值
   * @param label 标签
   * @param extra
   */

  var _onChange = (value, label, extra) => {
    console.log('value', value);

    if (props !== null && props !== void 0 && props.onChange) {
      setcurValue(value);
      var _arr = [];

      if (curTreeData && curTreeData !== null && curTreeData !== void 0 && curTreeData.length) {
        value.forEach(e => {
          _arr.push({
            siteId: e,
            subMerchantType: getSubMerchantType(curTreeData, e),
            merchantId: getPID(curTreeData, e)
          });
        });
      }

      props.onChange(_arr, curTreeData);
    }
  };
  /**
   * 提示
   */
  // const tips = useMemo(() => {
  //   const _tip = curValue.length ? `已选择${curValue.length}个门店` : ''
  //   return `选择门店 ${_tip}`
  // }, [curValue])


  (0,react.useEffect)(() => {
    if (props.treeData) {
      setcurTreeData(props.treeData);
    }
  }, [props.treeData]);
  (0,react.useEffect)(() => {
    setcurValue(shopList);
  }, [shopList]);

  var radioChange = e => {
    var _e$target;

    console.log('e', e);
    setcurYTSelect(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
  };

  return /*#__PURE__*/react.createElement("div", {
    id: "my-tree-select"
  }, /*#__PURE__*/react.createElement(tree_select/* default */.Z, {
    value: curValue !== null && curValue !== void 0 ? curValue : undefined,
    dropdownStyle: {
      maxHeight: 400,
      overflow: 'auto'
    },
    onChange: _onChange,
    treeData: curTreeData,
    multiple: true,
    treeCheckable: treeCheckable,
    maxTagCount: 1 // showCheckedStrategy={showCheckedStrategy}
    ,
    placeholder: placeholder || '请输入商家/门店名称',
    allowClear: props.allowClear,
    showSearch: true,
    treeDefaultExpandAll: props.treeDefaultExpandAll || false,
    style: {
      width: '100%'
    },
    treeDataSimpleMode: true,
    treeNodeFilterProp: "title" // 开启按title搜索

  }));
};

/* harmony default export */ var components_StoresSelect = (StoresSelect);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/searchForm/Fields.tsx












var _excluded = ["field", "onChange"],
    _excluded2 = ["field", "onChange"];





var Option = es_select/* default.Option */.Z.Option;
var RangePicker = date_picker/* default.RangePicker */.Z.RangePicker;
var COMMON_INPUT = _ref => {
  var field = _ref.field,
      value = _ref.value,
      placeholder = _ref.placeholder,
      _onChange = _ref.onChange,
      initialValue = _ref.initialValue;
  return /*#__PURE__*/react.createElement(input/* default */.Z, {
    type: "text",
    placeholder: placeholder,
    value: value ? value : initialValue || null,
    onChange: e => _onChange(e, field)
  });
};
var COMMON_INPUT_NUMBER = _ref2 => {
  var field = _ref2.field,
      value = _ref2.value,
      placeholder = _ref2.placeholder,
      _onChange2 = _ref2.onChange;
  return /*#__PURE__*/react.createElement(input_number/* default */.Z, {
    placeholder: placeholder,
    value: value ? value : null,
    onChange: e => _onChange2(e, field)
  });
};
var COMMON_TYPE_SELECT = _ref3 => {
  var field = _ref3.field,
      value = _ref3.value,
      placeholder = _ref3.placeholder,
      _onChange3 = _ref3.onChange,
      initialValue = _ref3.initialValue,
      fieldOptions = _ref3.fieldOptions,
      list = _ref3.list;
  return /*#__PURE__*/react.createElement(es_select/* default */.Z, (0,esm_extends/* default */.Z)({
    showSearch: true,
    placeholder: placeholder,
    value: value ? value : initialValue || initialValue === null ? initialValue : undefined,
    filterOption: (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
    onChange: e => _onChange3(e, field)
  }, fieldOptions), list.length && list.map(i => {
    return /*#__PURE__*/react.createElement(Option, {
      value: i.value,
      key: i.value
    }, i.name);
  }));
};
var GOODS_MERCHANT = _ref4 => {
  var field = _ref4.field,
      _onChange4 = _ref4.onChange,
      other = (0,objectWithoutProperties/* default */.Z)(_ref4, _excluded);

  return /*#__PURE__*/react.createElement(searchSelect/* MerchantSearch */.cO, (0,esm_extends/* default */.Z)({
    onChange: e => _onChange4(e, field)
  }, other));
};
var ITEM_TAGS = _ref5 => {
  var field = _ref5.field,
      _onChange5 = _ref5.onChange,
      other = (0,objectWithoutProperties/* default */.Z)(_ref5, _excluded2);

  return /*#__PURE__*/react.createElement(searchSelect/* ItemTagSearch */.iN, (0,esm_extends/* default */.Z)({
    onChange: e => _onChange5(e, field)
  }, other));
};
var GOODS_CATEGORY = _ref6 => {
  var field = _ref6.field,
      apis = _ref6.apis,
      value = _ref6.value,
      onChange = _ref6.onChange,
      params = _ref6.params;
  return /*#__PURE__*/react.createElement(searchSelect/* MyTreeSelect */.lO, {
    api: apis,
    setCategoryId: e => onChange(e, field),
    categoryId: value ? value : undefined,
    params: params ? params : {}
  });
};
var GOODS_CATEGORY_T = _ref7 => {
  var field = _ref7.field,
      apis = _ref7.apis,
      value = _ref7.value,
      onChange = _ref7.onChange;
  return /*#__PURE__*/react.createElement(searchSelect/* MyTreeSelectCategory */.vu, {
    api: apis,
    setCategoryId: e => onChange(e, field),
    categoryId: value ? value : undefined
  });
};
var GOODS_CATEGORY_CATGE = _ref8 => {
  var field = _ref8.field,
      apis = _ref8.apis,
      value = _ref8.value,
      onChange = _ref8.onChange;
  return /*#__PURE__*/react.createElement(searchSelect/* CategoryCascaderCatge */.a3, {
    setCategoryId: e => onChange(e, field),
    categoryId: value || []
  });
};
var FOREGROUND_CATEGORY = _ref9 => {
  var field = _ref9.field,
      apis = _ref9.apis,
      merchantId = _ref9.merchantId,
      value = _ref9.value,
      onChange = _ref9.onChange;
  return /*#__PURE__*/react.createElement(searchSelect/* MyTreeSelectForegroundCategory */.vc, {
    api: apis,
    merchantId: merchantId,
    setCategoryId: (e, treeData) => onChange(e, field, treeData),
    secondCategoryId: value ? value : undefined
  });
};
var GOODS_SHOP = _ref10 => {
  var field = _ref10.field,
      value = _ref10.value,
      merchantId = _ref10.merchantId,
      placeholder = _ref10.placeholder,
      _onChange6 = _ref10.onChange,
      setShopList = _ref10.setShopList;
  return /*#__PURE__*/react.createElement(searchSelect/* ShopSearch */.zD, {
    placeholder: placeholder,
    value: value ? value : undefined,
    setShopList: setShopList,
    onChange: e => _onChange6(e, field),
    merchantId: merchantId
  });
};
var GOODS_SHOP_T = _ref11 => {
  var field = _ref11.field,
      value = _ref11.value,
      merchantId = _ref11.merchantId,
      placeholder = _ref11.placeholder,
      _onChange7 = _ref11.onChange,
      setShopList = _ref11.setShopList,
      initialValue = _ref11.initialValue;
  return /*#__PURE__*/react.createElement(searchSelect/* ShopSearch2 */.cc, {
    placeholder: placeholder,
    value: value ? value : undefined,
    initialValue: initialValue ? initialValue : undefined,
    setShopList: setShopList,
    onChange: e => _onChange7(e, field),
    merchantId: merchantId
  });
};
var GOODS_BRAND = _ref12 => {
  var field = _ref12.field,
      value = _ref12.value,
      placeholder = _ref12.placeholder,
      _onChange8 = _ref12.onChange,
      initialValue = _ref12.initialValue;
  return /*#__PURE__*/react.createElement(searchSelect/* BrandSearch */.hP, {
    placeholder: placeholder,
    value: value ? value : initialValue.length ? initialValue : undefined,
    onChange: e => _onChange8(e, field)
  });
};
var RADIO = _ref13 => {
  var field = _ref13.field,
      value = _ref13.value,
      placeholder = _ref13.placeholder,
      _onChange9 = _ref13.onChange,
      initialValue = _ref13.initialValue,
      dataList = _ref13.dataList;
  return /*#__PURE__*/react.createElement(es_checkbox/* default.Group */.Z.Group, {
    onChange: e => _onChange9(e, field),
    options: dataList,
    defaultValue: initialValue
  });
};
var CHECKBOX = _ref14 => {
  var field = _ref14.field,
      value = _ref14.value,
      _onChange10 = _ref14.onChange,
      initialValue = _ref14.initialValue,
      label = _ref14.label;
  return /*#__PURE__*/react.createElement(es_checkbox/* default */.Z, {
    onChange: e => _onChange10(e.target.checked, field),
    checked: value,
    defaultChecked: initialValue
  }, label);
};
var DATE_RANGE = _ref15 => {
  var field = _ref15.field,
      value = _ref15.value,
      placeholder = _ref15.placeholder,
      _onChange11 = _ref15.onChange,
      initialValue = _ref15.initialValue,
      disabledDate = _ref15.disabledDate;
  return /*#__PURE__*/react.createElement(RangePicker, {
    locale: zh_CN/* default */.Z,
    value: value !== null && value !== void 0 && value.length ? value : [] // defaultValue={initialValue}
    ,
    format: "YYYY-MM-DD",
    onChange: e => _onChange11(e, field) // disabledDate={disabledDate}

  });
};
var SCENE_CATEGORY = _ref16 => {
  var field = _ref16.field,
      apis = _ref16.apis,
      value = _ref16.value,
      onChange = _ref16.onChange,
      params = _ref16.params,
      result = _ref16.result,
      placeholder = _ref16.placeholder;
  return /*#__PURE__*/react.createElement(searchSelect/* SceneTreeSelect */.Fk, {
    api: apis,
    setCategoryId: e => onChange(e, field),
    categoryId: value ? value : undefined,
    params: params,
    result: result,
    placeholder: placeholder
  });
};
var GOODS_SHOP_TREE = _ref17 => {
  var field = _ref17.field,
      apis = _ref17.apis,
      value = _ref17.value,
      onChange = _ref17.onChange,
      params = _ref17.params,
      result = _ref17.result,
      placeholder = _ref17.placeholder;
  return /*#__PURE__*/react.createElement(components_StoresSelect, {
    style: {
      width: 300
    },
    placeholder: placeholder,
    allowClear: true,
    shopList: result,
    params: params,
    onChange: onChange
  });
};
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/searchForm/index.tsx

















var Fields = Fields_namespaceObject;
var SearchForm = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var searchStorage = props.storageKey || '';

  var _useSliderBtn = useSliderBtn(props.formJson),
      _useSliderBtn2 = (0,slicedToArray/* default */.Z)(_useSliderBtn, 2),
      formfields = _useSliderBtn2[0],
      btnElement = _useSliderBtn2[1];

  var _useState = (0,react.useState)({}),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      formParams = _useState2[0],
      setFormParams = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      merchantList = _useState4[0],
      setMerchantList = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      shopList = _useState6[0],
      setShopList = _useState6[1];

  var _useState7 = (0,react.useState)([]),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      curShopSelect = _useState8[0],
      setcurShopSelect = _useState8[1];
  /** 当前门店 */


  var _useState9 = (0,react.useState)([]),
      _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
      curShopIdList = _useState10[0],
      setcurShopIdList = _useState10[1];

  var _useState11 = (0,react.useState)(false),
      _useState12 = (0,slicedToArray/* default */.Z)(_useState11, 2),
      shopIsChanged = _useState12[0],
      setshopIsChanged = _useState12[1];

  var _useState13 = (0,react.useState)([]),
      _useState14 = (0,slicedToArray/* default */.Z)(_useState13, 2),
      merchants = _useState14[0],
      setMerchants = _useState14[1];

  var renderBtn = () => {
    if (!(formfields !== null && formfields !== void 0 && formfields.length)) return null;
    var len = formfields === null || formfields === void 0 ? void 0 : formfields.length;
    var remainder = len % 4;
    var span = remainder === 0 ? 24 : (4 - remainder) * 6;
    return /*#__PURE__*/react.createElement(col/* default */.Z, {
      span: span,
      key: "btns",
      className: "search-btns"
    }, /*#__PURE__*/react.createElement(row/* default */.Z, {
      className: "rowItem"
    }, /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      type: "primary",
      id: "search-btn",
      onClick: handleSubmit,
      htmlType: "submit"
    }, "\u67E5\u8BE2"), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      onClick: reset
    }, "\u91CD\u7F6E"), btnElement));
  };

  var renderItem = (item, child) => {
    var label = item.label,
        field = item.field,
        _item$hiddenLabel = item.hiddenLabel,
        hiddenLabel = _item$hiddenLabel === void 0 ? false : _item$hiddenLabel;
    return /*#__PURE__*/react.createElement(col/* default */.Z, {
      span: 6,
      key: field
    }, /*#__PURE__*/react.createElement(row/* default */.Z, {
      className: "rowItem"
    }, /*#__PURE__*/react.createElement(col/* default */.Z, {
      span: 8,
      className: "itemLabel"
    }, hiddenLabel ? null : label), /*#__PURE__*/react.createElement(col/* default */.Z, {
      span: 16,
      className: "itemValue"
    }, child)));
  };

  var onChange = (e, key, validateMsg, args) => {
    var value = e && e.target ? e.target.value : e;

    if (validateMsg && !value) {
      message.default.info(validateMsg);

      return false;
    }

    var obj = (0,objectSpread2/* default */.Z)({}, formParams);

    if (key === 'merchantId') {
      obj[key] = value;
      obj['shopId'] = '';
      obj['secondCategoryId'] = null;
    } else if (key === 'goodsId') {
      var data = '';

      if (Array.isArray(value)) {
        data = value.join(' ');
      } else data = value !== null && value !== void 0 && value.length ? value : [];

      obj[key] = data;
    } else if (key === 'hiddenWareHouseGoodsFlag') {
      obj[key] = value[0];
    } else {
      obj[key] = value;
    }

    setFormParams(obj);
  };

  var handleSubmit = () => {
    // e && e.preventDefault();
    var params = (0,objectSpread2/* default */.Z)({}, formParams);

    if (props.needStorage && searchStorage) sessionStorage.setItem(searchStorage, JSON.stringify(params));
    setFormParams(params);
    props.handleSearch(params);
  };

  var reset = () => {
    var fieldsValue = (0,objectSpread2/* default */.Z)({}, formParams);

    console.log(fieldsValue, searchStorage, props.needStorage, 'reset--reset');

    for (var i in fieldsValue) {
      if (!['merchantId', 'shopIds', 'shopId', 'merchantIds'].includes(i)) {
        console.log('if----icludes');
        fieldsValue[i] = null;
        setcurShopIdList(null);
      } else if (props.needClearShopId && i === 'shopId') {
        fieldsValue.shopId = null;
        console.log('else--else');
      } else if (['siteIdList'].includes(i)) {
        fieldsValue[i] = undefined; // setcurShopIdList([])
      }
    }

    if (props.needStorage && searchStorage) {
      sessionStorage.setItem(searchStorage, '{}');
    }

    setFormParams(fieldsValue);
    props.resetSearch(fieldsValue);
  };

  var handleMerchant = list => {
    setMerchantList(list);
  };

  var handleShop = list => {
    setShopList(list);
  };

  var array2obj = function array2obj() {
    var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var obj = {};

    var fun = arr => {
      var _iterator = (0,createForOfIteratorHelper/* default */.Z)(arr),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _item$childCategory;

          var item = _step.value;
          obj[item.categoryId] = item;

          if (item !== null && item !== void 0 && (_item$childCategory = item.childCategory) !== null && _item$childCategory !== void 0 && _item$childCategory.length) {
            fun(item.childCategory);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };

    fun(array);
    return obj;
  };
  /**
   * 渲染searchForm
   */


  var renderElement = (0,react.useCallback)(item => {
    if (!Fields[item.type]) return null;

    var options = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, item), {}, {
      value: formParams[item.field],
      onChange: onChange
    });

    if (item.type === 'GOODS_MERCHANT' && !item.mode) {
      options = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, options), {}, {
        setMerchantList: handleMerchant
      });
    } else if (item.type === 'GOODS_MERCHANT' && item.mode) {
      options = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, options), {}, {
        setMerchantList: handleMerchant,
        onChange: v => {
          setFormParams((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formParams), {}, {
            merchantIds: v
          }));
          setMerchants(v);
        },
        onFirstChange: v => {
          props.handleSearch((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formParams), {}, {
            merchantIds: v
          }));
          setMerchants(v);
        }
      });
    } else if (item.type === 'GOODS_SHOP') {
      options = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, options), {}, {
        merchantId: formParams['merchantId'],
        setShopList: handleShop,
        multiple: props.multiShop ? true : false
      });
    } else if (['GOODS_CATEGORY', 'CATEGORY_TREE'].includes(item.type)) {
      options = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, options), {}, {
        apis: Api/* masterApi.getBackCategoryTree */.ZH.getBackCategoryTree
      });
    } else if (['FOREGROUND_CATEGORY'].includes(item.type)) {
      options = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, options), {}, {
        merchantId: formParams['merchantId'],
        apis: 'pms.sgMerchantItemManageService.queryWebCategory',
        onChange: (v, f, tree) => {
          var _obj$v, _obj$v$childCategory, _obj$v2;

          var obj = array2obj(tree);
          var ids = (_obj$v = obj[v]) === null || _obj$v === void 0 ? void 0 : (_obj$v$childCategory = _obj$v.childCategory) === null || _obj$v$childCategory === void 0 ? void 0 : _obj$v$childCategory.map(ele => ele.categoryId);
          setFormParams((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formParams), {}, {
            secondCategoryId: v,
            // 组建展示
            secondCategoryIds: ((_obj$v2 = obj[v]) === null || _obj$v2 === void 0 ? void 0 : _obj$v2.level) === 2 ? [v] : ids // 传参数

          }));
        }
      });
    } else if (item.type === 'SCENE_CATEGORY') {
      options = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, options), {}, {
        params: {
          status: 1
        },
        apis: 'kernel.console.SceneCategoryQueryService.searchSceneCategoryTree'
      });
    } else if (item.type === 'GOODS_SHOP_TREE') {
      options = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, options), {}, {
        result: curShopIdList,
        params: merchants,
        onChange: (siteArr, curTreeData) => {
          setshopIsChanged(true);
          setcurShopIdList(siteArr !== null && siteArr !== void 0 && siteArr.length ? siteArr.map(e => {
            return e === null || e === void 0 ? void 0 : e.siteId;
          }) : []);
          var arr = [];

          if (curTreeData !== null && curTreeData !== void 0 && curTreeData.length) {
            siteArr.forEach(e => {
              // 采用门店选择模式，返回所有门店，则无需level 16就是配送中心
              arr.push({
                level: 2,
                siteId: e === null || e === void 0 ? void 0 : e.siteId,
                merchantId: e === null || e === void 0 ? void 0 : e.merchantId,
                subMerchantType: e === null || e === void 0 ? void 0 : e.subMerchantType
              });
            });
            arr = handleShopSelect(arr);
            setcurShopSelect(arr);
            setFormParams((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formParams), {}, {
              siteIdList: arr // 组建展示

            }));
          }
        }
      });
    }

    var child = Fields[item.type](options);
    return renderItem(item, child);
  }, [formParams, merchantList]);
  /** 处理详情接口返回shop数据, 根据当前树数据和merchantIdlist，siteid匹配到对应的数据 */

  var handleShopSelect = curShopSelect => {
    var arr = [];
    var merchantArr = [];
    curShopSelect.forEach(e => {
      arr.push({
        siteId: e.siteId,
        merchantId: e.merchantId,
        level: e.level,
        subMerchantType: e.subMerchantType
      });
      merchantArr.push({
        siteId: e.merchantId,
        level: e.level
      });
    });
    merchantArr = (0,lodash.uniqBy)(merchantArr, 'siteId');
    arr = arr.concat(merchantArr);
    return arr;
  };

  var _useState15 = (0,react.useState)({
    siteArr: [],
    merchantArr: []
  }),
      _useState16 = (0,slicedToArray/* default */.Z)(_useState15, 2),
      treeState = _useState16[0],
      settreeState = _useState16[1];

  (0,react.useEffect)(() => {
    var _treeState$siteArr;

    if (merchantList !== null && merchantList !== void 0 && merchantList.length && treeState !== null && treeState !== void 0 && (_treeState$siteArr = treeState.siteArr) !== null && _treeState$siteArr !== void 0 && _treeState$siteArr.length) {
      handleTreeArr(merchantList, treeState);
    }
  }, [merchantList, treeState]);
  /** 默认匹配树数据 */

  var handleTreeArr = (merchantList, treeState) => {
    var arr = JSON.parse(JSON.stringify(merchantList)); //新数组

    arr.map(e => {
      if ((e === null || e === void 0 ? void 0 : e.subMerchantType) === 16) {
        var _e$pId;

        e.value = e === null || e === void 0 ? void 0 : e.id.substring(0, (e === null || e === void 0 ? void 0 : e.id.length) - (e === null || e === void 0 ? void 0 : (_e$pId = e.pId) === null || _e$pId === void 0 ? void 0 : _e$pId.length));
      }
    });
    var _shopTreeArr = [];

    var handleMatchVal = (arr, matchVal) => {
      var i = false;
      arr.forEach(e => {
        if (matchVal.indexOf(e) !== -1) {
          // 如果改pid是属于店群
          i = true;
        }
      });
      console.log('i', i);
      return i;
    };

    arr.forEach(e => {
      var isBelong = (treeState === null || treeState === void 0 ? void 0 : treeState.siteArr.includes(e.value)) && (treeState === null || treeState === void 0 ? void 0 : treeState.merchantArr.includes(e.pId));
      var isBelongTo = (treeState === null || treeState === void 0 ? void 0 : treeState.siteArr.includes(e.value)) && handleMatchVal(treeState === null || treeState === void 0 ? void 0 : treeState.merchantArr, e.pId);

      if (isBelong || isBelongTo) {
        if ((e === null || e === void 0 ? void 0 : e.subMerchantType) === 16) {
          e.value = e.id;
        }

        _shopTreeArr.push(e);
      }
    });

    var newSArr = _shopTreeArr.map(e => {
      return {
        siteId: e.id,
        subMerchantType: e.subMerchantType,
        level: 2,
        merchantId: e.id,
        pId: e.pId
      };
    });

    if (!shopIsChanged) {
      // 如果当前未从选择器更改数据
      treeState.merchantArr.forEach(e => {
        newSArr.push({
          siteId: e,
          level: 2
        });
      });
    }

    setcurShopSelect(newSArr);
    console.log('_shopTreeArr', _shopTreeArr);
    setcurShopIdList(_shopTreeArr.map(e => e.id));
  };
  /**
   * 设置默认商家
   */


  var defaultMerchant = (0,react.useCallback)(() => {
    if (!(merchantList !== null && merchantList !== void 0 && merchantList.length)) return;
    if (!props.needDefaultMerchant) return;
    var ids = merchantList.map(i => i.merchantId);
    var _formParams$merchantI = formParams.merchantId,
        merchantId = _formParams$merchantI === void 0 ? null : _formParams$merchantI;

    if (!merchantId) {
      setFormParams((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formParams), {}, {
        merchantId: ids[0] // 没有merchantId默认选第一个

      }));
    }
  }, [formParams, merchantList]);
  var defaultShop = (0,react.useCallback)(() => {
    if (!(merchantList !== null && merchantList !== void 0 && merchantList.length)) return;
    if (!props.needDefaultShop) return;
    var _formParams$merchantI2 = formParams.merchantId,
        merchantId = _formParams$merchantI2 === void 0 ? null : _formParams$merchantI2;

    if (merchantId && shopList !== null && shopList !== void 0 && shopList.length) {
      // 是否需要默认选营业部
      var list = shopList.length ? shopList.map(i => i.siteId) : [];
      setFormParams((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formParams), {}, {
        shopId: list[0]
      }));
    }
  }, [formParams, shopList]);

  if (ref) {
    ref.current = {
      resetFields: reset
    };
  }

  (0,react.useEffect)(() => {
    if (!props.needStorage) return;
    var sessionSearch = sessionStorage.getItem(searchStorage);
    var params = JSON.parse(sessionSearch) || {};

    if (!(0,lodash.isEmpty)(params)) {
      setFormParams(params);
    }
  }, [props.needStorage, searchStorage]);
  (0,react.useEffect)(() => {
    if (merchantList !== null && merchantList !== void 0 && merchantList.length) {
      defaultMerchant();
      props.setMerchantList && props.setMerchantList(merchantList);
    }
  }, [merchantList]);
  (0,react.useEffect)(() => {
    if (shopList !== null && shopList !== void 0 && shopList.length) {
      props.needDefaultShop && defaultShop();
      props.setShopList && props.setShopList(shopList);
    }
  }, [shopList, props.needDefaultShop]);
  (0,react.useEffect)(() => {
    if (!(0,lodash.isEmpty)(formParams)) {
      var _formParams$shopIds = formParams.shopIds,
          shopIds = _formParams$shopIds === void 0 ? [] : _formParams$shopIds,
          merchantId = formParams.merchantId,
          shopId = formParams.shopId;

      if (formParams.hasOwnProperty('merchantId')) {
        var item = merchantList.filter(i => i.merchantId === merchantId)[0] || {};
        props.setMerchant && props.setMerchant(item, formParams);
        props.setShop && props.setShop(item, props.multiShop ? shopIds : shopId, formParams);
      }

      props.saveShop && props.saveShop(props.multiShop ? shopIds : shopId, formParams);
    }
  }, [formParams, merchantList]);
  return /*#__PURE__*/react.createElement("div", {
    id: "serachFrom",
    key: searchStorage
  }, /*#__PURE__*/react.createElement(row/* default */.Z, {
    className: "search-row"
  }, formfields.map(renderElement), renderBtn()));
});
/* harmony default export */ var searchForm = (/*#__PURE__*/(0,react.memo)(SearchForm));
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/myStatistic.tsx


function MyStatistic(props) {
  return /*#__PURE__*/React.createElement("div", {
    id: "my-statistic"
  }, /*#__PURE__*/React.createElement("div", {
    className: "unusual"
  }, /*#__PURE__*/React.createElement(ExclamationCircleFilled, {
    style: {
      color: '#F7BB24',
      marginRight: '10px'
    }
  }), props.text ? props.text : null, props.child ? props.child() : null));
}
// EXTERNAL MODULE: ./src/pages/GoodsManage/GoodStock/components/myPopover.tsx
var myPopover = __webpack_require__(49978);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/index.ts









/***/ }),

/***/ 50307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wY": function() { return /* binding */ Multiply; },
/* harmony export */   "p3": function() { return /* binding */ Divide; },
/* harmony export */   "ZR": function() { return /* binding */ limitDecimalsNum; },
/* harmony export */   "ed": function() { return /* binding */ limitDecimalsThree; },
/* harmony export */   "hg": function() { return /* binding */ limitDecimalsThree1; },
/* harmony export */   "Xe": function() { return /* binding */ limitLength; },
/* harmony export */   "gV": function() { return /* binding */ limitNum1; }
/* harmony export */ });
/* unused harmony exports Add, Subtract, decimalFixed, limitDecimals, limitDecimalsLength, limitNum, limitOneDecimals */
// 加法函数
var Add = (arg1, arg2) => {
  var r1;
  var r2;
  var m;
  var c;

  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }

  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }

  c = Math.abs(r1 - r2);
  m = Math.pow(10, Math.max(r1, r2));

  if (c > 0) {
    var cm = Math.pow(10, c);

    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace('.', ''));
      arg2 = Number(arg2.toString().replace('.', '')) * cm;
    } else {
      arg1 = Number(arg1.toString().replace('.', '')) * cm;
      arg2 = Number(arg2.toString().replace('.', ''));
    }
  } else {
    arg1 = Number(arg1.toString().replace('.', ''));
    arg2 = Number(arg2.toString().replace('.', ''));
  }

  return (arg1 + arg2) / m;
}; // 减法函数

var Subtract = (arg1, arg2) => {
  var r1 = 0;
  var r2 = 0;
  var m;

  try {
    r1 = String(arg1).split('.')[1].length;
  } catch (e) {}

  try {
    r2 = String(arg2).split('.')[1].length;
  } catch (e) {}

  m = Math.pow(10, Math.max(r1, r2));
  arg1 = Number(arg1) * m;
  arg2 = Number(arg2) * m;
  return (arg1 - arg2) / m;
}; // 乘法函数

var Multiply = (arg1, arg2) => {
  var m = 0;
  var s1 = String(arg1);
  var s2 = String(arg2);

  try {
    m += s1.split('.')[1].length;
  } catch (e) {}

  try {
    m += s2.split('.')[1].length;
  } catch (e) {}

  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
}; // 除法函数

var Divide = (num1, num2) => {
  var baseNum1 = 0;
  var baseNum2 = 0;
  var baseNum3;
  var baseNum4;

  try {
    baseNum1 = num1.toString().split('.')[1].length;
  } catch (e) {
    baseNum1 = 0;
  }

  try {
    baseNum2 = num2.toString().split('.')[1].length;
  } catch (e) {
    baseNum2 = 0;
  }

  baseNum3 = Number(String(num1).replace('.', ''));
  baseNum4 = Number(String(num2).replace('.', ''));
  return baseNum3 / baseNum4 * Math.pow(10, baseNum2 - baseNum1);
};
/**
 * 判断小数点后几位
 * @param {判断的数值} number
 */

var decimalFixed = number => {
  if (!number) return;
  var num = Number(number);
  var str = String(number);
  if (num === 0) return 0;
  if (str.indexOf('.') === -1) return 0;
  return str.split('.')[1].length;
};
/**
 * 限制小数点后两位输入
 * @param {*} value
 */

var limitDecimals = (value, len) => {
  var reg = /^(\-)*(\d+)\.(\d\d).*$/;

  if (typeof value === 'string') {
    if (String(value).length > len) {
      return value.replace(reg, '$1$2.$3').slice(0, len);
    } else {
      return !isNaN(Number(value)) ? value.slice(0, len).replace(reg, '$1$2.$3') : '';
    }
  } else if (typeof value === 'number') {
    if (String(value).length > len) {
      return Number(String(value).replace(reg, '$1$2.$3').slice(0, len));
    } else {
      return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : '';
    }
  } else {
    return '';
  }
};
/**
 * 限制小数2位 大小
 * @param value
 * @param len
 */

var limitDecimalsNum = (value, num) => {
  var reg = /^(\-)*(\d+)\.(\d\d).*$/;

  if (typeof value === 'string') {
    if (!isNaN(Number(value))) {
      return Number(value) > num ? num : value.replace(reg, '$1$2.$3');
    } else {
      return !isNaN(parseFloat(value)) ? String(parseFloat(value)).replace(reg, '$1$2.$3') : '';
    }
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : '';
  } else {
    return '';
  }
};
/**
 * 限制小数点后三位输入
 * @param {*} value
 */

var limitDecimalsThree = (value, num) => {
  var reg = /^(\-)*(\d+)\.(\d\d\d).*$/;

  if (typeof value === 'string') {
    return Number(value) > num ? String(num) : value.replace(reg, '$1$2.$3');
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : '';
  } else {
    return '';
  }
};
var limitDecimalsThree1 = function limitDecimalsThree1(value) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 999999.999;
  //   const reg = /^(\d+)(\.\d{1.3}){0,1}$/
  //   if (reg.test(value)) {
  //     return Number(value) > max ? String(max) : String(value)
  //   }
  //   else {
  //     return value.replace(/^(0+)|[^\d]+/g, '')
  //   }
  var reg = /^(\-)*(\d+)(\.[\d]{1,3})?.*$/;

  if (typeof value === 'string') {
    return Number(value) > max ? String(max) : value.replace(reg, '$2$3');
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '$2.$3') : '';
  } else {
    return '';
  }
};
/**
 * 限制正数 长度
 * @param value
 * @param len
 */

var limitDecimalsLength = (value, len) => {
  var reg = /^(\-)*(\d+)\.(\d\d).*$/;

  if (typeof value === 'string') {
    if (!isNaN(Number(value))) {
      return String(value).length > len ? String(parseFloat(value)).slice(0, len).replace(reg, '$1$2.$3') : value.replace(reg, '$1$2.$3');
    } else {
      return !isNaN(parseFloat(value)) ? String(parseFloat(value)).replace(reg, '$1$2.$3') : '';
    }
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : '';
  } else {
    return '';
  }
};
/**
 * 限制正整数 长度:
 * @param {*} value
 */

var limitLength = (value, len) => {
  var reg = /[^\-?\d]/g;

  if (typeof value === 'string') {
    if (!isNaN(Number(value))) {
      return String(value).length > len ? String(parseFloat(value)).slice(0, len).replace(reg, '') : value.replace(reg, '');
    } else {
      return !isNaN(parseFloat(value)) ? String(parseFloat(value)).replace(reg, '') : '';
    }
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '') : '';
  } else {
    return '';
  }
};
/**
 * 限制整数
 * @param {*} value
 */

var limitNum = (value, num) => {
  var reg = /[^\-?\d]/g;

  if (typeof value === 'string') {
    if (!isNaN(Number(value))) {
      return num ? Number(value) > num ? String(num) : value.replace(reg, '') : value;
    } else {
      return !isNaN(parseFloat(value)) ? String(parseFloat(value)).replace(reg, '') : '';
    }
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '') : '';
  } else {
    return '';
  }
};
var limitNum1 = function limitNum1(value) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 999999;
  var reg = /^\d+$/;

  if (reg.test(value)) {
    return Number(value) > max ? String(max) : String(value);
  } else {
    return value.replace(/^(0+)|[^\d]+/g, '');
  } //   return /^\d+$/.test(value) ? (Number(value) > max ? String(max) : String(value)) : ''

};
/**
 * 限制小数点后一位輸入
 * @param {*} value
 */

var limitOneDecimals = (value, num) => {
  // if (value === '') return ''
  var reg = /^(\-)*(\d+)\.(\d).*$/;

  if (typeof value === 'string') {
    if (!isNaN(Number(value))) {
      return Number(value) > num ? num : value.replace(reg, '$1$2.$3');
    } else {
      return !isNaN(parseFloat(value)) ? String(parseFloat(value)).replace(reg, '$1$2.$3') : '';
    }
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : '';
  } else {
    return '';
  }
};

/***/ }),

/***/ 49978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_popover_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20136);
/* harmony import */ var antd_es_popover__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55241);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var Tips = props => {
  var _props$list, _props$list2, _props$list3;

  var _content = () => {
    var list = Array.from(new Set(props.list));
    if (!(list !== null && list !== void 0 && list.length)) return false;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "tips-wrap"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("ul", null, list.map((i, k) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("li", {
      key: k + 1
    }, i))));
  };

  var ele = props !== null && props !== void 0 && (_props$list = props.list) !== null && _props$list !== void 0 && _props$list.length ? props.list[0] : '';
  var _props$title = props.title,
      title = _props$title === void 0 ? '商品条码' : _props$title;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "tips"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, ele), props !== null && props !== void 0 && (_props$list2 = props.list) !== null && _props$list2 !== void 0 && _props$list2.length ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_popover__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    content: () => _content(),
    title: title
  }, (props === null || props === void 0 ? void 0 : (_props$list3 = props.list) === null || _props$list3 === void 0 ? void 0 : _props$list3.length) > 1 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
    style: {
      color: '#1890ff',
      cursor: 'pointer'
    }
  }, "\u66F4\u591A") : undefined) : null);
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(Tips));

/***/ }),

/***/ 16152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hP": function() { return /* reexport */ brandSearch; },
  "a3": function() { return /* reexport */ searchSelect_CategoryCascaderCatge; },
  "iN": function() { return /* reexport */ itemTagSearch/* default */.Z; },
  "cO": function() { return /* reexport */ merchantSearch; },
  "lO": function() { return /* reexport */ myTreeSelect; },
  "vu": function() { return /* reexport */ myTreeSelectCategory; },
  "vc": function() { return /* reexport */ MyTreeSelectForegroundCategory; },
  "Fk": function() { return /* reexport */ sceneTreeSelect; },
  "zD": function() { return /* reexport */ shopSearch; },
  "cc": function() { return /* reexport */ shopSearch2; }
});

// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/antd/es/select/style/index.js
var style = __webpack_require__(43358);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js
var es_select = __webpack_require__(34041);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/pages/GoodsManage/GoodStock/Api/index.ts
var Api = __webpack_require__(82682);
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/searchForm/searchSelect/brandSearch.tsx










var Option = es_select/* default.Option */.Z.Option;

function useSearch(search) {
  var debounceRef = (0,react.useRef)();

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      brandList = _useState2[0],
      setBrand = _useState2[1];

  (0,react.useEffect)(() => {
    if (debounceRef.current) {
      if (search) {
        debounceRef.current(search);
      }
    } else {
      debounceRef.current = (0,lodash.debounce)( /*#__PURE__*/function () {
        var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(search) {
          var url, params, res, result, success;
          return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  url = Api/* apiList.fuzzyQueryBrandByName */.X9.fuzzyQueryBrandByName;
                  params = {
                    brandName: search
                  };
                  _context.prev = 2;
                  _context.next = 5;
                  return (0,ypRequest/* default */.Z)(url, params);

                case 5:
                  res = _context.sent;
                  result = res.result, success = res.success;

                  if (success) {
                    setBrand(result);
                  }

                  _context.next = 13;
                  break;

                case 10:
                  _context.prev = 10;
                  _context.t0 = _context["catch"](2);
                  console.log(_context.t0);

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 10]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }(), 300);
    }
  }, [search]);
  return [brandList, setBrand];
}

var BrandSearch = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _useState3 = (0,react.useState)(''),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      search = _useState4[0],
      setSearch = _useState4[1];

  var _useSearch = useSearch(search),
      _useSearch2 = (0,slicedToArray/* default */.Z)(_useSearch, 1),
      brandList = _useSearch2[0];

  return /*#__PURE__*/react.createElement(es_select/* default */.Z, (0,esm_extends/* default */.Z)({
    allowClear: true,
    defaultActiveFirstOption: false,
    filterOption: false,
    showSearch: true,
    onSearch: val => setSearch(val)
  }, props), brandList.map(item => /*#__PURE__*/react.createElement(Option, {
    key: item.brandId,
    value: item.brandId || undefined
  }, item.brandName)));
});
/* harmony default export */ var brandSearch = (BrandSearch);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/searchForm/searchSelect/merchantSearch.tsx










var merchantSearch_Option = es_select/* default.Option */.Z.Option;
var MerchantSearch = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      merchantList = _useState2[0],
      setMerchantList = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      merchantId = _useState4[0],
      setMerchantId = _useState4[1];

  var _useState5 = (0,react.useState)(undefined),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      firstInitialValue = _useState6[0],
      setFirstInitialValue = _useState6[1];

  var queryMerchant = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
      var url, params, _yield$ypRider, result, success, data, list;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // const url = masterApi.queryYpShengXianMerchant
              url = Api/* apiList.queryUserMerchantList */.X9.queryUserMerchantList;
              params = {
                tenantId: 1,
                phone: js_cookie_default().get('mobile')
              };
              _context.prev = 2;
              _context.next = 5;
              return (0,ypRequest/* default */.Z)(url);

            case 5:
              _yield$ypRider = _context.sent;
              result = _yield$ypRider.result;
              success = _yield$ypRider.success;

              if (success) {
                data = result === null || result === void 0 ? void 0 : result.list.filter(ele => !ele.switchSx);
                list = data.map(item => {
                  return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, item), item.merchantInfo);
                });
                setMerchantList(list);
                props.setMerchantList && props.setMerchantList(list);
              }

              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              console.log(_context.t0);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 11]]);
    }));

    return function queryMerchant() {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(() => {
    if (!merchantList.length) queryMerchant();
  }, []); //默认展示第一个

  (0,react.useEffect)(() => {
    if (props.hasInitialValue && merchantList.length) {
      var _merchantList$, _merchantList$2;

      setFirstInitialValue((_merchantList$ = merchantList[0]) === null || _merchantList$ === void 0 ? void 0 : _merchantList$.merchantId);
      (props === null || props === void 0 ? void 0 : props.onFirstChange) && (props === null || props === void 0 ? void 0 : props.onFirstChange([(_merchantList$2 = merchantList[0]) === null || _merchantList$2 === void 0 ? void 0 : _merchantList$2.merchantId]));
    }
  }, [merchantList]);
  return /*#__PURE__*/react.createElement(es_select/* default */.Z, {
    allowClear: true,
    mode: props === null || props === void 0 ? void 0 : props.mode,
    maxTagCount: 1,
    defaultActiveFirstOption: false,
    showSearch: true,
    filterOption: (input, option) => {
      var _option$children, _option$children$toLo;

      return (option === null || option === void 0 ? void 0 : (_option$children = option.children) === null || _option$children === void 0 ? void 0 : (_option$children$toLo = _option$children.toLowerCase()) === null || _option$children$toLo === void 0 ? void 0 : _option$children$toLo.indexOf(input === null || input === void 0 ? void 0 : input.toLowerCase())) >= 0;
    },
    value: props.value === null ? undefined : props.value || firstInitialValue,
    onChange: props.onChange,
    placeholder: props.placeholder // {...props}

  }, merchantList.map(item => /*#__PURE__*/react.createElement(merchantSearch_Option, {
    key: item.merchantId,
    value: item.merchantId || undefined
  }, item.merchantName)));
});
/* harmony default export */ var merchantSearch = (MerchantSearch);
// EXTERNAL MODULE: ./src/pages/GoodsManage/GoodStock/components/searchForm/searchSelect/itemTagSearch.tsx
var itemTagSearch = __webpack_require__(62817);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/searchForm/searchSelect/shopSearch.tsx








var shopSearch_Option = es_select/* default.Option */.Z.Option;
var ShopSearch = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      shopList = _useState2[0],
      setShopList = _useState2[1];

  var queryShop = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(merchantId) {
      var url, params, _yield$ypRider, result, success, list, shops;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = Api/* salesApi.querySiteInfoByCodeOrName */.Ct.querySiteInfoByCodeOrName;
              params = {
                merchantId,
                siteCode: '',
                siteName: '',
                page: 1
              };
              _context.prev = 2;
              _context.next = 5;
              return (0,ypRequest/* default */.Z)(url, params);

            case 5:
              _yield$ypRider = _context.sent;
              result = _yield$ypRider.result;
              success = _yield$ypRider.success;

              if (success) {
                list = result.list;
                shops = [{
                  siteCode: null,
                  siteId: null,
                  siteName: "全部"
                }].concat(list);
                setShopList(shops);
                props.setShopList && props.setShopList(list);
              }

              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              console.log(_context.t0);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 11]]);
    }));

    return function queryShop(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(() => {
    var _props$merchantId;

    if (props !== null && props !== void 0 && (_props$merchantId = props.merchantId) !== null && _props$merchantId !== void 0 && _props$merchantId.length) {
      queryShop(props.merchantId);
    }
  }, [props.merchantId]);
  return /*#__PURE__*/react.createElement(es_select/* default */.Z, {
    allowClear: true,
    defaultActiveFirstOption: false,
    showSearch: true,
    filterOption: (input, option) => {
      var _option$children, _option$children$toLo;

      return (option === null || option === void 0 ? void 0 : (_option$children = option.children) === null || _option$children === void 0 ? void 0 : (_option$children$toLo = _option$children.toLowerCase()) === null || _option$children$toLo === void 0 ? void 0 : _option$children$toLo.indexOf(input === null || input === void 0 ? void 0 : input.toLowerCase())) >= 0;
    },
    value: props.value || null,
    onChange: props.onChange
  }, (shopList === null || shopList === void 0 ? void 0 : shopList.length) && shopList.map(item => /*#__PURE__*/react.createElement(shopSearch_Option, {
    key: item.siteId,
    value: item.siteId
  }, item.siteName))); // }
});
/* harmony default export */ var shopSearch = (ShopSearch);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/searchForm/searchSelect/shopSearch2.tsx








var shopSearch2_Option = es_select/* default.Option */.Z.Option;
var shopSearch2_ShopSearch = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      shopList = _useState2[0],
      setShopList = _useState2[1];

  var _merchantId = sessionStorage.getItem('_czMerchantId');

  var _czCategoryShopId = sessionStorage.getItem('_czCategoryShopId');

  var queryShop = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(merchantId) {
      var url, params, _yield$ypRider, result, success, list;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = Api/* salesApi.querySiteInfoByCodeOrName */.Ct.querySiteInfoByCodeOrName;
              params = {
                merchantId,
                siteCode: '',
                siteName: '',
                page: 1
              };
              _context.prev = 2;
              _context.next = 5;
              return (0,ypRequest/* default */.Z)(url, params);

            case 5:
              _yield$ypRider = _context.sent;
              result = _yield$ypRider.result;
              success = _yield$ypRider.success;

              if (success) {
                list = result.list; // const shops = [{
                //     siteCode: 'null',
                //     siteId: 'null',
                //     siteName: "全部",
                // }].concat(list)
                // setShopList(shops)

                setShopList(list);
                props.setShopList && props.setShopList(list);
              }

              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              console.log(_context.t0);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 11]]);
    }));

    return function queryShop(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(() => {
    // if (props?.merchantId?.length) {
    //     queryShop(props.merchantId)
    // }
    queryShop(_merchantId);
  }, [_merchantId]);

  var onSelectChange = e => {
    sessionStorage.removeItem('_czCategoryShopId');
    props.onChange(e);
  }; // if (props.initialValue) {


  return /*#__PURE__*/react.createElement(es_select/* default */.Z, {
    mode: "multiple",
    allowClear: true,
    defaultActiveFirstOption: false,
    showSearch: true,
    filterOption: (input, option) => {
      var _option$children, _option$children$toLo;

      return (option === null || option === void 0 ? void 0 : (_option$children = option.children) === null || _option$children === void 0 ? void 0 : (_option$children$toLo = _option$children.toLowerCase()) === null || _option$children$toLo === void 0 ? void 0 : _option$children$toLo.indexOf(input === null || input === void 0 ? void 0 : input.toLowerCase())) >= 0;
    },
    value: _czCategoryShopId || props.value || null // defaultValue={a || null}
    ,
    onChange: onSelectChange
  }, (shopList === null || shopList === void 0 ? void 0 : shopList.length) && shopList.map(item => /*#__PURE__*/react.createElement(shopSearch2_Option, {
    key: item.siteId,
    value: item.siteId
  }, item.siteName))); //   } else {
  //   return (
  //       <Select
  //           allowClear
  //           defaultActiveFirstOption={false}
  //           showSearch
  //           filterOption={(input: any, option: any) =>
  //               option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
  //           }
  //           value={props.value || null}
  //           onChange={props.onChange}
  //       >
  //           {shopList?.length && shopList.map((item: any) => (
  //               <Option key={item.siteId} value={item.siteId}>
  //                   {item.siteName}
  //               </Option>
  //           ))}
  //       </Select>
  //   )
  // }
});
/* harmony default export */ var shopSearch2 = (shopSearch2_ShopSearch);
// EXTERNAL MODULE: ./node_modules/antd/es/tree-select/style/index.js
var tree_select_style = __webpack_require__(62999);
// EXTERNAL MODULE: ./node_modules/antd/es/tree-select/index.js + 40 modules
var tree_select = __webpack_require__(57119);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/searchForm/searchSelect/myTreeSelect.tsx







var TreeNode = tree_select/* default.TreeNode */.Z.TreeNode;
var MyTreeSelect = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      treeData = _useState2[0],
      setTreeData = _useState2[1];

  (0,react.useEffect)(() => {
    getTreeData();
  }, []);

  var getTreeData = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
      var url, params, res, result, success, _result$childBackCate, childBackCategory;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = props.api;
              params = props.params;
              _context.prev = 2;
              _context.next = 5;
              return (0,ypRequest/* default */.Z)(url, params);

            case 5:
              res = _context.sent;
              result = res.result, success = res.success;

              if (success) {
                _result$childBackCate = result.childBackCategory, childBackCategory = _result$childBackCate === void 0 ? [] : _result$childBackCate;
                setTreeData(childBackCategory);
              }

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              console.log(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 10]]);
    }));

    return function getTreeData() {
      return _ref.apply(this, arguments);
    };
  }();

  var renderTreeNode = treeData => {
    if (!treeData) return;
    return treeData.map((item, key) => {
      if (item.childBackCategory) {
        return /*#__PURE__*/react.createElement(TreeNode, {
          value: item.backCategoryId,
          title: item.backCategoryName,
          key: item.backCategoryId
        }, renderTreeNode(item.childBackCategory));
      } else {
        return /*#__PURE__*/react.createElement(TreeNode, {
          value: item.backCategoryId,
          title: item.backCategoryName,
          key: item.backCategoryId
        });
      }
    });
  };

  var onTreeChange = e => {
    props.setCategoryId(e);
  };

  return /*#__PURE__*/react.createElement("div", {
    id: "my-tree-select"
  }, /*#__PURE__*/react.createElement(tree_select/* default */.Z, {
    treeDataSimpleMode: true,
    style: {
      width: '100%'
    },
    value: props.categoryId || undefined,
    dropdownStyle: {
      maxHeight: 400,
      overflow: 'auto'
    },
    placeholder: "\u8BF7\u9009\u62E9\u5546\u54C1\u7C7B\u76EE",
    onChange: onTreeChange,
    allowClear: true
  }, renderTreeNode(treeData)));
});
/* harmony default export */ var myTreeSelect = (MyTreeSelect);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/searchForm/searchSelect/myTreeSelectCategory.tsx







var myTreeSelectCategory_TreeNode = tree_select/* default.TreeNode */.Z.TreeNode;
var myTreeSelectCategory_MyTreeSelect = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      treeData = _useState2[0],
      setTreeData = _useState2[1];

  var _czCategoryCategoryId = sessionStorage.getItem('_czCategoryCategoryId') === 'undefined' ? null : sessionStorage.getItem('_czCategoryCategoryId');

  (0,react.useEffect)(() => {
    getTreeData();
  }, []);

  var getTreeData = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
      var url, params, res, result, success, _result$childBackCate, childBackCategory;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = 'pms.backCategoryManage.getBackCategoryTree';
              params = {};
              _context.prev = 2;
              _context.next = 5;
              return (0,ypRequest/* default */.Z)(url, params);

            case 5:
              res = _context.sent;
              result = res.result, success = res.success;

              if (success) {
                _result$childBackCate = result.childBackCategory, childBackCategory = _result$childBackCate === void 0 ? [] : _result$childBackCate;
                setTreeData(childBackCategory);
              }

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              console.log(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 10]]);
    }));

    return function getTreeData() {
      return _ref.apply(this, arguments);
    };
  }();

  var renderTreeNode = treeData => {
    if (!treeData) return;
    return treeData.map((item, key) => {
      if (item.childBackCategory) {
        return /*#__PURE__*/react.createElement(myTreeSelectCategory_TreeNode, {
          value: item.backCategoryId,
          title: item.backCategoryName,
          key: item.backCategoryId
        }, renderTreeNode(item.childBackCategory));
      } else {
        return /*#__PURE__*/react.createElement(myTreeSelectCategory_TreeNode, {
          value: item.backCategoryId,
          title: item.backCategoryName,
          key: item.backCategoryId
        });
      }
    });
  };

  var onTreeChange = e => {
    sessionStorage.removeItem('_czCategoryCategoryId');
    props.setCategoryId(e);
  };

  return /*#__PURE__*/react.createElement("div", {
    id: "my-tree-select"
  }, /*#__PURE__*/react.createElement(tree_select/* default */.Z, {
    treeDataSimpleMode: true,
    allowClear: true,
    style: {
      width: '100%'
    },
    value: _czCategoryCategoryId || props.categoryId || null,
    dropdownStyle: {
      maxHeight: 400,
      overflow: 'auto'
    },
    placeholder: "\u8BF7\u9009\u62E9\u5546\u54C1\u7C7B\u76EE",
    onChange: onTreeChange
  }, renderTreeNode(treeData)));
});
/* harmony default export */ var myTreeSelectCategory = (myTreeSelectCategory_MyTreeSelect);
// EXTERNAL MODULE: ./node_modules/antd/es/cascader/style/index.js
var cascader_style = __webpack_require__(36877);
// EXTERNAL MODULE: ./node_modules/antd/es/cascader/index.js + 5 modules
var cascader = __webpack_require__(34366);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/searchForm/searchSelect/CategoryCascaderCatge.tsx






// import { apiList } from "@config/api"

var timer = null;

var useCascader = setCategoryId => {
  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      options = _useState2[0],
      setOptions = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      lever = _useState4[0],
      setLever = _useState4[1];

  var onChange = value => {
    setCategoryId(value);
  };

  var loadData = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(selectedOptions) {
      var targetOption;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(selectedOptions.length > 2)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              targetOption = selectedOptions[selectedOptions.length - 1];
              targetOption.loading = true;
              timer = setTimeout( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
                return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        targetOption.loading = false;
                        _context.next = 3;
                        return getData(targetOption.value);

                      case 3:
                        targetOption.children = _context.sent;
                        setOptions([...options]);

                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })), 500);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function loadData(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var getData = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3(id) {
      var url, params, res, _yield$ypRider, result, success;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              url = 'pms.backCategoryService.querySubBackCategoryListByHeadId';
              params = {
                headCatId: id ? parseInt(id, 10) : null
              };
              res = [];
              _context3.prev = 3;
              _context3.next = 6;
              return (0,ypRequest/* default */.Z)(url, params);

            case 6:
              _yield$ypRider = _context3.sent;
              result = _yield$ypRider.result;
              success = _yield$ypRider.success;

              if (success) {
                res = result.map(item => {
                  return {
                    value: item.backCategoryId,
                    label: item.backCategoryName,
                    isLeaf: item.level === 4 ? true : false
                  };
                });

                if (!id) {
                  setOptions(res);
                }
              }

              _context3.next = 15;
              break;

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](3);
              console.log(_context3.t0);

            case 15:
              return _context3.abrupt("return", res);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 12]]);
    }));

    return function getData(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(() => {
    if (!options.length) getData(null);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  return [options, loadData, onChange];
};

var CategoryCascaderCatge = props => {
  var _useCascader = useCascader(props.setCategoryId),
      _useCascader2 = (0,slicedToArray/* default */.Z)(_useCascader, 3),
      options = _useCascader2[0],
      loadData = _useCascader2[1],
      onChange = _useCascader2[2];

  return /*#__PURE__*/react.createElement(cascader/* default */.Z, {
    style: {
      width: '100%'
    },
    value: props.categoryId,
    options: options,
    loadData: loadData,
    onChange: onChange,
    changeOnSelect: true
  });
};

/* harmony default export */ var searchSelect_CategoryCascaderCatge = (CategoryCascaderCatge);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/searchForm/searchSelect/MyTreeSelectForegroundCategory.tsx







var MyTreeSelectForegroundCategory_TreeNode = tree_select/* default.TreeNode */.Z.TreeNode;
var MyTreeSelectForegroundCategory_MyTreeSelect = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      treeData = _useState2[0],
      setTreeData = _useState2[1];

  (0,react.useEffect)(() => {
    getTreeData();
  }, [props.merchantId]);

  var getTreeData = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
      var url, params, res, result, success;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (props.merchantId) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              url = props.api;
              params = {
                merchantId: props.merchantId
              };
              _context.prev = 4;
              _context.next = 7;
              return (0,ypRequest/* default */.Z)(url, params);

            case 7:
              res = _context.sent;
              result = res.result, success = res.success;

              if (success) {
                console.log('...result', result);
                setTreeData(result);
              }

              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](4);
              console.log(_context.t0);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 12]]);
    }));

    return function getTreeData() {
      return _ref.apply(this, arguments);
    };
  }();

  var renderTreeNode = treeData => {
    if (!treeData) return;
    return treeData.map((item, key) => {
      if (item.childCategory) {
        return /*#__PURE__*/react.createElement(MyTreeSelectForegroundCategory_TreeNode, {
          value: item.categoryId,
          title: item.categoryName,
          key: item.categoryId
        }, renderTreeNode(item.childCategory));
      } else {
        return /*#__PURE__*/react.createElement(MyTreeSelectForegroundCategory_TreeNode, {
          value: item.categoryId,
          title: item.categoryName,
          key: item.categoryId
        });
      }
    });
  };

  var onTreeChange = e => {
    props.setCategoryId(e, treeData);
  };

  return /*#__PURE__*/react.createElement("div", {
    id: "my-tree-select"
  }, /*#__PURE__*/react.createElement(tree_select/* default */.Z, {
    treeDataSimpleMode: true,
    style: {
      width: '100%'
    },
    value: props.secondCategoryId || undefined,
    dropdownStyle: {
      maxHeight: 400,
      overflow: 'auto'
    },
    placeholder: "\u8BF7\u9009\u62E9\u524D\u53F0\u7C7B\u76EE",
    onChange: onTreeChange // multiple={true}
    // treeCheckable={true}
    ,
    allowClear: true // maxTagCount={1}
    ,
    showSearch: true
  }, renderTreeNode(treeData)));
});
/* harmony default export */ var MyTreeSelectForegroundCategory = (MyTreeSelectForegroundCategory_MyTreeSelect);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/searchForm/searchSelect/sceneTreeSelect.tsx







var sceneTreeSelect_TreeNode = tree_select/* default.TreeNode */.Z.TreeNode;
var SHOW_PARENT = tree_select/* default.SHOW_PARENT */.Z.SHOW_PARENT;
var sceneTreeSelect_MyTreeSelect = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      treeData = _useState2[0],
      setTreeData = _useState2[1];

  (0,react.useEffect)(() => {
    getTreeData();
  }, []);

  var getTreeData = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
      var url, params, res, result, success, _result$childList, childList;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = props.api;
              params = props.params;
              _context.prev = 2;
              _context.next = 5;
              return (0,ypRequest/* default */.Z)(url, params);

            case 5:
              res = _context.sent;
              result = res.result, success = res.success;

              if (success) {
                _result$childList = result.childList, childList = _result$childList === void 0 ? [] : _result$childList;
                setTreeData(childList);
              }

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              console.log(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 10]]);
    }));

    return function getTreeData() {
      return _ref.apply(this, arguments);
    };
  }();

  var renderTreeNode = treeData => {
    if (!treeData) return;
    return treeData.map((item, key) => {
      if (item.childList) {
        return /*#__PURE__*/react.createElement(sceneTreeSelect_TreeNode, {
          value: item.categoryCode,
          title: item.categoryName,
          key: item.categoryCode
        }, renderTreeNode(item.childList));
      } else {
        return /*#__PURE__*/react.createElement(sceneTreeSelect_TreeNode, {
          value: item.categoryCode,
          title: item.categoryName,
          key: item.categoryCode
        });
      }
    });
  };

  var onTreeChange = e => {
    props.setCategoryId(e);
  };

  return /*#__PURE__*/react.createElement("div", {
    id: "my-tree-select"
  }, /*#__PURE__*/react.createElement(tree_select/* default */.Z, {
    treeDataSimpleMode: true // treeCheckable
    ,
    showSearch: true,
    maxTagCount: 2,
    showCheckedStrategy: SHOW_PARENT,
    style: {
      width: '100%'
    },
    value: props.categoryId || undefined,
    dropdownStyle: {
      maxHeight: 400,
      overflow: 'auto'
    },
    placeholder: props.placeholder || "请选择商品类目",
    onChange: onTreeChange,
    allowClear: true
  }, renderTreeNode(treeData)));
});
/* harmony default export */ var sceneTreeSelect = (sceneTreeSelect_MyTreeSelect);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/GoodStock/components/searchForm/searchSelect/index.ts












/***/ }),

/***/ 62817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2824);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34041);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82682);
/* harmony import */ var _utils_fetchQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48344);









var Option = antd_es_select__WEBPACK_IMPORTED_MODULE_4__/* .default.Option */ .Z.Option;
var ItemTagSearch = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref) => {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState, 2),
      itemTagList = _useState2[0],
      setItemTagList = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(undefined),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState3, 2),
      firstInitialValue = _useState4[0],
      setFirstInitialValue = _useState4[1];

  var queryItemTags = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().mark(function _callee() {
      var url, _yield$fetchQuery, result, success;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = _Api__WEBPACK_IMPORTED_MODULE_2__/* .apiList.queryTagList */ .X9.queryTagList;
              _context.prev = 1;
              _context.next = 4;
              return (0,_utils_fetchQuery__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(url, 'POST', {});

            case 4:
              _yield$fetchQuery = _context.sent;
              result = _yield$fetchQuery.result;
              success = _yield$fetchQuery.success;

              if (success) {
                setItemTagList(result === null || result === void 0 ? void 0 : result.itemTags);
              }

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              console.log(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    return function queryItemTags() {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (!itemTagList.length) queryItemTags();
  }, []); //默认展示第一个

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (props.hasInitialValue && itemTagList.length) {
      var _itemTagList$, _itemTagList$2;

      setFirstInitialValue((_itemTagList$ = itemTagList[0]) === null || _itemTagList$ === void 0 ? void 0 : _itemTagList$.tagId);
      (props === null || props === void 0 ? void 0 : props.onFirstChange) && (props === null || props === void 0 ? void 0 : props.onFirstChange([(_itemTagList$2 = itemTagList[0]) === null || _itemTagList$2 === void 0 ? void 0 : _itemTagList$2.tagId]));
    }
  }, [itemTagList]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)({
    allowClear: true,
    showSearch: true,
    defaultActiveFirstOption: false,
    mode: props === null || props === void 0 ? void 0 : props.mode,
    maxTagCount: 1,
    filterOption: (input, option) => {
      var _option$children, _option$children$toLo;

      return (option === null || option === void 0 ? void 0 : (_option$children = option.children) === null || _option$children === void 0 ? void 0 : (_option$children$toLo = _option$children.toLowerCase()) === null || _option$children$toLo === void 0 ? void 0 : _option$children$toLo.indexOf(input === null || input === void 0 ? void 0 : input.toLowerCase())) >= 0;
    },
    value: props.value === null ? undefined : props.value || firstInitialValue,
    onChange: props.onChange,
    placeholder: props.placeholder
  }, props), itemTagList.map(item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(Option, {
    key: item.tagId,
    value: item.tagId || undefined
  }, item.tagName)));
});
/* harmony default export */ __webpack_exports__["Z"] = (ItemTagSearch);

/***/ }),

/***/ 57832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ cycleApi; }
/* harmony export */ });
/**
 * API集合
 */
// 详情
var cycleApi = {
  querySgMerchantItemStatusList: 'pms.sgMerchantItemManageService.querySgMerchantItemStatusList',
  // 商家商品列表查询
  batchUpdateSgMerchantItemStatus: 'pms.SgMerchantItemManageService.changeSgMerchantItemStatus',
  // 更新商家商品的生命周期状态
  pageQuerySgShopItemList: 'pms.ShopItemManageService.pageQuerySgShopItemList',
  // 营业部商品列表查询
  updateSgShopItemStatus: 'pms.SgShopItemManageService.changeSgShopItemStatus',
  // 新营业部商品生命周期状态
  querySgMerchantItemList: 'pms.sgMerchantItemManageService.querySgMerchantItemStatusList'
};

/***/ }),

/***/ 60862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "statusMapper": function() { return /* binding */ statusMapper; },
/* harmony export */   "CYCLE_COLUMNS": function() { return /* binding */ CYCLE_COLUMNS; },
/* harmony export */   "formJson": function() { return /* binding */ formJson; },
/* harmony export */   "statusList": function() { return /* binding */ statusList; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _GoodStock_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25428);




var statusMapper = {
  1: '新品',
  2: '正常',
  3: '停购',
  4: '停售',
  5: '清退',
  6: '永久淘汰'
};
var typeMapper = {
  1: '实物商品',
  2: '物料耗材',
  3: '虚拟商品',
  4: '礼品卡'
};
var lifeCycleList = [{
  name: '新品',
  value: 1
}, {
  name: '正常',
  value: 2
}, {
  name: '停购',
  value: 3
}, {
  name: '停售',
  value: 4
}, {
  name: '清退',
  value: 5
}, {
  name: '永久淘汰',
  value: 6
}];
var CYCLE_COLUMNS = [{
  title: '商家名称',
  dataIndex: 'merchantName',
  key: 'merchantName',
  align: 'center',
  fixed: 'left',
  width: 140,
  ellipsis: {
    showTitle: false
  },
  render: (merchantName, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    placement: "topLeft",
    title: merchantName
  }, record.merchantName)
}, {
  title: '商品编码',
  dataIndex: 'productId',
  align: 'center',
  fixed: 'left',
  width: 120
}, {
  title: '商品名称',
  dataIndex: 'alias',
  align: 'center',
  fixed: 'left',
  width: 140,
  ellipsis: {
    showTitle: false
  },
  render: (alias, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    placement: "topLeft",
    title: alias
  }, record.alias)
}, {
  title: '商品条码',
  dataIndex: 'barcode',
  width: 150,
  render: (text, record) => {
    var list = Array.from(new Set(record.barcode));
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_GoodStock_components__WEBPACK_IMPORTED_MODULE_2__/* .MyPopover */ .E7, {
      list: list || []
    });
  }
}, {
  title: '商品类目',
  dataIndex: 'categoryName',
  align: 'center',
  ellipsis: {
    showTitle: false
  },
  render: (categoryName, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    placement: "topLeft",
    title: categoryName
  }, record.categoryName)
}, {
  title: '商品品牌',
  dataIndex: 'brandName',
  align: 'center'
}, {
  title: '商品类型',
  dataIndex: 'productType',
  align: 'center',
  render: (text, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, typeMapper[record.productType])
}, {
  title: '商品单位',
  dataIndex: 'unit',
  align: 'center'
}];
var formJson = [{
  type: 'GOODS_MERCHANT',
  label: '商家',
  placeholder: '选择商家',
  field: 'merchantIds',
  width: '',
  initialValue: undefined,
  mode: 'multiple' // needDefaultMerchant: true

}, {
  type: 'COMMON_INPUT',
  label: '商品查询',
  placeholder: '商品名称/条码/编码/plu码',
  field: 'queryCriteria',
  width: '',
  initialValue: ''
}, {
  type: 'GOODS_BRAND',
  label: '商品品牌',
  placeholder: '请输入商品品牌',
  field: 'brandId',
  width: '',
  initialValue: ''
}, {
  type: 'SCENE_CATEGORY',
  label: '场景类目',
  placeholder: '场景类目',
  field: 'sceneCategoryId',
  result: 'childList',
  width: '',
  initialValue: ''
}, {
  type: 'GOODS_CATEGORY',
  label: '商品类目',
  placeholder: '商品类目',
  field: 'backCategoryId',
  width: '',
  initialValue: ''
}, {
  type: 'COMMON_TYPE_SELECT',
  label: '商品生命周期',
  placeholder: '请选择商品生命周期',
  field: 'status',
  initialValue: [1, 2, 3, 4, 5],
  list: lifeCycleList,
  fieldOptions: {
    maxTagCount: 6,
    mode: "multiple"
  }
}];
var statusList = type => {
  if (!type) return;
  var mapper = {
    1: [{
      value: 1,
      name: '新品'
    }, {
      value: 2,
      name: '正常'
    }, {
      value: 3,
      name: '停购'
    }, {
      value: 4,
      name: '停售'
    }, {
      value: 5,
      name: '清退'
    }, {
      value: 6,
      name: '永久淘汰'
    }],
    2: [{
      value: 2,
      name: '正常'
    }, {
      value: 3,
      name: '停购'
    }, {
      value: 4,
      name: '停售'
    }, {
      value: 5,
      name: '清退'
    }, {
      value: 6,
      name: '永久淘汰'
    }],
    3: [{
      value: 2,
      name: '正常'
    }, {
      value: 3,
      name: '停购'
    }, {
      value: 4,
      name: '停售'
    }, {
      value: 5,
      name: '清退'
    }, {
      value: 6,
      name: '永久淘汰'
    }],
    4: [{
      value: 2,
      name: '正常'
    }, {
      value: 3,
      name: '停购'
    }, {
      value: 4,
      name: '停售'
    }, {
      value: 5,
      name: '清退'
    }, {
      value: 6,
      name: '永久淘汰'
    }],
    5: [// { value: 1, name: '新品' },
    {
      value: 2,
      name: '正常'
    }, {
      value: 3,
      name: '停购'
    }, {
      value: 4,
      name: '停售'
    }, {
      value: 5,
      name: '清退'
    }, {
      value: 6,
      name: '永久淘汰'
    }]
  };
  return mapper[type];
};

/***/ }),

/***/ 43544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "defaultQuery": function() { return /* binding */ defaultQuery; },
/* harmony export */   "formJson": function() { return /* binding */ formJson; },
/* harmony export */   "statusMapper": function() { return /* binding */ statusMapper; },
/* harmony export */   "statusList": function() { return /* binding */ statusList; },
/* harmony export */   "CYCLE_COLUMNS": function() { return /* binding */ CYCLE_COLUMNS; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var defaultQuery = {
  merchantIds: [],
  shopId: null,
  productId: null,
  // 货品id（商品编码）
  productName: '',
  // 商品名称
  brandId: null,
  // 品牌id
  status: [1, 2, 3, 4, 5]
};
var lifeCycleList = [{
  name: '新品',
  value: 1
}, {
  name: '正常',
  value: 2
}, {
  name: '停购',
  value: 3
}, {
  name: '停售',
  value: 4
}, {
  name: '清退',
  value: 5
}, {
  name: '永久淘汰',
  value: 6
}];
var formJson = [{
  type: 'GOODS_MERCHANT',
  label: '商户查询',
  placeholder: '商户查询',
  field: 'merchantIds',
  mode: 'multiple',
  width: '',
  initialValue: '',
  hasInitialValue: true // needDefaultMerchant: true

}, // {
//   type: 'GOODS_SHOP',
//   label: '门店',
//   placeholder: '请选择门店',
//   field: 'shopId',
//   width: '',
//   initialValue: undefined
// },
{
  type: 'GOODS_SHOP_TREE',
  label: '地点查询',
  placeholder: '请选择门店',
  field: 'shopIdList',
  width: ''
}, {
  type: 'COMMON_INPUT_NUMBER',
  label: '商品编码',
  placeholder: '请输入商品编码',
  field: 'productId',
  width: '',
  initialValue: ''
}, {
  type: 'GOODS_BRAND',
  label: '商品品牌',
  placeholder: '请输入商品品牌',
  field: 'brandId',
  width: '',
  initialValue: ''
}, {
  type: 'COMMON_TYPE_SELECT',
  label: '商品生命周期',
  placeholder: '请选择商品生命周期',
  field: 'status',
  initialValue: [1, 2, 3, 4, 5],
  list: lifeCycleList,
  fieldOptions: {
    maxTagCount: 6,
    mode: "multiple"
  }
}, {
  type: 'COMMON_INPUT',
  label: '商品主档',
  placeholder: '商品主档名称',
  field: 'productName',
  width: '',
  initialValue: ''
}, {
  type: 'SCENE_CATEGORY',
  label: '场景类目',
  placeholder: '场景类目',
  field: 'sceneCategoryId',
  result: 'childList',
  width: '',
  initialValue: ''
}, {
  type: 'GOODS_CATEGORY',
  label: '商品类目',
  placeholder: '商品类目',
  field: 'backCategoryId',
  width: '',
  initialValue: ''
}, {
  type: 'RADIO',
  label: '隐藏仓库商品',
  field: 'hiddenWareHouseGoodsFlag',
  dataList: [{
    label: '是',
    value: 1
  }]
}];
var statusMapper = {
  1: '新品',
  2: '正常',
  3: '停购',
  4: '停售',
  5: '清退',
  6: '永久淘汰'
};
var typeMapper = {
  1: '实物商品',
  2: '物料耗材',
  3: '虚拟商品',
  4: '礼品卡'
};
var statusList = type => {
  if (!type) return;
  var mapper = {
    1: [
    /* 新品 */
    {
      value: 1,
      name: '新品'
    }, {
      value: 2,
      name: '正常'
    }, {
      value: 3,
      name: '停购'
    }, {
      value: 4,
      name: '停售'
    }, {
      value: 5,
      name: '清退'
    }, {
      value: 6,
      name: '永久淘汰'
    }],
    2: [
    /* 正常 */
    {
      value: 2,
      name: '正常'
    }, {
      value: 3,
      name: '停购'
    }, {
      value: 4,
      name: '停售'
    }, {
      value: 5,
      name: '清退'
    }, {
      value: 6,
      name: '永久淘汰'
    }],
    3: [
    /* 停购 */
    {
      value: 1,
      name: '新品'
    }, {
      value: 2,
      name: '正常'
    }, {
      value: 3,
      name: '停购'
    }, {
      value: 4,
      name: '停售'
    }, {
      value: 5,
      name: '清退'
    }, {
      value: 6,
      name: '永久淘汰'
    }],
    4: [
    /* 停售 */
    {
      value: 2,
      name: '正常'
    }, {
      value: 3,
      name: '停购'
    }, {
      value: 4,
      name: '停售'
    }, {
      value: 5,
      name: '清退'
    }, {
      value: 6,
      name: '永久淘汰'
    }],
    5: [{
      value: 1,
      name: '新品'
    }, {
      value: 2,
      name: '正常'
    }, {
      value: 3,
      name: '停购'
    }, {
      value: 4,
      name: '停售'
    }, {
      value: 5,
      name: '清退'
    }, {
      value: 6,
      name: '永久淘汰'
    }]
  };
  return mapper[type];
};
var CYCLE_COLUMNS = [{
  title: '商家名称',
  dataIndex: 'merchantName',
  key: 'merchantName',
  align: 'center',
  fixed: 'left',
  width: 140,
  ellipsis: {
    showTitle: false
  },
  render: (merchantName, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: merchantName
  }, record.merchantName)
}, {
  title: '门店',
  dataIndex: 'shopName',
  key: 'shopName',
  align: 'center',
  fixed: 'left',
  width: 140,
  ellipsis: {
    showTitle: false
  },
  render: (shopName, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: shopName
  }, record.shopName)
}, {
  title: '商品编码',
  dataIndex: 'productId',
  key: 'productId',
  align: 'center'
}, {
  title: '商品主档名称',
  dataIndex: 'productName',
  key: 'productName',
  align: 'center'
}, {
  title: '商品条码',
  dataIndex: 'basicBarcode',
  key: 'basicBarcode',
  align: 'center',
  width: 150 // render: (text: any, record: any) => (
  //     <MyPopover list={record.basicBarcode || []} />
  // )

}, {
  title: '商品类目',
  dataIndex: 'categoryName',
  key: 'categoryName',
  align: 'center',
  width: 140,
  ellipsis: {
    showTitle: false
  },
  render: (categoryName, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: categoryName
  }, record.categoryName)
}, {
  title: '商品品牌',
  dataIndex: 'brandName',
  key: 'brandName',
  align: 'center'
}, {
  title: '商品类型',
  dataIndex: 'productType',
  key: 'productType',
  align: 'center',
  render: (text, record, index) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, typeMapper[record.productType])
}, {
  title: '商品单位',
  dataIndex: 'unit',
  key: 'unit',
  align: 'center'
}];

/***/ }),

/***/ 3195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XC": function() { return /* binding */ BOM_DETAIL_API; },
/* harmony export */   "iJ": function() { return /* binding */ BOM_LIST_API; },
/* harmony export */   "Pp": function() { return /* binding */ DELIVERY_ADD_API; },
/* harmony export */   "OB": function() { return /* binding */ DELIVERY_MODIFY_API; },
/* harmony export */   "zU": function() { return /* binding */ MODIFY_BOM_STATUS_API; },
/* harmony export */   "hw": function() { return /* binding */ DELETE_BOM_API; },
/* harmony export */   "Me": function() { return /* binding */ QUERY_MERCHANTID; },
/* harmony export */   "V6": function() { return /* binding */ QUERY_MERCHANT_GOODS; },
/* harmony export */   "Js": function() { return /* binding */ EXPORT_BOM; },
/* harmony export */   "TF": function() { return /* binding */ QUERY_EXPORT_HISTORY_TASK; }
/* harmony export */ });
/**
 * API集合
 */
// 详情
var BOM_DETAIL_API = 'kernel.console.BomQueryService.queryBomDetail'; // 列表

var BOM_LIST_API = 'kernel.console.BomQueryService.pageQueryBom'; // 新增

var DELIVERY_ADD_API = 'kernel.console.BomCmdService.createBom'; // 编辑

var DELIVERY_MODIFY_API = 'kernel.console.BomCmdService.editBom'; // 修改bom状态

var MODIFY_BOM_STATUS_API = 'kernel.console.BomCmdService.editBomStatus'; // 删除bom

var DELETE_BOM_API = 'kernel.console.BomCmdService.deleteBom'; // 获取当前账号下的商家/商户

var QUERY_MERCHANTID = 'kernel.console.AuthorizedDataQueryService.queryAuthorizedMerchant'; // 分页查询商家货品信息

var QUERY_MERCHANT_GOODS = 'kernel.console.MerchantGoodsQueryService.pageQueryMerchantGoods'; // 导出BOM

var EXPORT_BOM = 'kernel.console.BomCmdService.exportBom'; // 导出历史

var QUERY_EXPORT_HISTORY_TASK = 'kernel.console.BatchToolsService.queryExportHistoryTask';

/***/ }),

/***/ 77205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ GOODS_SELL_PRICE_LIST_API; },
/* harmony export */   "Cp": function() { return /* binding */ GOODS_ENTER_PRICE_LIST_API; },
/* harmony export */   "Kh": function() { return /* binding */ SELL_PRICE_DETAIL_API; },
/* harmony export */   "On": function() { return /* binding */ GOODS_PRICE_DETAIL_API; },
/* harmony export */   "U$": function() { return /* binding */ SELL_PRICE_DETAIL_GOODS_API; },
/* harmony export */   "Lf": function() { return /* binding */ SELL_PRICE_ADD_API; },
/* harmony export */   "C$": function() { return /* binding */ IN_SELL_PRICE_ADD_API; },
/* harmony export */   "DA": function() { return /* binding */ IN_SELL_GOODS_PRICE_LIST_API; },
/* harmony export */   "qj": function() { return /* binding */ SELL_PRICE_DELETE_API; },
/* harmony export */   "Ri": function() { return /* binding */ GOODS_PRICE_DELETE_API; },
/* harmony export */   "n6": function() { return /* binding */ SELL_PRICE_VALIDATE_API; },
/* harmony export */   "UH": function() { return /* binding */ GOODS_PRICE_VALIDATE_API; },
/* harmony export */   "bt": function() { return /* binding */ DOWNLOAD_TEMPLATE_EXCEL; },
/* harmony export */   "Eb": function() { return /* binding */ IMPORT_ORDER_EXCEL; },
/* harmony export */   "T5": function() { return /* binding */ IMPORT_SELL_EXCEL; },
/* harmony export */   "Bx": function() { return /* binding */ QUERY_MERCH_SITE_INFO; },
/* harmony export */   "yz": function() { return /* binding */ GET_IPLOAD_TOKEN; },
/* harmony export */   "p1": function() { return /* binding */ QUERY_AUTHORIZED_PLACE; }
/* harmony export */ });
/* unused harmony exports SELL_PRICE_LIST_API, SELL_PRICE_DETAIL_INFO_API, SELL_PRICE_UPDATE_API, IMPORT_KEY_EXCEL, EXPORT_EXCEL_API, DOWN_LOAD_TEMPLATE */
/**
 * API集合
 */

/** 调价单 进价列表 */
var SELL_PRICE_LIST_API = 'pms.sgPriceModifyManageService.querySgPriceModifyRecordList';
/** 调价单 售价列表 */

var GOODS_SELL_PRICE_LIST_API = 'kernel.console.MerchantItemAdjustOrderService.pageMerchantItemAdjustOrder';
/** 调价单 进价列表 */

var GOODS_ENTER_PRICE_LIST_API = 'kernel.console.MerchantGoodsAdjustOrderQueryService.pageMerchantGoodsAdjustOrder';
/** 调价单 售价详情-编辑用主单信息 */

var SELL_PRICE_DETAIL_API = 'kernel.console.MerchantItemAdjustOrderService.queryMerchantItemAdjustOrderInfo';
/** 调价单 进价详情-编辑用主单信息 */

var GOODS_PRICE_DETAIL_API = 'kernel.console.MerchantGoodsAdjustOrderQueryService.queryMerchantGoodsAdjustOrderInfo';
/** 调价单 详情- 详情页用 */

var SELL_PRICE_DETAIL_INFO_API = 'pms.sgPriceModifyManageService.querySgPriceModifyRecordInfo';
/** 调价单 售价详情-获取商品分页 */

var SELL_PRICE_DETAIL_GOODS_API = 'kernel.console.MerchantItemAdjustOrderService.queryMerchantItemAdjustOrderDetailList';
/** 调价单 进价修改保存 */

var SELL_PRICE_UPDATE_API = 'pms.sgPriceModifyManageService.updateSgPriceModifyRecord';
/** 调价单 售价新增 */

var SELL_PRICE_ADD_API = 'kernel.console.MerchantItemAdjustOrderCmdService.saveMerchantItemAdjustOrder';
/** 调价单 进价新增 */

var IN_SELL_PRICE_ADD_API = 'kernel.console.MerchantGoodsAdjustOrderCmdService.saveMerchantGoodsAdjustOrder';
/** 调价单 进价编辑 详情 商品列表 */

var IN_SELL_GOODS_PRICE_LIST_API = 'kernel.console.MerchantGoodsAdjustOrderQueryService.queryMerchantGoodsAdjustOrderDetailList';
/** 调价单 售价删除 */

var SELL_PRICE_DELETE_API = 'kernel.console.MerchantItemAdjustOrderCmdService.deleteMerchantItemAdjustOrder';
/** 调价单 进价删除 */

var GOODS_PRICE_DELETE_API = 'kernel.console.MerchantGoodsAdjustOrderCmdService.deleteMerchantGoodsAdjustOrder';
/** 调价单 售价审核 */

var SELL_PRICE_VALIDATE_API = 'kernel.console.MerchantItemAdjustOrderCmdService.reviewMerchantItemAdjustOrder';
/** 调价单 进价审核 */

var GOODS_PRICE_VALIDATE_API = 'kernel.console.MerchantGoodsAdjustOrderCmdService.reviewMerchantGoodsAdjustOrder';
/** 调价 - 进价模板下载 */

var DOWNLOAD_TEMPLATE_EXCEL = 'kernel.console.BatchToolsService.downloadTemplate';
/** 调价 - 进价excel导入 */

var IMPORT_ORDER_EXCEL = 'kernel.console.MerchantGoodsAdjustOrderCmdService.importMerchantGoodsAdjustOrderDetail';
/** 调价 - 售价excel导入 */

var IMPORT_SELL_EXCEL = 'kernel.console.MerchantItemAdjustOrderCmdService.importMerchantItemAdjustOrderDetail';
/** 导入 结果处理 */

var IMPORT_KEY_EXCEL = 'pms.sgPriceModifyManageService.getImportSgPriceModifyResult';
/** 下载 */

var EXPORT_EXCEL_API = 'pms.sgPriceModifyManageService.exportSgPriceModifyRecordBusinessItemList';
/** 查看调整门店信息 */

var QUERY_MERCH_SITE_INFO = 'kernel.console.MerchantItemAdjustOrderService.queryMerchantItemAdjustOrderSiteInfo';
/** excel模板下载 */

var DOWN_LOAD_TEMPLATE = 'kernel.console.BatchToolsService.downloadTemplate';
/** excel模板下载 */

var GET_IPLOAD_TOKEN = 'kernel.console.BatchToolsService.getUploadFileToken'; // 查询用户有权限的地点列表（门店、大仓） // 3、门店 16、大仓，其他类型不支持

var QUERY_AUTHORIZED_PLACE = 'kernel.console.AuthorizedDataQueryService.queryAuthorizedPlace';

/***/ }),

/***/ 40420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(57016);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_FormBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5670);
/* harmony import */ var _components_GoodsCategorySelect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51115);
/* harmony import */ var _pages_GoodsManage_GoodStock_components_searchForm_searchSelect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16152);
/* harmony import */ var _SimpleEditableTable_SimpleEditableTable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30176);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24731);
/* harmony import */ var _utils_math__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(58180);







/**
 * 商品Modal
 */







var commonSize = 100; // 调价商品不分页，size写死

function PriceGoodsModal(props) {
  var merchantId = props.merchantId,
      queryApi = props.queryApi,
      resultCallback = props.resultCallback;
  var isSellPrice = window.location.href.includes('/SellPrice') ? true : false;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState, 2),
      selectedRows = _useState2[0],
      setSelectedRows = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState3, 2),
      cancelRequest = _useState4[0],
      setcancelRequest = _useState4[1];

  var getPageDefault = () => ({
    pageSize: 30,
    current: 1,
    total: 0
  });

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(getPageDefault()),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState5, 2),
      pageInfo = _useState6[0],
      setPageInfo = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(props.searchParams || {
    size: commonSize,
    queryScene: 1,
    // 1、区域管理列表 2、ypshop列表 ...
    businessType: 1,
    // 生鲜
    merchantId // switchMerchantItemFlag: isSellPrice ? undefined : 1

  }),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState7, 2),
      searchParams = _useState8[0],
      setSearchParams = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState9, 2),
      curSelectCategoryId = _useState10[0],
      setcurSelectCategoryId = _useState10[1];

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      _useState12 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState11, 2),
      curSelectBrandId = _useState12[0],
      setcurSelectBrandId = _useState12[1];

  var validateSearch = obj => {
    var arr = Object.values(obj);
    var isArrEffect = arr.some(e => e !== undefined && e !== null);
    return isArrEffect;
  };

  var handleData = (res, pageInfo) => {
    var params = {
      pageInfo: {
        page: pageInfo.current,
        size: pageInfo.pageSize
      },
      query: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({
        queryScene: props.searchParams.queryScene,
        merchantId,
        businessType: 3
      }, res)
    };
    console.log('...params', params);
    (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(queryApi, params).then(res => {
      var success = res.success,
          result = res.result;

      if (success) {
        var list = resultCallback ? resultCallback(result.list) : result.list;
        setcurDataSource(list);
        setPageInfo({
          total: result.total,
          current: result.page,
          pageSize: result.size
        });
      }
    });
  };
  /** 查询回调 */


  var searchHandler = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((state, values) => {
    var res = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, values), {}, {
      backCategoryId: curSelectCategoryId,
      brandId: curSelectBrandId
    }); // if (!validateSearch(res)) {
    //   message.info('请至少选择一个查询条件进行查询')
    //   return false
    // }


    if (cancelRequest) {
      setcancelRequest(false);
      handleData(res, pageInfo);
    } else {
      handleData(res, getPageDefault());
    }
  }, [curSelectCategoryId, curSelectBrandId]);
  /** 选择商品行 */
  // const rowSelectCallback = useCallback((keys, rows) => {
  //   setSelectedRows(rows)
  // }, [])

  /** 确认选择商品 */

  var handleOk = () => {
    if (selectedRows && selectedRows.length) {
      antd_es_message__WEBPACK_IMPORTED_MODULE_10__.default.success("\u5DF2\u9009\u62E9".concat(selectedRows.length, "\u6761\u5546\u54C1"));

      props.saveModalCallback(selectedRows);
    } else {
      antd_es_message__WEBPACK_IMPORTED_MODULE_10__.default.info('您未选择商品');

      props.closeModalCallback();
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    setSelectedRows([]);
    searchHandler(null, {});
  }, []);
  /** 类目选择 */

  var onCategoryChange = val => {
    setcurSelectCategoryId(val);
  };

  var sellPriceColumn = [{
    title: '商品编码',
    dataIndex: 'itemCode',
    key: 'itemCode',
    width: 140
  }, {
    title: '商品名称',
    dataIndex: 'saleName',
    key: 'saleName',
    width: 140
  }, {
    title: '商品条码',
    dataIndex: 'barCode',
    key: 'barcode',
    width: 140
  }, {
    title: 'PLU码',
    dataIndex: 'pluCode',
    key: 'pluCode',
    width: 140
  }, {
    title: 'PLU码级别',
    dataIndex: 'pluLevel',
    key: 'pluLevel',
    width: 140,
    render: (t, r) => {
      var _r$pluLevel;

      return r === null || r === void 0 ? void 0 : (_r$pluLevel = r.pluLevel) === null || _r$pluLevel === void 0 ? void 0 : _r$pluLevel.desc;
    }
  }, {
    title: '新售价',
    dataIndex: 'referenceSalePrice',
    key: 'referenceSalePrice',
    width: 100,
    render: (t, r, i, fn) => {
      if (fn) {
        var params = {
          fieldType: 'INPUT_NUMBER',
          fieldOptions: {
            formatter: _utils_math__WEBPACK_IMPORTED_MODULE_11__/* .limitDecimals */ .Cu,
            max: 99999.99,
            value: t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_11__/* .Divide */ .p3)((0,_utils_math__WEBPACK_IMPORTED_MODULE_11__/* .Multiply */ .wY)(t, 100), 100) : (0,_utils_math__WEBPACK_IMPORTED_MODULE_11__/* .Divide */ .p3)(r['referenceSalePrice'], 100)
          },
          blurCallBack: val => {
            if (val && !isNaN(val)) {
              props.saveModalCallback([(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, r), {}, {
                referenceSalePrice: val
              })]);
            }
          }
        };
        return fn(params);
      }

      if (isNaN(+t)) {
        return undefined;
      }

      return t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_11__/* .Divide */ .p3)((0,_utils_math__WEBPACK_IMPORTED_MODULE_11__/* .Multiply */ .wY)(t, 100), 100) : (0,_utils_math__WEBPACK_IMPORTED_MODULE_11__/* .Divide */ .p3)(r['referenceSalePrice'], 100);
    }
  }, {
    title: '商品类目',
    dataIndex: 'categoryInfo',
    key: 'categoryInfo',
    width: 140,
    render: (t, r) => r.categoryInfo.showName
  }, {
    title: '品牌',
    dataIndex: 'brandInfo',
    key: 'brandInfo',
    width: 120,
    render: (t, r) => r.brandInfo.brandName
  }, {
    title: '单位',
    dataIndex: 'saleUnit',
    key: 'saleUnit',
    width: 100
  }, {
    title: '规格描述',
    dataIndex: 'specDesc',
    key: 'specDesc',
    width: 120
  }];
  var purchasePriceColumn = [{
    title: '商品编码',
    dataIndex: 'itemCode',
    key: 'itemCode',
    width: 140
  }, {
    title: '商品名称',
    dataIndex: 'saleName',
    key: 'saleName',
    width: 140
  }, {
    title: '商品条码',
    dataIndex: 'barCode',
    key: 'barcode',
    width: 140
  }, {
    title: 'PLU码',
    dataIndex: 'pluCode',
    key: 'pluCode',
    width: 140
  }, {
    title: '新进价',
    dataIndex: 'newPrice',
    key: 'newPrice',
    width: 100,
    render: (t, r, i, fn) => {
      if (fn) {
        var params = {
          fieldType: 'INPUT_NUMBER',
          fieldOptions: {
            formatter: _utils_math__WEBPACK_IMPORTED_MODULE_11__/* .limitDecimals */ .Cu,
            max: 99999.99,
            value: t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_11__/* .Divide */ .p3)((0,_utils_math__WEBPACK_IMPORTED_MODULE_11__/* .Multiply */ .wY)(t, 100), 100) : (0,_utils_math__WEBPACK_IMPORTED_MODULE_11__/* .Divide */ .p3)(r['newPrice'], 100)
          },
          blurCallBack: val => {
            if (val && !isNaN(val)) {
              props.saveModalCallback([(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, r), {}, {
                newPrice: val
              })]);
            }
          }
        };
        return fn(params);
      }

      if (isNaN(+t)) {
        return undefined;
      }

      return t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_11__/* .Divide */ .p3)((0,_utils_math__WEBPACK_IMPORTED_MODULE_11__/* .Multiply */ .wY)(t, 100), 100) : (0,_utils_math__WEBPACK_IMPORTED_MODULE_11__/* .Divide */ .p3)(r['newPrice'], 100);
    }
  }, {
    title: '商品类目',
    dataIndex: 'categoryInfo',
    key: 'categoryInfo',
    width: 140,
    render: (t, r) => r.categoryInfo.showName
  }, {
    title: '品牌',
    dataIndex: 'brandInfo',
    key: 'brandInfo',
    width: 120,
    render: (t, r) => r.brandInfo.brandName
  }, {
    title: '单位',
    dataIndex: 'saleUnit',
    key: 'saleUnit',
    width: 100
  }, {
    title: '规格描述',
    dataIndex: 'specDesc',
    key: 'specDesc',
    width: 120
  }];
  var formFields = [{
    label: '商品查询',
    fieldOptions: {
      placeholder: '名称/编码/条码/PLU码'
    },
    name: 'queryCriteria',
    type: 'INPUT'
  }, {
    label: '商品类目',
    name: 'backCategoryId',
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_components_GoodsCategorySelect__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
      setCategoryId: onCategoryChange
    })
  }, {
    label: '品牌',
    name: 'brandId',
    // type: 'INPUT',
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_pages_GoodsManage_GoodStock_components_searchForm_searchSelect__WEBPACK_IMPORTED_MODULE_5__/* .BrandSearch */ .hP, {
      placeholder: "\u8BF7\u8F93\u5165\u5546\u54C1\u54C1\u724C",
      onChange: e => onBrandChange(e)
    })
  }];

  var onBrandChange = data => {
    setcurSelectBrandId(data);
  };

  var _useState13 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState14 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState13, 2),
      curDataSource = _useState14[0],
      setcurDataSource = _useState14[1];
  /** 重置 */


  var onResetFunc = () => {
    setcurSelectCategoryId(null);
    setcurSelectBrandId(null);
    setcurDataSource([]);
    setPageInfo(getPageDefault());
  };

  var priceGoodUrl = () => {
    var url = "";

    if (!isSellPrice) {
      url = "pms.sgMerchantItemManageService.querySgMerchantItemList"; // 进价类型查询商品
    } else {
      url = "pms.sgMerchantItemManageService.querySgMerchantItemSkuPluList"; // 售价类型查询商品
    }

    return url;
  };
  /** 可编辑表格数据变化 */


  var tableChange = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((data, allData) => {}, [curDataSource]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
    title: props.title || '新增商品',
    destroyOnClose: true,
    maskClosable: false,
    width: 1000,
    visible: true,
    onOk: props.closeModalCallback,
    onCancel: props.closeModalCallback
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_components_FormBuilder__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    onReset: onResetFunc,
    elements: props.GoodsModalFormElements || formFields,
    callbackHandler: searchHandler,
    defaultExpand: true,
    isHiddenSliderBtn: true
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_SimpleEditableTable_SimpleEditableTable__WEBPACK_IMPORTED_MODULE_6__.default // outLoading={curLoading || props.outLoading}
  , {
    showLimitGoodsTips: false,
    curGoodsNum: 0,
    hideBtn: true,
    dataSource: (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => curDataSource, [curDataSource]),
    hideDeleteBtn: true,
    columns: isSellPrice ? sellPriceColumn : purchasePriceColumn,
    buttonTitle: "\u6DFB\u52A0\u5546\u54C1\u884C",
    tableOptions: {
      scroll: {
        x: 800,
        y: 300
      }
    },
    pageInfo: pageInfo,
    pageChange: page => {
      handleData((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, searchParams), page);
    } // rowSelectCallback={rowSelectCallback}
    // canSelected={true}

  }));
}

/* harmony default export */ __webpack_exports__["default"] = (PriceGoodsModal);

/***/ }),

/***/ 79696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "goodsLimitShowNum": function() { return /* binding */ goodsLimitShowNum; }
/* harmony export */ });
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(71577);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(49101);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(90631);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(72850);
/* harmony import */ var _Common_SimpleEditableTable_SimpleEditableTable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30176);
/* harmony import */ var _PriceGoodsModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40420);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24731);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _config_goodsEnums__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3602);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_OldUploader__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(33773);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(77205);
/* harmony import */ var _components_UseRouter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27088);
/* harmony import */ var _utils_math__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(58180);
/* harmony import */ var _hooks_usePriceLoopImport__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41987);









/* eslint-disable complexity */

/**
 * 简单商品列表 - 无分页
 */













var levelMapper = {
  1: '基础',
  2: '折扣',
  3: '精品'
};
/** 当前页商品显示数量限制 */

var goodsLimitShowNum = 2000;
var _API = {
  productApi: 'pms.sgPriceModifyManageService.queryProductIdByKey',
  // 编码查询接口
  barCodeApi: 'pms.sgPriceModifyManageService.queryBarcodeListByProductId',
  // 条码查询接口
  productCodeSearchApi: 'pms.sgPriceModifyManageService.querySgPriceModifyItemByProductIdAndBarcode',
  // 售价：根据编码+条码查询出调价单商品信息
  codeSearchApi: 'pms.sgPriceModifyManageService.querySgPriceModifyItemByProductIdList' // 进价：根据商品编码查询调价单商品信息

};

function PriceProductEditTable(props, ref) {
  var _props$addBtnText;

  var table = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState3, 2),
      goodsIdList = _useState4[0],
      setGoodsIdList = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState5, 2),
      goodsBarCodeList = _useState6[0],
      setGoodsBarCodeList = _useState6[1];

  var router = (0,_components_UseRouter__WEBPACK_IMPORTED_MODULE_10__/* .useRouter */ .t)();
  var isAddHandle = router.query.type === 'add' ? true : false;
  var isPursePrice = window.location.href.includes('/PurchasePrice') ? true : false;
  var priceName = isPursePrice ? '进价' : '售价';
  var id = router.query.id;
  var p = {
    page: 1,
    size: 20
  };

  var toggleGoodsModal = bool => {
    setVisible(bool);
  };

  var merchantIds = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    var _props$storeData;

    var list = (_props$storeData = props.storeData) === null || _props$storeData === void 0 ? void 0 : _props$storeData.map(v => v.merchantId && +v.merchantId).filter(Boolean);
    return list !== null && list !== void 0 && list.length ? [...new Set(list)] : [];
  }, [props.storeData]);

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState7, 2),
      tableDataSource = _useState8[0],
      settableDataSource = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState9, 2),
      curLoading = _useState10[0],
      setcurLoading = _useState10[1];
  /** modal保存回调 */


  var saveGoodModal = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().mark(function _callee(rows) {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // props.saveGoodsModal(rows, 'product')
              handleDataFromModal(rows); // closeModal()

              setcurLoading(true);
              setTimeout(() => {
                setcurLoading(false); // 默认超过6s 关闭loading
              }, 1000);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function saveGoodModal(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var closeModal = () => {
    setVisible(false);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useImperativeHandle)(ref, () => ({
    reflashTable: () => table.current.reflashTable()
  }));
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    setdisableUpload(false);

    if (tableDataSource && tableDataSource.length) {
      setdisableUpload(true);
      props.onTableChange && props.onTableChange(tableDataSource); // 回调数据到父组件
    }
  }, [tableDataSource]);
  /** 根据商品modal获取列表查新的商品列表  */

  var handleDataFromModal = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().mark(function _callee2(list) {
      var key, newList, _productData, newArr;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 进价： 无需再处理商品
              try {
                setcurLoading(false); // const _data = tableDataSource
                // if (isPursePrice) {
                //   list.map((e: any) => {
                //     e['referencePurchasePrice'] = Divide(+e['referenceSalePrice'], 1)
                //   })
                // } else {
                //   list.map((e: any) => {
                //     e['referenceSalePrice'] = Divide(+e['referenceSalePrice'], 1)
                //   })
                // }

                key = isPursePrice ? 'referencePurchasePrice' : 'referenceSalePrice';
                newList = list.map(ele => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)({}, ele), {}, {
                  [key]: ele[key]
                }));
                _productData = tableDataSource.concat(newList);
                newArr = lodash__WEBPACK_IMPORTED_MODULE_8___default().uniqBy(_productData, 'itemCode'); // 去重
                // 初始化时新价格=旧价格

                settableDataSource(newArr);
              } catch (error) {
                console.error(error); // message.error(error)
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleDataFromModal(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  /** 模糊搜索 商品编码和条码的下拉数据 */


  var handleGoodSearchList = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().mark(function _callee3(val) {
      var res, list, uniqArr, data;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              if (val) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return");

            case 3:
              _context3.next = 5;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_API.productApi, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)({
                key: val
              }, p));

            case 5:
              res = _context3.sent;

              if (res.success) {
                _context3.next = 8;
                break;
              }

              throw '请求失败';

            case 8:
              list = res.result.list;

              if (list && !list.length) {
                setTimeout(() => {
                  antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.info('未查到相关信息');
                }, 500);
              }

              uniqArr = Array.from(new Set(list));
              data = uniqArr.map(v => ({
                value: v,
                label: v
              }));
              setGoodsIdList(data);
              _context3.next = 18;
              break;

            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.error(_context3.t0);

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 15]]);
    }));

    return function handleGoodSearchList(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  /** 模糊搜索 商品编码和条码的下拉数据 */


  var handleGoodCodebarSearchList = /*#__PURE__*/function () {
    var _ref4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().mark(function _callee4(val) {
      var res, list, uniqArr, barcodeData, goodIdData;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              if (val) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt("return");

            case 3:
              _context4.next = 5;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)("pms.sgMerchantItemManageService.querySgMerchantItemSkuList", (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)({
                barCodeWildcard: val
              }, p));

            case 5:
              res = _context4.sent;

              if (res.success) {
                _context4.next = 8;
                break;
              }

              throw '请求失败';

            case 8:
              list = res.result.list;

              if (!(list && !list.length)) {
                _context4.next = 12;
                break;
              }

              setTimeout(() => {
                antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.info('未查到相关信息');
              }, 500);
              return _context4.abrupt("return");

            case 12:
              uniqArr = Array.from(new Set(list));
              barcodeData = uniqArr.map(v => ({
                value: v['barcode'],
                label: v['barcode']
              }));
              goodIdData = uniqArr.map(v => ({
                value: v['goodsId'],
                label: v['goodsId']
              }));
              barcodeData = lodash__WEBPACK_IMPORTED_MODULE_8___default().uniqBy(barcodeData, 'barcode');
              goodIdData = lodash__WEBPACK_IMPORTED_MODULE_8___default().uniqBy(goodIdData, 'goodsId');
              setGoodsBarCodeList(barcodeData);
              setGoodsIdList(goodIdData);
              _context4.next = 24;
              break;

            case 21:
              _context4.prev = 21;
              _context4.t0 = _context4["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.error(_context4.t0);

            case 24:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 21]]);
    }));

    return function handleGoodCodebarSearchList(_x4) {
      return _ref4.apply(this, arguments);
    };
  }();

  var onDebounceGoodSearch = lodash_debounce__WEBPACK_IMPORTED_MODULE_6___default()(handleGoodSearchList, 800);
  var onDebounceGoodCodebarSearch = lodash_debounce__WEBPACK_IMPORTED_MODULE_6___default()(handleGoodCodebarSearchList, 800);
  var priceColumn = [{
    title: '序号',
    dataIndex: 'id',
    key: 'id',
    width: 60,
    render: (t, r, i, fn) => {
      return i + 1;
    }
  }, {
    title: '商品编码',
    dataIndex: 'itemCode',
    key: 'itemCode',
    width: 140
  }, {
    title: '商品名称',
    dataIndex: 'saleName',
    key: 'saleName',
    width: 140
  }, {
    title: '商品条码',
    dataIndex: 'barCode',
    key: 'barCode',
    width: 140
  }, {
    title: 'PLU码',
    dataIndex: 'pluCode',
    key: 'pluCode',
    width: 140,
    hide: isPursePrice
  }, {
    title: 'PLU码级别',
    dataIndex: 'pluLevel',
    key: 'pluLevel',
    width: 140,
    hide: isPursePrice,
    render: (t, r) => {
      var _r$pluLevel;

      return r === null || r === void 0 ? void 0 : (_r$pluLevel = r.pluLevel) === null || _r$pluLevel === void 0 ? void 0 : _r$pluLevel.desc;
    }
  }, {
    title: '商品单位',
    dataIndex: 'saleUnit',
    key: 'saleUnit',
    hide: isPursePrice,
    width: 90
  }, {
    title: '商品规格',
    dataIndex: 'specification',
    key: 'specification',
    hide: isPursePrice,
    width: 90
  }, // {
  //   title: '进价区间',
  //   dataIndex: 'purchasePriceRange',
  //   key: 'purchasePriceRange',
  //   hide: isPursePrice,
  //   width: 90
  // },
  // {
  //   title: '参考进价',
  //   dataIndex: 'purchasePriceRange',
  //   key: 'purchasePriceRange',
  //   width: 80,
  //   hide: isPursePrice,
  //   render: (t: any, r: any, i: number, fn: any) => {
  //     return t ? t : ''
  //   }
  // },
  {
    title: '新售价',
    hide: isPursePrice,
    dataIndex: 'referenceSalePrice',
    key: 'referenceSalePrice',
    width: 80,
    editable: true,
    render: (t, r, i, fn) => {
      if (fn) {
        var params = {
          fieldType: 'INPUT_NUMBER',
          fieldOptions: {
            formatter: _utils_math__WEBPACK_IMPORTED_MODULE_17__/* .limitDecimals */ .Cu,
            max: 99999.99,
            value: t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_17__/* .Divide */ .p3)((0,_utils_math__WEBPACK_IMPORTED_MODULE_17__/* .Multiply */ .wY)(t, 100), 100) : (0,_utils_math__WEBPACK_IMPORTED_MODULE_17__/* .Divide */ .p3)(r['oldReferenceSalePrice'], 100)
          }
        };
        return fn(params);
      }

      if (isNaN(+t)) {
        return undefined;
      }

      return t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_17__/* .Divide */ .p3)((0,_utils_math__WEBPACK_IMPORTED_MODULE_17__/* .Multiply */ .wY)(t, 100), 100) : (0,_utils_math__WEBPACK_IMPORTED_MODULE_17__/* .Divide */ .p3)(r['oldReferenceSalePrice'], 100);
    }
  }, // {
  //   title: '毛利率(%)',
  //   hide: isPursePrice,
  //   dataIndex: 'mRate',
  //   key: 'mRate',
  //   width: 100,
  //   render: (t: any, r: any, i: number, fn: any) => {
  //     if (r['referenceSalePrice'] != 0) {
  //       // if (!isNaN(r['referenceSalePrice']) && !isNaN(r['oldReferencePurchasePrice'])) {
  //       //   const p = +r['referenceSalePrice'] - Divide(r['oldReferencePurchasePrice'], 100)
  //       //   return ((p / r['oldReferencePurchasePrice']) * 10000).toFixed(2)
  //       // }
  //       if (!isNaN(r['referenceSalePrice']) && !isNaN(r['oldReferencePurchasePrice'])) {
  //         const p = +r['referenceSalePrice'] - Divide(r['oldReferencePurchasePrice'], 1000) * Number(r['conversionRatio']) // 统一换算成元
  //         return (Divide(p, Divide(+r['referenceSalePrice'], 100))).toFixed(2)
  //       } else {
  //         return ''
  //       }
  //     } else {
  //       return ''
  //     }
  //   }
  // },
  // {
  //   title: '毛利额',
  //   hide: isPursePrice,
  //   dataIndex: 'mRate',
  //   key: 'mRate',
  //   width: 100,
  //   render: (t: any, r: any, i: number, fn: any) => {
  //     if (r['referenceSalePrice'] != 0) {
  //       // if (!isNaN(r['referenceSalePrice']) && !isNaN(r['oldReferencePurchasePrice'])) {
  //       //   return (+r['referenceSalePrice'] - (Math.floor(+r['oldReferencePurchasePrice'] * 100) / 10000)).toFixed(2)
  //       // }
  //       if (!isNaN(r['referenceSalePrice']) && !isNaN(r['oldReferencePurchasePrice'])) {
  //         // 与编辑页不同
  //         const p = +r['referenceSalePrice'] - Divide(r['oldReferencePurchasePrice'], 1000)* Number(r['conversionRatio']) // 统一换算成元
  //         return p.toFixed(3)
  //       }
  //     } else {
  //       return ''
  //     }
  //   }
  // },
  {
    title: '商品单位',
    dataIndex: 'saleUnit',
    key: 'saleUnit',
    hide: !isPursePrice,
    width: 140
  }, {
    title: '商品规格',
    dataIndex: 'specification',
    hide: !isPursePrice,
    key: 'specification',
    width: 140
  }, {
    title: '参考进价',
    hide: !isPursePrice,
    dataIndex: 'purchasePriceRange',
    key: 'purchasePriceRange',
    width: 80,
    render: (t, r, i, fn) => {
      return t ? t : '';
    }
  }, {
    title: '新进价',
    hide: !isPursePrice,
    dataIndex: 'newPrice',
    key: 'newPrice',
    width: 80,
    editable: true,
    render: (t, r, i, fn) => {
      if (fn) {
        var params = {
          fieldType: 'INPUT_NUMBER',
          fieldOptions: {
            formatter: _utils_math__WEBPACK_IMPORTED_MODULE_17__/* .limitDecimalsThree */ .ed,
            // formatter: limitDecimalsNum,
            max: 999999.99,
            value: t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_17__/* .Divide */ .p3)((0,_utils_math__WEBPACK_IMPORTED_MODULE_17__/* .Multiply */ .wY)(t, 1000), 1000) : (0,_utils_math__WEBPACK_IMPORTED_MODULE_17__/* .Divide */ .p3)(r['newPrice'], 1000)
          }
        };
        return fn(params);
      }

      if (isNaN(+t)) {
        return undefined;
      }

      return t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_17__/* .Divide */ .p3)((0,_utils_math__WEBPACK_IMPORTED_MODULE_17__/* .Multiply */ .wY)(t, 1000), 1000) : (0,_utils_math__WEBPACK_IMPORTED_MODULE_17__/* .Divide */ .p3)(r['newPrice'], 1000);
    }
  }, {
    title: '商品类目',
    dataIndex: 'categoryNames',
    key: 'categoryNames',
    width: 140,
    render: (t, r) => {
      var _r$categoryInfo;

      return r === null || r === void 0 ? void 0 : (_r$categoryInfo = r.categoryInfo) === null || _r$categoryInfo === void 0 ? void 0 : _r$categoryInfo.showName;
    }
  }];
  /** 选中条码后，处理商品条码的事件,需要把条码对应的编码回填到编码框或者刷新该条数据 */

  var handleGoodBarCode = /*#__PURE__*/function () {
    var _ref5 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().mark(function _callee5(code, currentRow) {
      var res, success, list;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)("pms.sgMerchantItemManageService.querySgMerchantItemSkuList", (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)({
                barCodeWildcard: code
              }, p));

            case 3:
              res = _context5.sent;
              success = res.success;

              if (success) {
                list = res.result.list;
                currentRow['goodsId'] = list[0]['goodsId'];
                currentRow['barcode'] = code;
                handleQueryGoodsForId(currentRow);
              }

              _context5.next = 11;
              break;

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.error(_context5.t0);

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 8]]);
    }));

    return function handleGoodBarCode(_x5, _x6) {
      return _ref5.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (props.dataSource && props.dataSource.length) {
      var _props$dataSource;

      settableDataSource(props.dataSource);

      if ((props === null || props === void 0 ? void 0 : (_props$dataSource = props.dataSource) === null || _props$dataSource === void 0 ? void 0 : _props$dataSource.length) > goodsLimitShowNum) {
        setshowLimitGoodsTips(true);
        setdisableAddBtnText(true);
        setdisableUpload(true);

        if (id) {
          setshowTipObj({
            successCount: props.dataSource.length,
            detailUrl: "/GoodsManage/Price/SellPrice/Detail/".concat(id)
          });
        } else {
          setshowTipObj({
            successCount: props.dataSource.length
          });
        }
      }
    }
  }, [props.dataSource]);
  /** 可编辑表格数据变化 */

  var tableChange = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((data, allData) => {
    // const changeGoodsData = async (data: any, selected: any[]) => {
    var currentCell = data.currentCell,
        currentRow = data.currentRow,
        dataSource = data.dataSource,
        type = data.type;

    if (lodash__WEBPACK_IMPORTED_MODULE_8___default().isEmpty(currentCell) && type !== 'DELETE') {
      console.error('break');
      return;
    }

    var itemCode = currentCell['itemCode'];
    var barCode = currentCell['barcode']; // 单元格是商品编码

    if (itemCode) {
      handleGoodId(itemCode, currentRow);
    } // 当前修改的单元格是商品条码时


    if (barCode) {
      handleGoodBarCode(barCode, currentRow);
    }

    if (type === 'DELETE') {
      if (dataSource && !dataSource.length) {
        settableDataSource([]);
      }

      if (Object.keys(currentRow).length) {
        // 如果当前行有数据，保证导入后数据一致
        var _data = tableDataSource;

        var _arr = _data.filter(res => dataSource.length && res['barcode'] !== dataSource[0]['barcode']);

        settableDataSource(_arr);
      }
    }

    if (allData && allData.length) {
      props.onTableChange && props.onTableChange(allData);
    }

    if (allData && !allData.length) {
      // 不可提交
      props.handleCanEdit && props.handleCanEdit(true);
    }
  }, [tableDataSource]);
  /** 售价: 根据编码获取商品 进价：根据编码+条码获取商品 */

  var handleQueryGoodsForId = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)( /*#__PURE__*/function () {
    var _ref6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().mark(function _callee6(currentRow) {
      var goodsId, barcodeAndProductIdDTO, params, apiUrl, res, list, data, index, rowData, tableData, isRowIndex, arr, _index;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              goodsId = [currentRow['goodsId']];
              barcodeAndProductIdDTO = [{
                barcode: currentRow['barcode'],
                goodsId: currentRow['goodsId'],
                pluCode: currentRow['pluCode']
              }];

              if (isPursePrice) {
                params = {
                  goodsId,
                  merchantId: merchantIds,
                  type: _config_goodsEnums__WEBPACK_IMPORTED_MODULE_7__/* .changePriceType */ .dU[priceName]
                };
              } else {
                params = {
                  barcodeAndProductIdDTO,
                  type: _config_goodsEnums__WEBPACK_IMPORTED_MODULE_7__/* .changePriceType */ .dU[priceName]
                };
              }

              _context6.prev = 3;
              apiUrl = isPursePrice ? _API.codeSearchApi : _API.productCodeSearchApi;
              _context6.next = 7;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(apiUrl, params);

            case 7:
              res = _context6.sent;

              if (!res.success) {
                _context6.next = 21;
                break;
              }

              list = res.result.list;

              if (!(list && !list.length)) {
                _context6.next = 16;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.info("\u672A\u627E\u5230\u7F16\u7801".concat(currentRow['goodsId'], "\u6761\u7801").concat(currentRow['barcode'], "\u7684\u5546\u54C1\u4FE1\u606F"));

              data = tableDataSource;
              index = tableDataSource.findIndex(e => e['editableTableKey'] === currentRow['editableTableKey']);

              if (index !== -1) {
                // 如果当前datasource不存在该条数据，则默认头部添加
                data[index] = {
                  goodsId,
                  editableTableKey: currentRow['editableTableKey']
                };
                settableDataSource(data);
              }

              return _context6.abrupt("return");

            case 16:
              rowData = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)({}, currentRow), list[0]);

              if (isPursePrice) {
                rowData['referencePurchasePrice'] = (0,_utils_math__WEBPACK_IMPORTED_MODULE_17__/* .Divide */ .p3)(+rowData['oldReferencePurchasePrice'], 100);
              } else {
                rowData['referenceSalePrice'] = (0,_utils_math__WEBPACK_IMPORTED_MODULE_17__/* .Divide */ .p3)(+rowData['oldReferenceSalePrice'], 100);
              }

              tableData = tableDataSource;
              /** 列表里是否有了该数据 */

              isRowIndex = tableData.findIndex(e => e['goodsId'] === currentRow['goodsId'] && e['barcode'] === currentRow['barcode']);

              if (isRowIndex !== -1) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.info('该编码和条码已存在，请重试...');

                arr = tableData.filter(e => e['editableTableKey'] !== rowData['editableTableKey']);
                setTimeout(() => {
                  settableDataSource(arr);
                }, 400);
              } else {
                _index = tableData.findIndex(e => e['editableTableKey'] === rowData['editableTableKey']);

                if (_index === -1) {
                  // 如果当前datasource不存在该条数据，则默认头部添加
                  tableData.unshift(rowData);

                  if (Array.isArray(tableData)) {
                    settableDataSource(tableData);
                  }
                } else {
                  tableData[_index] = rowData;
                  settableDataSource(tableData);
                }
              }

            case 21:
              _context6.next = 26;
              break;

            case 23:
              _context6.prev = 23;
              _context6.t0 = _context6["catch"](3);
              console.error(_context6.t0);

            case 26:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[3, 23]]);
    }));

    return function (_x7) {
      return _ref6.apply(this, arguments);
    };
  }(), [tableDataSource]);
  /** 选中商品编码后 触发的事件 */

  var handleGoodId = /*#__PURE__*/function () {
    var _ref7 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().mark(function _callee7(goodsId, currentRow) {
      var params, res, success, result, _data2, index, _data, data;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              params = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)({
                goodsId
              }, p);
              _context7.next = 4;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_API.barCodeApi, params);

            case 4:
              res = _context7.sent;
              success = res.success, result = res.result;

              if (!success) {
                _context7.next = 19;
                break;
              }

              if (!(result['list'] && !result['list'].length)) {
                _context7.next = 13;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.info("\u672A\u627E\u5230\u7F16\u7801".concat(goodsId, "\u5BF9\u5E94\u7684\u6761\u7801\u4FE1\u606F,\u8BF7\u91CD\u65B0\u9009\u62E9"));

              _data2 = tableDataSource;
              index = tableDataSource.findIndex(e => e['editableTableKey'] === currentRow['editableTableKey']);

              if (index !== -1) {
                // 如果当前datasource不存在该条数据，则默认头部添加
                _data2[index] = {
                  goodsId,
                  editableTableKey: currentRow['editableTableKey']
                };
                settableDataSource(_data2);
              }

              return _context7.abrupt("return");

            case 13:
              // if (isPursePrice) {
              // } else {
              // }
              _data = result.list.filter(e => e['isBasic'] === 1);

              if (_data.length) {
                _data = lodash__WEBPACK_IMPORTED_MODULE_8___default().uniqBy(_data, 'barcode');
              }

              data = _data.map(v => ({
                value: v['barcode'],
                label: v['barcode']
              }));

              if (!goodsBarCodeList.length || data.length) {
                setGoodsBarCodeList(data);
                currentRow['barcode'] = data[0]['value'];
                handleQueryGoodsForId(currentRow);
              }

              _context7.next = 20;
              break;

            case 19:
              console.error(res);

            case 20:
              _context7.next = 25;
              break;

            case 22:
              _context7.prev = 22;
              _context7.t0 = _context7["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.error(_context7.t0);

            case 25:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[0, 22]]);
    }));

    return function handleGoodId(_x8, _x9) {
      return _ref7.apply(this, arguments);
    };
  }();

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      _useState12 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState11, 2),
      curImportTaskId = _useState12[0],
      setcurImportTaskId = _useState12[1];

  var _useState13 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      _useState14 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState13, 2),
      loopResult = _useState14[0],
      setLoopResult = _useState14[1];

  var _useState15 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      _useState16 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState15, 2),
      showLimitGoodsTips = _useState16[0],
      setshowLimitGoodsTips = _useState16[1]; // 大数据导入后，回填数量，根据数量个数，展示是否有去下载提示


  var _useState17 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      _useState18 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState17, 2),
      showTipObj = _useState18[0],
      setshowTipObj = _useState18[1];

  var _useState19 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      _useState20 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState19, 2),
      curGoodsNum = _useState20[0],
      setcurGoodsNum = _useState20[1];

  var _useState21 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      _useState22 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState21, 2),
      disableAddBtnText = _useState22[0],
      setdisableAddBtnText = _useState22[1];

  var _useState23 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      _useState24 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState23, 2),
      disableUpload = _useState24[0],
      setdisableUpload = _useState24[1];

  var _usePriceLoopImport = (0,_hooks_usePriceLoopImport__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({
    taskId: curImportTaskId,
    url: 'kernel.console.BatchToolsService.queryExecuteResult',
    type: isPursePrice ? 1 : 2,
    // 2 售价
    refreshCallback: (successed, result, obj) => {
      if (successed && result !== null && result !== void 0 && result.length) {
        var _arr2;

        if (result.length > goodsLimitShowNum) {
          // 超过页面限制条数 则不显示，
          setdisableAddBtnText(true);
          setshowLimitGoodsTips(true);
          setshowTipObj({
            successCount: obj === null || obj === void 0 ? void 0 : obj.successCount,
            errorCount: obj === null || obj === void 0 ? void 0 : obj.errorCount,
            successUrl: obj === null || obj === void 0 ? void 0 : obj.successUrl
          });
        }

        var key = isPursePrice ? 'referencePurchasePrice' : 'referenceSalePrice';
        var newResult = result.map(ele => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)({}, ele), {}, {
          [key]: (0,_utils_math__WEBPACK_IMPORTED_MODULE_17__/* .Divide */ .p3)(+ele[key], 100)
        })); // if (isPursePrice) {
        //   result?.length &&
        //     result.map((e: any) => {
        //       e['referencePurchasePrice'] = Divide(+e['referencePurchasePrice'], 1000)
        //     })
        // } else {
        //   result?.length &&
        //     result.map((e: any) => {
        //       e['referenceSalePrice'] = Divide(+e['referenceSalePrice'], 100)
        //     })
        // }
        // 但是数据保存在内存中

        var arr = tableDataSource.concat(newResult);
        arr = lodash__WEBPACK_IMPORTED_MODULE_8___default().uniqBy(arr, 'itemCode'); // 去重
        // arr = filterTwoProperty(arr, 'barcode', 'goodsId','pluCode')

        settableDataSource(arr);
        setcurGoodsNum(((_arr2 = arr) === null || _arr2 === void 0 ? void 0 : _arr2.length) || '');
      }

      setLoopResult(false); // 重置状态
    }
  }, [loopResult]),
      _usePriceLoopImport2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_usePriceLoopImport, 1),
      btnLoading = _usePriceLoopImport2[0];
  /** 上传文件 */


  var changeUpload = /*#__PURE__*/function () {
    var _ref8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().mark(function _callee8(val) {
      var resId, res, list, array;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              resId = val[0].resId;
              _context8.prev = 1;
              _context8.next = 4;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(props.importUrl, {
                // "resourceAddr": val[val.length - 1]['files'],
                adjustOrderNo: id,
                resId,
                merchantId: props.curShopIdList[0].split('-')[0],
                // 商家ID
                siteId: props.curShopIdList.map(ele => ele.split('-')[1]) // 地点ID
                // resourceAddr: resId,
                // merchantId: merchantIds,
                // type: changePriceType[priceName]

              });

            case 4:
              res = _context8.sent;

              if (!(res && res.success)) {
                _context8.next = 12;
                break;
              }

              // message.success('导入excel成功')
              // 全部成功
              list = res.result.list; // if (success) {
              // setcurImportTaskId(importOrderNo)

              array = list.map(ele => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)({}, ele), {}, {
                itemCode: ele.goodsCode,
                saleName: ele.saleName
              }));
              props.uploadSuccessCallback(array); // setLoopResult(true)
              // } else {
              // message.warn('上传excel失败')
              // }

              return _context8.abrupt("return", false);

            case 12:
              antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.warn('导入失败');

            case 13:
              _context8.next = 18;
              break;

            case 15:
              _context8.prev = 15;
              _context8.t0 = _context8["catch"](1);

              antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.error(_context8.t0);

            case 18:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[1, 15]]);
    }));

    return function changeUpload(_x10) {
      return _ref8.apply(this, arguments);
    };
  }();
  /** 下载模板 */


  var downloadTemplate = /*#__PURE__*/function () {
    var _ref9 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().mark(function _callee9() {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_18__/* .DOWNLOAD_TEMPLATE_EXCEL */ .bt, {
                taskType: 4005
              });

            case 3:
              res = _context9.sent;

              if (res && res.success) {
                window.location.href = res.result.templateUrl;
              } else {
                antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.warn('模板下载失败');
              }

              _context9.next = 10;
              break;

            case 7:
              _context9.prev = 7;
              _context9.t0 = _context9["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.error(_context9.t0);

            case 10:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[0, 7]]);
    }));

    return function downloadTemplate() {
      return _ref9.apply(this, arguments);
    };
  }();

  var handleAddGoods = /*#__PURE__*/function () {
    var _ref10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().mark(function _callee10() {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return props.validateFormCallback();

            case 2:
              toggleGoodsModal(true);

            case 3:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function handleAddGoods() {
      return _ref10.apply(this, arguments);
    };
  }();
  /** 清空商品明细 */


  var clearGoods = () => {
    settableDataSource([]);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    className: "mTop16 mBottom16"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z, {
    type: "primary",
    disabled: !props.canHandleModal || disableAddBtnText,
    className: "mRight16",
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, null) // onClick={() => toggleGoodsModal(true)}
    ,
    onClick: handleAddGoods
  }, (_props$addBtnText = props.addBtnText) !== null && _props$addBtnText !== void 0 ? _props$addBtnText : '添加商品'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
    style: {
      marginRight: '16px'
    },
    key: "upload"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_components_OldUploader__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, {
    tokenParams: {},
    accept: "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    onChange: changeUpload,
    loading: btnLoading,
    btnText: "\u5BFC\u5165excel\u5546\u54C1",
    tokenUrl: _Api__WEBPACK_IMPORTED_MODULE_18__/* .GET_IPLOAD_TOKEN */ .yz,
    uploadOptions: {
      showUploadList: false,
      disabled: disableUpload || !props.curShopIdList.length
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z, {
    className: "mRight16" // disabled={!canHandle}
    ,
    onClick: downloadTemplate,
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_21__/* .default */ .Z, null),
    key: "download"
  }, "\u4E0B\u8F7Dexcel\u6A21\u677F"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z, {
    className: "mRight16" // disabled={!canHandle}
    ,
    onClick: clearGoods,
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_22__/* .default */ .Z, null),
    danger: true
  }, "\u6E05\u7A7A\u5546\u54C1\u660E\u7EC6"), props.btnElement), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_Common_SimpleEditableTable_SimpleEditableTable__WEBPACK_IMPORTED_MODULE_3__.default, {
    outLoading: curLoading || props.outLoading,
    showLimitGoodsTips: props !== null && props !== void 0 && props.showLimitGoodsTips ? true : showLimitGoodsTips,
    showTipObj: props !== null && props !== void 0 && props.outShowTipObj && Object.entries(props === null || props === void 0 ? void 0 : props.outShowTipObj).length ? props === null || props === void 0 ? void 0 : props.outShowTipObj : showTipObj,
    curGoodsNum: curGoodsNum,
    hideBtn: true,
    dataSource: (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => tableDataSource, [tableDataSource]),
    hideDeleteBtn: props.hideDeleteBtn,
    columns: priceColumn.filter(item => !item.hide),
    buttonTitle: "\u6DFB\u52A0\u5546\u54C1\u884C",
    tableOptions: {
      scroll: {
        x: 800,
        y: 400
      }
    },
    onChange: tableChange
  }), visible && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_PriceGoodsModal__WEBPACK_IMPORTED_MODULE_4__.default, {
    searchParams: props.searchParams,
    queryApi: props.queryApi,
    closeModalCallback: closeModal,
    saveModalCallback: saveGoodModal,
    merchantId: merchantIds,
    resultCallback: props.resultCallback
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)( /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(PriceProductEditTable)));

/***/ }),

/***/ 85654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2824);
/* harmony import */ var antd_es_date_picker_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14965);
/* harmony import */ var antd_es_date_picker__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11448);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);






/**
 * 调价专用range picker
 * 从开始日期起，查询最多3个月的记录
 */


var RangePicker = antd_es_date_picker__WEBPACK_IMPORTED_MODULE_4__/* .default.RangePicker */ .Z.RangePicker;

var PriceRangePicker = props => {
  var _onChange = e => {
    console.log(e); // if (moment(e[1]) > moment(e[0]).add('days', 90)) {
    //   setdateValue([e[0], moment(e[0]).add('days', 90)])
    //   props.rangeOnChange([e[0], moment(e[0]).add('days', 90)])
    // } else {

    setdateValue(e);
    props.rangeOnChange(e); // }
  };

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState, 2),
      defaultValue = _useState2[0],
      setdefaultValue = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState3, 2),
      dateValue = _useState4[0],
      setdateValue = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    console.log('props?.isLimitMonth', props === null || props === void 0 ? void 0 : props.isLimitMonth);

    if (!(props !== null && props !== void 0 && props.isLimitMonth)) {
      setdefaultValue([]);
      setdateValue([]);
    } else {
      var date = [];

      if (props.defaultTime && props.defaultTime.length) {
        date = props.defaultTime;
      } else {
        date = [moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'months'), moment__WEBPACK_IMPORTED_MODULE_3___default()()];
      }

      setdefaultValue(date);
      setdateValue(date);
    }
  }, [props === null || props === void 0 ? void 0 : props.isLimitMonth]); // function disabledDate(current: any) {
  //   // Can not select days before today and today
  //   return current && current < moment().subtract('days', 90);
  // }

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState5, 2),
      dates = _useState6[0],
      setDates = _useState6[1];

  var disabledDate = current => {
    if (!dates || dates.length === 0) {
      return false;
    }

    var tooLate = dates[0] && current.diff(dates[0], 'days') > 90;
    var tooEarly = dates[1] && dates[1].diff(current, 'days') > 90;
    return tooEarly || tooLate;
  };

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)('最近一月'),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState7, 2),
      curDateSelect = _useState8[0],
      setcurDateSelect = _useState8[1];
  /**
   * 日期选择
   * @param type 类型
   */


  var dateSelectCb = type => {
    switch (type) {
      case '今天':
        setdateValue([moment__WEBPACK_IMPORTED_MODULE_3___default()(), moment__WEBPACK_IMPORTED_MODULE_3___default()()]);
        props.rangeOnChange([moment__WEBPACK_IMPORTED_MODULE_3___default()(), moment__WEBPACK_IMPORTED_MODULE_3___default()()]);
        setcurDateSelect('今天');
        break;

      case '最近一周':
        setdateValue([moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'weeks'), moment__WEBPACK_IMPORTED_MODULE_3___default()()]);
        props.rangeOnChange([moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'weeks'), moment__WEBPACK_IMPORTED_MODULE_3___default()()]);
        setcurDateSelect('最近一周');
        break;

      case '昨天':
        setdateValue([moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'days'), moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'days')]);
        props.rangeOnChange([moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'days'), moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'days')]);
        setcurDateSelect('昨天');
        break;

      default:
        break;
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'end'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(RangePicker, {
    onChange: _onChange,
    ranges: {
      '今天': [moment__WEBPACK_IMPORTED_MODULE_3___default()(), moment__WEBPACK_IMPORTED_MODULE_3___default()()],
      '昨天': [moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'days'), moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'days')],
      '最近一周': [moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'weeks'), moment__WEBPACK_IMPORTED_MODULE_3___default()()],
      '最近一月': [moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'months'), moment__WEBPACK_IMPORTED_MODULE_3___default()()],
      '重置': [moment__WEBPACK_IMPORTED_MODULE_3___default()(), moment__WEBPACK_IMPORTED_MODULE_3___default()()]
    },
    defaultValue: defaultValue,
    value: dateValue // disabledDate={disabledDate}
    ,
    disabledDate: disabledDate,
    onCalendarChange: value => {
      setDates(value);
    },
    style: {
      width: 260
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    style: {
      marginLeft: 10,
      marginRight: 10
    },
    onClick: () => dateSelectCb('今天'),
    type: curDateSelect === '今天' ? 'primary' : 'default'
  }, "\u4ECA\u5929"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    style: {
      marginRight: 10
    },
    onClick: () => dateSelectCb('昨天'),
    type: curDateSelect === '昨天' ? 'primary' : 'default'
  }, "\u6628\u5929"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    style: {
      marginRight: 10
    },
    onClick: () => dateSelectCb('最近一周'),
    type: curDateSelect === '最近一周' ? 'primary' : 'default'
  }, "\u6700\u8FD1\u4E00\u5468"));
};

/* harmony default export */ __webpack_exports__["default"] = (PriceRangePicker);

/***/ }),

/***/ 30176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SimpleEditableTable; }
});

// NAMESPACE OBJECT: ./src/pages/GoodsManage/NewPrice/Common/SimpleEditableTable/components/Field.tsx
var Field_namespaceObject = {};
__webpack_require__.r(Field_namespaceObject);
__webpack_require__.d(Field_namespaceObject, {
  "DATE_PICKER": function() { return DATE_PICKER; },
  "INPUT": function() { return INPUT; },
  "INPUT_NUMBER": function() { return INPUT_NUMBER; },
  "RANGE_PICKER": function() { return RANGE_PICKER; },
  "SELECT": function() { return SELECT; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/table/style/index.js
var table_style = __webpack_require__(66456);
// EXTERNAL MODULE: ./node_modules/antd/es/table/index.js + 45 modules
var table = __webpack_require__(97423);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlusOutlined.js + 1 modules
var PlusOutlined = __webpack_require__(49101);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/antd/es/form/style/index.js
var form_style = __webpack_require__(9715);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 12 modules
var es_form = __webpack_require__(35845);
// EXTERNAL MODULE: ./node_modules/antd/es/popconfirm/style/index.js
var popconfirm_style = __webpack_require__(62350);
// EXTERNAL MODULE: ./node_modules/antd/es/popconfirm/index.js
var popconfirm = __webpack_require__(75443);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(93224);
// EXTERNAL MODULE: ./node_modules/antd/es/input-number/style/index.js
var input_number_style = __webpack_require__(77883);
// EXTERNAL MODULE: ./node_modules/antd/es/input-number/index.js + 2 modules
var input_number = __webpack_require__(39635);
// EXTERNAL MODULE: ./node_modules/antd/es/input/style/index.js
var input_style = __webpack_require__(47673);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 3 modules
var input = __webpack_require__(4107);
// EXTERNAL MODULE: ./node_modules/antd/es/select/style/index.js
var select_style = __webpack_require__(43358);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js
var es_select = __webpack_require__(34041);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/style/index.js
var date_picker_style = __webpack_require__(14965);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/index.js + 6 modules
var date_picker = __webpack_require__(11448);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/NewPrice/Common/SimpleEditableTable/components/Field.tsx











var RangePicker = date_picker/* default.RangePicker */.Z.RangePicker;
var SELECT = props => {
  var fieldOptions = props.fieldOptions,
      dataList = props.dataList,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue;
  var dataSource = dataList;
  return /*#__PURE__*/react.createElement(es_select/* default */.Z, (0,esm_extends/* default */.Z)({
    showSearch: true,
    onBlur: () => fieldChange(''),
    dropdownMatchSelectWidth: false,
    value: fieldValue,
    filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
  }, fieldOptions, {
    onChange: fieldChange,
    style: {
      width: '100%'
    }
  }), dataSource.map(item => {
    var value = item.value,
        label = item.label;
    return /*#__PURE__*/react.createElement(es_select/* default.Option */.Z.Option, {
      key: value,
      value: value,
      rows: item
    }, label);
  }));
};
var INPUT = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      editing = props.editing,
      fieldValue = props.fieldValue;
  var inputRef = (0,react.useRef)();

  var save = e => {
    var val = e.target.value.replace(/(^\s*)|(\s*$)/g, '');
    fieldChange(val);
  };

  (0,react.useEffect)(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);
  return /*#__PURE__*/react.createElement(input/* default */.Z, (0,esm_extends/* default */.Z)({}, fieldOptions, {
    ref: inputRef,
    defaultValue: fieldValue,
    onChange: undefined,
    onPressEnter: save,
    onBlur: save
  }));
};
var RANGE_PICKER = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue;
  return /*#__PURE__*/react.createElement(RangePicker, (0,esm_extends/* default */.Z)({
    allowClear: true,
    style: {
      width: '100%'
    }
  }, fieldOptions, {
    // defaultValue={fieldValue}
    onChange: fieldChange
  }));
};
var DATE_PICKER = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue;
  var format = (fieldOptions === null || fieldOptions === void 0 ? void 0 : fieldOptions.fieldOptions) || 'YYYY-MM-DD';

  var handleChange = e => {
    var data = e ? moment_default()(e).format(format) : undefined;
    fieldChange(data);
  };

  return /*#__PURE__*/react.createElement(date_picker/* default */.Z, (0,esm_extends/* default */.Z)({
    style: {
      width: '100%'
    },
    format: format
  }, fieldOptions, {
    // defaultValue={value}
    onChange: handleChange
  }));
};
var INPUT_NUMBER = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      editing = props.editing,
      fieldValue = props.fieldValue,
      blurCallBack = props.blurCallBack;
  var inputRef = (0,react.useRef)();

  var save = e => {
    var val = e.target.value;
    fieldChange(val);
    blurCallBack && blurCallBack(val);
  };

  (0,react.useEffect)(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);
  return /*#__PURE__*/react.createElement(input_number/* default */.Z, (0,esm_extends/* default */.Z)({
    style: {
      width: '100%'
    }
  }, fieldOptions, {
    ref: inputRef,
    defaultValue: fieldValue,
    onChange: undefined,
    onPressEnter: save,
    onBlur: save
  }));
}; // export const SELECT_INPUT_NUMBER = (props: FieldsProps) => {
//   const { fieldOptions, dataList, fieldChange, fieldValue } = props
//   return (
//     <AutoComplete
//       options={dataList}
//       allowClear
//       showSearch
//        value={fieldValue}
//       filterOption={(input, option: any) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
//       {...fieldOptions}
//       onChange={fieldChange}
//     >
//       <InputNumber
//         placeholder='input here'
//         className='custom'
//         style={{ height: 50 }}
//         // onKeyPress={handleKeyPress}
//       />
//     </AutoComplete>
//   )
// }
;// CONCATENATED MODULE: ./src/pages/GoodsManage/NewPrice/Common/SimpleEditableTable/utils/context.tsx

var EditableContext = /*#__PURE__*/react.createContext(undefined);
var ContextWrapper = props => {
  return /*#__PURE__*/react.createElement(EditableContext.Provider, {
    value: props.value
  }, props.children);
};
;// CONCATENATED MODULE: ./src/pages/GoodsManage/NewPrice/Common/SimpleEditableTable/components/EditableCell.tsx








var _excluded = ["title", "editable", "children", "dataIndex", "type", "record", "rowIndex", "render", "dataList", "fieldOptions", "handleSaveRow", "handleDeleteRow", "hidedeletebtn"];


 // import { getEditableTableKey } from '../PageEditableTable'


 // 获取唯一的key

function getEditableTableKey() {
  return lodash_default().uniqueId('edittable_');
}
var Field = Field_namespaceObject;

var EditableCell = props => {
  var title = props.title,
      editable = props.editable,
      children = props.children,
      dataIndex = props.dataIndex,
      type = props.type,
      record = props.record,
      rowIndex = props.rowIndex,
      render = props.render,
      getDataList = props.dataList,
      fieldOptions = props.fieldOptions,
      handleSaveRow = props.handleSaveRow,
      handleDeleteRow = props.handleDeleteRow,
      hidedeletebtn = props.hidedeletebtn,
      restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded); // 拼接操作


  if (render && title === '操作') {
    // const { editableTableAdd } = record ?? {}
    // 给新增的行添加背景颜色
    return /*#__PURE__*/react.createElement("td", restProps, !hidedeletebtn && /*#__PURE__*/react.createElement(popconfirm/* default */.Z, {
      title: "\u786E\u8BA4\u5220\u9664\u8FD9\u6761\u6570\u636E\u5417\uFF1F",
      onConfirm: () => handleDeleteRow(record.editableTableKey),
      okText: "\u786E\u8BA4",
      cancelText: "\u53D6\u6D88"
    }, /*#__PURE__*/react.createElement("a", {
      style: {
        marginRight: '8px'
      }
    }, "\u5220\u9664")), render(record[dataIndex], record, rowIndex));
  }

  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      editing = _useState2[0],
      setEditing = _useState2[1];

  var form = (0,react.useContext)(EditableContext);
  var dataList = (0,react.useMemo)(() => {
    var isFunc = typeof getDataList === 'function';

    if (isFunc) {
      var _ref;

      return (_ref = getDataList(record)) !== null && _ref !== void 0 ? _ref : [];
    }

    return getDataList !== null && getDataList !== void 0 ? getDataList : [];
  }, [record, getDataList]); // 针对存在「dataList」的单元格进行设置；使单元格展示的是文案而不是值

  var childContent = (0,react.useMemo)(() => {
    if (!Array.isArray(children)) {
      return children;
    }
    /**
     * 如果当前单元格的 可编辑 状态是 Select、Radio等具有「dataList」属性的表单控件
     * 1. 对该值进行判断校验
     * 2. 最后获取到该值对应的 中文 文案，并交给Table渲染该单元格
     */


    var val = children.slice(1)[0];
    var childType = typeof val;

    if (!val) {
      return children;
    }

    if (childType === 'object' || childType === 'function') {
      return children;
    } // 过滤可能出现的不必要的标签


    var newChildren = childType === 'string' ? val.replace('<tt>', '').replace('</tt>', '') : val;

    if (!dataList) {
      return [undefined, newChildren];
    }

    var _ref2 = dataList.find(v => v.value === val) || {},
        label = _ref2.label;

    return [undefined, label !== null && label !== void 0 ? label : val];
  }, [children, dataList, dataIndex]); // 每条数据添加「editableTableKey」属性，相当于主键ID

  (0,react.useEffect)(() => {
    // 防止重复生成ID，预防后续操作的数据无法追溯
    if (record && !record.editableTableKey) {
      record.editableTableKey = getEditableTableKey();
    }
  }, [record]); // 如果没有传「type」时设置默认是「INPUT」
  // 传了「type」 可以不传 「editable」

  var fieldType = !type && editable ? 'INPUT' : type; // 更改单元格的编辑状态

  var toggleEdit = () => {
    setEditing(!editing);
  }; // 控件发生变化时


  var fieldChange = val => {
    try {
      // 切换编辑状态
      toggleEdit();

      if (!val && val !== 0) {
        return;
      }

      var values = form.getFieldsValue(); // 更新后的本行数据

      var params = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, record), values), {}, {
        [dataIndex]: val
      }); // 如果自定义了回调


      if (fieldOptions !== null && fieldOptions !== void 0 && fieldOptions.onChange) {
        fieldOptions.onChange(params);
      } // 单元格字段名对于的数据


      var currentCell = {
        [dataIndex]: val
      }; // 是否修改过数据

      var hasEdited = record[dataIndex] !== val;
      handleSaveRow(params, {
        hasEdited,
        currentCell
      });
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  }; // 设置组件回显的值


  var defaultVal = record ? record[dataIndex] : undefined;
  var childNode = childContent;
  var fieldVal = ['string', 'number'].includes(typeof defaultVal) ? defaultVal : undefined;
  /**
   * 如果存在自定义渲染的情况，给「render」函数的第四项添加参数
   */

  if (render) {
    var getFieldComponent = renderParams => {
      var fieldType = renderParams.fieldType;

      if (editing && fieldType) {
        var FieldComponent = Field[fieldType];
        return /*#__PURE__*/react.createElement(FieldComponent, (0,esm_extends/* default */.Z)({
          dataList: dataList
        }, props, renderParams, {
          fieldChange: fieldChange,
          fieldValue: fieldVal,
          editing: editing
        }));
      }

      return /*#__PURE__*/react.createElement("div", {
        className: "editableCellValueWrap",
        onClick: toggleEdit
      }, childNode);
    };

    return /*#__PURE__*/react.createElement("td", restProps, render(record[dataIndex], record, rowIndex, getFieldComponent));
  }

  if (fieldType) {
    var FieldComponent = Field[fieldType];
    childNode = editing ? /*#__PURE__*/react.createElement(es_form/* default.Item */.Z.Item, {
      style: {
        margin: 0,
        padding: 0
      },
      name: dataIndex
    }, /*#__PURE__*/react.createElement(FieldComponent, (0,esm_extends/* default */.Z)({}, props, {
      dataList: dataList,
      fieldChange: fieldChange,
      fieldValue: fieldVal,
      editing: editing
    }))) : /*#__PURE__*/react.createElement("div", {
      className: "editableCellValueWrap",
      onClick: toggleEdit
    }, childContent);
  }

  return /*#__PURE__*/react.createElement("td", restProps, childNode);
};

/* harmony default export */ var components_EditableCell = (EditableCell);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/pages/GoodsManage/NewPrice/Common/SimpleEditableTable/index.less?modules
var SimpleEditableTablemodules = __webpack_require__(19002);
var SimpleEditableTablemodules_default = /*#__PURE__*/__webpack_require__.n(SimpleEditableTablemodules);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/NewPrice/Common/SimpleEditableTable/components/EditableRow.tsx





var EditableRow_excluded = ["index"];





var EditableRow = _ref => {
  var _params$record;

  var index = _ref.index,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, EditableRow_excluded);

  var _Form$useForm = es_form/* default.useForm */.Z.useForm(),
      _Form$useForm2 = (0,slicedToArray/* default */.Z)(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var params = props; // 获取表格行的「editableTableAdd」，存在则表示当前行为新增的行

  var _ref2 = (_params$record = params === null || params === void 0 ? void 0 : params.record) !== null && _params$record !== void 0 ? _params$record : {},
      editableTableAdd = _ref2.editableTableAdd;

  return /*#__PURE__*/react.createElement(es_form/* default */.Z, {
    form: form,
    component: false
  }, /*#__PURE__*/react.createElement(ContextWrapper, {
    value: form
  }, /*#__PURE__*/react.createElement("tr", (0,esm_extends/* default */.Z)({}, props, {
    className: classnames_default()((SimpleEditableTablemodules_default()).editableTableRow, {
      newRow: !!editableTableAdd
    })
  }))));
};

/* harmony default export */ var components_EditableRow = (EditableRow);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/NewPrice/Common/SimpleEditableTable/utils/constance.ts
var tableOptionsCol = {
  title: '操作',
  dataIndex: 'operatess',
  key: 'operatess',
  fixed: 'right',
  width: 120,
  render: (t, r, i) => {
    return null;
  }
};
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(5977);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/NewPrice/Common/SimpleEditableTable/SimpleEditableTable.tsx










/* eslint-disable react-hooks/exhaustive-deps */

/**
 * 数据全是外部传入的 可编辑表格
 */









var EditableTable = props => {
  var _useState = (0,react.useState)(props.dataSource),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      dataSource = _useState2[0],
      setDataSource = _useState2[1];

  var history = (0,react_router/* useHistory */.k6)();
  var addRowData = (0,react.useMemo)(() => {
    return props.columns.reduce((prev, next) => {
      prev[next.dataIndex] = undefined;
      return prev;
    }, {});
  }, []);

  var _useState3 = (0,react.useState)([]),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      selectedRowKeys = _useState4[0],
      setSelectedRowKeys = _useState4[1]; // 新增行


  var handleAddRow = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
      var rowData, list;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              try {
                // 每个新增的数据都设置一个键为「editableTableKey」的随机值
                rowData = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, addRowData), {}, {
                  editableTableKey: lodash_default().uniqueId('edittable_')
                });
                list = [rowData, ...dataSource]; // if (props.addRow) {
                //   await props.addRow()
                // }
                // if (props.addRow) {
                //   props.addRow(addRowData, list)
                // }

                if (props.onChange) {
                  props.onChange(addRowData, list);
                }

                setDataSource(list);
              } catch (error) {
                console.log('add row failed：', error);
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleAddRow() {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * 保存表格行数据
   * @param data 当前修改保存的表格行所有数据
   * @param other 其他参数
   */
  // const handleSaveRow = async (data: any, other: any) => {
  //   try {
  //     // hasEdited，数据是否变化
  //     const { hasEdited, currentCell } = other
  //     if (!hasEdited) {
  //       return
  //     }
  //     // 赋值更新 列表数据
  //     const list = dataSource.map((v: any) => (v.editableTableKey === data.editableTableKey ? data : v))
  //     // 更新选中的数据
  //     // const selectedKeys = selectedRowKeys.map((v: any) => (v.editableTableKey === data.editableTableKey ? data : v))
  //     if (props.onChange) {
  //       /**
  //        * currentCell：当前编辑的单元格数据，{字段名：值}
  //        * currentRow：当前编辑的行数据
  //        * dataSource：表格所有数据
  //        */
  //       const dataParams = { currentCell, currentRow: data, dataSource: list, type: 'EDIT' as HandleType }
  //       // props.onChange(dataParams, [])
  //     }
  //     // if (props.saveRow) {
  //     //   await props.saveRow(data, list)
  //     // } else {
  //     setDataSource(list)
  //     // }
  //     if (props.onChange) {
  //       props.onChange(data, list)
  //     }
  //   } catch (error) {
  //     console.log('save row failed：', error)
  //   }
  // }

  /**
  * 对比和替换列表数据
  * @param list 列表数据
  * @param data 更新后的 列表行数据
  */


  function compareAndChangeData(list, data) {
    return list.map(v => v.editableTableKey === data.editableTableKey ? data : v);
  }
  /**
   * 保存表格行数据
   * @param data 当前修改保存的表格行所有数据
   * @param other 其他参数
   */


  var handleSaveRow = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(data, other) {
      var hasEdited, currentCell, list, dataParams;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              // hasEdited，数据是否变化
              hasEdited = other.hasEdited, currentCell = other.currentCell;

              if (hasEdited) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              // 赋值更新 列表数据
              list = compareAndChangeData(dataSource, data);

              if (props.onChange) {
                /**
                 * currentCell：当前编辑的单元格数据，{字段名：值}
                 * currentRow：当前编辑的行数据
                 * dataSource：表格所有数据
                 */
                dataParams = {
                  currentCell,
                  currentRow: data,
                  dataSource: list,
                  type: 'EDIT'
                };
                props.onChange(dataParams, list);
              } // 如果存在异步保存函数


              if (props.saveRow) {
                props.saveRow(data, list); // const res = await props.saveRow(data, list)
                // console.log(res)
                // table.current.reflashTable()
              }

              setDataSource(list); // 清空 模拟删除的队列
              // setRemovedRows([])

              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              console.error('save row failed：', _context2.t0);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    }));

    return function handleSaveRow(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(); // 删除行


  var handleDeleteRow = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3(i) {
      var list, dataParams;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              try {
                // const obj: any =
                //   dataSource.find((v: any) => v.editableTableKey === i) || {};
                list = dataSource.filter(v => v.editableTableKey !== i); // 如果删除的是已经选中的行数据，过滤了
                // const selectedRows = !!selectedRowKeys.length ? selectedRowKeys.filter((vi: any) => vi.editableTableKey !== i) : []
                // setSelectedRowKeys(selectedRows)

                if (props.onChange) {
                  /**
                   * currentCell：当前编辑的单元格数据，{字段名：值}
                   * currentRow：当前编辑的行数据
                   * dataSource：表格所有数据
                   */
                  dataParams = {
                    currentCell: {},
                    currentRow: {},
                    dataSource: list,
                    type: 'DELETE'
                  }; // 如果存在 onChange 则将删除后的结果数据返回

                  props.onChange(dataParams, list);
                } // if (props.deleteRow) {
                //   await props.deleteRow(obj, list)
                //   table.current.reflashTable()
                // } else {
                // 将之前新增时模拟删除的一项数据加回来
                // setTableParams((v: any) => ({ ...v, dataSource: [...list, ...removedRows] }))
                // }
                // if (props.onChange) {
                //   props.onChange(data, list)
                // }


                setDataSource(list);
              } catch (error) {
                console.log('delete row failed：', error);
              }

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleDeleteRow(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(() => {
    setDataSource(props.dataSource);
  }, [props.dataSource]); // 如果没有设置「hideDeleteBtn」，给「columns」拼接操作表头，并补上删除功能

  var renderCol = (0,react.useMemo)(() => {
    if (props.hideDeleteBtn) {
      return props.columns;
    }

    return props.columns.every(v => v.title !== '操作') ? [...props.columns, tableOptionsCol] : props.columns;
  }, [props.columns]);
  var columns = (0,react.useMemo)(() => {
    return renderCol.map(col => {
      // 如果当前column不存在 editable 字段、表头文案不是操作以及没有 type 值，表示当前单元格展示的是文案而不是表单组件
      if (!col.editable && col.title !== '操作' && !col.type && !col.render) {
        return col;
      }

      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, col), {}, {
        onCell: (record, rowIndex) => {
          return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, col), {}, {
            rowIndex,
            record,
            handleSaveRow,
            handleDeleteRow,
            hidedeletebtn: props.hideDeleteBtn
          });
        }
      });
    });
  }, [renderCol, handleSaveRow, handleDeleteRow, props.hideDeleteBtn]);
  var selection = {
    selectedRowKeys: selectedRowKeys,
    onChange: (keys, selectedRows) => {
      setSelectedRowKeys(keys);

      if (props.onChange) {
        var dataParams = {
          currentCell: {},
          currentRow: {},
          dataSource: dataSource,
          type: 'SELECTED'
        };
        props.onChange(dataParams, keys);
      }

      if (props.rowSelectCallback) {
        props.rowSelectCallback(keys, selectedRows);
      }
    }
  }; // 表格事件操作

  var changeTable = (pagination, filters, sorters) => {
    props.pageChange(pagination);
  };

  var getPagination = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
    showSizeChanger: true,
    showQuickJumper: true,
    pageSizeOptions: ['30', '100', '300', '500'],
    pageSize: 30,
    total: 0,
    current: 1
  }, props.pageInfo), {}, {
    showTotal: total => /*#__PURE__*/react.createElement("div", null, "\u5171 ", total, " \u6761")
  });

  var showTipObj = props.showTipObj;
  return /*#__PURE__*/react.createElement("div", null, (props === null || props === void 0 ? void 0 : props.showLimitGoodsTips) && /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/react.createElement("div", {
    style: {
      fontSize: 15,
      marginBottom: 5
    }
  }, "\u6210\u529F\u5BFC\u5165 ", showTipObj === null || showTipObj === void 0 ? void 0 : showTipObj.successCount, " \u6761\u6570\u636E  ", (showTipObj === null || showTipObj === void 0 ? void 0 : showTipObj.errorCount) && /*#__PURE__*/react.createElement("span", null, "\u672A\u5BFC\u5165 ", /*#__PURE__*/react.createElement("span", {
    style: {
      color: 'red'
    }
  }, showTipObj === null || showTipObj === void 0 ? void 0 : showTipObj.errorCount), " \u6761\u6570\u636E")), (showTipObj === null || showTipObj === void 0 ? void 0 : showTipObj.successUrl) && /*#__PURE__*/react.createElement("a", {
    style: {
      fontSize: 16,
      marginBottom: 5
    },
    onClick: () => {
      window.location.href = showTipObj === null || showTipObj === void 0 ? void 0 : showTipObj.successUrl;
    }
  }, "\u4E0B\u8F7D\u5DF2\u5BFC\u5165\u7ED3\u679C"), (showTipObj === null || showTipObj === void 0 ? void 0 : showTipObj.errorUrl) && /*#__PURE__*/react.createElement("a", {
    style: {
      fontSize: 16,
      marginBottom: 5
    },
    onClick: () => {
      if (showTipObj !== null && showTipObj !== void 0 && showTipObj.errorUrl) {
        window.location.href = showTipObj === null || showTipObj === void 0 ? void 0 : showTipObj.errorUrl;
      }
    }
  }, "\u4E0B\u8F7D\u672A\u5BFC\u5165\u7ED3\u679C"), (showTipObj === null || showTipObj === void 0 ? void 0 : showTipObj.detailUrl) && /*#__PURE__*/react.createElement("a", {
    style: {
      fontSize: 16,
      marginBottom: 5
    },
    onClick: () => {
      if (showTipObj !== null && showTipObj !== void 0 && showTipObj.detailUrl) {
        history.push(showTipObj === null || showTipObj === void 0 ? void 0 : showTipObj.detailUrl);
      }
    }
  }, "\u67E5\u770B\u5BFC\u5165\u5546\u54C1\u8BE6\u60C5"))), !(props !== null && props !== void 0 && props.showLimitGoodsTips) && /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(table/* default */.Z, (0,esm_extends/* default */.Z)({
    components: {
      body: {
        row: components_EditableRow,
        cell: components_EditableCell
      }
    },
    rowClassName: () => 'editableTable',
    rowSelection: props.canSelected ? selection : undefined,
    onChange: changeTable,
    dataSource: dataSource,
    columns: columns,
    rowKey: (re, k) => re.id ? re.id : k,
    pagination: getPagination,
    size: "small",
    loading: props === null || props === void 0 ? void 0 : props.outLoading
  }, props.tableOptions)), !props.hideBtn && /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    type: "dashed",
    onClick: handleAddRow,
    className: "mTop16",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/react.createElement(PlusOutlined/* default */.Z, null), " ", props.buttonTitle || '添加')));
};

/* harmony default export */ var SimpleEditableTable = (EditableTable);

/***/ }),

/***/ 31903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCategory2TreeData; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24731);





/** 给 TreeSelect 提供数据源 */
var useCategory2TreeData = function useCategory2TreeData() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var categoryFilter = props.categoryFilter;
  var initCategory = JSON.parse(sessionStorage.getItem('markedPriceCategory'));

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initCategory || [[]]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState, 2),
      category = _useState2[0],
      setCategory = _useState2[1];

  var genTreeSelect = data => {
    return data === null || data === void 0 ? void 0 : data.map(item => {
      var backCategoryName = item.backCategoryName,
          backCategoryId = item.backCategoryId,
          childBackCategory = item.childBackCategory;

      if (childBackCategory.length) {
        childBackCategory = genTreeSelect(childBackCategory);
      }

      var childCategoryList = {};
      childBackCategory.forEach(i => {
        childCategoryList[i.categoryId] = i;
      });
      return item.level === 1 ? {
        label: backCategoryName,
        value: +backCategoryId,
        others: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)({
          childCategoryList
        }, item)
      } : {
        categoryId: +backCategoryId,
        categoryName: backCategoryName,
        others: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)({
          childCategoryList
        }, item)
      };
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (initCategory) return;
    var url = 'pms.backCategoryManage.getBackCategoryTree'; // 返回所有类目

    (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)(url, {
      businessType: 1,
      status: 1
    }).then(_ref => {
      var success = _ref.success,
          result = _ref.result;

      if (success) {
        var arr = result.childBackCategory;
        if (categoryFilter instanceof Function) arr = categoryFilter(arr);
        var categoryTree = genTreeSelect(arr);
        sessionStorage.setItem('markedPriceCategory', JSON.stringify([categoryTree, result]));
        setCategory([categoryTree, result]);
      }
    });
  }, []);
  return category;
};

/***/ }),

/***/ 20699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vG": function() { return /* binding */ SELL_PRICE_LIST_API; },
/* harmony export */   "Kh": function() { return /* binding */ SELL_PRICE_DETAIL_API; },
/* harmony export */   "LY": function() { return /* binding */ SELL_PRICE_DETAIL_INFO_API; },
/* harmony export */   "U$": function() { return /* binding */ SELL_PRICE_DETAIL_GOODS_API; },
/* harmony export */   "EJ": function() { return /* binding */ SELL_PRICE_UPDATE_API; },
/* harmony export */   "Lf": function() { return /* binding */ SELL_PRICE_ADD_API; },
/* harmony export */   "qj": function() { return /* binding */ SELL_PRICE_DELETE_API; },
/* harmony export */   "n6": function() { return /* binding */ SELL_PRICE_VALIDATE_API; },
/* harmony export */   "Eb": function() { return /* binding */ IMPORT_ORDER_EXCEL; },
/* harmony export */   "Zf": function() { return /* binding */ EXPORT_EXCEL_API; },
/* harmony export */   "wh": function() { return /* binding */ CHECK_PRICE_API; },
/* harmony export */   "hD": function() { return /* binding */ CHECK_SALE_PRICE_API; }
/* harmony export */ });
/* unused harmony export IMPORT_KEY_EXCEL */
/**
 * API集合
 */

/** 调价单 进价列表 */
var SELL_PRICE_LIST_API = 'pms.sgPriceModifyManageService.querySgPriceModifyRecordList';
/** 调价单 详情-编辑用 */

var SELL_PRICE_DETAIL_API = 'pms.sgPriceModifyManageService.queryPriceModifyRecordDetail';
/** 调价单 详情- 详情页用 */

var SELL_PRICE_DETAIL_INFO_API = 'pms.sgPriceModifyManageService.querySgPriceModifyRecordInfo';
/** 调价单 进价详情-获取商品分页 */

var SELL_PRICE_DETAIL_GOODS_API = 'pms.sgPriceModifyManageService.querySgPriceModifyRecordBusinessItemList';
/** 调价单 进价修改保存 */

var SELL_PRICE_UPDATE_API = 'pms.sgPriceModifyManageService.updateSgPriceModifyRecord';
/** 调价单 进价新增 */

var SELL_PRICE_ADD_API = 'pms.sgPriceModifyManageService.addSgPriceModifyRecord';
/** 调价单 进价删除 */

var SELL_PRICE_DELETE_API = 'pms.sgPriceModifyManageService.deleteSgPriceModifyRecord';
/** 调价单 进价审核 */

var SELL_PRICE_VALIDATE_API = 'pms.sgPriceModifyManageService.updateSgPriceModifyRecordEffectiveStatus';
/** 调价 - 导入 */

var IMPORT_ORDER_EXCEL = 'pms.sgPriceModifyManageService.importSgPriceModify';
/** 导入 结果处理 */

var IMPORT_KEY_EXCEL = 'pms.sgPriceModifyManageService.getImportSgPriceModifyResult';
/** 下载 */

var EXPORT_EXCEL_API = 'pms.sgPriceModifyManageService.exportSgPriceModifyRecordBusinessItemList';
/** 进价调整增加价格校验 */

var CHECK_PRICE_API = 'pms.sgPriceModifyManageService.checkAbnormalPrice';
/** 售价调整增加价格校验 */

var CHECK_SALE_PRICE_API = 'pms.sgPriceModifyManageService.checkSalePriceAbnormal';

/***/ }),

/***/ 7136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ FormCommonTable; }
});

// NAMESPACE OBJECT: ./src/pages/GoodsManage/Price/Common/FormCommonTable/utils/queryStructure.ts
var queryStructure_namespaceObject = {};
__webpack_require__.r(queryStructure_namespaceObject);
__webpack_require__.d(queryStructure_namespaceObject, {
  "useHefei": function() { return useHefei; },
  "useNormal": function() { return useNormal; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/spin/style/index.js
var style = __webpack_require__(20228);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js
var spin = __webpack_require__(11382);
// EXTERNAL MODULE: ./node_modules/antd/es/table/style/index.js
var table_style = __webpack_require__(66456);
// EXTERNAL MODULE: ./node_modules/antd/es/table/index.js + 45 modules
var table = __webpack_require__(97423);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/antd/es/alert/style/index.js
var alert_style = __webpack_require__(17462);
// EXTERNAL MODULE: ./node_modules/antd/es/alert/index.js + 2 modules
var es_alert = __webpack_require__(1474);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/Price/Common/FormCommonTable/utils/queryStructure.ts
var useNormal = (page, size) => {
  return {
    page,
    size
  };
};
var useHefei = (page, size) => {
  return {
    pageReq: {
      pageNum: page,
      pageSize: size
    }
  };
};
// EXTERNAL MODULE: ./src/hooks/useCompareEffect.ts
var useCompareEffect = __webpack_require__(19125);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/Price/Common/FormCommonTable/index.tsx












/**
 * 通用列表
 */

/* eslint-disable @typescript-eslint/member-ordering */

/* eslint-disable @typescript-eslint/no-unused-vars */







var CommonTable = (props, ref) => {
  var _props$tableParams, _props$pageSize;

  var _props$showAlert = props.showAlert,
      showAlert = _props$showAlert === void 0 ? true : _props$showAlert,
      formatResult = props.formatResult,
      _props$reqStructure = props.reqStructure,
      reqStructure = _props$reqStructure === void 0 ? 'useNormal' : _props$reqStructure,
      tableOptions = props.tableOptions; // // 是否阻止发送请求
  // const cancelRequest = useRef<boolean | undefined>(props.cancelRequest)

  var componentDidMount = (0,react.useRef)(false);

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      selectedRowKeys = _useState2[0],
      setSelectedRowKeys = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = (0,react.useState)((_props$tableParams = props.tableParams) !== null && _props$tableParams !== void 0 ? _props$tableParams : {
    dataSource: [],
    total: 0,
    current: 1,
    pageSize: (_props$pageSize = props.pageSize) !== null && _props$pageSize !== void 0 ? _props$pageSize : 10,
    order: {},
    filters: {},
    sorters: {}
  }),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      tableParams = _useState6[0],
      setTableParams = _useState6[1];
  /**
   * values 外部查询调用传参
   * pageParams 分页等查询参数
   */


  var sendRequest = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
      var _props$pageSize2;

      var current,
          pageSize,
          _props$searchParams,
          searchParams,
          sParams,
          params,
          _ref2,
          result,
          _result$result,
          isEnd,
          _result$result$total,
          total,
          l,
          d,
          data,
          totalCount,
          currentNoData,
          _args = arguments;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              current = _args.length > 0 && _args[0] !== undefined ? _args[0] : 1;
              pageSize = _args.length > 1 && _args[1] !== undefined ? _args[1] : (_props$pageSize2 = props.pageSize) !== null && _props$pageSize2 !== void 0 ? _props$pageSize2 : 10;
              setLoading(true);
              _props$searchParams = props.searchParams, searchParams = _props$searchParams === void 0 ? {} : _props$searchParams;
              sParams = lodash_default().cloneDeep(searchParams);
              params = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, queryStructure_namespaceObject[reqStructure](current, pageSize)), sParams);
              _context.prev = 6;
              _context.next = 9;
              return (0,ypRequest/* default */.Z)(props.queryDataUrl, params);

            case 9:
              result = _context.sent;

              if (formatResult instanceof Function) {
                // 交给调用处格式化数据
                result.result = formatResult(result.result);
              }

              _result$result = result.result, isEnd = _result$result.isEnd, _result$result$total = _result$result.total, total = _result$result$total === void 0 ? 0 : _result$result$total, l = _result$result.list, d = _result$result.data;
              data = (_ref2 = d !== null && d !== void 0 ? d : l) !== null && _ref2 !== void 0 ? _ref2 : [];

              if (!(!data || !Array.isArray(data))) {
                _context.next = 15;
                break;
              }

              throw '接口返回的数据结构错误';

            case 15:
              // 对「total」进行数据转化
              totalCount = +total;

              if (!isNaN(totalCount)) {
                _context.next = 18;
                break;
              }

              throw '「total」字段类型错误';

            case 18:
              currentNoData = isEnd && !data.length;
              setTableParams(v => {
                // 如果为最后一页且页码大于一且本页无数据
                if (currentNoData && current > 1) {
                  return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
                    current: v.current - 1
                  });
                }

                return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
                  dataSource: data,
                  total,
                  current,
                  pageSize
                });
              }); // 清空表格多选选中的行

              setSelectedRowKeys([]);

              if (props.returnData) {
                props.returnData(data, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, tableParams), {}, {
                  dataSource: data,
                  total,
                  current,
                  pageSize
                }));
              }

              _context.next = 26;
              break;

            case 24:
              _context.prev = 24;
              _context.t0 = _context["catch"](6);

            case 26:
              _context.prev = 26;
              setLoading(false);
              return _context.finish(26);

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 24, 26, 29]]);
    }));

    return function sendRequest() {
      return _ref.apply(this, arguments);
    };
  }(); // 表格事件操作


  var changeTable = (pagination, filters, sorters) => {
    var current = pagination.current,
        pageSize = pagination.pageSize;
    var column = sorters.column; // 防止没有排序的列发生请求

    if (sorters.column && !column.sorter) {
      return;
    }

    setTableParams(v => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
      current,
      pageSize,
      filters,
      sorters
    }));
    sendRequest(current, pageSize); // 排序的回调

    if (props.sortCallback) {
      props.sortCallback(filters, sorters);
    } // 页面切换后，清空选中项


    setSelectedRowKeys([]);

    if (props.rowSelectCallback) {
      props.rowSelectCallback([], []);
    }
  };
  /**
   * 通过该 hook 定义父组件 ref 拿到子组件的实例的内容
   * 父组件使用 reflashTable 来调用子组件 sendRequest 这个方法
   */


  (0,react.useImperativeHandle)(ref, () => ({
    reflashTable: params => sendRequest(params),
    getTableData: () => tableParams
  }), [tableParams]);
  /**
   * 初始化加载时
   */

  (0,react.useEffect)(() => {
    // 没有设置 cancelRequest 时发送请求
    if (!props.cancelRequest) {
      sendRequest();
    }
  }, [props.searchParams]); // }, [props.searchParams, props.cancelRequest])
  // useEffect(() => {
  // }, []);

  (0,react.useEffect)(() => {
    componentDidMount.current = true;
  }, []); // 替换当前页的数据

  (0,react.useEffect)(() => {
    // console.log('触发了一次')
    setTableParams(v => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
      dataSource: props.dataSource
    }));
  }, [props.dataSource]);
  /**
   * 覆盖组件表格的参数；
   * 用于表格的自定义操作
   */

  (0,useCompareEffect/* default */.Z)(() => {
    if (!props.tableParams) {
      return;
    }

    setTableParams(props.tableParams);
  }, [props.tableParams]);
  /**
   * 默认的多选配置
   */
  // const selection = {
  //   selectedRowKeys: selectedRowKeys,
  //   onChange: (keys: any[] | any, selectedRows: any[]) => {
  //     setSelectedRowKeys(keys)
  //     if (props.rowSelectCallback) {
  //       props.rowSelectCallback(keys, selectedRows)
  //     }
  //   }
  // }

  var selection = (0,react.useMemo)(() => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.rowSelection), {}, {
    selectedRowKeys: selectedRowKeys,
    onChange: (keys, selectedRows) => {
      setSelectedRowKeys(keys);

      if (props.rowSelectCallback) {
        props.rowSelectCallback(keys, selectedRows);
      }
    }
  }), [props.rowSelectCallback, selectedRowKeys, tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.rowSelection]);
  /**
   * 获取CommonTable的selection配置
   */

  var getRowSelection = () => {
    // 如果没有自定义配置「rowSelection」以及没有「rowSelectCallback」表示不需要列表多选
    if (!(tableOptions !== null && tableOptions !== void 0 && tableOptions.rowSelection) && !props.rowSelectCallback) {
      return undefined;
    } // 自定义多选


    if (tableOptions && tableOptions.rowSelection) {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, tableOptions.rowSelection), selection);
    } // 默认的多选


    if (props.rowSelectCallback) {
      return selection;
    }
  };

  var getPagination = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
    showSizeChanger: true,
    showQuickJumper: true,
    pageSizeOptions: ['10', '30', '50', '100'],
    pageSize: tableParams.pageSize
  }, tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.pagination), {}, {
    total: tableParams.total,
    current: tableParams.current,
    showTotal: (total, range) => {
      if (props.paginationElement) {
        return /*#__PURE__*/react.createElement("div", {
          className: "paginationElement"
        }, props.paginationElement(total, range));
      }

      return null;
    }
  });

  return /*#__PURE__*/react.createElement(spin/* default */.Z, {
    spinning: loading,
    wrapperClassName: "commonTable"
  }, showAlert && /*#__PURE__*/react.createElement("div", {
    className: "table-alert"
  }, /*#__PURE__*/react.createElement(es_alert/* default */.Z, {
    message: "\u5171\u6709".concat(tableParams.total, "\u6761\u6570\u636E"),
    type: "warning",
    showIcon: true,
    key: "alert"
  })), /*#__PURE__*/react.createElement(table/* default */.Z, (0,esm_extends/* default */.Z)({
    columns: props.columns,
    dataSource: tableParams.dataSource // rowKey={(key, record: any) => console.log(key, record)}
    ,
    rowKey: (record, key) => {
      var _record$siteId;

      return (_record$siteId = record.siteId) !== null && _record$siteId !== void 0 ? _record$siteId : key;
    },
    onChange: changeTable,
    key: "table",
    size: "small"
  }, tableOptions, {
    rowSelection: getRowSelection(),
    pagination: props.hidePagination ? false : getPagination
  })));
};

/* harmony default export */ var FormCommonTable = (/*#__PURE__*/(0,react.memo)( /*#__PURE__*/(0,react.forwardRef)(CommonTable)));

/***/ }),

/***/ 25804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Common_PriceGoodsModal; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/modal/style/index.js
var style = __webpack_require__(71194);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(57016);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/index.js
var message_style = __webpack_require__(34792);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(48086);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/FormBuilder/index.tsx + 4 modules
var FormBuilder = __webpack_require__(5670);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/Price/Common/PriceGoodsModal/columns.ts
var levelMapper = {
  1: '基础',
  2: '折扣',
  3: '精品'
};
var sellPriceColumn = [{
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 140
}, {
  title: '商品条码',
  dataIndex: 'barcode',
  key: 'barcode',
  width: 140
}, {
  title: '商品名称',
  dataIndex: 'productName',
  key: 'productName',
  width: 140
}, {
  title: 'PLU码',
  dataIndex: 'pluCode',
  key: 'pluCode',
  width: 140
}, {
  title: 'PLU码级别',
  dataIndex: 'pluLevel',
  key: 'pluLevel',
  width: 140,
  render: (t, r, i, fn) => {
    return t ? levelMapper[t] : '';
  }
}, {
  title: '商品类目',
  dataIndex: 'backCategoryName',
  key: 'backCategoryName',
  width: 140
}, {
  title: '品牌',
  dataIndex: 'brandName',
  key: 'brandName',
  width: 120
}, {
  title: '单位',
  dataIndex: 'saleUnit',
  key: 'saleUnit',
  width: 100
}, {
  title: '规格描述',
  dataIndex: 'specDesc',
  key: 'specDesc',
  width: 120
}];
var purchasePriceColumn = [{
  title: '商品编码',
  dataIndex: 'productId',
  key: 'productId',
  width: 140
}, {
  title: '商品条码',
  dataIndex: 'basicBarcode',
  key: 'basicBarcode',
  width: 140
}, {
  title: '商品名称',
  dataIndex: 'alias',
  key: 'alias',
  width: 140
}, {
  title: '商品类目',
  dataIndex: 'categoryName',
  key: 'categoryName',
  width: 140
}, {
  title: '品牌',
  dataIndex: 'brandName',
  key: 'brandName',
  width: 120
}, {
  title: '单位',
  dataIndex: 'unit',
  key: 'unit',
  width: 100
}, {
  title: '规格描述',
  dataIndex: 'specDesc',
  key: 'specDesc',
  width: 120
}];
// EXTERNAL MODULE: ./src/components/GoodsCategorySelect/index.tsx
var GoodsCategorySelect = __webpack_require__(51115);
// EXTERNAL MODULE: ./src/pages/GoodsManage/Price/Common/FormCommonTable/index.tsx + 1 modules
var FormCommonTable = __webpack_require__(7136);
// EXTERNAL MODULE: ./src/pages/GoodsManage/GoodStock/components/searchForm/searchSelect/index.ts + 9 modules
var searchSelect = __webpack_require__(16152);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/Price/Common/PriceGoodsModal/index.tsx







/**
 * 商品Modal
 */






var commonSize = 100; // 调价商品不分页，size写死

function PriceGoodsModal(props) {
  var merchantId = props.merchantId;
  var isSellPrice = window.location.href.includes('/SellPrice') ? true : false;

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      selectedRows = _useState2[0],
      setSelectedRows = _useState2[1];

  var _useState3 = (0,react.useState)(true),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      cancelRequest = _useState4[0],
      setcancelRequest = _useState4[1];

  var _useState5 = (0,react.useState)(props.searchParams || {
    size: commonSize,
    isDeduplication: 1,
    // 后端过滤约束，参数写死
    merchantId // switchMerchantItemFlag: isSellPrice ? undefined : 1

  }),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      searchParams = _useState6[0],
      setSearchParams = _useState6[1];

  var _useState7 = (0,react.useState)(),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      curSelectCategoryId = _useState8[0],
      setcurSelectCategoryId = _useState8[1];

  var _useState9 = (0,react.useState)(),
      _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
      curSelectBrandId = _useState10[0],
      setcurSelectBrandId = _useState10[1];

  var validateSearch = obj => {
    var arr = Object.values(obj);
    var isArrEffect = arr.some(e => e !== undefined && e !== null);
    return isArrEffect;
  };

  var handleData = res => {
    for (var k in res) {
      if (res[k] === null || res[k] === undefined) {
        delete res[k];
      }
    }

    res['size'] = commonSize;
    res['isDeduplication'] = 1;
    console.log('res', res);
    setSearchParams(v => (0,objectSpread2/* default */.Z)({
      merchantId
    }, res));
  };

  console.log(merchantId);
  /** 查询回调 */

  var searchHandler = (0,react.useCallback)((state, values) => {
    console.log('curSelectCategoryId', curSelectCategoryId);

    var res = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, values), {}, {
      backCategoryId: curSelectCategoryId,
      brandId: curSelectBrandId
    });

    console.log('res', res);

    if (!validateSearch(res)) {
      message.default.info('请至少选择一个查询条件进行查询');

      return false;
    }

    if (cancelRequest) {
      setcancelRequest(false);
      handleData(res);
    } else {
      handleData(res);
    }
  }, [curSelectCategoryId, curSelectBrandId]);
  /** 选择商品行 */

  var rowSelectCallback = (0,react.useCallback)((keys, rows) => {
    setSelectedRows(rows);
  }, []);
  /** 确认选择商品 */

  var handleOk = () => {
    if (selectedRows && selectedRows.length) {
      message.default.success("\u5DF2\u9009\u62E9".concat(selectedRows.length, "\u6761\u5546\u54C1"));

      props.saveModalCallback(selectedRows);
    } else {
      message.default.info('您未选择商品');

      props.closeModalCallback();
    }
  };

  (0,react.useEffect)(() => {
    console.log('curSelectCategoryId', curSelectCategoryId, curSelectBrandId);
  }, [curSelectCategoryId, curSelectBrandId]);
  /** 类目选择 */

  var onCategoryChange = val => {
    setcurSelectCategoryId(val);
  };

  var formFields = [{
    label: '商品查询',
    fieldOptions: {
      placeholder: '名称/编码/条码/PLU码'
    },
    name: 'queryCriteria',
    type: 'INPUT'
  }, {
    label: '品牌',
    name: 'brandId',
    // type: 'INPUT',
    widget: /*#__PURE__*/react.createElement(searchSelect/* BrandSearch */.hP, {
      placeholder: "\u8BF7\u8F93\u5165\u5546\u54C1\u54C1\u724C",
      onChange: e => onBrandChange(e)
    })
  }, {
    label: '供应商查询',
    name: 'supplierCriteria',
    fieldOptions: {
      placeholder: '供应商编码/名称'
    },
    type: 'INPUT'
  }, {
    label: '商品类目',
    name: 'backCategoryId',
    widget: /*#__PURE__*/react.createElement(GoodsCategorySelect/* default */.Z, {
      setCategoryId: onCategoryChange
    })
  }];

  var onBrandChange = data => {
    console.log('data', data);
    setcurSelectBrandId(data);
  };

  var _useState11 = (0,react.useState)([]),
      _useState12 = (0,slicedToArray/* default */.Z)(_useState11, 2),
      curDataSource = _useState12[0],
      setcurDataSource = _useState12[1];
  /** 重置 */


  var onResetFunc = () => {
    setcurSelectCategoryId(null);
    setcurSelectBrandId(null);
    setcurDataSource([]);
  };

  var priceGoodUrl = () => {
    var url = "";

    if (!isSellPrice) {
      url = "pms.sgMerchantItemManageService.querySgMerchantItemList"; // 进价类型查询商品
    } else {
      url = "pms.sgMerchantItemManageService.querySgMerchantItemSkuPluList"; // 售价类型查询商品
    }

    return url;
  };

  return /*#__PURE__*/react.createElement(modal/* default */.Z, {
    title: props.title || '新增商品',
    destroyOnClose: true,
    maskClosable: false,
    width: 1000,
    visible: true,
    onOk: handleOk,
    onCancel: props.closeModalCallback
  }, /*#__PURE__*/react.createElement(FormBuilder/* default */.Z, {
    onReset: onResetFunc,
    elements: props.GoodsModalFormElements || formFields,
    callbackHandler: searchHandler,
    defaultExpand: true,
    isHiddenSliderBtn: true
  }), /*#__PURE__*/react.createElement(FormCommonTable.default, {
    cancelRequest: cancelRequest,
    outControlSize: true,
    dataSource: curDataSource,
    columns: isSellPrice ? sellPriceColumn : purchasePriceColumn,
    searchParams: searchParams,
    showAlert: false // 进价 选择商品必须走 pms.sgMerchantItemManageService.querySgMerchantItemList 简单查询
    ,
    queryDataUrl: priceGoodUrl(),
    tableOptions: (0,objectSpread2/* default */.Z)({
      scroll: {
        x: 800,
        y: 300
      }
    }, props.tableOptions),
    hidePagination: true,
    rowSelectCallback: rowSelectCallback
  }));
}

/* harmony default export */ var Common_PriceGoodsModal = (PriceGoodsModal);

/***/ }),

/***/ 35712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "goodsLimitShowNum": function() { return /* binding */ goodsLimitShowNum; }
/* harmony export */ });
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(71577);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(31097);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(8870);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(84387);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(49101);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(90631);
/* harmony import */ var _Common_SimpleEditableTable_SimpleEditableTable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92581);
/* harmony import */ var _PriceGoodsModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25804);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24731);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _config_goodsEnums__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3602);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _components_OldUploader__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33773);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(20699);
/* harmony import */ var _components_UseRouter__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27088);
/* harmony import */ var _utils_math__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(58180);
/* harmony import */ var _hooks_usePriceLoopImport__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(41987);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(96534);











/* eslint-disable complexity */

/**
 * 简单商品列表 - 无分页
 */














var levelMapper = {
  1: '基础',
  2: '折扣',
  3: '精品'
};
/** 当前页商品显示数量限制 */

var goodsLimitShowNum = 2000;
var _API = {
  productApi: 'pms.sgPriceModifyManageService.queryProductIdByKey',
  // 编码查询接口
  barCodeApi: 'pms.sgPriceModifyManageService.queryBarcodeListByProductId',
  // 条码查询接口
  productCodeSearchApi: 'pms.sgPriceModifyManageService.querySgPriceModifyItemByProductIdAndBarcode',
  // 售价：根据编码+条码查询出调价单商品信息
  codeSearchApi: 'pms.sgPriceModifyManageService.querySgPriceModifyItemByProductIdList' // 进价：根据商品编码查询调价单商品信息

};

function PriceProductEditTable(props, ref) {
  var _props$addBtnText;

  var table = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState3, 2),
      goodsIdList = _useState4[0],
      setGoodsIdList = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState5, 2),
      goodsBarCodeList = _useState6[0],
      setGoodsBarCodeList = _useState6[1];

  var router = (0,_components_UseRouter__WEBPACK_IMPORTED_MODULE_11__/* .useRouter */ .t)();
  var isAddHandle = router.query.type === 'add' ? true : false;
  var isPursePrice = window.location.href.includes('/PurchasePrice') ? true : false;
  var priceName = isPursePrice ? '进价' : '售价';
  var id = router.query.id;
  var p = {
    page: 1,
    size: 20
  };

  var toggleGoodsModal = bool => {
    setVisible(bool);
  };

  var merchantIds = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    var _props$storeData;

    var list = (_props$storeData = props.storeData) === null || _props$storeData === void 0 ? void 0 : _props$storeData.map(v => (v === null || v === void 0 ? void 0 : v.merchantId) && +(v === null || v === void 0 ? void 0 : v.merchantId)).filter(Boolean);
    return list !== null && list !== void 0 && list.length ? [...new Set(list)] : [];
  }, [props.storeData]);

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState7, 2),
      tableDataSource = _useState8[0],
      settableDataSource = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState9, 2),
      curLoading = _useState10[0],
      setcurLoading = _useState10[1];
  /** modal保存回调 */


  var saveGoodModal = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee(rows) {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // props.saveGoodsModal(rows, 'product')
              console.log('rows', rows);
              handleDataFromModal(rows);
              closeModal();
              setcurLoading(true);
              setTimeout(() => {
                setcurLoading(false); // 默认超过6s 关闭loading
              }, 6000);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function saveGoodModal(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var closeModal = () => {
    setVisible(false);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useImperativeHandle)(ref, () => ({
    reflashTable: () => table.current.reflashTable()
  }));
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (tableDataSource && tableDataSource.length) {
      props.onTableChange && props.onTableChange(tableDataSource); // 回调数据到父组件
    }
  }, [tableDataSource]);
  /** 根据商品modal获取列表查新的商品列表  */

  var handleDataFromModal = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee2(rows) {
      var goodsId, params, barcodeAndProductIdDTO, apiUrl, res, list, _data, _productData, newArr;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              goodsId = [];
              rows.forEach(e => {
                // 查到商品，处理成list，发起真正商品处理接口后设置table
                goodsId.push(e['productId']);
              });

              if (isPursePrice) {
                params = {
                  goodsId,
                  merchantId: merchantIds,
                  type: _config_goodsEnums__WEBPACK_IMPORTED_MODULE_8__/* .changePriceType["进价"] */ .dU["进价"]
                };
              } else {
                barcodeAndProductIdDTO = [];
                rows.forEach(e => {
                  // 查到商品，处理成list，发起真正商品处理接口后设置table
                  barcodeAndProductIdDTO.push({
                    goodsId: e['goodsId'],
                    barcode: e['barcode'],
                    pluCode: e['pluCode']
                  });
                });
                params = {
                  barcodeAndProductIdDTO,
                  merchantId: merchantIds,
                  type: _config_goodsEnums__WEBPACK_IMPORTED_MODULE_8__/* .changePriceType["售价"] */ .dU["售价"]
                };
              }

              apiUrl = isPursePrice ? _API.codeSearchApi : _API.productCodeSearchApi; // 获取商品数据

              _context2.next = 7;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(apiUrl, params);

            case 7:
              res = _context2.sent;
              setcurLoading(false);

              if (!res.success) {
                _context2.next = 21;
                break;
              }

              list = res.result.list;

              if (!(list && !list.length)) {
                _context2.next = 14;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_17__.default.info('未查到商品');

              return _context2.abrupt("return");

            case 14:
              _data = tableDataSource;

              if (isPursePrice) {
                list.map(e => {
                  e['referencePurchasePrice'] = (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(+e['oldReferencePurchasePrice'], 1000);
                });
              } else {
                list.map(e => {
                  e['referenceSalePrice'] = (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(+e['oldReferenceSalePrice'], 100);
                });
              }

              _productData = _data.concat(list);
              newArr = (0,_utils_common__WEBPACK_IMPORTED_MODULE_13__/* .filterTwoProperty */ .TW)(_productData, 'barcode', 'goodsId', 'pluCode'); // 去重
              // 初始化时新价格=旧价格

              settableDataSource(newArr);
              _context2.next = 22;
              break;

            case 21:
              console.error(res);

            case 22:
              _context2.next = 27;
              break;

            case 24:
              _context2.prev = 24;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0); // message.error(error)

            case 27:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 24]]);
    }));

    return function handleDataFromModal(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  /** 模糊搜索 商品编码和条码的下拉数据 */


  var handleGoodSearchList = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee3(val) {
      var res, list, uniqArr, data;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              console.log('search handleGoodSearchList');
              _context3.prev = 1;

              if (val) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return");

            case 4:
              _context3.next = 6;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_API.productApi, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)({
                key: val
              }, p));

            case 6:
              res = _context3.sent;
              console.log('res', res);

              if (res.success) {
                _context3.next = 10;
                break;
              }

              throw '请求失败';

            case 10:
              list = res.result.list;

              if (list && !list.length) {
                setTimeout(() => {
                  antd_es_message__WEBPACK_IMPORTED_MODULE_17__.default.info('未查到相关信息');
                }, 500);
              }

              uniqArr = Array.from(new Set(list));
              data = uniqArr.map(v => ({
                value: v,
                label: v
              }));
              setGoodsIdList(data);
              _context3.next = 20;
              break;

            case 17:
              _context3.prev = 17;
              _context3.t0 = _context3["catch"](1);

              antd_es_message__WEBPACK_IMPORTED_MODULE_17__.default.error(_context3.t0);

            case 20:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 17]]);
    }));

    return function handleGoodSearchList(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  /** 模糊搜索 商品编码和条码的下拉数据 */


  var handleGoodCodebarSearchList = /*#__PURE__*/function () {
    var _ref4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee4(val) {
      var res, list, uniqArr, barcodeData, goodIdData;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              console.log('search handleGoodSearchList');
              _context4.prev = 1;

              if (val) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt("return");

            case 4:
              _context4.next = 6;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)("pms.sgMerchantItemManageService.querySgMerchantItemSkuList", (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)({
                barCodeWildcard: val
              }, p));

            case 6:
              res = _context4.sent;
              console.log('res', res);

              if (res.success) {
                _context4.next = 10;
                break;
              }

              throw '请求失败';

            case 10:
              list = res.result.list;

              if (!(list && !list.length)) {
                _context4.next = 14;
                break;
              }

              setTimeout(() => {
                antd_es_message__WEBPACK_IMPORTED_MODULE_17__.default.info('未查到相关信息');
              }, 500);
              return _context4.abrupt("return");

            case 14:
              uniqArr = Array.from(new Set(list));
              barcodeData = uniqArr.map(v => ({
                value: v['barcode'],
                label: v['barcode']
              }));
              goodIdData = uniqArr.map(v => ({
                value: v['goodsId'],
                label: v['goodsId']
              }));
              barcodeData = lodash__WEBPACK_IMPORTED_MODULE_9___default().uniqBy(barcodeData, 'barcode');
              goodIdData = lodash__WEBPACK_IMPORTED_MODULE_9___default().uniqBy(goodIdData, 'goodsId');
              setGoodsBarCodeList(barcodeData);
              setGoodsIdList(goodIdData);
              _context4.next = 26;
              break;

            case 23:
              _context4.prev = 23;
              _context4.t0 = _context4["catch"](1);

              antd_es_message__WEBPACK_IMPORTED_MODULE_17__.default.error(_context4.t0);

            case 26:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 23]]);
    }));

    return function handleGoodCodebarSearchList(_x4) {
      return _ref4.apply(this, arguments);
    };
  }();

  var onDebounceGoodSearch = lodash_debounce__WEBPACK_IMPORTED_MODULE_7___default()(handleGoodSearchList, 800);
  var onDebounceGoodCodebarSearch = lodash_debounce__WEBPACK_IMPORTED_MODULE_7___default()(handleGoodCodebarSearchList, 800);

  var calculatedGross = value => {
    var p = +value['referenceSalePrice'] - (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(value['oldReferencePurchasePrice'], 1000) * Number(value['conversionRatio']); // 统一换算成元

    var res = (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(p, (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(+value['referenceSalePrice'], 100)).toFixed(2);
    return res;
  };

  var priceColumn = [{
    title: '序号',
    dataIndex: 'id',
    key: 'id',
    width: 60,
    render: (t, r, i, fn) => {
      return i + 1;
    }
  }, // {
  //   title: '商品编码',
  //   dataIndex: 'goodsId',
  //   key: 'goodsId',
  //   width: 140,
  //   type: 'SELECT',
  //   dataList: goodsIdList,
  //   fieldOptions: {
  //     onSearch: onDebounceGoodSearch
  //   }
  // },
  // {
  //   title: '商品条码',
  //   dataIndex: 'barcode',
  //   key: 'barcode',
  //   width: 160,
  //   type: 'SELECT',
  //   dataList: goodsBarCodeList,
  //   fieldOptions: {
  //     onSearch: onDebounceGoodCodebarSearch
  //   }
  // },
  {
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 140
  }, {
    title: '商品条码',
    dataIndex: 'barcode',
    key: 'barcode',
    width: 140
  }, {
    title: '商品名称',
    dataIndex: 'productName',
    key: 'productName',
    width: 140
  }, {
    title: 'PLU码',
    dataIndex: 'pluCode',
    key: 'pluCode',
    width: 140,
    hide: isPursePrice
  }, {
    title: 'PLU码级别',
    dataIndex: 'pluLevel',
    key: 'pluLevel',
    width: 140,
    hide: isPursePrice,
    render: (t, r, i, fn) => {
      return t ? levelMapper[t] : '';
    }
  }, {
    title: () => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", null, "\u79FB\u52A8\u5E73\u5747\u4EF7"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
        placement: "top",
        title: "\u7EC4\u7EC7\u5185\u4EFB\u4E00\u6709\u6548\u95E8\u5E97\u79FB\u52A8\u5E73\u5747\u4EF7"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_21__/* .default */ .Z, null)));
    },
    hide: isPursePrice,
    dataIndex: 'movingAveragePrice',
    key: 'movingAveragePrice',
    width: 110
  }, {
    title: () => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", null, "\u672B\u6B21\u5165\u5E93\u4EF7"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
        placement: "top",
        title: "\u4F18\u5148\u53D6\u7EC4\u7EC7\u91CC\u7684\u95E8\u5E97\u5BF9\u5E94\u4ED3\u7684\u672B\u6B21\u5165\u5E93\u8FDB\u4EF7+\u914D\u9001\u8D39\uFF0C\u53D6\u4E0D\u5230\u53D6\u4EFB\u4E00\u95E8\u5E97\u672B\u6B21\u5165\u5E93"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_21__/* .default */ .Z, null)));
    },
    hide: isPursePrice,
    dataIndex: 'lastPurchasePrice',
    key: 'lastPurchasePrice',
    width: 110
  }, {
    title: () => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", null, "\u53C2\u8003\u8FDB\u4EF7"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
        placement: "top",
        title: "\u7EC4\u7EC7\u5185\u4EFB\u4E00\u6709\u6548\u95E8\u5E97\u6700\u4F4E\u8FDB\u4EF7"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_21__/* .default */ .Z, null)));
    },
    hide: !isPursePrice,
    dataIndex: 'oldReferencePurchasePrice',
    key: 'oldReferencePurchasePrice',
    width: 110,
    render: (t, r, i, fn) => {
      return t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(t, 1000) : '';
    }
  }, // {
  //   title: '参考进价',
  //   dataIndex: 'purchasePrice',
  //   key: 'purchasePrice',
  //   width: 80,
  //   hide: !isPursePrice,
  //   render: (t: any, r: any, i: number, fn: any) => {
  //     return t ? Divide(t, 100) : ''
  //   }
  // },
  {
    title: '新进价',
    hide: !isPursePrice,
    dataIndex: 'referencePurchasePrice',
    key: 'referencePurchasePrice',
    width: 80,
    editable: true,
    render: (t, r, i, fn) => {
      if (fn) {
        var params = {
          fieldType: 'INPUT_NUMBER',
          fieldOptions: {
            formatter: _utils_math__WEBPACK_IMPORTED_MODULE_18__/* .limitDecimalsThree */ .ed,
            // formatter: limitDecimalsNum,
            max: 999999.99,
            value: t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)((0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Multiply */ .wY)(t, 1000), 1000) : (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(r['oldReferencePurchasePrice'], 1000)
          }
        };
        return fn(params);
      }

      if (isNaN(+t)) {
        return undefined;
      }

      return t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)((0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Multiply */ .wY)(t, 1000), 1000) : (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(r['oldReferencePurchasePrice'], 1000);
    }
  }, {
    // 规格：值不取规格描述，取换算比例。例如：24（瓶）
    title: '进价',
    hide: isPursePrice,
    dataIndex: 'oldReferencePurchasePrice',
    key: 'oldReferencePurchasePrice',
    width: 80,
    render: (t, r, i, fn) => {
      if (t && r !== null && r !== void 0 && r.conversionRatio) {
        return t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(t * +(r === null || r === void 0 ? void 0 : r.conversionRatio), 1000) : '';
      }

      if (t && !(r !== null && r !== void 0 && r.conversionRatio)) {
        return t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(t, 1000) : '';
      }

      return t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(t, 1000) : '';
    }
  }, {
    title: '参考售价',
    hide: isPursePrice,
    dataIndex: 'oldReferenceSalePrice',
    key: 'oldReferenceSalePrice',
    width: 80,
    render: (t, r, i, fn) => {
      return t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(t, 100) : '';
    }
  }, // {
  //   title: '参考售价',
  //   dataIndex: 'referencePrice',
  //   key: 'referencePrice',
  //   width: 80,
  //   hide: isPursePrice,
  //   render: (t: any, r: any, i: number, fn: any) => {
  //     return t ? Divide(t, 100) : ''
  //   }
  // },
  {
    title: '新售价',
    hide: isPursePrice,
    dataIndex: 'referenceSalePrice',
    key: 'referenceSalePrice',
    width: 80,
    editable: true,
    render: (t, r, i, fn) => {
      if (fn) {
        var params = {
          fieldType: 'INPUT_NUMBER',
          fieldOptions: {
            formatter: _utils_math__WEBPACK_IMPORTED_MODULE_18__/* .limitDecimals */ .Cu,
            max: 99999.99,
            value: t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)((0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Multiply */ .wY)(t, 100), 100) : (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(r['oldReferenceSalePrice'], 100)
          }
        };
        return fn(params);
      }

      if (isNaN(+t)) {
        return undefined;
      }

      return t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)((0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Multiply */ .wY)(t, 100), 100) : (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(r['oldReferenceSalePrice'], 100);
    }
  }, {
    title: '规格',
    dataIndex: 'specification',
    key: 'specification',
    width: 90
  }, {
    title: '毛利率(%)',
    hide: isPursePrice,
    dataIndex: 'mRate',
    key: 'mRate',
    width: 130,
    sorter: (a, b) => {
      var ag = calculatedGross(a);
      var bg = calculatedGross(b);
      return Number(ag) - Number(bg);
    },
    render: (t, r, i, fn) => {
      if (r['referenceSalePrice'] != 0) {
        if (!isNaN(r['referenceSalePrice']) && !isNaN(r['oldReferencePurchasePrice'])) {
          var _p = +r['referenceSalePrice'] - (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(r['oldReferencePurchasePrice'], 1000) * Number(r['conversionRatio']); // 统一换算成元


          var res = (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(_p, (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(+r['referenceSalePrice'], 100)).toFixed(2);

          if (+res < 0) {
            return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
              style: {
                color: 'red'
              }
            }, res);
          }

          return res;
        } else {
          return '';
        }
      } else {
        return '';
      }
    }
  }, {
    title: '毛利额',
    hide: isPursePrice,
    dataIndex: 'mRate',
    key: 'mRate',
    width: 100,
    render: (t, r, i, fn) => {
      if (r['referenceSalePrice'] != 0) {
        // if (!isNaN(r['referenceSalePrice']) && !isNaN(r['oldReferencePurchasePrice'])) {
        //   return (+r['referenceSalePrice'] - (Math.floor(+r['oldReferencePurchasePrice'] * 100) / 10000)).toFixed(2)
        // }
        if (!isNaN(r['referenceSalePrice']) && !isNaN(r['oldReferencePurchasePrice'])) {
          // 与编辑页不同
          var _p2 = +r['referenceSalePrice'] - (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(r['oldReferencePurchasePrice'], 1000) * Number(r['conversionRatio']); // 统一换算成元


          return _p2.toFixed(3);
        }
      } else {
        return '';
      }
    }
  }, {
    title: '商品类目',
    dataIndex: 'backCategoryName',
    key: 'backCategoryName',
    width: 140
  }, {
    title: '单位',
    dataIndex: 'saleUnit',
    key: 'saleUnit',
    width: 140
  }, {
    title: '供应商编码',
    dataIndex: 'supplierCode',
    key: 'supplierCode',
    width: 140
  }, {
    title: '供应商名称',
    dataIndex: 'supplierName',
    key: 'supplierName',
    width: 140
  }];
  /** 选中条码后，处理商品条码的事件,需要把条码对应的编码回填到编码框或者刷新该条数据 */

  var handleGoodBarCode = /*#__PURE__*/function () {
    var _ref5 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee5(code, currentRow) {
      var res, success, list;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)("pms.sgMerchantItemManageService.querySgMerchantItemSkuList", (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)({
                barCodeWildcard: code
              }, p));

            case 3:
              res = _context5.sent;
              console.log('res', res);
              success = res.success;

              if (success) {
                list = res.result.list;
                currentRow['goodsId'] = list[0]['goodsId'];
                currentRow['barcode'] = code;
                handleQueryGoodsForId(currentRow);
              }

              _context5.next = 12;
              break;

            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_17__.default.error(_context5.t0);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 9]]);
    }));

    return function handleGoodBarCode(_x5, _x6) {
      return _ref5.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (props.dataSource && props.dataSource.length) {
      var _props$dataSource;

      settableDataSource(props.dataSource);

      if ((props === null || props === void 0 ? void 0 : (_props$dataSource = props.dataSource) === null || _props$dataSource === void 0 ? void 0 : _props$dataSource.length) > goodsLimitShowNum) {
        setshowLimitGoodsTips(true);
        setdisableAddBtnText(true);
        setdisableUpload(true);

        if (id) {
          setshowTipObj({
            successCount: props.dataSource.length,
            detailUrl: "/GoodsManage/Price/SellPrice/Detail/".concat(id)
          });
        } else {
          setshowTipObj({
            successCount: props.dataSource.length
          });
        }
      }
    }
  }, [props.dataSource]);
  /** 可编辑表格数据变化 */

  var tableChange = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((data, allData) => {
    // const changeGoodsData = async (data: any, selected: any[]) => {
    var currentCell = data.currentCell,
        currentRow = data.currentRow,
        dataSource = data.dataSource,
        type = data.type;
    console.log('allData', allData);
    console.log('currentRow', currentRow);

    if (lodash__WEBPACK_IMPORTED_MODULE_9___default().isEmpty(currentCell) && type !== 'DELETE') {
      console.error('break');
      return;
    }

    var goodsId = currentCell['goodsId'];
    var barCode = currentCell['barcode'];
    console.log('goodsId', goodsId); // 单元格是商品编码

    if (goodsId) {
      handleGoodId(goodsId, currentRow);
    } // 当前修改的单元格是商品条码时


    if (barCode) {
      handleGoodBarCode(barCode, currentRow);
    }

    if (type === 'DELETE') {
      if (dataSource && !dataSource.length) {
        settableDataSource([]);
      }

      if (Object.keys(currentRow).length) {
        // 如果当前行有数据，保证导入后数据一致
        var _data = tableDataSource;

        var _arr = _data.filter(res => dataSource.length && res['barcode'] !== dataSource[0]['barcode']);

        settableDataSource(_arr);
      }
    }

    if (allData && allData.length) {
      props.onTableChange && props.onTableChange(allData);
    }

    if (allData && !allData.length) {
      // 不可提交
      props.handleCanEdit && props.handleCanEdit(true);
    }
  }, [tableDataSource]);
  /** 售价: 根据编码获取商品 进价：根据编码+条码获取商品 */

  var handleQueryGoodsForId = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/function () {
    var _ref6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee6(currentRow) {
      var goodsId, barcodeAndProductIdDTO, params, apiUrl, res, list, data, index, rowData, tableData, isRowIndex, arr, _index;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              goodsId = [currentRow['goodsId']];
              barcodeAndProductIdDTO = [{
                barcode: currentRow['barcode'],
                goodsId: currentRow['goodsId'],
                pluCode: currentRow['pluCode']
              }];

              if (isPursePrice) {
                params = {
                  goodsId,
                  merchantId: merchantIds,
                  type: _config_goodsEnums__WEBPACK_IMPORTED_MODULE_8__/* .changePriceType */ .dU[priceName]
                };
              } else {
                params = {
                  barcodeAndProductIdDTO,
                  type: _config_goodsEnums__WEBPACK_IMPORTED_MODULE_8__/* .changePriceType */ .dU[priceName]
                };
              }

              _context6.prev = 3;
              apiUrl = isPursePrice ? _API.codeSearchApi : _API.productCodeSearchApi;
              _context6.next = 7;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(apiUrl, params);

            case 7:
              res = _context6.sent;
              console.log('res', res);

              if (!res.success) {
                _context6.next = 23;
                break;
              }

              list = res.result.list;

              if (!(list && !list.length)) {
                _context6.next = 17;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_17__.default.info("\u672A\u627E\u5230\u7F16\u7801".concat(currentRow['goodsId'], "\u6761\u7801").concat(currentRow['barcode'], "\u7684\u5546\u54C1\u4FE1\u606F"));

              data = tableDataSource;
              index = tableDataSource.findIndex(e => e['editableTableKey'] === currentRow['editableTableKey']);

              if (index !== -1) {
                // 如果当前datasource不存在该条数据，则默认头部添加
                data[index] = {
                  goodsId,
                  editableTableKey: currentRow['editableTableKey']
                };
                settableDataSource(data);
              }

              return _context6.abrupt("return");

            case 17:
              rowData = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)({}, currentRow), list[0]);

              if (isPursePrice) {
                rowData['referencePurchasePrice'] = (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(+rowData['oldReferencePurchasePrice'], 100);
              } else {
                rowData['referenceSalePrice'] = (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(+rowData['oldReferenceSalePrice'], 100);
              }

              tableData = tableDataSource;
              /** 列表里是否有了该数据 */

              isRowIndex = tableData.findIndex(e => e['goodsId'] === currentRow['goodsId'] && e['barcode'] === currentRow['barcode']);
              console.log('isRowIndex', isRowIndex);

              if (isRowIndex !== -1) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_17__.default.info('该编码和条码已存在，请重试...');

                arr = tableData.filter(e => e['editableTableKey'] !== rowData['editableTableKey']);
                setTimeout(() => {
                  settableDataSource(arr);
                }, 400);
              } else {
                _index = tableData.findIndex(e => e['editableTableKey'] === rowData['editableTableKey']);

                if (_index === -1) {
                  // 如果当前datasource不存在该条数据，则默认头部添加
                  tableData.unshift(rowData);

                  if (Array.isArray(tableData)) {
                    settableDataSource(tableData);
                  }
                } else {
                  tableData[_index] = rowData;
                  settableDataSource(tableData);
                }
              }

            case 23:
              _context6.next = 28;
              break;

            case 25:
              _context6.prev = 25;
              _context6.t0 = _context6["catch"](3);
              console.error(_context6.t0);

            case 28:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[3, 25]]);
    }));

    return function (_x7) {
      return _ref6.apply(this, arguments);
    };
  }(), [tableDataSource]);
  /** 选中商品编码后 触发的事件 */

  var handleGoodId = /*#__PURE__*/function () {
    var _ref7 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee7(goodsId, currentRow) {
      var params, res, success, result, _data2, index, _data, data;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              params = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)({
                goodsId
              }, p);
              _context7.next = 4;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_API.barCodeApi, params);

            case 4:
              res = _context7.sent;
              success = res.success, result = res.result;

              if (!success) {
                _context7.next = 19;
                break;
              }

              if (!(result['list'] && !result['list'].length)) {
                _context7.next = 13;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_17__.default.info("\u672A\u627E\u5230\u7F16\u7801".concat(goodsId, "\u5BF9\u5E94\u7684\u6761\u7801\u4FE1\u606F,\u8BF7\u91CD\u65B0\u9009\u62E9"));

              _data2 = tableDataSource;
              index = tableDataSource.findIndex(e => e['editableTableKey'] === currentRow['editableTableKey']);

              if (index !== -1) {
                // 如果当前datasource不存在该条数据，则默认头部添加
                _data2[index] = {
                  goodsId,
                  editableTableKey: currentRow['editableTableKey']
                };
                settableDataSource(_data2);
              }

              return _context7.abrupt("return");

            case 13:
              // if (isPursePrice) {
              // } else {
              // }
              _data = result.list.filter(e => e['isBasic'] === 1);

              if (_data.length) {
                _data = lodash__WEBPACK_IMPORTED_MODULE_9___default().uniqBy(_data, 'barcode');
              }

              data = _data.map(v => ({
                value: v['barcode'],
                label: v['barcode']
              }));

              if (!goodsBarCodeList.length || data.length) {
                setGoodsBarCodeList(data);
                currentRow['barcode'] = data[0]['value'];
                handleQueryGoodsForId(currentRow);
              }

              _context7.next = 20;
              break;

            case 19:
              console.error(res);

            case 20:
              _context7.next = 25;
              break;

            case 22:
              _context7.prev = 22;
              _context7.t0 = _context7["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_17__.default.error(_context7.t0);

            case 25:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[0, 22]]);
    }));

    return function handleGoodId(_x8, _x9) {
      return _ref7.apply(this, arguments);
    };
  }();

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''),
      _useState12 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState11, 2),
      curImportTaskId = _useState12[0],
      setcurImportTaskId = _useState12[1];

  var _useState13 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState14 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState13, 2),
      loopResult = _useState14[0],
      setLoopResult = _useState14[1];

  var _useState15 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState16 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState15, 2),
      showLimitGoodsTips = _useState16[0],
      setshowLimitGoodsTips = _useState16[1]; // 大数据导入后，回填数量，根据数量个数，展示是否有去下载提示


  var _useState17 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(),
      _useState18 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState17, 2),
      showTipObj = _useState18[0],
      setshowTipObj = _useState18[1];

  var _useState19 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''),
      _useState20 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState19, 2),
      curGoodsNum = _useState20[0],
      setcurGoodsNum = _useState20[1];

  var _useState21 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState22 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState21, 2),
      disableAddBtnText = _useState22[0],
      setdisableAddBtnText = _useState22[1];

  var _useState23 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState24 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState23, 2),
      disableUpload = _useState24[0],
      setdisableUpload = _useState24[1];

  var _usePriceLoopImport = (0,_hooks_usePriceLoopImport__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)({
    taskId: curImportTaskId,
    type: isPursePrice ? 1 : 2,
    // 2 售价
    refreshCallback: (successed, result, obj) => {
      if (successed && result !== null && result !== void 0 && result.length) {
        var _arr2;

        if (result.length > goodsLimitShowNum) {
          // 超过页面限制条数 则不显示，
          setdisableAddBtnText(true);
          setshowLimitGoodsTips(true);
          setshowTipObj({
            successCount: obj === null || obj === void 0 ? void 0 : obj.successCount,
            errorCount: obj === null || obj === void 0 ? void 0 : obj.errorCount,
            successUrl: obj === null || obj === void 0 ? void 0 : obj.successUrl
          });
        }

        if (isPursePrice) {
          (result === null || result === void 0 ? void 0 : result.length) && result.map(e => {
            e['referencePurchasePrice'] = (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(+e['referencePurchasePrice'], 1000);
          });
        } else {
          (result === null || result === void 0 ? void 0 : result.length) && result.map(e => {
            e['referenceSalePrice'] = (0,_utils_math__WEBPACK_IMPORTED_MODULE_18__/* .Divide */ .p3)(+e['referenceSalePrice'], 100);
          });
        } // 但是数据保存在内存中


        var arr = tableDataSource.concat(result);
        arr = (0,_utils_common__WEBPACK_IMPORTED_MODULE_13__/* .filterTwoProperty */ .TW)(arr, 'barcode', 'goodsId', 'pluCode');
        settableDataSource(arr);
        setcurGoodsNum(((_arr2 = arr) === null || _arr2 === void 0 ? void 0 : _arr2.length) || '');
      }

      setLoopResult(false); // 重置状态
    }
  }, [loopResult]),
      _usePriceLoopImport2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_usePriceLoopImport, 1),
      btnLoading = _usePriceLoopImport2[0];
  /** 上传文件 */


  var changeUpload = /*#__PURE__*/function () {
    var _ref8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee8(val) {
      var resId, res, _res$result, taskId, success;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              resId = val[0].resId;
              _context8.prev = 1;
              _context8.next = 4;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_22__/* .IMPORT_ORDER_EXCEL */ .Eb, {
                // "resourceAddr": val[val.length - 1]['files'],
                resourceAddr: resId,
                merchantId: merchantIds,
                type: _config_goodsEnums__WEBPACK_IMPORTED_MODULE_8__/* .changePriceType */ .dU[priceName]
              });

            case 4:
              res = _context8.sent;

              if (!(res && res.success)) {
                _context8.next = 12;
                break;
              }

              console.log('res', res); // message.success('导入excel成功')
              // 全部成功

              _res$result = res.result, taskId = _res$result.taskId, success = _res$result.success;

              if (success) {
                setcurImportTaskId(taskId);
                setLoopResult(true);
              } else {
                antd_es_message__WEBPACK_IMPORTED_MODULE_17__.default.warn('上传excel失败');
              }

              return _context8.abrupt("return", false);

            case 12:
              antd_es_message__WEBPACK_IMPORTED_MODULE_17__.default.warn('导入失败');

            case 13:
              _context8.next = 18;
              break;

            case 15:
              _context8.prev = 15;
              _context8.t0 = _context8["catch"](1);

              antd_es_message__WEBPACK_IMPORTED_MODULE_17__.default.error(_context8.t0);

            case 18:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[1, 15]]);
    }));

    return function changeUpload(_x10) {
      return _ref8.apply(this, arguments);
    };
  }();
  /** 下载模板 */


  var downloadTemplate = /*#__PURE__*/function () {
    var _ref9 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee9() {
      var SELL_DOWNLOAD_URL;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              SELL_DOWNLOAD_URL = '';

              if (priceName.includes('售')) {
                // SELL_DOWNLOAD_URL = 'https://d0.ypshengxian.com/y4zsoacqctrze1ypecuvbab6ec9v0ipv.xlsx'
                SELL_DOWNLOAD_URL = 'https://d0.ypshengxian.com/udvy6fqg9npd954mi7qgllwpa8eiwr8m.xlsx';
              } else {
                SELL_DOWNLOAD_URL = 'https://d0.ypshengxian.com/un5ielrofiymjbqjfe4ixlotcjj5bs9q.xlsx';
              }

              window.location.href = SELL_DOWNLOAD_URL;

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function downloadTemplate() {
      return _ref9.apply(this, arguments);
    };
  }();

  var handleAddGoods = /*#__PURE__*/function () {
    var _ref10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee10() {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return props.validateFormCallback();

            case 2:
              toggleGoodsModal(true);

            case 3:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function handleAddGoods() {
      return _ref10.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
    className: "mTop16 mBottom16"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z, {
    type: "primary",
    disabled: !props.canHandleModal || disableAddBtnText,
    className: "mRight16",
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_24__/* .default */ .Z, null) // onClick={() => toggleGoodsModal(true)}
    ,
    onClick: handleAddGoods
  }, (_props$addBtnText = props.addBtnText) !== null && _props$addBtnText !== void 0 ? _props$addBtnText : '添加商品'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
    style: {
      marginRight: '16px'
    },
    key: "upload"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_OldUploader__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z, {
    tokenParams: {},
    accept: "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    onChange: changeUpload,
    loading: btnLoading,
    btnText: "\u5BFC\u5165excel\u5546\u54C1",
    uploadOptions: {
      showUploadList: false,
      disabled: disableUpload
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z, {
    className: "mRight16" // disabled={!canHandle}
    ,
    onClick: downloadTemplate,
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_25__/* .default */ .Z, null),
    key: "download"
  }, "\u4E0B\u8F7Dexcel\u6A21\u677F"), props.btnElement), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_Common_SimpleEditableTable_SimpleEditableTable__WEBPACK_IMPORTED_MODULE_4__.default, {
    outLoading: curLoading || props.outLoading,
    showLimitGoodsTips: props !== null && props !== void 0 && props.showLimitGoodsTips ? true : showLimitGoodsTips,
    showTipObj: props !== null && props !== void 0 && props.outShowTipObj && Object.entries(props === null || props === void 0 ? void 0 : props.outShowTipObj).length ? props === null || props === void 0 ? void 0 : props.outShowTipObj : showTipObj,
    curGoodsNum: curGoodsNum,
    hideBtn: true,
    dataSource: (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => tableDataSource, [tableDataSource]),
    hideDeleteBtn: props.hideDeleteBtn,
    columns: priceColumn.filter(item => !item.hide),
    buttonTitle: "\u6DFB\u52A0\u5546\u54C1\u884C",
    tableOptions: {
      scroll: {
        x: 800,
        y: 400
      }
    },
    onChange: tableChange
  }), visible && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_PriceGoodsModal__WEBPACK_IMPORTED_MODULE_5__.default, {
    searchParams: props.searchParams,
    closeModalCallback: closeModal,
    saveModalCallback: saveGoodModal,
    merchantId: merchantIds
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_3__.memo)( /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(PriceProductEditTable)));

/***/ }),

/***/ 1804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2824);
/* harmony import */ var antd_es_date_picker_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14965);
/* harmony import */ var antd_es_date_picker__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11448);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);






/**
 * 调价专用range picker
 * 从开始日期起，查询最多3个月的记录
 */


var RangePicker = antd_es_date_picker__WEBPACK_IMPORTED_MODULE_4__/* .default.RangePicker */ .Z.RangePicker;

var PriceRangePicker = props => {
  var _onChange = e => {
    console.log(e); // if (moment(e[1]) > moment(e[0]).add('days', 90)) {
    //   setdateValue([e[0], moment(e[0]).add('days', 90)])
    //   props.rangeOnChange([e[0], moment(e[0]).add('days', 90)])
    // } else {

    setdateValue(e);
    props.rangeOnChange(e); // }
  };

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState, 2),
      defaultValue = _useState2[0],
      setdefaultValue = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState3, 2),
      dateValue = _useState4[0],
      setdateValue = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    console.log('props?.isLimitMonth', props === null || props === void 0 ? void 0 : props.isLimitMonth);

    if (!(props !== null && props !== void 0 && props.isLimitMonth)) {
      setdefaultValue([]);
      setdateValue([]);
    } else {
      setdefaultValue([moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'months'), moment__WEBPACK_IMPORTED_MODULE_3___default()()]);
      setdateValue([moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'months'), moment__WEBPACK_IMPORTED_MODULE_3___default()()]);
    }
  }, [props === null || props === void 0 ? void 0 : props.isLimitMonth]); // function disabledDate(current: any) {
  //   // Can not select days before today and today
  //   return current && current < moment().subtract('days', 90);
  // }

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState5, 2),
      dates = _useState6[0],
      setDates = _useState6[1];

  var disabledDate = current => {
    if (!dates || dates.length === 0) {
      return false;
    }

    var tooLate = dates[0] && current.diff(dates[0], 'days') > 90;
    var tooEarly = dates[1] && dates[1].diff(current, 'days') > 90;
    return tooEarly || tooLate;
  };

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)('最近一月'),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState7, 2),
      curDateSelect = _useState8[0],
      setcurDateSelect = _useState8[1];
  /**
   * 日期选择
   * @param type 类型
   */


  var dateSelectCb = type => {
    switch (type) {
      case '今天':
        setdateValue([moment__WEBPACK_IMPORTED_MODULE_3___default()(), moment__WEBPACK_IMPORTED_MODULE_3___default()()]);
        props.rangeOnChange([moment__WEBPACK_IMPORTED_MODULE_3___default()(), moment__WEBPACK_IMPORTED_MODULE_3___default()()]);
        setcurDateSelect('今天');
        break;

      case '最近一周':
        setdateValue([moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'weeks'), moment__WEBPACK_IMPORTED_MODULE_3___default()()]);
        props.rangeOnChange([moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'weeks'), moment__WEBPACK_IMPORTED_MODULE_3___default()()]);
        setcurDateSelect('最近一周');
        break;

      case '昨天':
        setdateValue([moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'days'), moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'days')]);
        props.rangeOnChange([moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'days'), moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'days')]);
        setcurDateSelect('昨天');
        break;

      default:
        break;
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'end'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(RangePicker, {
    onChange: _onChange,
    ranges: {
      '今天': [moment__WEBPACK_IMPORTED_MODULE_3___default()(), moment__WEBPACK_IMPORTED_MODULE_3___default()()],
      '昨天': [moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'days'), moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'days')],
      '最近一周': [moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'weeks'), moment__WEBPACK_IMPORTED_MODULE_3___default()()],
      '最近一月': [moment__WEBPACK_IMPORTED_MODULE_3___default()(new Date()).subtract(1, 'months'), moment__WEBPACK_IMPORTED_MODULE_3___default()()],
      '重置': [moment__WEBPACK_IMPORTED_MODULE_3___default()(), moment__WEBPACK_IMPORTED_MODULE_3___default()()]
    },
    defaultValue: defaultValue,
    value: dateValue // disabledDate={disabledDate}
    ,
    disabledDate: disabledDate,
    onCalendarChange: value => {
      setDates(value);
    },
    style: {
      width: 260
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    style: {
      marginLeft: 10,
      marginRight: 10
    },
    onClick: () => dateSelectCb('今天'),
    type: curDateSelect === '今天' ? 'primary' : 'default'
  }, "\u4ECA\u5929"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    style: {
      marginRight: 10
    },
    onClick: () => dateSelectCb('昨天'),
    type: curDateSelect === '昨天' ? 'primary' : 'default'
  }, "\u6628\u5929"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    style: {
      marginRight: 10
    },
    onClick: () => dateSelectCb('最近一周'),
    type: curDateSelect === '最近一周' ? 'primary' : 'default'
  }, "\u6700\u8FD1\u4E00\u5468"));
};

/* harmony default export */ __webpack_exports__["default"] = (PriceRangePicker);

/***/ }),

/***/ 92581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SimpleEditableTable; }
});

// NAMESPACE OBJECT: ./src/pages/GoodsManage/Price/Common/SimpleEditableTable/components/Field.tsx
var Field_namespaceObject = {};
__webpack_require__.r(Field_namespaceObject);
__webpack_require__.d(Field_namespaceObject, {
  "DATE_PICKER": function() { return DATE_PICKER; },
  "INPUT": function() { return INPUT; },
  "INPUT_NUMBER": function() { return INPUT_NUMBER; },
  "RANGE_PICKER": function() { return RANGE_PICKER; },
  "SELECT": function() { return SELECT; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/table/style/index.js
var table_style = __webpack_require__(66456);
// EXTERNAL MODULE: ./node_modules/antd/es/table/index.js + 45 modules
var table = __webpack_require__(97423);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlusOutlined.js + 1 modules
var PlusOutlined = __webpack_require__(49101);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/antd/es/form/style/index.js
var form_style = __webpack_require__(9715);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 12 modules
var es_form = __webpack_require__(35845);
// EXTERNAL MODULE: ./node_modules/antd/es/popconfirm/style/index.js
var popconfirm_style = __webpack_require__(62350);
// EXTERNAL MODULE: ./node_modules/antd/es/popconfirm/index.js
var popconfirm = __webpack_require__(75443);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(93224);
// EXTERNAL MODULE: ./node_modules/antd/es/input-number/style/index.js
var input_number_style = __webpack_require__(77883);
// EXTERNAL MODULE: ./node_modules/antd/es/input-number/index.js + 2 modules
var input_number = __webpack_require__(39635);
// EXTERNAL MODULE: ./node_modules/antd/es/input/style/index.js
var input_style = __webpack_require__(47673);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 3 modules
var input = __webpack_require__(4107);
// EXTERNAL MODULE: ./node_modules/antd/es/select/style/index.js
var select_style = __webpack_require__(43358);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js
var es_select = __webpack_require__(34041);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/style/index.js
var date_picker_style = __webpack_require__(14965);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/index.js + 6 modules
var date_picker = __webpack_require__(11448);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/Price/Common/SimpleEditableTable/components/Field.tsx











var RangePicker = date_picker/* default.RangePicker */.Z.RangePicker;
var SELECT = props => {
  var fieldOptions = props.fieldOptions,
      dataList = props.dataList,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue;
  var dataSource = dataList;
  return /*#__PURE__*/react.createElement(es_select/* default */.Z, (0,esm_extends/* default */.Z)({
    showSearch: true,
    onBlur: () => fieldChange(''),
    dropdownMatchSelectWidth: false,
    value: fieldValue,
    filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
  }, fieldOptions, {
    onChange: fieldChange,
    style: {
      width: '100%'
    }
  }), dataSource.map(item => {
    var value = item.value,
        label = item.label;
    return /*#__PURE__*/react.createElement(es_select/* default.Option */.Z.Option, {
      key: value,
      value: value,
      rows: item
    }, label);
  }));
};
var INPUT = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      editing = props.editing,
      fieldValue = props.fieldValue;
  var inputRef = (0,react.useRef)();

  var save = e => {
    var val = e.target.value.replace(/(^\s*)|(\s*$)/g, '');
    fieldChange(val);
  };

  (0,react.useEffect)(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);
  return /*#__PURE__*/react.createElement(input/* default */.Z, (0,esm_extends/* default */.Z)({}, fieldOptions, {
    ref: inputRef,
    defaultValue: fieldValue,
    onChange: undefined,
    onPressEnter: save,
    onBlur: save
  }));
};
var RANGE_PICKER = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue;
  return /*#__PURE__*/react.createElement(RangePicker, (0,esm_extends/* default */.Z)({
    allowClear: true,
    style: {
      width: '100%'
    }
  }, fieldOptions, {
    // defaultValue={fieldValue}
    onChange: fieldChange
  }));
};
var DATE_PICKER = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      fieldValue = props.fieldValue;
  var format = (fieldOptions === null || fieldOptions === void 0 ? void 0 : fieldOptions.fieldOptions) || 'YYYY-MM-DD';

  var handleChange = e => {
    var data = e ? moment_default()(e).format(format) : undefined;
    fieldChange(data);
  };

  return /*#__PURE__*/react.createElement(date_picker/* default */.Z, (0,esm_extends/* default */.Z)({
    style: {
      width: '100%'
    },
    format: format
  }, fieldOptions, {
    // defaultValue={value}
    onChange: handleChange
  }));
};
var INPUT_NUMBER = props => {
  var fieldOptions = props.fieldOptions,
      fieldChange = props.fieldChange,
      editing = props.editing,
      fieldValue = props.fieldValue;
  var inputRef = (0,react.useRef)();

  var save = e => {
    var val = e.target.value;
    fieldChange(val);
  };

  (0,react.useEffect)(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);
  return /*#__PURE__*/react.createElement(input_number/* default */.Z, (0,esm_extends/* default */.Z)({
    style: {
      width: '100%'
    }
  }, fieldOptions, {
    ref: inputRef,
    defaultValue: fieldValue,
    onChange: undefined,
    onPressEnter: save,
    onBlur: save
  }));
}; // export const SELECT_INPUT_NUMBER = (props: FieldsProps) => {
//   const { fieldOptions, dataList, fieldChange, fieldValue } = props
//   return (
//     <AutoComplete
//       options={dataList}
//       allowClear
//       showSearch
//        value={fieldValue}
//       filterOption={(input, option: any) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
//       {...fieldOptions}
//       onChange={fieldChange}
//     >
//       <InputNumber
//         placeholder='input here'
//         className='custom'
//         style={{ height: 50 }}
//         // onKeyPress={handleKeyPress}
//       />
//     </AutoComplete>
//   )
// }
;// CONCATENATED MODULE: ./src/pages/GoodsManage/Price/Common/SimpleEditableTable/utils/context.tsx

var EditableContext = /*#__PURE__*/react.createContext(undefined);
var ContextWrapper = props => {
  return /*#__PURE__*/react.createElement(EditableContext.Provider, {
    value: props.value
  }, props.children);
};
;// CONCATENATED MODULE: ./src/pages/GoodsManage/Price/Common/SimpleEditableTable/components/EditableCell.tsx








var _excluded = ["title", "editable", "children", "dataIndex", "type", "record", "rowIndex", "render", "dataList", "fieldOptions", "handleSaveRow", "handleDeleteRow", "hidedeletebtn"];


 // import { getEditableTableKey } from '../PageEditableTable'


 // 获取唯一的key

function getEditableTableKey() {
  return lodash_default().uniqueId('edittable_');
}
var Field = Field_namespaceObject;

var EditableCell = props => {
  var title = props.title,
      editable = props.editable,
      children = props.children,
      dataIndex = props.dataIndex,
      type = props.type,
      record = props.record,
      rowIndex = props.rowIndex,
      render = props.render,
      getDataList = props.dataList,
      fieldOptions = props.fieldOptions,
      handleSaveRow = props.handleSaveRow,
      handleDeleteRow = props.handleDeleteRow,
      hidedeletebtn = props.hidedeletebtn,
      restProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded); // 拼接操作


  if (render && title === '操作') {
    // const { editableTableAdd } = record ?? {}
    // 给新增的行添加背景颜色
    return /*#__PURE__*/react.createElement("td", restProps, !hidedeletebtn && /*#__PURE__*/react.createElement(popconfirm/* default */.Z, {
      title: "\u786E\u8BA4\u5220\u9664\u8FD9\u6761\u6570\u636E\u5417\uFF1F",
      onConfirm: () => handleDeleteRow(record.editableTableKey),
      okText: "\u786E\u8BA4",
      cancelText: "\u53D6\u6D88"
    }, /*#__PURE__*/react.createElement("a", {
      style: {
        marginRight: '8px'
      }
    }, "\u5220\u9664")), render(record[dataIndex], record, rowIndex));
  }

  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      editing = _useState2[0],
      setEditing = _useState2[1];

  var form = (0,react.useContext)(EditableContext);
  var dataList = (0,react.useMemo)(() => {
    var isFunc = typeof getDataList === 'function';

    if (isFunc) {
      var _ref;

      return (_ref = getDataList(record)) !== null && _ref !== void 0 ? _ref : [];
    }

    return getDataList !== null && getDataList !== void 0 ? getDataList : [];
  }, [record, getDataList]); // 针对存在「dataList」的单元格进行设置；使单元格展示的是文案而不是值

  var childContent = (0,react.useMemo)(() => {
    if (!Array.isArray(children)) {
      return children;
    }
    /**
     * 如果当前单元格的 可编辑 状态是 Select、Radio等具有「dataList」属性的表单控件
     * 1. 对该值进行判断校验
     * 2. 最后获取到该值对应的 中文 文案，并交给Table渲染该单元格
     */


    var val = children.slice(1)[0];
    var childType = typeof val;

    if (!val) {
      return children;
    }

    if (childType === 'object' || childType === 'function') {
      return children;
    } // 过滤可能出现的不必要的标签


    var newChildren = childType === 'string' ? val.replace('<tt>', '').replace('</tt>', '') : val;

    if (!dataList) {
      return [undefined, newChildren];
    }

    var _ref2 = dataList.find(v => v.value === val) || {},
        label = _ref2.label;

    return [undefined, label !== null && label !== void 0 ? label : val];
  }, [children, dataList, dataIndex]); // 每条数据添加「editableTableKey」属性，相当于主键ID

  (0,react.useEffect)(() => {
    // 防止重复生成ID，预防后续操作的数据无法追溯
    if (record && !record.editableTableKey) {
      record.editableTableKey = getEditableTableKey();
    }
  }, [record]); // 如果没有传「type」时设置默认是「INPUT」
  // 传了「type」 可以不传 「editable」

  var fieldType = !type && editable ? 'INPUT' : type; // 更改单元格的编辑状态

  var toggleEdit = () => {
    setEditing(!editing);
  }; // 控件发生变化时


  var fieldChange = val => {
    try {
      // 切换编辑状态
      toggleEdit();

      if (!val && val !== 0) {
        return;
      }

      var values = form.getFieldsValue(); // 更新后的本行数据

      var params = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, record), values), {}, {
        [dataIndex]: val
      }); // 如果自定义了回调


      if (fieldOptions !== null && fieldOptions !== void 0 && fieldOptions.onChange) {
        fieldOptions.onChange(params);
      } // 单元格字段名对于的数据


      var currentCell = {
        [dataIndex]: val
      }; // 是否修改过数据

      var hasEdited = record[dataIndex] !== val;
      handleSaveRow(params, {
        hasEdited,
        currentCell
      });
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  }; // 设置组件回显的值


  var defaultVal = record ? record[dataIndex] : undefined;
  var childNode = childContent;
  var fieldVal = ['string', 'number'].includes(typeof defaultVal) ? defaultVal : undefined;
  /**
   * 如果存在自定义渲染的情况，给「render」函数的第四项添加参数
   */

  if (render) {
    var getFieldComponent = renderParams => {
      var fieldType = renderParams.fieldType;

      if (editing && fieldType) {
        var FieldComponent = Field[fieldType];
        return /*#__PURE__*/react.createElement(FieldComponent, (0,esm_extends/* default */.Z)({
          dataList: dataList
        }, props, renderParams, {
          fieldChange: fieldChange,
          fieldValue: fieldVal,
          editing: editing
        }));
      }

      return /*#__PURE__*/react.createElement("div", {
        className: "editableCellValueWrap",
        onClick: toggleEdit
      }, childNode);
    };

    return /*#__PURE__*/react.createElement("td", restProps, render(record[dataIndex], record, rowIndex, getFieldComponent));
  }

  if (fieldType) {
    var FieldComponent = Field[fieldType];
    childNode = editing ? /*#__PURE__*/react.createElement(es_form/* default.Item */.Z.Item, {
      style: {
        margin: 0,
        padding: 0
      },
      name: dataIndex
    }, /*#__PURE__*/react.createElement(FieldComponent, (0,esm_extends/* default */.Z)({}, props, {
      dataList: dataList,
      fieldChange: fieldChange,
      fieldValue: fieldVal,
      editing: editing
    }))) : /*#__PURE__*/react.createElement("div", {
      className: "editableCellValueWrap",
      onClick: toggleEdit
    }, childContent);
  }

  return /*#__PURE__*/react.createElement("td", restProps, childNode);
};

/* harmony default export */ var components_EditableCell = (EditableCell);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/pages/GoodsManage/Price/Common/SimpleEditableTable/index.less?modules
var SimpleEditableTablemodules = __webpack_require__(23875);
var SimpleEditableTablemodules_default = /*#__PURE__*/__webpack_require__.n(SimpleEditableTablemodules);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/Price/Common/SimpleEditableTable/components/EditableRow.tsx





var EditableRow_excluded = ["index"];





var EditableRow = _ref => {
  var _params$record;

  var index = _ref.index,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, EditableRow_excluded);

  var _Form$useForm = es_form/* default.useForm */.Z.useForm(),
      _Form$useForm2 = (0,slicedToArray/* default */.Z)(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var params = props; // 获取表格行的「editableTableAdd」，存在则表示当前行为新增的行

  var _ref2 = (_params$record = params === null || params === void 0 ? void 0 : params.record) !== null && _params$record !== void 0 ? _params$record : {},
      editableTableAdd = _ref2.editableTableAdd;

  return /*#__PURE__*/react.createElement(es_form/* default */.Z, {
    form: form,
    component: false
  }, /*#__PURE__*/react.createElement(ContextWrapper, {
    value: form
  }, /*#__PURE__*/react.createElement("tr", (0,esm_extends/* default */.Z)({}, props, {
    className: classnames_default()((SimpleEditableTablemodules_default()).editableTableRow, {
      newRow: !!editableTableAdd
    })
  }))));
};

/* harmony default export */ var components_EditableRow = (EditableRow);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/Price/Common/SimpleEditableTable/utils/constance.ts
var tableOptionsCol = {
  title: '操作',
  dataIndex: 'operatess',
  key: 'operatess',
  fixed: 'right',
  width: 120,
  render: (t, r, i) => {
    return null;
  }
};
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(5977);
;// CONCATENATED MODULE: ./src/pages/GoodsManage/Price/Common/SimpleEditableTable/SimpleEditableTable.tsx










/* eslint-disable react-hooks/exhaustive-deps */

/**
 * 数据全是外部传入的 可编辑表格
 */









var EditableTable = props => {
  var _useState = (0,react.useState)(props.dataSource),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      dataSource = _useState2[0],
      setDataSource = _useState2[1];

  var history = (0,react_router/* useHistory */.k6)();
  var addRowData = (0,react.useMemo)(() => {
    return props.columns.reduce((prev, next) => {
      prev[next.dataIndex] = undefined;
      return prev;
    }, {});
  }, []); // 新增行

  var handleAddRow = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
      var rowData, list;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              try {
                // 每个新增的数据都设置一个键为「editableTableKey」的随机值
                rowData = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, addRowData), {}, {
                  editableTableKey: lodash_default().uniqueId('edittable_')
                });
                list = [rowData, ...dataSource]; // if (props.addRow) {
                //   await props.addRow()
                // }
                // if (props.addRow) {
                //   props.addRow(addRowData, list)
                // }

                if (props.onChange) {
                  props.onChange(addRowData, list);
                }

                setDataSource(list);
              } catch (error) {
                console.log('add row failed：', error);
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleAddRow() {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * 保存表格行数据
   * @param data 当前修改保存的表格行所有数据
   * @param other 其他参数
   */
  // const handleSaveRow = async (data: any, other: any) => {
  //   try {
  //     // hasEdited，数据是否变化
  //     const { hasEdited, currentCell } = other
  //     if (!hasEdited) {
  //       return
  //     }
  //     // 赋值更新 列表数据
  //     const list = dataSource.map((v: any) => (v.editableTableKey === data.editableTableKey ? data : v))
  //     // 更新选中的数据
  //     // const selectedKeys = selectedRowKeys.map((v: any) => (v.editableTableKey === data.editableTableKey ? data : v))
  //     if (props.onChange) {
  //       /**
  //        * currentCell：当前编辑的单元格数据，{字段名：值}
  //        * currentRow：当前编辑的行数据
  //        * dataSource：表格所有数据
  //        */
  //       const dataParams = { currentCell, currentRow: data, dataSource: list, type: 'EDIT' as HandleType }
  //       // props.onChange(dataParams, [])
  //     }
  //     // if (props.saveRow) {
  //     //   await props.saveRow(data, list)
  //     // } else {
  //     setDataSource(list)
  //     // }
  //     if (props.onChange) {
  //       props.onChange(data, list)
  //     }
  //   } catch (error) {
  //     console.log('save row failed：', error)
  //   }
  // }

  /**
  * 对比和替换列表数据
  * @param list 列表数据
  * @param data 更新后的 列表行数据
  */


  function compareAndChangeData(list, data) {
    return list.map(v => v.editableTableKey === data.editableTableKey ? data : v);
  }
  /**
   * 保存表格行数据
   * @param data 当前修改保存的表格行所有数据
   * @param other 其他参数
   */


  var handleSaveRow = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(data, other) {
      var hasEdited, currentCell, list, dataParams;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              // hasEdited，数据是否变化
              hasEdited = other.hasEdited, currentCell = other.currentCell;

              if (hasEdited) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              // 赋值更新 列表数据
              list = compareAndChangeData(dataSource, data);

              if (props.onChange) {
                /**
                 * currentCell：当前编辑的单元格数据，{字段名：值}
                 * currentRow：当前编辑的行数据
                 * dataSource：表格所有数据
                 */
                dataParams = {
                  currentCell,
                  currentRow: data,
                  dataSource: list,
                  type: 'EDIT'
                };
                props.onChange(dataParams, list);
              } // 如果存在异步保存函数


              if (props.saveRow) {
                props.saveRow(data, list); // const res = await props.saveRow(data, list)
                // console.log(res)
                // table.current.reflashTable()
              }

              setDataSource(list); // 清空 模拟删除的队列
              // setRemovedRows([])

              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              console.error('save row failed：', _context2.t0);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    }));

    return function handleSaveRow(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(); // 删除行


  var handleDeleteRow = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3(i) {
      var list, dataParams;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              try {
                // const obj: any =
                //   dataSource.find((v: any) => v.editableTableKey === i) || {};
                list = dataSource.filter(v => v.editableTableKey !== i); // 如果删除的是已经选中的行数据，过滤了
                // const selectedRows = !!selectedRowKeys.length ? selectedRowKeys.filter((vi: any) => vi.editableTableKey !== i) : []
                // setSelectedRowKeys(selectedRows)

                if (props.onChange) {
                  /**
                   * currentCell：当前编辑的单元格数据，{字段名：值}
                   * currentRow：当前编辑的行数据
                   * dataSource：表格所有数据
                   */
                  dataParams = {
                    currentCell: {},
                    currentRow: {},
                    dataSource: list,
                    type: 'DELETE'
                  }; // 如果存在 onChange 则将删除后的结果数据返回

                  props.onChange(dataParams, list);
                } // if (props.deleteRow) {
                //   await props.deleteRow(obj, list)
                //   table.current.reflashTable()
                // } else {
                // 将之前新增时模拟删除的一项数据加回来
                // setTableParams((v: any) => ({ ...v, dataSource: [...list, ...removedRows] }))
                // }
                // if (props.onChange) {
                //   props.onChange(data, list)
                // }


                setDataSource(list);
              } catch (error) {
                console.log('delete row failed：', error);
              }

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleDeleteRow(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(() => {
    setDataSource(props.dataSource);
  }, [props.dataSource]); // 如果没有设置「hideDeleteBtn」，给「columns」拼接操作表头，并补上删除功能

  var renderCol = (0,react.useMemo)(() => {
    if (props.hideDeleteBtn) {
      return props.columns;
    }

    return props.columns.every(v => v.title !== '操作') ? [...props.columns, tableOptionsCol] : props.columns;
  }, [props.columns]);
  var columns = (0,react.useMemo)(() => {
    return renderCol.map(col => {
      // 如果当前column不存在 editable 字段、表头文案不是操作以及没有 type 值，表示当前单元格展示的是文案而不是表单组件
      if (!col.editable && col.title !== '操作' && !col.type && !col.render) {
        return col;
      }

      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, col), {}, {
        onCell: (record, rowIndex) => {
          return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, col), {}, {
            rowIndex,
            record,
            handleSaveRow,
            handleDeleteRow,
            hidedeletebtn: props.hideDeleteBtn
          });
        }
      });
    });
  }, [renderCol, handleSaveRow, handleDeleteRow, props.hideDeleteBtn]); // const selection = {
  //   selectedRowKeys: selectedRowKeys,
  //   onChange: (keys: any[] | any) => {
  //     setSelectedRowKeys(keys)
  //     if (props.onChange) {
  //       const dataParams = {
  //         currentCell: {},
  //         currentRow: {},
  //         dataSource: dataSource,
  //         type: 'SELECTED' as HandleType
  //       }
  //       props.onChange(dataParams, keys)
  //     }
  //   }
  // }

  var showTipObj = props.showTipObj;
  return /*#__PURE__*/react.createElement("div", null, (props === null || props === void 0 ? void 0 : props.showLimitGoodsTips) && /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/react.createElement("div", {
    style: {
      fontSize: 15,
      marginBottom: 5
    }
  }, "\u6210\u529F\u5BFC\u5165 ", showTipObj === null || showTipObj === void 0 ? void 0 : showTipObj.successCount, " \u6761\u6570\u636E  ", (showTipObj === null || showTipObj === void 0 ? void 0 : showTipObj.errorCount) && /*#__PURE__*/react.createElement("span", null, "\u672A\u5BFC\u5165 ", /*#__PURE__*/react.createElement("span", {
    style: {
      color: 'red'
    }
  }, showTipObj === null || showTipObj === void 0 ? void 0 : showTipObj.errorCount), " \u6761\u6570\u636E")), (showTipObj === null || showTipObj === void 0 ? void 0 : showTipObj.successUrl) && /*#__PURE__*/react.createElement("a", {
    style: {
      fontSize: 16,
      marginBottom: 5
    },
    onClick: () => {
      window.location.href = showTipObj === null || showTipObj === void 0 ? void 0 : showTipObj.successUrl;
    }
  }, "\u4E0B\u8F7D\u5DF2\u5BFC\u5165\u7ED3\u679C"), (showTipObj === null || showTipObj === void 0 ? void 0 : showTipObj.errorUrl) && /*#__PURE__*/react.createElement("a", {
    style: {
      fontSize: 16,
      marginBottom: 5
    },
    onClick: () => {
      if (showTipObj !== null && showTipObj !== void 0 && showTipObj.errorUrl) {
        window.location.href = showTipObj === null || showTipObj === void 0 ? void 0 : showTipObj.errorUrl;
      }
    }
  }, "\u4E0B\u8F7D\u672A\u5BFC\u5165\u7ED3\u679C"), (showTipObj === null || showTipObj === void 0 ? void 0 : showTipObj.detailUrl) && /*#__PURE__*/react.createElement("a", {
    style: {
      fontSize: 16,
      marginBottom: 5
    },
    onClick: () => {
      if (showTipObj !== null && showTipObj !== void 0 && showTipObj.detailUrl) {
        history.push(showTipObj === null || showTipObj === void 0 ? void 0 : showTipObj.detailUrl);
      }
    }
  }, "\u67E5\u770B\u5BFC\u5165\u5546\u54C1\u8BE6\u60C5"))), !(props !== null && props !== void 0 && props.showLimitGoodsTips) && /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(table/* default */.Z, (0,esm_extends/* default */.Z)({
    components: {
      body: {
        row: components_EditableRow,
        cell: components_EditableCell
      }
    },
    rowClassName: () => 'editableTable' // rowSelection={props.canSelected ? selection : undefined}
    ,
    dataSource: dataSource,
    columns: columns,
    rowKey: (re, k) => re.id ? re.id : k,
    pagination: false,
    size: "small",
    loading: props === null || props === void 0 ? void 0 : props.outLoading
  }, props.tableOptions)), !props.hideBtn && /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    type: "dashed",
    onClick: handleAddRow,
    className: "mTop16",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/react.createElement(PlusOutlined/* default */.Z, null), " ", props.buttonTitle || '添加')));
};

/* harmony default export */ var SimpleEditableTable = (EditableTable);

/***/ }),

/***/ 53378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCategory2TreeData; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24731);





/** 给 TreeSelect 提供数据源 */
var useCategory2TreeData = function useCategory2TreeData() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var categoryFilter = props.categoryFilter;
  var initCategory = JSON.parse(sessionStorage.getItem('markedPriceCategory'));

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initCategory || [[]]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState, 2),
      category = _useState2[0],
      setCategory = _useState2[1];

  var genTreeSelect = data => {
    return data === null || data === void 0 ? void 0 : data.map(item => {
      var backCategoryName = item.backCategoryName,
          backCategoryId = item.backCategoryId,
          childBackCategory = item.childBackCategory;

      if (childBackCategory.length) {
        childBackCategory = genTreeSelect(childBackCategory);
      }

      var childCategoryList = {};
      childBackCategory.forEach(i => {
        childCategoryList[i.categoryId] = i;
      });
      return item.level === 1 ? {
        label: backCategoryName,
        value: +backCategoryId,
        others: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)({
          childCategoryList
        }, item)
      } : {
        categoryId: +backCategoryId,
        categoryName: backCategoryName,
        others: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)({
          childCategoryList
        }, item)
      };
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (initCategory) return;
    var url = 'pms.backCategoryManage.getBackCategoryTree'; // 返回所有类目

    (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)(url, {
      businessType: 1,
      status: 1
    }).then(_ref => {
      var success = _ref.success,
          result = _ref.result;

      if (success) {
        var arr = result.childBackCategory;
        if (categoryFilter instanceof Function) arr = categoryFilter(arr);
        var categoryTree = genTreeSelect(arr);
        sessionStorage.setItem('markedPriceCategory', JSON.stringify([categoryTree, result]));
        setCategory([categoryTree, result]);
      }
    });
  }, []);
  return category;
};

/***/ }),

/***/ 97745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SELL_TABLE_COLUMNS": function() { return /* binding */ SELL_TABLE_COLUMNS; },
/* harmony export */   "SELL_DETAIL_TABLE_COLUMNS": function() { return /* binding */ SELL_DETAIL_TABLE_COLUMNS; },
/* harmony export */   "SELL_EDIT_TABLE_COLUMNS": function() { return /* binding */ SELL_EDIT_TABLE_COLUMNS; },
/* harmony export */   "BASE_MAP": function() { return /* binding */ BASE_MAP; },
/* harmony export */   "enumPriceStatus": function() { return /* binding */ enumPriceStatus; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31097);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config_goodsEnums__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3602);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _utils_math__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58180);



/**
 * 进价 COLUMNS
 */




var _max = 40;
var SELL_TABLE_COLUMNS = [{
  title: '单号',
  dataIndex: 'orderNum',
  key: 'orderNum',
  width: 90
}, {
  title: '调整门店数',
  dataIndex: 'siteIdCount',
  key: 'siteIdCount',
  width: 80
}, {
  title: '生效时间',
  dataIndex: 'effectiveTime',
  key: 'effectiveTime',
  render: t => {
    var _date = moment__WEBPACK_IMPORTED_MODULE_1___default()(t).format('YYYY-MM-DD HH:mm:ss');

    if (_date.includes('1970-01-01')) {
      return '-';
    }

    return _date;
  },
  width: 120
}, {
  title: '单据状态',
  dataIndex: 'approvalStatus',
  key: 'approvalStatus',
  width: 60,
  render: t => {
    if (t === _config_goodsEnums__WEBPACK_IMPORTED_MODULE_2__/* .changePriceApproveStatus["未审核"] */ .Uh["未审核"]) {
      return '未审核';
    } else {
      return '已审核';
    }
  }
}, // {
//   title: '商品审核通过数',
//   dataIndex: 'successCount',
//   key: 'successCount',
//   width: 90,
//   render: (t: any) => {
//     if (+t === 0) {
//       return '-'
//     }
//     return t
//   },
// },
// {
//   title: '商品审核失败数',
//   dataIndex: 'failCount',
//   key: 'failCount',
//   width: 90,
//   render: (t: any) => {
//     if (+t === 0) {
//       return '-'
//     }
//     return t
//   },
// },
{
  title: '审核时间',
  dataIndex: 'reviewTime',
  key: 'reviewTime',
  width: 140,
  render: t => {
    var _date = moment__WEBPACK_IMPORTED_MODULE_1___default()(t).format('YYYY-MM-DD HH:mm:ss');

    if (_date.includes('1970-01-01')) {
      return '-';
    }

    return _date;
  }
}, {
  title: '制单人',
  dataIndex: 'creator',
  key: 'creator',
  width: 60,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '制单时间',
  dataIndex: 'gmtCreated',
  key: 'gmtCreated',
  width: 120,
  render: t => {
    return moment__WEBPACK_IMPORTED_MODULE_1___default()(t).format('YYYY-MM-DD HH:mm:ss');
  }
}, {
  title: '审核人',
  dataIndex: 'reviewer',
  key: 'reviewer',
  width: 60,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}];
var SELL_DETAIL_TABLE_COLUMNS = [{
  title: '序号',
  dataIndex: 'idx',
  key: 'idx',
  width: 50,
  render: (t, r, i) => i + 1
}, {
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 90
}, {
  title: '商品条码',
  dataIndex: 'barcode',
  key: 'barcode',
  width: 90
}, {
  title: '商品名称',
  dataIndex: 'productName',
  key: 'productName',
  width: 100
}, {
  title: '单位',
  dataIndex: 'saleUnit',
  key: 'saleUnit',
  width: 60
}, {
  title: '商品类目',
  dataIndex: 'backCategoryName',
  key: 'backCategoryName',
  width: 190
}, {
  title: '原进价(￥)',
  dataIndex: 'oldReferencePurchasePrice',
  key: 'oldReferencePurchasePrice',
  width: 80,
  render: t => {
    return isNaN(t) ? '' : (0,_utils_math__WEBPACK_IMPORTED_MODULE_5__/* .Divide */ .p3)(+t, 1000);
  }
}, {
  title: '新进价(￥)',
  dataIndex: 'referencePurchasePrice',
  key: 'referencePurchasePrice',
  width: 80,
  render: t => {
    return isNaN(t) ? '' : (0,_utils_math__WEBPACK_IMPORTED_MODULE_5__/* .Divide */ .p3)(+t, 1000);
  }
}, {
  title: '销售规格',
  dataIndex: 'specification',
  key: 'specification',
  width: 80
}, {
  title: '供应商编码',
  dataIndex: 'supplierCode',
  key: 'supplierCode',
  width: 80
}, {
  title: '供应商名称',
  dataIndex: 'supplierName',
  key: 'supplierName',
  width: 160
}];
var SELL_EDIT_TABLE_COLUMNS = [{
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 140,
  type: 'SELECT'
}, {
  title: '商品条码',
  dataIndex: 'goodsBarCode',
  key: 'goodsBarCode',
  width: 140,
  type: 'SELECT'
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 140
}, {
  title: '单位',
  dataIndex: 'categoryName',
  key: 'categoryName',
  width: 140
}, {
  title: '商品类目',
  dataIndex: 'isGift',
  key: 'isGift',
  width: 140
}, {
  title: '售价(￥)',
  dataIndex: 'referenceSalePrice',
  key: 'referenceSalePrice',
  width: 100
}, {
  title: '原进价(￥)',
  dataIndex: 'oldReferencePurchasePrice',
  key: 'oldReferencePurchasePrice',
  width: 90
}, {
  title: '新进价(￥)',
  dataIndex: 'referencePurchasePrice',
  key: 'referencePurchasePrice',
  width: 140
}, {
  title: '销售规格',
  dataIndex: 'taxRate',
  key: 'taxRate',
  width: 140
}];
var BASE_MAP = [// 基础信息
['orderNum', ['单号', '']], ['gmtCreated', ['制单时间', '']], ['creator', ['制单人', '']], ['effectiveTime', ['生效时间', '']], ['reviewer', ['审核人', '']], ['memo', ['备注', '']]];
var enumPriceStatus;

(function (enumPriceStatus) {
  enumPriceStatus[enumPriceStatus["\u5DF2\u5BA1\u6838"] = 1] = "\u5DF2\u5BA1\u6838";
  enumPriceStatus[enumPriceStatus["\u672A\u5BA1\u6838"] = 2] = "\u672A\u5BA1\u6838";
})(enumPriceStatus || (enumPriceStatus = {}));

/***/ }),

/***/ 19547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "calculatedGross": function() { return /* binding */ calculatedGross; },
/* harmony export */   "SELL_TABLE_COLUMNS": function() { return /* binding */ SELL_TABLE_COLUMNS; },
/* harmony export */   "SELL_DETAIL_TABLE_COLUMNS": function() { return /* binding */ SELL_DETAIL_TABLE_COLUMNS; },
/* harmony export */   "BASE_MAP": function() { return /* binding */ BASE_MAP; },
/* harmony export */   "enumPriceStatus": function() { return /* binding */ enumPriceStatus; },
/* harmony export */   "enumPriceEffectType": function() { return /* binding */ enumPriceEffectType; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31097);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config_goodsEnums__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3602);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _utils_math__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58180);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84387);



/**
 * 售价 COLUMNS
 */





var levelMapper = {
  1: '基础',
  2: '折扣',
  3: '精品'
};
var calculatedGross = value => {
  var p = (0,_utils_math__WEBPACK_IMPORTED_MODULE_4__/* .Divide */ .p3)(+value['referenceSalePrice'], 100) - (0,_utils_math__WEBPACK_IMPORTED_MODULE_4__/* .Divide */ .p3)(value['oldReferencePurchasePrice'], 1000) * Number(value['conversionRatio']); // 统一换算成元

  var res = ((0,_utils_math__WEBPACK_IMPORTED_MODULE_4__/* .Divide */ .p3)(p, (0,_utils_math__WEBPACK_IMPORTED_MODULE_4__/* .Divide */ .p3)(+value['referenceSalePrice'], 100)) * 100).toFixed(2);
  return res;
};
var SELL_TABLE_COLUMNS = [{
  title: '单号',
  dataIndex: 'orderNum',
  key: 'orderNum',
  width: 110
}, {
  title: '调整门店数',
  dataIndex: 'siteIdCount',
  key: 'siteIdCount',
  width: 80
}, {
  title: '生效时间',
  dataIndex: 'effectiveTime',
  key: 'effectiveTime',
  render: t => {
    var _date = moment__WEBPACK_IMPORTED_MODULE_1___default()(t).format('YYYY-MM-DD HH:mm:ss');

    if (_date.includes('1970-01-01')) {
      return '-';
    }

    return _date;
  },
  width: 120
}, {
  title: '单据状态',
  dataIndex: 'approvalStatus',
  key: 'approvalStatus',
  width: 60,
  render: (t, row) => {
    if (row.source === _config_goodsEnums__WEBPACK_IMPORTED_MODULE_2__/* .sellPriceSource["门店"] */ .rZ["门店"]) {
      return '已审核';
    } else {
      if (t === _config_goodsEnums__WEBPACK_IMPORTED_MODULE_2__/* .changePriceApproveStatus["未审核"] */ .Uh["未审核"]) {
        return '未审核';
      } else {
        return '已审核';
      }
    }
  }
}, {
  title: '来源',
  dataIndex: 'source',
  key: 'source',
  width: 60,
  render: t => {
    if (t === _config_goodsEnums__WEBPACK_IMPORTED_MODULE_2__/* .sellPriceSource["门店"] */ .rZ["门店"]) {
      return '门店';
    }

    if (t === _config_goodsEnums__WEBPACK_IMPORTED_MODULE_2__/* .sellPriceSource["鸵宝"] */ .rZ["鸵宝"]) {
      return '鸵宝';
    }

    return '总部';
  }
}, {
  title: '商品调价成功数',
  dataIndex: 'successCount',
  key: 'successCount',
  width: 100
}, {
  title: '商品调价失败数',
  dataIndex: 'failCount',
  key: 'failCount',
  width: 100
}, {
  title: '审核时间',
  dataIndex: 'reviewTime',
  key: 'reviewTime',
  width: 120,
  render: (t, row) => {
    if (row.source === _config_goodsEnums__WEBPACK_IMPORTED_MODULE_2__/* .sellPriceSource["门店"] */ .rZ["门店"]) {
      var _date = moment__WEBPACK_IMPORTED_MODULE_1___default()(row.gmtCreated).format('YYYY-MM-DD HH:mm:ss');

      if (_date.includes('1970-01-01')) {
        return '-';
      }

      return _date;
    } else {
      var _date2 = moment__WEBPACK_IMPORTED_MODULE_1___default()(t).format('YYYY-MM-DD HH:mm:ss');

      if (_date2.includes('1970-01-01')) {
        return '-';
      }

      return _date2;
    }
  }
}, {
  title: '制单人',
  dataIndex: 'creator',
  key: 'creator',
  width: 60,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '制单时间',
  dataIndex: 'gmtCreated',
  key: 'gmtCreated',
  width: 120,
  render: t => {
    return moment__WEBPACK_IMPORTED_MODULE_1___default()(t).format('YYYY-MM-DD HH:mm:ss');
  }
}, {
  title: '审核人',
  dataIndex: 'reviewer',
  key: 'reviewer',
  width: 60,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}];
var SELL_DETAIL_TABLE_COLUMNS = [{
  title: '序号',
  dataIndex: 'idx',
  key: 'idx',
  width: 50,
  render: (t, r, i) => i + 1
}, {
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 90
}, {
  title: '商品条码',
  dataIndex: 'barcode',
  key: 'barcode',
  width: 130
}, {
  title: '商品名称',
  dataIndex: 'productName',
  key: 'productName',
  width: 100
}, {
  title: 'PLU码',
  dataIndex: 'pluCode',
  key: 'pluCode',
  width: 80
}, {
  title: 'PLU码级别',
  dataIndex: 'pluLevel',
  key: 'pluLevel',
  width: 100,
  render: (t, r, i, fn) => {
    return t ? levelMapper[t] : '';
  }
}, {
  title: '单位',
  dataIndex: 'saleUnit',
  key: 'saleUnit',
  width: 60
}, {
  title: '商品类目',
  dataIndex: 'backCategoryName',
  key: 'backCategoryName',
  width: 200
}, {
  title: () => {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", null, "\u79FB\u52A8\u5E73\u5747\u4EF7"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
      placement: "top",
      title: "\u7EC4\u7EC7\u5185\u4EFB\u4E00\u6709\u6548\u95E8\u5E97\u79FB\u52A8\u5E73\u5747\u4EF7"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, null)));
  },
  dataIndex: 'movingAveragePrice',
  key: 'movingAveragePrice',
  width: 120
}, {
  title: () => {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", null, "\u672B\u6B21\u5165\u5E93\u4EF7"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
      placement: "top",
      title: "\u4F18\u5148\u53D6\u7EC4\u7EC7\u91CC\u7684\u95E8\u5E97\u5BF9\u5E94\u4ED3\u7684\u672B\u6B21\u5165\u5E93\u8FDB\u4EF7+\u914D\u9001\u8D39\uFF0C\u53D6\u4E0D\u5230\u53D6\u4EFB\u4E00\u95E8\u5E97\u672B\u6B21\u5165\u5E93"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, null)));
  },
  dataIndex: 'lastPurchasePrice',
  key: 'lastPurchasePrice',
  width: 120
}, {
  title: '原进价(￥)',
  dataIndex: 'oldReferencePurchasePrice',
  key: 'oldReferencePurchasePrice',
  width: 90,
  render: (t, r, i, fn) => {
    if (t && r !== null && r !== void 0 && r.conversionRatio) {
      return t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_4__/* .Divide */ .p3)(t * +(r === null || r === void 0 ? void 0 : r.conversionRatio), 1000) : '';
    }

    if (t && !(r !== null && r !== void 0 && r.conversionRatio)) {
      return t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_4__/* .Divide */ .p3)(t, 1000) : '';
    }

    return t ? (0,_utils_math__WEBPACK_IMPORTED_MODULE_4__/* .Divide */ .p3)(t, 1000) : '';
  }
}, {
  title: '原售价(￥)',
  dataIndex: 'oldReferenceSalePrice',
  key: 'oldReferenceSalePrice',
  width: 90,
  render: t => {
    return isNaN(t) ? '' : (0,_utils_math__WEBPACK_IMPORTED_MODULE_4__/* .Divide */ .p3)(+t, 100);
  }
}, {
  title: '新售价(￥)',
  dataIndex: 'referenceSalePrice',
  key: 'referenceSalePrice',
  width: 90,
  render: t => {
    return isNaN(t) ? '' : (0,_utils_math__WEBPACK_IMPORTED_MODULE_4__/* .Divide */ .p3)(+t, 100);
  }
}, {
  title: '毛利率(%)',
  dataIndex: 'creator',
  key: 'creator',
  width: 130,
  sorter: (a, b) => {
    var ag = calculatedGross(a);
    var bg = calculatedGross(b);
    return Number(ag) - Number(bg);
  },
  render: (t, r, i, fn) => {
    if (r['referenceSalePrice'] != 0) {
      if (!isNaN(r['referenceSalePrice']) && !isNaN(r['oldReferencePurchasePrice'])) {
        var p = (0,_utils_math__WEBPACK_IMPORTED_MODULE_4__/* .Divide */ .p3)(+r['referenceSalePrice'], 100) - (0,_utils_math__WEBPACK_IMPORTED_MODULE_4__/* .Divide */ .p3)(r['oldReferencePurchasePrice'], 1000) * Number(r['conversionRatio']); // 统一换算成元

        var res = ((0,_utils_math__WEBPACK_IMPORTED_MODULE_4__/* .Divide */ .p3)(p, (0,_utils_math__WEBPACK_IMPORTED_MODULE_4__/* .Divide */ .p3)(+r['referenceSalePrice'], 100)) * 100).toFixed(2);

        if (+res < 0) {
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
            style: {
              color: 'red'
            }
          }, res);
        }

        return res;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
}, {
  title: '毛利额(￥)',
  dataIndex: 'gmtCreate',
  key: 'gmtCreate',
  width: 90,
  render: (t, r, i, fn) => {
    if (!isNaN(r['referenceSalePrice']) && !isNaN(r['oldReferencePurchasePrice'])) {
      // 与编辑页不同
      var p = (0,_utils_math__WEBPACK_IMPORTED_MODULE_4__/* .Divide */ .p3)(+r['referenceSalePrice'], 100) - (0,_utils_math__WEBPACK_IMPORTED_MODULE_4__/* .Divide */ .p3)(r['oldReferencePurchasePrice'], 1000) * Number(r['conversionRatio']); // 统一换算成元

      return p.toFixed(3);
    } else {
      return '';
    }
  }
}, {
  title: '销售规格',
  dataIndex: 'specification',
  key: 'specification',
  width: 80
}, {
  title: '供应商编码',
  dataIndex: 'supplierCode',
  key: 'supplierCode',
  width: 100
}, {
  title: '供应商名称',
  dataIndex: 'supplierName',
  key: 'supplierName',
  width: 160
}]; // export const SELL_EDIT_TABLE_COLUMNS: any = [
//   {
//     title: '商品编码',
//     dataIndex: 'goodsId',
//     key: 'goodsId',
//     width: 140,
//     type: 'SELECT',
//   },
//   {
//     title: '商品条码',
//     dataIndex: 'goodsBarCode',
//     key: 'goodsBarCode',
//     width: 140,
//     type: 'SELECT',
//   },
//   {
//     title: '商品名称',
//     dataIndex: 'goodsName',
//     key: 'goodsName',
//     width: 140
//   },
//   {
//     title: '单位',
//     dataIndex: 'categoryName',
//     key: 'categoryName',
//     width: 140
//   },
//   {
//     title: '商品类目',
//     dataIndex: 'isGift',
//     key: 'isGift',
//     width: 140
//   },
//   {
//     title: '进价(￥)',
//     dataIndex: 'costPrice',
//     key: 'costPrice',
//     width: 140
//   },
//   {
//     title: '原售价(￥)',
//     dataIndex: 'tradePrice',
//     key: 'tradePrice',
//     width: 140
//   },
//   {
//     title: '新售价(￥)',
//     dataIndex: 'unitPrice',
//     key: 'unitPrice',
//     width: 140,
//     type: 'INPUT'
//   },
//   {
//     title: '毛利率(%)',
//     dataIndex: 'amount',
//     key: 'amount',
//     width: 140,
//     render: (t: any, r: any, i: number, fn: any) => {
//       // if (!isNaN(r['referenceSalePrice']) && !isNaN(r['oldReferencePurchasePrice'])) {
//       //   const p = r['referenceSalePrice'] - (Math.floor(r['oldReferencePurchasePrice'] * 100) / 10000)
//       //   return ((p / r['oldReferencePurchasePrice']) * 10000).toFixed(2)
//       // } else {
//       //   return ''
//       // }
//       if (!isNaN(r['referenceSalePrice']) && !isNaN(r['oldReferencePurchasePrice'])) {
//         const p = Divide(+r['referenceSalePrice'], 100) - Divide(r['oldReferencePurchasePrice'], 1000) // 统一换算成元
//         return (Divide(p, Divide(+r['referenceSalePrice'], 100)) * 100).toFixed(2)
//       } else {
//         return ''
//       }
//     }
//   },
//   {
//     title: '毛利额(￥)',
//     dataIndex: 'taxRate',
//     key: 'taxRate',
//     width: 140,
//     render: (t: any, r: any, i: number, fn: any) => {
//       if (!isNaN(r['referenceSalePrice']) && !isNaN(r['oldReferencePurchasePrice'])) {
//         return (r['referenceSalePrice'] - (Math.floor(r['oldReferencePurchasePrice'] * 100) / 10000)).toFixed(2)
//       } else {
//         return ''
//       }
//     }
//   },
//   {
//     title: '销售规格',
//     dataIndex: 'taxRate',
//     key: 'taxRate',
//     width: 140
//   }
// ]

var BASE_MAP = [// 基础信息
['orderNum', ['单号', '']], ['gmtCreated', ['制单时间', '']], ['creator', ['制单人', '']], ['effectiveTime', ['生效时间', '']], ['reviewer', ['审核人', '']], ['memo', ['备注', '']]];
var enumPriceStatus;

(function (enumPriceStatus) {
  enumPriceStatus[enumPriceStatus["\u5DF2\u5BA1\u6838"] = 1] = "\u5DF2\u5BA1\u6838";
  enumPriceStatus[enumPriceStatus["\u672A\u5BA1\u6838"] = 2] = "\u672A\u5BA1\u6838";
})(enumPriceStatus || (enumPriceStatus = {}));

var enumPriceEffectType;

(function (enumPriceEffectType) {
  enumPriceEffectType[enumPriceEffectType["\u7ACB\u5373\u751F\u6548"] = 1] = "\u7ACB\u5373\u751F\u6548";
  enumPriceEffectType[enumPriceEffectType["\u5B9A\u65F6\u751F\u6548"] = 2] = "\u5B9A\u65F6\u751F\u6548";
})(enumPriceEffectType || (enumPriceEffectType = {}));

/***/ }),

/***/ 4710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ExportType": function() { return /* binding */ ExportType; }
/* harmony export */ });
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57016);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71577);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48086);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _components_CommonTable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40934);







/**
 * 查看导出结果浮层
 */


var ExportType;

(function (ExportType) {
  ExportType[ExportType["\u91C7\u8D2D\u5355\u5546\u54C1\u5BFC\u51FA"] = 1] = "\u91C7\u8D2D\u5355\u5546\u54C1\u5BFC\u51FA";
  ExportType[ExportType["\u91C7\u8D2D\u5355\u5355\u4E2A\u5BFC\u51FA"] = 2] = "\u91C7\u8D2D\u5355\u5355\u4E2A\u5BFC\u51FA";
  ExportType[ExportType["\u8C03\u62E8\u5355\u5BFC\u51FA"] = 3] = "\u8C03\u62E8\u5355\u5BFC\u51FA";
  ExportType[ExportType["\u96C6\u5355\u5546\u54C1\u5BFC\u51FA"] = 4] = "\u96C6\u5355\u5546\u54C1\u5BFC\u51FA";
  ExportType[ExportType["\u96C6\u5355\u672A\u4E0B\u5355\u95E8\u5E97\u5BFC\u51FA"] = 5] = "\u96C6\u5355\u672A\u4E0B\u5355\u95E8\u5E97\u5BFC\u51FA";
  ExportType[ExportType["\u96C6\u5355\u5931\u8D25\u660E\u7EC6\u5BFC\u51FA"] = 6] = "\u96C6\u5355\u5931\u8D25\u660E\u7EC6\u5BFC\u51FA";
  ExportType[ExportType["\u91C7\u8D2D\u5355\u4EF7\u683C\u6A21\u677F\u5BFC\u51FA"] = 7] = "\u91C7\u8D2D\u5355\u4EF7\u683C\u6A21\u677F\u5BFC\u51FA";
  ExportType[ExportType["\u91C7\u8D2D\u5355\u5408\u5E76\u5BFC\u51FA"] = 8] = "\u91C7\u8D2D\u5355\u5408\u5E76\u5BFC\u51FA";
  ExportType[ExportType["\u5546\u54C1\u6C60\u660E\u7EC6\u5BFC\u51FA"] = 9] = "\u5546\u54C1\u6C60\u660E\u7EC6\u5BFC\u51FA";
  ExportType[ExportType["\u672A\u62A5\u4EF7\u4F9B\u5E94\u5546\u660E\u7EC6"] = 11] = "\u672A\u62A5\u4EF7\u4F9B\u5E94\u5546\u660E\u7EC6";
  ExportType[ExportType["\u672A\u5E02\u8C03\u5546\u54C1"] = 12] = "\u672A\u5E02\u8C03\u5546\u54C1";
  ExportType[ExportType["\u7F3A\u91CF\u660E\u7EC6"] = 13] = "\u7F3A\u91CF\u660E\u7EC6";
})(ExportType || (ExportType = {}));

function ExportModal(props) {
  var _props$businessType;

  var queryDataUrl = props.queryDataUrl,
      businessType = props.businessType,
      closeModalCallback = props.closeModalCallback,
      _props$visible = props.visible,
      visible = _props$visible === void 0 ? true : _props$visible;
  var table = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
  var searchParams = {
    businessType: (_props$businessType = props.businessType) !== null && _props$businessType !== void 0 ? _props$businessType : ExportType.采购单单个导出
  };

  var downloadFile = url => {
    if (!url) {
      antd_es_message__WEBPACK_IMPORTED_MODULE_5__.default.error('不存在文件');

      return;
    }

    window.location.href = url;
  };

  var reloadTable = () => {
    table.current.reflashTable({
      businessType
    });
  };

  var columns = [{
    title: '文件名称',
    dataIndex: 'fileName',
    key: 'fileName',
    width: 160
  }, {
    title: '导出时间',
    dataIndex: 'exportTime',
    key: 'exportTime',
    width: 140
  }, {
    title: '状态',
    dataIndex: 'statusName',
    key: 'statusName',
    width: 100
  }, {
    title: '操作人',
    dataIndex: 'creator',
    key: 'creator',
    width: 120
  }, {
    title: '操作',
    dataIndex: 'operateeee',
    key: 'operateeee',
    width: 100,
    render: (_, r) => {
      return r.status === 8 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("a", {
        onClick: () => downloadFile(r.downloadUrl)
      }, "\u4E0B\u8F7D") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("a", {
        onClick: reloadTable
      }, "\u5237\u65B0");
    }
  }];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    title: "\u67E5\u770B\u5BFC\u51FA\u7ED3\u679C",
    destroyOnClose: true,
    maskClosable: false,
    width: 800,
    visible: visible,
    onOk: closeModalCallback,
    onCancel: closeModalCallback,
    footer: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
      onClick: closeModalCallback
    }, "\u5173\u95ED")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_CommonTable__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    ref: table,
    searchParams: searchParams,
    columns: columns,
    queryDataUrl: 'scm.purchase.getExportTaskList'
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (ExportModal);

/***/ }),

/***/ 19334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(57016);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _components_CommonTable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40934);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24731);
/* harmony import */ var _ExportModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4710);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2423);











/**
 * 未报价供应商明细
 */






var NoQuotedModal = props => {
  var handleOnCancelFn = props.handleOnCancelFn,
      searchParams = props.searchParams;
  var table = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState, 2),
      exportModal = _useState2[0],
      setExportModal = _useState2[1];

  var formatResult = data => {
    return {
      list: data === null || data === void 0 ? void 0 : data.info,
      total: data === null || data === void 0 ? void 0 : data.total
    };
  };

  var columns = [{
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 160
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 140
  }, {
    title: '商家名称',
    dataIndex: 'merchantName',
    key: 'merchantName',
    width: 160
  }, {
    title: '地点编码',
    dataIndex: 'placeId',
    key: 'placeId',
    width: 160
  }, {
    title: '地点名称',
    dataIndex: 'placeName',
    key: 'placeName',
    width: 160
  }, {
    title: '供应商编码',
    dataIndex: 'suppCode',
    key: 'suppCode',
    width: 100
  }, {
    title: '供应商名称',
    dataIndex: 'suppName',
    key: 'suppName',
    width: 120
  }];

  var exportList = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().mark(function _callee() {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_10__/* .lookForwardQuoteDetailExport */ .c, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({}, props.searchParams));

            case 2:
              res = _context.sent;

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_12__.default.success('导出任务完成，在【导出列表】查看下载');

                setTimeout(() => {
                  setExportModal(true);
                }, 500);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function exportList() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
    title: "\u672A\u62A5\u4EF7\u4F9B\u5E94\u5546\u660E\u7EC6",
    destroyOnClose: true,
    width: 800,
    visible: true,
    onCancel: handleOnCancelFn,
    footer: null
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
    type: "primary",
    onClick: exportList,
    style: {
      marginRight: '14px'
    }
  }, "\u5BFC\u51FA"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
    type: "primary",
    onClick: () => setExportModal(true)
  }, "\u5BFC\u51FA\u5217\u8868"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_CommonTable__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    ref: table,
    searchParams: searchParams,
    columns: columns,
    queryDataUrl: 'scm.purchase.quote.lookForwardQuoteDetail',
    formatResult: formatResult
  }), exportModal && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ExportModal__WEBPACK_IMPORTED_MODULE_6__.default, {
    businessType: 11,
    closeModalCallback: () => setExportModal(false)
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (NoQuotedModal);

/***/ }),

/***/ 67182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2423);
/* harmony import */ var _components_FormBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5670);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24731);








/**
 * 批量审核汇
 */






function ProcessModal(props) {
  var _props$selectedRows = props.selectedRows,
      selectedRows = _props$selectedRows === void 0 ? [] : _props$selectedRows,
      handleOnCancelFn = props.handleOnCancelFn,
      handleOkFn = props.handleOkFn; // console.log(selectedRows,'选中的数据')

  var form = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  var formList = [{
    label: '审核',
    name: 'auditState',
    type: 'SELECT',
    required: true,
    dataList: [{
      value: 1,
      label: '通过'
    }, {
      value: 2,
      label: '不通过'
    }]
  }, {
    label: '审核意见',
    name: 'auditRemark',
    type: 'SELECT',
    // required: true,
    dataList: [{
      value: 1,
      label: '价格较高'
    }, {
      value: 2,
      label: '数量较少'
    }, {
      value: 3,
      label: '其他'
    }]
  }];

  var handleOk = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().mark(function _callee() {
      var value, param, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return form.current.validateFields();

            case 2:
              value = form.current.getFieldsValue();
              param = selectedRows.map(r => ({
                quoteOrderNo: r.quoteOrderNo,
                goodsBarCode: r.goodsBarCode,
                goodsCode: r.goodsCode,
                pluCode: r.pluCode,
                goodsAuditQty: r.goodsAuditQty,
                auditPrice: r.auditPrice,
                quotedPriceEndDate: r.quotedPriceEndDate
              }));
              _context.next = 6;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_7__/* .ORDER_DETAIL_LINE_REQUEST */ .Xz, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)({
                param
              }, value));

            case 6:
              res = _context.sent;

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_9__.default.success('批量审核成功');

                handleOkFn();
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleOk() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z, {
    title: "\u6279\u91CF\u5BA1\u6838",
    destroyOnClose: true,
    maskClosable: false,
    width: 500,
    visible: true,
    onCancel: handleOnCancelFn,
    onOk: handleOk
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_components_FormBuilder__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    ref: form,
    elements: formList,
    notSearchForm: true
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (ProcessModal);

/***/ }),

/***/ 47433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(57016);
/* harmony import */ var antd_es_table_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66456);
/* harmony import */ var antd_es_table__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(97423);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45577);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2423);
/* harmony import */ var _useBatchColumns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92855);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96534);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_7__);











/**
 * 批量采购汇总浮层
 */

// import { YpRequest } from 'yp-frontend-library'







function SummaryModal(props) {
  var _total$purchaseOrderR, _total$purchaseOrderA;

  var goodsList = props.goodsList,
      _props$visible = props.visible,
      visible = _props$visible === void 0 ? true : _props$visible,
      closeModalCallback = props.closeModalCallback,
      confirmCallback = props.confirmCallback;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState, 2),
      preData = _useState2[0],
      setPreData = _useState2[1];

  var tableRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    purchaseOrderReqTotal: 0,
    purchaseOrderAmountTotal: 0
  }),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState3, 2),
      total = _useState4[0],
      setTotal = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState5, 2),
      storeReqQtyTotal = _useState6[0],
      setStoreReqQtyTotal = _useState6[1]; // 门店要货总量


  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState9, 2),
      error = _useState10[0],
      setError = _useState10[1];

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''),
      _useState12 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState11, 2),
      errorTitle = _useState12[0],
      setErrorTitle = _useState12[1];

  var _useState13 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState14 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState13, 2),
      errorData = _useState14[0],
      setErrorData = _useState14[1];

  var _useState15 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState16 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState15, 2),
      errorColumns = _useState16[0],
      setErrorCloumns = _useState16[1]; // 使用key值缓存 来区分操作那个 purchaseAmount


  var _useState17 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState18 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState17, 2),
      keyData = _useState18[0],
      setKey = _useState18[1]; // const [tableParams, setTableParams] = useState({
  //   pageSize: 30,
  //   current: 1,
  //   total: 0
  // })


  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (Array.isArray(goodsList) && goodsList.length > 0) {
      queryPreData();
    }
  }, [goodsList]); // const getPagination = {
  //   showSizeChanger: true,
  //   showQuickJumper: true,
  //   pageSizeOptions: ['30', '100', '300', '500'],
  //   pageSize: tableParams.pageSize,
  //   current: tableParams.current,
  //   onChange: (page: any, pageSize: any) => {
  //     setTableParams({
  //       ...tableParams,
  //       pageSize,
  //       current: page
  //     })
  //   }
  // }

  /**
   *
   * @param v 修改input回调
   * @param key
   * @param bIndex
   * @param sIndex
   */

  var inputChange = (v, key, bIndex, sIndex) => {
    var cur = preData[bIndex].quoteSuppList[sIndex]; // if (key === 'purchaseAmount' && (isNaN(cur.purchaseQty) || +cur.purchaseQty === 0)) {
    //   message.warning('请先输入采购数量！')
    //   return
    // }

    if (key === 'purchaseQty' || key === 'netConversionRatio') {
      v = cur.isWeigh === 1 ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_6__/* .exchageToNum3 */ .hY)(v) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_6__/* .exchageToNum1 */ .Ly)(v);
    }

    if (key === 'purchasePrice' || key === 'purchaseAmount') {
      v = (0,_utils_common__WEBPACK_IMPORTED_MODULE_6__/* .exchageToNum3 */ .hY)(v);
    }

    preData[bIndex].quoteSuppList[sIndex][key] = v;

    if (key === 'purchaseQty' && cur !== null && cur !== void 0 && cur.isMinPrice || key === 'purchaseAmount' && cur !== null && cur !== void 0 && cur.isMinPrice) {
      console.log('key进行识别333', preData[bIndex], key);
      var keylist = [...keyData]; // 检查lastPurchasePriceKey是否已存在于keyData中

      var exists = keyData.some(k => k.key === "".concat(cur.lastPurchasePriceKey, "-").concat(bIndex, "-").concat(sIndex));

      if (!exists && cur.lastPurchasePriceKey) {
        keylist.push({
          key: "".concat(cur.lastPurchasePriceKey, "-").concat(bIndex, "-").concat(sIndex)
        });
        setKey(keylist);
      }
    } // // 计算逻辑
    // if (key === 'purchasePrice') {
    //   preData[bIndex].quoteSuppList[sIndex]['purchaseAmount'] = Multiply((cur.purchaseQty || 0), (+v || 0))
    // }
    // if (key === 'purchaseQty') {
    //   preData[bIndex].quoteSuppList[sIndex]['purchaseAmount'] = Multiply((cur.purchasePrice || 0), (+v || 0))
    // }
    // if (key === 'purchaseAmount') {
    //   preData[bIndex].quoteSuppList[sIndex]['purchasePrice'] = Divide((+v || 0), cur.purchaseQty).toFixed(3)
    // }


    console.log('时间的数据', preData, key);
    setPreData([...preData]);
  };
  /**
   * 输入框失焦调用编辑接口
   * @param bIndex
   * @param sIndex
   */


  var inputBlur = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee(cur, key) {
      var quoteOrderNo, pluCode, goodsBarCode, goodsCode, netConversionRatio, param, editValue, preKeys;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              quoteOrderNo = cur.quoteOrderNo, pluCode = cur.pluCode, goodsBarCode = cur.goodsBarCode, goodsCode = cur.goodsCode, netConversionRatio = cur.netConversionRatio;
              param = {
                quoteOrderNo,
                pluCode,
                goodsBarCode,
                goodsCode
              };
              console.log(cur, key, '时间参数传递', param);
              editValue = cur[key];

              if (editValue === '' || editValue === undefined) {
                editValue = 0;
              }

              if (key !== 'purchaseQty' && +editValue === 0) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_11__.default.error('不可以为0或者为空');
              } // 接口需要对key转换


              preKeys = {
                purchaseQty: 'purchaseOrderQty',
                purchaseAmount: 'purchaseAmount',
                purchasePrice: 'purchaseOrderPrice',
                netConversionRatio: 'conversionRatio',
                expectedDate: 'expectedDate'
              };

              if (key == 'purchaseQty1') {
                key = 'purchaseQty';
                editValue = editValue && netConversionRatio ? editValue * netConversionRatio : editValue;
              }

              param[preKeys[key]] = editValue;
              param['editKey'] = preKeys[key];

              if (key !== 'purchaseAmount') {
                // 后面服务端要求 总额也传进去
                param['purchaseAmount'] = cur['purchaseAmount'];
              }

              console.log('时间参数传递9999', param);
              getOrderEdit(param);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function inputBlur(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var purchaseAmountFunc = (item, differenceQty, bIndex, sIndex) => {
    if (item !== null && item !== void 0 && item.isMinPrice) {
      var exists = keyData.some(k => k.key === "".concat(item.lastPurchasePriceKey, "-").concat(bIndex, "-").concat(sIndex));
      console.log(keyData, 'key进行识别2222', exists, 'item', item, 'differenceQty', differenceQty, '`${item.lastPurchasePriceKey}-${bIndex}-${sIndex}`', "".concat(item.lastPurchasePriceKey, "-").concat(bIndex, "-").concat(sIndex));

      if (Number(item === null || item === void 0 ? void 0 : item.purchaseAmount) === 0 && Number(differenceQty) > 0 && !exists) {
        return Number((differenceQty * item.purchasePrice * 1000 / 1000).toFixed(3));
      } else {
        return item.purchaseAmount;
      }
    } else {
      return item.purchaseAmount;
    }
  };

  var purchasePriceFunc = (item, differenceQty, bIndex, sIndex) => {
    if (item !== null && item !== void 0 && item.isMinPrice) {
      var exists = keyData.some(k => k.key === "".concat(item.lastPurchasePriceKey, "-").concat(bIndex, "-").concat(sIndex));
      console.log(keyData, 'key进行识别111', exists, item, '`${item.lastPurchasePriceKey}-${bIndex}-${sIndex}`', "".concat(item.lastPurchasePriceKey, "-").concat(bIndex, "-").concat(sIndex));

      if (Number(item === null || item === void 0 ? void 0 : item.purchaseQty) === 0 && Number(differenceQty) > 0 && !exists) {
        return differenceQty;
      } else {
        return item.purchaseQty;
      }
    } else {
      return item.purchaseQty;
    }
  };
  /**
   * radioChange
   *
   */


  var radioChange = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee2(cur, v, key) {
      var quoteOrderNo, pluCode, goodsBarCode, goodsCode, param;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              quoteOrderNo = cur.quoteOrderNo, pluCode = cur.pluCode, goodsBarCode = cur.goodsBarCode, goodsCode = cur.goodsCode;
              param = {
                quoteOrderNo,
                pluCode,
                goodsBarCode,
                goodsCode
              };
              param['editKey'] = key;
              param[key] = v;
              getOrderEdit(param);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function radioChange(_x3, _x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }();

  var getOrderEdit = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee3(param) {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return (0,_utils_ypRequest_core__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_12__/* .QUOTE_ORDER_EDIT */ .aC, {
                param
              });

            case 3:
              res = _context3.sent;

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_11__.default.success('修改成功'); // 重新刷数据


                queryPreData();
              } else {}

              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              console.log('request error ==>', _context3.t0);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 7]]);
    }));

    return function getOrderEdit(_x6) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * 服务端获取处理过的批量数据
   */


  var queryPreData = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee4() {
    var params, res, data, list, _yield$Promise$all, _yield$Promise$all2, inventoryResult, referencePriceResult, updatedList;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            params = {
              param: {
                goodsList
              } // page: tableParams.current,
              // szie: tableParams.pageSize

            };
            _context4.prev = 1;
            _context4.next = 4;
            return (0,_utils_ypRequest_core__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_12__/* .ORDER_PRE_PROCESS */ .Kj, params);

          case 4:
            res = _context4.sent;

            if (!res.success) {
              _context4.next = 19;
              break;
            }

            data = res.result || {};
            list = data.list || [];
            setTotal({
              purchaseOrderReqTotal: data.purchaseOrderReqTotal,
              purchaseOrderAmountTotal: data.purchaseOrderAmountTotal
            }); // setTableParams({
            //   total: data.total,
            //   pageSize: data.size,
            //   current: data.page
            // })
            // 使用 Promise.all 等待所有异步操作完成

            _context4.next = 11;
            return Promise.all([queryStoreInventory(list), queryPurchaseReferencePrice(list)]);

          case 11:
            _yield$Promise$all = _context4.sent;
            _yield$Promise$all2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_yield$Promise$all, 2);
            inventoryResult = _yield$Promise$all2[0];
            referencePriceResult = _yield$Promise$all2[1];
            console.log(inventoryResult, 'pall合并数据', referencePriceResult, list);
            updatedList = list.map((item, index) => {
              if (item.quoteSuppList && item.quoteSuppList.length > 0) {
                item.quoteSuppList = item.quoteSuppList.map((suppItem, sIndex) => {
                  var purchaseQty1 = suppItem.purchaseQty && suppItem.netConversionRatio ? (suppItem.purchaseQty / suppItem.netConversionRatio).toFixed(1) : '';
                  return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, suppItem), {}, {
                    purchaseQty1
                  });
                });
              }

              return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, item), inventoryResult[index]), referencePriceResult[index]);
            });
            console.log(updatedList, '合并数据');
            setPreData(updatedList); // 先渲染
            // setPreData(list)
            // queryStoreInventory(list)
            // queryPurchaseReferencePrice(list)

          case 19:
            _context4.next = 24;
            break;

          case 21:
            _context4.prev = 21;
            _context4.t0 = _context4["catch"](1);
            console.log('request error ==>', _context4.t0);

          case 24:
            _context4.prev = 24;
            setLoading(false);
            return _context4.finish(24);

          case 27:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 21, 24, 27]]);
  })), [keyData]);
  /**
   * 列表数据完成之后去获取门店要货量和库存量
   * @param list
   */

  var queryStoreInventory = /*#__PURE__*/function () {
    var _ref5 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee5(list) {
      var params, res, data, listStoreReq, listInventoryReq, totalStoreReq, mapLastQuoteAmount, mapLastPurchased;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(list.length === 0)) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt("return", list);

            case 2:
              _context5.prev = 2;
              params = {
                param: {
                  expectedDate: goodsList && goodsList.length > 0 && goodsList[0].expectedDate ? goodsList[0].expectedDate.split(' ')[0] : null,
                  list: goodsList
                }
              };
              _context5.next = 6;
              return (0,_utils_ypRequest_core__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_12__/* .QUOTE_P_STOREQEQ_INVENTORY */ ._U, params);

            case 6:
              res = _context5.sent;

              if (!res.success) {
                _context5.next = 16;
                break;
              }

              data = res.result || {};
              listStoreReq = data.listStoreReq || {};
              listInventoryReq = data.listInventoryReq || {};
              totalStoreReq = data.totalStoreReq || 0;
              mapLastQuoteAmount = data.mapLastQuoteAmount || {};
              mapLastPurchased = data.mapLastPurchased || {};
              setStoreReqQtyTotal(totalStoreReq);
              return _context5.abrupt("return", list = list.map((i, bIndex) => {
                var storeReqQty = listStoreReq[i.storeReqKey] || 0;
                var inventoryQty = listInventoryReq[i.inventoryKey] || 0;
                i.quoteSuppList && i.quoteSuppList.map((item, sIndex) => {
                  item['lastQuoteAmountQty'] = mapLastQuoteAmount[item.lastQuotePriceKey] || '-'; //上次报价

                  item['lastPurchasePriceQty'] = mapLastPurchased[item.lastPurchasePriceKey] || ''; // 上次采购标识

                  item['purchaseQty'] = purchasePriceFunc(item, +storeReqQty - +inventoryQty - +i.purchaseReqQty, bIndex, sIndex); // 采购数量

                  item['purchaseAmount'] = purchaseAmountFunc(item, +storeReqQty - +inventoryQty - +i.purchaseReqQty, bIndex, sIndex); // 采购总金额
                });
                return {
                  // ...i,
                  storeReqQty,
                  inventoryQty,
                  differenceQty: +storeReqQty - +inventoryQty - +i.purchaseReqQty
                };
              }));

            case 16:
              _context5.next = 22;
              break;

            case 18:
              _context5.prev = 18;
              _context5.t0 = _context5["catch"](2);
              console.log('request error ==>', _context5.t0);
              return _context5.abrupt("return", list);

            case 22:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[2, 18]]);
    }));

    return function queryStoreInventory(_x7) {
      return _ref5.apply(this, arguments);
    };
  }();
  /**
   * 列表数据完成之后去获取参考价
   * @param list
   */


  var queryPurchaseReferencePrice = /*#__PURE__*/function () {
    var _ref6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee6(list) {
      var paramsList, params, res, data, listReferencePrice, referencePriceMap;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(list.length === 0)) {
                _context6.next = 2;
                break;
              }

              return _context6.abrupt("return");

            case 2:
              _context6.prev = 2;
              paramsList = list.map(item => {
                return {
                  placeId: item.placeId,
                  goodsId: item.goodsCode
                };
              });
              params = {
                orderDirect: 1,
                merchantId: goodsList[0].merchantId,
                firstCategoryId: goodsList[0].firstCategoryId,
                goods: paramsList
              };
              _context6.next = 7;
              return (0,_utils_ypRequest_core__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_12__/* .REFERENCE_PRICE */ .DE, params);

            case 7:
              res = _context6.sent;

              if (!res.success) {
                _context6.next = 15;
                break;
              }

              data = res.result || {};
              listReferencePrice = data.list || {};
              referencePriceMap = new Map();
              listReferencePrice.forEach(item => {
                var key = "".concat(item.goodsId, "-").concat(item.placeId);
                referencePriceMap.set(key, item.price);
              });
              console.log('referencePriceMap' + referencePriceMap);
              return _context6.abrupt("return", list = list.map(i => {
                var key = "".concat(i.goodsCode, "-").concat(i.placeId);
                var referencePrice = referencePriceMap.get(key) || 0;
                i.quoteSuppList && i.quoteSuppList.map(item => {
                  item['referencePrice'] = referencePrice;
                });
                return {
                  // ...i
                  referencePrice
                };
              }));

            case 15:
              _context6.next = 21;
              break;

            case 17:
              _context6.prev = 17;
              _context6.t0 = _context6["catch"](2);
              console.log('request error ==>', _context6.t0);
              return _context6.abrupt("return", list);

            case 21:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[2, 17]]);
    }));

    return function queryPurchaseReferencePrice(_x8) {
      return _ref6.apply(this, arguments);
    };
  }();
  /**
   * 确认采购
   */


  var confirmPurchase = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee7() {
    var gl, res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            gl = (0,lodash__WEBPACK_IMPORTED_MODULE_7__.flatten)(preData.map(q => q.quoteSuppList)).map(i => {
              var _goodsList$find;

              return {
                purchaseQty: i.purchaseQty,
                purchasePrice: i.purchasePrice,
                netConversionRatio: i.netConversionRatio,
                quoteOrderNo: i.quoteOrderNo,
                pluCode: i.pluCode,
                goodsBarCode: i.goodsBarCode,
                goodsCode: i.goodsCode,
                purchaseAmount: i.purchaseAmount,
                bdSupplierFlag: i.bdSupplierFlag,
                goodsName: i.goodsName,
                quotedPriceEndDate: (goodsList === null || goodsList === void 0 ? void 0 : (_goodsList$find = goodsList.find(goods => goods.goodsCode === i.goodsCode)) === null || _goodsList$find === void 0 ? void 0 : _goodsList$find.quotedPriceEndDate) || i.quotedPriceEndDate
              };
            });
            _context7.prev = 1;
            _context7.next = 4;
            return (0,_utils_ypRequest_core__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_12__/* .SUBMIT_PURCHASE_ORDER */ .ZE, {
              param: {
                goodsList: gl
              }
            });

          case 4:
            res = _context7.sent;

            if (!res.success) {
              _context7.next = 13;
              break;
            }

            if (!(res.result.errorInfo && res.result.errorInfo.length > 0)) {
              _context7.next = 10;
              break;
            }

            setError(res.result.errorInfo);
            setErrorTitle(res.result.errorTitle);
            return _context7.abrupt("return");

          case 10:
            antd_es_message__WEBPACK_IMPORTED_MODULE_11__.default.success('确认采购成功');

            closeModalCallback();
            confirmCallback();

          case 13:
            _context7.next = 18;
            break;

          case 15:
            _context7.prev = 15;
            _context7.t0 = _context7["catch"](1);
            console.log('request error ==>', _context7.t0);

          case 18:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[1, 15]]);
  })), [preData]);
  var tableColumns = (0,_useBatchColumns__WEBPACK_IMPORTED_MODULE_5__.default)({
    inputChange,
    inputBlur,
    radioChange
  });
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (error.length > 0) {
      var headers = error[0].row;
      setErrorCloumns(headers.map(header => ({
        title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
          style: {
            fontWeight: 'bold'
          }
        }, header),
        dataIndex: header,
        key: header,
        render: (text, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", null, record[header])
      })));
      var dataSource = error.slice(1).map((row, index) => {
        var rowData = {};
        headers.forEach((header, i) => {
          rowData[header] = row.row[i];
        });
        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({
          key: index
        }, rowData);
      });
      setErrorData(dataSource);
    }
  }, [error]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
    bodyStyle: {
      padding: '0'
    },
    wrapClassName: "goodsPool-modal",
    title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'space-between'
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
      style: {
        display: 'flex'
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "\u6279\u91CF\u91C7\u8D2D"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
      style: {
        marginLeft: '40px',
        fontSize: '14px'
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", null, "\u5171\u8BA1\uFF1A", goodsList === null || goodsList === void 0 ? void 0 : goodsList.length, "\u6761"), "\u2003", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", null, "\u95E8\u5E97\u8981\u8D27\u603B\u91CF\uFF1A", storeReqQtyTotal || '-'), "\u2003", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", null, "\u91C7\u8D2D\u603B\u91CF\uFF1A", (_total$purchaseOrderR = total.purchaseOrderReqTotal) !== null && _total$purchaseOrderR !== void 0 ? _total$purchaseOrderR : '-'), "\u2003", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
      className: "mRight16"
    }, "\u91C7\u8D2D\u603B\u91D1\u989D\uFF1A", (_total$purchaseOrderA = total.purchaseOrderAmountTotal) !== null && _total$purchaseOrderA !== void 0 ? _total$purchaseOrderA : '-', "\u5143"), "\u2003", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
      className: "mRight16"
    }, (goodsList === null || goodsList === void 0 ? void 0 : goodsList.length) > 0 ? "".concat(goodsList[0].placeCode, "-").concat(goodsList[0].placeName) : '-'))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
      style: {
        fontSize: '14px',
        marginRight: '40px',
        color: 'red'
      }
    }, "\u6CE8\u610F\uFF1ABD\u4F9B\u5E94\u5546\u786E\u8BA4\u91C7\u8D2D\u65F6\uFF0C\u4F1A\u88AB\u8FC7\u6EE4\uFF0C\u4E0D\u4EA7\u751F\u91C7\u8D2D\u5355")),
    destroyOnClose: true,
    maskClosable: false,
    width: "99%",
    visible: visible,
    onCancel: closeModalCallback,
    okText: "\u786E\u8BA4\u91C7\u8D2D",
    onOk: confirmPurchase
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_table__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z, {
    className: "goodsPool-table",
    columns: tableColumns,
    scroll: {
      x: 1500,
      y: window.innerHeight - 200
    },
    bordered: true,
    loading: loading,
    pagination: false,
    dataSource: preData,
    rowKey: record => record.placeId + record.expectedDate
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, error.length > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
    title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
      style: {
        fontWeight: 'bold',
        color: 'red'
      }
    }, " ", errorTitle, " "),
    visible: true,
    onCancel: () => setError([]),
    footer: null
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_table__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z, {
    dataSource: errorData,
    pagination: false,
    columns: errorColumns
  }))));
}

/* harmony default export */ __webpack_exports__["default"] = (SummaryModal);

/***/ }),

/***/ 92220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2824);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93224);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46565);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2423);








var _excluded = ["columns", "searchParams", "handleCallback"];




function SupplierTable(props) {
  var columns = props.columns,
      searchParams = props.searchParams,
      handleCallback = props.handleCallback,
      restProps = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(props, _excluded); // 审核


  var handleAudit = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee(r) {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(r.auditName === "未知")) {
                _context.next = 3;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_6__.default.error('请选择审核意见');

              return _context.abrupt("return");

            case 3:
              _context.next = 5;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_7__/* .SUPPLIER_AUDIT */ .xd, {
                param: {
                  quoteOrderNo: r.quoteOrderNo,
                  goodsBarCode: r.goodsBarCode,
                  auditState: r.auditName,
                  auditRemark: r.auditRemark,
                  goodsCode: r.goodsCode,
                  pluCode: r.pluCode,
                  goodsAuditQty: r.goodsAuditQty,
                  auditPrice: r.auditPrice
                }
              });

            case 5:
              res = _context.sent;

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_6__.default.success('审核成功');

                handleCallback(searchParams);
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [handleCallback, searchParams]); // 添加到采购池

  var pushToPurchasePool = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee2(r) {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_7__/* .SUPPLIER_PUSH_TO_PURCHASE */ .SF, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)({}, r));

            case 2:
              res = _context2.sent;

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_6__.default.success('已成功添加到采购池');

                handleCallback(searchParams);
              }

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [handleCallback, searchParams]);
  var tableColumns = [...columns, {
    title: '操作',
    dataIndex: 'snsjs',
    width: 100,
    fixed: 'right',
    render: (t, r) => {
      var dataList = [r.detailBillState === 2 && {
        event: () => handleAudit(r),
        name: '确认审核'
      } // r.auditState === 1 && {
      //   event: () => pushToPurchasePool(r),
      //   name: '添加采购池'
      // }
      ];
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .DropdownMenu */ .h_, {
        dataList: dataList,
        num: 3
      });
    }
  }];
  /**
   * 改变表格内容时，触发保存
   */

  var saveRowCallback = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee3(data) {
      var currentCell, currentRow, currentRowOldData, dataIndex, _i, _Object$entries, _ref6, _ref5, propName, quoteOrderNo, pluCode, goodsBarCode, goodsCode, param, res, _res$result, isArchive;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              currentCell = data.currentCell, currentRow = data.currentRow, currentRowOldData = data.currentRowOldData; // 获取当前修改的单元格名称

              dataIndex = '';

              for (_i = 0, _Object$entries = Object.entries(currentCell); _i < _Object$entries.length; _i++) {
                _ref6 = _Object$entries[_i];
                _ref5 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_ref6, 1);
                propName = _ref5[0];
                dataIndex = propName;
              }

              if (!(dataIndex === 'auditName' || dataIndex === 'auditRemark')) {
                _context3.next = 5;
                break;
              }

              return _context3.abrupt("return");

            case 5:
              if (!(dataIndex === 'goodsAuditQty' && Number(currentRow[dataIndex]) === 0)) {
                _context3.next = 8;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_6__.default.warning('审核量不可为0');

              return _context3.abrupt("return", currentRowOldData);

            case 8:
              if (!(dataIndex === 'purchaseOrderPrice' && Number(currentRow[dataIndex]) === 0)) {
                _context3.next = 11;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_6__.default.warning('采购价不可为0');

              return _context3.abrupt("return", currentRowOldData);

            case 11:
              if (!(dataIndex === 'auditPrice' && Number(currentRow[dataIndex]) === 0)) {
                _context3.next = 14;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_6__.default.warning('审核价不可为0');

              return _context3.abrupt("return", currentRowOldData);

            case 14:
              if (!(dataIndex === 'auditPrice' && Number(currentRow[dataIndex]) > Number(currentRow['netSynthPrice']))) {
                _context3.next = 17;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_6__.default.warning('审核价不可高于报价');

              return _context3.abrupt("return", currentRowOldData);

            case 17:
              // if (dataIndex === 'purchaseOrderPrice' && Number(currentRow[dataIndex]) > Number(currentRow['auditPrice'])) {
              //   message.warning('采购价不可高于审核价/报价')
              //   return currentRowOldData
              // }
              quoteOrderNo = currentRow.quoteOrderNo, pluCode = currentRow.pluCode, goodsBarCode = currentRow.goodsBarCode, goodsCode = currentRow.goodsCode;
              param = {
                quoteOrderNo,
                pluCode,
                goodsBarCode,
                goodsCode,
                needArchive: 1 // 需要分档标识

              };

              if (dataIndex === 'placeName') {
                param['placeId'] = currentRow.placeId;
                param['editKey'] = 'placeId';
              } else {
                param[dataIndex] = currentRow[dataIndex];
                param['editKey'] = dataIndex;
              }

              _context3.next = 22;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .YpRequest */ .XQ)('quote.scm.quoteOrderEdit', {
                param
              });

            case 22:
              res = _context3.sent;

              if (!res.success) {
                _context3.next = 29;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_6__.default.success("\u4FEE\u6539\u6210\u529F");

              isArchive = res === null || res === void 0 ? void 0 : (_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.isArchive;
              return _context3.abrupt("return", (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)({}, currentRow), {}, {
                isArchive
              }));

            case 29:
              return _context3.abrupt("return", currentRowOldData);

            case 30:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }(), []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .EnhanceTable */ .UO, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)({}, restProps, {
    useTool: false,
    columns: tableColumns,
    searchParams: searchParams,
    scroll: {
      y: 600
    },
    saveRowCallback: saveRowCallback,
    rowKey: "unionKey",
    cacheTable: true,
    useVirtual: true
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (SupplierTable);

/***/ }),

/***/ 10103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(57016);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _components_CommonTable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40934);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24731);
/* harmony import */ var _ExportModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4710);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2423);











/**
 * 缺量明细
 */






var UllageModal = props => {
  var handleOnCancelFn = props.handleOnCancelFn,
      searchParams = props.searchParams;
  var table = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState, 2),
      exportModal = _useState2[0],
      setExportModal = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState3, 2),
      modalMsg = _useState4[0],
      setModalMsg = _useState4[1];

  var formatResult = data => {
    setModalMsg({
      unfilledPurchaseOrder: data === null || data === void 0 ? void 0 : data.unfilledPurchaseOrder,
      withoutEnquiryGoods: data === null || data === void 0 ? void 0 : data.withoutEnquiryGoods
    });
    return {
      list: data === null || data === void 0 ? void 0 : data.info,
      total: data === null || data === void 0 ? void 0 : data.total
    };
  };

  var columns = [{
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 160
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 140
  }, {
    title: '商家名称',
    dataIndex: 'merchantName',
    key: 'merchantName',
    width: 160
  }, {
    title: '地点编码',
    dataIndex: 'placeCode',
    key: 'placeCode',
    width: 160
  }, {
    title: '地点名称',
    dataIndex: 'placeName',
    key: 'placeName',
    width: 160
  }, {
    title: '是否询价',
    dataIndex: 'boolEnquiry',
    key: 'boolEnquiry',
    width: 100,
    render: (text, record) => {
      return text === '1' ? '是' : '否';
    }
  }, {
    title: '单位',
    dataIndex: 'basicUnit',
    key: 'basicUnit',
    width: 100
  }, {
    title: '要货量',
    dataIndex: 'applyQty',
    key: 'applyQty',
    width: 100
  }, {
    title: '今日已下单量',
    dataIndex: 'purchaseQty',
    key: 'purchaseQty',
    width: 100
  }, {
    title: '缺量',
    dataIndex: 'deficiencyQty',
    key: 'deficiencyQty',
    width: 120
  }];

  var exportList = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().mark(function _callee() {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_10__/* .deficiencyDetailExport */ .Fo, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({}, props.searchParams));

            case 2:
              res = _context.sent;

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_12__.default.success('导出任务完成，在【导出列表】查看下载');

                setTimeout(() => {
                  setExportModal(true);
                }, 500);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function exportList() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
    title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
      style: {
        display: 'flex'
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "\u7F3A\u91CF\u660E\u7EC6"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
      style: {
        marginLeft: '50px',
        color: '#333333'
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "\u8981\u8D27\u672A\u8BE2\u4EF7\u54C1\u9879\uFF1A", modalMsg.withoutEnquiryGoods), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "\u4E0B\u5355\u672A\u6EE1\u8DB3\u91CF\u54C1\u9879\uFF1A", modalMsg.unfilledPurchaseOrder))),
    destroyOnClose: true,
    width: 800,
    visible: true,
    onCancel: handleOnCancelFn,
    footer: null
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
    type: "primary",
    onClick: exportList,
    style: {
      marginRight: '14px'
    }
  }, "\u5BFC\u51FA"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
    type: "primary",
    onClick: () => setExportModal(true)
  }, "\u5BFC\u51FA\u5217\u8868"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_CommonTable__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    ref: table,
    searchParams: searchParams,
    columns: columns,
    queryDataUrl: 'scm.purchase.quote.deficiencyDetail',
    formatResult: formatResult
  }), exportModal && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ExportModal__WEBPACK_IMPORTED_MODULE_6__.default, {
    businessType: 13,
    closeModalCallback: () => setExportModal(false)
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (UllageModal);

/***/ }),

/***/ 30266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(57016);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _components_CommonTable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40934);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24731);
/* harmony import */ var _ExportModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4710);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2423);











/**
 * 未市调品项
 */






var UnreportedModal = props => {
  var handleOnCancelFn = props.handleOnCancelFn,
      searchParams = props.searchParams;
  var table = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState, 2),
      exportModal = _useState2[0],
      setExportModal = _useState2[1];

  var formatResult = data => {
    return {
      list: data === null || data === void 0 ? void 0 : data.info,
      total: data === null || data === void 0 ? void 0 : data.total
    };
  };

  var columns = [{
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 160
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 140
  }, {
    title: '商家名称',
    dataIndex: 'merchantName',
    key: 'merchantName',
    width: 160
  }, {
    title: '地点编码',
    dataIndex: 'placeCode',
    key: 'placeCode',
    width: 160
  }, {
    title: '地点名称',
    dataIndex: 'placeName',
    key: 'placeName',
    width: 160
  }];

  var exportList = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().mark(function _callee() {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_10__/* .marketInspectionGoodsExport */ .$V, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({}, props.searchParams));

            case 2:
              res = _context.sent;

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_12__.default.success('导出任务完成，在【导出列表】查看下载');

                setTimeout(() => {
                  setExportModal(true);
                }, 500);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function exportList() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
    title: "\u672A\u5E02\u8C03\u54C1\u9879",
    destroyOnClose: true,
    width: 800,
    visible: true,
    onCancel: handleOnCancelFn,
    footer: null
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
    type: "primary",
    onClick: exportList,
    style: {
      marginRight: '14px'
    }
  }, "\u5BFC\u51FA"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
    type: "primary",
    onClick: () => setExportModal(true)
  }, "\u5BFC\u51FA\u5217\u8868"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_CommonTable__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    ref: table,
    searchParams: searchParams,
    columns: columns,
    queryDataUrl: 'scm.quote.marketInspectionGoods',
    formatResult: formatResult
  }), exportModal && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ExportModal__WEBPACK_IMPORTED_MODULE_6__.default, {
    businessType: 12,
    closeModalCallback: () => setExportModal(false)
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (UnreportedModal);

/***/ }),

/***/ 2423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K7": function() { return /* binding */ GOODS_LIST; },
/* harmony export */   "xX": function() { return /* binding */ SUPPLIER_LIST; },
/* harmony export */   "xd": function() { return /* binding */ SUPPLIER_AUDIT; },
/* harmony export */   "SF": function() { return /* binding */ SUPPLIER_PUSH_TO_PURCHASE; },
/* harmony export */   "QY": function() { return /* binding */ GOODS_EXPORT; },
/* harmony export */   "Kj": function() { return /* binding */ ORDER_PRE_PROCESS; },
/* harmony export */   "ZE": function() { return /* binding */ SUBMIT_PURCHASE_ORDER; },
/* harmony export */   "aC": function() { return /* binding */ QUOTE_ORDER_EDIT; },
/* harmony export */   "_U": function() { return /* binding */ QUOTE_P_STOREQEQ_INVENTORY; },
/* harmony export */   "Xz": function() { return /* binding */ ORDER_DETAIL_LINE_REQUEST; },
/* harmony export */   "c": function() { return /* binding */ lookForwardQuoteDetailExport; },
/* harmony export */   "Fo": function() { return /* binding */ deficiencyDetailExport; },
/* harmony export */   "$V": function() { return /* binding */ marketInspectionGoodsExport; },
/* harmony export */   "DE": function() { return /* binding */ REFERENCE_PRICE; }
/* harmony export */ });
// 商品池商品列表
var GOODS_LIST = 'quote.scm.queryQuoteGoodsPool'; // 商品对应的供应商列表

var SUPPLIER_LIST = 'quote.scm.queryQuoteGoodsPoolDetail'; // 审核

var SUPPLIER_AUDIT = 'quote.scm.auditQuoteOrder'; // 添加到采购池

var SUPPLIER_PUSH_TO_PURCHASE = 'scm.purchasePool.savePurchasePool'; // 商品池合并导出

var GOODS_EXPORT = 'quote.scm.exportQuoteGoodsPoolDetail'; // 商品池选品-批量采购预处理

var ORDER_PRE_PROCESS = 'quote.scm.quotePurchaseOrderPreProcess'; // 商品池选品-提交采购单

var SUBMIT_PURCHASE_ORDER = 'quote.scm.quoteBatchSubmitPurchaseOrder'; // 商品池选品-编辑

var QUOTE_ORDER_EDIT = 'quote.scm.quoteOrderEdit'; // 商品池选品-批量采购预处理-门店要货量和库存量查询

var QUOTE_P_STOREQEQ_INVENTORY = 'quote.scm.quotePurchaseStoreReqInventory'; // 商品池选品-批量审核

var ORDER_DETAIL_LINE_REQUEST = 'quote.scm.AuditBatchQuoteOrderDetailLineRequest'; // 未报价供应商明细导出

var lookForwardQuoteDetailExport = 'scm.purchase.quote.lookForwardQuoteDetailExport'; // 缺量明细导出

var deficiencyDetailExport = 'scm.purchase.quote.deficiencyDetailExport'; // 未市调品项导出

var marketInspectionGoodsExport = 'scm.quote.marketInspectionGoodsExport'; // 参考价
// export const REFERENCE_PRICE = 'purchase.purchase.queryPrePurchaseReferencePrice'

var REFERENCE_PRICE = '/scm/purchase/purchase/queryLastPurchaseCost';

/***/ }),

/***/ 92855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ useBatchColumns; }
/* harmony export */ });
/* harmony import */ var antd_es_radio_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88983);
/* harmony import */ var antd_es_radio__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(55742);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8870);
/* harmony import */ var antd_es_input_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47673);
/* harmony import */ var antd_es_input__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4107);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31097);
/* harmony import */ var antd_es_tag_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71153);
/* harmony import */ var antd_es_tag__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(60331);
/* harmony import */ var antd_es_list_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54421);
/* harmony import */ var antd_es_list__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38272);
/* harmony import */ var antd_es_time_picker_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39002);
/* harmony import */ var antd_es_time_picker__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68351);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_8__);
















var listItemStyle = {
  justifyContent: 'center',
  padding: '4px 0px',
  height: '60px'
};
function useBatchColumns(_ref) {
  var inputChange = _ref.inputChange,
      inputBlur = _ref.inputBlur,
      radioChange = _ref.radioChange;
  var purchaseQtyRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(false); // 新增

  var purchaseAmountRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(false); // 新增

  return [// {
  //   title: '地点',
  //   dataIndex: 'placeName',
  //   key: 'placeName',
  //   width: 80,
  //   align: 'center',
  //   fixed: 'left',
  //   render: (t, r) => (
  //     <Tooltip title={t}>
  //       <span style={{
  //         display: 'inline-block',
  //         width: '100%',
  //       }}>{t}</span>
  //     </Tooltip>
  //   ),
  //   shouldCellUpdate: (record: any, prevRecord: any) => !_.isEqual(record, prevRecord)
  // },
  {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 110,
    align: 'center',
    fixed: 'left' // render: (t, r: any) => {
    //   return (
    //     <Tooltip title={t}>
    //       <span>{t}</span>
    //     </Tooltip>
    //   )
    // },

  }, {
    title: '门店要货量',
    dataIndex: 'storeReqQty',
    key: 'storeReqQty',
    fixed: 'left',
    width: 80,
    align: 'center',
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_7___default().isEqual(record, prevRecord)
  }, {
    title: '门店要货件数',
    dataIndex: 'storeReqQty1',
    key: 'storeReqQty1',
    width: 120,
    align: 'center',
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_7___default().isEqual(record, prevRecord),

    render(text, record) {
      var netConversionRatio = record.quoteSuppList && record.quoteSuppList.length > 0 ? record.quoteSuppList[0].netConversionRatio : null;
      if (record.storeReqQty == '0') return '0';
      return record.storeReqQty != null && netConversionRatio != null && netConversionRatio != 0 ? (record.storeReqQty / netConversionRatio).toFixed(1) : '';
    }

  }, {
    title: '库存量',
    dataIndex: 'inventoryQty',
    key: 'inventoryQty',
    width: 90,
    align: 'center',
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_7___default().isEqual(record, prevRecord)
  }, {
    title: '采购小计',
    dataIndex: 'purchaseReqQty',
    key: 'purchaseReqQty',
    width: 80,
    align: 'center',
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_7___default().isEqual(record, prevRecord)
  }, {
    title: '差异量',
    dataIndex: 'differenceQty',
    key: 'differenceQty',
    width: 80,
    align: 'center',
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_7___default().isEqual(record, prevRecord)
  }, {
    title: '单位',
    dataIndex: 'basicUnit',
    key: 'basicUnit',
    width: 70,
    align: 'center',
    ellipsis: true,
    onCell: () => ({
      style: {
        padding: 0
      }
    }),
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_7___default().isEqual(record, prevRecord)
  }, {
    title: '到仓日期',
    dataIndex: 'expectedDate',
    key: 'expectedDate',
    width: 100,
    align: 'center',
    render: (t, r, i) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default */ .ZP, {
        rowKey: "id",
        dataSource: r.quoteSuppList || [],
        renderItem: (item, j) => {
          var dateTime = item !== null && item !== void 0 && item.expectedDate ? moment__WEBPACK_IMPORTED_MODULE_8___default()(item === null || item === void 0 ? void 0 : item.expectedDate) : moment__WEBPACK_IMPORTED_MODULE_8___default()();
          var dateStr = dateTime.format('YYYY-MM-DD');
          var timeStr = dateTime.format('HH:mm');
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default.Item */ .ZP.Item, {
            style: listItemStyle
          }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement("div", {
            style: {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }
          }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement("div", {
            style: {
              fontSize: '12px',
              marginBottom: '2px'
            }
          }, dateStr), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_time_picker__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z, {
            showNow: false,
            format: 'HH:mm',
            value: moment__WEBPACK_IMPORTED_MODULE_8___default()(timeStr, 'HH:mm'),
            onChange: value => {
              if (value) {
                var newDateTime = moment__WEBPACK_IMPORTED_MODULE_8___default()(dateStr + ' ' + value.format('HH:mm'), 'YYYY-MM-DD HH:mm');
                inputChange(newDateTime.format('YYYY-MM-DD HH:mm:ss'), 'expectedDate', i, j);
                inputBlur(item, 'expectedDate');
              }
            },
            style: {
              width: '100px'
            },
            size: "small"
          })));
        }
      });
    }
  }, {
    title: '供应商',
    dataIndex: 'suppName',
    key: 'suppName',
    width: 100,
    align: 'center',
    // ellipsis: true,
    render: (t, r) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default */ .ZP, {
        rowKey: "id",
        dataSource: r.quoteSuppList || [],
        renderItem: item => {
          var _r$quoteSuppList$;

          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default.Item */ .ZP.Item, {
            style: listItemStyle
          }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z, {
            title: item.suppName
          }, item.bdSupplierFlag === 1 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_tag__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
            style: {
              position: 'absolute',
              top: '-9px',
              right: '5px'
            },
            color: "#1890ff"
          }, "BD") : item.lastPurchasePriceQty ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_tag__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
            style: {
              position: 'absolute',
              top: '-9px',
              right: '5px'
            },
            color: "#1890ff"
          }, "\u4E0A\u6B21\u91C7\u8D2D") : null, (r === null || r === void 0 ? void 0 : (_r$quoteSuppList$ = r.quoteSuppList[0]) === null || _r$quoteSuppList$ === void 0 ? void 0 : _r$quoteSuppList$.enquiryOrderType) !== 1 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_tag__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
            color: "volcano",
            style: {
              fontSize: '10px',
              padding: '0px 4px',
              lineHeight: '12px',
              position: 'absolute',
              top: '-7px',
              left: '5px'
            }
          }, "\u9884\u8BA2\u5355"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement("span", null, item.suppName)));
        }
      });
    },
    onCell: () => ({
      style: {
        padding: 0
      }
    }),
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_7___default().isEqual(record, prevRecord)
  }, {
    title: '产地',
    dataIndex: 'placeOriginName',
    key: 'placeOriginName',
    width: 80,
    render: (t, r) => {
      var _r$quoteSuppList$2;

      console.log(r, '产地');
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(react__WEBPACK_IMPORTED_MODULE_6__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z, {
        title: t
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement("span", null, r === null || r === void 0 ? void 0 : (_r$quoteSuppList$2 = r.quoteSuppList[0]) === null || _r$quoteSuppList$2 === void 0 ? void 0 : _r$quoteSuppList$2.placeOriginName)));
    }
  }, {
    title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement("span", {
      style: {
        display: 'block'
      }
    }, "\u4E0A\u6B21"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement("span", {
      style: {
        display: 'block'
      }
    }, "\u62A5\u4EF7")),
    dataIndex: 'lastQuoteAmountQty',
    key: 'lastQuoteAmountQty',
    width: 60,
    align: 'center',
    ellipsis: true,
    render: (t, r) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default */ .ZP, {
        dataSource: r.quoteSuppList || [],
        renderItem: item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default.Item */ .ZP.Item, {
          style: listItemStyle
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement("div", null, item.lastQuoteAmountQty))
      });
    },
    onCell: () => ({
      style: {
        padding: 0
      }
    })
  }, {
    title: '最新入库价',
    dataIndex: 'referencePrice',
    key: 'referencePrice',
    width: 120,
    align: 'center',
    render: (t, r) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default */ .ZP, {
        dataSource: r.quoteSuppList || [],
        renderItem: item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default.Item */ .ZP.Item, {
          style: listItemStyle
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement("div", null, item.referencePrice))
      });
    },
    onCell: () => ({
      style: {
        padding: 0
      }
    })
  }, {
    title: '报价',
    dataIndex: 'quotePrice',
    key: 'quotePrice',
    width: 60,
    align: 'center',
    render: (t, r) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default */ .ZP, {
        rowKey: "id",
        dataSource: r.quoteSuppList || [],
        renderItem: item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default.Item */ .ZP.Item, {
          style: listItemStyle
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement("div", null, item.quotePrice))
      });
    },
    onCell: () => ({
      style: {
        padding: 0
      }
    }),
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_7___default().isEqual(record, prevRecord)
  }, {
    title: '采购价',
    dataIndex: 'purchasePrice',
    key: 'purchasePrice',
    width: 100,
    align: 'center',
    ellipsis: true,
    render: (t, r, i) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default */ .ZP, {
        rowKey: "id",
        dataSource: r.quoteSuppList || [],
        renderItem: (item, j) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default.Item */ .ZP.Item, {
          style: listItemStyle
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
          onChange: e => inputChange(e.target.value, 'purchasePrice', i, j),
          style: {
            width: '90%'
          },
          value: item.purchasePrice,
          onBlur: e => inputBlur(item, 'purchasePrice'),
          disabled: item.purchasePrice === '******'
        }))
      });
    },
    onCell: () => ({
      style: {
        padding: 0
      }
    })
  }, {
    title: '可供量',
    dataIndex: 'goodsAvailQty',
    key: 'goodsAvailQty',
    width: 90,
    align: 'center',
    ellipsis: true,
    render: (t, r) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default */ .ZP, {
        rowKey: "id",
        dataSource: r.quoteSuppList || [],
        renderItem: item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default.Item */ .ZP.Item, {
          style: listItemStyle
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement("div", null, item.goodsAvailQty))
      });
    },
    onCell: () => ({
      style: {
        padding: 0
      }
    }),
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_7___default().isEqual(record, prevRecord)
  }, // {
  //   title: '审核量',
  //   dataIndex: 'goodsAuditQty',
  //   key: 'goodsAuditQty',
  //   width: 90,
  //   align: 'center',
  //   ellipsis: true,
  //   render: (t, r) => {
  //     return (
  //       <List
  //         rowKey='id'
  //         dataSource={r.quoteSuppList || []}
  //         renderItem={(item: any) => (
  //           <List.Item style={listItemStyle}>
  //             <div>{item.goodsAuditQty}</div>
  //           </List.Item>
  //         )}
  //       />
  //     )
  //   },
  //   onCell: () => ({ style: { padding: 0 } }),
  //   shouldCellUpdate: (record: any, prevRecord: any) => !_.isEqual(record, prevRecord)
  // },
  {
    title: '规格(净)',
    dataIndex: 'netConversionRatio',
    key: 'netConversionRatio',
    width: 90,
    align: 'center',
    ellipsis: true,
    render: (t, r, i) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default */ .ZP, {
        rowKey: "id",
        dataSource: r.quoteSuppList || [],
        renderItem: (item, j) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default.Item */ .ZP.Item, {
          style: listItemStyle
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
          onBlur: e => inputBlur(item, 'netConversionRatio'),
          onChange: e => inputChange(e.target.value, 'netConversionRatio', i, j),
          style: {
            width: '60%',
            marginRight: '5px'
          },
          value: item.netConversionRatio
        }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement("span", null, " ", r.basicUnit + '/件'))
      });
    },
    onCell: () => ({
      style: {
        padding: 0
      }
    })
  }, {
    title: '采购量',
    dataIndex: 'purchaseQty',
    key: 'purchaseQty',
    width: 100,
    align: 'center',
    ellipsis: true,
    render: (t, r, i) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default */ .ZP, {
        rowKey: "id",
        dataSource: r.quoteSuppList || [],
        renderItem: (item, j) => {
          // console.log(r, '采购量', r?.quoteSuppList[0]?.isMinPrice, 'item.purchaseQty', item.purchaseQty)
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default.Item */ .ZP.Item, {
            style: listItemStyle
          }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
            onBlur: e => inputBlur(item, 'purchaseQty'),
            onChange: e => {
              inputChange(e.target.value, 'purchaseQty', i, j);
              purchaseQtyRef.current = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, purchaseQtyRef.current), {}, {
                [item.goodsCode]: true
              });
              purchaseAmountRef.current = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, purchaseAmountRef.current), {}, {
                [item.goodsCode]: true
              });
            },
            style: {
              width: '90%'
            },
            value: item.purchaseQty //  value={item?.isMinPrice&&!purchaseQtyRef.current[item.goodsCode]? (Number(item.purchaseQty) > 0 || Number(r?.differenceQty) < 0 ? item.purchaseQty : r?.differenceQty) : item.purchaseQty}

          }));
        }
      });
    },
    onCell: () => ({
      style: {
        padding: 0
      }
    })
  }, {
    title: '采购件数',
    dataIndex: 'purchaseQty1',
    key: 'purchaseQty1',
    width: 100,
    align: 'center',
    ellipsis: true,
    render: (t, r, i) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default */ .ZP, {
        rowKey: "id",
        dataSource: r.quoteSuppList || [],
        renderItem: (item, j) => {
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default.Item */ .ZP.Item, {
            style: listItemStyle
          }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
            onBlur: e => inputBlur(item, 'purchaseQty1'),
            onChange: e => {
              inputChange(e.target.value, 'purchaseQty1', i, j);
              purchaseQtyRef.current = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, purchaseQtyRef.current), {}, {
                [item.goodsCode]: true
              });
              purchaseAmountRef.current = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, purchaseAmountRef.current), {}, {
                [item.goodsCode]: true
              });
            },
            style: {
              width: '90%'
            },
            value: item.purchaseQty1
          }));
        }
      });
    },
    onCell: () => ({
      style: {
        padding: 0
      }
    })
  }, {
    title: '采购总金额',
    dataIndex: 'purchaseAmount',
    key: 'purchaseAmount',
    width: 130,
    align: 'center',
    ellipsis: true,
    render: (t, r, i) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default */ .ZP, {
        rowKey: "id",
        dataSource: r.quoteSuppList || [],
        renderItem: (item, j) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default.Item */ .ZP.Item, {
          style: listItemStyle
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
          onBlur: e => inputBlur(item, 'purchaseAmount'),
          onChange: e => {
            inputChange(e.target.value, 'purchaseAmount', i, j);
            purchaseAmountRef.current = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, purchaseAmountRef.current), {}, {
              [item.goodsCode]: true
            });
            purchaseQtyRef.current = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, purchaseQtyRef.current), {}, {
              [item.goodsCode]: true
            });
          },
          style: {
            width: '90%'
          },
          value: item.purchaseAmount,
          disabled: item.purchaseAmount === '******' // value={item?.isMinPrice&&!purchaseAmountRef.current[item.goodsCode] ?
          //   (Number(item.purchaseAmount) > 0 ?
          //     item.purchaseAmount :
          //     Number(
          //       ((Number(r?.differenceQty) < 0 ?
          //           (item.purchaseQty * item.purchasePrice * 1000) :
          //           (r?.differenceQty * item.purchasePrice * 1000)
          //         )
          //         / 1000).toFixed(3)
          //     )
          //   ) : item.purchaseAmount}

        }))
      });
    },
    onCell: () => ({
      style: {
        padding: 0
      }
    })
  }, {
    title: '操作',
    dataIndex: 'acion',
    key: 'acion',
    fixed: 'right',
    width: 60,
    render: (t, r, i) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default */ .ZP, {
        dataSource: r.quoteSuppList || [],
        renderItem: (item, j) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_list__WEBPACK_IMPORTED_MODULE_9__/* .default.Item */ .ZP.Item, {
          style: listItemStyle
        }, item.bdSupplierFlag === 1 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_15__/* .default.Group */ .ZP.Group, {
          value: item.bdPushedFlag,
          onChange: e => radioChange(item, e.target.value, 'bdPushedFlag')
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_15__/* .default */ .ZP, {
          value: 1
        }, "\u63A8\u9001BD")) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_15__/* .default.Group */ .ZP.Group, {
          value: item.undeterminedFlag,
          onChange: e => radioChange(item, e.target.value, 'undeterminedFlag')
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_15__/* .default */ .ZP, {
          value: 1
        }, "\u5F85\u5B9A")))
      });
    }
  }];
}

/***/ }),

/***/ 40707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ useSupplierColumns; }
/* harmony export */ });
/* harmony import */ var antd_es_badge_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54029);
/* harmony import */ var antd_es_badge__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(62529);
/* harmony import */ var antd_es_tag_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71153);
/* harmony import */ var antd_es_tag__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(60331);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2824);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7704);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46565);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96534);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_6__);













var statusColor = new Map([[2, 'warning'], [3, 'processing'], [4, 'default']]);
function useSupplierColumns(fixedSupper) {
  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)([_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["商品池审核状态"] */ .M["商品池审核状态"], _hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["商品池审核意见"] */ .M["商品池审核意见"]]),
      mappingList = _useMapping.mappingList;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState, 2),
      merchantId = _useState2[0],
      setMerchantId = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_useState3, 2),
      placeList = _useState4[0],
      setPlaceList = _useState4[1]; // 以merchantId为key，存储请求来的placeList数据


  var searchPlacesWithMerchant = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().mark(function _callee(merchantId) {
      var result, list, ps, newP;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!Object.keys(placeList).includes(merchantId)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .YpRequest */ .XQ)('purchase.basic.placeListByMerchant', {
                param: {
                  merchantId
                }
              });

            case 4:
              result = _context.sent;

              if (result.success) {
                list = result.result.list || [];
                ps = list.map(p => ({
                  value: p.placeId + '&&' + p.placeCode + '&&' + p.placeName,
                  label: p.placeCode + '-' + p.placeName
                }));
                newP = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)({}, placeList);
                newP[merchantId] = ps;
                setPlaceList(newP);
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function searchPlacesWithMerchant(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (merchantId) {
      searchPlacesWithMerchant(merchantId);
    }
  }, [merchantId]);
  return [// {
  //   title: '编码',
  //   dataIndex: 'goodsCode',
  //   key: 'goodsCode',
  //   ellipsis: true,
  //   width: 120,
  //   shouldCellUpdate: (record, prevRecord) => !_.isEqual(record, prevRecord)
  // },
  // {
  //   title: 'plu',
  //   dataIndex: 'pluCode',
  //   key: 'pluCode',
  //   ellipsis: true,
  //   width: 60,
  //   shouldCellUpdate: (record, prevRecord) => !_.isEqual(record, prevRecord)
  // },
  {
    title: '联系人',
    dataIndex: 'liaisonPerson',
    key: 'liaisonPerson',
    ellipsis: true,
    width: 120,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '联系电话',
    dataIndex: 'phoneNumber',
    ellipsis: true,
    key: 'phoneNumber',
    width: 120,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '类型',
    dataIndex: 'quoteOrderTypeName',
    key: 'quoteOrderTypeName',
    ellipsis: true,
    width: 100,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '单号',
    dataIndex: 'quoteOrderNo',
    key: 'quoteOrderNo',
    ellipsis: true,
    width: 60,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, // {
  //   title: '发布时间',
  //   dataIndex: 'gmtPublish',
  //   ellipsis: true,
  //   key: 'gmtPublish',
  //   width: 160,
  //   sorter: true
  // },
  {
    title: '报价截止时间',
    dataIndex: 'quotedPriceEndDate',
    key: 'quotedPriceEndDate',
    ellipsis: true,
    width: 60,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, // {
  //   title: '期望/可交货时间',
  //   dataIndex: 'expectedDate',
  //   key: 'expectedDate',
  //   ellipsis: true,
  //   width: 60
  // },
  // {
  //   title: '价格生效时间',
  //   dataIndex: 'effectStartDate',
  //   key: 'effectStartDate',
  //   // ellipsis: true,
  //   width: 200,
  //   render: (t, r) => {
  //     if (r.effectEndDate) {
  //       let start = t.split(' ')
  //       let end = r.effectEndDate.split(' ')
  //       // console.log("🚀 ~ file: useSupplierColumns.tsx ~ line 115 ~ useSupplierColumns ~ start", start)
  //       return (
  //         <div>
  //           {start[0]}-{end[0]}
  //         </div>
  //       )
  //     }
  //     return t
  //   }
  // },
  {
    title: '交货地点',
    dataIndex: 'merchantName',
    key: 'merchantName',
    width: 160,
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '供应商名称',
    dataIndex: 'suppName',
    key: 'suppName',
    width: 190,
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord) // sorter: true,
    // fixed: 'left'

  }, {
    title: '供应商编码',
    dataIndex: 'suppCode',
    key: 'suppCode',
    ellipsis: true,
    sorter: true,
    width: 120,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '产地',
    dataIndex: 'placeOriginName',
    key: 'placeOriginName',
    width: 80,
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '到仓时期',
    dataIndex: 'expectedDate',
    key: 'expectedDate',
    width: 120,
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '交货仓库编码',
    dataIndex: 'placeCode',
    key: 'placeCode',
    width: 120,
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '交货仓库',
    dataIndex: 'placeName',
    key: 'placeName',
    width: 200,
    type: r => (r.detailBillState === 2 || r.detailBillState === 3) && !r.purchaseOrderNo ? 'SELECT' : undefined,
    dataList: t => placeList[t === null || t === void 0 ? void 0 : t.merchantId],
    setCellRowValue: function () {
      var _setCellRowValue = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().mark(function _callee2(record, o) {
        var idAndCode;
        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                idAndCode = o.value && o.value.split('&&');
                return _context2.abrupt("return", (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)({}, record), {}, {
                  placeId: idAndCode[0],
                  placeCode: idAndCode[1],
                  placeName: o.rows.label
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function setCellRowValue(_x2, _x3) {
        return _setCellRowValue.apply(this, arguments);
      }

      return setCellRowValue;
    }(),
    fieldOptions: (t, r) => {
      return {
        onFocus: () => {
          setMerchantId(t === null || t === void 0 ? void 0 : t.merchantId);
        },
        filterOption: (input, option) => {
          var _option$children;

          return ((_option$children = option === null || option === void 0 ? void 0 : option.children) !== null && _option$children !== void 0 ? _option$children : '').toLowerCase().includes(input.toLowerCase());
        }
      };
    }
  }, {
    title: '单位',
    dataIndex: 'basicUnit',
    key: 'basicUnit',
    width: 60,
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '需求量',
    dataIndex: 'goodsReqQty',
    key: 'goodsReqQty',
    width: 60,
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '可供量',
    dataIndex: 'goodsAvailQty',
    key: 'goodsAvailQty',
    width: 60,
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '审核量',
    dataIndex: 'goodsAuditQty',
    key: 'goodsAuditQty',
    width: 120,
    type: r => r.detailBillState === 2 ? 'INPUT' : undefined,
    fieldOptions: t => {
      // 商品属性 称重商品保留三位小数
      var isWeight = +t.isWeigh === 1;
      return {
        formatter: value => isWeight ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_5__/* .exchageToNum3 */ .hY)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_5__/* .exchageToNum1 */ .Ly)(value)
      };
    },
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '报价类型',
    dataIndex: 'requireType',
    key: 'requireType',
    width: 80,
    render: (t, r) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, t === 2 ? '含税' : '不含税');
    },
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '审核价',
    dataIndex: 'auditPrice',
    key: 'auditPrice',
    width: 120,
    type: r => r.detailBillState === 2 && r.auditPrice !== '******' ? 'INPUT' : undefined,
    fieldOptions: () => {
      return {
        formatter: value => (0,_utils_common__WEBPACK_IMPORTED_MODULE_5__/* .exchageToNum3 */ .hY)(value)
      };
    },
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '报价(净重)',
    dataIndex: 'netSynthPrice',
    key: 'netSynthPrice',
    width: 110,
    render: (t, r) => {
      if (r.recommendFlag && r.recommendFlag === 1) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, t, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tag__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z, {
          color: "green",
          style: {
            marginLeft: '5px'
          }
        }, "\u63A8\u8350"));
      }

      return t;
    },
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '规格(净重)',
    dataIndex: 'conversionRatio',
    key: 'conversionRatio',
    width: 80,
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '可供价(毛重)',
    dataIndex: 'grossSynthPrice',
    key: 'grossSynthPrice',
    width: 60,
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '规格(毛重)',
    dataIndex: 'grossConversionRatio',
    key: 'grossConversionRatio',
    width: 60,
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '区间最低价',
    dataIndex: 'minPrice',
    key: 'minPrice',
    width: 60,
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '采购量',
    dataIndex: 'purchaseOrderQty',
    key: 'purchaseOrderQty',
    width: 60,
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '采购价',
    dataIndex: 'purchaseOrderPrice',
    key: 'purchaseOrderPrice',
    width: 120,
    type: r => (r.detailBillState === 2 || r.detailBillState === 3) && !r.purchaseOrderNo && r.purchaseOrderPrice !== '******' ? 'INPUT' : undefined,
    fieldOptions: (t, r) => {
      return {
        formatter: value => (0,_utils_common__WEBPACK_IMPORTED_MODULE_5__/* .exchageToNum3 */ .hY)(value)
      };
    },
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '采购单号',
    dataIndex: 'purchaseOrderNo',
    key: 'purchaseOrderNo',
    width: 180,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord) // render: (t: any, r: any) => {
    //   // 详情页面
    //   const url = `/Purchase/Purchase/Detail?purchaseOrderNo=${t}`
    //   return (
    //     <a href={url} >
    //       {t}
    //     </a>
    //   )
    // }

  }, {
    title: '建议售价',
    dataIndex: 'salePrice',
    key: 'salePrice',
    width: 60,
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '产地',
    dataIndex: 'placeOrigin',
    key: 'placeOrigin',
    width: 60,
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '保质天数',
    dataIndex: 'expiryDay',
    key: 'expiryDay',
    width: 60,
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '储存属性',
    dataIndex: 'saveTypeName',
    key: 'saveTypeName',
    width: 60,
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
    width: 60,
    ellipsis: true,
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '状态',
    dataIndex: 'detailBillStateName',
    key: 'detailBillStateName',
    width: 90,
    fixed: 'right',
    render: (t, r) => {
      if (r.detailBillState) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_badge__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
          status: statusColor.get(r.detailBillState)
        }), t);
      }

      return t;
    },
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '审核',
    dataIndex: 'auditName',
    key: 'auditName',
    width: 100,
    fixed: 'right',
    type: r => r.detailBillState === 2 ? 'SELECT' : undefined,
    dataList: mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["商品池审核状态"] */ .M["商品池审核状态"]),
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }, {
    title: '审核意见',
    dataIndex: 'auditRemark',
    key: 'auditRemark',
    width: 100,
    fixed: 'right',
    type: r => r.detailBillState === 2 ? 'SELECT' : undefined,
    dataList: mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["商品池审核意见"] */ .M["商品池审核意见"]),
    shouldCellUpdate: (record, prevRecord) => !lodash__WEBPACK_IMPORTED_MODULE_6___default().isEqual(record, prevRecord)
  }];
}

/***/ }),

/***/ 48338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(57016);
/* harmony import */ var antd_es_input_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47673);
/* harmony import */ var antd_es_input__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(4107);
/* harmony import */ var antd_es_row_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13062);
/* harmony import */ var antd_es_row__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(71230);
/* harmony import */ var antd_es_cascader_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36877);
/* harmony import */ var antd_es_cascader__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(34366);
/* harmony import */ var antd_es_col_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89032);
/* harmony import */ var antd_es_col__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(15746);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(31097);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(3182);
/* harmony import */ var antd_es_form_style__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9715);
/* harmony import */ var antd_es_form__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(35845);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(2824);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34041);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7704);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71720);
/* harmony import */ var _utils_fetchQuery__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48344);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(46565);
/* harmony import */ var _hooks_useCategoryWholeData__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(61982);




























var Option = antd_es_select__WEBPACK_IMPORTED_MODULE_14__/* .default.Option */ .Z.Option;
var unitList = [{
  label: 'kg',
  value: 'kg'
}, {
  label: '包',
  value: '包'
}, {
  label: '瓶',
  value: '瓶'
}, {
  label: '袋',
  value: '袋'
}, {
  label: '盒',
  value: '盒'
}, {
  label: '箱',
  value: '箱'
}, {
  label: '件',
  value: '件'
}, {
  label: '支',
  value: '支'
}, {
  label: '罐',
  value: '罐'
}, {
  label: '条',
  value: '条'
}, {
  label: '份',
  value: '份'
}, {
  label: '桶',
  value: '桶'
}, {
  label: '杯',
  value: '杯'
}, {
  label: '只',
  value: '只'
}, {
  label: '盆',
  value: '盆'
}, {
  label: '把',
  value: '把'
}, {
  label: '双',
  value: '双'
}, {
  label: '提',
  value: '提'
}, {
  label: '套',
  value: '套'
}, {
  label: '根',
  value: '根'
}, {
  label: '块',
  value: '块'
}, {
  label: '排',
  value: '排'
}, {
  label: '捆',
  value: '捆'
}, {
  label: '张',
  value: '张'
}, {
  label: '板',
  value: '板'
}, {
  label: '卷',
  value: '卷'
}, {
  label: '片',
  value: '片'
}, {
  label: '听',
  value: '听'
}, {
  label: '打',
  value: '打'
}, {
  label: '组',
  value: '组'
}, {
  label: '碗',
  value: '碗'
}, {
  label: '台',
  value: '台'
}, {
  label: '串',
  value: '串'
}, {
  label: '个',
  value: '个'
}, {
  label: '卡',
  value: '卡'
}, {
  label: '筒',
  value: '筒'
}, {
  label: '本',
  value: '本'
}, {
  label: '副',
  value: '副'
}, {
  label: '米',
  value: '米'
}, {
  label: '壶',
  value: '壶'
}, {
  label: '筐',
  value: '筐'
}];
/* harmony default export */ __webpack_exports__["default"] = (_ref => {
  var _requireRef$current;

  var open = _ref.open,
      setFromBoolean = _ref.setFromBoolean,
      setDataSource = _ref.setDataSource,
      dataSource = _ref.dataSource,
      editInquiryData = _ref.editInquiryData,
      requireRef = _ref.requireRef,
      editKey = _ref.editKey;
  console.log(editInquiryData, '编辑的时候的值', (_requireRef$current = requireRef.current) === null || _requireRef$current === void 0 ? void 0 : _requireRef$current.getFieldsValue());

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)([91, 92]),
      mappingList = _useMapping.mappingList;

  var goodsPackageIdList = (0,react__WEBPACK_IMPORTED_MODULE_9__.useMemo)(() => mappingList.get(91), [mappingList]);
  var goodsGradeIdList = (0,react__WEBPACK_IMPORTED_MODULE_9__.useMemo)(() => mappingList.get(92), [mappingList]);
  console.log(goodsGradeIdList, '商品等级'); // 品类数据

  var categoryList = (0,_hooks_useCategoryWholeData__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)(2);
  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_15__/* .useDispatch */ .I0)();

  var _Form$useForm = antd_es_form__WEBPACK_IMPORTED_MODULE_16__/* .default.useForm */ .Z.useForm(),
      _Form$useForm2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)(_Form$useForm, 1),
      form = _Form$useForm2[0]; // 询价对象是否存在


  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)(_useState, 2),
      inquiryBoolean = _useState2[0],
      setInquiryBoolean = _useState2[1]; // 询价对象数据


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)(_useState3, 2),
      suppCodeList = _useState4[0],
      setSuppCodeList = _useState4[1]; // 商品下拉选择的数据


  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)([]),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)(_useState5, 2),
      commodityCode = _useState6[0],
      setCommodityCode = _useState6[1]; // 商品名称导入


  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)([]),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)(_useState7, 2),
      commodityNameData = _useState8[0],
      setCommodityNameData = _useState8[1]; // 所属品类是否可选


  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)(_useState9, 2),
      styleType = _useState10[0],
      setStyleType = _useState10[1]; // 判断选择是输入的还是后端查询到的
  // 商品码


  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false),
      _useState12 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)(_useState11, 2),
      queryName = _useState12[0],
      setQueryName = _useState12[1];

  var _useState13 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false),
      _useState14 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)(_useState13, 2),
      queryCode = _useState14[0],
      setQueryCode = _useState14[1]; // 每个商品对应不同商家


  var _useState15 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(),
      _useState16 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)(_useState15, 2),
      merchantIdDatas = _useState16[0],
      setMerchantIdData = _useState16[1]; // 是否带出包装


  var _useState17 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false),
      _useState18 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)(_useState17, 2),
      basicUnitBoole = _useState18[0],
      setBasicUnit = _useState18[1]; // 规格 拼接的显示


  var _useState19 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(''),
      _useState20 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)(_useState19, 2),
      conversionRatioDes = _useState20[0],
      setConversionRatioDes = _useState20[1]; // 获取供应商数据


  var querySupplier = (0,react__WEBPACK_IMPORTED_MODULE_9__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)().mark(function _callee(value) {
      var list, formatList;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch({
                type: 'purchase/querySupplierBaseInfoPage',
                payload: {
                  page: 1,
                  size: 10,
                  supplierCategory: 1,
                  supplierStatus: 1,
                  supplierName: value
                }
              });

            case 2:
              list = _context.sent;
              formatList = list.map(v => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(Option, {
                key: v.supplierCode,
                value: "".concat(v.supplierCode, "&&").concat(v.supplierName)
              }, "".concat(v.supplierCode, "-").concat(v.supplierName)));
              setSuppCodeList(formatList);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [dispatch]);
  var editinitialValuesCallBack = (0,react__WEBPACK_IMPORTED_MODULE_9__.useCallback)(() => {
    //  console.log(editInquiryData, '编辑的时候的值')
    if (editInquiryData) {
      if (editInquiryData && editInquiryData.enquiryType === '2') {
        setInquiryBoolean(false);
      } else {
        setInquiryBoolean(true);
      }

      setConversionRatioDes(editInquiryData.basicUnit + '/件');
      form.setFieldsValue((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)({}, editInquiryData));
    }
  }, [editInquiryData]);
  (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(() => {
    var _requireRef$current2, _requireRef$current2$;

    querySupplier(); // 设置默认值

    editinitialValuesCallBack();
    var merchantIdData = (_requireRef$current2 = requireRef.current) === null || _requireRef$current2 === void 0 ? void 0 : (_requireRef$current2$ = _requireRef$current2.getFieldsValue().merchantId) === null || _requireRef$current2$ === void 0 ? void 0 : _requireRef$current2$.split('&&');
    setMerchantIdData(merchantIdData);
  }, []);

  var handleChange = (newValue, type) => {
    // console.log(newValue, '选择之后的值', type)
    var codeData = newValue.split('&&'); // console.log(codeData, 'newValue')

    if (type === 'goodsCode') {
      if (codeData[4] !== 'undefined' && codeData[5] !== 'undefined') {
        form.setFieldsValue({
          goodsName: codeData[3],
          category: [Number(codeData[4]), Number(codeData[5])]
        });
        setStyleType(true);
      } else {
        if (queryName) {
          form.setFieldsValue({
            category: null
          });
        } else {
          form.setFieldsValue({
            goodsName: null,
            category: null
          });
        }

        setStyleType(false);
      }

      if (codeData[6] !== 'undefined') {
        form.setFieldsValue({
          basicUnit: codeData[6]
        });
        setConversionRatioDes(codeData[6] + '/件');
        setBasicUnit(true);
      } else {
        form.setFieldsValue({
          basicUnit: null
        });
        setConversionRatioDes('');
        setBasicUnit(false);
      }
    } else if (type === 'goodsName') {
      if (codeData[4] !== 'undefined' && codeData[5] !== 'undefined') {
        form.setFieldsValue({
          goodsCode: codeData[0],
          category: [Number(codeData[4]), Number(codeData[5])]
        });
        setStyleType(true);
      } else {
        if (queryCode) {
          form.setFieldsValue({
            category: null
          });
        } else {
          form.setFieldsValue({
            goodsCode: null,
            category: null
          });
        }

        setStyleType(false);
      }

      if (codeData[6] !== 'undefined') {
        form.setFieldsValue({
          basicUnit: codeData[6]
        });
        setConversionRatioDes(codeData[6] + '/件');
        setBasicUnit(true);
      } else {
        form.setFieldsValue({
          basicUnit: null
        });
        setConversionRatioDes('');
        setBasicUnit(false);
      }
    }

    packingQuery(codeData);
  }; // 商品编码输入调接口


  var handleSearch = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)().mark(function _callee2(newValue, type) {
      var result, data, _data;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!newValue) {
                _context2.next = 5;
                break;
              }

              _context2.next = 3;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_12__/* .YpRequest */ .XQ)('purchase.scm.productInfoPageInfo', {
                page: 1,
                size: 30,
                param: {
                  merchatId: merchantIdDatas[0],
                  keyword: newValue,
                  fuzzy: true
                }
              });

            case 3:
              result = _context2.sent;

              if (result.success) {
                if (type === 'goodsCode') {
                  if (result.result.list.length > 0) {
                    setCommodityCode([...result.result.list]);
                    setQueryCode(false);
                  } else {
                    data = [{
                      goodsCode: newValue,
                      goodsName: '输入的值'
                    }];
                    setCommodityCode([...data]);
                    setQueryCode(true);
                  }
                } else if (type === 'goodsName') {
                  if (result.result.list.length > 0) {
                    setCommodityNameData([...result.result.list]);
                    setQueryName(false);
                  } else {
                    _data = [{
                      goodsCode: newValue,
                      goodsName: '输入的值'
                    }];
                    setCommodityNameData([..._data]);
                    setQueryName(true);
                  }
                }
              } else {
                setCommodityCode([]);
                setCommodityNameData([]);
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSearch(_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }(); // 设置包装等级默认值


  var packingQuery = /*#__PURE__*/function () {
    var _ref4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)().mark(function _callee3(value) {
      var _requireRef$current3;

      var _requireRef$current$g, placeId, params, res, _res$result$result, _res$result$result2, _res$result$result3, _res$result$result4;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _requireRef$current$g = (_requireRef$current3 = requireRef.current) === null || _requireRef$current3 === void 0 ? void 0 : _requireRef$current3.getFieldsValue(), placeId = _requireRef$current$g.placeId; // const goodsCodeValue = form.getFieldValue('goodsCode');
              // let codeData = goodsCodeValue?goodsCodeValue.split('&&'):null
              // console.log(value, '选择获取的值',placeId,merchantIdDatas![0])

              params = {
                merchantId: merchantIdDatas[0] ? Number(merchantIdDatas[0]) : 0,
                // 商家id
                placeId: placeId ? Number(placeId) : null,
                // 地点id
                firstCateId: value[4] && Number(value[4]) ? Number(value[4]) : null,
                secondCateId: value[5] && Number(value[5]) ? Number(value[5]) : null,
                goodsId: value[0] && Number(value[0]) ? Number(value[0]) : null
              };
              _context3.next = 4;
              return (0,_utils_fetchQuery__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)('/scm/enquiry/queryFreshReplenishment', 'POST', params);

            case 4:
              res = _context3.sent;

              if (res.success) {
                console.log(res.result, '返回的包装等级');

                if ((_res$result$result = res.result.result) !== null && _res$result$result !== void 0 && _res$result$result.goodsPackageId) {
                  form.setFieldsValue({
                    goodsPackageId: res.result.result.goodsPackageId
                  });
                }

                if ((_res$result$result2 = res.result.result) !== null && _res$result$result2 !== void 0 && _res$result$result2.goodsGradeId) {
                  form.setFieldsValue({
                    goodsGradeId: res.result.result.goodsGradeId
                  });
                }

                if ((_res$result$result3 = res.result.result) !== null && _res$result$result3 !== void 0 && _res$result$result3.qualityDesc) {
                  form.setFieldsValue({
                    specDesc: res.result.result.qualityDesc
                  });
                }

                if ((_res$result$result4 = res.result.result) !== null && _res$result$result4 !== void 0 && _res$result$result4.conversionRatio) {
                  form.setFieldsValue({
                    netConversionRatio: res.result.result.conversionRatio
                  });
                }
              }

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function packingQuery(_x4) {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_21__/* .default */ .Z, {
    visible: open,
    title: "".concat(editInquiryData ? '编辑' : '新增', "\u8BE2\u4EF7\u5546\u54C1"),
    okText: "\u786E\u5B9A",
    cancelText: "\u53D6\u6D88",
    mask: false,
    maskClosable: false,
    width: 680,
    onOk: () => {
      form.validateFields().then(values => {
        if (+values.netConversionRatio === 0) {
          antd_es_message__WEBPACK_IMPORTED_MODULE_22__.default.error('规格不可以为0！');

          return;
        }

        var categoryData = {
          firstCategory: null,
          firstCategoryName: null,
          secondCategoryId: null,
          secondCategoryName: null
        };
        var inquiryGoodsData = [...dataSource];
        console.log(values, '表单的值', categoryList); // 选择码

        var selectCode = values.goodsCode && values.goodsCode.split('&&'); //选择名称

        var selectName = values.goodsName && values.goodsName.split('&&');
        values.merchantId = merchantIdDatas[0];
        values.merchantName = merchantIdDatas[1]; // 判断出所属品类

        var keyData = values.category;
        keyData && categoryList.map(_ref5 => {
          var label = _ref5.label,
              value = _ref5.value,
              children = _ref5.children;

          if (value === keyData[0]) {
            categoryData.firstCategory = value;
            categoryData.firstCategoryName = label;
          }

          children && children.map(itemKey => {
            if (itemKey.value === keyData[1]) {
              categoryData.secondCategoryId = itemKey.value;
              categoryData.secondCategoryName = itemKey.label;
            }
          });
        }); // 判断是否是输入的值

        console.log(queryCode, 'queryCode', queryName, 'queryName', selectCode, selectName, selectName);

        if (queryCode) {
          values.barCode = selectCode && selectCode[0];
          values.pluCode = null;
          values.goodsCode = null;
        }

        if (queryName) {
          values.pluCode = null;
          values.goodsCode = null;
          values.goodsName = selectName[0];
        }

        if (!editInquiryData) {
          if (!queryCode && !queryName) {
            // 这个逻辑下的商品是商品库里没有的 手动添加的  给一个sourceType为1
            values.sourceType = 1;
          } else {
            values.sourceType = 2;
          }
        } // 判断是商品做了选择还是商品码做了选择


        if (!queryCode && !queryName && selectCode && selectCode.length > 2) {
          values.goodsCode = selectCode[0];
          values.pluCode = selectCode[1];
          values.barCode = selectCode[2];
          values.goodsName = selectCode[3];
        }

        if (!queryCode && !queryName && selectName && selectName.length > 2) {
          values.goodsCode = selectName[0];
          values.pluCode = selectName[1];
          values.barCode = selectName[2];
          values.goodsName = selectName[3];
        } // 判断自填生鲜要补码


        if (values && values.category && values.category[0] === 10 && !values.goodsCode) {
          var codeData = Date.now();
          values.barCode = "".concat(codeData);
          values.freshCode = true;
        } else {
          values.freshCode = false;
        } // 判断编辑还是新增


        console.log(categoryData, '值', values, 'categoryList', selectCode, 'selectCode', selectName); // console.log(editKey, 'editInquiryData编辑')

        if (editKey || editKey === 0) {
          inquiryGoodsData.splice(editKey, 1, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)({}, editInquiryData), categoryData), values));
        } else {
          inquiryGoodsData.push((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)({}, categoryData), values));
        }

        setDataSource(inquiryGoodsData);
        form.resetFields();
        setFromBoolean(false);
      }).catch(info => {
        console.log('Validate Failed:', info);
      });
    },
    onCancel: () => {
      form.resetFields();
      setFromBoolean(false);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, {
    form: form,
    layout: "vertical",
    name: "form_in_modal",
    initialValues: {
      modifier: 'public'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_row__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z, {
    gutter: 16
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_24__/* .default */ .Z, {
    span: 8
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_16__/* .default.Item */ .Z.Item, {
    name: "goodsCode",
    label: "\u5546\u54C1\u7801(\u5FEB\u6D88\u6761\u7801\u5FC5\u586B)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
    showSearch: true,
    showArrow: false,
    filterOption: false,
    onSearch: value => {
      handleSearch(value, 'goodsCode');
    },
    onChange: value => {
      handleChange(value, 'goodsCode');
    },
    notFoundContent: null,
    placeholder: "\u8BF7\u8F93\u5165\u5546\u54C1\u7F16\u7801/\u6761\u7801/pul\u7801"
  }, commodityCode.map((d, index) => {
    var commodityCodeName;

    if (d.goodsCode) {
      commodityCodeName = d.goodsCode;
    } else if (d.pluCode) {
      commodityCodeName = d.pluCode;
    } else if (d.barCode) {
      commodityCodeName = d.barCode;
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(Option, {
      key: index,
      value: "".concat(d.goodsCode, "&&").concat(d.pluCode, "&&").concat(d.barCode, "&&").concat(d.goodsName, "&&").concat(d.firstCategoryId, "&&").concat(d.secondCategoryId, "&&").concat(d.basicUnit)
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_25__/* .default */ .Z, {
      title: "".concat(commodityCodeName).concat(d.goodsName == '输入的值' ? null : "-".concat(d.goodsName))
    }, commodityCodeName, d.goodsName == '输入的值' ? null : '--', d.goodsName == '输入的值' ? null : d.goodsName));
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_24__/* .default */ .Z, {
    span: 8
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_16__/* .default.Item */ .Z.Item, {
    name: "goodsName",
    label: "\u5546\u54C1\u540D\u79F0",
    rules: [{
      required: true,
      message: '请输入商品名称'
    }]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
    showSearch: true,
    showArrow: false,
    filterOption: false,
    onSearch: value => {
      handleSearch(value, 'goodsName');
    },
    onChange: value => {
      handleChange(value, 'goodsName');
    },
    notFoundContent: null,
    placeholder: "\u8BF7\u8F93\u5165\u5546\u54C1\u540D\u79F0"
  }, commodityNameData.map((d, index) => {
    var commodityCodeName;

    if (d.goodsCode) {
      commodityCodeName = d.goodsCode;
    } else if (d.pluCode) {
      commodityCodeName = d.pluCode;
    } else if (d.barCode) {
      commodityCodeName = d.barCode;
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(Option, {
      key: index,
      value: "".concat(d.goodsCode, "&&").concat(d.pluCode, "&&").concat(d.barCode, "&&").concat(d.goodsName, "&&").concat(d.firstCategoryId, "&&").concat(d.secondCategoryId, "&&").concat(d.basicUnit)
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_25__/* .default */ .Z, {
      title: "".concat(commodityCodeName).concat(d.goodsName == '输入的值' ? null : "-".concat(d.goodsName))
    }, commodityCodeName, d.goodsName == '输入的值' ? null : '--', d.goodsName == '输入的值' ? null : d.goodsName));
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_24__/* .default */ .Z, {
    span: 8
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_16__/* .default.Item */ .Z.Item, {
    name: "category",
    label: "\u6240\u5C5E\u54C1\u7C7B",
    rules: [{
      required: true,
      message: '请选择品类'
    }]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_cascader__WEBPACK_IMPORTED_MODULE_26__/* .default */ .Z, {
    options: categoryList,
    placeholder: "\u8BF7\u9009\u62E9\u54C1\u7C7B",
    disabled: styleType,
    showSearch: true
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_row__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z, {
    gutter: 16
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_24__/* .default */ .Z, {
    span: 8
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_16__/* .default.Item */ .Z.Item, {
    name: "goodsReqQty",
    label: "\u91C7\u8D2D\u6570\u91CF",
    rules: [{
      required: true,
      message: '请输入采购数量'
    }]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_27__/* .default */ .Z, {
    placeholder: "\u8BF7\u8F93\u5165\u91C7\u8D2D\u6570\u91CF"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_24__/* .default */ .Z, {
    span: 8
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_16__/* .default.Item */ .Z.Item, {
    name: "basicUnit",
    label: "\u5355\u4F4D",
    rules: [{
      required: true,
      message: '请选择单位'
    }]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
    placeholder: "\u8BF7\u9009\u62E9\u5355\u4F4D",
    showSearch: true,
    disabled: basicUnitBoole,
    onChange: value => {
      setConversionRatioDes(value + '/件');
    }
  }, unitList.map(_ref6 => {
    var value = _ref6.value,
        label = _ref6.label;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(Option, {
      key: label,
      value: value
    }, label);
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_24__/* .default */ .Z, {
    span: 8
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_16__/* .default.Item */ .Z.Item, {
    name: "specDesc",
    label: "\u7B49\u7EA7\u63CF\u8FF0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_27__/* .default */ .Z, {
    placeholder: "\u8BF7\u8F93\u5165\u7B49\u7EA7\u63CF\u8FF0",
    maxLength: 30
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_row__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z, {
    gutter: 24
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_24__/* .default */ .Z, {
    span: 7
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_16__/* .default.Item */ .Z.Item, {
    name: "netConversionRatio",
    label: "\u89C4\u683C",
    initialValue: '1',
    rules: [{
      required: true,
      pattern: /^\d+(\.\d{1,3})?$/,
      message: "请输入正确格式数字，小数位不能超过3位"
    }]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_27__/* .default */ .Z, {
    placeholder: "\u8BF7\u8F93\u5165\u89C4\u683C"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement("span", null, "\xA0\xA0", conversionRatioDes)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_24__/* .default */ .Z, {
    span: 8
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_16__/* .default.Item */ .Z.Item, {
    name: "enquiryType",
    label: "\u8BE2\u4EF7\u65B9\u5F0F",
    rules: [{
      required: true,
      message: '请选择询价方式'
    }],
    initialValue: '2',
    help: "\u5B9A\u5411\uFF1A\u9664\u6307\u5B9A\u4F9B\u5E94\u5546\u5916\uFF0C\u5176\u4ED6\u4F9B\u5E94\u5546\u62A5\u4EF7\u4E0D\u53EF\u89C1 \u516C\u5F00\uFF1A\u5747\u53EF\u89C1"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
    placeholder: "\u8BF7\u9009\u62E9\u8BE2\u4EF7\u65B9\u5F0F",
    onChange: value => {
      // console.log(value, 'value禁止操作')
      if (value == 2) {
        setInquiryBoolean(false);
      } else {
        setInquiryBoolean(true);
      }
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_14__/* .default.Option */ .Z.Option, {
    value: "1"
  }, "\u516C\u5F00"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_14__/* .default.Option */ .Z.Option, {
    value: "2"
  }, "\u6307\u5B9A")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_24__/* .default */ .Z, {
    span: 8
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_16__/* .default.Item */ .Z.Item, {
    name: "list",
    label: "\u8BE2\u4EF7\u5BF9\u8C61",
    rules: [{
      required: inquiryBoolean ? false : true,
      message: '请选择询价对象'
    }]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
    placeholder: "\u8BF7\u9009\u62E9\u8BE2\u4EF7\u5BF9\u8C61",
    disabled: inquiryBoolean,
    mode: "multiple",
    allowClear: true,
    maxTagCount: 5,
    onSearch: value => {
      querySupplier(value);
    }
  }, suppCodeList)))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_row__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z, {
    gutter: 24
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_24__/* .default */ .Z, {
    span: 8
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_16__/* .default.Item */ .Z.Item, {
    name: "goodsPackageId",
    label: "\u5305\u88C5",
    rules: [{
      required: true,
      message: '请选择包装方式'
    }]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
    placeholder: "\u8BF7\u9009\u5305\u88C5\u4EF7\u65B9\u5F0F",
    options: goodsPackageIdList ? [...goodsPackageIdList] : []
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_24__/* .default */ .Z, {
    span: 8
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_16__/* .default.Item */ .Z.Item, {
    name: "goodsGradeId",
    label: "\u7B49\u7EA7",
    rules: [{
      required: true,
      message: '请选择等级'
    }]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_9__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
    placeholder: "\u8BF7\u9009\u62E9\u7B49\u7EA7",
    options: goodsGradeIdList ? [...goodsGradeIdList] : []
  }))))));
});

/***/ }),

/***/ 20297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_table_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66456);
/* harmony import */ var antd_es_table__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97423);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




var ShopTable = props => {
  var dataSource = props.dataSource,
      columns = props.columns;
  console.log(dataSource, 'dataSource');
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_table__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    columns: columns,
    dataSource: dataSource,
    scroll: {
      x: true,
      y: 600
    },
    rowKey: "goodsBarCode",
    pagination: false
  });
};

/* harmony default export */ __webpack_exports__["default"] = (ShopTable);

/***/ }),

/***/ 11832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YN": function() { return /* binding */ INQUIRY_LIST; },
/* harmony export */   "MC": function() { return /* binding */ INQUIRY_CANCEL; },
/* harmony export */   "Np": function() { return /* binding */ INQUIRY_SAVE; },
/* harmony export */   "Ut": function() { return /* binding */ INQUIRY_SUBMIT; },
/* harmony export */   "ov": function() { return /* binding */ INQUIRY_INFO_DETAIL; },
/* harmony export */   "vX": function() { return /* binding */ INQUIRY_DETAIL_LIST; },
/* harmony export */   "xd": function() { return /* binding */ INQUIRY_QUOTE_STAT; },
/* harmony export */   "xJ": function() { return /* binding */ INQUIRY_QUOTE_DETAIL_LIST; }
/* harmony export */ });
/* unused harmony exports INQUIRY_GOODS_LIST, INQUIRY_DELETE_DETAIL, INQUIRY_SEARCH_GOODS, INQUIRY_COMMDITY */
// 询价列表
var INQUIRY_LIST = 'enquiry.scm.enquiryOrderPageInfo'; // 取消询价单

var INQUIRY_CANCEL = 'enquiry.scm.cancelEnquiryOrder'; // 询价商品

var INQUIRY_GOODS_LIST = 'enquiry.scm.enquiryOrderDetailPageInfo'; // 保存询价信息

var INQUIRY_SAVE = 'enquiry.scm.saveEnquiryOrder'; // 提交询价单

var INQUIRY_SUBMIT = 'enquiry.scm.submitEnquiryOrder'; // 询价单详情

var INQUIRY_INFO_DETAIL = 'enquiry.scm.enquiryOrderInfo'; // 询价单明细删除

var INQUIRY_DELETE_DETAIL = 'enquiry.scm.deleteEnquiryOrderLine'; // 明细列表

var INQUIRY_DETAIL_LIST = 'enquiry.scm.enquiryOrderDetailInfoList'; // 通过条码查询商品数据

var INQUIRY_SEARCH_GOODS = 'purchase.scm.productInfoPageInfo'; // 报价单汇总

var INQUIRY_QUOTE_STAT = 'quote.scm.sumQuoteOrderDetail'; // 查询报价单明细列表

var INQUIRY_QUOTE_DETAIL_LIST = 'quote.scm.queryQuoteOrderDetailPage'; // 查询商品码

var INQUIRY_COMMDITY = 'quote.scm.queryQuoteOrderDetailPage';

/***/ }),

/***/ 44355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ GOODS_LIST; },
/* harmony export */   "K": function() { return /* binding */ BATCH_DELETE; }
/* harmony export */ });
// 采购池列表
var GOODS_LIST = 'scm.purchasePool.purchasePoolList'; // 批量删除

var BATCH_DELETE = 'scm.purchasePool.deletePurchasePool';

/***/ }),

/***/ 23081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lG": function() { return /* binding */ DELIVERY_DETAIL_API; },
/* harmony export */   "e1": function() { return /* binding */ DELIVERY_LIST_API; },
/* harmony export */   "OB": function() { return /* binding */ DELIVERY_MODIFY_API; },
/* harmony export */   "c_": function() { return /* binding */ ORDER_DELETE_API; },
/* harmony export */   "yy": function() { return /* binding */ ORDER_RESOLVE_API; }
/* harmony export */ });
/**
 * API集合
 */
// 详情
var DELIVERY_DETAIL_API = 'purchase.demandPooling.queryDemandPoolingStrategy'; // 列表

var DELIVERY_LIST_API = 'purchase.demandPooling.listDemandPoolingStrategy'; // 保存

var DELIVERY_MODIFY_API = 'purchase.demandPooling.saveDemandPoolingStrategy'; // 删除

var ORDER_DELETE_API = 'purchase.demandPooling.deleteDemandPoolingStrategy'; // 手动集单

var ORDER_RESOLVE_API = 'purchase.demandPooling.manualTriggerPooling';

/***/ }),

/***/ 13030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ON": function() { return /* binding */ queryAuthorizedCategoryTree; },
/* harmony export */   "b1": function() { return /* binding */ pageQueryMerchantGoods; },
/* harmony export */   "LZ": function() { return /* binding */ pageVegetablePropelling; },
/* harmony export */   "Th": function() { return /* binding */ exportVegetablePropelling; },
/* harmony export */   "Sr": function() { return /* binding */ pageVegetableByMerchantAgg; },
/* harmony export */   "PF": function() { return /* binding */ exportVegetableByMerchantAgg; },
/* harmony export */   "AJ": function() { return /* binding */ createVegetablePropelling; },
/* harmony export */   "ks": function() { return /* binding */ modifyVegetablePropelling; },
/* harmony export */   "gK": function() { return /* binding */ cancelVegetablePropelling; },
/* harmony export */   "mw": function() { return /* binding */ confirmVegetablePropelling; },
/* harmony export */   "xi": function() { return /* binding */ importVegetablePropelling; },
/* harmony export */   "b8": function() { return /* binding */ pageFruitPropelling; },
/* harmony export */   "cj": function() { return /* binding */ exportFruitPropelling; },
/* harmony export */   "b$": function() { return /* binding */ pageFruitByMerchantAgg; },
/* harmony export */   "VN": function() { return /* binding */ exportFruitByMerchantAgg; },
/* harmony export */   "qJ": function() { return /* binding */ createFruitPropelling; },
/* harmony export */   "G2": function() { return /* binding */ modifyFruitPropelling; },
/* harmony export */   "rp": function() { return /* binding */ cancelFruitPropelling; },
/* harmony export */   "uN": function() { return /* binding */ confirmFruitPropelling; },
/* harmony export */   "xB": function() { return /* binding */ importFruitPropelling; },
/* harmony export */   "fQ": function() { return /* binding */ downloadTemplate; },
/* harmony export */   "g2": function() { return /* binding */ queryExecuteResult; },
/* harmony export */   "xG": function() { return /* binding */ getDownloadFileUrl; }
/* harmony export */ });
/**
 * 获取权限下的类目
 */
var queryAuthorizedCategoryTree = 'kernel.console.AuthorizedDataQueryService.queryAuthorizedCategoryTree';
/**
 * 获取商品
 */

var pageQueryMerchantGoods = 'kernel.console.MerchantGoodsQueryService.pageQueryMerchantGoodsCompatibility';
/**
 * 蔬菜推动品列表
 */

var pageVegetablePropelling = 'kernel.console.propellingGoods.pageVegetablePropelling';
/**
 * 导出蔬菜推动品列表
 */

var exportVegetablePropelling = 'kernel.console.propellingGoods.exportVegetablePropelling';
/**
 * 蔬菜推动品商家合计列表
 */

var pageVegetableByMerchantAgg = 'kernel.console.propellingGoods.pageVegetableByMerchantAgg';
/**
 * 导出蔬菜推动品商家合计列表
 */

var exportVegetableByMerchantAgg = 'kernel.console.propellingGoods.exportVegetableByMerchantAgg';
/**
 * 蔬菜推动品提报
 */

var createVegetablePropelling = 'kernel.console.propellingGoods.createVegetablePropelling';
/**
 * 修改蔬菜推动品提报数据
 */

var modifyVegetablePropelling = 'kernel.console.propellingGoods.modifyVegetablePropelling';
/**
 * 取消蔬菜推动品提报数据
 */

var cancelVegetablePropelling = 'kernel.console.propellingGoods.cancelVegetablePropelling';
/**
 * 确认蔬菜推动品提报数据
 */

var confirmVegetablePropelling = 'kernel.console.propellingGoods.confirmVegetablePropelling';
/**
 * 导入蔬菜推动品
 */

var importVegetablePropelling = 'kernel.console.propellingGoods.importVegetablePropelling';
/**
 * 水果推动品列表
 */

var pageFruitPropelling = 'kernel.console.propellingGoods.pageFruitPropelling';
/**
 * 导出水果推动品列表
 */

var exportFruitPropelling = 'kernel.console.propellingGoods.exportFruitPropelling';
/**
 * 水果推动品商家合计列表
 */

var pageFruitByMerchantAgg = 'kernel.console.propellingGoods.pageFruitByMerchantAgg';
/**
 * 导出水果推动品商家合计列表
 */

var exportFruitByMerchantAgg = 'kernel.console.propellingGoods.exportFruitByMerchantAgg';
/**
 * 水果推动品提报
 */

var createFruitPropelling = 'kernel.console.propellingGoods.createFruitPropelling';
/**
 * 修改水果推动品提报数据
 */

var modifyFruitPropelling = 'kernel.console.propellingGoods.modifyFruitPropelling';
/**
 * 取消水果推动品提报数据
 */

var cancelFruitPropelling = 'kernel.console.propellingGoods.cancelFruitPropelling';
/**
 * 确认水果推动品提报数据
 */

var confirmFruitPropelling = 'kernel.console.propellingGoods.confirmFruitPropelling';
/**
 * 导入水果推动品
 */

var importFruitPropelling = 'kernel.console.propellingGoods.importFruitPropelling';
/**
 * 模板下载
 */

var downloadTemplate = 'kernel.console.BatchToolsService.downloadTemplate';
/**
*  查询导入导出结果
*/

var queryExecuteResult = 'kernel.console.BatchToolsService.queryExecuteResult';
/**
 *  获取下载链接
 */

var getDownloadFileUrl = 'kernel.console.BatchToolsService.getDownloadFileUrl';

/***/ }),

/***/ 56791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2824);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24731);
/* harmony import */ var _Api_index__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(13030);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71720);
/* harmony import */ var _components_FormBuilder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5670);
/* harmony import */ var _View_module_less_modules__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70483);
/* harmony import */ var _View_module_less_modules__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_View_module_less_modules__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26715);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96534);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7704);
/* harmony import */ var _hooks_useDateRange__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(76511);








/**
 * 新增商品modal
 */












var AddModal = props => {
  var merchantList = props.merchantList,
      record = props.record,
      handleOk = props.handleOk,
      handleCancel = props.handleCancel,
      type = props.type;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState, 2),
      merchantId = _useState2[0],
      setMerchantId = _useState2[1]; // 城市（商家）

  /** 是否新增操作 */


  var modalFormRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([{
    label: '水果',
    value: '1001'
  }, {
    label: '蔬菜',
    value: '1002'
  }]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState3, 2),
      opCategoryList = _useState4[0],
      setOpCategoryList = _useState4[1];

  var formCache = (0,umi__WEBPACK_IMPORTED_MODULE_10__/* .useSelector */ .v9)(state => {
    var _state$formCache;

    return ((_state$formCache = state.formCache) === null || _state$formCache === void 0 ? void 0 : _state$formCache[location.pathname]) || {};
  });

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState5, 2),
      goodsKeyword = _useState6[0],
      setGoodsKeyword = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState7, 2),
      opGoodsList = _useState8[0],
      setOpGoodsList = _useState8[1];

  var isFruit = type == '1' ? true : false;

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)([_config_enums__WEBPACK_IMPORTED_MODULE_6__/* .purchaseEnumConfig.merchantId */ .Nt.merchantId, 59], {
    'merchantId': merchantId
  }),
      mappingList = _useMapping.mappingList;

  var fieldDataList = type => {
    return mappingList && mappingList['get'] && mappingList.get(_config_enums__WEBPACK_IMPORTED_MODULE_6__/* .purchaseEnumConfig */ .Nt[type]);
  };

  var changeMerchantId = () => {
    var _modalFormRef$current;

    (_modalFormRef$current = modalFormRef.current) === null || _modalFormRef$current === void 0 ? void 0 : _modalFormRef$current.setFieldsValue({
      placeGroupId: undefined
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    getGoodsList();
  }, [merchantId, goodsKeyword]);
  var pickRange = (0,_hooks_useDateRange__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({
    label: '档期',
    name: 'kinoprogrammStart',
    type: 'RANGE_PICKER_SHORT',
    required: true,
    fieldOptions: {
      disabledDate: current => {
        return current < moment__WEBPACK_IMPORTED_MODULE_1___default()().subtract(-1, 'day').startOf('day');
      }
    }
  });
  /** 表单form */

  var formList = isFruit ? [pickRange, {
    label: '城市',
    name: 'merchantId',
    type: 'SELECT',
    dataList: fieldDataList('merchantId'),
    required: true,
    fieldOptions: {
      onChange: () => {
        var _modalFormRef$current2;

        setMerchantId((_modalFormRef$current2 = modalFormRef.current) === null || _modalFormRef$current2 === void 0 ? void 0 : _modalFormRef$current2.getFieldsValue().merchantId);
      }
    }
  }, {
    label: '队形',
    name: 'placeGroupId',
    type: 'SELECT',
    dataList: (mappingList === null || mappingList === void 0 ? void 0 : mappingList.get(59)) || [],
    required: true
  }, {
    label: '商品',
    name: 'goodsId',
    type: 'SELECT',
    dataList: opGoodsList,
    required: true,
    fieldOptions: {
      filterOption: false,
      onSearch: value => {
        setGoodsKeyword(value);
      }
    }
  }, {
    label: ' ',
    name: 'line',
    type: 'INPUT',
    fieldOptions: {
      className: 'sep',
      disabled: true
    }
  }, {
    label: '单件规格',
    name: 'sortUnit',
    type: 'INPUT',
    required: true,
    rules: [{
      pattern: /^(([1-9][0-9]*)(\.\d{1,2})?)$|^0\.\d{1,2}?$/,
      message: '仅支持>0两位小数数字'
    }]
  }, {
    label: '当前成本',
    name: 'currentCost',
    type: 'INPUT',
    required: true,
    rules: [{
      pattern: /^(([1-9][0-9]*)(\.\d{1,2})?)$|^0\.\d{1,2}?$/,
      message: '仅支持>0两位小数数字'
    }]
  }, {
    label: '促销成本',
    name: 'promotionCost',
    type: 'INPUT',
    required: true,
    rules: [{
      pattern: /^(([1-9][0-9]*)(\.\d{1,2})?)$|^0\.\d{1,2}?$/,
      message: '仅支持>0两位小数数字'
    }]
  }, {
    label: '去损%',
    name: 'lossRate',
    type: 'INPUT',
    required: true,
    rules: [{
      pattern: /^(([1-9][0-9]?)(\.\d{1,2})?)$|^0\.\d{1,2}?|100$/,
      message: '仅支持>0且100以内两位小数数字'
    }],
    fieldOptions: {
      className: 'lossRate',
      addonAfter: '%'
    }
  }, {
    label: '配送费/kg',
    name: 'distributeCost',
    type: 'INPUT',
    required: true,
    rules: [{
      pattern: /^(([1-9][0-9]*)(\.\d{1,2})?)$|^0\.\d{1,2}?$/,
      message: '仅支持>0两位小数数字'
    }]
  }, {
    label: '指导价',
    name: 'guidePrice',
    type: 'INPUT',
    required: true,
    rules: [{
      pattern: /^(([1-9][0-9]*)(\.\d{1,2})?)$|^0\.\d{1,2}?$/,
      message: '仅支持>0两位小数数字'
    }]
  }, {
    label: '推动价',
    name: 'pushPrice',
    type: 'INPUT',
    required: true,
    rules: [{
      pattern: /^(([1-9][0-9]*)(\.\d{1,2})?)$|^0\.\d{1,2}?$/,
      message: '仅支持>0两位小数数字'
    }]
  }, {
    label: '备货量/件',
    name: 'stockUpQty',
    type: 'INPUT',
    required: true,
    rules: [{
      pattern: /^(([1-9][0-9]*)(\.\d{1,2})?)$|^0\.\d{1,2}?$/,
      message: '仅支持>0两位小数数字'
    }]
  }, {
    label: '供应商',
    name: 'supplierName',
    type: 'INPUT',
    required: true,
    rules: [{
      max: 10,
      message: '10字以内'
    }]
  }, {
    label: '天气',
    name: 'weather',
    type: 'INPUT',
    required: true,
    rules: [{
      max: 10,
      message: '10字以内'
    }]
  }, {
    label: '类型',
    name: 'type',
    type: 'INPUT',
    required: true,
    rules: [{
      max: 10,
      message: '10字以内'
    }]
  }] : [{
    label: '档期',
    name: 'kinoprogramm',
    type: 'DATE_PICKER',
    required: true,
    fieldOptions: {
      disabledDate: current => {
        return current < moment__WEBPACK_IMPORTED_MODULE_1___default()().subtract(-1, 'day').startOf('day');
      }
    }
  }, {
    label: '城市',
    name: 'merchantId',
    type: 'SELECT',
    dataList: fieldDataList('merchantId'),
    required: true,
    fieldOptions: {
      onChange: () => {
        var _modalFormRef$current3;

        setMerchantId((_modalFormRef$current3 = modalFormRef.current) === null || _modalFormRef$current3 === void 0 ? void 0 : _modalFormRef$current3.getFieldsValue().merchantId);
      }
    }
  }, {
    label: '队形',
    name: 'placeGroupId',
    type: 'SELECT',
    dataList: (mappingList === null || mappingList === void 0 ? void 0 : mappingList.get(59)) || [],
    required: true
  }, {
    label: '商品',
    name: 'goodsId',
    type: 'SELECT',
    dataList: opGoodsList,
    required: true,
    fieldOptions: {
      filterOption: false,
      onSearch: value => {
        setGoodsKeyword(value);
      }
    }
  }, {
    label: ' ',
    name: 'line',
    type: 'INPUT',
    fieldOptions: {
      className: 'sep',
      disabled: true
    }
  }, {
    label: '到店价(公斤)',
    name: 'shopPrice',
    type: 'INPUT',
    required: true,
    rules: [{
      pattern: /^(([1-9][0-9]*)(\.\d{1,2})?)$|^0\.\d{1,2}?$/,
      message: '仅支持>0两位小数数字'
    }]
  }, {
    label: '售价(公斤)',
    name: 'salePrice',
    type: 'INPUT',
    required: true,
    rules: [{
      pattern: /^(([1-9][0-9]*)(\.\d{1,2})?)$|^0\.\d{1,2}?$/,
      message: '仅支持>0两位小数数字'
    }]
  }, {
    label: '目标销量',
    name: 'targetSales',
    type: 'INPUT',
    required: true,
    rules: [{
      pattern: /^(([1-9][0-9]*)(\.\d{1,2})?)$|^0\.\d{1,2}?$/,
      message: '仅支持>0两位小数数字'
    }]
  }, {
    label: '类型',
    name: 'type',
    type: 'INPUT',
    required: true,
    rules: [{
      max: 10,
      message: '10字以内'
    }]
  }];
  var defaultFormItemLayout = {
    labelCol: {
      xs: {
        span: 12
      },
      sm: {
        span: 6
      }
    },
    wrapperCol: {
      xs: {
        span: 12
      },
      sm: {
        span: 6
      }
    }
  }; // 默认搜索条件

  var defaultValues = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => ({
    kinoprogrammStart: [moment__WEBPACK_IMPORTED_MODULE_1___default()().subtract(15, 'day').startOf('day'), moment__WEBPACK_IMPORTED_MODULE_1___default()().endOf('day')]
  }), []); // 初始化表单值

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
    param: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)({}, formCache), (0,_utils_common__WEBPACK_IMPORTED_MODULE_7__/* .formatRangeDate */ .v3)(formCache.kinoprogrammStart || [], 'kinoprogrammStart', 'kinoprogrammEnd'))
  }),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState9, 2),
      addParams = _useState10[0],
      setAddParams = _useState10[1]; // const goodsChange = ()=>{
  //   setGoodsKeyword(modalFormRef.current?.getFieldsValue().goodsId)
  //   getGoodsList()
  // }

  /** 提交 */


  var baseHandler = () => {
    modalFormRef.current.validateFields().then(result => {
      delete result.line;

      var rest = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, result);

      var params = {};

      if (isFruit) {
        params = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)({}, rest), {}, {
          kinoprogrammStart: rest.kinoprogrammStart[0].format('YYYY-MM-DD') + ' ' + '00:00:00',
          kinoprogrammEnd: rest.kinoprogrammStart[1].format('YYYY-MM-DD') + ' ' + '23:59:59'
        });
      } else {
        var t = rest.kinoprogramm.format('YYYY-MM-DD');
        params = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)({}, rest), {}, {
          kinoprogrammStart: t + ' ' + '00:00:00',
          kinoprogrammEnd: t + ' ' + '23:59:59'
        });
      }

      handleOk && handleOk(params);
    }).catch(err => {
      console.log('err', err);
    });
  };

  var getGoodsList = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().mark(function _callee() {
      var res, list, newList;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!merchantId) {
                _context.next = 13;
                break;
              }

              _context.prev = 1;
              _context.next = 4;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_Api_index__WEBPACK_IMPORTED_MODULE_16__/* .pageQueryMerchantGoods */ .b1, {
                query: {
                  queryScene: 1,
                  merchantId: [merchantId],
                  categoryId: [isFruit ? '1002' : '1003'],
                  queryCondition: goodsKeyword
                }
              });

            case 4:
              res = _context.sent;

              if (res && res.success) {
                list = res.result.list;
                newList = [];
                list.forEach(item => {
                  newList.push({
                    label: item.goodsAlias,
                    value: item.goodsCode
                  });
                });
                setOpGoodsList(newList);
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.log(_context.t0);

            case 11:
              _context.prev = 11;
              return _context.finish(11);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8, 11, 13]]);
    }));

    return function getGoodsList() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z, {
    className: (_View_module_less_modules__WEBPACK_IMPORTED_MODULE_5___default().sBlackListM),
    title: "\u65B0\u589E".concat(isFruit ? '水果' : '蔬菜', "\u5546\u54C1"),
    width: 500,
    visible: true,
    destroyOnClose: true,
    onOk: () => baseHandler(),
    onCancel: handleCancel,
    cancelText: "\u53D6\u6D88",
    okText: "\u786E\u8BA4"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_components_FormBuilder__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, defaultFormItemLayout, {
    ref: modalFormRef,
    elements: formList,
    initialValues: defaultValues,
    notSearchForm: true
  }))));
};

/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(AddModal));

/***/ }),

/***/ 21553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_progress_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34669);
/* harmony import */ var antd_es_progress__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(44808);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(57016);
/* harmony import */ var antd_es_spin_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20228);
/* harmony import */ var antd_es_spin__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(11382);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(91896);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46565);
/* harmony import */ var _components_YPDragger__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71651);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7704);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24731);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26715);
/* harmony import */ var _Api_index__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(13030);





















var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 7
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 14
    }
  }
};

var ImportView = props => {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(''),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState, 2),
      merchantId = _useState2[0],
      setMerchantId = _useState2[1];

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)([40, 59], {
    'merchantId': merchantId
  }),
      mappingList = _useMapping.mappingList;

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState3, 2),
      fileInfo = _useState4[0],
      setFileInfo = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState5, 2),
      resId = _useState6[0],
      setResId = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState7, 2),
      modalVisible = _useState8[0],
      setModalVisible = _useState8[1];

  var importForm = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)();

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState9, 2),
      spinLoading = _useState10[0],
      setSpinLoading = _useState10[1];

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(),
      _useState12 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState11, 2),
      taskOrderNo = _useState12[0],
      setTaskOrderNo = _useState12[1]; // let order;


  var orderNo = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)();

  var cancelHandler = () => {
    props.closeModalCallback(false);
    initFormdata();
  };

  var uploadChange = (fileInfo, resId) => {
    var fileList = fileInfo.fileList;
    setResId(resId);
    setFileInfo(fileList[fileList.length - 1]);
  };

  var changeMerchantId = () => {
    var _importForm$current, _importForm$current2;

    setMerchantId((_importForm$current = importForm.current) === null || _importForm$current === void 0 ? void 0 : _importForm$current.getFieldsValue().merchantId);
    (_importForm$current2 = importForm.current) === null || _importForm$current2 === void 0 ? void 0 : _importForm$current2.setFieldsValue({
      formation: undefined
    });
  };

  var fieldDataList = type => {
    return mappingList && mappingList['get'] && mappingList.get(_config_enums__WEBPACK_IMPORTED_MODULE_10__/* .purchaseEnumConfig */ .Nt[type]);
  };

  var formFileds = () => {
    return [{
      label: '城市',
      name: 'merchantId',
      type: 'SELECT',
      dataList: fieldDataList('merchantId'),
      required: true,
      fieldOptions: {
        onChange: () => {
          var _importForm$current3;

          setMerchantId((_importForm$current3 = importForm.current) === null || _importForm$current3 === void 0 ? void 0 : _importForm$current3.getFieldsValue().merchantId);
        }
      }
    }, {
      label: '队形',
      name: 'formation',
      type: 'SELECT',
      required: true,
      dataList: (mappingList === null || mappingList === void 0 ? void 0 : mappingList.get(59)) || []
    }, {
      label: '文件选择',
      name: 'file',
      required: true,
      widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("div", {
        style: {
          maxWidth: 200
        }
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(_components_YPDragger__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
        onChange: (fileInfo, resId) => uploadChange(fileInfo, resId),
        tokenUrl2: "kernel.console.BatchToolsService.getUploadFileToken",
        showUploadList: false
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("div", null, fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.name), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("div", {
        style: {
          marginTop: 5,
          color: 'grey'
        }
      }, "\u652F\u6301\u6269\u5C55\u540D: .xls .xlsx"))
    }];
  }; // 轮训导入请求结果


  var importRequest = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee(taskOrder) {
      var timer, res, success, result, isFinish, resultFile, failTips, progress;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_Api_index__WEBPACK_IMPORTED_MODULE_14__/* .queryExecuteResult */ .g2, {
                taskOrderNo: taskOrder
              });

            case 2:
              res = _context.sent;
              success = res.success, result = res.result;

              if (success) {
                _context.next = 7;
                break;
              }

              setModalVisible(false);
              return _context.abrupt("return", false);

            case 7:
              isFinish = result.isFinish, resultFile = result.resultFile, failTips = result.failTips, progress = result.progress;

              if (isFinish) {
                _context.next = 13;
                break;
              }

              //每隔一秒轮询一次
              timer = setTimeout(() => {
                importRequest(taskOrder);
              }, 1000);
              return _context.abrupt("return", true);

            case 13:
              if (!(progress.fail > 0)) {
                _context.next = 21;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_15__.default.warn('导入失败');

              if (resultFile) {
                // message.warn(failTips ? failTips : '导入失败,请在excel中查看明细..')
                downloadExcel(resultFile);
              } // else {
              //     message.warn(failTips ? failTips : '导入失败')
              // }


              clearTimeout(timer);
              setModalVisible(false);
              return _context.abrupt("return", false);

            case 21:
              antd_es_message__WEBPACK_IMPORTED_MODULE_15__.default.success('导入数据成功');

              clearTimeout(timer);
              setModalVisible(false);
              props.closeModalCallback(true);
              return _context.abrupt("return", false);

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function importRequest(_x) {
      return _ref.apply(this, arguments);
    };
  }(); // 导入失败下载表格


  var downloadExcel = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee2(id) {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_Api_index__WEBPACK_IMPORTED_MODULE_14__/* .getDownloadFileUrl */ .xG, {
                resId: id
              });

            case 3:
              res = _context2.sent;

              if (res && res.success) {
                window.location.href = res.result;
              }

              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));

    return function downloadExcel(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var submit = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee4() {
    var _importForm$current4;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            // const values = importForm.current?.getFieldsValue()
            (_importForm$current4 = importForm.current) === null || _importForm$current4 === void 0 ? void 0 : _importForm$current4.validateFields().then( /*#__PURE__*/function () {
              var _ref4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee3(values) {
                var params, api, v;
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        params = {
                          resId: resId,
                          merchantId: values === null || values === void 0 ? void 0 : values.merchantId,
                          placeGroupId: values === null || values === void 0 ? void 0 : values.formation
                        };
                        api = '';

                        if (props.type == '1') {
                          api = _Api_index__WEBPACK_IMPORTED_MODULE_14__/* .importFruitPropelling */ .xB;
                        } else {
                          api = _Api_index__WEBPACK_IMPORTED_MODULE_14__/* .importVegetablePropelling */ .xi;
                        }

                        _context3.next = 5;
                        return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_6__/* .YpRequest */ .XQ)(api, params);

                      case 5:
                        v = _context3.sent;

                        if (v.success) {
                          antd_es_message__WEBPACK_IMPORTED_MODULE_15__.default.success('导入任务添加成功');

                          setModalVisible(true);
                          setTaskOrderNo(v.result.importOrderNo);
                          props.closeModalCallback(false);
                          initFormdata();
                          importRequest(v.result.importOrderNo);
                        }

                      case 7:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x3) {
                return _ref4.apply(this, arguments);
              };
            }());

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  })), [resId]);

  var initFormdata = () => {
    var _importForm$current5;

    (_importForm$current5 = importForm.current) === null || _importForm$current5 === void 0 ? void 0 : _importForm$current5.setFieldsValue({
      merchantId: undefined,
      formation: undefined
    });
    setResId('');
    setFileInfo({});
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, {
    width: 400,
    visible: props.visible,
    closable: false,
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z, {
      key: "back",
      onClick: cancelHandler
    }, "\u53D6\u6D88"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z, {
      key: "submit",
      type: "primary",
      onClick: () => {
        submit();
      }
    }, "\u786E\u5B9A")]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_spin__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
    spinning: spinLoading
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_6__/* .FormBuilder */ .qu, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)({}, defaultFormItemLayout, {
    formRef: importForm,
    elements: formFileds(),
    notSearchForm: true
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, {
    width: 540,
    visible: modalVisible,
    centered: true,
    destroyOnClose: true,
    maskClosable: false,
    closable: false,
    footer: null
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("h3", {
    className: "mTop16 mBottom16 alignCenter"
  }, "\u6B63\u5728\u5BFC\u5165\u6570\u636E"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("div", {
    style: {
      paddingBottom: '20px'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_progress__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
    strokeColor: {
      from: '#108ee9',
      to: '#87d068'
    },
    percent: 100,
    showInfo: false,
    status: "active"
  }))));
};

/* harmony default export */ __webpack_exports__["default"] = (ImportView);

/***/ }),

/***/ 82451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ useFruitColumns; }
/* harmony export */ });
/* harmony import */ var antd_es_popconfirm_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62350);
/* harmony import */ var antd_es_popconfirm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75443);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _useBaseColumns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80049);
/* harmony import */ var _useOperationClms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34702);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96534);






function useFruitColumns(optionFunc) {
  return [...(0,_useBaseColumns__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(), {
    title: '单件规格',
    dataIndex: 'sortUnit',
    key: 'sortUnit',
    width: 150,
    type: 'INPUT',
    fieldOptions: (t, r) => {
      return {
        disabled: (t === null || t === void 0 ? void 0 : t.statusStr) === '已取消' || t.isExpire,
        formatter: value => (0,_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exchageToNum2 */ .Tn)(value)
      };
    }
  }, {
    title: '当前成本采货成本/kg(净果成本)',
    dataIndex: 'currentCost',
    key: 'currentCost',
    width: 150,
    type: 'INPUT',
    fieldOptions: (t, r) => {
      return {
        disabled: (t === null || t === void 0 ? void 0 : t.statusStr) === '已取消' || t.isExpire,
        formatter: value => (0,_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exchageToNum2 */ .Tn)(value)
      };
    }
  }, {
    title: '促销成本采货成本/kg(净果成本)',
    dataIndex: 'promotionCost',
    key: 'promotionCost',
    width: 150,
    type: 'INPUT',
    fieldOptions: (t, r) => {
      return {
        disabled: (t === null || t === void 0 ? void 0 : t.statusStr) === '已取消' || t.isExpire,
        formatter: value => (0,_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exchageToNum2 */ .Tn)(value)
      };
    }
  }, {
    title: '下降幅度采货成本/kg(净果成本)',
    dataIndex: 'fallingRange',
    key: 'fallingRange',
    width: 100
  }, {
    title: '去损%',
    dataIndex: 'lossRate',
    key: 'lossRate',
    width: 150,
    type: 'INPUT',
    fieldOptions: (t, r) => {
      return {
        disabled: (t === null || t === void 0 ? void 0 : t.statusStr) === '已取消' || t.isExpire,
        formatter: value => (0,_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exchageToNum2 */ .Tn)(value)
      };
    }
  }, {
    title: '配送费/kg',
    dataIndex: 'distributeCost',
    key: 'distributeCost',
    width: 150,
    type: 'INPUT',
    fieldOptions: (t, r) => {
      return {
        disabled: (t === null || t === void 0 ? void 0 : t.statusStr) === '已取消' || t.isExpire,
        formatter: value => (0,_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exchageToNum2 */ .Tn)(value)
      };
    }
  }, {
    title: '到店价',
    dataIndex: 'shopPrice',
    key: 'shopPrice',
    width: 100
  }, {
    title: '指导价',
    dataIndex: 'guidePrice',
    key: 'guidePrice',
    width: 150,
    type: 'INPUT',
    fieldOptions: (t, r) => {
      return {
        disabled: (t === null || t === void 0 ? void 0 : t.statusStr) === '已取消' || t.isExpire,
        formatter: value => (0,_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exchageToNum2 */ .Tn)(value)
      };
    }
  }, {
    title: '推动价',
    dataIndex: 'pushPrice',
    key: 'pushPrice',
    width: 150,
    type: 'INPUT',
    fieldOptions: (t, r) => {
      return {
        disabled: (t === null || t === void 0 ? void 0 : t.statusStr) === '已取消' || t.isExpire,
        formatter: value => (0,_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exchageToNum2 */ .Tn)(value)
      };
    }
  }, {
    title: '加价额/kg(原)',
    dataIndex: 'originMarkupPrice',
    key: 'originMarkupPrice',
    width: 100
  }, {
    title: '加价额/kg(促)',
    dataIndex: 'promotionMarkupPrice',
    key: 'promotionMarkupPrice',
    width: 100
  }, {
    title: '毛利率%(原)',
    dataIndex: 'originGrossMargin',
    key: 'originGrossMargin',
    width: 100
  }, {
    title: '毛利率%(促)',
    dataIndex: 'promotionGrossMargin',
    key: 'promotionGrossMargin',
    width: 100
  }, {
    title: '备货量/件',
    dataIndex: 'stockUpQty',
    key: 'stockUpQty',
    width: 150,
    type: 'INPUT',
    fieldOptions: (t, r) => {
      return {
        disabled: (t === null || t === void 0 ? void 0 : t.statusStr) === '已取消' || t.isExpire,
        formatter: value => (0,_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exchageToNum2 */ .Tn)(value)
      };
    }
  }, {
    title: '预估日店均销量/件',
    dataIndex: 'estimatedDayPlaceAvgSales',
    key: 'estimatedDayPlaceAvgSales',
    width: 100
  }, {
    title: '预估销量',
    dataIndex: 'estimatedSales',
    key: 'estimatedSales',
    width: 100
  }, {
    title: '预估销售',
    dataIndex: 'estimatedSalesPrice',
    key: 'estimatedSalesPrice',
    width: 100
  }, {
    title: '供应商',
    dataIndex: 'supplierName',
    key: 'supplierName',
    width: 150,
    type: 'INPUT',
    fieldOptions: (t, r) => {
      return {
        disabled: (t === null || t === void 0 ? void 0 : t.statusStr) === '已取消' || t.isExpire,
        maxLength: 10
      };
    }
  }, {
    title: '天气',
    dataIndex: 'weather',
    key: 'weather',
    width: 150,
    type: 'INPUT',
    fieldOptions: (t, r) => {
      return {
        disabled: (t === null || t === void 0 ? void 0 : t.statusStr) === '已取消' || t.isExpire
      };
    }
  }, ...(0,_useOperationClms__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(), {
    title: '操作',
    key: 'opened',
    align: 'center',
    width: 100,
    fixed: 'right',
    render: (text, record) => {
      return record.statusStr !== '已取消' && !record.isExpire && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_popconfirm__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
        title: "\u786E\u8BA4\u53D6\u6D88\u8FD9\u6761\u63A8\u52A8\u54C1\u5417\uFF1F",
        okText: "\u786E\u8BA4",
        cancelText: "\u5173\u95ED",
        onConfirm: () => optionFunc([record.id])
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("a", null, "\u53D6\u6D88"));
    }
  }];
}

/***/ }),

/***/ 56484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ExportType */
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57016);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71577);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48086);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_CommonTable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40934);







/**
 * 查看导出结果浮层
 */



var ExportType;

(function (ExportType) {
  ExportType[ExportType["\u5BFC\u51FA\u852C\u83DC\u4E3B\u63A8\u54C1"] = 6003] = "\u5BFC\u51FA\u852C\u83DC\u4E3B\u63A8\u54C1";
  ExportType[ExportType["\u5BFC\u51FA\u852C\u83DC\u4E3B\u63A8\u54C1\u5546\u5BB6\u5408\u8BA1"] = 6004] = "\u5BFC\u51FA\u852C\u83DC\u4E3B\u63A8\u54C1\u5546\u5BB6\u5408\u8BA1";
  ExportType[ExportType["\u5BFC\u51FA\u6C34\u679C\u4E3B\u63A8\u54C1"] = 6005] = "\u5BFC\u51FA\u6C34\u679C\u4E3B\u63A8\u54C1";
  ExportType[ExportType["\u5BFC\u51FA\u6C34\u679C\u4E3B\u63A8\u54C1\u5546\u5BB6\u5408\u8BA1"] = 6006] = "\u5BFC\u51FA\u6C34\u679C\u4E3B\u63A8\u54C1\u5546\u5BB6\u5408\u8BA1";
})(ExportType || (ExportType = {}));

function ExportModal(props) {
  var _props$taskType;

  var queryDataUrl = props.queryDataUrl,
      taskType = props.taskType,
      closeModalCallback = props.closeModalCallback,
      _props$visible = props.visible,
      visible = _props$visible === void 0 ? true : _props$visible;
  var table = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
  var searchParams = {
    query: {
      taskType: (_props$taskType = props.taskType) !== null && _props$taskType !== void 0 ? _props$taskType : ExportType.导出蔬菜主推品
    }
  };

  var downloadFile = url => {
    if (!url) {
      antd_es_message__WEBPACK_IMPORTED_MODULE_6__.default.error('不存在文件');

      return;
    }

    window.location.href = url;
  };

  var reloadTable = () => {
    table.current.reflashTable({
      query: {
        taskType
      }
    });
  };

  var columns = [{
    title: '任务单号',
    dataIndex: 'taskOrderNo',
    key: 'taskOrderNo',
    width: 160
  }, {
    title: '导出时间',
    dataIndex: 'gmtCreated',
    key: 'gmtCreated',
    width: 140,
    render: t => t ? moment__WEBPACK_IMPORTED_MODULE_4___default()(Number(t)).format('YYYY-MM-DD HH:mm:ss') : ''
  }, {
    title: '状态',
    dataIndex: 'taskStatus',
    key: 'taskStatus',
    width: 100,
    render: (_, r) => {
      return _.desc;
    }
  }, {
    title: '操作人',
    dataIndex: 'operator',
    key: 'operator',
    width: 120
  }, {
    title: '操作',
    dataIndex: 'operateeee',
    key: 'operateeee',
    width: 100,
    render: (_, r) => {
      return r.taskStatus.value === 4 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("a", {
        onClick: () => downloadFile(r.resultFile)
      }, "\u4E0B\u8F7D") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("a", {
        onClick: reloadTable
      }, "\u5237\u65B0");
    }
  }];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
    title: "\u67E5\u770B\u5BFC\u51FA\u7ED3\u679C",
    destroyOnClose: true,
    maskClosable: false,
    width: 800,
    visible: visible,
    onOk: closeModalCallback,
    onCancel: closeModalCallback,
    footer: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, {
      onClick: closeModalCallback
    }, "\u5173\u95ED")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_CommonTable__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    ref: table,
    searchParams: searchParams,
    columns: columns,
    queryDataUrl: queryDataUrl || 'kernel.console.BatchToolsService.queryExportHistoryTask'
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (ExportModal);

/***/ }),

/***/ 80049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBaseColumns; }
/* harmony export */ });
function useBaseColumns() {
  return [{
    title: '推动档期',
    dataIndex: 'kinoprogrammTimeSlot',
    key: 'kinoprogrammTimeSlot',
    width: 140
  }, {
    title: '城市',
    dataIndex: 'merchantName',
    key: 'merchantName',
    width: 150
  }, {
    title: '队形',
    dataIndex: 'placeGroupName',
    key: 'placeGroupName',
    width: 120
  }, {
    title: '门店数',
    dataIndex: 'placeNum',
    key: 'placeNum',
    width: 80
  }, {
    title: '状态',
    dataIndex: 'statusStr',
    key: 'statusStr',
    width: 80
  }, {
    title: '类型',
    dataIndex: 'typeStr',
    key: 'typeStr',
    width: 100
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 130
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 180
  }, {
    title: '单位',
    dataIndex: 'unit',
    key: 'unit',
    width: 80
  }];
}

/***/ }),

/***/ 34702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useOperationColumns; }
/* harmony export */ });
function useOperationColumns() {
  return [{
    title: '操作人',
    dataIndex: 'updateUserName',
    key: 'updateUserName',
    width: 100
  }, {
    title: '操作时间',
    dataIndex: 'gmtModified',
    key: 'gmtModified',
    width: 180
  }];
}

/***/ }),

/***/ 72837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(91896);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46565);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52054);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7704);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56196);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(65272);










/**
 * 批量更新
 */





var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 4
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 18
    }
  }
};

function BatchUpdateModal(props) {
  var poolingId = props.poolingId,
      batchType = props.batchType,
      closeModalCallback = props.closeModalCallback;
  var formbuilder = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)([_hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__/* .MappingKey["当前用户权限的供货DC"] */ .M["当前用户权限的供货DC"], _hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__/* .MappingKey["紧急程度"] */ .M["紧急程度"]]),
      mappingList = _useMapping.mappingList;

  var dcList = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    if (batchType === _config__WEBPACK_IMPORTED_MODULE_5__/* .BatchUpdateType["供货路径"] */ .U4["供货路径"]) {
      return [{
        value: 1,
        label: '台州仓-城市仓-城市店'
      }, {
        value: 2,
        label: '台州仓-城市仓'
      }, {
        value: 3,
        label: '台州仓-城市店'
      }];
    } else if (batchType === _config__WEBPACK_IMPORTED_MODULE_5__/* .BatchUpdateType["紧急程度"] */ .U4["紧急程度"]) {
      return mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__/* .MappingKey["紧急程度"] */ .M["紧急程度"]);
    } else {
      return mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__/* .MappingKey["当前用户权限的供货DC"] */ .M["当前用户权限的供货DC"]);
    }
  }, [mappingList, batchType]); // 保存

  var handleOk = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)().mark(function _callee() {
    var _formbuilder$current;

    var values, params, url, res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (_formbuilder$current = formbuilder.current) === null || _formbuilder$current === void 0 ? void 0 : _formbuilder$current.getFieldsValue();

          case 2:
            values = _context.sent;

            if (values.modifyDeliveryDcId) {
              _context.next = 6;
              break;
            }

            antd_es_message__WEBPACK_IMPORTED_MODULE_9__.default.error('请选择批量更新的内容');

            return _context.abrupt("return");

          case 6:
            params = {};
            url = _api__WEBPACK_IMPORTED_MODULE_10__/* .DURABLE_BATCH_UPDATE */ .$D;

            if (batchType === _config__WEBPACK_IMPORTED_MODULE_5__/* .BatchUpdateType["供货路径"] */ .U4["供货路径"]) {
              params = {
                query: {
                  poolingId
                },
                modifyInfo: {
                  supplyRoute: values === null || values === void 0 ? void 0 : values.modifyDeliveryDcId
                }
              };
            } else if (batchType === _config__WEBPACK_IMPORTED_MODULE_5__/* .BatchUpdateType["紧急程度"] */ .U4["紧急程度"]) {
              params = {
                query: {
                  poolingId
                },
                modifyInfo: {
                  emergLevel: values === null || values === void 0 ? void 0 : values.modifyDeliveryDcId
                }
              };
            } else {
              // 不确定格式
              params = {
                modifyDeliveryDcId: values === null || values === void 0 ? void 0 : values.modifyDeliveryDcId,
                poolingId
              };
              url = _api__WEBPACK_IMPORTED_MODULE_11__/* .BATCH_MODIFY_DC */ .sH;
            }

            _context.next = 11;
            return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .YpRequest */ .XQ)(url, params);

          case 11:
            res = _context.sent;

            if (!res.success) {
              _context.next = 15;
              break;
            }

            antd_es_message__WEBPACK_IMPORTED_MODULE_9__.default.success('批量更新成功');

            return _context.abrupt("return", closeModalCallback());

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [batchType, poolingId, closeModalCallback]);
  var elements = [batchType === _config__WEBPACK_IMPORTED_MODULE_5__/* .BatchUpdateType["供货路径"] */ .U4["供货路径"] && {
    label: ' ',
    name: 'deliveryDcId',
    type: 'RADIO',
    dataList: [{
      value: 1,
      label: '供货路径'
    }]
  }, batchType === _config__WEBPACK_IMPORTED_MODULE_5__/* .BatchUpdateType["紧急程度"] */ .U4["紧急程度"] && {
    label: ' ',
    name: 'deliveryDcId',
    type: 'RADIO',
    dataList: [{
      value: 1,
      label: '紧急程度'
    }]
  }, batchType === _config__WEBPACK_IMPORTED_MODULE_5__/* .BatchUpdateType["配送仓"] */ .U4["配送仓"] && {
    label: ' ',
    name: 'deliveryDcId',
    type: 'RADIO',
    dataList: [{
      value: 1,
      label: '配送仓'
    }]
  }, {
    label: ' ',
    name: 'modifyDeliveryDcId',
    type: 'SELECT',
    dataList: dcList || []
  }].filter(Boolean);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
    title: "\u6279\u91CF\u66F4\u65B0",
    destroyOnClose: true,
    maskClosable: false,
    width: 400,
    visible: true,
    onCancel: closeModalCallback,
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
      key: "cancel",
      onClick: closeModalCallback
    }, "\u53D6\u6D88"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
      type: "primary",
      key: "ok",
      onClick: handleOk
    }, "\u786E\u8BA4")]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .FormBuilder */ .qu, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, defaultFormItemLayout, {
    colon: false,
    formRef: formbuilder,
    elements: elements,
    initialValues: {
      deliveryDcId: 1
    },
    notSearchForm: true
  })));
}

/* harmony default export */ __webpack_exports__["default"] = (BatchUpdateModal);

/***/ }),

/***/ 35997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(91896);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93224);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46565);
/* harmony import */ var _components_FormCategorySelect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45199);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7704);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(65272);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26715);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21859);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24731);












var _excluded = ["category"];

/**
 * 商品清退
 */








var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 4
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 18
    }
  }
};

function GoodsModal(props) {
  var formData = props.formData,
      childPlaceList = props.childPlaceList,
      bussinessType = props.bussinessType;
  var formbuilder = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
  var isFresh = ___WEBPACK_IMPORTED_MODULE_8__.BussinessType["生鲜"] === bussinessType; // 表格查询参数

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_useState, 2),
      searchParams = _useState2[0],
      setSearchParams = _useState2[1]; // 正在保存商品行


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_useState3, 2),
      isSaving = _useState4[0],
      setIsSaving = _useState4[1];

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)([_hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__/* .MappingKey["所有品类"] */ .M["所有品类"]]),
      mappingList = _useMapping.mappingList;

  var categoryList = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_6__/* .MappingKey["所有品类"] */ .M["所有品类"]), [mappingList]); // 取消请求数据

  var cancelRequest = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    return !(searchParams !== null && searchParams !== void 0 && searchParams.condition.placeId);
  }, [searchParams === null || searchParams === void 0 ? void 0 : searchParams.condition.placeId]); // 查询

  var handleSearch = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(values => {
    var category = values.category,
        rest = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(values, _excluded);

    var params = {
      billType: _config_enums__WEBPACK_IMPORTED_MODULE_7__/* .BILL_TYPE["要货集单"] */ .$M["要货集单"],
      condition: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)({}, rest), {}, {
        firstCategoryId: formData === null || formData === void 0 ? void 0 : formData.firstCategoryId,
        secondCategoryId: formData === null || formData === void 0 ? void 0 : formData.secondCategoryId,
        merchantId: formData === null || formData === void 0 ? void 0 : formData.merchantId,
        logisticMode: formData !== null && formData !== void 0 && formData.logistics ? [formData === null || formData === void 0 ? void 0 : formData.logistics] : undefined
      })
    };
    setSearchParams(params);
  }, [formData === null || formData === void 0 ? void 0 : formData.firstCategoryId, formData === null || formData === void 0 ? void 0 : formData.logistics, formData === null || formData === void 0 ? void 0 : formData.merchantId, formData === null || formData === void 0 ? void 0 : formData.secondCategoryId]); // 保存行

  var saveRowCallback = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().mark(function _callee(data) {
      var currentCellOldData, currentRow, params, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currentCellOldData = data.currentCellOldData, currentRow = data.currentRow;
              params = {
                poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId,
                detail: {
                  id: currentRow.id,
                  placeId: currentRow.placeId,
                  goodsId: currentRow.goodsId,
                  barCode: currentRow.goodsBarCode,
                  demandNum: 1,
                  // 需求数量 固定
                  approveNum: currentRow.approveNum || 0,
                  // 审核数量
                  supplierCode: currentRow.supplierCode,
                  // 供应商编码
                  logistics: currentRow.logistic,
                  // 物流模式：1直送；2配送；3直通
                  unitPrice: currentRow.unitPrice,
                  merchantId: currentRow === null || currentRow === void 0 ? void 0 : currentRow.merchantId,
                  deliveryDcId: currentRow.logistic === 1 ? '0' : currentRow.deliveryDcId,
                  emergLevel: 1,
                  // 默认 正常
                  supplyRoute: 1 // 默认 台州仓-城市仓-城市店

                }
              };
              setIsSaving(true);
              _context.next = 5;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_15__/* .SAVE_PLACE_GOODS */ .xq, params);

            case 5:
              res = _context.sent;
              setIsSaving(false);

              if (!res.success) {
                _context.next = 12;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.success('保存商品成功');

              return _context.abrupt("return", (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)({}, currentRow), {}, {
                id: res.result.id
              }));

            case 12:
              return _context.abrupt("return", currentCellOldData);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [formData === null || formData === void 0 ? void 0 : formData.poolingId]);
  var elements = [{
    label: '地点',
    name: 'placeId',
    type: 'SELECT',
    required: true,
    dataList: childPlaceList || []
  }, {
    label: '商品信息',
    name: 'queryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/编码/名称/PLU'
    }
  }, {
    label: '品牌名称',
    name: 'brandName',
    type: 'INPUT'
  }, {
    label: '品类',
    name: 'category',
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_FormCategorySelect__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
      categoryList: categoryList,
      formValue: {
        first: formData === null || formData === void 0 ? void 0 : formData.firstCategoryId,
        second: formData === null || formData === void 0 ? void 0 : formData.secondCategoryId
      },
      firstProps: {
        disabled: true
      },
      secondProps: {
        disabled: isFresh
      }
    })
  }];
  var columns = [{
    title: '商品编码',
    dataIndex: 'goodsId',
    width: 100
  }, {
    title: '商品条码',
    dataIndex: 'goodsBarCode',
    width: 130
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    width: 170
  }, {
    title: '二类名称',
    dataIndex: 'secondCategoryName',
    width: 130
  }, {
    title: '审核数量',
    dataIndex: 'approveNum',
    width: 140,
    type: 'INPUT'
  }, {
    title: '品牌名称',
    dataIndex: 'brandName',
    width: 130
  }, {
    title: '规格',
    dataIndex: 'orderSpecification',
    width: 80
  }, {
    title: '单位',
    dataIndex: 'orderSpecificationUnit',
    width: 80
  }];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z, {
    title: "\u5546\u54C1\u9009\u62E9",
    destroyOnClose: true,
    maskClosable: false,
    width: 1200,
    visible: true,
    onCancel: props.closeModalCallback,
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
      key: "cancel",
      disabled: isSaving,
      onClick: props.closeModalCallback
    }, "\u5173\u95ED")]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .FormBuilder */ .qu, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)({}, defaultFormItemLayout, {
    formRef: formbuilder,
    elements: elements,
    onSearch: handleSearch
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .EnhanceTable */ .UO, {
    cancelRequest: cancelRequest,
    searchParams: searchParams,
    columns: columns,
    requestUrl: _api__WEBPACK_IMPORTED_MODULE_15__/* .ADD_GOODS_LIST */ .gA,
    saveRowCallback: saveRowCallback
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (GoodsModal);

/***/ }),

/***/ 60431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(8870);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71720);
/* harmony import */ var _components_Uploader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84843);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46565);
/* harmony import */ var _BatchUpdateModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72837);
/* harmony import */ var _hooks_useLoopImport__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88242);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(83987);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(90631);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(65272);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(56196);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52054);
/* harmony import */ var _GoodsModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35997);











/* eslint-disable no-async-promise-executor */











function HandleBtn(props) {
  var formData = props.formData,
      exitSavedGoods = props.exitSavedGoods,
      exitGoods = props.exitGoods,
      bussinessType = props.bussinessType,
      importUrl = props.importUrl,
      templateType = props.templateType,
      afterHandleCallback = props.afterHandleCallback;
  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_10__/* .useDispatch */ .I0)();

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_config__WEBPACK_IMPORTED_MODULE_8__/* .CollectionContext */ .WH),
      childPlaceList = _useContext.childPlaceList; // 无法操作


  var disabledBtn = !(formData !== null && formData !== void 0 && formData.id);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState, 2),
      goodsModalVisible = _useState2[0],
      setGoodsModalVisible = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    batchType: undefined,
    visible: false
  }),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState3, 2),
      batchModal = _useState4[0],
      setBatchModal = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    stock: false,
    errorReason: false
  }),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState5, 2),
      btnLoading = _useState6[0],
      setBtnLoading = _useState6[1];

  var _useLoopImport = (0,_hooks_useLoopImport__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({
    request: {
      url: 'scm.require.getLastImportResult',
      params: {
        businessType: props.importLoopRequestType,
        orderNo: (formData === null || formData === void 0 ? void 0 : formData.poolingId) || ''
      }
    },
    refreshCallback: afterHandleCallback
  }),
      loading = _useLoopImport.loading,
      loadingModal = _useLoopImport.loadingModal,
      startLoop = _useLoopImport.startLoop;

  var changeUpload = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee(val) {
      var params, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              params = {
                poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId,
                resId: val
              };
              _context.next = 4;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_5__/* .YpRequest */ .XQ)(importUrl, params);

            case 4:
              res = _context.sent;

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.success('导入任务添加成功'); // 开始轮训


                startLoop();
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.error(_context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [formData === null || formData === void 0 ? void 0 : formData.poolingId, importUrl, startLoop]); // 下载

  var downloadTemplate = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee2() {
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return dispatch({
              type: 'purchase/downloadGoodsTemplate',
              payload: {
                downloadType: templateType
              }
            });

          case 3:
            _context2.next = 8;
            break;

          case 5:
            _context2.prev = 5;
            _context2.t0 = _context2["catch"](0);

            antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.error(_context2.t0);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 5]]);
  })), [dispatch, templateType]); // 清空商品

  var clearGoods = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    antd_es_modal__WEBPACK_IMPORTED_MODULE_15__/* .default.confirm */ .Z.confirm({
      title: '清空商品',
      icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, null),
      content: '确认清空全部商品吗？',
      okText: '确认',
      cancelText: '取消',

      onOk() {
        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee3() {
          var res;
          return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_5__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_17__/* .CLEAR_GOODS */ .NN, {
                    poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId
                  });

                case 2:
                  res = _context3.sent;

                  if (res.success) {
                    afterHandleCallback();

                    antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.success('清空商品成功');
                  }

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      }

    });
  }, [afterHandleCallback, formData === null || formData === void 0 ? void 0 : formData.poolingId]); // 刷新大仓库存

  var reloadStock = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee4() {
    var res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            setBtnLoading(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)({}, v), {}, {
              stock: true
            }));
            _context4.next = 3;
            return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_5__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_17__/* .REFRESH_STOCK */ .H, {
              poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId
            });

          case 3:
            res = _context4.sent;
            setBtnLoading(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)({}, v), {}, {
              stock: false
            }));

            if (!res.success) {
              _context4.next = 8;
              break;
            }

            antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.success('刷新大仓库存成功');

            return _context4.abrupt("return", afterHandleCallback());

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  })), [formData === null || formData === void 0 ? void 0 : formData.poolingId, afterHandleCallback]); // 刷新异常原因

  var reloadErrorReason = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee6() {
    var result, loopResult;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            setBtnLoading(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)({}, v), {}, {
              errorReason: true
            }));
            _context6.next = 3;
            return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_5__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_19__/* .DURABLE_REFRESH_ERROR */ .p1, {
              poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId
            });

          case 3:
            result = _context6.sent;

            if (result.success) {
              _context6.next = 7;
              break;
            }

            setBtnLoading(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)({}, v), {}, {
              errorReason: false
            }));
            return _context6.abrupt("return");

          case 7:
            loopResult = /*#__PURE__*/function () {
              var _ref5 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee5() {
                var res;
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_5__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_19__/* .DURABLE_REFRESH_LOOP */ .Np, {
                          poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId
                        });

                      case 2:
                        res = _context5.sent;

                        if (res.success) {
                          _context5.next = 5;
                          break;
                        }

                        return _context5.abrupt("return");

                      case 5:
                        if (!res.result.succ) {
                          _context5.next = 11;
                          break;
                        }

                        setBtnLoading(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)({}, v), {}, {
                          errorReason: false
                        }));

                        antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.success('异常原因检测完毕');

                        return _context5.abrupt("return", afterHandleCallback());

                      case 11:
                        loopResult();

                      case 12:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));

              return function loopResult() {
                return _ref5.apply(this, arguments);
              };
            }();

            loopResult();

          case 9:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  })), [formData === null || formData === void 0 ? void 0 : formData.poolingId, afterHandleCallback]); // 关闭浮层回调

  var closeModalCallback = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    setGoodsModalVisible(false);
    afterHandleCallback();
  }, [afterHandleCallback]); // 批量更新供货路径

  var batchUpdateRoute = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    setBatchModal({
      batchType: _config__WEBPACK_IMPORTED_MODULE_8__/* .BatchUpdateType["供货路径"] */ .U4["供货路径"],
      visible: true
    });
  }, []); // 批量更新配送仓

  var batchUpdateWarehouse = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    setBatchModal({
      batchType: _config__WEBPACK_IMPORTED_MODULE_8__/* .BatchUpdateType["配送仓"] */ .U4["配送仓"],
      visible: true
    });
  }, []); // 批量更新紧急程度

  var batchUpdateEmergLevel = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    setBatchModal({
      batchType: _config__WEBPACK_IMPORTED_MODULE_8__/* .BatchUpdateType["紧急程度"] */ .U4["紧急程度"],
      visible: true
    });
  }, []);
  var closeBatchModalCallback = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    setBatchModal(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)({}, v), {}, {
      visible: false
    }));
    afterHandleCallback();
  }, [afterHandleCallback]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
    type: "primary",
    disabled: disabledBtn,
    className: "mRight16",
    onClick: () => setGoodsModalVisible(true)
  }, "\u6DFB\u52A0\u5546\u54C1"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
    className: "mRight16"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_Uploader__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    tokenUrl: "scm.require.getResourceToken",
    accept: ".xlsx,.xls",
    onChange: changeUpload,
    loading: loading,
    btnText: "\u6279\u91CF\u5BFC\u5165",
    uploadOptions: {
      showUploadList: false,
      disabled: exitGoods || disabledBtn
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
    className: "mRight16",
    onClick: downloadTemplate,
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_21__/* .default */ .Z, null)
  }, "\u6A21\u677F\u4E0B\u8F7D"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
    className: "mRight16",
    danger: true,
    disabled: !exitGoods,
    onClick: clearGoods
  }, "\u6E05\u7A7A\u5546\u54C1"), bussinessType !== _config__WEBPACK_IMPORTED_MODULE_8__/* .BussinessType["耐用品"] */ .fQ["耐用品"] ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
    type: "primary",
    loading: btnLoading.stock,
    disabled: !exitSavedGoods || disabledBtn,
    className: "mRight16",
    onClick: reloadStock
  }, "\u5237\u65B0\u5927\u4ED3\u5E93\u5B58"), bussinessType === _config__WEBPACK_IMPORTED_MODULE_8__/* .BussinessType["生鲜"] */ .fQ["生鲜"] ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
    onClick: batchUpdateWarehouse,
    disabled: !exitSavedGoods || disabledBtn
  }, "\u6279\u91CF\u66F4\u65B0\u914D\u9001\u4ED3") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
    onClick: batchUpdateEmergLevel,
    disabled: !exitSavedGoods || disabledBtn
  }, "\u6279\u91CF\u66F4\u65B0\u7D27\u6025\u7A0B\u5EA6")) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
    type: "primary",
    className: "mRight16",
    disabled: !exitSavedGoods || disabledBtn,
    onClick: reloadErrorReason
  }, "\u5237\u65B0\u5F02\u5E38\u539F\u56E0"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
    onClick: batchUpdateRoute,
    disabled: !exitSavedGoods || disabledBtn
  }, "\u6279\u91CF\u66F4\u65B0\u4F9B\u8D27\u8DEF\u5F84")), batchModal.visible && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_BatchUpdateModal__WEBPACK_IMPORTED_MODULE_6__.default, {
    poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId,
    batchType: batchModal.batchType,
    closeModalCallback: closeBatchModalCallback
  }), goodsModalVisible && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_GoodsModal__WEBPACK_IMPORTED_MODULE_9__.default, {
    formData: formData,
    childPlaceList: childPlaceList,
    bussinessType: bussinessType,
    closeModalCallback: closeModalCallback
  }), loadingModal);
}

/* harmony default export */ __webpack_exports__["default"] = (HandleBtn);

/***/ }),

/***/ 57924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8870);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93224);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46565);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65272);
/* harmony import */ var _useExtData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8624);







var _excluded = ["formData", "placeTableRef", "getApproveSummary", "handleReload"];

/**
 * 地点维度表格
 */





function PlaceDemandTable(props) {
  var formData = props.formData,
      placeTableRef = props.placeTableRef,
      getApproveSummary = props.getApproveSummary,
      handleReload = props.handleReload,
      restProps = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(props, _excluded); // 获取额外参数


  var concatExtData = (0,_useExtData__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(formData === null || formData === void 0 ? void 0 : formData.firstCategoryId, formData === null || formData === void 0 ? void 0 : formData.merchantId); // 地点维度

  var afterPlaceRequest = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().mark(function _callee(data) {
      var list;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return concatExtData(data);

            case 2:
              list = _context.sent;

              if (restProps.afterRequest) {
                requestAnimationFrame(() => {
                  restProps.afterRequest(data);
                });
              }

              return _context.abrupt("return", list);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [concatExtData, restProps.afterRequest]); // 保存地点维度商品

  var savePlaceRowCallback = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().mark(function _callee2(data) {
      var currentCell, currentRow, currentRowOldData, deliveryDcId, _currentRow$dc, defaultDC, params, res;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currentCell = data.currentCell, currentRow = data.currentRow, currentRowOldData = data.currentRowOldData; // 不是直送时  大仓必选

              if (!(currentCell['deliveryDcId'] && currentRow.logistics !== 1 && !currentRow.deliveryDcId)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", antd_es_message__WEBPACK_IMPORTED_MODULE_7__.default.warn('请选择大仓'));

            case 3:
              deliveryDcId = currentRow.deliveryDcId;

              if (currentCell['logistics'] && Number(currentRow.deliveryDcId) === 0) {
                defaultDC = (_currentRow$dc = currentRow.dc) === null || _currentRow$dc === void 0 ? void 0 : _currentRow$dc.find(d => d.isDefault);

                if (defaultDC) {
                  deliveryDcId = defaultDC.deliveryDcId;
                }
              }

              console.log(currentRow);

              if (currentRow.supplierCode) {
                _context2.next = 9;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_7__.default.warning('请选择供应商');

              return _context2.abrupt("return");

            case 9:
              if (currentRow.logistics) {
                _context2.next = 12;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_7__.default.warning('请选择物流模式');

              return _context2.abrupt("return");

            case 12:
              params = {
                poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId,
                detail: {
                  id: currentRow.id,
                  placeId: currentRow.placeId,
                  goodsId: currentRow.goodsId,
                  barCode: currentRow.barCode,
                  demandNum: currentRow.demandNum,
                  // 需求数量
                  approveNum: currentRow.approveNum || 0,
                  // 审核数量
                  supplierCode: currentRow.supplierCode,
                  // 供应商编码
                  logistics: currentRow.logistics,
                  // 物流模式：1直送；2配送；3直通
                  deliveryDcId,
                  unitPrice: currentRow.unitPrice,
                  merchantId: formData === null || formData === void 0 ? void 0 : formData.merchantId,
                  supplyRoute: currentRow.supplyRoute,
                  // 供货路径
                  emergLevel: currentRow.emergLevel,
                  fatness: Array.isArray(currentRow.fatness) ? undefined : currentRow.fatness,
                  referneceWeight: Array.isArray(currentRow.referneceWeight) ? undefined : currentRow.referneceWeight
                }
              };
              _context2.next = 15;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_8__/* .SAVE_PLACE_GOODS */ .xq, params);

            case 15:
              res = _context2.sent;

              if (!res.success) {
                _context2.next = 22;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_7__.default.success('修改成功');

              requestAnimationFrame(() => {
                getApproveSummary();

                if (handleReload) {
                  handleReload(currentCell);
                }
              });
              return _context2.abrupt("return", (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, currentRow), {}, {
                id: res.result.id
              }));

            case 22:
              return _context2.abrupt("return", currentRowOldData);

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [formData === null || formData === void 0 ? void 0 : formData.poolingId, formData === null || formData === void 0 ? void 0 : formData.merchantId, getApproveSummary, handleReload]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .EnhanceTable */ .UO, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)({}, restProps, {
    tableRef: placeTableRef,
    requestUrl: _api__WEBPACK_IMPORTED_MODULE_8__/* .PLACE_DEMAND_LIST */ .Wc,
    afterRequest: afterPlaceRequest,
    saveRowCallback: savePlaceRowCallback
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (PlaceDemandTable);

/***/ }),

/***/ 65272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vC": function() { return /* binding */ CREATE_COLLECTION; },
/* harmony export */   "VT": function() { return /* binding */ IMPORT_FRESH_DETAIL; },
/* harmony export */   "gA": function() { return /* binding */ ADD_GOODS_LIST; },
/* harmony export */   "Wc": function() { return /* binding */ PLACE_DEMAND_LIST; },
/* harmony export */   "m": function() { return /* binding */ GOODS_DEMAND_LIST; },
/* harmony export */   "NN": function() { return /* binding */ CLEAR_GOODS; },
/* harmony export */   "xq": function() { return /* binding */ SAVE_PLACE_GOODS; },
/* harmony export */   "H": function() { return /* binding */ REFRESH_STOCK; },
/* harmony export */   "wL": function() { return /* binding */ GOODS_STAT; },
/* harmony export */   "ig": function() { return /* binding */ BATCH_MODIFY; },
/* harmony export */   "sH": function() { return /* binding */ BATCH_MODIFY_DC; },
/* harmony export */   "g$": function() { return /* binding */ UPDATE_STATUS; }
/* harmony export */ });
/* unused harmony export DEMAND_REFERENCE_PRICE */

/**
 * 创建集单主单
 */

var CREATE_COLLECTION = 'scm.require.pooling.saveDemandPooling';
/**
 * 生鲜集单导入
 */

var IMPORT_FRESH_DETAIL = 'scm.require.importFreshDemandPoolingDetail';
/**
 * 复杂商品查询
 */

var ADD_GOODS_LIST = 'scm.require.querySelectPlaceProductByCondition';
/**
 * 地点维度请求
 */

var PLACE_DEMAND_LIST = 'scm.require.durablePooling.queryGoodsDemandPoolingDetailList';
/**
 * 商品维度请求
 */

var GOODS_DEMAND_LIST = 'scm.require.durablePooling.queryGoodsDemandPoolingDetailList';
/**
 * 清空明细
 */

var CLEAR_GOODS = 'scm.require.pooling.clearDemandPoolingDetail';
/**
 * 保存地点维度商品
 */

var SAVE_PLACE_GOODS = 'scm.require.pooling.saveAndUpdatePoolingDetail';
/**
 * 刷新大仓库存
 */

var REFRESH_STOCK = 'scm.require.pooling.refreshStock';
/**
 * 审核汇总信息
 */

var GOODS_STAT = 'scm.require.durablePooling.statGoodsPoolingDetailInfo';
/**
 * 批量更新
 */

var BATCH_MODIFY = 'scm.require.pooling.batchModifyDetail';
/**
 * 更新
 */

var BATCH_MODIFY_DC = 'scm.require.pooling.batchModifyDeliveryDc';
/**
 * 获取参考价等
 */

var DEMAND_REFERENCE_PRICE = 'scm.require.queryDemandPoolingReferencePrice';
/**
 * 审核
 */

var UPDATE_STATUS = 'scm.require.pooling.updateDurablePoolingStatus';

/***/ }),

/***/ 52054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fQ": function() { return /* binding */ BussinessType; },
/* harmony export */   "U4": function() { return /* binding */ BatchUpdateType; },
/* harmony export */   "V7": function() { return /* binding */ RouteUrl; },
/* harmony export */   "qp": function() { return /* binding */ CreateCollectionContext; },
/* harmony export */   "WH": function() { return /* binding */ CollectionContext; }
/* harmony export */ });
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26715);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65272);



var BussinessType;

(function (BussinessType) {
  BussinessType[BussinessType["\u751F\u9C9C"] = 0] = "\u751F\u9C9C";
  BussinessType[BussinessType["\u5FEB\u6D88"] = 1] = "\u5FEB\u6D88";
  BussinessType[BussinessType["\u8010\u7528\u54C1"] = 2] = "\u8010\u7528\u54C1";
})(BussinessType || (BussinessType = {}));

var BatchUpdateType;

(function (BatchUpdateType) {
  BatchUpdateType[BatchUpdateType["\u4F9B\u8D27\u8DEF\u5F84"] = 0] = "\u4F9B\u8D27\u8DEF\u5F84";
  BatchUpdateType[BatchUpdateType["\u7D27\u6025\u7A0B\u5EA6"] = 1] = "\u7D27\u6025\u7A0B\u5EA6";
  BatchUpdateType[BatchUpdateType["\u914D\u9001\u4ED3"] = 2] = "\u914D\u9001\u4ED3";
})(BatchUpdateType || (BatchUpdateType = {}));

var RouteUrl;
/**
 * 新增集单上下文
 */

(function (RouteUrl) {
  RouteUrl["\u751F\u9C9C"] = "/NewCentralManage/FreshSupplement";
  RouteUrl["\u5FEB\u6D88"] = "/NewCentralManage/QuickSaleSupplement";
  RouteUrl["\u8010\u7528\u54C1"] = "/NewCentralManage/DurableGoods";
})(RouteUrl || (RouteUrl = {}));

var CreateCollectionContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  bussinessType: BussinessType.快消,
  importUrl: _api__WEBPACK_IMPORTED_MODULE_2__/* .IMPORT_FRESH_DETAIL */ .VT,
  logisticsList: [],
  placeColumns: [],
  goodsColumns: [],
  importLoopRequestType: _config_enums__WEBPACK_IMPORTED_MODULE_0__/* .enumPurchaseImportStatusType["集单耐用品明细"] */ .Pb["集单耐用品明细"],
  templateType: _config_enums__WEBPACK_IMPORTED_MODULE_0__/* .enumPurchaseDownloadType.QUICK_TEMPLATE */ .Zz.QUICK_TEMPLATE,
  getFormDataCallback: undefined
});
var CollectionContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  formData: undefined,
  childPlaceList: []
});

/***/ }),

/***/ 21859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BussinessType": function() { return /* reexport safe */ _config__WEBPACK_IMPORTED_MODULE_9__.fQ; },
/* harmony export */   "CreateCollectionContext": function() { return /* reexport safe */ _config__WEBPACK_IMPORTED_MODULE_9__.qp; }
/* harmony export */ });
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(71577);
/* harmony import */ var antd_es_divider_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48736);
/* harmony import */ var antd_es_divider__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(27049);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(91896);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2824);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(93224);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5977);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46565);
/* harmony import */ var _components_BigTitle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70400);
/* harmony import */ var _components_ComplexTable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97275);
/* harmony import */ var _HandleBtn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60431);
/* harmony import */ var _useFormfields__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72488);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52054);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(65272);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25546);
/* harmony import */ var _components_FixedBottomCps__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(32065);












var _excluded = ["bussinessType", "getFormDataCallback", "goodsColumns", "placeColumns"],
    _excluded2 = ["category"];

/**
 * 新增集单
 */












function CreateCollection() {
  var _history$location$que;

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_config__WEBPACK_IMPORTED_MODULE_9__/* .CreateCollectionContext */ .qp),
      bussinessType = _useContext.bussinessType,
      getFormDataCallback = _useContext.getFormDataCallback,
      goodsColumns = _useContext.goodsColumns,
      placeColumns = _useContext.placeColumns,
      restContext = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useContext, _excluded);

  var history = (0,umi__WEBPACK_IMPORTED_MODULE_13__/* .useHistory */ .k6)();
  var autoFormRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null); // 地点维度的ref

  var placeTableRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null); // 商品维度的ref

  var goodsTableRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null); // 主单信息

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    poolingId: (_history$location$que = history.location.query) === null || _history$location$que === void 0 ? void 0 : _history$location$que.poolingId
  }),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState, 2),
      formData = _useState2[0],
      setFormData = _useState2[1]; // 商家下的地点


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState3, 2),
      childPlaceList = _useState4[0],
      setChildPlaceList = _useState4[1]; // 汇总信息


  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState5, 2),
      statistics = _useState6[0],
      setStatistics = _useState6[1]; // 是否存在已保存的商品\存在商品


  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    exitSavedGoods: false,
    exitGoods: false,
    exitNotSaved: false
  }),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState7, 2),
      goodsStatus = _useState8[0],
      setGoodsStatus = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState9, 2),
      btnLoading = _useState10[0],
      setBtnLoading = _useState10[1]; // 取消请求


  var cancelRequest = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => !(formData !== null && formData !== void 0 && formData.id), [formData === null || formData === void 0 ? void 0 : formData.id]); // 允许提交

  var canCommit = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    return !goodsStatus.exitNotSaved && (formData === null || formData === void 0 ? void 0 : formData.id) && goodsStatus.exitGoods;
  }, [formData === null || formData === void 0 ? void 0 : formData.id, goodsStatus.exitGoods, goodsStatus.exitNotSaved]); // 返回主页的url

  var mainRouteUrl = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    if (bussinessType === _config__WEBPACK_IMPORTED_MODULE_9__/* .BussinessType["快消"] */ .fQ["快消"]) {
      return _config__WEBPACK_IMPORTED_MODULE_9__/* .RouteUrl["快消"] */ .V7["快消"];
    } else if (bussinessType === _config__WEBPACK_IMPORTED_MODULE_9__/* .BussinessType["生鲜"] */ .fQ["生鲜"]) {
      return _config__WEBPACK_IMPORTED_MODULE_9__/* .RouteUrl["生鲜"] */ .V7["生鲜"];
    } else {
      return _config__WEBPACK_IMPORTED_MODULE_9__/* .RouteUrl["耐用品"] */ .V7["耐用品"];
    }
  }, [bussinessType]); // 请求参数

  var searchParams = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    return {
      condition: {
        poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId,
        logistics: formData === null || formData === void 0 ? void 0 : formData.logistics,
        firstCategoryId: formData === null || formData === void 0 ? void 0 : formData.firstCategoryId,
        secondCategoryId: formData === null || formData === void 0 ? void 0 : formData.secondCategoryId,
        merchantId: formData === null || formData === void 0 ? void 0 : formData.merchantId
      }
    };
  }, [formData === null || formData === void 0 ? void 0 : formData.firstCategoryId, formData === null || formData === void 0 ? void 0 : formData.logistics, formData === null || formData === void 0 ? void 0 : formData.merchantId, formData === null || formData === void 0 ? void 0 : formData.poolingId, formData === null || formData === void 0 ? void 0 : formData.secondCategoryId]); // 一级品类默认值

  var initCategory = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    if (bussinessType === _config__WEBPACK_IMPORTED_MODULE_9__/* .BussinessType["生鲜"] */ .fQ["生鲜"]) {
      return {
        first: 10
      };
    } else {
      return {
        first: 20
      };
    }
  }, [bussinessType]); // 表单项内容

  var formfields = (0,_useFormfields__WEBPACK_IMPORTED_MODULE_8__.default)(initCategory, setChildPlaceList, goodsStatus.exitGoods); // 保存主单

  var saveForm = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee(values) {
      var category, rest, categoryData, params, res, _autoFormRef$current, id;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              category = values.category, rest = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(values, _excluded2);
              categoryData = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)({}, initCategory), category ? category : {});
              params = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)({}, rest), {}, {
                firstCategoryId: categoryData === null || categoryData === void 0 ? void 0 : categoryData.first,
                secondCategoryId: categoryData === null || categoryData === void 0 ? void 0 : categoryData.second,
                demandType: 1,
                // 1补货；2退货  现阶段只有正向补货
                poolingDurableType: [_config__WEBPACK_IMPORTED_MODULE_9__/* .BussinessType["快消"] */ .fQ["快消"], _config__WEBPACK_IMPORTED_MODULE_9__/* .BussinessType["生鲜"] */ .fQ["生鲜"]].includes(bussinessType) ? 1 : 3
              });
              _context.next = 5;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_18__/* .CREATE_COLLECTION */ .vC, params);

            case 5:
              res = _context.sent;

              if (res.success) {
                id = res.result.id;
                (_autoFormRef$current = autoFormRef.current) === null || _autoFormRef$current === void 0 ? void 0 : _autoFormRef$current.setFieldsValue({
                  id
                });
                setFormData((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)({}, params), {}, {
                  id
                }));
              }

              return _context.abrupt("return", res.success);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [bussinessType, initCategory]); // 获取汇总信息

  var getApproveSummary = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee2() {
    var condition, res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            condition = {
              poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId,
              logistics: formData === null || formData === void 0 ? void 0 : formData.logistics,
              firstCategoryId: formData === null || formData === void 0 ? void 0 : formData.firstCategoryId,
              secondCategoryId: formData === null || formData === void 0 ? void 0 : formData.secondCategoryId,
              merchantId: formData === null || formData === void 0 ? void 0 : formData.merchantId
            };
            _context2.next = 3;
            return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_18__/* .GOODS_STAT */ .wL, {
              condition
            });

          case 3:
            res = _context2.sent;

            if (res.success) {
              setStatistics(res.result);
            }

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [formData === null || formData === void 0 ? void 0 : formData.firstCategoryId, formData === null || formData === void 0 ? void 0 : formData.logistics, formData === null || formData === void 0 ? void 0 : formData.merchantId, formData === null || formData === void 0 ? void 0 : formData.poolingId, formData === null || formData === void 0 ? void 0 : formData.secondCategoryId]); // 地点维度列表数据变化后会触发

  var placeDataChangeCallback = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(data => {
    setGoodsStatus(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)({}, v), {}, {
      exitSavedGoods: data === null || data === void 0 ? void 0 : data.some(v => !!v.id),
      exitNotSaved: !(data !== null && data !== void 0 && data.every(v => !!v.id))
    }));
  }, []); // 商品数据变化

  var goodsDataChangeCallback = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(data => {
    setGoodsStatus(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)({}, v), {}, {
      exitGoods: !!(data !== null && data !== void 0 && data.length)
    }));
  }, []); // 刷新列表项

  var afterHandleCallback = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    var _goodsTableRef$curren, _placeTableRef$curren;

    getApproveSummary();
    (_goodsTableRef$curren = goodsTableRef.current) === null || _goodsTableRef$curren === void 0 ? void 0 : _goodsTableRef$curren.reload();
    (_placeTableRef$curren = placeTableRef.current) === null || _placeTableRef$curren === void 0 ? void 0 : _placeTableRef$curren.reload();
  }, [getApproveSummary]);
  var submitOrder = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee3() {
    var _yield$YpRequest, success;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            setBtnLoading(true);
            _context3.next = 3;
            return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_18__/* .UPDATE_STATUS */ .g$, {
              poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId,
              operateType: _utils__WEBPACK_IMPORTED_MODULE_10__/* .APPROVE_STATUS_OPT["审核通过"] */ .l["审核通过"]
            });

          case 3:
            _yield$YpRequest = _context3.sent;
            success = _yield$YpRequest.success;
            setBtnLoading(false);

            if (success) {
              antd_es_message__WEBPACK_IMPORTED_MODULE_19__.default.success('审核成功');

              history.push(mainRouteUrl);
            }

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [formData === null || formData === void 0 ? void 0 : formData.poolingId, history, mainRouteUrl]); // 获取单号

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    var _history$location$que2;

    if ((_history$location$que2 = history.location.query) !== null && _history$location$que2 !== void 0 && _history$location$que2.poolingId) {
      return;
    }

    (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .YpRequest */ .XQ)('scm.require.getOrderIdByBizType', {
      bizType: 15
    }).then(res => {
      if (res.success && res.result.orderId) {
        var _autoFormRef$current2, _history$location$que3;

        history.push({
          pathname: history.location.pathname,
          query: {
            poolingId: res.result.orderId
          }
        }); // 设置单号默认值

        (_autoFormRef$current2 = autoFormRef.current) === null || _autoFormRef$current2 === void 0 ? void 0 : _autoFormRef$current2.setFieldsValue({
          poolingId: (_history$location$que3 = history.location.query) === null || _history$location$que3 === void 0 ? void 0 : _history$location$que3.poolingId
        });
      }
    });
  }, [history]); // 汇总

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (!(formData !== null && formData !== void 0 && formData.id)) {
      return;
    }

    getApproveSummary();
  }, [formData === null || formData === void 0 ? void 0 : formData.id, getApproveSummary]);
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (formData !== null && formData !== void 0 && formData.id && getFormDataCallback) {
      getFormDataCallback(formData);
    }
  }, [formData, formData === null || formData === void 0 ? void 0 : formData.id, getFormDataCallback]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_config__WEBPACK_IMPORTED_MODULE_9__/* .CollectionContext.Provider */ .WH.Provider, {
    value: {
      childPlaceList,
      formData
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
    className: "wrapStyle flex-fill"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_BigTitle__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    title: "\u57FA\u672C\u4FE1\u606F"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .AutoSaveForm */ .uC, {
    autoFormRef: autoFormRef,
    saveFormCallback: saveForm,
    elements: formfields
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_BigTitle__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    title: "\u5546\u54C1\u4FE1\u606F"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_HandleBtn__WEBPACK_IMPORTED_MODULE_7__.default, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)({}, restContext, {
    formData: formData,
    bussinessType: bussinessType,
    exitSavedGoods: goodsStatus.exitSavedGoods,
    exitGoods: goodsStatus.exitGoods,
    afterHandleCallback: afterHandleCallback
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
    className: "flex-fill text-right pt-1"
  }, bussinessType === _config__WEBPACK_IMPORTED_MODULE_9__/* .BussinessType["耐用品"] */ .fQ["耐用品"] && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
    style: {
      color: 'red'
    }
  }, "\u5546\u54C1\u5F02\u5E38 ", statistics === null || statistics === void 0 ? void 0 : statistics.abnormalGoodsCount), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_divider__WEBPACK_IMPORTED_MODULE_21__/* .default */ .Z, {
    type: "vertical"
  })), "\u4F9B\u5E94\u5546\u4E2A\u6570 ", statistics === null || statistics === void 0 ? void 0 : statistics.supplierCount, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_divider__WEBPACK_IMPORTED_MODULE_21__/* .default */ .Z, {
    type: "vertical"
  }), "\u79CD\u7C7B ", statistics === null || statistics === void 0 ? void 0 : statistics.skuNum, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_divider__WEBPACK_IMPORTED_MODULE_21__/* .default */ .Z, {
    type: "vertical"
  }), "\u7533\u8BF7\u603B\u6570 ", statistics === null || statistics === void 0 ? void 0 : statistics.totalApplyNum, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_divider__WEBPACK_IMPORTED_MODULE_21__/* .default */ .Z, {
    type: "vertical"
  }), "\u5BA1\u6838\u603B\u6570 ", statistics === null || statistics === void 0 ? void 0 : statistics.totalApproveNum), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_ComplexTable__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    goodsTableRef: goodsTableRef,
    formSearchData: searchParams.condition,
    placeTableRef: placeTableRef,
    bussinessType: _config__WEBPACK_IMPORTED_MODULE_9__/* .BussinessType["耐用品"] */ .fQ["耐用品"],
    queryApporeSummaryCallback: getApproveSummary,
    hideAddStoreBtn: true,
    goods: {
      columns: goodsColumns,
      cancelRequest,
      dataSourceChangeCallback: goodsDataChangeCallback
    },
    place: {
      columns: placeColumns,
      dataSourceChangeCallback: placeDataChangeCallback
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_FixedBottomCps__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z, {
    outerRE: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_22__/* .default */ .Z, {
      type: "primary",
      className: "mRight16",
      loading: btnLoading,
      disabled: !canCommit,
      onClick: submitOrder
    }, "\u63D0\u4EA4\u5E76\u5BA1\u6838"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_22__/* .default */ .Z, {
      onClick: () => history.push(mainRouteUrl)
    }, "\u4FDD\u5B58\u5E76\u8FD4\u56DE"))
  })));
}


/* harmony default export */ __webpack_exports__["default"] = (CreateCollection);

/***/ }),

/***/ 8624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2824);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46565);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25546);









function useExtData(firstCategoryId, merchantId) {
  // 额外参数
  var queryDemandPoolingExt = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee(data) {
      var params, res, extList;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = {
                needSupplier: true,
                needPlaceStock: true,
                needSale: true,
                needDc: true,
                param: data.map(item => ({
                  placeId: item.placeId,
                  goodsId: item.goodsId,
                  merchantId: item.merchantId,
                  firstCategoryId: item.firstCategoryId,
                  secondCategoryId: item.secondCategoryId
                }))
              };
              _context.next = 3;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .YpRequest */ .XQ)('scm.require.queryProductExtInfo', params);

            case 3:
              res = _context.sent;
              extList = res.result.list || [];
              return _context.abrupt("return", (0,lodash__WEBPACK_IMPORTED_MODULE_1__.keyBy)(extList, o => "".concat(o.goodsId, "-").concat(o.placeId)));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []); // 获取参考价

  var queryDemandReferencePrice = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee2(data) {
      var params, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = {
                orderDirect: _utils__WEBPACK_IMPORTED_MODULE_3__/* .DEMAND_TYPE.SUUPLEMENT */ .fb.SUUPLEMENT,
                // 订单方向
                firstCategoryId,
                // 一级类目ID
                merchantId,
                // 商家ID
                goodsList: data.map(item => ({
                  goodsId: item.goodsId,
                  // 商品 id
                  logistics: item.logistics,
                  // 物流模式
                  placeId: item.placeId,
                  // 地点ID
                  deliveryDcId: item.deliveryDcId // 大仓ID

                }))
              };
              _context2.next = 3;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .YpRequest */ .XQ)('scm.require.queryDemandPoolingReferencePrice', params);

            case 3:
              res = _context2.sent;
              return _context2.abrupt("return", (0,lodash__WEBPACK_IMPORTED_MODULE_1__.keyBy)(res.result.list, o => "".concat(o.goodsId, "-").concat(o.placeId)));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [firstCategoryId, merchantId]); // 拼接额外的参数

  var concatExtData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)( /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee3(data) {
      var _yield$Promise$allSet, _yield$Promise$allSet2, extObj, referObj, fir, sec;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (data.length) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", data);

            case 2:
              _context3.next = 4;
              return Promise.allSettled([queryDemandPoolingExt(data), queryDemandReferencePrice(data)]);

            case 4:
              _yield$Promise$allSet = _context3.sent;
              _yield$Promise$allSet2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_yield$Promise$allSet, 2);
              extObj = _yield$Promise$allSet2[0];
              referObj = _yield$Promise$allSet2[1];
              fir = extObj.status === 'fulfilled';
              sec = referObj.status === 'fulfilled';
              return _context3.abrupt("return", data.map(v => {
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({}, v), fir ? extObj.value["".concat(v.goodsId, "-").concat(v.placeId)] : {}), sec ? referObj.value["".concat(v.goodsId, "-").concat(v.placeId)] : {}), {}, {
                  deliveryDcId: v.deliveryDcId,
                  dcStock: v.dcStock,
                  emergLevel: Number(v.emergLevel) === 0 ? 1 : v.emergLevel // 紧急程度如果是0 默认赋值 正常

                });
              }));

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }(), [queryDemandPoolingExt, queryDemandReferencePrice]);
  return concatExtData;
}

/* harmony default export */ __webpack_exports__["Z"] = (useExtData);

/***/ }),

/***/ 72488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_FormCategorySelect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45199);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7704);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52054);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5977);






function useFormfields(initCategory, setChildPlaceList, disabled) {
  var location = (0,umi__WEBPACK_IMPORTED_MODULE_4__/* .useLocation */ .TH)();

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_config__WEBPACK_IMPORTED_MODULE_3__/* .CreateCollectionContext */ .qp),
      bussinessType = _useContext.bussinessType,
      logisticsList = _useContext.logisticsList;

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)([_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["所有品类"] */ .M["所有品类"], _hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["权限下的商家"] */ .M["权限下的商家"]]),
      mappingList = _useMapping.mappingList; // 当前是否为生鲜新增项


  var isFresh = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => bussinessType === _config__WEBPACK_IMPORTED_MODULE_3__/* .BussinessType["生鲜"] */ .fQ["生鲜"], [bussinessType]); // 耐用品

  var isDurable = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => bussinessType === _config__WEBPACK_IMPORTED_MODULE_3__/* .BussinessType["耐用品"] */ .fQ["耐用品"], [bussinessType]);
  var categoryList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (!mappingList.has(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["所有品类"] */ .M["所有品类"])) {
      return [];
    }

    if (isFresh) {
      return mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["所有品类"] */ .M["所有品类"]);
    } else {
      return mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["所有品类"] */ .M["所有品类"]).filter(v => v.value !== 10);
    }
  }, [isFresh, mappingList]); // 获取商户下的地点数据

  var changeMerchant = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((v, o) => {
    var _o$others;

    var placeList = ((_o$others = o.others) === null || _o$others === void 0 ? void 0 : _o$others.placeVos) || [];
    var list = placeList.map(i => {
      return {
        label: "".concat(i.placeCode, "-").concat(i.placeName),
        value: i.placeId,
        others: i
      };
    });
    setChildPlaceList(list || []); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return [{
    label: 'id',
    name: 'id',
    type: 'INPUT',
    hide: true
  }, {
    label: isDurable ? '耐用品集单号' : '补货集单号',
    name: 'poolingId',
    type: 'INPUT',
    initialValue: location === null || location === void 0 ? void 0 : location.query.poolingId,
    fieldOptions: {
      disabled: true
    }
  }, !isDurable && {
    label: '物流模式',
    name: 'logistics',
    type: 'SELECT',
    dataList: logisticsList,
    required: true,
    fieldOptions: {
      disabled
    }
  }, {
    label: '商家',
    name: 'merchantId',
    type: 'SELECT',
    required: true,
    dataList: mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["权限下的商家"] */ .M["权限下的商家"]) || [],
    fieldOptions: {
      disabled,
      onChange: changeMerchant
    }
  }, {
    label: '品类',
    name: 'category',
    required: isFresh,
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_FormCategorySelect__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z, {
      categoryList: categoryList,
      formValue: initCategory,
      firstProps: {
        disabled: isFresh || disabled
      },
      secondProps: {
        disabled
      }
    })
  }].filter(Boolean);
}

/* harmony default export */ __webpack_exports__["default"] = (useFormfields);

/***/ }),

/***/ 56196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vl": function() { return /* binding */ DURABLE_LIST; },
/* harmony export */   "B6": function() { return /* binding */ SUBMIT_DURABLE; },
/* harmony export */   "QN": function() { return /* binding */ DURABLE_PLACE; },
/* harmony export */   "rJ": function() { return /* binding */ DURABLE_MERCHANT; },
/* harmony export */   "Fb": function() { return /* binding */ DURABLE_EXPORT; },
/* harmony export */   "r3": function() { return /* binding */ DURABLE_PICK_STAT; },
/* harmony export */   "p1": function() { return /* binding */ DURABLE_REFRESH_ERROR; },
/* harmony export */   "Np": function() { return /* binding */ DURABLE_REFRESH_LOOP; },
/* harmony export */   "Bw": function() { return /* binding */ DURABLE_IMPORT_DETAIL; },
/* harmony export */   "$D": function() { return /* binding */ DURABLE_BATCH_UPDATE; },
/* harmony export */   "fR": function() { return /* binding */ DURABLE_CANCEL; },
/* harmony export */   "n5": function() { return /* binding */ DURABLE_GOODS_PLACE; },
/* harmony export */   "Hl": function() { return /* binding */ DURABLE_PLACE_LIST; }
/* harmony export */ });
/* unused harmony export GET_UPLOAD_TOKEN */
/**
 * 耐用品集单列表
 */
var DURABLE_LIST = 'scm.require.durablePooling.queryDurablePoolingOrder';
/**
 * 耐用品提取数据
 */

var SUBMIT_DURABLE = 'scm.require.durablePooling.extractDurablePooling';
/**
 * 耐用品集单提取数据-地点商品维度查询
 */

var DURABLE_PLACE = 'scm.require.durablePooling.pagePlaceDurablePoolingDetail';
/**
 * 耐用品集单提取数据-商品维度查询
 */

var DURABLE_MERCHANT = 'scm.require.durablePooling.pageGoodsDurablePoolingDetail';
/**
 * 导出耐用品集单
 */

var DURABLE_EXPORT = 'scm.require.exportDurablePoolingGoods';
/**
 * 耐用品集单提取数据统计
 */

var DURABLE_PICK_STAT = 'scm.require.durablePooling.statDurablePoolingDetail';
/**
 * 刷新耐用品异常明细
 */

var DURABLE_REFRESH_ERROR = 'scm.require.durablePooling.refreshDurableAbnormalGoods';
/**
 * 查询异常刷新结果
 */

var DURABLE_REFRESH_LOOP = 'scm.require.refreshDurableAbnormalGoodsResult';
/**
 * 集单明细导入
 */

var DURABLE_IMPORT_DETAIL = 'scm.require.importPoolingDetail';
/**
 * 批量更新
 */

var DURABLE_BATCH_UPDATE = 'scm.require.batchModifyPoolingDetail';
/**
 * 集单取消
 */

var DURABLE_CANCEL = 'scm.require.pooling.cancelPooling';
/**
 * 获取token
 */

var GET_UPLOAD_TOKEN = 'scm.require.getResourceToken';
/**
 * 商品地点维度列表
 */

var DURABLE_GOODS_PLACE = 'scm.require.durablePooling.queryGoodsDemandPoolingDetailList';
/**
 * 地点维度
 */

var DURABLE_PLACE_LIST = 'scm.require.durablePooling.queryPlaceDemandPoolingDetailList';

/***/ }),

/***/ 78253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1870);





function useGoodsColumns() {
  return [{
    title: '商品名称',
    dataIndex: 'goodsName',
    fixed: 'left',
    width: 200,
    sorter: true
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    sorter: true,
    width: 110
  }, {
    title: '商品条码',
    dataIndex: 'barCode',
    sorter: true,
    width: 140
  }, {
    title: '类目',
    dataIndex: 'secondCategoryId',
    width: 140,
    render: (_, record) => record.secondCategoryName ? "".concat(record.firstCategoryName, "/").concat(record.secondCategoryName) : record.firstCategoryName,
    sorter: true
  }, {
    title: '规格',
    dataIndex: 'specification',
    width: 90
  }, {
    title: '单位',
    dataIndex: 'specificationUnit',
    width: 90
  }, {
    title: '物流模式',
    dataIndex: 'logisticsName',
    width: 80
  }, {
    title: '总申请数量',
    dataIndex: 'totalDemandNum',
    width: 110,
    sorter: true
  }, {
    title: '审批数量',
    width: 110,
    dataIndex: 'totalApproveNum',
    sorter: true
  }, {
    title: '满足率%',
    dataIndex: 'satisfactionRate',
    width: 100,
    render: (txt, record) => {
      if (+record.totalDemandNum === 0) {
        return '100%';
      }

      var rate = +record.totalApproveNum / +record.totalDemandNum * 100;
      return isNaN(rate) ? '' : "".concat(rate.toFixed(1), "%");
    }
  }, {
    title: '门店数',
    dataIndex: 'placeNum',
    sorter: true,
    width: 90
  }, {
    title: '大仓库存',
    width: 120,
    dataIndex: 'dcStock',
    sorter: true
  }, {
    title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
      placement: "top",
      title: "\u8D1F\u6570\u4EE3\u8868\u5927\u4ED3\u7F3A\u8D27\uFF0C\u6B63\u6570\u4EE3\u8868\u5927\u4ED3\u6EE1\u8DB3\u9700\u6C42\u540E\u5269\u4F59\u5E93\u5B58"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "cursor-pointer"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
      className: "mr-1"
    }, "\u5DEE\u5F02\u91CF"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, null))),
    dataIndex: 'diffQty',
    sorter: true,
    width: 100
  }];
}

/* harmony default export */ __webpack_exports__["default"] = (useGoodsColumns);

/***/ }),

/***/ 57289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1870);





function useGoodsColumns() {
  return [{
    title: '商品名称',
    dataIndex: 'goodsName',
    fixed: 'left',
    width: 200,
    sorter: true
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    sorter: true,
    width: 110
  }, {
    title: '商品条码',
    dataIndex: 'barCode',
    sorter: true,
    width: 140
  }, {
    title: '类目',
    dataIndex: 'secondCategoryId',
    width: 140,
    render: (_, record) => record.secondCategoryName ? "".concat(record.firstCategoryName, "/").concat(record.secondCategoryName) : record.firstCategoryName,
    sorter: true
  }, {
    title: '单位',
    dataIndex: 'specificationUnit',
    width: 90
  }, {
    title: '物流模式',
    dataIndex: 'logisticsName',
    width: 80
  }, {
    title: '总申请数量',
    dataIndex: 'totalDemandNum',
    width: 110,
    sorter: true
  }, {
    title: '总审批数量',
    width: 110,
    dataIndex: 'totalApproveNum',
    sorter: true
  }, {
    title: '满足率%',
    dataIndex: 'satisfactionRate',
    width: 100,
    render: (txt, record) => {
      if (+record.totalDemandNum === 0) {
        return '100%';
      }

      var rate = +record.totalApproveNum / +record.totalDemandNum * 100;
      return isNaN(rate) ? '' : "".concat(rate.toFixed(1), "%");
    }
  }, {
    title: '门店数',
    dataIndex: 'placeNum',
    sorter: true,
    width: 90
  }, {
    title: '大仓库存',
    width: 120,
    dataIndex: 'dcStock',
    sorter: true
  }, {
    title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
      placement: "top",
      title: "\u8D1F\u6570\u4EE3\u8868\u5927\u4ED3\u7F3A\u8D27\uFF0C\u6B63\u6570\u4EE3\u8868\u5927\u4ED3\u6EE1\u8DB3\u9700\u6C42\u540E\u5269\u4F59\u5E93\u5B58"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "cursor-pointer"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
      className: "mr-1"
    }, "\u5DEE\u5F02\u91CF"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, null))),
    dataIndex: 'diffQty',
    sorter: true,
    width: 100
  }];
}

/* harmony default export */ __webpack_exports__["default"] = (useGoodsColumns);

/***/ }),

/***/ 65927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Create_usePlaceColumns; }
});

// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(5977);
// EXTERNAL MODULE: ./src/pages/NewCentralManage/utils.ts
var utils = __webpack_require__(25546);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(93224);
// EXTERNAL MODULE: ./node_modules/yp-frontend-library/esm/index.js + 77 modules
var esm = __webpack_require__(46565);
;// CONCATENATED MODULE: ./src/pages/NewCentralManage/CreateCollection/useSlicedMeat.ts




var _excluded = ["bomWithProduct"];

/* eslint-disable max-nested-callbacks */

/**
 * 获取膘厚、重量参数
 */



function useSlicedMeat() {
  var querySlicedMeat = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(condition) {
      var res, data, list;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,esm/* YpRequest */.XQ)('scm.require.queryMerchantProductSlicedMeat', {
                condition
              });

            case 2:
              res = _context.sent;

              if (res.success) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              data = res.result || [];
              list = data.map(v => {
                var bomWithProduct = v.bomWithProduct,
                    rest = (0,objectWithoutProperties/* default */.Z)(v, _excluded);

                var obj = bomWithProduct.reduce((pre, next) => {
                  var fat = {
                    value: next.fatness,
                    label: next.fatness
                  };
                  var weight = {
                    value: next.referneceWeight,
                    label: next.referneceWeight
                  };
                  var fatnessList = pre.fatnessList.some(v => v.value === next.fatness) ? pre.fatnessList : pre.fatnessList.concat(fat);
                  var referneceWeightList = pre.referneceWeightList.some(v => v.value === next.referneceWeight) ? pre.referneceWeightList : pre.referneceWeightList.concat(weight); // 存在膘厚,则判断该膘厚下是否已存在重量参数，做出对应的操作

                  var curFatnessMap = pre.fatnessMap[next.fatness] ? pre.fatnessMap[next.fatness].some(v => v.value === next.referneceWeight) ? pre.fatnessMap[next.fatness] : pre.fatnessMap[next.fatness].concat(weight) : [weight]; // 同上

                  var curWeightMap = pre.referneceWeightMap[next.referneceWeight] ? pre.referneceWeightMap[next.referneceWeight].some(v => v.value === next.fatness) ? pre.referneceWeightMap[next.referneceWeight] : pre.referneceWeightMap[next.referneceWeight].concat(fat) : [fat];
                  return {
                    fatnessList,
                    referneceWeightList,
                    fatnessMap: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, pre.fatnessMap), {}, {
                      [next.fatness]: curFatnessMap
                    }),
                    referneceWeightMap: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, pre.referneceWeightMap), {}, {
                      [next.referneceWeight]: curWeightMap
                    })
                  };
                }, {
                  fatnessList: [],
                  referneceWeightList: [],
                  fatnessMap: {},
                  referneceWeightMap: {}
                });
                return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, rest), obj);
              });
              return _context.abrupt("return", list);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  return querySlicedMeat;
}

/* harmony default export */ var CreateCollection_useSlicedMeat = (useSlicedMeat);
;// CONCATENATED MODULE: ./src/pages/NewCentralManage/FreshSupplement/Create/usePlaceColumns.tsx









function usePlaceColumns(_ref) {
  var logisticsList = _ref.logisticsList;

  var _useLocation = (0,react_router/* useLocation */.TH)(),
      query = _useLocation.query;

  var editable = query.fn !== utils/* FUNC.VIEW */.O6.VIEW; // 膘厚、白条重量参数数据

  var _useState = (0,react.useState)(),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      meatData = _useState2[0],
      setMeatData = _useState2[1];

  var querySlicedMeat = CreateCollection_useSlicedMeat(); // 膘厚

  var visibleChange = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(v, r) {
      var data;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (v) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              setMeatData(undefined);
              _context.next = 5;
              return querySlicedMeat([{
                merchantId: r.merchantId,
                goodsId: r.goodsId
              }]);

            case 5:
              data = _context.sent;

              if (data && data.length) {
                setMeatData(data[0]);
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [querySlicedMeat]);
  return [// {
  //   title: '商品名称',
  //   dataIndex: 'goodsName',
  //   fixed: 'left',
  //   width: 160,
  //   sorter: true
  // },
  // {
  //   title: '商品条码',
  //   dataIndex: 'barCode',
  //   sorter: true,
  //   width: 140
  // },
  // {
  //   title: '商品编码',
  //   dataIndex: 'goodsId',
  //   sorter: true,
  //   width: 100
  // },
  {
    title: '地点编码',
    dataIndex: 'placeCode',
    width: 100,
    fixed: 'left',
    sorter: true
  }, {
    title: '地点名称',
    dataIndex: 'placeName',
    fixed: 'left',
    width: 180
  }, {
    title: '类目',
    dataIndex: 'secondCategoryId',
    width: 130,
    render: (_, record) => record.secondCategoryName ? "".concat(record.firstCategoryName, "/").concat(record.secondCategoryName) : record.firstCategoryName,
    sorter: true
  }, {
    title: '单位',
    dataIndex: 'specificationUnit',
    width: 80
  }, {
    title: '物流模式',
    dataIndex: editable ? 'logistics' : 'logisticsName',
    // 注意：商品给的是 logistic，采购给的是 logistics。在添加门店层逻辑中磨平
    width: 120,
    dataList: logisticsList,
    type: editable ? 'SELECT' : undefined,
    sorter: true
  }, {
    title: '膘厚',
    dataIndex: 'fatness',
    width: 130,
    type: editable ? 'SELECT' : undefined,
    fieldOptions: r => {
      return {
        onDropdownVisibleChange: v => visibleChange(v, r)
      };
    },
    dataList: meatData === null || meatData === void 0 ? void 0 : meatData.fatnessList,
    setCellRowValue: r => {
      var list = (meatData === null || meatData === void 0 ? void 0 : meatData.fatnessMap[r.fatness]) || [];
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, r), {}, {
        referneceWeight: list.length ? list[0].value : undefined
      });
    }
  }, {
    title: '白条重量参数',
    dataIndex: 'referneceWeight',
    width: 130,
    type: editable ? 'SELECT' : undefined,
    dataList: r => (meatData === null || meatData === void 0 ? void 0 : meatData.fatnessMap[r.fatness]) || [],
    fieldOptions: r => {
      return {
        onDropdownVisibleChange: v => visibleChange(v, r)
      };
    }
  }, {
    title: '申请数量',
    dataIndex: 'demandNum',
    width: 100,
    sorter: true,
    type: r => !r.id ? 'INPUT' : undefined,
    render: (node, r) => /*#__PURE__*/react.createElement("div", {
      className: "d-flex"
    }, node, "\xA0", r.barCodeUnit)
  }, {
    title: '审核数量',
    dataIndex: 'approveNum',
    width: 100,
    sorter: true,
    type: editable ? 'INPUT' : undefined,
    render: (node, r) => /*#__PURE__*/react.createElement("div", {
      className: "d-flex"
    }, node, "\xA0", r.barCodeUnit)
  }, {
    title: '供应商名称',
    dataIndex: 'supplierName',
    type: r => r.logistics === utils/* LOGISTICE_MODE.配送 */.xT["配送"] || !editable ? undefined : 'SELECT',
    width: 200,
    dataList: r => {
      if (r.supplier && Array.isArray(r.supplier)) {
        return r.supplier.map(v => ({
          value: v.supplierCode,
          label: v.supplierName
        }));
      } else {
        return [{
          value: r.supplierCode,
          label: r.supplierName
        }];
      }
    },
    sorter: true,
    setCellRowValue: (r, o) => {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, r), {}, {
        supplierCode: o.value
      });
    }
  }, {
    title: '供应商编码',
    dataIndex: 'supplierCode',
    sorter: true,
    width: 120
  }, {
    title: '参考采购价(元)',
    dataIndex: 'purchaseReferencePrice',
    width: 120
  }, {
    title: '采购价(元)',
    dataIndex: 'unitPrice',
    width: 110,
    type: r => ![utils/* LOGISTICE_MODE.直送 */.xT["直送"], utils/* LOGISTICE_MODE.直通 */.xT["直通"]].includes(r.logistics) || !editable ? undefined : 'INPUT'
  }, {
    title: '配送价(元)',
    // 成本价
    dataIndex: 'transferReferencePrice',
    width: 110
  }, {
    title: '大仓',
    dataIndex: editable ? 'deliveryDcId' : 'deliveryDcName',
    type: editable ? 'SELECT' : undefined,
    dataList: r => Array.isArray(r.dc) && r.dc.length ? r.dc.map(e => ({
      label: e.deliveryDcName,
      value: e.deliveryDcId
    })) : [{
      label: r.deliveryDcName,
      value: r.deliveryDcId,
      others: {
        deliveryDcCode: r.deliveryDcCode,
        deliveryDcId: r.deliveryDcId,
        deliveryDcName: r.deliveryDcName
      }
    }],
    render: (node, record) => record.logistics === utils/* LOGISTICE_MODE.直送 */.xT["直送"] ? '-' : node,
    // 直送不展示
    width: 190
  }, {
    title: '大仓库存',
    dataIndex: 'dcStock',
    width: 110
  }, {
    title: '满足率%',
    dataIndex: 'satisfactionRate',
    width: 100,
    // （审核数量/申请数量）*100=结果（保留1为小数）
    render: (txt, record) => {
      if (+record.demandNum === 0) {
        return '100%';
      }

      var rate = +record.approveNum / +record.demandNum * 100;
      return isNaN(rate) ? '' : "".concat(rate.toFixed(1), "%");
    }
  }, {
    title: '当前库存',
    dataIndex: 'stock',
    width: 100
  }, {
    title: '当前在途',
    dataIndex: 'onOrderStock',
    width: 100
  }, {
    title: '昨日销量',
    dataIndex: 'yestDaySaleCount',
    width: 100
  }, {
    title: '近7日销量',
    dataIndex: 'last7DaySaleCount',
    width: 100
  }, {
    title: '失败原因',
    dataIndex: 'errorMsg',
    width: 130,
    render: txt => /*#__PURE__*/react.createElement("span", {
      style: {
        color: 'red'
      }
    }, txt),
    sorter: true
  }];
}

/* harmony default export */ var Create_usePlaceColumns = (usePlaceColumns);

/***/ }),

/***/ 66072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5977);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7704);
/* harmony import */ var _components_FormCategorySelect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45199);






function useFormfields(initCategory) {
  var _useLocation = (0,umi__WEBPACK_IMPORTED_MODULE_3__/* .useLocation */ .TH)(),
      query = _useLocation.query;

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)([_hooks_useMapping__WEBPACK_IMPORTED_MODULE_1__/* .MappingKey["物流模式"] */ .M["物流模式"], _hooks_useMapping__WEBPACK_IMPORTED_MODULE_1__/* .MappingKey["所有品类"] */ .M["所有品类"], _hooks_useMapping__WEBPACK_IMPORTED_MODULE_1__/* .MappingKey["当前用户权限的供货DC"] */ .M["当前用户权限的供货DC"], _hooks_useMapping__WEBPACK_IMPORTED_MODULE_1__/* .MappingKey["权限下的商家"] */ .M["权限下的商家"]]),
      mappingList = _useMapping.mappingList;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      placeList = _useState2[0],
      setPlaceList = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var merchantList = mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_1__/* .MappingKey["权限下的商家"] */ .M["权限下的商家"]);

    if (merchantList !== null && merchantList !== void 0 && merchantList.length) {
      var _target$others;

      var target = merchantList.find(v => v.value === Number(query.merchantId)) || {};

      var _placeList = ((target === null || target === void 0 ? void 0 : (_target$others = target.others) === null || _target$others === void 0 ? void 0 : _target$others.placeVos) || []).map(v => ({
        value: v.placeId,
        label: "".concat(v.placeCode, "-").concat(v.placeName),
        others: v
      }));

      setPlaceList(_placeList);
    }
  }, [mappingList, query.merchantId]);
  return [{
    label: '补货集单号',
    name: 'poolingId',
    type: 'INPUT',
    reset: false,
    initialValue: query.poolingId,
    fieldOptions: {
      disabled: true
    }
  }, {
    label: '物流模式',
    name: 'logistics',
    type: 'SELECT',
    reset: false,
    initialValue: +query.logistics,
    dataList: (mappingList === null || mappingList === void 0 ? void 0 : mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_1__/* .MappingKey["物流模式"] */ .M["物流模式"])) || [],
    fieldOptions: {
      disabled: true
    }
  }, {
    label: '地点',
    name: 'placeId',
    type: 'SELECT',
    dataList: placeList
  }, {
    label: '商品类别',
    name: 'category',
    reset: false,
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_FormCategorySelect__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
      categoryList: (mappingList === null || mappingList === void 0 ? void 0 : mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_1__/* .MappingKey["所有品类"] */ .M["所有品类"])) || [],
      formValue: initCategory
    })
  }, {
    label: '商品编码',
    name: 'goodsId',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '支持多个逗号隔开'
    }
  }, {
    label: '商品名称',
    name: 'goodsName',
    type: 'INPUT'
  }, {
    label: '品牌名称',
    name: 'brandName',
    type: 'INPUT'
  }, {
    label: '供应商',
    name: 'supplierName',
    type: 'INPUT'
  }, {
    label: '大仓名称',
    name: 'deliveryDcId',
    type: 'SELECT',
    dataList: (mappingList === null || mappingList === void 0 ? void 0 : mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_1__/* .MappingKey["当前用户权限的供货DC"] */ .M["当前用户权限的供货DC"])) || []
  }];
}

/* harmony default export */ __webpack_exports__["default"] = (useFormfields);

/***/ }),

/***/ 20619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1870);





function useGoodsColumns() {
  return [{
    title: '商品名称',
    dataIndex: 'goodsName',
    fixed: 'left',
    width: 200,
    sorter: true
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    sorter: true,
    width: 110
  }, {
    title: '商品条码',
    dataIndex: 'barCode',
    sorter: true,
    width: 140
  }, {
    title: '类目',
    dataIndex: 'secondCategoryId',
    width: 140,
    render: (_, record) => record.secondCategoryName ? "".concat(record.firstCategoryName, "/").concat(record.secondCategoryName) : record.firstCategoryName,
    sorter: true
  }, {
    title: '规格',
    dataIndex: 'specification',
    width: 90
  }, {
    title: '单位',
    dataIndex: 'specificationUnit',
    width: 90
  }, {
    title: '物流模式',
    dataIndex: 'logisticsName',
    width: 80
  }, {
    title: '申请数量',
    dataIndex: 'totalDemandNum',
    width: 110,
    sorter: true
  }, {
    title: '审批数量',
    width: 110,
    dataIndex: 'totalApproveNum',
    sorter: true
  }, {
    title: '满足率%',
    dataIndex: 'satisfactionRate',
    width: 100,
    render: (txt, record) => {
      if (+record.totalDemandNum === 0) {
        return '100%';
      }

      var rate = +record.totalApproveNum / +record.totalDemandNum * 100;
      return isNaN(rate) ? '' : "".concat(rate.toFixed(1), "%");
    }
  }, {
    title: '门店数',
    dataIndex: 'placeNum',
    sorter: true,
    width: 90
  }, {
    title: '大仓库存',
    width: 120,
    dataIndex: 'dcStock',
    sorter: true
  }, {
    title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
      placement: "top",
      title: "\u8D1F\u6570\u4EE3\u8868\u5927\u4ED3\u7F3A\u8D27\uFF0C\u6B63\u6570\u4EE3\u8868\u5927\u4ED3\u6EE1\u8DB3\u9700\u6C42\u540E\u5269\u4F59\u5E93\u5B58"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "cursor-pointer"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
      className: "mr-1"
    }, "\u5DEE\u5F02\u91CF"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, null))),
    dataIndex: 'diffQty',
    sorter: true,
    width: 100
  }];
}

/* harmony default export */ __webpack_exports__["default"] = (useGoodsColumns);

/***/ }),

/***/ 22968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8870);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5977);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25546);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7704);






function usePlaceColumns(logistics) {
  var _useLocation = (0,umi__WEBPACK_IMPORTED_MODULE_3__/* .useLocation */ .TH)(),
      query = _useLocation.query;

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)([_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["紧急程度"] */ .M["紧急程度"]]),
      mappingList = _useMapping.mappingList;

  var editable = query.fn !== _utils__WEBPACK_IMPORTED_MODULE_1__/* .FUNC.VIEW */ .O6.VIEW;
  return [// {
  //   title: '商品名称',
  //   dataIndex: 'goodsName',
  //   fixed: 'left',
  //   width: 160,
  //   sorter: true
  // },
  // {
  //   title: '商品条码',
  //   dataIndex: 'barCode',
  //   sorter: true,
  //   width: 140
  // },
  // {
  //   title: '商品编码',
  //   dataIndex: 'goodsId',
  //   sorter: true,
  //   width: 100
  // },
  {
    title: '地点编码',
    dataIndex: 'placeCode',
    width: 100,
    fixed: 'left',
    sorter: true
  }, {
    title: '地点名称',
    dataIndex: 'placeName',
    fixed: 'left',
    width: 160
  }, {
    title: '类目',
    dataIndex: 'secondCategoryId',
    width: 130,
    render: (_, record) => record.secondCategoryName ? "".concat(record.firstCategoryName, "/").concat(record.secondCategoryName) : record.firstCategoryName,
    sorter: true
  }, {
    title: '单位',
    dataIndex: 'specificationUnit',
    width: 80
  }, {
    title: '参考采购价(元)',
    dataIndex: 'purchaseReferencePrice',
    hide: ![_utils__WEBPACK_IMPORTED_MODULE_1__/* .LOGISTICE_MODE["直送"] */ .xT["直送"], _utils__WEBPACK_IMPORTED_MODULE_1__/* .LOGISTICE_MODE["直通"] */ .xT["直通"]].includes(Number(logistics)),
    width: 120
  }, {
    title: '采购价(元)',
    dataIndex: 'unitPrice',
    width: 100,
    hide: ![_utils__WEBPACK_IMPORTED_MODULE_1__/* .LOGISTICE_MODE["直送"] */ .xT["直送"]
    /* LOGISTICE_MODE.直通 */
    ].includes(Number(logistics)),
    type: r => ![_utils__WEBPACK_IMPORTED_MODULE_1__/* .LOGISTICE_MODE["直送"] */ .xT["直送"]].includes(r.logistics) || !editable ? undefined : 'INPUT'
  }, {
    title: '配送价(元)',
    // 成本价
    dataIndex: 'transferReferencePrice',
    hide: ![_utils__WEBPACK_IMPORTED_MODULE_1__/* .LOGISTICE_MODE["配送"] */ .xT["配送"]].includes(Number(logistics)),
    width: 100
  }, {
    title: '大仓',
    dataIndex: editable ? 'deliveryDcId' : 'deliveryDcName',
    type: editable ? 'SELECT' : undefined,
    dataList: r => Array.isArray(r.dc) && r.dc.length ? r.dc.map(e => ({
      label: e.deliveryDcName,
      value: e.deliveryDcId
    })) : [{
      label: r.deliveryDcName,
      value: r.deliveryDcId,
      raw: {
        deliveryDcCode: r.deliveryDcCode,
        deliveryDcId: r.deliveryDcId,
        deliveryDcName: r.deliveryDcName
      }
    }],
    render: (node, record) => record.logistics === _utils__WEBPACK_IMPORTED_MODULE_1__/* .LOGISTICE_MODE["直送"] */ .xT["直送"] ? '-' : node,
    // 直送不展示
    width: 180
  }, {
    title: '大仓库存',
    dataIndex: 'dcStock',
    width: 110
  }, {
    title: '物流模式',
    dataIndex: 'logisticsName',
    // 注意：商品给的是 logistic，采购给的是 logistics。在添加门店层逻辑中磨平
    width: 120,
    sorter: true
  }, {
    title: '申请数量',
    dataIndex: 'demandNum',
    width: 100,
    sorter: true,
    type: r => !r.id && editable ? 'INPUT' : undefined,
    render: (node, r) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "d-flex"
    }, node, "\xA0", r.barCodeUnit)
  }, {
    title: '审核数量',
    dataIndex: 'approveNum',
    width: 100,
    sorter: true,
    type: editable ? 'INPUT' : undefined,
    render: (node, r) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "d-flex"
    }, node, "\xA0", r.barCodeUnit)
  }, {
    title: '供应商名称',
    dataIndex: 'supplierName',
    type: r => r.logistics === _utils__WEBPACK_IMPORTED_MODULE_1__/* .LOGISTICE_MODE["配送"] */ .xT["配送"] || !editable ? undefined : 'SELECT',
    width: 180,
    dataList: r => {
      if (r.supplier && Array.isArray(r.supplier)) {
        return r.supplier.map(v => ({
          value: v.supplierCode,
          label: v.supplierName
        }));
      } else {
        return [{
          value: r.supplierCode,
          label: r.supplierName
        }];
      }
    },
    setCellRowValue: (r, o) => {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)({}, r), {}, {
        supplierCode: o.value
      });
    },
    sorter: true
  }, {
    title: '供应商编码',
    dataIndex: 'supplierCode',
    sorter: true,
    width: 120
  }, {
    title: '紧急程度',
    dataIndex: editable ? 'emergLevel' : 'emergLevelName',
    type: editable ? 'SELECT' : undefined,
    width: 110,
    dataList: (mappingList === null || mappingList === void 0 ? void 0 : mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .MappingKey["紧急程度"] */ .M["紧急程度"])) || []
  }, {
    title: '昨日销量',
    dataIndex: 'yestDaySaleCount',
    width: 110
  }, {
    title: '近7日销量',
    dataIndex: 'last7DaySaleCount',
    width: 110
  }, {
    title: '当前库存',
    dataIndex: 'stock',
    width: 110
  }, {
    title: '当前在途',
    dataIndex: 'onOrderStock',
    width: 110
  }, {
    title: '失败原因',
    dataIndex: 'errorMsg',
    width: 130,
    render: txt => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      style: {
        color: 'red'
      }
    }, txt),
    sorter: true
  }];
}

/* harmony default export */ __webpack_exports__["default"] = (usePlaceColumns);

/***/ }),

/***/ 97275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ComplexTable; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/tabs/style/index.js
var style = __webpack_require__(18106);
// EXTERNAL MODULE: ./node_modules/antd/es/tabs/index.js + 32 modules
var tabs = __webpack_require__(69584);
// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var button_style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./src/hooks/useMapping.ts
var useMapping = __webpack_require__(7704);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/UpOutlined.js + 1 modules
var UpOutlined = __webpack_require__(58491);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/DownOutlined.js + 1 modules
var DownOutlined = __webpack_require__(57254);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(5977);
// EXTERNAL MODULE: ./node_modules/yp-frontend-library/esm/index.js + 77 modules
var esm = __webpack_require__(46565);
// EXTERNAL MODULE: ./src/pages/NewCentralManage/CreateCollection/index.tsx
var CreateCollection = __webpack_require__(21859);
// EXTERNAL MODULE: ./src/pages/NewCentralManage/CreateCollection/PlaceDemandTable.tsx
var PlaceDemandTable = __webpack_require__(57924);
// EXTERNAL MODULE: ./src/pages/NewCentralManage/utils.ts
var utils = __webpack_require__(25546);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/style/index.js
var modal_style = __webpack_require__(71194);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(57016);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/index.js
var message_style = __webpack_require__(34792);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(48086);
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
// EXTERNAL MODULE: ./src/pages/NewCentralManage/CreateCollection/useExtData.ts
var useExtData = __webpack_require__(8624);
// EXTERNAL MODULE: ./src/utils/common.ts
var common = __webpack_require__(96534);
;// CONCATENATED MODULE: ./src/pages/NewCentralManage/components/NoOrderModal.tsx












/**
 * 商品清退
 */








var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 4
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 18
    }
  }
};

function NoOrderModal(props) {
  var formData = props.formData,
      bussinessType = props.bussinessType,
      childPlaceList = props.childPlaceList;
  var formbuilder = (0,react.useRef)();
  var isFresh = CreateCollection.BussinessType["生鲜"] === bussinessType;

  var _useMapping = (0,useMapping/* default */.Z)([useMapping/* MappingKey.物流模式 */.M["物流模式"]]),
      mappingList = _useMapping.mappingList;

  var logisticsList = mappingList.get(useMapping/* MappingKey.物流模式 */.M["物流模式"]) || []; // 表格查询参数

  var _useState = (0,react.useState)({
    poolingNo: formData === null || formData === void 0 ? void 0 : formData.poolingId,
    goodsId: formData === null || formData === void 0 ? void 0 : formData.goodsId
  }),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      searchParams = _useState2[0],
      setSearchParams = _useState2[1]; // 正在保存商品行


  var _useState3 = (0,react.useState)(false),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      isSaving = _useState4[0],
      setIsSaving = _useState4[1]; // // 取消请求数据
  // const cancelRequest = useMemo(() => {
  //   return !searchParams?.placeIds.length
  // }, [searchParams?.placeIds])
  // 获取额外参数


  var concatExtData = (0,useExtData/* default */.Z)(formData === null || formData === void 0 ? void 0 : formData.firstCategoryId, formData === null || formData === void 0 ? void 0 : formData.merchantId); // 查询

  var handleSearch = (0,react.useCallback)(values => {
    setSearchParams((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, values), {}, {
      poolingNo: formData === null || formData === void 0 ? void 0 : formData.poolingId,
      goodsId: formData === null || formData === void 0 ? void 0 : formData.goodsId
    }));
  }, [formData === null || formData === void 0 ? void 0 : formData.poolingId, formData === null || formData === void 0 ? void 0 : formData.goodsId]); // 请求后

  var afterRequest = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
    var data,
        list,
        _args = arguments;
    return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = _args.length > 0 && _args[0] !== undefined ? _args[0] : [];
            _context.next = 3;
            return concatExtData(data);

          case 3:
            list = _context.sent;
            return _context.abrupt("return", list);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [concatExtData]); // 保存行

  var saveRowCallback = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(data) {
      var currentCellOldData, currentRow, params, res;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currentCellOldData = data.currentCellOldData, currentRow = data.currentRow;
              params = {
                poolingId: formData === null || formData === void 0 ? void 0 : formData.poolingId,
                detail: {
                  id: currentRow.id,
                  placeId: currentRow.placeId,
                  goodsId: formData === null || formData === void 0 ? void 0 : formData.goodsId,
                  barCode: formData === null || formData === void 0 ? void 0 : formData.barCode,
                  demandNum: 0,
                  // 需求数量 固定
                  approveNum: currentRow.approveNum || 0,
                  // 审核数量
                  supplierCode: currentRow.supplierCode,
                  // 供应商编码
                  logistics: currentRow.logistics,
                  // 物流模式：1直送；2配送；3直通
                  unitPrice: currentRow.unitPrice,
                  merchantId: formData === null || formData === void 0 ? void 0 : formData.merchantId,
                  deliveryDcId: currentRow.logistics === 1 ? '0' : currentRow.deliveryDcId,
                  emergLevel: 1,
                  // 默认 正常
                  supplyRoute: 1 // 默认 台州仓-城市仓-城市店

                }
              };
              setIsSaving(true);
              _context2.next = 5;
              return (0,ypRequest/* default */.Z)('scm.require.pooling.saveAndUpdatePoolingDetail', params);

            case 5:
              res = _context2.sent;
              setIsSaving(false);

              if (!res.success) {
                _context2.next = 12;
                break;
              }

              message.default.success('保存商品成功');

              return _context2.abrupt("return", (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, currentRow), {}, {
                id: res.result.id
              }));

            case 12:
              return _context2.abrupt("return", currentCellOldData);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [formData === null || formData === void 0 ? void 0 : formData.barCode, formData === null || formData === void 0 ? void 0 : formData.goodsId, formData === null || formData === void 0 ? void 0 : formData.merchantId, formData === null || formData === void 0 ? void 0 : formData.poolingId]);
  var elements = [{
    label: '地点',
    name: 'placeIds',
    type: 'SELECT',
    dataList: childPlaceList || [],
    fieldOptions: {
      mode: 'multiple'
    }
  }];
  var columns = [{
    title: '地点编码',
    dataIndex: 'placeCode',
    width: 100,
    fixed: 'left'
  }, {
    title: '地点名称',
    dataIndex: 'placeName',
    width: 170,
    fixed: 'left'
  }, {
    title: '物流模式',
    dataIndex: 'logisticsName',
    width: 100 // type: isFresh ? 'SELECT' : undefined,
    // dataList: logisticsList

  }, {
    title: '申请数量',
    dataIndex: 'demandNum',
    width: 100,
    render: () => 0
  }, {
    title: '审核数量',
    dataIndex: 'approveNum',
    width: 140,
    type: 'INPUT',
    fieldOptions: r => {
      // 非称重商品为正整数，称重商品保留三位小数
      var isPositiveInteger = r.isWeigh === 2;
      return {
        formatter: value => isPositiveInteger ? (0,common/* exchageToNum1 */.Ly)(value) : (0,common/* exchageToNum3 */.hY)(value)
      };
    }
  }, {
    title: '供应商名称',
    dataIndex: 'supplierName',
    width: 150,
    type: r => r.logistics === utils/* LOGISTICE_MODE.配送 */.xT["配送"] ? undefined : 'SELECT',
    dataList: r => {
      if (r.supplier && Array.isArray(r.supplier)) {
        return r.supplier.map(v => ({
          value: v.supplierCode,
          label: v.supplierName
        }));
      } else {
        return [{
          value: r.supplierCode,
          label: r.supplierName
        }];
      }
    },
    setCellRowValue: (r, o) => {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, r), {}, {
        supplierCode: o.value
      });
    }
  }, {
    title: '供应商编码',
    dataIndex: 'supplierCode',
    width: 100
  }, {
    title: '参考采购价',
    dataIndex: 'purchaseReferencePrice',
    width: 110
  }, {
    title: '采购价',
    dataIndex: 'unitPrice',
    width: 110,
    type: r => ![utils/* LOGISTICE_MODE.直送 */.xT["直送"], utils/* LOGISTICE_MODE.直通 */.xT["直通"]].includes(r.logistics) ? undefined : 'INPUT'
  }, {
    title: '参考配送价',
    dataIndex: 'transferReferencePrice',
    width: 110
  }, {
    title: '大仓',
    dataIndex: 'deliveryDcId',
    width: 150,
    type: 'SELECT',
    dataList: r => Array.isArray(r.dc) && r.dc.length ? r.dc.map(e => ({
      label: e.deliveryDcName,
      value: e.deliveryDcId
    })) : [{
      label: r.deliveryDcName,
      value: r.deliveryDcId,
      others: {
        deliveryDcCode: r.deliveryDcCode,
        deliveryDcId: r.deliveryDcId,
        deliveryDcName: r.deliveryDcName
      }
    }],
    render: (node, record) => record.logistics === utils/* LOGISTICE_MODE.直送 */.xT["直送"] ? '-' : node // 直送不展示

  }, {
    title: '大仓库存',
    dataIndex: 'dcStock',
    width: 110
  }, {
    title: '满足率',
    dataIndex: 'satisfactionRate',
    width: 110,
    // （审核数量/申请数量）*100=结果（保留1为小数）
    render: (txt, record) => {
      var rate = +record.approveNum / +record.demandNum * 100;
      return isNaN(rate) ? '' : "".concat(rate.toFixed(1), "%");
    }
  }, {
    title: '当前库存',
    dataIndex: 'stock',
    width: 110
  }, {
    title: '当前在途',
    dataIndex: 'onOrderStock',
    width: 110
  }, {
    title: '昨日销量',
    dataIndex: 'yestDaySaleCount',
    width: 110
  }, {
    title: '近7日销量',
    dataIndex: 'last7DaySaleCount',
    width: 120
  }, {
    title: '失败原因',
    dataIndex: 'errorMsg',
    width: 140,
    render: txt => /*#__PURE__*/react.createElement("span", {
      style: {
        color: 'red'
      }
    }, txt)
  }];
  return /*#__PURE__*/react.createElement(modal/* default */.Z, {
    title: "\u5546\u54C1\u9009\u62E9",
    destroyOnClose: true,
    maskClosable: false,
    width: 1200,
    visible: true,
    onCancel: props.closeModalCallback,
    footer: [/*#__PURE__*/react.createElement(es_button/* default */.Z, {
      key: "cancel",
      disabled: isSaving,
      onClick: props.closeModalCallback
    }, "\u5173\u95ED")]
  }, /*#__PURE__*/react.createElement(esm/* FormBuilder */.qu, (0,esm_extends/* default */.Z)({}, defaultFormItemLayout, {
    formRef: formbuilder,
    elements: elements,
    onSearch: handleSearch
  })), /*#__PURE__*/react.createElement(esm/* EnhanceTable */.UO, {
    // cancelRequest={cancelRequest}
    searchParams: searchParams,
    columns: columns,
    requestUrl: "scm.require.placeNoOrderSelect",
    saveRowCallback: saveRowCallback,
    afterRequest: afterRequest,
    scroll: {
      x: 1300,
      y: 500
    }
  }));
}

/* harmony default export */ var components_NoOrderModal = (NoOrderModal);
;// CONCATENATED MODULE: ./src/pages/NewCentralManage/components/ComplexTable.tsx










/**
 * 商品和地点维度表格结合
 */










function ComplexTable(props) {
  var goods = props.goods,
      place = props.place,
      placeGoods = props.placeGoods,
      goodsTableRef = props.goodsTableRef,
      formSearchData = props.formSearchData,
      hideAddStoreBtn = props.hideAddStoreBtn,
      bussinessType = props.bussinessType,
      placeTableRef = props.placeTableRef,
      queryApporeSummaryCallback = props.queryApporeSummaryCallback;

  var _useLocation = (0,react_router/* useLocation */.TH)(),
      query = _useLocation.query;

  var editable = query.fn !== utils/* FUNC.VIEW */.O6.VIEW;
  var goodsRef = (0,react.useRef)(null);
  var placeRef = (0,react.useRef)(null);
  var tabPlaceRef = (0,react.useRef)(null);

  var _useMapping = (0,useMapping/* default */.Z)([useMapping/* MappingKey.权限下的商家 */.M["权限下的商家"]]),
      mappingList = _useMapping.mappingList;

  var isFresh = CreateCollection.BussinessType["生鲜"] === bussinessType; // 追加门店

  var _useState = (0,react.useState)({
    visible: false,
    record: {}
  }),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      goodsModal = _useState2[0],
      setGoodsModal = _useState2[1]; // 商家下的地点


  var _useState3 = (0,react.useState)([]),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      childPlaceList = _useState4[0],
      setChildPlaceList = _useState4[1]; // 表格展示的key


  var _useState5 = (0,react.useState)([]),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      expandKeys = _useState6[0],
      setExpandKeys = _useState6[1]; // 子表格展示参数


  var _useState7 = (0,react.useState)(),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      expandPrams = _useState8[0],
      setExpandPrams = _useState8[1];

  var _useState9 = (0,react.useState)(),
      _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
      goodsDataSource = _useState10[0],
      setGoodsDataSource = _useState10[1]; // tab的key


  var _useState11 = (0,react.useState)('goods'),
      _useState12 = (0,slicedToArray/* default */.Z)(_useState11, 2),
      activeKey = _useState12[0],
      setActiveKey = _useState12[1]; // 未展开不请求地点数据


  var cancelRequestPlace = (0,react.useMemo)(() => !(expandPrams !== null && expandPrams !== void 0 && expandPrams.expanded), [expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.expanded]); // 商品维度请求参数

  var goodsSearchParams = (0,react.useMemo)(() => ({
    condition: formSearchData
  }), [formSearchData]); // 地点维度请求参数

  var placeSearchParams = (0,react.useMemo)(() => ({
    condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formSearchData), {}, {
      goodsId: expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.record.goodsId,
      deliveryDcId: expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.record.deliveryDcId,
      barCode: expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.record.barCode,
      searchType: 1
    })
  }), [formSearchData, expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.record.goodsId, expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.record.deliveryDcId, expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.record.barCode]); // 地点商品维度查询数据

  var goodsPlaceSearchParams = (0,react.useMemo)(() => {
    return {
      condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formSearchData), {}, {
        searchType: 2
      })
    };
  }, [formSearchData]); // 商品维度筛选，排序的回调

  var sortCallback = (0,react.useCallback)((filter, sorter) => {
    var isAsc;

    if (sorter.order === 'ascend') {
      isAsc = true;
    } else if (sorter.order === 'descend') {
      isAsc = false;
    }

    return {
      condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formSearchData), {}, {
        isAsc,
        orderColumn: sorter.field
      })
    };
  }, [formSearchData]); // 地点维度筛选，排序的回调

  var sortPlaceCallback = (0,react.useCallback)((filter, sorter) => {
    var isAsc;

    if (sorter.order === 'ascend') {
      isAsc = true;
    } else if (sorter.order === 'descend') {
      isAsc = false;
    }

    return {
      condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, placeSearchParams.condition), {}, {
        isAsc,
        orderColumn: sorter.field
      })
    };
  }, [placeSearchParams]); // 商品地点维度排序

  var sortGoodsPlaceCallback = (0,react.useCallback)((filter, sorter) => {
    var isAsc;

    if (sorter.order === 'ascend') {
      isAsc = true;
    } else if (sorter.order === 'descend') {
      isAsc = false;
    }

    return {
      condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, goodsPlaceSearchParams.condition), {}, {
        isAsc,
        orderColumn: sorter.field
      })
    };
  }, [goodsPlaceSearchParams]); // 展示子表格

  var handleExpand = (0,react.useCallback)((expanded, record) => {
    setExpandPrams({
      expanded,
      record
    });
  }, []); // 关闭浮层回调

  var closeModalCallback = (0,react.useCallback)(() => {
    var _goodsRef$current;

    setGoodsModal({
      visible: false,
      record: {}
    });
    (_goodsRef$current = goodsRef.current) === null || _goodsRef$current === void 0 ? void 0 : _goodsRef$current.reload(goodsSearchParams);
    queryApporeSummaryCallback();
  }, [goodsSearchParams, queryApporeSummaryCallback]); // 追加门店

  var handleAddShop = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(r) {
      var _target$others;

      var list, target, placeList;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              list = mappingList.get(useMapping/* MappingKey.权限下的商家 */.M["权限下的商家"]) || [];
              target = list.find(v => v.value === Number(r.merchantId)) || {};
              placeList = ((target === null || target === void 0 ? void 0 : (_target$others = target.others) === null || _target$others === void 0 ? void 0 : _target$others.placeVos) || []).map(v => ({
                value: +v.placeId,
                label: "".concat(v.placeCode, "-").concat(v.placeName),
                others: v
              }));
              setGoodsModal({
                visible: true,
                record: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, formSearchData), r)
              });
              setChildPlaceList(placeList);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [mappingList, formSearchData]); // 商品维度请求后

  var afterRequest = (0,react.useCallback)(data => {
    if (data && data.length && !expandKeys.length) {
      // 默认展开
      setExpandKeys(["".concat(data[0].barCode, "-").concat(data[0].goodsId, "-").concat(data[0].deliveryDcId)]);
      setExpandPrams({
        expanded: true,
        record: data[0]
      });
    }

    setGoodsDataSource(data);
    return data;
  }, [expandKeys.length]); // 商品维度地点保存行回调

  var handleReload = (0,react.useCallback)(data => {
    // 如果修改的是 审核数量 更新商品维度的总量
    if (data.approveNum) {
      var _placeRef$current;

      var placeData = (_placeRef$current = placeRef.current) === null || _placeRef$current === void 0 ? void 0 : _placeRef$current.getTableData();
      var dataSource = (placeData === null || placeData === void 0 ? void 0 : placeData.dataSource) || [];
      var totalApproveNum = dataSource.reduce((pre, next) => {
        var num = Number(next.approveNum);

        if (Number.isNaN(num)) {
          return pre;
        }

        return pre + num;
      }, 0);
      setGoodsDataSource(v => {
        return v === null || v === void 0 ? void 0 : v.map(item => {
          if ("".concat(expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.record.barCode, "-").concat(expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.record.goodsId, "-").concat(expandPrams === null || expandPrams === void 0 ? void 0 : expandPrams.record.deliveryDcId) === "".concat(item.barCode, "-").concat(item.goodsId, "-").concat(item.deliveryDcId)) {
            return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, item), {}, {
              totalApproveNum
            });
          }

          return item;
        });
      });
    }
  }, [expandPrams]);

  var changeTabs = key => {
    setActiveKey(key);

    if (key === 'goods') {
      var _goodsRef$current2;

      goodsRef === null || goodsRef === void 0 ? void 0 : (_goodsRef$current2 = goodsRef.current) === null || _goodsRef$current2 === void 0 ? void 0 : _goodsRef$current2.reload(goodsSearchParams);
    } else {
      var _tabPlaceRef$current;

      (_tabPlaceRef$current = tabPlaceRef.current) === null || _tabPlaceRef$current === void 0 ? void 0 : _tabPlaceRef$current.reload(goodsPlaceSearchParams);
    }
  };

  (0,react.useEffect)(() => {
    if (!goodsTableRef) {
      return;
    } // @ts-ignore


    goodsTableRef.current = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, goodsRef.current), {}, {
      reload: data => {
        var _goodsRef$current3;

        return (_goodsRef$current3 = goodsRef.current) === null || _goodsRef$current3 === void 0 ? void 0 : _goodsRef$current3.reload({
          condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, data === null || data === void 0 ? void 0 : data.condition), formSearchData)
        });
      }
    });
  }, [formSearchData, goodsRef, goodsTableRef]);
  (0,react.useEffect)(() => {
    if (!placeTableRef) {
      return;
    } // @ts-ignore


    placeTableRef.current = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, placeRef.current), {}, {
      reload: data => {
        var _placeRef$current2;

        return (_placeRef$current2 = placeRef.current) === null || _placeRef$current2 === void 0 ? void 0 : _placeRef$current2.reload({
          condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, data === null || data === void 0 ? void 0 : data.condition), placeSearchParams.condition)
        });
      }
    });
  }, [placeSearchParams.condition, placeTableRef, placeSearchParams]);
  var placeColumns = [{
    title: '商品名称',
    dataIndex: 'goodsName',
    fixed: 'left',
    width: 160,
    sorter: true
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    sorter: true,
    width: 100
  }, {
    title: '商品条码',
    dataIndex: 'barCode',
    sorter: true,
    width: 140
  }, {
    title: '类目',
    dataIndex: 'secondCategoryId',
    width: 130,
    render: (_, record) => record.secondCategoryName ? "".concat(record.firstCategoryName, "/").concat(record.secondCategoryName) : record.firstCategoryName,
    sorter: true
  }, {
    title: '地点编码',
    dataIndex: 'placeCode',
    width: 100,
    sorter: true
  }, {
    title: '地点名称',
    dataIndex: 'placeName',
    width: 160
  }, {
    title: '物流模式',
    dataIndex: 'logisticsName',
    // 注意：商品给的是 logistic，采购给的是 logistics。在添加门店层逻辑中磨平
    width: 100,
    sorter: true
  }, {
    title: '申请数量',
    dataIndex: 'demandNum',
    width: 100,
    sorter: true,
    render: (node, r) => /*#__PURE__*/react.createElement("div", {
      className: "d-flex"
    }, node, "\xA0", r.barCodeUnit)
  }, {
    title: '审核数量',
    dataIndex: 'approveNum',
    width: 100,
    sorter: true,
    type: editable ? 'INPUT' : undefined,
    render: (node, r) => /*#__PURE__*/react.createElement("div", {
      className: "d-flex"
    }, node, "\xA0", r.barCodeUnit)
  }, {
    title: '供应商名称',
    dataIndex: 'supplierName',
    type: r => r.logistics === utils/* LOGISTICE_MODE.配送 */.xT["配送"] || !editable ? undefined : 'SELECT',
    width: 180,
    dataList: r => {
      if (r.supplier && Array.isArray(r.supplier)) {
        return r.supplier.map(v => ({
          value: v.supplierCode,
          label: v.supplierName
        }));
      } else {
        return [{
          value: r.supplierCode,
          label: r.supplierName
        }];
      }
    },
    sorter: true,
    setCellRowValue: r => {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, r), {}, {
        supplierCode: r.supplierName
      });
    }
  }, {
    title: '供应商编码',
    dataIndex: 'supplierCode',
    sorter: true,
    width: 120
  }, {
    title: '参考采购价(元)',
    dataIndex: 'purchaseReferencePrice',
    width: 120
  }, {
    title: '采购价(元)',
    dataIndex: 'unitPrice',
    width: 100,
    type: r => {
      if (isFresh) {
        return ![utils/* LOGISTICE_MODE.直送 */.xT["直送"], utils/* LOGISTICE_MODE.直通 */.xT["直通"]].includes(r.logistics) || !editable ? undefined : 'INPUT';
      }

      return ![utils/* LOGISTICE_MODE.直送 */.xT["直送"]].includes(r.logistics) || !editable ? undefined : 'INPUT';
    }
  }, {
    title: '参考配送价(元)',
    // 成本价
    dataIndex: 'transferReferencePrice',
    width: 120
  }, {
    title: '大仓',
    dataIndex: editable ? 'deliveryDcId' : 'deliveryDcName',
    type: r => [utils/* LOGISTICE_MODE.直通 */.xT["直通"], utils/* LOGISTICE_MODE.配送 */.xT["配送"]].includes(r.logistics) || editable ? 'SELECT' : undefined,
    dataList: r => Array.isArray(r.dc) && r.dc.length ? r.dc.map(e => ({
      label: e.deliveryDcName,
      value: e.deliveryDcId
    })) : [{
      label: r.deliveryDcName,
      value: r.deliveryDcId,
      raw: {
        deliveryDcCode: r.deliveryDcCode,
        deliveryDcId: r.deliveryDcId,
        deliveryDcName: r.deliveryDcName
      }
    }],
    render: (node, record) => record.logistics === utils/* LOGISTICE_MODE.直送 */.xT["直送"] ? '-' : node,
    // 直送不展示
    width: 180
  }, {
    title: '大仓库存',
    dataIndex: 'dcStock',
    width: 110
  }, {
    title: '当前库存',
    dataIndex: 'stock',
    width: 110
  }, {
    title: '当前在途',
    dataIndex: 'onOrderStock',
    width: 110
  }, {
    title: '昨日销量',
    dataIndex: 'yestDaySaleCount',
    width: 110
  }, {
    title: '近7日销量',
    dataIndex: 'last7DaySaleCount',
    width: 110
  }, {
    title: '失败原因',
    dataIndex: 'errorMsg',
    width: 130,
    render: txt => /*#__PURE__*/react.createElement("span", {
      style: {
        color: 'red'
      }
    }, txt),
    sorter: true
  }];
  return /*#__PURE__*/react.createElement(tabs/* default */.Z, {
    onChange: changeTabs,
    activeKey: activeKey
  }, /*#__PURE__*/react.createElement(tabs/* default.TabPane */.Z.TabPane, {
    tab: "\u5546\u54C1\u7EF4\u5EA6",
    key: "goods"
  }, /*#__PURE__*/react.createElement(esm/* EnhanceTable */.UO, (0,esm_extends/* default */.Z)({
    requestUrl: "scm.require.pooling.queryGoodsPoolingDetailList"
  }, goods, {
    tableRef: goodsRef,
    searchParams: goodsSearchParams,
    sortCallback: sortCallback,
    scroll: {
      x: 1200,
      y: 2000
    },
    rowKey: r => "".concat(r.barCode, "-").concat(r.goodsId, "-").concat(r.deliveryDcId),
    afterRequest: afterRequest,
    dataSource: goodsDataSource,
    onRow: r => {
      if (expandKeys.includes("".concat(r.barCode, "-").concat(r.goodsId, "-").concat(r.deliveryDcId))) {
        return {
          className: 'bgBlue'
        };
      }

      return {};
    },
    expandable: {
      expandRowByClick: true,
      expandedRowKeys: expandKeys,
      onExpand: handleExpand,
      expandIcon: _ref2 => {
        var expanded = _ref2.expanded,
            onExpand = _ref2.onExpand,
            record = _ref2.record;
        return expanded ? /*#__PURE__*/react.createElement(UpOutlined/* default */.Z, {
          onClick: e => onExpand(record, e)
        }) : /*#__PURE__*/react.createElement(DownOutlined/* default */.Z, {
          onClick: e => onExpand(record, e)
        });
      },
      expandedRowRender: record => {
        return expandKeys.includes("".concat(record.barCode, "-").concat(record.goodsId, "-").concat(record.deliveryDcId)) && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(PlaceDemandTable.default, (0,esm_extends/* default */.Z)({}, place, {
          mode: "scroll",
          cancelRequest: cancelRequestPlace,
          formData: formSearchData,
          searchParams: placeSearchParams,
          placeTableRef: placeRef,
          sortCallback: sortPlaceCallback,
          getApproveSummary: queryApporeSummaryCallback,
          handleReload: handleReload,
          scroll: {
            x: 600
          }
        })), !hideAddStoreBtn && /*#__PURE__*/react.createElement(es_button/* default */.Z, {
          type: "dashed",
          style: {
            width: '100%',
            marginTop: '23px',
            color: '#1890ff',
            borderColor: '#1890ff'
          },
          onClick: () => handleAddShop(record)
        }, "\u8FFD\u52A0\u95E8\u5E97"));
      },
      onExpandedRowsChange: r => {
        var data = r.filter(v => !expandKeys.includes(v));
        setExpandKeys(data);
      }
    }
  }))), /*#__PURE__*/react.createElement(tabs/* default.TabPane */.Z.TabPane, {
    tab: "\u5730\u70B9\u5546\u54C1\u7EF4\u5EA6",
    key: "place"
  }, /*#__PURE__*/react.createElement(PlaceDemandTable.default, (0,esm_extends/* default */.Z)({
    requestUrl: "scm.require.pooling.queryPlacePoolingDetailList"
  }, placeGoods, {
    mode: "scroll",
    columns: placeGoods !== null && placeGoods !== void 0 && placeGoods.columns ? placeGoods === null || placeGoods === void 0 ? void 0 : placeGoods.columns : placeColumns,
    cancelRequest: cancelRequestPlace,
    formData: formSearchData,
    searchParams: goodsPlaceSearchParams,
    placeTableRef: tabPlaceRef,
    sortCallback: sortGoodsPlaceCallback,
    getApproveSummary: queryApporeSummaryCallback,
    scroll: {
      x: 700
    }
  }))), goodsModal.visible && /*#__PURE__*/react.createElement(components_NoOrderModal, {
    formData: goodsModal.record,
    bussinessType: bussinessType,
    childPlaceList: childPlaceList,
    closeModalCallback: closeModalCallback
  }));
}

/* harmony default export */ var components_ComplexTable = (ComplexTable);

/***/ }),

/***/ 3003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tM": function() { return /* binding */ ExportType; },
/* harmony export */   "ug": function() { return /* binding */ ExportTabType; }
/* harmony export */ });
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57016);
/* harmony import */ var antd_es_tabs_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18106);
/* harmony import */ var antd_es_tabs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69584);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91896);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71577);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _components_EnhanceTable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14845);











/**
 * 查看导出结果浮层
 */


var ExportType;

(function (ExportType) {
  ExportType[ExportType["\u91C7\u8D2D\u5355\u5546\u54C1\u5BFC\u51FA"] = 1] = "\u91C7\u8D2D\u5355\u5546\u54C1\u5BFC\u51FA";
  ExportType[ExportType["\u91C7\u8D2D\u5355\u5355\u4E2A\u5BFC\u51FA"] = 2] = "\u91C7\u8D2D\u5355\u5355\u4E2A\u5BFC\u51FA";
  ExportType[ExportType["\u8C03\u62E8\u5355\u5BFC\u51FA"] = 3] = "\u8C03\u62E8\u5355\u5BFC\u51FA";
  ExportType[ExportType["\u96C6\u5355\u5546\u54C1\u5BFC\u51FA"] = 4] = "\u96C6\u5355\u5546\u54C1\u5BFC\u51FA";
  ExportType[ExportType["\u96C6\u5355\u672A\u4E0B\u5355\u95E8\u5E97\u5BFC\u51FA"] = 5] = "\u96C6\u5355\u672A\u4E0B\u5355\u95E8\u5E97\u5BFC\u51FA";
  ExportType[ExportType["\u96C6\u5355\u5931\u8D25\u660E\u7EC6\u5BFC\u51FA"] = 6] = "\u96C6\u5355\u5931\u8D25\u660E\u7EC6\u5BFC\u51FA";
  ExportType[ExportType["\u91C7\u8D2D\u5355\u4EF7\u683C\u6A21\u677F\u5BFC\u51FA"] = 7] = "\u91C7\u8D2D\u5355\u4EF7\u683C\u6A21\u677F\u5BFC\u51FA";
  ExportType[ExportType["\u91C7\u8D2D\u5355\u5408\u5E76\u5BFC\u51FA"] = 8] = "\u91C7\u8D2D\u5355\u5408\u5E76\u5BFC\u51FA";
  ExportType[ExportType["\u96C6\u5355\u5206\u62E8\u6253\u5370\u5BFC\u51FA"] = 9] = "\u96C6\u5355\u5206\u62E8\u6253\u5370\u5BFC\u51FA";
  ExportType[ExportType["\u96C6\u5355\u8010\u7528\u54C1\u660E\u7EC6"] = 11] = "\u96C6\u5355\u8010\u7528\u54C1\u660E\u7EC6";
})(ExportType || (ExportType = {}));

var ExportTabType;

(function (ExportTabType) {
  ExportTabType["\u5BFC\u51FA\u660E\u7EC6"] = "\u5BFC\u51FA\u660E\u7EC6";
  ExportTabType["\u5546\u54C1\u660E\u7EC6"] = "\u5546\u54C1\u660E\u7EC6";
})(ExportTabType || (ExportTabType = {}));

function ExportList(props) {
  var businessType = props.businessType;
  var table = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(props.exportTabType || ExportTabType.导出明细),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_useState, 2),
      exportTabType = _useState2[0],
      setExportTabType = _useState2[1];

  var downloadFile = url => {
    if (!url) {
      antd_es_message__WEBPACK_IMPORTED_MODULE_7__.default.error('不存在文件');

      return;
    }

    window.location.href = url;
  };

  var columns = [{
    title: '文件名称',
    dataIndex: 'fileName',
    width: 160
  }, {
    title: '导出时间',
    dataIndex: 'exportTime',
    width: 140
  }, {
    title: '状态',
    dataIndex: 'statusName',
    width: 100
  }, {
    title: '操作人',
    dataIndex: 'creator',
    width: 120
  }, {
    title: '操作',
    dataIndex: 'operateeee',
    width: 100,
    render: (_, r) => {
      return r.status === 8 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("a", {
        onClick: () => downloadFile(r.downloadUrl)
      }, "\u4E0B\u8F7D") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("a", {
        onClick: () => {
          var _table$current;

          return (_table$current = table.current) === null || _table$current === void 0 ? void 0 : _table$current.reload();
        }
      }, "\u5237\u65B0");
    }
  }];
  var tablePropsJD = {
    columns,
    query: {
      url: 'scm.requireExport.getExportTaskList',
      params: {
        businessType: businessType || ExportType.集单商品导出
      } // 不用 useMemoe 包裹可以在 Tabs 切换时触发刷新

    }
  };
  var tablePropsDY = {
    columns,
    query: {
      url: 'scm.requireExport.getExportTaskList',
      params: {
        businessType: businessType || ExportType.集单分拨打印导出
      } // 不用 useMemoe 包裹可以在 Tabs 切换时触发刷新

    }
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, {
    title: "\u67E5\u770B\u5BFC\u51FA\u7ED3\u679C",
    destroyOnClose: true,
    maskClosable: false,
    width: 800,
    visible: true,
    onOk: props.closeModalCallback,
    onCancel: props.closeModalCallback,
    footer: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, {
      onClick: props.closeModalCallback
    }, "\u5173\u95ED")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_tabs__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z, {
    activeKey: exportTabType,
    onChange: key => setExportTabType(key)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_tabs__WEBPACK_IMPORTED_MODULE_10__/* .default.TabPane */ .Z.TabPane, {
    key: ExportTabType.导出明细,
    tab: "\u5BFC\u51FA\u660E\u7EC6"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_components_EnhanceTable__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({
    ref: table
  }, tablePropsJD))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_tabs__WEBPACK_IMPORTED_MODULE_10__/* .default.TabPane */ .Z.TabPane, {
    key: ExportTabType.商品明细,
    tab: "\u5546\u54C1\u660E\u7EC6"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_components_EnhanceTable__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({
    ref: table
  }, tablePropsDY)))));
}

/* harmony default export */ __webpack_exports__["ZP"] = (ExportList);

/***/ }),

/***/ 22239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EY": function() { return /* binding */ FRESH_CATE_CODE; },
/* harmony export */   "Aj": function() { return /* binding */ QUICK_SALE_CATE_CODE; },
/* harmony export */   "eT": function() { return /* binding */ useCategory3; },
/* harmony export */   "s6": function() { return /* binding */ categoryFilter; }
/* harmony export */ });
/* unused harmony export CategoryDict */
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var antd_lib_select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64749);
/* harmony import */ var _hooks_useEnums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16965);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25546);






var CategoryDict;

(function (CategoryDict) {
  CategoryDict["\u4E00\u7EA7\u7C7B\u76EE"] = "firstCategoryId";
  CategoryDict["\u4E8C\u7EA7\u7C7B\u76EE"] = "secondCategoryIds";
  CategoryDict["\u4E09\u7EA7\u7C7B\u76EE"] = "thirdCategoryIds";
  CategoryDict["\u56DB\u7EA7\u7C7B\u76EE"] = "fourthCategoryIds";
})(CategoryDict || (CategoryDict = {}));

/** 生鲜类目 ID */
var FRESH_CATE_CODE = 10;
/** 快消类目 ID */

var QUICK_SALE_CATE_CODE = 20;
var Option = antd_lib_select__WEBPACK_IMPORTED_MODULE_3__/* .default.Option */ .Z.Option;
/**
 * 二级商品类目联动
 */

var useCategory3 = function useCategory3() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var filterCates = props.filterCates,
      depth = props.depth,
      _props$defaultValues = props.defaultValues,
      defaultValues = _props$defaultValues === void 0 ? {} : _props$defaultValues;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultValues.firstCategoryId),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      firstCategoryId = _useState2[0],
      setFirstCategoryId = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState3, 2),
      secondCategoryIds = _useState4[0],
      setSecondCategoryIds = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState5, 2),
      thirdCategoryIds = _useState6[0],
      setThirdCategoryIds = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState7, 2),
      fourthCategoryIds = _useState8[0],
      setFourthCategoryIds = _useState8[1];

  var _useEnums = (0,_hooks_useEnums__WEBPACK_IMPORTED_MODULE_1__/* .useEnums */ .ws)(_hooks_useEnums__WEBPACK_IMPORTED_MODULE_1__/* .ENUM_DICT.categoryTreeBusinessMapping */ .J3.categoryTreeBusinessMapping),
      _useEnums2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useEnums, 2),
      categoryRaw = _useEnums2[1];

  var _useMemo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (!categoryRaw) return [[], []];
    var arr = [];
    var item; // 用 const 也可以在 eval 下跑 🙃

    Object.values(categoryRaw).forEach(val => {
      // eslint-disable-next-line no-eval
      eval("(item=".concat(val, ")"));
      arr.push(item);
    }); // {categoryId: 10, categoryName: "生鲜部", categorylevel: 1, childCategoryList: {…}, parentCategoryId: 0}

    if (filterCates instanceof Function) {
      try {
        arr = filterCates(arr);
      } catch (error) {
        console.warn('格式化类目报错\n', error);
      }
    }

    return [arr.map(item => ({
      value: item.categoryId,
      label: item.categoryName
    })), arr];
  }, [categoryRaw]),
      _useMemo2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useMemo, 2),
      categoryOpts1 = _useMemo2[0],
      categoryArr = _useMemo2[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState9, 2),
      categoryOpts2 = _useState10[0],
      setCategoryOpts2 = _useState10[1];

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState12 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState11, 2),
      categoryOpts3 = _useState12[0],
      setCategoryOpts3 = _useState12[1];

  var _useState13 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState14 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState13, 2),
      categoryOpts4 = _useState14[0],
      setCategoryOpts4 = _useState14[1];

  if (categoryRaw && !Object.values(categoryRaw).length) {
    console.warn('木有获取到类目[enum46]\n', categoryRaw);
  }

  var changeCategory = (value, key) => {
    // const item = categoryArr.find(_ => value === _.categoryId)
    // const opts = Object.values(item?.childCategoryList || {}).map(({ categoryId: value, categoryName: label }) => ({ value, label }))
    if (key === CategoryDict.一级类目) {
      setFirstCategoryId(value); // 设置一级类目，会自动重置二级类目

      setSecondCategoryIds([]);
      setThirdCategoryIds([]);
      setFourthCategoryIds([]);
    } else if (key === CategoryDict.二级类目) {
      setSecondCategoryIds(value);
    } else if (key === CategoryDict.三级类目) {
      setThirdCategoryIds(value);
    } else if (key === CategoryDict.四级类目) {
      setFourthCategoryIds(value);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    // console.log('categoryArr', categoryArr)
    var item = categoryArr.find(_ => firstCategoryId === _.categoryId);
    var opts = Object.values((item === null || item === void 0 ? void 0 : item.childCategoryList) || {}).map(_ref => {
      var value = _ref.categoryId,
          label = _ref.categoryName;
      return {
        value,
        label
      };
    });
    setSecondCategoryIds([]);
    setThirdCategoryIds([]);
    setFourthCategoryIds([]);
    setCategoryOpts2(opts !== null && opts !== void 0 ? opts : []);
  }, [firstCategoryId, categoryArr]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var firstItem = categoryArr.find(_ => firstCategoryId === _.categoryId); // 根据二级类目id拼接三级类目

    var secondIem = secondCategoryIds.reduce((acc, id) => {
      if (firstItem !== null && firstItem !== void 0 && firstItem.childCategoryList[id]) {
        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)({}, acc), firstItem.childCategoryList[id].childCategoryList);
      }

      return acc;
    }, {});
    var opts = Object.values(secondIem || {}).map(_ref2 => {
      var value = _ref2.categoryId,
          label = _ref2.categoryName;
      return {
        value,
        label
      };
    });
    setThirdCategoryIds([]);
    setFourthCategoryIds([]);
    setCategoryOpts3(opts !== null && opts !== void 0 ? opts : []);
  }, [secondCategoryIds, categoryArr, firstCategoryId]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var firstItem = categoryArr.find(_ => firstCategoryId === _.categoryId);
    var secondItem = secondCategoryIds.reduce((acc, id) => {
      if (firstItem !== null && firstItem !== void 0 && firstItem.childCategoryList[id]) {
        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)({}, acc), firstItem.childCategoryList[id].childCategoryList);
      }

      return acc;
    }, {});
    var thirdItem = thirdCategoryIds.reduce((acc, id) => {
      var _secondItem$id;

      if (secondItem !== null && secondItem !== void 0 && (_secondItem$id = secondItem[id]) !== null && _secondItem$id !== void 0 && _secondItem$id.childCategoryList) {
        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)({}, acc), secondItem[id].childCategoryList);
      }

      return acc;
    }, {});
    var opts = Object.values(thirdItem || {}).map(_ref3 => {
      var value = _ref3.categoryId,
          label = _ref3.categoryName;
      return {
        value,
        label
      };
    });
    setFourthCategoryIds([]);
    setCategoryOpts4(opts !== null && opts !== void 0 ? opts : []);
  }, [thirdCategoryIds, categoryArr, firstCategoryId, secondCategoryIds]);
  var element = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "d-flex user-category-3"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd_lib_select__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    style: {
      width: 90
    },
    allowClear: true,
    placeholder: "\u8BF7\u9009\u62E9",
    value: firstCategoryId,
    dropdownMatchSelectWidth: false,
    onChange: val => changeCategory(val, CategoryDict.一级类目)
  }, categoryOpts1.map(_ref4 => {
    var value = _ref4.value,
        label = _ref4.label;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, {
      key: value,
      value: value
    }, label);
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd_lib_select__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    style: {
      width: '100%'
    },
    allowClear: true,
    placeholder: "\u8BF7\u9009\u62E9",
    mode: "multiple",
    value: secondCategoryIds,
    onChange: val => changeCategory(val, CategoryDict.二级类目)
  }, categoryOpts2.map(_ref5 => {
    var value = _ref5.value,
        label = _ref5.label;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, {
      key: value,
      value: value
    }, label);
  })), depth ? null : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd_lib_select__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    style: {
      width: '100%'
    },
    allowClear: true,
    placeholder: "\u8BF7\u9009\u62E9",
    mode: "multiple",
    value: thirdCategoryIds,
    onChange: val => changeCategory(val, CategoryDict.三级类目)
  }, categoryOpts3.map(_ref6 => {
    var value = _ref6.value,
        label = _ref6.label;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, {
      key: value,
      value: value
    }, label);
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd_lib_select__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    style: {
      width: '100%'
    },
    allowClear: true,
    placeholder: "\u8BF7\u9009\u62E9",
    mode: "multiple",
    value: fourthCategoryIds,
    onChange: val => changeCategory(val, CategoryDict.四级类目)
  }, categoryOpts4.map(_ref7 => {
    var value = _ref7.value,
        label = _ref7.label;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, {
      key: value,
      value: value
    }, label);
  }))));
  return [element, {
    category3: {
      firstCategoryId,
      secondCategoryIds,
      thirdCategoryIds,
      fourthCategoryIds
    },

    reset() {
      setFirstCategoryId(defaultValues.firstCategoryId);
      setThirdCategoryIds([]);
      setFourthCategoryIds([]);
    }

  }];
};
/**
 * 类目过滤
 * 20-09-22
 */

function categoryFilter(type) {
  return categoryies => categoryies.filter(cate => {
    if (type === _utils__WEBPACK_IMPORTED_MODULE_2__/* .POOL_TYPE.FRESH */ .FP.FRESH) {
      return +cate.categoryId === FRESH_CATE_CODE; // 生鲜只留生鲜
    } else {
      return +cate.categoryId !== FRESH_CATE_CODE; // 快消排除生鲜
    }
  });
}

/***/ }),

/***/ 25546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O6": function() { return /* binding */ FUNC; },
/* harmony export */   "FP": function() { return /* binding */ POOL_TYPE; },
/* harmony export */   "fb": function() { return /* binding */ DEMAND_TYPE; },
/* harmony export */   "gn": function() { return /* binding */ TAB_TYPE; },
/* harmony export */   "l": function() { return /* binding */ APPROVE_STATUS_OPT; },
/* harmony export */   "Oq": function() { return /* binding */ APPROVE_STATUS; },
/* harmony export */   "jY": function() { return /* binding */ supplyRouteList; },
/* harmony export */   "al": function() { return /* binding */ changeApproveStatus; },
/* harmony export */   "G$": function() { return /* binding */ validateForm; },
/* harmony export */   "xT": function() { return /* binding */ LOGISTICE_MODE; },
/* harmony export */   "g2": function() { return /* binding */ RETURN_MODE; },
/* harmony export */   "B5": function() { return /* binding */ mergeArr; },
/* harmony export */   "ME": function() { return /* binding */ seconds2minute; },
/* harmony export */   "yQ": function() { return /* binding */ getApproveSummary; },
/* harmony export */   "zN": function() { return /* binding */ formatPlaceGroup; },
/* harmony export */   "O1": function() { return /* binding */ usePlaceList; },
/* harmony export */   "kp": function() { return /* binding */ uniqueOptions; },
/* harmony export */   "v0": function() { return /* binding */ ONE_PAGE_COL; },
/* harmony export */   "Y1": function() { return /* binding */ ONE_PAGE_ROW; },
/* harmony export */   "FN": function() { return /* binding */ assembleGoodsPrintTpl; },
/* harmony export */   "y8": function() { return /* binding */ cancelPooling; },
/* harmony export */   "hQ": function() { return /* binding */ onekeyBalanceStock; },
/* harmony export */   "XK": function() { return /* binding */ useBatchUpdateDelivery; },
/* harmony export */   "H8": function() { return /* binding */ backfill; },
/* harmony export */   "MO": function() { return /* binding */ editChange; },
/* harmony export */   "FU": function() { return /* binding */ convertBusiness_with_Place; },
/* harmony export */   "MU": function() { return /* binding */ limitDay_for_RangePicker; },
/* harmony export */   "gz": function() { return /* binding */ STOCK_SUPPLIER; },
/* harmony export */   "KZ": function() { return /* binding */ convertValue_arr2let; }
/* harmony export */ });
/* unused harmony exports map2options, options2map, LINE_FLAG, APPROVE_STATUS_MAP, RETURNE_OPTS, getSupplier, getDemandPoolingReferencePrice, BILL_TYPE, getPlaceProductSales, ONE_PAGE_ITEMS, refreshDCStock, queryProductExtInfo, sorterHelper, querystring */
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(34041);
/* harmony import */ var antd_es_radio_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88983);
/* harmony import */ var antd_es_radio__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(55742);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(48086);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24731);
/* harmony import */ var _hooks_useEnums__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16965);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7704);


















/** 详情页功能标识 */
var FUNC;

(function (FUNC) {
  FUNC["APPROVE"] = "_approve";
  FUNC["VIEW"] = "_view";
})(FUNC || (FUNC = {}));

var map2options = map => {
  return Array.from(map).map(_ref => {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return {
      value: k,
      label: v
    };
  });
};
var options2map = options => {
  return new Map(options.map(_ref3 => {
    var value = _ref3.value,
        label = _ref3.label;
    return [+value, label];
  }));
};
/**
 * int32 categoryType = 6; // 1.生鲜 2.快消  必传
 */

var POOL_TYPE;
/**
 * int32 demandType = 8; // 需求类型：1补货；2退货  必传
 */

(function (POOL_TYPE) {
  POOL_TYPE[POOL_TYPE["FRESH"] = 1] = "FRESH";
  POOL_TYPE[POOL_TYPE["QUICK"] = 2] = "QUICK";
})(POOL_TYPE || (POOL_TYPE = {}));

var DEMAND_TYPE;

(function (DEMAND_TYPE) {
  DEMAND_TYPE[DEMAND_TYPE["SUUPLEMENT"] = 1] = "SUUPLEMENT";
  DEMAND_TYPE[DEMAND_TYPE["RETURN"] = 2] = "RETURN";
})(DEMAND_TYPE || (DEMAND_TYPE = {}));

var TAB_TYPE;
/** 回落数据标记 */

(function (TAB_TYPE) {
  TAB_TYPE["GOODS"] = "GOODS";
  TAB_TYPE["PLACE"] = "PLACE";
})(TAB_TYPE || (TAB_TYPE = {}));

var LINE_FLAG;
/**
 * 操作类型：1开始审核；2取消审核；3审核通过；4审核不通过
 */

(function (LINE_FLAG) {
  LINE_FLAG["\u65B0\u6DFB"] = "\u65B0\u6DFB";
  LINE_FLAG["\u56DE\u586B"] = "\u56DE\u586B";
})(LINE_FLAG || (LINE_FLAG = {}));

var APPROVE_STATUS_OPT;

(function (APPROVE_STATUS_OPT) {
  APPROVE_STATUS_OPT[APPROVE_STATUS_OPT["\u5F00\u59CB\u5BA1\u6838"] = 1] = "\u5F00\u59CB\u5BA1\u6838";
  APPROVE_STATUS_OPT[APPROVE_STATUS_OPT["\u53D6\u6D88\u5BA1\u6838"] = 2] = "\u53D6\u6D88\u5BA1\u6838";
  APPROVE_STATUS_OPT[APPROVE_STATUS_OPT["\u5BA1\u6838\u901A\u8FC7"] = 3] = "\u5BA1\u6838\u901A\u8FC7";
  APPROVE_STATUS_OPT[APPROVE_STATUS_OPT["\u5BA1\u6838\u4E0D\u901A\u8FC7"] = 4] = "\u5BA1\u6838\u4E0D\u901A\u8FC7";
})(APPROVE_STATUS_OPT || (APPROVE_STATUS_OPT = {}));

var APPROVE_STATUS;

(function (APPROVE_STATUS) {
  APPROVE_STATUS[APPROVE_STATUS["\u5F85\u5BA1\u6838"] = 1] = "\u5F85\u5BA1\u6838";
  APPROVE_STATUS[APPROVE_STATUS["\u5BA1\u6838\u4E2D"] = 2] = "\u5BA1\u6838\u4E2D";
  APPROVE_STATUS[APPROVE_STATUS["\u5BA1\u6838\u901A\u8FC7"] = 3] = "\u5BA1\u6838\u901A\u8FC7";
  APPROVE_STATUS[APPROVE_STATUS["\u5BA1\u6838\u4E0D\u901A\u8FC7"] = 4] = "\u5BA1\u6838\u4E0D\u901A\u8FC7";
  APPROVE_STATUS[APPROVE_STATUS["\u96C6\u5355\u4E2D"] = 5] = "\u96C6\u5355\u4E2D";
  APPROVE_STATUS[APPROVE_STATUS["\u96C6\u5355\u5931\u8D25"] = 6] = "\u96C6\u5355\u5931\u8D25";
})(APPROVE_STATUS || (APPROVE_STATUS = {}));

var APPROVE_STATUS_MAP = new Map([[1, '待审核'], [2, '审核中'], [3, '审核通过'], [4, '审核不通过'], [5, '集单中'], [6, '集单失败']]);
/**
 * 供货路径
 */

var supplyRouteList = [{
  value: 1,
  label: '台州仓-城市仓-城市店'
}, {
  value: 2,
  label: '台州仓-城市仓'
}, {
  value: 3,
  label: '台州仓-城市店'
}];
/**
 * 修改审核状态
 * @param poolingId 集单号
 */

var changeApproveStatus = /*#__PURE__*/function () {
  var _ref4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee(poolingId, operateType) {
    var url;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = 'scm.require.durablePooling.updateDurablePoolingStatus';
            return _context.abrupt("return", (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(url, {
              poolingId,
              operateType
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function changeApproveStatus(_x, _x2) {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * 验证表单
 */

var validateForm = /*#__PURE__*/function () {
  var _ref5 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee2(form) {
    var _ref6,
        _ref6$begin,
        begin,
        _ref6$end,
        end,
        values,
        _args2 = arguments;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref6 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, _ref6$begin = _ref6.begin, begin = _ref6$begin === void 0 ? 'beginCreateTime' : _ref6$begin, _ref6$end = _ref6.end, end = _ref6$end === void 0 ? 'endCreateTime' : _ref6$end;

            if (form) {
              _context2.next = 3;
              break;
            }

            throw new Error('form 实例不能为空');

          case 3:
            _context2.prev = 3;
            _context2.next = 6;
            return form.current.validateFields();

          case 6:
            values = _context2.sent;

            if (Array.isArray(values.time) && values.time.length) {
              values[begin] = values.time[0].format('YYYY-MM-DD 00:00:00');
              values[end] = values.time[1].format('YYYY-MM-DD 23:59:59');
            }

            Object.entries(values).forEach(_ref7 => {
              var _ref8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_ref7, 2),
                  k = _ref8[0],
                  v = _ref8[1];

              return v || delete values[k];
            });
            delete values.time;
            return _context2.abrupt("return", values);

          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](3);
            return _context2.abrupt("return", null);

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 13]]);
  }));

  return function validateForm(_x3) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * 物流模式 1直送；2配送；3直通
 */

var LOGISTICE_MODE; // 直通是统一退大仓后退供应商
// 退货方式：退供应商（直送）
// 退货方式：退仓（配送）
// 退DC后退供应商：直通（DC-大仓）

/**
 * 退货方式,对应三种物流模式
 * [{"value":1,"label":"退仓后退供应商","others":"1"},{"value":2,"label":"退仓后退供应商","others":"2"},{"value":3,"label":"退仓后退供应商","others":"3"}]
 */

(function (LOGISTICE_MODE) {
  LOGISTICE_MODE[LOGISTICE_MODE["\u76F4\u9001"] = 1] = "\u76F4\u9001";
  LOGISTICE_MODE[LOGISTICE_MODE["\u914D\u9001"] = 2] = "\u914D\u9001";
  LOGISTICE_MODE[LOGISTICE_MODE["\u76F4\u901A"] = 3] = "\u76F4\u901A";
})(LOGISTICE_MODE || (LOGISTICE_MODE = {}));

var RETURN_MODE;

(function (RETURN_MODE) {
  RETURN_MODE[RETURN_MODE["\u9000\u4F9B\u5E94\u5546"] = 1] = "\u9000\u4F9B\u5E94\u5546";
  RETURN_MODE[RETURN_MODE["\u9000\u4ED3"] = 2] = "\u9000\u4ED3";
  RETURN_MODE[RETURN_MODE["\u9000\u4ED3\u540E\u9000\u4F9B\u5E94\u5546"] = 3] = "\u9000\u4ED3\u540E\u9000\u4F9B\u5E94\u5546";
})(RETURN_MODE || (RETURN_MODE = {}));

var RETURNE_OPTS = [{
  label: '退供应商',
  value: 1
}, {
  label: '退仓',
  value: 2
}, {
  label: '退仓后退供应商',
  value: 3
}];

/**
 * @deprecated
 * 获取供应商
 * 文档：https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=31960057#id-%E9%80%9A%E7%94%A8%E5%95%86%E5%93%81%E6%A8%A1%E5%9D%97%E6%8E%A5%E5%8F%A3-2.4%E6%9F%A5%E8%AF%A2%E5%95%86%E5%93%81%E4%BE%9B%E5%BA%94%E5%95%86%E4%BF%A1%E6%81%AF
 */
function getSupplier(_x4) {
  return _getSupplier.apply(this, arguments);
}

function _getSupplier() {
  _getSupplier = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(tableList) {
    var url, paramList, res, _yield$ypRequest4, success, result;

    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (Array.isArray(tableList) && tableList.length) {
              _context6.next = 3;
              break;
            }

            console.warn('getSupplier-获取供应商参数无效', tableList);
            return _context6.abrupt("return", Promise.resolve([]));

          case 3:
            url = 'scm.require.queryProductSupplier';
            paramList = tableList.map(item => {
              var json = {
                merchantId: item.merchantId,
                // 商家Id
                goodsId: item.goodsId,
                // 商品Id列表
                placeId: item.placeId // 地点Id

              };

              if (json.merchantId && json.goodsId && json.placeId) {
                return json;
              }

              return null;
            }).filter(_ => _);
            res = [];
            _context6.next = 8;
            return ypRequest(url, {
              paramList
            });

          case 8:
            _yield$ypRequest4 = _context6.sent;
            success = _yield$ypRequest4.success;
            result = _yield$ypRequest4.result;

            if (success) {
              res = result.list.map(item => _objectSpread(_objectSpread({}, item), {}, {
                options: item.supplier.map(item2 => ({
                  label: item2.supplierName,
                  value: item2.supplierCode
                }))
              }));
            }

            return _context6.abrupt("return", res);

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getSupplier.apply(this, arguments);
}

/**
 * @deprecated
 * 获取集单里商品的参考采购价、配送价
 * 文档：https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=31960057#id-通用商品模块接口-2.2获取集单里商品的参考采购价、配送价
 */
function getReferencePrice2(_x5, _x6) {
  return _getReferencePrice.apply(this, arguments);
}

function _getReferencePrice() {
  _getReferencePrice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(orderDirect, tableList) {
    var url, paramList, res, _yield$ypRequest5, success, result;

    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (Array.isArray(tableList) && tableList.length) {
              _context7.next = 3;
              break;
            }

            console.warn('getReferencePrice-参考采购价、配送价参数无效', tableList);
            return _context7.abrupt("return", Promise.resolve([]));

          case 3:
            url = 'scm.require.queryDemandPoolingReferencePrice';
            paramList = tableList.map(item => ({
              merchantId: item.merchantId,
              // 商家Id
              goodsId: item.goodsId,
              // 商品Id列表
              placeId: item.placeId,
              // 地点Id
              firstCategoryId: item.firstCategoryId,
              // 商品一级类目
              secondCategoryId: item.secondCategoryId // 商品二级类目

            }));
            res = [];
            _context7.next = 8;
            return ypRequest(url, {
              orderDirect,
              paramList
            });

          case 8:
            _yield$ypRequest5 = _context7.sent;
            success = _yield$ypRequest5.success;
            result = _yield$ypRequest5.result;

            if (success) {
              res = result.list;
            }

            return _context7.abrupt("return", res);

          case 13:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getReferencePrice.apply(this, arguments);
}

/**
 * 获取集单里商品的参考采购价、成本价
 * https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=31960057#id-通用商品模块接口-2.2获取集单里商品的参考采购价、成本价
 */
function getDemandPoolingReferencePrice(_x7) {
  return _getDemandPoolingReferencePrice.apply(this, arguments);
}
/** 单据类型 */

function _getDemandPoolingReferencePrice() {
  _getDemandPoolingReferencePrice = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee8(arg0) {
    var url, params, res, _yield$ypRequest6, success, result;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (Array.isArray(arg0.tableList) && arg0.tableList.length) {
              _context8.next = 3;
              break;
            }

            console.warn('getReferencePrice-参考采购价、配送价参数无效', arg0.tableList);
            return _context8.abrupt("return", Promise.resolve([]));

          case 3:
            url = 'scm.require.queryDemandPoolingReferencePrice';
            params = {
              orderDirect: arg0.orderDirect,
              // 订单方向
              firstCategoryId: arg0.firstCategoryId,
              // 一级类目ID
              merchantId: arg0.merchantId,
              // 商家ID
              goodsList: arg0.tableList.map(item => ({
                goodsId: item.goodsId,
                // 商品 id
                logistics: item.logistics,
                // 物流模式
                placeId: item.placeId,
                // 地点ID
                deliveryDcId: item.deliveryDcId // 大仓ID

              }))
            };
            res = [];
            _context8.next = 8;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(url, params);

          case 8:
            _yield$ypRequest6 = _context8.sent;
            success = _yield$ypRequest6.success;
            result = _yield$ypRequest6.result;

            if (success) {
              res = result.list;
            }

            return _context8.abrupt("return", res);

          case 13:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _getDemandPoolingReferencePrice.apply(this, arguments);
}

var BILL_TYPE;

(function (BILL_TYPE) {
  BILL_TYPE[BILL_TYPE["\u672A\u77E5"] = 0] = "\u672A\u77E5";
  BILL_TYPE[BILL_TYPE["\u91C7\u8D2D\u8BA2\u8D27"] = 1] = "\u91C7\u8D2D\u8BA2\u8D27";
  BILL_TYPE[BILL_TYPE["\u91C7\u8D2D\u9000\u8D27"] = 2] = "\u91C7\u8D2D\u9000\u8D27";
  BILL_TYPE[BILL_TYPE["\u4ED3\u95F4\u8C03\u62E8"] = 3] = "\u4ED3\u95F4\u8C03\u62E8";
  BILL_TYPE[BILL_TYPE["\u5E97\u95F4\u8C03\u62E8"] = 4] = "\u5E97\u95F4\u8C03\u62E8";
  BILL_TYPE[BILL_TYPE["\u4ED3\u5E97\u914D\u9001"] = 5] = "\u4ED3\u5E97\u914D\u9001";
  BILL_TYPE[BILL_TYPE["\u8981\u8D27\u96C6\u5355"] = 6] = "\u8981\u8D27\u96C6\u5355";
  BILL_TYPE[BILL_TYPE["\u9000\u8D27\u96C6\u5355"] = 7] = "\u9000\u8D27\u96C6\u5355";
  BILL_TYPE[BILL_TYPE["\u6279\u53D1\u9500\u552E"] = 8] = "\u6279\u53D1\u9500\u552E";
  BILL_TYPE[BILL_TYPE["\u5E97\u4ED3\u9000\u914D"] = 9] = "\u5E97\u4ED3\u9000\u914D";
  BILL_TYPE[BILL_TYPE["\u91C7\u8D2D\u5206\u914D\u5355\u8BA2\u8D27"] = 10] = "\u91C7\u8D2D\u5206\u914D\u5355\u8BA2\u8D27";
  BILL_TYPE[BILL_TYPE["\u91C7\u8D2D\u5206\u914D\u5355\u9000\u8D27"] = 11] = "\u91C7\u8D2D\u5206\u914D\u5355\u9000\u8D27";
  BILL_TYPE[BILL_TYPE["\u5206\u62E8\u8BA2\u5355\u4ED3\u95F4\u8C03\u62E8"] = 12] = "\u5206\u62E8\u8BA2\u5355\u4ED3\u95F4\u8C03\u62E8";
  BILL_TYPE[BILL_TYPE["\u5206\u62E8\u8BA2\u5355\u5E97\u95F4\u8C03\u62E8"] = 13] = "\u5206\u62E8\u8BA2\u5355\u5E97\u95F4\u8C03\u62E8";
  BILL_TYPE[BILL_TYPE["\u5206\u62E8\u8BA2\u5355\u4ED3\u5E97\u914D\u9001"] = 14] = "\u5206\u62E8\u8BA2\u5355\u4ED3\u5E97\u914D\u9001";
  BILL_TYPE[BILL_TYPE["\u5206\u62E8\u8BA2\u5355\u5E97\u4ED3\u9000\u914D"] = 15] = "\u5206\u62E8\u8BA2\u5355\u5E97\u4ED3\u9000\u914D";
})(BILL_TYPE || (BILL_TYPE = {}));

/**
 * @deprecated
 * 根据商家+地点+编码查询商品销量(地点维度)
 * 文档：https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=31960057#id-通用商品模块接口-1.8根据商家+地点+编码查询商品销量(地点维度)
 */
function getPlaceProductSales(_x8) {
  return _getPlaceProductSales.apply(this, arguments);
}
/**
 * 合并两个数组
 */

function _getPlaceProductSales() {
  _getPlaceProductSales = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(tableList) {
    var url, paramList, res, _yield$ypRequest7, success, result;

    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (Array.isArray(tableList) && tableList.length) {
              _context9.next = 3;
              break;
            }

            console.warn('getPlaceProductSales-根据商家+地点+编码查询商品销量，参数无效', tableList);
            return _context9.abrupt("return", Promise.resolve([]));

          case 3:
            url = 'scm.require.queryPlaceProductSales';
            paramList = tableList.map(item => ({
              merchantId: item.merchantId,
              // 商家Id
              goodsId: item.goodsId,
              // 商品Id列表
              placeId: item.placeId // 地点Id

            }));
            res = [];
            _context9.next = 8;
            return ypRequest(url, {
              paramList
            });

          case 8:
            _yield$ypRequest7 = _context9.sent;
            success = _yield$ypRequest7.success;
            result = _yield$ypRequest7.result;

            if (success) {
              res = result.list;
            }

            return _context9.abrupt("return", res);

          case 13:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _getPlaceProductSales.apply(this, arguments);
}

function mergeArr() {
  var arr1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var arr2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var field = arguments.length > 2 ? arguments[2] : undefined;
  return arr1.map(item1 => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)({}, item1), arr2.find(item2 => {
    if (Array.isArray(field)) {
      // 方式1
      var rest = field.map(str => item2[str] === item1[str]).filter(b => !b);
      return rest.length === 0; // 方式2
      // const bool = field.reduce((acc, cur, idx) => acc && item2[cur] === item1[cur], true)
      // return bool
    } else {
      return item2[field] === item1[field];
    }
  })));
} // /**
//  * 返回：数组交集、并集
//  * 并集有问题: 20-07-09
//  */
// export function intersectionArr(arr1: Array<any> = [], arr2: Array<any> = [], field: string | string[]) {
//   const _arr1: Array<any> = []
//   const _arr2: Array<any> = []
//   arr1.forEach(item1 => {
//     _arr2.push(JSON.parse(JSON.stringify(item1)))
//     let first_index = -1
//     arr2.forEach((item2, idx2) => {
//       let bool: boolean
//       if (Array.isArray(field)) {
//         bool = field.reduce((acc, key, i) => acc && item2[key] === item1[key], true) as any
//       } else {
//         bool = item2[field] === item1[field]
//       }
//       if (!bool) {
//         _arr2.push(JSON.parse(JSON.stringify(item2)))
//       }
//       if (bool && first_index === -1) first_index = idx2
//     })
//     if (first_index !== -1) {
//       _arr1.push(JSON.parse(JSON.stringify(arr2[first_index])))
//     }
//   })
//   return [
//     /** 交集 */
//     _arr1,
//     /** 并集 */
//     _arr2
//   ]
// }

/** 秒 -> 分 */

function seconds2minute(str) {
  var splitor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '~';

  try {
    var tmp = str.split(splitor);

    if (tmp.length === 2) {
      return [tmp[0].substr(0, 10), tmp[1].substr(0, 10)].join(splitor);
    }

    return tmp[0].substr(0, 10);
  } catch (error) {
    return str;
  }
}

/**
 * 审核汇总
 * https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=29184742#id-%E9%9C%80%E6%B1%82%E5%B9%B3%E8%A1%A1-2.17%E6%9F%A5%E8%AF%A2%E9%9B%86%E5%8D%95%E6%B1%87%E6%80%BB%E4%BF%A1%E6%81%AF
 */
function getApproveSummary(_x9) {
  return _getApproveSummary.apply(this, arguments);
}

function _getApproveSummary() {
  _getApproveSummary = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee10(params) {
    var _yield$ypRequest8, success, result;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)('scm.require.statPoolingGoodsInfo', {
              condition: params
            });

          case 2:
            _yield$ypRequest8 = _context10.sent;
            success = _yield$ypRequest8.success;
            result = _yield$ypRequest8.result;
            return _context10.abrupt("return", success ? result : getApproveSummary.defaultApproveSummary);

          case 6:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _getApproveSummary.apply(this, arguments);
}

getApproveSummary.defaultApproveSummary = {
  supplierCount: '-',
  skuNum: '-',
  totalApplyNum: '-',
  totalApproveNum: '-',
  totalAmount: '-',
  abnormalGoodsCount: '-',
  _failed: true
};
/** 店群下门店 */

/** 格式化店群数据 */
function formatPlaceGroup(rawMap) {
  if (Array.isArray(rawMap) || !rawMap) {
    return [];
  }

  return Object.entries(rawMap).map(_ref9 => {
    var _ref10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_ref9, 2),
        val = _ref10[1];

    var _ref11 = JSON.parse(val),
        placeGroupName = _ref11.placeGroupName,
        placeGroupId = _ref11.placeGroupId,
        placeList = _ref11.placeList;

    return {
      label: placeGroupName,
      value: placeGroupId,
      placeList
    };
  });
}
/** 获取店群下的门店 */

function usePlaceList() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState, 2),
      placeGroupId = _useState2[0],
      setPlaceGroupId = _useState2[1];

  var _useEnums = (0,_hooks_useEnums__WEBPACK_IMPORTED_MODULE_6__/* .useEnums */ .ws)(60, {
    placeGroupId
  }),
      _useEnums2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useEnums, 2),
      _useEnums2$ = _useEnums2[1],
      raw = _useEnums2$ === void 0 ? {} : _useEnums2$;

  var place = {};

  try {
    place = JSON.parse(raw[placeGroupId || '']);
  } catch (error) {}

  var placeList = (place.placeList || []).map(_ => ({
    label: _.shotName,
    value: _.placeId,
    $raw: _
  }));
  return {
    placeList: placeGroupId ? placeList :
    /** 无店群用原来的全部地点 */
    [],
    setPlaceGroupId
  };
}
/** 数组去重 */

function uniqueOptions(arr) {
  return [...new Set(arr.map(_ => _.value))].map(_ => arr.find(ele => ele.value === _)).filter(_ => _);
}
var ONE_PAGE_COL = 3; // 分三列打印

var ONE_PAGE_ROW = 31; // 行数

var ONE_PAGE_ITEMS = ONE_PAGE_COL * ONE_PAGE_ROW; // 单页总数据量

/**
 * 装配打印模板
 * record 即代表一页 A4 纸，item.detail 为 A4 纸一页数据
 */

function assembleGoodsPrintTpl(record) {
  var title = [[{
    n: '采购日期',
    f: 'purchaseDate'
  }, {
    n: '采购商品',
    f: 'goodsName',

    /* value style */
    vs: 'font-weight:bold; font-size:14px;'
  }, {
    n: '商品总重',
    f: 'totalQty',
    vs: 'font-weight:bold; font-size:14px;'
  }, {
    n: '商品单位',
    f: 'unit'
  }], [{
    n: '供应商名称',
    f: ''
  }, {
    n: '商品编码',
    f: 'goodsId'
  }, {
    n: '联系方式',
    f: ''
  }, {
    n: '商品规格',
    f: 'spec'
  }], [{
    n: '采购员签字',
    f: ''
  }, {
    n: '送货员签字',
    f: ''
  }, {
    n: '质检签字',
    f: ''
  }, {
    n: '仓位号',
    f: ''
  }]].map(strs => {
    var labelStyle = "style=\"display:inline-block;width:9%;line-height:24px;font-size:12px;margin-left:1.4%;\"";

    var valueStyle = function valueStyle() {
      var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return "style=\"display:inline-block;width:13%;line-height:24px;font-size:12px;border-bottom:1px solid black;".concat(style, "\"");
    };

    var spans = "\n      <span ".concat(labelStyle, ">").concat(strs[0].n, "</span> <span ").concat(valueStyle(strs[0].vs), ">").concat(record[strs[0].f] || '&nbsp;', "</span>\n      <span ").concat(labelStyle, ">").concat(strs[1].n, "</span> <span ").concat(valueStyle(strs[1].vs), ">").concat(record[strs[1].f] || '&nbsp;', "</span>\n      <span ").concat(labelStyle, ">").concat(strs[2].n, "</span> <span ").concat(valueStyle(strs[2].vs), ">").concat(record[strs[2].f] || '&nbsp;', "</span>\n      <span ").concat(labelStyle, ">").concat(strs[3].n, "</span> <span ").concat(valueStyle(strs[3].vs), ">").concat(record[strs[3].f] || '&nbsp;', "</span>");
    return "<div>".concat(spans.trim(), "</div>");
  });
  var fillPrintRecord = {
    detail: {}
  };
  var length = ONE_PAGE_ITEMS - record.detail.length % ONE_PAGE_ITEMS + record.detail.length; // 补充每页空白

  var tableDataArr = new Array(length).fill(fillPrintRecord).map((_, i) => record.detail[i] || _);
  var tableArr_chunked = (0,lodash__WEBPACK_IMPORTED_MODULE_7__.chunk)(tableDataArr, ONE_PAGE_ROW); // 按每列排列行数切割

  var trStyle = "style=\"height:26px;\"";

  var table = dataSource => {
    var tdCenter = "style=\"text-align:center;\"";
    var trs = dataSource.map((_ref12, idx) => {
      var placeCode = _ref12.placeCode,
          sortName = _ref12.sortName,
          qty = _ref12.qty;
      var sortName_style = (sortName || '').length >=
      /* 两列取 11，三列取 7 */
      7 ? "style=\"font-size:10px;\"" : '';
      return "<tr ".concat(trStyle.trim(), ">\n        <td ").concat(tdCenter, ">").concat(placeCode || '', "</td>\n        <td ").concat(sortName_style, ">").concat(sortName || '', "</td>\n        <td ").concat(tdCenter, ">").concat(qty || '', "</td>\n        <td></td>\n      </tr>");
    });
    var tableStyle = "\n    border=\"1\" style=\"border-spacing:0;border-collapse:collapse;font-size:13px;float:left;width:".concat((1 / ONE_PAGE_COL * 100 - 1).toFixed(2), "%;margin:0 .5%;\"\n    ");
    return "<table ".concat(tableStyle.trim(), ">\n      <thead>\n        <tr>\n          <th style=\"width:20%;text-align:center;\">\u5E97\u7F16\u53F7</th>\n          <th style=\"width:40%;font-weight:bold;\">\u5E97\u7B80\u79F0</th>\n          <th style=\"width:20%;text-align:center;font-size:10px;\">\u8981\u8D27\u6570\u91CF</th>\n          <th style=\"width:20%;font-size:10px;\">\u5B9E\u5206\u6570\u91CF</th>\n        </tr>\n      </thead>\n      <tbody>\n        ").concat(trs, "\n      </tbody>\n    </table>");
  };

  var tables = tableArr_chunked.map(d => table(d));
  var bottomLabelStyle = "style=\"display:inline-block;font-size:12px;line-height:24px;width:9%;margin-left:1%;\"";
  var bottomValueStyle = "style=\"display:inline-block;font-size:12px;line-height:24px;width:15%;border-bottom:1px solid black;\"";
  var bottom = "\n  <div style=\"text-align:center;margin-top:15px;clear:both;\">\n  <span ".concat(bottomLabelStyle, ">\u53D1\u8D27\u603B\u91CD\u91CF</span> <span ").concat(bottomValueStyle, ">&nbsp;</span>\n  <span ").concat(bottomLabelStyle, ">\u5355\u4EF7</span> <span ").concat(bottomValueStyle, ">&nbsp;</span>\n  <span ").concat(bottomLabelStyle, ">\u603B\u91D1\u989D</span> <span ").concat(bottomValueStyle, ">&nbsp;</span>\n  </div>\n  ");
  var pages = (0,lodash__WEBPACK_IMPORTED_MODULE_7__.chunk)(tables, ONE_PAGE_COL);
  return {
    title,
    tables,
    pages,
    A4_pages: pages.map(tablesOfA4 => "\n      <div style=\"text-align:center;margin-bottom:5px;font-size:16px;font-weight:bold;\">\u8C0A\u54C1\u751F\u9C9C\u91C7\u8D2D\u5355</div>\n      ".concat(title, "\n      <div style=\"margin-top:15px;padding:0 7px;\">\n        <div>").concat(tablesOfA4.join(''), "</div>\n        ").concat(record.isLastPage ? bottom.trim() : '', "\n      </div>").trim())
  };
}
/**
 * 取消集单
 */

function cancelPooling(poolingId) {
  return new Promise((resolve, reject) => {
    antd_es_modal__WEBPACK_IMPORTED_MODULE_13__/* .default.confirm */ .Z.confirm({
      content: '是否确定取消',

      onOk() {
        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee3() {
          var _yield$ypRequest, success, result;

          return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)('scm.require.pooling.cancelPooling', {
                    poolingId
                  });

                case 2:
                  _yield$ypRequest = _context3.sent;
                  success = _yield$ypRequest.success;
                  result = _yield$ypRequest.result;

                  if (success && result) {
                    antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.success('取消成功');
                  }

                  resolve(success && result);

                case 7:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      }

    });
  });
}

function get_refreshDCStock_res(_x10) {
  return _get_refreshDCStock_res.apply(this, arguments);
}
/**
 * 刷新大仓库存
 */


function _get_refreshDCStock_res() {
  _get_refreshDCStock_res = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(poolingId) {
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt("return", new Promise((resolve, reject) => {
              var refresh = /*#__PURE__*/function () {
                var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(poolingId) {
                  var _yield$ypRequest9, success, result;

                  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                    while (1) {
                      switch (_context11.prev = _context11.next) {
                        case 0:
                          _context11.next = 2;
                          return ypRequest('require.poolingorder.refreshStockUpdateResult', {
                            poolingId
                          });

                        case 2:
                          _yield$ypRequest9 = _context11.sent;
                          success = _yield$ypRequest9.success;
                          result = _yield$ypRequest9.result;

                          if (!success) {
                            resolve([false, false]); // 网关报错
                          } else if (result) {
                            resolve([true, true]); // 成功
                          } else {
                            setTimeout(() => {
                              refresh(poolingId);
                            }, 999); // 轮询刷新
                          }

                        case 6:
                        case "end":
                          return _context11.stop();
                      }
                    }
                  }, _callee11);
                }));

                return function refresh(_x17) {
                  return _ref21.apply(this, arguments);
                };
              }();

              setTimeout(() => {
                refresh(poolingId);
              }, 999);
            }));

          case 1:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _get_refreshDCStock_res.apply(this, arguments);
}

function refreshDCStock(_x11) {
  return _refreshDCStock.apply(this, arguments);
}

function _refreshDCStock() {
  _refreshDCStock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(poolingId) {
    var listen,
        _args14 = arguments;
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            listen = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : bool => {};
            return _context14.abrupt("return", new Promise( /*#__PURE__*/function () {
              var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(resolve, reject) {
                var _yield$ypRequest10, success, result;

                return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                  while (1) {
                    switch (_context13.prev = _context13.next) {
                      case 0:
                        listen(true);
                        _context13.next = 3;
                        return ypRequest('scm.require.pooling.refreshStock', {
                          poolingId
                        });

                      case 3:
                        _yield$ypRequest10 = _context13.sent;
                        success = _yield$ypRequest10.success;
                        result = _yield$ypRequest10.result;

                        if (success) {
                          _context13.next = 11;
                          break;
                        }

                        resolve([false, false]); // 网关报错

                        listen(false);
                        _context13.next = 17;
                        break;

                      case 11:
                        _context13.t0 = resolve;
                        _context13.next = 14;
                        return get_refreshDCStock_res(poolingId);

                      case 14:
                        _context13.t1 = _context13.sent;
                        (0, _context13.t0)(_context13.t1);
                        // 获取结果
                        listen(false);

                      case 17:
                      case "end":
                        return _context13.stop();
                    }
                  }
                }, _callee13);
              }));

              return function (_x18, _x19) {
                return _ref22.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _refreshDCStock.apply(this, arguments);
}

function get_onekeyBalanceStock_res(poolingId) {
  return new Promise((resolve, reject) => {
    var refresh = /*#__PURE__*/function () {
      var _ref13 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee4(poolingId) {
        var _yield$ypRequest2, success, result;

        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)('scm.require.refreshBalanceStockResult', {
                  poolingId
                });

              case 2:
                _yield$ypRequest2 = _context4.sent;
                success = _yield$ypRequest2.success;
                result = _yield$ypRequest2.result;

                if (!success) {
                  resolve([false, false]); // 网关报错
                } else if (result) {
                  resolve([true, true]); // 成功
                } else {
                  setTimeout(() => {
                    refresh(poolingId);
                  }, 999); // 轮询刷新
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function refresh(_x12) {
        return _ref13.apply(this, arguments);
      };
    }();

    setTimeout(() => {
      refresh(poolingId);
    }, 999);
  });
}
/**
 * 库存平衡
 */


function onekeyBalanceStock(_x13) {
  return _onekeyBalanceStock.apply(this, arguments);
}

function _onekeyBalanceStock() {
  _onekeyBalanceStock = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee17(poolingId) {
    var listen,
        _args17 = arguments;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            listen = _args17.length > 1 && _args17[1] !== undefined ? _args17[1] : bool => {};
            return _context17.abrupt("return", new Promise( /*#__PURE__*/function () {
              var _ref23 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee16(resolve, reject) {
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee16$(_context16) {
                  while (1) {
                    switch (_context16.prev = _context16.next) {
                      case 0:
                        _context16.t0 = antd_es_modal__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z;
                        _context16.t1 = {
                          content: '是否同比例分配大仓库存',

                          onCancel() {
                            resolve([false, false]);
                          },

                          onOk() {
                            return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee15() {
                              var _yield$ypRequest11, success, result;

                              return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee15$(_context15) {
                                while (1) {
                                  switch (_context15.prev = _context15.next) {
                                    case 0:
                                      listen(true);
                                      _context15.next = 3;
                                      return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)('scm.require.pooling.balanceStock', {
                                        poolingId
                                      });

                                    case 3:
                                      _yield$ypRequest11 = _context15.sent;
                                      success = _yield$ypRequest11.success;
                                      result = _yield$ypRequest11.result;

                                      if (success) {
                                        _context15.next = 11;
                                        break;
                                      }

                                      resolve([false, false]); // 网关报错

                                      listen(false);
                                      _context15.next = 17;
                                      break;

                                    case 11:
                                      _context15.t0 = resolve;
                                      _context15.next = 14;
                                      return get_onekeyBalanceStock_res(poolingId);

                                    case 14:
                                      _context15.t1 = _context15.sent;
                                      (0, _context15.t0)(_context15.t1);
                                      // 获取结果
                                      listen(false);

                                    case 17:
                                    case "end":
                                      return _context15.stop();
                                  }
                                }
                              }, _callee15);
                            }))();
                          }

                        };

                        _context16.t0.confirm.call(_context16.t0, _context16.t1);

                      case 3:
                      case "end":
                        return _context16.stop();
                    }
                  }
                }, _callee16);
              }));

              return function (_x20, _x21) {
                return _ref23.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _onekeyBalanceStock.apply(this, arguments);
}

/**
 * 20-11-24 通用回填数据接口
 * https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=31960057#id-%E9%80%9A%E7%94%A8%E5%95%86%E5%93%81%E6%A8%A1%E5%9D%97%E6%8E%A5%E5%8F%A3-2.7%E6%9F%A5%E8%AF%A2%E5%95%86%E5%93%81%E6%89%A9%E5%B1%95%E4%BF%A1%E6%81%AF
 */
function queryProductExtInfo(_x14) {
  return _queryProductExtInfo.apply(this, arguments);
}

function _queryProductExtInfo() {
  _queryProductExtInfo = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee18(params) {
    var _yield$ypRequest12, success, result;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.next = 2;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)('scm.require.queryProductExtInfo', params);

          case 2:
            _yield$ypRequest12 = _context18.sent;
            success = _yield$ypRequest12.success;
            result = _yield$ypRequest12.result;
            return _context18.abrupt("return", success ? result.list : []);

          case 6:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _queryProductExtInfo.apply(this, arguments);
}

// TODO weiwanc

/**
 * 批量更新配送仓
 * https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=46368304#id-4.3.1%E5%95%86%E8%A1%8C%E9%9B%86%E5%8D%95-2.25%E6%89%B9%E9%87%8F%E6%9B%B4%E6%96%B0%E9%85%8D%E9%80%81%E4%BB%93
 */
function useBatchUpdateDelivery(_ref14) {
  var beforeReq = _ref14.beforeReq,
      _ref14$afterReq = _ref14.afterReq,
      afterReq = _ref14$afterReq === void 0 ? () => {} : _ref14$afterReq,
      merchantId = _ref14.merchantId,
      _ref14$batchType = _ref14.batchType,
      batchType = _ref14$batchType === void 0 ? '紧急程度' : _ref14$batchType,
      _ref14$requestUrl = _ref14.requestUrl,
      requestUrl = _ref14$requestUrl === void 0 ? 'scm.require.pooling.batchModifyDeliveryDc' : _ref14$requestUrl;

  var _useEnums3 = (0,_hooks_useEnums__WEBPACK_IMPORTED_MODULE_6__/* .useEnums */ .ws)(_hooks_useEnums__WEBPACK_IMPORTED_MODULE_6__/* .ENUM_DICT.authDCBusinessMapping */ .J3.authDCBusinessMapping, {
    merchantId
  }),
      _useEnums4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useEnums3, 1),
      delivery = _useEnums4[0];

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(63),
      mappingList = _useMapping.mappingList;

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(batchType),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState3, 2),
      dcId = _useState4[0],
      setDcId = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState5, 2),
      visible = _useState6[0],
      setVisible = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_useState7, 2),
      selected = _useState8[0],
      setSelected = _useState8[1];

  var emergLevelsList = (mappingList === null || mappingList === void 0 ? void 0 : mappingList.get(63)) || [];
  var listMap = {
    配送仓: delivery,
    紧急程度: emergLevelsList,
    供货路径: supplyRouteList
  };
  var optionDataList = listMap[dcId];
  var ModalNode = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
    title: '批量更新',

    onOk() {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee5() {
        var _ref15, params, _yield$ypRequest3, success, result;

        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _ref15 = beforeReq(dcId, selected), params = _ref15.params;

                if (!(!params.modifyDeliveryDcId && Object.keys(params.modifyInfo).length === 0)) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return", antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.warn('请选择'));

              case 3:
                _context5.next = 5;
                return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(requestUrl, params);

              case 5:
                _yield$ypRequest3 = _context5.sent;
                success = _yield$ypRequest3.success;
                result = _yield$ypRequest3.result;
                afterReq(success);

                if (success) {
                  console.log('更新 result', result);
                }

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },

    onCancel() {
      setVisible(false);
    },

    visible,
    width: 340
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_15__/* .default.Group */ .ZP.Group, {
    style: {
      marginBottom: '12px'
    },

    onChange(e) {
      setSelected(undefined);
      setDcId(e.target.value);
    },

    value: dcId
  }, // React.createElement(Radio, { value: '配送仓', children: '配送仓', key: '配送仓' }),
  batchType === '紧急程度' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_15__/* .default */ .ZP, {
    value: '紧急程度',
    children: '紧急程度',
    key: '紧急程度'
  }), batchType === '供货路径' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_15__/* .default */ .ZP, {
    value: '供货路径',
    children: '供货路径',
    key: '供货路径'
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, {
    style: {
      width: 220
    },
    placeholder: '请选择',
    allowClear: true,
    showSearch: true,
    filterOption: (input, option) => (option === null || option === void 0 ? void 0 : option.children.toLowerCase().indexOf(input.toLowerCase())) >= 0,
    value: selected,

    onChange(value) {
      setSelected(value);
    }

  }, optionDataList.map((item, idx) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_16__/* .default.Option */ .Z.Option, {
    value: item.value,
    children: item.label,
    key: idx
  }, item.label))));
  return {
    showUpdateDeliveryModal: function showUpdateDeliveryModal() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return setVisible(bool);
    },
    UpdateDeliveryModal: ModalNode
  };
}
/** 集单详情列表回填数据 */

function backfill(_x15) {
  return _backfill.apply(this, arguments);
}
/**
 * 排序自动封装
 */

function _backfill() {
  _backfill = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee19(_ref16) {
    var firstCategoryId, merchantId, tableRef, dataSource, list, query, queryPrice, res, _res$, _res$2, _res$3, tmp;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            firstCategoryId = _ref16.firstCategoryId, merchantId = _ref16.merchantId, tableRef = _ref16.tableRef, dataSource = _ref16.dataSource;
            list = dataSource;

            if (list.length) {
              _context19.next = 4;
              break;
            }

            return _context19.abrupt("return", list);

          case 4:
            query = querystring.parse();
            queryPrice = APPROVE_STATUS.待审核 === +query.status; // 20-01-21 add 除了待审核状态，不查询任何价格

            _context19.next = 8;
            return Promise.allSettled([queryProductExtInfo({
              needSupplier: true,
              needPlaceStock: true,
              needSale: true,
              needDc: true,
              param: list.map(item => ({
                placeId: item.placeId,
                goodsId: item.goodsId,
                merchantId: item.merchantId,
                firstCategoryId: item.firstCategoryId,
                secondCategoryId: item.secondCategoryId
              }))
            }), ...(queryPrice ? [getDemandPoolingReferencePrice({
              // 回填参考采购价、配送价
              tableList: list,
              orderDirect: DEMAND_TYPE.SUUPLEMENT,
              firstCategoryId,
              merchantId
            })] : [])]);

          case 8:
            res = _context19.sent;

            if (queryPrice) {
              console.groupCollapsed('---- 回填 ----');
              console.log('地点维度库存、销量、供应商', (_res$ = res[0]) === null || _res$ === void 0 ? void 0 : _res$.value);
              console.log('参考采购价、配送价', (_res$2 = res[1]) === null || _res$2 === void 0 ? void 0 : _res$2.value);
              console.groupEnd();
            } else {
              console.log('地点维度库存、销量、供应商', (_res$3 = res[0]) === null || _res$3 === void 0 ? void 0 : _res$3.value);
            }

            tmp = [];
            res.forEach((r, i) => {
              if (r.status === 'fulfilled' && r.value.length) {
                if (i === 0) r.value = r.value.map(item => {
                  delete item.deliveryDcId; // 屏蔽大仓显示 0 BUG

                  delete item.dcStock; // 屏蔽大仓库存显示空 BUG

                  return item;
                });
                tmp = tmp.length ? mergeArr(tmp, r.value, ['goodsId', 'placeId'
                /* 回填采购价中没有该字段 'merchantId' */
                ]) : r.value;
              }
            });
            return _context19.abrupt("return", tmp);

          case 13:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _backfill.apply(this, arguments);
}

function sorterHelper(_ref17) {
  var _changArgs$;

  var url = _ref17.url,
      params = _ref17.params,
      changArgs = _ref17.changArgs;
  var sorter = (_changArgs$ = changArgs[2]) !== null && _changArgs$ !== void 0 ? _changArgs$ : {};

  if (sorter.order === 'ascend') {
    params.condition = _objectSpread(_objectSpread({}, params.condition), {}, {
      orderColumn: sorter.field,
      isAsc: true
    });
  } else if (sorter.order === 'descend') {
    params.condition = _objectSpread(_objectSpread({}, params.condition), {}, {
      orderColumn: sorter.field,
      isAsc: false
    });
  } else {
    params.condition = _objectSpread(_objectSpread({}, params.condition), {}, {
      orderColumn: undefined,
      isAsc: undefined
    });
  }

  return params;
}
/**
 * @脏逻辑
 * 集单审核-行内编辑
 * Select、Input 改动实时保存
 */

function editChange(_x16) {
  return _editChange.apply(this, arguments);
}
/**
 * 转换商家(商家以及商家下的地点) -> OptionItem
 */

function _editChange() {
  _editChange = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee20(_ref18) {
    var _refTable$current;

    var cmd, cellChangeArgs, query, refTable, setDataSource, successCallback, dataSource, value, type, dataIndex, record, rowIndex, _record$dc, defaultDC, updateOld, url, params, result;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            cmd = _ref18.cmd, cellChangeArgs = _ref18.cellChangeArgs, query = _ref18.query, refTable = _ref18.refTable, setDataSource = _ref18.setDataSource, successCallback = _ref18.successCallback;
            dataSource = ((_refTable$current = refTable.current) === null || _refTable$current === void 0 ? void 0 : _refTable$current.dataSource) || [];
            value = cellChangeArgs.value, type = cellChangeArgs.type, dataIndex = cellChangeArgs.dataIndex, record = cellChangeArgs.record, rowIndex = cellChangeArgs.rowIndex;
            console.log("".concat(cmd, "[").concat(dataIndex, "]"), "".concat(record[dataIndex + '_old'], "_old"), value);
            if (cmd === '审核数量' && value === '') record[dataIndex] = 0; // 审核数量为空时，自动补 0

            if (!(type === 'INPUT' && record["".concat(dataIndex, "_old")] === value)) {
              _context20.next = 7;
              break;
            }

            return _context20.abrupt("return");

          case 7:
            if (!(cmd === '大仓' && record.logistics !== LOGISTICE_MODE.直送 && !+record.deliveryDcId)) {
              _context20.next = 9;
              break;
            }

            return _context20.abrupt("return", antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.warn('请选择大仓'));

          case 9:
            if (cmd === '物流模式' && +record.deliveryDcId ===
            /* grpc int 类型默认值 */
            0) {
              defaultDC = (_record$dc = record.dc) === null || _record$dc === void 0 ? void 0 : _record$dc.find(d => d.isDefault);
              defaultDC && (record.deliveryDcId = defaultDC.deliveryDcId); // 12-20-17 直送->配送、直通 默认大仓
              // @todo
              // record === refTable.current?.dataSource[rowIndex] -> true
              // 这里背后赋值，理论上 tabel 刷新会跟着变；还需要再折腾下 20-12-17 18:12:00
            }

            updateOld = () => {
              record["".concat(dataIndex, "_old")] = value;
            }; // 更新改动


            if (+record.demandNum > 0 && record.supplierCode && record.logistics) {
              _context20.next = 13;
              break;
            }

            return _context20.abrupt("return");

          case 13:
            // 必传三个参数
            url = 'scm.require.pooling.saveAndUpdatePoolingDetail';
            params = {
              poolingId: query.poolingId,
              detail: {
                id: record.id,
                placeId: record.placeId,
                goodsId: record.goodsId,
                barCode: record.barCode,
                demandNum: record.demandNum,
                // 需求数量
                approveNum: record.approveNum,
                // 审核数量
                supplierCode: record.supplierCode,
                // 供应商编码
                logistics: record.logistics,
                // 物流模式：1直送；2配送；3直通
                deliveryDcId: record.deliveryDcId,
                // 20-11-27 add 选择大仓
                unitPrice: record.unitPrice,
                merchantId: query.merchantId,
                supplyRoute: record.supplyRoute,
                // 供货路径
                emergLevel: record.emergLevel,
                fatness: record.fatness,
                referneceWeight: record.referneceWeight
              }
            };
            _context20.next = 17;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(url, params);

          case 17:
            result = _context20.sent;

            if (result.success) {
              updateOld();

              antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.success('保存成功'); // @complete
              // refTable.current?.dataSource[rowIndex] === dataSource[rowIndex] -> false
              // 这里竟然不相等；通过引用上面的 dataSource 避开 20-12-17 20:36:00
              // 地点维度改动


              setDataSource(dataSource.map(item => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)({}, item), {}, {
                // ERP-1904(goodsId + placeId 才是唯一的)
                id: item.goodsId === record.goodsId && item.placeId === record.placeId ? result.result.id : item.id,
                // 补充 id
                LINE_FLAG: undefined // 回填数据状态改变

              })));

              if (successCallback) {
                successCallback();
              }
            }

            return _context20.abrupt("return", result);

          case 20:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _editChange.apply(this, arguments);
}

function convertBusiness_with_Place() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  try {
    var arr = data.merchants ? JSON.parse(data.merchants) : [];
    return arr.map(item => ({
      label: item.merchantName,
      value: item.merchantId
    }));
  } catch (error) {
    return [];
  }
}
/** RangePicker 选择时间控制 */

function limitDay_for_RangePicker() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 31;
  return {
    validator: (_, value) => {
      if (value && value.length) {
        var diffDate = value[1].diff(value[0], 'day');

        if (diffDate > limit) {
          return Promise.reject("\u65F6\u95F4\u8303\u56F4\u4E0D\u80FD\u8D85\u8FC7".concat(limit, "\u5929"));
        }
      }

      return Promise.resolve();
    }
  };
}
/** 原生解析 querystring */

var querystring = {
  parse() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.search;
    var dict = {};
    Array.from(new URLSearchParams(str).entries()).forEach(_ref19 => {
      var _ref20 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)(_ref19, 2),
          k = _ref20[0],
          v = _ref20[1];

      return dict[k] = v;
    });
    return dict;
  }

};
/** 供货方。其他：1；台州仓供货：2 */

var STOCK_SUPPLIER;
/** FormBuilder 中 CHECKBOX_GROUP_EXTRA 数据类型是数组；转换成单个值 */

(function (STOCK_SUPPLIER) {
  STOCK_SUPPLIER[STOCK_SUPPLIER["\u5176\u4ED6"] = 1] = "\u5176\u4ED6";
  STOCK_SUPPLIER[STOCK_SUPPLIER["\u53F0\u5DDE\u4ED3\u4F9B\u8D27"] = 2] = "\u53F0\u5DDE\u4ED3\u4F9B\u8D27";
})(STOCK_SUPPLIER || (STOCK_SUPPLIER = {}));

function convertValue_arr2let(values, key) {
  var _values = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)({}, values);

  _values[key] = (values[key] || []).length ? +values[key][0] : undefined;
  _values[key] === undefined && delete _values[key];
  return _values;
}

/***/ }),

/***/ 1950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lG": function() { return /* binding */ DELIVERY_DETAIL_API; },
/* harmony export */   "e1": function() { return /* binding */ DELIVERY_LIST_API; },
/* harmony export */   "OB": function() { return /* binding */ DELIVERY_MODIFY_API; },
/* harmony export */   "c_": function() { return /* binding */ ORDER_DELETE_API; },
/* harmony export */   "yy": function() { return /* binding */ ORDER_RESOLVE_API; }
/* harmony export */ });
/**
 * API集合
 */
// 详情
var DELIVERY_DETAIL_API = 'scm.require.pooling.queryDemandPoolingStrategy'; // 列表

var DELIVERY_LIST_API = 'scm.require.pooling.listDemandPoolingStrategy'; // 保存

var DELIVERY_MODIFY_API = 'scm.require.pooling.saveDemandPoolingStrategy'; // 删除

var ORDER_DELETE_API = 'scm.require.pooling.deleteDemandPoolingStrategy'; // 手动集单

var ORDER_RESOLVE_API = 'scm.require.pooling.manualTriggerPooling';

/***/ }),

/***/ 56870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kO": function() { return /* binding */ DELETE_APPLY_ORDER_LINE; },
/* harmony export */   "b2": function() { return /* binding */ IMPORT_APPLY_ORDER; },
/* harmony export */   "dI": function() { return /* binding */ DOWNLOAD_TEMPLATE; },
/* harmony export */   "LF": function() { return /* binding */ SAVE_APPLY_ORDER_LINE; },
/* harmony export */   "ju": function() { return /* binding */ REPLENISH_LIST_API; },
/* harmony export */   "sB": function() { return /* binding */ REPLENISH_ORDER_EXPORT; },
/* harmony export */   "A7": function() { return /* binding */ SAVE_BASE_INFO_API; },
/* harmony export */   "Cf": function() { return /* binding */ NEW_APPLY_ORDER_API; },
/* harmony export */   "ER": function() { return /* binding */ SUBMIT_APPLY_ORDER; },
/* harmony export */   "Jb": function() { return /* binding */ APPLY_ORDER_BASE_DETAIL; },
/* harmony export */   "XO": function() { return /* binding */ APPLY_ORDER_GOODS_LIST_API; },
/* harmony export */   "go": function() { return /* binding */ CANCEL_APPLY_ORDER; },
/* harmony export */   "hL": function() { return /* binding */ APPLY_CLEAR_GOODS; },
/* harmony export */   "Mo": function() { return /* binding */ GET_PRODUCT_EXTINFO; },
/* harmony export */   "Uv": function() { return /* binding */ GET_SUMMARY_DATA; }
/* harmony export */ });
/* unused harmony exports DOWNLOAD_UNORMAL_TEMPLATE, DETAIL_QUERY_GOODS_SALE, DETAIL_QUERY_GOODS_STOCK */
/**
 * API集合
 */
// export const ORDER_LINE_DETAIL_LIST = 'purchase.order.purchaseOrderDetailPageInfo'
// 删除 当前商品行
var DELETE_APPLY_ORDER_LINE = 'scm.require.deleteOrderDetail'; // 导入

var IMPORT_APPLY_ORDER = 'scm.require.importOrderDetails'; // 公用 - 下载模板

var DOWNLOAD_TEMPLATE = 'purchase.downlaod.getTemplate'; // 公用 - 下载模板

var DOWNLOAD_UNORMAL_TEMPLATE = 'purchase.downlaod.getTemplate'; // 保存单行商品

var SAVE_APPLY_ORDER_LINE = 'scm.require.saveOrModifyOrderDetail'; // 获取申请单列表

var REPLENISH_LIST_API = 'scm.require.orderPages'; // 补货申请单导出

var REPLENISH_ORDER_EXPORT = 'scm.require.exportOrderDetails'; // 保存基本信息

var SAVE_BASE_INFO_API = 'scm.require.saveOrModifyOrder'; // 生成单子编码

var NEW_APPLY_ORDER_API = 'scm.require.getOrderIdByBizType'; // 需求单提交

var SUBMIT_APPLY_ORDER = 'scm.require.submitOrder'; // 需求单 基本信息明细

var APPLY_ORDER_BASE_DETAIL = 'scm.require.orderDetail'; // 需求单 商品信息明细 | 商品信息列表

var APPLY_ORDER_GOODS_LIST_API = 'scm.require.orderDetailPages'; // 需求单 作废

var CANCEL_APPLY_ORDER = 'scm.require.cancelOrder'; // 清空商品

var APPLY_CLEAR_GOODS = 'scm.require.clearOrderDetails'; // 根据商家+地点+编码查询商品销量(地点维度)

var DETAIL_QUERY_GOODS_SALE = 'purchase.product.queryPlaceProductSales'; // 根据商家+地点+编码查询商品库存(地点维度)

var DETAIL_QUERY_GOODS_STOCK = 'purchase.product.queryPlaceProductStock'; //  查询商品扩展信息, 可查库存，销量，订货数量等

var GET_PRODUCT_EXTINFO = 'purchase.product.queryProductExtInfo'; // 查询汇总

var GET_SUMMARY_DATA = 'scm.require.statOrderDetail';

/***/ }),

/***/ 776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getHomeFormFields": function() { return /* binding */ getHomeFormFields; },
/* harmony export */   "getEditFormFields": function() { return /* binding */ getEditFormFields; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_YpshopCps_GoodsCategoryCascader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64679);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26715);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_UseRouter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27088);
/* harmony import */ var _hooks_usePurchaseConfigPlaced__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12051);
/* harmony import */ var _components_FormCategorySelect__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45199);








/**
 * 根据全局map获取退货首页表单FIELD - 首页
 * @param mappingList
 */
var getHomeFormFields = (mappingList, dateDefault) => {
  var _href = window.location.href;
  var isGoodsReturn = _href.indexOf('/GoodsReturn') !== -1;
  var manageType = isGoodsReturn ? '退货' : '补货';

  var fieldDataList = type => {
    return mappingList && mappingList['get'] && mappingList.get(_config_enums__WEBPACK_IMPORTED_MODULE_2__/* .purchaseEnumConfig */ .Nt[type]);
  };

  var categoryAllList = mappingList.get(_config_enums__WEBPACK_IMPORTED_MODULE_2__/* .purchaseEnumConfig.categoryCodeAll */ .Nt.categoryCodeAll); // let useCategoryList: any[] = []
  // if (categoryAllList && categoryAllList.length) {
  //   useCategoryList = categoryAllList
  // }

  return [{
    label: "".concat(manageType, "\u7533\u8BF7\u5355"),
    name: 'applyCode',
    type: 'INPUT'
  }, {
    label: '地点',
    name: 'placeId',
    widget: (0,_hooks_usePurchaseConfigPlaced__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)({
      purchaseEnum: _config_enums__WEBPACK_IMPORTED_MODULE_2__/* .purchaseEnumConfig.placeId */ .Nt.placeId,
      placeScopes: '1,2,3',
      title: '请选择地点'
    })
  }, {
    label: '品类',
    name: 'category',
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_FormCategorySelect__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
      categoryList: categoryAllList
    })
  }, {
    label: '来源',
    name: 'requireSource',
    type: 'SELECT',
    fieldOptions: {
      defaultValue: ''
    },
    dataList: [// {"4":"自动补货","5":"手动补货","6":"PDA补货"}"
    {
      label: '全部',
      value: ''
    }, {
      label: 'PDA补货',
      value: 6
    }, {
      label: '手动补货',
      value: 5
    }, {
      label: '自动补货',
      value: 4
    }]
  }, {
    label: '状态',
    name: 'status',
    type: 'SELECT',
    dataList: fieldDataList('status')
  }, {
    label: '集单标记',
    name: 'flag',
    type: 'SELECT',
    dataList: fieldDataList('flag')
  }, {
    label: '创建人',
    name: 'createUserCode',
    type: 'INPUT'
  }, {
    label: '创建时间',
    name: 'date',
    type: 'RANGE_PICKER_SHORT',
    value: dateDefault,
    initialValue: dateDefault || [moment__WEBPACK_IMPORTED_MODULE_3___default()().subtract(1, 'day'), moment__WEBPACK_IMPORTED_MODULE_3___default()()]
  }, {
    label: '商家',
    name: 'merchantId',
    type: 'SELECT',
    dataList: fieldDataList('merchantId')
  }];
};
/**
 * 根据全局map获取 首页表单FIELD -编辑
 * @param mappingList
 */

var getEditFormFields = (mappingList, autoSaveCallback, editFormState, handleCategory, formCanEdit) => {
  var _href = window.location.href;
  var isGoodsReturn = _href.indexOf('/GoodsReturn') !== -1;
  var manageType = isGoodsReturn ? '退货' : '补货';
  var router = (0,_components_UseRouter__WEBPACK_IMPORTED_MODULE_4__/* .useRouter */ .t)();
  var handleType = router.query.type;
  var isAddHandle = handleType === 'add' ? true : false;
  /** 根据地点place获取merchantid */

  var getMerchantDataList = (val, dataList) => {
    var list = dataList.get(_config_enums__WEBPACK_IMPORTED_MODULE_2__/* .purchaseEnumConfig.placeId */ .Nt.placeId);

    if (list !== null && list !== void 0 && list.length) {
      var _list = list.filter(v => v.value === val);

      if (_list !== null && _list !== void 0 && _list.length) {
        var curMerchantId = _list[0].others.merchantId;
        var curPlaceId = _list[0].value;
        autoSaveCallback({
          merchantId: curMerchantId,
          placeId: curPlaceId
        });
      } else {
        console.error("getMerchantDataListERROR");
      }
    }
  };

  return [{
    label: "".concat(manageType, "\u7533\u8BF7\u5355"),
    name: 'applyCode',
    type: 'INPUT',
    fieldOptions: {
      disabled: true
    }
  }, {
    label: '状态',
    name: 'status',
    type: 'SELECT',
    dataList: [{
      value: 1,
      label: '草稿'
    }],
    fieldOptions: {
      disabled: true,
      defaultValue: 1
    }
  }, {
    label: '补货分类',
    name: 'requireSource',
    fieldOptions: {
      disabled: true
    },
    type: 'SELECT',
    required: true,
    dataList: [{
      label: 'PDA补货',
      value: 6
    }, {
      label: '手动补货',
      value: 5
    }, {
      label: '自动补货',
      value: 4
    }]
  }, {
    label: '地点',
    name: 'placeId',
    // type: 'SELECT',
    required: true,
    // dataList: fieldDataList('placeId'),
    // fieldOptions: {
    //   onSelect: getMerchantDataList,
    //   disabled: isAddHandle ? false : true,
    //   // disabled: !formCanEdit,
    //   // defaultValue: (fieldDataList('placeId')?.length > 0 && fieldDataList('placeId')?.findIndex(e => e?.value === shop?.id) > -1) ? shop?.id : undefined
    // },
    widget: (0,_hooks_usePurchaseConfigPlaced__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)({
      purchaseEnum: _config_enums__WEBPACK_IMPORTED_MODULE_2__/* .purchaseEnumConfig.placeId */ .Nt.placeId,
      placeScopes: '1,2,3',
      title: '请选择地点',
      onSelect: getMerchantDataList,
      disabled: isAddHandle ? false : true
    })
  }, {
    label: '商品类目',
    name: 'category',
    required: true,
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_YpshopCps_GoodsCategoryCascader__WEBPACK_IMPORTED_MODULE_1__/* .GoodsCategoryCascader */ .z, {
      mappingList: mappingList,
      onChange: handleCategory,
      data: editFormState.category,
      disabled: !formCanEdit
    })
  }, {
    label: '备注',
    name: 'remark',
    type: 'INPUT'
  }];
};

/***/ }),

/***/ 17447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8870);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_EditableTable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72927);



/**
 *  可编辑表格 - 目前补退货使用
 */



function GoodEditableTable(props, ref) {
  var formData = props.formData;
  var table = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(ref, () => ({
    reflashTable: params => table.current.reflashTable((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)({
      applyId: formData === null || formData === void 0 ? void 0 : formData.applyId,
      applyCode: formData === null || formData === void 0 ? void 0 : formData.applyCode
    }, params)),
    deleteAndRefreshData: commonTableKeys => table.current.deleteAndRefreshData(commonTableKeys),
    getTableData: () => {
      var _table$current;

      return table === null || table === void 0 ? void 0 : (_table$current = table.current) === null || _table$current === void 0 ? void 0 : _table$current.getTableData();
    }
  }));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "mTop16 mBottom16"
  }, props.btnElement), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_EditableTable__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)({
    hideBtn: true,
    hideDeleteBtn: false,
    ref: table
  }, props, {
    columns: props.columns,
    disableAddBtn: !props.canHandle,
    buttonTitle: "\u6DFB\u52A0\u5546\u54C1\u884C",
    scrollYSize: 510,
    tableOptions: {
      scroll: {
        x: 1400,
        y: 450
      }
    }
  })));
}

/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)( /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(GoodEditableTable)));

/***/ }),

/***/ 77975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(91896);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24731);
/* harmony import */ var _GoodEditableTable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17447);
/* harmony import */ var _HandleBtn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55057);
/* harmony import */ var _useColumns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43627);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(56870);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37778);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71720);










/**
 * 商品信息
 */










function GoodsTable(props) {
  var mappingList = props.mappingList;
  var childRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
  var _href = window.location.href;
  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_9__/* .useDispatch */ .I0)();
  var isGoodsReturn = _href.indexOf('/GoodsReturn') !== -1;
  var manageType = isGoodsReturn ? '退货' : '补货';
  var formData = props.formData,
      applyId = props.applyId,
      applyCode = props.applyCode,
      applyDetailId = props.applyDetailId;
  var canHandle = applyId ? true : false; // 能否操作表格

  var table = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(); // 要更新的表格数据

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_useState, 2),
      editTableData = _useState2[0],
      setEditTableData = _useState2[1]; // 商品数据


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_useState3, 2),
      barCodeList = _useState4[0],
      setBarCodeList = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_useState5, 2),
      canHandleClear = _useState6[0],
      setcanHandleClear = _useState6[1];

  var columns = (0,_useColumns__WEBPACK_IMPORTED_MODULE_7__.default)({
    formData,
    mappingList,
    barCodeList
  }); // 表格表头

  var goodModalcolumns = (0,_useColumns__WEBPACK_IMPORTED_MODULE_7__.default)({
    formData,
    mappingList,
    barCodeList,
    type: 'modal'
  }); // 表格表头
  // 处理商品编码的事件

  var handleGoodId = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().mark(function _callee(goodsId, currentRow) {
      var params, res, success, result;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              params = {
                goodsId: +goodsId,
                merchantId: formData.merchantId
              };
              _context.next = 4;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)('purchase.product.queryBarcodeByProductId', params);

            case 4:
              res = _context.sent;
              success = res.success, result = res.result;

              if (success) {
                setBarCodeList(result.list); // setEditTableData((v: any) => ([...v, ...currentRow]))
              }

              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_13__.default.error(_context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function handleGoodId(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(); // 处理商品条码的操作事件


  var handleGoodBarCode = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().mark(function _callee2(code, currentRow) {
      var params, res, list, rowData, _rowData;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              params = {
                merchantId: +formData.merchantId,
                placeId: +formData.placeId,
                barcodeList: [code],
                withRealPrice: true,
                billType: formData.billType
              }; // 获取商品数据

              _context2.next = 4;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)('purchase.product.queryInsertPlaceProduct', params);

            case 4:
              res = _context2.sent;

              if (!res.success) {
                _context2.next = 15;
                break;
              }

              list = res.result.list;

              if (!(list && !list.length)) {
                _context2.next = 10;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_13__.default.info('未找到商品信息');

              return _context2.abrupt("return");

            case 10:
              rowData = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, currentRow), list[0]), {}, {
                goodsBarCode: code,
                categoryName: list[0].cate1Name,
                isGift: list[0].gift,
                orderSpecification: list[0].specification,
                orderSpecificationUnit: list[0].specUnit,
                taxRate: list[0].tax
              });
              _context2.next = 13;
              return (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .exchangeDataPromise */ .m)([rowData], formData.merchantId, formData.placeId, {
                isListReq: true
              });

            case 13:
              _rowData = _context2.sent;
              return _context2.abrupt("return", _rowData);

            case 15:
              _context2.next = 20;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_13__.default.error(_context2.t0);

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 17]]);
    }));

    return function handleGoodBarCode(_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
  /** 保存商品行 */


  var saveGoodsData = (data, currentCellOldData) => {
    // console.log('formData', formData);
    // console.log('saveGoodsData', data)
    return new Promise( /*#__PURE__*/function () {
      var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().mark(function _callee3(resolve, reject) {
        var params, res, result, _childRef$current, _childRef$current2, _res$result, _data, tmpData, _data2;

        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // if (parseFloat(data.goodsReqQty) === 0) {
                //   message.warn('商品数量不能为0')
                //   // eslint-disable-next-line prefer-promise-reject-errors
                //   return reject('商品数量不能为0')
                // }
                params = {
                  applyId: applyId || formData.applyId,
                  applyCode: applyCode || formData.applyCode,
                  placeId: +formData.placeId,
                  request: {
                    goodsId: data.goodsId,
                    unitPrice: data === null || data === void 0 ? void 0 : data.unitPrice,
                    goodsBarCode: data.goodsBarCode,
                    goodsReqQty: data.goodsReqQty
                  }
                };

                if (manageType === '退货') {
                  params.request['isDamage'] = data['isDamage'];
                  params.request['returnReason'] = data['returnReason'];
                }

                if (!data['applyDetailId']) {// console.error('applyDetailId not found')
                }

                if (data['applyDetailId']) {
                  // 编辑
                  params.request['applyDetailId'] = data['applyDetailId'];
                }

                _context3.next = 6;
                return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_15__/* .SAVE_APPLY_ORDER_LINE */ .LF, params);

              case 6:
                res = _context3.sent;
                result = res.result;

                if (result !== null && result !== void 0 && result.isUpdateQty && manageType === '补货') {
                  antd_es_modal__WEBPACK_IMPORTED_MODULE_16__/* .default.info */ .Z.info({
                    title: '温馨提示',
                    content: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, "\u5546\u54C1\u3010", data.goodsId, "\u3011", data === null || data === void 0 ? void 0 : data.goodsName), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, "\u8981\u8D27\u6570\u91CF: ", data.goodsReqQty), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, "\u6309\u8981\u8D27\u89C4\u683C\u6298\u7B97\u6210: ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("strong", null, result === null || result === void 0 ? void 0 : result.realGoodsReqQty)))
                  });
                }

                if (!res.success) {
                  _context3.next = 18;
                  break;
                }

                _data = JSON.parse(JSON.stringify(data));
                (childRef === null || childRef === void 0 ? void 0 : (_childRef$current = childRef.current) === null || _childRef$current === void 0 ? void 0 : _childRef$current.innerFn) && (childRef === null || childRef === void 0 ? void 0 : (_childRef$current2 = childRef.current) === null || _childRef$current2 === void 0 ? void 0 : _childRef$current2.innerFn());

                antd_es_message__WEBPACK_IMPORTED_MODULE_13__.default.success('商品保存成功');

                if (manageType === '补货') {
                  _data['copies'] = result === null || result === void 0 ? void 0 : result.copies;
                  _data['goodsReqQty'] = result === null || result === void 0 ? void 0 : result.realGoodsReqQty;
                }

                _data['applyDetailId'] = (_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.applyDetailId;
                return _context3.abrupt("return", resolve({
                  newRow: _data
                }));

              case 18:
                // 保存失败时 恢复修改前的值
                tmpData = Object.assign(data, currentCellOldData);
                _data2 = JSON.parse(JSON.stringify(tmpData));
                return _context3.abrupt("return", resolve({
                  newRow: _data2
                }));

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }());
  }; // 商品数据变化时


  var changeGoodsData = /*#__PURE__*/function () {
    var _ref4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().mark(function _callee4(data, selected) {
      var currentCell, currentCellOldData, currentRow, rows, goodsId, barCode, unitPrice, goodsReqQty, returnReason, isDamage, res, price, qty, orderSpecification, amount, totalAmount, _yield$saveGoodsData, newRow;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              currentCell = data.currentCell, currentCellOldData = data.currentCellOldData, currentRow = data.currentRow;

              if (!lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(currentCell)) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt("return");

            case 3:
              rows = currentRow;
              goodsId = data.currentCell['goodsId'];
              barCode = data.currentCell['goodsBarCode'];
              unitPrice = data.currentCell['unitPrice'];
              goodsReqQty = data.currentCell['goodsReqQty'];
              returnReason = data.currentCell['returnReason'];
              isDamage = data.currentCell['isDamage']; // 单元格是商品编码

              if (goodsId) {
                handleGoodId(goodsId, currentRow);
              } // 当前修改的单元格是商品条码时


              if (!barCode) {
                _context4.next = 16;
                break;
              }

              _context4.next = 14;
              return handleGoodBarCode(barCode, currentRow);

            case 14:
              res = _context4.sent;
              rows = res;

            case 16:
              if (!(goodsReqQty || returnReason || isDamage)) {
                _context4.next = 31;
                break;
              }

              price = unitPrice !== null && unitPrice !== void 0 ? unitPrice : currentRow.unitPrice;
              qty = goodsReqQty !== null && goodsReqQty !== void 0 ? goodsReqQty : currentRow.goodsReqQty;
              orderSpecification = currentRow.orderSpecification;
              amount = +price * +qty;
              totalAmount = +price * +qty * +orderSpecification;
              rows = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, currentRow), {}, {
                amount,
                totalAmount
              });
              setEditTableData(rows);
              _context4.next = 26;
              return saveGoodsData(rows, currentCellOldData);

            case 26:
              _yield$saveGoodsData = _context4.sent;
              newRow = _yield$saveGoodsData.newRow;
              setEditTableData(Array.isArray(newRow) ? newRow : [newRow]);
              _context4.next = 32;
              break;

            case 31:
              setEditTableData(rows);

            case 32:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function changeGoodsData(_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }(); // 保存浮层，保存商品
  // const saveGoodsModal = useCallback(
  //   async ,
  //   [formData]
  // )


  var saveGoodsModal = rows => {
    var _table$current, _childRef$current3, _childRef$current4;

    (_table$current = table.current) === null || _table$current === void 0 ? void 0 : _table$current.reflashTable({
      applyId,
      applyCode,
      current: 1
    });
    ((_childRef$current3 = childRef.current) === null || _childRef$current3 === void 0 ? void 0 : _childRef$current3.innerFn) && ((_childRef$current4 = childRef.current) === null || _childRef$current4 === void 0 ? void 0 : _childRef$current4.innerFn());
  }; // 删除商品的回调


  var handleDeleteRow = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)( /*#__PURE__*/function () {
    var _ref5 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().mark(function _callee5(currentRow, list) {
      var applyDetailId, res, _childRef$current5, _childRef$current6;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              // console.log('handleDeleteRow data删除商品', currentRow)
              // console.log('handleDeleteRow data删除商品', editTableData)
              applyDetailId = currentRow.applyDetailId; // const { applyDetailId, goodsName, applyId } = currentRow

              if (!applyDetailId) {
                _context5.next = 9;
                break;
              }

              _context5.next = 4;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_15__/* .DELETE_APPLY_ORDER_LINE */ .kO, {
                applyDetailIds: [applyDetailId],
                applyId,
                applyCode
              });

            case 4:
              res = _context5.sent;

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_13__.default.success("\u6210\u529F\u5220\u9664\u5546\u54C1"); // table?.current?.reflashTable({ applyId })


                ((_childRef$current5 = childRef.current) === null || _childRef$current5 === void 0 ? void 0 : _childRef$current5.innerFn) && ((_childRef$current6 = childRef.current) === null || _childRef$current6 === void 0 ? void 0 : _childRef$current6.innerFn());
                console.log('editTableData', editTableData);
              }

              return _context5.abrupt("return", res.success);

            case 9:
              return _context5.abrupt("return", true);

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }(), [applyId, applyDetailId, editTableData]); // 获取表格商品信息列表

  var getGoodsData = (data, params) => {
    if (props.returnData) {
      props.returnData(data, params);
    } // console.log('000getGoodsData', data);


    setEditTableData(data);
  };

  var initTableData = (editTableData, formData) => {
    (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .exchangeDataPromise */ .m)(editTableData, formData.merchantId, formData.placeId, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, formData), {}, {
      isListReq: true
    })).then(unionData => {
      // setGoodsData(unionData)
      if (props.returnData) {
        props.returnData(unionData);
      }

      setEditTableData(unionData[0]);
    }).catch(e => {// console.error('handleEditTableCallbackERROR', e)
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (Array.isArray(editTableData) && !lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(formData)) {
      // console.log(233, formData);
      // 根据列表URL获取的数据，重新拿id后，根据id数据拿到其他数据，填到原先数据，更新updateDatasource
      initTableData(editTableData, formData);
      editTableData.length && setcanHandleClear(true);
    }

    if (editTableData === undefined) {
      setcanHandleClear(false);
    }
  }, [formData, editTableData]); // 每个可编辑的单元格都存在数据后，发送保存的请求

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {// console.log('当前表格数据11', editTableData)
  }, [editTableData]);
  var goodsModalOptions = {
    title: "\u6DFB\u52A0".concat(manageType, "\u5546\u54C1"),
    rowSelectionType: 'checkbox'
  };
  /** 监听表格数据 */

  var handleEmitTableChange = data => {
    var dataSource = data.dataSource;

    if (!(dataSource !== null && dataSource !== void 0 && dataSource.length)) {
      setcanHandleClear(false);
    }

    props === null || props === void 0 ? void 0 : props.onTableParamsChange(data);
  };

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_useState7, 2),
      outSearchParams = _useState8[0],
      setOutSearchParams = _useState8[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    setOutSearchParams({
      applyId: formData === null || formData === void 0 ? void 0 : formData.applyId,
      applyCode: formData === null || formData === void 0 ? void 0 : formData.applyCode,
      hideZeroDetail: formData === null || formData === void 0 ? void 0 : formData.hideZeroDetail
    });
  }, [formData]);

  var reSearch = e => {
    setOutSearchParams(e);
  };

  var tableProps = {
    goodModalCategoryData: props.goodModalCategoryData,
    goodsModalSearchParams: props.goodsModalSearchParams,
    ref: table,
    returnData: getGoodsData,
    canSelected: false,
    showAlert: false,
    searchParams: outSearchParams,
    queryDataUrl: (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => outSearchParams !== null && outSearchParams !== void 0 && outSearchParams.applyId ? _Api__WEBPACK_IMPORTED_MODULE_15__/* .APPLY_ORDER_GOODS_LIST_API */ .XO : '', [outSearchParams]),
    onChange: changeGoodsData,
    saveGoodsModal: saveGoodsModal,
    columns: columns,
    onTableParamsChange: handleEmitTableChange,
    pageSize: 100,
    deleteRow: handleDeleteRow,
    updateDataSource: editTableData,
    canHandle: canHandle,
    billType: formData.billType,
    goodsModalOptions: goodsModalOptions,
    goodModalcolumns: goodModalcolumns,
    formData: formData,
    rowSelectCallback: props.rowSelectCallback,
    selectedItems: props.selectedItems
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_GoodEditableTable__WEBPACK_IMPORTED_MODULE_5__.default, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)({}, tableProps, {
    btnElement: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_HandleBtn__WEBPACK_IMPORTED_MODULE_6__.default, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)({
      innerRef: childRef,
      addBtnText: "\u6DFB\u52A0".concat(manageType, "\u5546\u54C1"),
      downloadTemplateType: props.downloadTemplateType,
      table: table.current,
      canHandleClear: canHandleClear,
      reSearch: reSearch
    }, tableProps))
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(GoodsTable));

/***/ }),

/***/ 55057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(31097);
/* harmony import */ var antd_es_input_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47673);
/* harmony import */ var antd_es_input__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(4107);
/* harmony import */ var antd_es_row_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13062);
/* harmony import */ var antd_es_row__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(71230);
/* harmony import */ var antd_es_col_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89032);
/* harmony import */ var antd_es_col__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(15746);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(2824);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(57016);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(49101);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(90631);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(76570);
/* harmony import */ var _components_Uploader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84843);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24731);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(56870);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26715);
/* harmony import */ var _hooks_useLoopImportResult__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68406);
/* harmony import */ var _components_CategorySelectForTwo__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(76252);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7704);
/* harmony import */ var _mapEnums__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(59249);
/* harmony import */ var _ReplenishGoodsModal__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(12343);
/* harmony import */ var _pages_Replenishment_Api__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(91249);
/* harmony import */ var _components_Exception__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(42891);
































var confirm = antd_es_modal__WEBPACK_IMPORTED_MODULE_17__/* .default.confirm */ .Z.confirm;

function HandleBtn(props, ref) {
  var _props$addBtnText, _formData$category2, _formData$category3, _formData$category4;

  var formData = props.formData,
      table = props.table,
      canHandle = props.canHandle,
      innerRef = props.innerRef,
      selectedItems = props.selectedItems;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(''),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)(_useState, 2),
      goodSearchKey = _useState2[0],
      setgoodSearchKey = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)({
    secondCategoryIds: [],
    thirdCategoryIds: []
  }),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)(_useState3, 2),
      categorySearch = _useState4[0],
      setcategorySearch = _useState4[1];

  var resultParams = {
    businessType: 2,
    orderNo: formData.applyId
  };

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)({
    skuCount: '',
    totalAmount: '',
    totalQty: '',
    abnormalCount: ''
  }),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)(_useState5, 2),
      curSummaryData = _useState6[0],
      setcurSummaryData = _useState6[1];
  /** 下载模板 */


  var downloadTemplate = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().mark(function _callee() {
      var res, downloadUrl;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_21__/* .DOWNLOAD_TEMPLATE */ .dI, {
                downloadType: props.downloadTemplateType || 1
              });

            case 3:
              res = _context.sent;
              downloadUrl = res.result.downloadUrl;

              if (downloadUrl) {
                _context.next = 7;
                break;
              }

              throw '请求的文件不存在';

            case 7:
              window.location.href = downloadUrl; // 默认文件管理器保存

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_22__.default.error(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    return function downloadTemplate() {
      return _ref.apply(this, arguments);
    };
  }();

  var confirmClear = () => {
    confirm({
      title: '清空所有商品',
      content: '是否确认清空？',

      onOk() {
        clearGood();
        handleGetSummaryData();
      },

      onCancel() {}

    });
  };

  var confirmDeleteSelected = () => {
    confirm({
      title: '删除已选择项',
      content: '是否确认删除？',

      onOk() {
        handleDeleteRows();
      },

      onCancel() {}

    });
  };

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)(_useState7, 2),
      loopResult = _useState8[0],
      setLoopResult = _useState8[1];

  var _useLoopImportResult = (0,_hooks_useLoopImportResult__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)({}, resultParams), {}, {
    refreshCallback: successed => {
      if (successed) {
        table.reflashTable({
          applyId: formData.applyId,
          applyCode: formData.applyCode
        });
        handleGetSummaryData();
      }

      setLoopResult(false); // 重置状态
    }
  }), [loopResult]),
      _useLoopImportResult2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)(_useLoopImportResult, 1),
      btnLoading = _useLoopImportResult2[0];
  /** 导入文件 */


  var changeUpload = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().mark(function _callee2(val) {
      var len, params, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              len = val.length;

              if (len) {
                _context2.next = 4;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_22__.default.warn('changeUploadERROR: 文件不存在');

              return _context2.abrupt("return");

            case 4:
              _context2.prev = 4;
              params = {
                applyId: formData.applyId,
                resId: val,
                applyCode: formData.applyCode
              };
              _context2.next = 8;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_21__/* .IMPORT_APPLY_ORDER */ .b2, params);

            case 8:
              res = _context2.sent;

              if (res && res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_22__.default.success('导入任务添加成功'); // 导入改为异步，则2s轮询请求状态，直到成功或失败停止，给提示
                // handleAfterImport()


                setLoopResult(true); // table.reflashTable()
              }

              _context2.next = 15;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](4);

              antd_es_message__WEBPACK_IMPORTED_MODULE_22__.default.error(_context2.t0);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 12]]);
    }));

    return function changeUpload(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  /** 清空商品 */


  var clearGood = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().mark(function _callee3() {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_21__/* .APPLY_CLEAR_GOODS */ .hL, {
                applyId: formData.applyId,
                applyCode: formData.applyCode,
                currentStatus: _config_enums__WEBPACK_IMPORTED_MODULE_10__/* .replenishStatus["草稿"] */ .qW["草稿"]
              });

            case 3:
              res = _context3.sent;

              if (res.success) {
                table.reflashTable({
                  applyId: formData.applyId,
                  applyCode: formData.applyCode
                });

                antd_es_message__WEBPACK_IMPORTED_MODULE_22__.default.success('清空商品成功');
              }

              _context3.next = 9;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 7]]);
    }));

    return function clearGood() {
      return _ref3.apply(this, arguments);
    };
  }();
  /** 查询汇总数量 */


  var handleGetSummaryData = /*#__PURE__*/function () {
    var _ref4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().mark(function _callee5() {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              try {
                setTimeout( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().mark(function _callee4() {
                  var res, result;
                  return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_21__/* .GET_SUMMARY_DATA */ .Uv, {
                            applyId: formData.applyId,
                            applyCode: formData.applyCode
                          });

                        case 2:
                          res = _context4.sent;

                          if (res.success) {
                            result = res.result;
                            setcurSummaryData(result);
                          }

                        case 4:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                })), 1500);
              } catch (error) {
                console.error('clearGood', clearGood);
              }

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleGetSummaryData() {
      return _ref4.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(() => {
    if (formData !== null && formData !== void 0 && formData.applyId) {
      handleGetSummaryData();
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.applyId]); // 回给父组件调用方法

  (0,react__WEBPACK_IMPORTED_MODULE_7__.useImperativeHandle)(props.innerRef, () => {
    return {
      innerFn: () => {
        handleGetSummaryData();
      }
    };
  });
  /** 查询明细的商品 */

  var searchHandle = /*#__PURE__*/function () {
    var _ref6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().mark(function _callee6() {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              props === null || props === void 0 ? void 0 : props.reSearch((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)({
                searchGoods: goodSearchKey,
                applyId: formData.applyId,
                applyCode: formData.applyCode
              }, categorySearch));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function searchHandle() {
      return _ref6.apply(this, arguments);
    };
  }();

  var keyChange = e => {
    var _e$currentTarget$valu;

    if (((_e$currentTarget$valu = e.currentTarget.value) === null || _e$currentTarget$valu === void 0 ? void 0 : _e$currentTarget$valu.length) === 0) {
      props === null || props === void 0 ? void 0 : props.reSearch({
        searchGoods: '',
        applyId: formData.applyId,
        applyCode: formData.applyCode
      });
    }

    setgoodSearchKey(e.currentTarget.value);
  };

  var categoryCodeKey = 46;

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)([categoryCodeKey]),
      mappingList = _useMapping.mappingList; // 品类list


  var categoryList = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(() => mappingList.get(categoryCodeKey), [mappingList, categoryCodeKey]);
  (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(() => {
    var _formData$category;

    if (formData !== null && formData !== void 0 && formData.secondCategoryId) {
      setcategorySearch((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)({}, categorySearch), {}, {
        secondCategoryIds: [formData === null || formData === void 0 ? void 0 : formData.secondCategoryId]
      }));
    }

    if ((formData === null || formData === void 0 ? void 0 : (_formData$category = formData.category) === null || _formData$category === void 0 ? void 0 : _formData$category.length) === 3) {
      setcategorySearch((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)({}, categorySearch), {}, {
        thirdCategoryIds: [formData === null || formData === void 0 ? void 0 : formData.category[2]]
      }));
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.secondCategoryId, formData === null || formData === void 0 ? void 0 : formData.thirdCategoryId]);

  var onSecondChange = vals => {
    setcategorySearch((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)({}, categorySearch), {}, {
      secondCategoryIds: vals
    }));
  };

  var onThirdChange = vals => {
    setcategorySearch((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)({}, categorySearch), {}, {
      thirdCategoryIds: vals
    }));
  };

  var checkOnChange = val => {
    props === null || props === void 0 ? void 0 : props.reSearch((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)({
      applyId: formData.applyId,
      hideZeroDetail: !(val !== null && val !== void 0 && val.length) ? false : true
    }, categorySearch));
  };

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)(_useState9, 2),
      visible = _useState10[0],
      setVisible = _useState10[1];

  var toggleGoodsModal = bool => {
    setVisible(bool);
  };

  var saveGoodModal = /*#__PURE__*/function () {
    var _ref7 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().mark(function _callee7(rows) {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return props === null || props === void 0 ? void 0 : props.saveGoodsModal(rows);

            case 2:
              closeModal();

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function saveGoodModal(_x2) {
      return _ref7.apply(this, arguments);
    };
  }();

  var closeModal = () => {
    setVisible(false);
  }; // 删除已选择多个商品的回调


  var handleDeleteRows = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().mark(function _callee8() {
    var res, _table$getTableData, _table$getTableData$d, _innerRef$current, _innerRef$current2, pageSize;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            console.log('handleDeleteRows data删除已选择商品', selectedItems);

            if (!((selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) > 0)) {
              _context8.next = 10;
              break;
            }

            console.log('applyId', formData.applyId);
            _context8.next = 5;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_21__/* .DELETE_APPLY_ORDER_LINE */ .kO, {
              applyId: formData.applyId,
              applyCode: formData.applyCode,
              applyDetailIds: selectedItems.map(m => m.applyDetailId)
            });

          case 5:
            res = _context8.sent;

            if (res.success) {
              antd_es_message__WEBPACK_IMPORTED_MODULE_22__.default.success("\u6210\u529F\u5220\u9664\u5DF2\u9009\u62E9\u5546\u54C1");

              pageSize = table === null || table === void 0 ? void 0 : (_table$getTableData = table.getTableData()) === null || _table$getTableData === void 0 ? void 0 : (_table$getTableData$d = _table$getTableData.dataSource) === null || _table$getTableData$d === void 0 ? void 0 : _table$getTableData$d.length;

              if (selectedItems.length == pageSize) {
                // 整个页面删除，则刷新列表
                table === null || table === void 0 ? void 0 : table.reflashTable({
                  applyId: formData === null || formData === void 0 ? void 0 : formData.applyId,
                  applyCode: formData === null || formData === void 0 ? void 0 : formData.applyCode,
                  current: 1
                });
              } else {
                table === null || table === void 0 ? void 0 : table.deleteAndRefreshData(selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.map(m => m.commonTableKey));
              }

              ((_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : _innerRef$current.innerFn) && ((_innerRef$current2 = innerRef.current) === null || _innerRef$current2 === void 0 ? void 0 : _innerRef$current2.innerFn());
            }

            return _context8.abrupt("return", res.success);

          case 10:
            return _context8.abrupt("return", true);

          case 11:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  })), [selectedItems]); // 根据异常排序

  var handleSort = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)(isAsc => {
    props === null || props === void 0 ? void 0 : props.reSearch((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)({
      abnormalBy: isAsc,
      searchGoods: goodSearchKey,
      applyId: formData.applyId,
      applyCode: formData.applyCode
    }, categorySearch));
  }, [categorySearch, formData.applyCode, formData.applyId, goodSearchKey, props]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(_ReplenishGoodsModal__WEBPACK_IMPORTED_MODULE_15__.default, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_24__/* .default */ .Z)({
    closeModalCallback: closeModal,
    saveModalCallback: saveGoodModal,
    visible: visible
  }, props)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_row__WEBPACK_IMPORTED_MODULE_25__/* .default */ .Z, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_26__/* .default */ .Z, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("span", {
    style: {
      marginRight: '16px'
    },
    key: "upload"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_27__/* .default */ .Z, {
    style: {
      marginBottom: 5
    },
    type: "primary",
    disabled: !props.canHandle,
    className: "mRight16",
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_28__/* .default */ .Z, null),
    onClick: () => toggleGoodsModal(true)
  }, (_props$addBtnText = props === null || props === void 0 ? void 0 : props.addBtnText) !== null && _props$addBtnText !== void 0 ? _props$addBtnText : '添加商品'), (formData === null || formData === void 0 ? void 0 : formData.requireSource) != _mapEnums__WEBPACK_IMPORTED_MODULE_14__/* .enumRequireSource["自动补货"] */ .LN["自动补货"] && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(_components_Uploader__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, {
    tokenUrl: _pages_Replenishment_Api__WEBPACK_IMPORTED_MODULE_29__/* .purchaseResourceTokenApi */ .w,
    accept: ".xlsx,.xls",
    onChange: changeUpload,
    loading: btnLoading,
    btnText: "\u5BFC\u5165excel\u5546\u54C1",
    uploadOptions: {
      showUploadList: false,
      disabled: !canHandle || props.canHandleClear
    }
  })), (formData === null || formData === void 0 ? void 0 : formData.requireSource) != _mapEnums__WEBPACK_IMPORTED_MODULE_14__/* .enumRequireSource["自动补货"] */ .LN["自动补货"] && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_27__/* .default */ .Z, {
    className: "mRight16",
    disabled: !canHandle,
    onClick: downloadTemplate,
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_30__/* .default */ .Z, null),
    key: "download"
  }, "\u4E0B\u8F7Dexcel\u6A21\u677F"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_27__/* .default */ .Z, {
    onClick: confirmClear,
    key: "clean",
    disabled: !props.canHandleClear,
    className: "mRight16"
  }, "\u6E05\u7A7A\u5546\u54C1"), selectedItems != undefined && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_27__/* .default */ .Z, {
    key: "deleteSeleted",
    disabled: (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) == 0,
    onClick: confirmDeleteSelected,
    className: "mRight16"
  }, "\u5220\u9664"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_row__WEBPACK_IMPORTED_MODULE_25__/* .default */ .Z, {
    style: {
      marginTop: 3
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_26__/* .default */ .Z, {
    xs: 24,
    sm: 24,
    md: 16,
    lg: 16,
    xl: 16
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(_components_CategorySelectForTwo__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
    onSecondChange: onSecondChange,
    onThirdChange: onThirdChange,
    className: "f-l",
    categoryList: categoryList,
    value: {
      first: formData === null || formData === void 0 ? void 0 : formData.firstCategoryId,
      second: formData === null || formData === void 0 ? void 0 : formData.secondCategoryId,
      third: (formData === null || formData === void 0 ? void 0 : (_formData$category2 = formData.category) === null || _formData$category2 === void 0 ? void 0 : _formData$category2.length) === 3 && +(formData === null || formData === void 0 ? void 0 : formData.category[2]) !== 0 || formData !== null && formData !== void 0 && (_formData$category3 = formData.category) !== null && _formData$category3 !== void 0 && _formData$category3.thirdCategoryId ? (formData === null || formData === void 0 ? void 0 : (_formData$category4 = formData.category) === null || _formData$category4 === void 0 ? void 0 : _formData$category4.thirdCategoryId) || (formData === null || formData === void 0 ? void 0 : formData.category[2]) : undefined
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_31__/* .default */ .Z, {
    style: {
      width: 150,
      marginLeft: 3,
      borderRadius: 4,
      marginTop: 5,
      marginBottom: 5
    },
    onChange: keyChange,
    allowClear: true,
    placeholder: "\u54C1\u540D/\u7F16\u7801/\u6761\u7801"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_32__/* .default */ .Z, {
    title: "\u641C\u7D22\u7C7B\u76EE/\u54C1\u540D/\u7F16\u7801/\u6761\u7801"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_27__/* .default */ .Z, {
    type: "primary",
    style: {
      marginLeft: '3px'
    },
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_33__/* .default */ .Z, null),
    onClick: searchHandle
  }, "\u641C\u7D22"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_26__/* .default */ .Z, {
    xs: 16,
    sm: 16,
    md: 8,
    lg: 8,
    xl: 8,
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(_components_Exception__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, {
    labelName: "\u6570\u91CF\u5F02\u5E38",
    exceptionPriceCount: curSummaryData === null || curSummaryData === void 0 ? void 0 : curSummaryData.abnormalCount,
    sortCallback: handleSort
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("span", {
    style: {
      marginLeft: 15
    }
  }, "\u79CD\u7C7B: ", curSummaryData === null || curSummaryData === void 0 ? void 0 : curSummaryData.skuCount), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("span", {
    style: {
      marginLeft: 15
    }
  }, "\u603B\u6570\u91CF: ", curSummaryData === null || curSummaryData === void 0 ? void 0 : curSummaryData.totalQty), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("span", {
    style: {
      marginLeft: 15
    }
  }, "\u603B\u91D1\u989D: ", curSummaryData === null || curSummaryData === void 0 ? void 0 : curSummaryData.totalAmount))));
}

/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_7__.forwardRef)(HandleBtn));

/***/ }),

/***/ 12343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(91896);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(71577);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(57016);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _components_YpshopCps_FormBuilder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29891);
/* harmony import */ var _components_YpshopCps_EditableTable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37734);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37778);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24731);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(56870);
/* harmony import */ var _hooks_useCategory3Level__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71117);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53719);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26715);












/**
 * 商家商品
 */











function ReplenishGoodsModal(props) {
  var _props$canSelected;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState, 2),
      selectedRows = _useState2[0],
      setSelectedRows = _useState2[1];

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)([_config_enums__WEBPACK_IMPORTED_MODULE_11__/* .purchaseEnumConfig.categoryCodeAll */ .Nt.categoryCodeAll, _config_enums__WEBPACK_IMPORTED_MODULE_11__/* .purchaseEnumConfig.placeId */ .Nt.placeId]),
      mappingList = _useMapping.mappingList;

  var _href = window.location.href;
  var isGoodsReturn = _href.indexOf('/GoodsReturn') !== -1;
  var manageType = isGoodsReturn ? '退货' : '补货';

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState3, 2),
      searchParams = _useState4[0],
      setSearchParams = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    setSearchParams({
      billType: props.billType,
      condition: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, props.goodsModalSearchParams)
    });
  }, [props]);
  var formData = props.formData,
      goodsModalSearchParams = props.goodsModalSearchParams;

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState5, 2),
      editTableData = _useState6[0],
      setEditTableData = _useState6[1];

  var category = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    var obj = {
      firstCategoryId: +(goodsModalSearchParams === null || goodsModalSearchParams === void 0 ? void 0 : goodsModalSearchParams.firstCategoryId)
    };

    if (goodsModalSearchParams !== null && goodsModalSearchParams !== void 0 && goodsModalSearchParams.secondCategoryId) {
      obj['secondCategoryId'] = +(goodsModalSearchParams === null || goodsModalSearchParams === void 0 ? void 0 : goodsModalSearchParams.secondCategoryId);
    }

    if (goodsModalSearchParams !== null && goodsModalSearchParams !== void 0 && goodsModalSearchParams.thirdCategoryId) {
      obj['thirdCategoryId'] = +(goodsModalSearchParams === null || goodsModalSearchParams === void 0 ? void 0 : goodsModalSearchParams.thirdCategoryId);
    } // if (goodsModalSearchParams?.thirdCategoryId) {
    //   obj['thirdCategoryId'] = +goodsModalSearchParams?.thirdCategoryId
    // }


    return obj;
  }, [goodsModalSearchParams]);

  var _useCategory3Level = (0,_hooks_useCategory3Level__WEBPACK_IMPORTED_MODULE_9__/* .useCategory3Level */ .W)({
    outCategory: category,
    goodModalCategoryData: props.goodModalCategoryData,
    mappingList
  }),
      _useCategory3Level2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useCategory3Level, 2),
      categories = _useCategory3Level2[0],
      _useCategory3Level2$ = _useCategory3Level2[1],
      category3 = _useCategory3Level2$.category3,
      reset = _useCategory3Level2$.reset;

  var table = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(); // const { mappingList } = useMapping(5)
  // const searchHandler = useCallback((state, values) => , [props.goodsModalSearchParams])

  var searchHandler = (state, values) => {
    var _props$goodsModalSear, _props$goodsModalSear2, _category3$secondCate, _category3$thirdCateg;

    var secondCategoryId;

    for (var k in values) {
      if (!values[k]) {
        delete values[k];
      }
    }

    var condition = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, values), props.goodsModalSearchParams), {}, {
      firstCategoryId: (category3 === null || category3 === void 0 ? void 0 : category3.firstCategoryId) || ((_props$goodsModalSear = props.goodsModalSearchParams) === null || _props$goodsModalSear === void 0 ? void 0 : _props$goodsModalSear.firstCategoryId),
      secondCategoryId: (category3 === null || category3 === void 0 ? void 0 : category3.secondCategoryIds) || secondCategoryId || ((_props$goodsModalSear2 = props.goodsModalSearchParams) === null || _props$goodsModalSear2 === void 0 ? void 0 : _props$goodsModalSear2.secondCategoryId)
    });

    if (Array.isArray(category3 === null || category3 === void 0 ? void 0 : category3.secondCategoryIds) && category3 !== null && category3 !== void 0 && (_category3$secondCate = category3.secondCategoryIds) !== null && _category3$secondCate !== void 0 && _category3$secondCate.length) {
      var ids = category3 === null || category3 === void 0 ? void 0 : category3.secondCategoryIds;
      secondCategoryId = ids[0];
      condition['secondCategoryId'] = secondCategoryId;
    }

    if (category3 !== null && category3 !== void 0 && (_category3$thirdCateg = category3.thirdCategoryIds) !== null && _category3$thirdCateg !== void 0 && _category3$thirdCateg.length) {
      condition['categoryIds'] = category3 === null || category3 === void 0 ? void 0 : category3.thirdCategoryIds;
    }

    Object.keys(condition).forEach(i => {
      var _condition$i;

      if (Array.isArray(condition[i]) && !((_condition$i = condition[i]) !== null && _condition$i !== void 0 && _condition$i.length)) {
        delete condition[i];
      }
    });
    setSearchParams((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, searchParams), {}, {
      condition
    }));
  };

  var rowSelectCallback = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((keys, rows) => {
    setSelectedRows(rows);
  }, []);

  var handleOk = () => {
    props.saveModalCallback(selectedRows);
  };

  var handleReset = () => {
    setSearchParams((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, searchParams), {}, {
      condition: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, props.goodsModalSearchParams)
    }));
  };

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    // columns: props.goodModalcolumns,
    canHandle: props.canHandle,
    canSelected: props.canSelected // searchParams: searchParams

  }),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState7, 2),
      editProps = _useState8[0],
      seteditProps = _useState8[1]; // 更新表格数据 请求库存等add到原对象


  var getTableData = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().mark(function _callee(data) {
      var _props$goodsModalSear3, _props$goodsModalSear4;

      var arr;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (data.length) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .exchangeDataPromise */ .m)(data, (_props$goodsModalSear3 = props.goodsModalSearchParams) === null || _props$goodsModalSear3 === void 0 ? void 0 : _props$goodsModalSear3.merchantId, (_props$goodsModalSear4 = props.goodsModalSearchParams) === null || _props$goodsModalSear4 === void 0 ? void 0 : _props$goodsModalSear4.placeId, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, goodsModalSearchParams), {}, {
                billType: props.billType
              }));

            case 4:
              arr = _context.sent;
              setEditTableData(arr);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getTableData(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  /** 保存商品行 */


  var saveGoodsData = data => {
    return new Promise( /*#__PURE__*/function () {
      var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().mark(function _callee2(resolve, reject) {
        var params, res, result, _res$result, _data;

        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (formData !== null && formData !== void 0 && formData.applyId) {
                  _context2.next = 3;
                  break;
                }

                // console.error('no applyid');
                antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.info('未找到主单ID');

                return _context2.abrupt("return");

              case 3:
                params = {
                  applyId: formData.applyId,
                  applyCode: formData.applyCode,
                  placeId: +formData.placeId,
                  request: {
                    goodsId: data.goodsId,
                    unitPrice: data === null || data === void 0 ? void 0 : data.unitPrice,
                    goodsBarCode: data.goodsBarCode,
                    goodsReqQty: data.goodsReqQty
                  }
                };

                if (manageType === '退货') {
                  params.request['isDamage'] = data['isDamage'];
                  params.request['returnReason'] = data['returnReason'];
                }

                if (!data['applyDetailId']) {// console.error('applyDetailId not found')
                }

                if (data['applyDetailId']) {
                  // 编辑
                  params.request['applyDetailId'] = data['applyDetailId'];
                }

                _context2.next = 9;
                return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_17__/* .SAVE_APPLY_ORDER_LINE */ .LF, params);

              case 9:
                res = _context2.sent;
                console.log('保存结果', res);
                result = res.result;

                if (result !== null && result !== void 0 && result.isUpdateQty && manageType === '补货') {
                  antd_es_modal__WEBPACK_IMPORTED_MODULE_18__/* .default.info */ .Z.info({
                    title: '温馨提示',
                    content: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "\u5546\u54C1\u3010", data.goodsId, "\u3011", data === null || data === void 0 ? void 0 : data.goodsName), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "\u8981\u8D27\u6570\u91CF: ", data.goodsReqQty), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "\u6309\u8981\u8D27\u89C4\u683C\u6298\u7B97\u6210:  ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("strong", null, result === null || result === void 0 ? void 0 : result.realGoodsReqQty)))
                  });
                } //   bool isUpdateQty = 2; // 是否更新了数量
                // 目前补货支持校验： 如果isUpdateQty为true，则弹框提示并且更新表格数据，赋值要货件数，赋值正确补货量
                // 如果isUpdateQty为false，不弹框只更新table


                if (!res.success) {
                  _context2.next = 21;
                  break;
                }

                _data = JSON.parse(JSON.stringify(data));

                antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.success('商品保存成功');

                if (manageType === '补货') {
                  _data['copies'] = result === null || result === void 0 ? void 0 : result.copies;
                  _data['goodsReqQty'] = result === null || result === void 0 ? void 0 : result.realGoodsReqQty;
                }

                _data['applyDetailId'] = (_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.applyDetailId;
                return _context2.abrupt("return", resolve({
                  newRow: _data
                }));

              case 21:
                return _context2.abrupt("return", reject(res));

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());
  }; // 商品数据变化时


  var changeGoodsData = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().mark(function _callee3(data, selected) {
      var currentCell, currentRow, rows, goodsReqQty, returnReason, isDamage, unitPrice, _yield$saveGoodsData, newRow;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              currentCell = data.currentCell, currentRow = data.currentRow;

              if (!lodash__WEBPACK_IMPORTED_MODULE_7___default().isEmpty(currentCell)) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return");

            case 3:
              rows = currentRow;
              goodsReqQty = data.currentCell['goodsReqQty'];
              returnReason = data.currentCell['returnReason'];
              isDamage = data.currentCell['isDamage'];
              unitPrice = data.currentCell['unitPrice']; // 单元格为单价和数量的时候，计算金额

              if (!(goodsReqQty || returnReason || isDamage)) {
                _context3.next = 18;
                break;
              }

              // const qty = goodsReqQty ?? currentRow.goodsReqQty
              // const orderSpecification = currentRow.orderSpecification
              rows = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, currentRow); // rows = { ...currentRow, amount, totalAmount }

              setEditTableData(rows); // 注意： 如果外部赋值可编辑表格字段，table做对比前需要手动set一遍state

              _context3.next = 13;
              return saveGoodsData(rows);

            case 13:
              _yield$saveGoodsData = _context3.sent;
              newRow = _yield$saveGoodsData.newRow;
              setEditTableData(Array.isArray(newRow) ? newRow : [newRow]); // 注意: 更新pageEditable表格数据需要外部控制数据为数组

              _context3.next = 19;
              break;

            case 18:
              setEditTableData(rows);

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function changeGoodsData(_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();

  var GoodsModalFormElements = [{
    label: '商品',
    name: 'queryCriteria',
    type: 'INPUT',
    columns: 2,
    fieldOptions: {
      placeholder: '品名/编码/plu/条码'
    }
  }, {
    label: '商品精准',
    name: 'accurateQueryCriteria',
    type: 'INPUT',
    columns: 2,
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '品牌名称',
    name: 'brandName',
    type: 'INPUT',
    columns: 2
  }, {
    label: '商品品类',
    name: 'category',
    widget: categories,
    columns: 4,
    formItemProps: {
      labelCol: {
        span: 2
      },
      wrapperCol: {
        span: 22
      }
    }
  }];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
    closable: false,
    title: props.goodsModalOptions['title'] || '商家选择',
    destroyOnClose: true,
    maskClosable: false,
    width: 1350,
    style: {
      maxHeight: 700
    },
    visible: props.visible // onOk={handleOk}
    ,
    onOk: props.saveGoodModal,
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z, {
      key: "back",
      onClick: handleOk,
      type: "primary"
    }, "\u5173\u95ED")]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_YpshopCps_FormBuilder__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    elements: GoodsModalFormElements,
    callbackHandler: searchHandler,
    onReset: handleReset,
    disableCache: true,
    defaultExpand: true
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_YpshopCps_EditableTable__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)({}, editProps, {
    onChange: changeGoodsData,
    searchParams: searchParams,
    returnData: getTableData,
    hideBtn: true,
    hideDeleteBtn: true,
    queryDataUrl: "purchase.product.querySelectPlaceProductByCondition",
    ref: table,
    columns: props.goodModalcolumns,
    disableAddBtn: !props.canHandle,
    canSelected: (_props$canSelected = props.canSelected) !== null && _props$canSelected !== void 0 ? _props$canSelected : true,
    tableOptions: {
      scroll: {
        x: 1400
      }
    },
    scrollYSize: 300,
    updateDataSource: editTableData
  })));
}

/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_3__.memo)(ReplenishGoodsModal));

/***/ }),

/***/ 59249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LN": function() { return /* binding */ enumRequireSource; },
/* harmony export */   "iq": function() { return /* binding */ enumPlaceCope; }
/* harmony export */ });
/* unused harmony export purchaseObj */
// 字段名对应的映射
var purchaseObj = {
  billState: 9,
  categoryCode: 4,
  placeCode: 3,
  orderType: 10,
  isStraight: 43,
  categoryCodeAll: 41,
  isDamage: 11,
  returnReason: 12,
  sencondCategoryId: 5,
  businessMode: 13,
  merchantId: 18
};
var enumRequireSource; // UNKNOWN_ENUM(0, "未知"),
//     STORE(1, "门店"),
//     WAREHOUSE(2, "大仓"),
//     YYB(3, "营业部");

(function (enumRequireSource) {
  enumRequireSource[enumRequireSource["PDA\u8865\u8D27"] = 6] = "PDA\u8865\u8D27";
  enumRequireSource[enumRequireSource["\u624B\u52A8\u8865\u8D27"] = 5] = "\u624B\u52A8\u8865\u8D27";
  enumRequireSource[enumRequireSource["\u81EA\u52A8\u8865\u8D27"] = 4] = "\u81EA\u52A8\u8865\u8D27";
})(enumRequireSource || (enumRequireSource = {}));

var enumPlaceCope;

(function (enumPlaceCope) {
  enumPlaceCope[enumPlaceCope["\u95E8\u5E97"] = 1] = "\u95E8\u5E97";
  enumPlaceCope[enumPlaceCope["\u5927\u4ED3"] = 2] = "\u5927\u4ED3";
  enumPlaceCope[enumPlaceCope["\u8425\u4E1A\u90E8"] = 3] = "\u8425\u4E1A\u90E8";
})(enumPlaceCope || (enumPlaceCope = {}));

/***/ }),

/***/ 43627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ useColumns; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31097);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24731);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96534);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26715);
/* harmony import */ var _mapEnums__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59249);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68628);














// 商品编码与商品条码的请求接口
var selectMap = {
  goodsIdList: 'purchase.product.queryProductIdByKey',
  goodsBarCodeList: 'purchase.product.queryBarcodeByKey'
};
var orderTypeOneCols = [{
  title: '好坏货标记',
  dataIndex: 'isDamage',
  key: 'isDamage',
  width: 110,
  editable: true,
  sorter: (a, b) => {
    return a === null || a === void 0 ? void 0 : a.isDamageName.localeCompare(b === null || b === void 0 ? void 0 : b.isDamageName, 'cn');
  },
  render: (t, r, i, fn) => {
    var data = _config_enums__WEBPACK_IMPORTED_MODULE_6__/* .enumGlobalPurchase.isDamage.filter */ .Ov.isDamage.filter(e => e.value === t);
    var value = data.length ? data[0].label : '';

    if (fn) {
      return fn({
        fieldType: 'SELECT',
        dataList: _config_enums__WEBPACK_IMPORTED_MODULE_6__/* .enumGlobalPurchase.isDamage */ .Ov.isDamage
      });
    }

    return +t == 0 ? '' : value; // 如果下拉框后端返回0，则默认为空处理
  }
}, {
  title: '退货原因',
  dataIndex: 'returnReason',
  key: 'returnReason',
  width: 110,
  editable: true,
  sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.returnReason.length) - (b === null || b === void 0 ? void 0 : b.returnReason.length),
  render: (t, r, i, fn) => {
    var data = _config_enums__WEBPACK_IMPORTED_MODULE_6__/* .enumGlobalPurchase.returnReason.filter */ .Ov.returnReason.filter(e => e.value === t);
    var value = data.length ? data[0].label : '';

    if (fn) {
      return fn({
        fieldType: 'SELECT',
        dataList: _config_enums__WEBPACK_IMPORTED_MODULE_6__/* .enumGlobalPurchase.returnReason */ .Ov.returnReason
      });
    }

    return +t == 0 ? '' : value; // 如果下拉框后端返回0，则默认为空处理
  }
}]; // 商品列表的表头

function useColumns(props) {
  var _href = window.location.href;
  var isGoodsReturn = _href.indexOf('/GoodsReturn') !== -1;
  var manageType = isGoodsReturn ? '退货' : '补货';
  var formData = props.formData,
      barCodeList = props.barCodeList;
  var requireSource = formData.requireSource,
      firstCategoryId = formData.firstCategoryId;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState, 2),
      goodsIdList = _useState2[0],
      setGoodsIdList = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState3, 2),
      goodsBarCodeList = _useState4[0],
      setGoodsBarCodeList = _useState4[1]; // 获取商品编码和条码的下拉数据


  var handleGoodSearchList = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee(val) {
      var res, list, data;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (!(formData && !formData['merchantId'])) {
                _context.next = 4;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_11__.default.info('未选择商家');

              return _context.abrupt("return", false);

            case 4:
              if (val) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              _context.next = 8;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(selectMap['goodsIdList'], {
                merchantId: +formData.merchantId,
                key: val
              });

            case 8:
              res = _context.sent;

              if (res.success) {
                _context.next = 11;
                break;
              }

              throw '请求失败';

            case 11:
              list = res.result.list;

              if (list && !list.length) {
                setTimeout(() => {
                  antd_es_message__WEBPACK_IMPORTED_MODULE_11__.default.info('未查到相关信息');
                }, 500);
              }

              data = list.map(v => ({
                value: v,
                label: v
              }));
              setGoodsIdList(data);
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_11__.default.error(_context.t0);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 17]]);
    }));

    return function handleGoodSearchList(_x) {
      return _ref.apply(this, arguments);
    };
  }(); // 获取条码的下拉数据


  var handleCodeSearchList = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee2(val) {
      var res, list, data;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              if (formData.merchantId) {
                _context2.next = 4;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_11__.default.info('未选择商家');

              return _context2.abrupt("return", false);

            case 4:
              if (val) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt("return");

            case 6:
              _context2.next = 8;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(selectMap['goodsBarCodeList'], {
                merchantId: +formData.merchantId,
                key: val
              });

            case 8:
              res = _context2.sent;

              if (res.success) {
                _context2.next = 11;
                break;
              }

              throw '请求失败';

            case 11:
              list = res.result.list;
              data = list.map(v => ({
                value: v,
                label: v
              }));
              setGoodsBarCodeList(data);
              _context2.next = 19;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_11__.default.error(_context2.t0);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 16]]);
    }));

    return function handleCodeSearchList(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    var data = barCodeList.map(v => ({
      value: v,
      label: v
    }));
    setGoodsBarCodeList(data);
  }, [barCodeList]);
  var onDebounceGoodSearch = lodash_debounce__WEBPACK_IMPORTED_MODULE_4___default()(handleGoodSearchList, 500);
  var onDebounceCodeSearch = lodash_debounce__WEBPACK_IMPORTED_MODULE_4___default()(handleCodeSearchList, 500);

  if ((props === null || props === void 0 ? void 0 : props.type) === 'modal') {
    // 商品弹框的列表list
    // 弹框专属
    var normalColumns = [{
      title: '商品名称',
      dataIndex: 'goodsName',
      key: 'goodsName',
      width: 180,
      fixed: 'left',
      sorter: (a, b) => {
        var stringA = a.goodsName.toUpperCase(); // ignore upper and lowercase

        var stringB = b.goodsName.toUpperCase(); // ignore upper and lowercase

        if (stringA < stringB) {
          return -1;
        }

        if (stringA > stringB) {
          return 1;
        }

        return 0;
      },
      sortDirections: ['descend', 'ascend']
    }, {
      title: '商品编码',
      dataIndex: 'goodsId',
      key: 'goodsId',
      width: 80
    }, {
      title: '商品条码',
      dataIndex: 'goodsBarCode',
      key: 'goodsBarCode',
      width: 130
    }, {
      title: 'PLU码',
      dataIndex: 'pluCode',
      key: 'pluCode',
      width: 100,
      hide: firstCategoryId && +firstCategoryId !== 10 // 一级类目为生鲜，则展示plu码

    }, {
      title: '单位',
      dataIndex: 'specUnit',
      key: 'specUnit',
      //  商品弹窗去specUnit
      //  明细是orderSpecificationUnit
      width: 80
    }, {
      title: '审核数量',
      dataIndex: 'goodsReqQty',
      key: 'goodsReqQty',
      width: 120,
      editable: true,
      render: (t, r, i, fn) => {
        var msg = +t > 2000 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
          style: {
            color: 'red'
          }
        }, "\u6570\u91CF>2000") : '';

        if (requireSource === _mapEnums__WEBPACK_IMPORTED_MODULE_7__/* .enumRequireSource["自动补货"] */ .LN["自动补货"] && r.goodsAdviceQty) {
          msg = +t > +r.goodsAdviceQty * 3 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
            style: {
              color: 'red'
            }
          }, "\u6570\u91CF>\u5EFA\u8BAE\u91CF3\u500D") : '';
        } // 非称重商品为正整数，称重商品保留两位小数


        var isPositiveInteger = r.isWeigh === 2;

        if (fn) {
          var params = {
            fieldType: 'INPUT',
            // fieldType: 'INPUT_NUMBER',
            fieldOptions: {
              min: 0,
              formatter: value => isPositiveInteger ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_5__/* .exchageToNum1 */ .Ly)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_5__/* .exchageToNum3 */ .hY)(value),
              parser: value => isPositiveInteger ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_5__/* .exchageToNum1 */ .Ly)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_5__/* .exchageToNum3 */ .hY)(value)
            }
          };
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, fn(params), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, msg));
        }

        if (isNaN(+t)) {
          return undefined;
        }

        return isPositiveInteger ? Math.floor(+t) + "(".concat((r === null || r === void 0 ? void 0 : r.barCodeUnit) || '', ")") : (Math.floor(+t * 1000) / 1000).toFixed(3) + "(".concat((r === null || r === void 0 ? void 0 : r.barCodeUnit) || '', ")");
      }
    }, {
      title: '今日已订货量',
      dataIndex: 'todayBuyCount',
      key: 'todayBuyCount',
      width: 100,
      render: (t, r, i, fn) => {
        if (t === '') {
          return '';
        } else {
          return t ? t + "(".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")") : t;
        }
      }
    }, {
      title: '昨日销量/近7日销量',
      dataIndex: 'yestDaySaleCount',
      key: 'yestDaySaleCount',
      width: 100,
      render: (t, r, i, fn) => {
        // 添加单位:  basicUnit  (瓶)
        if (t && !(r !== null && r !== void 0 && r.last7DaySaleCount)) {
          return t + ' / ' + '-' + " (".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
        }

        if (t && r !== null && r !== void 0 && r.last7DaySaleCount) {
          return t + ' / ' + (r === null || r === void 0 ? void 0 : r.last7DaySaleCount) + " (".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
        }
      },
      sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.yestDaySaleCount) - (b === null || b === void 0 ? void 0 : b.yestDaySaleCount)
    }, {
      title: '可用库存/在途库存',
      dataIndex: 'stock',
      key: 'stock',
      width: 100,
      sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.stock) - (b === null || b === void 0 ? void 0 : b.stock),
      render: (t, r, i, fn) => {
        if (t && !(r !== null && r !== void 0 && r.onOrderStock)) {
          return t + ' / ' + '-' + " (".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
        }

        if (t && r !== null && r !== void 0 && r.onOrderStock) {
          return t + ' / ' + ((r === null || r === void 0 ? void 0 : r.onOrderStock) || '') + " (".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
        }
      }
    }, {
      title: '大仓库存量',
      dataIndex: 'dcStock',
      key: 'dcStock',
      width: 110,
      sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.dcStock) - (b === null || b === void 0 ? void 0 : b.dcStock),
      render: (t, r, i, fn) => {
        if ((r === null || r === void 0 ? void 0 : r.logisticName) !== '配送') {
          return '-';
        } else {
          if (t === '' || !t) {
            return '';
          } else {
            return t + "(".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
          }
        }
      }
    }, {
      title: '经营状态',
      dataIndex: 'businessStatusName',
      key: 'businessStatusName',
      width: 80
    }, {
      title: '单价(含税)',
      dataIndex: 'unitPrice',
      key: 'unitPrice',
      width: 110,
      editable: true,
      render: (t, r, i, fn) => {
        if (fn && r.allowChangePrice) {
          return fn('INPUT_NUMBER');
        }

        if (t === '') {
          return '';
        } // basicUnit 元/瓶


        return isNaN(+t) ? undefined : +t + "(\u5143/".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
      }
    }, {
      title: '申请金额(含税)',
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      width: 120,
      editable: true,
      render: (t, r, i, fn) => {
        if (fn && r.allowChangePrice) {
          return fn('INPUT_NUMBER');
        }

        return isNaN(+t) ? undefined : +t;
      }
    }, {
      title: '物流模式',
      dataIndex: 'logisticName',
      key: 'logisticName',
      width: 80
    }, {
      title: '品牌名称',
      dataIndex: 'brandName',
      key: 'brandName',
      width: 140
    }, {
      title: '供应商编码',
      dataIndex: 'supplierCode',
      key: 'supplierCode',
      width: 140
    }, {
      title: '供应商名称',
      dataIndex: 'supplierName',
      key: 'supplierName',
      width: 170
    }];

    if (manageType === '补货') {
      normalColumns.splice(4, 0, {
        title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, "\u8981\u8D27\u89C4\u683C", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
          title: "\u8981\u8D27\u91CF\u5FC5\u987B\u4E3A\u8981\u8D27\u89C4\u683C\u500D\u6570"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("a", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
          style: {
            color: '#f50'
          }
        })))),
        dataIndex: 'orderStepSize',
        key: 'orderStepSize',
        width: 100
      });
      normalColumns.splice(6, 0, {
        title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, "\u8981\u8D27\u4EF6\u6570", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
          title: "\u8981\u8D27\u89C4\u683C\u6574\u4EF6\u6570 "
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("a", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
          style: {
            color: '#f50'
          }
        })))),
        dataIndex: 'copies',
        key: 'copies',
        width: 100
      });
    }

    if (manageType === '退货') {
      return [...normalColumns, ...orderTypeOneCols].filter(item => !item.hide);
    }

    return normalColumns.filter(item => !item.hide);
  } else {
    var _normalColumns = [{
      title: '商品名称',
      dataIndex: 'goodsName',
      key: 'goodsName',
      width: 180,
      fixed: 'left',
      sorter: (a, b) => {
        var stringA = a.goodsName.toUpperCase(); // ignore upper and lowercase

        var stringB = b.goodsName.toUpperCase(); // ignore upper and lowercase

        if (stringA < stringB) {
          return -1;
        }

        if (stringA > stringB) {
          return 1;
        }

        return 0;
      },
      sortDirections: ['descend', 'ascend']
    }, {
      title: '商品编码',
      dataIndex: 'goodsId',
      key: 'goodsId',
      width: 110,
      type: 'SELECT',
      dataList: goodsIdList,
      fieldOptions: {
        onSearch: onDebounceGoodSearch
      },
      sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.goodsId) - (b === null || b === void 0 ? void 0 : b.goodsId)
    }, {
      title: '商品条码',
      dataIndex: 'goodsBarCode',
      key: 'goodsBarCode',
      width: 160,
      type: 'SELECT',
      dataList: goodsBarCodeList,
      fieldOptions: {
        onSearch: onDebounceCodeSearch
      },
      sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.goodsBarCode) - (b === null || b === void 0 ? void 0 : b.goodsBarCode)
    }, {
      title: 'PLU码',
      dataIndex: 'goodsPluCode',
      key: 'goodsPluCode',
      width: 100,
      hide: firstCategoryId && +firstCategoryId !== 10 // 一级类目为生鲜，则展示plu码

    }, {
      title: '单位',
      dataIndex: 'orderSpecificationUnit',
      key: 'orderSpecificationUnit',
      //  明细是orderSpecificationUnit
      width: 70
    }, {
      title: '建议补货量',
      dataIndex: 'goodsAdviceQty',
      key: 'goodsAdviceQty',
      width: 90,
      hide: requireSource !== _mapEnums__WEBPACK_IMPORTED_MODULE_7__/* .enumRequireSource["自动补货"] */ .LN["自动补货"] ? true : false // “建议补货量”（手动补货/pda补货不展示此字段），自动补货： 补货量默认=审核数量

    }, {
      title: '审核数量',
      dataIndex: 'goodsReqQty',
      key: 'goodsReqQty',
      width: 120,
      editable: true,
      sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.goodsReqQty) - (b === null || b === void 0 ? void 0 : b.goodsReqQty),
      render: (t, r, i, fn) => {
        var msg = +t > 2000 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
          style: {
            color: 'red'
          }
        }, "\u6570\u91CF>2000") : '';

        if (requireSource === _mapEnums__WEBPACK_IMPORTED_MODULE_7__/* .enumRequireSource["自动补货"] */ .LN["自动补货"] && r.goodsAdviceQty) {
          msg = +t > +r.goodsAdviceQty * 3 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
            style: {
              color: 'red'
            }
          }, "\u6570\u91CF>\u5EFA\u8BAE\u91CF3\u500D") : '';
        } // 非称重商品为正整数，称重商品保留两位小数


        var isPositiveInteger = r.isWeigh === 2;

        if (fn) {
          var params = {
            fieldType: 'INPUT',
            fieldOptions: {
              formatter: value => isPositiveInteger ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_5__/* .exchageToNum1 */ .Ly)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_5__/* .exchageToNum3 */ .hY)(value)
            },
            value: r !== null && r !== void 0 && r.goodsReqQty ? r === null || r === void 0 ? void 0 : r.goodsReqQty : ''
          };
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
            style: {
              color: r !== null && r !== void 0 && r.goodsAdviceQty && (r === null || r === void 0 ? void 0 : r.goodsReqQty) !== (r === null || r === void 0 ? void 0 : r.goodsAdviceQty) ? 'red' : 'black'
            }
          }, fn(params), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, msg));
        }

        if (isNaN(+t)) {
          return undefined;
        }

        return isPositiveInteger ? Math.floor(+t) + "(".concat((r === null || r === void 0 ? void 0 : r.barCodeUnit) || '', ")") : (Math.floor(+t * 1000) / 1000).toFixed(3) + "(".concat((r === null || r === void 0 ? void 0 : r.barCodeUnit) || '', ")");
      }
    }, {
      title: '今日已订货量',
      dataIndex: 'todayBuyCount',
      key: 'todayBuyCount',
      width: 110,
      render: (t, r, i, fn) => {
        if (t === '' || isNaN(t) || t === undefined) {
          return '';
        } else {
          return t ? t + "(".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")") : t;
        }
      }
    }, {
      title: '昨日销量/近7日销量',
      dataIndex: 'yestDaySaleCount',
      key: 'yestDaySaleCount',
      width: 140,
      sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.yestDaySaleCount) - (b === null || b === void 0 ? void 0 : b.yestDaySaleCount),
      render: (t, r, i, fn) => {
        // 添加单位:  basicUnit  (瓶)
        if (t && !(r !== null && r !== void 0 && r.last7DaySaleCount)) {
          return t + ' / ' + '-' + " (".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
        }

        if (t && r !== null && r !== void 0 && r.last7DaySaleCount) {
          return t + ' / ' + (r === null || r === void 0 ? void 0 : r.last7DaySaleCount) + " (".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
        }
      }
    }, {
      title: '可用库存/在途库存',
      dataIndex: 'stock',
      key: 'stock',
      width: 140,
      sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.stock) - (b === null || b === void 0 ? void 0 : b.stock),
      render: (t, r, i, fn) => {
        if (t && !(r !== null && r !== void 0 && r.onOrderStock)) {
          return t + ' / ' + '-' + " (".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
        }

        if (t && r !== null && r !== void 0 && r.onOrderStock) {
          return t + ' / ' + (r === null || r === void 0 ? void 0 : r.onOrderStock) + " (".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
        }
      }
    }, {
      title: '上限库存',
      dataIndex: 'maxStock',
      key: 'maxStock',
      width: 130,
      sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.maxStock) - (b === null || b === void 0 ? void 0 : b.maxStock),
      render: (t, r, i, fn) => {
        if (t === '' || !t) {
          return '-';
        } else {
          return t + "(".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
        }
      },
      hide: requireSource !== _mapEnums__WEBPACK_IMPORTED_MODULE_7__/* .enumRequireSource["自动补货"] */ .LN["自动补货"] ? true : false
    }, {
      title: '大仓库存量',
      dataIndex: 'dcStock',
      key: 'dcStock',
      width: 130,
      sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.dcStock) - (b === null || b === void 0 ? void 0 : b.dcStock),
      render: (t, r, i, fn) => {
        if ((r === null || r === void 0 ? void 0 : r.logisticName) !== '配送') {
          return '-';
        } else {
          if (t === '' || !t) {
            return '';
          } else {
            return t + "(".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
          }
        }
      }
    }, {
      title: '经营状态',
      dataIndex: 'businessStatusName',
      key: 'businessStatusName',
      width: 140,
      sorter: (a, b) => a.businessStatusName.localeCompare(b.businessStatusName, 'cn')
    }, {
      title: '单价(含税)',
      dataIndex: 'unitPrice',
      key: 'unitPrice',
      width: 120,
      editable: true,
      render: (t, r, i, fn) => {
        if (fn && r.allowChangePrice) {
          return fn('INPUT_NUMBER');
        }

        return isNaN(+t) ? undefined : +t + "(\u5143/".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
      },
      sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.unitPrice) - (b === null || b === void 0 ? void 0 : b.unitPrice)
    }, {
      title: '申请金额(含税)',
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      width: 150,
      editable: true,
      render: (t, r, i, fn) => {
        if (fn && r.allowChangePrice) {
          return fn('INPUT_NUMBER');
        }

        return isNaN(+t) ? undefined : +t;
      },
      sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.totalAmount) - (b === null || b === void 0 ? void 0 : b.totalAmount)
    }, {
      title: '物流模式',
      dataIndex: 'logisticName',
      key: 'logisticName',
      width: 140,
      sorter: (a, b) => a.logisticName.localeCompare(b.logisticName, 'cn')
    }, {
      title: '商品税率(%)',
      dataIndex: 'taxRate',
      key: 'taxRate',
      width: 140,
      render: (t, r, i, fn) => {
        return t ? (t * 100).toFixed(2) : (+r['tax'] * 100).toFixed(2);
      }
    }, {
      title: '品牌名称',
      dataIndex: 'brandName',
      key: 'brandName',
      width: 140
    }, {
      title: '供应商编码',
      dataIndex: 'supplierCode',
      key: 'supplierCode',
      width: 140,
      sorter: (a, b) => +(a === null || a === void 0 ? void 0 : a.supplierCode.slice(-5)) - +(b === null || b === void 0 ? void 0 : b.supplierCode.slice(-5))
    }, {
      title: '供应商名称',
      dataIndex: 'supplierName',
      key: 'supplierName',
      width: 170,
      sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.supplierName.length) - (b === null || b === void 0 ? void 0 : b.supplierName.length)
    }];

    if (manageType === '补货') {
      _normalColumns.splice(4, 0, {
        title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, "\u8981\u8D27\u89C4\u683C", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
          title: "\u8981\u8D27\u91CF\u5FC5\u987B\u4E3A\u8981\u8D27\u89C4\u683C\u500D\u6570"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("a", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
          style: {
            color: '#f50'
          }
        })))),
        dataIndex: 'orderStepSize',
        key: 'orderStepSize',
        width: 100
      });

      _normalColumns.splice(6, 0, {
        title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, "\u8981\u8D27\u4EF6\u6570", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
          title: "\u8981\u8D27\u89C4\u683C\u6574\u4EF6\u6570 "
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("a", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
          style: {
            color: '#f50'
          }
        })))),
        dataIndex: 'copies',
        key: 'copies',
        width: 100
      });
    }

    if (manageType === '退货') {
      return [..._normalColumns, ...orderTypeOneCols].filter(item => !item.hide);
    }

    return _normalColumns.filter(item => !item.hide);
  }
}

/***/ }),

/***/ 37778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ exchangeDataPromise; }
/* harmony export */ });
/* unused harmony export exchangeDataPromiseForDetail */
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3182);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24731);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56870);




/**
 *  根据编码走其他接口，获取字段，拼接数据
 *  isListReq 是否列表明细，列表明细不处理applyOrderPrice
*/

var exchangeDataPromise = /*#__PURE__*/function () {
  var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)().mark(function _callee(list, merchantId, placeId, formData) {
    var productList, param, p, res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            productList = [];

            if (list !== null && list !== void 0 && list.length) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            param = list.map(item => ({
              merchantId: parseInt(merchantId),
              // 商家Id
              logistics: item['logistic'] || item['logistics'],
              goodsId: parseInt(item['goodsId']),
              // 商品Id列表
              deliveryDcId: parseInt(item['deliveryDcId']),
              // 大仓id
              placeId: parseInt(placeId),
              // 地点Id(当前库存)
              firstCategoryId: formData === null || formData === void 0 ? void 0 : formData.firstCategoryId,
              secondCategoryId: formData === null || formData === void 0 ? void 0 : formData.secondCategoryId
            }));
            p = {
              param,
              needPlaceStock: true,
              needSale: true,
              needYesterdayBuy: true,
              needWarehouseStock: true
            };

            if (formData !== null && formData !== void 0 && formData.billType) {
              p['orderTypePrice'] = formData === null || formData === void 0 ? void 0 : formData.billType;
            }

            _context.next = 8;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_3__/* .GET_PRODUCT_EXTINFO */ .Mo, p);

          case 8:
            res = _context.sent;

            if (res !== null && res !== void 0 && res.success) {
              if (formData && formData !== null && formData !== void 0 && formData.isListReq) {
                // 是否列表明细，列表明细不处理applyOrderPrice
                productList = res.result['list'].map(item => ({
                  yestDaySaleCount: item['yestDaySaleCount'],
                  goodsId: item['goodsId'],
                  // 商品Id列表
                  last7DaySaleCount: item['last7DaySaleCount'],
                  onOrderStock: item['onOrderStock'],
                  stock: item['stock'],
                  todayBuyCount: item['todayBuyCount'],
                  // 今日
                  dcStock: item['dcStock'] // 大仓库存

                }));
              } else {
                productList = res.result['list'].map(item => ({
                  yestDaySaleCount: item['yestDaySaleCount'],
                  goodsId: item['goodsId'],
                  // 商品Id列表
                  last7DaySaleCount: item['last7DaySaleCount'],
                  onOrderStock: item['onOrderStock'],
                  stock: item['stock'],
                  todayBuyCount: item['todayBuyCount'],
                  // 今日
                  dcStock: item['dcStock'],
                  // 大仓库存
                  unitPrice: item['applyOrderPrice'] // 查到价格直接覆盖

                }));
              }
            }

            if (formData && formData !== null && formData !== void 0 && formData.isListReq) {
              // 是否列表明细，列表明细不处理applyOrderPrice
              list.forEach(e => {
                productList.forEach(v => {
                  if (v['goodsId'] === e['goodsId']) {
                    e['yestDaySaleCount'] = v['yestDaySaleCount'];
                    e['last7DaySaleCount'] = v['last7DaySaleCount'];
                    e['onOrderStock'] = v['onOrderStock'];
                    e['stock'] = v['stock'];
                    e['todayBuyCount'] = v['todayBuyCount'];
                    e['dcStock'] = v['dcStock'];
                  }
                });
              });
            } else {
              list.forEach(e => {
                productList.forEach(v => {
                  if (v['goodsId'] === e['goodsId']) {
                    e['yestDaySaleCount'] = v['yestDaySaleCount'];
                    e['last7DaySaleCount'] = v['last7DaySaleCount'];
                    e['onOrderStock'] = v['onOrderStock'];
                    e['stock'] = v['stock'];
                    e['todayBuyCount'] = v['todayBuyCount'];
                    e['dcStock'] = v['dcStock'];
                    e['unitPrice'] = v['unitPrice'];
                  }
                });
              });
            }

            console.log('最后结果', list);
            return _context.abrupt("return", Promise.resolve(list));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function exchangeDataPromise(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
/** 根据编码走其他接口，获取字段，拼接数据 */

var exchangeDataPromiseForDetail = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(list, merchantId, placeId) {
    var productList, param, res;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            productList = [];

            if (list !== null && list !== void 0 && list.length) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return");

          case 3:
            param = list.map(item => ({
              merchantId: parseInt(merchantId),
              // 商家Id
              goodsId: parseInt(item['goodsId']),
              // 商品Id列表
              deliveryDcId: parseInt(item['deliveryDcId']),
              // 大仓id
              placeId: parseInt(placeId) // 地点Id(当前库存)

            }));
            console.log('paramList', param); // console.log('paramList', paramList)

            _context2.next = 7;
            return ypRider(API.GET_PRODUCT_EXTINFO, {
              param,
              needPlaceStock: true,
              needSale: true,
              needYesterdayBuy: true,
              needWarehouseStock: true
            });

          case 7:
            res = _context2.sent;

            if (res !== null && res !== void 0 && res.success) {
              productList = res.result['list'].map(item => ({
                yestDaySaleCount: item['yestDaySaleCount'],
                goodsId: item['goodsId'],
                // 商品Id列表
                last7DaySaleCount: item['last7DaySaleCount'],
                onOrderStock: item['onOrderStock'],
                stock: item['stock'],
                todayBuyCount: item['todayBuyCount'],
                // 今日
                dcStock: item['dcStock'] // 大仓库存

              }));
            }

            list.forEach(e => {
              productList.forEach(v => {
                if (v['goodsId'] === e['goodsId']) {
                  e['yestDaySaleCount'] = v['yestDaySaleCount'];
                  e['last7DaySaleCount'] = v['last7DaySaleCount'];
                  e['onOrderStock'] = v['onOrderStock'];
                  e['stock'] = v['stock'];
                  e['todayBuyCount'] = v['todayBuyCount'];
                  e['dcStock'] = v['dcStock'];
                }
              });
            });
            return _context2.abrupt("return", Promise.resolve(list));

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function exchangeDataPromiseForDetail(_x5, _x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}()));

/***/ }),

/***/ 83315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HOME_TABLE_COLUMNS": function() { return /* binding */ HOME_TABLE_COLUMNS; },
/* harmony export */   "DETAIL_TABLE_COLUMNS": function() { return /* binding */ DETAIL_TABLE_COLUMNS; },
/* harmony export */   "BASE_MAP": function() { return /* binding */ BASE_MAP; },
/* harmony export */   "goodsBackModal": function() { return /* binding */ goodsBackModal; },
/* harmony export */   "DICTIONARY": function() { return /* binding */ DICTIONARY; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var HOME_TABLE_COLUMNS = [{
  title: '退货申请单',
  dataIndex: 'applyCode',
  key: 'applyCode',
  width: 130,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, // {
//   title: '退货分类',
//   dataIndex: 'applyTypeName',
//   key: 'applyTypeName',
//   width: 90,
// },
{
  title: '地点编码',
  dataIndex: 'placeCode',
  key: 'placeCode',
  width: 65 // render: (t) => dictionaryMatch(t, 'supplierCategory', DICTIONARY, 'list')

}, {
  title: '地点名称',
  dataIndex: 'placeName',
  key: 'placeName',
  width: 140,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '品类',
  dataIndex: 'firstCategoryName',
  key: 'firstCategoryName',
  width: 140,
  ellipsis: true,
  render: (t, r) => {
    var text = r.firstCategoryName;

    if (r !== null && r !== void 0 && r.thirdCategoryName) {
      text = r.firstCategoryName + '/' + r.secondCategoryName + '/' + r.thirdCategoryName;
    } else if (!(r !== null && r !== void 0 && r.thirdCategoryName) && r !== null && r !== void 0 && r.secondCategoryName) {
      text = r.firstCategoryName + '/' + r.secondCategoryName;
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
      placement: "topLeft",
      title: text
    }, text);
  }
}, {
  title: 'sku种类',
  dataIndex: 'skuTypeCount',
  key: 'skuTypeCount',
  width: 50
}, {
  title: '数量',
  dataIndex: 'totalCount',
  key: 'totalCount',
  width: 50
}, {
  title: '金额(元)',
  dataIndex: 'totalAmount',
  key: 'totalAmount',
  width: 100,
  render: t => {
    return t !== null || t !== undefined ? (Math.floor(+t * 100) / 100).toFixed(3) : '';
  }
}, {
  title: '状态',
  dataIndex: 'statusName',
  key: 'statusName',
  width: 50
}, {
  title: '集单标记',
  dataIndex: 'flagName',
  key: 'flagName',
  width: 70
}, {
  title: '来源',
  dataIndex: 'requireSourceName',
  key: 'requireSourceName',
  width: 70
}, {
  title: '创建人',
  dataIndex: 'createUserName',
  key: 'createUserName',
  width: 90
}, {
  title: '创建时间',
  dataIndex: 'gmtCreate',
  key: 'gmtCreate',
  width: 150,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}];
var DETAIL_TABLE_COLUMNS = [{
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 90
}, {
  title: '商品条码',
  dataIndex: 'goodsBarCode',
  key: 'goodsBarCode',
  width: 100
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 100
}, {
  title: '单位',
  dataIndex: 'orderSpecificationUnit',
  key: 'orderSpecificationUnit',
  width: 130
}, {
  title: '单价',
  dataIndex: 'unitPrice',
  key: 'unitPrice',
  width: 130,
  render: (t, r) => isNaN(t) ? '' : t + "(\u5143/".concat(r === null || r === void 0 ? void 0 : r.basicUnit, ")")
}, {
  title: '申请数量',
  dataIndex: 'goodsReqQty',
  key: 'goodsReqQty',
  width: 130,
  render: (t, r) => isNaN(t) ? '' : t + "(".concat(r === null || r === void 0 ? void 0 : r.barCodeUnit, ")")
}, {
  title: '是否好坏货',
  dataIndex: 'isDamageName',
  key: 'isDamageName',
  width: 130
}, {
  title: '退货原因',
  dataIndex: 'returnReasonName',
  key: 'returnReasonName',
  width: 130
}, {
  title: '申请总金额',
  dataIndex: 'totalAmount',
  key: 'totalAmount',
  width: 130,
  render: t => isNaN(t) ? '' : t + '元' // render: (t) => { return (t !== null || t !== undefined) ? (Math.floor(+t * 100) / 1000000).toFixed(4) : '' },

}, // {
//   title: '昨日销量',
//   dataIndex: 'yestDaySaleCount',
//   key: 'yestDaySaleCount',
//   width: 130
// },
// {
//   title: '近7日销量',
//   dataIndex: 'last7DaySaleCount',
//   key: 'last7DaySaleCount',
//   width: 130
// },
// {
//   title: '可用库存',
//   dataIndex: 'stock',
//   key: 'stock',
//   width: 130
// },
// {
//   title: '在途库存',
//   dataIndex: 'onOrderStock',
//   key: 'onOrderStock',
//   width: 130
// },
{
  title: '大仓库存量',
  dataIndex: 'dcStock',
  key: 'dcStock',
  width: 120,
  sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.dcStock) - (b === null || b === void 0 ? void 0 : b.dcStock),
  render: (t, r, i, fn) => {
    if ((r === null || r === void 0 ? void 0 : r.logisticName) !== '配送') {
      return '-';
    } else {
      if (t === '' || !t) {
        return '';
      } else {
        return t + "(".concat(r === null || r === void 0 ? void 0 : r.basicUnit, ")");
      }
    }
  }
}, {
  title: '集单标记',
  dataIndex: 'poolingFlag',
  key: 'poolingFlag',
  width: 130
}, {
  title: '品牌名称',
  dataIndex: 'brandName',
  key: 'brandName',
  width: 90
}, {
  title: '供应商编码',
  dataIndex: 'supplierCode',
  key: 'supplierCode',
  width: 100
}, {
  title: '供应商名称',
  dataIndex: 'supplierName',
  key: 'supplierName',
  width: 140
}, {
  title: '经营状态',
  dataIndex: 'businessStatusName',
  key: 'businessStatusName',
  width: 100
}, {
  title: '物流模式',
  dataIndex: 'logisticsName',
  key: 'logisticsName',
  width: 130
}, {
  title: '规格',
  dataIndex: 'orderSpecification',
  key: 'orderSpecification',
  width: 130
}, {
  title: '集单单号',
  dataIndex: 'poolingNo',
  key: 'poolingNo',
  width: 130,
  render: t => {
    if (t === '0' || t === null) {
      return '';
    }

    return t;
  }
}];
/**
 * 列表常量
 */

var BASE_MAP = [// 基础信息
['applyCode', ['退货申请单号', '']], // ['requireSourceName', ['退货分类', '']],
['statusName', ['状态', '']], ['remark', ['备注', '']], ['placeName', ['地点', '']], ['firstCategoryName', ['一级品类', '']], ['secondCategoryName', ['二级品类', '']]];
var goodsBackModal = [{
  title: '商家名称',
  dataIndex: 'ffds',
  key: 'ffds',
  width: 140
}, {
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 140
}, {
  title: '商品条码',
  dataIndex: 'goodsBarCode',
  key: 'goodsBarCode',
  width: 140
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 140
}, {
  title: '大类名称',
  dataIndex: 'kmk',
  key: 'kmk',
  width: 140
}, {
  title: '品牌名称',
  dataIndex: 'crs',
  key: 'crs',
  width: 140
}, {
  title: '单位',
  dataIndex: 'njknd',
  key: 'njknd',
  width: 140
}, {
  title: '规格',
  dataIndex: 'jndsf',
  key: 'jndsf',
  width: 140
}];
/**
 * 字段字典
 */

var DICTIONARY = [{
  "key": "SupplierCategory",
  "configMap": {
    "1": "采购供应商",
    "2": "农户供应商"
  }
}];

/***/ }),

/***/ 50013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HOME_TABLE_COLUMNS": function() { return /* binding */ HOME_TABLE_COLUMNS; },
/* harmony export */   "DETAIL_TABLE_COLUMNS": function() { return /* binding */ DETAIL_TABLE_COLUMNS; },
/* harmony export */   "DETAIL_TABLE_COLUMNS_NOT_TODAY": function() { return /* binding */ DETAIL_TABLE_COLUMNS_NOT_TODAY; },
/* harmony export */   "BASE_MAP": function() { return /* binding */ BASE_MAP; },
/* harmony export */   "goodsBackModal": function() { return /* binding */ goodsBackModal; },
/* harmony export */   "DICTIONARY": function() { return /* binding */ DICTIONARY; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var HOME_TABLE_COLUMNS = [{
  title: '补货申请单',
  dataIndex: 'applyCode',
  key: 'applyCode',
  width: 160,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, // {
//   title: '补货分类',
//   dataIndex: 'applyTypeName',
//   key: 'applyTypeName',
//   width: 90,
// },
{
  title: '地点编码',
  dataIndex: 'placeCode',
  key: 'placeCode',
  width: 100 // render: (t) => dictionaryMatch(t, 'supplierCategory', DICTIONARY, 'list')

}, {
  title: '地点名称',
  dataIndex: 'placeName',
  key: 'placeName',
  width: 140,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '品类',
  dataIndex: 'firstCategoryName',
  key: 'firstCategoryName',
  width: 130,
  ellipsis: true,
  render: (t, r) => {
    var text = r.firstCategoryName;

    if (r !== null && r !== void 0 && r.thirdCategoryName) {
      text = r.firstCategoryName + '/' + r.secondCategoryName + '/' + r.thirdCategoryName;
    } else if (!(r !== null && r !== void 0 && r.thirdCategoryName) && r !== null && r !== void 0 && r.secondCategoryName) {
      text = r.firstCategoryName + '/' + r.secondCategoryName;
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
      placement: "topLeft",
      title: text
    }, text);
  }
}, {
  title: 'sku种类',
  dataIndex: 'skuTypeCount',
  key: 'skuTypeCount',
  width: 90
}, {
  title: '数量',
  dataIndex: 'totalCount',
  key: 'totalCount',
  width: 50
}, {
  title: '金额(元)',
  dataIndex: 'totalAmount',
  key: 'totalAmount',
  width: 100,
  render: t => {
    return t !== null || t !== undefined ? (Math.floor(+t * 100) / 100).toFixed(3) : '';
  }
}, {
  title: '状态',
  dataIndex: 'statusName',
  key: 'statusName',
  width: 50
}, {
  title: '集单标记',
  dataIndex: 'flagName',
  key: 'flagName',
  width: 90
}, {
  title: '来源',
  dataIndex: 'requireSourceName',
  key: 'requireSourceName',
  width: 90
}, {
  title: '创建人',
  dataIndex: 'createUserName',
  key: 'createUserName',
  width: 100
}, {
  title: '创建时间',
  dataIndex: 'gmtCreate',
  key: 'gmtCreate',
  width: 170,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '提交时间',
  dataIndex: 'submitTime',
  key: 'submitTime',
  width: 170,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}];
var DETAIL_TABLE_COLUMNS = [{
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 90
}, {
  title: '商品条码',
  dataIndex: 'goodsBarCode',
  key: 'goodsBarCode',
  width: 100
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 100
}, {
  title: '单位',
  dataIndex: 'orderSpecificationUnit',
  key: 'orderSpecificationUnit',
  width: 130
}, {
  title: '单价',
  dataIndex: 'unitPrice',
  key: 'unitPrice',
  width: 130,
  render: (t, r) => isNaN(t) ? '' : t + "(\u5143/".concat(r === null || r === void 0 ? void 0 : r.basicUnit, ")")
}, {
  title: '申请数量',
  dataIndex: 'goodsReqQty',
  key: 'goodsReqQty',
  width: 130,
  render: (t, r) => isNaN(t) ? '' : t + "(".concat(r === null || r === void 0 ? void 0 : r.barCodeUnit, ")")
}, {
  title: '申请总金额',
  dataIndex: 'totalAmount',
  key: 'totalAmount',
  width: 130,
  render: t => isNaN(t) ? '' : t + '元'
}, {
  title: '今日已订货量',
  dataIndex: 'todayBuyCount',
  key: 'todayBuyCount',
  width: 130,
  render: (t, r, i, fn) => {
    if (t === '' || !t) {
      return '';
    } else {
      return t + "(".concat(r === null || r === void 0 ? void 0 : r.basicUnit, ")");
    }
  }
}, {
  title: '大仓库存量',
  dataIndex: 'dcStock',
  key: 'dcStock',
  width: 120,
  sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.dcStock) - (b === null || b === void 0 ? void 0 : b.dcStock),
  render: (t, r, i, fn) => {
    if ((r === null || r === void 0 ? void 0 : r.logisticName) !== '配送') {
      return '-';
    } else {
      if (t === '' || !t) {
        return '';
      } else {
        return t + "(".concat(r === null || r === void 0 ? void 0 : r.basicUnit, ")");
      }
    }
  }
}, // {
//   title: '昨日销量',
//   dataIndex: 'yestDaySaleCount',
//   key: 'yestDaySaleCount',
//   width: 130
// },
// {
//   title: '近7日销量',
//   dataIndex: 'last7DaySaleCount',
//   key: 'last7DaySaleCount',
//   width: 130
// },
// {
//   title: '可用库存',
//   dataIndex: 'stock',
//   key: 'stock',
//   width: 130
// },
// {
//   title: '在途库存',
//   dataIndex: 'onOrderStock',
//   key: 'onOrderStock',
//   width: 130
// },
{
  title: '集单标记',
  dataIndex: 'poolingFlag',
  key: 'poolingFlag',
  width: 130
}, {
  title: '品牌名称',
  dataIndex: 'brandName',
  key: 'brandName',
  width: 90
}, {
  title: '供应商编码',
  dataIndex: 'supplierCode',
  key: 'supplierCode',
  width: 100
}, {
  title: '供应商名称',
  dataIndex: 'supplierName',
  key: 'supplierName',
  width: 140
}, {
  title: '经营状态',
  dataIndex: 'businessStatusName',
  key: 'businessStatusName',
  width: 100
}, {
  title: '物流模式',
  dataIndex: 'logisticsName',
  key: 'logisticsName',
  width: 130
}, {
  title: '规格描述',
  dataIndex: 'specDesc',
  key: 'specDesc',
  width: 130
}, {
  title: '集单单号',
  dataIndex: 'poolingNo',
  key: 'poolingNo',
  width: 130,
  render: t => {
    if (t === '0' || t === null) {
      return '';
    }

    return t;
  }
}];
var DETAIL_TABLE_COLUMNS_NOT_TODAY = [{
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 90
}, {
  title: '商品条码',
  dataIndex: 'goodsBarCode',
  key: 'goodsBarCode',
  width: 100
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 100
}, {
  title: '单位',
  dataIndex: 'orderSpecificationUnit',
  key: 'orderSpecificationUnit',
  width: 130
}, {
  title: '单价',
  dataIndex: 'unitPrice',
  key: 'unitPrice',
  width: 130,
  render: (t, r) => isNaN(t) ? '' : t + "(\u5143/".concat(r === null || r === void 0 ? void 0 : r.basicUnit, ")")
}, {
  title: '申请数量',
  dataIndex: 'goodsReqQty',
  key: 'goodsReqQty',
  width: 130,
  render: (t, r) => isNaN(t) ? '' : t + "(".concat(r === null || r === void 0 ? void 0 : r.barCodeUnit, ")")
}, {
  title: '申请总金额',
  dataIndex: 'totalAmount',
  key: 'totalAmount',
  width: 130,
  render: t => isNaN(t) ? '' : t + '元'
}, {
  title: '大仓库存量',
  dataIndex: 'dcStock',
  key: 'dcStock',
  width: 120,
  sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.dcStock) - (b === null || b === void 0 ? void 0 : b.dcStock),
  render: (t, r, i, fn) => {
    if ((r === null || r === void 0 ? void 0 : r.logisticName) !== '配送') {
      return '-';
    } else {
      if (t === '' || !t) {
        return '';
      } else {
        return t + "(".concat(r === null || r === void 0 ? void 0 : r.basicUnit, ")");
      }
    }
  }
}, {
  title: '集单标记',
  dataIndex: 'poolingFlag',
  key: 'poolingFlag',
  width: 130
}, {
  title: '品牌名称',
  dataIndex: 'brandName',
  key: 'brandName',
  width: 90
}, {
  title: '供应商编码',
  dataIndex: 'supplierCode',
  key: 'supplierCode',
  width: 100
}, {
  title: '供应商名称',
  dataIndex: 'supplierName',
  key: 'supplierName',
  width: 140
}, {
  title: '经营状态',
  dataIndex: 'businessStatusName',
  key: 'businessStatusName',
  width: 100
}, {
  title: '物流模式',
  dataIndex: 'logisticsName',
  key: 'logisticsName',
  width: 130
}, {
  title: '规格描述',
  dataIndex: 'specDesc',
  key: 'specDesc',
  width: 130
}, {
  title: '集单单号',
  dataIndex: 'poolingNo',
  key: 'poolingNo',
  width: 130,
  render: t => {
    if (t === '0' || t === null) {
      return '';
    }

    return t;
  }
}];
/**
 * 列表常量
 */

var BASE_MAP = [// 基础信息
['applyCode', ['补货申请单号', '']], // ['requireSourceName', ['补货分类', '']],
['statusName', ['状态', '']], ['remark', ['备注', '']], ['placeName', ['地点', '']], ['firstCategoryName', ['一级品类', '']], ['secondCategoryName', ['二级品类', '']], ['thirdCategoryName', ['三级品类', '']]];
var goodsBackModal = [{
  title: '商家名称',
  dataIndex: 'ffds',
  key: 'ffds',
  width: 140
}, {
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 140
}, {
  title: '商品条码',
  dataIndex: 'goodsBarCode',
  key: 'goodsBarCode',
  width: 140
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 140
}, {
  title: '大类名称',
  dataIndex: 'kmk',
  key: 'kmk',
  width: 140
}, {
  title: '品牌名称',
  dataIndex: 'crs',
  key: 'crs',
  width: 140
}, {
  title: '单位',
  dataIndex: 'njknd',
  key: 'njknd',
  width: 140
}, {
  title: '规格',
  dataIndex: 'jndsf',
  key: 'jndsf',
  width: 140
}];
/**
 * 字段字典
 */

var DICTIONARY = [{
  "key": "SupplierCategory",
  "configMap": {
    "1": "采购供应商",
    "2": "农户供应商"
  }
}];

/***/ }),

/***/ 53719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMapping; }
/* harmony export */ });
/* unused harmony export renderOptionsByObj */
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24731);




/**
 * 全局枚举
 */


// 恶一些心的枚举数据结构，害
var arrEnums = new Map([[3, ['placeId', 'placeName']], [46, ['categoryId', 'categoryName']], [41, ['categoryId', 'categoryName']], [47, ['placeId', 'placeName']], [53, ['placeId', 'placeName']]]);
var enumsKeys = [...arrEnums.keys()]; // 将对象转为对象数组的形式

var renderOptionsByObj = (obj, num) => {
  if (!obj || typeof obj !== 'object') {
    return [];
  }

  return Object.keys(obj).map(v => {
    var value = isNaN(parseFloat(v)) ? v : parseFloat(v);

    if (enumsKeys.includes(num)) {
      try {
        var enums = arrEnums.get(num); // eslint-disable-next-line no-eval

        var labelData = eval("(".concat(obj[v], ")"));
        return {
          value: labelData[enums[0]],
          label: labelData[enums[1]],
          others: labelData
        };
      } catch (error) {
        console.log("\u89E3\u6790\u679A\u4E3E\u300C".concat(num, "\u300D\u5931\u8D25\uFF1A"), error);
      }
    }

    return {
      value,
      label: obj[v],
      others: v
    };
  });
};
/**
 * 获取全局枚举
 * @param type 获取的枚举类型
 */

function useMapping(type, p) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(new Map()),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState, 2),
      mapping = _useState2[0],
      setMapping = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(new Map()),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState3, 2),
      mappingList = _useState4[0],
      setMappingList = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var queryMappingData = /*#__PURE__*/function () {
      var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().mark(function _callee() {
        var params, res, maps, mappings, mappingsList;
        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  type: Array.isArray(type) ? type : [type]
                };

                if (p) {
                  params['ext'] = p;
                }

                _context.next = 4;
                return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)('purchase.basis.mapping', params);

              case 4:
                res = _context.sent;
                maps = res.result.maps;

                if (maps) {
                  _context.next = 9;
                  break;
                }

                console.error('请求枚举失败：', res);
                return _context.abrupt("return");

              case 9:
                mappings = [];
                mappingsList = [];
                Object.entries(maps).forEach(val => {
                  var key = val[0]; // 枚举的键值，如：1，2，3，4

                  var value = val[1]; // 枚举的值，如：{1:xxx, 2: hhhh}
                  // 将键转为数字类型

                  var num = typeof key === 'string' ? parseInt(key) : key; // 判断是否存在，以及是否为字符串

                  var obj = value ? typeof value === 'string' ? JSON.parse(value) : {} : {};
                  var list = [];

                  if (num === 40) {
                    var str = obj.merchants;

                    try {
                      var arr = JSON.parse(str);
                      list = arr.map(v => ({
                        value: +v.merchantId,
                        label: v.merchantName,
                        others: v
                      }));
                    } catch (error) {
                      console.log('解析商户枚举失败：', error);
                    }
                  } else {
                    list = renderOptionsByObj(obj, num);
                  }

                  mappings.push([num, obj]); // 塞到枚举数组里

                  mappingsList.push([num, list]);
                });
                setMapping(new Map(mappings)); // message.info(json.s)

                setMappingList(new Map(mappingsList));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function queryMappingData() {
        return _ref.apply(this, arguments);
      };
    }();

    queryMappingData();
  }, []);
  return {
    mapping,
    mappingList
  };
}

/***/ }),

/***/ 41993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tr": function() { return /* binding */ REPLENISH_CONFIG; },
/* harmony export */   "xu": function() { return /* binding */ DEL_REPLENISH_CONFIG; },
/* harmony export */   "E_": function() { return /* binding */ CONFIG_LIST; },
/* harmony export */   "NN": function() { return /* binding */ DETAIL_REPLENISH; }
/* harmony export */ });
/* unused harmony export IMPORT_REPLENISH */
/**
 * API集合
 */
// 保存补货策略配置
var REPLENISH_CONFIG = 'scm.require.saveOrModifyOrderStrategy'; // 删除

var DEL_REPLENISH_CONFIG = 'scm.require.deleteOrderStrategy'; // 配置列表

var CONFIG_LIST = 'scm.require.orderStrategyPages'; // 导入模板

var IMPORT_REPLENISH = 'scmConfig.replenish.importReplenishGoods'; // 详情

var DETAIL_REPLENISH = 'scm.require.orderStrategyDetail';

/***/ }),

/***/ 50350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BASE_MAP": function() { return /* binding */ BASE_MAP; },
/* harmony export */   "TABLE_COLUMNS": function() { return /* binding */ TABLE_COLUMNS; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31097);
/**
 * 业务常量
 */


var BASE_MAP = [// 基础信息
['merchantName', ['商家', '']], ['firstCategoryName', ['一级分类', '']], ['secondCategoryNames', ['二级分类', '']], ['requireApplyTime', ['补货时间', '']]];
var TABLE_COLUMNS = [{
  title: '商家编码',
  dataIndex: 'merchantCode',
  key: 'merchantCode'
}, {
  title: '商家名称',
  dataIndex: 'merchantName',
  key: 'merchantName',
  ellipsis: true,
  render: text => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z, {
    title: text
  }, text)
}, {
  title: '一级品类',
  dataIndex: 'firstCategoryName',
  key: 'firstCategoryName'
}, {
  title: '二级品类',
  dataIndex: 'secondCategoryNames',
  key: 'secondCategoryNames',
  ellipsis: true,
  width: 200,
  render: text => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z, {
    title: text
  }, text)
}, {
  title: '自动出单时间',
  dataIndex: 'requireApplyTime',
  key: 'requireApplyTime'
}, {
  title: '创建人',
  dataIndex: 'createUserName',
  key: 'createUserName',
  width: 100
}, {
  title: '创建时间',
  dataIndex: 'gmtCreate',
  key: 'gmtCreate',
  width: 180
}, {
  title: '更新人',
  dataIndex: 'updateUserName',
  key: 'updateUserName',
  width: 80
}, {
  title: '更新时间',
  dataIndex: 'gmtModified',
  key: 'gmtModified',
  width: 180
}];

/***/ }),

/***/ 12569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z_": function() { return /* binding */ GOODS_IMPORT; },
/* harmony export */   "Jg": function() { return /* binding */ CUSTOMER_CODE_LIST; },
/* harmony export */   "Lv": function() { return /* binding */ CUSTOMER_INFO_LIST; },
/* harmony export */   "tA": function() { return /* binding */ CUSTOMER_SAVE; },
/* harmony export */   "wS": function() { return /* binding */ CUSTOMER_DETAIL; },
/* harmony export */   "gU": function() { return /* binding */ SALES_SAVE_DETAIL; },
/* harmony export */   "CH": function() { return /* binding */ SALES_INFO_LIST; },
/* harmony export */   "lL": function() { return /* binding */ SALES_SUBMIT; },
/* harmony export */   "M0": function() { return /* binding */ SALES_CANCEL; },
/* harmony export */   "w7": function() { return /* binding */ SALES_DETAIL; },
/* harmony export */   "VT": function() { return /* binding */ SALES_DETAIL_LIST; },
/* harmony export */   "dI": function() { return /* binding */ DOWNLOAD_TEMPLATE; },
/* harmony export */   "Iy": function() { return /* binding */ SALES_DELETE; },
/* harmony export */   "T2": function() { return /* binding */ SALES_DETAIL_LIST_STAT; },
/* harmony export */   "Eo": function() { return /* binding */ SALES_PRICE_CONFIG; },
/* harmony export */   "SS": function() { return /* binding */ SALES_EXPORT_ORDER; },
/* harmony export */   "hb": function() { return /* binding */ SALES_BATCH_DRIVE; },
/* harmony export */   "oe": function() { return /* binding */ SALES_SAVE_INFO; },
/* harmony export */   "I0": function() { return /* binding */ PRE_ORDER_SAVE; },
/* harmony export */   "ui": function() { return /* binding */ PRE_ORDER_DETAIL_SAVE; },
/* harmony export */   "NP": function() { return /* binding */ PRE_ORDER_LIST; },
/* harmony export */   "zd": function() { return /* binding */ PRE_ORDER_DETAIL; },
/* harmony export */   "E3": function() { return /* binding */ PRE_ORDER_DETAIL_LIST; },
/* harmony export */   "ZI": function() { return /* binding */ PRE_CLEAN_DETAIL_LIST; },
/* harmony export */   "Ii": function() { return /* binding */ PRE_ORDER_SUBMIT; },
/* harmony export */   "yT": function() { return /* binding */ PRE_IMPORT; },
/* harmony export */   "ZW": function() { return /* binding */ PRE_ORDER_CANCEL; },
/* harmony export */   "$E": function() { return /* binding */ PRE_ORDER_DETAIL_STAT; },
/* harmony export */   "I6": function() { return /* binding */ PRE_SALES_LIST; },
/* harmony export */   "iD": function() { return /* binding */ PRE_ORDER_DELETE; },
/* harmony export */   "xx": function() { return /* binding */ PRE_CHANGE_PRICE; },
/* harmony export */   "UD": function() { return /* binding */ PRE_REFERENCE_PRICE; }
/* harmony export */ });
/* unused harmony exports GOODS_LIST, SALES_RECEIPT */
// 商品信息导入
var GOODS_IMPORT = 'scm.wholesale.importOrderDetails'; // 商品查询

var GOODS_LIST = 'purchase.wholesale.queryWholesaleGoodsList'; // 客户信息下拉列表

var CUSTOMER_CODE_LIST = 'scm.wholesale.customerCodePages'; // 客户信息列表

var CUSTOMER_INFO_LIST = 'scm.wholesale.customerPages'; // 客户信息新增/修改

var CUSTOMER_SAVE = 'scm.wholesale.saveOrModifyCustomer'; // 客户信息详情

var CUSTOMER_DETAIL = 'scm.wholesale.customerDetail'; // 批发销售WMS出库/入库流水回传

var SALES_RECEIPT = 'purchase.wholesale.salesIssueReceiptNotice'; // 批发销售订单明细保存

var SALES_SAVE_DETAIL = 'scm.wholesale.saveOrModifyOrderDetail'; // 批发销售订单列表查询

var SALES_INFO_LIST = 'scm.wholesale.orderPages'; // 批发销售订单提交

var SALES_SUBMIT = 'scm.wholesale.submitOrder'; // 批发销售订单撤销

var SALES_CANCEL = 'scm.wholesale.cancelOrder'; // 批发销售订单详情

var SALES_DETAIL = 'scm.wholesale.orderDetail'; // 批发销售订单商品列表

var SALES_DETAIL_LIST = 'scm.wholesale.orderDetailPages'; // 下载模板

var DOWNLOAD_TEMPLATE = 'purchase.downlaod.getTemplate'; // 删除商品

var SALES_DELETE = 'scm.wholesale.removeOrderDetail'; // 批发销售统计

var SALES_DETAIL_LIST_STAT = 'scm.wholesale.statOrder'; // 获取批发销售的价格配置服务

var SALES_PRICE_CONFIG = 'scm.wholesale.orderPriceConfig'; // 合并导出

var SALES_EXPORT_ORDER = 'scm.wholesale.mergeExportOrder'; // 批量发车

var SALES_BATCH_DRIVE = 'scm.wholesale.createTransferOrPurchaseOrder'; // 保存主单

var SALES_SAVE_INFO = 'scm.wholesale.saveOrModifyOrder';
/**
 * 分配单
 */
// 批发销售分配单主单保存接口

var PRE_ORDER_SAVE = 'scm.wholesale.saveOrModifyPreOrder'; // 批发销售分配单详情保存接口

var PRE_ORDER_DETAIL_SAVE = 'scm.wholesale.saveOrModifyPreOrderDetail'; // 批发销售分配单列表查询接口

var PRE_ORDER_LIST = 'scm.wholesale.preOrderPages'; // 批发销售分配单查询主单详情接口

var PRE_ORDER_DETAIL = 'scm.wholesale.preOrderDetail'; // 批发销售单明细列表接口

var PRE_ORDER_DETAIL_LIST = 'scm.wholesale.preOrderDetailList'; // 批发销售单清空

var PRE_CLEAN_DETAIL_LIST = 'scm.wholesale.clearPreOrderDetails'; // 批发销售单提交

var PRE_ORDER_SUBMIT = 'scm.wholesale.submitPreOrder'; // 批发销售单导入

var PRE_IMPORT = 'scm.wholesale.importPreOrderDetails'; // 批发销售分配单作废接口

var PRE_ORDER_CANCEL = 'scm.wholesale.cancelPreOrder'; // 批发分配单明细查询

var PRE_ORDER_DETAIL_STAT = 'scm.wholesale.statPreOrder'; // 批发分配单号获取批发列表

var PRE_SALES_LIST = 'scm.wholesale.orderDetails'; // 批发分配单删除明细

var PRE_ORDER_DELETE = 'scm.wholesale.removePreOrderDetail'; // 批发分配单是否能改价

var PRE_CHANGE_PRICE = 'purchase.require.wholesalePrePriceConfig'; // 批发分配单参考价

var PRE_REFERENCE_PRICE = 'purchase.require.queryWholesalePreReferencePrice';

/***/ }),

/***/ 49518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93224);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46565);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24731);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12569);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71720);







var _excluded = ["formData", "placeId", "afterHandleCallback", "savingRowCallback"];






function GoodsTable(props) {
  var formData = props.formData,
      placeId = props.placeId,
      afterHandleCallback = props.afterHandleCallback,
      savingRowCallback = props.savingRowCallback,
      tableProps = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(props, _excluded);

  var _ref = formData || {},
      preprocessOrderNo = _ref.preprocessOrderNo,
      merchantId = _ref.merchantId;

  var cancelRequest = !merchantId;
  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)(); // 保存

  var saveRowCallback = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().mark(function _callee(data) {
      var currentCell, currentRow, currentRowOldData, id, planQty, goodsId, goodsBarCode, placeCode, customerNo, tradeSpecificationPrice, planPrice, requestObj, res, resData;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currentCell = data.currentCell, currentRow = data.currentRow, currentRowOldData = data.currentRowOldData;
              id = currentRow.id, planQty = currentRow.planQty, goodsId = currentRow.goodsId, goodsBarCode = currentRow.goodsBarCode, placeCode = currentRow.placeCode, customerNo = currentRow.customerNo, tradeSpecificationPrice = currentRow.tradeSpecificationPrice;
              planPrice = currentCell['planPrice']; // 如果编辑的是金额时，则该值存在

              savingRowCallback(true);
              requestObj = {
                id,
                planQty,
                preprocessOrderNo,
                placeCode,
                customerNo,
                goodsId,
                goodsBarCode,
                tradeSpecificationPrice: planPrice ? undefined : tradeSpecificationPrice,
                planPrice: planPrice ? planPrice : undefined,
                isSpecifiedPrice: Number(tradeSpecificationPrice) === 0 || Number(tradeSpecificationPrice) > 0 || Number(planPrice) === 0 || Number(planPrice) > 0 ? 1 : 0 // isSpecifiedPrice： 1-指定价格，0-不指定价格

              };
              _context.next = 7;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_8__/* .PRE_ORDER_DETAIL_SAVE */ .ui, requestObj);

            case 7:
              res = _context.sent;
              savingRowCallback(false);

              if (!res.success) {
                _context.next = 16;
                break;
              }

              resData = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, currentRow), res.result);

              antd_es_message__WEBPACK_IMPORTED_MODULE_10__.default.success('保存成功');

              afterHandleCallback === null || afterHandleCallback === void 0 ? void 0 : afterHandleCallback();
              return _context.abrupt("return", resData);

            case 16:
              return _context.abrupt("return", currentRowOldData);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [preprocessOrderNo, afterHandleCallback, savingRowCallback]); // 获取参考价和库存，并更新列表数据

  var afterTableRequest = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().mark(function _callee2(dataList) {
      var _res$0$result, _res$, _res$1$list, _res$2, _res$2$result;

      var _dataList$reduce, referList, extList, referenceParams, extInfoParams, requestArr, res, referenceList, stockList, allowList, maps, stockMaps, allowMaps;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _dataList$reduce = dataList.reduce((pre, next) => {
                return {
                  referList: pre.referList.concat({
                    placeId: next.placeId,
                    goodsId: next.goodsId,
                    placeCode: next.placeCode
                  }),
                  extList: pre.extList.concat({
                    merchantId,
                    placeId,
                    goodsId: next.goodsId
                  })
                };
              }, {
                referList: [],
                extList: []
              }), referList = _dataList$reduce.referList, extList = _dataList$reduce.extList; // 参考价的请求参数

              referenceParams = {
                merchantId,
                goodsList: referList
              }; // 库存等数据参数

              extInfoParams = {
                needPlaceStock: true,
                param: extList
              }; // 如果当前页面类型是批发销售时，需要额外发送接口请求特定的数据

              requestArr = [(0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_8__/* .PRE_REFERENCE_PRICE */ .UD, referenceParams), dispatch({
                type: 'purchase/queryProductExtInfo',
                payload: extInfoParams
              }), (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_8__/* .PRE_CHANGE_PRICE */ .xx, {
                merchantId,
                placeId: [placeId]
              })];
              _context2.next = 6;
              return Promise.all(requestArr);

            case 6:
              res = _context2.sent;
              // 参考价list
              referenceList = (_res$0$result = (_res$ = res[0]) === null || _res$ === void 0 ? void 0 : _res$.result) !== null && _res$0$result !== void 0 ? _res$0$result : []; // 库存list

              stockList = (_res$1$list = (_res$2 = res[1]) === null || _res$2 === void 0 ? void 0 : _res$2.list) !== null && _res$1$list !== void 0 ? _res$1$list : []; // 能否改价

              allowList = (_res$2$result = res[2].result) !== null && _res$2$result !== void 0 ? _res$2$result : []; // 获取商品编码与参考价的映射

              maps = referenceList.reduce((pre, next) => {
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, pre), {}, {
                  [next.goodsId]: {
                    referencePrice: next.referencePrice
                  }
                });
              }, {}); // 库存等

              stockMaps = stockList.reduce((pre, next) => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, pre), {}, {
                [next.goodsId]: {
                  stock: next.stock
                }
              }), {});
              allowMaps = allowList.reduce((pre, next) => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, pre), {}, {
                [next.placeId]: {
                  allowChangePrice: next.allowChangePrice
                }
              }), {}); // 给「goodsId」对应的数据设置参考价

              return _context2.abrupt("return", dataList.map(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, v), maps[v.goodsId]), stockMaps[v.goodsId]), allowMaps[v.placeId])));

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [dispatch, merchantId, placeId]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .EnhanceTable */ .UO, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({
    cancelRequest: cancelRequest
  }, tableProps, {
    searchParams: (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => ({
      preprocessOrderNo
    }), [preprocessOrderNo]),
    saveRowCallback: saveRowCallback,
    afterRequest: afterTableRequest,
    pageSize: 30,
    scroll: {
      y: 500
    }
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)( /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(GoodsTable)));

/***/ }),

/***/ 54535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_space_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49111);
/* harmony import */ var antd_es_space__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19650);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40847);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46565);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12569);










function Statistics(props) {
  var _statistics$totalFrei;

  var statisticsRef = props.statisticsRef,
      preprocessOrderNo = props.preprocessOrderNo; // 汇总信息

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState, 2),
      statistics = _useState2[0],
      setStatistics = _useState2[1]; // 获取商品总金额和总数量


  var queryStatData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee() {
    var res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (preprocessOrderNo) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.next = 4;
            return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .YpRequest */ .XQ)(_Api__WEBPACK_IMPORTED_MODULE_6__/* .PRE_ORDER_DETAIL_STAT */ .$E, {
              preprocessOrderNo
            });

          case 4:
            res = _context.sent;
            setStatistics(res.result);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [preprocessOrderNo]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    queryStatData();
  }, [queryStatData]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (statisticsRef) {
      // @ts-ignore
      statisticsRef.current = {
        queryStatData,
        statistics
      };
    }
  }, [queryStatData, statistics, statisticsRef]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "alignRight mBottom16"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_space__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, {
    style: {
      color: '#1890ff'
    }
  }), '  ', "\u79CD\u7C7B\uFF1A", (statistics === null || statistics === void 0 ? void 0 : statistics.skuTypeQty) || '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, "\u603B\u6570\u91CF\uFF1A", (statistics === null || statistics === void 0 ? void 0 : statistics.skuTotalCopies) || '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, "\u603B\u4EF7\uFF1A", (statistics === null || statistics === void 0 ? void 0 : statistics.skuTotalAmount) || '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, "\u603B\u52A0\u70B9\u91D1\u989D\uFF1A", (_statistics$totalFrei = statistics === null || statistics === void 0 ? void 0 : statistics.totalFreight) !== null && _statistics$totalFrei !== void 0 ? _statistics$totalFrei : '-', "\u5143")));
}

/* harmony default export */ __webpack_exports__["default"] = (Statistics);

/***/ }),

/***/ 23976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(91896);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8870);
/* harmony import */ var antd_es_tag_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71153);
/* harmony import */ var antd_es_tag__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(60331);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46565);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7704);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96534);
/* harmony import */ var _GoodsTable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63553);










/**
 * 商家商品
 */





var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 10
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 14
    }
  }
};

function GoodsEditableModal(props) {
  var allowChangePrice = props.allowChangePrice,
      formData = props.formData,
      billType = props.billType;
  var placeId = formData.placeId,
      merchantId = formData.merchantId,
      firstCategoryId = formData.firstCategoryId,
      secondCategoryId = formData.secondCategoryId; // 默认查询参数

  var defaultSearchParams = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => ({
    billType,
    condition: {
      merchantId,
      placeId,
      firstCategoryId,
      secondCategoryId
    }
  }), [billType, firstCategoryId, merchantId, placeId, secondCategoryId]);

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(5),
      mappingList = _useMapping.mappingList;

  var tableRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(defaultSearchParams),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState, 2),
      searchParams = _useState2[0],
      setSearchParams = _useState2[1]; //  正在保存


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState3, 2),
      isSaving = _useState4[0],
      setIsSaving = _useState4[1];

  var secondId = isNaN(+secondCategoryId) ? undefined : +secondCategoryId;
  var formfields = [{
    label: '商品模糊',
    name: 'queryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '商品精准',
    name: 'accurateQueryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '商品品类',
    name: 'secondCategoryId',
    type: 'SELECT',
    dataList: mappingList.get(5),
    initialValue: secondId === 0 || !secondId ? undefined : secondId,
    fieldOptions: {
      disabled: !!secondId
    }
  }, {
    label: '品牌名称',
    name: 'brandName',
    type: 'INPUT'
  }];
  var columns = [{
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 170,
    fixed: true
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 90
  }, {
    title: '商品条码',
    dataIndex: 'goodsBarCode',
    key: 'goodsBarCode',
    width: 140
  }, {
    title: '二类类目',
    dataIndex: 'secondCategoryName',
    key: 'secondCategoryName',
    width: 100
  }, {
    title: '品牌名称',
    dataIndex: 'brandName',
    key: 'brandName',
    width: 110
  }, {
    title: '单位',
    dataIndex: 'specUnit',
    key: 'specUnit',
    align: 'right',
    width: 90
  }, {
    title: '数量',
    dataIndex: 'goodsCopies',
    key: 'goodsCopies',
    width: 150,
    type: 'INPUT',
    fieldOptions: r => {
      // 非称重商品为正整数，称重商品保留三位小数
      var isWeight = r.isWeigh === 1;
      return {
        formatter: value => isWeight ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_6__/* .exchageToNum3 */ .hY)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_6__/* .exchageToNum1 */ .Ly)(value)
      };
    },
    render: (t, r) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
        style: {
          flex: 1
        }
      }, t), r.barCodeUnit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "/", r.barCodeUnit));
    }
  }, {
    title: '参考价',
    dataIndex: 'costPrice',
    key: 'costPrice',
    width: 110,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " \u5143").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '批发单价(含税)',
    dataIndex: 'unitPrice',
    key: 'unitPrice',
    width: 160,
    type: allowChangePrice ? 'INPUT' : undefined,
    render: (t, r) => {
      var extraMsg = +t < +r.costPrice ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tag__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, {
        color: "red"
      }, "\u6279\u53D1\u4EF7\u5C0F\u4E8E\u6210\u672C\u4EF7") : null;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start'
        }
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
        style: {
          flex: 1
        }
      }, t), r.basicUnit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "\u5143/", r.basicUnit)), extraMsg);
    }
  }, {
    title: '批发总金额(含税)',
    dataIndex: 'planAmount',
    key: 'planAmount',
    width: 170,
    type: allowChangePrice ? 'INPUT' : undefined,
    fieldOptions: {
      formatter: _utils_common__WEBPACK_IMPORTED_MODULE_6__/* .exchageToNum3 */ .hY
    }
  }, {
    title: '库存量',
    dataIndex: 'stock',
    key: 'stock',
    width: 110,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " ").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '规格描述',
    dataIndex: 'specDesc',
    key: 'specDesc',
    align: 'right',
    width: 90,
    render: t => t || '-'
  }];
  var searchHandler = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(values => {
    setSearchParams(v => {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)({}, v), {}, {
        condition: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)({}, v.condition), values)
      });
    });
  }, []);
  var resetFields = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    setSearchParams(defaultSearchParams);
  }, [defaultSearchParams]); // 是否正在保存

  var savingTableCallback = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(bool => {
    setIsSaving(bool);
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z, {
    title: "\u5546\u54C1\u9009\u62E9",
    destroyOnClose: true,
    maskClosable: false,
    width: 1200,
    visible: true,
    closable: false,
    onCancel: props.closeModalCallback,
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
      key: "back",
      disabled: isSaving,
      onClick: props.closeModalCallback
    }, "\u5173\u95ED")]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .FormBuilder */ .qu, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, defaultFormItemLayout, {
    elements: formfields,
    onSearch: searchHandler,
    onReset: resetFields
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_GoodsTable__WEBPACK_IMPORTED_MODULE_7__.default, {
    tableRef: tableRef,
    formData: formData,
    allowChangePrice: allowChangePrice,
    searchParams: searchParams,
    columns: columns,
    requestUrl: "purchase.product.querySelectPlaceProductByCondition",
    savingTableCallback: savingTableCallback,
    scroll: {
      y: 500
    }
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (GoodsEditableModal);

/***/ }),

/***/ 63553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91896);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93224);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71720);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46565);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12569);







var _excluded = ["formData", "allowChangePrice", "savingTableCallback", "afterHandleCallback"];

/**
 * 商品可编辑表格-采购单-调拨单-批发销售
 */





function GoodsTable(props) {
  var formData = props.formData,
      allowChangePrice = props.allowChangePrice,
      savingTableCallback = props.savingTableCallback,
      afterHandleCallback = props.afterHandleCallback,
      restProps = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(props, _excluded);

  var _ref = formData || {},
      placeId = _ref.placeId,
      merchantId = _ref.merchantId,
      placeCode = _ref.placeCode;

  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)(); // 获取参考价的请求参数

  var getReferencePrice = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(dataList => {
    // 拼接获取参考价的参数
    var params = {
      merchantId,
      placeId,
      placeCode,
      goodsIds: dataList.map(v => +v.goodsId)
    };
    return params;
  }, [merchantId, placeCode, placeId]); // 库存等数据的请求参数

  var getExtInfoParams = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(dataList => {
    // 批发销售库存等数据的请求参数
    return {
      needPlaceStock: true,
      param: dataList.map(v => ({
        merchantId: +merchantId,
        placeId: +placeId,
        goodsId: +v.goodsId
      }))
    };
  }, [merchantId, placeId]); // 获取参考价

  var queryReferencePrice = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().mark(function _callee(dataList) {
      var _res$0$result$list, _res$, _res$$result, _res$1$list, _res$2;

      var referenceParams, extInfoParams, requestArr, res, referenceList, stockList, maps, stockMaps;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 参考价的请求参数
              referenceParams = getReferencePrice(dataList); // 库存等数据参数

              extInfoParams = getExtInfoParams(dataList); // 如果当前页面类型是批发销售时，需要额外发送接口请求特定的数据

              requestArr = [dispatch({
                type: 'purchase/queryWholesaleReferencePrice',
                payload: referenceParams
              }), dispatch({
                type: 'purchase/queryProductExtInfo',
                payload: extInfoParams
              })];
              _context.next = 5;
              return Promise.all(requestArr);

            case 5:
              res = _context.sent;
              // 参考价list
              referenceList = (_res$0$result$list = (_res$ = res[0]) === null || _res$ === void 0 ? void 0 : (_res$$result = _res$.result) === null || _res$$result === void 0 ? void 0 : _res$$result.list) !== null && _res$0$result$list !== void 0 ? _res$0$result$list : []; // 库存list

              stockList = (_res$1$list = (_res$2 = res[1]) === null || _res$2 === void 0 ? void 0 : _res$2.list) !== null && _res$1$list !== void 0 ? _res$1$list : []; // 获取商品编码与参考价的映射

              maps = referenceList === null || referenceList === void 0 ? void 0 : referenceList.reduce((pre, next) => {
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({}, pre), {}, {
                  [next.goodsId]: {
                    costPrice: next.referencePrice
                  }
                });
              }, {}); // 库存等

              stockMaps = stockList === null || stockList === void 0 ? void 0 : stockList.reduce((pre, next) => {
                pre[next.goodsId] = {
                  stock: next.stock,
                  dcStock: next.dcStock
                };
                return pre;
              }, {}); // 给「goodsId」对应的数据设置参考价

              return _context.abrupt("return", dataList.map(v => {
                return maps[v.goodsId] ? (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({}, v), maps[v.goodsId]), stockMaps[v.goodsId]) : v;
              }));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [getReferencePrice, getExtInfoParams, dispatch]); // 保存行

  var saveRowCallback = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().mark(function _callee2(data) {
      var currentCell, currentRow, currentRowOldData, planAmount, requestObj, params, res, _res$result, _res$result$orderDeta, orderDetailVo, success;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currentCell = data.currentCell, currentRow = data.currentRow, currentRowOldData = data.currentRowOldData;
              planAmount = currentCell['planAmount']; // 当前编辑是计划商品金额时，

              requestObj = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({}, currentRow), {}, {
                planAmount: planAmount ? currentRow.planAmount : currentRow.unitPrice ? undefined : currentRow.planAmount,
                // 编辑的不是金额时，不传金额
                unitPrice: planAmount ? undefined : currentRow.unitPrice // 编辑的是金额的时候，批发价不传值

              }); // 不允许改价的时候，金额和批发单价都不传

              if (!allowChangePrice) {
                requestObj = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({}, requestObj), {}, {
                  planAmount: undefined,
                  unitPrice: undefined
                });
              }

              params = {
                wholesaleOrderNo: formData === null || formData === void 0 ? void 0 : formData.wholesaleOrderNo,
                id: requestObj.id,
                goodsId: requestObj.goodsId,
                goodsBarCode: requestObj.goodsBarCode,
                goodsName: requestObj.goodsName,
                unitPrice: requestObj.unitPrice,
                goodsCopies: requestObj.goodsCopies,
                planAmount: requestObj.planAmount,
                isSpecifiedPrice: !!requestObj.planAmount || !!requestObj.unitPrice ? 1 : 2 // 单价或者金额有值时传1

              };
              savingTableCallback(true);
              _context2.next = 8;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .YpRequest */ .XQ)(_Api__WEBPACK_IMPORTED_MODULE_8__/* .SALES_SAVE_DETAIL */ .gU, params);

            case 8:
              res = _context2.sent;
              savingTableCallback(false);
              _res$result = res.result, _res$result$orderDeta = _res$result.orderDetailVo, orderDetailVo = _res$result$orderDeta === void 0 ? {} : _res$result$orderDeta, success = _res$result.success;

              if (success) {
                _context2.next = 15;
                break;
              }

              return _context2.abrupt("return", currentRowOldData);

            case 15:
              antd_es_message__WEBPACK_IMPORTED_MODULE_9__.default.success('保存成功');

              afterHandleCallback === null || afterHandleCallback === void 0 ? void 0 : afterHandleCallback();
              return _context2.abrupt("return", (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({}, currentRow), orderDetailVo));

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [afterHandleCallback, allowChangePrice, formData === null || formData === void 0 ? void 0 : formData.wholesaleOrderNo, savingTableCallback]);
  /**
   * 请求列表数据成功后对数据进行操作
   */

  var setTableDataAfterRequest = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().mark(function _callee3(dataList) {
      var dataSource;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return queryReferencePrice(dataList);

            case 2:
              dataSource = _context3.sent;
              return _context3.abrupt("return", dataSource);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }(), [queryReferencePrice]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .EnhanceTable */ .UO, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)({}, restProps, {
    pageSize: 100,
    saveRowCallback: saveRowCallback,
    afterRequest: setTableDataAfterRequest,
    scroll: {
      y: 500
    }
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (GoodsTable);

/***/ }),

/***/ 98108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_space_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49111);
/* harmony import */ var antd_es_space__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19650);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40847);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46565);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12569);










function Statistics(props) {
  var statisticsRef = props.statisticsRef,
      wholesaleOrderNo = props.wholesaleOrderNo; // 汇总信息

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState, 2),
      statistics = _useState2[0],
      setStatistics = _useState2[1]; // 统计信息


  var queryStatData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee() {
    var res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (wholesaleOrderNo) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.next = 4;
            return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .YpRequest */ .XQ)(_Api__WEBPACK_IMPORTED_MODULE_6__/* .SALES_DETAIL_LIST_STAT */ .T2, {
              wholesaleOrderNo
            });

          case 4:
            res = _context.sent;

            if (res.success) {
              setStatistics(res.result.statOrderVo);
            }

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [wholesaleOrderNo]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    queryStatData();
  }, [queryStatData]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (statisticsRef) {
      // @ts-ignore
      statisticsRef.current = {
        queryStatData,
        statistics
      };
    }
  }, [queryStatData, statistics, statisticsRef]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "alignRight mBottom16"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_space__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, {
    style: {
      color: '#1890ff'
    }
  }), '  ', "\u79CD\u7C7B\uFF1A", (statistics === null || statistics === void 0 ? void 0 : statistics.totalGoods) || '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, "\u603B\u91CF\uFF1A", (statistics === null || statistics === void 0 ? void 0 : statistics.totalPlanQty) || '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, "\u5546\u54C1\u603B\u4EF7\uFF1A", (statistics === null || statistics === void 0 ? void 0 : statistics.totalPlanPrice) || '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, "\u603B\u52A0\u70B9\uFF1A", (statistics === null || statistics === void 0 ? void 0 : statistics.totalPlanFreight) || '-', "\u5143")));
}

/* harmony default export */ __webpack_exports__["default"] = (Statistics);

/***/ }),

/***/ 65349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ wholesaleCustomerObj; }
/* harmony export */ });
// 字段名对应的映射
var wholesaleCustomerObj = {
  customerType: 27,
  status: 42,
  type: 29,
  settlementType: 28
};

/***/ }),

/***/ 76384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ wholesaleOrderObj; },
/* harmony export */   "h": function() { return /* binding */ exportUnHandleStatusMap; }
/* harmony export */ });
// 字段名对应的映射
var wholesaleOrderObj = {
  orderType: 32,
  deliverType: 31,
  orderSource: 30,
  payType: 33,
  status: 26,
  fakePlaceName: 3,
  // 故意设置假的配置
  type: 29,
  preStatus: 58,
  // 批发分配单状态
  merchantId: 40 // 权限下的商家

}; // 这些状态的无法合并导出

var exportUnHandleStatusMap = [1, 2, 9];

/***/ }),

/***/ 8776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "is": function() { return /* binding */ freshActivityItemUpload; },
/* harmony export */   "YE": function() { return /* binding */ CategoryTree; },
/* harmony export */   "cu": function() { return /* binding */ MemberDayActivityService; },
/* harmony export */   "o6": function() { return /* binding */ ImportPoll; },
/* harmony export */   "fO": function() { return /* binding */ queryThemeInfo_API; }
/* harmony export */ });
/* unused harmony export BatchMendianService */
/**
 * 调拨单主信息查询接口
 */
var freshActivityItemUpload = 'mms.importTask.addAsyncImportTask'; // 类目查询接口

var CategoryTree = 'mms.coupon.getBackCategoryTree'; //会员全场折扣88折导入接口

var MemberDayActivityService = 'mms.MemberDayActivityService.importMemberDay'; //门店批量导入接口

var BatchMendianService = 'mms.MemberDayActivityService.importMemberDayStore'; // 导入数据轮询接口

var ImportPoll = 'mms.importTask.getLastImportResult';
/** 活动列表查询营销主题信息 */

var queryThemeInfo_API = 'mms.ThemeService.queryThemeInfo';

/***/ }),

/***/ 23685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SelectShop; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/form/style/index.js
var form_style = __webpack_require__(9715);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 12 modules
var es_form = __webpack_require__(35845);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/style/index.js
var radio_style = __webpack_require__(88983);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js
var es_radio = __webpack_require__(55742);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/style/index.js
var modal_style = __webpack_require__(71194);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(57016);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlusOutlined.js + 1 modules
var PlusOutlined = __webpack_require__(49101);
// EXTERNAL MODULE: ./node_modules/antd/es/tabs/style/index.js
var tabs_style = __webpack_require__(18106);
// EXTERNAL MODULE: ./node_modules/antd/es/tabs/index.js + 32 modules
var tabs = __webpack_require__(69584);
// EXTERNAL MODULE: ./node_modules/antd/es/transfer/style/index.js
var transfer_style = __webpack_require__(58996);
// EXTERNAL MODULE: ./node_modules/antd/es/transfer/index.js + 5 modules
var transfer = __webpack_require__(77933);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/index.js
var message_style = __webpack_require__(34792);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(48086);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
// EXTERNAL MODULE: ./src/config/api.ts
var api = __webpack_require__(15910);
// EXTERNAL MODULE: ./node_modules/antd/es/select/style/index.js
var select_style = __webpack_require__(43358);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js
var es_select = __webpack_require__(34041);
;// CONCATENATED MODULE: ./src/pages/Promotion/StoreCoupon/components/ShopSearch.tsx










var joinTypeMap = {
  1: '加盟',
  2: '自营'
};
var joinTypeList = [{
  label: '全部',
  value: 0
}, {
  label: '加盟',
  value: 1
}, {
  label: '自营',
  value: 2
}];
function ShopSearch(_ref) {
  var onChange = _ref.onChange,
      operationGroupIds = _ref.operationGroupIds;

  var _Form$useForm = es_form/* default.useForm */.Z.useForm(),
      _Form$useForm2 = (0,slicedToArray/* default */.Z)(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _React$useState = react.useState([]),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      shopGroupList = _React$useState2[0],
      setShopGroupList = _React$useState2[1];

  var handleValuesChange = react.useCallback((_, _ref2) => {
    var joinType = _ref2.joinType,
        shopGroupId = _ref2.shopGroupId;
    onChange({
      joinType: joinType === 0 ? undefined : joinType,
      shopGroupId
    });
  }, []);
  react.useEffect(() => {
    (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
      var res, entityGroupMap, keys, list;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,ypRequest/* default */.Z)(api/* queryGroupByOperationGroupIdsAndType */.P5, {
                ids: operationGroupIds,
                type: 1
              });

            case 2:
              res = _context.sent;

              if (res.success) {
                entityGroupMap = res.result.entityGroupMap;
                keys = Object.keys(entityGroupMap);
                list = [];

                if (keys.length) {
                  keys.forEach(key => {
                    list.push({
                      label: entityGroupMap[key].name,
                      value: entityGroupMap[key].id
                    });
                  });
                }

                setShopGroupList(list);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, []);
  return /*#__PURE__*/react.createElement(es_form/* default */.Z, {
    form: form,
    layout: "inline",
    initialValues: {
      joinType: 0,
      shopGroupId: undefined
    },
    onValuesChange: handleValuesChange
  }, /*#__PURE__*/react.createElement(es_form/* default.Item */.Z.Item, {
    label: "\u95E8\u5E97\u7C7B\u578B",
    name: "joinType"
  }, /*#__PURE__*/react.createElement(es_select/* default */.Z, {
    options: joinTypeList,
    style: {
      width: 200
    }
  })), /*#__PURE__*/react.createElement(es_form/* default.Item */.Z.Item, {
    label: "\u95E8\u5E97\u7EC4",
    name: "shopGroupId"
  }, /*#__PURE__*/react.createElement(es_select/* default */.Z, {
    mode: "multiple",
    maxTagCount: 2,
    showSearch: false,
    options: shopGroupList,
    style: {
      width: 300
    }
  })));
}
// EXTERNAL MODULE: ./src/pages/Promotion/StoreCoupon/components/ShopImport.tsx + 1 modules
var ShopImport = __webpack_require__(77444);
;// CONCATENATED MODULE: ./src/pages/Promotion/StoreCoupon/components/storeSelect.tsx


















var StoreSelector = props => {
  var params = props.params;
  var allShopMapRef = react.useRef({});

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      shopList = _useState2[0],
      setShopList = _useState2[1]; // 左侧门店列表


  var _useState3 = (0,react.useState)(props.selected),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      selectedTemp = _useState4[0],
      setSelectedTemp = _useState4[1]; // 选择的门店缓存


  var _React$useState = react.useState({}),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      shopParams = _React$useState2[0],
      setShopParams = _React$useState2[1];

  (0,react.useEffect)(() => {
    queryData(shopParams);
  }, [shopParams]);

  var queryData = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(_params) {
      var _yield$ypRequest, success, _yield$ypRequest$resu, result, _result, shopMap, _seleted, _shops;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!params.operationGroupIds || params.operationGroupIds.length === 0)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", message.default.error('请先选择运营组'));

            case 2:
              _context.next = 4;
              return (0,ypRequest/* default */.Z)(props.type === 'marketing' ? api/* queryStoreByCondition */.gg : api/* posListShopByCondition */.a, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _params), {}, {
                operationGroupId: params.operationGroupIds
              }));

            case 4:
              _yield$ypRequest = _context.sent;
              success = _yield$ypRequest.success;
              _yield$ypRequest$resu = _yield$ypRequest.result;
              result = _yield$ypRequest$resu === void 0 ? [] : _yield$ypRequest$resu;

              if (success) {
                _result = props.type === 'marketing' ? result : result.list;
                shopMap = {};
                _seleted = [];
                _shops = [];

                _result.forEach(item => {
                  item.merchantId = item.id;
                  item.merchantName = item.name;
                  shopMap[item.merchantId] = item;

                  _shops.push(item);
                });

                if (_params.joinType === undefined && _params.shopGroupId === undefined) {
                  allShopMapRef.current = shopMap;
                }

                if (selectedTemp.length) {
                  selectedTemp.forEach(item => {
                    var key = typeof item === 'string' ? item : item.merchantId;

                    if (allShopMapRef.current[key]) {
                      _seleted.push(allShopMapRef.current[key]);

                      if (!shopMap[key]) {
                        _shops.push(allShopMapRef.current[key]);
                      }
                    }
                  });
                }

                setSelectedTemp(_seleted);
                setShopList(_shops);
              }

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function queryData(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handelTransfer = (targetKeys, direction, moveKeys) => {
    if (direction === 'right') {
      var list = [];
      shopList.map(item => {
        if (moveKeys.indexOf(item.merchantId) > -1) {
          list.push(item);
        }
      });
      setSelectedTemp([...selectedTemp, ...list]);
    }

    if (direction === 'left') {
      var _list = selectedTemp.filter(item => {
        var key = typeof item === 'string' ? item : item.merchantId;
        return moveKeys.indexOf(key) === -1; // 筛选出不在本次操作列表中的门店
      });

      setSelectedTemp(_list);
    }
  };

  var filterOption = (inputValue, option) => {
    return option.merchantName.indexOf(inputValue) > -1;
  };

  var modalOk = () => {
    var _props$params;

    if (!selectedTemp || selectedTemp.length === 0) {
      message.default.warn('请先选择门店');

      return false;
    }

    if (props !== null && props !== void 0 && (_props$params = props.params) !== null && _props$params !== void 0 && _props$params.operationGroupIds) {
      var cachedMap = JSON.parse(sessionStorage.getItem('CAHCED_OPERATIONGROUP_MAP') || '{}');
      var map = new Map(props.params.operationGroupIds.map(id => [id, cachedMap[id]]));
      selectedTemp.forEach(shop => {
        if (map.has(shop.operationGroupId)) {
          map.delete(shop.operationGroupId);
        }
      });

      if (map.size) {
        message.default.warn("".concat([...map.values()].join('、'), "\u672A\u9009\u62E9\u95E8\u5E97\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9\u95E8\u5E97\uFF01"));

        return;
      }
    }

    props.modalOk && props.modalOk(selectedTemp);
  };

  var modalCancel = () => {
    props.modalCancel && props.modalCancel();
  };

  return /*#__PURE__*/react.createElement(modal/* default */.Z, {
    width: 800,
    okText: "\u786E\u5B9A",
    visible: true,
    onOk: modalOk,
    onCancel: modalCancel
  }, /*#__PURE__*/react.createElement(tabs/* default */.Z, {
    defaultActiveKey: "1"
  }, /*#__PURE__*/react.createElement(tabs/* default.TabPane */.Z.TabPane, {
    tab: "\u9009\u62E9\u95E8\u5E97",
    key: "1"
  }, /*#__PURE__*/react.createElement(ShopSearch, {
    onChange: setShopParams,
    operationGroupIds: params.operationGroupIds
  }), /*#__PURE__*/react.createElement(transfer/* default */.Z, {
    showSearch: true,
    listStyle: {
      width: 350,
      height: 400
    },
    style: {
      marginTop: 20,
      justifyContent: 'space-between'
    },
    filterOption: filterOption,
    titles: ['可选门店', '已选门店'],
    rowKey: record => record.merchantId,
    dataSource: shopList,
    targetKeys: selectedTemp.map(item => typeof item === 'string' ? item : item.merchantId),
    onChange: handelTransfer,
    render: _ref2 => {
      var merchantName = _ref2.merchantName,
          joinType = _ref2.joinType;
      return /*#__PURE__*/react.createElement("div", {
        className: "merchant-flex"
      }, /*#__PURE__*/react.createElement("div", {
        className: "merchant-ellipsis"
      }, merchantName), /*#__PURE__*/react.createElement("div", {
        className: "merchant-jointype"
      }, joinTypeMap[joinType], "\u5E97"));
    }
  })), /*#__PURE__*/react.createElement(tabs/* default.TabPane */.Z.TabPane, {
    tab: "\u6279\u91CF\u5BFC\u5165",
    key: "2"
  }, /*#__PURE__*/react.createElement(ShopImport/* default */.Z, {
    onChange: setSelectedTemp,
    operationGroupIds: params.operationGroupIds,
    type: props.type
  }))));
};

/* harmony default export */ var storeSelect = (StoreSelector);
// EXTERNAL MODULE: ./src/pages/Promotion/StoreCoupon/components/ShopTable.tsx
var ShopTable = __webpack_require__(18166);
;// CONCATENATED MODULE: ./src/pages/Promotion/StoreCoupon/components/SelectShop.tsx













function SelectShop(_ref) {
  var disabled = _ref.disabled,
      areaName = _ref.areaName,
      isAllShop = _ref.isAllShop,
      setIsAllShop = _ref.setIsAllShop,
      _ref$goods = _ref.goods,
      goods = _ref$goods === void 0 ? [] : _ref$goods,
      setGoods = _ref.setGoods,
      _ref$selectedShops = _ref.selectedShops,
      selectedShops = _ref$selectedShops === void 0 ? [] : _ref$selectedShops,
      setSelectedShops = _ref.setSelectedShops,
      operationGroupIds = _ref.operationGroupIds,
      form = _ref.form,
      _ref$shopIds = _ref.shopIds,
      shopIds = _ref$shopIds === void 0 ? [] : _ref$shopIds,
      setCategorys = _ref.setCategorys,
      status = _ref.status,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'marketing' : _ref$type,
      _ref$noAllShop = _ref.noAllShop,
      noAllShop = _ref$noAllShop === void 0 ? false : _ref$noAllShop,
      mode = _ref.mode;

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      showShopSelector = _React$useState2[0],
      setShowShopSelector = _React$useState2[1];

  var handleFormChange = react.useCallback(isAllShop => {
    var _form$setFieldsValue, _form$current, _form$current$setFiel;

    form === null || form === void 0 ? void 0 : (_form$setFieldsValue = form.setFieldsValue) === null || _form$setFieldsValue === void 0 ? void 0 : _form$setFieldsValue.call(form, {
      isAllShop
    });
    form === null || form === void 0 ? void 0 : (_form$current = form.current) === null || _form$current === void 0 ? void 0 : (_form$current$setFiel = _form$current.setFieldsValue) === null || _form$current$setFiel === void 0 ? void 0 : _form$current$setFiel.call(_form$current, {
      isAllShop
    });
  }, []);

  var onIsAllShopChange = e => {
    var targetValue = e.target.value;

    if (!targetValue && (goods === null || goods === void 0 ? void 0 : goods.length) > 0 && status != 1) {
      modal/* default.confirm */.Z.confirm({
        title: targetValue ? "\u9009\u62E9\u5168\u90E8".concat(areaName, "\uFF1F") : '自选发放范围？',
        content: '重新选择发放范围已添加的商品会被清空',
        cancelText: '取消',
        okText: '确认',
        onOk: () => {
          setIsAllShop(targetValue);
          setGoods([]);
        },

        onCancel() {
          setIsAllShop(!targetValue);
          handleFormChange(!targetValue);
        }

      });
    } else {
      setIsAllShop(targetValue);
    }
  };

  var addShop = () => {
    if (shopIds && shopIds.length > 0 && goods.length > 0 && status != 1 && mode !== 'copy') {
      modal/* default.confirm */.Z.confirm({
        title: "\u4FEE\u6539".concat(areaName),
        content: "\u4FEE\u6539".concat(areaName, "\uFF0C\u6307\u5B9A\u5546\u54C1\u9700\u8981\u91CD\u65B0\u914D\u7F6E"),
        cancelText: '取消',
        okText: '确认',
        onOk: () => {
          setShowShopSelector(true);
        },

        onCancel() {}

      });
    } else {
      setShowShopSelector(true);
    }
  };

  var shopModalOk = function shopModalOk() {
    var selectedTemp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var _selectedTemp = selectedTemp.map(_each => ({
      id: _each.merchantId,
      fullName: _each.merchantName,
      operationGroupId: _each.operationGroupId,
      operationGroupName: _each.merchantName
    }));

    if (mode !== 'copy') {
      setGoods([]);
    }

    setSelectedShops(_selectedTemp, []);
    setShowShopSelector(false);

    if (status != 1) {
      setCategorys === null || setCategorys === void 0 ? void 0 : setCategorys([]);
    }
  };

  react.useEffect(() => {
    handleFormChange(isAllShop);
  }, [isAllShop]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(es_form/* default.Item */.Z.Item, {
    noStyle: true,
    name: "isAllShop",
    rules: [{
      required: true,
      message: '请选择发放范围'
    }]
  }, /*#__PURE__*/react.createElement(es_radio/* default.Group */.ZP.Group, {
    disabled: disabled,
    onChange: onIsAllShopChange
  }, noAllShop ? null : /*#__PURE__*/react.createElement(es_radio/* default */.ZP, {
    value: true,
    key: "0"
  }, "\u5168\u90E8", areaName), /*#__PURE__*/react.createElement(es_radio/* default */.ZP, {
    value: false,
    key: "1"
  }, "\u81EA\u9009", areaName))), isAllShop === false && /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    type: "link",
    onClick: addShop,
    disabled: disabled
  }, /*#__PURE__*/react.createElement(PlusOutlined/* default */.Z, null), selectedShops.length > 0 ? '修改' : '添加', areaName), isAllShop === false && selectedShops.length > 0 && /*#__PURE__*/react.createElement(ShopTable/* default */.Z, {
    selectedShops: selectedShops,
    operationGroupIds: operationGroupIds,
    type: type
  }), showShopSelector ? /*#__PURE__*/react.createElement(storeSelect, {
    modalOk: shopModalOk,
    params: {
      operationGroupId: undefined,
      operationGroupIds
    },
    modalCancel: () => {
      setShowShopSelector(false);
    },
    selected: selectedShops.map(each => ({
      merchantId: each.id,
      merchantName: each.fullName
    })),
    type: type
  }) : null);
}

/***/ }),

/***/ 77444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ShopImport; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/style/index.js
var spin_style = __webpack_require__(20228);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js
var spin = __webpack_require__(11382);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CloudUploadOutlined.js + 1 modules
var CloudUploadOutlined = __webpack_require__(43837);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CheckCircleOutlined.js + 1 modules
var CheckCircleOutlined = __webpack_require__(15873);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/ExclamationCircleOutlined.js + 1 modules
var ExclamationCircleOutlined = __webpack_require__(83987);
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
// EXTERNAL MODULE: ./src/config/api.ts
var api = __webpack_require__(15910);
// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.less
var button_style = __webpack_require__(9683);
// EXTERNAL MODULE: ./node_modules/antd/es/upload/index.js + 12 modules
var upload = __webpack_require__(3388);
// EXTERNAL MODULE: ./node_modules/antd/es/upload/style/index.less
var upload_style = __webpack_require__(63252);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(48086);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/index.less
var message_style = __webpack_require__(79186);
;// CONCATENATED MODULE: ./src/pages/Promotion/StoreCoupon/components/ExcelUpload.tsx














var ExcelUpload = props => {
  var _useState = (0,react.useState)(),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      uploadToken = _useState2[0],
      setUploadToken = _useState2[1];

  var _useState3 = (0,react.useState)(),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      endpoint = _useState4[0],
      setEndpoint = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      fileList = _useState6[0],
      setFileList = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var defaultProps = {
    maxCount: 1,
    type: 'line',
    accept: '.xls,.xlsx',
    name: 'files',
    action: endpoint,
    data: uploadToken,
    disabled: false,
    listType: 'text',
    preview: file => handlePreview(file),
    beforeUpload: file => _beforeUpload(file),
    onRemove: file => handleRemove(file),
    fileList: fileList,

    onChange(info) {
      if (info.file.status === 'done') {
        setLoading(false);
        var _info$file = info.file,
            uid = _info$file.uid,
            response = _info$file.response,
            name = _info$file.name,
            _resId = _info$file.resId;

        if (response && response.code === 200) {
          message.default.success("".concat(name, " \u4E0A\u4F20\u6210\u529F"));
          setFileList([info.file]);
          props.callBack && props.callBack(_resId, response === null || response === void 0 ? void 0 : response.message);
        } else {
          message.default.error("".concat(info.file.name, " \u4E0A\u4F20\u5931\u8D25 ").concat(info.file.response.msg || ''));
        }
      } else if (info.file.status === 'error') {
        setLoading(false);
        message.default.error("".concat(info.file.name, " \u4E0A\u4F20\u5931\u8D25"));
      } else {
        setFileList(info === null || info === void 0 ? void 0 : info.fileList);
      }
    },

    progress: {
      strokeColor: {
        '0%': '#A14EFF',
        '100%': '#A14EFF'
      },
      strokeWidth: 3,
      format: percent => "".concat(parseFloat(percent.toFixed(2)), "%")
    }
  };

  var _beforeUpload = file => {
    if (loading) {
      return false;
    }

    var isLt10M = file.size / 1024 / 1024 < 10;

    if (!isLt10M) {
      message.default.error('上传文件需小于10MB');
    }

    return new Promise((resolve, reject) => {
      var _params = {
        description: '营销中心表格上传',
        bizType: 1,
        fileName: file === null || file === void 0 ? void 0 : file.name
      };
      isLt10M ? resolve(getResourceToken(_params, file)) : reject();
    }); // return isLt2M
  };

  var handleRemove = file => {
    var convertedFile = fileList.filter(each => file.uid !== each.uid);
    setFileList(convertedFile);
  };

  var handlePreview = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(file) {
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('handlePreview:file>>', file);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handlePreview(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var getResourceToken = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(args, file) {
      var res, success, result, errorCode, errorMessage, params, endPoint, _resId2, type, _endpoint;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              _context2.prev = 1;
              _context2.next = 4;
              return (0,ypRequest/* default */.Z)(props.type === 'marketing' ? api/* upload_token */.V$ : api/* pos_upload_token */.mV, args);

            case 4:
              res = _context2.sent;
              success = res.success, result = res.result, errorCode = res.errorCode, errorMessage = res.errorMessage;

              if (success) {
                params = result.params, endPoint = result.endPoint, _resId2 = result.resId, type = result.type, _endpoint = result.endpoint;
                file.resId = _resId2;

                if (params) {
                  setUploadToken(params);
                  setEndpoint(endPoint || _endpoint);
                } else {
                  setLoading(false);
                }
              } else {
                setLoading(false);
                message.default.error(errorMessage);
              }

              _context2.next = 13;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](1);
              console.log('error>>>', _context2.t0);
              setLoading(false);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 9]]);
    }));

    return function getResourceToken(_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/react.createElement(upload/* default */.Z, defaultProps, /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    type: "primary",
    size: "large",
    className: "upload-button",
    loading: loading
  }, "\u4E0A\u4F20"));
};

/* harmony default export */ var components_ExcelUpload = (ExcelUpload);
;// CONCATENATED MODULE: ./src/pages/Promotion/StoreCoupon/components/ShopImport.tsx













function ShopImport(_ref) {
  var onChange = _ref.onChange,
      operationGroupIds = _ref.operationGroupIds,
      type = _ref.type;

  var _React$useState = react.useState(0),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      status = _React$useState2[0],
      setStatus = _React$useState2[1];

  var _React$useState3 = react.useState(0),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      succCount = _React$useState4[0],
      setSuccCount = _React$useState4[1];

  var _React$useState5 = react.useState(0),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      failCount = _React$useState6[0],
      setFailCount = _React$useState6[1];

  var _React$useState7 = react.useState(''),
      _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
      failAddress = _React$useState8[0],
      setFailAddress = _React$useState8[1];

  var handleReUpload = () => {
    setStatus(0);
  };

  var handleErrorDownLoad = () => {
    window.location.href = failAddress;
  };

  var handleDownload = () => {
    window.location.href = type === "marketing" ? "https://res-1258369466.cos.ap-shanghai.myqcloud.com/ywwyjsbv5jr7pztni61ob2jzyykbfh5e.xlsx" : "https://res-1258369466.cos.ap-shanghai.myqcloud.com/zrlgeathgxgezglts1xivftkairtlwfb.xlsx";
  };

  var handleImport = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(resId, url) {
      var res;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setStatus(1);
              _context.next = 3;
              return (0,ypRequest/* default */.Z)(type === 'marketing' ? api/* asyncImportShop */.NO : api/* posAsyncImportShop */.DL, {
                resId,
                operationGroupId: operationGroupIds
              });

            case 3:
              res = _context.sent;

              if (res.success) {
                // setTaskId()
                polling(res.result.taskId);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleImport(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  /** 轮询查询结果 */


  var polling = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(taskId) {
      var res, list;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0,ypRequest/* default */.Z)(type === 'marketing' ? api/* getLastImportShopResult */.$H : api/* posGetLastImportShopResult */.s8, {
                taskId,
                operationGroupId: operationGroupIds
              });

            case 2:
              res = _context2.sent;

              if (res.success) {
                if (res.result.status < 3) {
                  setTimeout(() => {
                    polling(taskId);
                  }, 1000);
                } else {
                  if (res.result.failNumber > 0) {
                    setSuccCount(res.result.successNumber);
                    setFailCount(res.result.failNumber);
                    setFailAddress(res.result.failDataDownloadAddress);
                    setStatus(3);
                  } else {
                    setSuccCount(res.result.successNumber);
                    setStatus(2);
                  }

                  list = [];
                  res.result.successList.forEach(item => {
                    list.push({
                      merchantId: item.id,
                      merchantName: item.name,
                      joinType: item.joinType,
                      operationGroupId: item.operationGroupId
                    });
                  });
                  onChange(list);
                }
              } else {
                setStatus(0);
              }

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function polling(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/react.createElement(react.Fragment, null, status === 0 ? /*#__PURE__*/react.createElement("div", {
    className: "import-box"
  }, /*#__PURE__*/react.createElement(CloudUploadOutlined/* default */.Z, {
    className: "status-icon"
  }), /*#__PURE__*/react.createElement("div", null, "\u6587\u4EF6\u5185\u9700\u5305\u542B\u5168\u90E8\u9002\u7528\u95E8\u5E97\u7684\u95E8\u5E97\u7F16\u7801\uFF08\u7F6E\u4E8E\u7B2C\u4E00\u5217\uFF09\u3002"), /*#__PURE__*/react.createElement("div", null, "\u652F\u6301 xls\u3001xlsx \u683C\u5F0F\uFF0C\u6587\u4EF6\u5927\u5C0F\u4E0D\u8D85\u8FC710MB\u3002"), /*#__PURE__*/react.createElement("div", {
    className: "import-tips"
  }, "\u6CE8\u610F\uFF1A \u6BCF\u6B21\u4E0A\u4F20\u5C06\u8986\u76D6\u4E0A\u6B21\u7684\u8BBE\u7F6E\u7ED3\u679C\uFF0C\u975E\u65B0\u589E\u3002\u8BF7\u52A1\u5FC5\u6BCF\u6B21\u90FD\u4E0A\u4F20\u5B8C\u6574\u7684\u9002\u7528\u95E8\u5E97\u3002"), /*#__PURE__*/react.createElement("div", {
    className: "import-tips"
  }, "\u6B64\u5904\u53EF\u4E0B\u8F7D\u5BFC\u5165\u6A21\u7248\uFF0C\u4E0B\u8F7D\u540E\u9700\u586B\u5199\u95E8\u5E97\u7F16\u7801\u548C\u95E8\u5E97\u540D\u79F0\uFF0C", /*#__PURE__*/react.createElement("a", {
    onClick: handleDownload
  }, "\u4E0B\u8F7D\u5BFC\u5165\u6A21\u7248\u6587\u4EF6")), /*#__PURE__*/react.createElement(components_ExcelUpload, {
    callBack: handleImport,
    type: type
  })) : null, status === 1 ? /*#__PURE__*/react.createElement("div", {
    className: "import-box"
  }, /*#__PURE__*/react.createElement(spin/* default */.Z, null)) : null, status === 2 ? /*#__PURE__*/react.createElement("div", {
    className: "import-box"
  }, /*#__PURE__*/react.createElement(CheckCircleOutlined/* default */.Z, {
    className: "status-icon success"
  }), /*#__PURE__*/react.createElement("div", null, "\u5168\u90E8\u95E8\u5E97\u8BC6\u522B\u6210\u529F\uFF0C", /*#__PURE__*/react.createElement("span", {
    className: "error-tips"
  }, "\u786E\u5B9A\u4E4B\u540E\u751F\u6548")), /*#__PURE__*/react.createElement("div", null, "\u6587\u4EF6\u5185\u7684", succCount, "\u5BB6\u95E8\u5E97\u5DF2\u5168\u90E8\u8BC6\u522B\u6210\u529F"), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    onClick: handleReUpload
  }, "\u91CD\u65B0\u4E0A\u4F20")) : null, status === 3 ? /*#__PURE__*/react.createElement("div", {
    className: "import-box"
  }, /*#__PURE__*/react.createElement(ExclamationCircleOutlined/* default */.Z, {
    className: "status-icon error"
  }), succCount != 0 && succCount != 0 ? /*#__PURE__*/react.createElement("div", null, "\u90E8\u5206\u95E8\u5E97\u8BC6\u522B\u6210\u529F\uFF0C", /*#__PURE__*/react.createElement("span", {
    className: "error-tips"
  }, "\u786E\u5B9A\u4E4B\u540E\u751F\u6548")) : /*#__PURE__*/react.createElement("div", null, "\u4E0A\u4F20\u95E8\u5E97\u8BC6\u522B\u5931\u8D25"), /*#__PURE__*/react.createElement("div", null, succCount, "\u5BB6\u95E8\u5E97\u8BC6\u522B\u6210\u529F\uFF0C", failCount, "\u5BB6\u95E8\u5E97\u8BC6\u522B\u5931\u8D25\u3002"), /*#__PURE__*/react.createElement("div", null, "\u8BF7", /*#__PURE__*/react.createElement("a", {
    onClick: handleErrorDownLoad
  }, "\u4E0B\u8F7D\u6587\u4EF6"), "\uFF0C\u6839\u636E\u6587\u4EF6\u5185\u7684\u63D0\u793A\u4FEE\u6539\u540E\u91CD\u65B0\u4E0A\u4F20"), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
    size: "large",
    onClick: handleReUpload
  }, "\u91CD\u65B0\u4E0A\u4F20")) : null);
}

/***/ }),

/***/ 18166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ShopTable; }
/* harmony export */ });
/* harmony import */ var antd_es_table_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66456);
/* harmony import */ var antd_es_table__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97423);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _config_api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15910);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24731);








var joinTypeMap = {
  1: '加盟',
  2: '自营'
};
var columns = [{
  title: '门店名称',
  dataIndex: 'name'
}, {
  title: '门店类型',
  dataIndex: 'joinType',
  render: joinType => joinTypeMap[joinType] || '-'
}];
function ShopTable(_ref) {
  var selectedShops = _ref.selectedShops,
      operationGroupIds = _ref.operationGroupIds,
      type = _ref.type;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1__.useState({}),
      _React$useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_React$useState, 2),
      shopMap = _React$useState2[0],
      setShopMap = _React$useState2[1];

  var showList = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(() => {
    var list = [];

    if (selectedShops.length) {
      selectedShops.forEach(item => {
        var key = String(typeof item === 'string' || typeof item === 'number' ? item : item.id);

        if (shopMap[key]) {
          list.push(shopMap[key]);
        } else if (item && typeof item === 'object') {
          // shopMap 尚未加载或 key 不一致时，兜底展示已选数据
          list.push({
            id: item.id,
            name: item.fullName || item.name,
            joinType: item.joinType
          });
        }
      });
    }

    return list;
  }, [selectedShops, shopMap]);
  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee() {
      var res, list, next;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(type === 'marketing' ? _config_api__WEBPACK_IMPORTED_MODULE_6__/* .queryStoreByCondition */ .gg : _config_api__WEBPACK_IMPORTED_MODULE_6__/* .posListShopByCondition */ .a, {
                operationGroupId: operationGroupIds
              });

            case 2:
              res = _context.sent;

              if (res.success) {
                list = (type === 'marketing' ? res.result : res.result.list) || [];
                next = {};
                list.forEach(item => {
                  next[String(item.id)] = item;
                });
                setShopMap(next);
              } else {
                setShopMap({});
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [operationGroupIds]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_table__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
    columns: columns,
    dataSource: showList
  });
}

/***/ }),

/***/ 69063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useActivity; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94554);



function useActivity(act) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(act),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState3, 2),
      activity = _useState4[0],
      setActivity = _useState4[1];

  var id = Number(activity.activityId); //可以改名称字段为couponId activity改成接口返回的包裹

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!id) {
      return;
    }

    setLoading(true); //getActivitycoupon  getActivity

    _utils_api__WEBPACK_IMPORTED_MODULE_1__/* .default.getActivitycoupon */ .Z.getActivitycoupon({
      couponId: id,
      shopType: 3
    }).then(result => {
      var coupon = result.coupon;
      var _coupon$shopIds = coupon.shopIds,
          shopIds = _coupon$shopIds === void 0 ? [] : _coupon$shopIds,
          _coupon$shop = coupon.shop,
          shop = _coupon$shop === void 0 ? [] : _coupon$shop,
          activityId = coupon.activityId;

      if (!shopIds.length) {
        coupon.shopIds = shop.map(i => i.id); // delete coupon.shop
      }

      if (!Number(activityId) && id) {
        coupon.activityId = id;
      }

      coupon.isMounted = true;
      setActivity(coupon);
      setLoading(false);
      return coupon;
    }).catch(() => {
      setLoading(false);
    });
  }, [id]);
  return [loading, activity, setActivity];
} //回显示

/***/ }),

/***/ 79139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useOperation; }
/* harmony export */ });
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94554);





var resetParams = {
  activityId: 0,
  activityStatus: 0
};
function useOperation() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState, 2),
      rId = _useState2[0],
      refresh = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(resetParams),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState3, 2),
      params = _useState4[0],
      setParams = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    var activityId = params.activityId,
        activityStatus = params.activityStatus;

    if (!activityId || !activityStatus) {
      return;
    }

    activityStatus == 22 ? _utils_api__WEBPACK_IMPORTED_MODULE_2__/* .default.publishTimeDiscountActivity */ .Z.publishTimeDiscountActivity({
      activityId
    }).then(() => {
      refresh(String([activityId, activityStatus].join('')));
      setParams(resetParams);

      antd_es_message__WEBPACK_IMPORTED_MODULE_4__.default.success('发布成功');
    }).catch(() => {
      setParams(resetParams);
    }) : _utils_api__WEBPACK_IMPORTED_MODULE_2__/* .default.closeTimeDiscountActivity */ .Z.closeTimeDiscountActivity({
      activityId
    }).then(() => {
      refresh(String([activityId, activityStatus].join('')));
      setParams(resetParams);
    }).catch(() => {
      setParams(resetParams);
    });
  }, [params]);
  return [rId, setParams];
}

/***/ }),

/***/ 85394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3182);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2824);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34041);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24731);










var Option = antd_es_select__WEBPACK_IMPORTED_MODULE_4__/* .default.Option */ .Z.Option;

var SearchSelect = props => {
  var callBack = props.callBack,
      searchUrl = props.searchUrl,
      type = props.type,
      fields = props.fields,
      isShowSelectId = props.isShowSelectId,
      disabled = props.disabled,
      initialValue = props.initialValue,
      isAdd = props.isAdd;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (initialValue) setValue(initialValue);
  }, [initialValue]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (!data.length) fetchFoo();
  }, []);

  var msgNotFound = () => {
    setTimeout(() => {
      antd_es_message__WEBPACK_IMPORTED_MODULE_6__.default.info('未查询到指定信息');

      setData([]);
      return;
    }, 1500);
  };

  var fetchFoo = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)().mark(function _callee() {
      var _params, _yield$ypRider, result, list, _data, defaultValue;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _params = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, props.params);
              _context.prev = 1;
              _context.next = 4;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(searchUrl, _params);

            case 4:
              _yield$ypRider = _context.sent;
              result = _yield$ypRider.result;
              list = result[type]; // if (!list?.length) {
              //   msgNotFound()
              // }

              if (list && list.length) {
                _data = [];
                defaultValue = '';
                list.map(e => {
                  _data = [..._data, {
                    label: e[fields.label],
                    value: e[fields.value]
                  }]; // 默认展示

                  if (e.defaultMark === '1') {
                    defaultValue = e.themeId;
                  }
                });
                setData(_data);

                if (isAdd) {
                  setValue(defaultValue);
                  callBack(defaultValue);
                }
              }

              return _context.abrupt("return");

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              console.error('fetchFooERROR', _context.t0);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11]]);
    }));

    return function fetchFoo() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleChange = value => {
    callBack(value);
    setValue(value);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    disabled: disabled,
    showSearch: true,
    value: value,
    optionFilterProp: "children",
    filterOption: (input, option) => {
      var _option$children;

      return ((_option$children = option === null || option === void 0 ? void 0 : option.children) !== null && _option$children !== void 0 ? _option$children : '').includes(input);
    },
    placeholder: props.placeholder || '请输入关键字查询',
    onChange: handleChange,
    style: {
      width: props.width || '100%'
    },
    allowClear: true
  }, data.map(d => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(Option, {
    key: d.value,
    value: d.value
  }, isShowSelectId ? " (".concat(d.value, ") ") + d.label : d.label)));
};

/* harmony default export */ __webpack_exports__["Z"] = (SearchSelect);

/***/ }),

/***/ 91836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCategory; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8870);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94554);




var results = new Map();

function cachedCategory(parentId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (results.has(parentId)) {
    return Promise.resolve(results.get(parentId));
  }

  return new Promise((res, rej) => {
    _utils_api__WEBPACK_IMPORTED_MODULE_1__/* .default.getCategorys */ .Z.getCategorys((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)({
      parentId: parentId || null
    }, params)).then(data => {
      var _data$list = data.list,
          list = _data$list === void 0 ? [] : _data$list;
      var optionList = list.map(each => {
        return {
          value: each.categoryId,
          label: each.categoryName
        };
      });
      optionList.unshift({
        value: '',
        label: '全部'
      });
      results.set(parentId, optionList);
      return res(optionList);
    }).catch(rej);
  });
}

function useCategory(params) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState, 2),
      cateList1 = _useState2[0],
      setCateList1 = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState3, 2),
      cateList2 = _useState4[0],
      setCateList2 = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState5, 2),
      parentId = _useState6[0],
      setParentId = _useState6[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    cachedCategory(parentId, params).then(list => {
      if (parentId) {
        setCateList2(list);
      } else {
        setCateList1(list);

        if (cateList2.length) {
          setCateList2([]);
        }
      }
    });
  }, [parentId, params, cateList2.length]);
  return [cateList1, cateList2, setParentId];
}

/***/ }),

/***/ 87237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useOperationGroupList; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94554);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_2__);




var _list = [];

function cachedOperationGroupList() {
  if (_list.length) {
    return Promise.resolve(_list);
  }

  return new Promise((res, rej) => {
    _utils_api__WEBPACK_IMPORTED_MODULE_1__/* .default.queryOperationGroupList */ .Z.queryOperationGroupList({
      tenantId: 1
    }).then(data => {
      if (data && data.length > 0) {
        var _list2;

        _list = data.map(o => {
          return {
            value: o.operationGroupId,
            label: o.operationGroupName
          };
        });
        var cachedMap = {};
        (_list2 = _list) === null || _list2 === void 0 ? void 0 : _list2.forEach(item => {
          cachedMap[item.value] = item.label;
        });
        sessionStorage.setItem('CAHCED_OPERATIONGROUP_MAP', JSON.stringify(cachedMap));
        return res(_list);
      }
    }).catch(rej);
  });
}

var cookieKey = 'promotion_operationGroupId'; // 运营组

function useOperationGroupList(defaultValue) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState, 2),
      list = _useState2[0],
      setList = _useState2[1];

  var cookieValue = js_cookie__WEBPACK_IMPORTED_MODULE_2___default().get(cookieKey);
  var initOperationGroupId = defaultValue || cookieValue || '';

  if (initOperationGroupId && initOperationGroupId === 'undefined') {
    initOperationGroupId = '';
  }

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initOperationGroupId),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState3, 2),
      operationGroupId = _useState4[0],
      setOperationGroupId = _useState4[1];

  var updateOperationGroup = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(c => {
    if (c) {
      setOperationGroupId(c);
      js_cookie__WEBPACK_IMPORTED_MODULE_2___default().set(cookieKey, c);
    } else {
      console.error('updateCity error', c);
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (list.length) {
      return;
    }

    cachedOperationGroupList().then(results => {
      var first = results[0].value; // 判断初始化的operationGroupId是否存在与列表中

      var findItem = results.find(item => {
        return item.value === operationGroupId;
      }); // 没有初始的运营组id，或者存在运营组id但是匹配不到

      if ((!operationGroupId || !findItem) && first) {
        updateOperationGroup(first);
      }

      setList(results);
    });
  }, [operationGroupId, list]);
  return [operationGroupId, list, updateOperationGroup];
}

/***/ }),

/***/ 54597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSupplier; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94554);



 // TODO pagesize

function useSupplier(defaultParms) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)({
    cityCode: '',
    page: 1,
    size: 100,
    supplierName: ''
  }, defaultParms)),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState3, 1),
      params = _useState4[0];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState5, 2),
      results = _useState6[0],
      setResults = _useState6[1];

  var searchSupplierName = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(supplierName => {
    if (loading || !supplierName) {
      return;
    }

    setLoading(true);
    _utils_api__WEBPACK_IMPORTED_MODULE_1__/* .default.getSupplieries */ .Z.getSupplieries((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)({}, params), {}, {
      supplierName
    })).then(data => {
      var list = data.list.map(o => {
        return {
          label: o.supplierName,
          value: o.supplierCode
        };
      });
      setResults(list);
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  }, [loading, params]);
  return [loading, results, searchSupplierName];
}

/***/ }),

/***/ 46077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_GoodsSelector; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/modal/style/index.js
var style = __webpack_require__(71194);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(57016);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(93224);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/style/index.js
var tooltip_style = __webpack_require__(22385);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 1 modules
var tooltip = __webpack_require__(31097);
// EXTERNAL MODULE: ./node_modules/antd/es/form/style/index.js
var form_style = __webpack_require__(9715);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 12 modules
var es_form = __webpack_require__(35845);
// EXTERNAL MODULE: ./node_modules/antd/es/select/style/index.js
var select_style = __webpack_require__(43358);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js
var es_select = __webpack_require__(34041);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(91896);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/QuestionCircleOutlined.js + 1 modules
var QuestionCircleOutlined = __webpack_require__(1870);
// EXTERNAL MODULE: ./src/components/FormBuilder/index.tsx + 4 modules
var FormBuilder = __webpack_require__(5670);
// EXTERNAL MODULE: ./src/components/CommonTable/index.tsx + 3 modules
var CommonTable = __webpack_require__(40934);
// EXTERNAL MODULE: ./src/components/GoodsCategorySelect/index.tsx
var GoodsCategorySelect = __webpack_require__(51115);
// EXTERNAL MODULE: ./src/utils/mixin.ts
var mixin = __webpack_require__(6067);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
;// CONCATENATED MODULE: ./src/pages/Promotion/pricecut/Api/index.ts
/**
 * API集合
 */
var masterApi = {
  querySgMerchantItemList: 'pms.sgMerchantItemManageService.querySgMerchantItemList',
  // 获取商家商品列表
  getBackCategoryTree: 'pms.backCategoryManage.getBackCategoryTree',
  // 获取后台类目树
  queryProductDetail: 'pms.productManageService.queryProductDetail',
  // 基础资料详情
  createProduct: 'pms.productManageService.createProduct',
  // 创建基础资料
  updateProduct: 'pms.productManageService.updateProduct',
  // 更新基础资料
  queryYpShengXianMerchant: 'pms.pmsMerchantService.queryYpShengXianMerchant',
  // 查询生鲜商户列表
  queryMerchantList: 'pms.merchantItemManage.queryMerchantList',
  // 查询商户权限
  downloadSgMerchantItem: 'pms.sgMerchantItemManageService.downloadSgMerchantItem',
  // 导出
  queryTaskList: 'pms.taskManageService.queryTaskList' // 异步导出查询列表

};
var gradingApi = {
  queryProductManageInfo: 'pms.sgMerchantItemManageService.queryProductManageInfo',
  // 获取经营信息详情
  getPluCodeList: 'pms.productManageService.getPluCodeList',
  // 新建分档，查询Plu列表
  createProductManageInfo: 'pms.productManageService.createProductManageInfo',
  // 新增经营信息
  updateProductManageInfo: 'pms.sgMerchantItemManageService.updateProductManageInfo',
  // 编辑经营信息
  querySupplierByCodeOrName: 'pms.pmsPurchaseService.querySupplierByCodeOrName' // 根据编码或者名称查询供应商列表

};
var Api_salesApi = {
  queryProductSaleInfo: 'pms.sgMerchantItemManageService.queryProductSaleInfo',
  // 获取销售信息详情
  updateProductSaleInfo: 'pms.sgMerchantItemManageService.updateProductSaleInfo',
  // 编辑销售信息
  createProductSaleInfo: 'pms.productManageService.createProductSaleInfo',
  // 新建销售信息
  querySiteInfoByCodeOrName: 'pms.pmsMerchantService.querySiteInfoByCodeOrName',
  // 根据编码或者名称查询地点列表
  queryProductSaleInfoBySiteIds: 'pms.sgMerchantItemManageService.queryProductSaleInfoBySiteIds',
  // 根据门店id查询销售信息
  queryGroupsAndWarehouseByMerchantId: 'pms.pmsMerchantService.queryGroupsAndWarehouseByMerchantId' // 查询店群和配送中心

};
var Api_apiList = {
  category: 'item.erpCategory.queryCategoryListByHeadId',
  fuzzyQueryBrandByName: 'pms.brandManageService.fuzzyQueryBrandByName',
  queryUserMerchantList: 'pms.pmsMerchantService.queryUserMerchantList',
  // 查询生鲜商户权限列表
  queryUserSiteList: 'pms.pmsMerchantService.queryUserSiteList' // 查询生鲜门店权限列表

};
var sgApi = {
  querySgMerchantItemList: 'pms.sgMerchantItemManageService.querySgMerchantItemList'
};
/**
 * 调拨单主信息查询接口
 */

var freshActivityItemUpload = 'mms.file.freshActivityItemUpload';
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
;// CONCATENATED MODULE: ./src/pages/Promotion/pricecut/components/searchForm/searchSelect/brandSearch.tsx










var Option = es_select/* default.Option */.Z.Option;

function useSearch(search) {
  var debounceRef = (0,react.useRef)();

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      brandList = _useState2[0],
      setBrand = _useState2[1];

  (0,react.useEffect)(() => {
    if (debounceRef.current) {
      if (search) {
        debounceRef.current(search);
      }
    } else {
      debounceRef.current = (0,lodash.debounce)( /*#__PURE__*/function () {
        var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(search) {
          var url, params, res, result, success;
          return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  url = Api_apiList.fuzzyQueryBrandByName;
                  params = {
                    brandName: search
                  };
                  _context.prev = 2;
                  _context.next = 5;
                  return (0,ypRequest/* default */.Z)(url, params);

                case 5:
                  res = _context.sent;
                  result = res.result, success = res.success;

                  if (success) {
                    setBrand(result);
                  }

                  _context.next = 13;
                  break;

                case 10:
                  _context.prev = 10;
                  _context.t0 = _context["catch"](2);
                  console.log(_context.t0);

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 10]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }(), 300);
    }
  }, [search]);
  return [brandList, setBrand];
}

var BrandSearch = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _useState3 = (0,react.useState)(''),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      search = _useState4[0],
      setSearch = _useState4[1];

  var _useSearch = useSearch(search),
      _useSearch2 = (0,slicedToArray/* default */.Z)(_useSearch, 1),
      brandList = _useSearch2[0];

  return /*#__PURE__*/react.createElement(es_select/* default */.Z, (0,esm_extends/* default */.Z)({
    allowClear: true,
    defaultActiveFirstOption: false,
    filterOption: false,
    showSearch: true,
    onSearch: val => setSearch(val)
  }, props), brandList.map(item => /*#__PURE__*/react.createElement(Option, {
    key: item.brandId,
    value: item.brandId || undefined
  }, item.brandName)));
});
/* harmony default export */ var brandSearch = (BrandSearch);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
;// CONCATENATED MODULE: ./src/pages/Promotion/pricecut/components/searchForm/searchSelect/merchantSearch.tsx









var merchantSearch_Option = es_select/* default.Option */.Z.Option;
var MerchantSearch = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef((props, ref) => {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      merchantList = _useState2[0],
      setMerchantList = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      merchantId = _useState4[0],
      setMerchantId = _useState4[1];

  var queryMerchant = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var url, params, _yield$ypRider, result, success;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // const url = masterApi.queryYpShengXianMerchant
              url = apiList.queryUserMerchantList;
              params = {
                tenantId: 1,
                phone: Cookies.get('mobile')
              };
              _context.prev = 2;
              _context.next = 5;
              return ypRider(url, params);

            case 5:
              _yield$ypRider = _context.sent;
              result = _yield$ypRider.result;
              success = _yield$ypRider.success;

              if (success) {
                setMerchantList(result);
                props.setMerchantList && props.setMerchantList(result);
              }

              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              console.log(_context.t0);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 11]]);
    }));

    return function queryMerchant() {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(() => {
    if (!merchantList.length) queryMerchant();
  }, []);
  return /*#__PURE__*/React.createElement(_Select, {
    allowClear: true,
    defaultActiveFirstOption: false,
    showSearch: true,
    filterOption: (input, option) => {
      var _option$children, _option$children$toLo;

      return (option === null || option === void 0 ? void 0 : (_option$children = option.children) === null || _option$children === void 0 ? void 0 : (_option$children$toLo = _option$children.toLowerCase()) === null || _option$children$toLo === void 0 ? void 0 : _option$children$toLo.indexOf(input === null || input === void 0 ? void 0 : input.toLowerCase())) >= 0;
    },
    value: props.value,
    onChange: props.onChange,
    placeholder: props.placeholder // {...props}

  }, merchantList.map(item => /*#__PURE__*/React.createElement(merchantSearch_Option, {
    key: item.merchantId,
    value: item.merchantId || undefined
  }, item.merchantName)));
})));
/* harmony default export */ var merchantSearch = ((/* unused pure expression or super */ null && (MerchantSearch)));
;// CONCATENATED MODULE: ./src/pages/Promotion/pricecut/components/searchForm/searchSelect/shopSearch.tsx








var shopSearch_Option = es_select/* default.Option */.Z.Option;
var ShopSearch = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef((props, ref) => {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      shopList = _useState2[0],
      setShopList = _useState2[1];

  var queryShop = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(merchantId) {
      var url, params, _yield$ypRider, result, success, list, shops;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = salesApi.querySiteInfoByCodeOrName;
              params = {
                merchantId,
                siteCode: '',
                siteName: '',
                page: 1
              };
              _context.prev = 2;
              _context.next = 5;
              return ypRider(url, params);

            case 5:
              _yield$ypRider = _context.sent;
              result = _yield$ypRider.result;
              success = _yield$ypRider.success;

              if (success) {
                list = result.list;
                shops = [{
                  siteCode: null,
                  siteId: null,
                  siteName: "全部"
                }].concat(list);
                setShopList(shops);
                props.setShopList && props.setShopList(list);
              }

              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              console.log(_context.t0);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 11]]);
    }));

    return function queryShop(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(() => {
    var _props$merchantId;

    if (props !== null && props !== void 0 && (_props$merchantId = props.merchantId) !== null && _props$merchantId !== void 0 && _props$merchantId.length) {
      queryShop(props.merchantId);
    }
  }, [props.merchantId]);
  return /*#__PURE__*/React.createElement(_Select, {
    allowClear: true,
    defaultActiveFirstOption: false,
    showSearch: true,
    filterOption: (input, option) => {
      var _option$children, _option$children$toLo;

      return (option === null || option === void 0 ? void 0 : (_option$children = option.children) === null || _option$children === void 0 ? void 0 : (_option$children$toLo = _option$children.toLowerCase()) === null || _option$children$toLo === void 0 ? void 0 : _option$children$toLo.indexOf(input === null || input === void 0 ? void 0 : input.toLowerCase())) >= 0;
    },
    value: props.value || null,
    onChange: props.onChange
  }, (shopList === null || shopList === void 0 ? void 0 : shopList.length) && shopList.map(item => /*#__PURE__*/React.createElement(shopSearch_Option, {
    key: item.siteId,
    value: item.siteId
  }, item.siteName)));
})));
/* harmony default export */ var shopSearch = ((/* unused pure expression or super */ null && (ShopSearch)));
// EXTERNAL MODULE: ./node_modules/antd/es/tree-select/style/index.js
var tree_select_style = __webpack_require__(62999);
// EXTERNAL MODULE: ./node_modules/antd/es/tree-select/index.js + 40 modules
var tree_select = __webpack_require__(57119);
;// CONCATENATED MODULE: ./src/pages/Promotion/pricecut/components/searchForm/searchSelect/myTreeSelect.tsx







var TreeNode = tree_select/* default.TreeNode */.Z.TreeNode;
var MyTreeSelect = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef((props, ref) => {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      treeData = _useState2[0],
      setTreeData = _useState2[1];

  useEffect(() => {
    getTreeData();
  }, []);

  var getTreeData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var url, params, res, result, success, _result$childBackCate, childBackCategory;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = props.api;
              params = {};
              _context.prev = 2;
              _context.next = 5;
              return ypRider(url, params);

            case 5:
              res = _context.sent;
              result = res.result, success = res.success;

              if (success) {
                _result$childBackCate = result.childBackCategory, childBackCategory = _result$childBackCate === void 0 ? [] : _result$childBackCate;
                setTreeData(childBackCategory);
              }

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              console.log(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 10]]);
    }));

    return function getTreeData() {
      return _ref.apply(this, arguments);
    };
  }();

  var renderTreeNode = treeData => {
    if (!treeData) return;
    return treeData.map((item, key) => {
      if (item.childBackCategory) {
        return /*#__PURE__*/React.createElement(TreeNode, {
          value: item.backCategoryId,
          title: item.backCategoryName,
          key: item.backCategoryId
        }, renderTreeNode(item.childBackCategory));
      } else {
        return /*#__PURE__*/React.createElement(TreeNode, {
          value: item.backCategoryId,
          title: item.backCategoryName,
          key: item.backCategoryId
        });
      }
    });
  };

  var onTreeChange = e => {
    props.setCategoryId(e);
  };

  return /*#__PURE__*/React.createElement("div", {
    id: "my-tree-select"
  }, /*#__PURE__*/React.createElement(_TreeSelect, {
    treeDataSimpleMode: true,
    style: {
      width: '100%'
    },
    value: props.categoryId || undefined,
    dropdownStyle: {
      maxHeight: 400,
      overflow: 'auto'
    },
    placeholder: "\u8BF7\u9009\u62E9\u5546\u54C1\u7C7B\u76EE",
    onChange: onTreeChange
  }, renderTreeNode(treeData)));
})));
/* harmony default export */ var myTreeSelect = ((/* unused pure expression or super */ null && (MyTreeSelect)));
;// CONCATENATED MODULE: ./src/pages/Promotion/pricecut/components/searchForm/searchSelect/index.ts





// EXTERNAL MODULE: ./src/pages/Promotion/hooks/useCategory.ts
var useCategory = __webpack_require__(91836);
// EXTERNAL MODULE: ./src/pages/Promotion/hooks/useSupplier.ts
var useSupplier = __webpack_require__(54597);
;// CONCATENATED MODULE: ./src/pages/Promotion/pricecut/components/GoodsSelector.tsx












var _excluded = ["supplierCode"];










var columns = [{
  title: '商品ID',
  dataIndex: 'itemId',
  key: 'itemId'
}, {
  title: '商品编码',
  dataIndex: 'productId',
  key: 'productId'
}, {
  title: '商品条码',
  dataIndex: 'barCode',
  key: 'barCode'
}, {
  title: '商品信息',
  dataIndex: 'itemName',
  key: 'itemName',
  width: 150,
  // TODO image?
  render: (_text, record) => {
    var cover = record.cover,
        itemName = record.itemName,
        _record$itemPrice = record.itemPrice,
        itemPrice = _record$itemPrice === void 0 ? 0 : _record$itemPrice,
        itemLowPrice = record.itemLowPrice,
        itemHighPrice = record.itemHighPrice;
    return /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("div", null, !!cover && /*#__PURE__*/react.createElement("img", {
      className: "modal-goods-img",
      src: cover,
      alt: ""
    }), /*#__PURE__*/react.createElement("span", null, itemName)), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("strong", null, "\xA5"), ' ', itemLowPrice && itemHighPrice && (itemLowPrice === itemHighPrice ? (0,mixin/* formatMoney */.lb)(itemLowPrice) : "".concat((0,mixin/* formatMoney */.lb)(itemLowPrice), "-").concat((0,mixin/* formatMoney */.lb)(itemHighPrice))) || (0,mixin/* formatMoney */.lb)(itemPrice)));
  }
}, {
  title: '商品类目',
  dataIndex: 'categoryName',
  key: 'categoryName',
  width: 150
}, {
  title: '品牌',
  dataIndex: 'brandName',
  key: 'brandName'
}, {
  title: '级别',
  dataIndex: 'pluCode',
  key: 'pluCode'
}, {
  title: '单位',
  dataIndex: 'saleUnit',
  key: 'saleUnit',
  width: 60
}, {
  title: '请选择供应商',
  dataIndex: 'supplierName',
  key: 'supplierName',
  width: 200,
  render: (_text, record) => {
    var _record$supplier;

    if (!((_record$supplier = record.supplier) !== null && _record$supplier !== void 0 && _record$supplier.length)) {
      return null;
    }

    var list = (record.supplier || []).map(o => {
      return {
        label: o.supplierName,
        value: o.supplierCode
      };
    });
    var formItemProps = {
      name: [record.itemId],
      initialValue: list[0].value
    };
    var selectProps = {
      allowClear: false,
      options: list
    };
    return /*#__PURE__*/react.createElement(es_form/* default.Item */.Z.Item, formItemProps, /*#__PURE__*/react.createElement(es_select/* default */.Z, (0,esm_extends/* default */.Z)({}, selectProps, {
      disabled: true
    })));
  }
}, {
  title: '备注',
  dataIndex: 'remarks',
  key: 'remarks',
  width: 110,
  render: (_text, record) => {
    var activityFlag = record.activityFlag,
        notUseReason = record.notUseReason;
    return activityFlag && notUseReason ? notUseReason.length <= 25 ? /*#__PURE__*/react.createElement("div", null, record.notUseReason) : /*#__PURE__*/react.createElement(tooltip/* default */.Z, {
      title: notUseReason,
      placement: "right"
    }, /*#__PURE__*/react.createElement("i", null, /*#__PURE__*/react.createElement("span", null, notUseReason.slice(0, 25) + '...'), /*#__PURE__*/react.createElement(QuestionCircleOutlined/* default */.Z, {
      className: "cantReason"
    }))) : '';
  }
}];

function genFields(props) {
  var cateList1 = props.cateList1,
      cateList2 = props.cateList2,
      setCat1Id = props.setCat1Id,
      loading = props.loading,
      results = props.results,
      search = props.search;
  var fields = [{
    label: '一级分类',
    name: 'cateId1',
    type: 'SELECT',
    dataList: cateList1,
    initialValue: '',
    fieldOptions: {
      allowClear: false,
      onChange: setCat1Id
    }
  }, {
    label: '二级分类',
    name: 'cateId2',
    type: 'SELECT',
    initialValue: '',
    dataList: cateList2
  }, {
    label: '供应商名称',
    name: 'supplierCode',
    type: 'SELECT',
    dataList: results,
    fieldOptions: {
      loading,
      onSearch: _.debounce(value => {
        var _value = _.trim(value);

        if (_value.length) {
          search(_value);
        }
      }, 1e3)
    }
  }, {
    label: '商品查询',
    name: 'itemName',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '名称/编码/条码'
    }
  }];
  return fields;
}

var processItemSupplier = (form, o) => {
  var values = form.getFieldsValue();
  var supplierCode = values[o.itemId];

  var selectedSupplier = lodash_default().find(o.supplier, {
    supplierCode
  });

  return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, o), {}, {
    selectedSupplier
  });
};

function CombineFormAndTable(props) {
  var modalProps = props.modalProps,
      itemSearchReqParams = props.itemSearchReqParams,
      categoryReqParams = props.categoryReqParams;
  var form = (0,react.useRef)(null);

  var _Form$useForm = es_form/* default.useForm */.Z.useForm(),
      _Form$useForm2 = (0,slicedToArray/* default */.Z)(_Form$useForm, 1),
      activityItemsForm = _Form$useForm2[0];

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      selectedItems = _useState2[0],
      setSelectedItems = _useState2[1]; // 类目


  var _useState3 = (0,react.useState)(),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      curSelectCategoryId = _useState4[0],
      setcurSelectCategoryId = _useState4[1];

  var _useState5 = (0,react.useState)(itemSearchReqParams),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      searchParams = _useState6[0],
      setSearchParams = _useState6[1];

  var searchHandler = (0,react.useCallback)((status, values) => {
    if (status === 'success') {
      var supplierCode = values.supplierCode,
          rest = (0,objectWithoutProperties/* default */.Z)(values, _excluded);

      var params = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, searchParams), rest), {}, {
        categoryId: curSelectCategoryId || undefined,
        // 类目
        supplierCode: supplierCode ? [supplierCode] : [] // 供应商

      });

      setSearchParams(params);
    }
  }, [searchParams, curSelectCategoryId]);

  var onSelect = (record, selected) => {
    if (selected) {
      setSelectedItems(lodash_default().concat(selectedItems, processItemSupplier(activityItemsForm, record)));
    } else {
      setSelectedItems(lodash_default().filter(selectedItems, each => each.itemId !== record.itemId));
    }
  };

  var onSelectAll = function onSelectAll(selected) {
    var selectedRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var changeRows = arguments.length > 2 ? arguments[2] : undefined;

    if (selected) {
      var filteredRows = selectedRows.filter(each => !!each && !lodash_default().includes(selectedItems, each)).map(r => processItemSupplier(activityItemsForm, r));
      setSelectedItems(lodash_default().concat(selectedItems, filteredRows));
    } else {
      var changeedRowKeys = Array.from(changeRows, item => item.itemId);

      var _filteredRows = selectedItems.filter(each => !changeedRowKeys.includes(each.itemId));

      setSelectedItems(_filteredRows);
    }
  };

  var selectedRowKeys = lodash_default().map(selectedItems, 'itemId');

  var chkProps = r => ({
    disabled: !!r.notUseReason
  });

  var tableSelectionProps = {
    // rowSelectCallback: _.noop,
    tableOptions: {
      rowKey: 'itemId',
      rowSelection: {
        getCheckboxProps: chkProps,
        selectedRowKeys,
        onSelect: onSelect,
        // onSelectAll: onSelectAll
        type: 'radio'
      },
      onRow: () => {}
    }
  };

  var onOk = () => {
    modalProps.onOk();
    modalProps.handleConfirm(selectedItems.map(o => {
      var selectedSupplier = lodash_default().clone(o.selectedSupplier);

      delete o.selectedSupplier;
      delete o.supplier;
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, o), selectedSupplier);
    }));

    if (form.current) {
      form.current.setFieldsValue({
        itemId: selectedRowKeys
      });
    }
  };

  var resetCateId2 = (0,react.useCallback)(value => {
    if (form.current) {
      form.current.setFieldsValue({
        cateId2: value
      });
    }
  }, [form]);

  var _useSupplier = (0,useSupplier/* default */.Z)({
    cityCode: categoryReqParams.cityCode
  }),
      _useSupplier2 = (0,slicedToArray/* default */.Z)(_useSupplier, 3),
      loading = _useSupplier2[0],
      results = _useSupplier2[1],
      search = _useSupplier2[2];

  var _useCategory = (0,useCategory/* default */.Z)(categoryReqParams),
      _useCategory2 = (0,slicedToArray/* default */.Z)(_useCategory, 3),
      cateList1 = _useCategory2[0],
      cateList2 = _useCategory2[1],
      setCat1Id = _useCategory2[2];
  /** 类目选择 */


  var onCategoryChange = val => {
    setcurSelectCategoryId(val);
  };

  var formFields = [{
    label: '商品查询',
    fieldOptions: {
      placeholder: '名称/编码/条码/PLU码'
    },
    name: 'itemName',
    type: 'INPUT'
  }, {
    label: '品牌',
    name: 'brandId',
    widget: /*#__PURE__*/react.createElement(brandSearch, {
      placeholder: "\u8BF7\u8F93\u5165\u5546\u54C1\u54C1\u724C"
    })
  }, {
    label: '供应商名称',
    name: 'supplierCode',
    type: 'SELECT',
    dataList: results,
    fieldOptions: {
      loading,
      onSearch: lodash_default().debounce(value => {
        var _value = lodash_default().trim(value);

        if (_value.length) {
          search(_value);
        }
      }, 1e3)
    }
  }, {
    label: '商品类目',
    name: 'categoryId',
    widget: /*#__PURE__*/react.createElement(GoodsCategorySelect/* default */.Z, {
      setCategoryId: onCategoryChange
    })
  }];
  var formBuilderProps = {
    ref: form,
    elements: formFields,
    callbackHandler: searchHandler,
    onReset: () => {
      resetCateId2(null);
    },
    formOptions: {
      onValuesChange: (changes, values) => {
        var cateId1 = values.cateId1;

        if (lodash_default().has(changes, 'cateId1')) {
          var value = cateId1 ? '' : null;
          resetCateId2(value);
        }
      }
    }
  };
  var activityItemsFormProps = {
    component: false,
    form: activityItemsForm,
    onValuesChange: changes => {
      var _changes = Array.from(Object.entries(changes));

      var changesCount = 0;

      var newList = lodash_default().cloneDeep(selectedItems);

      _changes.forEach(_ref => {
        var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
            k = _ref2[0],
            v = _ref2[1];

        var index = lodash_default().findIndex(newList, {
          itemId: k
        });

        if (!~index) {
          return;
        }

        var target = newList[index];

        var selectedSupplier = lodash_default().find(target.supplier, {
          supplierCode: v
        });

        var newTarget = lodash_default().merge(target, {
          selectedSupplier
        });

        newList[index] = newTarget;
        changesCount++;
      });

      if (changesCount) {
        setSelectedItems(newList);
      }
    }
  };
  return /*#__PURE__*/react.createElement(modal/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, modalProps), {}, {
    onOk
  }), /*#__PURE__*/react.createElement(FormBuilder/* default */.Z, formBuilderProps), /*#__PURE__*/react.createElement(es_form/* default */.Z, activityItemsFormProps, /*#__PURE__*/react.createElement(CommonTable/* default */.Z, (0,esm_extends/* default */.Z)({
    columns: columns,
    queryDataUrl: "mms.item.itemSearch",
    searchParams: searchParams
  }, tableSelectionProps))));
}

var GoodsSelector = props => {
  var _props$itemSearchReqP = props.itemSearchReqParams,
      itemSearchReqParams = _props$itemSearchReqP === void 0 ? {} : _props$itemSearchReqP,
      _props$categoryReqPar = props.categoryReqParams,
      categoryReqParams = _props$categoryReqPar === void 0 ? {} : _props$categoryReqPar,
      beforeShow = props.beforeShow,
      handleConfirm = props.handleConfirm,
      disabled = props.disabled;

  var _useState7 = (0,react.useState)(false),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      visible = _useState8[0],
      setVisible = _useState8[1];

  var show = () => {
    if (beforeShow) {
      return beforeShow().then(() => setVisible(true)).catch((lodash_default()).noop);
    }

    setVisible(true);
  };

  var hide = () => setVisible(false);

  var modalProps = {
    title: '商品',
    width: 1100,
    height: 600,
    visible,
    onOk: hide,
    onCancel: hide,
    handleConfirm
  };
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(es_form/* default.Item */.Z.Item, {
    name: "itemId"
  }, /*#__PURE__*/react.createElement("input", {
    onClick: show,
    disabled: disabled,
    className: "ant-input"
  })), visible && /*#__PURE__*/react.createElement(CombineFormAndTable, {
    modalProps,
    categoryReqParams,
    itemSearchReqParams
  }));
};

/* harmony default export */ var components_GoodsSelector = (GoodsSelector);

/***/ }),

/***/ 94554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_api; }
});

// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
;// CONCATENATED MODULE: ./src/utils/req.ts


var req = (url, param) => {
  return new Promise((resolve, reject) => {
    try {
      (0,ypRequest/* default */.Z)(url, param).then(res => {
        var success = res.success,
            result = res.result;

        if (success) {
          resolve(result);
        } else {
          reject(res);
        }
      });
    } catch (error) {
      reject(error);
    }
  });
};

/* harmony default export */ var utils_req = (req);
;// CONCATENATED MODULE: ./src/pages/Promotion/utils/api.ts

var methods = new Map([['getActivitys', 'mms.activity.queryActivityList'], ['createActivity', 'mms.activity.addActivity'], ['updateActivity', 'mms.activity.updateActivity'], ['getActivity', 'mms.activity.queryActivityById'], ['getActivitycoupon', 'mms.coupon.queryCouponById'], ['updateActivityStatus', 'mms.activity.updateActivityStatus'], ['getCitys', 'auth.subject.listSubjectCity'], ['getItems', 'mms.item.itemSearch'], ['getCategorys', 'mms.item.queryCategoryListByParentId'], ['getShops', 'mms.merchant.listShop'], ['getSupplieries', 'mms.merchant.querySupplierList'], ['getImportItems', 'mms.file.activityItemUpload'], ['queryOperationGroupList', 'mms.merchant.queryOperationGroupList'], ['getTimeDiscountActivitys', 'mms.activityService.queryActivityList'], // 限时折扣-查询活动列表
['createTimeDiscountActivity', 'mms.activityService.createActivity'], // 限时折扣-查询创建活动
['updateTimeDiscountActivity', 'mms.activityService.updateActivity'], // 编辑
['getTimeDiscountActivityDetail', 'mms.activityService.queryActivityDetail'], // 详情
['publishTimeDiscountActivity', 'mms.activityService.publishActivity'], // 发布
['closeTimeDiscountActivity', 'mms.activityService.closeActivity'], // 关闭
['multipleSearch', 'phoenix.GeneralQueryService.multipleSearch'], // 关闭
['queryMemberDayDetail', 'mms.MemberDayActivityService.queryMemberDayDetail'], // 会员88折查看详情
['queryStoreList', 'mms.merchantService.queryStoreList'] // 会员88折查看详情
]);
var api = [...methods.entries()].reduce((o, m) => {
  o[m[0]] = utils_req.bind(null, m[1]);
  return o;
}, Object.create(null));
/* harmony default export */ var utils_api = (api);

/***/ }),

/***/ 50294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8870);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);



var isNumber = lodash__WEBPACK_IMPORTED_MODULE_0___default().overEvery([Boolean, isFinite]);

function toNumber(n) {
  return isNumber(n) ? Number(n) : 0;
} // n * 100


var divideHundred = lodash__WEBPACK_IMPORTED_MODULE_0___default().partialRight((lodash__WEBPACK_IMPORTED_MODULE_0___default().divide), 100); // n / 100


var multiplHundredy = lodash__WEBPACK_IMPORTED_MODULE_0___default().partialRight((lodash__WEBPACK_IMPORTED_MODULE_0___default().multiply), 100); // https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat


var digits = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  useGrouping: false
};
var CNY = {
  style: 'currency',
  currency: 'CNY',
  useGrouping: true
};
var notation = {
  notation: 'compact'
};
var formatOptions = {
  digits,
  CNY,
  notation,
  digitsCNY: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)({}, digits), CNY),
  readable: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)({}, digits), notation),
  readableCNY: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)({}, digits), notation), CNY)
};

function numberFormat(n, opts) {
  opts = opts || formatOptions.digits;
  var nf = new Intl.NumberFormat('zh-Hans-CN', opts);
  return nf.format(n);
}

var digitsFunc = lodash__WEBPACK_IMPORTED_MODULE_0___default().partialRight(numberFormat, formatOptions.digits);

var digitsCNYFunc = lodash__WEBPACK_IMPORTED_MODULE_0___default().partialRight(numberFormat, formatOptions.digitsCNY);

var readableFunc = lodash__WEBPACK_IMPORTED_MODULE_0___default().partialRight(numberFormat, formatOptions.readable);

var readableCNYFunc = lodash__WEBPACK_IMPORTED_MODULE_0___default().partialRight(numberFormat, formatOptions.readableCNY);

var _toYuan = lodash__WEBPACK_IMPORTED_MODULE_0___default().flow([toNumber, divideHundred]);

var _toYuanWithDigits = lodash__WEBPACK_IMPORTED_MODULE_0___default().flow([toNumber, divideHundred, digitsFunc]); // 100 => 1  12345 => 123.45


var toYuan = lodash__WEBPACK_IMPORTED_MODULE_0___default().flow([_toYuanWithDigits, toNumber]); // 123.45 => 12345  0.07 => 700


var toCent = lodash__WEBPACK_IMPORTED_MODULE_0___default().flow([toNumber, multiplHundredy, digitsFunc, toNumber]); // 1 => '1.00', 1234.56 => '1234.56'


var format = lodash__WEBPACK_IMPORTED_MODULE_0___default().flow([toNumber, digitsFunc]); // 100 => '1.00', 123456 => '1234.56'


var formatToYuan = _toYuanWithDigits; // 1 => '￥1.00', 1234.56 => '￥1,234.56.00'

var formatCNY = lodash__WEBPACK_IMPORTED_MODULE_0___default().flow([toNumber, digitsCNYFunc]); // 100 => '￥1.00', 123456 => '￥1,234.46'


var formatToYuanCNY = lodash__WEBPACK_IMPORTED_MODULE_0___default().flow([_toYuan, digitsCNYFunc]); // 没有 千, 十万，百万千万...
// 123456 => '12.35万' 123456789 => '1.23亿'  12e11 => '1.20兆'


var formatReadable = lodash__WEBPACK_IMPORTED_MODULE_0___default().flow([toNumber, readableFunc]); // 123456 => '￥12.35万' 123456789 => '￥1.23亿'  12e11 => '￥1.20兆'


var formatReadableCNY = lodash__WEBPACK_IMPORTED_MODULE_0___default().flow([toNumber, readableCNYFunc]); // 12345678 => '12.35万' 12345678900 => '1.23亿'  12e13 => '1.20兆'


var formatToYuanReadable = lodash__WEBPACK_IMPORTED_MODULE_0___default().flow([_toYuan, readableFunc]); // ￥12345678 => '￥12.35万' 12345678900 => '￥1.23亿'  12e13 => '￥1.20兆'


var formatToYuanReadableCNY = lodash__WEBPACK_IMPORTED_MODULE_0___default().flow([_toYuan, readableCNYFunc]);

var price = {
  toNumber,
  divideHundred,
  multiplHundredy,
  toYuan,
  toCent,
  // for calc
  format,
  formatToYuan,
  formatCNY,
  formatToYuanCNY,
  formatReadable,
  formatReadableCNY,
  formatToYuanReadable,
  formatToYuanReadableCNY,
  formatOptions,
  numberFormat
};
/* harmony default export */ __webpack_exports__["Z"] = (price);

/***/ }),

/***/ 72427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mJ": function() { return /* binding */ ORDER_INFO; },
/* harmony export */   "Qm": function() { return /* binding */ CANCEL_ORDER; },
/* harmony export */   "kX": function() { return /* binding */ ORDER_LIST; },
/* harmony export */   "tA": function() { return /* binding */ SAVE_ORDER; },
/* harmony export */   "yG": function() { return /* binding */ IMPORT_ORDER; },
/* harmony export */   "ZK": function() { return /* binding */ SUBMIT_ORDER; },
/* harmony export */   "BK": function() { return /* binding */ SAVE_ORDER_LINE; },
/* harmony export */   "EY": function() { return /* binding */ AUDIT_ORDER_LINE; },
/* harmony export */   "Hc": function() { return /* binding */ ORDER_LINE_DETAIL_LIST; },
/* harmony export */   "tt": function() { return /* binding */ DELETE_ORDER_LINE; },
/* harmony export */   "km": function() { return /* binding */ CLEAN_ORDER_LINE; },
/* harmony export */   "d_": function() { return /* binding */ ORDER_FLOW; },
/* harmony export */   "v4": function() { return /* binding */ EXPORT_COMBINE; },
/* harmony export */   "iK": function() { return /* binding */ AUDIT_ORDER; },
/* harmony export */   "VQ": function() { return /* binding */ CHECK_REVERSE; },
/* harmony export */   "Ck": function() { return /* binding */ CONFIRM_REVERSE; },
/* harmony export */   "FG": function() { return /* binding */ DOWNLOAD_PRICE_TEMPLATE; },
/* harmony export */   "nq": function() { return /* binding */ IMPORT_PRICE; },
/* harmony export */   "kz": function() { return /* binding */ BLOCK_ORDER; },
/* harmony export */   "NP": function() { return /* binding */ PRE_ORDER_LIST; },
/* harmony export */   "vQ": function() { return /* binding */ PRE_ORDER_INFO; },
/* harmony export */   "I0": function() { return /* binding */ PRE_ORDER_SAVE; },
/* harmony export */   "lj": function() { return /* binding */ PRE_ORDER_LINE_LIST; },
/* harmony export */   "Bz": function() { return /* binding */ PRE_ORDER_IMPORT; },
/* harmony export */   "U2": function() { return /* binding */ PRE_ORDER_LINE_SAVE; },
/* harmony export */   "_M": function() { return /* binding */ PRE_ORDER_LINE_DELETE; },
/* harmony export */   "Ii": function() { return /* binding */ PRE_ORDER_SUBMIT; },
/* harmony export */   "ZW": function() { return /* binding */ PRE_ORDER_CANCEL; },
/* harmony export */   "dQ": function() { return /* binding */ PRE_ORDER_CLEAN; },
/* harmony export */   "s6": function() { return /* binding */ PRE_ORDER_LIST_BYID; },
/* harmony export */   "NO": function() { return /* binding */ ALLOW_CHANGE_PRICE; },
/* harmony export */   "nM": function() { return /* binding */ PRODUCT_DETAIL; },
/* harmony export */   "xX": function() { return /* binding */ SUPPLIER_LIST; },
/* harmony export */   "DE": function() { return /* binding */ REFERENCE_PRICE; },
/* harmony export */   "l8": function() { return /* binding */ STATISTICS; },
/* harmony export */   "kO": function() { return /* binding */ APPOINTMENT_CREAT; },
/* harmony export */   "Wx": function() { return /* binding */ CHECK_PURCHAESE_STATUS; },
/* harmony export */   "RC": function() { return /* binding */ ORDER_DETAIL; },
/* harmony export */   "_w": function() { return /* binding */ ORDER_EXPORT; },
/* harmony export */   "n2": function() { return /* binding */ ORDER_DETAIL_HEADER; },
/* harmony export */   "tm": function() { return /* binding */ SUPPLIER_TERM_VALIDITY; },
/* harmony export */   "uF": function() { return /* binding */ CONTRACT_QUERY; }
/* harmony export */ });
/* unused harmony exports ORDER_LIST_BY_PREID, ORDER_CLOSE, RECEIPT_RETURN, RECEIVE_ORDER, DOWNLOAD_TEMPLATE, SUPPLIER_INFO, BAR_CODE_LIST, PRODUCT_ID_NAMELIKE, PRODUCT_CODE_NAMELIKE */
/**
 * 采购单
 */
// 采购单主信息 详情
var ORDER_INFO = 'purchase.order.purchaseOrderInfo'; // 根据预处理单号查采购单列表

var ORDER_LIST_BY_PREID = 'purchase.order.purchaseOrderListByPreId'; // 采购关单接口

var ORDER_CLOSE = 'purchase.order.notifyPurchaseOrderClose'; // 采购单作废接口

var CANCEL_ORDER = 'purchase.order.cancelPurchaseOrder'; // 采购单列表查询接口

var ORDER_LIST = 'purchase.order.purchaseOrderList'; // 采购单创建接口

var SAVE_ORDER = 'purchase.order.savePurchaseOrder'; // 采购单导入接口

var IMPORT_ORDER = 'purchase.order.importPurchaseOrderLine'; // 采购单提交接口

var SUBMIT_ORDER = 'purchase.order.submitPurchaseOrder'; // 采购单明细保存接口

var SAVE_ORDER_LINE = 'purchase.order.savePurchaseOrderLine'; // 采购单明细审核接口

var AUDIT_ORDER_LINE = 'purchase.order.auditPurchaseOrderDetail'; // 采购单明细分页查询接口

var ORDER_LINE_DETAIL_LIST = 'purchase.order.purchaseOrderDetailPageInfo'; // 采购单明细删除接口

var DELETE_ORDER_LINE = 'purchase.order.deletePurchaseOrderLine'; // 采购单清空明细接口

var CLEAN_ORDER_LINE = 'purchase.order.cleanPurchaseOrderDetail'; // 采购回执接口

var RECEIPT_RETURN = 'purchase.order.notifyPurchaseOrderReturnReceipt'; // 采购履行回调接口

var RECEIVE_ORDER = 'purchase.order.receiveOrderNotifyForWMS'; // 导出任务列表
// export const EXPORT_TASK_LIST = 'purchase.export.getExportTaskList'
// 采购单商品收退货流水、交货信息

var ORDER_FLOW = 'purchase.order.purchaseOrderFLowPage'; // 采购单合并导出

var EXPORT_COMBINE = 'purchase.order.mergeExportPurchaseOrder'; // 批量审核

var AUDIT_ORDER = 'purchase.order.auditPurchaseOrder'; // 下载模板

var DOWNLOAD_TEMPLATE = 'purchase.downlaod.getTemplate'; // 检查采购单是否允许红冲

var CHECK_REVERSE = 'purchase.order.checkPurchaseOrderReverse'; //  确认红冲

var CONFIRM_REVERSE = 'purchase.order.confirmReverse'; // 下载采购单价格模板

var DOWNLOAD_PRICE_TEMPLATE = 'purchase.order.downloadGoodsPriceTemplate'; // 导入更新采购单价格（异步）

var IMPORT_PRICE = 'purchase.order.batchModifyGoodsPrice'; // 供应商查询

var SUPPLIER_INFO = 'supplier.basicdata.querySupplierBaseInfoPage'; // 堵单

var BLOCK_ORDER = 'purchase.order.queryPurchaseBlockingReason';
/**
 * 采购分配单
 */
// 查询采购分配单列表

var PRE_ORDER_LIST = 'purchase.require.purchasePreOrderList'; // 采购分配单主单详情接口

var PRE_ORDER_INFO = 'purchase.require.purchasePreOrder'; // 采购分配单主单保存接口

var PRE_ORDER_SAVE = 'purchase.require.savePurchasePreOrder'; // 查询-采购分配单-商品明细列表

var PRE_ORDER_LINE_LIST = 'purchase.require.purchasePreOrderLines'; // 导入采购分配单商品明细

var PRE_ORDER_IMPORT = 'purchase.require.importPurchasePreOrderLine'; // 采购分配单商品明细保存接口

var PRE_ORDER_LINE_SAVE = 'purchase.require.savePurchasePreOrderLine'; // 采购分配单商品明细删除接口

var PRE_ORDER_LINE_DELETE = 'purchase.require.deletePurchasePreOrderLine'; // 采购分配单主单提交接口

var PRE_ORDER_SUBMIT = 'purchase.require.submitPurchasePreOrder'; // 采购分配单主单作废接口

var PRE_ORDER_CANCEL = 'purchase.require.cancelPurchasePreOrder'; // 采购分配单商品明细清空接口

var PRE_ORDER_CLEAN = 'purchase.require.clearPurchasePreOrderLine'; // 采购预处理单详情下的订单查询

var PRE_ORDER_LIST_BYID = 'purchase.order.purchaseOrderListByPreId'; // 查询是否能够改价-根据一级品类

var ALLOW_CHANGE_PRICE = 'purchase.product.allowChangePrice'; // 根据编码查询条码列表

var BAR_CODE_LIST = 'purchase.product.queryBarcodeByProductId'; // 模糊搜索 商品编码

var PRODUCT_ID_NAMELIKE = 'purchase.product.queryProductIdByKey'; // 模糊搜索 商品条码

var PRODUCT_CODE_NAMELIKE = 'purchase.product.queryBarcodeByKey'; // 商品详情

var PRODUCT_DETAIL = 'purchase.product.queryInsertPlaceProduct'; // 供销商列表

var SUPPLIER_LIST = 'purchase.product.queryProductSupplier'; // 参考价

var REFERENCE_PRICE = 'purchase.purchase.queryPrePurchaseReferencePrice'; // 统计

var STATISTICS = 'purchase.require.statPurchasePreOrderInfo'; //预约单创建

var APPOINTMENT_CREAT = 'busops.appointmentOrder.purchaseOrderManualAppointCreate'; //检验采购单是否可预约

var CHECK_PURCHAESE_STATUS = 'busops.scmPurchase.checkPurchaseOrderCanAppointment'; // 采购明细列表查询

var ORDER_DETAIL = 'purchase.pagePurchaseOrderDetail'; // 采购明细列表导出

var ORDER_EXPORT = 'purchase.exportPurchaseOrderDetail'; // 采购明细列表汇总查询

var ORDER_DETAIL_HEADER = 'purchase.aggregationPurchaseOrderDetail'; // 查询订单有效期

var SUPPLIER_TERM_VALIDITY = 'scm.purchase.queryEffectiveDateBySupplier'; // 合同查询

var CONTRACT_QUERY = 'contract.contactQuery.pageContractList';

/***/ }),

/***/ 51145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildCategoryMeta": function() { return /* binding */ buildCategoryMeta; },
/* harmony export */   "buildLightCategoryTree": function() { return /* binding */ buildLightCategoryTree; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



/**
 * 采购明细 - 品类一二三级联动（原生 select，避免 antd Select 受控更新卡死）
 * 「一级/二级/三级」仅作占位展示，不出现在下拉选项列表中
 */

var MAX_SECOND = 2000;
var MAX_THIRD = 1000;
var selectStyle = {
  width: '33.33%',
  height: 32,
  border: '1px solid #d9d9d9',
  borderRadius: 2,
  padding: '0 8px',
  fontSize: 14,
  color: 'rgba(0,0,0,.65)',
  background: '#fff',
  outline: 'none',
  boxSizing: 'border-box'
};

function flattenThird(thirdMap) {
  if (!thirdMap || typeof thirdMap !== 'object') {
    return [];
  }

  var result = [];
  var keys;

  try {
    keys = Object.keys(thirdMap);
  } catch (e) {
    return [];
  }

  var len = Math.min(keys.length, MAX_THIRD);

  for (var i = 0; i < len; i++) {
    var _item$categoryName;

    var item = thirdMap[keys[i]];

    if (!item || item.categoryId == null) {
      continue;
    }

    result.push({
      value: String(item.categoryId),
      label: String((_item$categoryName = item.categoryName) !== null && _item$categoryName !== void 0 ? _item$categoryName : '')
    });
  }

  return result;
}
/** 只构建到二级；三级原始 map 存入 Map，切换二级时再展开 */


function buildCategoryMeta(categoryList) {
  var thirdRawMap = new Map();

  if (!(categoryList !== null && categoryList !== void 0 && categoryList.length)) {
    return {
      treeData: [],
      thirdRawMap
    };
  }

  var treeData = categoryList.map(first => {
    var _first$others, _first$label;

    var seconds = [];
    var secondMap = first === null || first === void 0 ? void 0 : (_first$others = first.others) === null || _first$others === void 0 ? void 0 : _first$others.childCategoryList;

    if (secondMap && typeof secondMap === 'object') {
      var secondKeys = Object.keys(secondMap);
      var secondLen = Math.min(secondKeys.length, MAX_SECOND);

      for (var i = 0; i < secondLen; i++) {
        var _second$categoryName;

        var second = secondMap[secondKeys[i]];

        if (!second || second.categoryId == null) {
          continue;
        }

        var secondId = String(second.categoryId);
        var firstId = String(first.value);

        if (second.childCategoryList) {
          thirdRawMap.set("".concat(firstId, "_").concat(secondId), second.childCategoryList);
        }

        seconds.push({
          value: secondId,
          label: String((_second$categoryName = second.categoryName) !== null && _second$categoryName !== void 0 ? _second$categoryName : '')
        });
      }
    }

    return {
      value: String(first.value),
      label: String((_first$label = first.label) !== null && _first$label !== void 0 ? _first$label : ''),
      children: seconds
    };
  });
  return {
    treeData,
    thirdRawMap
  };
}
function buildLightCategoryTree(categoryList) {
  return buildCategoryMeta(categoryList).treeData;
}

function CategorySelect(props) {
  var meta = props.meta,
      onChange = props.onChange,
      defaultValue = props.defaultValue;
  var treeData = (meta === null || meta === void 0 ? void 0 : meta.treeData) || [];
  var thirdRawMap = meta === null || meta === void 0 ? void 0 : meta.thirdRawMap;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => ({
    first: (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.first) != null ? String(defaultValue.first) : undefined,
    second: (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.second) != null ? String(defaultValue.second) : undefined,
    third: (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.third) != null ? String(defaultValue.third) : undefined
  })),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)(_useState3, 2),
      thirdOptions = _useState4[0],
      setThirdOptions = _useState4[1];

  var thirdCacheRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new Map());
  var firstOptions = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => treeData.map(_ref => {
    var v = _ref.value,
        label = _ref.label;
    return {
      value: v,
      label
    };
  }), [treeData]);
  var secondOptions = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (!value.first) {
      return [];
    }

    var first = treeData.find(item => item.value === value.first);
    return ((first === null || first === void 0 ? void 0 : first.children) || []).map(_ref2 => {
      var v = _ref2.value,
          label = _ref2.label;
      return {
        value: v,
        label
      };
    });
  }, [treeData, value.first]);

  var emit = next => {
    setValue(next);
    onChange === null || onChange === void 0 ? void 0 : onChange(next);
  };

  var ensureThirdOptions = (first, second) => {
    if (!first || !second) {
      setThirdOptions([]);
      return;
    }

    var cacheKey = "".concat(first, "_").concat(second);
    var cached = thirdCacheRef.current.get(cacheKey);

    if (cached) {
      setThirdOptions(cached);
      return;
    }

    var list = flattenThird(thirdRawMap === null || thirdRawMap === void 0 ? void 0 : thirdRawMap.get(cacheKey));
    thirdCacheRef.current.set(cacheKey, list);
    setThirdOptions(list);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: {
      display: 'flex',
      width: '100%'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("select", {
    style: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)({}, selectStyle), {}, {
      borderRight: 'none'
    }),
    value: value.first || '',
    onChange: e => {
      var first = e.target.value || undefined;
      setThirdOptions([]);
      emit({
        first,
        second: undefined,
        third: undefined
      });
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("option", {
    value: "",
    hidden: true
  }, "\u4E00\u7EA7"), firstOptions.map(item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("option", {
    key: item.value,
    value: item.value
  }, item.label))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("select", {
    style: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)({}, selectStyle), {}, {
      borderRight: 'none'
    }),
    value: value.second || '',
    onChange: e => {
      var second = e.target.value || undefined;
      setThirdOptions([]);
      emit({
        first: value.first,
        second,
        third: undefined
      });
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("option", {
    value: "",
    hidden: true
  }, "\u4E8C\u7EA7"), secondOptions.map(item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("option", {
    key: item.value,
    value: item.value
  }, item.label))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("select", {
    style: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)({}, selectStyle), {}, {
      width: '33.34%'
    }),
    value: value.third || '',
    onFocus: () => ensureThirdOptions(value.first, value.second),
    onClick: () => ensureThirdOptions(value.first, value.second),
    onChange: e => {
      var third = e.target.value || undefined;
      emit({
        first: value.first,
        second: value.second,
        third
      });
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("option", {
    value: "",
    hidden: true
  }, "\u4E09\u7EA7"), thirdOptions.map(item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("option", {
    key: item.value,
    value: item.value
  }, item.label))));
}

/* harmony default export */ __webpack_exports__["default"] = (CategorySelect);

/***/ }),

/***/ 10688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(57016);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(71577);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71720);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_FormBuilder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5670);
/* harmony import */ var _components_EditableTable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72927);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24731);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7704);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96534);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26715);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(72427);











/**
 * 商家商品
 */










var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 10
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 14
    }
  }
};

function GoodsEditableModal(props) {
  var formData = props.formData,
      placeList = props.placeList,
      allowChangePrice = props.allowChangePrice;
  var merchantId = formData.merchantId,
      preProcessOrderNo = formData.preProcessOrderNo,
      orderDirect = formData.orderDirect,
      firstCategoryId = formData.firstCategoryId,
      secondCategoryId = formData.secondCategoryId; // 默认查询参数

  var defaultSearchParams = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => ({
    condition: {
      merchantId,
      logisticMode: _config_enums__WEBPACK_IMPORTED_MODULE_10__/* .LogisticModeMap.NOMORL */ .oB.NOMORL,
      firstCategoryId,
      secondCategoryId
    },
    billType: orderDirect
  }), [firstCategoryId, merchantId, orderDirect, secondCategoryId]);
  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_11__/* .useDispatch */ .I0)();

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(46),
      mappingList = _useMapping.mappingList;

  var table = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
  var form = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null); // 能否关闭浮层

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState, 2),
      canClose = _useState2[0],
      setCanClose = _useState2[1]; // 判断多个请求之后状态


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState3, 2),
      queryState = _useState4[0],
      setQuery = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(defaultSearchParams),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState5, 2),
      searchParams = _useState6[0],
      setSearchParams = _useState6[1]; // 更新表格数据


  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState7, 2),
      updateDataSource = _useState8[0],
      setUpdateDataSource = _useState8[1];

  var placeId = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => searchParams.condition.placeId, [searchParams.condition.placeId]);
  var secondId = isNaN(+secondCategoryId) ? undefined : +secondCategoryId; // 二级品类下拉框

  var secondList = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    var _category$others;

    var list = mappingList.get(46);

    if (!list || !list.length) {
      return [];
    }

    var category = list.find(v => Number(v.value) === Number(firstCategoryId));

    if (category !== null && category !== void 0 && (_category$others = category.others) !== null && _category$others !== void 0 && _category$others.childCategoryList) {
      return Object.values(category.others.childCategoryList).map(v => ({
        value: v.categoryId,
        label: v.categoryName
      }));
    }

    return [];
  }, [firstCategoryId, mappingList]);
  var formfields = [{
    label: '地点',
    name: 'placeId',
    required: true,
    type: 'SELECT',
    dataList: placeList || []
  }, {
    label: '商品模糊',
    name: 'queryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '商品精准',
    name: 'accurateQueryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '商品品类',
    name: 'secondCategoryId',
    type: 'SELECT',
    dataList: secondList || [],
    initialValue: secondId === 0 || !secondId ? undefined : secondId,
    fieldOptions: {
      disabled: !!secondId
    }
  }, {
    label: '品牌名称',
    name: 'brandName',
    type: 'INPUT'
  }];
  var columns = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => [{
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 170,
    fixed: true
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 90
  }, {
    title: '商品条码',
    dataIndex: 'goodsBarCode',
    key: 'goodsBarCode',
    width: 140
  }, {
    title: '二类类目',
    dataIndex: 'secondCategoryName',
    key: 'secondCategoryName',
    width: 100
  }, {
    title: '品牌名称',
    dataIndex: 'brandName',
    key: 'brandName',
    width: 110
  }, {
    title: '单位',
    dataIndex: 'specUnit',
    key: 'specUnit',
    align: 'right',
    width: 90
  }, {
    title: '数量',
    dataIndex: 'goodsCopies',
    key: 'goodsCopies',
    width: 150,
    editable: true,
    render: (t, r, i, fn) => {
      // 非称重商品为正整数，称重商品保留三位小数
      var isWeight = r.isWeigh === 1;

      if (fn) {
        var params = {
          fieldType: 'INPUT',
          fieldOptions: {
            formatter: value => isWeight ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_9__/* .exchageToNum3 */ .hY)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_9__/* .exchageToNum1 */ .Ly)(value)
          }
        };
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center'
          }
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
          style: {
            flex: 1
          }
        }, fn(params)), r.barCodeUnit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "/", r.barCodeUnit));
      }

      return t && isWeight ? (Math.floor(+t * 1000) / 1000).toFixed(3) : t || '';
    }
  }, {
    title: '参考价',
    dataIndex: 'referencePrice',
    key: 'referencePrice',
    width: 110,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " \u5143").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '单价(含税)',
    dataIndex: 'unitPrice',
    width: 120,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " \u5143").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '金额(含税)',
    dataIndex: 'amount',
    key: 'amount',
    width: 160,
    editable: true,
    render: (t, r, i, fn) => {
      if (fn && allowChangePrice) {
        var params = {
          fieldType: 'INPUT',
          fieldOptions: {
            formatter: _utils_common__WEBPACK_IMPORTED_MODULE_9__/* .exchageToNum3 */ .hY
          }
        };
        return fn(params);
      }

      return t ? (Math.floor(+t * 1000) / 1000).toFixed(3) : '';
    }
  }, {
    title: '库存量',
    dataIndex: 'stock',
    key: 'stock',
    width: 110,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " ").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '规格描述',
    dataIndex: 'specDesc',
    key: 'specDesc',
    align: 'right',
    width: 90,
    render: t => t || '-'
  }], [allowChangePrice]);
  var searchHandler = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((state, values) => {
    if (state === 'error') return;
    setSearchParams(v => {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, v), {}, {
        condition: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, v.condition), values)
      });
    });
  }, []);
  var resetFields = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    var _form$current;

    (_form$current = form.current) === null || _form$current === void 0 ? void 0 : _form$current.validateFields();
  }, []); // 获取参考价和库存，并更新列表数据

  var setTableDataAfterRequest = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().mark(function _callee(dataList) {
      var _res$0$result$list, _res$, _res$1$list, _res$2;

      var _dataList$reduce, referList, extList, referenceParams, extInfoParams, requestArr, res, referenceList, stockList, maps, stockMaps;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _dataList$reduce = dataList.reduce((pre, next) => {
                return {
                  referList: pre.referList.concat({
                    placeId: next.placeId,
                    goodsId: next.goodsId
                  }),
                  extList: pre.extList.concat({
                    merchantId,
                    placeId,
                    goodsId: next.goodsId
                  })
                };
              }, {
                referList: [],
                extList: []
              }), referList = _dataList$reduce.referList, extList = _dataList$reduce.extList; // 参考价的请求参数

              referenceParams = {
                orderDirect,
                merchantId,
                firstCategoryId,
                goods: referList
              }; // 库存等数据参数

              extInfoParams = {
                needPlaceStock: true,
                param: extList
              }; // 如果当前页面类型是批发销售时，需要额外发送接口请求特定的数据

              requestArr = [(0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_16__/* .REFERENCE_PRICE */ .DE, referenceParams), dispatch({
                type: 'purchase/queryProductExtInfo',
                payload: extInfoParams
              })];
              _context.next = 6;
              return Promise.all(requestArr);

            case 6:
              res = _context.sent;
              // 参考价list
              referenceList = (_res$0$result$list = (_res$ = res[0]) === null || _res$ === void 0 ? void 0 : _res$.result.list) !== null && _res$0$result$list !== void 0 ? _res$0$result$list : []; // 库存list

              stockList = (_res$1$list = (_res$2 = res[1]) === null || _res$2 === void 0 ? void 0 : _res$2.list) !== null && _res$1$list !== void 0 ? _res$1$list : []; // 获取商品编码与参考价的映射

              maps = referenceList.reduce((pre, next) => {
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, pre), {}, {
                  [next.goodsId]: {
                    referencePrice: next.referencePrice
                  }
                });
              }, {}); // 库存等

              stockMaps = stockList.reduce((pre, next) => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, pre), {}, {
                [next.goodsId]: {
                  stock: next.stock
                }
              }), {}); // 给「goodsId」对应的数据设置参考价

              return _context.abrupt("return", dataList.map(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, v), maps[v.goodsId]), stockMaps[v.goodsId]), {}, {
                unitPrice: undefined
              })));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function setTableDataAfterRequest(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * 改变表格内容时，触发保存
   */


  var changeTable = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().mark(function _callee2(data) {
      var currentCell, currentRowOldData, currentRow, params, res, newRow;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currentCell = data.currentCell, currentRowOldData = data.currentRowOldData, currentRow = data.currentRow;

              if (!lodash__WEBPACK_IMPORTED_MODULE_4___default().isEmpty(currentCell)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              if (currentRow['goodsCopies']) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return");

            case 5:
              // if (Number(currentRow.amount) === 0) {
              //   message.warning('单价/金额不可为0')
              //   return
              // }
              params = {
                id: currentRow.id,
                merchantId,
                preProcessOrderNo,
                placeId,
                // 地点Id
                goodsId: currentRow.goodsId,
                // 商品编码
                goodsBarCode: currentRow.goodsBarCode,
                suppCode: currentRow.supplierCode,
                goodsCopies: currentRow.goodsCopies,
                amount: currentRow.amount
              };
              setQuery(prev => {
                return prev + 1;
              });
              _context2.next = 9;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_16__/* .PRE_ORDER_LINE_SAVE */ .U2, params);

            case 9:
              res = _context2.sent;
              setQuery(prev => {
                return prev - 1;
              }); // console.log('111111')

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_17__.default.success("".concat(currentRow.id ? '修改' : '添加', "\u5546\u54C1\u3010").concat(currentRow.goodsName, "\u3011\u6210\u529F"));

                newRow = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, currentRow), res === null || res === void 0 ? void 0 : res.result);
                setUpdateDataSource(arr => [...arr, newRow]);
              } else {
                setUpdateDataSource([(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, currentRow), currentRowOldData), {}, {
                  amount: undefined,
                  goodsCopies: undefined
                })]);
              }

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function changeTable(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (queryState === 0) {
      setCanClose(true);
    } else {
      setCanClose(false);
    }
  }, [queryState]); // 关闭的函数

  var closeProgramFun = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    console.log('33333');

    if (canClose) {
      props.closeModalCallback();
    }
  }, [canClose]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
    title: "\u5546\u54C1\u9009\u62E9",
    destroyOnClose: true,
    maskClosable: false,
    width: 1200,
    closable: false,
    visible: true,
    onCancel: props.closeModalCallback,
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z, {
      key: "back",
      disabled: !canClose,
      onClick: () => {
        closeProgramFun();
      }
    }, "\u5173\u95ED")]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_FormBuilder__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    ref: form,
    elements: formfields,
    callbackHandler: searchHandler,
    onReset: resetFields,
    formOptions: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, defaultFormItemLayout)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_EditableTable__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    ref: table,
    scrollYSize: 400,
    columns: columns,
    searchParams: searchParams,
    hideBtn: true,
    hideDeleteBtn: true,
    cancelRequest: !placeId,
    onChange: changeTable,
    queryDataUrl: "purchase.product.querySelectPlaceProductByCondition",
    tableOptions: {
      scroll: {
        y: 380
      }
    },
    updateDataSource: updateDataSource,
    setTableDataAfterRequest: setTableDataAfterRequest
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (GoodsEditableModal);

/***/ }),

/***/ 9119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ HandleBtn; }
/* harmony export */ });
/* harmony import */ var antd_es_badge_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54029);
/* harmony import */ var antd_es_badge__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(62529);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(71577);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(57016);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26715);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(83987);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(90631);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71720);
/* harmony import */ var _components_Uploader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84843);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24731);
/* harmony import */ var _hooks_useLoopImportResult__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68406);



















function HandleBtn(props) {
  var canHandle = props.canHandle,
      uploadOptions = props.uploadOptions,
      clearOptions = props.clearOptions,
      hasGoods = props.hasGoods,
      _props$downloadType = props.downloadType,
      downloadType = _props$downloadType === void 0 ? _config_enums__WEBPACK_IMPORTED_MODULE_5__/* .enumPurchaseDownloadType.PURCAHSE_PRE_TEMPLATE */ .Zz.PURCAHSE_PRE_TEMPLATE : _props$downloadType,
      resultParams = props.resultParams,
      showPurchasePoolModal = props.showPurchasePoolModal,
      formData = props.formData;
  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_9__/* .useDispatch */ .I0)(); // 是否轮训导入情况

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_useState, 2),
      loopResult = _useState2[0],
      setLoopResult = _useState2[1];

  var _useLoopImportResult = (0,_hooks_useLoopImportResult__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({}, resultParams), {}, {
    refreshCallback: successed => {
      if (successed) {
        props.afterHandle();
      }

      setLoopResult(false); // 重置状态
    }
  }), [loopResult]),
      _useLoopImportResult2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_useLoopImportResult, 2),
      btnLoading = _useLoopImportResult2[0],
      LoadingModal = _useLoopImportResult2[1]; // 下载模板


  var downloadTemplate = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee() {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch({
                type: 'purchase/downloadGoodsTemplate',
                payload: {
                  downloadType
                }
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function downloadTemplate() {
      return _ref.apply(this, arguments);
    };
  }();

  var changeUpload = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee2(val) {
      var params, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({
                resId: val
              }, uploadOptions.params);
              _context2.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(uploadOptions.url, params);

            case 3:
              res = _context2.sent;

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.success('导入任务添加成功');

                setLoopResult(true);
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function changeUpload(_x) {
      return _ref2.apply(this, arguments);
    };
  }(); //  清空商品


  var clearGood = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee3() {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(clearOptions.url, clearOptions.params);

            case 2:
              res = _context3.sent;

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.success('清空商品成功');

                props.afterHandle();
              }

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function clearGood() {
      return _ref3.apply(this, arguments);
    };
  }();

  var confirmModal = () => {
    antd_es_modal__WEBPACK_IMPORTED_MODULE_15__/* .default.confirm */ .Z.confirm({
      title: '清空商品',
      icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, null),
      content: '确认清空全部商品吗？',
      okText: '确认',
      cancelText: '取消',

      onOk() {
        clearGood();
      }

    });
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("span", {
    style: {
      marginRight: '16px'
    },
    key: "upload"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_components_Uploader__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    tokenUrl: "purchase.scm.getResourceToken",
    onChange: changeUpload,
    loading: btnLoading,
    btnText: "\u5BFC\u5165excel\u5546\u54C1",
    uploadOptions: {
      showUploadList: false,
      disabled: !canHandle
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z, {
    className: "mRight16",
    disabled: !canHandle,
    onClick: downloadTemplate,
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, null),
    key: "download"
  }, "\u4E0B\u8F7Dexcel\u6A21\u677F"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z, {
    onClick: confirmModal,
    key: "clean",
    className: "mRight16",
    disabled: !hasGoods
  }, "\u6E05\u7A7A\u5546\u54C1"), (formData === null || formData === void 0 ? void 0 : formData.orderDirect) === 1 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_badge__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z, {
    dot: true
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z, {
    type: "primary",
    onClick: showPurchasePoolModal
  }, "\u91C7\u8D2D\u6C60")), LoadingModal);
}

/***/ }),

/***/ 24803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(91896);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(71577);
/* harmony import */ var antd_es_tag_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71153);
/* harmony import */ var antd_es_tag__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(60331);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46565);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26715);
/* harmony import */ var _hooks_useDateRange__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(76511);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7704);
/* harmony import */ var _pages_InquiryOffer_PurchasePool_api__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(44355);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(72427);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96534);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_11__);














/**
 * 采购池浮层
 */











var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 4
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 18
    }
  }
};

function PurchasePoolModal(props) {
  var formData = props.formData,
      placeList = props.placeList;
  var formbuilder = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(); // 表格查询参数

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState, 2),
      searchParams = _useState2[0],
      setSearchParams = _useState2[1]; // 正在保存商品行


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState3, 2),
      isSaving = _useState4[0],
      setIsSaving = _useState4[1]; // 用户信息


  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState5, 2),
      userList = _useState6[0],
      setUserList = _useState6[1];

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_9__/* .MappingKey["权限下的商家"] */ .M["权限下的商家"]),
      mappingList = _useMapping.mappingList;

  var businessType = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => {
    var list = mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_9__/* .MappingKey["权限下的商家"] */ .M["权限下的商家"]);

    if (list !== null && list !== void 0 && list.length) {
      var _obj$others;

      var obj = list.find(v => v.value === (formData === null || formData === void 0 ? void 0 : formData.merchantId)) || {};
      return obj === null || obj === void 0 ? void 0 : (_obj$others = obj.others) === null || _obj$others === void 0 ? void 0 : _obj$others.merchantBusinessType;
    }

    return undefined;
  }, [formData === null || formData === void 0 ? void 0 : formData.merchantId, mappingList]); // 取消请求数据

  var cancelRequest = !(searchParams !== null && searchParams !== void 0 && searchParams.param.placeId);
  var searchCreateUser = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)((0,lodash__WEBPACK_IMPORTED_MODULE_11__.debounce)(v => {
    (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_7__/* .YpRequest */ .XQ)('purchase.scm.createUserList', {
      page: 1,
      size: 30,
      param: {
        createUserCode: undefined,
        createUserName: v,
        querySenceId: 1
      }
    }).then(v => {
      var list = v.result.list || [];
      var data = list.map(item => ({
        value: item.createUserName,
        label: item.createUserName,
        others: item
      }));
      setUserList(data);
    });
  }, 500), []); // 查询

  var handleSearch = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(values => {
    var createStartTime = values.createStartTime;

    var _ref = createStartTime || [],
        _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_ref, 2),
        start = _ref2[0],
        end = _ref2[1];

    var params = {
      billType: formData === null || formData === void 0 ? void 0 : formData.orderDirect,
      param: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, values), {}, {
        createStartTime: start ? moment__WEBPACK_IMPORTED_MODULE_5___default()(start).format('YYYY-MM-DD HH:mm:ss') : start,
        createEndTime: end ? moment__WEBPACK_IMPORTED_MODULE_5___default()(end).format('YYYY-MM-DD HH:mm:ss') : end,
        merchantId: formData === null || formData === void 0 ? void 0 : formData.merchantId,
        logisticMode: _config_enums__WEBPACK_IMPORTED_MODULE_8__/* .LogisticModeMap.NOMORL */ .oB.NOMORL,
        firstCategoryId: formData === null || formData === void 0 ? void 0 : formData.firstCategoryId,
        secondCategoryId: formData === null || formData === void 0 ? void 0 : formData.secondCategoryId,
        businessType
      })
    };
    setSearchParams(params);
  }, [businessType, formData === null || formData === void 0 ? void 0 : formData.firstCategoryId, formData === null || formData === void 0 ? void 0 : formData.merchantId, formData === null || formData === void 0 ? void 0 : formData.orderDirect, formData === null || formData === void 0 ? void 0 : formData.secondCategoryId]);
  var afterRequest = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)( /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().mark(function _callee(dataList) {
      var referList, referenceParams, res, referenceList, maps;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // console.log(dataList,'dataList数据')
              referList = dataList.reduce((pre, next) => {
                return pre.concat({
                  placeId: searchParams === null || searchParams === void 0 ? void 0 : searchParams.param.placeId,
                  goodsCode: next.goodsCode
                });
              }, []);
              referenceParams = {
                orderDirect: formData === null || formData === void 0 ? void 0 : formData.orderDirect,
                merchantId: formData === null || formData === void 0 ? void 0 : formData.merchantId,
                firstCategoryId: formData === null || formData === void 0 ? void 0 : formData.firstCategoryId,
                goods: referList
              };
              _context.next = 4;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_7__/* .YpRequest */ .XQ)(_Api__WEBPACK_IMPORTED_MODULE_16__/* .REFERENCE_PRICE */ .DE, referenceParams);

            case 4:
              res = _context.sent;
              referenceList = res.result.list || []; // 获取商品编码与参考价的映射

              maps = referenceList.reduce((pre, next) => {
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, pre), {}, {
                  [next.goodsCode]: {
                    referencePrice: next.referencePrice
                  }
                });
              }, {});
              return _context.abrupt("return", dataList.map(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, v), maps[v.goodsCode]), {}, {
                unitPrice: undefined
              })));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [formData === null || formData === void 0 ? void 0 : formData.firstCategoryId, formData === null || formData === void 0 ? void 0 : formData.merchantId, formData === null || formData === void 0 ? void 0 : formData.orderDirect, searchParams === null || searchParams === void 0 ? void 0 : searchParams.param.placeId]); // 保存行

  var saveRowCallback = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)( /*#__PURE__*/function () {
    var _ref4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().mark(function _callee2(data) {
      var currentCellOldData, currentRow, params, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currentCellOldData = data.currentCellOldData, currentRow = data.currentRow;
              params = {
                id: currentRow.id,
                merchantId: formData === null || formData === void 0 ? void 0 : formData.merchantId,
                preProcessOrderNo: formData === null || formData === void 0 ? void 0 : formData.preProcessOrderNo,
                placeId: searchParams === null || searchParams === void 0 ? void 0 : searchParams.param.placeId,
                // 地点Id
                goodsId: currentRow.goodsCode ? currentRow.goodsCode : 0,
                // 商品编码
                goodsBarCode: currentRow.goodsBarCode,
                suppCode: currentRow.suppCode,
                goodsCopies: currentRow.goodsCopies,
                amount: currentRow.amount,
                orderSpecification: currentRow.conversionRatio
              };
              setIsSaving(true);
              _context2.next = 5;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_7__/* .YpRequest */ .XQ)(_Api__WEBPACK_IMPORTED_MODULE_16__/* .PRE_ORDER_LINE_SAVE */ .U2, params);

            case 5:
              res = _context2.sent;
              setIsSaving(false);

              if (!res.success) {
                _context2.next = 12;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_17__.default.success('保存商品成功');

              return _context2.abrupt("return", (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, currentRow), res.result));

            case 12:
              return _context2.abrupt("return", currentCellOldData);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }(), [formData === null || formData === void 0 ? void 0 : formData.merchantId, formData === null || formData === void 0 ? void 0 : formData.preProcessOrderNo, searchParams === null || searchParams === void 0 ? void 0 : searchParams.param.placeId]);
  var elements = [{
    label: '地点',
    name: 'placeId',
    type: 'SELECT',
    required: true,
    dataList: placeList || []
  }, {
    label: '商品模糊',
    name: 'goodsKey',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/编码/名称/PLU'
    }
  }, (0,_hooks_useDateRange__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)({
    label: '添加时间',
    name: 'createStartTime',
    type: 'RANGE_PICKER_SHORT',
    initialValue: [moment__WEBPACK_IMPORTED_MODULE_5___default()().subtract(7, 'day').startOf('day'), moment__WEBPACK_IMPORTED_MODULE_5___default()().endOf('day')]
  }), {
    label: '添加人',
    name: 'createUserName',
    type: 'SELECT',
    dataList: userList,
    initialValue: js_cookie__WEBPACK_IMPORTED_MODULE_6___default().get('relName'),
    fieldOptions: {
      onSearch: searchCreateUser
    }
  }];
  var columns = [{
    title: '商品名称',
    dataIndex: 'goodsName',
    width: 170
  }, {
    title: '商品编码',
    dataIndex: 'goodsCode',
    width: 100
  }, {
    title: '商品条码',
    dataIndex: 'goodsBarCode',
    width: 130,
    render: (t, r) => r && r.firstCategoryName === '生鲜部' || r.firstCategoryId === '10' ? null : t
  }, {
    title: '商品品类',
    dataIndex: 'firstCategoryName',
    width: 130,
    render: (t, r) => "".concat(t || '', "/").concat(r.secondCategoryName || '')
  }, {
    title: '供应商',
    dataIndex: 'suppName',
    width: 130
  }, {
    title: '交货地点',
    dataIndex: 'merchantName',
    width: 130
  }, {
    title: '单位',
    dataIndex: 'basicUnit',
    width: 80
  }, {
    title: '可供量',
    dataIndex: 'goodsReqQty',
    width: 110
  }, {
    title: '数量',
    dataIndex: 'goodsCopies',
    width: 140,
    type: 'INPUT',
    fieldOptions: r => {
      // 非称重商品为正整数，称重商品保留三位小数
      var isWeight = r.isWeigh === 1;
      return {
        formatter: value => isWeight ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_10__/* .exchageToNum3 */ .hY)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_10__/* .exchageToNum1 */ .Ly)(value)
      };
    }
  }, {
    title: '报价',
    dataIndex: 'netSynthPrice',
    width: 120,
    render: (t, r) => {
      if (r.referencePrice && t) {
        return Number(r.referencePrice) < Number(t) ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", null, t), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_tag__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z, {
          color: "red"
        }, "\u5927\u4E8E\u53C2\u8003\u4EF7")) : t;
      }

      return t;
    }
  }, {
    title: '参考价',
    dataIndex: 'referencePrice',
    width: 130,
    render: (t, r) => t ? "".concat(t, " \u5143").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '单价',
    dataIndex: 'unitPrice',
    width: 130,
    render: (t, r) => {
      var value = !r.amount || !Number(r.amount) ? r.price : t;
      return value ? "".concat(value, " \u5143").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-';
    }
  }, {
    title: '总金额',
    dataIndex: 'amount',
    width: 130,
    type: 'INPUT'
  }, {
    title: '规格描述',
    dataIndex: 'specDesc',
    width: 100
  }];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
    title: "\u91C7\u8D2D\u6C60\u9009\u62E9",
    destroyOnClose: true,
    maskClosable: false,
    width: 1200,
    visible: true,
    onCancel: props.closeModalCallback,
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_21__/* .default */ .Z, {
      key: "cancel",
      disabled: isSaving,
      onClick: props.closeModalCallback
    }, "\u5173\u95ED")]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_7__/* .FormBuilder */ .qu, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_22__/* .default */ .Z)({}, defaultFormItemLayout, {
    formRef: formbuilder,
    elements: elements,
    onSearch: handleSearch
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_7__/* .EnhanceTable */ .UO, {
    cancelRequest: cancelRequest,
    searchParams: searchParams,
    columns: columns,
    requestUrl: _pages_InquiryOffer_PurchasePool_api__WEBPACK_IMPORTED_MODULE_23__/* .GOODS_LIST */ .R,
    saveRowCallback: saveRowCallback,
    afterRequest: afterRequest,
    scroll: {
      y: 500
    }
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (PurchasePoolModal);

/***/ }),

/***/ 50748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tq": function() { return /* binding */ ColumnDataIndex; },
/* harmony export */   "H8": function() { return /* binding */ FormDictionary; },
/* harmony export */   "wC": function() { return /* binding */ MerchantType; }
/* harmony export */ });
/* unused harmony exports fieldEnums, OrderTyep, OrderDirectType */
/**
 * 表单项的映射
 * 表单项的 code/id 与 中文 表单项的映射
 * 主要用于表单提交，与回显
 */
var fieldEnums;

(function (fieldEnums) {
  fieldEnums["orderDirectName"] = "orderDirect";
  fieldEnums["placeName"] = "placeId";
  fieldEnums["categoryName"] = "categoryCode";
  fieldEnums["secondCategoryName"] = "secondCategoryId";
  fieldEnums["merchantName"] = "merchantId";
  fieldEnums["suppName"] = "suppCode";
  fieldEnums["firstCategoryName"] = "firstCategoryId";
  fieldEnums["requireSourceName"] = "requireSource";
})(fieldEnums || (fieldEnums = {}));

var ColumnDataIndex;

(function (ColumnDataIndex) {
  ColumnDataIndex["isGift"] = "gift";
  ColumnDataIndex["manageName"] = "businessStatusName";
  ColumnDataIndex["suppCode"] = "supplierCode";
  ColumnDataIndex["suppName"] = "supplierName";
  ColumnDataIndex["orderSpecificationUnit"] = "specUnit";
  ColumnDataIndex["orderSpecification"] = "specification";
})(ColumnDataIndex || (ColumnDataIndex = {}));

var FormDictionary = {
  // 需求类型
  requireSource: 14,
  // 用户权限下商家
  merchant: 40,
  // 订单方向
  orderDirect: 16,
  // 所有品类
  categoryAll: 46
};
var MerchantType;
/**
 * 分配单订单类别枚举
 */

(function (MerchantType) {
  MerchantType[MerchantType["BUSINESS"] = 1] = "BUSINESS";
  MerchantType[MerchantType["POP"] = 2] = "POP";
})(MerchantType || (MerchantType = {}));

var OrderTyep;

(function (OrderTyep) {
  OrderTyep[OrderTyep["IN"] = 1] = "IN";
  OrderTyep[OrderTyep["OUT"] = 2] = "OUT";
})(OrderTyep || (OrderTyep = {}));

var OrderDirectType = {
  [OrderTyep.IN]: 10,
  [OrderTyep.OUT]: 11
};

/***/ }),

/***/ 91057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "goodsColumns": function() { return /* binding */ goodsColumns; },
/* harmony export */   "getDeliveryColumns": function() { return /* binding */ getDeliveryColumns; }
/* harmony export */ });
/* harmony import */ var antd_es_tag_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71153);
/* harmony import */ var antd_es_tag__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60331);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31097);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68628);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);







var goodsColumns = (orderDirect, isWarn) => [{
  title: '序号',
  dataIndex: 'goodslistIndex',
  key: 'goodslistIndex',
  width: 90,
  render: (t, r, i) => i + 1
}, {
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 140
}, {
  title: '商品条码',
  dataIndex: 'goodsBarCode',
  key: 'goodsBarCode',
  width: 140
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 140
}, {
  title: '是否赠品',
  dataIndex: 'isGift',
  key: 'isGift',
  width: 90,
  render: t => t === 1 ? '是' : '否'
}, {
  title: '规格',
  dataIndex: 'orderSpecification',
  key: 'orderSpecification',
  width: 100
}, {
  title: '订货单位',
  dataIndex: 'orderSpecificationUnit',
  key: 'orderSpecificationUnit',
  width: 100,
  render: (t, r) => {
    var e; // 后续这些复杂的逻辑收到服务端

    if (r.isWeigh === 1 && r.firstCategoryName.includes('生鲜')) {
      var unitDesc = r.barCodeUnit !== 'kg' ? r.barCodeUnit : '件'; // 称重

      e = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", null, unitDesc, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", null, '(' + r.orderSpecification + 'kg' + ')'));
    } else if (r.firstCategoryName.includes('快消')) {
      e = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", null, r.orderSpecificationUnit);
    } else {
      e = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", null, t);
    }

    return e;
  }
}, {
  title: '件数',
  dataIndex: 'goodsCopies',
  key: 'goodsCopies',
  width: 120
}, {
  title: '审核数量',
  dataIndex: 'goodsAduitQty',
  key: 'goodsAduitQty',
  width: 120,
  render: (t, r) => t ? "".concat(t, "/").concat(r.basicUnit || '') : t
}, {
  title: '参考价(含税)',
  dataIndex: 'referencePrice',
  key: 'referencePrice',
  width: 120,
  render: (t, r) => r.basicUnit ? "".concat(t, "/").concat(r.basicUnit || '') : t
}, {
  title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, "\u5168\u56FD\u6700\u4F4E\u4EF7", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    title: "\u8FD11\u6708\u5168\u56FD\u6700\u4F4E\u8FDB\u4EF7"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("a", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    style: {
      color: '#f50'
    }
  })))),
  dataIndex: 'minPrice',
  key: 'minPrice',
  width: 150,
  render: (t, r) => t ? "".concat(t, " \u5143").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
}, {
  title: '单价(含税)',
  dataIndex: 'unitPrice',
  key: 'unitPrice',
  width: 120,
  render: (t, r) => {
    // specifiedPrice 0.未指定价格 1.调拨指定价格（直通不允许修改）2.普通指定价格(直通可修改)
    if (r.specifiedPrice === 0) {
      return r.basicUnit ? "".concat(t || '', "/").concat(r.basicUnit || '') : t || '';
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, r.basicUnit ? "".concat(t || '', "/").concat(r.basicUnit || '') : t || '', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tag__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
      color: "#2db7f5"
    }, "\u6307"), (r === null || r === void 0 ? void 0 : r.isExceptionPrice) === 1 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tag__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
      color: "red"
    }, r === null || r === void 0 ? void 0 : r.exceptionTips));
  }
}, {
  title: '金额(含税)',
  dataIndex: 'amount',
  key: 'amount',
  width: 140,
  render: (t, r) => {
    // specifiedPrice 0.未指定价格 1.调拨指定价格（直通不允许修改）2.普通指定价格(直通可修改)
    if (r.specifiedPrice === 0) {
      return t;
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, t, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tag__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
      color: "#2db7f5"
    }, "\u6307"));
  }
}, {
  title: '市场批发价',
  dataIndex: 'marketWholesalePrice',
  key: 'marketWholesalePrice',
  width: 100
}, {
  title: '税率(%)',
  dataIndex: 'taxRate',
  key: 'taxRate',
  width: 110,
  render: t => {
    var number = +t;

    if (isNaN(number)) {
      return '';
    }

    return number * 100;
  }
}, ...(isWarn ? [{
  title: '周转天数',
  dataIndex: 'turnoverDay',
  key: 'turnoverDay',
  width: 130,
  render: (t, r) => {
    if (r.turnoverDay && r.warnDay && Number(r.turnoverDay) > Number(r.warnDay)) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
        style: {
          color: 'red'
        }
      }, t);
    } else {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", null, t);
    }
  }
}, {
  title: '周转预警天数',
  dataIndex: 'warnDay',
  key: 'warnDay',
  width: 130,
  render: (t, r) => {
    if (r.turnoverDay && r.warnDay && Number(r.turnoverDay) > Number(r.warnDay)) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
        style: {
          color: 'red'
        }
      }, t);
    } else {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", null, t);
    }
  }
}] : []), ...(orderDirect === 2 ? [{
  title: '好坏货标记',
  dataIndex: 'isDamageName',
  key: 'isDamage',
  width: 100
}, {
  title: '退货原因',
  dataIndex: 'returnReasonName',
  key: 'returnReason',
  width: 100
}] : []), {
  title: orderDirect === 1 ? '实收总量' : '实退总量',
  dataIndex: 'receiveQty',
  key: 'receiveQty',
  width: 120,
  render: (t, r) => r.basicUnit ? "".concat(t, "/").concat(r.basicUnit || '') : t
}, {
  title: "\u5B9E".concat(orderDirect === 1 ? '收' : '退', "\u603B\u4EF7(\u542B\u7A0E)"),
  dataIndex: 'receiveAmount',
  key: 'receiveAmount',
  width: 120
}, {
  title: "\u5B9E".concat(orderDirect === 1 ? '收' : '退', "\u5355\u4EF7(\u542B\u7A0E)"),
  dataIndex: 'receiveUnitPrice',
  key: 'receiveUnitPrice',
  width: 120,
  render: (t, r) => r.basicUnit ? "".concat(t, "/").concat(r.basicUnit || '') : t
}, {
  title: '质差扣款',
  dataIndex: 'qualityDeduction',
  key: 'qualityDeduction',
  width: 100
}, {
  title: '结算单价',
  dataIndex: 'settleUnitPrice',
  key: 'settleUnitPrice',
  width: 100,
  render: (t, r) => r.basicUnit ? "".concat(t, "/").concat(r.basicUnit || '') : t
}, {
  title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, "\u7ED3\u7B97\u603B\u989D", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    title: "\u5B9E\u6536\u603B\u4EF7-\u8D28\u5DEE\u6263\u6B3E"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("a", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    style: {
      color: '#f50'
    }
  })))),
  dataIndex: 'settlementAmount',
  key: 'settlementAmount',
  width: 100
}, {
  title: '备注',
  dataIndex: 'auditRemark',
  key: 'auditRemark',
  width: 130
}, {
  title: '等级',
  dataIndex: 'goodsGradeName',
  key: 'goodsGradeName',
  width: 100
}, {
  title: '包装',
  dataIndex: 'goodsPackageName',
  key: 'goodsPackageName',
  width: 100
}, {
  title: '品质要求',
  dataIndex: 'qualityDesc',
  key: 'qualityDesc',
  width: 120
}, {
  title: '规格描述',
  dataIndex: 'productSpecDesc',
  key: 'productSpecDesc',
  width: 120
}];
var getDeliveryColumns = (orderType, orderDirect) => orderType === 2 ? [{
  title: '出库单号',
  dataIndex: 'purchaseReceiveOrderNo',
  key: 'purchaseReceiveOrderNo',
  width: 120
}, {
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 120
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 170
}, {
  title: orderDirect === 1 ? '实收量' : '实退量',
  dataIndex: 'appointmentQty',
  key: 'appointmentQty',
  width: 110,
  render: (t, r) => r.basicUnit ? "".concat(t, "/").concat(r.basicUnit || '') : t
}, {
  title: '出库量',
  dataIndex: 'receiveQty',
  key: 'receiveQty',
  width: 110
}, {
  title: '实际出库时间',
  dataIndex: 'performTime',
  key: 'performTime',
  width: 160,
  render: t => t ? dayjs__WEBPACK_IMPORTED_MODULE_2___default()(t).format('YYYY-MM-DD HH:mm:ss') : ''
}] : [{
  title: '收货单号',
  dataIndex: 'purchaseReceiveOrderNo',
  key: 'purchaseReceiveOrderNo',
  width: 110
}, {
  title: '预约单号',
  dataIndex: 'purchaseAppointmentNo',
  key: 'purchaseAppointmentNo',
  width: 110
}, {
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 100
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 170
}, {
  title: '采购量',
  dataIndex: 'orderReqQty',
  key: 'orderReqQty',
  width: 110,
  render: (t, r) => r.orderSpecificationUnit ? "".concat(t, "/").concat(r.orderSpecificationUnit || '') : t
}, {
  title: '预约量',
  dataIndex: 'appointmentQty',
  key: 'appointmentQty',
  width: 110,
  render: (t, r) => r.orderSpecificationUnit ? "".concat(t, "/").concat(r.orderSpecificationUnit || '') : t
}, {
  title: orderDirect === 1 ? '实收量' : '实退量',
  dataIndex: 'receiveQty',
  key: 'receiveQty',
  width: 110,
  render: (t, r) => r.basicUnit ? "".concat(t, "/").concat(r.basicUnit || '') : t
}, {
  title: "\u5B9E".concat(orderDirect === 1 ? '收' : '退', "\u603B\u4EF7(\u542B\u7A0E)"),
  dataIndex: 'receiveAmount',
  key: 'receiveAmount',
  width: 120
}, {
  title: "\u5B9E".concat(orderDirect === 1 ? '收' : '退', "\u5355\u4EF7(\u542B\u7A0E)"),
  dataIndex: 'receiveUnitPrice',
  key: 'receiveUnitPrice',
  width: 120,
  render: (t, r) => r.basicUnit ? "".concat(t, "/").concat(r.basicUnit || '') : t
}, {
  title: '结算总额',
  dataIndex: 'settlementAmount',
  key: 'settlementAmount',
  width: 100
}, {
  title: '质差扣款',
  dataIndex: 'qualityDeduction',
  key: 'qualityDeduction',
  width: 100
}, {
  title: '扣款原因',
  dataIndex: 'deductReason',
  key: 'deductReason',
  ellipsis: true,
  width: 200
}, {
  title: '预约时间',
  dataIndex: 'appointmentTime',
  key: 'appointmentTime',
  width: 180,
  render: t => t ? dayjs__WEBPACK_IMPORTED_MODULE_2___default()(t).format('YYYY-MM-DD HH:mm:ss') : ''
}, {
  title: '实际入库时间',
  dataIndex: 'performTime',
  key: 'performTime',
  width: 180,
  render: t => t ? dayjs__WEBPACK_IMPORTED_MODULE_2___default()(t).format('YYYY-MM-DD HH:mm:ss') : ''
}];

/***/ }),

/***/ 70969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(91896);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93224);
/* harmony import */ var antd_es_cascader_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36877);
/* harmony import */ var antd_es_cascader__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34366);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _GoodsTable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61117);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96534);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46565);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(76951);
/* harmony import */ var _hooks_useCategoryWholeData__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61982);










var _excluded = ["firstCategoryId"];

/**
 * 商家商品
 */






var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 10
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 14
    }
  }
};

function GoodsEditableModal(props) {
  var formData = props.formData,
      placeList = props.placeList; // 默认查询参数

  var defaultSearchParams = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => ({
    condition: {
      merchantId: formData === null || formData === void 0 ? void 0 : formData.merchantId
    },
    billType: (formData === null || formData === void 0 ? void 0 : formData.orderDirect) === 1 ? 20 : 21
  }), [formData === null || formData === void 0 ? void 0 : formData.merchantId, formData === null || formData === void 0 ? void 0 : formData.orderDirect]); // 能否关闭浮层

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState, 2),
      canClose = _useState2[0],
      setCanClose = _useState2[1]; // 判断多个请求之后状态


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState3, 2),
      queryState = _useState4[0],
      setQuery = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(defaultSearchParams),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState5, 2),
      searchParams = _useState6[0],
      setSearchParams = _useState6[1];

  var placeId = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => searchParams.condition.placeId, [searchParams.condition.placeId]);
  var categoryList = (0,_hooks_useCategoryWholeData__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(2);
  var formfields = [{
    label: '地点',
    name: 'placeId',
    required: true,
    type: 'SELECT',
    dataList: placeList || []
  }, {
    label: '商品模糊',
    name: 'queryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '商品精准',
    name: 'accurateQueryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '商品品类',
    name: 'firstCategoryId',
    required: true,
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_cascader__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, {
      options: categoryList
    })
  }, {
    label: '品牌名称',
    name: 'brandName',
    type: 'INPUT'
  }];
  var columns = [{
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 170,
    fixed: true
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 90
  }, {
    title: '商品条码',
    dataIndex: 'goodsBarCode',
    key: 'goodsBarCode',
    width: 140
  }, {
    title: '二类类目',
    dataIndex: 'secondCategoryName',
    key: 'secondCategoryName',
    width: 100
  }, {
    title: '品牌名称',
    dataIndex: 'brandName',
    key: 'brandName',
    width: 110
  }, {
    title: '单位',
    dataIndex: 'specUnit',
    key: 'specUnit',
    align: 'right',
    width: 90
  }, {
    title: '数量',
    dataIndex: 'goodsCopies',
    key: 'goodsCopies',
    width: 150,
    type: 'INPUT',
    fieldOptions: r => {
      // 非称重商品为正整数，称重商品保留三位小数
      var isWeight = r.isWeigh === 1;
      return {
        formatter: value => isWeight ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_5__/* .exchageToNum3 */ .hY)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_5__/* .exchageToNum1 */ .Ly)(value)
      };
    },
    render: (t, r) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
        style: {
          flex: 1
        }
      }, t), r.barCodeUnit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "/", r.barCodeUnit));
    }
  }, {
    title: '参考价',
    dataIndex: 'referencePrice',
    key: 'referencePrice',
    width: 110,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " \u5143").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '单价(含税)',
    dataIndex: 'unitPrice',
    width: 120,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " \u5143").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '金额(含税)',
    dataIndex: 'amount',
    key: 'amount',
    width: 160,
    type: r => r.allowChangePrice ? 'INPUT' : undefined,
    fieldOptions: {
      formatter: _utils_common__WEBPACK_IMPORTED_MODULE_5__/* .exchageToNum3 */ .hY
    }
  }, {
    title: '库存量',
    dataIndex: 'stock',
    key: 'stock',
    width: 110,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " ").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '规格描述',
    dataIndex: 'specDesc',
    key: 'specDesc',
    align: 'right',
    width: 90,
    render: t => t || '-'
  }];
  var searchHandler = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(values => {
    var firstCategoryId = values.firstCategoryId,
        rest = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(values, _excluded);

    var _ref = firstCategoryId || [],
        _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_ref, 2),
        first = _ref2[0],
        second = _ref2[1];

    setSearchParams(v => {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({}, v), {}, {
        condition: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({}, v.condition), rest), {}, {
          firstCategoryId: first,
          secondCategoryId: second
        })
      });
    });
  }, []); // const judgeRowCallback = useCallback((bool: any) => {
  //   // setCanClose(bool)
  // }, [])

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (queryState === 0) {
      setCanClose(false);
    } else {
      setCanClose(true);
    }
  }, [queryState]); // 关闭的函数

  var closeProgramFun = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    if (!canClose) {
      props.closeModalCallback();
    }
  }, [canClose]);
  var resetFields = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    setSearchParams(defaultSearchParams);
  }, [defaultSearchParams]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
    title: "\u5546\u54C1\u9009\u62E9",
    destroyOnClose: true,
    maskClosable: false,
    width: 1200,
    closable: false,
    visible: true,
    onCancel: props.closeModalCallback,
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
      key: "back",
      onClick: () => {
        closeProgramFun();
      },
      disabled: canClose
    }, "\u5173\u95ED")]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_6__/* .FormBuilder */ .qu, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, defaultFormItemLayout, {
    elements: formfields,
    onSearch: searchHandler,
    onReset: resetFields
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_GoodsTable__WEBPACK_IMPORTED_MODULE_4__.default, {
    cancelRequest: !placeId,
    columns: columns,
    infoData: formData,
    searchParams: searchParams,
    requestUrl: _api__WEBPACK_IMPORTED_MODULE_15__/* .PURCHASE_PRIVILEGE_GOODS_LIST */ .Cn,
    setQuery: setQuery,
    fromModal: true
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (GoodsEditableModal);

/***/ }),

/***/ 61117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2824);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93224);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71720);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96534);
/* harmony import */ var _Distribution_Edit_constance__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50748);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24731);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76951);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72427);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46565);








var _excluded = ["infoData", "afterHandleCallback", "savingRowCallback", "fromModal", "setQuery", "dataSourceRef"];

/**
 * 采购分配单-新增/编辑
 */








function GoodsTable(props) {
  var _restTableProps$searc3, _restTableProps$searc4;

  var infoData = props.infoData,
      afterHandleCallback = props.afterHandleCallback,
      savingRowCallback = props.savingRowCallback,
      fromModal = props.fromModal,
      setQuery = props.setQuery,
      dataSourceRef = props.dataSourceRef,
      restTableProps = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(props, _excluded);

  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();

  function isNull(params) {
    return params === undefined || params === '' || params === null;
  }
  /**
   * 自动保存-满足必填项后触发自动保存
   */


  var autoSaveRow = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().mark(function _callee(record) {
      var isBusiness, needAmount, needSupplier, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 自营
              isBusiness = _Distribution_Edit_constance__WEBPACK_IMPORTED_MODULE_3__/* .MerchantType.BUSINESS */ .wC.BUSINESS === Number(infoData === null || infoData === void 0 ? void 0 : infoData.merchantFlag); // 金额-必填条件：自营/改价/且参考价为0

              needAmount = isBusiness && record.allowChangePrice && !record.referencePrice && record.referencePrice !== 0; // 供应商-必填条件：自营商家

              needSupplier = isBusiness; // 必填项: 地点/商品编码/数量, 供应商(条件), 金额（条件）

              if (!(!record.placeId || !record.goodsId || !record.goodsBarCode || !record.goodsCopies || needSupplier && !record.supplierCode || needAmount && !record.amount)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              _context.next = 7;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_10__/* .PURCHASE_PRIVILEGE_SAVE_ORDER_DETAIL */ .pD, {
                merchantId: infoData === null || infoData === void 0 ? void 0 : infoData.merchantId,
                privilegeOrderNo: infoData === null || infoData === void 0 ? void 0 : infoData.privilegeOrderNo,
                id: record.id,
                placeId: record.placeId,
                // 地点Id
                goodsId: record.goodsId,
                // 商品编码
                goodsBarCode: record.goodsBarCode,
                suppCode: record.supplierCode,
                goodsCopies: record.goodsCopies,
                amount: record.amount,
                specifiedPrice: Number(record.amount) === 0 || Number(record.amount) > 0 ? 1 : 2,
                // 存在amount表示指定价格；1-指定，2-不指定
                orderSpecification: fromModal ? null : record.orderSpecification // 规格

              });

            case 7:
              res = _context.sent;

              if (res.success || res.result.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_11__.default.success("".concat(record.goodsName, "\u4FDD\u5B58\u6210\u529F\uFF01"));

                afterHandleCallback === null || afterHandleCallback === void 0 ? void 0 : afterHandleCallback();
              }

              return _context.abrupt("return", res);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [infoData === null || infoData === void 0 ? void 0 : infoData.merchantFlag, infoData === null || infoData === void 0 ? void 0 : infoData.merchantId, infoData === null || infoData === void 0 ? void 0 : infoData.privilegeOrderNo, afterHandleCallback, fromModal]);
  /**
   * 获取商品信息
   * 前提条件 => 商品条码和地点
   */

  var getGoodData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().mark(function _callee2(record) {
      var _res$result, res, item;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(record.goodsBarCode && record.placeId)) {
                _context2.next = 6;
                break;
              }

              _context2.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_12__/* .PRODUCT_DETAIL */ .nM, {
                merchantId: infoData === null || infoData === void 0 ? void 0 : infoData.merchantId,
                placeId: record.placeId,
                // 地点Id
                barcodeList: [record.goodsBarCode],
                // 商品条码
                withRealPrice: true,
                // 是否查询实时成本价相关信息
                billType: infoData === null || infoData === void 0 ? void 0 : infoData.orderDirect // 单据类型

              });

            case 3:
              res = _context2.sent;
              item = (res === null || res === void 0 ? void 0 : (_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.list[0]) || {}; // 不采用商品的价格

              return _context2.abrupt("return", (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, item), {}, {
                unitPrice: undefined
              }));

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [infoData === null || infoData === void 0 ? void 0 : infoData.merchantId, infoData === null || infoData === void 0 ? void 0 : infoData.orderDirect]);
  /**
   * 获取供应商信息
   * 前提条件 => 商品编码和地点
   */

  var getSupplierList = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().mark(function _callee3(recordList) {
      var paramList, _res$result2, res, list;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              paramList = [];
              recordList.forEach(item => {
                if (item.goodsId && item.placeId && infoData !== null && infoData !== void 0 && infoData.merchantId) {
                  paramList.push({
                    goodsId: item.goodsId,
                    placeId: item.placeId,
                    merchantId: infoData === null || infoData === void 0 ? void 0 : infoData.merchantId
                  });
                }
              });

              if (!paramList.length) {
                _context3.next = 9;
                break;
              }

              _context3.next = 5;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_12__/* .SUPPLIER_LIST */ .xX, {
                paramList
              });

            case 5:
              res = _context3.sent;
              list = res === null || res === void 0 ? void 0 : (_res$result2 = res.result) === null || _res$result2 === void 0 ? void 0 : _res$result2.list;
              list.forEach(item => {
                var _item$supplier;

                item.supplier = (_item$supplier = item.supplier) === null || _item$supplier === void 0 ? void 0 : _item$supplier.map(v => ({
                  label: v.supplierCode,
                  value: v.supplierCode,
                  name: v.supplierName
                }));
              });
              return _context3.abrupt("return", res.result.list);

            case 9:
              return _context3.abrupt("return", []);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }(), [infoData === null || infoData === void 0 ? void 0 : infoData.merchantId]);
  /**
   * 参考价
   * 前提条件 => 商品编码和地点
   */

  var getReferencePrice = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().mark(function _callee4(recordList) {
      var metRequset, paramsList, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              metRequset = recordList.length > 1;
              paramsList = recordList.map(item => {
                metRequset = item.goodsId && item.placeId;
                return {
                  placeId: item.placeId,
                  goodsId: item.goodsId
                };
              });

              if (metRequset) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt("return", []);

            case 4:
              _context4.next = 6;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_12__/* .REFERENCE_PRICE */ .DE, {
                orderDirect: infoData === null || infoData === void 0 ? void 0 : infoData.orderDirect,
                merchantId: infoData === null || infoData === void 0 ? void 0 : infoData.merchantId,
                // firstCategoryId: infoData?.firstCategoryId,
                goods: paramsList
              });

            case 6:
              res = _context4.sent;
              return _context4.abrupt("return", res.result.list);

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }(), [infoData === null || infoData === void 0 ? void 0 : infoData.orderDirect, infoData === null || infoData === void 0 ? void 0 : infoData.merchantId]);
  var getExtInfoData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref5 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().mark(function _callee5(dataList) {
      var extParams, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              extParams = {
                needPlaceStock: true,
                needWarehouseStock: true,
                needMinPurchasePrice: (infoData === null || infoData === void 0 ? void 0 : infoData.billState) === undefined || (infoData === null || infoData === void 0 ? void 0 : infoData.billState) === 1,
                param: dataList.map(v => {
                  var _restTableProps$searc, _restTableProps$searc2;

                  return {
                    merchantId: infoData === null || infoData === void 0 ? void 0 : infoData.merchantId,
                    placeId: restTableProps === null || restTableProps === void 0 ? void 0 : (_restTableProps$searc = restTableProps.searchParams) === null || _restTableProps$searc === void 0 ? void 0 : (_restTableProps$searc2 = _restTableProps$searc.condition) === null || _restTableProps$searc2 === void 0 ? void 0 : _restTableProps$searc2.placeId,
                    goodsId: +v.goodsId
                  };
                })
              };
              _context5.next = 3;
              return dispatch({
                type: 'purchase/queryProductExtInfo',
                payload: extParams
              });

            case 3:
              res = _context5.sent;
              return _context5.abrupt("return", (res === null || res === void 0 ? void 0 : res.list) || []);

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }(), [dispatch, infoData === null || infoData === void 0 ? void 0 : infoData.merchantId, restTableProps === null || restTableProps === void 0 ? void 0 : (_restTableProps$searc3 = restTableProps.searchParams) === null || _restTableProps$searc3 === void 0 ? void 0 : (_restTableProps$searc4 = _restTableProps$searc3.condition) === null || _restTableProps$searc4 === void 0 ? void 0 : _restTableProps$searc4.placeId]);
  /**
   * 获取商品信息或[地点&商品编码]变化后进行的联动更新
   * 因为[地点&商品编码]变化一定影响商品信息，因此合并处理
   * 0. 字段对齐
   * 1. 请求参考价
   * 2. 请求供应商列表
   */

  var afterProductChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().mark(function _callee6(record) {
      var needMatch,
          paramsList,
          referencePriceList,
          extInfoList,
          supplierList,
          stockMaps,
          tableData,
          _args6 = arguments;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              needMatch = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : false;
              paramsList = Array.isArray(record) ? record : [record]; // 获取参考价

              _context6.next = 4;
              return getReferencePrice(paramsList);

            case 4:
              referencePriceList = _context6.sent;
              _context6.next = 7;
              return getExtInfoData(paramsList);

            case 7:
              extInfoList = _context6.sent;
              _context6.next = 10;
              return getSupplierList(paramsList);

            case 10:
              supplierList = _context6.sent;
              // 库存等
              stockMaps = extInfoList.reduce((pre, next) => {
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, pre), {}, {
                  [next.goodsId]: {
                    stock: next.stock,
                    minPurchasePrice: next.minPurchasePrice
                  }
                });
              }, {}); // 字段对齐, 更新表格数据

              tableData = paramsList.map(item => {
                var _stockMaps$item$goods;

                var product = referencePriceList === null || referencePriceList === void 0 ? void 0 : referencePriceList.find(v => v.goodsId === item.goodsId && v.placeId === item.placeId);
                var ext = extInfoList === null || extInfoList === void 0 ? void 0 : extInfoList.find(v => v.goodsId === item.goodsId && v.placeId === item.placeId);
                var iSupplierList = supplierList === null || supplierList === void 0 ? void 0 : supplierList.find(v => v.goodsId === item.goodsId && v.placeId === item.placeId);
                var minPrice = (infoData === null || infoData === void 0 ? void 0 : infoData.billState) === 1 || !(infoData !== null && infoData !== void 0 && infoData.billState) ? stockMaps === null || stockMaps === void 0 ? void 0 : (_stockMaps$item$goods = stockMaps[item === null || item === void 0 ? void 0 : item.goodsId]) === null || _stockMaps$item$goods === void 0 ? void 0 : _stockMaps$item$goods.minPurchasePrice : item.minPrice; // 格式化-对齐不同接口的字段

                var newItem = needMatch ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .formatResponseName */ .Bb)(item, _Distribution_Edit_constance__WEBPACK_IMPORTED_MODULE_3__/* .ColumnDataIndex */ .Tq) : item;
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, newItem), {}, {
                  referencePrice: product === null || product === void 0 ? void 0 : product.referencePrice,
                  supplierList: iSupplierList === null || iSupplierList === void 0 ? void 0 : iSupplierList.supplier
                }, ext), stockMaps[item.goodsId]), {}, {
                  minPrice
                });
              });

              if (!Array.isArray(record)) {
                _context6.next = 17;
                break;
              }

              return _context6.abrupt("return", tableData);

            case 17:
              return _context6.abrupt("return", tableData === null || tableData === void 0 ? void 0 : tableData[0]);

            case 18:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }(), [getExtInfoData, getReferencePrice, getSupplierList]); // 保存行

  var handleSaveRow = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref7 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().mark(function _callee7(data) {
      var currentCell, currentRow, currentRowOldData, dataIndex, _i, _Object$entries, _ref10, _ref9, propName, noOrderSpecification, newRow, goodInfo, tableData, res;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              currentCell = data.currentCell, currentRow = data.currentRow, currentRowOldData = data.currentRowOldData; // 获取当前修改的单元格名称

              dataIndex = '';

              for (_i = 0, _Object$entries = Object.entries(currentCell); _i < _Object$entries.length; _i++) {
                _ref10 = _Object$entries[_i];
                _ref9 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_ref10, 1);
                propName = _ref9[0];
                dataIndex = propName;
              }

              noOrderSpecification = isNull(currentRow.orderSpecification);

              if (!(dataIndex === 'orderSpecification')) {
                _context7.next = 11;
                break;
              }

              if (!noOrderSpecification) {
                _context7.next = 8;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_11__.default.warning('请输入规格');

              return _context7.abrupt("return");

            case 8:
              if (!(+currentRow['orderSpecification'] === 0)) {
                _context7.next = 11;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_11__.default.warning('规格必须大于0');

              return _context7.abrupt("return");

            case 11:
              newRow = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, currentRow);
              savingRowCallback === null || savingRowCallback === void 0 ? void 0 : savingRowCallback(true);
              setQuery && setQuery(prev => {
                return prev + 1;
              }); // [商品编码/条码]，[地点]改变 可能 触发获取商品信息动作

              if (!(dataIndex === 'goodsId' || dataIndex === 'goodsBarCode' || dataIndex === 'placeId')) {
                _context7.next = 24;
                break;
              }

              _context7.next = 17;
              return getGoodData(newRow);

            case 17:
              goodInfo = _context7.sent;

              if (goodInfo) {
                // 可能获取到商品信息中的goodsId 影响后面的系列联动
                Object.assign(newRow, goodInfo);
              } // [编码][地点]


              if (!(newRow.goodsId && newRow.placeId)) {
                _context7.next = 24;
                break;
              }

              _context7.next = 22;
              return afterProductChange(newRow);

            case 22:
              tableData = _context7.sent;
              Object.assign(newRow, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, tableData));

            case 24:
              _context7.next = 26;
              return autoSaveRow(newRow);

            case 26:
              res = _context7.sent;
              savingRowCallback === null || savingRowCallback === void 0 ? void 0 : savingRowCallback(false);
              setQuery && setQuery(prev => {
                return prev - 1;
              });

              if (!res.success) {
                _context7.next = 34;
                break;
              }

              Object.assign(newRow, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({
                id: res.result.id
              }, res));
              return _context7.abrupt("return", newRow);

            case 34:
              return _context7.abrupt("return", currentRowOldData);

            case 35:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }(), [afterProductChange, autoSaveRow, getGoodData, savingRowCallback]);
  /**
   * 查询商品明细列表的回调
   * 更新参考价/供应商列表
   */

  var requestCallback = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref11 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().mark(function _callee8(data) {
      var tableData;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return afterProductChange(data, true);

            case 2:
              tableData = _context8.sent;

              if (dataSourceRef) {
                dataSourceRef.current = tableData;
              }

              return _context8.abrupt("return", tableData);

            case 5:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x8) {
      return _ref11.apply(this, arguments);
    };
  }(), [afterProductChange]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_5__/* .EnhanceTable */ .UO, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)({}, restTableProps, {
    saveRowCallback: handleSaveRow,
    afterRequest: requestCallback,
    scroll: {
      y: 500
    }
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (GoodsTable);

/***/ }),

/***/ 43258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_space_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49111);
/* harmony import */ var antd_es_space__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19650);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var _components_Exception__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42891);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40847);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46565);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76951);











function Statistics(props) {
  var _statistics$skuTotalA;

  var infoData = props.infoData,
      pageId = props.pageId,
      statisticsRef = props.statisticsRef,
      hideException = props.hideException,
      handleSortCallback = props.handleSortCallback; // 汇总信息

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      statistics = _useState2[0],
      setStatistics = _useState2[1]; // 统计信息


  var queryStatData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().mark(function _callee() {
    var res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!(infoData !== null && infoData !== void 0 && infoData.privilegeOrderNo) || !pageId)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.next = 4;
            return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_3__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_7__/* .PURCHASE_PRIVILEGE_STAT */ .Jb, {
              privilegeOrderNo: infoData === null || infoData === void 0 ? void 0 : infoData.privilegeOrderNo
            });

          case 4:
            res = _context.sent;

            if (res.success) {
              setStatistics(res.result);
            }

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [infoData === null || infoData === void 0 ? void 0 : infoData.privilegeOrderNo, pageId]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    queryStatData();
  }, [queryStatData]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (statisticsRef) {
      // @ts-ignore
      statisticsRef.current = {
        queryStatData,
        statistics
      };
    }
  }, [queryStatData, statistics, statisticsRef]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    className: "alignRight mBottom16"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_space__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
    style: {
      color: 'red'
    }
  }, "\u5468\u8F6C\u5F02\u5E38\uFF1A", statistics !== null && statistics !== void 0 && statistics.warnDayInfo ? "".concat(statistics === null || statistics === void 0 ? void 0 : statistics.warnDayInfo) : '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, {
    style: {
      color: '#1890ff'
    }
  }), hideException ? null : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_components_Exception__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z, {
    exceptionPriceCount: statistics === null || statistics === void 0 ? void 0 : statistics.exceptionPriceCount,
    sortCallback: function sortCallback() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      handleSortCallback === null || handleSortCallback === void 0 ? void 0 : handleSortCallback(...args);
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", null, "\u79CD\u7C7B\uFF1A", (statistics === null || statistics === void 0 ? void 0 : statistics.skuTypeQty) || '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", null, "\u603B\u6570\u91CF\uFF1A", statistics !== null && statistics !== void 0 && statistics.skuTotalCopies ? "".concat(statistics === null || statistics === void 0 ? void 0 : statistics.skuTotalCopies) : '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
    className: "mRight16"
  }, "\u603B\u91D1\u989D\uFF1A", (_statistics$skuTotalA = statistics === null || statistics === void 0 ? void 0 : statistics.skuTotalAmount) !== null && _statistics$skuTotalA !== void 0 ? _statistics$skuTotalA : '-', "\u5143")));
}

/* harmony default export */ __webpack_exports__["default"] = (Statistics);

/***/ }),

/***/ 76951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n5": function() { return /* binding */ PURCHASE_PRIVILEGE_SAVE_ORDER; },
/* harmony export */   "b4": function() { return /* binding */ PURCHASE_PRIVILEGE_IMPORT_ORDER_DETAIL; },
/* harmony export */   "pD": function() { return /* binding */ PURCHASE_PRIVILEGE_SAVE_ORDER_DETAIL; },
/* harmony export */   "xg": function() { return /* binding */ PURCHASE_PRIVILEGE_DELETE_ORDER_DETAIL; },
/* harmony export */   "BQ": function() { return /* binding */ PURCHASE_PRIVILEGE_SUBMIT; },
/* harmony export */   "vA": function() { return /* binding */ PURCHASE_PRIVILEGE_CANCEL; },
/* harmony export */   "a1": function() { return /* binding */ PURCHASE_PRIVILEGE_CLEAR; },
/* harmony export */   "mQ": function() { return /* binding */ PURCHASE_PRIVILEGE_ORDER_DETAIL; },
/* harmony export */   "Rk": function() { return /* binding */ PURCHASE_PRIVILEGE_ORDER_LIST; },
/* harmony export */   "hh": function() { return /* binding */ PURCHASE_PRIVILEGE_ORDER_DETAIL_LIST; },
/* harmony export */   "Jb": function() { return /* binding */ PURCHASE_PRIVILEGE_STAT; },
/* harmony export */   "W7": function() { return /* binding */ PURCHASE_PRIVILEGE_CODE; },
/* harmony export */   "Cn": function() { return /* binding */ PURCHASE_PRIVILEGE_GOODS_LIST; },
/* harmony export */   "fV": function() { return /* binding */ PURCHASE_PRIVILEGE_LOOP_RESULT; }
/* harmony export */ });

/**
 * 特权采购单主单保存接口
 */

var PURCHASE_PRIVILEGE_SAVE_ORDER = 'scm.purchase.savePurchasePrivilegeOrder';
/**
 * 导入特权采购单商品明细接口
 */

var PURCHASE_PRIVILEGE_IMPORT_ORDER_DETAIL = 'scm.purchase.importPurchasePrivilegeOrderLine';
/**
 * 特权采购单商品明细保存接口
 */

var PURCHASE_PRIVILEGE_SAVE_ORDER_DETAIL = 'scm.purchase.savePurchasePrivilegeOrderLine';
/**
 * 特权采购单商品明细删除接口
 */

var PURCHASE_PRIVILEGE_DELETE_ORDER_DETAIL = 'scm.purchase.deletePurchasePrivilegeOrderLine';
/**
 * 特权采购单提交接口
 */

var PURCHASE_PRIVILEGE_SUBMIT = 'scm.purchase.submitPurchasePrivilegeOrder';
/**
 * 特权采购单作废接口
 */

var PURCHASE_PRIVILEGE_CANCEL = 'scm.purchase.cancelPurchasePrivilegeOrder';
/**
 * 特权采购单商品明细清空接口
 */

var PURCHASE_PRIVILEGE_CLEAR = 'scm.purchase.clearPurchasePrivilegeOrderLine';
/**
 * 特权采购单详情接口
 */

var PURCHASE_PRIVILEGE_ORDER_DETAIL = 'scm.purchase.purchasePrivilegeOrder';
/**
 * 特权采购单列表接口
 */

var PURCHASE_PRIVILEGE_ORDER_LIST = 'scm.purchase.purchasePrivilegeOrderList';
/**
 * 特权采购单商品明细列表接口
 */

var PURCHASE_PRIVILEGE_ORDER_DETAIL_LIST = 'scm.purchase.purchasePrivilegeOrderLines';
/**
 * 统计特权采购单商品明细接口
 */

var PURCHASE_PRIVILEGE_STAT = 'scm.purchase.statPurchasePrivilegeOrderInfo';
/**
 * 获取单号
 */

var PURCHASE_PRIVILEGE_CODE = 'scm.purchase.getOrderIdByBizType';
/**
 * 选品列表
 */

var PURCHASE_PRIVILEGE_GOODS_LIST = 'scm.purchase.querySelectPlaceProductByCondition';
/**
 * 轮训导入结果
 */

var PURCHASE_PRIVILEGE_LOOP_RESULT = 'scm.purchase.getLastImportResult';

/***/ }),

/***/ 29401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(57016);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(71577);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71720);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_EnhanceCommonTable_components_EnhanceTable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7336);
/* harmony import */ var _components_FormBuilder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5670);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24731);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7704);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26715);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96534);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(72427);











/**
 * 商家商品
 */











function isNull(params) {
  return params === undefined || params === '' || params === null;
}

var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 10
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 14
    }
  }
};

function GoodsEditableModal(props) {
  var allowChangePrice = props.allowChangePrice;
  var _props$formData = props.formData,
      purchaseOrderNo = _props$formData.purchaseOrderNo,
      firstCategoryId = _props$formData.firstCategoryId,
      merchantFlag = _props$formData.merchantFlag,
      orderDirect = _props$formData.orderDirect,
      merchantId = _props$formData.merchantId,
      placeId = _props$formData.placeId,
      secondCategoryId = _props$formData.secondCategoryId,
      suppCode = _props$formData.suppCode; // 默认查询参数

  var defaultSearchParams = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => ({
    billType: orderDirect,
    condition: {
      logisticMode: _config_enums__WEBPACK_IMPORTED_MODULE_9__/* .LogisticModeMap.NOMORL */ .oB.NOMORL,
      supplierCode: suppCode,
      firstCategoryId,
      merchantId,
      placeId,
      secondCategoryId
    }
  }), [firstCategoryId, merchantId, orderDirect, placeId, secondCategoryId, suppCode]);
  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_11__/* .useDispatch */ .I0)();

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(5),
      mappingList = _useMapping.mappingList; // 能否关闭浮层


  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState, 2),
      canClose = _useState2[0],
      setCanClose = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(defaultSearchParams),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState3, 2),
      searchParams = _useState4[0],
      setSearchParams = _useState4[1];

  var secondId = isNaN(+secondCategoryId) ? undefined : +secondCategoryId; // 是否存在二级code

  var notSecondCode = secondId === 0 || !secondId;
  var formfields = [{
    label: '商品查询',
    name: 'queryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '商品精准',
    name: 'accurateQueryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '商品品类',
    name: 'secondCategoryId',
    type: 'SELECT',
    dataList: mappingList.get(5),
    initialValue: notSecondCode ? undefined : secondId,
    reset: notSecondCode,
    fieldOptions: {
      disabled: !!secondId
    }
  }, {
    label: '品牌名称',
    name: 'brandName',
    type: 'INPUT'
  }];
  var columns = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => [{
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 170,
    fixed: true
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 90
  }, {
    title: '商品条码',
    dataIndex: 'goodsBarCode',
    key: 'goodsBarCode',
    width: 140
  }, {
    title: '二类',
    dataIndex: 'secondCategoryName',
    key: 'secondCategoryName',
    width: 100
  }, {
    title: '品牌名称',
    dataIndex: 'brandName',
    key: 'brandName',
    width: 110
  }, {
    title: '单位',
    dataIndex: 'specUnit',
    key: 'specUnit',
    align: 'right',
    width: 90
  }, {
    title: '数量',
    dataIndex: 'goodsCopies',
    key: 'goodsCopies',
    width: 150,
    type: 'INPUT',
    fieldOptions: r => {
      // 非称重商品为正整数，称重商品保留三位小数
      var isPositiveInteger = r.isWeigh === 2;
      return {
        formatter: value => isPositiveInteger ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_10__/* .exchageToNum1 */ .Ly)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_10__/* .exchageToNum3 */ .hY)(value)
      };
    },
    render: (t, r) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
        style: {
          flex: 1
        }
      }, t), r.barCodeUnit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "/", r.barCodeUnit));
    }
  }, {
    title: '参考价',
    dataIndex: 'referencePrice',
    key: 'referencePrice',
    width: 120,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " \u5143").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '单价(含税)',
    dataIndex: 'unitPrice',
    key: 'unitPrice',
    width: 120,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " \u5143").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '总金额(含税)',
    dataIndex: 'amount',
    key: 'amount',
    width: 130,
    type: allowChangePrice ? 'INPUT' : undefined,
    fieldOptions: {
      formatter: _utils_common__WEBPACK_IMPORTED_MODULE_10__/* .exchageToNum3 */ .hY
    }
  }, {
    title: '库存量',
    dataIndex: 'stock',
    key: 'stock',
    width: 120,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " ").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '规格描述',
    dataIndex: 'specDesc',
    key: 'specDesc',
    align: 'right',
    width: 90,
    render: t => t || '-'
  }], [allowChangePrice]);
  var editableColmns = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => columns.filter(v => v.type || v.editable), [columns]); // 判断多个请求之后状态

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState5, 2),
      queryState = _useState6[0],
      setQuery = _useState6[1];

  var searchHandler = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((state, values) => {
    setSearchParams(v => {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, v), {}, {
        condition: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, v.condition), values)
      });
    });
  }, []);
  var resetFields = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    setSearchParams(defaultSearchParams);
  }, [defaultSearchParams]); // 获取参考价和库存，并更新列表数据

  var setTableDataAfterRequest = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().mark(function _callee(data) {
      var _res$0$list, _res$, _res$1$result$list, _res$2, _res$2$result;

      var _data$reduce, referList, extList, referParams, stockParams, res, stockList, referenceList, maps, stockMaps, dataSource;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _data$reduce = data.reduce((pre, next) => ({
                referList: pre.referList.concat(+next.goodsId),
                extList: pre.extList.concat({
                  merchantId,
                  placeId,
                  goodsId: +next.goodsId
                })
              }), {
                referList: [],
                extList: []
              }), referList = _data$reduce.referList, extList = _data$reduce.extList;
              referParams = {
                orderDirect,
                merchantId,
                placeId,
                firstCategoryId,
                goodsIds: referList
              };
              stockParams = {
                needPlaceStock: true,
                needWarehouseStock: true,
                param: extList
              };
              _context.next = 5;
              return Promise.all([dispatch({
                type: 'purchase/queryProductExtInfo',
                payload: stockParams
              }), dispatch({
                type: 'purchase/queryPurchaseReferencePrice',
                payload: referParams
              })]);

            case 5:
              res = _context.sent;
              // 库存list
              stockList = (_res$0$list = (_res$ = res[0]) === null || _res$ === void 0 ? void 0 : _res$.list) !== null && _res$0$list !== void 0 ? _res$0$list : []; // 参考价list

              referenceList = (_res$1$result$list = (_res$2 = res[1]) === null || _res$2 === void 0 ? void 0 : (_res$2$result = _res$2.result) === null || _res$2$result === void 0 ? void 0 : _res$2$result.list) !== null && _res$1$result$list !== void 0 ? _res$1$result$list : []; // 获取参考价的映射

              maps = referenceList.reduce((pre, next) => {
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, pre), {}, {
                  [next.goodsId]: {
                    referencePrice: next.referencePrice
                  }
                });
              }, {}); // 库存等

              stockMaps = stockList.reduce((pre, next) => {
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, pre), {}, {
                  [next.goodsId]: {
                    stock: next.stock
                  }
                });
              }, {});
              dataSource = data.map(v => {
                // 供应商类型为-POP，则金额、单价默认为0，当 merchantFlag 为1时，表示为自营商家，否则pop商家
                // 新增时采购单的单价、金额默认为空
                var unitPrice = !!v.id && !!v.unitPrice ? v.unitPrice : merchantFlag === 2 ? 0 : undefined;
                var amount = !!v.id && !!v.amount ? v.amount : merchantFlag === 2 ? 0 : undefined;
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, v), maps[v.goodsId]), {}, {
                  unitPrice,
                  amount
                }, stockMaps[v.goodsId]);
              });
              return _context.abrupt("return", dataSource);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [dispatch, firstCategoryId, merchantFlag, merchantId, orderDirect, placeId]);
  var changeTable = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().mark(function _callee2(data) {
      var _currentRow$unitPrice;

      var currentCell, currentRowOldData, currentRow, amount, referencePrice, isPop, noPrice, noAmount, canSave, specifiedPrice, hasAmount, reqParams, res, newRow;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // console.log('先走的哪里')
              currentCell = data.currentCell, currentRowOldData = data.currentRowOldData, currentRow = data.currentRow;

              if (!(0,lodash__WEBPACK_IMPORTED_MODULE_4__.isEmpty)(currentCell)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              if (currentRow['goodsCopies']) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return");

            case 5:
              // setUpdateDataSource([])
              amount = currentRow.amount, referencePrice = currentRow.referencePrice; // merchantFlag 为1时，表示为自营商家，否则pop商家

              isPop = merchantFlag === 2;
              noPrice = isNull(referencePrice);
              noAmount = isNull(amount);
              canSave = editableColmns.every(v => {
                if (v.dataIndex === 'amount') {
                  // if (+currentRow[v.dataIndex] === 0) {
                  //   message.warning('单价/金额不可为0')
                  //   return false
                  // }
                  // 参考价为空，并且抬头表商家类型为-自营，并且金额为空，则不允许保存
                  if (noPrice && noAmount && !isPop && allowChangePrice) {
                    return false;
                  } // 如果参考价为空，并且抬头表商家类型为-自营；则不允许保存


                  if (!allowChangePrice && noPrice && !isPop) {
                    return false;
                  }

                  return true;
                }

                if (currentRow[v.dataIndex] === 0) {
                  // // 单价、总金额不能为0
                  // if (v.dataIndex === 'unitPrice') {
                  //   message.warning('单价/金额不可为0')
                  //   return false
                  // }
                  return true;
                }

                return !!currentRow[v.dataIndex];
              });

              if (canSave) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return");

            case 12:
              specifiedPrice = currentRow.specifiedPrice;
              hasAmount = !Number.isNaN(Number.parseInt(currentRow.amount)) && (Number(currentRow.amount) === 0 || Number(currentRow.amount) > 0) ? 2 : 0; // 指定价格；2-指定，0-不指定
              // 当前编辑的是金额， 且金额有值，表示指定单价

              if (currentCell.amount && hasAmount) {
                specifiedPrice = 2;
              } else if (!hasAmount) {
                specifiedPrice = 0;
              }

              reqParams = {
                purchaseOrderNo,
                merchantId,
                placeId,
                firstCategoryId,
                detail: {
                  id: currentRow.id,
                  goodsId: currentRow.goodsId,
                  goodsBarCode: currentRow.goodsBarCode,
                  goodsCopies: currentRow.goodsCopies,
                  unitPrice: (_currentRow$unitPrice = currentRow.unitPrice) !== null && _currentRow$unitPrice !== void 0 ? _currentRow$unitPrice : '',
                  amount: currentRow.amount,
                  isDamage: currentRow.isDamage,
                  returnReason: currentRow.returnReason,
                  referencePrice: currentRow.referencePrice,
                  specifiedPrice
                }
              };
              setQuery(prev => {
                return prev + 1;
              });
              _context2.next = 19;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_16__/* .SAVE_ORDER_LINE */ .BK, reqParams);

            case 19:
              res = _context2.sent;
              setQuery(prev => {
                return prev - 1;
              });

              if (!res.success) {
                _context2.next = 27;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_17__.default.success("".concat(currentRow.id ? '修改' : '添加', "\u5546\u54C1\u3010").concat(currentRow.goodsName, "\u3011\u6210\u529F"));

              newRow = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, currentRow), res === null || res === void 0 ? void 0 : res.result);
              return _context2.abrupt("return", newRow);

            case 27:
              return _context2.abrupt("return", currentRowOldData);

            case 28:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [allowChangePrice, editableColmns, firstCategoryId, merchantFlag, merchantId, placeId, purchaseOrderNo]);
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (queryState === 0) {
      setCanClose(true);
    } else {
      setCanClose(false);
    }
  }, [queryState]); // 关闭的函数

  var closeProgramFun = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(() => {
    if (canClose) {
      props.closeModalCallback();
    }
  }, [canClose]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
    title: "\u5546\u54C1\u9009\u62E9",
    destroyOnClose: true,
    maskClosable: false,
    width: 1200,
    closable: false,
    visible: true,
    onCancel: props.closeModalCallback,
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z, {
      key: "back",
      disabled: !canClose,
      onClick: () => {
        closeProgramFun();
      }
    }, "\u5173\u95ED")]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_FormBuilder__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    elements: formfields,
    callbackHandler: searchHandler,
    onReset: resetFields,
    formOptions: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, defaultFormItemLayout)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_EnhanceCommonTable_components_EnhanceTable__WEBPACK_IMPORTED_MODULE_5__/* .default */ .ZP, {
    columns: columns,
    searchParams: searchParams,
    afterRequest: setTableDataAfterRequest,
    saveRowCallback: changeTable,
    requestUrl: "purchase.product.querySelectPlaceProductByCondition",
    scroll: {
      y: 380
    },
    focusFunCallback: () => {
      setCanClose(false);
    }
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (GoodsEditableModal);

/***/ }),

/***/ 18581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nR": function() { return /* binding */ reverseReasonTypeList; }
/* harmony export */ });
/* unused harmony exports fieldEnums, colFieldEnums */
/**
 * 表单项的映射
 * 表单项的 code/id 与 中文 表单项的映射
 * 主要用于表单提交，与回显
 */
var fieldEnums;
/**
 * 商品列表金额计算的字段映射
 */

(function (fieldEnums) {
  fieldEnums["orderDirectName"] = "orderDirect";
  fieldEnums["placeName"] = "placeId";
  fieldEnums["categoryName"] = "categoryCode";
  fieldEnums["secondCategoryName"] = "secondCategoryId";
  fieldEnums["merchantName"] = "merchantId";
  fieldEnums["suppName"] = "suppCode";
  fieldEnums["firstCategoryName"] = "firstCategoryId";
})(fieldEnums || (fieldEnums = {}));

var colFieldEnums;

(function (colFieldEnums) {
  colFieldEnums["specification"] = "orderSpecification";
  colFieldEnums["goodsQty"] = "goodsCopies";
  colFieldEnums["goodsPrice"] = "unitPrice";
  colFieldEnums["referencePrice"] = "referencePrice";
})(colFieldEnums || (colFieldEnums = {}));

var reverseReasonTypeList = [// int32 reverseReasonType = 16;// 退货原因类型 运输损耗1、门店报损2、成本冲差3、多到货退货4、供应商多开单5、品质问题退换6、停售商品退货7、信息错误红冲8、临期退供9、其他退货10
{
  label: '运输损耗',
  value: 1
}, {
  label: '门店报损',
  value: 2
}, {
  label: '成本冲差',
  value: 3
}, {
  label: '多到货退货',
  value: 4
}, {
  label: '供应商多开单',
  value: 5
}, {
  label: '品质问题退换',
  value: 6
}, {
  label: '停售商品退货',
  value: 7
}, {
  label: '信息错误红冲',
  value: 8
}, {
  label: '临期退供',
  value: 9
}, {
  label: '其他退货',
  value: 10
}];

/***/ }),

/***/ 5045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H2": function() { return /* binding */ purchaseObj; },
/* harmony export */   "hz": function() { return /* binding */ exportUnHandleStatusMap; },
/* harmony export */   "g1": function() { return /* binding */ supplierMap; }
/* harmony export */ });
/* unused harmony export cancelStatusMap */
// 字段名对应的映射
var purchaseObj = {
  billState: 9,
  categoryCode: 4,
  placeId: 3,
  queryPlaces: 84,
  orderDirect: 10,
  isStraight: 43,
  categoryCodeAll: 46,
  isDamage: 11,
  returnReason: 12,
  secondCategoryId: 5,
  businessMode: 13,
  merchantId: 40,
  // 权限下的商家
  categoryAll: 41,
  relationAll: 88 // 供应商编码关联单号

}; // 这些状态下可 「取消」

var cancelStatusMap = (/* unused pure expression or super */ null && ([1, 2, 3, 4, 7])); // 这些状态的采购单无法合并导出

var exportUnHandleStatusMap = [1];
/**
 * 供应商的枚举
 */

var supplierMap = {
  businessModel: 4
};

/***/ }),

/***/ 75475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57016);
/* harmony import */ var antd_es_table_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66456);
/* harmony import */ var antd_es_table__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97423);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);









var layout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 5
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 18
    }
  }
};

function WarningModal(props) {
  var total = props.total,
      dataSource = props.dataSource;
  var combineTable = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
  var columns = [{
    title: '地点名称',
    dataIndex: 'placeName',
    key: 'placeName',
    width: 160
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 140
  }, {
    title: '预警周转天数',
    dataIndex: 'warnDay',
    key: 'warnDay',
    width: 100,
    render: (t, r) => {
      if (r.turnoverDay && r.warnDay && Number(r.turnoverDay) > Number(r.warnDay)) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
          style: {
            color: 'red'
          }
        }, t);
      } else {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", null, t);
      }
    }
  }, {
    title: '当前周转天数',
    dataIndex: 'turnoverDay',
    key: 'turnoverDay',
    width: 120,
    render: (t, r) => {
      if (r.turnoverDay && r.warnDay && Number(r.turnoverDay) > Number(r.warnDay)) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
          style: {
            color: 'red'
          }
        }, t);
      } else {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", null, t);
      }
    }
  }];

  var handleOk = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee() {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              props.saveModalCallback();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleOk() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    title: "\u9884\u8B66\u63D0\u793A",
    destroyOnClose: true,
    maskClosable: false,
    width: 700,
    visible: true,
    onOk: handleOk,
    onCancel: props.closeModalCallback,
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
      key: "submit",
      type: "primary",
      onClick: handleOk
    }, "\u7EE7\u7EED\u63D0\u4EA4"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
      key: "back",
      onClick: props.closeModalCallback
    }, "\u53D6\u6D88")]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "\u5B58\u5728", total, "\u6761\u6570\u636E\uFF0C\u8D85\u8FC7\u5468\u8F6C\u9884\u8B66"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_table__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, {
    columns: columns,
    dataSource: dataSource,
    pagination: false,
    scroll: {
      y: 200
    },
    style: {
      height: 250
    }
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (WarningModal);

/***/ }),

/***/ 59134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ isSupplierDisabled; }
/* harmony export */ });
/** 进货单 +（快消 或 二级类目干货类/生鲜干货类）时，商品列表供应商不可编辑 */
var isSupplierDisabled = (orderDirect, firstCategoryName, secondCategoryName, secondCategoryId) => {
  if (Number(orderDirect) !== 1) return false; // 一级类目：快消

  if (firstCategoryName !== null && firstCategoryName !== void 0 && firstCategoryName.includes('快消')) return true; // 二级类目：生鲜干货类 / 干货类（名称或固定 id=1001）

  if (secondCategoryName !== null && secondCategoryName !== void 0 && secondCategoryName.includes('干货')) return true;
  if (Number(secondCategoryId) === 1001) return true;
  return false;
};

/***/ }),

/***/ 20641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qh": function() { return /* binding */ queryPurchaseRemedyOrderList; },
/* harmony export */   "uD": function() { return /* binding */ operationPurchaseRemedyOrder; },
/* harmony export */   "o0": function() { return /* binding */ reviewPurchaseRemedyOrder; },
/* harmony export */   "T_": function() { return /* binding */ queryPurchaseRemedyOrderDetail; },
/* harmony export */   "Zz": function() { return /* binding */ createPurchaseRemedyOrder; },
/* harmony export */   "E0": function() { return /* binding */ updatePurchaseRemedyOrder; },
/* harmony export */   "n2": function() { return /* binding */ queryOriginOrder; },
/* harmony export */   "Ok": function() { return /* binding */ getFreightCalculation; }
/* harmony export */ });
/* unused harmony exports queryOriginOrderDetailList, queryPurchaseRemedyOrderType */
var domain = 'purchase.remedy.';
var queryPurchaseRemedyOrderList = "".concat(domain, "queryPurchaseRemedyOrderList"); // 补救单列表查询

var operationPurchaseRemedyOrder = "".concat(domain, "operationPurchaseRemedyOrder"); // 补救单（作废，驳回）

var reviewPurchaseRemedyOrder = "".concat(domain, "reviewPurchaseRemedyOrder"); // 补救单（审核）

var queryPurchaseRemedyOrderDetail = "".concat(domain, "queryPurchaseRemedyOrderDetail"); // 补救单详情查询

var createPurchaseRemedyOrder = "".concat(domain, "createPurchaseRemedyOrder"); // 新增补救单

var updatePurchaseRemedyOrder = "".concat(domain, "updatePurchaseRemedyOrder"); // 修改补救单

var queryOriginOrderDetailList = "".concat(domain, "queryOriginOrderDetailList"); // 源订单商品明细查询

var queryOriginOrder = "".concat(domain, "queryOriginOrder"); // 源单基本信息查询

var queryPurchaseRemedyOrderType = "".concat(domain, "queryPurchaseRemedyOrderType"); // 补救单类型

var getFreightCalculation = "".concat(domain, "getFreightCalculation"); // 补救单商品运费计算

/***/ }),

/***/ 49987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jv": function() { return /* binding */ convertAryToMap; },
/* harmony export */   "lN": function() { return /* binding */ remedyTypeAry; },
/* harmony export */   "oi": function() { return /* binding */ remedyTypeOptions; },
/* harmony export */   "SY": function() { return /* binding */ statusAry; },
/* harmony export */   "hm": function() { return /* binding */ statusOptions; },
/* harmony export */   "p7": function() { return /* binding */ remedyTypes; },
/* harmony export */   "uS": function() { return /* binding */ operationTypeAry; },
/* harmony export */   "zR": function() { return /* binding */ reservationObj; }
/* harmony export */ });
var convertAryToMap = function convertAryToMap(ary) {
  var excludeAry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var convertedAry = ary.map((each, index) => {
    return {
      value: index,
      label: each
    };
  });

  if (excludeAry && excludeAry.length > 0) {
    return convertedAry.filter(each => {
      return !excludeAry.includes(each.value);
    });
  }

  return convertedAry;
};
var remedyTypeAry = ['全部', '采购进货补救', '采购退货补救', '仓间调拨补救', '店间调拨补救', '仓店配送补救', '店仓返配补救'];
var remedyTypeOptions = convertAryToMap(remedyTypeAry, [3, 4]);
var statusAry = ['全部', '草稿', '待审核', '已完成', '已取消', '审核中'];
var statusOptions = convertAryToMap(statusAry);
var remedyTypes = convertAryToMap(remedyTypeAry, [0, 3, 4]);
var operationTypeAry = ['', '作废', '驳回', '通过'];
var reservationObj = {
  placeId: 3
};

/***/ }),

/***/ 70016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l9": function() { return /* binding */ SHOP_DETAILLIST; },
/* harmony export */   "Wt": function() { return /* binding */ EXPORT_Aquatic_Products; },
/* harmony export */   "t2": function() { return /* binding */ EXPORT_Aquatic_Products_COLLECT; },
/* harmony export */   "Ku": function() { return /* binding */ IMPORT_SHOP_DETAIL; },
/* harmony export */   "sz": function() { return /* binding */ SHOP_DETAILLIST_LIST; },
/* harmony export */   "lz": function() { return /* binding */ EDIT_AQUATIC_POST; },
/* harmony export */   "Js": function() { return /* binding */ REALT_IMEINVE_NTORY; },
/* harmony export */   "Zg": function() { return /* binding */ STORE_DETAILS_INOF; },
/* harmony export */   "Y8": function() { return /* binding */ DISTRIBUTION_BATCH_SUBMIT_ORDER; },
/* harmony export */   "if": function() { return /* binding */ ODD_SUBMIT_PRODUCT; },
/* harmony export */   "dZ": function() { return /* binding */ GTE_FRESH_LIST; },
/* harmony export */   "vm": function() { return /* binding */ REAL_TIME_SALES_VOLUME; },
/* harmony export */   "EK": function() { return /* binding */ REAL_TIME_SALES_VOLUME_SCHEDULE; }
/* harmony export */ });
// 门店列表
// export const SHOP_LIST = 'purchase.require.queryAutoRequirePreprocessShops'
// 水产自动补货分配单明细列表
var SHOP_DETAILLIST = 'require.fisheriesAutoPreprocess.queryFisheriesAutoRequirePreprocessDetail'; // 导出门店明细列表
// export const EXPORT_SHOP_DETAIL = 'purchase.require.exportRequireAutoPreprocessOrder'
// 导出

var EXPORT_Aquatic_Products = 'require.fisheriesAutoPreprocess.exportRequireFisheriesAutoPreprocessOrder'; // 商品汇总导出

var EXPORT_Aquatic_Products_COLLECT = 'require.fisheriesAutoPreprocess.exportRequireFisheriesGoodsAutoPreprocessOrder'; // 导入

var IMPORT_SHOP_DETAIL = 'require.fisheriesAutoPreprocess.importRequireFisheriesAutoPreprocessOrderDetail'; // 门店列表的状态

var SHOP_DETAILLIST_LIST = 'require.fisheriesAutoPreprocess.queryRequireFisheriesAutoPreprocessShops'; // 编辑水产补货

var EDIT_AQUATIC_POST = 'require.fisheriesAutoPreprocess.modifyRequireFisheriesAutoPreprocessOrderDetail'; // 库存刷新

var REALT_IMEINVE_NTORY = 'require.fisheriesAutoPreprocess.refreshFisheriesRealStock'; // 水产详细信息

var STORE_DETAILS_INOF = 'require.fisheriesAutoPreprocess.queryRequireFisheriesAutoPreprocessInfo';
/**
 * 批量提交补货申请单
 */

var DISTRIBUTION_BATCH_SUBMIT_ORDER = 'purchase.requireApply.batchSubmitRequireApply'; // 提交单号

var ODD_SUBMIT_PRODUCT = 'require.fisheriesAutoPreprocess.commitRequireFisheriesAutoPreprocessOrder'; // 水产列表

var GTE_FRESH_LIST = 'require.fisheriesAutoPreprocess.queryFisheriesAutoRequirePreprocessGoodsTotalInfo'; // 实时销量

var REAL_TIME_SALES_VOLUME = 'require.fisheriesAutoPreprocess.refreshFisheriesRealTimeSales'; // 获取实时销量进度

var REAL_TIME_SALES_VOLUME_SCHEDULE = 'require.fisheriesAutoPreprocess.queryRefreshFisheriesRealTimeSalesProgress';

/***/ }),

/***/ 61664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ exportImport; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/row/style/index.js
var style = __webpack_require__(13062);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var button_style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/progress/style/index.js
var progress_style = __webpack_require__(34669);
// EXTERNAL MODULE: ./node_modules/antd/es/progress/index.js + 10 modules
var progress = __webpack_require__(44808);
// EXTERNAL MODULE: ./node_modules/antd/es/col/style/index.js
var col_style = __webpack_require__(89032);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/tabs/style/index.js
var tabs_style = __webpack_require__(18106);
// EXTERNAL MODULE: ./node_modules/antd/es/tabs/index.js + 32 modules
var tabs = __webpack_require__(69584);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/index.js
var message_style = __webpack_require__(34792);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(48086);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/style/index.js
var modal_style = __webpack_require__(71194);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(57016);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/ExclamationCircleOutlined.js + 1 modules
var ExclamationCircleOutlined = __webpack_require__(83987);
// EXTERNAL MODULE: ./src/utils/ypRequest/index.tsx
var ypRequest = __webpack_require__(24731);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/pages/ReplenishManage/Aquaticproducts/api.ts
var api = __webpack_require__(70016);
// EXTERNAL MODULE: ./src/components/ExportModal/index.tsx
var ExportModal = __webpack_require__(83769);
// EXTERNAL MODULE: ./src/components/Uploader/index.tsx + 4 modules
var Uploader = __webpack_require__(84843);
// EXTERNAL MODULE: ./src/hooks/useRefCallback.ts
var useRefCallback = __webpack_require__(82981);
// EXTERNAL MODULE: ./src/config/enums.ts
var enums = __webpack_require__(26715);
;// CONCATENATED MODULE: ./src/pages/ReplenishManage/Aquaticproducts/components/uploader/index.tsx
















var GoodsDetailImportBtn = props => {
  var orderNo = props.orderNo,
      _props$callBack = props.callBack,
      callBack = _props$callBack === void 0 ? () => {} : _props$callBack,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? '' : _props$mode; // 加载和 导入模块是否显示

  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      btnLoading = _useState2[0],
      setBtnLoading = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      visible = _useState4[0],
      setVisible = _useState4[1];

  var timer = (0,react.useRef)(); // 监听轮询结果

  var polling = (0,react.useCallback)(() => {
    timer.current && clearInterval(timer.current);
    timer.current = setInterval(() => {
      importRequest();
    }, 1000);
  }, []); // 轮训导入请求

  var importRequest = (0,useRefCallback/* default */.Z)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
    var res, success, result, status, downloadUrl, tipsMsg;
    return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,ypRequest/* default */.Z)('purchase.import.getLastImportResult', {
              businessType: 20,
              orderNo: orderNo
            });

          case 2:
            res = _context.sent;
            success = res.success, result = res.result;

            if (success) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", false);

          case 6:
            status = result.status, downloadUrl = result.downloadUrl, tipsMsg = result.tipsMsg;

            if (!(status === enums/* enumPurchaseImportStatus.待执行 */.wB["待执行"] || status === enums/* enumPurchaseImportStatus.执行中 */.wB["执行中"])) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", true);

          case 11:
            if (!(status === enums/* enumPurchaseImportStatus.执行成功 */.wB["执行成功"])) {
              _context.next = 18;
              break;
            }

            message.default.success('导入数据成功');

            location.reload();
            refreshCallback();
            return _context.abrupt("return", false);

          case 18:
            if (!(status === enums/* enumPurchaseImportStatus.执行失败 */.wB["执行失败"])) {
              _context.next = 22;
              break;
            }

            if (downloadUrl) {
              message.default.warn(tipsMsg ? tipsMsg : '导入失败,请在excel中查看明细..');

              window.location.href = downloadUrl;
            } else {
              message.default.warn(tipsMsg ? tipsMsg : '导入失败');
            }

            refreshCallback();
            return _context.abrupt("return", false);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [orderNo]);
  /** 导入初始化 轮询 */

  var startLoop = () => {
    setBtnLoading(true);
    setVisible(true);
    polling();
  }; // 导入循环之后的回调


  var refreshCallback = () => {
    setBtnLoading(false);
    setVisible(false);
    clearInterval(timer.current);
  }; // 导入商品明细


  var changeUpload = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(val) {
      var params, res;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = {
                resId: val,
                orderNo: orderNo
              };
              _context2.next = 3;
              return (0,ypRequest/* default */.Z)(api/* IMPORT_SHOP_DETAIL */.Ku, params);

            case 3:
              res = _context2.sent;

              if (res.success) {
                message.default.success('导入任务添加成功');

                startLoop();
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [orderNo, mode]);
  return /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(Uploader/* default */.Z, {
    accept: ".xlsx,.xls",
    onChange: changeUpload,
    showType: 1,
    tokenUrl: "purchase.resource.getResourceToken",
    loading: btnLoading,
    btnText: "\u5BFC\u5165",
    uploadOptions: {
      showUploadList: false
    }
  }), /*#__PURE__*/react.createElement(modal/* default */.Z, {
    width: 540,
    visible: visible,
    centered: true,
    destroyOnClose: true,
    maskClosable: false,
    closable: false,
    footer: null
  }, /*#__PURE__*/react.createElement("h3", {
    className: "mTop16 mBottom16 alignCenter"
  }, "\u6B63\u5728\u5BFC\u5165\u6570\u636E"), /*#__PURE__*/react.createElement("div", {
    style: {
      paddingBottom: '20px'
    }
  }, /*#__PURE__*/react.createElement(progress/* default */.Z, {
    strokeColor: {
      from: '#108ee9',
      to: '#87d068'
    },
    percent: 100,
    showInfo: false,
    status: "active"
  }))));
};

/* harmony default export */ var uploader = (GoodsDetailImportBtn);
;// CONCATENATED MODULE: ./src/pages/ReplenishManage/Aquaticproducts/components/exportImport/index.tsx























 // 导出的弹框


/* harmony default export */ var exportImport = (props => {
  var orderNo = props.orderNo,
      placeIdKey = props.placeIdKey,
      form = props.form,
      disabled = props.disabled,
      aquaticProducts = props.aquaticProducts,
      detailData = props.detailData,
      setDetail = props.setDetail,
      realTimeSalesVolumeRequest = props.realTimeSalesVolumeRequest,
      storeStateList = props.storeStateList,
      storeTableList = props.storeTableList;
  var tableRef = (0,react.useRef)(null); // 导出列表

  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      exportModal = _useState2[0],
      setExportModal = _useState2[1]; // 导出的类型


  var _useState3 = (0,react.useState)(18),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      businessType = _useState4[0],
      setBusinessType = _useState4[1]; // 实时进度


  var _useState5 = (0,react.useState)({
    load: false,
    shedule: 0
  }),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      realTimeShedule = _useState6[0],
      setRealTimeShedule = _useState6[1]; // 导出列表关闭的回调


  var closeModalCallback = () => {
    setExportModal(false);
  }; // 导出


  var exportHandle = (0,react.useCallback)(() => {
    // console.log(placeIdKey, 'placeIdKeyplaceIdKey')
    modal/* default.confirm */.Z.confirm({
      title: '导出',
      icon: /*#__PURE__*/react.createElement(ExclamationCircleOutlined/* default */.Z, null),
      content: '确认要导出吗',
      okText: '确认',
      cancelText: '取消',

      onOk() {
        return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
          return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  try {
                    form.validateFields().then(value => {
                      var goodsKey = value.goodsKey,
                          isModify = value.isModify,
                          categoryIds = value.categoryIds;
                      var params = {
                        tenantId: 1,
                        condition: {
                          orderNo: orderNo,
                          goodsKey,
                          firstCategoryIds: categoryIds && [categoryIds[0]],
                          secondCategoryIds: categoryIds && [categoryIds[1]],
                          thirdCategoryIds: categoryIds && [categoryIds[2]],
                          fourthCategoryIds: categoryIds && [categoryIds[3]],
                          isModify,
                          placeIds: placeIdKey
                        }
                      };
                      (0,ypRequest/* default */.Z)(api/* EXPORT_Aquatic_Products */.Wt, params).then(res => {
                        if (res.success) {
                          message.default.success('操作成功');
                        }
                      });
                    });
                  } catch (error) {
                    message.default.error(error);
                  }

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      }

    });
  }, [orderNo, placeIdKey]); // 刷新实时库存

  var realTimeInventory = (0,react.useCallback)(() => {
    (0,ypRequest/* default */.Z)(api/* REALT_IMEINVE_NTORY */.Js, {
      orderNo: orderNo
    }).then(_ref => {
      var success = _ref.success,
          result = _ref.result;

      if (success) {
        message.default.success('刷新成功');
      }
    });
  }, [orderNo]); //商品汇总导出

  var commoditySummary = (0,react.useCallback)(() => {
    modal/* default.confirm */.Z.confirm({
      title: '导出',
      icon: /*#__PURE__*/react.createElement(ExclamationCircleOutlined/* default */.Z, null),
      content: '确认要导出吗',
      okText: '确认',
      cancelText: '取消',

      onOk() {
        return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2() {
          return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  try {
                    form.validateFields().then(value => {
                      var goodsKey = value.goodsKey,
                          isModify = value.isModify,
                          categoryIds = value.categoryIds;
                      var params = {
                        tenantId: 1,
                        condition: {
                          orderNo: orderNo,
                          goodsKey,
                          firstCategoryIds: categoryIds && [categoryIds[0]],
                          secondCategoryIds: categoryIds && [categoryIds[1]],
                          thirdCategoryIds: categoryIds && [categoryIds[2]],
                          fourthCategoryIds: categoryIds && [categoryIds[3]],
                          isModify,
                          placeIds: placeIdKey
                        }
                      };
                      (0,ypRequest/* default */.Z)(api/* EXPORT_Aquatic_Products_COLLECT */.t2, params).then(res => {
                        if (res.success) {
                          message.default.success('操作成功');
                        }
                      });
                    });
                  } catch (error) {
                    message.default.error(error);
                  }

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      }

    });
  }, [orderNo, placeIdKey]); // 实时销量

  var realTimeSalesVolume = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3() {
      var res;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return (0,ypRequest/* default */.Z)(api/* REAL_TIME_SALES_VOLUME */.vm, {
                orderNo
              });

            case 3:
              res = _context3.sent;

              if (res.success && res.result.success) {
                pollQuerySchedule(res.result.uniqueKey);
              } else {}

              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);

              message.default.error(_context3.t0);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 7]]);
    }));

    return function realTimeSalesVolume() {
      return _ref2.apply(this, arguments);
    };
  }(); // 轮询进度问题


  var pollQuerySchedule = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee4(uniqueKey) {
      var timer, res;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              clearInterval(timer);
              _context4.next = 4;
              return (0,ypRequest/* default */.Z)(api/* REAL_TIME_SALES_VOLUME_SCHEDULE */.EK, {
                uniqueKey
              });

            case 4:
              res = _context4.sent;

              if (res.success) {
                setRealTimeShedule({
                  shedule: res.result.progress,
                  load: true
                });

                if (res.result.isRefreshEnd) {
                  setRealTimeShedule({
                    shedule: res.result.progress,
                    load: false
                  });
                  storeTableList(null);
                  storeStateList();
                } else {
                  timer = setTimeout(() => {
                    pollQuerySchedule(uniqueKey);
                  }, 1500);
                }
              }

              _context4.next = 11;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);

              message.default.error(_context4.t0);

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 8]]);
    }));

    return function pollQuerySchedule(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return (0,react.useMemo)(() => {
    return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(row/* default */.Z, {
      justify: "space-between",
      className: "exportImport"
    }, /*#__PURE__*/react.createElement(col/* default */.Z, {
      span: 10
    }, /*#__PURE__*/react.createElement(tabs/* default */.Z, {
      defaultActiveKey: detailData,
      style: {
        display: 'inline-block',
        height: '45px'
      },
      onChange: activeKey => {
        console.log(activeKey, 'activeKey');
        setDetail(activeKey);
      }
    }, /*#__PURE__*/react.createElement(tabs/* default.TabPane */.Z.TabPane, {
      tab: "\u95E8\u5E97\u660E\u7EC6",
      key: "1"
    }), /*#__PURE__*/react.createElement(tabs/* default.TabPane */.Z.TabPane, {
      tab: "\u5546\u54C1\u6C47\u603B",
      key: "2"
    })), /*#__PURE__*/react.createElement("span", {
      style: {
        fontSize: '17px',
        display: 'inline-block',
        verticalAlign: 'top',
        lineHeight: '45px'
      }
    }, aquaticProducts && moment_default()(parseInt(aquaticProducts.createTimeStamp)).format('YYYY-MM-DD ')), /*#__PURE__*/react.createElement("span", {
      style: {
        fontSize: '17px',
        display: 'inline-block',
        verticalAlign: 'top',
        lineHeight: '45px'
      }
    }, aquaticProducts && aquaticProducts.dateWeek)), detailData == 1 ? /*#__PURE__*/react.createElement(col/* default */.Z, {
      span: disabled ? 6 : 10,
      offset: disabled ? 4 : 0
    }, realTimeShedule.load ? /*#__PURE__*/react.createElement(progress/* default */.Z, {
      percent: realTimeShedule.shedule,
      size: "small",
      style: {
        width: 120
      }
    }) : null, !disabled && /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      type: "primary",
      loading: realTimeShedule.load,
      onClick: () => {
        realTimeSalesVolume();
      },
      style: {
        marginRight: '12px'
      }
    }, "\u5B9E\u65F6\u9500\u91CF"), !disabled && /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      type: "primary",
      onClick: () => {
        realTimeInventory();
      }
    }, "\u5237\u65B0\u5B9E\u65F6\u5E93\u5B58"), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      type: "primary",
      className: "leadingOut",
      style: {
        marginRight: disabled ? '12px' : '0px'
      },
      onClick: () => {
        exportHandle();
      }
    }, "\u5BFC\u51FA"), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      type: "primary",
      className: "exportList",
      onClick: () => {
        setExportModal(true);
      }
    }, "\u5BFC\u51FA\u5217\u8868"), !disabled && /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      type: "primary"
    }, /*#__PURE__*/react.createElement(uploader, {
      orderNo: orderNo,
      callBack: function callBack() {
        throw new Error('Function not implemented.');
      },
      mode: ''
    }))) : /*#__PURE__*/react.createElement(col/* default */.Z, null, /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      type: "primary",
      className: "leadingOut",
      style: {
        marginRight: disabled ? '12px' : '0px'
      },
      onClick: () => {
        commoditySummary();
      }
    }, "\u5BFC\u51FA"), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      type: "primary",
      className: "exportList",
      onClick: () => {
        setExportModal(true);
        setBusinessType(21);
      }
    }, "\u5BFC\u51FA\u5217\u8868"))), exportModal && /*#__PURE__*/react.createElement(ExportModal/* default */.Z, {
      queryDataUrl: "purchase.export.getExportTaskList",
      businessType: businessType,
      closeModalCallback: closeModalCallback
    }));
  }, [exportModal, orderNo, placeIdKey, aquaticProducts, detailData, realTimeShedule]);
});

/***/ }),

/***/ 29906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(91896);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(71577);
/* harmony import */ var antd_es_checkbox_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63185);
/* harmony import */ var antd_es_checkbox__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(9676);
/* harmony import */ var antd_es_row_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13062);
/* harmony import */ var antd_es_row__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71230);
/* harmony import */ var antd_es_input_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47673);
/* harmony import */ var antd_es_input__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(4107);
/* harmony import */ var antd_es_col_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89032);
/* harmony import */ var antd_es_col__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(15746);
/* harmony import */ var antd_es_form_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9715);
/* harmony import */ var antd_es_form__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(35845);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2824);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34041);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24731);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);





















var Option = antd_es_select__WEBPACK_IMPORTED_MODULE_9__/* .default.Option */ .Z.Option;
var layout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};
var isModifyList = [{
  value: 1,
  label: '订货量',
  children: [{
    value: 0,
    label: '全部'
  }, {
    value: 1,
    label: '已修改'
  }, {
    value: 2,
    label: '未修改'
  }]
}, {
  value: 2,
  label: '门店售价',
  children: [{
    value: 0,
    label: '全部'
  }, {
    value: 1,
    label: '已修改'
  }, {
    value: 2,
    label: '未修改'
  }]
}, {
  value: 3,
  label: '到店价',
  children: [{
    value: 0,
    label: '全部'
  }, {
    value: 1,
    label: '已修改'
  }, {
    value: 2,
    label: '未修改'
  }]
}];
/* harmony default export */ __webpack_exports__["Z"] = (props => {
  var storeData = props.storeData,
      orderNo = props.orderNo,
      setFromCheckedShop = props.setFromCheckedShop,
      storeTableList = props.storeTableList,
      form = props.form,
      detailData = props.detailData,
      commodity = props.commodity,
      storeStateList = props.storeStateList;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_useState3, 2),
      treeData = _useState4[0],
      setTreeData = _useState4[1];

  var structureTreeData = data => {
    var arrAyData = [];
    var objData;

    if (data && data.length > 0) {
      data.map(item => {
        objData = {
          value: item.backCategoryId,
          label: item.backCategoryName
        };

        if (item.childBackCategory && item.childBackCategory.length > 0) {
          objData.children = structureTreeData(item.childBackCategory);
        }

        arrAyData.push(objData);
      });
    }

    return arrAyData;
  }; // 获取类目的接口


  var getDataSource = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().mark(function _callee() {
      var res, result, success, _result$childBackCate, childBackCategory, _treeData;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)('pms.backCategoryManage.getBackCategoryTree', {});

            case 2:
              res = _context.sent;
              result = res.result, success = res.success;

              if (success) {
                _result$childBackCate = result.childBackCategory, childBackCategory = _result$childBackCate === void 0 ? [] : _result$childBackCate; // 处理下树的数据
                // structureTreeData(childBackCategory)
                // console.log(structureTreeData(childBackCategory), 'childBackCategory')

                _treeData = structureTreeData(childBackCategory);
                setTreeData(_treeData);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getDataSource() {
      return _ref.apply(this, arguments);
    };
  }();

  var queryWaterProduct = () => {
    if (detailData == 1) {
      storeTableList();
    } else {
      commodity();
    }
  }; // 选中的门店


  var pitchOnShop = data => {
    //  console.log(data, 'data')
    var placeIdsData = [];
    data && data.map(item => {
      if (item) {
        var _data = item.split('--');

        placeIdsData.push(_data[0]);
      }
    });
    setFromCheckedShop(placeIdsData); // console.log(placeIdsData, 'placeIdsData')
  };

  return (0,react__WEBPACK_IMPORTED_MODULE_8__.useMemo)(() => {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, layout, {
      form: form,
      className: "formstyle"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_row__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z, {
      gutter: 16
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, {
      span: 6
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_13__/* .default.Item */ .Z.Item, {
      label: "\u95E8\u5E97",
      name: "placeIds"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, {
      onChange: value => {
        // 获取到选中的门店
        pitchOnShop(value);
      },
      placeholder: "\u8BF7\u9009\u62E9\u95E8\u5E97",
      allowClear: true,
      mode: "multiple"
    }, storeData.map(item => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(Option, {
        key: item.shopId,
        value: "".concat(item.shopId, "--").concat(item.shopShortName)
      }, item.shopShortName);
    })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, {
      span: 6
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_13__/* .default.Item */ .Z.Item, {
      label: "\u5546\u54C1",
      name: "goodsKey"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z, {
      placeholder: "\u5546\u54C1\u7F16\u7801/\u540D\u79F0"
    }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, {
      span: 6
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_13__/* .default.Item */ .Z.Item, {
      label: "\u662F\u5426\u4FEE\u6539",
      name: "isModify"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(Option, {
      value: "0"
    }, "\u5168\u90E8"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(Option, {
      value: "1"
    }, "\u662F"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(Option, {
      value: "2"
    }, "\u5426"))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_row__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z, {
      gutter: 16
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, {
      span: 6
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_13__/* .default.Item */ .Z.Item, {
      label: "\u5355\u53F7"
    }, orderNo)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, {
      span: 6
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_13__/* .default.Item */ .Z.Item, {
      label: " ",
      name: "isFinish",
      valuePropName: "checked",
      className: "store"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_checkbox__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
      onChange: () => {
        storeStateList();
      }
    }, "\u672A\u5B8C\u6210\u95E8\u5E97"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, {
      span: 4,
      offset: 6
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z, {
      type: "primary",
      onClick: () => {
        queryWaterProduct();
      },
      style: {
        marginRight: '15px'
      }
    }, "\u67E5\u8BE2"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z, {
      onClick: () => {
        form.resetFields();

        if (detailData == 1) {
          storeTableList();
        } else {
          commodity();
        }

        storeStateList();
      }
    }, "\u91CD\u7F6E"))));
  }, [storeData]);
});

/***/ }),

/***/ 74989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31097);
/* harmony import */ var antd_es_radio_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88983);
/* harmony import */ var antd_es_radio__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55742);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);






/* harmony default export */ __webpack_exports__["Z"] = (props => {
  var storeState = props.storeState,
      storeTableList = props.storeTableList,
      setPlaceIdKey = props.setPlaceIdKey; // console.log(storeState,'storeState')

  return (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    var _onChange = e => {
      // console.log(`radio checked:${e.target.value}`);
      setPlaceIdKey(e.target.value);

      if (e.target.value != 1) {
        storeTableList(e.target.value);
      } else {
        storeTableList(1);
      }
    };

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
      className: "storeManage"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_3__/* .default.Group */ .ZP.Group, {
      onChange: value => {
        _onChange(value);
      }
    }, storeState && storeState.map(_ref => {
      var shopId = _ref.shopId,
          shopName = _ref.shopName,
          isModify = _ref.isModify,
          shopShortName = _ref.shopShortName,
          allGoodsReqQtyEmpty = _ref.allGoodsReqQtyEmpty;
      var data;
      data = shopName.replace('谊品生鲜', '');
      data = data.replace('谊品', '');
      return isModify == 1 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
        title: "".concat(data)
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        className: "model"
      }, " ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_3__/* .default.Button */ .ZP.Button, {
        value: shopId,
        style: {
          color: 'green',
          fontWeight: '600'
        }
      }, "".concat(data)))) : allGoodsReqQtyEmpty ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
        title: "".concat(data)
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        className: "model"
      }, " ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_3__/* .default.Button */ .ZP.Button, {
        value: shopId,
        style: {
          color: 'red',
          fontWeight: '600'
        }
      }, "".concat(data)))) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
        title: "".concat(data)
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        className: "model"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_3__/* .default.Button */ .ZP.Button, {
        value: shopId
      }, "".concat(data))));
    })));
  }, [storeState]);
});

/***/ }),

/***/ 57248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_table_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66456);
/* harmony import */ var antd_es_table__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97423);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var columns = [{
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId'
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName'
}, {
  title: '订单量',
  dataIndex: 'goodsReqQty',
  key: 'goodsReqQty'
}];
/* harmony default export */ __webpack_exports__["Z"] = (props => {
  var collectList = props.collectList;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_table__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    columns: columns,
    dataSource: collectList,
    rowKey: "goodsId",
    pagination: false
  });
});

/***/ }),

/***/ 26377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_table_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66456);
/* harmony import */ var antd_es_table__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97423);
/* harmony import */ var antd_es_input_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47673);
/* harmony import */ var antd_es_input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4107);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);






/* harmony default export */ __webpack_exports__["Z"] = (props => {
  var storeAquaticProductsList = props.storeAquaticProductsList,
      loading = props.loading,
      editAquaticReplenishment = props.editAquaticReplenishment,
      disabled = props.disabled,
      inputTable = props.inputTable,
      setInputTable = props.setInputTable,
      aquaticProducts = props.aquaticProducts,
      setImportInit = props.setImportInit,
      importInit = props.importInit,
      setSortQuery = props.setSortQuery;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
    showBoolean: true,
    indexKey: '',
    name: ''
  }),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var handleTableChange = (pagination, filters, sorter) => {
    var order = sorter.order; // console.log(order, 'order', sorter, 'sorter')

    if (order) {
      setSortQuery({
        orderByType: order == 'ascend' ? 1 : 2,
        orderBy: sorter.field,
        open: true
      });
    } else {
      setSortQuery({
        orderByType: null,
        orderBy: null,
        open: true
      });
    }
  };

  return (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    // console.log(storeAquaticProductsList, '水产的数据')
    var placeName = storeAquaticProductsList.placeName,
        totalGoodsReqQty = storeAquaticProductsList.totalGoodsReqQty,
        totalTargetPercentConversion = storeAquaticProductsList.totalTargetPercentConversion,
        totalGoodsWeight = storeAquaticProductsList.totalGoodsWeight,
        totalTargetGrossMargin = storeAquaticProductsList.totalTargetGrossMargin,
        lastWeekSameDayVegetableFlow = storeAquaticProductsList.lastWeekSameDayVegetableFlow,
        lastWeekSameDayPercentConversion = storeAquaticProductsList.lastWeekSameDayPercentConversion,
        lastWeekSameDayTotalCategoryFlow = storeAquaticProductsList.lastWeekSameDayTotalCategoryFlow,
        lastWeekSameDayTotalGrossMargin = storeAquaticProductsList.lastWeekSameDayTotalGrossMargin,
        firstTimeVegetableFlow = storeAquaticProductsList.firstTimeVegetableFlow,
        firstTimeTotalCategoryFlow = storeAquaticProductsList.firstTimeTotalCategoryFlow,
        firstTimeTotalGrossMargin = storeAquaticProductsList.firstTimeTotalGrossMargin,
        firstTimePercentConversion = storeAquaticProductsList.firstTimePercentConversion,
        secondTimeVegetableFlow = storeAquaticProductsList.secondTimeVegetableFlow,
        secondTimeTotalCategoryFlow = storeAquaticProductsList.secondTimeTotalCategoryFlow,
        secondTimeTotalGrossMargin = storeAquaticProductsList.secondTimeTotalGrossMargin,
        secondTimePercentConversion = storeAquaticProductsList.secondTimePercentConversion,
        thirdTimePercentConversion = storeAquaticProductsList.thirdTimePercentConversion,
        list = storeAquaticProductsList.list;
    var columns = [{
      title: '商品基本信息',
      align: 'center',
      children: [{
        title: '序号',
        width: 100,
        dataIndex: 'placeId',
        align: 'center',
        render: (text, data, index) => {
          return index + 1;
        }
      }, {
        title: '门店名称',
        width: 100,
        dataIndex: 'placeName',
        align: 'center'
      }, {
        title: '商品名称',
        dataIndex: 'goodsName',
        width: 100,
        align: 'center',
        sorter: true
      }, {
        title: '商品编码',
        width: 100,
        dataIndex: 'goodsId',
        align: 'center',
        sorter: true
      }, // {
      //   title: '类目(四级)',
      //   dataIndex: 'firstCategoryName',
      //   align: 'center',
      //   ellipsis: {
      //     showTitle: false
      //   },
      //   width: 90,
      //   render: (
      //     text: string,
      //     data: {
      //       firstCategoryName: string
      //       secondCategoryName: string
      //       thirdCategoryName: string
      //       fourthCategoryName: string
      //     }
      //   ) => {
      //     let { firstCategoryName, secondCategoryName, thirdCategoryName, fourthCategoryName } = data
      //     let address = `${firstCategoryName}/${secondCategoryName}/${thirdCategoryName}/${fourthCategoryName}`
      //     return (
      //       <Tooltip placement='topLeft' title={address}>
      //         {address}
      //       </Tooltip>
      //     )
      //   }
      // },
      {
        title: '最小起订量',
        width: 100,
        dataIndex: 'orderStepSize',
        align: 'center',
        sorter: true
      }]
    }, {
      title: '补货规划',
      children: [{
        title: '份数量合计',
        children: [{
          title: "\u95E8\u5E97\u8BA2\u8D27\u91CF",
          children: [{
            title: '份数量',
            dataIndex: 'goodsReqQty',
            width: 80,
            render: (text, data) => {
              // 二个input 框一个展示一个输出
              if (show.indexKey === data.id && show.name === 'goodsReqQty') {
                //  console.log(text,'返回的值',show,'inputTable',inputTable)
                return show.showBoolean ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
                  value: text,
                  disabled: disabled,
                  onFocus: () => {
                    setShow({
                      showBoolean: false,
                      indexKey: data.id,
                      name: 'goodsReqQty'
                    });
                  }
                }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
                  value: importInit ? inputTable : text,
                  onBlur: () => {
                    editAquaticReplenishment(data, 'goodsReqQty');
                    setShow({
                      showBoolean: true,
                      indexKey: data.id,
                      name: 'goodsReqQty'
                    });
                  },
                  onChange: e => {
                    var value = e.target.value;
                    var reg = /^(-)?(0|[1-9]\d*)\.\d{3}$/;

                    if (!reg.test("".concat(value))) {
                      // console.log(value,'value输入的值')
                      setInputTable(value);
                      setImportInit(true);
                    }
                  }
                });
              } else {
                return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
                  value: text,
                  disabled: disabled,
                  onFocus: () => {
                    setShow({
                      showBoolean: false,
                      indexKey: data.id,
                      name: 'goodsReqQty'
                    });
                  }
                });
              }
            }
          }, {
            title: '单份重量',
            dataIndex: 'goodsSingleWeight',
            key: 'goodsSingleWeight'
          }]
        }]
      }, {
        title: "".concat(totalGoodsReqQty ? totalGoodsReqQty : ''),
        children: [{
          title: "".concat(totalGoodsWeight ? totalGoodsWeight : ''),
          children: [{
            title: '订货量',
            dataIndex: 'orderQty'
          }, {
            title: '当日到货',
            dataIndex: 'todayArrivalQuantity'
          }, {
            title: '实时销量',
            dataIndex: 'realTimeSales'
          }, {
            title: '实际库存',
            dataIndex: 'actualStock',
            width: 80,
            render: (text, data) => {
              // 二个input 框一个展示一个输出
              if (show.indexKey === data.id && show.name === 'actualStock') {
                return show.showBoolean ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
                  value: text,
                  disabled: disabled,
                  onFocus: () => {
                    setShow({
                      showBoolean: false,
                      indexKey: data.id,
                      name: 'actualStock'
                    });
                  }
                }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
                  value: importInit ? inputTable : text,
                  onBlur: () => {
                    editAquaticReplenishment(data, 'actualStock');
                    setShow({
                      showBoolean: true,
                      indexKey: data.id,
                      name: 'actualStock'
                    });
                  },
                  onChange: e => {
                    var value = e.target.value;
                    var reg = /^(-)?(0|[1-9]\d*)\.\d{3}$/;

                    if (!reg.test("".concat(value))) {
                      setInputTable(value);
                      setImportInit(true);
                    }
                  }
                });
              } else {
                return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
                  value: text,
                  disabled: disabled,
                  onFocus: () => {
                    setShow({
                      showBoolean: false,
                      indexKey: data.id,
                      name: 'actualStock'
                    });
                  }
                });
              }
            }
          }]
        }]
      }, {
        title: '目标转化率',
        children: [{
          title: "\u76EE\u6807\u6BDB\u5229\u5408\u8BA1",
          children: [{
            title: '实时库存',
            dataIndex: 'realStock',
            key: 'realStock'
          }, {
            title: '到店价',
            dataIndex: 'shopPrice',
            key: 'shopPrice',
            width: 80,
            render: (text, data) => {
              // 二个input 框一个展示一个输出
              if (show.indexKey === data.id && show.name === 'shopPrice') {
                return show.showBoolean ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
                  value: text,
                  disabled: disabled,
                  onFocus: () => {
                    setShow({
                      showBoolean: false,
                      indexKey: data.id,
                      name: 'shopPrice'
                    });
                  }
                }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
                  value: importInit ? inputTable : text,
                  onBlur: () => {
                    editAquaticReplenishment(data, 'shopPrice');
                    setShow({
                      showBoolean: true,
                      indexKey: data.id,
                      name: 'shopPrice'
                    });
                  },
                  onChange: e => {
                    var value = e.target.value;
                    var reg = /^(-)?(0|[1-9]\d*)\.\d{3}$/;

                    if (!reg.test("".concat(value))) {
                      setInputTable(value);
                      setImportInit(true);
                    }
                  }
                });
              } else {
                return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
                  value: text,
                  disabled: disabled,
                  onFocus: () => {
                    setShow({
                      showBoolean: false,
                      indexKey: data.id,
                      name: 'shopPrice'
                    });
                  }
                });
              }
            }
          }, {
            title: '销售价',
            dataIndex: 'sellingPrice',
            key: 'sellingPrice',
            width: 80,
            render: (text, data) => {
              // 二个input 框一个展示一个输出
              if (show.indexKey === data.id && show.name === 'sellingPrice') {
                return show.showBoolean ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
                  value: text,
                  disabled: disabled,
                  onFocus: () => {
                    setShow({
                      showBoolean: false,
                      indexKey: data.id,
                      name: 'sellingPrice'
                    });
                  }
                }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
                  value: importInit ? inputTable : text,
                  onBlur: () => {
                    editAquaticReplenishment(data, 'sellingPrice');
                    setShow({
                      showBoolean: true,
                      indexKey: data.id,
                      name: 'sellingPrice'
                    });
                  },
                  onChange: e => {
                    var value = e.target.value;
                    var reg = /^(-)?(0|[1-9]\d*)\.\d{3}$/;

                    if (!reg.test("".concat(value))) {
                      setInputTable(value);
                      setImportInit(true);
                    }
                  }
                });
              } else {
                return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
                  value: text,
                  disabled: disabled,
                  onFocus: () => {
                    setShow({
                      showBoolean: false,
                      indexKey: data.id,
                      name: 'sellingPrice'
                    });
                  }
                });
              }
            }
          }]
        }]
      }, {
        title: "".concat(totalTargetPercentConversion ? totalTargetPercentConversion : ''),
        children: [{
          title: "".concat(totalTargetGrossMargin ? totalTargetGrossMargin : ''),
          children: [{
            title: '份加价额',
            dataIndex: 'barCodePremiumPrice'
          }, {
            title: '目标毛利',
            dataIndex: 'targetGrossMargin'
          }]
        }]
      }]
    }, // {
    //   title: '月经营数据',
    //   children: [
    //     {
    //       title: '月客流',
    //       dataIndex: 'monthFootfall'
    //     },
    //     {
    //       title: '月销量',
    //       dataIndex: 'monthSales'
    //     }
    //   ]
    // },
    {
      title: '上周同天经营数据',
      children: [{
        title: '菜流',
        children: [{
          title: '品流合计',
          children: [{
            title: '销量',
            dataIndex: 'lastWeekSameDaySales'
          }]
        }]
      }, {
        title: "".concat(lastWeekSameDayVegetableFlow ? lastWeekSameDayVegetableFlow : ''),
        children: [{
          title: "".concat(lastWeekSameDayTotalCategoryFlow ? lastWeekSameDayTotalCategoryFlow : ''),
          children: [{
            title: '库存',
            dataIndex: 'lastWeekSameDayStock'
          }]
        }]
      }, {
        title: '总转化率',
        children: [{
          title: '毛利合计',
          children: [{
            title: '均价',
            dataIndex: 'lastWeekSameDayAvgPrice'
          }]
        }]
      }, {
        title: "".concat(lastWeekSameDayPercentConversion ? lastWeekSameDayPercentConversion : ''),
        children: [{
          title: "".concat(lastWeekSameDayTotalGrossMargin ? lastWeekSameDayTotalGrossMargin : ''),
          children: [{
            title: '毛利',
            dataIndex: 'lastWeekSameDayGrossMargin'
          }, {
            title: '品流',
            dataIndex: 'lastWeekSameDayCategoryFlow'
          }]
        }]
      }]
    }, {
      title: '时段经营数据',
      children: [{
        title: '0-12',
        children: [{
          title: '菜流',
          children: [{
            title: '品流合计',
            children: [{
              title: '品流',
              dataIndex: 'firstTimeCategoryFlow'
            }]
          }]
        }, {
          title: "".concat(firstTimeVegetableFlow ? firstTimeVegetableFlow : ''),
          children: [{
            title: "".concat(firstTimeTotalCategoryFlow ? firstTimeTotalCategoryFlow : ''),
            children: [{
              title: '转率',
              dataIndex: 'firstTimeConversionRate'
            }, {
              title: '销量',
              dataIndex: 'firstTimeSales'
            }]
          }]
        }, {
          title: '转化率',
          children: [{
            title: '毛利合计',
            children: [{
              title: '均价',
              dataIndex: 'firstTimeAvgPrice'
            }]
          }]
        }, {
          title: "".concat(firstTimePercentConversion ? firstTimePercentConversion : ''),
          children: [{
            title: "".concat(firstTimeTotalGrossMargin ? firstTimeTotalGrossMargin : ''),
            children: [{
              title: '差量',
              dataIndex: 'firstTimeDifferAmount'
            }, {
              title: '毛利',
              dataIndex: 'firstTimeGrossMargin'
            }]
          }]
        }]
      }, {
        title: '12-19',
        children: [{
          title: '菜流',
          children: [{
            title: '品流合计',
            children: [{
              title: '品流',
              dataIndex: 'secondTimeCategoryFlow'
            }]
          }]
        }, {
          title: "".concat(secondTimeVegetableFlow ? secondTimeVegetableFlow : ''),
          children: [{
            title: "".concat(secondTimeTotalCategoryFlow ? secondTimeTotalCategoryFlow : ''),
            children: [{
              title: '转率',
              dataIndex: 'secondTimeConversionRate'
            }, {
              title: '销量',
              dataIndex: 'secondTimeSales'
            }]
          }]
        }, {
          title: '转化率',
          children: [{
            title: '毛利合计',
            children: [{
              title: '均价',
              dataIndex: 'secondTimeAvgPrice'
            }]
          }]
        }, {
          title: "".concat(secondTimePercentConversion ? secondTimePercentConversion : ''),
          children: [{
            title: "".concat(secondTimeTotalGrossMargin ? secondTimeTotalGrossMargin : ''),
            children: [{
              title: '差量',
              dataIndex: 'secondTimeDifferAmount'
            }, {
              title: '毛利',
              dataIndex: 'secondTimeGrossMargin'
            }]
          }]
        }]
      }, {
        title: '19-21',
        children: [{
          title: '转化率',
          children: [{
            title: '销量',
            dataIndex: 'thirdTimeSales'
          }]
        }, {
          title: "".concat(thirdTimePercentConversion ? thirdTimePercentConversion : ''),
          children: [{
            title: "\u5747\u4EF7",
            dataIndex: 'thirdTimeAvgPrice'
          }]
        }]
      }]
    }, {
      title: '历史销售数据',
      children: [{
        title: "".concat(aquaticProducts ? "".concat(aquaticProducts.sevenDayAgoSalesTime, " ").concat(aquaticProducts.sevenDayAgoSalesDateWeek) : ''),
        dataIndex: 'sevenDayAgoSales'
      }, {
        title: "".concat(aquaticProducts ? "".concat(aquaticProducts.sixDayAgoSalesTime, " ").concat(aquaticProducts.sixDayAgoSalesDateWeek) : ''),
        dataIndex: 'sixDayAgoSales'
      }, {
        title: "".concat(aquaticProducts ? "".concat(aquaticProducts.fiveDayAgoSalesTime, " ").concat(aquaticProducts.fiveDayAgoSalesDateWeek) : ''),
        dataIndex: 'fiveDayAgoSales'
      }, {
        title: "".concat(aquaticProducts ? "".concat(aquaticProducts.fourDayAgoSalesTime, " ").concat(aquaticProducts.fourDayAgoSalesDateWeek) : ''),
        dataIndex: 'fourDayAgoSales'
      }, {
        title: "".concat(aquaticProducts ? "".concat(aquaticProducts.threeDayAgoSalesTime, " ").concat(aquaticProducts.threeDayAgoSalesDateWeek) : ''),
        dataIndex: 'threeDayAgoSales'
      }, {
        title: "".concat(aquaticProducts ? "".concat(aquaticProducts.twoDayAgoSalesTime, " ").concat(aquaticProducts.twoDayAgoSalesDateWeek) : ''),
        dataIndex: 'twoDayAgoSales'
      }, {
        title: "".concat(aquaticProducts ? "".concat(aquaticProducts.yesterdaySalesTime, " ").concat(aquaticProducts.yesterdaySalesDateWeek) : ''),
        dataIndex: 'yesterdaySales'
      }]
    }];
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_table__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
      size: "small",
      style: {
        marginBottom: '40px'
      },
      rowKey: record => record && record.id,
      pagination: false,
      loading: loading,
      columns: columns,
      dataSource: list,
      bordered: true,
      scroll: {
        x: 2800,
        y: 500
      },
      onChange: handleTableChange
    });
  }, [storeAquaticProductsList, show, inputTable, importInit]);
});

/***/ }),

/***/ 8481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24731);
/* harmony import */ var _hooks_useLoopImport__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88242);
/* harmony import */ var _components_Uploader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84843);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30656);










var GoodsDetailImportBtn = props => {
  var orderNo = props.orderNo,
      _props$callBack = props.callBack,
      callBack = _props$callBack === void 0 ? () => {} : _props$callBack,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? '' : _props$mode; // props

  /** 导入初始化 轮询 */

  var _useLoopImport = (0,_hooks_useLoopImport__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)({
    request: {
      url: 'purchase.import.getLastImportResult',
      params: {
        businessType: 18,
        orderNo: orderNo
      }
    },
    refreshCallback: callBack
  }),
      loading = _useLoopImport.loading,
      loadingModal = _useLoopImport.loadingModal,
      startLoop = _useLoopImport.startLoop; // 导入商品明细


  var changeUpload = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().mark(function _callee(val) {
      var params, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = {
                resId: val,
                orderNo: orderNo,
                isSandTable: mode === 'sandTable' ? 1 : 2
              };
              _context.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_7__/* .IMPORT_SHOP_PRICE */ .Cj, params);

            case 3:
              res = _context.sent;

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_8__.default.success('导入任务添加成功');

                startLoop();
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [startLoop, orderNo, mode]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_components_Uploader__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z // accept='.xlsx,.xls'
  , {
    onChange: changeUpload,
    showType: 1,
    tokenUrl: "purchase.resource.getResourceToken",
    loading: loading,
    btnText: "\u5E93\u5B58\u4EF7\u683C",
    uploadOptions: {
      showUploadList: false // disabled: !curOrganizationId

    }
  }), loadingModal);
};

/* harmony default export */ __webpack_exports__["default"] = (GoodsDetailImportBtn);

/***/ }),

/***/ 73968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24731);
/* harmony import */ var _hooks_useLoopImport__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88242);
/* harmony import */ var _components_Uploader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84843);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30656);










var GoodsDetailImportBtn = props => {
  var orderNo = props.orderNo,
      _props$callBack = props.callBack,
      callBack = _props$callBack === void 0 ? () => {} : _props$callBack,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? '' : _props$mode; // props

  /** 导入初始化 轮询 */

  var _useLoopImport = (0,_hooks_useLoopImport__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)({
    request: {
      url: 'purchase.import.getLastImportResult',
      params: {
        businessType: 23,
        orderNo: orderNo
      }
    },
    refreshCallback: callBack
  }),
      loading = _useLoopImport.loading,
      loadingModal = _useLoopImport.loadingModal,
      startLoop = _useLoopImport.startLoop; // 导入商品明细


  var changeUpload = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().mark(function _callee(val) {
      var params, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = {
                resId: val,
                orderNo: orderNo,
                isSandTable: mode === 'sandTable' ? 1 : 2
              };
              _context.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_7__/* .IMPORT_SHOP_DETAIL */ .Ku, params);

            case 3:
              res = _context.sent;

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_8__.default.success('导入任务添加成功');

                startLoop();
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [startLoop, orderNo, mode]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_components_Uploader__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z // accept='.xlsx,.xls'
  , {
    onChange: changeUpload,
    showType: 1,
    tokenUrl: "purchase.resource.getResourceToken",
    loading: loading,
    btnText: "\u5546\u54C1\u660E\u7EC6",
    uploadOptions: {
      showUploadList: false // disabled: !curOrganizationId

    }
  }), loadingModal);
};

/* harmony default export */ __webpack_exports__["default"] = (GoodsDetailImportBtn);

/***/ }),

/***/ 66970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useCategoryWholeData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61982);



function useFormfields(shopList, orderNo, changePlace, changeIsCompleted) {
  // const { mappingList } = useMapping([76])
  // const vegetablesList = useMemo(() => mappingList.get(76), [mappingList])
  var categoryList = (0,_hooks_useCategoryWholeData__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)(4);
  var isModifyList = [{
    value: 1,
    label: '订货量',
    children: [{
      value: 0,
      label: '全部'
    }, {
      value: 1,
      label: '已修改'
    }, {
      value: 2,
      label: '未修改'
    }]
  }, {
    value: 2,
    label: '门店售价',
    children: [{
      value: 0,
      label: '全部'
    }, {
      value: 1,
      label: '已修改'
    }, {
      value: 2,
      label: '未修改'
    }]
  }, {
    value: 3,
    label: '到店价',
    children: [{
      value: 0,
      label: '全部'
    }, {
      value: 1,
      label: '已修改'
    }, {
      value: 2,
      label: '未修改'
    }]
  }];
  return [{
    label: '门店',
    name: 'placeIds',
    type: 'SELECT',
    dataList: shopList || [],
    fieldOptions: {
      placeholder: '请选择门店',
      mode: 'multiple',
      maxTagCount: 1,
      onChange: v => changePlace(v)
    }
  }, {
    label: '商品',
    name: 'goodsKey',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '商品编码/名称' // changeOnSelect: true

    }
  }, {
    label: '类目',
    name: 'category',
    type: 'CASCADER',
    dataList: categoryList,
    fieldOptions: {
      placeholder: '请选择类目',
      changeOnSelect: true
    }
  }, // {
  //   label: '菜种',
  //   name: 'vegetablesType',
  //   type: 'SELECT',
  //   dataList: vegetablesList,
  //   fieldOptions: {
  //     placeholder: '请选择菜种'
  //   }
  // },
  {
    label: '是否修改',
    name: 'modify',
    type: 'CASCADER',
    dataList: isModifyList,
    fieldOptions: {
      placeholder: '请选择是否修改'
    }
  }, // {
  //   label: '是否修改',
  //   name: 'isModify',
  //   type: 'SELECT',
  //   dataList: isModifyList,
  //   fieldOptions: {
  //     placeholder: '请选择是否修改'
  //   }
  // },
  {
    label: ' ',
    name: 'isPromotionGoods',
    type: 'CHECKBOX_GROUP',
    dataList: [{
      value: 1,
      label: '推动品'
    }]
  }, {
    label: ' ',
    name: 'isCompleted',
    type: 'CHECKBOX_GROUP',
    dataList: [{
      value: 1,
      label: '未完成门店'
    }],
    fieldOptions: {
      onChange: v => changeIsCompleted(v)
    }
  }, {
    label: '单号',
    name: 'OrderNo',
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, orderNo)
  }];
}

/* harmony default export */ __webpack_exports__["default"] = (useFormfields);

/***/ }),

/***/ 19392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useCategoryWholeData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61982);



function useFormfields(shopList, orderNo, changePlace, changeIsCompleted) {
  // const { mappingList } = useMapping([76])
  // const vegetablesList = useMemo(() => mappingList.get(76), [mappingList])
  var categoryList = (0,_hooks_useCategoryWholeData__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)(4);
  var isModifyList = [{
    value: 1,
    label: '订货量',
    children: [{
      value: 0,
      label: '全部'
    }, {
      value: 1,
      label: '已修改'
    }, {
      value: 2,
      label: '未修改'
    }]
  }, {
    value: 2,
    label: '门店售价',
    children: [{
      value: 0,
      label: '全部'
    }, {
      value: 1,
      label: '已修改'
    }, {
      value: 2,
      label: '未修改'
    }]
  }, {
    value: 3,
    label: '到店价',
    children: [{
      value: 0,
      label: '全部'
    }, {
      value: 1,
      label: '已修改'
    }, {
      value: 2,
      label: '未修改'
    }]
  }];
  return [{
    label: '门店',
    name: 'place',
    type: 'SELECT',
    dataList: shopList,
    fieldOptions: {
      placeholder: '请选择门店',
      mode: 'multiple',
      maxTagCount: 1,
      onChange: v => changePlace(v)
    }
  }, {
    label: '商品',
    name: 'goodsKey',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '商品编码/名称' // changeOnSelect: true

    }
  }, {
    label: '类目',
    name: 'category',
    type: 'CASCADER',
    dataList: categoryList,
    fieldOptions: {
      placeholder: '请选择类目',
      changeOnSelect: true
    }
  }, // {
  //   label: '菜种',
  //   name: 'vegetablesType',
  //   type: 'SELECT',
  //   dataList: vegetablesList,
  //   fieldOptions: {
  //     placeholder: '请选择菜种'
  //   }
  // },
  {
    label: '是否修改',
    name: 'modify',
    type: 'CASCADER',
    dataList: isModifyList,
    fieldOptions: {
      placeholder: '请选择是否修改'
    }
  }, // {
  //   label: '是否修改',
  //   name: 'isModify',
  //   type: 'SELECT',
  //   dataList: isModifyList,
  //   fieldOptions: {
  //     placeholder: '请选择是否修改'
  //   }
  // },
  {
    label: ' ',
    name: 'isPromotionGoods',
    type: 'CHECKBOX_GROUP',
    dataList: [{
      value: 1,
      label: '推动品'
    }]
  }, {
    label: ' ',
    name: 'isCompleted',
    type: 'CHECKBOX_GROUP',
    dataList: [{
      value: 1,
      label: '未完成门店'
    }],
    fieldOptions: {
      onChange: v => changeIsCompleted(v)
    }
  }, {
    label: '单号',
    name: 'OrderNo',
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, orderNo)
  }];
}

/* harmony default export */ __webpack_exports__["default"] = (useFormfields);

/***/ }),

/***/ 65540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46565);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30656);






function ShopCollect(props) {
  var columns = [{
    title: '序号',
    dataIndex: 'goodsListIndex',
    width: 50,
    render: (_t, _r, i) => i + 1
  }, {
    title: '门店编码',
    dataIndex: 'shopCode',
    key: 'shopCode',
    width: 100
  }, {
    title: '门店',
    dataIndex: 'shopName',
    key: 'shopName',
    width: 100,
    render: (_t, _r, i) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
      placement: "top",
      title: _t.replace(/合肥谊品生鲜/g, "")
    }, _t.replace(/合肥谊品生鲜/g, ""))
  }, {
    title: '商品种类',
    dataIndex: 'skuCount',
    key: 'skuCount',
    width: 100
  }, {
    title: '订货量',
    dataIndex: 'goodsReqQty',
    key: 'goodsReqQty',
    width: 100,
    sorter: (a, b) => a.goodsReqQty - b.goodsReqQty
  }, {
    title: '环比同天销量',
    dataIndex: 'sixDayAgoSales',
    key: 'sixDayAgoSales',
    width: 120,
    sorter: (a, b) => a.sixDayAgoSales - b.sixDayAgoSales
  }, {
    title: '剩余库存',
    dataIndex: 'surplusStock',
    key: 'surplusStock',
    width: 100,
    sorter: (a, b) => a.surplusStock - b.surplusStock
  }, {
    title: '份加价',
    dataIndex: 'barCodePremiumPrice',
    key: 'barCodePremiumPrice',
    width: 100,
    sorter: (a, b) => a.barCodePremiumPrice - b.barCodePremiumPrice
  }, {
    title: '加价总额',
    dataIndex: 'totalPremiumPrice',
    key: 'totalPremiumPrice',
    width: 100,
    sorter: (a, b) => a.totalPremiumPrice - b.totalPremiumPrice
  }, {
    title: '销售',
    dataIndex: 'totalSalePrice',
    key: 'totalSalePrice',
    width: 100,
    sorter: (a, b) => a.totalSalePrice - b.totalSalePrice
  }, {
    title: '未除去最大平均值销量',
    dataIndex: 'averageSales',
    key: 'averageSales',
    width: 170,
    sorter: (a, b) => a.averageSales - b.averageSales
  }, {
    title: '扣除最大平均值销量',
    dataIndex: 'deductionAverageSales',
    key: 'deductionAverageSales',
    width: 170,
    sorter: (a, b) => a.deductionAverageSales - b.deductionAverageSales
  }];
  var searchParams = props.searchParams;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .EnhanceTable */ .UO, {
    columns: columns,
    searchParams: searchParams,
    requestUrl: _api__WEBPACK_IMPORTED_MODULE_4__/* .SHOP_COLLECT */ .Nj,
    useTool: false,
    pageSize: 500
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (ShopCollect);

/***/ }),

/***/ 786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(71577);
/* harmony import */ var antd_es_form_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9715);
/* harmony import */ var antd_es_form__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(35845);
/* harmony import */ var antd_es_time_picker_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39002);
/* harmony import */ var antd_es_time_picker__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(68351);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(3182);
/* harmony import */ var antd_es_tabs_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18106);
/* harmony import */ var antd_es_tabs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69584);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2824);
/* harmony import */ var _components_FixedBottomCps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32065);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5977);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46565);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(30656);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(24731);
/* harmony import */ var _components_YpshopCps_EditableTable_utils_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82347);
/* harmony import */ var _useColumns__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(37794);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(83987);





























function ShopDetail(props, ref) {
  var _searchParams$conditi3, _searchParams$conditi4;

  var orderNo = props.orderNo,
      isEdit = props.isEdit,
      searchParams = props.searchParams,
      changeShopCallback = props.changeShopCallback,
      afterHandleCallback = props.afterHandleCallback,
      mode = props.mode,
      tableRef = props.tableRef,
      createTimeStamp = props.createTimeStamp,
      selectShopList = props.selectShopList,
      isCompleted = props.isCompleted; // const tableRef = useRef<EnhanceTableRefProps>(null)

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)({}),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState, 2),
      sortOrder = _useState2[0],
      setSortOrder = _useState2[1];

  var TabPane = antd_es_tabs__WEBPACK_IMPORTED_MODULE_15__/* .default.TabPane */ .Z.TabPane;

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(''),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState3, 2),
      activeTab = _useState4[0],
      _setActive = _useState4[1];

  var history = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_16__/* .useHistory */ .k6)();

  var onTabClick = (activeKey, e) => {
    _setActive(activeKey);

    changeShopCallback === null || changeShopCallback === void 0 ? void 0 : changeShopCallback(activeKey);
  };

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)('22:05'),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState5, 2),
      effectTime = _useState6[0],
      setEffectTime = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)([]),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState7, 2),
      _shopTabList = _useState8[0],
      setShopTabList = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState9, 2),
      isModalVisible = _useState10[0],
      setIsModalVisible = _useState10[1];

  var saveRowCallback = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().mark(function _callee(data) {
      var currentRow, currentRowOldData, currentCell, currentCellOldData, res, result;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currentRow = data.currentRow, currentRowOldData = data.currentRowOldData, currentCell = data.currentCell, currentCellOldData = data.currentCellOldData; // console.log(currentCell, currentCellOldData, currentRowOldData);
              // debugger

              _context.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_19__/* .SAVE_SHOP_DETAIL */ .c2, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)({
                isSandTable: mode === 'sandTable' ? 1 : 2
              }, currentRow));

            case 3:
              res = _context.sent;

              if (!res.success) {
                _context.next = 23;
                break;
              }

              result = res.result;

              antd_es_message__WEBPACK_IMPORTED_MODULE_21__.default.success("".concat(currentRow.goodsName, "\u4FDD\u5B58\u6210\u529F\uFF01"));

              if (currentRow.goodsReqQty !== result.goodsReqQty) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_21__.default.warn("".concat(currentRow.goodsName, "\u8981\u8D27\u6B65\u957F\u4E3A\uFF1A").concat(currentRow.orderStepSize, "\uFF0C\u6309\u8981\u8D27\u89C4\u5219\u6298\u7B97\u6210\uFF1A").concat(result.goodsReqQty));
              }

              afterHandleCallback === null || afterHandleCallback === void 0 ? void 0 : afterHandleCallback();
              currentRow.barCodePrice = result.barCodePrice;
              currentRow.totalPremiumPrice = result.totalPremiumPrice;
              currentRow.barCodePremiumPrice = result.barCodePremiumPrice;
              currentRow.totalSalePrice = result.totalSalePrice;
              currentRow.sellingPrice = result.sellingPrice;
              currentRow.goodsReqQty = result.goodsReqQty;
              currentRow.estimateSurplusStock = result.estimateSurplusStock;
              currentRow.shopPrice = result.shopPrice;
              currentRow.estimatedSales = result.estimatedSales;
              currentRow.orderQuantityAfterLossRemoval = result.orderQuantityAfterLossRemoval;
              searchShopList([currentRow.placeId], 2);
              return _context.abrupt("return", currentRow);

            case 23:
              return _context.abrupt("return", currentRowOldData);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function saveRowCallback(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var sortCallback = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)((filter, sorter) => {
    var orderByType;
    var orderBy = sorter.field;

    if (sorter.order === 'ascend') {
      orderByType = 1;
    } else if (sorter.order === 'descend') {
      orderByType = 2;
    } else {
      orderBy = undefined;
    }

    var condition = searchParams.condition;
    setSortOrder({
      orderByType,
      orderBy: orderBy
    });
    return {
      condition: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)({}, condition), {}, {
        orderByType,
        orderBy: orderBy
      })
    };
  }, [searchParams]);

  var commit = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().mark(function _callee2() {
      var curTime, timeStamp, curTimeStamp, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              curTime = moment__WEBPACK_IMPORTED_MODULE_9___default()().format('YYYY-MM-DD');
              timeStamp = moment__WEBPACK_IMPORTED_MODULE_9___default()("".concat(curTime, " ").concat(effectTime)).unix() * 1000;
              curTimeStamp = new Date().getTime();

              if (!(mode === 'sandTable' && curTimeStamp > timeStamp)) {
                _context2.next = 6;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_21__.default.error('时间选择不正确');

              return _context2.abrupt("return");

            case 6:
              _context2.prev = 6;
              _context2.next = 9;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_8__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_19__/* .COMMIT_ORDER */ .gt, {
                orderNo: orderNo,
                isSandTable: mode === 'sandTable' ? 1 : 2,
                effectTime: mode === 'sandTable' ? timeStamp : undefined
              });

            case 9:
              res = _context2.sent;

              if (!res.success) {
                _context2.next = 16;
                break;
              }

              setIsModalVisible(false);
              _context2.next = 14;
              return antd_es_message__WEBPACK_IMPORTED_MODULE_21__.default.success('提交成功');

            case 14:
              history.push("/ReplenishManage/Distribution");
              window.location.reload();

            case 16:
              _context2.next = 21;
              break;

            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](6);

              antd_es_message__WEBPACK_IMPORTED_MODULE_21__.default.error(_context2.t0);

            case 21:
              _context2.prev = 21;
              return _context2.finish(21);

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 18, 21, 23]]);
    }));

    return function commit() {
      return _ref2.apply(this, arguments);
    };
  }();

  var debounceSubmit = () => {
    lodash_debounce__WEBPACK_IMPORTED_MODULE_13___default()(commit, 500)();
  };

  var confirmModal = () => {
    mode === 'sandTable' ? setIsModalVisible(true) : // debounceSubmit()
    antd_es_modal__WEBPACK_IMPORTED_MODULE_22__/* .default.confirm */ .Z.confirm({
      title: '确认提醒',
      icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z, null),
      content: '请确认是否已经完成全部门店的订货量填写！',
      okText: '确认',
      cancelText: '取消',

      onOk() {
        debounceSubmit();
      }

    });
  }; // eslint-disable-next-line react-hooks/exhaustive-deps


  var searchShopList = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().mark(function _callee3(selectShopList, operatyType) {
      var params;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              params = {
                orderNo: orderNo,
                isSandTable: mode === 'sandTable' ? 1 : 2,
                shopIds: selectShopList
              };
              (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_19__/* .SHOP_LIST */ .cM, params).then(_ref4 => {
                var success = _ref4.success,
                    result = _ref4.result;

                if (success) {
                  var list = result.list;
                  var arr = list && list.map(item => ({
                    value: item.shopId,
                    label: item.shopName.replace(/合肥谊品生鲜/g, ''),
                    shortlabel: item.shopShortName.replace(/合肥谊品生鲜/g, ''),
                    isModify: item.isModify
                  })) || [];

                  if (operatyType === 2) {
                    _shopTabList.map((item, index) => {
                      // console.log(item, 'sss', selectShopList[0], 'ppppp')
                      if (item.value === selectShopList[0]) {
                        _shopTabList.splice(index, 1, arr[0]);
                      }

                      return '';
                    });

                    setShopTabList([..._shopTabList]);
                  } else {
                    if ((isCompleted === null || isCompleted === void 0 ? void 0 : isCompleted.length) > 0) {
                      arr = arr.filter(el => el.isModify === 2);
                    }

                    arr.unshift({
                      value: '',
                      label: '全部',
                      shortlabel: '全部',
                      isModify: 2
                    });
                    setShopTabList(arr ? arr : []);
                  }
                }
              });

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function searchShopList(_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(() => {
    var _searchParams$conditi, _searchParams$conditi2;

    setSortOrder({
      orderBy: (_searchParams$conditi = searchParams.condition) === null || _searchParams$conditi === void 0 ? void 0 : _searchParams$conditi.orderBy,
      orderByType: (_searchParams$conditi2 = searchParams.condition) === null || _searchParams$conditi2 === void 0 ? void 0 : _searchParams$conditi2.orderByType
    });
  }, [searchParams]);
  (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(() => {
    searchShopList(selectShopList, 1);

    _setActive('');
  }, [selectShopList, isCompleted]);

  var handleOk = () => {
    debounceSubmit();
  };

  var handleCancel = () => {
    setIsModalVisible(false);
  };

  var onChange = (value, dateString) => {
    setEffectTime(dateString);
  };
  /**
   * 通过该 hook 定义父组件 ref 拿到子组件的实例的内容
   * 父组件使用 reflashTable 来调用子组件 sendRequest 这个方法
   */


  (0,react__WEBPACK_IMPORTED_MODULE_7__.useImperativeHandle)(ref, () => ({
    searchShop: params => searchShopList(params, 1),
    setActive: val => _setActive(val),
    shopTabList: () => _shopTabList
  }), [searchShopList, _setActive]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_8__/* .EnhanceTable */ .UO, {
    tableRef: tableRef //   cacheTable
    ,
    useVirtual: true,
    rowKey: "goodsListIndex",
    columns: isEdit ? (0,_useColumns__WEBPACK_IMPORTED_MODULE_12__.useEditColumns)(sortOrder, (_searchParams$conditi3 = searchParams.condition) === null || _searchParams$conditi3 === void 0 ? void 0 : _searchParams$conditi3.place, mode, createTimeStamp) : (0,_useColumns__WEBPACK_IMPORTED_MODULE_12__.useDetailColumns)(sortOrder, (_searchParams$conditi4 = searchParams.condition) === null || _searchParams$conditi4 === void 0 ? void 0 : _searchParams$conditi4.place, createTimeStamp),
    searchParams: searchParams,
    requestUrl: _api__WEBPACK_IMPORTED_MODULE_19__/* .SHOP_DETAILLIST */ .l9,
    mode: isEdit ? 'scroll' : 'normal',
    saveRowCallback: saveRowCallback,
    sortCallback: sortCallback,
    pageSize: 500 //   rowSelectCallback={rowSelectCallback}
    //   requestUrl={api.DISTRIBUTION_ORDER_LIST}
    //   rowSelection={{
    //     getCheckboxProps: (r: MainListProps) => ({
    //       disabled: r.orderStatus !== 1
    //     })
    //   }}
    // useTool={false}
    ,
    tableHeaderBar: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("div", {
      className: "header-wrap",
      style: {
        overflow: 'hidden'
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_tabs__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z, {
      activeKey: activeTab,
      onTabClick: onTabClick
    }, _shopTabList.map(d => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(TabPane, {
      tab: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("div", {
        style: {
          color: d.isModify === 1 ? 'green' : '',
          fontWeight: d.isModify === 1 ? 600 : 400
        }
      }, !(0,_components_YpshopCps_EditableTable_utils_utils__WEBPACK_IMPORTED_MODULE_11__/* .isEmpty */ .xb)(d.shortlabel) ? d.shortlabel : d.label),
      key: d.value
    }))))
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_22__/* .default */ .Z, {
    title: "\u63D0\u4EA4\u6C99\u76D8\u786E\u8BA4\u552E\u4EF7\u751F\u6548\u65F6\u95F4",
    visible: isModalVisible,
    onOk: handleOk,
    onCancel: handleCancel
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_24__/* .default */ .Z, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_24__/* .default.Item */ .Z.Item, {
    label: "\u552E\u4EF7\u751F\u6548\u65F6\u95F4",
    name: "effectTime",
    rules: [{
      required: true,
      message: '请选择时间'
    }]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_time_picker__WEBPACK_IMPORTED_MODULE_25__/* .default */ .Z, {
    defaultValue: moment__WEBPACK_IMPORTED_MODULE_9___default()(effectTime, 'HH:mm'),
    format: "HH:mm",
    onChange: onChange,
    allowClear: false
  })))), isEdit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(_components_FixedBottomCps__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    width: "100%",
    left: "0px",
    outerRE: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_26__/* .default */ .Z, {
      className: "mRight16",
      onClick: () => {
        history.push("/ReplenishManage/Distribution"); // window.close()
      }
    }, "\u8FD4\u56DE"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_26__/* .default */ .Z, {
      type: "primary",
      onClick: confirmModal
    }, "\u63D0\u4EA4"))
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_7__.forwardRef)(ShopDetail));

/***/ }),

/***/ 37794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useEditColumns": function() { return /* binding */ useEditColumns; },
/* harmony export */   "useDetailColumns": function() { return /* binding */ useDetailColumns; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31097);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var moment_locale_zh_cn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83839);
/* harmony import */ var moment_locale_zh_cn__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment_locale_zh_cn__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96534);
/* harmony import */ var _components_YpshopCps_EditableTable_utils_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82347);







moment__WEBPACK_IMPORTED_MODULE_1___default().locale('zh-cn');
function useEditColumns(sortorder, currentPlace, mode, createTimeStamp) {
  var getSortOrder = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(orderby => {
    if (sortorder.orderBy === orderby) {
      return sortorder.orderByType == 1 ? 'ascend' : 'descend';
    }

    return undefined;
  }, [sortorder]);
  var time = new Date(createTimeStamp);
  return [{
    title: '序号',
    dataIndex: 'goodsListIndex',
    width: 60,
    fixed: 'left',
    render: (_t, _r, i) => i + 1
  }, {
    title: '门店',
    dataIndex: 'placeName',
    key: 'placeName',
    width: 180,
    sorter: true,
    fixed: 'left',
    hide: !(0,_components_YpshopCps_EditableTable_utils_utils__WEBPACK_IMPORTED_MODULE_5__/* .isEmpty */ .xb)(currentPlace) && currentPlace !== ',,全部',
    sortorder: getSortOrder('placeName'),
    render: (_t, _r, i) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
      placement: "top",
      title: _t.replace(/合肥谊品生鲜/g, '')
    }, _t.replace(/合肥谊品生鲜/g, ''))
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 120,
    sorter: true,
    fixed: 'left',
    sortorder: getSortOrder('goodsName'),
    render: (_t, _r, i) => {
      // return '123123'
      if (_r.isPromotionGoods == 1) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
          placement: "top",
          title: _r.goodsName
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
          style: {
            display: 'flex'
          }
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
          className: "recommend-tag"
        }, "\u63A8\u52A8"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
          style: {
            width: '72px',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            fontWeight: 600
          }
        }, _r.goodsName)));
      }

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
        placement: "top",
        title: _r.goodsName
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        style: {
          width: '120px',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          fontWeight: 600
        }
      }, _r.goodsName));
    }
  }, {
    title: '门店',
    dataIndex: 'placeName',
    key: 'placeName',
    width: 100,
    sorter: true,
    hide: !(!(0,_components_YpshopCps_EditableTable_utils_utils__WEBPACK_IMPORTED_MODULE_5__/* .isEmpty */ .xb)(currentPlace) && currentPlace !== ',,全部'),
    sortorder: getSortOrder('placeName'),
    render: (_t, _r, i) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
      placement: "top",
      title: _t.replace(/合肥谊品生鲜/g, '')
    }, _t.replace(/合肥谊品生鲜/g, ''))
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 90,
    sorter: true,
    sortorder: getSortOrder('goodsId')
  }, {
    title: '类目',
    dataIndex: 'thirdCategoryName',
    key: 'thirdCategoryName',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('thirdCategoryName') // render: (_t: any, _r: DetailListProps, i: number) => {
    //     let arr: Array<string> = []
    //     _r.firstCategoryName && arr.push(`${_r.firstCategoryName}`);
    //     _r.secondCategoryName && arr.push(`${_r.secondCategoryName}`);
    //     _r.thirdCategoryName && arr.push(`${_r.thirdCategoryName}`);
    //     _r.fourthCategoryName && arr.push(`${_r.fourthCategoryName}`);
    //     return arr.join('/');
    // }

  }, // {
  //     title: '菜种',
  //     dataIndex: 'vegetablesTypeName',
  //     key: 'vegetablesTypeName',
  //     width: 70,
  //     // sorter: true,
  //     // sortorder: getSortOrder('vegetablesTypeName'),
  // },
  {
    title: '货架期',
    dataIndex: 'shelvesDate',
    key: 'shelvesDate',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('shelvesDate')
  }, {
    title: '昨日库存',
    dataIndex: 'yesterdayInventory',
    key: 'yesterdayInventory',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('yesterdayInventory')
  }, {
    title: '当日到货',
    dataIndex: 'todayArrivalQuantity',
    key: 'todayArrivalQuantity',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('todayArrivalQuantity')
  }, {
    title: '参考实时库存',
    dataIndex: 'realStock',
    key: 'realStock',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('realStock')
  }, {
    title: '实时销量',
    dataIndex: 'realTimeSales',
    key: 'realTimeSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('realTimeSales')
  }, {
    title: '建议订单量',
    dataIndex: 'goodsAdviceQty',
    key: 'goodsAdviceQty',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('goodsAdviceQty')
  }, {
    title: '门店最终订单量',
    dataIndex: 'goodsReqQty',
    key: 'goodsReqQty',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('goodsReqQty'),
    type: (r, i) => {
      return mode === 'sandTable' ? 'TEXT' : 'INPUT';
    },
    fieldOptions: r => {
      // 商品属性 称重商品保留两位小数
      var isWeight = Number(r.isWeigh) === 1;
      return {
        formatter: value => isWeight ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_4__/* .exchageToNum3 */ .hY)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_4__/* .exchageToNum1 */ .Ly)(value)
      };
    }
  }, {
    title: '去损后订单量',
    dataIndex: 'orderQuantityAfterLossRemoval',
    key: 'orderQuantityAfterLossRemoval',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('orderQuantityAfterLossRemoval')
  }, {
    title: '实际库存',
    dataIndex: 'actualStock',
    key: 'actualStock',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('actualStock'),
    type: (r, i) => {
      return mode === 'sandTable' ? 'TEXT' : 'INPUT';
    },
    fieldOptions: r => {
      // 商品属性 称重商品保留两位小数
      var isWeight = Number(r.isWeigh) === 1;
      return {
        formatter: value => isWeight ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_4__/* .exchageToNum3 */ .hY)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_4__/* .exchageToNum1 */ .Ly)(value)
      };
    }
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(7, 'days').format('dddd MM/DD'),
    dataIndex: 'sevenDayAgoSales',
    key: 'sevenDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('sevenDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(6, 'days').format('dddd MM/DD'),
    dataIndex: 'sixDayAgoSales',
    key: 'sixDayAgoSales',
    width: 100,
    sorter: true,
    sortorder: getSortOrder('sixDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(5, 'days').format('dddd MM/DD'),
    dataIndex: 'fiveDayAgoSales',
    key: 'fiveDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('fiveDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(4, 'days').format('dddd MM/DD'),
    dataIndex: 'fourDayAgoSales',
    key: 'fourDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('fourDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(3, 'days').format('dddd MM/DD'),
    dataIndex: 'threeDayAgoSales',
    key: 'threeDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('threeDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(2, 'days').format('dddd MM/DD'),
    dataIndex: 'twoDayAgoSales',
    key: 'twoDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('twoDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(1, 'days').format('dddd MM/DD'),
    dataIndex: 'oneDayAgoSales',
    key: 'oneDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('oneDayAgoSales')
  }, {
    title: '未扣减最大值平均值销量',
    dataIndex: 'averageSales',
    key: 'averageSales',
    width: 100,
    sorter: true,
    sortorder: getSortOrder('averageSales')
  }, {
    title: '扣减最大值平均值销量',
    dataIndex: 'deductionAverageSales',
    key: 'deductionAverageSales',
    width: 100,
    sorter: true,
    sortorder: getSortOrder('deductionAverageSales')
  }, {
    title: '预估剩余库存量',
    dataIndex: 'estimateSurplusStock',
    key: 'estimateSurplusStock',
    type: 'INPUT',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('estimateSurplusStock'),
    fieldOptions: r => {
      // 商品属性 称重商品保留两位小数
      var isWeight = Number(r.isWeigh) === 1;
      return {
        formatter: value => isWeight ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_4__/* .exchageToNum3 */ .hY)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_4__/* .exchageToNum1 */ .Ly)(value)
      };
    }
  }, {
    title: '最小起订量',
    dataIndex: 'orderStepSize',
    key: 'orderStepSize',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('orderStepSize')
  }, {
    title: '平均售价',
    dataIndex: 'avgPrice',
    key: 'avgPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('avgPrice')
  }, {
    title: '去损率',
    dataIndex: 'wastageRate',
    key: 'wastageRate',
    width: 80,
    sorter: true,
    // sortorder: getSortOrder('wastageRate')
    render: text => text ? "".concat(Number(text) * 100, "%") : null
  }, {
    title: '到店价',
    dataIndex: 'shopPrice',
    key: 'shopPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('shopPrice'),
    type: (r, i) => {
      // return r?.shopPriceIsNull === 2 ? 'TEXT' : 'INPUT';
      return 'INPUT';
    },
    fieldOptions: r => {
      return {
        formatter: value => (0,_utils_common__WEBPACK_IMPORTED_MODULE_4__/* .exchageToNum3 */ .hY)(value)
      }; // 商品属性 称重商品保留两位小数
      // const isWeight = Number(r.isWeigh) === 1
      // return { formatter: (value: number) => (isWeight ? exchageToNum3(value) : exchageToNum1(value)) }
    }
  }, {
    title: '参考到店价',
    dataIndex: 'referShopPrice',
    key: 'referShopPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('referShopPrice')
  }, {
    title: '门店售价',
    dataIndex: 'sellingPrice',
    key: 'sellingPrice',
    width: 80,
    type: 'INPUT',
    sorter: true,
    sortorder: getSortOrder('sellingPrice'),
    fieldOptions: r => {
      return {
        formatter: value => (0,_utils_common__WEBPACK_IMPORTED_MODULE_4__/* .exchageToNum3 */ .hY)(value)
      }; // // 商品属性 称重商品保留两位小数
      // const isWeight = Number(r.isWeigh) === 1
      // return { formatter: (value: number) => (isWeight ? exchageToNum3(value) : exchageToNum1(value)) }
    }
  }, {
    title: '参考售价',
    dataIndex: 'referSellingPrice',
    key: 'referSellingPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('referSellingPrice')
  }, {
    title: '预计销量',
    dataIndex: 'estimatedSales',
    key: 'estimatedSales',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('estimatedSales')
  }, {
    title: '份单价',
    dataIndex: 'barCodePrice',
    key: 'barCodePrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('barCodePrice')
  }, {
    title: '份加价',
    dataIndex: 'barCodePremiumPrice',
    key: 'barCodePremiumPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('barCodePremiumPrice')
  }, {
    title: '加价总额',
    dataIndex: 'totalPremiumPrice',
    key: 'totalPremiumPrice',
    width: 100,
    sorter: true,
    sortorder: getSortOrder('totalPremiumPrice')
  }, {
    title: '销售',
    dataIndex: 'totalSalePrice',
    key: 'totalSalePrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('totalSalePrice')
  } // {
  //   title: '累计销量',
  //   dataIndex: 'totalSales',
  //   key: 'totalSales',
  //   width: 80,
  //   sorter: true,
  //   sortorder: getSortOrder('totalSales')
  // },
  // {
  //   title: '单天最大销量',
  //   dataIndex: 'maxSales',
  //   key: 'maxSales',
  //   width: 80,
  //   sorter: true,
  //   sortorder: getSortOrder('maxSales')
  // }
  ];
}
function useDetailColumns(sortorder, currentPlace, createTimeStamp) {
  var getSortOrder = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(orderby => {
    if (sortorder.orderBy === orderby) {
      return sortorder.orderByType == 1 ? 'ascend' : 'descend';
    }

    return undefined;
  }, [sortorder]);
  var time = new Date(createTimeStamp);
  return [{
    title: '序号',
    dataIndex: 'goodsListIndex',
    width: 60,
    fixed: 'left',
    render: (_t, _r, i) => i + 1
  }, {
    title: '门店',
    dataIndex: 'placeName',
    key: 'placeName',
    width: 180,
    sorter: true,
    fixed: 'left',
    hide: !(0,_components_YpshopCps_EditableTable_utils_utils__WEBPACK_IMPORTED_MODULE_5__/* .isEmpty */ .xb)(currentPlace) && currentPlace !== ',,全部',
    sortorder: getSortOrder('placeName'),
    render: (_t, _r, i) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
      placement: "top",
      title: _t.replace(/合肥谊品生鲜/g, '')
    }, _t.replace(/合肥谊品生鲜/g, ''))
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 120,
    sorter: true,
    fixed: 'left',
    sortorder: getSortOrder('goodsName'),
    render: (_t, _r, i) => {
      // return '123123'
      if (_r.isPromotionGoods == 1) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
          placement: "top",
          title: _r.goodsName
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
          style: {
            display: 'flex'
          }
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
          className: "recommend-tag"
        }, "\u63A8\u52A8"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
          style: {
            width: '72px',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            fontWeight: 600
          }
        }, _r.goodsName)));
      }

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
        placement: "top",
        title: _r.goodsName
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        style: {
          width: '120px',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          fontWeight: 600
        }
      }, _r.goodsName));
    }
  }, {
    title: '门店',
    dataIndex: 'placeName',
    key: 'placeName',
    width: 100,
    sorter: true,
    hide: !(!(0,_components_YpshopCps_EditableTable_utils_utils__WEBPACK_IMPORTED_MODULE_5__/* .isEmpty */ .xb)(currentPlace) && currentPlace !== ',,全部'),
    sortorder: getSortOrder('placeName'),
    render: (_t, _r, i) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
      placement: "top",
      title: _t.replace(/合肥谊品生鲜/g, '')
    }, _t.replace(/合肥谊品生鲜/g, ''))
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 90,
    sorter: true,
    sortorder: getSortOrder('goodsId')
  }, {
    title: '类目',
    dataIndex: 'thirdCategoryName',
    key: 'thirdCategoryName',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('thirdCategoryName') // render: (_t: any, _r: DetailListProps, i: number) => {
    //     let arr: Array<string> = []
    //     _r.firstCategoryName && arr.push(`${_r.firstCategoryName}`);
    //     _r.secondCategoryName && arr.push(`${_r.secondCategoryName}`);
    //     _r.thirdCategoryName && arr.push(`${_r.thirdCategoryName}`);
    //     _r.fourthCategoryName && arr.push(`${_r.fourthCategoryName}`);
    //     return arr.join('/');
    // }

  }, // {
  //     title: '菜种',
  //     dataIndex: 'vegetablesTypeName',
  //     key: 'vegetablesTypeName',
  //     width: 70,
  //     // sorter: true,
  //     // sortorder: getSortOrder('vegetablesTypeName'),
  // },
  {
    title: '货架期',
    dataIndex: 'shelvesDate',
    key: 'shelvesDate',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('shelvesDate')
  }, {
    title: '昨日库存',
    dataIndex: 'yesterdayInventory',
    key: 'yesterdayInventory',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('yesterdayInventory')
  }, {
    title: '当日到货',
    dataIndex: 'todayArrivalQuantity',
    key: 'todayArrivalQuantity',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('todayArrivalQuantity')
  }, {
    title: '参考实时库存',
    dataIndex: 'realStock',
    key: 'realStock',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('realStock')
  }, {
    title: '实时销量',
    dataIndex: 'realTimeSales',
    key: 'realTimeSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('realTimeSales')
  }, {
    title: '建议订单量',
    dataIndex: 'goodsAdviceQty',
    key: 'goodsAdviceQty',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('goodsAdviceQty')
  }, {
    title: '门店最终订单量',
    dataIndex: 'goodsReqQty',
    key: 'goodsReqQty',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('goodsReqQty')
  }, {
    title: '去损后订单量',
    dataIndex: 'orderQuantityAfterLossRemoval',
    key: 'orderQuantityAfterLossRemoval',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('orderQuantityAfterLossRemoval')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(7, 'days').format('dddd MM/DD'),
    dataIndex: 'sevenDayAgoSales',
    key: 'sevenDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('sevenDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(6, 'days').format('dddd MM/DD'),
    dataIndex: 'sixDayAgoSales',
    key: 'sixDayAgoSales',
    width: 100,
    sorter: true,
    sortorder: getSortOrder('sixDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(5, 'days').format('dddd MM/DD'),
    dataIndex: 'fiveDayAgoSales',
    key: 'fiveDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('fiveDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(4, 'days').format('dddd MM/DD'),
    dataIndex: 'fourDayAgoSales',
    key: 'fourDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('fourDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(3, 'days').format('dddd MM/DD'),
    dataIndex: 'threeDayAgoSales',
    key: 'threeDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('threeDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(2, 'days').format('dddd MM/DD'),
    dataIndex: 'twoDayAgoSales',
    key: 'twoDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('twoDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(1, 'days').format('dddd MM/DD'),
    dataIndex: 'oneDayAgoSales',
    key: 'oneDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('oneDayAgoSales')
  }, {
    title: '未扣减最大值平均值销量',
    dataIndex: 'averageSales',
    key: 'averageSales',
    width: 100,
    sorter: true,
    sortorder: getSortOrder('averageSales')
  }, {
    title: '扣除最大值平均值销量',
    dataIndex: 'deductionAverageSales',
    key: 'deductionAverageSales',
    width: 100,
    sorter: true,
    sortorder: getSortOrder('deductionAverageSales')
  }, {
    title: '预估剩余库存量',
    dataIndex: 'estimateSurplusStock',
    key: 'estimateSurplusStock',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('estimateSurplusStock')
  }, {
    title: '最小起订量',
    dataIndex: 'orderStepSize',
    key: 'orderStepSize',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('orderStepSize')
  }, {
    title: '平均售价',
    dataIndex: 'avgPrice',
    key: 'avgPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('avgPrice')
  }, {
    title: '去损率',
    dataIndex: 'wastageRate',
    key: 'wastageRate',
    width: 80,
    sorter: true,
    // sortorder: getSortOrder('wastageRate')
    render: text => text ? "".concat(Number(text) * 100, "%") : null
  }, {
    title: '到店价',
    dataIndex: 'shopPrice',
    key: 'shopPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('shopPrice')
  }, {
    title: '参考到店价',
    dataIndex: 'referShopPrice',
    key: 'referShopPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('referShopPrice')
  }, {
    title: '门店售价',
    dataIndex: 'sellingPrice',
    key: 'sellingPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('sellingPrice')
  }, {
    title: '参考售价',
    dataIndex: 'referSellingPrice',
    key: 'referSellingPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('referSellingPrice')
  }, {
    title: '预计销量',
    dataIndex: 'estimatedSales',
    key: 'estimatedSales',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('estimatedSales')
  }, {
    title: '份单价',
    dataIndex: 'barCodePrice',
    key: 'barCodePrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('barCodePrice')
  }, {
    title: '份加价',
    dataIndex: 'barCodePremiumPrice',
    key: 'barCodePremiumPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('barCodePremiumPrice')
  }, {
    title: '加价总额',
    dataIndex: 'totalPremiumPrice',
    key: 'totalPremiumPrice',
    width: 100,
    sorter: true,
    sortorder: getSortOrder('totalPremiumPrice')
  }, {
    title: '销售',
    dataIndex: 'totalSalePrice',
    key: 'totalSalePrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('totalSalePrice')
  } // {
  //   title: '累计销量',
  //   dataIndex: 'totalSales',
  //   key: 'totalSales',
  //   width: 80,
  //   sorter: true,
  //   sortorder: getSortOrder('totalSales')
  // },
  // {
  //   title: '单天最大销量',
  //   dataIndex: 'maxSales',
  //   key: 'maxSales',
  //   width: 80,
  //   sorter: true,
  //   sortorder: getSortOrder('maxSales')
  // }
  ];
}

/***/ }),

/***/ 21610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30656);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24731);







function Statistics(props) {
  var _statistics$goodsReqQ, _statistics$sixDayAgo, _statistics$surplusSt, _statistics$estimated, _statistics$barCodePr, _statistics$barCodePr2, _statistics$totalPrem, _statistics$totalSale;

  var statisticsRef = props.statisticsRef,
      searchParams = props.searchParams; // 汇总信息

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState, 2),
      statistics = _useState2[0],
      setStatistics = _useState2[1]; // 统计信息


  var queryStatData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().mark(function _callee() {
    var res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_5__/* .SHOP_STATICSTICS */ ._R, searchParams);

          case 3:
            res = _context.sent;

            if (res.success) {
              setStatistics(res.result);
            }

            _context.next = 9;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  })), [searchParams]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    queryStatData();
  }, [queryStatData]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (statisticsRef) {
      // @ts-ignore
      statisticsRef.current = {
        queryStatData
      };
    }
  }, [queryStatData, statisticsRef]);
  var style = {
    color: 'rgba(24, 144, 255, 1)'
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "header-height"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, "\u6C47\u603B\uFF1A\u95E8\u5E97\u8BA2\u8D27\u91CF\uFF1A"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: style
  }, (_statistics$goodsReqQ = statistics === null || statistics === void 0 ? void 0 : statistics.goodsReqQty) !== null && _statistics$goodsReqQ !== void 0 ? _statistics$goodsReqQ : '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, " / \u73AF\u6BD4\u540C\u5929\u9500\u91CF\uFF1A"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: style
  }, (_statistics$sixDayAgo = statistics === null || statistics === void 0 ? void 0 : statistics.sixDayAgoSales) !== null && _statistics$sixDayAgo !== void 0 ? _statistics$sixDayAgo : '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, " / \u5269\u4F59\u5E93\u5B58\uFF1A"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: style
  }, (_statistics$surplusSt = statistics === null || statistics === void 0 ? void 0 : statistics.surplusStock) !== null && _statistics$surplusSt !== void 0 ? _statistics$surplusSt : '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, " / \u9884\u8BA1\u9500\u91CF\uFF1A"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: style
  }, (_statistics$estimated = statistics === null || statistics === void 0 ? void 0 : statistics.estimatedSales) !== null && _statistics$estimated !== void 0 ? _statistics$estimated : '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, " / \u4EFD\u5355\u4EF7\uFF1A"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: style
  }, (_statistics$barCodePr = statistics === null || statistics === void 0 ? void 0 : statistics.barCodePrice) !== null && _statistics$barCodePr !== void 0 ? _statistics$barCodePr : '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, " / \u4EFD\u52A0\u4EF7\uFF1A"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: style
  }, (_statistics$barCodePr2 = statistics === null || statistics === void 0 ? void 0 : statistics.barCodePremiumPrice) !== null && _statistics$barCodePr2 !== void 0 ? _statistics$barCodePr2 : '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, " / \u52A0\u4EF7\u603B\u989D\uFF1A"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: style
  }, (_statistics$totalPrem = statistics === null || statistics === void 0 ? void 0 : statistics.totalPremiumPrice) !== null && _statistics$totalPrem !== void 0 ? _statistics$totalPrem : '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, " / \u9500\u552E\uFF1A"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: style
  }, (_statistics$totalSale = statistics === null || statistics === void 0 ? void 0 : statistics.totalSalePrice) !== null && _statistics$totalSale !== void 0 ? _statistics$totalSale : '-'));
}

/* harmony default export */ __webpack_exports__["default"] = (Statistics);

/***/ }),

/***/ 30656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cM": function() { return /* binding */ SHOP_LIST; },
/* harmony export */   "Nj": function() { return /* binding */ SHOP_COLLECT; },
/* harmony export */   "_R": function() { return /* binding */ SHOP_STATICSTICS; },
/* harmony export */   "l9": function() { return /* binding */ SHOP_DETAILLIST; },
/* harmony export */   "c2": function() { return /* binding */ SAVE_SHOP_DETAIL; },
/* harmony export */   "$X": function() { return /* binding */ EXPORT_SHOP_DETAIL; },
/* harmony export */   "Ku": function() { return /* binding */ IMPORT_SHOP_DETAIL; },
/* harmony export */   "Cj": function() { return /* binding */ IMPORT_SHOP_PRICE; },
/* harmony export */   "tP": function() { return /* binding */ EXPORT_SHOP_PRICE; },
/* harmony export */   "fc": function() { return /* binding */ REFRESH_REAL_SRTOCK; },
/* harmony export */   "gt": function() { return /* binding */ COMMIT_ORDER; },
/* harmony export */   "ZS": function() { return /* binding */ DISTRIBUTION_ORDER_DETAIL2; },
/* harmony export */   "vm": function() { return /* binding */ REAL_TIME_SALES_VOLUME; },
/* harmony export */   "EK": function() { return /* binding */ REAL_TIME_SALES_VOLUME_SCHEDULE; }
/* harmony export */ });
// 门店列表
var SHOP_LIST = 'purchase.require.queryAutoRequirePreprocessShops'; // 门店汇总列表

var SHOP_COLLECT = 'purchase.require.statAutoRequirePreprocessDetailByShop'; // 门店汇总

var SHOP_STATICSTICS = 'purchase.require.statAutoRequirePreprocessDetail'; // 门店明细列表

var SHOP_DETAILLIST = 'purchase.require.queryAutoRequirePreprocessDetail'; // 修改门店明细列表

var SAVE_SHOP_DETAIL = 'purchase.require.modifyRequireAutoPreprocessOrder'; // 导出门店明细列表

var EXPORT_SHOP_DETAIL = 'purchase.require.exportRequireAutoPreprocessOrder'; // 导入

var IMPORT_SHOP_DETAIL = 'purchase.require.importRequireAutoPreprocessOrderDetail'; // 导入门店价

var IMPORT_SHOP_PRICE = 'purchase.require.importShopPrice'; // 导出门店价列表

var EXPORT_SHOP_PRICE = 'purchase.require.exportShopPrice'; //  刷新实时库存

var REFRESH_REAL_SRTOCK = 'purchase.require.refreshRealStock'; // 整单提交

var COMMIT_ORDER = 'purchase.require.commitRequireAutoPreprocessOrder';
/**
 * 自动补货策略
 */

var DISTRIBUTION_ORDER_DETAIL2 = 'purchase.require.queryAutoRequirePreprocessInfo'; // 实时销量

var REAL_TIME_SALES_VOLUME = 'purchase.require.refreshRealTimeSales'; // 获取实时销量进度

var REAL_TIME_SALES_VOLUME_SCHEDULE = 'purchase.require.queryRefreshRealTimeSalesProgress';

/***/ }),

/***/ 67735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useShopList; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24731);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30656);




/**
 * 获取门店列表
 */

function useShopList(orderNo, mode) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState, 2),
      shopList = _useState2[0],
      setShopList = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_3__/* .SHOP_LIST */ .cM, {
      orderNo: orderNo,
      isSandTable: mode,
      shopIds: []
    }).then(_ref => {
      var success = _ref.success,
          result = _ref.result;

      if (success) {
        // console.log(result,'reeee')
        var list = result.list;
        var arr = list && list.map(item => ({
          value: item.shopId,
          label: item.shopName.replace(/合肥谊品生鲜/g, ""),
          shortlabel: item.shopShortName.replace(/合肥谊品生鲜/g, ""),
          isModify: item.isModify
        }));
        setShopList(arr ? arr : []);
      }
    });
  }, []);
  return shopList;
}

/***/ }),

/***/ 8450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kO": function() { return /* binding */ DELETE_APPLY_ORDER_LINE; },
/* harmony export */   "b2": function() { return /* binding */ IMPORT_APPLY_ORDER; },
/* harmony export */   "dI": function() { return /* binding */ DOWNLOAD_TEMPLATE; },
/* harmony export */   "LF": function() { return /* binding */ SAVE_APPLY_ORDER_LINE; },
/* harmony export */   "ju": function() { return /* binding */ REPLENISH_LIST_API; },
/* harmony export */   "sB": function() { return /* binding */ REPLENISH_ORDER_EXPORT; },
/* harmony export */   "A7": function() { return /* binding */ SAVE_BASE_INFO_API; },
/* harmony export */   "Cf": function() { return /* binding */ NEW_APPLY_ORDER_API; },
/* harmony export */   "ER": function() { return /* binding */ SUBMIT_APPLY_ORDER; },
/* harmony export */   "Jb": function() { return /* binding */ APPLY_ORDER_BASE_DETAIL; },
/* harmony export */   "XO": function() { return /* binding */ APPLY_ORDER_GOODS_LIST_API; },
/* harmony export */   "go": function() { return /* binding */ CANCEL_APPLY_ORDER; },
/* harmony export */   "hL": function() { return /* binding */ APPLY_CLEAR_GOODS; },
/* harmony export */   "Mo": function() { return /* binding */ GET_PRODUCT_EXTINFO; },
/* harmony export */   "Uv": function() { return /* binding */ GET_SUMMARY_DATA; },
/* harmony export */   "tZ": function() { return /* binding */ GET_REQUIRE_DETAIL_DATA; },
/* harmony export */   "nM": function() { return /* binding */ EXPORT_REQUIRE_DETAIL_DATA; },
/* harmony export */   "ql": function() { return /* binding */ BATCH_SAVE_TEMPLATE; },
/* harmony export */   "hn": function() { return /* binding */ POLL_RESULT; }
/* harmony export */ });
/* unused harmony exports DOWNLOAD_UNORMAL_TEMPLATE, DETAIL_QUERY_GOODS_SALE, DETAIL_QUERY_GOODS_STOCK */
/**
 * API集合
 */
// export const ORDER_LINE_DETAIL_LIST = 'purchase.order.purchaseOrderDetailPageInfo'
// 删除 当前商品行
var DELETE_APPLY_ORDER_LINE = 'purchase.requireApply.deleteRequireApplyDetail'; // 导入

var IMPORT_APPLY_ORDER = 'purchase.requireApply.importRequireApplyDetail'; // 公用 - 下载模板

var DOWNLOAD_TEMPLATE = 'purchase.downlaod.getTemplate'; // 公用 - 下载模板

var DOWNLOAD_UNORMAL_TEMPLATE = 'purchase.downlaod.getTemplate'; // 保存单行商品

var SAVE_APPLY_ORDER_LINE = 'purchase.requireApply.saveRequireApplyDetail'; // 获取申请单列表

var REPLENISH_LIST_API = 'purchase.requireApply.queryRequireApplyInfoList'; // 补货申请单导出

var REPLENISH_ORDER_EXPORT = 'purchase.requireApply.exportRequireDetailGoods'; // 保存基本信息

var SAVE_BASE_INFO_API = 'purchase.requireApply.saveRequireApply'; // 生成单子编码

var NEW_APPLY_ORDER_API = 'purchase.order.getOrderIdByBizType'; // 需求单提交

var SUBMIT_APPLY_ORDER = 'purchase.requireApply.submitRequireApply'; // 需求单 基本信息明细

var APPLY_ORDER_BASE_DETAIL = 'purchase.requireApply.queryRequireApplyInfo'; // 需求单 商品信息明细 | 商品信息列表

var APPLY_ORDER_GOODS_LIST_API = 'purchase.requireApply.pageRequireApplyDetail'; // 需求单 作废

var CANCEL_APPLY_ORDER = 'purchase.requireApply.cancelRequireApply'; // 清空商品

var APPLY_CLEAR_GOODS = 'purchase.requireApply.clearRequireApplyDetail'; // 根据商家+地点+编码查询商品销量(地点维度)

var DETAIL_QUERY_GOODS_SALE = 'purchase.product.queryPlaceProductSales'; // 根据商家+地点+编码查询商品库存(地点维度)

var DETAIL_QUERY_GOODS_STOCK = 'purchase.product.queryPlaceProductStock'; //  查询商品扩展信息, 可查库存，销量，订货数量等

var GET_PRODUCT_EXTINFO = 'purchase.product.queryProductExtInfo'; // 查询汇总

var GET_SUMMARY_DATA = 'purchase.requireApply.statRequireApplyDetail'; // 获取门店补货明细列表

var GET_REQUIRE_DETAIL_DATA = 'purchase.require.queryAllRequireDetailPage'; // 门店补货明细合并导出

var EXPORT_REQUIRE_DETAIL_DATA = 'purchase.require.exportAllRequireDetail'; // 判断批量保存生鲜补货模板数据

var BATCH_SAVE_TEMPLATE = 'purchase.requireApply.batchSaveFreshGoods'; // 轮询结果

var POLL_RESULT = 'purchase.requireApply.getBatchSaveFreshGoodsResult';

/***/ }),

/***/ 64556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getHomeFormFields": function() { return /* binding */ getHomeFormFields; },
/* harmony export */   "getEditFormFields": function() { return /* binding */ getEditFormFields; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_YpshopCps_GoodsCategoryCascader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64679);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26715);
/* harmony import */ var _components_UseRouter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27088);
/* harmony import */ var _hooks_usePurchaseConfigPlaced__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12051);
/* harmony import */ var _components_FormCategorySelect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45199);







/**
 * 根据全局map获取退货首页表单FIELD - 首页
 * @param mappingList
 */
var getHomeFormFields = (mappingList, dateDefault) => {
  var _href = window.location.href;
  var isGoodsReturn = _href.indexOf('/GoodsReturn') !== -1;
  var manageType = isGoodsReturn ? '退货' : '补货';

  var fieldDataList = type => {
    return mappingList && mappingList['get'] && mappingList.get(_config_enums__WEBPACK_IMPORTED_MODULE_2__/* .purchaseEnumConfig */ .Nt[type]);
  };

  var categoryAllList = mappingList.get(_config_enums__WEBPACK_IMPORTED_MODULE_2__/* .purchaseEnumConfig.categoryCodeAll */ .Nt.categoryCodeAll); // let useCategoryList: any[] = []
  // if (categoryAllList && categoryAllList.length) {
  //   useCategoryList = categoryAllList
  // }

  return [{
    label: "".concat(manageType, "\u7533\u8BF7\u5355"),
    name: 'applyCode',
    type: 'INPUT'
  }, {
    label: '地点',
    name: 'placeId',
    widget: (0,_hooks_usePurchaseConfigPlaced__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)({
      purchaseEnum: _config_enums__WEBPACK_IMPORTED_MODULE_2__/* .purchaseEnumConfig.queryPlaces */ .Nt.queryPlaces,
      placeScopes: '1,2,3',
      title: '请选择地点'
    })
  }, {
    label: '品类',
    name: 'category',
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_FormCategorySelect__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
      categoryList: categoryAllList
    })
  }, {
    label: '来源',
    name: 'requireSource',
    type: 'SELECT',
    fieldOptions: {
      defaultValue: ''
    },
    dataList: [// {"4":"自动补货","5":"手动补货","6":"PDA补货"}"
    {
      label: '全部',
      value: ''
    }, {
      label: 'PDA补货',
      value: 6
    }, {
      label: '手动补货',
      value: 5
    }, {
      label: '自动补货',
      value: 4
    }, {
      value: 11,
      label: '区域集中补货'
    }, {
      value: 12,
      label: '中台自动补货'
    }, {
      value: 16,
      label: '营销活动订单'
    }]
  }, {
    label: '状态',
    name: 'status',
    type: 'SELECT',
    dataList: fieldDataList('status')
  }, {
    label: '集单标记',
    name: 'flag',
    type: 'SELECT',
    dataList: fieldDataList('flag')
  }, {
    label: '创建人',
    name: 'createUserCode',
    type: 'INPUT'
  }, {
    label: '创建时间',
    name: 'date',
    type: 'RANGE_PICKER_SHORT' // fieldOptions: {
    //   showTime: true,
    //   format: 'YYYY-MM-DD HH:mm:ss'
    // },

  }, {
    label: '商家',
    name: 'merchantId',
    type: 'SELECT',
    dataList: fieldDataList('merchantId')
  }, {
    label: '关联单号',
    name: 'relativeOrderNo',
    type: 'INPUT'
  }];
};
/**
 * 根据全局map获取 首页表单FIELD -编辑
 * @param mappingList
 */

var getEditFormFields = (mappingList, autoSaveCallback, editFormState, handleCategory, formCanEdit) => {
  var _href = window.location.href;
  var isGoodsReturn = _href.indexOf('/GoodsReturn') !== -1;
  var manageType = isGoodsReturn ? '退货' : '补货';
  var router = (0,_components_UseRouter__WEBPACK_IMPORTED_MODULE_3__/* .useRouter */ .t)();
  var handleType = router.query.type;
  var isAddHandle = handleType === 'add' ? true : false;
  /** 根据地点place获取merchantid */

  var getMerchantDataList = (val, dataList) => {
    var list = dataList.get(_config_enums__WEBPACK_IMPORTED_MODULE_2__/* .purchaseEnumConfig.placeId */ .Nt.placeId);

    if (list !== null && list !== void 0 && list.length) {
      var _list = list.filter(v => v.value === val);

      if (_list !== null && _list !== void 0 && _list.length) {
        var curMerchantId = _list[0].others.merchantId;
        var curPlaceId = _list[0].value;
        autoSaveCallback({
          merchantId: curMerchantId,
          placeId: curPlaceId
        });
      } else {
        console.error("getMerchantDataListERROR");
      }
    }
  };

  return [{
    label: "".concat(manageType, "\u7533\u8BF7\u5355"),
    name: 'applyCode',
    type: 'INPUT',
    fieldOptions: {
      disabled: true
    }
  }, {
    label: '状态',
    name: 'status',
    type: 'SELECT',
    dataList: [{
      value: 1,
      label: '草稿'
    }],
    fieldOptions: {
      disabled: true,
      defaultValue: 1
    }
  }, {
    label: '补货分类',
    name: 'requireSource',
    fieldOptions: {
      disabled: true
    },
    type: 'SELECT',
    required: true,
    dataList: [{
      label: 'PDA补货',
      value: 6
    }, {
      label: '手动补货',
      value: 5
    }, {
      label: '自动补货',
      value: 4
    }, {
      value: 11,
      label: '区域集中补货'
    }]
  }, {
    label: '地点',
    name: 'placeId',
    // type: 'SELECT',
    required: true,
    // dataList: fieldDataList('placeId'),
    // fieldOptions: {
    //   onSelect: getMerchantDataList,
    //   disabled: isAddHandle ? false : true,
    //   // disabled: !formCanEdit,
    //   // defaultValue: (fieldDataList('placeId')?.length > 0 && fieldDataList('placeId')?.findIndex(e => e?.value === shop?.id) > -1) ? shop?.id : undefined
    // },
    widget: (0,_hooks_usePurchaseConfigPlaced__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)({
      purchaseEnum: _config_enums__WEBPACK_IMPORTED_MODULE_2__/* .purchaseEnumConfig.placeId */ .Nt.placeId,
      placeScopes: '1,2,3',
      title: '请选择地点',
      onSelect: getMerchantDataList,
      disabled: isAddHandle ? false : true
    })
  }, {
    label: '商品类目',
    name: 'category',
    required: true,
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_YpshopCps_GoodsCategoryCascader__WEBPACK_IMPORTED_MODULE_1__/* .GoodsCategoryCascader */ .z, {
      mappingList: mappingList,
      onChange: handleCategory,
      data: editFormState.category,
      disabled: !formCanEdit
    })
  }, {
    label: '备注',
    name: 'remark',
    type: 'INPUT'
  }];
};

/***/ }),

/***/ 89460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8870);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_EditableTable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72927);



/**
 *  可编辑表格 - 目前补退货使用
 */



function GoodEditableTable(props, ref) {
  var formData = props.formData;
  var table = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(ref, () => ({
    reflashTable: params => table.current.reflashTable((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)({
      applyId: formData === null || formData === void 0 ? void 0 : formData.applyId,
      applyCode: formData === null || formData === void 0 ? void 0 : formData.applyCode
    }, params)),
    deleteAndRefreshData: commonTableKeys => table.current.deleteAndRefreshData(commonTableKeys),
    getTableData: () => {
      var _table$current;

      return table === null || table === void 0 ? void 0 : (_table$current = table.current) === null || _table$current === void 0 ? void 0 : _table$current.getTableData();
    }
  }));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "mTop16 mBottom16"
  }, props.btnElement), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_EditableTable__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)({
    hideBtn: true,
    hideDeleteBtn: false,
    ref: table
  }, props, {
    columns: props.columns,
    disableAddBtn: !props.canHandle,
    buttonTitle: "\u6DFB\u52A0\u5546\u54C1\u884C",
    scrollYSize: 510,
    tableOptions: {
      scroll: {
        x: 1400,
        y: 450
      }
    }
  })));
}

/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)( /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(GoodEditableTable)));

/***/ }),

/***/ 21487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(91896);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24731);
/* harmony import */ var _Common_GoodEditableTable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89460);
/* harmony import */ var _HandleBtn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82246);
/* harmony import */ var _useColumns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51689);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8450);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9066);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71720);










/**
 * 商品信息
 */










function GoodsTable(props) {
  var mappingList = props.mappingList;
  var childRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
  var _href = window.location.href;
  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_9__/* .useDispatch */ .I0)();
  var isGoodsReturn = _href.indexOf('/GoodsReturn') !== -1;
  var manageType = isGoodsReturn ? '退货' : '补货';
  var formData = props.formData,
      applyId = props.applyId,
      applyCode = props.applyCode,
      applyDetailId = props.applyDetailId;
  var canHandle = applyId ? true : false; // 能否操作表格

  var table = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(); // 要更新的表格数据

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_useState, 2),
      editTableData = _useState2[0],
      setEditTableData = _useState2[1]; // 商品数据


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_useState3, 2),
      barCodeList = _useState4[0],
      setBarCodeList = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_useState5, 2),
      canHandleClear = _useState6[0],
      setcanHandleClear = _useState6[1];

  var columns = (0,_useColumns__WEBPACK_IMPORTED_MODULE_7__.default)({
    formData,
    mappingList,
    barCodeList,
    editTableData
  }); // 表格表头

  var goodModalcolumns = (0,_useColumns__WEBPACK_IMPORTED_MODULE_7__.default)({
    formData,
    mappingList,
    barCodeList,
    type: 'modal'
  }); // 表格表头
  // 处理商品编码的事件

  var handleGoodId = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().mark(function _callee(goodsId, currentRow) {
      var params, res, success, result;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              params = {
                goodsId: +goodsId,
                merchantId: formData.merchantId
              };
              _context.next = 4;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)('purchase.product.queryBarcodeByProductId', params);

            case 4:
              res = _context.sent;
              success = res.success, result = res.result;

              if (success) {
                setBarCodeList(result.list); // setEditTableData((v: any) => ([...v, ...currentRow]))
              }

              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_13__.default.error(_context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function handleGoodId(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(); // 处理商品条码的操作事件


  var handleGoodBarCode = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().mark(function _callee2(code, currentRow) {
      var params, res, list, rowData, _rowData;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              params = {
                merchantId: +formData.merchantId,
                placeId: +formData.placeId,
                barcodeList: [code],
                withRealPrice: true,
                billType: formData.billType
              }; // 获取商品数据

              _context2.next = 4;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)('purchase.product.queryInsertPlaceProduct', params);

            case 4:
              res = _context2.sent;

              if (!res.success) {
                _context2.next = 15;
                break;
              }

              list = res.result.list;

              if (!(list && !list.length)) {
                _context2.next = 10;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_13__.default.info('未找到商品信息');

              return _context2.abrupt("return");

            case 10:
              rowData = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, currentRow), list[0]), {}, {
                goodsBarCode: code,
                categoryName: list[0].cate1Name,
                isGift: list[0].gift,
                orderSpecification: list[0].specification,
                orderSpecificationUnit: list[0].specUnit,
                taxRate: list[0].tax
              });
              _context2.next = 13;
              return (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .exchangeDataPromise */ .m)([rowData], formData.merchantId, formData.placeId, {
                isListReq: true
              });

            case 13:
              _rowData = _context2.sent;
              return _context2.abrupt("return", _rowData);

            case 15:
              _context2.next = 20;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_13__.default.error(_context2.t0);

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 17]]);
    }));

    return function handleGoodBarCode(_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
  /** 保存商品行 */


  var saveGoodsData = (data, currentCellOldData) => {
    // console.log('formData', formData);
    // console.log('saveGoodsData', data)
    return new Promise( /*#__PURE__*/function () {
      var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().mark(function _callee3(resolve, reject) {
        var params, res, result, _childRef$current, _childRef$current2, _res$result, _data, tmpData, _data2;

        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // if (parseFloat(data.goodsReqQty) === 0) {
                //   message.warn('商品数量不能为0')
                //   // eslint-disable-next-line prefer-promise-reject-errors
                //   return reject('商品数量不能为0')
                // }
                params = {
                  applyId: applyId || formData.applyId,
                  applyCode: applyCode || formData.applyCode,
                  placeId: +formData.placeId,
                  request: {
                    goodsId: data.goodsId,
                    unitPrice: data === null || data === void 0 ? void 0 : data.unitPrice,
                    goodsBarCode: data.goodsBarCode,
                    goodsReqQty: data.goodsReqQty
                  }
                };

                if (manageType === '退货') {
                  params.request['isDamage'] = data['isDamage'];
                  params.request['returnReason'] = data['returnReason'];
                }

                if (!data['applyDetailId']) {// console.error('applyDetailId not found')
                }

                if (data['applyDetailId']) {
                  // 编辑
                  params.request['applyDetailId'] = data['applyDetailId'];
                }

                _context3.next = 6;
                return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_15__/* .SAVE_APPLY_ORDER_LINE */ .LF, params);

              case 6:
                res = _context3.sent;
                result = res.result;

                if (result !== null && result !== void 0 && result.isUpdateQty && manageType === '补货') {
                  antd_es_modal__WEBPACK_IMPORTED_MODULE_16__/* .default.info */ .Z.info({
                    title: '温馨提示',
                    content: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, "\u5546\u54C1\u3010", data.goodsId, "\u3011", data === null || data === void 0 ? void 0 : data.goodsName), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, "\u8981\u8D27\u6570\u91CF: ", data.goodsReqQty), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, "\u6309\u8981\u8D27\u89C4\u683C\u6298\u7B97\u6210: ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("strong", null, result === null || result === void 0 ? void 0 : result.realGoodsReqQty)))
                  });
                }

                if (!res.success) {
                  _context3.next = 18;
                  break;
                }

                _data = JSON.parse(JSON.stringify(data));
                (childRef === null || childRef === void 0 ? void 0 : (_childRef$current = childRef.current) === null || _childRef$current === void 0 ? void 0 : _childRef$current.innerFn) && (childRef === null || childRef === void 0 ? void 0 : (_childRef$current2 = childRef.current) === null || _childRef$current2 === void 0 ? void 0 : _childRef$current2.innerFn());

                antd_es_message__WEBPACK_IMPORTED_MODULE_13__.default.success('商品保存成功');

                if (manageType === '补货') {
                  _data['copies'] = result === null || result === void 0 ? void 0 : result.copies;
                  _data['goodsReqQty'] = result === null || result === void 0 ? void 0 : result.realGoodsReqQty;
                }

                _data['applyDetailId'] = (_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.applyDetailId;
                return _context3.abrupt("return", resolve({
                  newRow: _data
                }));

              case 18:
                // 保存失败时 恢复修改前的值
                tmpData = Object.assign(data, currentCellOldData);
                _data2 = JSON.parse(JSON.stringify(tmpData));
                return _context3.abrupt("return", resolve({
                  newRow: _data2
                }));

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }());
  }; // 商品数据变化时


  var changeGoodsData = /*#__PURE__*/function () {
    var _ref4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().mark(function _callee4(data, selected) {
      var currentCell, currentCellOldData, currentRow, rows, goodsId, barCode, unitPrice, goodsReqQty, returnReason, isDamage, res, price, qty, orderSpecification, amount, totalAmount, _yield$saveGoodsData, newRow;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              currentCell = data.currentCell, currentCellOldData = data.currentCellOldData, currentRow = data.currentRow;

              if (!lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(currentCell)) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt("return");

            case 3:
              rows = currentRow;
              goodsId = data.currentCell['goodsId'];
              barCode = data.currentCell['goodsBarCode'];
              unitPrice = data.currentCell['unitPrice'];
              goodsReqQty = data.currentCell['goodsReqQty'];
              returnReason = data.currentCell['returnReason'];
              isDamage = data.currentCell['isDamage']; // 单元格是商品编码

              if (goodsId) {
                handleGoodId(goodsId, currentRow);
              } // 当前修改的单元格是商品条码时


              if (!barCode) {
                _context4.next = 16;
                break;
              }

              _context4.next = 14;
              return handleGoodBarCode(barCode, currentRow);

            case 14:
              res = _context4.sent;
              rows = res;

            case 16:
              if (!(goodsReqQty || returnReason || isDamage)) {
                _context4.next = 31;
                break;
              }

              price = unitPrice !== null && unitPrice !== void 0 ? unitPrice : currentRow.unitPrice;
              qty = goodsReqQty !== null && goodsReqQty !== void 0 ? goodsReqQty : currentRow.goodsReqQty;
              orderSpecification = currentRow.orderSpecification;
              amount = +price * +qty;
              totalAmount = +price * +qty * +orderSpecification;
              rows = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, currentRow), {}, {
                amount,
                totalAmount
              });
              setEditTableData(rows);
              _context4.next = 26;
              return saveGoodsData(rows, currentCellOldData);

            case 26:
              _yield$saveGoodsData = _context4.sent;
              newRow = _yield$saveGoodsData.newRow;
              setEditTableData(Array.isArray(newRow) ? newRow : [newRow]);
              _context4.next = 32;
              break;

            case 31:
              setEditTableData(rows);

            case 32:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function changeGoodsData(_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }(); // 保存浮层，保存商品
  // const saveGoodsModal = useCallback(
  //   async ,
  //   [formData]
  // )


  var saveGoodsModal = rows => {
    var _table$current, _childRef$current3, _childRef$current4;

    (_table$current = table.current) === null || _table$current === void 0 ? void 0 : _table$current.reflashTable({
      applyId,
      applyCode,
      current: 1,
      searchSource: 1
    });
    ((_childRef$current3 = childRef.current) === null || _childRef$current3 === void 0 ? void 0 : _childRef$current3.innerFn) && ((_childRef$current4 = childRef.current) === null || _childRef$current4 === void 0 ? void 0 : _childRef$current4.innerFn());
  }; // 删除商品的回调


  var handleDeleteRow = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)( /*#__PURE__*/function () {
    var _ref5 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().mark(function _callee5(currentRow, list) {
      var applyDetailId, res, _childRef$current5, _childRef$current6;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              // console.log('handleDeleteRow data删除商品', currentRow)
              // console.log('handleDeleteRow data删除商品', editTableData)
              applyDetailId = currentRow.applyDetailId; // const { applyDetailId, goodsName, applyId } = currentRow

              if (!applyDetailId) {
                _context5.next = 9;
                break;
              }

              _context5.next = 4;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_15__/* .DELETE_APPLY_ORDER_LINE */ .kO, {
                applyDetailIds: [applyDetailId],
                applyId,
                applyCode
              });

            case 4:
              res = _context5.sent;

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_13__.default.success("\u6210\u529F\u5220\u9664\u5546\u54C1"); // table?.current?.reflashTable({ applyId })


                ((_childRef$current5 = childRef.current) === null || _childRef$current5 === void 0 ? void 0 : _childRef$current5.innerFn) && ((_childRef$current6 = childRef.current) === null || _childRef$current6 === void 0 ? void 0 : _childRef$current6.innerFn());
                console.log('editTableData', editTableData);
              }

              return _context5.abrupt("return", res.success);

            case 9:
              return _context5.abrupt("return", true);

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }(), [applyId, applyDetailId, editTableData]); // 获取表格商品信息列表

  var getGoodsData = (data, params) => {
    // const list = data?.map((v:any) => ({
    //   ...v,
    //   // goodsReqQty: formData?.requireSource === 11 ? v.goodsAdviceQty : v.goodsReqQty
    // }))
    if (props.returnData) {
      props.returnData(data, params);
    } // console.log('000getGoodsData', data);


    setEditTableData(data);
  };

  var initTableData = (editTableData, formData) => {
    (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .exchangeDataPromise */ .m)(editTableData, formData.merchantId, formData.placeId, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, formData), {}, {
      isListReq: true
    })).then(unionData => {
      // setGoodsData(unionData)
      if (props.returnData) {
        props.returnData(unionData);
      }

      setEditTableData(unionData[0]);
    }).catch(e => {// console.error('handleEditTableCallbackERROR', e)
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (Array.isArray(editTableData) && !lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(formData)) {
      // console.log(233, formData);
      // 根据列表URL获取的数据，重新拿id后，根据id数据拿到其他数据，填到原先数据，更新updateDatasource
      initTableData(editTableData, formData);
      editTableData.length && setcanHandleClear(true);
    }

    if (editTableData === undefined) {
      setcanHandleClear(false);
    }
  }, [formData, editTableData]); // 每个可编辑的单元格都存在数据后，发送保存的请求

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {// console.log('当前表格数据11', editTableData)
  }, [editTableData]);
  var goodsModalOptions = {
    title: "\u6DFB\u52A0".concat(manageType, "\u5546\u54C1"),
    rowSelectionType: 'checkbox'
  };
  /** 监听表格数据 */

  var handleEmitTableChange = data => {
    var dataSource = data.dataSource;

    if (!(dataSource !== null && dataSource !== void 0 && dataSource.length)) {
      setcanHandleClear(false);
    }

    props === null || props === void 0 ? void 0 : props.onTableParamsChange(data);
  };

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_useState7, 2),
      outSearchParams = _useState8[0],
      setOutSearchParams = _useState8[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    setOutSearchParams({
      applyId: formData === null || formData === void 0 ? void 0 : formData.applyId,
      applyCode: formData === null || formData === void 0 ? void 0 : formData.applyCode,
      hideZeroDetail: formData === null || formData === void 0 ? void 0 : formData.hideZeroDetail,
      searchSource: formData === null || formData === void 0 ? void 0 : formData.searchSource
    });
  }, [formData]);

  var reSearch = e => {
    setOutSearchParams(e);
  };

  var tableProps = {
    goodModalCategoryData: props.goodModalCategoryData,
    goodsModalSearchParams: props.goodsModalSearchParams,
    ref: table,
    returnData: getGoodsData,
    canSelected: false,
    showAlert: false,
    searchParams: outSearchParams,
    queryDataUrl: (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => outSearchParams !== null && outSearchParams !== void 0 && outSearchParams.applyId ? _Api__WEBPACK_IMPORTED_MODULE_15__/* .APPLY_ORDER_GOODS_LIST_API */ .XO : '', [outSearchParams]),
    onChange: changeGoodsData,
    saveGoodsModal: saveGoodsModal,
    columns: columns,
    onTableParamsChange: handleEmitTableChange,
    pageSize: 100,
    deleteRow: handleDeleteRow,
    updateDataSource: editTableData,
    canHandle: canHandle,
    billType: formData.billType,
    goodsModalOptions: goodsModalOptions,
    goodModalcolumns: goodModalcolumns,
    formData: formData,
    rowSelectCallback: props.rowSelectCallback,
    selectedItems: props.selectedItems,
    hideDeleteBtn: (formData === null || formData === void 0 ? void 0 : formData.requireSource) === 11 || (formData === null || formData === void 0 ? void 0 : formData.requireSource) === 4 // 区域集中和系统自动补货  不能删除

  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_Common_GoodEditableTable__WEBPACK_IMPORTED_MODULE_5__.default, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)({}, tableProps, {
    btnElement: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_HandleBtn__WEBPACK_IMPORTED_MODULE_6__.default, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)({
      innerRef: childRef,
      addBtnText: "\u6DFB\u52A0".concat(manageType, "\u5546\u54C1"),
      downloadTemplateType: props.downloadTemplateType,
      table: table.current,
      canHandleClear: canHandleClear,
      reSearch: reSearch
    }, tableProps))
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(GoodsTable));

/***/ }),

/***/ 82246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(31097);
/* harmony import */ var antd_es_input_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47673);
/* harmony import */ var antd_es_input__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(4107);
/* harmony import */ var antd_es_row_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13062);
/* harmony import */ var antd_es_row__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(71230);
/* harmony import */ var antd_es_col_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89032);
/* harmony import */ var antd_es_col__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(15746);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(2824);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(57016);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(49101);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(90631);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(76570);
/* harmony import */ var _components_Uploader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84843);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24731);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(8450);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26715);
/* harmony import */ var _hooks_useLoopImportResult__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68406);
/* harmony import */ var _components_CategorySelectForTwo__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(76252);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7704);
/* harmony import */ var _mapEnums__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(98799);
/* harmony import */ var _ReplenishGoodsModal__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(92940);
/* harmony import */ var _pages_Replenishment_Api__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(91249);
/* harmony import */ var _components_ExportModal__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(83769);
































var confirm = antd_es_modal__WEBPACK_IMPORTED_MODULE_17__/* .default.confirm */ .Z.confirm;

function HandleBtn(props, ref) {
  var _props$addBtnText, _formData$category2, _formData$category3, _formData$category4;

  var formData = props.formData,
      table = props.table,
      canHandle = props.canHandle,
      innerRef = props.innerRef,
      selectedItems = props.selectedItems;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(''),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)(_useState, 2),
      goodSearchKey = _useState2[0],
      setgoodSearchKey = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)({
    secondCategoryIds: [],
    thirdCategoryIds: []
  }),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)(_useState3, 2),
      categorySearch = _useState4[0],
      setcategorySearch = _useState4[1];

  var resultParams = {
    businessType: 2,
    orderNo: formData.applyId
  };

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)({
    skuCount: '',
    totalAmount: '',
    totalQty: '',
    abnormalCount: ''
  }),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)(_useState5, 2),
      curSummaryData = _useState6[0],
      setcurSummaryData = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)(_useState7, 2),
      exportLoading = _useState8[0],
      setexportLoading = _useState8[1]; // 导出loading


  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)(_useState9, 2),
      visibleExport = _useState10[0],
      setVisibleExport = _useState10[1]; // 导出商品列表


  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false),
      _useState12 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)(_useState11, 2),
      refreshLoading = _useState12[0],
      setrefreshLoading = _useState12[1];
  /** 下载模板 */


  var downloadTemplate = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().mark(function _callee() {
      var res, downloadUrl;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_21__/* .DOWNLOAD_TEMPLATE */ .dI, {
                downloadType: props.downloadTemplateType || 1
              });

            case 3:
              res = _context.sent;
              downloadUrl = res.result.downloadUrl;

              if (downloadUrl) {
                _context.next = 7;
                break;
              }

              throw '请求的文件不存在';

            case 7:
              window.location.href = downloadUrl; // 默认文件管理器保存

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_22__.default.error(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    return function downloadTemplate() {
      return _ref.apply(this, arguments);
    };
  }(); // 导出


  var confirmClear = () => {
    confirm({
      title: '清空所有商品',
      content: '是否确认清空？',

      onOk() {
        clearGood();
        handleGetSummaryData();
      },

      onCancel() {}

    });
  };

  var confirmDeleteSelected = () => {
    confirm({
      title: '删除已选择项',
      content: '是否确认删除？',

      onOk() {
        handleDeleteRows();
      },

      onCancel() {}

    });
  };

  var _useState13 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false),
      _useState14 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)(_useState13, 2),
      loopResult = _useState14[0],
      setLoopResult = _useState14[1];

  var _useLoopImportResult = (0,_hooks_useLoopImportResult__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)({}, resultParams), {}, {
    refreshCallback: successed => {
      if (successed) {
        table.reflashTable({
          applyId: formData.applyId,
          applyCode: formData.applyCode
        });
        handleGetSummaryData();
      }

      setLoopResult(false); // 重置状态
    }
  }), [loopResult]),
      _useLoopImportResult2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)(_useLoopImportResult, 1),
      btnLoading = _useLoopImportResult2[0];
  /** 导入文件 */


  var changeUpload = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().mark(function _callee2(val) {
      var len, params, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              len = val.length;

              if (len) {
                _context2.next = 4;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_22__.default.warn('changeUploadERROR: 文件不存在');

              return _context2.abrupt("return");

            case 4:
              _context2.prev = 4;
              params = {
                applyId: formData.applyId,
                resId: val,
                applyCode: formData.applyCode
              };
              _context2.next = 8;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_21__/* .IMPORT_APPLY_ORDER */ .b2, params);

            case 8:
              res = _context2.sent;

              if (res && res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_22__.default.success('导入任务添加成功'); // 导入改为异步，则2s轮询请求状态，直到成功或失败停止，给提示
                // handleAfterImport()


                setLoopResult(true); // table.reflashTable()
              }

              _context2.next = 15;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](4);

              antd_es_message__WEBPACK_IMPORTED_MODULE_22__.default.error(_context2.t0);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 12]]);
    }));

    return function changeUpload(_x) {
      return _ref2.apply(this, arguments);
    };
  }(); // console.log(formData,'传递进入数据')
  // 导出问题处理


  var exportIssue = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().mark(function _callee3() {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              console.log(formData, '获取到数据');
              _context3.prev = 1;
              setexportLoading(true);
              _context3.next = 5;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_pages_Replenishment_Api__WEBPACK_IMPORTED_MODULE_24__/* .EXPORT_ISSUE_REPAIR */ .b, {
                applyCode: [formData === null || formData === void 0 ? void 0 : formData.applyCode]
              });

            case 5:
              res = _context3.sent;
              setexportLoading(false);

              if (res && res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_22__.default.success('操作成功，请点击右侧按钮查看导出结果');
              }

              _context3.next = 12;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](1);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 10]]);
    }));

    return function exportIssue() {
      return _ref3.apply(this, arguments);
    };
  }();
  /** 清空商品 */


  var clearGood = /*#__PURE__*/function () {
    var _ref4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().mark(function _callee4() {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_21__/* .APPLY_CLEAR_GOODS */ .hL, {
                applyId: formData.applyId,
                applyCode: formData.applyCode,
                currentStatus: _config_enums__WEBPACK_IMPORTED_MODULE_10__/* .replenishStatus["草稿"] */ .qW["草稿"]
              });

            case 3:
              res = _context4.sent;

              if (res.success) {
                table.reflashTable({
                  applyId: formData.applyId,
                  applyCode: formData.applyCode
                });

                antd_es_message__WEBPACK_IMPORTED_MODULE_22__.default.success('清空商品成功');
              }

              _context4.next = 9;
              break;

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 7]]);
    }));

    return function clearGood() {
      return _ref4.apply(this, arguments);
    };
  }();
  /** 查询汇总数量 */


  var handleGetSummaryData = /*#__PURE__*/function () {
    var _ref5 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().mark(function _callee6() {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              try {
                setTimeout( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().mark(function _callee5() {
                  var res, result;
                  return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_21__/* .GET_SUMMARY_DATA */ .Uv, {
                            applyId: formData.applyId,
                            applyCode: formData.applyCode
                          });

                        case 2:
                          res = _context5.sent;

                          if (res.success) {
                            result = res.result;
                            setcurSummaryData(result);
                          }

                        case 4:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                })), 1500);
              } catch (error) {
                console.error('clearGood', clearGood);
              }

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function handleGetSummaryData() {
      return _ref5.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(() => {
    if (formData !== null && formData !== void 0 && formData.applyId) {
      handleGetSummaryData();
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.applyId]); // 回给父组件调用方法

  (0,react__WEBPACK_IMPORTED_MODULE_7__.useImperativeHandle)(props.innerRef, () => {
    return {
      innerFn: () => {
        handleGetSummaryData();
      }
    };
  });
  /** 查询明细的商品 */

  var searchHandle = /*#__PURE__*/function () {
    var _ref7 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().mark(function _callee7() {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              props === null || props === void 0 ? void 0 : props.reSearch((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)({
                searchGoods: goodSearchKey,
                applyId: formData.applyId,
                applyCode: formData.applyCode
              }, categorySearch));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function searchHandle() {
      return _ref7.apply(this, arguments);
    };
  }();

  var keyChange = e => {
    var _e$currentTarget$valu;

    if (((_e$currentTarget$valu = e.currentTarget.value) === null || _e$currentTarget$valu === void 0 ? void 0 : _e$currentTarget$valu.length) === 0) {
      props === null || props === void 0 ? void 0 : props.reSearch({
        searchGoods: '',
        applyId: formData.applyId,
        applyCode: formData.applyCode
      });
    }

    setgoodSearchKey(e.currentTarget.value);
  };

  var categoryCodeKey = 46;

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)([categoryCodeKey]),
      mappingList = _useMapping.mappingList; // 品类list


  var categoryList = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(() => mappingList.get(categoryCodeKey), [mappingList, categoryCodeKey]);
  (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(() => {
    var _formData$category;

    if (formData !== null && formData !== void 0 && formData.secondCategoryId) {
      setcategorySearch((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)({}, categorySearch), {}, {
        secondCategoryIds: [formData === null || formData === void 0 ? void 0 : formData.secondCategoryId]
      }));
    }

    if ((formData === null || formData === void 0 ? void 0 : (_formData$category = formData.category) === null || _formData$category === void 0 ? void 0 : _formData$category.length) === 3) {
      setcategorySearch((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)({}, categorySearch), {}, {
        thirdCategoryIds: [formData === null || formData === void 0 ? void 0 : formData.category[2]]
      }));
    }
  }, [formData === null || formData === void 0 ? void 0 : formData.secondCategoryId, formData === null || formData === void 0 ? void 0 : formData.thirdCategoryId]);

  var onSecondChange = vals => {
    setcategorySearch((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)({}, categorySearch), {}, {
      secondCategoryIds: vals
    }));
  };

  var onThirdChange = vals => {
    setcategorySearch((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)({}, categorySearch), {}, {
      thirdCategoryIds: vals
    }));
  };

  var checkOnChange = val => {
    props === null || props === void 0 ? void 0 : props.reSearch((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)({
      applyId: formData.applyId,
      hideZeroDetail: !(val !== null && val !== void 0 && val.length) ? false : true
    }, categorySearch));
  };

  var _useState15 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false),
      _useState16 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)(_useState15, 2),
      visible = _useState16[0],
      setVisible = _useState16[1];

  var toggleGoodsModal = bool => {
    setVisible(bool);
  };

  var saveGoodModal = /*#__PURE__*/function () {
    var _ref8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().mark(function _callee8(rows) {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return props === null || props === void 0 ? void 0 : props.saveGoodsModal(rows);

            case 2:
              closeModal();

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function saveGoodModal(_x2) {
      return _ref8.apply(this, arguments);
    };
  }();

  var closeModal = () => {
    setVisible(false);
  }; // 删除已选择多个商品的回调


  var handleDeleteRows = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().mark(function _callee9() {
    var res, _table$getTableData, _table$getTableData$d, _innerRef$current, _innerRef$current2, pageSize;

    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            console.log('handleDeleteRows data删除已选择商品', selectedItems);

            if (!((selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) > 0)) {
              _context9.next = 10;
              break;
            }

            console.log('applyId', formData.applyId);
            _context9.next = 5;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_21__/* .DELETE_APPLY_ORDER_LINE */ .kO, {
              applyId: formData.applyId,
              applyCode: formData.applyCode,
              applyDetailIds: selectedItems.map(m => m.applyDetailId)
            });

          case 5:
            res = _context9.sent;

            if (res.success) {
              antd_es_message__WEBPACK_IMPORTED_MODULE_22__.default.success("\u6210\u529F\u5220\u9664\u5DF2\u9009\u62E9\u5546\u54C1");

              pageSize = table === null || table === void 0 ? void 0 : (_table$getTableData = table.getTableData()) === null || _table$getTableData === void 0 ? void 0 : (_table$getTableData$d = _table$getTableData.dataSource) === null || _table$getTableData$d === void 0 ? void 0 : _table$getTableData$d.length;

              if (selectedItems.length == pageSize) {
                // 整个页面删除，则刷新列表
                table === null || table === void 0 ? void 0 : table.reflashTable({
                  applyId: formData === null || formData === void 0 ? void 0 : formData.applyId,
                  applyCode: formData === null || formData === void 0 ? void 0 : formData.applyCode,
                  current: 1
                });
              } else {
                table === null || table === void 0 ? void 0 : table.deleteAndRefreshData(selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.map(m => m.commonTableKey));
              }

              ((_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : _innerRef$current.innerFn) && ((_innerRef$current2 = innerRef.current) === null || _innerRef$current2 === void 0 ? void 0 : _innerRef$current2.innerFn());
            }

            return _context9.abrupt("return", res.success);

          case 10:
            return _context9.abrupt("return", true);

          case 11:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  })), [selectedItems]); // 根据异常排序

  var handleSort = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)(() => {
    props === null || props === void 0 ? void 0 : props.reSearch((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z)({
      abnormalBy: true,
      searchGoods: goodSearchKey,
      applyId: formData.applyId,
      applyCode: formData.applyCode
    }, categorySearch));
  }, [categorySearch, formData.applyCode, formData.applyId, goodSearchKey, props]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(_ReplenishGoodsModal__WEBPACK_IMPORTED_MODULE_15__.default, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_25__/* .default */ .Z)({
    closeModalCallback: closeModal,
    saveModalCallback: saveGoodModal,
    visible: visible
  }, props)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_row__WEBPACK_IMPORTED_MODULE_26__/* .default */ .Z, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_27__/* .default */ .Z, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("span", {
    style: {
      marginRight: '16px'
    },
    key: "upload"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_28__/* .default */ .Z, {
    style: {
      marginBottom: 5
    },
    type: "primary",
    disabled: !props.canHandle,
    className: "mRight16",
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_29__/* .default */ .Z, null),
    onClick: () => toggleGoodsModal(true)
  }, (_props$addBtnText = props === null || props === void 0 ? void 0 : props.addBtnText) !== null && _props$addBtnText !== void 0 ? _props$addBtnText : '添加商品'), (formData === null || formData === void 0 ? void 0 : formData.requireSource) != _mapEnums__WEBPACK_IMPORTED_MODULE_14__/* .enumRequireSource["自动补货"] */ .LN["自动补货"] && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(_components_Uploader__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, {
    tokenUrl: "purchase.resource.getResourceToken",
    accept: ".xlsx,.xls",
    onChange: changeUpload,
    loading: btnLoading,
    btnText: "\u5BFC\u5165excel\u5546\u54C1",
    uploadOptions: {
      showUploadList: false,
      disabled: !canHandle || props.canHandleClear
    }
  })), (formData === null || formData === void 0 ? void 0 : formData.requireSource) != _mapEnums__WEBPACK_IMPORTED_MODULE_14__/* .enumRequireSource["自动补货"] */ .LN["自动补货"] && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_28__/* .default */ .Z, {
    className: "mRight16",
    disabled: !canHandle,
    onClick: downloadTemplate,
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_30__/* .default */ .Z, null),
    key: "download"
  }, "\u4E0B\u8F7Dexcel\u6A21\u677F"), //区域集中和系统自动补货  不能清空
  ![11, 4].includes(formData === null || formData === void 0 ? void 0 : formData.requireSource) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(react__WEBPACK_IMPORTED_MODULE_7__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_28__/* .default */ .Z, {
    onClick: confirmClear,
    key: "clean",
    disabled: !props.canHandleClear,
    className: "mRight16"
  }, "\u6E05\u7A7A\u5546\u54C1"), selectedItems != undefined && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_28__/* .default */ .Z, {
    key: "deleteSeleted",
    disabled: (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) == 0,
    onClick: confirmDeleteSelected,
    className: "mRight16"
  }, "\u5220\u9664")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_row__WEBPACK_IMPORTED_MODULE_26__/* .default */ .Z, {
    style: {
      marginTop: 3
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_27__/* .default */ .Z, {
    xs: 24,
    sm: 24,
    md: 16,
    lg: 16,
    xl: 16
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(_components_CategorySelectForTwo__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
    onSecondChange: onSecondChange,
    onThirdChange: onThirdChange,
    className: "f-l",
    categoryList: categoryList,
    value: {
      first: formData === null || formData === void 0 ? void 0 : formData.firstCategoryId,
      second: formData === null || formData === void 0 ? void 0 : formData.secondCategoryId,
      third: (formData === null || formData === void 0 ? void 0 : (_formData$category2 = formData.category) === null || _formData$category2 === void 0 ? void 0 : _formData$category2.length) === 3 && +(formData === null || formData === void 0 ? void 0 : formData.category[2]) !== 0 || formData !== null && formData !== void 0 && (_formData$category3 = formData.category) !== null && _formData$category3 !== void 0 && _formData$category3.thirdCategoryId ? (formData === null || formData === void 0 ? void 0 : (_formData$category4 = formData.category) === null || _formData$category4 === void 0 ? void 0 : _formData$category4.thirdCategoryId) || (formData === null || formData === void 0 ? void 0 : formData.category[2]) : undefined
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_31__/* .default */ .Z, {
    style: {
      width: 150,
      marginLeft: 3,
      borderRadius: 4,
      marginTop: 5,
      marginBottom: 5
    },
    onChange: keyChange,
    allowClear: true,
    placeholder: "\u54C1\u540D/\u7F16\u7801/\u6761\u7801"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_32__/* .default */ .Z, {
    title: "\u641C\u7D22\u7C7B\u76EE/\u54C1\u540D/\u7F16\u7801/\u6761\u7801"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_28__/* .default */ .Z, {
    type: "primary",
    style: {
      marginLeft: '3px'
    },
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_33__/* .default */ .Z, null),
    onClick: searchHandle
  }, "\u641C\u7D22"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_27__/* .default */ .Z, {
    xs: 16,
    sm: 16,
    md: 8,
    lg: 8,
    xl: 8,
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("a", {
    style: {
      color: 'red'
    },
    onClick: handleSort
  }, "\u6570\u91CF\u5F02\u5E38\uFF1A", (curSummaryData === null || curSummaryData === void 0 ? void 0 : curSummaryData.abnormalCount) || '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("span", {
    style: {
      marginLeft: 15
    }
  }, "\u79CD\u7C7B: ", curSummaryData === null || curSummaryData === void 0 ? void 0 : curSummaryData.skuCount), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("span", {
    style: {
      marginLeft: 15
    }
  }, "\u603B\u6570\u91CF: ", curSummaryData === null || curSummaryData === void 0 ? void 0 : curSummaryData.totalQty), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("span", {
    style: {
      marginLeft: 15
    }
  }, "\u603B\u91D1\u989D: ", curSummaryData === null || curSummaryData === void 0 ? void 0 : curSummaryData.totalAmount))), visibleExport && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(_components_ExportModal__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, {
    queryDataUrl: "scm.config.getExportTaskList",
    businessType: 13,
    closeModalCallback: () => {
      setVisibleExport(false);
    }
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_7__.forwardRef)(HandleBtn));

/***/ }),

/***/ 92940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(91896);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(71577);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(57016);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _components_YpshopCps_FormBuilder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29891);
/* harmony import */ var _components_YpshopCps_EditableTable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37734);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9066);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24731);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(8450);
/* harmony import */ var _hooks_useCategory3Level__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71117);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(58576);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26715);












/**
 * 商家商品
 */











function ReplenishGoodsModal(props) {
  var _props$canSelected;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState, 2),
      selectedRows = _useState2[0],
      setSelectedRows = _useState2[1];

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)([_config_enums__WEBPACK_IMPORTED_MODULE_11__/* .purchaseEnumConfig.categoryCodeAll */ .Nt.categoryCodeAll, _config_enums__WEBPACK_IMPORTED_MODULE_11__/* .purchaseEnumConfig.placeId */ .Nt.placeId]),
      mappingList = _useMapping.mappingList;

  var _href = window.location.href;
  var isGoodsReturn = _href.indexOf('/GoodsReturn') !== -1;
  var manageType = isGoodsReturn ? '退货' : '补货';

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState3, 2),
      searchParams = _useState4[0],
      setSearchParams = _useState4[1]; // 能否关闭浮层


  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState5, 2),
      canClose = _useState6[0],
      setCanClose = _useState6[1]; // 判断多个请求之后状态


  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState7, 2),
      queryState = _useState8[0],
      setQuery = _useState8[1];

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    setSearchParams({
      billType: props.billType,
      condition: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, props.goodsModalSearchParams)
    });
  }, [props]);
  var formData = props.formData,
      goodsModalSearchParams = props.goodsModalSearchParams;

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState9, 2),
      editTableData = _useState10[0],
      setEditTableData = _useState10[1];

  var category = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    var obj = {
      firstCategoryId: +(goodsModalSearchParams === null || goodsModalSearchParams === void 0 ? void 0 : goodsModalSearchParams.firstCategoryId)
    };

    if (goodsModalSearchParams !== null && goodsModalSearchParams !== void 0 && goodsModalSearchParams.secondCategoryId) {
      obj['secondCategoryId'] = +(goodsModalSearchParams === null || goodsModalSearchParams === void 0 ? void 0 : goodsModalSearchParams.secondCategoryId);
    }

    if (goodsModalSearchParams !== null && goodsModalSearchParams !== void 0 && goodsModalSearchParams.thirdCategoryId) {
      obj['thirdCategoryId'] = +(goodsModalSearchParams === null || goodsModalSearchParams === void 0 ? void 0 : goodsModalSearchParams.thirdCategoryId);
    } // if (goodsModalSearchParams?.thirdCategoryId) {
    //   obj['thirdCategoryId'] = +goodsModalSearchParams?.thirdCategoryId
    // }


    return obj;
  }, [goodsModalSearchParams]);

  var _useCategory3Level = (0,_hooks_useCategory3Level__WEBPACK_IMPORTED_MODULE_9__/* .useCategory3Level */ .W)({
    outCategory: category,
    goodModalCategoryData: props.goodModalCategoryData,
    mappingList
  }),
      _useCategory3Level2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useCategory3Level, 2),
      categories = _useCategory3Level2[0],
      _useCategory3Level2$ = _useCategory3Level2[1],
      category3 = _useCategory3Level2$.category3,
      reset = _useCategory3Level2$.reset;

  var table = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(); // const { mappingList } = useMapping(5)
  // const searchHandler = useCallback((state, values) => , [props.goodsModalSearchParams])

  var searchHandler = (state, values) => {
    var _props$goodsModalSear, _props$goodsModalSear2, _category3$secondCate, _category3$thirdCateg;

    var secondCategoryId;

    for (var k in values) {
      if (!values[k]) {
        delete values[k];
      }
    }

    var condition = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, values), props.goodsModalSearchParams), {}, {
      firstCategoryId: (category3 === null || category3 === void 0 ? void 0 : category3.firstCategoryId) || ((_props$goodsModalSear = props.goodsModalSearchParams) === null || _props$goodsModalSear === void 0 ? void 0 : _props$goodsModalSear.firstCategoryId),
      secondCategoryId: (category3 === null || category3 === void 0 ? void 0 : category3.secondCategoryIds) || secondCategoryId || ((_props$goodsModalSear2 = props.goodsModalSearchParams) === null || _props$goodsModalSear2 === void 0 ? void 0 : _props$goodsModalSear2.secondCategoryId)
    });

    if (Array.isArray(category3 === null || category3 === void 0 ? void 0 : category3.secondCategoryIds) && category3 !== null && category3 !== void 0 && (_category3$secondCate = category3.secondCategoryIds) !== null && _category3$secondCate !== void 0 && _category3$secondCate.length) {
      var ids = category3 === null || category3 === void 0 ? void 0 : category3.secondCategoryIds;
      secondCategoryId = ids[0];
      condition['secondCategoryId'] = secondCategoryId;
    }

    if (category3 !== null && category3 !== void 0 && (_category3$thirdCateg = category3.thirdCategoryIds) !== null && _category3$thirdCateg !== void 0 && _category3$thirdCateg.length) {
      condition['categoryIds'] = category3 === null || category3 === void 0 ? void 0 : category3.thirdCategoryIds;
    }

    Object.keys(condition).forEach(i => {
      var _condition$i;

      if (Array.isArray(condition[i]) && !((_condition$i = condition[i]) !== null && _condition$i !== void 0 && _condition$i.length)) {
        delete condition[i];
      }
    });
    setSearchParams((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, searchParams), {}, {
      condition
    }));
  };

  var rowSelectCallback = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((keys, rows) => {
    setSelectedRows(rows);
  }, []);

  var handleOk = () => {
    console.log('33333');
    props.saveModalCallback(selectedRows);
  };

  var handleReset = () => {
    setSearchParams((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, searchParams), {}, {
      condition: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, props.goodsModalSearchParams)
    }));
  };

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    // columns: props.goodModalcolumns,
    canHandle: props.canHandle,
    canSelected: props.canSelected // searchParams: searchParams

  }),
      _useState12 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState11, 2),
      editProps = _useState12[0],
      seteditProps = _useState12[1]; // 更新表格数据 请求库存等add到原对象


  var getTableData = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().mark(function _callee(data) {
      var _props$goodsModalSear3, _props$goodsModalSear4;

      var arr;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (data.length) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              console.log(goodsModalSearchParams, 'goodsModalSearchParams', data);
              _context.next = 5;
              return (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .exchangeDataPromise */ .m)(data, (_props$goodsModalSear3 = props.goodsModalSearchParams) === null || _props$goodsModalSear3 === void 0 ? void 0 : _props$goodsModalSear3.merchantId, (_props$goodsModalSear4 = props.goodsModalSearchParams) === null || _props$goodsModalSear4 === void 0 ? void 0 : _props$goodsModalSear4.placeId, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, goodsModalSearchParams), {}, {
                billType: props.billType
              }));

            case 5:
              arr = _context.sent;
              setEditTableData(arr);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getTableData(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  /** 保存商品行 */


  var saveGoodsData = data => {
    return new Promise( /*#__PURE__*/function () {
      var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().mark(function _callee2(resolve, reject) {
        var params, res, result, _res$result, _data;

        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (formData !== null && formData !== void 0 && formData.applyId) {
                  _context2.next = 3;
                  break;
                }

                // console.error('no applyid');
                antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.info('未找到主单ID');

                return _context2.abrupt("return");

              case 3:
                params = {
                  applyId: formData.applyId,
                  applyCode: formData.applyCode,
                  placeId: +formData.placeId,
                  request: {
                    goodsId: data.goodsId,
                    unitPrice: data === null || data === void 0 ? void 0 : data.unitPrice,
                    goodsBarCode: data.goodsBarCode,
                    goodsReqQty: data.goodsReqQty
                  }
                };

                if (manageType === '退货') {
                  params.request['isDamage'] = data['isDamage'];
                  params.request['returnReason'] = data['returnReason'];
                }

                if (!data['applyDetailId']) {// console.error('applyDetailId not found')
                }

                if (data['applyDetailId']) {
                  // 编辑
                  params.request['applyDetailId'] = data['applyDetailId'];
                }

                _context2.next = 9;
                return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_17__/* .SAVE_APPLY_ORDER_LINE */ .LF, params);

              case 9:
                res = _context2.sent;
                console.log('保存结果', res);
                result = res.result;

                if (result !== null && result !== void 0 && result.isUpdateQty && manageType === '补货') {
                  antd_es_modal__WEBPACK_IMPORTED_MODULE_18__/* .default.info */ .Z.info({
                    title: '温馨提示',
                    content: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "\u5546\u54C1\u3010", data.goodsId, "\u3011", data === null || data === void 0 ? void 0 : data.goodsName), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "\u8981\u8D27\u6570\u91CF: ", data.goodsReqQty), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, "\u6309\u8981\u8D27\u89C4\u683C\u6298\u7B97\u6210:  ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("strong", null, result === null || result === void 0 ? void 0 : result.realGoodsReqQty)))
                  });
                } //   bool isUpdateQty = 2; // 是否更新了数量
                // 目前补货支持校验： 如果isUpdateQty为true，则弹框提示并且更新表格数据，赋值要货件数，赋值正确补货量
                // 如果isUpdateQty为false，不弹框只更新table


                if (!res.success) {
                  _context2.next = 21;
                  break;
                }

                _data = JSON.parse(JSON.stringify(data));

                antd_es_message__WEBPACK_IMPORTED_MODULE_16__.default.success('商品保存成功');

                if (manageType === '补货') {
                  _data['copies'] = result === null || result === void 0 ? void 0 : result.copies;
                  _data['goodsReqQty'] = result === null || result === void 0 ? void 0 : result.realGoodsReqQty;
                }

                _data['applyDetailId'] = (_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.applyDetailId;
                return _context2.abrupt("return", resolve({
                  newRow: _data
                }));

              case 21:
                return _context2.abrupt("return", reject(res));

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());
  }; // 商品数据变化时


  var changeGoodsData = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().mark(function _callee3(data, selected) {
      var currentCell, currentRow, rows, goodsReqQty, returnReason, isDamage, unitPrice, _yield$saveGoodsData, newRow;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              currentCell = data.currentCell, currentRow = data.currentRow;

              if (!lodash__WEBPACK_IMPORTED_MODULE_7___default().isEmpty(currentCell)) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return");

            case 3:
              setQuery(prev => {
                return prev + 1;
              });
              rows = currentRow;
              goodsReqQty = data.currentCell['goodsReqQty'];
              returnReason = data.currentCell['returnReason'];
              isDamage = data.currentCell['isDamage'];
              unitPrice = data.currentCell['unitPrice']; // 单元格为单价和数量的时候，计算金额

              if (!(goodsReqQty || returnReason || isDamage)) {
                _context3.next = 26;
                break;
              }

              // const qty = goodsReqQty ?? currentRow.goodsReqQty
              // const orderSpecification = currentRow.orderSpecification
              rows = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)({}, currentRow); // rows = { ...currentRow, amount, totalAmount }

              setEditTableData(rows); // 注意： 如果外部赋值可编辑表格字段，table做对比前需要手动set一遍state

              _context3.prev = 12;
              _context3.next = 15;
              return saveGoodsData(rows);

            case 15:
              _yield$saveGoodsData = _context3.sent;
              newRow = _yield$saveGoodsData.newRow;
              setEditTableData(Array.isArray(newRow) ? newRow : [newRow]); // 注意: 更新pageEditable表格数据需要外部控制数据为数组

              setQuery(prev => {
                return prev - 1;
              });
              _context3.next = 24;
              break;

            case 21:
              _context3.prev = 21;
              _context3.t0 = _context3["catch"](12);
              setQuery(prev => {
                return prev - 1;
              });

            case 24:
              _context3.next = 28;
              break;

            case 26:
              setEditTableData(rows);
              setQuery(prev => {
                return prev - 1;
              });

            case 28:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[12, 21]]);
    }));

    return function changeGoodsData(_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (queryState === 0) {
      setCanClose(true);
    } else {
      setCanClose(false);
    }
  }, [queryState]);
  var GoodsModalFormElements = [{
    label: '商品',
    name: 'queryCriteria',
    type: 'INPUT',
    columns: 2,
    fieldOptions: {
      placeholder: '品名/编码/plu/条码'
    }
  }, {
    label: '商品精准',
    name: 'accurateQueryCriteria',
    type: 'INPUT',
    columns: 2,
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '品牌名称',
    name: 'brandName',
    type: 'INPUT',
    columns: 2
  }, {
    label: '商品品类',
    name: 'category',
    widget: categories,
    columns: 4,
    formItemProps: {
      labelCol: {
        span: 2
      },
      wrapperCol: {
        span: 22
      }
    }
  }];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
    closable: false,
    title: props.goodsModalOptions['title'] || '商家选择',
    destroyOnClose: true,
    maskClosable: false,
    width: 1350,
    style: {
      maxHeight: 700
    },
    visible: props.visible // onOk={handleOk}
    ,
    onOk: props.saveGoodModal,
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z, {
      key: "back",
      disabled: !canClose,
      onClick: handleOk,
      type: "primary"
    }, "\u5173\u95ED")]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_YpshopCps_FormBuilder__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    elements: GoodsModalFormElements,
    callbackHandler: searchHandler,
    onReset: handleReset,
    disableCache: true,
    defaultExpand: true
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_YpshopCps_EditableTable__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)({}, editProps, {
    onChange: changeGoodsData,
    searchParams: searchParams,
    returnData: getTableData,
    hideBtn: true,
    hideDeleteBtn: true,
    queryDataUrl: "purchase.product.querySelectPlaceProductByCondition",
    ref: table,
    columns: props.goodModalcolumns,
    disableAddBtn: !props.canHandle,
    canSelected: (_props$canSelected = props.canSelected) !== null && _props$canSelected !== void 0 ? _props$canSelected : true,
    tableOptions: {
      scroll: {
        x: 1400
      }
    },
    scrollYSize: 300,
    updateDataSource: editTableData
  })));
}

/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_3__.memo)(ReplenishGoodsModal));

/***/ }),

/***/ 98799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LN": function() { return /* binding */ enumRequireSource; },
/* harmony export */   "iq": function() { return /* binding */ enumPlaceCope; }
/* harmony export */ });
/* unused harmony export purchaseObj */
// 字段名对应的映射
var purchaseObj = {
  billState: 9,
  categoryCode: 4,
  placeCode: 3,
  orderType: 10,
  isStraight: 43,
  categoryCodeAll: 41,
  isDamage: 11,
  returnReason: 12,
  sencondCategoryId: 5,
  businessMode: 13,
  merchantId: 18
};
var enumRequireSource; // UNKNOWN_ENUM(0, "未知"),
//     STORE(1, "门店"),
//     WAREHOUSE(2, "大仓"),
//     YYB(3, "营业部");

(function (enumRequireSource) {
  enumRequireSource[enumRequireSource["PDA\u8865\u8D27"] = 6] = "PDA\u8865\u8D27";
  enumRequireSource[enumRequireSource["\u624B\u52A8\u8865\u8D27"] = 5] = "\u624B\u52A8\u8865\u8D27";
  enumRequireSource[enumRequireSource["\u81EA\u52A8\u8865\u8D27"] = 4] = "\u81EA\u52A8\u8865\u8D27";
  enumRequireSource[enumRequireSource["\u533A\u57DF\u96C6\u4E2D\u8865\u8D27"] = 11] = "\u533A\u57DF\u96C6\u4E2D\u8865\u8D27";
})(enumRequireSource || (enumRequireSource = {}));

var enumPlaceCope;

(function (enumPlaceCope) {
  enumPlaceCope[enumPlaceCope["\u95E8\u5E97"] = 1] = "\u95E8\u5E97";
  enumPlaceCope[enumPlaceCope["\u5927\u4ED3"] = 2] = "\u5927\u4ED3";
  enumPlaceCope[enumPlaceCope["\u8425\u4E1A\u90E8"] = 3] = "\u8425\u4E1A\u90E8";
})(enumPlaceCope || (enumPlaceCope = {}));

/***/ }),

/***/ 51689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ useColumns; }
/* harmony export */ });
/* harmony import */ var antd_es_tag_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71153);
/* harmony import */ var antd_es_tag__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(60331);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31097);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24731);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96534);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26715);
/* harmony import */ var _mapEnums__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98799);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(68628);
















// 商品编码与商品条码的请求接口
var selectMap = {
  goodsIdList: 'purchase.product.queryProductIdByKey',
  goodsBarCodeList: 'purchase.product.queryBarcodeByKey'
};
var orderTypeOneCols = [{
  title: '好坏货标记',
  dataIndex: 'isDamage',
  key: 'isDamage',
  width: 110,
  editable: true,
  sorter: (a, b) => {
    return a === null || a === void 0 ? void 0 : a.isDamageName.localeCompare(b === null || b === void 0 ? void 0 : b.isDamageName, 'cn');
  },
  render: (t, r, i, fn) => {
    var data = _config_enums__WEBPACK_IMPORTED_MODULE_7__/* .enumGlobalPurchase.isDamage.filter */ .Ov.isDamage.filter(e => e.value === t);
    var value = data.length ? data[0].label : '';

    if (fn) {
      return fn({
        fieldType: 'SELECT',
        dataList: _config_enums__WEBPACK_IMPORTED_MODULE_7__/* .enumGlobalPurchase.isDamage */ .Ov.isDamage
      });
    }

    return +t == 0 ? '' : value; // 如果下拉框后端返回0，则默认为空处理
  }
}, {
  title: '退货原因',
  dataIndex: 'returnReason',
  key: 'returnReason',
  width: 110,
  editable: true,
  sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.returnReason.length) - (b === null || b === void 0 ? void 0 : b.returnReason.length),
  render: (t, r, i, fn) => {
    var data = _config_enums__WEBPACK_IMPORTED_MODULE_7__/* .enumGlobalPurchase.returnReason.filter */ .Ov.returnReason.filter(e => e.value === t);
    var value = data.length ? data[0].label : '';

    if (fn) {
      return fn({
        fieldType: 'SELECT',
        dataList: _config_enums__WEBPACK_IMPORTED_MODULE_7__/* .enumGlobalPurchase.returnReason */ .Ov.returnReason
      });
    }

    return +t == 0 ? '' : value; // 如果下拉框后端返回0，则默认为空处理
  }
}]; // 商品列表的表头

function useColumns(props) {
  var _href = window.location.href;
  var isGoodsReturn = _href.indexOf('/GoodsReturn') !== -1;
  var manageType = isGoodsReturn ? '退货' : '补货';
  var formData = props.formData,
      barCodeList = props.barCodeList,
      editTableData = props.editTableData;
  var requireSource = formData.requireSource,
      firstCategoryId = formData.firstCategoryId;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState, 2),
      goodsIdList = _useState2[0],
      setGoodsIdList = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState3, 2),
      goodsBarCodeList = _useState4[0],
      setGoodsBarCodeList = _useState4[1]; // 获取商品编码和条码的下拉数据


  var handleGoodSearchList = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)().mark(function _callee(val) {
      var res, list, data;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (!(formData && !formData['merchantId'])) {
                _context.next = 4;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_12__.default.info('未选择商家');

              return _context.abrupt("return", false);

            case 4:
              if (val) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              _context.next = 8;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(selectMap['goodsIdList'], {
                merchantId: +formData.merchantId,
                key: val
              });

            case 8:
              res = _context.sent;

              if (res.success) {
                _context.next = 11;
                break;
              }

              throw '请求失败';

            case 11:
              list = res.result.list;

              if (list && !list.length) {
                setTimeout(() => {
                  antd_es_message__WEBPACK_IMPORTED_MODULE_12__.default.info('未查到相关信息');
                }, 500);
              }

              data = list.map(v => ({
                value: v,
                label: v
              }));
              setGoodsIdList(data);
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_12__.default.error(_context.t0);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 17]]);
    }));

    return function handleGoodSearchList(_x) {
      return _ref.apply(this, arguments);
    };
  }(); // 获取条码的下拉数据


  var handleCodeSearchList = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)().mark(function _callee2(val) {
      var res, list, data;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              if (formData.merchantId) {
                _context2.next = 4;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_12__.default.info('未选择商家');

              return _context2.abrupt("return", false);

            case 4:
              if (val) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt("return");

            case 6:
              _context2.next = 8;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(selectMap['goodsBarCodeList'], {
                merchantId: +formData.merchantId,
                key: val
              });

            case 8:
              res = _context2.sent;

              if (res.success) {
                _context2.next = 11;
                break;
              }

              throw '请求失败';

            case 11:
              list = res.result.list;
              data = list.map(v => ({
                value: v,
                label: v
              }));
              setGoodsBarCodeList(data);
              _context2.next = 19;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_12__.default.error(_context2.t0);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 16]]);
    }));

    return function handleCodeSearchList(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    var data = barCodeList.map(v => ({
      value: v,
      label: v
    }));
    setGoodsBarCodeList(data);
  }, [barCodeList]);
  var onDebounceGoodSearch = lodash_debounce__WEBPACK_IMPORTED_MODULE_5___default()(handleGoodSearchList, 500);
  var onDebounceCodeSearch = lodash_debounce__WEBPACK_IMPORTED_MODULE_5___default()(handleCodeSearchList, 500);

  if ((props === null || props === void 0 ? void 0 : props.type) === 'modal') {
    // 商品弹框的列表list
    // 弹框专属
    var normalColumns = [{
      title: '商品名称',
      dataIndex: 'goodsName',
      key: 'goodsName',
      width: 180,
      fixed: 'left',
      sorter: (a, b) => {
        var stringA = a.goodsName.toUpperCase(); // ignore upper and lowercase

        var stringB = b.goodsName.toUpperCase(); // ignore upper and lowercase

        if (stringA < stringB) {
          return -1;
        }

        if (stringA > stringB) {
          return 1;
        }

        return 0;
      },
      sortDirections: ['descend', 'ascend']
    }, {
      title: '商品编码',
      dataIndex: 'goodsId',
      key: 'goodsId',
      width: 80
    }, {
      title: '商品条码',
      dataIndex: 'goodsBarCode',
      key: 'goodsBarCode',
      width: 130
    }, {
      title: 'PLU码',
      dataIndex: 'pluCode',
      key: 'pluCode',
      width: 100,
      hide: firstCategoryId && +firstCategoryId !== 10 // 一级类目为生鲜，则展示plu码

    }, {
      title: '单位',
      dataIndex: 'specUnit',
      key: 'specUnit',
      //  商品弹窗去specUnit
      //  明细是orderSpecificationUnit
      width: 80
    }, {
      title: '审核数量',
      dataIndex: 'goodsReqQty',
      key: 'goodsReqQty',
      width: 120,
      editable: true,
      render: (t, r, i, fn) => {
        var msg = +t > 2000 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
          style: {
            color: 'red'
          }
        }, "\u6570\u91CF>2000") : '';

        if (requireSource === _mapEnums__WEBPACK_IMPORTED_MODULE_8__/* .enumRequireSource["自动补货"] */ .LN["自动补货"] && r.goodsAdviceQty) {
          msg = +t > +r.goodsAdviceQty * 3 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
            style: {
              color: 'red'
            }
          }, "\u6570\u91CF>\u5EFA\u8BAE\u91CF3\u500D") : '';
        } // 非称重商品为正整数，称重商品保留两位小数


        var isPositiveInteger = r.isWeigh === 2;

        if (fn) {
          var params = {
            fieldType: 'INPUT',
            // fieldType: 'INPUT_NUMBER',
            fieldOptions: {
              min: 0,
              formatter: value => isPositiveInteger ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_6__/* .exchageToNum1 */ .Ly)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_6__/* .exchageToNum3 */ .hY)(value),
              parser: value => isPositiveInteger ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_6__/* .exchageToNum1 */ .Ly)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_6__/* .exchageToNum3 */ .hY)(value)
            }
          };
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, fn(params), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, msg));
        }

        if (isNaN(+t)) {
          return undefined;
        }

        return isPositiveInteger ? Math.floor(+t) + "(".concat((r === null || r === void 0 ? void 0 : r.barCodeUnit) || '', ")") : (Math.floor(+t * 1000) / 1000).toFixed(3) + "(".concat((r === null || r === void 0 ? void 0 : r.barCodeUnit) || '', ")");
      }
    }, {
      title: '今日已订货量',
      dataIndex: 'todayBuyCount',
      key: 'todayBuyCount',
      width: 100,
      render: (t, r, i, fn) => {
        if (t === '') {
          return '';
        } else {
          return t ? t + "(".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")") : t;
        }
      }
    }, {
      title: '昨日销量/近7日销量',
      dataIndex: 'yestDaySaleCount',
      key: 'yestDaySaleCount',
      width: 100,
      render: (t, r, i, fn) => {
        // // 添加单位:  basicUnit  (瓶)
        // if (t && !r?.last7DaySaleCount) {
        //   return t + ' / ' + '-' + ` (${r?.basicUnit || ''})`
        // }
        // if (t && r?.last7DaySaleCount) {
        //   return t + ' / ' + r?.last7DaySaleCount + ` (${r?.basicUnit || ''})`
        // }
        return "".concat(t || '', "/").concat((r === null || r === void 0 ? void 0 : r.last7DaySaleCount) || '', "(").concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
      },
      sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.yestDaySaleCount) - (b === null || b === void 0 ? void 0 : b.yestDaySaleCount)
    }, {
      title: '可用库存/在途库存',
      dataIndex: 'stock',
      key: 'stock',
      width: 100,
      sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.stock) - (b === null || b === void 0 ? void 0 : b.stock),
      render: (t, r, i, fn) => {
        if (t && !(r !== null && r !== void 0 && r.onOrderStock)) {
          return t + ' / ' + '-' + " (".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
        }

        if (t && r !== null && r !== void 0 && r.onOrderStock) {
          return t + ' / ' + ((r === null || r === void 0 ? void 0 : r.onOrderStock) || '') + " (".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
        }
      }
    }, {
      title: '大仓库存量',
      dataIndex: 'dcStock',
      key: 'dcStock',
      width: 110,
      sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.dcStock) - (b === null || b === void 0 ? void 0 : b.dcStock),
      render: (t, r, i, fn) => {
        if ((r === null || r === void 0 ? void 0 : r.logisticName) !== '配送') {
          return '-';
        } else {
          if (t === '' || !t) {
            return '';
          } else {
            return t + "(".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
          }
        }
      }
    }, {
      title: '经营状态',
      dataIndex: 'businessStatusName',
      key: 'businessStatusName',
      width: 80
    }, {
      title: '单价(含税)',
      dataIndex: 'unitPrice',
      key: 'unitPrice',
      width: 110,
      editable: true,
      render: (t, r, i, fn) => {
        if (fn && r.allowChangePrice) {
          return fn('INPUT_NUMBER');
        }

        if (t === '') {
          return '';
        } // basicUnit 元/瓶


        return isNaN(+t) ? undefined : +t + "(\u5143/".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
      }
    }, {
      title: '申请金额(含税)',
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      width: 120,
      editable: true,
      render: (t, r, i, fn) => {
        if (fn && r.allowChangePrice) {
          return fn('INPUT_NUMBER');
        }

        return isNaN(+t) ? undefined : +t;
      }
    }, {
      title: '物流模式',
      dataIndex: 'logisticName',
      key: 'logisticName',
      width: 80
    }, {
      title: '品牌名称',
      dataIndex: 'brandName',
      key: 'brandName',
      width: 140
    }, {
      title: '供应商编码',
      dataIndex: 'supplierCode',
      key: 'supplierCode',
      width: 140
    }, {
      title: '供应商名称',
      dataIndex: 'supplierName',
      key: 'supplierName',
      width: 170
    }];

    if (manageType === '补货') {
      normalColumns.splice(4, 0, {
        title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, "\u8981\u8D27\u89C4\u683C", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
          title: "\u8981\u8D27\u91CF\u5FC5\u987B\u4E3A\u8981\u8D27\u89C4\u683C\u500D\u6570"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("a", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
          style: {
            color: '#f50'
          }
        })))),
        dataIndex: 'orderStepSize',
        key: 'orderStepSize',
        width: 100
      });
      normalColumns.splice(6, 0, {
        title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, "\u8981\u8D27\u4EF6\u6570", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
          title: "\u8981\u8D27\u89C4\u683C\u6574\u4EF6\u6570 "
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("a", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
          style: {
            color: '#f50'
          }
        })))),
        dataIndex: 'copies',
        key: 'copies',
        width: 100
      });
    }

    if (manageType === '退货') {
      return [...normalColumns, ...orderTypeOneCols].filter(item => !item.hide);
    }

    return normalColumns.filter(item => !item.hide);
  } else {
    var _normalColumns;

    var booleanData;

    if (formData !== null && formData !== void 0 && formData.category && Array.isArray(formData === null || formData === void 0 ? void 0 : formData.category) && Number(formData === null || formData === void 0 ? void 0 : formData.category[0]) === 10) {
      booleanData = [1002, 1003, 1004, 1005].includes(Number(formData === null || formData === void 0 ? void 0 : formData.category[1]));
    } else if (formData !== null && formData !== void 0 && formData.category) {
      var _formData$category;

      booleanData = [1002, 1003, 1004, 1005].includes(Number(formData === null || formData === void 0 ? void 0 : (_formData$category = formData.category) === null || _formData$category === void 0 ? void 0 : _formData$category.secondCategoryId));
    }

    if (booleanData && editTableData && editTableData !== null && editTableData !== void 0 && editTableData.saleList) {
      var _editTableData$saleLi, _editTableData$saleLi2, _editTableData$saleLi3, _editTableData$saleLi4, _editTableData$saleLi5, _editTableData$saleLi6, _editTableData$saleLi7;

      _normalColumns = [{
        title: '商品名称',
        dataIndex: 'goodsName',
        key: 'goodsName',
        width: 120,
        fixed: 'left',
        sorter: (a, b) => {
          var stringA = a.goodsName.toUpperCase(); // ignore upper and lowercase

          var stringB = b.goodsName.toUpperCase(); // ignore upper and lowercase

          if (stringA < stringB) {
            return -1;
          }

          if (stringA > stringB) {
            return 1;
          }

          return 0;
        },
        sortDirections: ['descend', 'ascend'],
        render: (t, r, i, fn) => {
          return (r === null || r === void 0 ? void 0 : r.promoteProductFlag) == 1 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tag__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z, {
            color: "warning",
            style: {
              borderRadius: '5px'
            }
          }, "\u63A8\u52A8"), t) : t;
        }
      }, {
        title: '商品编码',
        dataIndex: 'goodsId',
        key: 'goodsId',
        width: 110,
        type: 'SELECT',
        dataList: goodsIdList,
        fieldOptions: {
          onSearch: onDebounceGoodSearch
        },
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.goodsId) - (b === null || b === void 0 ? void 0 : b.goodsId)
      }, {
        title: '商品条码',
        dataIndex: 'goodsBarCode',
        key: 'goodsBarCode',
        width: 160,
        type: 'SELECT',
        dataList: goodsBarCodeList,
        fieldOptions: {
          onSearch: onDebounceCodeSearch
        },
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.goodsBarCode) - (b === null || b === void 0 ? void 0 : b.goodsBarCode)
      }, {
        title: 'PLU码',
        dataIndex: 'goodsPluCode',
        key: 'goodsPluCode',
        width: 100,
        hide: firstCategoryId && +firstCategoryId !== 10 // 一级类目为生鲜，则展示plu码

      }, {
        title: '单位',
        dataIndex: 'orderSpecificationUnit',
        key: 'orderSpecificationUnit',
        //  明细是orderSpecificationUnit
        width: 70
      }, {
        title: '建议补货量',
        dataIndex: 'goodsAdviceQty',
        key: 'goodsAdviceQty',
        width: 90,
        hide: ![_mapEnums__WEBPACK_IMPORTED_MODULE_8__/* .enumRequireSource["区域集中补货"] */ .LN["区域集中补货"], _mapEnums__WEBPACK_IMPORTED_MODULE_8__/* .enumRequireSource["自动补货"] */ .LN["自动补货"]].includes(requireSource) ? true : false // “建议补货量”（手动补货/pda补货不展示此字段），自动补货： 补货量默认=审核数量

      }, {
        title: '审核数量',
        dataIndex: 'goodsReqQty',
        key: 'goodsReqQty',
        width: 120,
        editable: true,
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.goodsReqQty) - (b === null || b === void 0 ? void 0 : b.goodsReqQty),
        render: (t, r, i, fn) => {
          var msg = +t > 2000 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
            style: {
              color: 'red'
            }
          }, "\u6570\u91CF>2000") : '';

          if (requireSource === _mapEnums__WEBPACK_IMPORTED_MODULE_8__/* .enumRequireSource["自动补货"] */ .LN["自动补货"] && r.goodsAdviceQty) {
            msg = +t > +r.goodsAdviceQty * 3 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
              style: {
                color: 'red'
              }
            }, "\u6570\u91CF>\u5EFA\u8BAE\u91CF3\u500D") : '';
          } // 非称重商品为正整数，称重商品保留两位小数


          var isPositiveInteger = r.isWeigh === 2;

          if (fn) {
            var params = {
              fieldType: 'INPUT',
              fieldOptions: {
                formatter: value => isPositiveInteger ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_6__/* .exchageToNum1 */ .Ly)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_6__/* .exchageToNum3 */ .hY)(value)
              },
              value: r !== null && r !== void 0 && r.goodsReqQty ? r === null || r === void 0 ? void 0 : r.goodsReqQty : ''
            };
            return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
              style: {
                color: r !== null && r !== void 0 && r.goodsAdviceQty && (r === null || r === void 0 ? void 0 : r.goodsReqQty) !== (r === null || r === void 0 ? void 0 : r.goodsAdviceQty) ? 'red' : 'black'
              }
            }, fn(params), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, msg));
          }

          if (isNaN(+t)) {
            return undefined;
          }

          return isPositiveInteger ? Math.floor(+t) + "(".concat((r === null || r === void 0 ? void 0 : r.barCodeUnit) || '', ")") : (Math.floor(+t * 1000) / 1000).toFixed(3) + "(".concat((r === null || r === void 0 ? void 0 : r.barCodeUnit) || '', ")");
        }
      }, {
        title: '昨日销量/近7日销量',
        dataIndex: 'yestDaySaleCount',
        key: 'yestDaySaleCount',
        width: 150,
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.yestDaySaleCount) - (b === null || b === void 0 ? void 0 : b.yestDaySaleCount),
        render: (t, r, i, fn) => {
          // 添加单位:  basicUnit  (瓶)
          if (t && !(r !== null && r !== void 0 && r.last7DaySaleCount)) {
            return t + ' / ' + '-' + " (".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
          }

          if (t && r !== null && r !== void 0 && r.last7DaySaleCount) {
            return t + ' / ' + (r === null || r === void 0 ? void 0 : r.last7DaySaleCount) + " (".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
          }
        }
      }, {
        title: '可用库存/在途库存',
        dataIndex: 'stock',
        key: 'stock',
        width: 150,
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.stock) - (b === null || b === void 0 ? void 0 : b.stock),
        render: (t, r, i, fn) => {
          if (t && !(r !== null && r !== void 0 && r.onOrderStock)) {
            return t + ' / ' + '-' + " (".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
          }

          if (t && r !== null && r !== void 0 && r.onOrderStock) {
            return t + ' / ' + (r === null || r === void 0 ? void 0 : r.onOrderStock) + " (".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
          }
        }
      }, {
        title: "".concat(editTableData && editTableData !== null && editTableData !== void 0 && editTableData.saleList ? editTableData === null || editTableData === void 0 ? void 0 : (_editTableData$saleLi = editTableData.saleList[0]) === null || _editTableData$saleLi === void 0 ? void 0 : _editTableData$saleLi.weekDate : null),
        dataIndex: 'saleList',
        key: 'saleList',
        width: 60,
        render: (t, r, i, fn) => {
          var _t$;

          // console.log(t,'数据')
          return (_t$ = t[0]) === null || _t$ === void 0 ? void 0 : _t$.saleQty;
        }
      }, {
        title: "".concat(editTableData && editTableData !== null && editTableData !== void 0 && editTableData.saleList ? editTableData === null || editTableData === void 0 ? void 0 : (_editTableData$saleLi2 = editTableData.saleList[1]) === null || _editTableData$saleLi2 === void 0 ? void 0 : _editTableData$saleLi2.weekDate : null),
        dataIndex: 'saleList',
        key: 'saleList',
        width: 60,
        render: (t, r, i, fn) => {
          var _t$2;

          // console.log(t,'数据')
          return (_t$2 = t[1]) === null || _t$2 === void 0 ? void 0 : _t$2.saleQty;
        }
      }, {
        title: "".concat(editTableData && editTableData !== null && editTableData !== void 0 && editTableData.saleList ? editTableData === null || editTableData === void 0 ? void 0 : (_editTableData$saleLi3 = editTableData.saleList[2]) === null || _editTableData$saleLi3 === void 0 ? void 0 : _editTableData$saleLi3.weekDate : null),
        dataIndex: 'saleList',
        key: 'saleList',
        width: 60,
        render: (t, r, i, fn) => {
          var _t$3;

          // console.log(t,'数据')
          return (_t$3 = t[2]) === null || _t$3 === void 0 ? void 0 : _t$3.saleQty;
        }
      }, {
        title: "".concat(editTableData && editTableData !== null && editTableData !== void 0 && editTableData.saleList ? editTableData === null || editTableData === void 0 ? void 0 : (_editTableData$saleLi4 = editTableData.saleList[3]) === null || _editTableData$saleLi4 === void 0 ? void 0 : _editTableData$saleLi4.weekDate : null),
        dataIndex: 'saleList',
        key: 'saleList',
        width: 60,
        render: (t, r, i, fn) => {
          var _t$4;

          // console.log(t,'数据')
          return (_t$4 = t[3]) === null || _t$4 === void 0 ? void 0 : _t$4.saleQty;
        }
      }, {
        title: "".concat(editTableData && editTableData !== null && editTableData !== void 0 && editTableData.saleList ? editTableData === null || editTableData === void 0 ? void 0 : (_editTableData$saleLi5 = editTableData.saleList[4]) === null || _editTableData$saleLi5 === void 0 ? void 0 : _editTableData$saleLi5.weekDate : null),
        dataIndex: 'saleList',
        key: 'saleList',
        width: 60,
        render: (t, r, i, fn) => {
          var _t$5;

          // console.log(t,'数据')
          return (_t$5 = t[4]) === null || _t$5 === void 0 ? void 0 : _t$5.saleQty;
        }
      }, {
        title: "".concat(editTableData && editTableData !== null && editTableData !== void 0 && editTableData.saleList ? editTableData === null || editTableData === void 0 ? void 0 : (_editTableData$saleLi6 = editTableData.saleList[5]) === null || _editTableData$saleLi6 === void 0 ? void 0 : _editTableData$saleLi6.weekDate : null),
        dataIndex: 'saleList',
        key: 'saleList',
        width: 60,
        render: (t, r, i, fn) => {
          var _t$6;

          // console.log(t,'数据')
          return (_t$6 = t[5]) === null || _t$6 === void 0 ? void 0 : _t$6.saleQty;
        }
      }, {
        title: "".concat(editTableData && editTableData !== null && editTableData !== void 0 && editTableData.saleList ? editTableData === null || editTableData === void 0 ? void 0 : (_editTableData$saleLi7 = editTableData.saleList[6]) === null || _editTableData$saleLi7 === void 0 ? void 0 : _editTableData$saleLi7.weekDate : null),
        dataIndex: 'saleList',
        key: 'saleList',
        width: 60,
        render: (t, r, i, fn) => {
          var _t$7;

          // console.log(t,'数据')
          return (_t$7 = t[6]) === null || _t$7 === void 0 ? void 0 : _t$7.saleQty;
        }
      }, {
        title: '今日已订货量',
        dataIndex: 'todayBuyCount',
        key: 'todayBuyCount',
        width: 110,
        render: (t, r, i, fn) => {
          if (t === '' || isNaN(t) || t === undefined) {
            return '';
          } else {
            return t ? t + "(".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")") : t;
          }
        }
      }, {
        title: '在途库存',
        dataIndex: 'wayStock',
        key: 'wayStock',
        width: 80
      }, {
        title: 'DMS数量',
        dataIndex: 'dmsQty',
        key: 'dmsQty',
        width: 80
      }, {
        title: '期初库存',
        dataIndex: 'initStock',
        key: 'initStock',
        width: 80
      }, {
        title: '上限库存',
        dataIndex: 'maxStock',
        key: 'maxStock',
        width: 130,
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.maxStock) - (b === null || b === void 0 ? void 0 : b.maxStock),
        render: (t, r, i, fn) => {
          if (t === '' || !t) {
            return '-';
          } else {
            return t + "(".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
          }
        },
        hide: requireSource !== _mapEnums__WEBPACK_IMPORTED_MODULE_8__/* .enumRequireSource["自动补货"] */ .LN["自动补货"] ? true : false
      }, {
        title: '大仓库存量',
        dataIndex: 'dcStock',
        key: 'dcStock',
        width: 130,
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.dcStock) - (b === null || b === void 0 ? void 0 : b.dcStock),
        render: (t, r, i, fn) => {
          if ((r === null || r === void 0 ? void 0 : r.logisticName) !== '配送') {
            return '-';
          } else {
            if (t === '' || !t) {
              return '';
            } else {
              return t + "(".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
            }
          }
        }
      }, {
        title: '经营状态',
        dataIndex: 'businessStatusName',
        key: 'businessStatusName',
        width: 140,
        sorter: (a, b) => a.businessStatusName.localeCompare(b.businessStatusName, 'cn')
      }, {
        title: '单价(含税)',
        dataIndex: 'unitPrice',
        key: 'unitPrice',
        width: 120,
        editable: true,
        render: (t, r, i, fn) => {
          if (fn && r.allowChangePrice) {
            return fn('INPUT_NUMBER');
          }

          return isNaN(+t) ? undefined : +t + "(\u5143/".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
        },
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.unitPrice) - (b === null || b === void 0 ? void 0 : b.unitPrice)
      }, {
        title: '申请金额(含税)',
        dataIndex: 'totalAmount',
        key: 'totalAmount',
        width: 150,
        editable: true,
        render: (t, r, i, fn) => {
          if (fn && r.allowChangePrice) {
            return fn('INPUT_NUMBER');
          }

          return isNaN(+t) ? undefined : +t;
        },
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.totalAmount) - (b === null || b === void 0 ? void 0 : b.totalAmount)
      }, {
        title: '物流模式',
        dataIndex: 'logisticName',
        key: 'logisticName',
        width: 140,
        sorter: (a, b) => a.logisticName.localeCompare(b.logisticName, 'cn')
      }, {
        title: '商品税率(%)',
        dataIndex: 'taxRate',
        key: 'taxRate',
        width: 140,
        render: (t, r, i, fn) => {
          return t ? (t * 100).toFixed(2) : (+r['tax'] * 100).toFixed(2);
        }
      }, {
        title: '品牌名称',
        dataIndex: 'brandName',
        key: 'brandName',
        width: 140
      }, {
        title: '供应商编码',
        dataIndex: 'supplierCode',
        key: 'supplierCode',
        width: 140,
        sorter: (a, b) => +(a === null || a === void 0 ? void 0 : a.supplierCode.slice(-5)) - +(b === null || b === void 0 ? void 0 : b.supplierCode.slice(-5))
      }, {
        title: '供应商名称',
        dataIndex: 'supplierName',
        key: 'supplierName',
        width: 170,
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.supplierName.length) - (b === null || b === void 0 ? void 0 : b.supplierName.length)
      }];
    } else {
      _normalColumns = [{
        title: '商品名称',
        dataIndex: 'goodsName',
        key: 'goodsName',
        width: 120,
        fixed: 'left',
        sorter: (a, b) => {
          var stringA = a.goodsName.toUpperCase(); // ignore upper and lowercase

          var stringB = b.goodsName.toUpperCase(); // ignore upper and lowercase

          if (stringA < stringB) {
            return -1;
          }

          if (stringA > stringB) {
            return 1;
          }

          return 0;
        },
        sortDirections: ['descend', 'ascend'],
        render: (t, r, i, fn) => {
          return (r === null || r === void 0 ? void 0 : r.promoteProductFlag) == 1 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tag__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z, {
            color: "warning",
            style: {
              borderRadius: '5px'
            }
          }, "\u63A8\u52A8"), t) : t;
        }
      }, {
        title: '商品编码',
        dataIndex: 'goodsId',
        key: 'goodsId',
        width: 110,
        type: 'SELECT',
        dataList: goodsIdList,
        fieldOptions: {
          onSearch: onDebounceGoodSearch
        },
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.goodsId) - (b === null || b === void 0 ? void 0 : b.goodsId)
      }, {
        title: '商品条码',
        dataIndex: 'goodsBarCode',
        key: 'goodsBarCode',
        width: 160,
        type: 'SELECT',
        dataList: goodsBarCodeList,
        fieldOptions: {
          onSearch: onDebounceCodeSearch
        },
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.goodsBarCode) - (b === null || b === void 0 ? void 0 : b.goodsBarCode)
      }, {
        title: 'PLU码',
        dataIndex: 'goodsPluCode',
        key: 'goodsPluCode',
        width: 100,
        hide: firstCategoryId && +firstCategoryId !== 10 // 一级类目为生鲜，则展示plu码

      }, {
        title: '单位',
        dataIndex: 'orderSpecificationUnit',
        key: 'orderSpecificationUnit',
        //  明细是orderSpecificationUnit
        width: 70
      }, {
        title: '建议补货量',
        dataIndex: 'goodsAdviceQty',
        key: 'goodsAdviceQty',
        width: 90,
        hide: ![_mapEnums__WEBPACK_IMPORTED_MODULE_8__/* .enumRequireSource["区域集中补货"] */ .LN["区域集中补货"], _mapEnums__WEBPACK_IMPORTED_MODULE_8__/* .enumRequireSource["自动补货"] */ .LN["自动补货"]].includes(requireSource) ? true : false // “建议补货量”（手动补货/pda补货不展示此字段），自动补货： 补货量默认=审核数量

      }, {
        title: '审核数量',
        dataIndex: 'goodsReqQty',
        key: 'goodsReqQty',
        width: 120,
        editable: true,
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.goodsReqQty) - (b === null || b === void 0 ? void 0 : b.goodsReqQty),
        render: (t, r, i, fn) => {
          var msg = +t > 2000 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
            style: {
              color: 'red'
            }
          }, "\u6570\u91CF>2000") : '';

          if (requireSource === _mapEnums__WEBPACK_IMPORTED_MODULE_8__/* .enumRequireSource["自动补货"] */ .LN["自动补货"] && r.goodsAdviceQty) {
            msg = +t > +r.goodsAdviceQty * 3 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
              style: {
                color: 'red'
              }
            }, "\u6570\u91CF>\u5EFA\u8BAE\u91CF3\u500D") : '';
          } // 非称重商品为正整数，称重商品保留两位小数


          var isPositiveInteger = r.isWeigh === 2;

          if (fn) {
            var params = {
              fieldType: 'INPUT',
              fieldOptions: {
                formatter: value => isPositiveInteger ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_6__/* .exchageToNum1 */ .Ly)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_6__/* .exchageToNum3 */ .hY)(value)
              },
              value: r !== null && r !== void 0 && r.goodsReqQty ? r === null || r === void 0 ? void 0 : r.goodsReqQty : ''
            };
            return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
              style: {
                color: r !== null && r !== void 0 && r.goodsAdviceQty && (r === null || r === void 0 ? void 0 : r.goodsReqQty) !== (r === null || r === void 0 ? void 0 : r.goodsAdviceQty) ? 'red' : 'black'
              }
            }, fn(params), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", null, msg));
          }

          if (isNaN(+t)) {
            return undefined;
          }

          return isPositiveInteger ? Math.floor(+t) + "(".concat((r === null || r === void 0 ? void 0 : r.barCodeUnit) || '', ")") : (Math.floor(+t * 1000) / 1000).toFixed(3) + "(".concat((r === null || r === void 0 ? void 0 : r.barCodeUnit) || '', ")");
        }
      }, {
        title: '昨日销量/近7日销量',
        dataIndex: 'yestDaySaleCount',
        key: 'yestDaySaleCount',
        width: 150,
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.yestDaySaleCount) - (b === null || b === void 0 ? void 0 : b.yestDaySaleCount),
        render: (t, r, i, fn) => {
          // 添加单位:  basicUnit  (瓶)
          if (t && !(r !== null && r !== void 0 && r.last7DaySaleCount)) {
            return t + ' / ' + '-' + " (".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
          }

          if (t && r !== null && r !== void 0 && r.last7DaySaleCount) {
            return t + ' / ' + (r === null || r === void 0 ? void 0 : r.last7DaySaleCount) + " (".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
          }
        }
      }, {
        title: '可用库存/在途库存',
        dataIndex: 'stock',
        key: 'stock',
        width: 150,
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.stock) - (b === null || b === void 0 ? void 0 : b.stock),
        render: (t, r, i, fn) => {
          if (t && !(r !== null && r !== void 0 && r.onOrderStock)) {
            return t + ' / ' + '-' + " (".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
          }

          if (t && r !== null && r !== void 0 && r.onOrderStock) {
            return t + ' / ' + (r === null || r === void 0 ? void 0 : r.onOrderStock) + " (".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
          }
        }
      }, {
        title: '今日已订货量',
        dataIndex: 'todayBuyCount',
        key: 'todayBuyCount',
        width: 110,
        render: (t, r, i, fn) => {
          if (t === '' || isNaN(t) || t === undefined) {
            return '';
          } else {
            return t ? t + "(".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")") : t;
          }
        }
      }, {
        title: '在途库存',
        dataIndex: 'wayStock',
        key: 'wayStock',
        width: 80
      }, {
        title: 'DMS数量',
        dataIndex: 'dmsQty',
        key: 'dmsQty',
        width: 80
      }, {
        title: '期初库存',
        dataIndex: 'initStock',
        key: 'initStock',
        width: 80
      }, {
        title: '上限库存',
        dataIndex: 'maxStock',
        key: 'maxStock',
        width: 130,
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.maxStock) - (b === null || b === void 0 ? void 0 : b.maxStock),
        render: (t, r, i, fn) => {
          if (t === '' || !t) {
            return '-';
          } else {
            return t + "(".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
          }
        },
        hide: requireSource !== _mapEnums__WEBPACK_IMPORTED_MODULE_8__/* .enumRequireSource["自动补货"] */ .LN["自动补货"] ? true : false
      }, {
        title: '大仓库存量',
        dataIndex: 'dcStock',
        key: 'dcStock',
        width: 130,
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.dcStock) - (b === null || b === void 0 ? void 0 : b.dcStock),
        render: (t, r, i, fn) => {
          if ((r === null || r === void 0 ? void 0 : r.logisticName) !== '配送') {
            return '-';
          } else {
            if (t === '' || !t) {
              return '';
            } else {
              return t + "(".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
            }
          }
        }
      }, {
        title: '经营状态',
        dataIndex: 'businessStatusName',
        key: 'businessStatusName',
        width: 140,
        sorter: (a, b) => a.businessStatusName.localeCompare(b.businessStatusName, 'cn')
      }, {
        title: '单价(含税)',
        dataIndex: 'unitPrice',
        key: 'unitPrice',
        width: 120,
        editable: true,
        render: (t, r, i, fn) => {
          if (fn && r.allowChangePrice) {
            return fn('INPUT_NUMBER');
          }

          return isNaN(+t) ? undefined : +t + "(\u5143/".concat((r === null || r === void 0 ? void 0 : r.basicUnit) || '', ")");
        },
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.unitPrice) - (b === null || b === void 0 ? void 0 : b.unitPrice)
      }, {
        title: '申请金额(含税)',
        dataIndex: 'totalAmount',
        key: 'totalAmount',
        width: 150,
        editable: true,
        render: (t, r, i, fn) => {
          if (fn && r.allowChangePrice) {
            return fn('INPUT_NUMBER');
          }

          return isNaN(+t) ? undefined : +t;
        },
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.totalAmount) - (b === null || b === void 0 ? void 0 : b.totalAmount)
      }, {
        title: '物流模式',
        dataIndex: 'logisticName',
        key: 'logisticName',
        width: 140,
        sorter: (a, b) => a.logisticName.localeCompare(b.logisticName, 'cn')
      }, {
        title: '商品税率(%)',
        dataIndex: 'taxRate',
        key: 'taxRate',
        width: 140,
        render: (t, r, i, fn) => {
          return t ? (t * 100).toFixed(2) : (+r['tax'] * 100).toFixed(2);
        }
      }, {
        title: '品牌名称',
        dataIndex: 'brandName',
        key: 'brandName',
        width: 140
      }, {
        title: '供应商编码',
        dataIndex: 'supplierCode',
        key: 'supplierCode',
        width: 140,
        sorter: (a, b) => +(a === null || a === void 0 ? void 0 : a.supplierCode.slice(-5)) - +(b === null || b === void 0 ? void 0 : b.supplierCode.slice(-5))
      }, {
        title: '供应商名称',
        dataIndex: 'supplierName',
        key: 'supplierName',
        width: 170,
        sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.supplierName.length) - (b === null || b === void 0 ? void 0 : b.supplierName.length)
      }];
    }

    if (manageType === '补货') {
      _normalColumns.splice(4, 0, {
        title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, "\u89C4\u683C", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
          title: "\u8981\u8D27\u91CF\u5FC5\u987B\u4E3A\u8981\u8D27\u89C4\u683C\u500D\u6570"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("a", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
          style: {
            color: '#f50'
          }
        })))),
        dataIndex: 'orderStepSize',
        key: 'orderStepSize',
        width: 70
      });

      _normalColumns.splice(6, 0, {
        title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, "\u4EF6\u6570", ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
          title: "\u8981\u8D27\u89C4\u683C\u6574\u4EF6\u6570 "
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("a", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, {
          style: {
            color: '#f50'
          }
        })))),
        dataIndex: 'copies',
        key: 'copies',
        width: 70
      });
    }

    if (manageType === '退货') {
      return [..._normalColumns, ...orderTypeOneCols].filter(item => !item.hide);
    }

    return _normalColumns.filter(item => !item.hide);
  }
}

/***/ }),

/***/ 9066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ exchangeDataPromise; },
/* harmony export */   "q": function() { return /* binding */ exchangeDataPromiseForDetail; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3182);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24731);
/* harmony import */ var _Common_Api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8450);




/**
 *  根据编码走其他接口，获取字段，拼接数据
 *  isListReq 是否列表明细，列表明细不处理applyOrderPrice
*/

var exchangeDataPromise = /*#__PURE__*/function () {
  var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)().mark(function _callee(list, merchantId, placeId, formData) {
    var productList, param, p, res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            productList = [];

            if (list !== null && list !== void 0 && list.length) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            param = list.map(item => ({
              merchantId: parseInt(merchantId),
              // 商家Id
              logistics: item['logistic'] || item['logistics'],
              goodsId: parseInt(item['goodsId']),
              // 商品Id列表
              deliveryDcId: parseInt(item['deliveryDcId']),
              // 大仓id
              placeId: parseInt(placeId),
              // 地点Id(当前库存)
              firstCategoryId: formData === null || formData === void 0 ? void 0 : formData.firstCategoryId,
              secondCategoryId: formData === null || formData === void 0 ? void 0 : formData.secondCategoryId,
              thirdCategoryId: formData === null || formData === void 0 ? void 0 : formData.thirdCategoryId,
              fourthCategoryId: formData === null || formData === void 0 ? void 0 : formData.fourthCategoryId
            }));
            p = {
              param,
              needPlaceStock: true,
              needSale: true,
              needYesterdayBuy: true,
              needWarehouseStock: true
            };

            if (formData !== null && formData !== void 0 && formData.billType) {
              p['orderTypePrice'] = formData === null || formData === void 0 ? void 0 : formData.billType;
            }

            _context.next = 8;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__/* .default */ .Z)(_Common_Api__WEBPACK_IMPORTED_MODULE_3__/* .GET_PRODUCT_EXTINFO */ .Mo, p);

          case 8:
            res = _context.sent;

            if (res !== null && res !== void 0 && res.success) {
              if (formData && formData !== null && formData !== void 0 && formData.isListReq) {
                // 是否列表明细，列表明细不处理applyOrderPrice
                productList = res.result['list'].map(item => ({
                  yestDaySaleCount: item['yestDaySaleCount'],
                  goodsId: item['goodsId'],
                  // 商品Id列表
                  last7DaySaleCount: item['last7DaySaleCount'],
                  onOrderStock: item['onOrderStock'],
                  stock: item['stock'],
                  todayBuyCount: item['todayBuyCount'],
                  // 今日
                  dcStock: item['dcStock'] // 大仓库存

                }));
              } else {
                productList = res.result['list'].map(item => ({
                  yestDaySaleCount: item['yestDaySaleCount'],
                  goodsId: item['goodsId'],
                  // 商品Id列表
                  last7DaySaleCount: item['last7DaySaleCount'],
                  onOrderStock: item['onOrderStock'],
                  stock: item['stock'],
                  todayBuyCount: item['todayBuyCount'],
                  // 今日
                  dcStock: item['dcStock'],
                  // 大仓库存
                  unitPrice: item['applyOrderPrice'] // 查到价格直接覆盖

                }));
              }
            }

            if (formData && formData !== null && formData !== void 0 && formData.isListReq) {
              // 是否列表明细，列表明细不处理applyOrderPrice
              list.forEach(e => {
                productList.forEach(v => {
                  if (v['goodsId'] === e['goodsId']) {
                    e['yestDaySaleCount'] = v['yestDaySaleCount'];
                    e['last7DaySaleCount'] = v['last7DaySaleCount'];
                    e['onOrderStock'] = v['onOrderStock'];
                    e['stock'] = v['stock'];
                    e['todayBuyCount'] = v['todayBuyCount'];
                    e['dcStock'] = v['dcStock'];
                  }
                });
              });
            } else {
              list.forEach(e => {
                productList.forEach(v => {
                  if (v['goodsId'] === e['goodsId']) {
                    e['yestDaySaleCount'] = v['yestDaySaleCount'];
                    e['last7DaySaleCount'] = v['last7DaySaleCount'];
                    e['onOrderStock'] = v['onOrderStock'];
                    e['stock'] = v['stock'];
                    e['todayBuyCount'] = v['todayBuyCount'];
                    e['dcStock'] = v['dcStock'];
                    e['unitPrice'] = v['unitPrice'];
                  }
                });
              });
            }

            console.log('最后结果', list);
            return _context.abrupt("return", Promise.resolve(list));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function exchangeDataPromise(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
/** 根据编码走其他接口，获取字段，拼接数据 */

var exchangeDataPromiseForDetail = /*#__PURE__*/function () {
  var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)().mark(function _callee2(list, merchantId, placeId) {
    var productList, param, res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            productList = [];

            if (list !== null && list !== void 0 && list.length) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return");

          case 3:
            param = list.map(item => ({
              merchantId: parseInt(merchantId),
              // 商家Id
              goodsId: parseInt(item['goodsId']),
              // 商品Id列表
              deliveryDcId: parseInt(item['deliveryDcId']),
              // 大仓id
              placeId: parseInt(placeId) // 地点Id(当前库存)

            }));
            console.log('paramList', param); // console.log('paramList', paramList)

            _context2.next = 7;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__/* .default */ .Z)(_Common_Api__WEBPACK_IMPORTED_MODULE_3__/* .GET_PRODUCT_EXTINFO */ .Mo, {
              param,
              needPlaceStock: true,
              needSale: true,
              needYesterdayBuy: true,
              needWarehouseStock: true
            });

          case 7:
            res = _context2.sent;

            if (res !== null && res !== void 0 && res.success) {
              productList = res.result['list'].map(item => ({
                yestDaySaleCount: item['yestDaySaleCount'],
                goodsId: item['goodsId'],
                // 商品Id列表
                last7DaySaleCount: item['last7DaySaleCount'],
                onOrderStock: item['onOrderStock'],
                stock: item['stock'],
                todayBuyCount: item['todayBuyCount'],
                // 今日
                dcStock: item['dcStock'] // 大仓库存

              }));
            }

            list.forEach(e => {
              productList.forEach(v => {
                if (v['goodsId'] === e['goodsId']) {
                  e['yestDaySaleCount'] = v['yestDaySaleCount'];
                  e['last7DaySaleCount'] = v['last7DaySaleCount'];
                  e['onOrderStock'] = v['onOrderStock'];
                  e['stock'] = v['stock'];
                  e['todayBuyCount'] = v['todayBuyCount'];
                  e['dcStock'] = v['dcStock'];
                }
              });
            });
            return _context2.abrupt("return", Promise.resolve(list));

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function exchangeDataPromiseForDetail(_x5, _x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 68884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_space_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49111);
/* harmony import */ var antd_es_space__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19650);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71577);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34041);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2824);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7704);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76570);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);












function Search(props) {
  var infoData = props.infoData,
      handleSearchCallback = props.handleSearchCallback;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState, 2),
      params = _useState2[0],
      setParams = _useState2[1]; // 门店下拉框


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState3, 2),
      placeList = _useState4[0],
      setPlaceList = _useState4[1];

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)([_hooks_useMapping__WEBPACK_IMPORTED_MODULE_3__/* .MappingKey["需求申请单状态"] */ .M["需求申请单状态"], _hooks_useMapping__WEBPACK_IMPORTED_MODULE_3__/* .MappingKey["权限下的商家"] */ .M["权限下的商家"]]),
      mappingList = _useMapping.mappingList;

  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    var list = mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_3__/* .MappingKey["权限下的商家"] */ .M["权限下的商家"]); // console.log(list,'list数据',infoData)

    if (infoData !== null && infoData !== void 0 && infoData.merchantId && list !== null && list !== void 0 && list.length) {
      var _target$others;

      var target = (list === null || list === void 0 ? void 0 : list.find(v => v.value === Number(infoData.merchantId))) || {};
      var placeVos = (target === null || target === void 0 ? void 0 : (_target$others = target.others) === null || _target$others === void 0 ? void 0 : _target$others.placeVos) || [];
      var data = placeVos.map(v => ({
        value: v.placeId,
        label: "".concat(v.placeCode, "-").concat(v.placeName),
        others: v
      }));
      setPlaceList(data);
    }
  }, [infoData === null || infoData === void 0 ? void 0 : infoData.merchantId, mappingList]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_space__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
    placeholder: "\u95E8\u5E97",
    options: placeList,
    allowClear: true,
    showSearch: true,
    value: params === null || params === void 0 ? void 0 : params.placeId,
    style: {
      width: 200
    },
    dropdownMatchSelectWidth: false,
    filterOption: (input, option) => {
      var _option$label;

      return ((_option$label = option.label) === null || _option$label === void 0 ? void 0 : _option$label.toLowerCase().indexOf(input.toLowerCase())) >= 0;
    },
    onChange: v => setParams(i => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)({}, i), {}, {
      placeId: v
    }))
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
    placeholder: "\u72B6\u6001",
    options: mappingList.get(_hooks_useMapping__WEBPACK_IMPORTED_MODULE_3__/* .MappingKey["需求申请单状态"] */ .M["需求申请单状态"]),
    allowClear: true,
    value: params === null || params === void 0 ? void 0 : params.status,
    style: {
      width: 100
    },
    dropdownMatchSelectWidth: false,
    onChange: v => setParams(i => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)({}, i), {}, {
      status: v
    }))
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, {
    type: "primary",
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z, null),
    onClick: () => handleSearchCallback(params)
  }, "\u641C\u7D22"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, {
    onClick: () => {
      setParams({
        placeId: undefined,
        status: undefined
      });
      handleSearchCallback({
        placeId: undefined,
        status: undefined
      });
    }
  }, "\u91CD\u7F6E"));
}

/* harmony default export */ __webpack_exports__["default"] = (Search);

/***/ }),

/***/ 20496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73727);



function useOrderColumns() {
  return [{
    title: '补货申请单',
    dataIndex: 'applyCode',
    width: 170,
    render: (t, r) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(umi__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
      to: "/ReplenishManage/Replenish/Detail?applyId=".concat(r.applyId, "&applyCode=").concat(r.applyCode)
    }, t)
  }, {
    title: '地点',
    dataIndex: 'placeCode',
    width: 200,
    render: (t, r) => "".concat(t, "-").concat(r.placeName)
  }, {
    title: '品类',
    dataIndex: 'firstCategoryName',
    width: 110
  }, {
    title: 'sku种类',
    dataIndex: 'skuTypeCount',
    width: 90
  }, {
    title: '数量',
    dataIndex: 'totalCount',
    width: 90
  }, {
    title: '金额(元)',
    dataIndex: 'totalAmount',
    width: 120
  }, {
    title: '集单标记',
    dataIndex: 'flagName',
    width: 90
  }, {
    title: '来源',
    dataIndex: 'requireSourceName',
    width: 100,
    render: (t, r) => {
      if (r.requireSource === 11) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
          style: {
            color: 'red'
          }
        }, t);
      }

      return t;
    }
  }, {
    title: '创建人',
    dataIndex: 'createUserName',
    width: 90
  }, {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    width: 180
  }, {
    title: '提交时间',
    dataIndex: 'submitTime',
    width: 180
  }, {
    title: '状态',
    dataIndex: 'statusName',
    width: 90
  }];
}

/* harmony default export */ __webpack_exports__["default"] = (useOrderColumns);

/***/ }),

/***/ 70245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93224);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71720);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24731);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99745);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46565);







var _excluded = ["infoData", "afterHandleCallback", "savingRowCallback"];






function GoodsTable(props) {
  var infoData = props.infoData,
      afterHandleCallback = props.afterHandleCallback,
      savingRowCallback = props.savingRowCallback,
      restTableProps = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(props, _excluded);

  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)(); // 保存行

  var handleSaveRow = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().mark(function _callee(data) {
      var currentRow, currentRowOldData, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currentRow = data.currentRow, currentRowOldData = data.currentRowOldData;
              savingRowCallback === null || savingRowCallback === void 0 ? void 0 : savingRowCallback(true);
              _context.next = 4;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_8__/* .DISTRIBUTION_SAVE_ORDER_DETAIL */ .kn, {
                orderNo: infoData === null || infoData === void 0 ? void 0 : infoData.orderNo,
                request: {
                  id: currentRow.id,
                  placeId: currentRow.placeId,
                  goodsId: currentRow.goodsId,
                  goodsBarCode: currentRow.goodsBarCode,
                  goodsReqQty: currentRow.goodsReqQty,
                  isDamage: currentRow.isDamage,
                  returnReason: currentRow.returnReason,
                  billDate: currentRow.billDate,
                  unitPrice: currentRow.unitPrice
                }
              });

            case 4:
              res = _context.sent;
              savingRowCallback === null || savingRowCallback === void 0 ? void 0 : savingRowCallback(false);

              if (!res.success) {
                _context.next = 12;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_9__.default.success("".concat(currentRow.goodsName, "\u4FDD\u5B58\u6210\u529F\uFF01"));

              afterHandleCallback === null || afterHandleCallback === void 0 ? void 0 : afterHandleCallback();
              return _context.abrupt("return", currentRow);

            case 12:
              return _context.abrupt("return", currentRowOldData);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [afterHandleCallback, savingRowCallback, infoData === null || infoData === void 0 ? void 0 : infoData.orderNo]);
  /**
   * 查询商品明细列表的回调
   * 更新参考价/供应商列表
   */

  var requestCallback = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().mark(function _callee2(dataList) {
      var _res$list;

      var extParams, res, stockMaps;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              extParams = {
                // needSale: true,
                needSupplier: true,
                needPlaceStock: true,
                needWarehouseStock: true,
                needYesterdayBuy: true,
                needRecentSale: true,
                param: dataList.map(v => ({
                  merchantId: infoData === null || infoData === void 0 ? void 0 : infoData.merchantId,
                  placeId: v === null || v === void 0 ? void 0 : v.placeId,
                  goodsId: +v.goodsId,
                  firstCategoryId: infoData === null || infoData === void 0 ? void 0 : infoData.firstCategoryId,
                  secondCategoryId: infoData === null || infoData === void 0 ? void 0 : infoData.secondCategoryId
                }))
              };
              _context2.next = 3;
              return dispatch({
                type: 'purchase/queryProductExtInfo',
                payload: extParams
              });

            case 3:
              res = _context2.sent;
              stockMaps = res === null || res === void 0 ? void 0 : (_res$list = res.list) === null || _res$list === void 0 ? void 0 : _res$list.reduce((pre, next) => {
                var _next$supplier;

                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)({}, pre), {}, {
                  ["".concat(next.goodsId).concat(next.placeId)]: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)({}, next), {}, {
                    supplier: (_next$supplier = next.supplier) === null || _next$supplier === void 0 ? void 0 : _next$supplier.map(v => ({
                      value: v.supplierCode,
                      label: v.supplierName,
                      others: v
                    }))
                  })
                });
              }, {});
              return _context2.abrupt("return", dataList.map(v => {
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)({}, v), stockMaps["".concat(v.goodsId).concat(v.placeId)]);
              }));

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [dispatch, infoData === null || infoData === void 0 ? void 0 : infoData.firstCategoryId, infoData === null || infoData === void 0 ? void 0 : infoData.merchantId, infoData === null || infoData === void 0 ? void 0 : infoData.secondCategoryId]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_3__/* .EnhanceTable */ .UO, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z)({}, restTableProps, {
    saveRowCallback: handleSaveRow,
    afterRequest: requestCallback,
    scroll: {
      y: 500
    }
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (GoodsTable);

/***/ }),

/***/ 15006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_space_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49111);
/* harmony import */ var antd_es_space__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19650);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46565);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99745);










function Statistics(props) {
  var _statistics$skuCount, _statistics$totalQty, _statistics$totalAmou;

  var infoData = props.infoData,
      pageId = props.pageId,
      statisticsRef = props.statisticsRef,
      searchParams = props.searchParams; // 汇总信息

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState, 2),
      statistics = _useState2[0],
      setStatistics = _useState2[1]; // 统计信息


  var queryStatData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee(params) {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!(infoData !== null && infoData !== void 0 && infoData.orderNo) || !pageId)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              console.log(searchParams, params);
              _context.next = 5;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_6__/* .DISTRIBUTION_STAT */ .Y0, {
                condition: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({}, searchParams.condition), params), {}, {
                  orderNo: infoData === null || infoData === void 0 ? void 0 : infoData.orderNo
                })
              });

            case 5:
              res = _context.sent;

              if (res.success) {
                setStatistics(res.result);
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [infoData === null || infoData === void 0 ? void 0 : infoData.orderNo, pageId, searchParams]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    queryStatData();
  }, [queryStatData]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (statisticsRef) {
      // @ts-ignore
      statisticsRef.current = {
        queryStatData,
        statistics
      };
    }
  }, [queryStatData, statistics, statisticsRef]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "alignRight mBottom16"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_space__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, "\u79CD\u7C7B\uFF1A", (_statistics$skuCount = statistics === null || statistics === void 0 ? void 0 : statistics.skuCount) !== null && _statistics$skuCount !== void 0 ? _statistics$skuCount : '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, "\u603B\u6570\u91CF\uFF1A", (_statistics$totalQty = statistics === null || statistics === void 0 ? void 0 : statistics.totalQty) !== null && _statistics$totalQty !== void 0 ? _statistics$totalQty : '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, "\u603B\u91D1\u989D\uFF1A", (_statistics$totalAmou = statistics === null || statistics === void 0 ? void 0 : statistics.totalAmount) !== null && _statistics$totalAmou !== void 0 ? _statistics$totalAmou : '-', "\u5143")));
}

/* harmony default export */ __webpack_exports__["default"] = (Statistics);

/***/ }),

/***/ 99745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ho": function() { return /* binding */ DISTRIBUTION_SAVE_ORDER; },
/* harmony export */   "kL": function() { return /* binding */ DISTRIBUTION_IMPORT_ORDER_DETAIL; },
/* harmony export */   "kn": function() { return /* binding */ DISTRIBUTION_SAVE_ORDER_DETAIL; },
/* harmony export */   "wY": function() { return /* binding */ DISTRIBUTION_DELETE_ORDER_DETAIL; },
/* harmony export */   "c6": function() { return /* binding */ DISTRIBUTION_SUBMIT; },
/* harmony export */   "i0": function() { return /* binding */ DISTRIBUTION_CANCEL; },
/* harmony export */   "TA": function() { return /* binding */ DISTRIBUTION_CLEAR; },
/* harmony export */   "p7": function() { return /* binding */ DISTRIBUTION_ORDER_DETAIL; },
/* harmony export */   "ZS": function() { return /* binding */ DISTRIBUTION_ORDER_DETAIL2; },
/* harmony export */   "O8": function() { return /* binding */ DISTRIBUTION_ORDER_LIST; },
/* harmony export */   "oC": function() { return /* binding */ DISTRIBUTION_ORDER_DETAIL_LIST; },
/* harmony export */   "Y0": function() { return /* binding */ DISTRIBUTION_STAT; },
/* harmony export */   "i1": function() { return /* binding */ DISTRIBUTION_CODE; },
/* harmony export */   "fI": function() { return /* binding */ DISTRIBUTION_GET_GROUP; },
/* harmony export */   "Y8": function() { return /* binding */ DISTRIBUTION_BATCH_SUBMIT_ORDER; }
/* harmony export */ });
/* unused harmony exports DISTRIBUTION_GOODS_LIST, DISTRIBUTION_LOOP_RESULT */

/**
 * 主单保存接口
 */

var DISTRIBUTION_SAVE_ORDER = 'purchase.require.saveRequirePreprocessOrder';
/**
 * 导入商品明细接口
 */

var DISTRIBUTION_IMPORT_ORDER_DETAIL = 'purchase.require.importRequirePreprocessOrderLines';
/**
 * 商品明细保存接口
 */

var DISTRIBUTION_SAVE_ORDER_DETAIL = 'purchase.require.saveRequirePreprocessOrderLine';
/**
 * 商品明细删除接口
 */

var DISTRIBUTION_DELETE_ORDER_DETAIL = 'purchase.require.deleteRequirePreprocessOrderLine';
/**
 * 提交接口
 */

var DISTRIBUTION_SUBMIT = 'purchase.require.submitRequirePreprocessOrder';
/**
 * 作废接口
 */

var DISTRIBUTION_CANCEL = 'purchase.require.batchCancelRequirePreprocessOrder';
/**
 * 商品明细清空接口
 */

var DISTRIBUTION_CLEAR = 'purchase.require.clearRequirePreprocessOrderLines';
/**
 * 详情接口
 */

var DISTRIBUTION_ORDER_DETAIL = 'purchase.require.queryRequirePreprocessOrderDetail';
/**
 * 自动补货策略
 */

var DISTRIBUTION_ORDER_DETAIL2 = 'purchase.require.queryAutoRequirePreprocessInfo';
/**
 * 列表接口
 */
// export const DISTRIBUTION_ORDER_LIST = 'purchase.require.queryRequirePreprocessOrderList'

var DISTRIBUTION_ORDER_LIST = 'purchase.require.queryAllRequirePreprocessOrders';
/**
 * 商品明细列表接口
 */

var DISTRIBUTION_ORDER_DETAIL_LIST = 'purchase.require.queryRequirePreprocessOrderLines';
/**
 * 统计商品明细接口
 */

var DISTRIBUTION_STAT = 'purchase.require.statRequirePreprocessOrderInfo';
/**
 * 获取单号
 */

var DISTRIBUTION_CODE = 'purchase.order.getOrderIdByBizType';
/**
 * 选品列表
 */

var DISTRIBUTION_GOODS_LIST = 'scm.purchase.querySelectPlaceProductByCondition';
/**
 * 轮训导入结果
 */

var DISTRIBUTION_LOOP_RESULT = 'scm.purchase.getLastImportResult';
/**
 * 根据商家查询门店信息
 */

var DISTRIBUTION_GET_GROUP = 'purchase.require.getGroupsByMerchant';
/**
 * 批量提交补货申请单
 */

var DISTRIBUTION_BATCH_SUBMIT_ORDER = 'purchase.requireApply.batchSubmitRequireApply';

/***/ }),

/***/ 96756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24731);
/* harmony import */ var _hooks_useLoopImport__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88242);
/* harmony import */ var _components_Uploader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84843);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52590);










var GoodsDetailImportBtn = props => {
  var orderNo = props.orderNo,
      _props$callBack = props.callBack,
      callBack = _props$callBack === void 0 ? () => {} : _props$callBack,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? '' : _props$mode; // props

  /** 导入初始化 轮询 */

  var _useLoopImport = (0,_hooks_useLoopImport__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)({
    request: {
      url: 'purchase.import.getLastImportResult',
      params: {
        businessType: 18,
        orderNo: orderNo
      }
    },
    refreshCallback: callBack
  }),
      loading = _useLoopImport.loading,
      loadingModal = _useLoopImport.loadingModal,
      startLoop = _useLoopImport.startLoop; // 导入商品明细


  var changeUpload = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().mark(function _callee(val) {
      var params, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = {
                resId: val,
                orderNo: orderNo,
                isSandTable: mode === 'sandTable' ? 1 : 2
              };
              _context.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_7__/* .IMPORT_SHOP_PRICE */ .Cj, params);

            case 3:
              res = _context.sent;

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_8__.default.success('导入任务添加成功');

                startLoop();
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [startLoop, orderNo, mode]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_components_Uploader__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z // accept='.xlsx,.xls'
  , {
    onChange: changeUpload,
    showType: 1,
    tokenUrl: "purchase.resource.getResourceToken",
    loading: loading,
    btnText: "\u5E93\u5B58\u4EF7\u683C",
    uploadOptions: {
      showUploadList: false // disabled: !curOrganizationId

    }
  }), loadingModal);
};

/* harmony default export */ __webpack_exports__["default"] = (GoodsDetailImportBtn);

/***/ }),

/***/ 30177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24731);
/* harmony import */ var _hooks_useLoopImport__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88242);
/* harmony import */ var _components_Uploader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84843);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52590);










var GoodsDetailImportBtn = props => {
  var orderNo = props.orderNo,
      _props$callBack = props.callBack,
      callBack = _props$callBack === void 0 ? () => {} : _props$callBack,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? '' : _props$mode; // props

  /** 导入初始化 轮询 */

  var _useLoopImport = (0,_hooks_useLoopImport__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)({
    request: {
      url: 'purchase.import.getLastImportResult',
      params: {
        businessType: 22,
        orderNo: orderNo
      }
    },
    refreshCallback: callBack
  }),
      loading = _useLoopImport.loading,
      loadingModal = _useLoopImport.loadingModal,
      startLoop = _useLoopImport.startLoop; // 导入商品明细


  var changeUpload = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().mark(function _callee(val) {
      var params, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = {
                resId: val,
                orderNo: orderNo,
                isSandTable: mode === 'sandTable' ? 1 : 2
              };
              _context.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_7__/* .IMPORT_SHOP_DETAIL */ .Ku, params);

            case 3:
              res = _context.sent;

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_8__.default.success('导入任务添加成功');

                startLoop();
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [startLoop, orderNo, mode]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_components_Uploader__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z // accept='.xlsx,.xls'
  , {
    onChange: changeUpload,
    showType: 1,
    tokenUrl: "purchase.resource.getResourceToken",
    loading: loading,
    btnText: "\u5546\u54C1\u660E\u7EC6",
    uploadOptions: {
      showUploadList: false // disabled: !curOrganizationId

    }
  }), loadingModal);
};

/* harmony default export */ __webpack_exports__["default"] = (GoodsDetailImportBtn);

/***/ }),

/***/ 15104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useCategoryWholeData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61982);



function useFormfields(shopList, orderNo, changePlace, changeIsCompleted) {
  // const { mappingList } = useMapping([76])
  // const vegetablesList = useMemo(() => mappingList.get(76), [mappingList])
  var categoryList = (0,_hooks_useCategoryWholeData__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)(4);
  var isModifyList = [{
    value: 1,
    label: '订货量',
    children: [{
      value: 0,
      label: '全部'
    }, {
      value: 1,
      label: '已修改'
    }, {
      value: 2,
      label: '未修改'
    }]
  }, {
    value: 2,
    label: '门店售价',
    children: [{
      value: 0,
      label: '全部'
    }, {
      value: 1,
      label: '已修改'
    }, {
      value: 2,
      label: '未修改'
    }]
  }, {
    value: 3,
    label: '到店价',
    children: [{
      value: 0,
      label: '全部'
    }, {
      value: 1,
      label: '已修改'
    }, {
      value: 2,
      label: '未修改'
    }]
  }];
  return [{
    label: '门店',
    name: 'placeIds',
    type: 'SELECT',
    dataList: shopList || [],
    fieldOptions: {
      placeholder: '请选择门店',
      mode: 'multiple',
      maxTagCount: 1,
      onChange: v => changePlace(v)
    }
  }, {
    label: '商品',
    name: 'goodsKey',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '商品编码/名称' // changeOnSelect: true

    }
  }, {
    label: '类目',
    name: 'category',
    type: 'CASCADER',
    dataList: categoryList,
    fieldOptions: {
      placeholder: '请选择类目',
      changeOnSelect: true
    }
  }, // {
  //   label: '菜种',
  //   name: 'vegetablesType',
  //   type: 'SELECT',
  //   dataList: vegetablesList,
  //   fieldOptions: {
  //     placeholder: '请选择菜种'
  //   }
  // },
  {
    label: '是否修改',
    name: 'modify',
    type: 'CASCADER',
    dataList: isModifyList,
    fieldOptions: {
      placeholder: '请选择是否修改'
    }
  }, // {
  //   label: '是否修改',
  //   name: 'isModify',
  //   type: 'SELECT',
  //   dataList: isModifyList,
  //   fieldOptions: {
  //     placeholder: '请选择是否修改'
  //   }
  // },
  {
    label: ' ',
    name: 'isPromotionGoods',
    type: 'CHECKBOX_GROUP',
    dataList: [{
      value: 1,
      label: '推动品'
    }]
  }, {
    label: ' ',
    name: 'isCompleted',
    type: 'CHECKBOX_GROUP',
    dataList: [{
      value: 1,
      label: '未完成门店'
    }],
    fieldOptions: {
      onChange: v => changeIsCompleted(v)
    }
  }, {
    label: '单号',
    name: 'OrderNo',
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, orderNo)
  }];
}

/* harmony default export */ __webpack_exports__["default"] = (useFormfields);

/***/ }),

/***/ 30906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useCategoryWholeData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61982);



function useFormfields(shopList, orderNo, changePlace, changeIsCompleted) {
  // const { mappingList } = useMapping([76])
  // const vegetablesList = useMemo(() => mappingList.get(76), [mappingList])
  var categoryList = (0,_hooks_useCategoryWholeData__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)(4);
  var isModifyList = [{
    value: 1,
    label: '订货量',
    children: [{
      value: 0,
      label: '全部'
    }, {
      value: 1,
      label: '已修改'
    }, {
      value: 2,
      label: '未修改'
    }]
  }, {
    value: 2,
    label: '门店售价',
    children: [{
      value: 0,
      label: '全部'
    }, {
      value: 1,
      label: '已修改'
    }, {
      value: 2,
      label: '未修改'
    }]
  }, {
    value: 3,
    label: '到店价',
    children: [{
      value: 0,
      label: '全部'
    }, {
      value: 1,
      label: '已修改'
    }, {
      value: 2,
      label: '未修改'
    }]
  }];
  return [{
    label: '门店',
    name: 'place',
    type: 'SELECT',
    dataList: shopList,
    fieldOptions: {
      placeholder: '请选择门店',
      mode: 'multiple',
      maxTagCount: 1,
      onChange: v => changePlace(v)
    }
  }, {
    label: '商品',
    name: 'goodsKey',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '商品编码/名称' // changeOnSelect: true

    }
  }, {
    label: '类目',
    name: 'category',
    type: 'CASCADER',
    dataList: categoryList,
    fieldOptions: {
      placeholder: '请选择类目',
      changeOnSelect: true
    }
  }, {
    label: '是否修改',
    name: 'modify',
    type: 'CASCADER',
    dataList: isModifyList,
    fieldOptions: {
      placeholder: '请选择是否修改'
    }
  }, {
    label: ' ',
    name: 'isPromotionGoods',
    type: 'CHECKBOX_GROUP',
    dataList: [{
      value: 1,
      label: '推动品'
    }]
  }, {
    label: ' ',
    name: 'isCompleted',
    type: 'CHECKBOX_GROUP',
    dataList: [{
      value: 1,
      label: '未完成门店'
    }],
    fieldOptions: {
      onChange: v => changeIsCompleted(v)
    }
  }, {
    label: '单号',
    name: 'OrderNo',
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, orderNo)
  }];
}

/* harmony default export */ __webpack_exports__["default"] = (useFormfields);

/***/ }),

/***/ 96616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46565);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52590);






function ShopCollect(props) {
  var columns = [{
    title: '序号',
    dataIndex: 'goodsListIndex',
    width: 50,
    render: (_t, _r, i) => i + 1
  }, {
    title: '门店编码',
    dataIndex: 'shopCode',
    key: 'shopCode',
    width: 100
  }, {
    title: '门店',
    dataIndex: 'shopName',
    key: 'shopName',
    width: 100,
    render: (_t, _r, i) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
      placement: "top",
      title: _t.replace(/合肥谊品生鲜/g, '')
    }, _t.replace(/合肥谊品生鲜/g, ''))
  }, {
    title: '商品种类',
    dataIndex: 'skuCount',
    key: 'skuCount',
    width: 100
  }, {
    title: '订货量',
    dataIndex: 'goodsReqQty',
    key: 'goodsReqQty',
    width: 100,
    sorter: (a, b) => a.goodsReqQty - b.goodsReqQty
  }, {
    title: '环比同天销量',
    dataIndex: 'sixDayAgoSales',
    key: 'sixDayAgoSales',
    width: 120,
    sorter: (a, b) => a.sixDayAgoSales - b.sixDayAgoSales
  }, {
    title: '剩余库存',
    dataIndex: 'surplusStock',
    key: 'surplusStock',
    width: 100,
    sorter: (a, b) => a.surplusStock - b.surplusStock
  }, {
    title: '份加价',
    dataIndex: 'barCodePremiumPrice',
    key: 'barCodePremiumPrice',
    width: 100,
    sorter: (a, b) => a.barCodePremiumPrice - b.barCodePremiumPrice
  }, {
    title: '加价总额',
    dataIndex: 'totalPremiumPrice',
    key: 'totalPremiumPrice',
    width: 100,
    sorter: (a, b) => a.totalPremiumPrice - b.totalPremiumPrice
  }, {
    title: '销售',
    dataIndex: 'totalSalePrice',
    key: 'totalSalePrice',
    width: 100,
    sorter: (a, b) => a.totalSalePrice - b.totalSalePrice
  }, {
    title: '未除去最大平均值销量',
    dataIndex: 'averageSales',
    key: 'averageSales',
    width: 170,
    sorter: (a, b) => a.averageSales - b.averageSales
  }, {
    title: '扣除最大平均值销量',
    dataIndex: 'deductionAverageSales',
    key: 'deductionAverageSales',
    width: 170,
    sorter: (a, b) => a.deductionAverageSales - b.deductionAverageSales
  }];
  var searchParams = props.searchParams;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .EnhanceTable */ .UO, {
    columns: columns,
    searchParams: searchParams,
    requestUrl: _api__WEBPACK_IMPORTED_MODULE_4__/* .SHOP_COLLECT */ .Nj,
    useTool: false,
    pageSize: 500
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (ShopCollect);

/***/ }),

/***/ 46601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(71577);
/* harmony import */ var antd_es_form_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9715);
/* harmony import */ var antd_es_form__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(35845);
/* harmony import */ var antd_es_time_picker_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39002);
/* harmony import */ var antd_es_time_picker__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(68351);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(3182);
/* harmony import */ var antd_es_tabs_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18106);
/* harmony import */ var antd_es_tabs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69584);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2824);
/* harmony import */ var _components_FixedBottomCps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32065);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5977);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46565);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(52590);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(24731);
/* harmony import */ var _components_YpshopCps_EditableTable_utils_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82347);
/* harmony import */ var _useColumns__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4334);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(83987);





























function ShopDetail(props, ref) {
  var _searchParams$conditi3, _searchParams$conditi4;

  var orderNo = props.orderNo,
      isEdit = props.isEdit,
      searchParams = props.searchParams,
      changeShopCallback = props.changeShopCallback,
      afterHandleCallback = props.afterHandleCallback,
      mode = props.mode,
      tableRef = props.tableRef,
      createTimeStamp = props.createTimeStamp,
      selectShopList = props.selectShopList,
      isCompleted = props.isCompleted; // const tableRef = useRef<EnhanceTableRefProps>(null)

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)({}),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState, 2),
      sortOrder = _useState2[0],
      setSortOrder = _useState2[1];

  var TabPane = antd_es_tabs__WEBPACK_IMPORTED_MODULE_15__/* .default.TabPane */ .Z.TabPane;

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(''),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState3, 2),
      activeTab = _useState4[0],
      _setActive = _useState4[1];

  var history = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_16__/* .useHistory */ .k6)();

  var onTabClick = (activeKey, e) => {
    _setActive(activeKey);

    changeShopCallback === null || changeShopCallback === void 0 ? void 0 : changeShopCallback(activeKey);
  };

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)('22:05'),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState5, 2),
      effectTime = _useState6[0],
      setEffectTime = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)([]),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState7, 2),
      _shopTabList = _useState8[0],
      setShopTabList = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)(_useState9, 2),
      isModalVisible = _useState10[0],
      setIsModalVisible = _useState10[1];

  var saveRowCallback = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().mark(function _callee(data) {
      var currentRow, currentRowOldData, currentCell, currentCellOldData, copies, orderStepSize, goodReqQty, res, result;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currentRow = data.currentRow, currentRowOldData = data.currentRowOldData, currentCell = data.currentCell, currentCellOldData = data.currentCellOldData; // console.log(currentCell, currentCellOldData, currentRowOldData);
              // debugger
              //件数和门店最终订单量实现联动

              copies = currentRow.copies, orderStepSize = currentRow.orderStepSize;
              goodReqQty = '';

              if (currentCellOldData !== null && currentCellOldData !== void 0 && currentCellOldData.copies) {
                goodReqQty = copies * orderStepSize;
              }

              console.log('goodReqQty', goodReqQty);
              _context.next = 7;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_19__/* .SAVE_SHOP_DETAIL */ .c2, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)({
                isSandTable: mode === 'sandTable' ? 1 : 2
              }, currentRow), {}, {
                goodsReqQty: goodReqQty || currentRow.goodsReqQty
              }));

            case 7:
              res = _context.sent;

              if (!res.success) {
                _context.next = 28;
                break;
              }

              result = res.result;

              antd_es_message__WEBPACK_IMPORTED_MODULE_21__.default.success("".concat(currentRow.goodsName, "\u4FDD\u5B58\u6210\u529F\uFF01"));

              if (currentRow.goodsReqQty !== result.goodsReqQty) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_21__.default.warn("".concat(currentRow.goodsName, "\u8981\u8D27\u6B65\u957F\u4E3A\uFF1A").concat(currentRow.orderStepSize, "\uFF0C\u6309\u8981\u8D27\u89C4\u5219\u6298\u7B97\u6210\uFF1A").concat(result.goodsReqQty));
              }

              afterHandleCallback === null || afterHandleCallback === void 0 ? void 0 : afterHandleCallback();
              currentRow.barCodePrice = result.barCodePrice;
              currentRow.totalPremiumPrice = result.totalPremiumPrice;
              currentRow.barCodePremiumPrice = result.barCodePremiumPrice;
              currentRow.totalSalePrice = result.totalSalePrice;
              currentRow.sellingPrice = result.sellingPrice;
              currentRow.goodsReqQty = result.goodsReqQty;
              currentRow.estimateSurplusStock = result.estimateSurplusStock;
              currentRow.shopPrice = result.shopPrice;
              currentRow.estimatedSales = result.estimatedSales;
              currentRow.stockToSalesRatio = result.stockToSalesRatio;
              currentRow.copies = result.copies;
              searchShopList([currentRow.placeId], 2);
              return _context.abrupt("return", currentRow);

            case 28:
              return _context.abrupt("return", currentRowOldData);

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function saveRowCallback(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var sortCallback = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)((filter, sorter) => {
    var orderByType;
    var orderBy = sorter.field;

    if (sorter.order === 'ascend') {
      orderByType = 1;
    } else if (sorter.order === 'descend') {
      orderByType = 2;
    } else {
      orderBy = undefined;
    }

    var condition = searchParams.condition;
    setSortOrder({
      orderByType,
      orderBy: orderBy
    });
    return {
      condition: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z)({}, condition), {}, {
        orderByType,
        orderBy: orderBy
      })
    };
  }, [searchParams]);

  var commit = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().mark(function _callee2() {
      var curTime, timeStamp, curTimeStamp, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              curTime = moment__WEBPACK_IMPORTED_MODULE_9___default()().format('YYYY-MM-DD');
              timeStamp = moment__WEBPACK_IMPORTED_MODULE_9___default()("".concat(curTime, " ").concat(effectTime)).unix() * 1000;
              curTimeStamp = new Date().getTime();

              if (!(mode === 'sandTable' && curTimeStamp > timeStamp)) {
                _context2.next = 6;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_21__.default.error('时间选择不正确');

              return _context2.abrupt("return");

            case 6:
              _context2.prev = 6;
              _context2.next = 9;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_8__/* .YpRequest */ .XQ)(_api__WEBPACK_IMPORTED_MODULE_19__/* .COMMIT_ORDER */ .gt, {
                orderNo: orderNo,
                isSandTable: mode === 'sandTable' ? 1 : 2,
                effectTime: mode === 'sandTable' ? timeStamp : undefined
              });

            case 9:
              res = _context2.sent;

              if (!res.success) {
                _context2.next = 16;
                break;
              }

              setIsModalVisible(false);
              _context2.next = 14;
              return antd_es_message__WEBPACK_IMPORTED_MODULE_21__.default.success('提交成功');

            case 14:
              history.push("/ReplenishManage/Distribution");
              window.location.reload();

            case 16:
              _context2.next = 21;
              break;

            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](6);

              antd_es_message__WEBPACK_IMPORTED_MODULE_21__.default.error(_context2.t0);

            case 21:
              _context2.prev = 21;
              return _context2.finish(21);

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 18, 21, 23]]);
    }));

    return function commit() {
      return _ref2.apply(this, arguments);
    };
  }();

  var debounceSubmit = () => {
    lodash_debounce__WEBPACK_IMPORTED_MODULE_13___default()(commit, 500)();
  };

  var confirmModal = () => {
    mode === 'sandTable' ? setIsModalVisible(true) : // debounceSubmit()
    antd_es_modal__WEBPACK_IMPORTED_MODULE_22__/* .default.confirm */ .Z.confirm({
      title: '确认提醒',
      icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z, null),
      content: '请确认是否已经完成全部门店的订货量填写！',
      okText: '确认',
      cancelText: '取消',

      onOk() {
        debounceSubmit();
      }

    });
  }; // eslint-disable-next-line react-hooks/exhaustive-deps


  var searchShopList = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().mark(function _callee3(selectShopList, operatyType) {
      var params;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              params = {
                orderNo: orderNo,
                isSandTable: mode === 'sandTable' ? 1 : 2,
                shopIds: selectShopList
              };
              (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_19__/* .SHOP_LIST */ .cM, params).then(_ref4 => {
                var success = _ref4.success,
                    result = _ref4.result;

                if (success) {
                  var list = result.list;
                  var arr = list && list.map(item => ({
                    value: item.shopId,
                    label: item.shopName.replace(/合肥谊品生鲜/g, ''),
                    shortlabel: item.shopShortName.replace(/合肥谊品生鲜/g, ''),
                    isModify: item.isModify
                  })) || [];

                  if (operatyType === 2) {
                    _shopTabList.map((item, index) => {
                      // console.log(item, 'sss', selectShopList[0], 'ppppp')
                      if (item.value === selectShopList[0]) {
                        _shopTabList.splice(index, 1, arr[0]);
                      }

                      return '';
                    });

                    setShopTabList([..._shopTabList]);
                  } else {
                    if ((isCompleted === null || isCompleted === void 0 ? void 0 : isCompleted.length) > 0) {
                      arr = arr.filter(el => el.isModify === 2);
                    }

                    arr.unshift({
                      value: '',
                      label: '全部',
                      shortlabel: '全部',
                      isModify: 2
                    });
                    setShopTabList(arr ? arr : []);
                  }
                }
              });

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function searchShopList(_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(() => {
    var _searchParams$conditi, _searchParams$conditi2;

    setSortOrder({
      orderBy: (_searchParams$conditi = searchParams.condition) === null || _searchParams$conditi === void 0 ? void 0 : _searchParams$conditi.orderBy,
      orderByType: (_searchParams$conditi2 = searchParams.condition) === null || _searchParams$conditi2 === void 0 ? void 0 : _searchParams$conditi2.orderByType
    });
  }, [searchParams]);
  (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(() => {
    searchShopList(selectShopList, 1);

    _setActive('');
  }, [selectShopList, isCompleted]);

  var handleOk = () => {
    debounceSubmit();
  };

  var handleCancel = () => {
    setIsModalVisible(false);
  };

  var onChange = (value, dateString) => {
    setEffectTime(dateString);
  };
  /**
   * 通过该 hook 定义父组件 ref 拿到子组件的实例的内容
   * 父组件使用 reflashTable 来调用子组件 sendRequest 这个方法
   */


  (0,react__WEBPACK_IMPORTED_MODULE_7__.useImperativeHandle)(ref, () => ({
    searchShop: params => searchShopList(params, 1),
    setActive: val => _setActive(val),
    shopTabList: () => _shopTabList
  }), [searchShopList, _setActive]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_8__/* .EnhanceTable */ .UO, {
    tableRef: tableRef //   cacheTable
    ,
    useVirtual: true,
    rowKey: "goodsListIndex",
    columns: isEdit ? (0,_useColumns__WEBPACK_IMPORTED_MODULE_12__.useEditColumns)(sortOrder, (_searchParams$conditi3 = searchParams.condition) === null || _searchParams$conditi3 === void 0 ? void 0 : _searchParams$conditi3.place, mode, createTimeStamp) : (0,_useColumns__WEBPACK_IMPORTED_MODULE_12__.useDetailColumns)(sortOrder, (_searchParams$conditi4 = searchParams.condition) === null || _searchParams$conditi4 === void 0 ? void 0 : _searchParams$conditi4.place, createTimeStamp),
    searchParams: searchParams,
    requestUrl: _api__WEBPACK_IMPORTED_MODULE_19__/* .SHOP_DETAILLIST */ .l9,
    mode: isEdit ? 'scroll' : 'normal',
    saveRowCallback: saveRowCallback,
    sortCallback: sortCallback,
    pageSize: 500 //   rowSelectCallback={rowSelectCallback}
    //   requestUrl={api.DISTRIBUTION_ORDER_LIST}
    //   rowSelection={{
    //     getCheckboxProps: (r: MainListProps) => ({
    //       disabled: r.orderStatus !== 1
    //     })
    //   }}
    // useTool={false}
    ,
    tableHeaderBar: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("div", {
      className: "header-wrap",
      style: {
        overflow: 'hidden'
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_tabs__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z, {
      activeKey: activeTab,
      onTabClick: onTabClick
    }, _shopTabList.map(d => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(TabPane, {
      tab: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("div", {
        style: {
          color: d.isModify === 1 ? 'green' : '',
          fontWeight: d.isModify === 1 ? 600 : 400
        }
      }, !(0,_components_YpshopCps_EditableTable_utils_utils__WEBPACK_IMPORTED_MODULE_11__/* .isEmpty */ .xb)(d.shortlabel) ? d.shortlabel : d.label),
      key: d.value
    }))))
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_22__/* .default */ .Z, {
    title: "\u63D0\u4EA4\u6C99\u76D8\u786E\u8BA4\u552E\u4EF7\u751F\u6548\u65F6\u95F4",
    visible: isModalVisible,
    onOk: handleOk,
    onCancel: handleCancel
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_24__/* .default */ .Z, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_24__/* .default.Item */ .Z.Item, {
    label: "\u552E\u4EF7\u751F\u6548\u65F6\u95F4",
    name: "effectTime",
    rules: [{
      required: true,
      message: '请选择时间'
    }]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_time_picker__WEBPACK_IMPORTED_MODULE_25__/* .default */ .Z, {
    defaultValue: moment__WEBPACK_IMPORTED_MODULE_9___default()(effectTime, 'HH:mm'),
    format: "HH:mm",
    onChange: onChange,
    allowClear: false
  })))), isEdit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(_components_FixedBottomCps__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    width: "100%",
    left: "0px",
    outerRE: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_26__/* .default */ .Z, {
      className: "mRight16",
      onClick: () => {
        history.push("/ReplenishManage/Distribution");
      }
    }, "\u8FD4\u56DE"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_26__/* .default */ .Z, {
      type: "primary",
      onClick: confirmModal
    }, "\u63D0\u4EA4"))
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_7__.forwardRef)(ShopDetail));

/***/ }),

/***/ 4334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useEditColumns": function() { return /* binding */ useEditColumns; },
/* harmony export */   "useDetailColumns": function() { return /* binding */ useDetailColumns; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31097);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var moment_locale_zh_cn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83839);
/* harmony import */ var moment_locale_zh_cn__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment_locale_zh_cn__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96534);
/* harmony import */ var _components_YpshopCps_EditableTable_utils_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82347);







moment__WEBPACK_IMPORTED_MODULE_1___default().locale('zh-cn');
function useEditColumns(sortorder, currentPlace, mode, createTimeStamp) {
  var getSortOrder = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(orderby => {
    if (sortorder.orderBy === orderby) {
      return sortorder.orderByType == 1 ? 'ascend' : 'descend';
    }

    return undefined;
  }, [sortorder]);
  var time = new Date(createTimeStamp);
  return [{
    title: '序号',
    dataIndex: 'goodsListIndex',
    width: 60,
    fixed: 'left',
    render: (_t, _r, i) => i + 1
  }, {
    title: '门店',
    dataIndex: 'placeName',
    key: 'placeName',
    width: 180,
    sorter: true,
    fixed: 'left',
    hide: !(0,_components_YpshopCps_EditableTable_utils_utils__WEBPACK_IMPORTED_MODULE_5__/* .isEmpty */ .xb)(currentPlace) && currentPlace !== ',,全部',
    sortorder: getSortOrder('placeName'),
    render: (_t, _r, i) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
      placement: "top",
      title: _t.replace(/合肥谊品生鲜/g, '')
    }, _t.replace(/合肥谊品生鲜/g, ''))
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 120,
    sorter: true,
    fixed: 'left',
    sortorder: getSortOrder('goodsName'),
    render: (_t, _r, i) => {
      // return '123123'
      if (_r.isPromotionGoods == 1) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
          placement: "top",
          title: _r.goodsName
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
          style: {
            display: 'flex'
          }
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
          className: "recommend-tag"
        }, "\u63A8\u52A8"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
          style: {
            width: '72px',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            fontWeight: 600
          }
        }, _r.goodsName)));
      }

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
        placement: "top",
        title: _r.goodsName
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        style: {
          width: '120px',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          fontWeight: 600
        }
      }, _r.goodsName));
    }
  }, {
    title: '门店',
    dataIndex: 'placeName',
    key: 'placeName',
    width: 100,
    sorter: true,
    hide: !(!(0,_components_YpshopCps_EditableTable_utils_utils__WEBPACK_IMPORTED_MODULE_5__/* .isEmpty */ .xb)(currentPlace) && currentPlace !== ',,全部'),
    sortorder: getSortOrder('placeName'),
    render: (_t, _r, i) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
      placement: "top",
      title: _t.replace(/合肥谊品生鲜/g, '')
    }, _t.replace(/合肥谊品生鲜/g, ''))
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 90,
    sorter: true,
    sortorder: getSortOrder('goodsId')
  }, {
    title: '类目',
    dataIndex: 'thirdCategoryName',
    key: 'thirdCategoryName',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('thirdCategoryName')
  }, {
    title: '货架期',
    dataIndex: 'shelvesDate',
    key: 'shelvesDate',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('shelvesDate')
  }, {
    title: '参考实时库存',
    dataIndex: 'realStock',
    key: 'realStock',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('realStock')
  }, {
    title: '实际库存',
    dataIndex: 'actualStock',
    key: 'actualStock',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('actualStock'),
    type: (r, i) => {
      return mode === 'sandTable' ? 'TEXT' : 'INPUT';
    },
    fieldOptions: r => {
      // 商品属性 称重商品保留两位小数
      var isWeight = Number(r.isWeigh) === 1;
      return {
        formatter: value => isWeight ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_4__/* .exchageToNum3 */ .hY)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_4__/* .exchageToNum1 */ .Ly)(value)
      };
    }
  }, {
    title: '平均销量非扣除最大值',
    dataIndex: 'averageSales',
    key: 'averageSales',
    width: 100,
    sorter: true,
    sortorder: getSortOrder('averageSales')
  }, {
    title: '平均销量扣除最大值',
    dataIndex: 'deductionAverageSales',
    key: 'deductionAverageSales',
    width: 100,
    sorter: true,
    sortorder: getSortOrder('deductionAverageSales')
  }, {
    title: '库销比',
    dataIndex: 'stockToSalesRatio',
    key: 'stockToSalesRatio',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('stockToSalesRatio')
  }, {
    title: '建议订单量',
    dataIndex: 'goodsAdviceQty',
    key: 'goodsAdviceQty',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('goodsAdviceQty')
  }, {
    title: '昨日订单量',
    dataIndex: 'yesterdayOrderQuantity',
    key: 'yesterdayOrderQuantity',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('yesterdayOrderQuantity')
  }, {
    title: '件数',
    dataIndex: 'copies',
    key: 'copies',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('copies'),
    type: (r, i) => {
      return mode === 'sandTable' ? 'TEXT' : 'INPUT';
    },
    fieldOptions: r => {
      // 商品属性 称重商品保留两位小数
      var isWeight = Number(r.isWeigh) === 1;
      return {
        formatter: value => isWeight ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_4__/* .exchageToNum3 */ .hY)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_4__/* .exchageToNum1 */ .Ly)(value)
      };
    }
  }, {
    title: '门店最终订单量',
    dataIndex: 'goodsReqQty',
    key: 'goodsReqQty',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('goodsReqQty'),
    type: (r, i) => {
      return mode === 'sandTable' ? 'TEXT' : 'INPUT';
    },
    fieldOptions: r => {
      // 商品属性 称重商品保留两位小数
      var isWeight = Number(r.isWeigh) === 1;
      return {
        formatter: value => isWeight ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_4__/* .exchageToNum3 */ .hY)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_4__/* .exchageToNum1 */ .Ly)(value)
      };
    }
  }, {
    title: '预估剩余库存量',
    dataIndex: 'estimateSurplusStock',
    key: 'estimateSurplusStock',
    type: 'INPUT',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('estimateSurplusStock'),
    fieldOptions: r => {
      // 商品属性 称重商品保留两位小数
      var isWeight = Number(r.isWeigh) === 1;
      return {
        formatter: value => isWeight ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_4__/* .exchageToNum3 */ .hY)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_4__/* .exchageToNum1 */ .Ly)(value)
      };
    }
  }, {
    title: '最小起订量',
    dataIndex: 'orderStepSize',
    key: 'orderStepSize',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('orderStepSize')
  }, {
    title: '平均售价',
    dataIndex: 'avgPrice',
    key: 'avgPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('avgPrice')
  }, {
    title: '到店价',
    dataIndex: 'shopPrice',
    key: 'shopPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('shopPrice'),
    type: (r, i) => {
      // return r?.shopPriceIsNull === 2 ? 'TEXT' : 'INPUT';
      return 'INPUT';
    },
    fieldOptions: r => {
      return {
        formatter: value => (0,_utils_common__WEBPACK_IMPORTED_MODULE_4__/* .exchageToNum3 */ .hY)(value)
      }; // 商品属性 称重商品保留两位小数
      // const isWeight = Number(r.isWeigh) === 1
      // return { formatter: (value: number) => (isWeight ? exchageToNum3(value) : exchageToNum1(value)) }
    }
  }, {
    title: '参考到店价',
    dataIndex: 'referShopPrice',
    key: 'referShopPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('referShopPrice')
  }, {
    title: '门店售价',
    dataIndex: 'sellingPrice',
    key: 'sellingPrice',
    width: 80,
    type: 'INPUT',
    sorter: true,
    sortorder: getSortOrder('sellingPrice'),
    fieldOptions: r => {
      return {
        formatter: value => (0,_utils_common__WEBPACK_IMPORTED_MODULE_4__/* .exchageToNum3 */ .hY)(value)
      }; // // 商品属性 称重商品保留两位小数
      // const isWeight = Number(r.isWeigh) === 1
      // return { formatter: (value: number) => (isWeight ? exchageToNum3(value) : exchageToNum1(value)) }
    }
  }, {
    title: '参考售价',
    dataIndex: 'referSellingPrice',
    key: 'referSellingPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('referSellingPrice')
  }, {
    title: '预计销量',
    dataIndex: 'estimatedSales',
    key: 'estimatedSales',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('estimatedSales')
  }, {
    title: '份单价',
    dataIndex: 'barCodePrice',
    key: 'barCodePrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('barCodePrice')
  }, {
    title: '份加价',
    dataIndex: 'barCodePremiumPrice',
    key: 'barCodePremiumPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('barCodePremiumPrice')
  }, {
    title: '加价总额',
    dataIndex: 'totalPremiumPrice',
    key: 'totalPremiumPrice',
    width: 100,
    sorter: true,
    sortorder: getSortOrder('totalPremiumPrice')
  }, {
    title: '销售',
    dataIndex: 'totalSalePrice',
    key: 'totalSalePrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('totalSalePrice')
  }, {
    title: '实时销量',
    dataIndex: 'realTimeSales',
    key: 'realTimeSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('realTimeSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(1, 'days').format('dddd MM/DD'),
    dataIndex: 'oneDayAgoSales',
    key: 'oneDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('oneDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(2, 'days').format('dddd MM/DD'),
    dataIndex: 'twoDayAgoSales',
    key: 'twoDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('twoDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(3, 'days').format('dddd MM/DD'),
    dataIndex: 'threeDayAgoSales',
    key: 'threeDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('threeDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(4, 'days').format('dddd MM/DD'),
    dataIndex: 'fourDayAgoSales',
    key: 'fourDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('fourDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(5, 'days').format('dddd MM/DD'),
    dataIndex: 'fiveDayAgoSales',
    key: 'fiveDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('fiveDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(6, 'days').format('dddd MM/DD'),
    dataIndex: 'sixDayAgoSales',
    key: 'sixDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('sixDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(7, 'days').format('dddd MM/DD'),
    dataIndex: 'sevenDayAgoSales',
    key: 'sevenDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('sevenDayAgoSales')
  }, {
    title: '累计销量',
    dataIndex: 'totalSales',
    key: 'totalSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('totalSales')
  }, {
    title: '单天最大销量',
    dataIndex: 'maxSales',
    key: 'maxSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('maxSales')
  }];
}
function useDetailColumns(sortorder, currentPlace, createTimeStamp) {
  var getSortOrder = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(orderby => {
    if (sortorder.orderBy === orderby) {
      return sortorder.orderByType == 1 ? 'ascend' : 'descend';
    }

    return undefined;
  }, [sortorder]);
  var time = new Date(createTimeStamp);
  return [{
    title: '序号',
    dataIndex: 'goodsListIndex',
    width: 60,
    fixed: 'left',
    render: (_t, _r, i) => i + 1
  }, {
    title: '门店',
    dataIndex: 'placeName',
    key: 'placeName',
    width: 150,
    sorter: true,
    fixed: 'left',
    hide: !(0,_components_YpshopCps_EditableTable_utils_utils__WEBPACK_IMPORTED_MODULE_5__/* .isEmpty */ .xb)(currentPlace) && currentPlace !== ',,全部',
    sortorder: getSortOrder('placeName'),
    render: (_t, _r, i) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
      placement: "top",
      title: _t.replace(/合肥谊品生鲜/g, '')
    }, _t.replace(/合肥谊品生鲜/g, ''))
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 120,
    sorter: true,
    fixed: 'left',
    sortorder: getSortOrder('goodsName'),
    render: (_t, _r, i) => {
      // return '123123'
      if (_r.isPromotionGoods == 1) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
          placement: "top",
          title: _r.goodsName
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
          style: {
            display: 'flex'
          }
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
          className: "recommend-tag"
        }, "\u63A8\u52A8"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
          style: {
            width: '72px',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            fontWeight: 600
          }
        }, _r.goodsName)));
      }

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
        placement: "top",
        title: _r.goodsName
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
        style: {
          width: '120px',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          fontWeight: 600
        }
      }, _r.goodsName));
    }
  }, {
    title: '门店',
    dataIndex: 'placeName',
    key: 'placeName',
    width: 100,
    sorter: true,
    hide: !(!(0,_components_YpshopCps_EditableTable_utils_utils__WEBPACK_IMPORTED_MODULE_5__/* .isEmpty */ .xb)(currentPlace) && currentPlace !== ',,全部'),
    sortorder: getSortOrder('placeName'),
    render: (_t, _r, i) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
      placement: "top",
      title: _t.replace(/合肥谊品生鲜/g, '')
    }, _t.replace(/合肥谊品生鲜/g, ''))
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 90,
    sorter: true,
    sortorder: getSortOrder('goodsId')
  }, {
    title: '类目',
    dataIndex: 'thirdCategoryName',
    key: 'thirdCategoryName',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('thirdCategoryName')
  }, {
    title: '货架期',
    dataIndex: 'shelvesDate',
    key: 'shelvesDate',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('shelvesDate')
  }, // {
  //     title: '截止24点库存',
  //     dataIndex: 'zeroStock',
  //     key: 'zeroStock',
  //     width: 80,
  //     sorter: true,
  //     sortorder: getSortOrder('zeroStock'),
  // },
  {
    title: '参考实时库存',
    dataIndex: 'realStock',
    key: 'realStock',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('realStock')
  }, {
    title: '实际库存',
    dataIndex: 'actualStock',
    key: 'actualStock',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('actualStock')
  }, {
    title: '平均销量非扣减最大值',
    dataIndex: 'averageSales',
    key: 'averageSales',
    width: 100,
    sorter: true,
    sortorder: getSortOrder('averageSales')
  }, {
    title: '平均销量扣除最大值',
    dataIndex: 'deductionAverageSales',
    key: 'deductionAverageSales',
    width: 100,
    sorter: true,
    sortorder: getSortOrder('deductionAverageSales')
  }, {
    title: '库销比',
    dataIndex: 'stockToSalesRatio',
    key: 'stockToSalesRatio',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('stockToSalesRatio')
  }, {
    title: '建议订单量',
    dataIndex: 'goodsAdviceQty',
    key: 'goodsAdviceQty',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('goodsAdviceQty')
  }, {
    title: '昨日订单量',
    dataIndex: 'yesterdayOrderQuantity',
    key: 'yesterdayOrderQuantity',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('yesterdayOrderQuantity')
  }, {
    title: '件数',
    dataIndex: 'copies',
    key: 'copies',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('copies')
  }, {
    title: '门店最终订单量',
    dataIndex: 'goodsReqQty',
    key: 'goodsReqQty',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('goodsReqQty')
  }, {
    title: '预估剩余库存量',
    dataIndex: 'estimateSurplusStock',
    key: 'estimateSurplusStock',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('estimateSurplusStock')
  }, {
    title: '最小起订量',
    dataIndex: 'orderStepSize',
    key: 'orderStepSize',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('orderStepSize')
  }, {
    title: '平均售价',
    dataIndex: 'avgPrice',
    key: 'avgPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('avgPrice')
  }, {
    title: '到店价',
    dataIndex: 'shopPrice',
    key: 'shopPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('shopPrice')
  }, {
    title: '参考到店价',
    dataIndex: 'referShopPrice',
    key: 'referShopPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('referShopPrice')
  }, {
    title: '门店售价',
    dataIndex: 'sellingPrice',
    key: 'sellingPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('sellingPrice')
  }, {
    title: '参考售价',
    dataIndex: 'referSellingPrice',
    key: 'referSellingPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('referSellingPrice')
  }, {
    title: '预计销量',
    dataIndex: 'estimatedSales',
    key: 'estimatedSales',
    width: 70,
    sorter: true,
    sortorder: getSortOrder('estimatedSales')
  }, {
    title: '份单价',
    dataIndex: 'barCodePrice',
    key: 'barCodePrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('barCodePrice')
  }, {
    title: '份加价',
    dataIndex: 'barCodePremiumPrice',
    key: 'barCodePremiumPrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('barCodePremiumPrice')
  }, {
    title: '加价总额',
    dataIndex: 'totalPremiumPrice',
    key: 'totalPremiumPrice',
    width: 100,
    sorter: true,
    sortorder: getSortOrder('totalPremiumPrice')
  }, {
    title: '销售',
    dataIndex: 'totalSalePrice',
    key: 'totalSalePrice',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('totalSalePrice')
  }, {
    title: '实时销量',
    dataIndex: 'realTimeSales',
    key: 'realTimeSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('realTimeSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(1, 'days').format('dddd MM/DD'),
    dataIndex: 'oneDayAgoSales',
    key: 'oneDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('oneDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(2, 'days').format('dddd MM/DD'),
    dataIndex: 'twoDayAgoSales',
    key: 'twoDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('twoDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(3, 'days').format('dddd MM/DD'),
    dataIndex: 'threeDayAgoSales',
    key: 'threeDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('threeDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(4, 'days').format('dddd MM/DD'),
    dataIndex: 'fourDayAgoSales',
    key: 'fourDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('fourDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(5, 'days').format('dddd MM/DD'),
    dataIndex: 'fiveDayAgoSales',
    key: 'fiveDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('fiveDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(6, 'days').format('dddd MM/DD'),
    dataIndex: 'sixDayAgoSales',
    key: 'sixDayAgoSales',
    width: 100,
    sorter: true,
    sortorder: getSortOrder('sixDayAgoSales')
  }, {
    title: moment__WEBPACK_IMPORTED_MODULE_1___default()(time).subtract(7, 'days').format('dddd MM/DD'),
    dataIndex: 'sevenDayAgoSales',
    key: 'sevenDayAgoSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('sevenDayAgoSales')
  }, {
    title: '累计销量',
    dataIndex: 'totalSales',
    key: 'totalSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('totalSales')
  }, {
    title: '单天最大销量',
    dataIndex: 'maxSales',
    key: 'maxSales',
    width: 80,
    sorter: true,
    sortorder: getSortOrder('maxSales')
  }];
}

/***/ }),

/***/ 15158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52590);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24731);







function Statistics(props) {
  var _statistics$goodsReqQ, _statistics$sixDayAgo, _statistics$surplusSt, _statistics$estimated, _statistics$barCodePr, _statistics$barCodePr2, _statistics$totalPrem, _statistics$totalSale;

  var statisticsRef = props.statisticsRef,
      searchParams = props.searchParams; // 汇总信息

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState, 2),
      statistics = _useState2[0],
      setStatistics = _useState2[1]; // 统计信息


  var queryStatData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().mark(function _callee() {
    var res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_5__/* .SHOP_STATICSTICS */ ._R, searchParams);

          case 3:
            res = _context.sent;

            if (res.success) {
              setStatistics(res.result);
            }

            _context.next = 9;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  })), [searchParams]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    queryStatData();
  }, [queryStatData]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (statisticsRef) {
      // @ts-ignore
      statisticsRef.current = {
        queryStatData
      };
    }
  }, [queryStatData, statisticsRef]);
  var style = {
    color: 'rgba(24, 144, 255, 1)'
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "header-height"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, "\u6C47\u603B\uFF1A\u95E8\u5E97\u8BA2\u8D27\u91CF\uFF1A"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: style
  }, (_statistics$goodsReqQ = statistics === null || statistics === void 0 ? void 0 : statistics.goodsReqQty) !== null && _statistics$goodsReqQ !== void 0 ? _statistics$goodsReqQ : '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, " / \u73AF\u6BD4\u540C\u5929\u9500\u91CF\uFF1A"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: style
  }, (_statistics$sixDayAgo = statistics === null || statistics === void 0 ? void 0 : statistics.sixDayAgoSales) !== null && _statistics$sixDayAgo !== void 0 ? _statistics$sixDayAgo : '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, " / \u5269\u4F59\u5E93\u5B58\uFF1A"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: style
  }, (_statistics$surplusSt = statistics === null || statistics === void 0 ? void 0 : statistics.surplusStock) !== null && _statistics$surplusSt !== void 0 ? _statistics$surplusSt : '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, " / \u9884\u8BA1\u9500\u91CF\uFF1A"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: style
  }, (_statistics$estimated = statistics === null || statistics === void 0 ? void 0 : statistics.estimatedSales) !== null && _statistics$estimated !== void 0 ? _statistics$estimated : '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, " / \u4EFD\u5355\u4EF7\uFF1A"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: style
  }, (_statistics$barCodePr = statistics === null || statistics === void 0 ? void 0 : statistics.barCodePrice) !== null && _statistics$barCodePr !== void 0 ? _statistics$barCodePr : '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, " / \u4EFD\u52A0\u4EF7\uFF1A"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: style
  }, (_statistics$barCodePr2 = statistics === null || statistics === void 0 ? void 0 : statistics.barCodePremiumPrice) !== null && _statistics$barCodePr2 !== void 0 ? _statistics$barCodePr2 : '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, " / \u52A0\u4EF7\u603B\u989D\uFF1A"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: style
  }, (_statistics$totalPrem = statistics === null || statistics === void 0 ? void 0 : statistics.totalPremiumPrice) !== null && _statistics$totalPrem !== void 0 ? _statistics$totalPrem : '-'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, " / \u9500\u552E\uFF1A"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: style
  }, (_statistics$totalSale = statistics === null || statistics === void 0 ? void 0 : statistics.totalSalePrice) !== null && _statistics$totalSale !== void 0 ? _statistics$totalSale : '-'));
}

/* harmony default export */ __webpack_exports__["default"] = (Statistics);

/***/ }),

/***/ 52590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cM": function() { return /* binding */ SHOP_LIST; },
/* harmony export */   "Nj": function() { return /* binding */ SHOP_COLLECT; },
/* harmony export */   "_R": function() { return /* binding */ SHOP_STATICSTICS; },
/* harmony export */   "l9": function() { return /* binding */ SHOP_DETAILLIST; },
/* harmony export */   "c2": function() { return /* binding */ SAVE_SHOP_DETAIL; },
/* harmony export */   "$X": function() { return /* binding */ EXPORT_SHOP_DETAIL; },
/* harmony export */   "Ku": function() { return /* binding */ IMPORT_SHOP_DETAIL; },
/* harmony export */   "Cj": function() { return /* binding */ IMPORT_SHOP_PRICE; },
/* harmony export */   "tP": function() { return /* binding */ EXPORT_SHOP_PRICE; },
/* harmony export */   "fc": function() { return /* binding */ REFRESH_REAL_SRTOCK; },
/* harmony export */   "gt": function() { return /* binding */ COMMIT_ORDER; },
/* harmony export */   "ZS": function() { return /* binding */ DISTRIBUTION_ORDER_DETAIL2; },
/* harmony export */   "vm": function() { return /* binding */ REAL_TIME_SALES_VOLUME; },
/* harmony export */   "EK": function() { return /* binding */ REAL_TIME_SALES_VOLUME_SCHEDULE; }
/* harmony export */ });
// 门店列表
var SHOP_LIST = 'purchase.require.queryAutoRequirePreprocessShops'; // 门店汇总列表

var SHOP_COLLECT = 'purchase.require.statAutoRequirePreprocessDetailByShop'; // 门店汇总

var SHOP_STATICSTICS = 'purchase.require.statAutoRequirePreprocessDetail'; // 门店明细列表

var SHOP_DETAILLIST = 'purchase.require.queryAutoRequirePreprocessDetail'; // 修改门店明细列表

var SAVE_SHOP_DETAIL = 'purchase.require.modifyRequireAutoPreprocessOrder'; // 导出门店明细列表

var EXPORT_SHOP_DETAIL = 'purchase.require.exportRequireAutoPreprocessOrder'; // 导入

var IMPORT_SHOP_DETAIL = 'purchase.require.importRequireAutoPreprocessOrderDetail'; // 导入门店价

var IMPORT_SHOP_PRICE = 'purchase.require.importShopPrice'; // 导出门店价列表

var EXPORT_SHOP_PRICE = 'purchase.require.exportShopPrice'; //  刷新实时库存

var REFRESH_REAL_SRTOCK = 'purchase.require.refreshRealStock'; // 整单提交

var COMMIT_ORDER = 'purchase.require.commitRequireAutoPreprocessOrder';
/**
 * 自动补货策略
 */

var DISTRIBUTION_ORDER_DETAIL2 = 'purchase.require.queryAutoRequirePreprocessInfo'; // 实时销量

var REAL_TIME_SALES_VOLUME = 'purchase.require.refreshRealTimeSales'; // 获取实时销量进度

var REAL_TIME_SALES_VOLUME_SCHEDULE = 'purchase.require.queryRefreshRealTimeSalesProgress';

/***/ }),

/***/ 52737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useShopList; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24731);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52590);




/**
 * 获取门店列表
 */

function useShopList(orderNo, mode) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState, 2),
      shopList = _useState2[0],
      setShopList = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__/* .default */ .Z)(_api__WEBPACK_IMPORTED_MODULE_3__/* .SHOP_LIST */ .cM, {
      orderNo: orderNo,
      isSandTable: mode,
      shopIds: []
    }).then(_ref => {
      var success = _ref.success,
          result = _ref.result;

      if (success) {
        // console.log(result,'reeee')
        var list = result.list;
        var arr = list && list.map(item => ({
          value: item.shopId,
          label: item.shopName.replace(/合肥谊品生鲜/g, ""),
          shortlabel: item.shopShortName.replace(/合肥谊品生鲜/g, ""),
          isModify: item.isModify
        }));
        setShopList(arr ? arr : []);
      }
    });
  }, []);
  return shopList;
}

/***/ }),

/***/ 53931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HOME_TABLE_COLUMNS": function() { return /* binding */ HOME_TABLE_COLUMNS; },
/* harmony export */   "DETAIL_TABLE_COLUMNS": function() { return /* binding */ DETAIL_TABLE_COLUMNS; },
/* harmony export */   "BASE_MAP": function() { return /* binding */ BASE_MAP; },
/* harmony export */   "goodsBackModal": function() { return /* binding */ goodsBackModal; },
/* harmony export */   "DICTIONARY": function() { return /* binding */ DICTIONARY; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var HOME_TABLE_COLUMNS = [{
  title: '退货申请单',
  dataIndex: 'applyCode',
  key: 'applyCode',
  width: 130,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, // {
//   title: '退货分类',
//   dataIndex: 'applyTypeName',
//   key: 'applyTypeName',
//   width: 90,
// },
{
  title: '地点编码',
  dataIndex: 'placeCode',
  key: 'placeCode',
  width: 65 // render: (t) => dictionaryMatch(t, 'supplierCategory', DICTIONARY, 'list')

}, {
  title: '地点名称',
  dataIndex: 'placeName',
  key: 'placeName',
  width: 140,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '品类',
  dataIndex: 'firstCategoryName',
  key: 'firstCategoryName',
  width: 140,
  ellipsis: true,
  render: (t, r) => {
    var text = r.firstCategoryName;

    if (r !== null && r !== void 0 && r.thirdCategoryName) {
      text = r.firstCategoryName + '/' + r.secondCategoryName + '/' + r.thirdCategoryName;
    } else if (!(r !== null && r !== void 0 && r.thirdCategoryName) && r !== null && r !== void 0 && r.secondCategoryName) {
      text = r.firstCategoryName + '/' + r.secondCategoryName;
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
      placement: "topLeft",
      title: text
    }, text);
  }
}, {
  title: 'sku种类',
  dataIndex: 'skuTypeCount',
  key: 'skuTypeCount',
  width: 50
}, {
  title: '数量',
  dataIndex: 'totalCount',
  key: 'totalCount',
  width: 50
}, {
  title: '金额(元)',
  dataIndex: 'totalAmount',
  key: 'totalAmount',
  width: 100,
  render: t => {
    return t !== null || t !== undefined ? (Math.floor(+t * 100) / 100).toFixed(3) : '';
  }
}, {
  title: '状态',
  dataIndex: 'statusName',
  key: 'statusName',
  width: 50
}, {
  title: '集单标记',
  dataIndex: 'flagName',
  key: 'flagName',
  width: 70
}, {
  title: '来源',
  dataIndex: 'requireSourceName',
  key: 'requireSourceName',
  width: 70
}, {
  title: '创建人',
  dataIndex: 'createUserName',
  key: 'createUserName',
  width: 90
}, {
  title: '创建时间',
  dataIndex: 'gmtCreate',
  key: 'gmtCreate',
  width: 150,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}];
var DETAIL_TABLE_COLUMNS = [{
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 90
}, {
  title: '商品条码',
  dataIndex: 'goodsBarCode',
  key: 'goodsBarCode',
  width: 100
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 100
}, {
  title: '单位',
  dataIndex: 'orderSpecificationUnit',
  key: 'orderSpecificationUnit',
  width: 130
}, {
  title: '单价',
  dataIndex: 'unitPrice',
  key: 'unitPrice',
  width: 130,
  render: (t, r) => isNaN(t) ? '' : t + "(\u5143/".concat(r === null || r === void 0 ? void 0 : r.basicUnit, ")")
}, {
  title: '申请数量',
  dataIndex: 'goodsReqQty',
  key: 'goodsReqQty',
  width: 130,
  render: (t, r) => isNaN(t) ? '' : t + "(".concat(r === null || r === void 0 ? void 0 : r.barCodeUnit, ")")
}, {
  title: '是否好坏货',
  dataIndex: 'isDamageName',
  key: 'isDamageName',
  width: 130
}, {
  title: '退货原因',
  dataIndex: 'returnReasonName',
  key: 'returnReasonName',
  width: 130
}, {
  title: '申请总金额',
  dataIndex: 'totalAmount',
  key: 'totalAmount',
  width: 130,
  render: t => isNaN(t) ? '' : t + '元' // render: (t) => { return (t !== null || t !== undefined) ? (Math.floor(+t * 100) / 1000000).toFixed(4) : '' },

}, // {
//   title: '昨日销量',
//   dataIndex: 'yestDaySaleCount',
//   key: 'yestDaySaleCount',
//   width: 130
// },
// {
//   title: '近7日销量',
//   dataIndex: 'last7DaySaleCount',
//   key: 'last7DaySaleCount',
//   width: 130
// },
// {
//   title: '可用库存',
//   dataIndex: 'stock',
//   key: 'stock',
//   width: 130
// },
// {
//   title: '在途库存',
//   dataIndex: 'onOrderStock',
//   key: 'onOrderStock',
//   width: 130
// },
{
  title: '大仓库存量',
  dataIndex: 'dcStock',
  key: 'dcStock',
  width: 120,
  sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.dcStock) - (b === null || b === void 0 ? void 0 : b.dcStock),
  render: (t, r, i, fn) => {
    if ((r === null || r === void 0 ? void 0 : r.logisticName) !== '配送') {
      return '-';
    } else {
      if (t === '' || !t) {
        return '';
      } else {
        return t + "(".concat(r === null || r === void 0 ? void 0 : r.basicUnit, ")");
      }
    }
  }
}, {
  title: '集单标记',
  dataIndex: 'poolingFlag',
  key: 'poolingFlag',
  width: 130
}, {
  title: '品牌名称',
  dataIndex: 'brandName',
  key: 'brandName',
  width: 90
}, {
  title: '供应商编码',
  dataIndex: 'supplierCode',
  key: 'supplierCode',
  width: 100
}, {
  title: '供应商名称',
  dataIndex: 'supplierName',
  key: 'supplierName',
  width: 140
}, {
  title: '经营状态',
  dataIndex: 'businessStatusName',
  key: 'businessStatusName',
  width: 100
}, {
  title: '物流模式',
  dataIndex: 'logisticsName',
  key: 'logisticsName',
  width: 130
}, {
  title: '规格',
  dataIndex: 'orderSpecification',
  key: 'orderSpecification',
  width: 130
}, {
  title: '集单单号',
  dataIndex: 'poolingNo',
  key: 'poolingNo',
  width: 130,
  render: t => {
    if (t === '0' || t === null) {
      return '';
    }

    return t;
  }
}];
/**
 * 列表常量
 */

var BASE_MAP = [// 基础信息
['applyCode', ['退货申请单号', '']], // ['requireSourceName', ['退货分类', '']],
['statusName', ['状态', '']], ['remark', ['备注', '']], ['placeName', ['地点', '']], ['firstCategoryName', ['一级品类', '']], ['secondCategoryName', ['二级品类', '']]];
var goodsBackModal = [{
  title: '商家名称',
  dataIndex: 'ffds',
  key: 'ffds',
  width: 140
}, {
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 140
}, {
  title: '商品条码',
  dataIndex: 'goodsBarCode',
  key: 'goodsBarCode',
  width: 140
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 140
}, {
  title: '大类名称',
  dataIndex: 'kmk',
  key: 'kmk',
  width: 140
}, {
  title: '品牌名称',
  dataIndex: 'crs',
  key: 'crs',
  width: 140
}, {
  title: '单位',
  dataIndex: 'njknd',
  key: 'njknd',
  width: 140
}, {
  title: '规格',
  dataIndex: 'jndsf',
  key: 'jndsf',
  width: 140
}];
/**
 * 字段字典
 */

var DICTIONARY = [{
  "key": "SupplierCategory",
  "configMap": {
    "1": "采购供应商",
    "2": "农户供应商"
  }
}];

/***/ }),

/***/ 49522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ GoodsApi; }
/* harmony export */ });
/**
 * API集合
 */
var GoodsApi = {
  pageProduct: 'kernel.console.ProductQueryService.pageProduct',
  queryOperationSelect: 'ylp.ibd.ReceiptProcessService.queryOperationSelect',
  getUploadToken: 'ylp.md.resource.service.getUploadToken',
  pageQueryAquaticProduct: 'ds.link.linkAquaticProductService.pageQueryAquaticProduct',
  saveAquaticProduct: 'ds.link.linkAquaticProductService.saveAquaticProduct',
  getTemplate: 'ds.task.DataImportTemplateService.getTemplate',
  generateUrl: 'ylp.md.resource.service.generateUrl',
  dataImport: 'ds.task.ImportExportTaskService.dataImport',
  exportFile: 'ds.task.ImportExportTaskService.export',
  queryListByPage: 'ds.task.ImportExportTaskService.queryListByPage'
};

/***/ }),

/***/ 85456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "weightList": function() { return /* binding */ weightList; },
/* harmony export */   "statisticalUnitList": function() { return /* binding */ statisticalUnitList; },
/* harmony export */   "isStatisticsList": function() { return /* binding */ isStatisticsList; },
/* harmony export */   "formJson": function() { return /* binding */ formJson; },
/* harmony export */   "GOODS_COLUMN_FIELD": function() { return /* binding */ GOODS_COLUMN_FIELD; },
/* harmony export */   "statusMap": function() { return /* binding */ statusMap; },
/* harmony export */   "downformJson": function() { return /* binding */ downformJson; },
/* harmony export */   "DOWN_COLUMN_FIELD": function() { return /* binding */ DOWN_COLUMN_FIELD; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

// 是否称重
var weightList = [{
  label: '称重',
  value: 2
}, {
  label: '非称重',
  value: 1
}];
var weightMapper = {
  2: '称重',
  1: '非称重'
}; // 统计单位

var statisticalUnitList = [{
  label: 'KG',
  value: 1
}, {
  label: '条',
  value: 2
}, {
  label: '只',
  value: 3
}, {
  label: '袋',
  value: 4
}, {
  label: '个',
  value: 5
}, {
  label: '件',
  value: 6
}, {
  label: '份',
  value: 7
}, {
  label: '盒',
  value: 8
}, {
  label: '包',
  value: 9
}];
var unitMapper = {
  1: 'KG',
  2: '条',
  3: '只',
  4: '袋',
  5: '个',
  6: '件',
  7: '份',
  8: '盒',
  9: '包'
}; // 是否统计

var isStatisticsList = [{
  label: '是',
  value: 2
}, {
  label: '否',
  value: 1
}];
var defaultMapper = {
  1: '否',
  2: '是'
};
var statusMapper = {
  1: '新品',
  2: '正常',
  3: '停购',
  4: '停售',
  5: '清退'
};
var formJson = [{
  type: 'COMMON_INPUT',
  label: '运营组',
  placeholder: '请输入运营组名称',
  field: 'operationGroupName',
  width: '',
  initialValue: ''
}, {
  type: 'COMMON_INPUT',
  label: '商品名称',
  placeholder: '请输入商品名称/编码',
  field: 'productName',
  width: '',
  initialValue: ''
}, {
  type: 'GOODS_CATEGORY',
  label: '商品类别',
  placeholder: '请选择商品类别',
  field: 'categoryId',
  width: '',
  initialValue: ''
}];
var GOODS_COLUMN_FIELD = [{
  title: '运营组ID',
  dataIndex: 'operationGroupId',
  width: 90
}, {
  title: '运营组名称',
  dataIndex: 'operationGroupName',
  width: 120
}, {
  title: '商品编码',
  dataIndex: 'productCode',
  width: 90
}, {
  title: '商品名称',
  dataIndex: 'productName',
  width: 80
}, {
  title: '品类',
  dataIndex: 'categoryName',
  width: 100
}, {
  title: '是否统计',
  dataIndex: 'isStatistics',
  width: 80,
  render: isStatistics => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, defaultMapper[isStatistics])
}, {
  title: '是否称重',
  dataIndex: 'isWeigh',
  width: 80,
  render: isWeigh => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, weightMapper[isWeigh])
}, {
  title: '统计单位',
  dataIndex: 'statisticalUnit',
  width: 80,
  render: statisticalUnit => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, unitMapper[statisticalUnit] || '-')
}, {
  title: '统计换算',
  dataIndex: 'statisticalConversion',
  width: 80,
  render: statisticalConversion => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, statisticalConversion || '-')
}, {
  title: '创建人',
  dataIndex: 'creator',
  width: 80
}, {
  title: '创建时间',
  dataIndex: 'createTime',
  width: 120
}, {
  title: '更新人',
  dataIndex: 'modifier',
  width: 80
}, {
  title: '更新时间',
  dataIndex: 'modifyTime',
  width: 120
}];
var statusMap = {
  1: '待处理',
  2: '处理中',
  3: '处理成功',
  4: '处理失败',
  5: '部分成功'
};
var downformJson = [{
  label: '状态',
  name: 'taskStatus',
  type: 'SELECT',
  dataList: [{
    label: '待处理',
    value: 1
  }, {
    label: '处理中',
    value: 2
  }, {
    label: '处理成功',
    value: 3
  }, {
    label: '处理失败',
    value: 4
  }, {
    label: '部分成功',
    value: 5
  }]
} // {
//   label: '开始时间',
//   name: 'taskCreateTimeStart',
//   initialValue: undefined,
//   type: 'DATE_PICKER',
//   fieldOptions: {},
// },
// {
//   label: '结束时间',
//   name: 'taskCreateTimeEnd',
//   initialValue: undefined,
//   type: 'DATE_PICKER',
//   fieldOptions: {},
// },
];
var DOWN_COLUMN_FIELD = [{
  title: '名称',
  dataIndex: 'exportFileName',
  width: 120
}, {
  title: '类型',
  dataIndex: 'bizTypeName',
  width: 90,
  render: (bizTypeName, record) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, bizTypeName)
}, {
  title: '状态',
  dataIndex: 'status',
  width: 90,
  render: status => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, statusMap[status])
}, {
  title: '操作人',
  dataIndex: 'creator',
  width: 80
}, {
  title: '任务创建时间',
  dataIndex: 'createTime',
  width: 120
}, {
  title: '任务完成时间',
  dataIndex: 'finishTime',
  width: 120
}];

/***/ }),

/***/ 34411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HOME_TABLE_COLUMNS": function() { return /* binding */ HOME_TABLE_COLUMNS; },
/* harmony export */   "DETAIL_TABLE_COLUMNS": function() { return /* binding */ DETAIL_TABLE_COLUMNS; },
/* harmony export */   "DETAIL_TABLE_COLUMNS_NOT_TODAY": function() { return /* binding */ DETAIL_TABLE_COLUMNS_NOT_TODAY; },
/* harmony export */   "BASE_MAP": function() { return /* binding */ BASE_MAP; },
/* harmony export */   "goodsBackModal": function() { return /* binding */ goodsBackModal; },
/* harmony export */   "DICTIONARY": function() { return /* binding */ DICTIONARY; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var HOME_TABLE_COLUMNS = [{
  title: '补货申请单',
  dataIndex: 'applyCode',
  key: 'applyCode',
  width: 160,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, // {
//   title: '补货分类',
//   dataIndex: 'applyTypeName',
//   key: 'applyTypeName',
//   width: 90,
// },
{
  title: '地点编码',
  dataIndex: 'placeCode',
  key: 'placeCode',
  width: 100 // render: (t) => dictionaryMatch(t, 'supplierCategory', DICTIONARY, 'list')

}, {
  title: '地点名称',
  dataIndex: 'placeName',
  key: 'placeName',
  width: 140,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '品类',
  dataIndex: 'firstCategoryName',
  key: 'firstCategoryName',
  width: 130,
  ellipsis: true,
  render: (t, r) => {
    var text = r.firstCategoryName;

    if (r !== null && r !== void 0 && r.thirdCategoryName) {
      text = r.firstCategoryName + '/' + r.secondCategoryName + '/' + r.thirdCategoryName;
    } else if (!(r !== null && r !== void 0 && r.thirdCategoryName) && r !== null && r !== void 0 && r.secondCategoryName) {
      text = r.firstCategoryName + '/' + r.secondCategoryName;
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
      placement: "topLeft",
      title: text
    }, text);
  }
}, {
  title: 'sku种类',
  dataIndex: 'skuTypeCount',
  key: 'skuTypeCount',
  width: 90
}, {
  title: '数量',
  dataIndex: 'totalCount',
  key: 'totalCount',
  width: 50
}, {
  title: '金额(元)',
  dataIndex: 'totalAmount',
  key: 'totalAmount',
  width: 100,
  render: t => {
    return t !== null && t !== undefined ? (+t).toFixed(3) : '';
  }
}, {
  title: '状态',
  dataIndex: 'statusName',
  key: 'statusName',
  width: 50
}, {
  title: '集单标记',
  dataIndex: 'flagName',
  key: 'flagName',
  width: 90
}, {
  title: '来源',
  dataIndex: 'requireSourceName',
  key: 'requireSourceName',
  width: 90,
  render: (t, r) => {
    if (r.requireSource === 11) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
        style: {
          color: 'red'
        }
      }, t);
    }

    return t;
  }
}, {
  title: '创建人',
  dataIndex: 'createUserName',
  key: 'createUserName',
  width: 100
}, {
  title: '创建时间',
  dataIndex: 'gmtCreate',
  key: 'gmtCreate',
  width: 170,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '提交时间',
  dataIndex: 'submitTime',
  key: 'submitTime',
  width: 170,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '提交人',
  dataIndex: 'submitUserName',
  key: 'submitUserName',
  width: 100
}];
var DETAIL_TABLE_COLUMNS = [{
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 90
}, {
  title: '商品条码',
  dataIndex: 'goodsBarCode',
  key: 'goodsBarCode',
  width: 100
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 100
}, {
  title: '单位',
  dataIndex: 'orderSpecificationUnit',
  key: 'orderSpecificationUnit',
  width: 130
}, {
  title: '单价',
  dataIndex: 'unitPrice',
  key: 'unitPrice',
  width: 130,
  render: (t, r) => isNaN(t) ? '' : t + "(\u5143/".concat(r === null || r === void 0 ? void 0 : r.basicUnit, ")")
}, {
  title: '申请数量',
  dataIndex: 'goodsReqQty',
  key: 'goodsReqQty',
  width: 130,
  render: (t, r) => isNaN(t) ? '' : t + "(".concat(r === null || r === void 0 ? void 0 : r.barCodeUnit, ")")
}, {
  title: '申请总金额',
  dataIndex: 'totalAmount',
  key: 'totalAmount',
  width: 130,
  render: t => isNaN(t) ? '' : t + '元'
}, {
  title: '今日已订货量',
  dataIndex: 'todayBuyCount',
  key: 'todayBuyCount',
  width: 130,
  render: (t, r, i, fn) => {
    if (t === '' || !t) {
      return '';
    } else {
      return t + "(".concat(r === null || r === void 0 ? void 0 : r.basicUnit, ")");
    }
  }
}, {
  title: '大仓库存量',
  dataIndex: 'dcStock',
  key: 'dcStock',
  width: 120,
  sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.dcStock) - (b === null || b === void 0 ? void 0 : b.dcStock),
  render: (t, r, i, fn) => {
    if ((r === null || r === void 0 ? void 0 : r.logisticName) !== '配送') {
      return '-';
    } else {
      if (t === '' || !t) {
        return '';
      } else {
        return t + "(".concat(r === null || r === void 0 ? void 0 : r.basicUnit, ")");
      }
    }
  }
}, // {
//   title: '昨日销量',
//   dataIndex: 'yestDaySaleCount',
//   key: 'yestDaySaleCount',
//   width: 130
// },
// {
//   title: '近7日销量',
//   dataIndex: 'last7DaySaleCount',
//   key: 'last7DaySaleCount',
//   width: 130
// },
// {
//   title: '可用库存',
//   dataIndex: 'stock',
//   key: 'stock',
//   width: 130
// },
// {
//   title: '在途库存',
//   dataIndex: 'onOrderStock',
//   key: 'onOrderStock',
//   width: 130
// },
{
  title: '集单标记',
  dataIndex: 'poolingFlag',
  key: 'poolingFlag',
  width: 130
}, {
  title: '品牌名称',
  dataIndex: 'brandName',
  key: 'brandName',
  width: 90
}, {
  title: '供应商编码',
  dataIndex: 'supplierCode',
  key: 'supplierCode',
  width: 100
}, {
  title: '供应商名称',
  dataIndex: 'supplierName',
  key: 'supplierName',
  width: 140
}, {
  title: '经营状态',
  dataIndex: 'businessStatusName',
  key: 'businessStatusName',
  width: 100
}, {
  title: '物流模式',
  dataIndex: 'logisticsName',
  key: 'logisticsName',
  width: 130
}, {
  title: '规格描述',
  dataIndex: 'specDesc',
  key: 'specDesc',
  width: 130
}, {
  title: '集单单号',
  dataIndex: 'poolingNo',
  key: 'poolingNo',
  width: 130,
  render: t => {
    if (t === '0' || t === null) {
      return '';
    }

    return t;
  }
}];
var DETAIL_TABLE_COLUMNS_NOT_TODAY = [{
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 90
}, {
  title: '商品条码',
  dataIndex: 'goodsBarCode',
  key: 'goodsBarCode',
  width: 100
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 100
}, {
  title: '单位',
  dataIndex: 'orderSpecificationUnit',
  key: 'orderSpecificationUnit',
  width: 130
}, {
  title: '单价',
  dataIndex: 'unitPrice',
  key: 'unitPrice',
  width: 130,
  render: (t, r) => isNaN(t) ? '' : t + "(\u5143/".concat(r === null || r === void 0 ? void 0 : r.basicUnit, ")")
}, {
  title: '申请数量',
  dataIndex: 'goodsReqQty',
  key: 'goodsReqQty',
  width: 130,
  render: (t, r) => isNaN(t) ? '' : t + "(".concat(r === null || r === void 0 ? void 0 : r.barCodeUnit, ")")
}, {
  title: '申请总金额',
  dataIndex: 'totalAmount',
  key: 'totalAmount',
  width: 130,
  render: t => isNaN(t) ? '' : t + '元'
}, {
  title: '大仓库存量',
  dataIndex: 'dcStock',
  key: 'dcStock',
  width: 120,
  sorter: (a, b) => (a === null || a === void 0 ? void 0 : a.dcStock) - (b === null || b === void 0 ? void 0 : b.dcStock),
  render: (t, r, i, fn) => {
    if ((r === null || r === void 0 ? void 0 : r.logisticName) !== '配送') {
      return '-';
    } else {
      if (t === '' || !t) {
        return '';
      } else {
        return t + "(".concat(r === null || r === void 0 ? void 0 : r.basicUnit, ")");
      }
    }
  }
}, {
  title: '集单标记',
  dataIndex: 'poolingFlag',
  key: 'poolingFlag',
  width: 130
}, {
  title: '品牌名称',
  dataIndex: 'brandName',
  key: 'brandName',
  width: 90
}, {
  title: '供应商编码',
  dataIndex: 'supplierCode',
  key: 'supplierCode',
  width: 100
}, {
  title: '供应商名称',
  dataIndex: 'supplierName',
  key: 'supplierName',
  width: 140
}, {
  title: '经营状态',
  dataIndex: 'businessStatusName',
  key: 'businessStatusName',
  width: 100
}, {
  title: '物流模式',
  dataIndex: 'logisticsName',
  key: 'logisticsName',
  width: 130
}, {
  title: '规格描述',
  dataIndex: 'specDesc',
  key: 'specDesc',
  width: 130
}, {
  title: '集单单号',
  dataIndex: 'poolingNo',
  key: 'poolingNo',
  width: 130,
  render: t => {
    if (t === '0' || t === null) {
      return '';
    }

    return t;
  }
}];
/**
 * 列表常量
 */

var BASE_MAP = [// 基础信息
['applyCode', ['补货申请单号', '']], // ['requireSourceName', ['补货分类', '']],
['statusName', ['状态', '']], ['remark', ['备注', '']], ['placeName', ['地点', '']], ['firstCategoryName', ['一级品类', '']], ['secondCategoryName', ['二级品类', '']], ['thirdCategoryName', ['三级品类', '']]];
var goodsBackModal = [{
  title: '商家名称',
  dataIndex: 'ffds',
  key: 'ffds',
  width: 140
}, {
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 140
}, {
  title: '商品条码',
  dataIndex: 'goodsBarCode',
  key: 'goodsBarCode',
  width: 140
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 140
}, {
  title: '大类名称',
  dataIndex: 'kmk',
  key: 'kmk',
  width: 140
}, {
  title: '品牌名称',
  dataIndex: 'crs',
  key: 'crs',
  width: 140
}, {
  title: '单位',
  dataIndex: 'njknd',
  key: 'njknd',
  width: 140
}, {
  title: '规格',
  dataIndex: 'jndsf',
  key: 'jndsf',
  width: 140
}];
/**
 * 字段字典
 */

var DICTIONARY = [{
  "key": "SupplierCategory",
  "configMap": {
    "1": "采购供应商",
    "2": "农户供应商"
  }
}];

/***/ }),

/***/ 65847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R$": function() { return /* binding */ QUERY_SHOP_LEVEL_LIST; },
/* harmony export */   "VS": function() { return /* binding */ SAVE_SHOP_LEVEL; },
/* harmony export */   "fN": function() { return /* binding */ DELETE_SHOP_LEVEL; },
/* harmony export */   "eC": function() { return /* binding */ SHOP_LEVEL_DETAIL; },
/* harmony export */   "RO": function() { return /* binding */ GROUP_PLACE_LIST; }
/* harmony export */ });
/**
 * 列表查询
 */
var QUERY_SHOP_LEVEL_LIST = 'purchase.require.queryShopLevelPage';
/**
 * 新增修改门店级别
 */

var SAVE_SHOP_LEVEL = 'purchase.require.saveOrModifyShopLevel';
/**
 * 删除门店
 */

var DELETE_SHOP_LEVEL = 'purchase.require.deleteShopLevel';
/**
 * 门店详情
 */

var SHOP_LEVEL_DETAIL = 'purchase.require.queryShopLevelDetail';
/**
 * 查询店群下门店
 */

var GROUP_PLACE_LIST = 'purchase.require.queryPlaceInfoList';

/***/ }),

/***/ 31965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34041);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2824);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46565);











var GoodsSearchSelect = props => {
  var form = props.form,
      initValue = props.initValue,
      _props$setGoodsSearch = props.setGoodsSearchSelectInitValue,
      setGoodsSearchSelectInitValue = _props$setGoodsSearch === void 0 ? () => {} : _props$setGoodsSearch,
      setCate2Id = props.setCate2Id,
      setWeightType = props.setWeightType;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState, 2),
      options = _useState2[0],
      setOptions = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState3, 2),
      dataArr = _useState4[0],
      setDataArr = _useState4[1];

  var request = lodash_debounce__WEBPACK_IMPORTED_MODULE_2___default()( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().mark(function _callee(value) {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              searchReq(value);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), 800);

  var searchReq = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().mark(function _callee2(value) {
      var _form$current;

      var merchantId, v, opArr;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              merchantId = (_form$current = form.current) === null || _form$current === void 0 ? void 0 : _form$current.getFieldValue("merchantId");

              if (merchantId) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", antd_es_message__WEBPACK_IMPORTED_MODULE_8__.default.warn("请先选择商家"));

            case 3:
              _context2.next = 5;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .YpRequest */ .XQ)("purchase.product.querySelectMerchantProductByCondition", {
                page: 1,
                size: 30,
                condition: {
                  queryCriteria: value,
                  merchantId: merchantId
                }
              });

            case 5:
              v = _context2.sent;

              if (v.success) {
                setDataArr(v.result.list);
                opArr = v.result.list.map(val => {
                  return {
                    label: val.goodsName,
                    value: val.goodsId
                  };
                });
                setOptions(opArr);
              }

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function searchReq(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var changeVal = val => {
    var _form$current2;

    (_form$current2 = form.current) === null || _form$current2 === void 0 ? void 0 : _form$current2.setFieldsValue({
      goodsId: val
    });
    setGoodsSearchSelectInitValue(val);
    dataArr.forEach(v => {
      if (val === (v === null || v === void 0 ? void 0 : v.goodsId)) {
        var _form$current3;

        (_form$current3 = form.current) === null || _form$current3 === void 0 ? void 0 : _form$current3.setFieldsValue({
          plu: v === null || v === void 0 ? void 0 : v.pluCode
        });
        setCate2Id(v === null || v === void 0 ? void 0 : v.cate2Id);
        setWeightType(v === null || v === void 0 ? void 0 : v.isWeigh);
      }
    });
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, {
    showSearch: true,
    filterOption: false,
    onSearch: request,
    onChange: changeVal,
    options: options,
    value: initValue
  });
};

/* harmony default export */ __webpack_exports__["default"] = (GoodsSearchSelect);

/***/ }),

/***/ 82457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ ODD_SUBMIT_PRODUCT; }
/* harmony export */ });
// 提交仓库补货
var ODD_SUBMIT_PRODUCT = 'purchase.require.submitRequiryWarehouseAutoPreprocess';

/***/ }),

/***/ 27229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_table_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66456);
/* harmony import */ var antd_es_table__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97423);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



/* harmony default export */ __webpack_exports__["Z"] = (props => {
  var collectList = props.collectList,
      loading = props.loading; // const [dataTabel, setDataTabel] = useState([])

  var columns = [{
    title: '供应商编码',
    width: 100,
    dataIndex: 'supplierCode',
    align: 'center'
  }, {
    title: '供应商名称',
    width: 100,
    dataIndex: 'supplierName',
    align: 'center'
  }, {
    title: '品牌',
    dataIndex: 'brandName',
    width: 100,
    align: 'center'
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    width: 100,
    align: 'center',
    render: text => {
      if (text > 0) {
        return text;
      } else {
        return null;
      }
    }
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    width: 100,
    align: 'center'
  }, {
    title: '商品种类',
    dataIndex: 'goodsKind',
    key: 'goodsKind',
    align: 'center',
    width: 100
  }, {
    title: '补货量合计',
    dataIndex: 'goodsAdviceTotalQty',
    width: 100,
    align: 'center'
  }, {
    title: '补货总金额合计',
    dataIndex: 'reqTotalAmount',
    key: 'reqTotalAmount',
    align: 'center',
    width: 100
  }, {
    title: '供应商起送金额',
    dataIndex: 'deliveryAmount',
    key: 'deliveryAmount',
    width: 100,
    align: 'center'
  }, {
    title: '起送金额差额',
    dataIndex: 'deliveryAmountDiff',
    width: 100,
    align: 'center',
    render: text => {
      console.log(text, '起订金额');

      if (Number(text) > 0) {
        return null;
      } else if (Number(text) < 0) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
          style: {
            color: '#d9363e'
          }
        }, Math.abs(Number(text)), " ");
      }
    }
  }, {
    title: '起订量',
    dataIndex: 'thresholdQty',
    width: 100,
    align: 'center'
  }, {
    title: '起订量差值',
    dataIndex: 'thresholdQtyDiff',
    width: 100,
    align: 'center',
    render: text => {
      if (Number(text) > 0) {
        return null;
      } else if (Number(text) < 0) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
          style: {
            color: '#d9363e'
          }
        }, Math.abs(Number(text)), " ");
      }
    }
  }, {
    title: '备注',
    width: 100,
    dataIndex: 'remark',
    align: 'center',
    render: (text, data, index) => {
      if (Number(data.deliveryAmountDiff) < 0) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
          style: {
            color: 'red'
          }
        }, text);
      } else {
        return text;
      }
    }
  }];
  return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_table__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
      columns: columns,
      dataSource: collectList,
      rowKey: item => "".concat(item.goodsBarCode) // scroll={{ x: 900, y: 500 }}
      ,
      pagination: false,
      loading: loading
    });
  }, [collectList, loading]);
});

/***/ }),

/***/ 76728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_table_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66456);
/* harmony import */ var antd_es_table__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(97423);
/* harmony import */ var antd_es_input_number_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77883);
/* harmony import */ var antd_es_input_number__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(39635);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34041);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3182);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57016);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48086);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24731);














/* harmony default export */ __webpack_exports__["Z"] = (props => {
  var collectList = props.collectList,
      storeData = props.storeData,
      orderNo = props.orderNo,
      getStorageRepairList = props.getStorageRepairList,
      disabled = props.disabled,
      setCollectList = props.setCollectList,
      loading = props.loading,
      setLoadingData = props.setLoadingData; // 仓库补货编辑

  var selectSupplier = (type, e, data) => {
    var id = data.id,
        supplierCode = data.supplierCode,
        supplierName = data.supplierName,
        requireApplySubmitQty = data.requireApplySubmitQty,
        unitPrice = data.unitPrice,
        submitUnitPrice = data.submitUnitPrice,
        requireApplySubmitCopies = data.requireApplySubmitCopies;
    var params;

    if (type == 'submitUnitPrice') {
      params = {
        orderNo: orderNo,
        detailId: id,
        suppCode: supplierCode,
        suppName: supplierName,
        requireApplySubmitQty: requireApplySubmitQty,
        requireApplySubmitCopies: requireApplySubmitCopies,
        unitPrice: Number(unitPrice),
        submitUnitPrice: e
      };
    } else {
      var _requireApplySubmitCopies = e.requireApplySubmitCopies,
          _requireApplySubmitQty = e.requireApplySubmitQty;
      params = {
        orderNo: orderNo,
        detailId: id,
        suppCode: supplierCode,
        suppName: supplierName,
        requireApplySubmitQty: Math.floor(Number(_requireApplySubmitQty) * 100) / 100,
        requireApplySubmitCopies: Math.floor(Number(_requireApplySubmitCopies) * 100) / 100,
        unitPrice: Number(unitPrice),
        submitUnitPrice: submitUnitPrice
      };
    }

    (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)('purchase.require.operateRequireWarehouseAutoPreprocessDetail', params).then(_ref => {
      var success = _ref.success,
          result = _ref.result;

      if (success) {
        // console.log(result, '修改问题')
        antd_es_message__WEBPACK_IMPORTED_MODULE_7__.default.success('修改成功');

        getStorageRepairList({}, true);
      } else {
        antd_es_message__WEBPACK_IMPORTED_MODULE_7__.default.error('修改失败');
      }
    });
  };

  var warning = data => {
    antd_es_modal__WEBPACK_IMPORTED_MODULE_8__/* .default.warning */ .Z.warning({
      title: '温馨提示',
      cancelText: '知道了',
      content: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(react__WEBPACK_IMPORTED_MODULE_5__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("p", null, "\u5546\u54C1\uFF1A", data.goodsName), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("p", null, "\u8981\u8D27\u6B65\u957F\uFF1A", data.orderStepSize), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("p", null, "\u5EFA\u8BAE\u8865\u8D27\u91CF\u9700\u8981\u662F\u8981\u8D27\u6B65\u957F\u7684\u500D\u6570"))
    });
  }; // 排序


  var sortFun = (0,react__WEBPACK_IMPORTED_MODULE_5__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee(pagination, filters, sorter, extra) {
      var paramData;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // console.log(sorter, '排序的数据')
              // setLoadingData(true)
              // const res: any = await ypRequest('purchase.require.queryWarehousesAutoRequirePreprocessDetail', {
              //   param: {
              //     orderBy: sorter.field,
              //     orderByType: sorter.order == 'ascend' ? 1 : 2
              //   }
              // })
              // if (res.success) {
              //   let data: any = JSON.parse(JSON.stringify(res.result.detailList))
              //   setCollectList(data)
              // }
              // setLoadingData(false)
              paramData = {
                orderBy: sorter.field,
                orderByType: sorter.order == 'ascend' ? 1 : 2
              };
              getStorageRepairList(paramData, true);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  var columns = [{
    title: '序号',
    align: 'center',
    width: 30,
    render: (text, data, index) => {
      return index + 1;
    }
  }, {
    title: '商品',
    width: 250,
    dataIndex: 'goodsId',
    render: (text, data) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("div", null, data.goodsName), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("div", null, "\u7F16\u7801\uFF1A", data.goodsId), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("div", null, "\u6761\u7801\uFF1A", data.goodsBarCode));
    }
  }, {
    title: '规格/单位',
    dataIndex: 'specUnit',
    key: 'specUnit',
    width: 120,
    align: 'center',
    render: (text, data) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement("div", null, "".concat(Number(data.specUnit), "/").concat(data.barCodeUnit));
    }
  }, {
    title: '供应商',
    sorter: true,
    width: 350,
    dataIndex: 'supplierName',
    align: 'center',
    render: (text, data, index) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z, {
        disabled: true,
        value: "".concat(data.supplierCode, "-").concat(data.supplierName),
        dropdownMatchSelectWidth: false,
        showSearch: true,
        filterOption: (input, option) => {
          var _option$label;

          return ((_option$label = option === null || option === void 0 ? void 0 : option.label) !== null && _option$label !== void 0 ? _option$label : '').toLowerCase().includes(input.toLowerCase());
        },
        options: [{
          value: "".concat(data.supplierCode, ",").concat(data.supplierName),
          label: "".concat(data.supplierCode, "- ").concat(data.supplierName)
        }]
      });
    }
  }, {
    title: 'DMS',
    width: 80,
    dataIndex: 'dms',
    align: 'center',
    render: (text, data, index) => {
      return "".concat(text).concat(data.barCodeUnit);
    }
  }, {
    title: '建议补货量',
    width: 100,
    dataIndex: 'goodsAdviceQty',
    sorter: true,
    align: 'center'
  }, {
    title: '确认补货量',
    width: 100,
    dataIndex: 'requireApplySubmitQty',
    sorter: true,
    align: 'center',
    render: (text, data, index) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_input_number__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
        value: Number(text),
        disabled: disabled,
        defaultValue: data.goodsAdviceQty ? Number(data.goodsAdviceQty) : 0,
        min: 0,
        step: "1",
        onBlur: e => {
          if (/(^[0-9]\d*$)/.test(e.target.value) || data.isWeigh == 2) {
            // multiple 确认件数 dataValue
            var requireApplySubmitCopies = Math.round(Number(e.target.value) / Number(data.orderStepSize));
            var requireApplySubmitQty = requireApplySubmitCopies * Number(data.orderStepSize);
            selectSupplier('submitQty', {
              requireApplySubmitCopies,
              requireApplySubmitQty
            }, data);
          } else {
            antd_es_message__WEBPACK_IMPORTED_MODULE_7__.default.error('请输入正整数');
          }
        }
      });
    }
  }, {
    title: '确认补货件数',
    width: 100,
    dataIndex: 'requireApplySubmitCopies',
    sorter: true,
    align: 'center',
    render: (text, data, index) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_input_number__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
        value: Number(text),
        disabled: disabled,
        defaultValue: data.requireApplySubmitCopies ? Number(data.requireApplySubmitCopies) : 0,
        min: 0,
        step: "1",
        onBlur: e => {
          if (/(^[0-9]\d*$)/.test(e.target.value) || data.isWeigh == 2) {
            // requireApplySubmitCopies 确认件数 requireApplySubmitQty  确认补货量
            var requireApplySubmitCopies = Math.round(Number(e.target.value));
            var requireApplySubmitQty = requireApplySubmitCopies * Number(data.orderStepSize);
            selectSupplier('submitQty', {
              requireApplySubmitCopies,
              requireApplySubmitQty
            }, data);
          } else {
            antd_es_message__WEBPACK_IMPORTED_MODULE_7__.default.error('请输入正整数');
          }
        }
      });
    }
  }, {
    title: '单价',
    width: 120,
    dataIndex: 'unitPrice',
    sorter: true,
    align: 'center',
    render: (text, data, index) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_input_number__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, {
        value: Number(data.submitUnitPrice) !== 0 ? Number(data.submitUnitPrice) : Number(text),
        disabled: disabled,
        defaultValue: Number(data.submitUnitPrice) !== 0 ? Number(data.submitUnitPrice) : Number(data.unitPrice),
        min: 0,
        step: "1",
        style: {
          color: Number(data.submitUnitPrice) !== Number(data.unitPrice) ? 'red' : 'black'
        },
        onBlur: e => {
          if (Number(e.target.value) > Number(data.unitPrice)) {
            antd_es_message__WEBPACK_IMPORTED_MODULE_7__.default.error("\u4FEE\u6539\u5931\u8D25\uFF0C\u4E0D\u5141\u8BB8\u8D85\u8FC7".concat(data.unitPrice, "\u5143"));
          } else if (Number(e.target.value) <= 0) {
            antd_es_message__WEBPACK_IMPORTED_MODULE_7__.default.error("\u4FEE\u6539\u5931\u8D25\uFF0C\u5355\u4EF7\u5FC5\u987B\u5927\u4E8E0\u5143");
          } else {
            selectSupplier('submitUnitPrice', e.target.value, data);
          }
        }
      });
    }
  }, {
    title: '总金额',
    width: 100,
    dataIndex: 'reqAmount',
    sorter: true,
    align: 'center'
  }, {
    title: '要货步长',
    width: 80,
    dataIndex: 'orderStepSize',
    sorter: true,
    align: 'center'
  }, {
    title: '预计送达日期',
    dataIndex: 'deliveryDate',
    sorter: true,
    width: 100,
    align: 'center',
    key: 'action'
  }, {
    title: '期初库存',
    width: 100,
    dataIndex: 'initInventory',
    sorter: true,
    align: 'center'
  }, {
    title: '在途库存',
    width: 100,
    dataIndex: 'intransitInventory',
    sorter: true,
    align: 'center'
  }, {
    title: '周转天数',
    width: 80,
    sorter: true,
    dataIndex: 'turnoverDays',
    align: 'center'
  }, {
    title: '预警周转天数',
    width: 80,
    sorter: true,
    dataIndex: 'preTurnoverDays',
    align: 'center'
  }];
  return (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(() => {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_5__.createElement(antd_es_table__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
      columns: columns,
      dataSource: collectList,
      rowKey: (item, index) => "".concat(index),
      scroll: {
        x: 1200,
        y: 700
      },
      pagination: false,
      onChange: sortFun,
      loading: loading
    });
  }, [collectList, columns, loading]);
});

/***/ }),

/***/ 87577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_row_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13062);
/* harmony import */ var antd_es_row__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71230);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(71577);
/* harmony import */ var antd_es_col_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89032);
/* harmony import */ var antd_es_col__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(15746);
/* harmony import */ var antd_es_tabs_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18106);
/* harmony import */ var antd_es_tabs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69584);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3182);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83987);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24731);
/* harmony import */ var _components_ExportModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83769);



















/* harmony default export */ __webpack_exports__["Z"] = (props => {
  var orderNo = props.orderNo,
      placeIdKey = props.placeIdKey,
      form = props.form,
      disabled = props.disabled,
      detailData = props.detailData,
      setDetail = props.setDetail;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState, 2),
      exportModal = _useState2[0],
      setExportModal = _useState2[1]; // 导出列表
  // const businessType = '18' // 导出的类型


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(22),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(_useState3, 2),
      businessType = _useState4[0],
      setBusinessType = _useState4[1]; // 导出


  var exportHandle = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(() => {
    // console.log(placeIdKey, 'placeIdKeyplaceIdKey')
    antd_es_modal__WEBPACK_IMPORTED_MODULE_10__/* .default.confirm */ .Z.confirm({
      title: '导出',
      icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z, null),
      content: '确认要导出吗',
      okText: '确认',
      cancelText: '取消',

      onOk() {
        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().mark(function _callee() {
          return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  try {
                    form.validateFields().then(value => {
                      var goodsKey = value.goodsKey,
                          isModify = value.isModify,
                          categoryIds = value.categoryIds;
                      var params = {
                        tenantId: 1,
                        orderNo: orderNo,
                        goodsKey
                      };
                      (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)('purchase.require.exportRequireWarehouseAutoPreprocessDetail', params).then(res => {
                        if (res.success) {
                          antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.success('操作成功');
                        }
                      });
                    });
                  } catch (error) {
                    antd_es_message__WEBPACK_IMPORTED_MODULE_14__.default.error(error);
                  }

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      }

    });
  }, [orderNo, placeIdKey]); // 导出列表关闭的回调

  var closeModalCallback = () => {
    setExportModal(false);
  };

  return (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(() => {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(react__WEBPACK_IMPORTED_MODULE_6__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_row__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z, {
      justify: "space-between",
      className: "exportImport"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, {
      span: 10
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_tabs__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z, {
      defaultActiveKey: detailData,
      style: {
        display: 'inline-block',
        height: '45px'
      },
      onChange: activeKey => {
        console.log(activeKey, 'activeKey');
        setDetail(activeKey);
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_tabs__WEBPACK_IMPORTED_MODULE_17__/* .default.TabPane */ .Z.TabPane, {
      tab: "\u5546\u54C1\u8BE6\u60C5",
      key: "0"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_tabs__WEBPACK_IMPORTED_MODULE_17__/* .default.TabPane */ .Z.TabPane, {
      tab: "\u4F9B\u5E94\u5546\u5408\u8BA1",
      key: "1"
    }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, {
      span: 4
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
      type: "primary",
      className: "leadingOut",
      style: {
        marginRight: disabled ? '12px' : '0px'
      },
      onClick: () => {
        exportHandle();
      }
    }, "\u5BFC\u51FA"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
      type: "primary",
      className: "exportList",
      onClick: () => {
        setExportModal(true);
      }
    }, "\u5BFC\u51FA\u5217\u8868"))), exportModal && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_6__.createElement(_components_ExportModal__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, {
      queryDataUrl: "purchase.export.getExportTaskList",
      businessType: businessType,
      closeModalCallback: closeModalCallback
    }));
  }, [exportModal, detailData]);
});

/***/ }),

/***/ 43313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(91896);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(71577);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(31097);
/* harmony import */ var antd_es_checkbox_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63185);
/* harmony import */ var antd_es_checkbox__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(9676);
/* harmony import */ var antd_es_row_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13062);
/* harmony import */ var antd_es_row__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(71230);
/* harmony import */ var antd_es_input_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47673);
/* harmony import */ var antd_es_input__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(4107);
/* harmony import */ var antd_es_col_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89032);
/* harmony import */ var antd_es_col__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(15746);
/* harmony import */ var antd_es_form_style__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9715);
/* harmony import */ var antd_es_form__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(35845);
/* harmony import */ var antd_es_cascader_style__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36877);
/* harmony import */ var antd_es_cascader__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(34366);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2824);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34041);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24731);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67294);

























var Option = antd_es_select__WEBPACK_IMPORTED_MODULE_11__/* .default.Option */ .Z.Option;
var layout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (props => {
  var orderNo = props.orderNo,
      storeData = props.storeData,
      form = props.form,
      getStorageRepairList = props.getStorageRepairList; // const categoryList = useCategoryWholeData(2) // 品类数据

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState, 2),
      categoryList = _useState2[0],
      setCategoryList = _useState2[1]; // 供应商的数据


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState3, 2),
      supplierList = _useState4[0],
      setSupplierList = _useState4[1]; // 供应商的数据


  (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(() => {
    supplierQuery();
    getCategory();
  }, [storeData]); // merchantId: storeData.merchantId
  // supplierCategory: 1,
  // businessMode: 1,
  // 供应商查询

  var supplierQuery = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().mark(function _callee(data) {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)('supplier.basicdata.querySupplierBaseInfoPage', {
                page: 1,
                size: 20,
                supplierStatus: 1,
                supplierName: data ? data : '',
                supplierCategory: 1
              });

            case 2:
              res = _context.sent;

              if (res.success) {
                setSupplierList(res.result.list);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function supplierQuery(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var categoryReplace = data => {
    data.map(item => {
      item.label = item.categoryName;
      item.value = item.categoryCode;

      if (item.childList.length > 0) {
        item.childList.map(itemData => {
          itemData.label = itemData.categoryName;
          itemData.value = itemData.categoryCode;

          if (itemData.childList.length > 0) {
            itemData.childList.map(item3 => {
              item3.label = item3.categoryName;
              item3.value = item3.categoryCode;

              if (item3.childList.length > 0) {
                item3.childList.map(item4 => {
                  item4.label = item4.categoryName;
                  item4.value = item4.categoryCode;
                });
              }

              item3.children = item3.childList;
            });
          }

          itemData.children = itemData.childList;
        });
        item.children = item.childList;
      }
    });
    return data;
  }; // 获取商品品类数据


  var getCategory = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().mark(function _callee2(data) {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)('kernel.console.CategoryQueryService.searchCategoryTree', {
                searchKey: data ? data : '',
                businessCode: 1
              });

            case 2:
              res = _context2.sent;

              if (res.success && res.result.childList.length > 0) {
                setCategoryList(categoryReplace(res.result.childList)); // console.log(categoryReplace(res.result.childList), '遍历数据')
              }

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getCategory(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return (0,react__WEBPACK_IMPORTED_MODULE_10__.useMemo)(() => {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)({}, layout, {
      form: form,
      className: "formstyle"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_row__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z, {
      gutter: 16
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
      span: 5
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_15__/* .default.Item */ .Z.Item, {
      label: "\u54C1\u7C7B",
      name: "category"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_cascader__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z, {
      options: categoryList,
      placeholder: "\u9009\u62E9\u54C1\u7C7B",
      changeOnSelect: true,
      style: {
        maxWidth: '250px'
      }
    }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
      span: 5
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_15__/* .default.Item */ .Z.Item, {
      label: "\u5546\u54C1\u67E5\u8BE2",
      name: "goodsKey"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
      placeholder: "\u5546\u54C1\u7F16\u7801/\u540D\u79F0/\u6761\u7801",
      style: {
        maxWidth: '250px'
      }
    }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
      span: 10
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_15__/* .default.Item */ .Z.Item, {
      label: "\u4F9B\u5E94\u5546",
      name: "supplierCode"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z, {
      showSearch: true,
      onSearch: value => {
        supplierQuery(value);
      },
      filterOption: false,
      placeholder: "\u8BF7\u9009\u4F9B\u5E94\u5546",
      notFoundContent: null,
      style: {
        maxWidth: '300px'
      }
    }, supplierList.map(item => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(Option, {
        key: item.supplierCode,
        value: item.supplierCode
      }, item.supplierCode, "-", item.supplierName);
    })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
      span: 4
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_15__/* .default.Item */ .Z.Item, {
      label: "\u5355\u53F7"
    }, orderNo))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_row__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z, {
      gutter: 16
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
      span: 6
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_15__/* .default.Item */ .Z.Item, {
      label: "\u5EFA\u8BAE\u8865\u8D27\u91CF",
      name: "goodsAdviceQtyFlag"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z, {
      style: {
        maxWidth: '220px'
      },
      defaultValue: "0"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(Option, {
      value: "0"
    }, "\u5168\u90E8"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(Option, {
      value: "1"
    }, "\u5927\u4E8E0"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(Option, {
      value: "2"
    }, "\u7B49\u4E8E0")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
      span: 6
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_15__/* .default.Item */ .Z.Item, {
      label: "\u662F\u5426\u4FEE\u6539",
      name: "queryCorrectDateFlag",
      valuePropName: "checked"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_checkbox__WEBPACK_IMPORTED_MODULE_21__/* .default */ .Z, null))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
      span: 6
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_15__/* .default.Item */ .Z.Item, {
      name: "hideZeroDetailFlag"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z, {
      style: {
        maxWidth: '220px'
      },
      defaultValue: "0"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(Option, {
      value: "0"
    }, "\u5168\u90E8"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(Option, {
      value: "1"
    }, "\u9690\u85CF0\u5EFA\u8BAE\u91CF"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(Option, {
      value: "2"
    }, "\u9690\u85CF0\u5BA1\u6838\u91CF")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
      span: 6
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_form__WEBPACK_IMPORTED_MODULE_15__/* .default.Item */ .Z.Item, {
      label: "\u5907\u6CE8"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_22__/* .default */ .Z, {
      title: storeData && storeData.remark,
      trigger: "click"
    }, storeData && storeData.remark ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement("a", null, "...") : null)))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_row__WEBPACK_IMPORTED_MODULE_17__/* .default */ .Z, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_18__/* .default */ .Z, {
      span: 4,
      offset: 19
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z, {
      type: "primary",
      onClick: () => {
        getStorageRepairList();
      },
      style: {
        marginRight: '15px'
      }
    }, "\u67E5\u8BE2"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_23__/* .default */ .Z, {
      onClick: () => {
        getStorageRepairList();
        form.resetFields();
      }
    }, "\u91CD\u7F6E"))));
  }, [orderNo, storeData, categoryList, supplierList, form]);
});

/***/ }),

/***/ 58576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMapping; }
/* harmony export */ });
/* unused harmony export renderOptionsByObj */
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24731);




/**
 * 全局枚举
 */


// 恶一些心的枚举数据结构，害
var arrEnums = new Map([[3, ['placeId', 'placeName']], [46, ['categoryId', 'categoryName']], [41, ['categoryId', 'categoryName']], [47, ['placeId', 'placeName']], [53, ['placeId', 'placeName']]]);
var enumsKeys = [...arrEnums.keys()]; // 将对象转为对象数组的形式

var renderOptionsByObj = (obj, num) => {
  if (!obj || typeof obj !== 'object') {
    return [];
  }

  return Object.keys(obj).map(v => {
    var value = isNaN(parseFloat(v)) ? v : parseFloat(v);

    if (enumsKeys.includes(num)) {
      try {
        var enums = arrEnums.get(num); // eslint-disable-next-line no-eval

        var labelData = eval("(".concat(obj[v], ")"));
        return {
          value: labelData[enums[0]],
          label: labelData[enums[1]],
          others: labelData
        };
      } catch (error) {
        console.log("\u89E3\u6790\u679A\u4E3E\u300C".concat(num, "\u300D\u5931\u8D25\uFF1A"), error);
      }
    }

    return {
      value,
      label: obj[v],
      others: v
    };
  });
};
/**
 * 获取全局枚举
 * @param type 获取的枚举类型
 */

function useMapping(type, p) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(new Map()),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState, 2),
      mapping = _useState2[0],
      setMapping = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(new Map()),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState3, 2),
      mappingList = _useState4[0],
      setMappingList = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var queryMappingData = /*#__PURE__*/function () {
      var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().mark(function _callee() {
        var params, res, maps, mappings, mappingsList;
        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  type: Array.isArray(type) ? type : [type]
                };

                if (p) {
                  params['ext'] = p;
                }

                _context.next = 4;
                return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z)('purchase.basis.mapping', params);

              case 4:
                res = _context.sent;
                maps = res.result.maps;

                if (maps) {
                  _context.next = 9;
                  break;
                }

                console.error('请求枚举失败：', res);
                return _context.abrupt("return");

              case 9:
                mappings = [];
                mappingsList = [];
                Object.entries(maps).forEach(val => {
                  var key = val[0]; // 枚举的键值，如：1，2，3，4

                  var value = val[1]; // 枚举的值，如：{1:xxx, 2: hhhh}
                  // 将键转为数字类型

                  var num = typeof key === 'string' ? parseInt(key) : key; // 判断是否存在，以及是否为字符串

                  var obj = value ? typeof value === 'string' ? JSON.parse(value) : {} : {};
                  var list = [];

                  if (num === 40) {
                    var str = obj.merchants;

                    try {
                      var arr = JSON.parse(str);
                      list = arr.map(v => ({
                        value: +v.merchantId,
                        label: v.merchantName,
                        others: v
                      }));
                    } catch (error) {
                      console.log('解析商户枚举失败：', error);
                    }
                  } else {
                    list = renderOptionsByObj(obj, num);
                  }

                  mappings.push([num, obj]); // 塞到枚举数组里

                  mappingsList.push([num, list]);
                });
                setMapping(new Map(mappings)); // message.info(json.s)

                setMappingList(new Map(mappingsList));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function queryMappingData() {
        return _ref.apply(this, arguments);
      };
    }();

    queryMappingData();
  }, []);
  return {
    mapping,
    mappingList
  };
}

/***/ }),

/***/ 91249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ purchaseResourceTokenApi; },
/* harmony export */   "b": function() { return /* binding */ EXPORT_ISSUE_REPAIR; }
/* harmony export */ });
var purchaseResourceTokenApi = 'scmconfig.resouce.getResourceToken'; // 导出问题修复

var EXPORT_ISSUE_REPAIR = 'purchase.requireApply.exportRequireDetailGoods';

/***/ }),

/***/ 69287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tr": function() { return /* binding */ REPLENISH_CONFIG; },
/* harmony export */   "xu": function() { return /* binding */ DEL_REPLENISH_CONFIG; },
/* harmony export */   "E_": function() { return /* binding */ CONFIG_LIST; },
/* harmony export */   "NN": function() { return /* binding */ DETAIL_REPLENISH; }
/* harmony export */ });
/* unused harmony export IMPORT_REPLENISH */
/**
 * API集合
 */
// 保存补货策略配置
var REPLENISH_CONFIG = 'purchase.requireApply.saveRequireApplyStrategy'; // 删除

var DEL_REPLENISH_CONFIG = 'purchase.requireApply.deleteRequireApplyStrategy'; // 配置列表

var CONFIG_LIST = 'purchase.requireApply.listRequireApplyStrategy'; // 导入模板

var IMPORT_REPLENISH = 'scmConfig.replenish.importReplenishGoods'; // 详情

var DETAIL_REPLENISH = 'purchase.requireApply.queryRequireApplyStrategy';

/***/ }),

/***/ 5249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BASE_MAP": function() { return /* binding */ BASE_MAP; },
/* harmony export */   "TABLE_COLUMNS": function() { return /* binding */ TABLE_COLUMNS; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31097);
/**
 * 业务常量
 */


var BASE_MAP = [// 基础信息
['merchantName', ['商家', '']], ['firstCategoryName', ['一级分类', '']], ['secondCategoryNames', ['二级分类', '']], ['placeGroupName', ['队形', '']], ['requireApplyTime', ['补货时间', '']]];
var TABLE_COLUMNS = [{
  title: '商家编码',
  dataIndex: 'merchantCode',
  key: 'merchantCode'
}, {
  title: '商家名称',
  dataIndex: 'merchantName',
  key: 'merchantName',
  ellipsis: true,
  render: text => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z, {
    title: text
  }, text)
}, {
  title: '队形',
  dataIndex: 'placeGroupName',
  key: 'placeGroupName'
}, {
  title: '一级品类',
  dataIndex: 'firstCategoryName',
  key: 'firstCategoryName'
}, {
  title: '二级品类',
  dataIndex: 'secondCategoryNames',
  key: 'secondCategoryNames',
  ellipsis: true,
  width: 200,
  render: text => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z, {
    title: text
  }, text)
}, {
  title: '自动出单时间',
  dataIndex: 'requireApplyTime',
  key: 'requireApplyTime'
}, {
  title: '创建人',
  dataIndex: 'createUserName',
  key: 'createUserName',
  width: 100
}, {
  title: '创建时间',
  dataIndex: 'gmtCreate',
  key: 'gmtCreate',
  width: 180
}, {
  title: '更新人',
  dataIndex: 'updateUserName',
  key: 'updateUserName',
  width: 80
}, {
  title: '更新时间',
  dataIndex: 'gmtModified',
  key: 'gmtModified',
  width: 180
}];

/***/ }),

/***/ 260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oZ": function() { return /* binding */ LOSS_RATE_DETAIL_API; },
/* harmony export */   "Q9": function() { return /* binding */ MERCHANT_GOODS_LIST; },
/* harmony export */   "mL": function() { return /* binding */ MERCHANT_NOPLACE_GOODS_LIST; },
/* harmony export */   "Y7": function() { return /* binding */ SAVE_GOODS; },
/* harmony export */   "_N": function() { return /* binding */ DELETE_GOODS; },
/* harmony export */   "E_": function() { return /* binding */ CONFIG_LIST; },
/* harmony export */   "pJ": function() { return /* binding */ IMPORT_REPLENISH; },
/* harmony export */   "NN": function() { return /* binding */ DETAIL_REPLENISH; },
/* harmony export */   "lg": function() { return /* binding */ DELETE_API; },
/* harmony export */   "lD": function() { return /* binding */ BATCH_SAVE_GOOGSCONFIG; },
/* harmony export */   "p5": function() { return /* binding */ REPLENISH_GOOGS_EXPORT; },
/* harmony export */   "rt": function() { return /* binding */ EXPORT_REPLENISH_GOOGS_DETAIL; }
/* harmony export */ });
/* unused harmony exports SAVE_LOSS_RATE_API, IMPORT_LOSS_API, LOSS_RATE_LIST_API, DOWNLOAD_TEMPLATE, LOSS_IMPORT_ORDER */
/**
 * API集合
 */
// 去损率保存
var SAVE_LOSS_RATE_API = 'purchase.basic.goodsWastageRateSave'; // 去损率导入

var IMPORT_LOSS_API = 'purchase.basic.importGoodsWastageRate'; // 去损率列表

var LOSS_RATE_LIST_API = 'purchase.basic.getGoodsWastageRatePage'; // 去损率详情

var LOSS_RATE_DETAIL_API = 'purchase.basic.getGoodsWastageRateDetail'; // 下载模板

var DOWNLOAD_TEMPLATE = 'purchase.downlaod.getTemplate'; // 商品去损率导入接口

var LOSS_IMPORT_ORDER = 'purchase.basic.importGoodsWastageRate'; // 地点维度查询商品

var MERCHANT_GOODS_LIST = 'purchase.product.querySelectPlaceProductByCondition'; // 商家纬度查询商品(仅选择商家未选择地点时使用)

var MERCHANT_NOPLACE_GOODS_LIST = 'purchase.product.queryMerchantProductByCondition'; // 保存商品

var SAVE_GOODS = 'scmConfig.replenish.saveGoodsConfig'; //删除商品

var DELETE_GOODS = 'scmConfig.replenish.deleteGoodsConfig'; // 配置商品列表

var CONFIG_LIST = 'scmConfig.replenish.replenishGoodsPage'; // 导入模板

var IMPORT_REPLENISH = 'scmConfig.replenish.importReplenishGoods'; //详情

var DETAIL_REPLENISH = 'scmConfig.replenish.replenishGoodsDetail';
/** 删除 */

var DELETE_API = 'scmConfig.replenish.deleteGoodsConfig';
var BATCH_SAVE_GOOGSCONFIG = 'scmConfig.replenish.batchSaveGoodsConfig'; // 未配置库存水位线商品导出

var REPLENISH_GOOGS_EXPORT = 'scmConfig.replenish.exportReplenishGoods'; // 水位线列表导出

var EXPORT_REPLENISH_GOOGS_DETAIL = 'scmConfig.replenish.exportReplenishGoodsDetail';

/***/ }),

/***/ 11141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SHOP_TYPE_MAP": function() { return /* binding */ SHOP_TYPE_MAP; },
/* harmony export */   "SHOP_TYPE_OPTIONS": function() { return /* binding */ SHOP_TYPE_OPTIONS; },
/* harmony export */   "DICTIONARY": function() { return /* binding */ DICTIONARY; },
/* harmony export */   "BASE_MAP": function() { return /* binding */ BASE_MAP; },
/* harmony export */   "MerchantFormColumn": function() { return /* binding */ MerchantFormColumn; },
/* harmony export */   "TABLE_COLUMNS": function() { return /* binding */ TABLE_COLUMNS; },
/* harmony export */   "limitNumber": function() { return /* binding */ limitNumber; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31097);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1870);




 // 字典

/** 门店模式 shopType */

var SHOP_TYPE_MAP = {
  1: '生鲜门店',
  2: '俭字牌',
  3: '批发部',
  4: '闪电仓',
  6: '中台虚拟店',
  7: '民生自助服务站',
  8: '谊品鲜'
};
var SHOP_TYPE_OPTIONS = Object.entries(SHOP_TYPE_MAP).map(_ref => {
  var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_ref, 2),
      value = _ref2[0],
      label = _ref2[1];

  return {
    value: Number(value),
    label
  };
});
var DICTIONARY = [{
  "key": "SupplierCategory",
  "configMap": {
    "1": "采购供应商",
    "2": "农户供应商"
  }
}]; // 字段名对应的映射
// https://wiki.ypsx-internal.com/pages/viewpage.action?pageId=31411559
// export const purchaseObj: any = {
//   billState: 9,
//   categoryCode: 4,
//   placeCode: 3,
//   orderType: 10,
//   isStraight: 43,
//   categoryCodeAll: 46,
//   firstCategoryId: 4, // 一级类目
//   secondCategoryId: 5, // 一级类目
//   placeId: 3, // 地点
//   merchantId: 40, // 商家/机构
//   logisticMode: 7 // 物流模式
// }

var BASE_MAP = [// int64 organizationId = 2; //机构id, 商家id
// string placeId = 3; //调出地id，all-全部
// string firstCategoryId = 4; //一级分类id，all-全部
// string secondCategoryId = 5; //二级分类id，all-全部
// int64 goodsId = 6; //商品编码
// int32 wastageRate = 7; // 基数类型，1-按单价、2-按金额
// string operator = 8; // 操作人
// 基础信息
['organizationCode', ['机构编码', '']], ['organizationName', ['机构', '']], ['placeName', ['地点', '']], ['firstCategoryName', ['一级品类', '']], ['secondCategoryName', ['二级品类', '']], ['wastageRate', ['商品损耗率(%)', '']], ['goodsName', ['商品名', '']], ['goodsId', ['商品编码', '']], ['operator', ['操作人', '']]];
var MerchantFormColumn = [{
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId'
}, {
  title: '商品条码',
  dataIndex: 'goodsBarCode',
  key: 'goodsBarCode',
  width: 140
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName'
}, {
  title: '二类',
  dataIndex: 'secondCategoryName',
  key: 'secondCategoryName'
}, {
  title: '品牌名称',
  dataIndex: 'brandName',
  key: 'brandName'
}, {
  title: '单位',
  dataIndex: 'orderSpecificationUnit',
  key: 'orderSpecificationUnit',
  width: 120
}, {
  title: '规格',
  dataIndex: 'orderSpecification',
  key: 'orderSpecification',
  width: 130
}, {
  title: '整散配',
  dataIndex: 'isBasicSpec',
  key: 'isBasicSpec',
  width: 80,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, t == '1' ? '散配' : t == '2' ? '整配' : '')
}];
var TABLE_COLUMNS = [{
  title: '商家',
  dataIndex: 'merchantName',
  key: 'merchantName',
  width: 130,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '地点编码',
  dataIndex: 'placeCode',
  key: 'placeCode',
  width: 130
}, {
  title: '门店模式',
  dataIndex: 'shopType',
  key: 'shopType',
  width: 120,
  render: t => {
    var _SHOP_TYPE_MAP$t;

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
      placement: "topLeft",
      title: SHOP_TYPE_MAP[t]
    }, (_SHOP_TYPE_MAP$t = SHOP_TYPE_MAP[t]) !== null && _SHOP_TYPE_MAP$t !== void 0 ? _SHOP_TYPE_MAP$t : '-');
  }
}, {
  title: '地点名称',
  dataIndex: 'placeName',
  key: 'placeName',
  width: 130,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '分类',
  key: 'firstCategoryName',
  width: 150,
  ellipsis: true,
  render: (t, r) => {
    var firstCategoryName = r.firstCategoryName,
        secondCategoryName = r.secondCategoryName,
        thirdCategoryName = r.thirdCategoryName,
        fourthCategoryName = r.fourthCategoryName;
    var text = [firstCategoryName, secondCategoryName, thirdCategoryName, fourthCategoryName].filter(i => i).join('/');
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
      placement: "leftTop",
      title: text
    }, text);
  }
}, {
  title: '商品编码',
  dataIndex: 'goodsId',
  key: 'goodsId',
  width: 130
}, {
  title: '商品条码',
  dataIndex: 'barCode',
  key: 'barCode',
  width: 135
}, {
  title: '商品名称',
  dataIndex: 'goodsName',
  key: 'goodsName',
  width: 188,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t) // render: (t:any) => dictionaryMatch(t, 'isPrePay', DICTIONARY, 'list')

}, {
  title: '整散配',
  dataIndex: 'isBasicSpec',
  key: 'isBasicSpec',
  width: 80,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, t == '1' ? '散配' : t == '2' ? '整配' : '')
}, {
  title: '上下限库存',
  key: 'stock',
  width: 100,
  render: (t, r) => {
    var _r$minStock = r.minStock,
        minStock = _r$minStock === void 0 ? 0 : _r$minStock,
        _r$maxStock = r.maxStock,
        maxStock = _r$maxStock === void 0 ? 0 : _r$maxStock;
    return minStock + '~' + maxStock;
  }
}, {
  title: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
    placement: "topLeft",
    title: "\u8FD130\u5929DMS*5-\u8FD130\u5929DMS*12"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, "\u5EFA\u8BAE\u4E0A\u9650\u91CF\u8303\u56F4"), " \xA0", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, null))),
  dataIndex: 'minDms',
  key: 'minDms',
  width: 180,
  render: (t, r) => {
    var _r$minDms = r.minDms,
        minDms = _r$minDms === void 0 ? 0 : _r$minDms,
        _r$maxDms = r.maxDms,
        maxDms = _r$maxDms === void 0 ? 0 : _r$maxDms;
    return minDms + '~' + maxDms;
  }
}, {
  title: '补货点量',
  dataIndex: 'needStock',
  key: 'needStock',
  width: 100
}, {
  title: '单位',
  dataIndex: 'specUnit',
  key: 'specUnit',
  width: 100
}, {
  title: '更新人',
  dataIndex: 'updateUserName',
  key: 'updateUserName',
  width: 70
}, {
  title: '更新时间',
  dataIndex: 'gmtModified',
  key: 'gmtModified',
  width: 180
}, {
  title: '基础条码步长',
  dataIndex: 'orderStepSize',
  key: 'orderStepSize',
  width: 100
}];
/* 限制数字输入框只能输入整数 */

var limitNumber = value => {
  // if (typeof value === 'string') {
  //   return !isNaN(Number(value)) ? value.replace(/^(0+)|[^\d]/g, '') : ''
  // } else if (typeof value === 'number') {
  //   return !isNaN(value) ? String(value).replace(/^(0+)|[^\d]/g, '') : ''
  // } else {
  //   return ''
  // }
  return String(value).replace(/^(0+)|[^\d]/g, '');
};

/***/ }),

/***/ 13748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71577);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90631);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24731);












function DownLoadBtnForExport(_ref) {
  var param = _ref.param;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      httpLoading = _useState2[0],
      sethttpLoading = _useState2[1];

  var timer = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();

  var queryHandle = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().mark(function _callee() {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              sethttpLoading(true);
              _context.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)('matrix.queryReportService.exportExcel', (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({}, param));

            case 3:
              res = _context.sent;

              if (res.success) {
                getResult(res.result);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function queryHandle() {
      return _ref2.apply(this, arguments);
    };
  }();

  var getResult = taskId => {
    (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)('matrix.queryReportService.getExportResult', {
      taskId
    }).then(res => {
      if (!res.success) {
        return antd_es_message__WEBPACK_IMPORTED_MODULE_8__.default.error(res.error || '下载失败');
      } // 正在生成


      if (res.result.state !== 2) {
        timer.current = setTimeout(() => {
          getResult(taskId);
        }, 2000);
      } else {
        /** 后端返回成功 */
        if (res.result.limited) {
          antd_es_message__WEBPACK_IMPORTED_MODULE_8__.default.warn('当前导出数据大于10万条');
        }

        window.open(res.result.result);
        sethttpLoading(false);
        clearTimeout(timer.current);
      }
    }).catch(() => {
      clearTimeout(timer.current);
    });
  }; // 


  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, {
    type: "primary",
    style: {
      marginBottom: 5
    },
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z, null),
    loading: httpLoading,
    onClick: queryHandle
  }, "\u5BFC\u51FA");
}

/* harmony default export */ __webpack_exports__["Z"] = (DownLoadBtnForExport);

/***/ }),

/***/ 69999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ reservationObj; }
/* harmony export */ });
var reservationObj = {
  billState: 39,
  appointmentType: 38,
  placeId: 3,
  queryPlaces: 84
};

/***/ }),

/***/ 57380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N3": function() { return /* binding */ RETREAT_LIST; },
/* harmony export */   "FH": function() { return /* binding */ RETREAT_QUERY_ORDER; },
/* harmony export */   "C1": function() { return /* binding */ RETREAT_SAVE; },
/* harmony export */   "dF": function() { return /* binding */ RETREAT_GOODS_LIST; },
/* harmony export */   "qO": function() { return /* binding */ RETREAT_GOODS_IMPORT; },
/* harmony export */   "MD": function() { return /* binding */ RETREAT_GOODS_BATCH_SAVE; },
/* harmony export */   "Op": function() { return /* binding */ RETREAT_GOODS_CLEAR; },
/* harmony export */   "M9": function() { return /* binding */ RETREAT_GOODS_SAVE; },
/* harmony export */   "Mc": function() { return /* binding */ RETREAT_GOODS_DELETE; },
/* harmony export */   "_s": function() { return /* binding */ RETREAT_SUBMIT; },
/* harmony export */   "L8": function() { return /* binding */ RETREAT_GOODS_LOGISTICS; },
/* harmony export */   "WA": function() { return /* binding */ RETREAT_FAIL_TOTAL; },
/* harmony export */   "eR": function() { return /* binding */ RETREAT_FAIL_DETAIL; },
/* harmony export */   "Su": function() { return /* binding */ RETREAT_CANCEL; },
/* harmony export */   "Tg": function() { return /* binding */ RETREAT_DOWNLOAD_TEMPLATE; },
/* harmony export */   "Z8": function() { return /* binding */ RETREAT_GOODS_SAVE_PROGRESS; },
/* harmony export */   "QB": function() { return /* binding */ RETREAT_EXPORT_TASK; },
/* harmony export */   "iK": function() { return /* binding */ AUDIT_ORDER; },
/* harmony export */   "XA": function() { return /* binding */ RETREAT_PURCHASE; },
/* harmony export */   "hA": function() { return /* binding */ RETREAT_TRANSFER; },
/* harmony export */   "Hc": function() { return /* binding */ ORDER_LINE_DETAIL_LIST; },
/* harmony export */   "mJ": function() { return /* binding */ ORDER_INFO; },
/* harmony export */   "kU": function() { return /* binding */ RETREAT_WAREHOUSE_LIST; },
/* harmony export */   "S$": function() { return /* binding */ RETREAT_WAREHOUSE_DELETE_BATCH; },
/* harmony export */   "Yw": function() { return /* binding */ RETREAT_WAREHOUSE_IMPORT; },
/* harmony export */   "Ok": function() { return /* binding */ RETREAT_WAREHOUSE_SAVE; },
/* harmony export */   "nE": function() { return /* binding */ RETREAT_WAREHOUSE_DETAIL; },
/* harmony export */   "b_": function() { return /* binding */ GET_RESOURCE_TOKEN; }
/* harmony export */ });
/* unused harmony exports RETREAT_ORDER, SUPLIER_CANCEL, RETREAT_WAREHOUSE_DELETE */
/**
 * 退供清退
 */
// 列表
var RETREAT_LIST = 'scm.revert.queryRevertOrderList'; // 生成请退单

var RETREAT_ORDER = 'scm.revert.getOrderIdByBizType'; // 取消

var SUPLIER_CANCEL = ''; // 获取请退单

var RETREAT_QUERY_ORDER = 'scm.revert.queryRevertOrder'; // 清退单创建

var RETREAT_SAVE = 'scm.revert.saveRevertOrder'; // 查询清退单明细

var RETREAT_GOODS_LIST = 'scm.revert.queryRevertOrderDetail'; // 清退单导入明细

var RETREAT_GOODS_IMPORT = 'scm.revert.importRevertOrderLine'; // 批量保存清退单明细

var RETREAT_GOODS_BATCH_SAVE = 'scm.revert.queryAndSaveRevertOrderDetailBatch'; // 清空清退单明细

var RETREAT_GOODS_CLEAR = 'scm.revert.cleanRevertOrderDetail'; // 保存清退单行明细

var RETREAT_GOODS_SAVE = 'scm.revert.saveRevertOrderLine'; // 删除行明细

var RETREAT_GOODS_DELETE = 'scm.revert.deleteRevertOrderLine'; // 提交

var RETREAT_SUBMIT = 'scm.revert.submitRevertOrder'; // 查询统计数据

var RETREAT_GOODS_LOGISTICS = 'scm.revert.queryRevertTotalInfo'; // 查询失败清退单总数量

var RETREAT_FAIL_TOTAL = 'scm.revert.queryRevertFailTotalInfo'; // 异常明细导出

var RETREAT_FAIL_DETAIL = 'scm.revert.exportFailRevertOrder'; // 取消

var RETREAT_CANCEL = 'scm.revert.cancelRevertOrder'; // 模板下载

var RETREAT_DOWNLOAD_TEMPLATE = 'scm.revert.downlaod.getTemplate'; // 查询保存商品清退的进度

var RETREAT_GOODS_SAVE_PROGRESS = 'scm.revert.queryRevertRateOfProgress'; // 查询导出任务的列表

var RETREAT_EXPORT_TASK = 'scm.revert.export.getExportTaskList'; // 批量审核

var AUDIT_ORDER = 'purchase.order.auditRepayingPurchaseOrder'; // 查询采购单列表

var RETREAT_PURCHASE = 'purchase.order.purchaseOrderList'; // 查询调拨单

var RETREAT_TRANSFER = 'scm.transfer.queryTransferOrderList'; // 采购单明细分页查询接口

var ORDER_LINE_DETAIL_LIST = 'purchase.order.purchaseOrderDetailPageInfo'; // 采购单主信息 详情

var ORDER_INFO = 'purchase.order.purchaseOrderInfo'; // 大仓清退配置列表

var RETREAT_WAREHOUSE_LIST = 'scm.revert.queryWarehouseRevertConfigList'; // 批量删除大仓预警配置

var RETREAT_WAREHOUSE_DELETE_BATCH = 'scm.revert.deleteBatchWarehouseRevertConfig'; // 删除大仓预警配置

var RETREAT_WAREHOUSE_DELETE = 'scm.revert.deleteWarehouseRevertConfig'; // 导入大仓预警配置

var RETREAT_WAREHOUSE_IMPORT = 'scm.revert.importWarehouseRevertConfig'; // 导入大仓预警配置

var RETREAT_WAREHOUSE_SAVE = 'scm.revert.saveWarehouseRevertConfig'; // 查询大仓预警配置详情

var RETREAT_WAREHOUSE_DETAIL = 'scm.revert.queryWarehouseRevertConfigDetail';
/**
 * 获取文件服务token
 */

var GET_RESOURCE_TOKEN = 'scm.revert.getResourceToken';

/***/ }),

/***/ 15055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34041);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




var WareHouseSelect = porps => {
  var _form$current2;

  var Option = antd_es_select__WEBPACK_IMPORTED_MODULE_2__/* .default.Option */ .Z.Option;
  var data = porps.data,
      form = porps.form;

  var renderOptions = () => {
    var ops = [];
    data.forEach(v => {
      var d = JSON.parse(v === null || v === void 0 ? void 0 : v.value);
      ops.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(Option, {
        value: (v === null || v === void 0 ? void 0 : v.key) + "-" + (d === null || d === void 0 ? void 0 : d.code) + "-" + (d === null || d === void 0 ? void 0 : d.name),
        key: v === null || v === void 0 ? void 0 : v.key
      }, d === null || d === void 0 ? void 0 : d.name));
    });
    return ops;
  };

  var change = (value, option) => {
    var _form$current;

    (_form$current = form.current) === null || _form$current === void 0 ? void 0 : _form$current.setFieldsValue({
      warehouseId: value
    });
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z, {
    showSearch: true,
    placeholder: '请输入仓库编码、名称',
    allowClear: true,
    value: (_form$current2 = form.current) === null || _form$current2 === void 0 ? void 0 : _form$current2.getFieldValue("warehouseId"),
    onChange: change
  }, renderOptions());
};

/* harmony default export */ __webpack_exports__["default"] = (WareHouseSelect);

/***/ }),

/***/ 97884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_input_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47673);
/* harmony import */ var antd_es_input__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4107);
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31097);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8870);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34041);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);











function CategorySelect(props) {
  var _props$firstProps = props.firstProps,
      firstProps = _props$firstProps === void 0 ? {} : _props$firstProps,
      _props$secondProps = props.secondProps,
      secondProps = _props$secondProps === void 0 ? {} : _props$secondProps,
      _props$categoryList = props.categoryList,
      categoryList = _props$categoryList === void 0 ? [] : _props$categoryList,
      formValue = props.formValue,
      onChange = props.onChange;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      secondOptions = _useState2[0],
      setSecondOptions = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState3, 2),
      thirdOptions = _useState4[0],
      setThirdOptions = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState5, 2),
      secondList = _useState6[0],
      setSecondList = _useState6[1];

  var Option = antd_es_select__WEBPACK_IMPORTED_MODULE_5__/* .default.Option */ .Z.Option;

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(formValue),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState7, 2),
      fieldValue = _useState8[0],
      setFieldValue = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}),
      _useState10 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState9, 2),
      tipsValue = _useState10[0],
      setTipsValue = _useState10[1]; // useEffect(() => {
  // setSecondOptions([])
  // setThirdOptions([])
  // setSecondList([])
  // }, [categoryList])
  // useEffect(() => {
  //   if (formValue) {
  //     setFieldValue(formValue)
  //   }
  // }, [formValue])


  var changeFirstSelect = (value, option) => {
    setFieldValue(v => ({
      first: value,
      second: undefined,
      third: undefined
    }));
    console.log(value, option);
    setTipsValue(v => ({
      first: option === null || option === void 0 ? void 0 : option.children,
      second: undefined,
      third: undefined
    }));

    if (onChange) {
      onChange({
        first: value,
        second: undefined,
        third: undefined
      });
    }

    var firstValueTmp = value;

    if (!firstValueTmp || !categoryList.length) {
      return;
    }

    try {
      // 二级的下拉数据
      var _ref = categoryList && categoryList.find(v => v.value === firstValueTmp) || {},
          others = _ref.others;

      if (!(others !== null && others !== void 0 && others.childCategoryList)) {
        setSecondOptions([]);
      }

      setSecondList(others === null || others === void 0 ? void 0 : others.childCategoryList);
      var list = Object.values(others === null || others === void 0 ? void 0 : others.childCategoryList).map(v => ({
        value: v.categoryId,
        label: v.categoryName
      }));
      setSecondOptions(list);
    } catch (error) {
      console.log(error);
    }

    setThirdOptions([]);
  };

  var changeSecondSelect = (secondValue, option) => {
    setFieldValue(v => ({
      first: v === null || v === void 0 ? void 0 : v.first,
      second: secondValue,
      third: undefined
    }));
    setTipsValue(v => ({
      first: v.first,
      second: option === null || option === void 0 ? void 0 : option.children,
      third: undefined
    }));

    if (onChange) {
      var _value = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)({}, fieldValue), {}, {
        second: secondValue,
        third: undefined
      });

      onChange(_value);
    }

    var secondValueTmp = secondValue;

    if (!secondValueTmp || !secondList || !secondList[+secondValue]) {
      setThirdOptions([]);
      return;
    }

    try {
      var _secondList$secondVal;

      // 三级的下拉数据
      var list = Object.values((_secondList$secondVal = secondList[+secondValue]) === null || _secondList$secondVal === void 0 ? void 0 : _secondList$secondVal.childCategoryList).map(v => ({
        value: v.categoryId,
        label: v.categoryName
      }));
      setThirdOptions(list);
    } catch (error) {
      console.log(error);
    }
  };

  var changeThirdSelect = (thirdValue, option) => {
    setFieldValue(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)({}, v), {}, {
      third: thirdValue
    }));
    setTipsValue(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)({}, v), {}, {
      third: option === null || option === void 0 ? void 0 : option.children
    }));

    if (onChange) {
      var _value2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)({}, fieldValue), {}, {
        third: thirdValue
      });

      onChange(_value2);
    }
  };

  var renderOptions = dataSource => {
    if (dataSource && dataSource.length > 0) {
      return dataSource.map(v => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(Option, {
        value: v.value,
        key: v.value,
        rows: v
      }, v.label));
    }

    return null;
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_7__/* .default.Group */ .Z.Group, {
    compact: true
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, {
    title: tipsValue.first
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({
    placeholder: "\u4E00\u7EA7",
    dropdownMatchSelectWidth: false,
    showSearch: true,
    allowClear: true,
    optionFilterProp: "children",
    optionLabelProp: "children",
    style: {
      width: '33%'
    },
    onChange: changeFirstSelect,
    value: fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.first
  }, firstProps), renderOptions(categoryList))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, {
    title: tipsValue.second
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({
    placeholder: "\u4E8C\u7EA7",
    dropdownMatchSelectWidth: false,
    showSearch: true,
    allowClear: true,
    value: fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.second // filterOption={false}
    ,
    optionFilterProp: "children",
    optionLabelProp: "children",
    style: {
      width: '33%'
    },
    onChange: changeSecondSelect
  }, secondProps), renderOptions(secondOptions))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, {
    title: tipsValue.third
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({
    placeholder: "\u4E09\u7EA7",
    dropdownMatchSelectWidth: false,
    showSearch: true,
    allowClear: true,
    value: fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.third // filterOption={false}
    ,
    optionFilterProp: "children",
    optionLabelProp: "children",
    style: {
      width: '33%'
    },
    onChange: changeThirdSelect
  }, secondProps), renderOptions(thirdOptions))));
}

/* harmony default export */ __webpack_exports__["default"] = (CategorySelect);

/***/ }),

/***/ 68870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_row_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13062);
/* harmony import */ var antd_es_row__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71230);
/* harmony import */ var antd_es_col_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89032);
/* harmony import */ var antd_es_col__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15746);
/* harmony import */ var antd_es_input_number_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77883);
/* harmony import */ var antd_es_input_number__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39635);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);










function DayRanagerSelect(props) {
  var onChange = props.onChange;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      minVal2 = _useState2[0],
      setMinVal = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(undefined),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState3, 2),
      val1 = _useState4[0],
      setVal1 = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(undefined),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState5, 2),
      val2 = _useState6[0],
      setVal2 = _useState6[1];

  var valChange1 = val => {
    setMinVal(val);
    setVal1(val);
  };

  var valChange2 = val => {
    setVal2(val);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (onChange) {
      onChange({
        start: val1,
        end: val2
      });
    }
  }, [val1, val2]);
  var divStyle = {
    height: "1px",
    backgroundColor: "#44014C"
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_row__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    gutter: 12,
    align: "middle",
    className: "aa"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    span: 8
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_input_number__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
    min: 1,
    max: 100000,
    onChange: valChange1,
    style: {
      width: "100%"
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    span: 8
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
    style: divStyle
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_col__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    span: 8
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_input_number__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
    min: minVal2 + 1,
    max: 100000,
    onChange: valChange2,
    style: {
      width: "100%"
    }
  })));
}

/* harmony default export */ __webpack_exports__["default"] = (DayRanagerSelect);

/***/ }),

/***/ 85029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57016);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71577);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48086);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46565);







/**
 * 查看导出结果浮层
 */



function ExportList(props) {
  var businessType = props.businessType;
  var table = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);

  var downloadFile = url => {
    if (!url) {
      antd_es_message__WEBPACK_IMPORTED_MODULE_5__.default.error('不存在文件');

      return;
    }

    window.location.href = url;
  };

  var columns = [{
    title: '文件名称',
    dataIndex: 'fileName',
    width: 160
  }, {
    title: '导出时间',
    dataIndex: 'exportTime',
    width: 140
  }, {
    title: '状态',
    dataIndex: 'statusName',
    width: 100
  }, {
    title: '操作人',
    dataIndex: 'creator',
    width: 120
  }, {
    title: '操作',
    dataIndex: 'operateeee',
    width: 100,
    render: (_, r) => {
      return r.status === 8 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("a", {
        onClick: () => downloadFile(r.downloadUrl)
      }, "\u4E0B\u8F7D") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("a", {
        onClick: () => {
          var _table$current;

          return (_table$current = table.current) === null || _table$current === void 0 ? void 0 : _table$current.reload();
        }
      }, "\u5237\u65B0");
    }
  }];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    title: "\u67E5\u770B\u5BFC\u51FA\u7ED3\u679C",
    destroyOnClose: true,
    maskClosable: false,
    width: 800,
    visible: true,
    onOk: props.closeModalCallback,
    onCancel: props.closeModalCallback,
    footer: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
      onClick: props.closeModalCallback
    }, "\u5173\u95ED")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .EnhanceTable */ .UO, {
    tableRef: table,
    columns: columns,
    requestUrl: "scm.revert.export.getExportTaskList",
    searchParams: {
      "page": "1",
      "size": "20",
      "businessType": businessType
    }
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (ExportList);

/***/ }),

/***/ 98577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ SupplierMap; }
/* harmony export */ });
// 字段名对应的映射
var SupplierMap;

(function (SupplierMap) {
  SupplierMap[SupplierMap["CATEGORY"] = 41] = "CATEGORY";
  SupplierMap[SupplierMap["WAREHOUSECATEGORY"] = 46] = "WAREHOUSECATEGORY";
  SupplierMap[SupplierMap["MERCHANT"] = 40] = "MERCHANT";
  SupplierMap[SupplierMap["PLACE"] = 3] = "PLACE";
  SupplierMap[SupplierMap["TRANSFER_BILLSTATE"] = 35] = "TRANSFER_BILLSTATE";
})(SupplierMap || (SupplierMap = {}));

/***/ }),

/***/ 193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71577);
/* harmony import */ var antd_es_input_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47673);
/* harmony import */ var antd_es_input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4107);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2824);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76570);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46565);
/* harmony import */ var _pages_CentralManage_components_useCategory3__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80248);










var SearchInfo = (props, ref) => {
  var requestUrl = props.requestUrl,
      requestParams = props.requestParams,
      handleSearchCallback = props.handleSearchCallback; // 统计数据

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState, 2),
      logistics = _useState2[0],
      setLogistics = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState3, 2),
      codeValue = _useState4[0],
      setCodeValue = _useState4[1]; //  1.生鲜 2.快消


  var _useCategory = (0,_pages_CentralManage_components_useCategory3__WEBPACK_IMPORTED_MODULE_4__/* .useCategory3 */ .eT)({
    filterCates: (0,_pages_CentralManage_components_useCategory3__WEBPACK_IMPORTED_MODULE_4__/* .categoryFilter */ .s6)(2)
  }),
      _useCategory2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useCategory, 2),
      categoryNode = _useCategory2[0],
      categoryData = _useCategory2[1].category3; // 获取统计数据


  var queryLogisticsData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(() => {
    (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_3__/* .YpRequest */ .XQ)(requestUrl, requestParams).then(v => {
      if (v.success) {
        var _v$result = v.result,
            storeCount = _v$result.storeCount,
            skuCount = _v$result.skuCount,
            totalQty = _v$result.totalQty,
            totalAmount = _v$result.totalAmount;
        setLogistics({
          storeCount,
          skuCount,
          totalQty,
          totalAmount
        });
      }
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var handleSearch = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(() => {
    var firstCategoryId = categoryData.firstCategoryId,
        secondCategoryIds = categoryData.secondCategoryIds,
        thirdCategoryIds = categoryData.thirdCategoryIds;
    var params = {
      firstCategoryIds: firstCategoryId ? [firstCategoryId] : undefined,
      secondCategoryIds,
      thirdCategoryIds,
      goodsKey: codeValue
    };
    return handleSearchCallback(params);
  }, [categoryData, codeValue, handleSearchCallback]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    queryLogisticsData();
  }, [queryLogisticsData]);
  /**
   * 暴露出来的 ref 方法
   */

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useImperativeHandle)(ref, () => ({
    queryLogisticsData
  }), [queryLogisticsData]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    className: "d-flex mTop16"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    style: {
      width: '50%'
    },
    className: "mRight16"
  }, categoryNode), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    placeholder: "\u54C1\u540D/\u7F16\u7801/\u6761\u7801/PLU\u7801",
    className: "mBottom16 mRight16",
    value: codeValue,
    onChange: v => setCodeValue(v.target.value),
    style: {
      width: 200
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, null),
    onClick: handleSearch,
    type: "primary"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    className: "mBottom16 alignRight"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", null, "\u95E8\u5E97\uFF1A", (logistics === null || logistics === void 0 ? void 0 : logistics.storeCount) || '-'), " \u2003", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", null, "\u79CD\u7C7B\uFF1A", (logistics === null || logistics === void 0 ? void 0 : logistics.skuCount) || '-'), "\u2003", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", null, "\u603B\u6570\u91CF\uFF1A", (logistics === null || logistics === void 0 ? void 0 : logistics.totalQty) || '-'), "\u2003", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", null, "\u603B\u91D1\u989D\uFF1A", (logistics === null || logistics === void 0 ? void 0 : logistics.totalAmount) || '-', "\u5143")));
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(SearchInfo));

/***/ }),

/***/ 16021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46565);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57380);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);







function useOrderInfo(revertOrderNo, pageId, autoFormRef) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState, 2),
      formData = _useState2[0],
      setFormData = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (revertOrderNo && pageId) {
      setLoading(true);
      (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_1__/* .YpRequest */ .XQ)(_Api__WEBPACK_IMPORTED_MODULE_4__/* .RETREAT_QUERY_ORDER */ .FH, {
        revertOrderNo
      }).then(v => {
        if (v.success) {
          var _v$result = v.result,
              id = _v$result.id,
              bizType = _v$result.bizType,
              cutOffDate = _v$result.cutOffDate,
              effectiveDate = _v$result.effectiveDate,
              requireSource = _v$result.requireSource,
              merchantId = _v$result.merchantId,
              remark = _v$result.remark;
          var fieldData = {
            id,
            bizType,
            cutOffDate: cutOffDate ? moment__WEBPACK_IMPORTED_MODULE_2___default()(cutOffDate) : cutOffDate,
            effectiveDate: effectiveDate ? moment__WEBPACK_IMPORTED_MODULE_2___default()(effectiveDate) : effectiveDate,
            requireSource,
            merchantId: merchantId ? Number(merchantId) : merchantId,
            remark,
            revertOrderNo
          };
          autoFormRef === null || autoFormRef === void 0 ? void 0 : autoFormRef.current.handleReviewData(fieldData);
          setFormData((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)({}, v.result), fieldData));
        }
      }).finally(() => {
        setLoading(false);
      });
    }
  }, [revertOrderNo, pageId]);
  return [formData, loading];
}

/* harmony default export */ __webpack_exports__["Z"] = (useOrderInfo);

/***/ }),

/***/ 33913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ getMappingFive; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46565);






// function requestInstance(props: UseRetreatMappingProps) {
//   return YpRequest('scm.revert.mapping', { type: props.type, ext: props.ext }).then((v: ResponstResult) => {
//     if (v.success) {
//       const { list } = v.result
//       return list.map((v: DataListType) => ({ label: v.value, value: +v.key }))
//     }
//   })
// }
function useRetreatMapping(props) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState, 2),
      mappingList = _useState2[0],
      setMappingList = _useState2[1];

  var requestInstance = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(props => {
    return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_1__/* .YpRequest */ .XQ)('scm.revert.mapping', {
      type: props.type,
      ext: props.ext
    }).then(v => {
      if (v.success) {
        var list = v.result.list;
        return list.map(v => ({
          label: v.value,
          value: +v.key
        }));
      }
    });
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (props !== null && props !== void 0 && props.type) {
      requestInstance({
        type: props === null || props === void 0 ? void 0 : props.type,
        ext: props === null || props === void 0 ? void 0 : props.ext
      }).then(v => {
        setMappingList(v);
      });
    }
  }, [props === null || props === void 0 ? void 0 : props.type, props === null || props === void 0 ? void 0 : props.ext, requestInstance]);
  return [mappingList, requestInstance];
}
/**
 * 获取枚举5
 * @param ext 额外参数
 * @returns
 */


function getMappingFive(_x) {
  return _getMappingFive.apply(this, arguments);
}

function _getMappingFive() {
  _getMappingFive = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().mark(function _callee(ext) {
    var result, list, data;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_1__/* .YpRequest */ .XQ)('scm.revert.mapping', {
              type: 5,
              ext
            });

          case 2:
            result = _context.sent;
            list = result.result.list;
            data = list.map(v => {
              var item = JSON.parse(v.value);
              return {
                value: item.placeId,
                label: "".concat(item.placeCode, "-").concat(item.placeName),
                others: item
              };
            });
            return _context.abrupt("return", data);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getMappingFive.apply(this, arguments);
}

/* harmony default export */ __webpack_exports__["Z"] = (useRetreatMapping);

/***/ }),

/***/ 81039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91896);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46565);










var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 4
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 18
    }
  }
};

function PriceModal(props) {
  var params = props.params,
      closeModalCallback = props.closeModalCallback;
  var formRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  var saveModal = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee() {
    var _formRef$current;

    var values, res;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (_formRef$current = formRef.current) === null || _formRef$current === void 0 ? void 0 : _formRef$current.validateFields();

          case 2:
            values = _context.sent;
            _context.next = 5;
            return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_3__/* .YpRequest */ .XQ)('scm.revert.batchModifyUnitPrice', (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)({}, values), {}, {
              condition: params
            }));

          case 5:
            res = _context.sent;

            if (res.success) {
              antd_es_message__WEBPACK_IMPORTED_MODULE_7__.default.success('修改成功');

              closeModalCallback(true);
            }

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [params, closeModalCallback]);
  var formfields = [{
    label: '商品',
    name: 'goodsId',
    type: 'INPUT',
    required: true
  }, {
    label: '单价(元)',
    name: 'unitPrice',
    type: 'INPUT',
    required: true
  }];
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    console.log(params);

    if (params.goodsIds) {
      var _formRef$current2;

      (_formRef$current2 = formRef.current) === null || _formRef$current2 === void 0 ? void 0 : _formRef$current2.setFieldsValue({
        goodsId: params.goodsIds
      });
    }
  }, [params]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z, {
    title: "\u5546\u54C1\u9009\u62E9",
    destroyOnClose: true,
    maskClosable: false,
    width: 500,
    closable: true,
    visible: true,
    onCancel: closeModalCallback,
    onOk: saveModal
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_3__/* .FormBuilder */ .qu, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)({}, defaultFormItemLayout, {
    formRef: formRef,
    elements: formfields,
    notSearchForm: true
  })));
}

/* harmony default export */ __webpack_exports__["default"] = (PriceModal);

/***/ }),

/***/ 62943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8870);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71577);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48086);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46565);








/**
 * 查看导出结果浮层
 */



function ExportList(props) {
  var businessType = props.businessType,
      listExport = props.listExport;
  var table = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);

  var downloadFile = url => {
    if (!url) {
      antd_es_message__WEBPACK_IMPORTED_MODULE_5__.default.error('不存在文件');

      return;
    }

    window.location.href = url;
  };

  var columns = [{
    title: '文件名称',
    dataIndex: 'fileName',
    width: 160
  }, {
    title: '导出时间',
    dataIndex: 'exportTime',
    width: 140
  }, {
    title: '状态',
    dataIndex: 'statusName',
    width: 100
  }, {
    title: '操作人',
    dataIndex: 'creator',
    width: 120
  }, {
    title: '操作',
    dataIndex: 'operateeee',
    width: 100,
    render: (_, r) => {
      return r.status === 8 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("a", {
        onClick: () => downloadFile(r.downloadUrl)
      }, "\u4E0B\u8F7D") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("a", {
        onClick: () => {
          var _table$current;

          return (_table$current = table.current) === null || _table$current === void 0 ? void 0 : _table$current.reload();
        }
      }, "\u5237\u65B0");
    }
  }];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    title: "\u67E5\u770B\u5BFC\u51FA\u7ED3\u679C",
    destroyOnClose: true,
    maskClosable: false,
    width: 800,
    visible: true,
    onOk: props.closeModalCallback,
    onCancel: props.closeModalCallback,
    footer: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
      onClick: props.closeModalCallback
    }, "\u5173\u95ED")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(yp_frontend_library__WEBPACK_IMPORTED_MODULE_4__/* .EnhanceTable */ .UO, {
    tableRef: table,
    columns: columns,
    requestUrl: 'scm.revert.export.getExportTaskList',
    searchParams: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)({
      page: '1',
      size: '20',
      businessType: businessType
    }, listExport)
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (ExportList);

/***/ }),

/***/ 79266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ReturnsManage_BasePool; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/tabs/style/index.js
var style = __webpack_require__(18106);
// EXTERNAL MODULE: ./node_modules/antd/es/tabs/index.js + 32 modules
var tabs = __webpack_require__(69584);
// EXTERNAL MODULE: ./node_modules/antd/es/space/style/index.js
var space_style = __webpack_require__(49111);
// EXTERNAL MODULE: ./node_modules/antd/es/space/index.js + 1 modules
var space = __webpack_require__(19650);
// EXTERNAL MODULE: ./node_modules/antd/es/button/style/index.js
var button_style = __webpack_require__(57663);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/input/style/index.js
var input_style = __webpack_require__(47673);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 3 modules
var input = __webpack_require__(4107);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 1 modules
var regeneratorRuntime = __webpack_require__(90636);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/index.js
var message_style = __webpack_require__(34792);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(48086);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3182);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/style/index.js
var modal_style = __webpack_require__(71194);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(57016);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectSpread2.js + 1 modules
var objectSpread2 = __webpack_require__(8870);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(93224);
// EXTERNAL MODULE: ./node_modules/@umijs/babel-preset-umi/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(2824);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/yp-frontend-library/esm/index.js + 77 modules
var esm = __webpack_require__(46565);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/hooks/useCategoryWholeData.ts
var useCategoryWholeData = __webpack_require__(61982);
// EXTERNAL MODULE: ./src/hooks/useMapping.ts
var useMapping = __webpack_require__(7704);
// EXTERNAL MODULE: ./src/hooks/useSupplier.tsx
var useSupplier = __webpack_require__(53658);
;// CONCATENATED MODULE: ./src/pages/ReturnsManage/BasePool/api.ts
/** 退仓池退供池查询接口 */
var POOL_LIST = 'scm.revert.queryRequireReturnPoolList';
/** 批量审核 */

var BATCH_APPROVE = 'scm.revert.batchApproveReturnPool';
/** 保存行 */

var SAVE_TABLE_LINE = 'scm.revert.saveRequireReturnPoolLine';
/** 统计信息 */

var STAT_DATA = 'scm.revert.statRequireReturnPool';
/** 申请单列表 */

var APPLY_CODE_LIST = 'scm.revert.queryReturnApplyCodeList';
;// CONCATENATED MODULE: ./src/pages/ReturnsManage/BasePool/returnReasonOptions.ts


/**
 * 退货原因业务展示顺序（与 scm-revert ReturnReasonEnum.displayOrdered 对齐）
 * MappingKey=12 可能缺项或乱序时，按此顺序重排并补齐 label
 */
var RETURN_REASON_DISPLAY_ORDER = [{
  value: 1,
  label: '高库存'
}, {
  value: 7,
  label: '破损'
}, {
  value: 6,
  label: '日期过半'
}, {
  value: 8,
  label: '新开店首批退货'
}, {
  value: 2,
  label: '供应商撤场'
}, {
  value: 3,
  label: '销售差'
}, {
  value: 5,
  label: '收货差异'
}, {
  value: 4,
  label: '其他'
}];
function sortReturnReasonOptions() {
  var mappingList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var map = new Map((mappingList || []).map(item => [Number(item.value), item]));
  return RETURN_REASON_DISPLAY_ORDER.map(item => {
    var hit = map.get(item.value);

    if (hit) {
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, hit), {}, {
        label: hit.label || item.label,
        value: item.value
      });
    }

    return {
      value: item.value,
      label: item.label
    };
  });
}
;// CONCATENATED MODULE: ./src/pages/ReturnsManage/BasePool/useFormfields.ts




/**
 * 采购分配单-列表-搜索条件
 */








function useFormfields(formRef, returnType, status) {
  var _useMapping = (0,useMapping/* default */.Z)([useMapping/* MappingKey.权限下的商家 */.M["权限下的商家"], useMapping/* MappingKey.权限下的店群信息 */.M["权限下的店群信息"], useMapping/* MappingKey.权限下的地点 */.M["权限下的地点"], useMapping/* MappingKey.退货原因 */.M["退货原因"]]),
      mappingList = _useMapping.mappingList;

  var returnReasonList = (0,react.useMemo)(() => sortReturnReasonOptions(mappingList.get(useMapping/* MappingKey.退货原因 */.M["退货原因"]) || []), [mappingList]);
  var categoryList = (0,useCategoryWholeData/* default */.Z)(4);
  var supplier = (0,useSupplier/* default */.Z)({
    name: 'supplierCode',
    fieldOptions: {
      mode: 'multiple'
    }
  });
  var deliveryList = (0,react.useMemo)(() => {
    var list = mappingList.get(useMapping/* MappingKey.权限下的地点 */.M["权限下的地点"]) || [];

    if (!list.length) {
      return [];
    }

    return list.filter(v => [2, 4].includes(v.others.placeScope));
  }, [mappingList]);

  var _useState = (0,react.useState)([]),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      placeList = _useState2[0],
      setPlaceList = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      applyCodeList = _useState4[0],
      setApplyCodeList = _useState4[1];

  var queryList = (0,react.useCallback)(v => {
    var _formRef$current, _mappingList$get;

    if (!v) {
      return;
    }

    var merchantId = (_formRef$current = formRef.current) === null || _formRef$current === void 0 ? void 0 : _formRef$current.getFieldValue('merchantId');
    var obj = (_mappingList$get = mappingList.get(useMapping/* MappingKey.权限下的商家 */.M["权限下的商家"])) === null || _mappingList$get === void 0 ? void 0 : _mappingList$get.find(v => v.value === merchantId);

    if (obj) {
      var _obj$others$placeVos;

      var list = (_obj$others$placeVos = obj.others.placeVos) === null || _obj$others$placeVos === void 0 ? void 0 : _obj$others$placeVos.filter(v => [1, 3].includes(v.placeScope)).map(v => ({
        value: v.placeId,
        label: "".concat(v.placeCode, "-").concat(v.placeName),
        others: v
      }));
      setPlaceList(list);
    }
  }, [mappingList]);
  var searchApplyCode = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(v) {
      var _formRef$current2;

      var data, params, res, _res$result, list;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = (_formRef$current2 = formRef.current) === null || _formRef$current2 === void 0 ? void 0 : _formRef$current2.getFieldsValue();
              params = {
                merchantId: data.merchantId,
                returnType,
                status,
                keyword: v
              };
              _context.next = 4;
              return (0,esm/* YpRequest */.XQ)(APPLY_CODE_LIST, params);

            case 4:
              res = _context.sent;

              if (res.success) {
                list = (_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.applyCode.map(v => ({
                  value: v,
                  label: v
                }));
                setApplyCodeList(list || []);
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [returnType, status]);

  var onChange = () => {
    var _formRef$current3;

    (_formRef$current3 = formRef.current) === null || _formRef$current3 === void 0 ? void 0 : _formRef$current3.setFieldsValue({
      placeId: []
    });
  };

  var commonFields = [{
    label: '商家',
    name: 'merchantId',
    type: 'SELECT',
    required: true,
    reset: false,
    dataList: mappingList.get(useMapping/* MappingKey.权限下的商家 */.M["权限下的商家"]),
    fieldOptions: {
      onChange: onChange
    }
  }, returnType === 1 ? supplier : {
    label: '配送中心',
    name: 'deliveryDcId',
    type: 'SELECT',
    dataList: deliveryList
  }, {
    label: '商品类别',
    name: 'category',
    type: 'CASCADER',
    dataList: categoryList,
    fieldOptions: {
      changeOnSelect: true
    }
  }, {
    label: '地点',
    name: 'placeIds',
    type: 'SELECT',
    dataList: placeList,
    fieldOptions: {
      mode: 'multiple',
      onDropdownVisibleChange: queryList
    }
  }, {
    label: '商品编码',
    name: 'goodsIds',
    type: 'SELECT',
    fieldOptions: {
      mode: 'tags'
    }
  }, {
    label: '商品名称',
    name: 'goodsNames',
    type: 'SELECT',
    fieldOptions: {
      mode: 'tags'
    }
  }, {
    label: '退货原因',
    name: 'returnReason',
    type: 'SELECT',
    dataList: returnReasonList,
    fieldOptions: {
      mode: 'multiple'
    }
  }, {
    label: '退货申请单号',
    name: 'applyCode',
    type: 'SELECT',
    dataList: applyCodeList,
    fieldOptions: {
      onSearch: searchApplyCode
    }
  }, {
    label: '申请时间',
    name: 'gmTime',
    type: 'RANGE_PICKER_SHORT'
  }];
  var tailFields = [{
    label: returnType === 1 ? '退供单号' : '退仓单号',
    name: 'businessOrderNo',
    type: 'INPUT'
  }, {
    label: '队形',
    name: 'placeGroupId',
    type: 'SELECT',
    dataList: mappingList.get(useMapping/* MappingKey.权限下的店群信息 */.M["权限下的店群信息"]) || [],
    fieldOptions: {
      mode: 'multiple'
    }
  }, {
    label: '退货备注',
    name: 'returnRemark',
    type: 'INPUT'
  }]; // 待审核：status 含 1；已处理：2/3/4。status 缺失时按待审核兜底，避免 FormBuilder elements.reduce 报错

  var isPending = !(status !== null && status !== void 0 && status.length) || Number(status[0]) === 1;

  if (isPending) {
    return [...commonFields, ...tailFields];
  }

  return [...commonFields, {
    label: '状态',
    name: 'status',
    type: 'SELECT',
    reset: false,
    dataList: [{
      value: 2,
      label: '审核通过'
    }, {
      value: 3,
      label: '审核不通过'
    }, {
      value: 4,
      label: '失效过期'
    }],
    fieldOptions: {
      mode: 'multiple'
    }
  }, ...tailFields];
}

/* harmony default export */ var BasePool_useFormfields = (useFormfields);
// EXTERNAL MODULE: ./src/pages/ReturnsManage/BasePool/PriceModal.tsx
var PriceModal = __webpack_require__(81039);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/QuestionCircleOutlined.js + 1 modules
var QuestionCircleOutlined = __webpack_require__(1870);
// EXTERNAL MODULE: ./src/pages/ReturnsManage/BasePool/useSupplierColumns.tsx
var useSupplierColumns = __webpack_require__(78778);
;// CONCATENATED MODULE: ./src/pages/ReturnsManage/BasePool/useWareColumns.ts
function useWareColumns(editable) {
  var list = [{
    title: '地点编码',
    dataIndex: 'placeCode',
    key: 'placeCode',
    width: 100
  }, {
    title: '地点名称',
    dataIndex: 'placeName',
    key: 'placeName',
    width: 170,
    sorter: true
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 100
  }, {
    title: '商品条码',
    dataIndex: 'goodsBarCode',
    key: 'goodsBarCode',
    width: 140
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    sorter: true,
    width: 180
  }, {
    title: '二级类目',
    dataIndex: 'secondCategoryName',
    key: 'secondCategoryName',
    width: 110
  }, {
    title: '规格',
    dataIndex: 'orderSpecification',
    key: 'orderSpecification',
    width: 70
  }, {
    title: '单位',
    dataIndex: 'orderSpecificationUnit',
    key: 'orderSpecificationUnit',
    width: 70
  }, {
    title: '退仓单价',
    dataIndex: 'unitPrice',
    key: 'unitPrice',
    width: 90
  }, {
    title: '物流模式',
    dataIndex: 'logisticsName',
    key: 'logisticsName',
    width: 80
  }, {
    title: '申请退货数量',
    dataIndex: 'goodsReqCopies',
    key: 'goodsReqCopies',
    sorter: true,
    width: 120
  }, {
    title: '审核数量',
    dataIndex: 'goodsAuditCopies',
    key: 'goodsAuditCopies',
    width: 100,
    sorter: true,
    type: editable ? 'INPUT' : undefined
  }, {
    title: '退仓总金额',
    dataIndex: 'amount',
    key: 'amount',
    width: 110
  }, {
    title: '配送中心',
    dataIndex: 'deliveryDcName',
    key: 'deliveryDcName',
    width: 180
  }, {
    title: '门店实时库存',
    dataIndex: 'stock',
    key: 'stock',
    width: 100
  }, {
    title: '退货原因',
    dataIndex: 'returnReasonName',
    key: 'returnReasonName',
    width: 100
  }, {
    title: '门店申请单号',
    dataIndex: 'applyCode',
    key: 'applyCode',
    width: 160
  }];

  if (editable) {
    return list.concat([{
      title: '退货备注',
      dataIndex: 'returnRemark',
      key: 'returnRemark',
      width: 160
    }]);
  } else {
    return [{
      title: '店仓反配单号',
      dataIndex: 'businessOrderNo',
      key: 'businessOrderNo',
      width: 160
    }, {
      title: '状态',
      dataIndex: 'statusName',
      key: 'statusName',
      width: 120
    }].concat(list).concat([{
      title: '审批人',
      dataIndex: 'approveUserName',
      key: 'approveUserName',
      width: 160
    }, {
      title: '审批时间',
      dataIndex: 'approveTime',
      key: 'approveTime',
      width: 160
    }]);
  }
}

/* harmony default export */ var BasePool_useWareColumns = (useWareColumns);
// EXTERNAL MODULE: ./src/pages/ReturnsManage/BasePool/exportModal.tsx
var exportModal = __webpack_require__(62943);
;// CONCATENATED MODULE: ./src/pages/ReturnsManage/BasePool/index.tsx

















var _excluded = ["category", "goodsIds", "gmTime"];











function BasePool(props) {
  var _searchParams$conditi2;

  var returnType = props.returnType;
  var tableRef = (0,react.useRef)(null);
  var formRef = (0,react.useRef)(null);
  var rejectReason = (0,react.useRef)();

  var _useState = (0,react.useState)('un'),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      activeKey = _useState2[0],
      setActiveKey = _useState2[1]; // 查询参数


  var _useState3 = (0,react.useState)({
    condition: {
      status: [1]
    }
  }),
      _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
      searchParams = _useState4[0],
      setSearchParams = _useState4[1]; // 列表选中项


  var _useState5 = (0,react.useState)([]),
      _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
      selectedRows = _useState6[0],
      setSelectedRows = _useState6[1]; // 改价


  var _useState7 = (0,react.useState)(false),
      _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
      priceModal = _useState8[0],
      setPriceModal = _useState8[1]; // 统计信息


  var _useState9 = (0,react.useState)(),
      _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2),
      statData = _useState10[0],
      setStatData = _useState10[1];

  var _useState11 = (0,react.useState)(true),
      _useState12 = (0,slicedToArray/* default */.Z)(_useState11, 2),
      cancelRequest = _useState12[0],
      setCancelRequest = _useState12[1]; // 控制导出列表


  var _useState13 = (0,react.useState)(false),
      _useState14 = (0,slicedToArray/* default */.Z)(_useState13, 2),
      isvisible = _useState14[0],
      setVisible = _useState14[1]; // 列表导出的数据


  var _useState15 = (0,react.useState)({}),
      _useState16 = (0,slicedToArray/* default */.Z)(_useState15, 2),
      listExport = _useState16[0],
      setListExport = _useState16[1];

  var formfields = BasePool_useFormfields(formRef, returnType, searchParams.condition.status);
  var supColumns = (0,useSupplierColumns.default)(activeKey === 'un', searchParams.condition);
  var wareColumns = BasePool_useWareColumns(activeKey === 'un');
  var columns = returnType === 1 ? supColumns : wareColumns; // 审核按钮

  var disabledBtn = (0,react.useMemo)(() => !selectedRows.length, [selectedRows]); // 勾选信息

  var selectStat = (0,react.useMemo)(() => {
    if (selectedRows.length) {
      var _selectedRows$reduce = selectedRows.reduce((pre, next) => {
        if (!pre.sku.includes(next.goodsId)) {
          pre.sku.push(next.goodsId);
        }

        if (!pre.place.includes(next.placeId)) {
          pre.place.push(next.placeId);
        }

        pre.amount = pre.amount + (Number.isNaN(Number(next.amount)) ? 0 : Number(next.amount));
        return pre;
      }, {
        sku: [],
        amount: 0,
        place: []
      }),
          sku = _selectedRows$reduce.sku,
          amount = _selectedRows$reduce.amount,
          place = _selectedRows$reduce.place;

      return {
        total: place.length,
        sku: sku.length,
        amount: amount.toFixed(2)
      };
    } else {
      return {
        total: 0,
        sku: 0,
        amount: 0
      };
    }
  }, [selectedRows]);
  var queryStat = (0,react.useCallback)(params => {
    (0,esm/* YpRequest */.XQ)(STAT_DATA, {
      condition: params || (searchParams === null || searchParams === void 0 ? void 0 : searchParams.condition)
    }).then(res => {
      if (res.success) {
        setStatData(res.result);
      }
    });
  }, []);
  var format = (0,react.useCallback)(values => {
    var category = values.category,
        goodsIds = values.goodsIds,
        gmTime = values.gmTime,
        rest = (0,objectWithoutProperties/* default */.Z)(values, _excluded);

    var _ref = category || [],
        _ref2 = (0,slicedToArray/* default */.Z)(_ref, 4),
        firstCategoryId = _ref2[0],
        secondCategoryId = _ref2[1],
        thirdCategoryId = _ref2[2],
        fourthCategoryId = _ref2[3];

    var _ref3 = gmTime || [],
        _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
        beginGmtCreate = _ref4[0],
        endGmtCreate = _ref4[1]; // const ids = goodsIds
    //   ? goodsIds
    //     .split(',')
    //     .map((v: string) => v?.split('，'))
    //     .flat()
    //     .map((v: string) => Number(v))
    //   : []


    var ids = goodsIds;
    return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, rest), {}, {
      beginGmtCreate: beginGmtCreate ? moment_default()(beginGmtCreate).format('YYYY-MM-DD') + ' 00:00:00' : undefined,
      endGmtCreate: endGmtCreate ? moment_default()(endGmtCreate).format('YYYY-MM-DD') + ' 23:59:59' : undefined,
      goodsIds: ids,
      firstCategoryId,
      secondCategoryId,
      thirdCategoryId,
      fourthCategoryId,
      returnType
    });
  }, [returnType]);
  var reset = (0,react.useCallback)(values => {
    var _formRef$current;

    // 已处理与切 tab 一致：通过/不通过/失效过期
    var status = activeKey === 'un' ? [1] : [2, 3, 4];
    var conditions = format(values);

    var params = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, searchParams), {}, {
      condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, searchParams.condition), conditions), {}, {
        // 表单重置会清掉 status，必须写回，否则 useFormfields 无匹配分支返回 undefined
        status
      })
    }); // 重置按钮的时候，状态有默认值


    (_formRef$current = formRef.current) === null || _formRef$current === void 0 ? void 0 : _formRef$current.setFieldsValue({
      status
    });
    setSearchParams(params);
    queryStat(params.condition);
  }, [queryStat, format, searchParams, activeKey]);
  var searchHandler = (0,react.useCallback)(values => {
    var conditions = format(values);

    var params = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, searchParams), {}, {
      condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, searchParams === null || searchParams === void 0 ? void 0 : searchParams.condition), conditions)
    });

    setSearchParams(params);
    queryStat(params === null || params === void 0 ? void 0 : params.condition);
  }, [queryStat, returnType, format, searchParams]);

  var changeTabs = key => {
    var _formRef$current2;

    var status = key === 'un' ? [1] : [2, 3, 4];

    var condition = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, searchParams.condition), {}, {
      status
    });

    setActiveKey(key);
    queryStat(condition);
    (_formRef$current2 = formRef.current) === null || _formRef$current2 === void 0 ? void 0 : _formRef$current2.setFieldsValue({
      status: status
    });
    setSearchParams(v => (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v), {}, {
      condition
    }));
  };

  var getSelectedRows = (0,react.useCallback)((keys, rows) => {
    setSelectedRows(rows);
  }, []);

  var approveParams = () => {
    var data = selectedRows.map(v => ({
      id: v.id,
      applyCode: v.applyCode,
      goodsId: v.goodsId ? Number(v.goodsId) : v.goodsId
    }));
    return {
      data,
      returnType
    };
  };

  var handlePass = () => {
    modal/* default.confirm */.Z.confirm({
      icon: /*#__PURE__*/react.createElement(QuestionCircleOutlined/* default */.Z, null),
      title: '是否确认审核通过？',
      okText: '确认',
      cancelText: '取消',
      onOk: function () {
        var _onOk = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
          var params, res, _tableRef$current;

          return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  params = approveParams();
                  _context.next = 3;
                  return (0,esm/* YpRequest */.XQ)(BATCH_APPROVE, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, params), {}, {
                    status: 2
                  }));

                case 3:
                  res = _context.sent;

                  if (res.success) {
                    if (res.failCount) {
                      modal/* default.confirm */.Z.confirm({
                        title: '审核失败',
                        content: res.error.map(v => /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("p", null, "\u7533\u8BF7\u7F16\u7801\uFF1A", v.applyCode), /*#__PURE__*/react.createElement("p", null, "\u5931\u8D25\u539F\u56E0\uFF1A", v.failReason))),
                        cancelText: '关闭'
                      });
                    } else {
                      message.default.success('审核成功！');

                      (_tableRef$current = tableRef.current) === null || _tableRef$current === void 0 ? void 0 : _tableRef$current.reload(searchParams);
                    }
                  }

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onOk() {
          return _onOk.apply(this, arguments);
        }

        return onOk;
      }()
    });
  };

  var handleReject = () => {
    modal/* default.confirm */.Z.confirm({
      icon: /*#__PURE__*/react.createElement(QuestionCircleOutlined/* default */.Z, null),
      title: '是否审核驳回？',
      okText: '确定',
      cancelText: '取消',
      content: /*#__PURE__*/react.createElement(input/* default */.Z, {
        placeholder: "\u9A73\u56DE\u539F\u56E0",
        onChange: e => rejectReason.current = e.target.value
      }),
      onOk: function () {
        var _onOk2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2() {
          var params, res, _tableRef$current2;

          return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  params = approveParams();
                  _context2.next = 3;
                  return (0,esm/* YpRequest */.XQ)(BATCH_APPROVE, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, params), {}, {
                    status: 3,
                    failReason: rejectReason.current
                  }));

                case 3:
                  res = _context2.sent;

                  if (res.success) {
                    if (res.failCount) {
                      modal/* default.confirm */.Z.confirm({
                        title: '审核失败',
                        content: res.error.map(v => /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement("p", null, "\u7533\u8BF7\u7F16\u7801\uFF1A", v.applyCode), /*#__PURE__*/react.createElement("p", null, "\u5931\u8D25\u539F\u56E0\uFF1A", v.failReason))),
                        cancelText: '关闭'
                      });
                    } else {
                      message.default.success('审核成功！');

                      (_tableRef$current2 = tableRef.current) === null || _tableRef$current2 === void 0 ? void 0 : _tableRef$current2.reload(searchParams);
                    }
                  }

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function onOk() {
          return _onOk2.apply(this, arguments);
        }

        return onOk;
      }()
    });
  };

  var batchEditPrice = () => {
    setPriceModal(true);
  };

  var closePriceModal = (0,react.useCallback)(v => {
    if (typeof v === 'boolean' && v) {
      var _tableRef$current3;

      (_tableRef$current3 = tableRef.current) === null || _tableRef$current3 === void 0 ? void 0 : _tableRef$current3.reload(searchParams);
    }

    setPriceModal(false);
  }, [tableRef, searchParams]);
  var saveCell = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3(data) {
      var currentRow, currentRowOldData, res, _tableRef$current4;

      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              currentRow = data.currentRow, currentRowOldData = data.currentRowOldData;
              _context3.next = 3;
              return (0,esm/* YpRequest */.XQ)(SAVE_TABLE_LINE, {
                id: currentRow.id,
                applyCode: currentRow.applyCode,
                placeIds: currentRow.placeIds,
                goodsId: currentRow.goodsId,
                unitPrice: currentRow.unitPrice,
                goodsAuditCopies: currentRow.goodsAuditCopies,
                totalAmount: currentRow.amount,
                supplierCode: currentRow.supplierCode,
                returnType
              });

            case 3:
              res = _context3.sent;

              if (!res.success) {
                _context3.next = 10;
                break;
              }

              message.default.success('修改成功');

              (_tableRef$current4 = tableRef.current) === null || _tableRef$current4 === void 0 ? void 0 : _tableRef$current4.reload(searchParams);
              return _context3.abrupt("return", res.result);

            case 10:
              return _context3.abrupt("return", currentRowOldData);

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x) {
      return _ref5.apply(this, arguments);
    };
  }(), [tableRef, searchParams]);
  var sortCallback = (0,react.useCallback)((filter, sorter) => {
    var isAsc;

    if (sorter.order === 'ascend') {
      isAsc = true;
    } else if (sorter.order === 'descend') {
      isAsc = false;
    }

    return {
      condition: (0,objectSpread2/* default */.Z)({}, searchParams.condition),
      orderByType: isAsc ? 1 : 2,
      orderBy: sorter.field
    };
  }, [searchParams]);

  var exportAll = operation => {
    if (returnType == 1) {
      exportGoodsRequest('scm.revert.exportRequireReturnSupplyPool', operation == 'un' ? true : false);
    } else if (returnType == 2) {
      exportGoodsRequest('scm.revert.exportRequireReturnWarehousePool', operation == 'un' ? true : false);
    }
  }; // 时间格式化


  var dateFormat = (fmt, date) => {
    var ret;
    var opt = {
      'Y+': date.getFullYear().toString(),
      // 年
      'm+': (date.getMonth() + 1).toString(),
      // 月
      'd+': date.getDate().toString(),
      // 日
      'H+': date.getHours().toString(),
      // 时
      'M+': date.getMinutes().toString(),
      // 分
      'S+': date.getSeconds().toString() // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串

    };

    for (var k in opt) {
      ret = new RegExp('(' + k + ')').exec(fmt);

      if (ret) {
        fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
      }
    }

    return fmt;
  }; // 导出列表


  var exportGoodsRequest = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee4(api, operType) {
      var _formRef$current3, _formRef$current3$get, _formRef$current4;

      var merchant, formData, v;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              merchant = (_formRef$current3 = formRef.current) === null || _formRef$current3 === void 0 ? void 0 : (_formRef$current3$get = _formRef$current3.getFieldsValue()) === null || _formRef$current3$get === void 0 ? void 0 : _formRef$current3$get.merchantId;
              formData = (_formRef$current4 = formRef.current) === null || _formRef$current4 === void 0 ? void 0 : _formRef$current4.getFieldsValue();

              if (merchant) {
                _context4.next = 5;
                break;
              }

              message.default.warn('请先选择商家');

              return _context4.abrupt("return");

            case 5:
              if (formData.gmTime) {
                _context4.next = 8;
                break;
              }

              message.default.warn('请选择申请时间');

              return _context4.abrupt("return");

            case 8:
              if (!(formData.category && formData.category.length > 0)) {
                _context4.next = 27;
                break;
              }

              _context4.t0 = formData.category.length;
              _context4.next = _context4.t0 === 1 ? 12 : _context4.t0 === 2 ? 14 : _context4.t0 === 3 ? 17 : _context4.t0 === 4 ? 21 : 26;
              break;

            case 12:
              formData.firstCategoryId = formData.category[0];
              return _context4.abrupt("break", 26);

            case 14:
              formData.firstCategoryId = formData.category[0];
              formData.secondCategoryId = formData.category[1];
              return _context4.abrupt("break", 26);

            case 17:
              formData.firstCategoryId = formData.category[0];
              formData.secondCategoryId = formData.category[1];
              formData.thirdCategoryId = formData.category[2];
              return _context4.abrupt("break", 26);

            case 21:
              formData.firstCategoryId = formData.category[0];
              formData.secondCategoryId = formData.category[1];
              formData.thirdCategoryId = formData.category[2];
              formData.fourthCategoryId = formData.category[3];
              return _context4.abrupt("break", 26);

            case 26:
              delete formData.category;

            case 27:
              formData.beginGmtCreate = formData.gmTime[0].format('YYYY-MM-DD 00:00:00');
              formData.endGmtCreate = formData.gmTime[1].format('YYYY-MM-DD 23:59:59');
              delete formData.gmTime;
              _context4.next = 32;
              return (0,esm/* YpRequest */.XQ)(api, {
                condition: (0,objectSpread2/* default */.Z)({
                  returnType: returnType,
                  status: operType ? [1] : [2, 3]
                }, formData)
              });

            case 32:
              v = _context4.sent;
              setListExport({
                condition: (0,objectSpread2/* default */.Z)({
                  returnType: returnType,
                  status: operType ? [1] : [2, 3]
                }, formData)
              });

              if (v.success) {
                message.default.success('执行成功');
              }

            case 35:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function exportGoodsRequest(_x2, _x3) {
      return _ref6.apply(this, arguments);
    };
  }(); // 判断传入的值


  var businessType = () => {
    if (returnType == 1) {
      return '10';
    } else if (returnType == 2) {
      return '11';
    }
  };

  (0,react.useEffect)(() => {
    var _formRef$current5;

    (_formRef$current5 = formRef.current) === null || _formRef$current5 === void 0 ? void 0 : _formRef$current5.setFieldsValue({
      status: [1]
    });
    queryStat();
  }, []);
  (0,react.useEffect)(() => {
    var _formRef$current6;

    var data = (_formRef$current6 = formRef.current) === null || _formRef$current6 === void 0 ? void 0 : _formRef$current6.getFieldsValue();
    var conditions = format(data);
    setSearchParams(v => ({
      condition: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, v.condition), conditions)
    }));
  }, [format]);
  (0,react.useEffect)(() => {
    var _formRef$current7, _searchParams$conditi;

    var data = (_formRef$current7 = formRef.current) === null || _formRef$current7 === void 0 ? void 0 : _formRef$current7.getFieldsValue();
    var cancelReq = !(data !== null && data !== void 0 && data.merchantId) || !((_searchParams$conditi = searchParams.condition) !== null && _searchParams$conditi !== void 0 && _searchParams$conditi.merchantId);
    setCancelRequest(cancelReq);
  }, [formRef.current, searchParams.condition]);
  var dataSourceChangeCallback = (0,react.useCallback)(da => {
    // 重置选中
    setSelectedRows([]);
  }, []);
  return /*#__PURE__*/react.createElement(esm/* WrapperLayout.WrapperLayout */.p8.WrapperLayout, null, /*#__PURE__*/react.createElement(esm/* WrapperLayout.WrapperForm */.p8.WrapperForm, null, /*#__PURE__*/react.createElement(esm/* FormBuilder */.qu, {
    formRef: formRef,
    elements: formfields,
    onSearch: searchHandler,
    onReset: reset,
    useCache: true
  })), /*#__PURE__*/react.createElement(esm/* WrapperLayout.WrapperContent */.p8.WrapperContent, null, /*#__PURE__*/react.createElement(tabs/* default */.Z, {
    activeKey: activeKey,
    onChange: changeTabs,
    tabBarExtraContent: {
      right: /*#__PURE__*/react.createElement(react.Fragment, null, statData && ((_searchParams$conditi2 = searchParams.condition) === null || _searchParams$conditi2 === void 0 ? void 0 : _searchParams$conditi2.merchantId) && /*#__PURE__*/react.createElement("a", {
        style: {
          display: 'block',
          width: '100%'
        }
      }, "\u5171\u8BA1\uFF1A\u95E8\u5E97", statData === null || statData === void 0 ? void 0 : statData.placeCount, "\u4E2A\uFF0C\u5546\u54C1\u79CD\u7C7B", statData === null || statData === void 0 ? void 0 : statData.skuCount, "\u4E2A\uFF0C\u603B\u8BA1\u91D1\u989D", statData === null || statData === void 0 ? void 0 : statData.totalAmount, "\u5143"), selectStat.total ? /*#__PURE__*/react.createElement("a", null, "\u5DF2\u52FE\u9009\uFF1A\u95E8\u5E97", selectStat.total, "\u4E2A\uFF0C\u5546\u54C1\u79CD\u7C7B", selectStat.sku, "\u4E2A\uFF0C\u603B\u8BA1\u91D1\u989D", selectStat.amount, "\u5143") : null)
    }
  }, /*#__PURE__*/react.createElement(tabs/* default.TabPane */.Z.TabPane, {
    tab: "\u5F85\u5904\u7406",
    key: "un"
  }, /*#__PURE__*/react.createElement(esm/* EnhanceTable */.UO, {
    tableRef: tableRef,
    columns: columns,
    requestUrl: POOL_LIST,
    searchParams: searchParams,
    cancelRequest: cancelRequest,
    rowSelectCallback: getSelectedRows,
    sortCallback: sortCallback,
    saveRowCallback: saveCell,
    dataSourceChangeCallback: dataSourceChangeCallback,
    tableHeaderBar: /*#__PURE__*/react.createElement(space/* default */.Z, null, /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      type: "primary",
      disabled: disabledBtn,
      onClick: handlePass
    }, "\u5BA1\u6838\u901A\u8FC7"), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      danger: true,
      disabled: disabledBtn,
      onClick: () => {
        handleReject();
      }
    }, "\u5BA1\u6838\u4E0D\u901A\u8FC7"), props.returnType == 1 && /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      onClick: batchEditPrice
    }, "\u6279\u91CF\u6539\u5355\u4EF7"), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      onClick: () => {
        exportAll('un');
      }
    }, "\u5408\u5E76\u5BFC\u51FA"), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      onClick: () => {
        setVisible(true);
      }
    }, "\u5BFC\u51FA\u5217\u8868"))
  })), /*#__PURE__*/react.createElement(tabs/* default.TabPane */.Z.TabPane, {
    tab: "\u5DF2\u5904\u7406",
    key: "has"
  }, /*#__PURE__*/react.createElement(esm/* EnhanceTable */.UO, {
    tableRef: tableRef,
    columns: columns,
    cancelRequest: cancelRequest,
    requestUrl: POOL_LIST,
    searchParams: searchParams,
    tableHeaderBar: /*#__PURE__*/react.createElement(space/* default */.Z, null, /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      onClick: () => {
        exportAll('has');
      }
    }, "\u5408\u5E76\u5BFC\u51FA"), /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      onClick: () => {
        setVisible(true);
      }
    }, "\u5BFC\u51FA\u5217\u8868"))
  }))), priceModal && /*#__PURE__*/react.createElement(PriceModal.default, {
    params: searchParams.condition,
    closeModalCallback: closePriceModal
  }), isvisible && /*#__PURE__*/react.createElement(exportModal.default, {
    businessType: businessType(),
    listExport: listExport,
    closeModalCallback: () => {
      setVisible(false);
    }
  })));
}

/* harmony default export */ var ReturnsManage_BasePool = (BasePool);

/***/ }),

/***/ 78778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_spin_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20228);
/* harmony import */ var antd_es_spin__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11382);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46565);










function useSupplierColumns(editable, condition) {
  // 供应商数据
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState, 2),
      suppList = _useState2[0],
      setSuppList = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(_useState3, 2),
      suppLoading = _useState4[0],
      setSuppLoading = _useState4[1]; // 获取供应商数据


  var getSuppList = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().mark(function _callee(visible, record) {
      var goodsId, placeId, res, success, result, data;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              goodsId = record.goodsId, placeId = record.placeId;

              if (!(!visible || !(condition !== null && condition !== void 0 && condition.merchantId) || !placeId || !goodsId)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              setSuppList([]);
              setSuppLoading(true); // 单元格处于编辑状态时请求数据

              _context.next = 7;
              return (0,yp_frontend_library__WEBPACK_IMPORTED_MODULE_2__/* .YpRequest */ .XQ)('purchase.product.queryProductExtInfo', {
                needSupplier: true,
                param: [{
                  merchantId: condition.merchantId,
                  placeId,
                  goodsId: +goodsId
                }]
              });

            case 7:
              res = _context.sent;
              success = res.success, result = res.result;

              if (success) {
                data = result === null || result === void 0 ? void 0 : result.list.reduce((pre, next) => {
                  if (Array.isArray(next.supplier)) {
                    var _list = next.supplier.map(v => ({
                      label: v.supplierName,
                      value: v.supplierCode,
                      others: v
                    }));

                    pre = pre.concat(_list);
                  }

                  return pre;
                }, []);
                setSuppList(data);
              }

              setSuppLoading(false);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [condition === null || condition === void 0 ? void 0 : condition.merchantId]);
  var list = [{
    title: '地点编码',
    dataIndex: 'placeCode',
    key: 'placeCode',
    width: 100
  }, {
    title: '地点名称',
    dataIndex: 'placeName',
    key: 'placeName',
    width: 180,
    sorter: true
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 100
  }, {
    title: '商品条码',
    dataIndex: 'goodsBarCode',
    key: 'goodsBarCode',
    width: 140
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    sorter: true,
    width: 180
  }, {
    title: '二级类目',
    dataIndex: 'secondCategoryName',
    key: 'secondCategoryName',
    width: 100
  }, {
    title: '规格',
    dataIndex: 'orderSpecification',
    key: 'orderSpecification',
    width: 70
  }, {
    title: '单位',
    dataIndex: 'orderSpecificationUnit',
    key: 'orderSpecificationUnit',
    width: 70
  }, {
    title: '参考退供价',
    dataIndex: 'referencePrice',
    key: 'referencePrice',
    width: 100
  }, {
    title: '采购退货单价',
    dataIndex: 'unitPrice',
    key: 'unitPrice',
    sorter: true,
    width: 120,
    type: editable ? 'INPUT' : undefined
  }, {
    title: '物流模式',
    dataIndex: 'logisticsName',
    key: 'logisticsName',
    width: 100
  }, {
    title: '审核数量',
    dataIndex: 'goodsAuditCopies',
    key: 'goodsAuditCopies',
    width: 100,
    sorter: true,
    type: editable ? 'INPUT' : undefined
  }, {
    title: '退货总金额',
    dataIndex: 'amount',
    key: 'amount',
    width: 100,
    type: editable ? 'INPUT' : undefined
  }, {
    title: '退货实时库存',
    dataIndex: 'stock',
    key: 'stock',
    width: 100
  }, {
    title: '供应商编码',
    dataIndex: 'supplierCode',
    key: 'supplierCode',
    width: 120
  }, {
    title: '供应商名称',
    dataIndex: 'supplierName',
    key: 'supplierName',
    width: 170,
    sorter: true,
    type: editable ? 'SELECT' : undefined,
    dataList: suppList,
    setCellRowValue: (record, o) => {
      var children = o.children,
          value = o.value;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)({}, record), {}, {
        supplierName: children,
        supplierCode: value
      });
    },
    fieldOptions: record => {
      return {
        onDropdownVisibleChange: visible => getSuppList(visible, record),
        notFoundContent: suppLoading ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_spin__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
          size: "small"
        }) : null
      };
    }
  }, {
    title: '退货原因',
    dataIndex: 'returnReasonName',
    key: 'returnReasonName',
    width: 100
  }, {
    title: '门店申请单号',
    dataIndex: 'applyCode',
    key: 'applyCode',
    width: 160
  }];

  if (editable) {
    return list.concat([{
      title: '退货备注',
      dataIndex: 'returnRemark',
      key: 'returnRemark',
      width: 160
    }]);
  } else {
    return [{
      title: '采购单号',
      dataIndex: 'businessOrderNo',
      key: 'businessOrderNo',
      width: 160
    }, {
      title: '状态',
      dataIndex: 'statusName',
      key: 'statusName',
      width: 120
    }].concat(list).concat([{
      title: '审批人',
      dataIndex: 'approveUserName',
      key: 'approveUserName',
      width: 160
    }, {
      title: '审批时间',
      dataIndex: 'approveTime',
      key: 'approveTime',
      width: 160
    }]);
  }
}

/* harmony default export */ __webpack_exports__["default"] = (useSupplierColumns);

/***/ }),

/***/ 16051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "uY": function() { return /* binding */ REVERT_MAIN_LIST; },
/* harmony export */   "Xm": function() { return /* binding */ REVERT_MAIN_INFO; },
/* harmony export */   "ej": function() { return /* binding */ REVERT_CONFIG; },
/* harmony export */   "jM": function() { return /* binding */ REVERT_SAVE; },
/* harmony export */   "p4": function() { return /* binding */ REVERT_CLEAR; },
/* harmony export */   "H6": function() { return /* binding */ REVERT_TEMPLATE; },
/* harmony export */   "Wz": function() { return /* binding */ REVERT_IMPORT; }
/* harmony export */ });
/** 主单查询 */
var REVERT_MAIN_LIST = 'scm.requireConfig.queryRevertConfigPage';
/** 主单 */

var REVERT_MAIN_INFO = 'scm.requireConfig.queryRevertConfigDetail';
/** 删除配置 */

var REVERT_CONFIG = 'scm.requireConfig.deleteRevertConfig';
/** 保存配置 */

var REVERT_SAVE = 'scm.requireConfig.saveOrModifyRevertConfig';
/** 清空配置 */

var REVERT_CLEAR = 'scm.requireConfig.clearRevertConfig';
/** 下载模板 */

var REVERT_TEMPLATE = 'scm.config.getDownloadTemplate';
/** 导入模板 */

var REVERT_IMPORT = 'scm.requireConfig.importRevertConfig';

/***/ }),

/***/ 21194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BW": function() { return /* binding */ STOCKMANAGE_PLAN_LIST; },
/* harmony export */   "i0": function() { return /* binding */ STOCKMANAGE_PLAN_DETAIL; },
/* harmony export */   "jg": function() { return /* binding */ STOCKMANAGE_PLAN_NEW; },
/* harmony export */   "V0": function() { return /* binding */ STOCKMANAGE_PLAN_DELETE; },
/* harmony export */   "RF": function() { return /* binding */ queryStockTakeMonitorByEs; },
/* harmony export */   "f2": function() { return /* binding */ queryStockTakeDetailMonitorByCode; },
/* harmony export */   "xL": function() { return /* binding */ queryStockTakeAdjustByBigData; }
/* harmony export */ });
/* unused harmony export STOCKMANAGE_PLAN_UPDATE */
//盘点计划-列表分页
var STOCKMANAGE_PLAN_LIST = 'ylp.stock.pageQueryCityPlan'; //单个盘点计划查询-详情

var STOCKMANAGE_PLAN_DETAIL = 'ylp.stock.queryCityPlanDetail'; //盘点计划-创建

var STOCKMANAGE_PLAN_NEW = 'ylp.stock.createCityPlan'; //盘点计划-删除

var STOCKMANAGE_PLAN_DELETE = 'ylp.stock.deleteCityPlan'; //盘点几乎-编辑

var STOCKMANAGE_PLAN_UPDATE = 'ylp.stock.updateCityPlan'; // 查询盘点监控报表

var queryStockTakeMonitorByEs = 'ylp.stocktake.StockTakeDataService.queryStockTakeMonitorByEs'; // 查询盘点明细报表

var queryStockTakeDetailMonitorByCode = 'ylp.stocktake.StockTakeDataService.queryStockTakeDetailMonitorByCode';
/**
 * 查询盘点调整报表（大数据 API 2.0）
 * 与盘点监控 queryStockTakeMonitorByEs（旧网关 ypRequest + pageReq）不同，须走 fetchQuery + page/size
 */

/**
 * apigw2 路径须与网关平台注册一致（规则同 purchase.activity.queryActivityList）：
 * API名称：ylp.stocktake.queryStockTakeAdjustByBigData
 * BasePath=/ylp，Path=/stocktake/StockTakeDataService/queryStockTakeAdjustByBigData
 * 完整请求：apigw2-{env}/ylp/stocktake/StockTakeDataService/queryStockTakeAdjustByBigData
 */

var queryStockTakeAdjustByBigData = '/ylp/stocktake/StockTakeDataService/queryStockTakeAdjustByBigData';

/***/ }),

/***/ 19212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fI": function() { return /* binding */ DISTRIBUTION_GET_GROUP; },
/* harmony export */   "m6": function() { return /* binding */ queryMerchantProductByCondition; },
/* harmony export */   "_Z": function() { return /* binding */ getPlacesByGroup; },
/* harmony export */   "d_": function() { return /* binding */ saveActivity; },
/* harmony export */   "UU": function() { return /* binding */ updateActivity; },
/* harmony export */   "CW": function() { return /* binding */ copyActivity; },
/* harmony export */   "jV": function() { return /* binding */ importActivity; },
/* harmony export */   "ro": function() { return /* binding */ submitActivity; },
/* harmony export */   "Dx": function() { return /* binding */ queryActivityList; },
/* harmony export */   "Gh": function() { return /* binding */ queryActivityGoodsList; },
/* harmony export */   "IB": function() { return /* binding */ exportActivity; },
/* harmony export */   "CG": function() { return /* binding */ exportActivityGoods; },
/* harmony export */   "TH": function() { return /* binding */ cancelActivity; },
/* harmony export */   "Dv": function() { return /* binding */ queryActivityDetail; },
/* harmony export */   "Wt": function() { return /* binding */ queryActivityShopReqInfo; },
/* harmony export */   "Zj": function() { return /* binding */ queryActivityGoodsPrice; }
/* harmony export */ });
/* unused harmony export DISTRIBUTION_GET_SHOP */
/**
 * 根据商家查询店群信息
 */
var DISTRIBUTION_GET_GROUP = 'purchase.require.getGroupsByMerchant';
/**
 * 根据商家店群查询门店信息
 */

var DISTRIBUTION_GET_SHOP = 'purchase.require.queryPlaceInfoList';
var queryMerchantProductByCondition = 'purchase.product.queryMerchantProductByCondition'; // 根据店群查询门店

var getPlacesByGroup = '/scm/basis/getPlacesByGroup'; // 保存编辑营销活动。草稿整单编辑走此接口

var saveActivity = '/scm/activityOperateService/saveActivity'; // 待生效、进行中的营销活动调整库存，只允许调大设置库存量

var updateActivity = '/scm/activityOperateService/updateActivity'; // 复制待生效、进行中、已结束的营销活动，生成草稿

var copyActivity = '/scm/activityOperateService/copyActivity'; // 导入营销活动

var importActivity = '/scm/activityOperateService/importActivity'; // 提交营销活动

var submitActivity = '/scm/activityOperateService/submitActivity'; // 查询营销活动列表

var queryActivityList = '/scm/activityQueryService/queryActivityList'; // 查询营销商品明细列表

var queryActivityGoodsList = '/scm/activityQueryService/queryActivityGoodsList'; // 导出营销活动列表

var exportActivity = '/scm/activityOperateService/exportActivity'; // 导出营销商品明细列表

var exportActivityGoods = '/scm/activityOperateService/exportActivityGoods'; // 作废营销活动

var cancelActivity = '/scm/activityOperateService/cancelActivity'; // 营销活动详情

var queryActivityDetail = '/scm/activityQueryService/queryActivityDetail'; // 查询营销明细门店订购情况

var queryActivityShopReqInfo = '/scm/activityQueryService/queryActivityShopReqInfo'; // 查询营销明细门店订购情况

var queryActivityGoodsPrice = '/scm/activityQueryService/queryActivityGoodsPrice';

/***/ }),

/***/ 55358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ useFormfields; },
/* harmony export */   "useAddGoodsFormfields": function() { return /* binding */ useAddGoodsFormfields; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_FormCategorySelect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45199);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7704);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63095);
/* harmony import */ var _components_PurchaseCategorySelect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55054);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _hooks_useQuerySupplier__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58298);









function useFormfields() {
  var _autoFormRef$current;

  var disabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var autoFormRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var formValues = autoFormRef === null || autoFormRef === void 0 ? void 0 : (_autoFormRef$current = autoFormRef.current) === null || _autoFormRef$current === void 0 ? void 0 : _autoFormRef$current.getFieldsValue();
  var categoryCodeKey = _config__WEBPACK_IMPORTED_MODULE_3__/* .purchaseObj.categoryCodeAll */ .H2.categoryCodeAll;
  var placeIdKey = _config__WEBPACK_IMPORTED_MODULE_3__/* .purchaseObj.queryPlaces */ .H2.queryPlaces;
  var merchantKey = _config__WEBPACK_IMPORTED_MODULE_3__/* .purchaseObj.merchantId */ .H2.merchantId;

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)([categoryCodeKey, placeIdKey, merchantKey], {
    'merchantFlag': '1'
  }),
      mappingList = _useMapping.mappingList;

  var categoryList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    var _mappingList$get;

    var list = (_mappingList$get = mappingList.get(categoryCodeKey)) === null || _mappingList$get === void 0 ? void 0 : _mappingList$get.filter(item => item.value === 10);
    return list === null || list === void 0 ? void 0 : list.map(item => {
      var filteredChildCategoryList = Object.fromEntries(Object.entries(item.others.childCategoryList).filter(_ref => {
        var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)(_ref, 1),
            key = _ref2[0];

        return key !== '1001';
      }));
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)({}, item), {}, {
        others: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)({}, item.others), {}, {
          childCategoryList: filteredChildCategoryList
        })
      });
    });
  }, [mappingList, categoryCodeKey]);
  var categoryValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => formValues === null || formValues === void 0 ? void 0 : formValues.category, [formValues === null || formValues === void 0 ? void 0 : formValues.category]);
  return [{
    label: '活动名称',
    name: 'activityId',
    type: 'INPUT',
    hide: true
  }, {
    label: '活动名称',
    name: 'activityCode',
    type: 'INPUT',
    hide: true
  }, {
    label: '商家',
    name: 'merchantId',
    type: 'SELECT',
    dataList: mappingList.get(merchantKey),
    fieldOptions: {
      disabled,
      allowClear: false
    },
    required: true
  }, {
    label: '类型',
    name: 'activityType',
    type: 'SELECT',
    dataList: _config__WEBPACK_IMPORTED_MODULE_3__/* .types */ .V5,
    fieldOptions: {
      disabled,
      allowClear: false
    },
    required: true
  }, {
    label: '周期',
    name: 'cycle',
    type: 'SELECT',
    dataList: _config__WEBPACK_IMPORTED_MODULE_3__/* .cycles */ .k4,
    fieldOptions: {
      disabled,
      allowClear: false
    },
    required: true
  }, {
    label: '到店日期',
    name: 'arrivalDay',
    type: 'DATE_PICKER',
    fieldOptions: {
      disabledDate: current => current && (current < moment__WEBPACK_IMPORTED_MODULE_5___default()().add(1, 'day').startOf('day') || current > moment__WEBPACK_IMPORTED_MODULE_5___default()().add(7, 'day').endOf('day')),
      disabled,
      allowClear: false
    },
    required: true
  }, {
    label: '品类',
    name: 'category',
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_FormCategorySelect__WEBPACK_IMPORTED_MODULE_1__/* .default */ .Z, {
      firstProps: {
        disabled,
        allowClear: false
      },
      secondProps: {
        disabled,
        allowClear: false
      },
      categoryList: categoryList,
      formValue: categoryValue
    }),
    required: true,
    rules: [{
      required: true,
      message: '品类不能为空!',
      validator: (rule, value) => {
        if (!value.first || !value.second) {
          return Promise.reject('品类不能为空!');
        }

        return Promise.resolve();
      }
    }]
  }, {
    label: '活动名称',
    name: 'activityName',
    type: 'INPUT',
    fieldOptions: {
      maxLength: 50,
      allowClear: false,
      disabled
    },
    required: true
  }];
}
var useAddGoodsFormfields = (form, autoFormRef) => {
  var _autoFormRef$current2;

  var supplier = (0,_hooks_useQuerySupplier__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)({
    name: 'supplierCode'
  });
  var formValues = autoFormRef === null || autoFormRef === void 0 ? void 0 : (_autoFormRef$current2 = autoFormRef.current) === null || _autoFormRef$current2 === void 0 ? void 0 : _autoFormRef$current2.getFieldsValue();
  var curCategoryArr = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => [formValues === null || formValues === void 0 ? void 0 : formValues.category.first.toString(), formValues === null || formValues === void 0 ? void 0 : formValues.category.second.toString()], [formValues === null || formValues === void 0 ? void 0 : formValues.category]);

  var handleCategory = val => {
    form.current.setFieldsValue({
      'category': val
    });
  };

  return [{
    label: '商品查询',
    name: 'queryCriteria',
    type: 'INPUT'
  }, supplier, {
    label: '商品类目',
    name: 'category',
    // type: 'SELECT',
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_PurchaseCategorySelect__WEBPACK_IMPORTED_MODULE_4__/* .PurchaseCategorySelect */ .o, {
      handleCategory: handleCategory,
      deepLength: 2,
      disabled: true,
      curCategoryArr: curCategoryArr
    })
  }];
};

/***/ }),

/***/ 63095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H2": function() { return /* binding */ purchaseObj; },
/* harmony export */   "V5": function() { return /* binding */ types; },
/* harmony export */   "k4": function() { return /* binding */ cycles; },
/* harmony export */   "$q": function() { return /* binding */ states; },
/* harmony export */   "n7": function() { return /* binding */ activityTypeMap; },
/* harmony export */   "PM": function() { return /* binding */ emptyImage; }
/* harmony export */ });
/* unused harmony exports supplierMap, activityGoodsInfo */
var purchaseObj = {
  billState: 9,
  categoryCode: 4,
  placeId: 3,
  queryPlaces: 84,
  orderDirect: 10,
  isStraight: 43,
  categoryCodeAll: 46,
  isDamage: 11,
  returnReason: 12,
  secondCategoryId: 5,
  businessMode: 13,
  merchantId: 40,
  // 权限下的商家
  categoryAll: 41,
  relationAll: 88 // 供应商编码关联单号

};
var supplierMap = {
  businessModel: 4
};
var types = [{
  label: '临采',
  value: 1
}, {
  label: '每日爆款',
  value: 2
}, {
  label: '寻找中的爆品',
  value: 3
}, {
  label: '产地直发',
  value: 4
}, {
  label: '大主题爆品',
  value: 5
}, {
  label: '常规营销',
  value: 6
}];
var cycles = [{
  label: 'T+1',
  value: 1
}, {
  label: 'T+2',
  value: 2
}, {
  label: 'T+3',
  value: 3
}, {
  label: 'T+4',
  value: 4
}, {
  label: 'T+5',
  value: 5
}, {
  label: 'T+6',
  value: 6
}, {
  label: 'T+7',
  value: 7
}];
var states = [{
  label: '草稿',
  value: 1
}, {
  label: '进行中',
  value: 2
}, {
  label: '已结束',
  value: 3
}, {
  label: '作废',
  value: 4
}, {
  label: '待生效',
  value: 5
}];
var activityTypeMap = {
  1: {
    label: '临采',
    color: '#108ee9'
  },
  2: {
    label: '爆款',
    color: '#f50'
  },
  3: {
    label: '报量',
    color: '#2db7f5'
  },
  4: {
    label: '产地',
    color: '#87d068'
  },
  5: {
    label: '主题',
    color: '#ff9900'
  },
  6: {
    label: '常规',
    color: '#009933'
  }
};
var emptyImage = 'data:image/png;base64,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';
var activityGoodsInfo = {
  activityGoodsId: 1,
  //主键Id，编辑传入
  goodsId: 2,
  //商品ID
  goodsBarCode: 3,
  //商品条码
  goodsName: 4,
  //商品名称
  firstCategoryId: 5,
  //一级品类Id
  secondCategoryId: 6,
  //二级品类Id
  thirdCategoryId: 7,
  //三级类目
  fourCategoryId: 8,
  //四级类目
  isWeigh: 9,
  //是否称重 1.称重 2.非称重
  orderDeadline: 10,
  //订购截止时间
  shopPrice: 11,
  // 到店价
  adviceSalePrice: 12,
  // 到店价
  orderStepSize: 13,
  // 步长
  orderMaxQuantity: 14,
  // 最大订购数量
  orderMinQuantity: 15,
  // 最小订购数量
  orderSpecification: 16,
  // 订货规格
  orderSpecificationUnit: 17,
  // 订货单位
  imgUrl: 18,
  //商品图片
  remark: 19,
  //备注
  allGroupFlag: 20,
  //是否勾选全部店群
  activityShopInfo: {
    activityShopId: '',
    //主键Id，编辑传入
    placeCode: 1,
    //商户编码
    placeName: 2,
    //商户名称
    placeId: 3,
    //商户id
    groupId: 4,
    // 店群ID
    groupName: 5 // 店群名称

  } //活动门店列表

};

/***/ }),

/***/ 40655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FORM_FIELD": function() { return /* binding */ FORM_FIELD; },
/* harmony export */   "TABLE_COLUMN_FIELD": function() { return /* binding */ TABLE_COLUMN_FIELD; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31097);
/* harmony import */ var antd_es_input_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47673);
/* harmony import */ var antd_es_input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4107);
/* harmony import */ var antd_es_date_picker_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14965);
/* harmony import */ var antd_es_date_picker__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11448);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);







// import moment from 'moment'
var RangePicker = antd_es_date_picker__WEBPACK_IMPORTED_MODULE_4__/* .default.RangePicker */ .Z.RangePicker;
var FORM_FIELD = [{
  label: '供应商名称',
  name: 'supplierName',
  widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    placeholder: "\u8BF7\u8F93\u5165\u4F9B\u5E94\u5546\u540D\u79F0",
    allowClear: true
  })
}, {
  label: '营业执照号',
  name: 'businessLicense',
  widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    placeholder: "\u8BF7\u8F93\u5165\u8425\u4E1A\u6267\u7167\u53F7",
    allowClear: true
  })
}, {
  label: '创建人',
  name: 'creator',
  widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_input__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    placeholder: "\u8BF7\u8F93\u5165\u521B\u5EFA\u4EBA",
    allowClear: true
  })
}, {
  label: '创建时间',
  name: 'date',
  // required: true,
  widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(RangePicker, {
    allowClear: true
  })
}];
var TABLE_COLUMN_FIELD = [{
  title: '供应商名称',
  dataIndex: 'supplierName',
  key: 'supplierName',
  width: 40,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '营业执照注册号',
  dataIndex: 'businessLicense',
  key: 'businessLicense',
  width: 40,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '备注',
  dataIndex: 'remark',
  key: 'remark',
  width: 30,
  ellipsis: true,
  render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    placement: "topLeft",
    title: t
  }, t)
}, {
  title: '状态',
  dataIndex: 'isValid',
  key: 'isValid',
  width: 20,
  render: t => validMatch(t)
}, {
  title: '创建人',
  dataIndex: 'creator',
  key: 'creator',
  width: 20
}, {
  title: '创建时间',
  dataIndex: 'gmtCreate',
  key: 'gmtCreate',
  width: 30
}];

var validMatch = e => {
  // eslint-disable-next-line radix
  e = parseInt(e);
  var res = '';

  switch (e) {
    case 1:
      res = '生效';
      break;

    case 2:
      res = '失效';
      break;

    default:
      break;
  }

  return res;
};

/***/ }),

/***/ 1687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_radio_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88983);
/* harmony import */ var antd_es_radio__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55742);
/* harmony import */ var antd_es_date_picker_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14965);
/* harmony import */ var antd_es_date_picker__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11448);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





// import moment from 'moment'
var RangePicker = antd_es_date_picker__WEBPACK_IMPORTED_MODULE_3__/* .default.RangePicker */ .Z.RangePicker;
var _max = 50;
/* harmony default export */ __webpack_exports__["default"] = ([{
  label: '供应商名称',
  required: true,
  name: 'supplierName',
  type: 'INPUT',
  fieldOptions: {
    maxLength: _max
  }
}, {
  label: '营业执照注册号',
  name: 'businessLicense',
  required: true,
  type: 'INPUT',
  fieldOptions: {
    maxLength: _max
  }
}, {
  label: '备注',
  name: 'remark',
  type: 'INPUT',
  fieldOptions: {
    maxLength: _max
  }
}, {
  label: '状态',
  name: 'isValid',
  required: true,
  widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_radio__WEBPACK_IMPORTED_MODULE_4__/* .default.Group */ .ZP.Group, {
    options: [{
      label: '生效',
      value: 1
    }, {
      label: '失效',
      value: 2
    }]
  })
}]);

/***/ }),

/***/ 18419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SUPPLIER_TITLE_BAR_DATA": function() { return /* binding */ SUPPLIER_TITLE_BAR_DATA; },
/* harmony export */   "CONTACT_PERSON_COLUMN": function() { return /* binding */ CONTACT_PERSON_COLUMN; },
/* harmony export */   "TABLE_COLUMNS": function() { return /* binding */ TABLE_COLUMNS; },
/* harmony export */   "BASE_MAP": function() { return /* binding */ BASE_MAP; },
/* harmony export */   "FINANCE_MAP": function() { return /* binding */ FINANCE_MAP; },
/* harmony export */   "PURCHASE_MAP": function() { return /* binding */ PURCHASE_MAP; },
/* harmony export */   "DICTIONARY": function() { return /* binding */ DICTIONARY; }
/* harmony export */ });
/* harmony import */ var antd_es_tooltip_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22385);
/* harmony import */ var antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31097);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



/* eslint-disable @typescript-eslint/no-use-before-define */

/**
 * 业务常量
 */


// 供应商管理
var SUPPLIER_TITLE_BAR_DATA = [// 供应商管理 - tab msg
{
  name: 'BASE_INFO',
  title: '基础信息'
}, {
  name: 'BUSINESS_INFO',
  title: '业务信息'
}, {
  name: 'MERCHANT_INFO',
  title: '采购组织'
}];
var CONTACT_PERSON_COLUMN = [// 联系人
{
  title: '类型',
  dataIndex: 'contactTypeName',
  align: 'center',
  className: 'table-head'
}, {
  title: '姓名',
  dataIndex: 'contactName',
  align: 'center',
  className: 'table-head'
}, {
  title: '手机号',
  dataIndex: 'contactTel',
  align: 'center',
  className: 'table-head'
}, {
  title: '邮箱',
  dataIndex: 'contactMail',
  align: 'center',
  className: 'table-head'
}];
var TABLE_COLUMNS = fieldConfig => {
  return [{
    title: '供应商编码',
    dataIndex: 'supplierCode',
    key: 'supplierCode',
    width: 90
  }, {
    title: '供应商名称',
    dataIndex: 'supplierName',
    key: 'supplierName',
    width: 150,
    ellipsis: true,
    render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
      placement: "topLeft",
      title: t
    }, t)
  }, {
    title: '供应商分类',
    dataIndex: 'supplierCategory',
    key: 'supplierCategory',
    width: 90,
    render: (t, r) => (0,_utils_common__WEBPACK_IMPORTED_MODULE_1__/* .dictionaryMatch */ .XB)(t, 'supplierCategory', DICTIONARY(), 'list')
  }, {
    title: '父子供应商',
    dataIndex: 'supplierFlagName',
    key: 'supplierFlagName',
    width: 80
  }, {
    title: '经营方式',
    dataIndex: 'businessMode',
    key: 'businessMode',
    width: 70,
    render: (t, r) => (0,_utils_common__WEBPACK_IMPORTED_MODULE_1__/* .dictionaryMatch */ .XB)(t, 'businessMode', DICTIONARY(fieldConfig), 'list')
  }, {
    title: '结算标记',
    dataIndex: 'settlementMark',
    key: 'settlementMark',
    width: 70,
    render: (t, r) => (0,_utils_common__WEBPACK_IMPORTED_MODULE_1__/* .dictionaryMatch */ .XB)(t, 'settlementMark', DICTIONARY(), 'list')
  }, {
    title: '经营状态',
    dataIndex: 'supplierStatus',
    key: 'supplierStatus',
    width: 70,
    render: (t, r) => (0,_utils_common__WEBPACK_IMPORTED_MODULE_1__/* .dictionaryMatch */ .XB)(t, 'supplierStatus', DICTIONARY(), 'list')
  }, {
    title: '付款方式',
    dataIndex: 'payModeName',
    key: 'payModeName',
    width: 90
  }, {
    title: '是否预付款',
    dataIndex: 'isPrePay',
    key: 'isPrePay',
    width: 90,
    render: (t, r) => (0,_utils_common__WEBPACK_IMPORTED_MODULE_1__/* .dictionaryMatch */ .XB)(t, 'isPrePay', DICTIONARY(), 'list')
  }, {
    title: '创建人',
    dataIndex: 'creator',
    key: 'creator',
    width: 90,
    ellipsis: true,
    render: t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_tooltip__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
      placement: "topLeft",
      title: t
    }, t)
  }, {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    key: 'gmtCreate',
    width: 130
  }, {
    title: '状态',
    dataIndex: 'approveStatus',
    key: 'approveStatus',
    width: 60,
    render: t => (0,_utils_common__WEBPACK_IMPORTED_MODULE_1__/* .dictionaryMatch */ .XB)(t, 'approveStatus', DICTIONARY(), 'list')
  }, {
    title: '最后更新人',
    dataIndex: 'modifiedName',
    key: 'modifiedName',
    width: 130
  }, {
    title: '最后更新时间',
    dataIndex: 'gmtModified',
    key: 'gmtModified',
    width: 130
  }];
};
/**
 * 列表常量
 */

var BASE_MAP = [// 基础信息
['supplierCode', ['供应商编码', '']], ['supplierName', ['供应商名称', '']], ['supplierCategory', ['供应商分类', '']], ['purchaseSupplierName', ['采购供应商', '']], ['isInternalSupplier', ['是否内部供应商', '']], ['supplierType', ['供应商类型', '']], ['supplierStatus', ['经营状态', '']], ['establishedTime', ['成立时间', '']], ['businessScope', ['经营范围', '']], ['mainProduct', ['主要产品', '']], ['companyType', ['企业类型', '']], ['taxLevel', ['纳税级别', '']], ['legalPerson', ['法人代表', '']], ['registeredCapital', ['注册资本', '']], ['companyPhone', ['公司电话', '']], ['companyFax', ['公司传真', '']], ['companyPostcode', ['邮政编码', '']], ['companyMail', ['邮箱', '']], ['provinceCode', ['供应商省市', '']], // cityCode
['companyAddress', ['详细地址', '']], ['businessLicense', ['营业执照注册号', '']], ['foodBusinessLicenseNo', ['食品经营许可证号', '']], ['buyerCode', ['采购人', '']], ['kmtkSupplierCode', ['康铭编码', '']], ['erpSupplierCode', ['富基编码', '']], ['bdSupplierFlag', ['是否BD', '']]];
var FINANCE_MAP = [// 财务信息
['bankProvinceName', ['开户行省市', '']], ['bankTypeName', ['银行类型', '']], ['bankName', ['开户支行', '']], ['bankAccount', ['银行账号', '']], ['bankAccountName', ['银行用户名', '']], ['invoiceHead', ['发票抬头', '']], ['invoiceAddress', ['发票地址', '']], ['settlementMark', ['结算标记', '']], ['payShopLevel', ['结算级别', '']], ['settlementCompanyName', ['结算公司', '']], ['payMode', ['付款方式', '']], ['isPrePay', ['是否预付款', '']], ['invoiceWayName', ['发票方式', '']], ['buyLevel', ['采购级别', '']], ['supplierFlag', ['父子供应商', '']], ['fatherSupplierName', ['父供应商', '']], ['isFrozenPay', ['冻结付款', '']]];
var PURCHASE_MAP = [// 采购信息
['businessMode', ['经营方式', '']], ['orderMode', ['出单方式', '']], ['minimumAmount', ['起定金额', '']], ['minimumCount', ['起订量', '']], ['effectiveDays', ['有效天数', '']], ['isReturn', ['允许退货', '']]];
/**
 * 字段字典
 */

var getDataList = (params, fieldConfig) => {
  if (fieldConfig !== null && fieldConfig !== void 0 && fieldConfig.length) {
    var _configObj$;

    var configObj = fieldConfig.filter(c => c.key === params.replace(/^\S/, s => s.toUpperCase()));
    return (_configObj$ = configObj[0]) === null || _configObj$ === void 0 ? void 0 : _configObj$.configMap;
  }

  return {};
};

var DICTIONARY = fieldConfig => {
  // item: fieldConfig
  return [{
    key: 'SupplierCategory',
    configMap: {
      '1': '采购供应商',
      '2': '农户供应商',
      '3': '个人供应商'
    }
  }, {
    key: 'IsInternalSupplier',
    configMap: {
      '1': '是',
      '2': '否'
    }
  }, {
    key: 'SupplierType',
    configMap: {
      '1': '经销商',
      '2': '代理商',
      '3': '生产商',
      '4': '其他'
    }
  }, {
    key: 'SupplierStatus',
    configMap: {
      '1': '正常',
      '2': '撤场'
    }
  }, {
    key: 'CompanyType',
    configMap: {
      '1': '国有',
      '2': '有限责任公司',
      '3': '股份有限公司',
      '4': '外商及港澳台投资企业',
      '5': '其他'
    }
  }, {
    key: 'TaxLevel',
    configMap: {
      '1': '一般',
      '2': '小规模',
      '3': '农业生产单位',
      '4': '农业生产自然人'
    }
  }, {
    key: 'SettlementMark',
    configMap: {
      '1': '全国结算',
      '2': '大区结算',
      '3': '地点结算'
    }
  }, {
    key: 'PayShopLevel',
    configMap: {
      '1': '集团总部',
      '2': '业态总部',
      '3': '区域公司',
      '4': '区域子公司',
      '5': '门店'
    }
  }, {
    key: 'PayMode',
    configMap: {
      '1': '网银',
      '2': '现金',
      '3': '支票',
      '4': '承兑'
    }
  }, // {
  //   key: 'invoiceWayName',
  //   configMap: {
  //     '1': '普通发票',
  //     '2': '增值税专用发票13%(收购)',
  //     '3': '增值税专用发票6%',
  //     '4': '增值税专用发票10%',
  //     '5': '增值税专用发票3%(税务代开)',
  //     '6': '增值税普通发票',
  //     '7': '增值税专用发票16%',
  //     '8': '增值税专用发票13%'
  //   }
  // },
  {
    key: 'BuyLevel',
    configMap: {
      '1': '统采',
      '2': '地采',
      '3': '联采'
    }
  }, {
    key: 'BusinessMode',
    configMap: {
      '1': '经销',
      '2': '代销',
      '3': '联营',
      '8': 'POP'
    } // configMap: getDataList('BusinessMode', fieldConfig)

  }, {
    key: 'ApproveStatus',
    configMap: {
      '0': '新建',
      '1': '草稿',
      '2': '作废',
      '3': '待审核',
      '4': '生效'
    }
  }, {
    key: 'IsPrePay',
    configMap: {
      '1': '是',
      '2': '否'
    }
  }, {
    key: 'ContactType',
    configMap: {
      '1': '业务人员',
      '2': '接单人员'
    }
  }, {
    key: 'IsFrozenPay',
    configMap: {
      '1': '是',
      '2': '否'
    }
  }, {
    key: 'OrderMode',
    configMap: {
      '1': '网上订单',
      '2': '电子订单',
      '3': '手工订单'
    }
  }, {
    key: 'IsReturn',
    configMap: {
      '1': '是',
      '2': '否'
    }
  }, {
    key: 'SupplierFlag',
    configMap: {
      '1': '父供应商',
      '2': '子供应商',
      '3': '普通'
    }
  }, {
    key: 'BdSupplierFlag',
    configMap: {
      '0': '否',
      '1': '是',
      '2': '否'
    }
  }];
};

/***/ }),

/***/ 14922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2824);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var fine_username = js_cookie__WEBPACK_IMPORTED_MODULE_0___default().get('mobile');

function index(_ref) {
  var src = _ref.src;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)('#javascript'),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)(_useState, 2),
      url = _useState2[0],
      setsrc = _useState2[1];

  var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  var content = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  var isFirstLoad = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(-1);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    var element = document.createElement('iframe');
    ref.current.appendChild(element);
    element.contentWindow.location = "https://data.ypshengxian.com/webroot/decision/login/cross/domain?fine_username=" + fine_username + "&fine_password=" + 123456 + "&validity=" + -1 + "&callback=callback";

    element.onload = () => {
      ref.current.contentWindow.location = "".concat(src, "&FINE_USERNAME=").concat(fine_username);
    };
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    ref: content,
    style: {
      width: '100%',
      height: '100%',
      background: '#fff',
      paddingBottom: 20
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("iframe", {
    ref: ref,
    style: {
      width: '100%',
      height: '100%',
      border: 'none'
    },
    src: "#javascript"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (index);

/***/ }),

/***/ 23207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "xr": function() { return /* binding */ fetchOperationGroup; },
/* harmony export */   "ln": function() { return /* binding */ appList; },
/* harmony export */   "We": function() { return /* binding */ packagePage; },
/* harmony export */   "HU": function() { return /* binding */ packageSave; },
/* harmony export */   "DU": function() { return /* binding */ packageEdit; },
/* harmony export */   "qb": function() { return /* binding */ versionRecord; },
/* harmony export */   "OT": function() { return /* binding */ publishEdit; },
/* harmony export */   "Cw": function() { return /* binding */ versionById; },
/* harmony export */   "nY": function() { return /* binding */ publish; },
/* harmony export */   "ww": function() { return /* binding */ warehouseList; },
/* harmony export */   "ni": function() { return /* binding */ shopList; },
/* harmony export */   "sk": function() { return /* binding */ deviceList; },
/* harmony export */   "Gr": function() { return /* binding */ deviceShopListByGroup; },
/* harmony export */   "Lh": function() { return /* binding */ userList; }
/* harmony export */ });
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3182);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24731);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_1__);




/**
 * 查询最新运营组
 */

function fetchOperationGroup() {
  return _fetchOperationGroup.apply(this, arguments);
}
/**
 * 应用列表
 */

function _fetchOperationGroup() {
  _fetchOperationGroup = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)().mark(function _callee() {
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_0__/* .default */ .Z)('auth.data.queryDataByResourceType', {
              operationGroupId: "",
              tenantId: "1",
              resourceTypeList: ["OPERATION_GROUP"],
              subjectId: js_cookie__WEBPACK_IMPORTED_MODULE_1___default().get('subjectId'),
              status: 1
            }).then(_ref => {
              var success = _ref.success,
                  result = _ref.result;

              if (success) {
                var resourceList = result.resourceList;
                var arr = resourceList && resourceList.map(item => ({
                  value: item.identity,
                  label: item.resourceName
                }));
                return arr;
              } else {
                return [];
              }
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchOperationGroup.apply(this, arguments);
}

var appList = 'ypsx.terminal.client.TerminalAppService.appList';
/**
 * 终端应用版本包
 */

var packagePage = 'ypsx.terminal.client.AppPackageService.packagePage';
var packageSave = 'ypsx.terminal.client.AppPackageService.packageSave';
var packageEdit = 'ypsx.terminal.client.AppPackageService.packageEdit';
/**
 * 版本发布记录
 */

var versionRecord = 'ypsx.terminal.version.PublishService.versionPage';
var publishEdit = 'ypsx.terminal.version.PublishService.publishEdit';
var versionById = 'ypsx.terminal.version.PublishService.versionById';
var publish = 'ypsx.terminal.version.PublishService.publish';
/**
 * 仓库、门店、pos、会员
 */

var warehouseList = 'owl.warehouse.queryList';
var shopList = 'owl.shop.queryShopList';
var deviceList = 'ypsx.pos.device.v1.DeviceService.ListDevices';
var deviceShopListByGroup = 'ypsx.pos.merchant.v1.ShopService.ListShops';
var userList = 'auth.StaffService.pageStaffInfo';

/***/ }),

/***/ 49309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z_": function() { return /* binding */ GOODS_IMPORT; },
/* harmony export */   "Jg": function() { return /* binding */ CUSTOMER_CODE_LIST; },
/* harmony export */   "Lv": function() { return /* binding */ CUSTOMER_INFO_LIST; },
/* harmony export */   "tA": function() { return /* binding */ CUSTOMER_SAVE; },
/* harmony export */   "wS": function() { return /* binding */ CUSTOMER_DETAIL; },
/* harmony export */   "YD": function() { return /* binding */ SALES_SAVE; },
/* harmony export */   "CH": function() { return /* binding */ SALES_INFO_LIST; },
/* harmony export */   "M0": function() { return /* binding */ SALES_CANCEL; },
/* harmony export */   "w7": function() { return /* binding */ SALES_DETAIL; },
/* harmony export */   "VT": function() { return /* binding */ SALES_DETAIL_LIST; },
/* harmony export */   "dI": function() { return /* binding */ DOWNLOAD_TEMPLATE; },
/* harmony export */   "Iy": function() { return /* binding */ SALES_DELETE; },
/* harmony export */   "T2": function() { return /* binding */ SALES_DETAIL_LIST_STAT; },
/* harmony export */   "Eo": function() { return /* binding */ SALES_PRICE_CONFIG; },
/* harmony export */   "SS": function() { return /* binding */ SALES_EXPORT_ORDER; },
/* harmony export */   "hb": function() { return /* binding */ SALES_BATCH_DRIVE; },
/* harmony export */   "pX": function() { return /* binding */ SALES_EXPORT_WHOLE_DATA; },
/* harmony export */   "QY": function() { return /* binding */ SALES_COMMIT_DATA; },
/* harmony export */   "I0": function() { return /* binding */ PRE_ORDER_SAVE; },
/* harmony export */   "ui": function() { return /* binding */ PRE_ORDER_DETAIL_SAVE; },
/* harmony export */   "NP": function() { return /* binding */ PRE_ORDER_LIST; },
/* harmony export */   "zd": function() { return /* binding */ PRE_ORDER_DETAIL; },
/* harmony export */   "E3": function() { return /* binding */ PRE_ORDER_DETAIL_LIST; },
/* harmony export */   "ZI": function() { return /* binding */ PRE_CLEAN_DETAIL_LIST; },
/* harmony export */   "yT": function() { return /* binding */ PRE_IMPORT; },
/* harmony export */   "ZW": function() { return /* binding */ PRE_ORDER_CANCEL; },
/* harmony export */   "$E": function() { return /* binding */ PRE_ORDER_DETAIL_STAT; },
/* harmony export */   "I6": function() { return /* binding */ PRE_SALES_LIST; },
/* harmony export */   "iD": function() { return /* binding */ PRE_ORDER_DELETE; },
/* harmony export */   "xx": function() { return /* binding */ PRE_CHANGE_PRICE; },
/* harmony export */   "UD": function() { return /* binding */ PRE_REFERENCE_PRICE; },
/* harmony export */   "FP": function() { return /* binding */ PRE_SUBMIT_ORDER; }
/* harmony export */ });
/* unused harmony exports GOODS_LIST, SALES_RECEIPT, SALES_SUBMIT, PRE_ORDER_SUBMIT */
// 商品信息导入
var GOODS_IMPORT = 'purchase.wholesale.importWholesaleOrderDetail'; // 商品查询

var GOODS_LIST = 'purchase.wholesale.queryWholesaleGoodsList'; // 客户信息下拉列表

var CUSTOMER_CODE_LIST = 'purchase.wholesale.queryCustomerInformationCodeList'; // 客户信息列表

var CUSTOMER_INFO_LIST = 'purchase.wholesale.queryCustomerInformationList'; // 客户信息新增/修改

var CUSTOMER_SAVE = 'purchase.wholesale.createOrModifyCustomerInformation'; // 客户信息详情

var CUSTOMER_DETAIL = 'purchase.wholesale.queryCustomerInformationDetail'; // 批发销售WMS出库/入库流水回传

var SALES_RECEIPT = 'purchase.wholesale.salesIssueReceiptNotice'; // 批发销售订单保存

var SALES_SAVE = 'purchase.wholesale.createOrModifyWholesaleManageOrder'; // 批发销售订单列表查询

var SALES_INFO_LIST = 'purchase.wholesale.queryWholesaleManageOrderList'; // 批发销售订单提交

var SALES_SUBMIT = 'purchase.wholesale.commitWholesaleManageOrder'; // 批发销售订单撤销

var SALES_CANCEL = 'purchase.wholesale.cancelWholesaleManageOrder'; // 批发销售订单详情

var SALES_DETAIL = '/scm/WholesaleOrderQueryService/orderDetail'; // 批发销售订单商品列表

var SALES_DETAIL_LIST = 'purchase.wholesale.queryWholesaleManageOrderDetail'; // 下载模板

var DOWNLOAD_TEMPLATE = 'purchase.downlaod.getTemplate'; // 删除商品

var SALES_DELETE = 'purchase.wholesale.deleteWholesaleManageOrderDetail'; // 批发销售统计

var SALES_DETAIL_LIST_STAT = 'purchase.wholesale.queryWholesalePriceQuantityCount'; // 获取批发销售的价格配置服务

var SALES_PRICE_CONFIG = 'purchase.wholesale.wholesalePriceConfig'; // 合并导出

var SALES_EXPORT_ORDER = 'purchase.wholesale.mergeExportWholesaleManageOrder'; // 批量发车

var SALES_BATCH_DRIVE = 'scm.wholesale.createTransferOrPurchaseOrder'; // 全部导出

var SALES_EXPORT_WHOLE_DATA = 'scm.wholesale.exportAllOrder'; //价格防呆监测

var SALES_COMMIT_DATA = 'purchase.wholesale.commitWholesaleManageOrder';
/**
 * 分配单
 */
// 批发销售分配单主单保存接口

var PRE_ORDER_SAVE = 'purchase.require.saveOrModifyWholesaleManagePreprocessOrder'; // 批发销售分配单详情保存接口

var PRE_ORDER_DETAIL_SAVE = 'purchase.require.modifyWholesaleManagePreprocessOrderDetail'; // 批发销售分配单列表查询接口

var PRE_ORDER_LIST = 'purchase.require.queryWholesaleManagePreprocessOrderList'; // 批发销售分配单查询主单详情接口

var PRE_ORDER_DETAIL = 'purchase.require.queryWholesaleManagePreprocessOrderDetail'; // 批发销售单明细列表接口

var PRE_ORDER_DETAIL_LIST = 'purchase.require.queryWholesaleManagePreprocessOrderDetailList'; // 批发销售单清空

var PRE_CLEAN_DETAIL_LIST = 'purchase.require.clearWholesaleManagePreprocessOrderLine'; // 批发销售单提交

var PRE_ORDER_SUBMIT = 'purchase.require.submitWholesaleManagePreprocessOrder'; // 批发销售单导入

var PRE_IMPORT = 'purchase.require.importWholesaleManagePreprocessOrderLine'; // 批发销售分配单作废接口

var PRE_ORDER_CANCEL = 'purchase.require.cancelWholesaleManagePreprocessOrder'; // 批发分配单明细查询

var PRE_ORDER_DETAIL_STAT = 'purchase.require.statWholesaleManagePreprocessOrderInfo'; // 批发分配单号获取批发列表

var PRE_SALES_LIST = 'purchase.wholesale.queryWholesaleManageOrders'; // 批发分配单删除明细

var PRE_ORDER_DELETE = 'purchase.require.deleteWholesaleManagePreOrderDetail'; // 批发分配单是否能改价

var PRE_CHANGE_PRICE = 'purchase.require.wholesalePrePriceConfig'; // 批发分配单参考价

var PRE_REFERENCE_PRICE = 'purchase.require.queryWholesalePreReferencePrice'; // 批发分配单防呆

var PRE_SUBMIT_ORDER = 'purchase.require.submitWholesaleManagePreprocessOrder';

/***/ }),

/***/ 41542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(57016);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(71577);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8870);
/* harmony import */ var antd_es_select_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43358);
/* harmony import */ var antd_es_select__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34041);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71720);
/* harmony import */ var _components_FormBuilder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5670);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24731);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7704);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96534);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(49309);
/* harmony import */ var _hooks_useCustomer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53421);
/* harmony import */ var yp_frontend_library_lib_EnhanceTable__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39200);













/**
 * 商家商品
 */









var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 10
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 14
    }
  }
};

function GoodsEditableModal(props) {
  var formData = props.formData;
  var merchantId = formData.merchantId,
      firstCategoryId = formData.firstCategoryId,
      secondCategoryId = formData.secondCategoryId;
  console.log("*********" + firstCategoryId);
  var ext = {};

  if (firstCategoryId == undefined || firstCategoryId == 0) {
    ext = {
      "placeScopes": 1
    };
  } else if (secondCategoryId == undefined || secondCategoryId == 0) {
    ext = {
      "firstCategoryId": firstCategoryId
    };
  }

  var _useMapping = (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)([5, 40], ext),
      mappingList = _useMapping.mappingList; // 商家下拉数据


  var merchantList = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => {
    return (mappingList === null || mappingList === void 0 ? void 0 : mappingList.get(40)) || [];
  }, [mappingList]);
  var placeList = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => {
    var obj = merchantList.find(v => v.value === +formData.merchantId);

    if (!obj) {
      return [];
    } else {
      var _obj$others;

      var list = ((_obj$others = obj.others) === null || _obj$others === void 0 ? void 0 : _obj$others.placeVos) || [];
      return list.map(v => ({
        label: v.placeName,
        value: v.placeId,
        others: v
      }));
    }
  }, [formData.merchantId, merchantList]);
  console.log("----" + placeList.length); // 默认查询参数

  var defaultSearchParams = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => ({
    billType: formData.orderType === 1 ? 19 : 20,
    // 销售-19。退货-20
    condition: {
      merchantId,
      firstCategoryId,
      secondCategoryId
    }
  }), [merchantId, formData.orderType]);
  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_11__/* .useDispatch */ .I0)();
  var table = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
  var form = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null); // 能否关闭浮层

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState, 2),
      canClose = _useState2[0],
      setCanClose = _useState2[1]; // 判断多个请求之后状态


  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState3, 2),
      queryState = _useState4[0],
      setQuery = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(defaultSearchParams),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState5, 2),
      searchParams = _useState6[0],
      setSearchParams = _useState6[1]; // 客户名称


  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(''),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState7, 2),
      customerName = _useState8[0],
      setCustomerName = _useState8[1];

  var placeId = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => searchParams.condition.placeId, [searchParams.condition.placeId]);
  var secondId = isNaN(+secondCategoryId) ? undefined : +secondCategoryId;

  var _useCustomer = (0,_hooks_useCustomer__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(customerName),
      _useCustomer2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useCustomer, 1),
      customerList = _useCustomer2[0];

  var formfields = [{
    label: '地点',
    name: 'placeId',
    required: true,
    widget: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
      showSearch: true,
      placeholder: "\u8BF7\u9009\u62E9\u5730\u70B9",
      dropdownMatchSelectWidth: false,
      filterOption: (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }, placeList === null || placeList === void 0 ? void 0 : placeList.map(v => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_select__WEBPACK_IMPORTED_MODULE_13__/* .default.Option */ .Z.Option, {
      value: v.value || '',
      key: v.value
    }, "".concat(v.others.placeCode, "-").concat(v.label))))
  }, {
    label: '客户',
    name: 'customerNo',
    type: 'SELECT',
    dataList: customerList || [],
    required: true,
    fieldOptions: {
      onSearch: v => setCustomerName(v)
    }
  }, {
    label: '商品模糊',
    name: 'queryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '商品精准',
    name: 'accurateQueryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '商品品类',
    name: 'secondCategoryId',
    type: 'SELECT',
    dataList: mappingList.get(5),
    initialValue: secondId === 0 || !secondId ? undefined : secondId,
    fieldOptions: {
      disabled: !!secondId
    }
  }, {
    label: '品牌名称',
    name: 'brandName',
    type: 'INPUT'
  }];
  var columns = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => [{
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 90
  }, {
    title: '商品条码',
    dataIndex: 'goodsBarCode',
    key: 'goodsBarCode',
    width: 140
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 170
  }, {
    title: '二类类目',
    dataIndex: 'secondCategoryName',
    key: 'secondCategoryName',
    width: 100
  }, {
    title: '品牌名称',
    dataIndex: 'brandName',
    key: 'brandName',
    width: 110
  }, {
    title: '单位',
    dataIndex: 'specUnit',
    key: 'specUnit',
    align: 'right',
    width: 80
  }, {
    title: '数量',
    dataIndex: 'planQty',
    key: 'planQty',
    width: 150,
    type: 'INPUT',
    fieldOptions: r => {
      // 非称重商品为正整数，称重商品保留三位小数
      var isWeight = r.isWeigh === 1;
      return {
        formatter: value => isWeight ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_8__/* .exchageToNum3 */ .hY)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_8__/* .exchageToNum1 */ .Ly)(value)
      };
    },
    render: (t, r) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
        style: {
          flex: 1
        }
      }, t), r.barCodeUnit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", null, "/", r.barCodeUnit));
    }
  }, {
    title: '参考价',
    dataIndex: 'referencePrice',
    key: 'referencePrice',
    width: 110,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " \u5143").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '批发单价(含税)',
    dataIndex: 'tradeSpecificationPrice',
    key: 'tradeSpecificationPrice',
    width: 160,
    align: 'right',
    type: r => r.allowChangePrice ? 'INPUT' : undefined,
    fieldOptions: {
      formatter: _utils_common__WEBPACK_IMPORTED_MODULE_8__/* .exchageToNum3 */ .hY
    },
    render: (t, r) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start'
        }
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
        style: {
          flex: 1
        }
      }, t), r.basicUnit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", null, "\u5143/", r.basicUnit));
    }
  }, {
    title: '批发总金额(含税)',
    dataIndex: 'planPrice',
    key: 'planPrice',
    width: 160,
    type: r => r.allowChangePrice ? 'INPUT' : undefined,
    fieldOptions: {
      formatter: _utils_common__WEBPACK_IMPORTED_MODULE_8__/* .exchageToNum3 */ .hY
    }
  }, {
    title: '库存量',
    dataIndex: 'stock',
    key: 'stock',
    width: 110,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " ").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '规格描述',
    dataIndex: 'specDesc',
    key: 'specDesc',
    align: 'right',
    width: 90,
    render: t => t || '-'
  }], []);
  var searchHandler = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)((state, values) => {
    if (state === 'error') return;
    setSearchParams(v => {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, v), {}, {
        condition: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, v.condition), values)
      });
    });
  }, []);
  var resetFields = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(() => {
    var _form$current;

    (_form$current = form.current) === null || _form$current === void 0 ? void 0 : _form$current.validateFields();
  }, []); // 获取参考价和库存，并更新列表数据

  var afterTableRequest = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee(dataList) {
      var _res$0$result, _res$, _res$1$list, _res$2, _res$2$result;

      var _dataList$reduce, referList, extList, referenceParams, extInfoParams, requestArr, res, referenceList, stockList, allowList, maps, stockMaps, allowMaps;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _dataList$reduce = dataList.reduce((pre, next) => {
                return {
                  referList: pre.referList.concat({
                    placeId: next.placeId,
                    goodsId: next.goodsId,
                    placeCode: next.placeCode
                  }),
                  extList: pre.extList.concat({
                    merchantId,
                    placeId,
                    goodsId: next.goodsId
                  })
                };
              }, {
                referList: [],
                extList: []
              }), referList = _dataList$reduce.referList, extList = _dataList$reduce.extList;
              console.log(referList); // 参考价的请求参数

              referenceParams = {
                merchantId,
                goodsList: referList
              }; // 库存等数据参数

              extInfoParams = {
                needPlaceStock: true,
                param: extList
              }; // 如果当前页面类型是批发销售时，需要额外发送接口请求特定的数据

              requestArr = [(0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_17__/* .PRE_REFERENCE_PRICE */ .UD, referenceParams), dispatch({
                type: 'purchase/queryProductExtInfo',
                payload: extInfoParams
              }), (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_17__/* .PRE_CHANGE_PRICE */ .xx, {
                merchantId,
                placeId: [placeId]
              })];
              _context.next = 7;
              return Promise.all(requestArr);

            case 7:
              res = _context.sent;
              // 参考价list
              referenceList = (_res$0$result = (_res$ = res[0]) === null || _res$ === void 0 ? void 0 : _res$.result) !== null && _res$0$result !== void 0 ? _res$0$result : []; // 库存list

              stockList = (_res$1$list = (_res$2 = res[1]) === null || _res$2 === void 0 ? void 0 : _res$2.list) !== null && _res$1$list !== void 0 ? _res$1$list : []; // 能否改价

              allowList = (_res$2$result = res[2].result) !== null && _res$2$result !== void 0 ? _res$2$result : []; // 获取商品编码与参考价的映射

              maps = referenceList.reduce((pre, next) => {
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, pre), {}, {
                  [next.goodsId]: {
                    referencePrice: next.referencePrice
                  }
                });
              }, {}); // 库存等

              stockMaps = stockList.reduce((pre, next) => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, pre), {}, {
                [next.goodsId]: {
                  stock: next.stock
                }
              }), {});
              allowMaps = allowList.reduce((pre, next) => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, pre), {}, {
                [next.placeId]: {
                  allowChangePrice: next.allowChangePrice
                }
              }), {}); // 给「goodsId」对应的数据设置参考价

              return _context.abrupt("return", dataList.map(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, v), maps[v.goodsId]), stockMaps[v.goodsId]), allowMaps[v.placeId])));

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [dispatch, merchantId, placeId]);
  /**
   * 改变表格内容时，触发保存
   */

  var saveRowCallback = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee2(data) {
      var currentCell, currentRow, currentRowOldData, planPrice, id, goodsName, planQty, goodsId, goodsBarCode, placeCode, tradeSpecificationPrice, params, res, newRow;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currentCell = data.currentCell, currentRow = data.currentRow, currentRowOldData = data.currentRowOldData;

              if (currentRow['planQty']) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              // setUpdateDataSource([])
              // if (Number(currentRow['tradeSpecificationPrice']) === 0 || Number(currentRow['planPrice']) === 0) {
              //   message.warning('单价/金额不可为0')
              //   return
              // }
              setQuery(prev => {
                return prev + 1;
              });
              planPrice = currentCell['planPrice']; // 当前编辑是计划商品金额时，

              id = currentRow.id, goodsName = currentRow.goodsName, planQty = currentRow.planQty, goodsId = currentRow.goodsId, goodsBarCode = currentRow.goodsBarCode, placeCode = currentRow.placeCode, tradeSpecificationPrice = currentRow.tradeSpecificationPrice;
              params = {
                id,
                planQty,
                preprocessOrderNo: formData.preprocessOrderNo,
                placeCode,
                customerNo: searchParams.condition.customerNo,
                goodsId,
                goodsBarCode,
                tradeSpecificationPrice: planPrice ? undefined : tradeSpecificationPrice,
                planPrice: planPrice ? planPrice : undefined,
                isSpecifiedPrice: Number(tradeSpecificationPrice) === 0 || Number(tradeSpecificationPrice) > 0 || Number(planPrice) === 0 || Number(planPrice) > 0 ? 1 : 0 // isSpecifiedPrice： 1-指定价格，0-不指定价格

              };
              _context2.next = 9;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_17__/* .PRE_ORDER_DETAIL_SAVE */ .ui, params);

            case 9:
              res = _context2.sent;
              setQuery(prev => {
                return prev - 1;
              });

              if (!res.success) {
                _context2.next = 17;
                break;
              }

              antd_es_message__WEBPACK_IMPORTED_MODULE_18__.default.success("".concat(id ? '修改' : '添加', "\u5546\u54C1\u3010").concat(goodsName, "\u3011\u6210\u529F"));

              newRow = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, currentRow), res === null || res === void 0 ? void 0 : res.result);
              return _context2.abrupt("return", newRow);

            case 17:
              return _context2.abrupt("return", currentRowOldData);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [formData.preprocessOrderNo, searchParams.condition.customerNo]);
  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    if (queryState === 0) {
      setCanClose(true);
    } else {
      setCanClose(false);
    }
  }, [queryState]); // 关闭的函数

  var closeProgramFun = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(() => {
    console.log('33333');

    if (canClose) {
      props.closeModalCallback();
    }
  }, [canClose]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z, {
    title: "\u5546\u54C1\u9009\u62E9",
    destroyOnClose: true,
    maskClosable: false,
    width: 1200,
    visible: true,
    closable: false,
    onCancel: props.closeModalCallback,
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
      key: "back",
      disabled: !canClose,
      onClick: () => {
        closeProgramFun();
      }
    }, "\u5173\u95ED")]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_components_FormBuilder__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    ref: form,
    elements: formfields,
    callbackHandler: searchHandler,
    onReset: resetFields,
    formOptions: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, defaultFormItemLayout)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(yp_frontend_library_lib_EnhanceTable__WEBPACK_IMPORTED_MODULE_10__/* .default */ .ZP, {
    tableRef: table,
    cancelRequest: !placeId,
    searchParams: searchParams,
    columns: columns,
    requestUrl: "purchase.product.querySelectPlaceProductByCondition",
    saveRowCallback: saveRowCallback,
    afterRequest: afterTableRequest,
    scroll: {
      x: 1000,
      y: 400
    }
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (GoodsEditableModal);

/***/ }),

/***/ 61001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71577);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(57016);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(83987);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(90631);
/* harmony import */ var _components_Uploader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84843);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24731);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49309);
/* harmony import */ var _hooks_useLoopImportResult__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68406);
/* harmony import */ var _config_enums__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26715);










/* eslint-disable no-throw-literal */








function HandleBtn(props) {
  var formData = props.formData,
      canHandle = props.canHandle,
      hasGoods = props.hasGoods;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useState, 2),
      loopResult = _useState2[0],
      setLoopResult = _useState2[1];

  var _useLoopImportResult = (0,_hooks_useLoopImportResult__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)({
    businessType: _config_enums__WEBPACK_IMPORTED_MODULE_7__/* .enumPurchaseImportStatusType["批发分配单导入"] */ .Pb["批发分配单导入"],
    orderNo: formData.preprocessOrderNo,
    refreshCallback: successed => {
      if (successed) {
        props.afterHandle();
      }

      setLoopResult(false); // 重置状态
    }
  }, [loopResult]),
      _useLoopImportResult2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_useLoopImportResult, 2),
      btnLoading = _useLoopImportResult2[0],
      LoadingModal = _useLoopImportResult2[1]; // 下载模板


  var downloadTemplate = /*#__PURE__*/function () {
    var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee() {
      var res, downloadUrl;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_11__/* .DOWNLOAD_TEMPLATE */ .dI, {
                downloadType: 14
              });

            case 3:
              res = _context.sent;
              downloadUrl = res.result.downloadUrl;

              if (downloadUrl) {
                _context.next = 7;
                break;
              }

              throw '请求的文件不存在';

            case 7:
              window.location.href = downloadUrl;
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_12__.default.error(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    return function downloadTemplate() {
      return _ref.apply(this, arguments);
    };
  }();

  var changeUpload = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee2(val) {
      var params, res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              params = {
                preprocessOrderNo: formData.preprocessOrderNo,
                resId: val
              };
              _context2.next = 4;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_11__/* .PRE_IMPORT */ .yT, params);

            case 4:
              res = _context2.sent;

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_12__.default.success('导入任务添加成功');

                setLoopResult(true);
              }

              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_12__.default.error(_context2.t0);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    }));

    return function changeUpload(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var clearGood = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee3() {
      var res;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_11__/* .PRE_CLEAN_DETAIL_LIST */ .ZI, {
                preprocessOrderNo: formData.preprocessOrderNo
              });

            case 3:
              res = _context3.sent;

              if (res.success) {
                props.afterHandle();

                antd_es_message__WEBPACK_IMPORTED_MODULE_12__.default.success('清空商品成功');
              }

              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);

              antd_es_message__WEBPACK_IMPORTED_MODULE_12__.default.error(_context3.t0);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 7]]);
    }));

    return function clearGood() {
      return _ref3.apply(this, arguments);
    };
  }();

  var confirmModal = /*#__PURE__*/function () {
    var _ref4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().mark(function _callee4() {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              antd_es_modal__WEBPACK_IMPORTED_MODULE_13__/* .default.confirm */ .Z.confirm({
                title: '清空商品',
                icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z, null),
                content: '确认清空全部商品吗？',
                okText: '确认',
                cancelText: '取消',

                onOk() {
                  clearGood();
                }

              });

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function confirmModal() {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
    style: {
      marginRight: '16px'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_Uploader__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    tokenUrl: "scm.wholesale.getResourceToken",
    accept: ".xlsx,.xls",
    onChange: changeUpload,
    loading: btnLoading,
    btnText: "\u5BFC\u5165\u6279\u53D1\u5206\u914D\u5546\u54C1",
    uploadOptions: {
      showUploadList: false,
      disabled: !canHandle
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z, {
    className: "mRight16",
    onClick: downloadTemplate,
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z, null)
  }, "\u6279\u53D1\u5206\u914D\u6A21\u677F\u4E0B\u8F7D"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z, {
    danger: true,
    onClick: confirmModal,
    disabled: !hasGoods
  }, "\u6E05\u7A7A\u5546\u54C1"), LoadingModal);
}

/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_3__.memo)(HandleBtn));

/***/ }),

/***/ 69609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ useColumns; }
/* harmony export */ });
/* harmony import */ var antd_es_tag_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71153);
/* harmony import */ var antd_es_tag__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60331);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96534);
/* harmony import */ var _hooks_useCustomer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53421);







function useColumns(placeList) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useState, 2),
      customerName = _useState2[0],
      setCustomerName = _useState2[1];

  var _useCustomer = (0,_hooks_useCustomer__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)(customerName),
      _useCustomer2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(_useCustomer, 1),
      customerList = _useCustomer2[0];

  return [{
    title: '地点编码',
    dataIndex: 'placeCode',
    key: 'placeCode',
    width: 120
  }, {
    title: '地点名称',
    dataIndex: 'placeName',
    key: 'placeName',
    width: 200,
    ellipsis: true,
    type: 'SELECT',
    dataList: placeList,

    setCellRowValue(r, o) {
      var placeCode = o.rows.others.placeCode;
      console.log(placeCode);
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)({}, r), {}, {
        placeCode
      });
    }

  }, {
    title: '客户编码',
    dataIndex: 'customerNo',
    key: 'customerNo',
    width: 130
  }, {
    title: '客户名称',
    dataIndex: 'customerName',
    key: 'customerName',
    width: 200,
    ellipsis: true,
    type: 'SELECT',
    dataList: customerList,
    setCellRowValue: (r, o) => {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)({}, r), {}, {
        customerNo: o.value
      }); // 设置客户编码
    },
    fieldOptions: record => {
      return {
        onDropdownVisibleChange: visible => {
          if (visible) {
            setCustomerName(record.customerName);
          }
        },
        onSearch: v => setCustomerName(v)
      };
    }
  }, {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 160
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 100
  }, {
    title: '商品条码',
    dataIndex: 'goodsBarCode',
    key: 'goodsBarCode',
    width: 140
  }, {
    title: '单位',
    dataIndex: 'orderSpecificationUnit',
    key: 'orderSpecificationUnit',
    width: 70,
    align: 'right'
  }, {
    title: '参考价',
    dataIndex: 'referencePrice',
    key: 'referencePrice',
    width: 100,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " \u5143").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '批发价(含税)',
    dataIndex: 'tradeSpecificationPrice',
    key: 'tradeSpecificationPrice',
    width: 180,
    align: 'right',
    type: r => r.allowChangePrice ? 'INPUT' : undefined,
    // 标记为是可编辑
    fieldOptions: {
      formatter: _utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exchageToNum3 */ .hY
    },
    render: (t, r) => {
      var extraMsg = +r.tradeSpecificationPrice >= 1.5 * +r.referencePrice ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tag__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
        color: "red"
      }, "\u5355\u4EF7\u4E0D\u80FD\u5927\u4E8E\u7B49\u4E8E1.5\u500D\u53C2\u8003\u4EF7") : null;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'end'
        }
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        style: {
          flex: 1
        }
      }, t), r.basicUnit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, "\u5143/", r.basicUnit)), extraMsg);
    }
  }, {
    title: '计划数量',
    dataIndex: 'planQty',
    key: 'planQty',
    width: 150,
    type: 'INPUT',
    // 标记为是可编辑
    fieldOptions: r => {
      // 非称重商品为正整数，称重商品保留三位小数
      return {
        formatter: value => r.isWeigh ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exchageToNum3 */ .hY)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exchageToNum1 */ .Ly)(value)
      };
    },
    render: (t, r) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        style: {
          flex: 1
        }
      }, t), r.barCodeUnit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, "/", r.barCodeUnit));
    }
  }, {
    title: '计划商品金额(元)',
    dataIndex: 'planPrice',
    key: 'planPrice',
    width: 160,
    type: r => r.allowChangePrice ? 'INPUT' : undefined,
    fieldOptions: {
      formatter: _utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exchageToNum3 */ .hY
    }
  }, {
    title: '计划加点金额',
    dataIndex: 'planFreight',
    key: 'planFreight',
    width: 120
  }, {
    title: '税率',
    dataIndex: 'tax',
    key: 'tax',
    width: 90
  }, {
    title: '税额',
    dataIndex: 'taxes',
    key: 'taxes',
    width: 120
  }];
}

/***/ }),

/***/ 59806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(57016);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(71577);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(90636);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8870);
/* harmony import */ var antd_es_tag_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71153);
/* harmony import */ var antd_es_tag__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(60331);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var umi__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71720);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_FormBuilder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5670);
/* harmony import */ var _components_EditableTable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72927);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24731);
/* harmony import */ var _hooks_useMapping__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7704);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96534);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(49309);













/**
 * 商家商品
 */









var defaultFormItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 10
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 14
    }
  }
};

function GoodsEditableModal(props) {
  var allowChangePrice = props.allowChangePrice,
      formData = props.formData,
      billType = props.billType;
  var placeId = formData.placeId,
      merchantId = formData.merchantId,
      placeCode = formData.placeCode,
      firstCategoryId = formData.firstCategoryId,
      secondCategoryId = formData.secondCategoryId; // 默认查询参数

  var defaultSearchParams = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => ({
    billType,
    condition: {
      merchantId,
      placeId,
      firstCategoryId,
      secondCategoryId
    }
  }), [billType, firstCategoryId, merchantId, placeId, secondCategoryId]);
  var dispatch = (0,umi__WEBPACK_IMPORTED_MODULE_11__/* .useDispatch */ .I0)();
  var ext = {
    "firstCategoryId": firstCategoryId
  };

  var _ref = firstCategoryId != undefined && firstCategoryId != 0 && (secondCategoryId == undefined || secondCategoryId == 0) ? (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(5, ext) : (0,_hooks_useMapping__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z)(5),
      mappingList = _ref.mappingList;

  var table = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null); // 能否关闭浮层

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState, 2),
      canClose = _useState2[0],
      setCanClose = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(defaultSearchParams),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState3, 2),
      searchParams = _useState4[0],
      setSearchParams = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0),
      _useState6 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState5, 2),
      queryState = _useState6[0],
      setQuery = _useState6[1]; // 判断多个请求之后状态
  // 更新表格数据


  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]),
      _useState8 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z)(_useState7, 2),
      updateDataSource = _useState8[0],
      setUpdateDataSource = _useState8[1];

  var secondId = isNaN(+secondCategoryId) ? undefined : +secondCategoryId;
  var formfields = [{
    label: '商品模糊',
    name: 'queryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '商品精准',
    name: 'accurateQueryCriteria',
    type: 'INPUT',
    fieldOptions: {
      placeholder: '条码/名称/编码/PLU码'
    }
  }, {
    label: '商品品类',
    name: 'secondCategoryId',
    type: 'SELECT',
    dataList: mappingList.get(5),
    initialValue: secondId === 0 || !secondId ? undefined : secondId,
    fieldOptions: {
      disabled: !!secondId
    }
  }, {
    label: '品牌名称',
    name: 'brandName',
    type: 'INPUT'
  }];
  var columns = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => [{
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 170,
    fixed: true
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 90
  }, {
    title: '商品条码',
    dataIndex: 'goodsBarCode',
    key: 'goodsBarCode',
    width: 140
  }, {
    title: '二类类目',
    dataIndex: 'secondCategoryName',
    key: 'secondCategoryName',
    width: 100
  }, {
    title: '品牌名称',
    dataIndex: 'brandName',
    key: 'brandName',
    width: 110
  }, {
    title: '单位',
    dataIndex: 'specUnit',
    key: 'specUnit',
    align: 'right',
    width: 90
  }, {
    title: '数量',
    dataIndex: 'copies',
    key: 'copies',
    width: 150,
    editable: true,
    render: (t, r, i, fn) => {
      // 非称重商品为正整数，称重商品保留三位小数
      var isWeight = r.isWeigh === 1;

      if (fn) {
        var params = {
          fieldType: 'INPUT',
          fieldOptions: {
            formatter: value => isWeight ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_10__/* .exchageToNum3 */ .hY)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_10__/* .exchageToNum1 */ .Ly)(value)
          }
        };
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center'
          }
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
          style: {
            flex: 1
          }
        }, fn(params)), r.barCodeUnit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", null, "/", r.barCodeUnit));
      }

      return t;
    }
  }, {
    title: '参考价',
    dataIndex: 'costPrice',
    key: 'costPrice',
    width: 110,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " \u5143").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '批发单价(含税)',
    dataIndex: 'tradePrice',
    key: 'tradePrice',
    width: 160,
    editable: allowChangePrice,
    render: (t, r, i, fn) => {
      if (fn && allowChangePrice) {
        var extraMsg = +t < +r.costPrice ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_tag__WEBPACK_IMPORTED_MODULE_13__/* .default */ .Z, {
          color: "red"
        }, "\u6279\u53D1\u4EF7\u5C0F\u4E8E\u6210\u672C\u4EF7") : null;
        var params = {
          fieldType: 'INPUT',
          fieldOptions: {
            formatter: _utils_common__WEBPACK_IMPORTED_MODULE_10__/* .exchageToNum3 */ .hY
          }
        };
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start'
          }
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", {
          style: {
            flex: 1
          }
        }, fn(params)), r.basicUnit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement("div", null, "\u5143/", r.basicUnit)), extraMsg);
      }

      return r.basicUnit && !allowChangePrice && t ? "".concat(t, "\u5143/").concat(r.basicUnit) : t;
    }
  }, {
    title: '批发总金额(含税)',
    dataIndex: 'planPrice',
    key: 'planPrice',
    width: 170,
    editable: allowChangePrice,
    render: (t, r, i, fn) => {
      if (fn && allowChangePrice) {
        var params = {
          fieldType: 'INPUT',
          fieldOptions: {
            formatter: _utils_common__WEBPACK_IMPORTED_MODULE_10__/* .exchageToNum3 */ .hY
          }
        };
        return fn(params);
      }

      return t || '';
    }
  }, {
    title: '库存量',
    dataIndex: 'stock',
    key: 'stock',
    width: 110,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " ").concat(r.basicUnit ? '/' + r.basicUnit : '') : '-'
  }, {
    title: '规格描述',
    dataIndex: 'specDesc',
    key: 'specDesc',
    align: 'right',
    width: 90,
    render: t => t || '-'
  }], [allowChangePrice]);
  var searchHandler = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)((state, values) => {
    setSearchParams(v => {
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, v), {}, {
        condition: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, v.condition), values)
      });
    });
  }, []);
  var resetFields = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(() => {
    setSearchParams(defaultSearchParams);
  }, [defaultSearchParams]); // 获取参考价和库存，并更新列表数据

  var setTableDataAfterRequest = /*#__PURE__*/function () {
    var _ref2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee(dataList) {
      var _res$0$result$list, _res$, _res$$result, _res$1$list, _res$2;

      var referenceParams, extInfoParams, requestArr, res, referenceList, stockList, maps, stockMaps, dataSource;
      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 参考价的请求参数
              referenceParams = {
                merchantId,
                placeId,
                placeCode,
                goodsIds: dataList.map(v => +v.goodsId)
              }; // 库存等数据参数

              extInfoParams = {
                needPlaceStock: true,
                param: dataList.map(v => ({
                  merchantId: +merchantId,
                  placeId: +placeId,
                  goodsId: +v.goodsId
                }))
              }; // 如果当前页面类型是批发销售时，需要额外发送接口请求特定的数据

              requestArr = [dispatch({
                type: 'purchase/queryWholesaleReferencePrice',
                payload: referenceParams
              }), dispatch({
                type: 'purchase/queryProductExtInfo',
                payload: extInfoParams
              })];
              _context.next = 5;
              return Promise.all(requestArr);

            case 5:
              res = _context.sent;
              // 参考价list
              referenceList = (_res$0$result$list = (_res$ = res[0]) === null || _res$ === void 0 ? void 0 : (_res$$result = _res$.result) === null || _res$$result === void 0 ? void 0 : _res$$result.list) !== null && _res$0$result$list !== void 0 ? _res$0$result$list : []; // 库存list

              stockList = (_res$1$list = (_res$2 = res[1]) === null || _res$2 === void 0 ? void 0 : _res$2.list) !== null && _res$1$list !== void 0 ? _res$1$list : []; // 获取商品编码与参考价的映射

              maps = referenceList.reduce((pre, next) => {
                return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, pre), {}, {
                  [next.goodsId]: {
                    costPrice: next.referencePrice
                  }
                });
              }, {}); // 库存等

              stockMaps = stockList.reduce((pre, next) => {
                pre[next.goodsId] = {
                  stock: next.stock
                };
                return pre;
              }, {}); // 给「goodsId」对应的数据设置参考价

              dataSource = dataList.map(v => {
                return maps[v.goodsId] ? (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, v), maps[v.goodsId]), stockMaps[v.goodsId]) : v;
              });
              return _context.abrupt("return", dataSource);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function setTableDataAfterRequest(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * 改变表格内容时，触发保存
   */


  var changeTable = /*#__PURE__*/function () {
    var _ref3 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().mark(function _callee2(data) {
      var currentCell, currentRowOldData, currentRow, planPrice, requestObj, params, res, _res$result, newRow;

      return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_16__/* .default */ .Z)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              currentCell = data.currentCell, currentRowOldData = data.currentRowOldData, currentRow = data.currentRow;

              if (!lodash__WEBPACK_IMPORTED_MODULE_5___default().isEmpty(currentCell)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              if (currentRow['copies']) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return");

            case 5:
              // if (Number(currentRow['planPrice']) === 0 || Number(currentRow['tradePrice']) === 0) {
              //   message.warning('批发单价/批发金额不可为0')
              //   return
              // }
              planPrice = currentCell['planPrice']; // 当前编辑是计划商品金额时，

              requestObj = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, currentRow), {}, {
                planPrice: planPrice ? currentRow.planPrice : currentRow.tradePrice ? undefined : currentRow.planPrice,
                // 编辑的不是金额时，不传金额
                tradePrice: planPrice ? undefined : currentRow.tradePrice // 编辑的是金额的时候，批发价不传值

              }); // 不允许改价的时候，金额和批发单价都不传

              if (!allowChangePrice) {
                requestObj = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, requestObj), {}, {
                  planPrice: undefined,
                  tradePrice: undefined
                });
              }

              setQuery(prev => {
                return prev + 1;
              });
              params = {
                wholesaleManageInformation: formData,
                wholesaleManageOrderDetail: [{
                  id: currentRow.id,
                  goodsId: requestObj.goodsId,
                  goodsBarCode: requestObj.goodsBarCode,
                  goodsName: requestObj.goodsName,
                  tradePrice: requestObj.tradePrice,
                  copies: requestObj.copies,
                  planPrice: requestObj.planPrice,
                  isSpecifiedPrice: !!requestObj.planPrice || !!requestObj.tradePrice ? 1 : 0 // 单价或者金额有值时传1

                }]
              };
              _context2.next = 12;
              return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_8__/* .default */ .Z)(_Api__WEBPACK_IMPORTED_MODULE_17__/* .SALES_SAVE */ .YD, params);

            case 12:
              res = _context2.sent;
              setQuery(prev => {
                return prev - 1;
              });

              if (res.success) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_18__.default.success("".concat(currentRow.id ? '修改' : '添加', "\u5546\u54C1\u3010").concat(currentRow.goodsName, "\u3011\u6210\u529F"));

                newRow = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, currentRow), res === null || res === void 0 ? void 0 : (_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.wholesaleManageOrderDetail);
                setUpdateDataSource(arr => [...arr, newRow]);
              } else {
                setUpdateDataSource([(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, currentRow), currentRowOldData), {}, {
                  planPrice: undefined,
                  tradePrice: undefined,
                  copies: undefined
                })]);
              }

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function changeTable(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    if (queryState === 0) {
      setCanClose(true);
    } else {
      setCanClose(false);
    }
  }, [queryState]); // 关闭的函数

  var closeProgramFun = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(() => {
    console.log('33333');

    if (canClose) {
      props.closeModalCallback();
    }
  }, [canClose]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_19__/* .default */ .Z, {
    title: "\u5546\u54C1\u9009\u62E9",
    destroyOnClose: true,
    maskClosable: false,
    width: 1200,
    visible: true,
    closable: false,
    onCancel: props.closeModalCallback,
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_20__/* .default */ .Z, {
      key: "back",
      disabled: !canClose,
      onClick: () => {
        closeProgramFun();
      }
    }, "\u5173\u95ED")]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_components_FormBuilder__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z, {
    elements: formfields,
    callbackHandler: searchHandler,
    onReset: resetFields,
    formOptions: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_14__/* .default */ .Z)({}, defaultFormItemLayout)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.createElement(_components_EditableTable__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z, {
    ref: table,
    scrollYSize: 400,
    columns: columns,
    searchParams: searchParams,
    hideBtn: true,
    hideDeleteBtn: true,
    onChange: changeTable,
    queryDataUrl: "purchase.product.querySelectPlaceProductByCondition",
    tableOptions: {
      scroll: {
        y: 380
      }
    },
    updateDataSource: updateDataSource,
    setTableDataAfterRequest: setTableDataAfterRequest
  }));
}

/* harmony default export */ __webpack_exports__["default"] = (GoodsEditableModal);

/***/ }),

/***/ 8477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ useColumns; }
/* harmony export */ });
/* harmony import */ var antd_es_tag_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71153);
/* harmony import */ var antd_es_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60331);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96534);




function useColumns(allowChangePrice) {
  return [{
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 140,
    fixed: 'left'
  }, {
    title: '商品编码',
    dataIndex: 'goodsId',
    key: 'goodsId',
    width: 150
  }, {
    title: '商品条码',
    dataIndex: 'goodsBarCode',
    key: 'goodsBarCode',
    width: 170
  }, {
    title: '单位',
    dataIndex: 'orderSpecificationUnit',
    key: 'orderSpecificationUnit',
    width: 90
  }, {
    title: '成本价',
    dataIndex: 'costPrice',
    key: 'costPrice',
    width: 120,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " \u5143").concat(r.basicSpecificationUnit ? '/' + r.basicSpecificationUnit : '') : '-'
  }, {
    title: '批发单价(含税)',
    dataIndex: 'tradePrice',
    key: 'tradePrice',
    width: 160,
    align: 'right',
    editable: true,
    render: (t, r, i, fn) => {
      if (fn && allowChangePrice) {
        var params = {
          fieldType: 'INPUT',
          fieldOptions: {
            formatter: _utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exchageToNum3 */ .hY
          }
        };
        var extraMsg = '';

        if (+t < +r.costPrice) {
          extraMsg = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tag__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
            color: "red"
          }, "\u6279\u53D1\u4EF7\u5C0F\u4E8E\u6210\u672C\u4EF7");
        } else if (+t >= 1.5 * +r.costPrice) {
          extraMsg = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(antd_es_tag__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z, {
            color: "red"
          }, "\u5355\u4EF7\u4E0D\u80FD\u5927\u4E8E\u7B49\u4E8E1.5\u500D\u53C2\u8003\u4EF7");
        } else {
          extraMsg = '';
        }

        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start'
          }
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
          style: {
            flex: 1
          }
        }, fn(params)), r.basicSpecificationUnit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, "\u5143/", r.basicSpecificationUnit)), extraMsg);
      }

      return r.basicSpecificationUnit && !allowChangePrice ? "".concat(t, "\u5143/").concat(r.basicSpecificationUnit) : t;
    }
  }, {
    title: '当前库存',
    dataIndex: 'stock',
    key: 'stock',
    width: 120,
    align: 'right',
    render: (t, r) => t ? "".concat(t, " ").concat(r.basicSpecificationUnit ? '/' + r.basicSpecificationUnit : '') : '-'
  }, {
    title: '计划数量',
    dataIndex: 'copies',
    key: 'copies',
    width: 160,
    editable: true,
    render: (t, r, i, fn) => {
      var isWeight = r.isWeigh === 1;

      if (fn) {
        var params = {
          fieldType: 'INPUT',
          fieldOptions: {
            formatter: value => isWeight ? (0,_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exchageToNum3 */ .hY)(value) : (0,_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exchageToNum1 */ .Ly)(value)
          }
        };
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start'
          }
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
          style: {
            flex: 1
          }
        }, fn(params)), r.orderSpecificationUnit && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, "/", r.orderSpecificationUnit));
      }

      return t;
    }
  }, {
    title: '计划商品金额',
    dataIndex: 'planPrice',
    key: 'planPrice',
    width: 170,
    editable: true,
    render: (t, r, i, fn) => {
      if (fn && allowChangePrice) {
        var params = {
          fieldType: 'INPUT',
          fieldOptions: {
            formatter: _utils_common__WEBPACK_IMPORTED_MODULE_2__/* .exchageToNum3 */ .hY
          }
        };
        return fn(params);
      }

      return t;
    }
  }, {
    title: '计划加点金额',
    dataIndex: 'planFreight',
    key: 'planFreight',
    width: 120,
    render: t => t ? t : 0
  }, {
    title: '税率(%)',
    dataIndex: 'tax',
    key: 'tax',
    width: 70,
    render: (t, r) => {
      var _r$taxRate;

      var tax = (_r$taxRate = r.taxRate) !== null && _r$taxRate !== void 0 ? _r$taxRate : t;
      var number = +tax;

      if (isNaN(number)) {
        return '';
      }

      return number * 100;
    }
  }, {
    title: '税额',
    dataIndex: 'taxes',
    key: 'taxes',
    width: 120
  }];
}

/***/ }),

/***/ 87809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57016);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71577);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _components_FormBuilder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5670);
/* harmony import */ var _components_CommonTable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40934);
/* harmony import */ var _Api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49309);












var columns = [{
  title: '编号',
  dataIndex: 'customerNo',
  key: 'customerNo',
  width: 120
}, {
  title: '姓名',
  dataIndex: 'customerName',
  key: 'customerName',
  width: 130
}, {
  title: '手机号',
  dataIndex: 'customerTel',
  key: 'customerTel',
  width: 130
}, {
  title: '地址',
  dataIndex: 'detailedAddress',
  key: 'detailedAddress',
  width: 170
}];

function CustomerModal(props) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_useState, 2),
      selectedRows = _useState2[0],
      setSelectedRows = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({}, props.searchParams || {})),
      _useState4 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)(_useState3, 2),
      searchParams = _useState4[0],
      setSearchParams = _useState4[1];

  var selectedOne = selectedRows.length === 1;
  var searchHandler = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((state, values) => {
    setSearchParams(v => (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)((0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)({}, v), values));
  }, []);
  var rowSelectCallback = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((keys, rows) => {
    setSelectedRows(rows);
  }, []);

  var handleOk = () => {
    props.saveModalCallback(selectedRows);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (!selectedOne && !!selectedRows.length) {
      antd_es_message__WEBPACK_IMPORTED_MODULE_8__.default.warning('只能选择一位客户');
    }
  }, [selectedOne]);
  var formfields = [{
    label: '客户编码',
    name: 'customerNo',
    type: 'INPUT'
  }, {
    label: '客户名称',
    name: 'customerName',
    type: 'INPUT'
  }];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_modal__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, {
    title: "\u6DFB\u52A0\u5BA2\u6237",
    destroyOnClose: true,
    maskClosable: false,
    width: 1000,
    visible: true,
    onOk: handleOk,
    onCancel: props.closeModalCallback,
    footer: [/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z, {
      key: "close",
      onClick: props.closeModalCallback
    }, "\u5173\u95ED"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z, {
      key: "confirm",
      type: "primary",
      onClick: handleOk,
      disabled: !selectedOne
    }, "\u786E\u8BA4")]
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_FormBuilder__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
    elements: formfields,
    callbackHandler: searchHandler,
    onReset: searchHandler
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_components_CommonTable__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z, {
    scrollYSize: 400,
    columns: columns,
    searchParams: searchParams,
    queryDataUrl: _Api__WEBPACK_IMPORTED_MODULE_11__/* .CUSTOMER_CODE_LIST */ .Jg,
    rowSelectCallback: rowSelectCallback,
    tableOptions: {
      scroll: {
        y: 380
      },
      rowSelection: {
        type: 'radio'
      }
    }
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (CustomerModal);

/***/ }),

/***/ 22897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ wholesaleCustomerObj; }
/* harmony export */ });
// 字段名对应的映射
var wholesaleCustomerObj = {
  customerType: 27,
  status: 42,
  type: 29,
  settlementType: 28
};

/***/ }),

/***/ 84675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ wholesaleOrderObj; },
/* harmony export */   "h": function() { return /* binding */ exportUnHandleStatusMap; }
/* harmony export */ });
// 字段名对应的映射
var wholesaleOrderObj = {
  orderType: 32,
  deliverType: 31,
  orderSource: 30,
  payType: 33,
  status: 26,
  fakePlaceName: 3,
  // 故意设置假的配置
  type: 29,
  preStatus: 58,
  // 批发分配单状态
  merchantId: 40,
  // 权限下的商家
  category: 41,
  fakePlaceNameNotFilter: 84 // 所有的地点

}; // 这些状态的无法合并导出

var exportUnHandleStatusMap = [1, 2, 9];

/***/ }),

/***/ 93021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_es_upload_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43185);
/* harmony import */ var antd_es_upload__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3388);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91896);
/* harmony import */ var antd_es_button_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57663);
/* harmony import */ var antd_es_button__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71577);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3182);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24731);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(84391);














var UploadImg = props => {
  var _uploadPrograms$param;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    endPoint: '',
    // 上传地址
    resId: '',
    // 资源id
    params: {} // 上传附带的参数

  }),
      _useState2 = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* .default */ .Z)(_useState, 2),
      uploadPrograms = _useState2[0],
      setUploadPrograms = _useState2[1];

  var getTokenUrl = props.getTokenUrl,
      listType = props.listType,
      text = props.text,
      handleChange = props.handleChange,
      disabled = props.disabled,
      size = props.size;

  var beforeUpload = file => {
    //获取上传所需token，url
    return new Promise( /*#__PURE__*/function () {
      var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().mark(function _callee(resolve, reject) {
        var isLt2M, _yield$ypRider, result, success;

        return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_7__/* .default */ .Z)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!size) {
                  _context.next = 18;
                  break;
                }

                console.log(size);
                isLt2M = file.size / 1024 < size;

                if (isLt2M) {
                  _context.next = 8;
                  break;
                }

                antd_es_message__WEBPACK_IMPORTED_MODULE_8__.default.error("请上传大小不超过2M的图片");

                return _context.abrupt("return", reject(false));

              case 8:
                _context.next = 10;
                return (0,_utils_ypRequest__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)(getTokenUrl, {
                  fileName: file.name
                });

              case 10:
                _yield$ypRider = _context.sent;
                result = _yield$ypRider.result;
                success = _yield$ypRider.success;

                if (success) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return");

              case 15:
                setUploadPrograms(result); // 资源id

                file.uid = result.resId;
                resolve();

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  };

  var fileChange = file => {
    handleChange && handleChange(file, uploadPrograms);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_upload__WEBPACK_IMPORTED_MODULE_9__/* .default */ .Z, (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_10__/* .default */ .Z)({
    action: uploadPrograms.endpoint,
    listType: listType,
    beforeUpload: beforeUpload,
    onChange: fileChange,
    data: {
      token: uploadPrograms === null || uploadPrograms === void 0 ? void 0 : (_uploadPrograms$param = uploadPrograms.params) === null || _uploadPrograms$param === void 0 ? void 0 : _uploadPrograms$param.token
    }
  }, props), !disabled && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(antd_es_button__WEBPACK_IMPORTED_MODULE_11__/* .default */ .Z, {
    icon: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ant_design_icons__WEBPACK_IMPORTED_MODULE_12__/* .default */ .Z, null)
  }, text));
};

/* harmony default export */ __webpack_exports__["default"] = (UploadImg);

/***/ }),

/***/ 14382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fj": function() { return /* binding */ queryAllEvent; },
/* harmony export */   "H6": function() { return /* binding */ queryAllAddress; },
/* harmony export */   "L8": function() { return /* binding */ queryEventVisitList; },
/* harmony export */   "Fu": function() { return /* binding */ queryAddressVisitList; },
/* harmony export */   "dV": function() { return /* binding */ queryListByPage; },
/* harmony export */   "kM": function() { return /* binding */ getBizTypeList; },
/* harmony export */   "yj": function() { return /* binding */ getTaskStatusList; },
/* harmony export */   "q": function() { return /* binding */ exportPoint; },
/* harmony export */   "nu": function() { return /* binding */ generateUrl; }
/* harmony export */ });
// 查询所有事件
var queryAllEvent = 'dot.manager.queryAllEvent'; // 查询所有地址

var queryAllAddress = 'dot.manager.queryAllAddress'; // 查询事件访问列表

var queryEventVisitList = 'dot.manager.queryEventVisitList'; // 查询地址访问列表

var queryAddressVisitList = 'dot.manager.queryAddressVisitList'; // 查询导入导出任务列表信息

var queryListByPage = 'dot.importExport.queryListByPage'; // 查询业务类型

var getBizTypeList = 'dot.importExport.getBizTypeList'; // 获取任务状态集合

var getTaskStatusList = 'dot.importExport.getTaskStatusList'; // 导出任务创建接口

var exportPoint = 'dot.importExport.export'; // 根据返回的resId 获取文件

var generateUrl = 'ylp.md.resource.service.generateUrl';

/***/ }),

/***/ 28566:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var getUrlParams = (url, name) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i'); // 定义正则表达式

  var r = url.substr(1).match(reg);
  if (r !== null) return unescape(r[2]);
  return null;
};

var deepClone = function deepClone(obj) {
  var hash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new WeakMap();
  // 先把特殊情况全部过滤掉 null undefined date reg
  if (obj === null) return obj; // null 和undefine的都不理你

  if (typeof obj !== 'object') return obj;
  if (obj instanceof Date) return new Date(obj);
  if (obj instanceof RegExp) return new RegExp(obj); // [] {} 判断是数组还是对象
  // 判断类型    typeof instanceof constructor

  if (hash.has(obj)) {
    // 有拷贝后的直接返还即可
    return hash.get(obj); // 解决循环引用的问题
  }

  var instance = new obj.constructor(); // new 做了什么事 new实现原理

  hash.set(obj, instance); // 制作一个映射表
  // 把实例上的属性拷贝到这个对象身上 把原型链指向到原型对象上

  for (var key in obj) {
    // 递归拷贝
    if (obj.hasOwnProperty(key)) {
      // 不拷贝原型链上的属性
      instance[key] = deepClone(obj[key], hash);
    }
  }

  return instance;
};

/* harmony default export */ __webpack_exports__["Z"] = ({
  getUrlParams,
  deepClone
});

/***/ }),

/***/ 34749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ handleBalanceInsufficientError; }
/* harmony export */ });
/* unused harmony export showBalanceInsufficientModal */
/* harmony import */ var antd_es_table_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66456);
/* harmony import */ var antd_es_table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97423);
/* harmony import */ var antd_es_modal_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71194);
/* harmony import */ var antd_es_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57016);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var columns = [{
  title: '门店编码',
  dataIndex: 'storeCode',
  key: 'storeCode',
  width: 120
}, {
  title: '门店名称',
  dataIndex: 'storeName',
  key: 'storeName',
  width: 180
}, {
  title: '报错信息',
  dataIndex: 'errorMessage',
  key: 'errorMessage'
}];
/**
 * 展示货款余额不足门店明细弹窗（表格 + 错误文件下载）
 */

function showBalanceInsufficientModal(payload) {
  var message = payload.message,
      stores = payload.stores,
      errorFileUrl = payload.errorFileUrl;

  antd_es_modal__WEBPACK_IMPORTED_MODULE_3__/* .default.error */ .Z.error({
    title: '货款余额不足',
    width: 720,
    okText: '我知道了',
    content: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, message ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("p", {
      style: {
        marginBottom: 12
      }
    }, message) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(antd_es_table__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z, {
      rowKey: (row, index) => "".concat(row.storeCode || '', "-").concat(index),
      columns: columns,
      dataSource: stores,
      pagination: false,
      size: "small",
      scroll: {
        y: 320
      }
    }), errorFileUrl ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
      style: {
        marginTop: 12
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("a", {
      href: errorFileUrl,
      target: "_blank",
      rel: "noreferrer"
    }, "\u4E0B\u8F7D\u9519\u8BEF\u6587\u4EF6")) : null)
  });
}
/**
 * 若为余额不足业务错误则弹窗处理并返回 true，否则返回 false
 */

function handleBalanceInsufficientError(res) {
  var _res$result;

  if (!res || res.success) {
    return false;
  }

  var stores = res === null || res === void 0 ? void 0 : (_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.balanceInsufficientStores; // 有门店明细即弹窗（调拨/采购提交多门店余额不足）

  if (Array.isArray(stores) && stores.length > 0) {
    var _res$result2;

    showBalanceInsufficientModal({
      message: res.message,
      stores,
      errorFileUrl: res === null || res === void 0 ? void 0 : (_res$result2 = res.result) === null || _res$result2 === void 0 ? void 0 : _res$result2.errorFileUrl
    });
    return true;
  }

  return false;
}

/***/ }),

/***/ 48344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90636);
/* harmony import */ var antd_es_message_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34792);
/* harmony import */ var antd_es_message__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48086);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8870);
/* harmony import */ var _builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3182);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_1__);






var env = "prod" || 0 || 0;

function getBaseUrl(apiName) {
  if (apiName && apiName.includes('/mock/api')) {
    return window.location.origin + apiName;
  }

  var baseURL = 'https://apigw2.ypshengxian.com';

  if (env && env !== 'prod') {
    baseURL = "https://apigw2-".concat(env, ".ypshengxian.com");
  }

  return baseURL;
}

var fetchQuery = /*#__PURE__*/function () {
  var _ref = (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* .default */ .Z)( /*#__PURE__*/(0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)().mark(function _callee(apiName) {
    var method,
        data,
        headers,
        url,
        options,
        _args = arguments;
    return (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_3__/* .default */ .Z)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            method = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'GET';
            data = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
            headers = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
            url = getBaseUrl() + "".concat(apiName); // console.log(url, '请求地址', method, 'data', data)

            options = {
              method,
              headers: (0,_builds_web_front_end_ypsxmanage_web_node_modules_umijs_babel_preset_umi_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_4__/* .default */ .Z)({
                'Content-Type': 'application/json',
                'X-YPSX-TOKEN': js_cookie__WEBPACK_IMPORTED_MODULE_1___default().get('token') || ''
              }, headers)
            };

            if (data) {
              options.body = JSON.stringify(data);
            }

            return _context.abrupt("return", fetch(url, options).then(response => {
              if (!response.ok) {
                throw new Error("HTTP error! Status: ".concat(response.status));
              }

              return response === null || response === void 0 ? void 0 : response.json();
            }).then(data => {
              if (!data.success) {
                var _data$error;

                antd_es_message__WEBPACK_IMPORTED_MODULE_5__.default.error(((_data$error = data.error) === null || _data$error === void 0 ? void 0 : _data$error.message) || '请求失败');

                return data;
              }

              var result = data.result; // 合肥网关 codeInfo 格式：外层 success 可能仍为 true，需单独判断

              if (result !== null && result !== void 0 && result.codeInfo && result.codeInfo.code !== 0) {
                antd_es_message__WEBPACK_IMPORTED_MODULE_5__.default.error(result.codeInfo.msg);

                return data;
              }

              if ((result === null || result === void 0 ? void 0 : result.success) === false) {
                var _result$error;

                antd_es_message__WEBPACK_IMPORTED_MODULE_5__.default.error(((_result$error = result.error) === null || _result$error === void 0 ? void 0 : _result$error.message) || '请求失败');
              }

              return data;
            }).catch(error => {
              console.error('Fetch error:', error);
              throw error;
            }));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchQuery(_x) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["Z"] = (fetchQuery);

/***/ }),

/***/ 58180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wY": function() { return /* binding */ Multiply; },
/* harmony export */   "p3": function() { return /* binding */ Divide; },
/* harmony export */   "Cu": function() { return /* binding */ limitDecimals; },
/* harmony export */   "ZR": function() { return /* binding */ limitDecimalsNum; },
/* harmony export */   "ed": function() { return /* binding */ limitDecimalsThree; },
/* harmony export */   "gf": function() { return /* binding */ limitDecimalsLength; },
/* harmony export */   "Xe": function() { return /* binding */ limitLength; },
/* harmony export */   "ky": function() { return /* binding */ limitJustNum; },
/* harmony export */   "jy": function() { return /* binding */ limitDecimalsOne; }
/* harmony export */ });
/* unused harmony exports Add, Subtract, decimalFixed, limitNum */
// 加法函数
var Add = (arg1, arg2) => {
  var r1;
  var r2;
  var m;
  var c;

  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }

  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }

  c = Math.abs(r1 - r2);
  m = Math.pow(10, Math.max(r1, r2));

  if (c > 0) {
    var cm = Math.pow(10, c);

    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace('.', ''));
      arg2 = Number(arg2.toString().replace('.', '')) * cm;
    } else {
      arg1 = Number(arg1.toString().replace('.', '')) * cm;
      arg2 = Number(arg2.toString().replace('.', ''));
    }
  } else {
    arg1 = Number(arg1.toString().replace('.', ''));
    arg2 = Number(arg2.toString().replace('.', ''));
  }

  return (arg1 + arg2) / m;
}; // 减法函数

var Subtract = (arg1, arg2) => {
  var r1 = 0;
  var r2 = 0;
  var m;

  try {
    r1 = String(arg1).split('.')[1].length;
  } catch (e) {}

  try {
    r2 = String(arg2).split('.')[1].length;
  } catch (e) {}

  m = Math.pow(10, Math.max(r1, r2));
  arg1 = Number(arg1) * m;
  arg2 = Number(arg2) * m;
  return (arg1 - arg2) / m;
}; // 乘法函数

var Multiply = (arg1, arg2) => {
  var m = 0;
  var s1 = String(arg1);
  var s2 = String(arg2);

  try {
    m += s1.split('.')[1].length;
  } catch (e) {}

  try {
    m += s2.split('.')[1].length;
  } catch (e) {}

  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
}; // 除法函数

var Divide = (num1, num2) => {
  var baseNum1 = 0;
  var baseNum2 = 0;
  var baseNum3;
  var baseNum4;

  try {
    baseNum1 = num1.toString().split('.')[1].length;
  } catch (e) {
    baseNum1 = 0;
  }

  try {
    baseNum2 = num2.toString().split('.')[1].length;
  } catch (e) {
    baseNum2 = 0;
  }

  baseNum3 = Number(String(num1).replace('.', ''));
  baseNum4 = Number(String(num2).replace('.', ''));
  return baseNum3 / baseNum4 * Math.pow(10, baseNum2 - baseNum1);
};
/**
 * 判断小数点后几位
 * @param {判断的数值} number
 */

var decimalFixed = number => {
  if (!number) return;
  var num = Number(number);
  var str = String(number);
  if (num === 0) return 0;
  if (str.indexOf('.') === -1) return 0;
  return str.split('.')[1].length;
};
/**
 * 限制小数点后两位输入
 * @param {*} value
 */

var limitDecimals = (value, len) => {
  var reg = /^(\-)*(\d+)\.(\d\d).*$/;

  if (typeof value === 'string') {
    if (String(value).length > len) {
      return value.replace(reg, '$1$2.$3').slice(0, len);
    } else {
      return !isNaN(Number(value)) ? value.slice(0, len).replace(reg, '$1$2.$3') : '';
    }
  } else if (typeof value === 'number') {
    if (String(value).length > len) {
      return Number(String(value).replace(reg, '$1$2.$3').slice(0, len));
    } else {
      return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : '';
    }
  } else {
    return '';
  }
};
/**
 * 限制小数2位 大小
 * @param value
 * @param len
 */

var limitDecimalsNum = (value, num) => {
  var reg = /^(\-)*(\d+)\.(\d\d).*$/;

  if (typeof value === 'string') {
    if (!isNaN(Number(value))) {
      return Number(value) > num ? num : value.replace(reg, '$1$2.$3');
    } else {
      return !isNaN(parseFloat(value)) ? String(parseFloat(value)).replace(reg, '$1$2.$3') : '';
    }
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : '';
  } else {
    return '';
  }
};
/**
 * 限制小数点后三位输入
 * @param {*} value
 */

var limitDecimalsThree = (value, num) => {
  var reg = /^(\-)*(\d+)\.(\d\d\d).*$/;

  if (typeof value === 'string') {
    return Number(value) > num ? String(num) : value.replace(reg, '$1$2.$3');
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : '';
  } else {
    return '';
  }
};
/**
 * 限制正数 长度
 * @param value
 * @param len
 */

var limitDecimalsLength = (value, len) => {
  var reg = /^(\-)*(\d+)\.(\d\d).*$/;

  if (typeof value === 'string') {
    if (!isNaN(Number(value)) && len) {
      return String(value).length > len ? String(parseFloat(value)).slice(0, len).replace(reg, '$1$2.$3') : value.replace(reg, '$1$2.$3');
    } else {
      return !isNaN(parseFloat(value)) ? String(parseFloat(value)).replace(reg, '$1$2.$3') : '';
    }
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : '';
  } else {
    return '';
  }
};
/**
 * 限制正整数 长度:
 * @param {*} value
 */

var limitLength = (value, len) => {
  var reg = /[^\-?\d]/g;

  if (typeof value === 'string') {
    if (!isNaN(Number(value))) {
      return String(value).length > len ? String(parseFloat(value)).slice(0, len).replace(reg, '') : value.replace(reg, '');
    } else {
      return !isNaN(parseFloat(value)) ? String(parseFloat(value)).replace(reg, '') : '';
    }
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '') : '';
  } else {
    return '';
  }
};
/**
 * 限制整数
 * @param {*} value
 */

var limitNum = value => {
  var reg = /[^\-?\d]/g;

  if (typeof value === 'string') {
    if (!isNaN(Number(value))) {
      return value.replace(reg, '');
    } else {
      return !isNaN(parseFloat(value)) ? String(parseFloat(value)).replace(reg, '') : '';
    }
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '') : '';
  } else {
    return '';
  }
};
/**
 * 限制正整数
 * @param {*} value
 */

var limitJustNum = value => {
  var reg = /[^\d]/g;

  if (typeof value === 'string') {
    if (!isNaN(Number(value))) {
      return value.replace(reg, '');
    } else {
      return !isNaN(parseFloat(value)) ? String(parseFloat(value)).replace(reg, '') : '';
    }
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '') : '';
  } else {
    return '';
  }
};
var limitDecimalsOne = (value, num) => {
  var reg = /^(\-)*(\d+)\.(\d).*$/;

  if (typeof value === 'string') {
    if (!isNaN(Number(value))) {
      return Number(value) ? value.replace(reg, '$1$2.$3') : value;
    } else {
      return !isNaN(parseFloat(value)) ? String(parseFloat(value)).replace(reg, '$1$2.$3') : '';
    }
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : '';
  } else {
    return '';
  }
};

/***/ }),

/***/ 6067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lb": function() { return /* binding */ formatMoney; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "_g": function() { return /* binding */ formatDateTimeWithoutZeroSeconds; }
/* harmony export */ });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);

/**
 * 格式化金额
 * @param number
 * @returns {string}
 */

var formatMoney = number => {
  if (typeof number === 'string') {
    return Number(number / 100).toFixed(2);
  }

  return (number / 100).toFixed(2);
};
/**
 * 格式化 时间区间
 * @param start 开始时间 必传
 * @param end 结束时间 非必传
 * @constructor
 */

var formatDate = function formatDate(start, end) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'YYYY-MM-DD HH:mm';

  if (!end) {
    return moment__WEBPACK_IMPORTED_MODULE_0___default()(start).format(mode);
  } else {
    return moment__WEBPACK_IMPORTED_MODULE_0___default()(start).format(mode) + ' ~ ' + moment__WEBPACK_IMPORTED_MODULE_0___default()(end).format(mode);
  }
};
/**
 * 格式化日期时间，根据时间精度决定显示格式
 * @param time 时间戳或日期字符串
 * @returns 格式化后的日期时间字符串
 */

var formatDateTimeWithoutZeroSeconds = time => {
  if (!time) return '';
  var momentTime = moment__WEBPACK_IMPORTED_MODULE_0___default()(time); // 不管有没有秒都不显示秒
  // 如果分钟也为0，则只显示到小时

  if (momentTime.minutes() === 0) {
    return momentTime.format('YYYY-MM-DD');
  }

  return momentTime.format('YYYY-MM-DD HH:mm');
};

/***/ })

}]);